/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 676);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(449)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(511);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(807), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(512);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(833);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(837);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(512);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(316);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(612);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* ALERT */
var ALERT_SET = exports.ALERT_SET = 'ALERT_SET';
var ALERT_DIALOG_CLOSE = exports.ALERT_DIALOG_CLOSE = 'ALERT_DIALOG_CLOSE';
var ALERTS_CLEAR = exports.ALERTS_CLEAR = 'ALERT_CLEAR';

/* MAP */
var MAP_NEW = exports.MAP_NEW = 'MAP_NEW';
var MAP_SET = exports.MAP_SET = 'MAP_SET';
var MAP_NAME_SET = exports.MAP_NAME_SET = 'MAP_NAME_SET';
var MAP_CONTEXT_MENU_OPEN = exports.MAP_CONTEXT_MENU_OPEN = 'MAP_CONTEXT_MENU_OPEN';
var MAP_CONTEXT_MENU_CLOSE = exports.MAP_CONTEXT_MENU_CLOSE = 'MAP_CONTEXT_MENU_CLOSE';
var MAP_COORDINATE_OPEN = exports.MAP_COORDINATE_OPEN = 'MAP_COORDINATE_OPEN';
var MAP_COORDINATE_CLOSE = exports.MAP_COORDINATE_CLOSE = 'MAP_COORDINATE_CLOSE';
var MAP_EARTH_ENGINE_VALUE_SHOW = exports.MAP_EARTH_ENGINE_VALUE_SHOW = 'MAP_EARTH_ENGINE_VALUE_SHOW';

/* BASEMAP */
var BASEMAP_ADD = exports.BASEMAP_ADD = 'BASEMAP_ADD';
var BASEMAP_REMOVE = exports.BASEMAP_REMOVE = 'BASEMAP_REMOVE';
var BASEMAP_SELECTED = exports.BASEMAP_SELECTED = 'BASEMAP_SELECTED';
var BASEMAP_TOGGLE_EXPAND = exports.BASEMAP_TOGGLE_EXPAND = 'BASEMAP_TOGGLE_EXPAND';
var BASEMAP_TOGGLE_VISIBILITY = exports.BASEMAP_TOGGLE_VISIBILITY = 'BASEMAP_TOGGLE_VISIBILITY';
var BASEMAP_CHANGE_OPACITY = exports.BASEMAP_CHANGE_OPACITY = 'BASEMAP_CHANGE_OPACITY';

/* LAYER */
var LAYER_ADD = exports.LAYER_ADD = 'LAYER_ADD';
var LAYER_REMOVE = exports.LAYER_REMOVE = 'LAYER_REMOVE';
var LAYER_CHANGE_OPACITY = exports.LAYER_CHANGE_OPACITY = 'LAYER_CHANGE_OPACITY';
var LAYER_EDIT = exports.LAYER_EDIT = 'LAYER_EDIT';
var LAYER_EDIT_SUCCESS = exports.LAYER_EDIT_SUCCESS = 'LAYER_EDIT_SUCCESS';
var LAYER_EDIT_ERROR = exports.LAYER_EDIT_ERROR = 'LAYER_EDIT_ERROR';
var LAYER_CANCEL = exports.LAYER_CANCEL = 'LAYER_CANCEL';
// export const LAYER_GET = 'LAYER_GET';
var LAYER_LOAD = exports.LAYER_LOAD = 'LAYER_LOAD';
var LAYER_LOAD_SUCCESS = exports.LAYER_LOAD_SUCCESS = 'LAYER_LOAD_SUCCESS';
var LAYER_LOAD_ERROR = exports.LAYER_LOAD_ERROR = 'LAYER_LOAD_ERROR';
var LAYER_SORT = exports.LAYER_SORT = 'LAYER_SORT';
var LAYER_TOGGLE_EXPAND = exports.LAYER_TOGGLE_EXPAND = 'LAYER_TOGGLE_EXPAND';
var LAYER_TOGGLE_VISIBILITY = exports.LAYER_TOGGLE_VISIBILITY = 'LAYER_TOGGLE_VISIBILITY';
var LAYER_UPDATE = exports.LAYER_UPDATE = 'LAYER_UPDATE';
var LAYER_DRILL = exports.LAYER_DRILL = 'LAYER_DRILL';
var LAYERS_DIALOG_OPEN = exports.LAYERS_DIALOG_OPEN = 'LAYERS_DIALOG_OPEN';
var LAYERS_DIALOG_CLOSE = exports.LAYERS_DIALOG_CLOSE = 'LAYERS_DIALOG_CLOSE';

/* EXTERNAL LAYERS */
var EXTERNAL_LAYERS_LOAD = exports.EXTERNAL_LAYERS_LOAD = 'EXTERNAL_LAYERS_LOAD';
var EXTERNAL_LAYERS_LOAD_ERROR = exports.EXTERNAL_LAYERS_LOAD_ERROR = 'EXTERNAL_LAYERS_LOAD_ERROR';
var EXTERNAL_LAYER_ADD = exports.EXTERNAL_LAYER_ADD = 'EXTERNAL_LAYER_ADD';
var EXTERNAL_LAYER_REMOVE = exports.EXTERNAL_LAYER_REMOVE = 'EXTERNAL_LAYER_REMOVE';

/* FAVORITE */
var FAVORITE_LOAD = exports.FAVORITE_LOAD = 'FAVORITE_LOAD';
var FAVORITE_LOAD_SUCCESS = exports.FAVORITE_LOAD_SUCCESS = 'FAVORITE_LOAD_SUCCESS';
var FAVORITE_LOAD_ERROR = exports.FAVORITE_LOAD_ERROR = 'FAVORITE_LOAD_ERROR';
var FAVORITE_SAVE = exports.FAVORITE_SAVE = 'FAVORITE_SAVE';
var FAVORITE_SAVE_NEW = exports.FAVORITE_SAVE_NEW = 'FAVORITE_SAVE_NEW';
var FAVORITE_SAVE_NEW_SUCCESS = exports.FAVORITE_SAVE_NEW_SUCCESS = 'FAVORITE_SAVE_NEW_SUCCESS';
var FAVORITE_SAVE_NEW_ERROR = exports.FAVORITE_SAVE_NEW_ERROR = 'FAVORITE_SAVE_NEW_ERROR';
var FAVORITE_SAVE_NEW_DIALOG_OPEN = exports.FAVORITE_SAVE_NEW_DIALOG_OPEN = 'FAVORITE_SAVE_NEW_DIALOG_OPEN';
var FAVORITE_SAVE_NEW_DIALOG_CLOSE = exports.FAVORITE_SAVE_NEW_DIALOG_CLOSE = 'FAVORITE_SAVE_NEW_DIALOG_CLOSE';
var FAVORITE_INTERPRETATION_SAVE = exports.FAVORITE_INTERPRETATION_SAVE = 'FAVORITE_INTERPRETATION_SAVE';
var FAVORITES_DIALOG_OPEN = exports.FAVORITES_DIALOG_OPEN = 'FAVORITES_DIALOG_OPEN';
var FAVORITES_DIALOG_CLOSE = exports.FAVORITES_DIALOG_CLOSE = 'FAVORITES_DIALOG_CLOSE';

/* DATA TABLE */
var DATA_TABLE_OPEN = exports.DATA_TABLE_OPEN = 'DATA_TABLE_OPEN';
var DATA_TABLE_CLOSE = exports.DATA_TABLE_CLOSE = 'DATA_TABLE_CLOSE';
var DATA_TABLE_TOGGLE = exports.DATA_TABLE_TOGGLE = 'DATA_TABLE_TOGGLE';
var DATA_TABLE_RESIZE = exports.DATA_TABLE_RESIZE = 'DATA_TABLE_RESIZE';

/* DATA FILTER */
var DATA_FILTER_SET = exports.DATA_FILTER_SET = 'DATA_FILTER_SET';
var DATA_FILTER_CLEAR = exports.DATA_FILTER_CLEAR = 'DATA_FILTER_CLEAR';

/* ORGANISATION UNITS */
var ORGANISATION_UNIT_LOAD = exports.ORGANISATION_UNIT_LOAD = 'ORGANISATION_UNIT_LOAD';
var ORGANISATION_UNIT_SET = exports.ORGANISATION_UNIT_SET = 'ORGANISATION_UNIT_SET';
var ORGANISATION_UNIT_CLOSE = exports.ORGANISATION_UNIT_CLOSE = 'ORGANISATION_UNIT_CLOSE';
var ORGANISATION_UNIT_SELECT = exports.ORGANISATION_UNIT_SELECT = 'ORGANISATION_UNIT_SELECT';
var ORGANISATION_UNIT_UNSELECT = exports.ORGANISATION_UNIT_UNSELECT = 'ORGANISATION_UNIT_UNSELECT';
var ORGANISATION_UNIT_RELOCATE_START = exports.ORGANISATION_UNIT_RELOCATE_START = 'ORGANISATION_UNIT_RELOCATE_START';
var ORGANISATION_UNIT_RELOCATE_STOP = exports.ORGANISATION_UNIT_RELOCATE_STOP = 'ORGANISATION_UNIT_RELOCATE_STOP';
var ORGANISATION_UNIT_COORDINATE_CHANGE = exports.ORGANISATION_UNIT_COORDINATE_CHANGE = 'ORGANISATION_UNIT_COORDINATE_CHANGE';
var ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR = exports.ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR = 'ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR';
var ORGANISATION_UNIT_COORDINATE_SET = exports.ORGANISATION_UNIT_COORDINATE_SET = 'ORGANISATION_UNIT_COORDINATE_SET';
var ORGANISATION_UNIT_TREE_LOAD = exports.ORGANISATION_UNIT_TREE_LOAD = 'ORGANISATION_UNIT_TREE_LOAD';
var ORGANISATION_UNIT_TREE_LOAD_ERROR = exports.ORGANISATION_UNIT_TREE_LOAD_ERROR = 'ORGANISATION_UNIT_TREE_LOAD_ERROR';
var ORGANISATION_UNIT_TREE_SET = exports.ORGANISATION_UNIT_TREE_SET = 'ORGANISATION_UNIT_TREE_SET';
var ORGANISATION_UNIT_GROUPS_LOAD = exports.ORGANISATION_UNIT_GROUPS_LOAD = 'ORGANISATION_UNIT_GROUPS_LOAD';
var ORGANISATION_UNIT_GROUPS_LOAD_ERROR = exports.ORGANISATION_UNIT_GROUPS_LOAD_ERROR = 'ORGANISATION_UNIT_GROUPS_LOAD_ERROR';
var ORGANISATION_UNIT_GROUPS_SET = exports.ORGANISATION_UNIT_GROUPS_SET = 'ORGANISATION_UNIT_GROUPS_SET';
var ORGANISATION_UNIT_GROUP_SETS_LOAD = exports.ORGANISATION_UNIT_GROUP_SETS_LOAD = 'ORGANISATION_UNIT_GROUP_SETS_LOAD';
var ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR = exports.ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR = 'ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR';
var ORGANISATION_UNIT_GROUP_SETS_SET = exports.ORGANISATION_UNIT_GROUP_SETS_SET = 'ORGANISATION_UNIT_GROUP_SETS_SET';
var ORGANISATION_UNIT_LEVELS_SET = exports.ORGANISATION_UNIT_LEVELS_SET = 'ORGANISATION_UNIT_LEVELS_SET';
var ORGANISATION_UNIT_LEVELS_LOAD = exports.ORGANISATION_UNIT_LEVELS_LOAD = 'ORGANISATION_UNIT_LEVELS_LOAD';
var ORGANISATION_UNIT_LEVELS_LOAD_ERROR = exports.ORGANISATION_UNIT_LEVELS_LOAD_ERROR = 'ORGANISATION_UNIT_LEVELS_LOAD_ERROR';

/* ABOUT DIALOG */
var ABOUT_DIALOG_OPEN = exports.ABOUT_DIALOG_OPEN = 'ABOUT_DIALOG_OPEN';
var ABOUT_DIALOG_CLOSE = exports.ABOUT_DIALOG_CLOSE = 'ABOUT_DIALOG_CLOSE';

/* USER INTERFACE */
var SCREEN_RESIZE = exports.SCREEN_RESIZE = 'SCREEN_RESIZE';
var LAYERS_PANEL_OPEN = exports.LAYERS_PANEL_OPEN = 'LAYERS_PANEL_OPEN';
var LAYERS_PANEL_CLOSE = exports.LAYERS_PANEL_CLOSE = 'LAYERS_PANEL_CLOSE';

/* LOADING */
var LOADING = exports.LOADING = 'LOADING';
var LOADED = exports.LOADED = 'LOADED';

/* SYSTEM SETTINGS */
var SYSTEM_DATA_SET = exports.SYSTEM_DATA_SET = 'SYSTEM_DATA_SET';

/* USER */
var USER_SET = exports.USER_SET = 'USER_SET';

/* PROGRAMS */
var PROGRAMS_LOAD = exports.PROGRAMS_LOAD = 'PROGRAMS_LOAD';
var PROGRAMS_LOAD_ERROR = exports.PROGRAMS_LOAD_ERROR = 'PROGRAMS_LOAD_ERROR';
var PROGRAMS_SET = exports.PROGRAMS_SET = 'PROGRAMS_SET';
var PROGRAM_STAGES_LOAD = exports.PROGRAM_STAGES_LOAD = 'PROGRAM_STAGES_LOAD';
var PROGRAM_STAGES_LOAD_ERROR = exports.PROGRAM_STAGES_LOAD_ERROR = 'PROGRAM_STAGES_LOAD_ERROR';
var PROGRAM_STAGES_SET = exports.PROGRAM_STAGES_SET = 'PROGRAM_STAGES_SET';
var PROGRAM_ATTRIBUTES_LOAD = exports.PROGRAM_ATTRIBUTES_LOAD = 'PROGRAM_ATTRIBUTES_LOAD';
var PROGRAM_ATTRIBUTES_LOAD_ERROR = exports.PROGRAM_ATTRIBUTES_LOAD_ERROR = 'PROGRAM_ATTRIBUTES_LOAD_ERROR';
var PROGRAM_ATTRIBUTES_SET = exports.PROGRAM_ATTRIBUTES_SET = 'PROGRAM_ATTRIBUTES_SET';
var PROGRAM_DATA_ELEMENTS_LOAD = exports.PROGRAM_DATA_ELEMENTS_LOAD = 'PROGRAM_DATA_ELEMENTS_LOAD';
var PROGRAM_DATA_ELEMENTS_LOAD_ERROR = exports.PROGRAM_DATA_ELEMENTS_LOAD_ERROR = 'PROGRAM_DATA_ELEMENTS_LOAD_ERROR';
var PROGRAM_DATA_ELEMENTS_SET = exports.PROGRAM_DATA_ELEMENTS_SET = 'PROGRAM_DATA_ELEMENTS_SET';
var PROGRAM_INDICATORS_LOAD = exports.PROGRAM_INDICATORS_LOAD = 'PROGRAM_INDICATORS_LOAD';
var PROGRAM_INDICATORS_LOAD_ERROR = exports.PROGRAM_INDICATORS_LOAD_ERROR = 'PROGRAM_INDICATORS_LOAD_ERROR';
var PROGRAM_INDICATORS_SET = exports.PROGRAM_INDICATORS_SET = 'PROGRAM_INDICATORS_SET ';
var PROGRAM_STAGE_DATA_ELEMENTS_LOAD = exports.PROGRAM_STAGE_DATA_ELEMENTS_LOAD = 'PROGRAM_STAGE_DATA_ELEMENTS_LOAD';
var PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR = exports.PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR = 'PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR';
var PROGRAM_STAGE_DATA_ELEMENTS_SET = exports.PROGRAM_STAGE_DATA_ELEMENTS_SET = 'PROGRAM_STAGE_DATA_ELEMENTS_SET';

/* OPTION SETS */
var OPTION_SET_LOAD = exports.OPTION_SET_LOAD = 'OPTION_SET_LOAD';
var OPTION_SET_LOAD_ERROR = exports.OPTION_SET_LOAD_ERROR = 'OPTION_SET_LOAD_ERROR';
var OPTION_SET_ADD = exports.OPTION_SET_ADD = 'OPTION_SET_ADD';

/* LAYER EDIT */
var LAYER_EDIT_PROGRAM_SET = exports.LAYER_EDIT_PROGRAM_SET = 'LAYER_EDIT_PROGRAM_SET';
var LAYER_EDIT_PROGRAM_STAGE_SET = exports.LAYER_EDIT_PROGRAM_STAGE_SET = 'LAYER_EDIT_PROGRAM_STAGE_SET';
var LAYER_EDIT_PROGRAM_INDICATOR_SET = exports.LAYER_EDIT_PROGRAM_INDICATOR_SET = 'LAYER_EDIT_PROGRAM_INDICATOR_SET';
var LAYER_EDIT_PERIOD_SET = exports.LAYER_EDIT_PERIOD_SET = 'LAYER_EDIT_PERIOD_SET';
var LAYER_EDIT_START_DATE_SET = exports.LAYER_EDIT_START_DATE_SET = 'LAYER_EDIT_START_DATE_SET';
var LAYER_EDIT_END_DATE_SET = exports.LAYER_EDIT_END_DATE_SET = 'LAYER_EDIT_END_DATE_SET';
var LAYER_EDIT_FILTER_ADD = exports.LAYER_EDIT_FILTER_ADD = 'LAYER_EDIT_FILTER_ADD';
var LAYER_EDIT_FILTER_REMOVE = exports.LAYER_EDIT_FILTER_REMOVE = 'LAYER_EDIT_FILTER_REMOVE';
var LAYER_EDIT_FILTER_CHANGE = exports.LAYER_EDIT_FILTER_CHANGE = 'LAYER_EDIT_FILTER_CHANGE';
var LAYER_EDIT_STYLE_DATA_ITEM_SET = exports.LAYER_EDIT_STYLE_DATA_ITEM_SET = 'LAYER_EDIT_STYLE_DATA_ITEM_SET';
var LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET = exports.LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET = 'LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET';
var LAYER_EDIT_CLASSIFICATION_SET = exports.LAYER_EDIT_CLASSIFICATION_SET = 'LAYER_EDIT_CLASSIFICATION_SET';
var LAYER_EDIT_COLOR_SCALE_SET = exports.LAYER_EDIT_COLOR_SCALE_SET = 'LAYER_EDIT_COLOR_SCALE_SET';
var LAYER_EDIT_DATA_ITEM_SET = exports.LAYER_EDIT_DATA_ITEM_SET = 'LAYER_EDIT_DATA_ITEM_SET';
var LAYER_EDIT_EVENT_COORDINATE_FIELD_SET = exports.LAYER_EDIT_EVENT_COORDINATE_FIELD_SET = 'LAYER_EDIT_EVENT_COORDINATE_FIELD_SET';
var LAYER_EDIT_EVENT_CLUSTERING_SET = exports.LAYER_EDIT_EVENT_CLUSTERING_SET = 'LAYER_EDIT_EVENT_CLUSTERING_SET';
var LAYER_EDIT_EVENT_POINT_RADIUS_SET = exports.LAYER_EDIT_EVENT_POINT_RADIUS_SET = 'LAYER_EDIT_EVENT_POINT_RADIUS_SET';
var LAYER_EDIT_EVENT_POINT_COLOR_SET = exports.LAYER_EDIT_EVENT_POINT_COLOR_SET = 'LAYER_EDIT_EVENT_POINT_COLOR_SET';
var LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET = exports.LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET = 'LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET';
var LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET = exports.LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET = 'LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET'; // Org units selection
var LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET = exports.LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET = 'LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET'; // Facility TODO: Distinguish frome above
var LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE = exports.LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE = 'LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE';
var LAYER_EDIT_USER_ORGANISATION_UNITS_SET = exports.LAYER_EDIT_USER_ORGANISATION_UNITS_SET = 'LAYER_EDIT_USER_ORGANISATION_UNITS_SET';
var LAYER_EDIT_VALUE_TYPE_SET = exports.LAYER_EDIT_VALUE_TYPE_SET = 'LAYER_EDIT_VALUE_TYPE_SET';
var LAYER_EDIT_INDICATOR_GROUP_SET = exports.LAYER_EDIT_INDICATOR_GROUP_SET = 'LAYER_EDIT_INDICATOR_GROUP_SET';
var LAYER_EDIT_PERIOD_TYPE_SET = exports.LAYER_EDIT_PERIOD_TYPE_SET = 'LAYER_EDIT_PERIOD_TYPE_SET';
var LAYER_EDIT_AGGREGATION_TYPE_SET = exports.LAYER_EDIT_AGGREGATION_TYPE_SET = 'LAYER_EDIT_AGGREGATION_TYPE_SET';
var LAYER_EDIT_DATA_ELEMENT_GROUP_SET = exports.LAYER_EDIT_DATA_ELEMENT_GROUP_SET = 'LAYER_EDIT_DATA_ELEMENT_GROUP_SET';
var LAYER_EDIT_PARAMS_SET = exports.LAYER_EDIT_PARAMS_SET = 'LAYER_EDIT_PARAMS_SET';
var LAYER_EDIT_FILTER_SET = exports.LAYER_EDIT_FILTER_SET = 'LAYER_EDIT_FILTER_SET';
var LAYER_EDIT_LABELS_SET = exports.LAYER_EDIT_LABELS_SET = 'LAYER_EDIT_LABELS_SET';
var LAYER_EDIT_LABEL_FONT_SIZE_SET = exports.LAYER_EDIT_LABEL_FONT_SIZE_SET = 'LAYER_EDIT_LABEL_FONT_SIZE_SET';
var LAYER_EDIT_LABEL_FONT_WEIGHT_SET = exports.LAYER_EDIT_LABEL_FONT_WEIGHT_SET = 'LAYER_EDIT_LABEL_FONT_WEIGHT_SET';
var LAYER_EDIT_LABEL_FONT_STYLE_SET = exports.LAYER_EDIT_LABEL_FONT_STYLE_SET = 'LAYER_EDIT_LABEL_FONT_STYLE_SET';
var LAYER_EDIT_LABEL_FONT_COLOR_SET = exports.LAYER_EDIT_LABEL_FONT_COLOR_SET = 'LAYER_EDIT_LABEL_FONT_COLOR_SET';
var LAYER_EDIT_AREA_RADIUS_SET = exports.LAYER_EDIT_AREA_RADIUS_SET = 'LAYER_EDIT_AREA_RADIUS_SET';
var LAYER_EDIT_RADIUS_LOW_SET = exports.LAYER_EDIT_RADIUS_LOW_SET = 'LAYER_EDIT_RADIUS_LOW_SET';
var LAYER_EDIT_RADIUS_HIGH_SET = exports.LAYER_EDIT_RADIUS_HIGH_SET = 'LAYER_EDIT_RADIUS_HIGH_SET';
var LAYER_EDIT_LEGEND_SET_SET = exports.LAYER_EDIT_LEGEND_SET_SET = 'LAYER_EDIT_LEGEND_SET_SET';
var LAYER_EDIT_ORGANISATION_UNIT_PATH_SET = exports.LAYER_EDIT_ORGANISATION_UNIT_PATH_SET = 'LAYER_EDIT_ORGANISATION_UNIT_PATH_SET'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
var LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD = exports.LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD = 'LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
var LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR = exports.LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR = 'LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
var LAYER_EDIT_OPERAND_SET = exports.LAYER_EDIT_OPERAND_SET = 'OPERAND_SET'; // Data element operands (details)

/* PERIODS */
var RELATIVE_PERIODS_SET = exports.RELATIVE_PERIODS_SET = 'RELATIVE_PERIODS_SET';
var RELATIVE_PERIODS_TRANSLATE = exports.RELATIVE_PERIODS_TRANSLATE = 'RELATIVE_PERIODS_TRANSLATE';

/* INDICATORS */
var INDICATORS_SET = exports.INDICATORS_SET = 'INDICATORS_SET';
var INDICATORS_LOAD = exports.INDICATORS_LOAD = 'INDICATORS_LOAD';
var INDICATORS_LOAD_ERROR = exports.INDICATORS_LOAD_ERROR = 'INDICATORS_LOAD_ERROR';
var INDICATOR_GROUPS_LOAD = exports.INDICATOR_GROUPS_LOAD = 'INDICATOR_GROUPS_LOAD';
var INDICATOR_GROUPS_LOAD_ERROR = exports.INDICATOR_GROUPS_LOAD_ERROR = 'INDICATOR_GROUPS_LOAD_ERROR';
var INDICATOR_GROUPS_SET = exports.INDICATOR_GROUPS_SET = 'INDICATOR_GROUPS_SET';

/* DATA ELEMENTS */
var DATA_ELEMENT_GROUPS_SET = exports.DATA_ELEMENT_GROUPS_SET = 'DATA_ELEMENT_GROUPS_SET';
var DATA_ELEMENT_GROUPS_LOAD = exports.DATA_ELEMENT_GROUPS_LOAD = 'DATA_ELEMENT_GROUPS_LOAD';
var DATA_ELEMENT_GROUPS_LOAD_ERROR = exports.DATA_ELEMENT_GROUPS_LOAD_ERROR = 'DATA_ELEMENT_GROUPS_LOAD_ERROR';
var DATA_ELEMENTS_SET = exports.DATA_ELEMENTS_SET = 'DATA_ELEMENTS_SET';
var DATA_ELEMENTS_LOAD = exports.DATA_ELEMENTS_LOAD = 'DATA_ELEMENTS_LOAD';
var DATA_ELEMENTS_LOAD_ERROR = exports.DATA_ELEMENTS_LOAD_ERROR = 'DATA_ELEMENTS_LOAD_ERROR';
var DATA_ELEMENT_OPERANDS_SET = exports.DATA_ELEMENT_OPERANDS_SET = 'DATA_ELEMENT_OPERANDS_SET';
var DATA_ELEMENT_OPERANDS_LOAD = exports.DATA_ELEMENT_OPERANDS_LOAD = 'DATA_ELEMENT_OPERANDS_LOAD';
var DATA_ELEMENT_OPERANDS_LOAD_ERROR = exports.DATA_ELEMENT_OPERANDS_LOAD_ERROR = 'DATA_ELEMENT_OPERANDS_LOAD_ERROR';

/* DATA SETS */
var DATA_SETS_SET = exports.DATA_SETS_SET = 'DATA_SETS_SET';
var DATA_SETS_LOAD = exports.DATA_SETS_LOAD = 'DATA_SETS_LOAD';
var DATA_SETS_LOAD_ERROR = exports.DATA_SETS_LOAD_ERROR = 'DATA_SETS_LOAD_ERROR';

/* LEGEND SETS */
var LEGEND_SETS_SET = exports.LEGEND_SETS_SET = 'LEGEND_SETS_SET';
var LEGEND_SETS_LOAD = exports.LEGEND_SETS_LOAD = 'LEGEND_SETS_LOAD';
var LEGEND_SETS_LOAD_ERROR = exports.LEGEND_SETS_LOAD_ERROR = 'LEGEND_SETS_LOAD_ERROR';

/* EARTH ENGINE */
var EARTH_ENGINE_COLLECTION_LOAD = exports.EARTH_ENGINE_COLLECTION_LOAD = 'EARTH_ENGINE_COLLECTION_LOAD';
var EARTH_ENGINE_COLLECTION_LOAD_ERROR = exports.EARTH_ENGINE_COLLECTION_LOAD_ERROR = 'EARTH_ENGINE_COLLECTION_LOAD_ERROR';
var EARTH_ENGINE_COLLECTION_SET = exports.EARTH_ENGINE_COLLECTION_SET = 'EARTH_ENGINE_COLLECTION_SET';

/* USER */
var USER_SETTINGS_SET = exports.USER_SETTINGS_SET = 'USER_SETTINGS_SET';

/* MESSAGE (SNACKBAR) */
var MESSAGE_SET = exports.MESSAGE_SET = 'MESSAGE_SET';
var MESSAGE_CLEAR = exports.MESSAGE_CLEAR = 'MESSAGE_CLEAR';

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(897);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(894);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(619);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(620);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.checkDefined = checkDefined;
exports.checkType = checkType;
exports.isType = isType;
exports.isString = isString;
exports.isArray = isArray;
exports.isObject = isObject;
exports.isDefined = isDefined;
exports.isInteger = isInteger;
exports.isNumeric = isNumeric;
exports.contains = contains;
exports.isValidUid = isValidUid;
exports.areDefinedAndEqual = areDefinedAndEqual;
/**
 * @module lib/check
 */

/**
 *
 * @param value
 * @param name
 * @returns {boolean}
 */
function checkDefined(value, name) {
    if (value !== undefined) {
        return true;
    }
    throw new Error([name || 'Value', 'should be provided'].join(' '));
}

// TODO: Decide if checkType([], 'object') is a 'false' positive
function checkType(value, type, name) {
    checkDefined(value, name);
    checkDefined(type, 'Type');

    if (typeof type === 'function' && value instanceof type || typeof type === 'string' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === type) {
        // eslint-disable-line valid-typeof
        return true;
    }
    throw new Error(['Expected', name || value, 'to have type', type].join(' '));
}

// TODO: Log type error?
function isType(value, type) {
    function noop() {}

    try {
        checkType(value, type);
        return true;
    } catch (e) {
        noop();
    }

    return false;
}

function isString(value) {
    return isType(value, 'string');
}

function isArray(value) {
    return Array.isArray(value);
}

function isObject(value) {
    return isType(value, Object);
}

function isDefined(value) {
    return value != null;
}

function isInteger(nVal) {
    return typeof nVal === 'number' && isFinite(nVal) && nVal > -9007199254740992 && nVal < 9007199254740992 && Math.floor(nVal) === nVal;
}

// Polyfill for the isInteger function that will be added in ES6
// http://wiki.ecmascript.org/doku.php?id=harmony:number.isinteger
/* istanbul ignore if  */
if (!Number.isInteger) {
    Number.isInteger = isInteger;
}

function isNumeric(nVal) {
    return typeof nVal === 'number' && isFinite(nVal) && nVal - parseFloat(nVal) + 1 >= 0;
}

function contains(item, list) {
    var listToCheck = isArray(list) && list || [];

    return listToCheck.indexOf(item) >= 0;
}

var isEmpty = exports.isEmpty = function isEmpty(list) {
    return list.length >= 0;
};

/**
 * @deprecated Use isValidUid from the `uid.js` file.
 */
function isValidUid(value) {
    return value && value.length === 11;
}

var hasKeys = exports.hasKeys = function hasKeys(object) {
    return object && Object.keys(object).length > 0;
};

function areDefinedAndEqual(left, right) {
    return isDefined(left) && isDefined(right) && right === left;
}

var toBe = exports.toBe = function toBe(left, right) {
    return left === right;
};
var toBeAny = exports.toBeAny = function toBeAny(values) {
    return function (left) {
        return values.some(function (right) {
            return toBe(left, right);
        });
    };
};
var isNullUndefinedOrEmptyString = exports.isNullUndefinedOrEmptyString = toBeAny([undefined, null, '']);

var isFunction = exports.isFunction = function isFunction(fun) {
    return typeof fun === 'function';
};

var hasOwnProperty = exports.hasOwnProperty = function hasOwnProperty(object, propertyName) {
    return Object.prototype.hasOwnProperty.call(object, propertyName);
};
//# sourceMappingURL=check.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(325),
    util = __webpack_require__(327);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = undefined;
exports.getManifest = getManifest;
exports.getUserSettings = getUserSettings;
exports.init = init;
exports.getInstance = getInstance;

__webpack_require__(167);

var _utils = __webpack_require__(29);

var _Logger = __webpack_require__(168);

var _Logger2 = _interopRequireDefault(_Logger);

var _model = __webpack_require__(278);

var _model2 = _interopRequireDefault(_model);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _System = __webpack_require__(170);

var _System2 = _interopRequireDefault(_System);

var _I18n = __webpack_require__(299);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(300);

var _config2 = _interopRequireDefault(_config);

var _CurrentUser = __webpack_require__(301);

var _CurrentUser2 = _interopRequireDefault(_CurrentUser);

var _config3 = __webpack_require__(173);

var _DataStore = __webpack_require__(306);

var _DataStore2 = _interopRequireDefault(_DataStore);

var _Analytics = __webpack_require__(308);

var _Analytics2 = _interopRequireDefault(_Analytics);

var _GeoFeatures = __webpack_require__(315);

var _GeoFeatures2 = _interopRequireDefault(_GeoFeatures);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * @module d2
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @description
                                                                                                                                                                                                     * Module that contains the entry points for working with the d2 instance. Most of the api related functionality will be available through this package.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * The most important functions from the module are {@link module:d2.init|init} and {@link module:d2.init|getInstance} these are used to create and to get
                                                                                                                                                                                                     * a hold of the initialized instance of {@link module:d2.init~d2|d2}. The initialized instance is the object that allows you access most of d2's functionality.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @example
                                                                                                                                                                                                     * import { init } from 'd2/lib/d2';
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * init({ baseUrl: 'https://play.dhis2.org/demo/api/27/' })
                                                                                                                                                                                                     *  .then(d2 => console.log(d2.currentUser.name));
                                                                                                                                                                                                     */


var firstRun = true;
var deferredD2Init = _utils.Deferred.create();

var preInitConfig = _config2.default.create();

/**
 * Utility function to load the app manifest.
 *
 * The manifest well be enhanced with a `getBaseUrl()` utility function that will return the base url of the DHIS2 instance.
 * This is a simple getter for the `activities.dhis.href` property on the manifest.
 *
 * @example
 * import { getManifest } from 'd2/lib/d2';
 *
 * getManifest()
 *   .then(manifest => {
 *      console.log(manifest.getBaseUrl());
 *   });
 *
 * @param {string} url The location of the manifest. Generally this is located in the root of your app folder. (e.g. './manifest.webapp)
 * @param {Api} [ApiClass] An implementation of the Api class that will be used to fetch the manifest.
 *
 * @returns {Promise} Returns a Promise to  the DHIS2 app manifest with the added `getBaseUrl` method.
 */
function getManifest(url) {
    var ApiClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default;

    var api = ApiClass.getApi();
    api.setBaseUrl('');

    var manifestUtilities = {
        getBaseUrl: function getBaseUrl() {
            return this.activities.dhis.href;
        }
    };

    return api.get('' + url).then(function (manifest) {
        return Object.assign({}, manifest, manifestUtilities);
    });
}

/**
 * @function getUserSettings
 *
 * @returns {Promise} A promise to the current user settings
 *
 * @description
 * The object that is the result of the promise will have the following properties
 *
 * @example
 * import {getUserSettings} from 'd2/lib/d2';
 *
 * getUserSettings()
 *  .then(userSettings => {
 *      console.log(userSettings);
 *  });
 */
function getUserSettings() {
    var ApiClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default;

    var api = ApiClass.getApi();

    if (preInitConfig.baseUrl && firstRun) {
        api.setBaseUrl(preInitConfig.baseUrl);
    }

    return api.get('userSettings');
}

function getModelRequests(api, schemaNames) {
    var modelRequests = [];
    var loadSchemaForName = function loadSchemaForName(schemaName) {
        return api.get('schemas/' + schemaName, { fields: _config3.fieldsForSchemas });
    };

    if (Array.isArray(schemaNames)) {
        var individualSchemaRequests = schemaNames.map(loadSchemaForName).concat([]);

        var schemasPromise = Promise.all(individualSchemaRequests).then(function (schemas) {
            return { schemas: schemas };
        });

        modelRequests.push(schemasPromise);

        if (schemaNames.length > 0) {
            // If schemas are loaded, attributes should be as well
            modelRequests.push(api.get('attributes', { fields: ':all,optionSet[:all,options[:all]]', paging: false }));
        } else {
            // Otherwise, just return an empty list of attributes
            modelRequests.push({ attributes: [] });
        }
    } else {
        // If no schemas are specified, load all schemas and attributes
        modelRequests.push(api.get('schemas', { fields: _config3.fieldsForSchemas }));
        modelRequests.push(api.get('attributes', { fields: ':all,optionSet[:all,options[:all]]', paging: false }));
    }

    return modelRequests;
}

/**
 * Init function that used to initialise {@link module:d2.init~d2|d2}. This will load the schemas from the DHIS2 api and configure your {@link module:d2.init~d2|d2} instance.
 *
 * The `config` object that can be passed into init can have the following properties:
 *
 * baseUrl: Set this when the url is something different then `/api`. If you are running your dhis instance in a subdirectory of the actual domain
 * for example http://localhost/dhis/ you should set the base url to `/dhis/api`
 *
 * @param {Object} initConfig Configuration object that will be used to configure to define D2 Setting.
 * See the description for more information on the available settings.
 * @returns {Promise.<D2>} A promise that resolves with the intialized {@link init~d2|d2} object.
 *
 * @example
 * import init from 'd2';
 *
 * init({baseUrl: '/dhis/api'})
 *   .then((d2) => {
 *     console.log(d2.model.dataElement.list());
 *   });
 */
function init(initConfig) {
    var ApiClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default;
    var logger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Logger2.default.getLogger();

    var api = ApiClass.getApi();

    var config = _config2.default.create(preInitConfig, initConfig);

    if (config.headers) {
        api.setDefaultHeaders(config.headers);
    }

    /**
     * @namespace
     */
    var d2 = {
        /**
         * @description
         * This is the entry point for the modelDefinitions that were loaded. To start interacting with the metadata api
         * you would pick a modelDefinition from this object to interact with.
         *
         * @type {Object.<string, ModelDefinition>}
         * @instance
         */
        models: undefined,
        /**
         * Collection of the {@link module:model} classes
         *
         * @deprecated There is probably no point to expose this.
         * @instance
         */
        model: _model2.default, // TODO: Remove (Breaking)
        /**
         * Api class that is used throughout the api interaction. This can be used to get hold of the module:Api singleton.
         *
         * @example
         * d2.Api.getApi()      // Returns the api object
         *  .get('resources')   // Do a get request for /api/resources
         *  .then(resources => {
         *      console.log(resources);
         *  });
         *
         * @see {@link module:api~Api#getApi}
         *
         * @instance
         */
        Api: ApiClass,
        /**
         * System instance to interact with system information like system settings, system info etc.
         *
         * @example
         * console.log(d2.system.version.major); // 2 for DHIS 2.27
         *
         * @see {@link module:system/System~System|System}
         * @instance
         */
        system: _System2.default.getSystem(),
        /**
         * I18n instance with the loaded translations.
         *
         * Usually used for retrieving translations for a given key using `getTranslation(key: string)`
         *
         * @example
         * d2.i18n.getTranslation('success'); // Returns "Success" for the english locale
         *
         * @see {@link module:i18n~I18n#getTranslation|getTranslation}
         *
         * @instance
         */
        i18n: _I18n2.default.getI18n(),
        /**
         * Instance of the DataStore class for interaction with the dataStore api.
         *
         * @see {@link module:datastore.DataStore DataStore}
         *
         * @instance
         */
        dataStore: _DataStore2.default.getDataStore(),

        /**
         * Analytics instance for requesting analytics data from various endpoints.
         *
         * @example
         * d2.analytics.aggregate
         *  .addDimensions([
         *   'dx:Uvn6LCg7dVU;OdiHJayrsKo',
         *   'pe:LAST_4_QUARTERS',
         *   'ou:lc3eMKXaEfw;PMa2VCrupOd',
         *  ])
         *  .addFilter('pe:2016Q1;2016Q2')
         *  .getRawData({
         *    startDate: '2017-10-01',
         *    endDate: '2017-10-31'
         *  })
         *  .then(console.log)
         *
         * @see {@link module:analytics.Analytics Analytics}
         * @instance
         */
        analytics: _Analytics2.default.getAnalytics(),

        /*
         * GeoFeatures instance
         *
         * @see {@link module:geoFeatures.GeoFeatures GeoFeatures}
         * @instance
         */
        geoFeatures: _GeoFeatures2.default.getGeoFeatures()
    };

    // Process the config in a the config class to keep all config calls together.
    _config2.default.processConfigForD2(config, d2);

    // Because when importing the getInstance method in dependencies the getInstance could run before
    // init we have to resolve the current promise on first run and for consecutive ones replace the
    // old one with a fresh promise.
    if (firstRun) {
        firstRun = false;
    } else {
        deferredD2Init = _utils.Deferred.create();
    }

    var modelRequests = getModelRequests(api, config.schemas);

    var userRequests = [api.get('me', { fields: ':all,organisationUnits[id],userGroups[id],userCredentials[:all,!user,userRoles[id]' }), api.get('me/authorization'), getUserSettings(ApiClass)];

    var systemRequests = [api.get('system/info'), api.get('apps')];

    return Promise.all([].concat(_toConsumableArray(modelRequests), userRequests, systemRequests, [d2.i18n.load()])).then(function (res) {
        var responses = {
            schemas: (0, _utils.pick)('schemas')(res[0]),
            attributes: (0, _utils.pick)('attributes')(res[1]),
            currentUser: res[2],
            authorities: res[3],
            userSettings: res[4],
            systemInfo: res[5],
            apps: res[6]
        };

        responses.schemas
        // We only deal with metadata schemas
        .filter(function (schema) {
            return schema.metadata;
        })
        // TODO: Remove this when the schemas endpoint is versioned or shows the correct urls for the requested version
        // The schemas endpoint is not versioned which will result into the modelDefinitions always using the
        // "default" endpoint, we therefore modify the endpoint url based on the given baseUrl.
        .map(function (schema) {
            schema.apiEndpoint = (0, _utils.updateAPIUrlWithBaseUrlVersionNumber)(schema.apiEndpoint, config.baseUrl); // eslint-disable-line no-param-reassign

            return schema;
        }).forEach(function (schema) {
            // Attributes that do not have values do not by default get returned with the data,
            // therefore we need to grab the attributes that are attached to this particular schema to be able to know about them
            var schemaAttributes = responses.attributes.filter(function (attributeDescriptor) {
                var attributeNameFilter = [schema.singular, 'Attribute'].join('');
                return attributeDescriptor[attributeNameFilter] === true;
            });

            if (!Object.prototype.hasOwnProperty.call(d2.models, schema.singular)) {
                d2.models.add(_model2.default.ModelDefinition.createFromSchema(schema, schemaAttributes));
            }
        });

        /**
         * An instance of {@link module:current-user/CurrentUser~CurrentUser|CurrentUser}
         *
         * The currentUser can be used to retrieve data related to the currentUser.
         *
         * These things primarily include:
         * - currentUser properties retrieved from `/api/me`
         * - Lazily request collections related to the user such as
         *      - userRoles
         *      - userGroups
         *      - organisationUnits
         *      - dataViewOrganisationUnits
         * - authorities
         * - userSettings
         * - utility methods for ACL
         *
         * @example
         * d2.currentUser.canCreate(d2.models.dataElement); // Returns true when the user can create either a private/public dataElement
         * d2.currentUser.canCreate(d2.models.organisationUnit); // Returns true the user can create an organisationUnit
         *
         * @see {@link module:current-user/CurrentUser~CurrentUser|CurrentUser}
         * @instance
         */
        d2.currentUser = _CurrentUser2.default.create(responses.currentUser, responses.authorities, d2.models, responses.userSettings);
        d2.system.setSystemInfo(responses.systemInfo);
        d2.system.setInstalledApps(responses.apps);

        deferredD2Init.resolve(d2);
        return deferredD2Init.promise;
    }).catch(function (error) {
        logger.error('Unable to get schemas from the api', JSON.stringify(error), error);

        deferredD2Init.reject('Unable to get schemas from the DHIS2 API');
        return deferredD2Init.promise;
    });
}

/**
 * This function can be used to retrieve the `singleton` instance of d2. The instance is being created by calling
 * the `init` method.
 *
 * @returns {Promise.<D2>} A promise to the initialized {@link module:d2.init~d2|d2} instance.
 *
 * @example
 * import {init, getInstance} from 'd2';
 *
 * init({baseUrl: '/dhis2/api/'});
 * getInstance()
 *   .then(d2 => {
 *      d2.models.dataElement.list();
 *      // and all your other d2 magic.
 *   });
 */
function getInstance() {
    return deferredD2Init.promise;
}

/**
 * Can be used to set config options before initialisation of d2.
 *
 * @example
 * import {config, init} from 'd2';
 *
 * config.baseUrl = '/demo/api';
 * config.i18n.sources.add('i18n/systemsettingstranslations.properties');
 *
 * init()
 *   .then(d2 => {
 *     d2.system.settings.all()
 *       .then(systemSettings => Object.keys())
 *       .then(systemSettingsKey => {
 *         d2.i18n.getTranslation(systemSettingsKey);
 *       });
 *   });
 *   @type Config
 */
var config = exports.config = preInitConfig; // Alias preInitConfig to be able to `import {config} from 'd2';`

exports.default = {
    init: init,
    config: config,
    getInstance: getInstance,
    getUserSettings: getUserSettings,
    getManifest: getManifest
};
//# sourceMappingURL=d2.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module api
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/* global window fetch Headers */


__webpack_require__(167);

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _System = __webpack_require__(170);

var _System2 = _interopRequireDefault(_System);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getMergeStrategyParam() {
    var mergeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'REPLACE';

    var system = _System2.default.getSystem();

    if (system.version && Number(system.version.minor) <= 22) {
        return 'mergeStrategy=' + mergeType;
    }

    return 'mergeMode=' + mergeType;
}

function getUrl(baseUrl, url) {
    // If we are dealing with an absolute url use that instead
    if (new RegExp('^(:?https?:)?//').test(url)) {
        return url;
    }

    var urlParts = [];

    if (baseUrl) {
        urlParts.push(baseUrl);
    }
    urlParts.push(url);

    return urlParts.join('/').replace(new RegExp('(.(?:[^:]))//+', 'g'), '$1/').replace(new RegExp('/$'), '');
}

/**
 * @description
 * Used for interaction with the dhis2 api.
 *
 * This class is used as the backbone for d2 and handles all the interaction with the server. There is a singleton
 * available to be reused across your applications. The singleton can be grabbed from the d2 instance.
 *
 * ```js
 * import { getInstance } from 'd2/lib/d2';
 *
 * getInstance()
 *  .then(d2 => {
 *      const api = d2.Api.getApi() // Returns the Api singleton.
 *
 *      api.get('resources');
 *  });
 * ```
 *
 * Uses {@link https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API|Fetch} to do network requests.
 *
 * @memberof module:api
 */

var Api = function () {
    /**
     * @constructor
     *
     * @param {Fetch} [fetchImpl] The fetch implementation to use. Can be used to pass a different implementation
     * similar to the fetch Api. Will default to `window.fetch` in a browser context.
     */
    function Api(fetchImpl) {
        _classCallCheck(this, Api);

        // Optionally provide fetch to the constructor so it can be mocked during testing
        if (typeof fetchImpl === 'function') {
            this.fetch = fetchImpl.bind(typeof window !== 'undefined' ? window : global);
        } else if (typeof fetch !== 'undefined') {
            this.fetch = fetch.bind(typeof window !== 'undefined' ? window : global);
        } else {
            throw new Error('Failed to initialise D2 Api: No fetch implementation is available');
        }

        this.baseUrl = '/api';
        this.defaultFetchOptions = {
            mode: 'cors', // requests to different origins fail
            credentials: 'include', // include cookies with same-origin requests
            cache: 'default' // See https://fetch.spec.whatwg.org/#concept-request-cache-mode
        };
        this.defaultHeaders = {};
    }

    /**
     * Used for setting default headers that should be send with every request.
     *
     * @example
     * const api = Api.getApi();
     *
     * api.setDefaultHeaders({
     *  'x-requested-with': 'XMLHttpRequest', // Make sure the Api does not redirect when authorization is expired.
     * });
     *
     * @param {Object.<string, string>} headers Default headers that should be set on every request.
     */


    _createClass(Api, [{
        key: 'setDefaultHeaders',
        value: function setDefaultHeaders(headers) {
            this.defaultHeaders = headers;
        }

        /**
         * Performs a GET request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. For a GET request these are turned into
         * query parameters. For POST and PUT requests it becomes the body.
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'get',
        value: function get(url, data, options) {
            return this.request('GET', getUrl(this.baseUrl, url), data, options);
        }

        /* eslint-disable complexity */
        /**
         * Performs a POST request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request this becomes the body for the POST request
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'post',
        value: function post(url, data) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var requestUrl = getUrl(this.baseUrl, url);
            var payload = data;

            // Ensure that headers are defined and are treated without case sensitivity
            options.headers = new Headers(options.headers || {}); // eslint-disable-line

            if (data !== undefined) {
                if (data.constructor.name === 'FormData') {
                    // Ensure that the browser will set the correct Content-Type header for FormData, including boundary
                    options.headers.delete('Content-Type');
                    payload = data;
                } else if (options.headers.has('Content-Type') && options.headers.get('Content-Type').toLocaleLowerCase().startsWith('text/')) {
                    payload = String(data);
                } else {
                    // Send JSON data by default
                    options.headers.set('Content-Type', 'application/json');
                    payload = JSON.stringify(data);
                }
            }

            return this.request('POST', requestUrl, payload, options);
        }
        /**
         * Performs a DELETE request.
         *
         * @param {string} url The url for the request
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */
        /* eslint-enable complexity */

    }, {
        key: 'delete',
        value: function _delete(url, options) {
            return this.request('DELETE', getUrl(this.baseUrl, url), undefined, options);
        }

        /**
         * Perform a PUT request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. This becomes the body of the PUT request.
         * @param {boolean} [useMergeStrategy=false]
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'update',
        value: function update(url, data) {
            var useMergeStrategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            // Since we are currently using PUT to save the full state back, we have to use mergeMode=REPLACE
            // to clear out existing values
            var urlForUpdate = useMergeStrategy === true ? url + '?' + getMergeStrategyParam() : url;

            return this.request('PUT', getUrl(this.baseUrl, urlForUpdate), JSON.stringify(data));
        }

        /**
         * Perform a PATCH request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. This becomes the body of the PATCH request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'patch',
        value: function patch(url, data) {
            return this.request('PATCH', getUrl(this.baseUrl, url), JSON.stringify(data));
        }

        /**
         * General purpose request function for making http requests.
         *
         * The more specific functions like `delete`, `post` and `get`, utilize this function to make the requests.
         *
         * @param {string} method The HTTP request method (e.g. POST/GET/PATCH)
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. For a GET request these are turned into
         * query parameters. For POST and PUT requests it becomes the body.
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */
        /* eslint-disable complexity */

    }, {
        key: 'request',
        value: function request(method, url, data) {
            var _this = this;

            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            (0, _check.checkType)(method, 'string', 'Request type');
            (0, _check.checkType)(url, 'string', 'Url');
            var api = this;
            var requestUrl = url;
            var query = '';

            if (requestUrl.indexOf('?') !== -1) {
                query = requestUrl.substr(requestUrl.indexOf('?') + 1);
                requestUrl = requestUrl.substr(0, requestUrl.indexOf('?'));
            }

            // Transfer filter properties from the data object to the query string
            if (data && Array.isArray(data.filter)) {
                var encodedFilters = data.filter.map(function (filter) {
                    return filter.split(':').map(encodeURIComponent).join(':');
                });

                query = '' + (0, _utils.customEncodeURIComponent)(query) + (query.length ? '&' : '') + ('filter=' + encodedFilters.join('&filter='));
                delete data.filter; // eslint-disable-line no-param-reassign
            }

            // When using the GET method, transform the data object to query parameters
            if (data && method === 'GET') {
                Object.keys(data).forEach(function (key) {
                    query = '' + query + (query.length > 0 ? '&' : '') + (encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
                });
            }

            function getOptions(defaultHeaders, mergeOptions, requestData) {
                var resultOptions = Object.assign({}, api.defaultFetchOptions, mergeOptions);
                var headers = new Headers(mergeOptions.headers || {});

                Object.keys(defaultHeaders).filter(function (header) {
                    return !headers.get(header);
                }).forEach(function (header) {
                    return headers.set(header, defaultHeaders[header]);
                });

                resultOptions.method = method;

                // Only set content type when there is data to send
                // GET requests and requests without data do not need a Content-Type header
                // 0 and false are valid requestData values and therefore should have a content type
                if (resultOptions.method === 'GET' || !requestData && requestData !== 0 && requestData !== false) {
                    headers.delete('Content-Type');
                } else if (requestData) {
                    if (data.constructor.name === 'FormData') {
                        headers.delete('Content-Type');
                    } else if (!headers.get('Content-Type')) {
                        headers.set('Content-Type', 'application/json');
                    }
                    resultOptions.body = requestData;
                }

                resultOptions.headers = headers;
                return resultOptions;
            }

            if (query.length) {
                requestUrl = requestUrl + '?' + query;
            }
            var requestOptions = getOptions(this.defaultHeaders, options, data);

            // If the provided value is valid JSON, return the parsed JSON object. If not, return the raw value as is.
            function parseResponseData(value) {
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                // fetch returns a promise that will resolve with any response received from the server
                // It will be rejected ONLY if no response is received from the server, i.e. because there's no internet
                _this.fetch(requestUrl, requestOptions).then(function (response) {
                    // If the request failed, response.ok will be false and response.status will be the status code
                    if (response.ok) {
                        response.text().then(function (text) {
                            return resolve(parseResponseData(text));
                        });
                    } else {
                        response.text().then(function (text) {
                            if (!Object({"NODE_ENV":"production"}) || Object({"NODE_ENV":"production"}).npm_lifecycle_event !== 'test') {
                                console.warn( // eslint-disable-line
                                'API request failed with status ' + response.status + ' ' + response.statusText + '\n', 'Request: ' + requestOptions.method + ' ' + requestUrl);
                            }
                            reject(parseResponseData(text));
                        });
                    }
                }).catch(function (err) {
                    // It's not usually possible to get much info about the cause of the error programmatically, but
                    // the user can check the browser console for more info
                    if (!Object({"NODE_ENV":"production"}) || Object({"NODE_ENV":"production"}).npm_lifecycle_event !== 'test') {
                        console.error('Server connection error:', err); // eslint-disable-line
                    }
                    reject('Server connection failed for API request: ' + requestOptions.method + ' ' + requestUrl);
                });
            });
        }
        /* eslint-enable complexity */

        /**
         * Sets the baseUrl that should be used for the api.
         *
         * When working against the dhis2 demo instance at {@link https://play.dhis2.org/demo} the
         * baseUrl would be set as `https://play.dhis2.org/demo/api`.
         *
         * This method is used when calling the `d2.init` method with the `baseUrl` config property
         * to configure the Api singleton.
         *
         * @param {string} baseUrl The base url to be used for the API.
         *
         * @returns {this} Itself for chaining purposes
         */

    }, {
        key: 'setBaseUrl',
        value: function setBaseUrl(baseUrl) {
            (0, _check.checkType)(baseUrl, 'string', 'Base url');

            this.baseUrl = baseUrl;

            return this;
        }
    }]);

    return Api;
}();

/**
 * Retrieve the Api singleton or create one.
 *
 * When called for the first time it creates and Api singleton object.
 * Any subsequent calls will return the previously created singleton.
 *
 * @returns {Api} The Api singleton.
 * @memberof module:api~Api
 */


function getApi() {
    if (getApi.api) {
        return getApi.api;
    }
    return getApi.api = new Api();
}

Api.getApi = getApi;

exports.default = Api;
//# sourceMappingURL=Api.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(181);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_isString__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_helpers_utils__ = __webpack_require__(272);








var getLoadingStyle = function getLoadingStyle(loading) {
    var listStyle = void 0;

    if (loading === true) {
        listStyle = {
            textAlign: 'center'
        };
    } else if (__WEBPACK_IMPORTED_MODULE_5_lodash_fp_isString___default()(loading)) {
        listStyle = {
            paddingLeft: 24,
            lineHeight: '32px',
            fontStyle: 'italic'
        };
    }

    return listStyle;
};

var getLoadingIndicator = function getLoadingIndicator(loading) {
    var node = void 0;

    if (loading === true) {
        node = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default.a, { size: 30 });
    } else if (__WEBPACK_IMPORTED_MODULE_5_lodash_fp_isString___default()(loading)) {
        node = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            loading
        );
    }

    return node;
};

var getMenuItems = function getMenuItems(items, isLoading, isMultiple, value) {
    if (isLoading || !Array.isArray(items)) {
        return null;
    }

    return items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
            key: item.id,
            value: item.id,
            primaryText: item.name,
            insetChildren: isMultiple,
            checked: isMultiple && Array.isArray(value) && value.indexOf(item.id) > -1
        });
    });
};

var SelectField = function SelectField(props) {
    var label = props.label,
        items = props.items,
        multiple = props.multiple,
        value = props.value,
        onChange = props.onChange,
        style = props.style,
        selector = props.selector,
        loading = props.loading,
        errorText = props.errorText,
        children = props.children;

    var className = Object(__WEBPACK_IMPORTED_MODULE_6__component_helpers_utils__["a" /* createClassName */])('d2-ui-selectfield', selector);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
        {
            floatingLabelText: label,
            value: value,
            multiple: multiple,
            onChange: onChange ? function (event, index, val) {
                return onChange(items[index] || val);
            } : null,
            className: className,
            style: style,
            listStyle: getLoadingStyle(loading),
            errorText: errorText
        },
        getLoadingIndicator(loading),
        getMenuItems(items, loading, multiple, value),
        !loading && children ? children : null
    );
};

SelectField.propTypes = {

    /**
     * The label of the select field
     */
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * The select field items (rendered as MenuItems)
     */
    items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })),

    /**
     * If true, the select field will support multiple selection. A check mark will show before selected items.
     */
    multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * If true, a spinner will be shown in the select menu. If string, the loading text will be shown.
     */
    loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

    /**
     * onChange callback, that is fired when the select field's value changes
     *
     * The onChange callback will receive one argument: The item selected (if items are provided) or the value selected
     */
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * The value(s) of the select field
     */
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]))]),

    /**
     * Override the inline-styles of the root element
     */
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * If set, adds a class to the element in the format d2-ui-selectfield-selector
     */
    selector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * If set, shows the error message below the SelectField
     */
    errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * MenuItems to show in the dropdown
     */
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

SelectField.defaultProps = {
    errorText: null,
    items: [],
    loading: false,
    label: null,
    multiple: false,
    onChange: null,
    className: null,
    selector: null,
    style: null,
    value: null,
    children: null
};

/* harmony default export */ __webpack_exports__["default"] = (SelectField);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(538);



var babelPluginFlowReactPropTypes_proptype_CellPosition =  true ? null : {
  columnIndex: require('prop-types').number.isRequired,
  rowIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellPosition', {
  value: babelPluginFlowReactPropTypes_proptype_CellPosition,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRendererParams =  true ? null : {
  columnIndex: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  isVisible: require('prop-types').bool.isRequired,
  key: require('prop-types').string.isRequired,
  parent: require('prop-types').object.isRequired,
  rowIndex: require('prop-types').number.isRequired,
  style: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_CellRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_CellRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: require('prop-types').object.isRequired,
  cellRenderer: require('prop-types').func.isRequired,
  columnSizeAndPositionManager: typeof ScalingCellSizeAndPositionManager === 'function' ? require('prop-types').instanceOf(ScalingCellSizeAndPositionManager).isRequired : require('prop-types').any.isRequired,
  columnStartIndex: require('prop-types').number.isRequired,
  columnStopIndex: require('prop-types').number.isRequired,
  deferredMeasurementCache: require('prop-types').object,
  horizontalOffsetAdjustment: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  parent: require('prop-types').object.isRequired,
  rowSizeAndPositionManager: typeof ScalingCellSizeAndPositionManager === 'function' ? require('prop-types').instanceOf(ScalingCellSizeAndPositionManager).isRequired : require('prop-types').any.isRequired,
  rowStartIndex: require('prop-types').number.isRequired,
  rowStopIndex: require('prop-types').number.isRequired,
  scrollLeft: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired,
  styleCache: require('prop-types').object.isRequired,
  verticalOffsetAdjustment: require('prop-types').number.isRequired,
  visibleColumnIndices: require('prop-types').object.isRequired,
  visibleRowIndices: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_CellRangeRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellSizeGetter =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSizeGetter', {
  value: babelPluginFlowReactPropTypes_proptype_CellSizeGetter,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellSize =  true ? null : require('prop-types').oneOfType([require('prop-types').func, require('prop-types').number]);
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSize', {
  value: babelPluginFlowReactPropTypes_proptype_CellSize,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_NoContentRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_NoContentRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_NoContentRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
  clientHeight: require('prop-types').number.isRequired,
  clientWidth: require('prop-types').number.isRequired,
  scrollHeight: require('prop-types').number.isRequired,
  scrollLeft: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired,
  scrollWidth: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
  value: babelPluginFlowReactPropTypes_proptype_Scroll,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: require('prop-types').bool.isRequired,
  vertical: require('prop-types').bool.isRequired,
  size: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange', {
  value: babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: require('prop-types').number.isRequired,
  columnOverscanStopIndex: require('prop-types').number.isRequired,
  columnStartIndex: require('prop-types').number.isRequired,
  columnStopIndex: require('prop-types').number.isRequired,
  rowOverscanStartIndex: require('prop-types').number.isRequired,
  rowOverscanStopIndex: require('prop-types').number.isRequired,
  rowStartIndex: require('prop-types').number.isRequired,
  rowStopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedSection', {
  value: babelPluginFlowReactPropTypes_proptype_RenderedSection,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: require('prop-types').oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: require('prop-types').oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: require('prop-types').number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: require('prop-types').number.isRequired,


  // Begin of range of visible cells
  startIndex: require('prop-types').number.isRequired,


  // End of range of visible cells
  stopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: require('prop-types').number.isRequired,
  overscanStopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndices', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndices,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Alignment =  true ? null : require('prop-types').oneOf(['auto', 'end', 'start', 'center']);
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Alignment', {
  value: babelPluginFlowReactPropTypes_proptype_Alignment,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_VisibleCellRange =  true ? null : {
  start: require('prop-types').number,
  stop: require('prop-types').number
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_VisibleCellRange', {
  value: babelPluginFlowReactPropTypes_proptype_VisibleCellRange,
  configurable: true
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.throwError = throwError;
exports.curry = curry;
exports.addLockedProperty = addLockedProperty;
exports.copyOwnProperties = copyOwnProperties;
exports.pick = pick;
exports.updateAPIUrlWithBaseUrlVersionNumber = updateAPIUrlWithBaseUrlVersionNumber;
exports.customEncodeURIComponent = customEncodeURIComponent;
exports.identity = identity;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module lib/utils
 */

function throwError(message) {
    throw new Error(message);
}

// TODO: Throw an error when `toCurry` is not a function
function curry(toCurry, parameter) {
    return function curried() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return toCurry.apply(this, [parameter].concat(args));
    };
}

function addLockedProperty(object, name, value) {
    var propertyDescriptor = {
        enumerable: true,
        configurable: false,
        writable: false,
        value: value
    };
    Object.defineProperty(object, name, propertyDescriptor);
}

function copyOwnProperties(to, from) {
    Object.keys(from).filter(function (key) {
        return from.hasOwnProperty(key);
    }).forEach(function (key) {
        to[key] = from[key]; // eslint-disable-line no-param-reassign
    });

    return to;
}

/**
 * Curried get function to pick a property from an object
 * Will safely pick a property from an object and guards against the infamous "can not read property of undefined".
 *
 * @param {String} propertyPath
 * @param {Any} defaultValue A default value to be returned when no value was found at the path
 * @returns Function
 *
 * get :: String -> Object -> Any
 */
function pick(propertyPath) {
    var propertiesToGet = propertyPath.split('.');

    return function (item) {
        return propertiesToGet.reduce(function (result, property) {
            if (result) {
                return result[property];
            }
            return undefined;
        }, item);
    };
}

var pickOr = exports.pickOr = function pickOr(pathProperty, defaultValue) {
    return function (item) {
        var pathResult = pick(pathProperty)(item);

        return pathResult !== undefined ? pathResult : defaultValue;
    };
};

var Deferred = exports.Deferred = function () {
    function Deferred() {
        var _this = this;

        _classCallCheck(this, Deferred);

        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }

    _createClass(Deferred, null, [{
        key: 'create',
        value: function create() {
            return new Deferred();
        }
    }]);

    return Deferred;
}();

function updateAPIUrlWithBaseUrlVersionNumber(apiUrl, baseUrl) {
    if (!baseUrl || !apiUrl) {
        return apiUrl;
    }

    var apiUrlWithVersionRexExp = /api\/([1-9][0-9])/;
    var apiVersionMatch = baseUrl.match(apiUrlWithVersionRexExp);

    var baseUrlHasVersion = apiVersionMatch && apiVersionMatch[1];
    var apiUrlHasVersion = apiUrl && !apiUrlWithVersionRexExp.test(apiUrl);

    if (baseUrlHasVersion && apiUrlHasVersion) {
        var version = apiVersionMatch[1];

        // Inject the current api version number into the endPoint urls
        return apiUrl.replace(/api/, 'api/' + version);
    }

    return apiUrl;
}

// Define our very own special list of characters that we don't want to encode in the URI
var whitelistURI = ',&$=/;:';
var whitelistURICodes = whitelistURI.split('').map(function (c) {
    return encodeURIComponent(c);
});
var whitelistRegExp = new RegExp('(?:' + whitelistURICodes.join('|') + ')', 'g');

/**
 * Encode all invalid URI characters, except the ones we've decided we don't want to
 */
function customEncodeURIComponent(uri) {
    // return uri;
    return encodeURIComponent(uri).replace(whitelistRegExp, decodeURIComponent);
}

function identity(value) {
    return value;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(138);
var toSubscriber_1 = __webpack_require__(697);
var observable_1 = __webpack_require__(434);
var pipe_1 = __webpack_require__(700);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getApiResponseNames = exports.removeEmptyItems = exports.combineDataItems = exports.getFilterValueName = exports.getFilterOperatorAsText = exports.getFiltersAsText = exports.getFiltersFromColumns = exports.setFiltersFromPeriod = exports.getPeriodNameFromId = exports.getPeriodFromFilters = exports.addUserOrgUnitsToRows = exports.getUserOrgUnitsFromRows = exports.setOrgUnitPathInRows = exports.addOrgUnitGroupsToRows = exports.getOrgUnitGroupsFromRows = exports.addOrgUnitLevelsToRows = exports.getOrgUnitLevelsFromRows = exports.toggleOrgUnitNodeInRows = exports.getOrgUnitNodesFromRows = exports.getOrgUnitsFromRows = exports.setDataItemInColumns = exports.getDataItemFromColumns = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _negate = __webpack_require__(447);

var _negate2 = _interopRequireDefault(_negate);

var _uid = __webpack_require__(50);

var _periods = __webpack_require__(220);

var _dimension = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* DIMENSIONS */

var createDimension = function createDimension(dimension, items, props) {
    return _extends({
        dimension: dimension,
        items: items
    }, props);
};

var getDimension = function getDimension(dimension, arr) {
    return arr.filter(function (item) {
        return item.dimension === dimension;
    })[0];
};

var getDimensionItems = function getDimensionItems(dimension, arr) {
    var dataItems = getDimension(dimension, arr);
    return dataItems && dataItems.items ? dataItems.items : [];
};

/* DATA ITEM */

var getDataItemFromColumns = exports.getDataItemFromColumns = function getDataItemFromColumns() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('dx', columns)[0];
};

var setDataItemInColumns = exports.setDataItemInColumns = function setDataItemInColumns(dataItem, dimension) {
    var dim = _dimension.dimConf[dimension];
    return dim ? [createDimension(dim.dimensionName, [{
        id: dataItem.id + (dimension === 'reportingRate' ? '.REPORTING_RATE' : ''),
        name: dataItem.name,
        dimensionItemType: dim.itemType,
        legendSet: dataItem.legendSet // TODO: Keep outside of columns?
    }], { objectName: dim.objectName })] : [];
};

/* ORGANISATION UNIT */

var getOrgUnitsFromRows = exports.getOrgUnitsFromRows = function getOrgUnitsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('ou', rows) || [];
};

/* ORGANISATION UNIT NODES */

var isOrgUnitNode = function isOrgUnitNode(ou) {
    return (0, _uid.isValidUid)(ou.id);
};

var getOrgUnitNodesFromRows = exports.getOrgUnitNodesFromRows = function getOrgUnitNodesFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitNode);
};

var toggleOrgUnitNodeInRows = exports.toggleOrgUnitNodeInRows = function toggleOrgUnitNodeInRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var orgUnit = arguments[1];

    var orgUnits = getOrgUnitsFromRows(rows);
    var hasOrgUnit = orgUnits.some(function (ou) {
        return ou.id === orgUnit.id;
    });
    return [createDimension('ou', hasOrgUnit ? orgUnits.filter(function (ou) {
        return ou.id !== orgUnit.id;
    }) : [].concat(_toConsumableArray(orgUnits), [_extends({}, orgUnit)]))];
};

/* ORGANISATION UNIT LEVELS */

var isOrgUnitLevel = function isOrgUnitLevel(ou) {
    return ou.id.substring(0, 6) === 'LEVEL-';
};
var getIdFromOrgUnitLevel = function getIdFromOrgUnitLevel(ou) {
    return ou.id.substring(6);
};
var createOrgUnitLevel = function createOrgUnitLevel(id) {
    return { id: 'LEVEL-' + id };
};

var getOrgUnitLevelsFromRows = exports.getOrgUnitLevelsFromRows = function getOrgUnitLevelsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitLevel).map(getIdFromOrgUnitLevel);
};

var addOrgUnitLevelsToRows = exports.addOrgUnitLevelsToRows = function addOrgUnitLevelsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isOrgUnitLevel))), _toConsumableArray(levels.map(createOrgUnitLevel))))];
};

/* ORGANISATION UNIT GROUPS */

var isOrgUnitGroup = function isOrgUnitGroup(ou) {
    return ou.id.substring(0, 9) === 'OU_GROUP-';
};
var getIdFromOrgUnitGroup = function getIdFromOrgUnitGroup(ou) {
    return ou.id.substring(9);
};
var createOrgUnitGroup = function createOrgUnitGroup(id) {
    return { id: 'OU_GROUP-' + id };
};

var getOrgUnitGroupsFromRows = exports.getOrgUnitGroupsFromRows = function getOrgUnitGroupsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitGroup).map(getIdFromOrgUnitGroup);
};

var addOrgUnitGroupsToRows = exports.addOrgUnitGroupsToRows = function addOrgUnitGroupsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isOrgUnitGroup))), _toConsumableArray(levels.map(createOrgUnitGroup))))];
};

/* ORGANISATION UNIT PATH */
// Set organisation unit tree path (temporary solution, as favorites don't include paths)
var setOrgUnitPathInRows = exports.setOrgUnitPathInRows = function setOrgUnitPathInRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var id = arguments[1];
    var path = arguments[2];

    var orgUnits = getOrgUnitsFromRows(rows);
    var orgUnit = orgUnits.find(function (ou) {
        return ou.id === id;
    });
    return [createDimension('ou', [].concat(_toConsumableArray(orgUnits.filter(function (ou) {
        return ou.id !== id;
    })), [_extends({}, orgUnit, { path: path })]))];
};

/* USER ORGANISATION UNITS */

var isUserOrgUnit = function isUserOrgUnit(ou) {
    return ou.id.substring(0, 12) === 'USER_ORGUNIT';
};
var getIdFromUserOrgUnit = function getIdFromUserOrgUnit(ou) {
    return ou.id;
};
var createUserOrgUnit = function createUserOrgUnit(id) {
    return { id: id };
};

var getUserOrgUnitsFromRows = exports.getUserOrgUnitsFromRows = function getUserOrgUnitsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isUserOrgUnit).map(getIdFromUserOrgUnit);
};

var addUserOrgUnitsToRows = exports.addUserOrgUnitsToRows = function addUserOrgUnitsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var userOrgUnits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isUserOrgUnit))), _toConsumableArray(userOrgUnits.map(createUserOrgUnit))))];
};

/* PERIODS */

var getPeriodFromFilters = exports.getPeriodFromFilters = function getPeriodFromFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('pe', filters)[0];
};

var getPeriodNameFromId = exports.getPeriodNameFromId = function getPeriodNameFromId(id) {
    var period = _periods.relativePeriods.filter(function (period) {
        return period.id === id;
    })[0];
    return period ? _i18next2.default.t(period.name) : null;
};

var setFiltersFromPeriod = exports.setFiltersFromPeriod = function setFiltersFromPeriod(period) {
    return [createDimension('pe', [_extends({}, period)])];
};

var getFiltersFromColumns = exports.getFiltersFromColumns = function getFiltersFromColumns() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var filters = columns.filter(function (item) {
        return item.filter;
    });
    return filters.length ? filters : null;
};

var getFiltersAsText = exports.getFiltersAsText = function getFiltersAsText() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return filters.map(function (_ref) {
        var name = _ref.name,
            filter = _ref.filter;

        var _filter$split = filter.split(':'),
            _filter$split2 = _slicedToArray(_filter$split, 2),
            operator = _filter$split2[0],
            value = _filter$split2[1];

        return name + ' ' + getFilterOperatorAsText(operator) + ' [' + getFilterValueName(value, names) + ']';
    });
};

// TODO: Cache?
var getFilterOperatorAsText = exports.getFilterOperatorAsText = function getFilterOperatorAsText(id) {
    return {
        EQ: '=',
        GT: '>',
        GE: '>=',
        LT: '<',
        LE: '<=',
        NE: '!=',
        IN: _i18next2.default.t('one of'),
        '!IN': _i18next2.default.t('not one of'),
        LIKE: _i18next2.default.t('contains'),
        '!LIKE': _i18next2.default.t("doesn't contains")
    }[id];
};

var getFilterValueName = exports.getFilterValueName = function getFilterValueName(value, names) {
    return value.split(';').map(function (val) {
        return names[val] || val;
    }).join(', ');
};

// Combine data items into one array and exclude certain value types
var combineDataItems = exports.combineDataItems = function combineDataItems() {
    var dataItemsA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var dataItemsB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var excludeTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return (0, _sortBy2.default)('name', [].concat(_toConsumableArray(dataItemsA), _toConsumableArray(dataItemsB)).filter(function (item) {
        return !excludeTypes.includes(item.valueType);
    }));
};

// Some favorites have emtpy items in dx dimension
var removeEmptyItems = exports.removeEmptyItems = function removeEmptyItems(items) {
    return items.filter(function (item) {
        return !item.items || item.items && item.items.length;
    });
};

// Builds an object with key/names pairs from an API response
var getApiResponseNames = exports.getApiResponseNames = function getApiResponseNames(_ref2) {
    var metaData = _ref2.metaData,
        headers = _ref2.headers;
    return _extends({}, Object.keys(metaData.items).reduce(function (names, key) {
        return _extends({}, names, _defineProperty({}, key, metaData.items[key].name));
    }, {}), headers.reduce(function (names, header) {
        return _extends({}, names, _defineProperty({}, header.name, header.column));
    }, {}), {
        true: _i18next2.default.t('Yes'),
        false: _i18next2.default.t('No')
    });
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(530);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    getRawTag = __webpack_require__(330),
    objectToString = __webpack_require__(331);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.legendSetFields = exports.legendFields = exports.mapFields = exports.getDisplayPropertyUrl = exports.getDisplayProperty = undefined;

var _d = __webpack_require__(19);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import store from '../store';
var defaultKeyAnalysisDisplayProperty = 'displayName';

var propertyMap = {
    name: 'name',
    displayName: 'name',
    shortName: 'shortName',
    displayShortName: 'shortName'
};

var displayPropertyMap = {
    name: 'displayName',
    displayName: 'displayName',
    shortName: 'displayShortName',
    displayShortName: 'displayShortName'
};

var getDisplayProperty = exports.getDisplayProperty = function getDisplayProperty(d2, displayProperty) {
    var keyAnalysisDisplayProperty = d2.currentUser.settings.keyAnalysisDisplayProperty;
    return propertyMap[keyAnalysisDisplayProperty] || propertyMap[displayProperty] || 'name'; // TODO: check
};

var getDisplayPropertyUrl = exports.getDisplayPropertyUrl = function getDisplayPropertyUrl(d2) {
    // return `${getDisplayProperty(d2)}~rename(name)`; // TODO
    return 'displayName~rename(name)';
};

var baseFields = ['id', 'user', 'displayName~rename(name)', 'longitude', 'latitude', 'zoom', 'basemap'];

var analysisFields = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var d2, namePropertyUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context.sent;
                        _context.next = 5;
                        return getDisplayPropertyUrl(d2);

                    case 5:
                        namePropertyUrl = _context.sent;
                        return _context.abrupt('return', ['*', 'columns[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'rows[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'filters[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'dataDimensionItems', 'program[id,' + namePropertyUrl + ']', 'programStage[id,displayName~rename(name)]', 'legendSet[id,displayName~rename(name)]', '!lastUpdated', '!href', '!created', '!publicAccess', '!rewindRelativePeriods', '!userOrganisationUnit', '!userOrganisationUnitChildren', '!userOrganisationUnitGrandChildren', '!externalAccess', '!access', '!relativePeriods', '!columnDimensions', '!rowDimensions', '!filterDimensions', '!user', '!organisationUnitGroups', '!itemOrganisationUnitGroups', '!userGroupAccesses', '!indicators', '!dataElements', '!dataElementOperands', '!dataElementGroups', '!dataSets', '!periods', '!organisationUnitLevels', '!organisationUnits', '!sortOrder', '!topLimit']);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function analysisFields() {
        return _ref.apply(this, arguments);
    };
}();

var mapFields = exports.mapFields = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fields;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return analysisFields();

                    case 2:
                        fields = _context2.sent;
                        return _context2.abrupt('return', baseFields.join(',') + ', mapViews[' + fields.join(',') + ']');

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function mapFields() {
        return _ref2.apply(this, arguments);
    };
}();

var legendFields = exports.legendFields = ['*', '!created', '!lastUpdated', '!displayName', '!externalAccess', '!access', '!userGroupAccesses'];

var legendSetFields = exports.legendSetFields = ['id,displayName~rename(name),legends[' + legendFields.join(',') + ']'];

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(405),
    baseMatchesProperty = __webpack_require__(415),
    identity = __webpack_require__(57),
    isArray = __webpack_require__(21),
    property = __webpack_require__(422);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(329),
    getValue = __webpack_require__(334);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(116),
    isLength = __webpack_require__(124);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('sortBy', __webpack_require__(245));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layer = function (_PureComponent) {
    _inherits(Layer, _PureComponent);

    function Layer() {
        _classCallCheck(this, Layer);

        return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
    }

    _createClass(Layer, [{
        key: 'componentWillMount',


        // Create pane and layer
        value: function componentWillMount() {
            this.createPane();
            this.createLayer();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var map = this.context.map;
            map.addLayer(this.layer);
            this.onLayerAdd();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prev) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                index = _props.index,
                opacity = _props.opacity,
                isVisible = _props.isVisible,
                editCounter = _props.editCounter,
                dataFilters = _props.dataFilters;

            var map = this.context.map;

            // Create new map if new id of editCounter is increased
            if (id !== prev.id || data !== prev.data || editCounter !== prev.editCounter || dataFilters !== prev.dataFilters) {
                this.removeLayer();
                this.createPane();
                this.createLayer();
                map.addLayer(this.layer);
                this.onLayerAdd();
            }

            if (index !== undefined && index !== prev.index) {
                this.setLayerOrder();
            }

            if (opacity !== prev.opacity) {
                this.setLayerOpacity();
            }

            if (isVisible !== prev.isVisible) {
                this.setLayerVisibility();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeLayer();
        }

        // Create custom pane to control layer ordering: http://leafletjs.com/examples/map-panes/

    }, {
        key: 'createPane',
        value: function createPane() {
            var _props2 = this.props,
                id = _props2.id,
                labels = _props2.labels,
                areaRadius = _props2.areaRadius;

            var map = this.context.map;

            this.pane = map.createPane(id);

            if (labels) {
                this.labelPane = map.createPane(id + '-labels');
            }

            if (areaRadius) {
                this.areaPane = map.createPane(id + '-area');
            }
        }

        // Create new layer from config object (override in subclasses)

    }, {
        key: 'createLayer',
        value: function createLayer() {
            var _props3 = this.props,
                id = _props3.id,
                index = _props3.index,
                config = _props3.config;

            var map = this.context.map;
            var layerConfig = _extends({}, config);

            if (index !== undefined) {
                // If not a basemap
                layerConfig.pane = id;
            }

            this.layer = map.createLayer(layerConfig);
        }
    }, {
        key: 'onLayerAdd',
        value: function onLayerAdd() {
            this.setLayerOpacity();
            this.setLayerVisibility();

            if (this.props.index !== undefined) {
                // Basemap don't have index
                this.setLayerOrder();
            }
        }
    }, {
        key: 'setLayerOpacity',
        value: function setLayerOpacity() {
            this.layer.setOpacity(this.props.opacity);
        }

        // Set layer order using custom panes and z-index: http://leafletjs.com/examples/map-panes/

    }, {
        key: 'setLayerOrder',
        value: function setLayerOrder() {
            var index = this.props.index;

            var zIndex = 600 - index * 10;

            if (this.pane) {
                this.pane.style.zIndex = zIndex;
            }

            if (this.areaPane) {
                this.areaPane.style.zIndex = zIndex - 1;
            }

            if (this.labelPane) {
                this.labelPane.style.zIndex = zIndex + 1;
            }
        }
    }, {
        key: 'setLayerVisibility',
        value: function setLayerVisibility() {
            var isVisible = this.props.isVisible;
            var map = this.context.map;
            var layer = this.layer;

            if (isVisible && map.hasLayer(layer) === false) {
                map.addLayer(layer);
            } else if (!isVisible && map.hasLayer(layer) === true) {
                map.removeLayer(layer);
            }
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            var layer = this.layer;
            var map = this.context.map;

            if (map.hasLayer(layer)) {
                map.removeLayer(layer);
            }

            delete this.layer;
            delete this.pane;
            delete this.labelPane;
            delete this.areaPane;
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Layer;
}(_react.PureComponent);

Layer.contextTypes = {
    map: _propTypes2.default.object,
    d2: _propTypes2.default.object
};
Layer.propTypes = {
    id: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number,
    editCounter: _propTypes2.default.number,
    opacity: _propTypes2.default.number,
    isVisible: _propTypes2.default.bool,
    config: _propTypes2.default.object
    // labels: PropTypes.object, // TODO: Is sometimes boolean
};
Layer.defaultProps = {
    opacity: 1,
    isVisible: true
};
exports.default = Layer;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEpicMiddleware__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createEpicMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_0__createEpicMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionsObservable__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionsObservable", function() { return __WEBPACK_IMPORTED_MODULE_1__ActionsObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__combineEpics__ = __webpack_require__(717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineEpics", function() { return __WEBPACK_IMPORTED_MODULE_2__combineEpics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EPIC_END__ = __webpack_require__(577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EPIC_END", function() { return __WEBPACK_IMPORTED_MODULE_3__EPIC_END__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ofType", function() { return __WEBPACK_IMPORTED_MODULE_4__operators__["a"]; });






/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isString', __webpack_require__(253), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(1034);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__["c"]; });









/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateUid = generateUid;
exports.isValidUid = isValidUid;
/**
 * @module uid
 *
 * @description
 * Client side implementation of the DHIS2 code (uid) generator.
 * ({@link https://github.com/dhis2/dhis2-core/blob/ad2d5dea959aff3146d8fe5796cf0b75eb6ee5d8/dhis-2/dhis-api/src/main/java/org/hisp/dhis/common/CodeGenerator.java|CodeGenerator.java})
 *
 * This module is used to generate and validate DHIS2 uids. A valid DHIS2 uid is a 11 character string which starts with a letter from the ISO basic Latin alphabet.
 */

var abc = 'abcdefghijklmnopqrstuvwxyz';
var letters = abc.concat(abc.toUpperCase());

var ALLOWED_CHARS = '0123456789' + letters;

var NUMBER_OF_CODEPOINTS = ALLOWED_CHARS.length;
var CODESIZE = 11;

var CODE_PATTERN = /^[a-zA-Z]{1}[a-zA-Z0-9]{10}$/;

function randomWithMax(max) {
    return Math.floor(Math.random() * max);
}

/**
 * Generate a valid DHIS2 uid. A valid DHIS2 uid is a 11 character string which starts with a letter from the ISO basic Latin alphabet.
 *
 * @return {string} A 11 character uid that always starts with a letter.
 *
 * @example
 * import { generateUid } from 'd2/lib/uid';
 *
 * generateUid();
 */
function generateUid() {
    // First char should be a letter
    var randomChars = letters.charAt(randomWithMax(letters.length));

    for (var i = 1; i < CODESIZE; i += 1) {
        randomChars += ALLOWED_CHARS.charAt(randomWithMax(NUMBER_OF_CODEPOINTS));
    }

    // return new String( randomChars );
    return randomChars;
}

/**
 * Tests whether the given code is valid.
 *
 * @param {string} code The code to validate.
 * @return {boolean} Returns true if the code is valid, false otherwise.
 *
 * @example
 * import { isValidUid } from 'd2/lib/uid';
 *
 * isValidUid('JkWynlWMjJR'); // true
 * isValidUid('0kWynlWMjJR'); // false (Uid can not start with a number)
 * isValidUid('AkWy$lWMjJR'); // false (Uid can only contain alphanumeric characters.
 */
function isValidUid(code) {
    if (code == null) {
        // eslint-disable-line eqeqeq
        return false;
    }

    return CODE_PATTERN.test(code);
}
//# sourceMappingURL=uid.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(389),
    Map = __webpack_require__(129),
    Promise = __webpack_require__(390),
    Set = __webpack_require__(205),
    WeakMap = __webpack_require__(180),
    baseGetTag = __webpack_require__(35),
    toSource = __webpack_require__(182);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = __webpack_require__(882);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_apps__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_apps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_navigation_arrow_downward__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_navigation_arrow_downward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_navigation_arrow_downward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_arrow_drop_right__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_arrow_drop_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_arrow_drop_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_arrow_upward__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_arrow_upward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_arrow_upward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_communication_business__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_communication_business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_communication_business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_cancel__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_cancel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_cancel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_clear__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_close__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_content_create__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_image_crop_free__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_image_crop_free___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_image_crop_free__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_action_delete__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_action_description__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_action_description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_action_description__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_action_done__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_action_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_material_ui_svg_icons_editor_drag_handle__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_material_ui_svg_icons_editor_drag_handle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_material_ui_svg_icons_editor_drag_handle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_svg_icons_communication_email__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_svg_icons_communication_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_material_ui_svg_icons_communication_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_svg_icons_action_extension__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_svg_icons_action_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_material_ui_svg_icons_action_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_svg_icons_content_font_download__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_svg_icons_content_font_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_material_ui_svg_icons_content_font_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_svg_icons_social_group__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_svg_icons_social_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_material_ui_svg_icons_social_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_svg_icons_image_grid_on__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_svg_icons_image_grid_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_material_ui_svg_icons_image_grid_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_svg_icons_action_info_outline__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_material_ui_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_material_ui_svg_icons_editor_insert_chart__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_material_ui_svg_icons_editor_insert_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_material_ui_svg_icons_editor_insert_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_svg_icons_action_list__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_svg_icons_action_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_material_ui_svg_icons_action_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_material_ui_svg_icons_action_launch__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_material_ui_svg_icons_action_launch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_material_ui_svg_icons_action_launch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_material_ui_svg_icons_communication_message__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_material_ui_svg_icons_communication_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_material_ui_svg_icons_communication_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_material_ui_svg_icons_navigation_more_vert__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_material_ui_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_material_ui_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_material_ui_svg_icons_av_not_interested__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_material_ui_svg_icons_av_not_interested___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_material_ui_svg_icons_av_not_interested__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_material_ui_svg_icons_social_person__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_material_ui_svg_icons_social_person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_material_ui_svg_icons_social_person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_material_ui_svg_icons_social_public__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_material_ui_svg_icons_social_public___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_material_ui_svg_icons_social_public__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_material_ui_svg_icons_content_reply__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_material_ui_svg_icons_content_reply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_material_ui_svg_icons_content_reply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_material_ui_svg_icons_action_room__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_material_ui_svg_icons_action_room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_material_ui_svg_icons_action_room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_material_ui_svg_icons_action_search__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_material_ui_svg_icons_action_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_material_ui_svg_icons_action_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_material_ui_svg_icons_editor_show_chart__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_material_ui_svg_icons_editor_show_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_material_ui_svg_icons_editor_show_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_material_ui_svg_icons_toggle_star__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_material_ui_svg_icons_toggle_star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_material_ui_svg_icons_toggle_star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_material_ui_svg_icons_toggle_star_border__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_material_ui_svg_icons_toggle_star_border___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_material_ui_svg_icons_toggle_star_border__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_material_ui_svg_icons_action_thumb_up__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_material_ui_svg_icons_action_thumb_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_material_ui_svg_icons_action_thumb_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_svg_icons_action_view_list__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_svg_icons_action_view_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_material_ui_svg_icons_action_view_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_material_ui_svg_icons_action_visibility__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_material_ui_svg_icons_action_visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_material_ui_svg_icons_action_visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_material_ui_svg_icons_action_visibility_off__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_material_ui_svg_icons_action_visibility_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_material_ui_svg_icons_action_visibility_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_material_ui_svg_icons_social_sentiment_dissatisfied__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_material_ui_svg_icons_social_sentiment_dissatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_material_ui_svg_icons_social_sentiment_dissatisfied__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_material_ui_SvgIcon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_material_ui_SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_material_ui_SvgIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_material_ui_styles_colors__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_material_ui_styles_colors__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















































var icons = {
    Add: __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add___default.a,
    Apps: __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_apps___default.a,
    ArrowDownward: __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_navigation_arrow_downward___default.a,
    ArrowDropRight: __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_arrow_drop_right___default.a,
    ArrowUpward: __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_arrow_upward___default.a,
    Business: __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_communication_business___default.a,
    Cancel: __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_cancel___default.a,
    ChevronLeft: __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_left___default.a,
    ChevronRight: __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_right___default.a,
    Clear: __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_clear___default.a,
    Close: __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_close___default.a,
    Create: __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_content_create___default.a,
    CropFree: __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_image_crop_free___default.a,
    Delete: __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_action_delete___default.a,
    Description: __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_action_description___default.a,
    Done: __WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_action_done___default.a,
    DragHandle: __WEBPACK_IMPORTED_MODULE_18_material_ui_svg_icons_editor_drag_handle___default.a,
    Email: __WEBPACK_IMPORTED_MODULE_19_material_ui_svg_icons_communication_email___default.a,
    Extension: __WEBPACK_IMPORTED_MODULE_20_material_ui_svg_icons_action_extension___default.a,
    FontDownload: __WEBPACK_IMPORTED_MODULE_21_material_ui_svg_icons_content_font_download___default.a,
    GridOn: __WEBPACK_IMPORTED_MODULE_23_material_ui_svg_icons_image_grid_on___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_22_material_ui_svg_icons_social_group___default.a,
    InfoOutline: __WEBPACK_IMPORTED_MODULE_24_material_ui_svg_icons_action_info_outline___default.a,
    InsertChart: __WEBPACK_IMPORTED_MODULE_25_material_ui_svg_icons_editor_insert_chart___default.a,
    List: __WEBPACK_IMPORTED_MODULE_26_material_ui_svg_icons_action_list___default.a,
    Launch: __WEBPACK_IMPORTED_MODULE_27_material_ui_svg_icons_action_launch___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_28_material_ui_svg_icons_communication_message___default.a,
    MoreVert: __WEBPACK_IMPORTED_MODULE_29_material_ui_svg_icons_navigation_more_vert___default.a,
    NotInterested: __WEBPACK_IMPORTED_MODULE_30_material_ui_svg_icons_av_not_interested___default.a,
    Person: __WEBPACK_IMPORTED_MODULE_31_material_ui_svg_icons_social_person___default.a,
    Public: __WEBPACK_IMPORTED_MODULE_32_material_ui_svg_icons_social_public___default.a,
    Reply: __WEBPACK_IMPORTED_MODULE_33_material_ui_svg_icons_content_reply___default.a,
    Room: __WEBPACK_IMPORTED_MODULE_34_material_ui_svg_icons_action_room___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_35_material_ui_svg_icons_action_search___default.a,
    ShowChart: __WEBPACK_IMPORTED_MODULE_36_material_ui_svg_icons_editor_show_chart___default.a,
    Star: __WEBPACK_IMPORTED_MODULE_37_material_ui_svg_icons_toggle_star___default.a,
    StarBorder: __WEBPACK_IMPORTED_MODULE_38_material_ui_svg_icons_toggle_star_border___default.a,
    ThumbUp: __WEBPACK_IMPORTED_MODULE_39_material_ui_svg_icons_action_thumb_up___default.a,
    ViewList: __WEBPACK_IMPORTED_MODULE_40_material_ui_svg_icons_action_view_list___default.a,
    Visibility: __WEBPACK_IMPORTED_MODULE_41_material_ui_svg_icons_action_visibility___default.a,
    VisibilityOff: __WEBPACK_IMPORTED_MODULE_42_material_ui_svg_icons_action_visibility_off___default.a
};

var SvgIcon = function SvgIcon(_ref) {
    var icon = _ref.icon,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        style = _ref.style;

    var Icon = null;
    if (children && !icons[icon]) {
        Icon = __WEBPACK_IMPORTED_MODULE_44_material_ui_SvgIcon___default.a;
    } else {
        Icon = icons[icon] || __WEBPACK_IMPORTED_MODULE_43_material_ui_svg_icons_social_sentiment_dissatisfied___default.a;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Icon,
        {
            className: className,
            style: _extends({}, style, {
                fill: style.fill || (disabled ? __WEBPACK_IMPORTED_MODULE_45_material_ui_styles_colors__["grey200"] : __WEBPACK_IMPORTED_MODULE_45_material_ui_styles_colors__["grey600"])
            })
        },
        children
    );
};

SvgIcon.propTypes = {
    /**
     * Name of the material icon to render
     */
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * A node representing a custom svg
     */
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

    /**
     * The class name to apply to the component
     */
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * Whether icon should have a disabled look
     */
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * Pass inline styles to the root element
     */
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

SvgIcon.defaultProps = {
    icon: '',
    children: null,
    className: '',
    disabled: false,
    style: {}
};

/* harmony default export */ __webpack_exports__["default"] = (SvgIcon);

/***/ }),
/* 57 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(198),
    baseKeys = __webpack_require__(126),
    isArrayLike = __webpack_require__(42);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.apiFetch = undefined;

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isObject = __webpack_require__(221);

var _isObject2 = _interopRequireDefault(_isObject);

var _d = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// TODO: Channel all api request through d2

var apiFetch = exports.apiFetch = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, method, body) {
        var options;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        options = {
                            headers: {}
                        };


                        if (_d.config.context && _d.config.context.auth) {
                            options.headers['Authorization'] = 'Basic ' + btoa(_d.config.context.auth);
                        } else {
                            options.credentials = 'include';
                        }

                        if (method && body) {
                            options.method = method;

                            if ((0, _isString2.default)(body)) {
                                options.headers['Content-Type'] = 'text/html';
                                options.body = body;
                            } else if ((0, _isObject2.default)(body)) {
                                options.headers['Content-Type'] = 'application/json';
                                options.body = JSON.stringify(body);
                            }
                        }

                        return _context.abrupt('return', fetch(encodeURI(_d.config.baseUrl + url), options).then(function (response) {
                            return method !== 'PUT' && method !== 'PATCH' ? response.json() : response;
                        }) // Avoids error
                        .catch(function (error) {
                            return console.log('Error: ', error);
                        }));

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function apiFetch(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setOrgUnitPath = exports.loadOrgUnitPath = exports.setLegendSet = exports.setRadiusHigh = exports.setRadiusLow = exports.setAreaRadius = exports.setLabelFontColor = exports.setLabelFontStyle = exports.setLabelFontWeight = exports.setLabelFontSize = exports.setLabels = exports.setFilter = exports.setParams = exports.setUserOrgUnits = exports.setOrgUnitGroups = exports.setOrgUnitLevels = exports.setAggregationType = exports.setIndicatorGroup = exports.setValueType = exports.setEndDate = exports.setStartDate = exports.setPeriod = exports.setPeriodType = exports.setOrganisationUnitGroupSet = exports.toggleOrganisationUnit = exports.setEventPointColor = exports.setEventPointRadius = exports.setEventClustering = exports.setEventCoordinateField = exports.setColorScale = exports.setClassification = exports.setStyleOptions = exports.setStyleDataItem = exports.setOperand = exports.setDataElementGroup = exports.setDataItem = exports.setProgramStage = exports.setProgram = exports.changeFilter = exports.removeFilter = exports.addFilter = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _optionSets = __webpack_require__(260);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addFilter = exports.addFilter = function addFilter(filter) {
    return {
        type: types.LAYER_EDIT_FILTER_ADD,
        filter: filter
    };
};

var removeFilter = exports.removeFilter = function removeFilter(index) {
    return {
        type: types.LAYER_EDIT_FILTER_REMOVE,
        index: index
    };
};

var changeFilter = exports.changeFilter = function changeFilter(index, filter) {
    return {
        type: types.LAYER_EDIT_FILTER_CHANGE,
        index: index,
        filter: filter
    };
};

// Set program used (event and thematic)
var setProgram = exports.setProgram = function setProgram(program) {
    return {
        type: types.LAYER_EDIT_PROGRAM_SET,
        program: program
    };
};

// Set program stage used (event)
var setProgramStage = exports.setProgramStage = function setProgramStage(programStage) {
    return {
        type: types.LAYER_EDIT_PROGRAM_STAGE_SET,
        programStage: programStage
    };
};

// Set data item (thematic)
var setDataItem = exports.setDataItem = function setDataItem(dataItem, dimension) {
    return {
        type: types.LAYER_EDIT_DATA_ITEM_SET,
        dataItem: dataItem,
        dimension: dimension
    };
};

// Set program indicator used (thematic)
var setDataElementGroup = exports.setDataElementGroup = function setDataElementGroup(dataElementGroup) {
    return {
        type: types.LAYER_EDIT_DATA_ELEMENT_GROUP_SET,
        dataElementGroup: dataElementGroup
    };
};

// Set data element operand (operand = true = details, operand = false = totals)
var setOperand = exports.setOperand = function setOperand(operand) {
    return {
        type: types.LAYER_EDIT_OPERAND_SET,
        operand: operand
    };
};

// Set data element used for styling (event)
var setStyleDataItem = exports.setStyleDataItem = function setStyleDataItem(dataItem) {
    return {
        type: types.LAYER_EDIT_STYLE_DATA_ITEM_SET,
        dataItem: dataItem
    };
};

// Set options for style data element with option set (options are loaded separately) (event layer)
var setStyleOptions = exports.setStyleOptions = function setStyleOptions(options) {
    return {
        type: types.LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET,
        options: options
    };
};

// Set classification style (method, classes, colorScale)
var setClassification = exports.setClassification = function setClassification(method) {
    return {
        type: types.LAYER_EDIT_CLASSIFICATION_SET,
        method: method
    };
};

var setColorScale = exports.setColorScale = function setColorScale(colorScale) {
    return {
        type: types.LAYER_EDIT_COLOR_SCALE_SET,
        colorScale: colorScale
    };
};

// Set coordinate field
var setEventCoordinateField = exports.setEventCoordinateField = function setEventCoordinateField(fieldId) {
    return {
        type: types.LAYER_EDIT_EVENT_COORDINATE_FIELD_SET,
        fieldId: fieldId
    };
};

// Set if event clustering should be used (event)
var setEventClustering = exports.setEventClustering = function setEventClustering(checked) {
    return {
        type: types.LAYER_EDIT_EVENT_CLUSTERING_SET,
        checked: checked
    };
};

// Set event point radius (event layer)
var setEventPointRadius = exports.setEventPointRadius = function setEventPointRadius(radius) {
    return {
        type: types.LAYER_EDIT_EVENT_POINT_RADIUS_SET,
        radius: radius
    };
};

// Set event point color (event layer)
var setEventPointColor = exports.setEventPointColor = function setEventPointColor(color) {
    return {
        type: types.LAYER_EDIT_EVENT_POINT_COLOR_SET,
        color: color
    };
};

var toggleOrganisationUnit = exports.toggleOrganisationUnit = function toggleOrganisationUnit(orgUnit) {
    return {
        type: types.LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE,
        orgUnit: orgUnit
    };
};

// Set organisation unit group set (facility layer)
var setOrganisationUnitGroupSet = exports.setOrganisationUnitGroupSet = function setOrganisationUnitGroupSet(organisationUnitGroupSet) {
    return {
        type: types.LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET,
        organisationUnitGroupSet: organisationUnitGroupSet
    };
};

// Set period type (thematic)
var setPeriodType = exports.setPeriodType = function setPeriodType(periodType) {
    return {
        type: types.LAYER_EDIT_PERIOD_TYPE_SET,
        periodType: periodType
    };
};

// Set period (event & thematic)
var setPeriod = exports.setPeriod = function setPeriod(period) {
    return {
        type: types.LAYER_EDIT_PERIOD_SET,
        period: period
    };
};

// Set start date (event)
var setStartDate = exports.setStartDate = function setStartDate(startDate) {
    return {
        type: types.LAYER_EDIT_START_DATE_SET,
        startDate: startDate
    };
};

// Set end date (event)
var setEndDate = exports.setEndDate = function setEndDate(endDate) {
    return {
        type: types.LAYER_EDIT_END_DATE_SET,
        endDate: endDate
    };
};

// Set value type (thematic)
var setValueType = exports.setValueType = function setValueType(valueType, keepColumns) {
    return {
        type: types.LAYER_EDIT_VALUE_TYPE_SET,
        valueType: valueType,
        keepColumns: keepColumns // Kept if favorite is loaded
    };
};

// Set indicator group (thematic)
var setIndicatorGroup = exports.setIndicatorGroup = function setIndicatorGroup(indicatorGroup) {
    return {
        type: types.LAYER_EDIT_INDICATOR_GROUP_SET,
        indicatorGroup: indicatorGroup
    };
};

// Set aggregation type (thematic)
var setAggregationType = exports.setAggregationType = function setAggregationType(aggregationType) {
    return {
        type: types.LAYER_EDIT_AGGREGATION_TYPE_SET,
        aggregationType: aggregationType
    };
};

// Set org. unit levels (facility, thematic, boundary)
var setOrgUnitLevels = exports.setOrgUnitLevels = function setOrgUnitLevels(levels) {
    return {
        type: types.LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET,
        levels: levels
    };
};

// Set org. unit levels (facility, thematic, boundary)
var setOrgUnitGroups = exports.setOrgUnitGroups = function setOrgUnitGroups(groups) {
    return {
        type: types.LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET,
        groups: groups
    };
};

// Set user org. unit levels (event, facility, thematic, boundary)
var setUserOrgUnits = exports.setUserOrgUnits = function setUserOrgUnits(userOrgUnits) {
    return {
        type: types.LAYER_EDIT_USER_ORGANISATION_UNITS_SET,
        userOrgUnits: userOrgUnits
    };
};

// Set layer params (EE)
var setParams = exports.setParams = function setParams(min, max, palette) {
    return {
        type: types.LAYER_EDIT_PARAMS_SET,
        min: min,
        max: max,
        palette: palette
    };
};

// Set collection filter (EE)
var setFilter = exports.setFilter = function setFilter(filter) {
    return {
        type: types.LAYER_EDIT_FILTER_SET,
        filter: filter
    };
};

// Set label visibility
var setLabels = exports.setLabels = function setLabels(isChecked) {
    return {
        type: types.LAYER_EDIT_LABELS_SET,
        isChecked: isChecked
    };
};

// Set label font style (italic)
var setLabelFontSize = exports.setLabelFontSize = function setLabelFontSize(size) {
    return {
        type: types.LAYER_EDIT_LABEL_FONT_SIZE_SET,
        size: size
    };
};

// Set label font weight (bold)
var setLabelFontWeight = exports.setLabelFontWeight = function setLabelFontWeight(weight) {
    return {
        type: types.LAYER_EDIT_LABEL_FONT_WEIGHT_SET,
        weight: weight
    };
};

// Set label font style
var setLabelFontStyle = exports.setLabelFontStyle = function setLabelFontStyle(style) {
    return {
        type: types.LAYER_EDIT_LABEL_FONT_STYLE_SET,
        style: style
    };
};

// Set label font color
var setLabelFontColor = exports.setLabelFontColor = function setLabelFontColor(color) {
    return {
        type: types.LAYER_EDIT_LABEL_FONT_COLOR_SET,
        color: color
    };
};

// Set area radius (facility)
var setAreaRadius = exports.setAreaRadius = function setAreaRadius(radius) {
    return {
        type: types.LAYER_EDIT_AREA_RADIUS_SET,
        radius: radius
    };
};

// Set point radius low (thematic, boundary)
var setRadiusLow = exports.setRadiusLow = function setRadiusLow(radius) {
    return {
        type: types.LAYER_EDIT_RADIUS_LOW_SET,
        radius: radius
    };
};

// Set point radius high (thematic)
var setRadiusHigh = exports.setRadiusHigh = function setRadiusHigh(radius) {
    return {
        type: types.LAYER_EDIT_RADIUS_HIGH_SET,
        radius: radius
    };
};

// Set legend set (event, thematic)
var setLegendSet = exports.setLegendSet = function setLegendSet(legendSet) {
    return {
        type: types.LAYER_EDIT_LEGEND_SET_SET,
        legendSet: legendSet
    };
};

// Load organisation unit tree path (temporary solution, as favorites don't include paths)
var loadOrgUnitPath = exports.loadOrgUnitPath = function loadOrgUnitPath(id) {
    return {
        type: types.LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD,
        id: id
    };
};

// Load organisation unit tree path (temporary solution, as favorites don't include paths)
var setOrgUnitPath = exports.setOrgUnitPath = function setOrgUnitPath(id, path) {
    return {
        type: types.LAYER_EDIT_ORGANISATION_UNIT_PATH_SET,
        id: id,
        path: path
    };
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatAsISODate = formatAsISODate;
exports.filterFuturePeriods = filterFuturePeriods;
exports.getYYYYMM = getYYYYMM;
exports.getBiMonthlyId = getBiMonthlyId;
exports.validateIfValueIsInteger = validateIfValueIsInteger;
exports.getCurrentYear = getCurrentYear;
exports.is53WeekISOYear = is53WeekISOYear;
exports.addDays = addDays;
exports.addMonths = addMonths;
exports.subtractDays = subtractDays;
exports.getFirstDayInFirstISOWeekForYear = getFirstDayInFirstISOWeekForYear;
exports.getLastDayOfTheWeekForFirstDayOfTheWeek = getLastDayOfTheWeekForFirstDayOfTheWeek;
exports.getMonthNamesForLocale = getMonthNamesForLocale;
exports.getLastDateOfMonth = getLastDateOfMonth;
exports.getFirstDateOfQuarter = getFirstDateOfQuarter;
exports.getLastDateOfQuarter = getLastDateOfQuarter;
exports.getFirstDateOfWeek = getFirstDateOfWeek;

var _check = __webpack_require__(15);

function formatAsISODate(date) {
    if (!(date instanceof Date)) {
        throw new Error('formatAsISODate(date) only accepts Date objects');
    }

    var y = date.getFullYear();
    var m = ('0' + (date.getMonth() + 1)).substr(-2);
    var d = ('0' + date.getDate()).substr(-2);
    return y + '-' + m + '-' + d;
}

function filterFuturePeriods(periods) {
    var array = [];
    var now = new Date();

    for (var i = 0; i < periods.length; i++) {
        if (new Date(periods[i].startDate) <= now) {
            array.push(periods[i]);
        }
    }

    return array;
}

function getYYYYMM(date) {
    var y = date.getFullYear();
    var m = '' + (date.getMonth() + 1);
    m = ('0' + m).substr(-2);
    return y + m;
}

function getBiMonthlyId(date) {
    var y = date.getFullYear();
    var m = ('0' + (Math.floor(date.getMonth() / 2) + 1)).substr(-2);
    return y + m + 'B';
}

function validateIfValueIsInteger(year) {
    if (!(0, _check.isInteger)(year)) {
        throw new Error('Generator should be called with an integer to identify the year.' + ' Perhaps you passed a Date object?');
    }

    if (year < 0) {
        throw new Error('Generator does not support generating year before the year 0.');
    }
}

function getCurrentYear() {
    return new Date().getFullYear();
}

function is53WeekISOYear(year) {
    var p = function p(y) {
        return y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400);
    };

    return p(year) % 7 === 4 || p(year - 1) % 7 === 3;
}

function addDays(days, date) {
    var result = new Date(date);

    result.setDate(result.getDate() + days);

    return result;
}

function addMonths(months, date) {
    var result = new Date(date);

    result.setMonth(date.getMonth() + months);

    return result;
}

function subtractDays(days, date) {
    return addDays(-days, date);
}

function getFirstDayInFirstISOWeekForYear(year) {
    // The first ISO week of the year always contains 4th January. We can use this as a pointer to start the first week.
    var startDate = new Date(year, 0, 4);

    // January 4th might not be at the start of the week. Therefore we rewind to the start of the week.
    if (startDate.getDay() === 0) {
        startDate = subtractDays(6, startDate);
        // If January 4th is on a Sunday we'll revert back 6 days
    } else {
        // We'll revert back the current day number of days - 1 (Due to the days being 0 indexed with 0 being Sunday)
        var daysAfterMonday = startDate.getDay() - 1;
        startDate = subtractDays(daysAfterMonday, startDate);
    }

    return startDate;
}

function getLastDayOfTheWeekForFirstDayOfTheWeek(startDate) {
    var endDate = new Date(startDate);

    endDate.setDate(endDate.getDate() + 6);

    return endDate;
}

function getMonthNamesForLocale(locale) {
    var monthNames = [];

    for (var i = 0; i < 12; i += 1) {
        var monthName = new Date(2000, i, 1).toLocaleDateString(locale, { month: 'long' });
        monthNames.push(monthName);
    }

    return monthNames;
}

function getLastDateOfMonth(year, month) {
    return new Date(new Date(year, month + 1).setDate(0));
}

function getFirstDateOfQuarter(year, quarter) {
    var startMonth = (quarter - 1) * 3;
    return new Date(year, startMonth);
}

function getLastDateOfQuarter(year, quarter) {
    return new Date(getFirstDateOfQuarter(year, quarter + 1).setDate(0));
}

var ordTable = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
var ordTableLeap = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function getFirstDateOfWeek(year, week) {
    var isLeapYear = new Date(new Date(year, 2, 1).setDate(0)).getDate() === 29;
    var ordDiff = isLeapYear ? ordTableLeap : ordTable;

    var correction = (new Date(year, 0, 4).getDay() || 7) + 3;
    var ordDate = week * 7 + (1 - correction);
    if (ordDate < 0) {
        return new Date(year, 0, ordDate);
    }

    var month = 11;
    while (ordDate < ordDiff[month]) {
        month--; // eslint-disable-line
    }

    return new Date(year, month, ordDate - ordDiff[month]);
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 63 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isKey = __webpack_require__(137),
    stringToPath = __webpack_require__(214),
    toString = __webpack_require__(215);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var errorActionCreator = exports.errorActionCreator = function errorActionCreator(actionType) {
    return function (error) {
        return {
            type: actionType,
            error: error
        };
    };
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.drillUpDown = exports.toGeoJson = exports.isValidCoordinate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _compact = __webpack_require__(472);

var _compact2 = _interopRequireDefault(_compact);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _dimension = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidCoordinate = exports.isValidCoordinate = function isValidCoordinate(coord) {
    return Array.isArray(coord) && coord.length === 2 && coord[0] >= -180 && coord[0] <= 180 && coord[1] >= -90 && coord[1] <= 90;
};

var toGeoJson = exports.toGeoJson = function toGeoJson(organisationUnits) {
    return (0, _sortBy2.default)('le', organisationUnits).map(function (ou) {
        var coord = JSON.parse(ou.co);
        var gpid = '';
        var gppg = '';
        var type = 'Point';

        if (ou.ty === 2) {
            type = 'Polygon';
            if (ou.co.substring(0, 4) === '[[[[') {
                type = 'MultiPolygon';
            }
        }

        // Grand parent
        if ((0, _isString2.default)(ou.pg) && ou.pg.length) {
            var ids = (0, _compact2.default)(ou.pg.split('/'));

            // Grand parent id
            if (ids.length >= 2) {
                gpid = ids[ids.length - 2];
            }

            // Grand parent parent graph
            if (ids.length > 2) {
                gppg = '/' + ids.slice(0, ids.length - 2).join('/');
            }
        }

        return {
            type: 'Feature',
            id: ou.id,
            geometry: {
                type: type,
                coordinates: coord
            },
            properties: {
                id: ou.id,
                name: ou.na,
                hasCoordinatesDown: ou.hcd,
                hasCoordinatesUp: ou.hcu,
                level: ou.le,
                grandParentParentGraph: gppg,
                grandParentId: gpid,
                parentGraph: ou.pg,
                parentId: ou.pi,
                parentName: ou.pn
            }
        };
    }).filter(function (_ref) {
        var geometry = _ref.geometry;
        return Array.isArray(geometry.coordinates) && geometry.coordinates.length;
    });
};

// TODO: parentGraph is not used
var drillUpDown = exports.drillUpDown = function drillUpDown(layerConfig, parentId, parentGraph, level) {
    return _extends({}, layerConfig, {
        rows: [{
            dimension: _dimension.dimConf.organisationUnit.objectName,
            items: [{ id: parentId }, { id: 'LEVEL-' + level }]
        }],
        parentGraphMap: {}
    });
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.classificationTypes = exports.CLASSIFICATION_EQUAL_COUNTS = exports.CLASSIFICATION_EQUAL_INTERVALS = exports.CLASSIFICATION_PREDEFINED = exports.EVENT_RADIUS = exports.EVENT_COLOR = exports.EVENT_END_DATE = exports.EVENT_START_DATE = undefined;

var _d3TimeFormat = __webpack_require__(139);

var formatTime = (0, _d3TimeFormat.timeFormat)('%Y-%m-%d');

/* EVENT LAYER */
var EVENT_START_DATE = exports.EVENT_START_DATE = formatTime(new Date().setFullYear(new Date().getFullYear() - 1));
var EVENT_END_DATE = exports.EVENT_END_DATE = formatTime(new Date());
var EVENT_COLOR = exports.EVENT_COLOR = '#333333';
var EVENT_RADIUS = exports.EVENT_RADIUS = 6;

/* CLASSIFICATION */

var CLASSIFICATION_PREDEFINED = exports.CLASSIFICATION_PREDEFINED = 1;
var CLASSIFICATION_EQUAL_INTERVALS = exports.CLASSIFICATION_EQUAL_INTERVALS = 2;
var CLASSIFICATION_EQUAL_COUNTS = exports.CLASSIFICATION_EQUAL_COUNTS = 3;

var classificationTypes = exports.classificationTypes = [{
    id: CLASSIFICATION_EQUAL_INTERVALS,
    name: 'Equal intervals'
}, {
    id: CLASSIFICATION_EQUAL_COUNTS,
    name: 'Equal counts'
}];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(507)('wks');
var uid = __webpack_require__(262);
var Symbol = __webpack_require__(103).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);

exports.default = {

  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  horizontal: horizontal,

  vertical: vertical,

  origin: _propTypes2.default.shape({
    horizontal: horizontal,
    vertical: vertical
  }),

  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(1137);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(1139);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(1141);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(1142);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(1143);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(1144);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(122),
    baseAssignValue = __webpack_require__(150);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = __webpack_require__(949);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AnalyticsRequestDimensionsMixin = __webpack_require__(311);

var _AnalyticsRequestDimensionsMixin2 = _interopRequireDefault(_AnalyticsRequestDimensionsMixin);

var _AnalyticsRequestFiltersMixin = __webpack_require__(312);

var _AnalyticsRequestFiltersMixin2 = _interopRequireDefault(_AnalyticsRequestFiltersMixin);

var _AnalyticsRequestPropertiesMixin = __webpack_require__(313);

var _AnalyticsRequestPropertiesMixin2 = _interopRequireDefault(_AnalyticsRequestPropertiesMixin);

var _AnalyticsRequestBase = __webpack_require__(314);

var _AnalyticsRequestBase2 = _interopRequireDefault(_AnalyticsRequestBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @memberof module:analytics
 *
 * @extends module:analytics.AnalyticsRequestDimensionsMixin
 * @extends module:analytics.AnalyticsRequestFiltersMixin
 * @extends module:analytics.AnalyticsRequestPropertiesMixin
 * @extends module:analytics.AnalyticsRequestBase
 */
var AnalyticsRequest = function (_AnalyticsRequestDime) {
    _inherits(AnalyticsRequest, _AnalyticsRequestDime);

    function AnalyticsRequest() {
        _classCallCheck(this, AnalyticsRequest);

        return _possibleConstructorReturn(this, (AnalyticsRequest.__proto__ || Object.getPrototypeOf(AnalyticsRequest)).apply(this, arguments));
    }

    return AnalyticsRequest;
}((0, _AnalyticsRequestDimensionsMixin2.default)((0, _AnalyticsRequestFiltersMixin2.default)((0, _AnalyticsRequestPropertiesMixin2.default)(_AnalyticsRequestBase2.default))));

exports.default = AnalyticsRequest;
//# sourceMappingURL=AnalyticsRequest.js.map

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(178),
    createBind = __webpack_require__(335),
    createCurry = __webpack_require__(336),
    createHybrid = __webpack_require__(183),
    createPartial = __webpack_require__(352),
    getData = __webpack_require__(187),
    mergeData = __webpack_require__(353),
    setData = __webpack_require__(190),
    setWrapToString = __webpack_require__(192),
    toInteger = __webpack_require__(97);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    isObject = __webpack_require__(26);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(355),
    isObjectLike = __webpack_require__(25);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23),
    stubFalse = __webpack_require__(356);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(360),
    listCacheDelete = __webpack_require__(361),
    listCacheGet = __webpack_require__(362),
    listCacheHas = __webpack_require__(363),
    listCacheSet = __webpack_require__(364);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(80);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(378);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var dimConf = exports.dimConf = {
    data: {
        id: 'data',
        value: 'data',
        param: 'dx',
        dimensionName: 'dx',
        objectName: 'dx'
    },
    category: {
        name: 'categories',
        dimensionName: 'co',
        objectName: 'co'
    },
    indicator: {
        id: 'indicator',
        value: 'indicators',
        param: 'in',
        dimensionName: 'dx',
        objectName: 'in',
        itemType: 'INDICATOR'
    },
    dataElement: {
        id: 'dataElement',
        value: 'dataElement',
        param: 'de',
        dimensionName: 'dx',
        objectName: 'de',
        itemType: 'DATA_ELEMENT' // AGGREGATE_DATA_ELEMENT
    },
    operand: {
        id: 'operand',
        value: 'operand',
        param: 'dc',
        dimensionName: 'dx',
        objectName: 'dc',
        itemType: 'DATA_ELEMENT_OPERAND'
    },
    dataSet: {
        value: 'dataSets',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'DATA_SET'
    },
    eventDataItem: {
        value: 'eventDataItem',
        dimensionName: 'dx',
        objectName: 'di'
    },
    programDataElement: {
        value: 'programDataElement',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_DATA_ELEMENT'
    },
    programAttribute: {
        value: 'programAttribute',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_ATTRIBUTE'
    },
    programIndicator: {
        value: 'programIndicator',
        dimensionName: 'dx',
        objectName: 'pi',
        itemType: 'PROGRAM_INDICATOR'
    },
    period: {
        id: 'period',
        value: 'period',
        param: 'pe',
        dimensionName: 'pe',
        objectName: 'pe'
    },
    organisationUnit: {
        id: 'organisationUnit',
        value: 'organisationUnit',
        param: 'ou',
        dimensionName: 'ou',
        objectName: 'ou'
    },
    reportingRate: {
        value: 'reportingRate',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'REPORTING_RATE'
    },
    value: {
        id: 'value',
        value: 'value',
        param: 'value',
        dimensionName: 'value',
        objectName: 'value'
    }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var concatMap_1 = __webpack_require__(776);
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setOrgUnitCoordinate = exports.changeOrgUnitCoordinate = exports.stopRelocateOrgUnit = exports.startRelocateOrgUnit = exports.unselectOrgUnit = exports.selectOrgUnit = exports.closeOrgUnit = exports.setOrgUnit = exports.loadOrgUnit = exports.setOrgUnitGroupSets = exports.loadOrgUnitGroupSets = exports.setOrgUnitGroups = exports.loadOrgUnitGroups = exports.setOrgUnitLevels = exports.loadOrgUnitLevels = exports.setOrgUnitTree = exports.loadOrgUnitTree = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load organisation unit tree
var loadOrgUnitTree = exports.loadOrgUnitTree = function loadOrgUnitTree() {
    return {
        type: types.ORGANISATION_UNIT_TREE_LOAD
    };
};

// set organisation unit tree
var setOrgUnitTree = exports.setOrgUnitTree = function setOrgUnitTree(rootModel) {
    return {
        type: types.ORGANISATION_UNIT_TREE_SET,
        payload: rootModel
    };
};

// Load all organisation unit groups sets
var loadOrgUnitLevels = exports.loadOrgUnitLevels = function loadOrgUnitLevels() {
    return {
        type: types.ORGANISATION_UNIT_LEVELS_LOAD
    };
};

// Set all organisation unit groups sets
var setOrgUnitLevels = exports.setOrgUnitLevels = function setOrgUnitLevels(data) {
    return {
        type: types.ORGANISATION_UNIT_LEVELS_SET,
        payload: data
    };
};

// Load all organisation unit groups sets
var loadOrgUnitGroups = exports.loadOrgUnitGroups = function loadOrgUnitGroups() {
    return {
        type: types.ORGANISATION_UNIT_GROUPS_LOAD
    };
};

// Set all organisation unit groups sets
var setOrgUnitGroups = exports.setOrgUnitGroups = function setOrgUnitGroups(data) {
    return {
        type: types.ORGANISATION_UNIT_GROUPS_SET,
        payload: data
    };
};

// Load all organisation unit groups sets
var loadOrgUnitGroupSets = exports.loadOrgUnitGroupSets = function loadOrgUnitGroupSets() {
    return {
        type: types.ORGANISATION_UNIT_GROUP_SETS_LOAD
    };
};

// Set all organisation unit groups sets
var setOrgUnitGroupSets = exports.setOrgUnitGroupSets = function setOrgUnitGroupSets(data) {
    return {
        type: types.ORGANISATION_UNIT_GROUP_SETS_SET,
        payload: data
    };
};

var loadOrgUnit = exports.loadOrgUnit = function loadOrgUnit(attr) {
    return {
        type: types.ORGANISATION_UNIT_LOAD,
        payload: attr
    };
};

var setOrgUnit = exports.setOrgUnit = function setOrgUnit(model) {
    return {
        type: types.ORGANISATION_UNIT_SET,
        payload: model
    };
};

var closeOrgUnit = exports.closeOrgUnit = function closeOrgUnit() {
    return {
        type: types.ORGANISATION_UNIT_CLOSE
    };
};

var selectOrgUnit = exports.selectOrgUnit = function selectOrgUnit(layerId, featureId) {
    return {
        type: types.ORGANISATION_UNIT_SELECT,
        layerId: layerId,
        featureId: featureId
    };
};

var unselectOrgUnit = exports.unselectOrgUnit = function unselectOrgUnit(layerId, featureId) {
    return {
        type: types.ORGANISATION_UNIT_UNSELECT,
        layerId: layerId,
        featureId: featureId
    };
};

var startRelocateOrgUnit = exports.startRelocateOrgUnit = function startRelocateOrgUnit(layerId, feature) {
    return {
        type: types.ORGANISATION_UNIT_RELOCATE_START,
        layerId: layerId,
        feature: feature
    };
};

var stopRelocateOrgUnit = exports.stopRelocateOrgUnit = function stopRelocateOrgUnit(layerId, feature) {
    return {
        type: types.ORGANISATION_UNIT_RELOCATE_STOP,
        layerId: layerId,
        feature: feature
    };
};

var changeOrgUnitCoordinate = exports.changeOrgUnitCoordinate = function changeOrgUnitCoordinate(layerId, featureId, coordinate) {
    return {
        type: types.ORGANISATION_UNIT_COORDINATE_CHANGE,
        layerId: layerId,
        featureId: featureId,
        coordinate: coordinate
    };
};

var setOrgUnitCoordinate = exports.setOrgUnitCoordinate = function setOrgUnitCoordinate(layerId, featureId, coordinate) {
    return {
        type: types.ORGANISATION_UNIT_COORDINATE_SET,
        layerId: layerId,
        featureId: featureId,
        coordinate: coordinate
    };
};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _ModelBase = __webpack_require__(113);

var _ModelBase2 = _interopRequireDefault(_ModelBase);

var _attibutes = __webpack_require__(282);

var _attibutes2 = _interopRequireDefault(_attibutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pickAttributeValues = (0, _utils.pickOr)('attributeValues', []);

// TODO: Perhaps we can generate model classes dynamically based on the schemas and inherit from this.
/**
 * @extends ModelBase
 *
 * @description
 * A Model represents an object from the DHIS2 Api. A model is created based of a ModelDefinition. The ModelDefinition
 * has the properties that the model should have.
 *
 * @memberof module:model
 */

var Model = function () {
  /**
   * @constructor
   *
   * @param {ModelDefinition} modelDefinition The model definition that corresponds with the model.
   * This is essential defining what type the model is representing.
   *
   * @description
   * Will create a new model instanced based on the model definition. When creating a new instance the model
   * definition needs to have both the modelValidations and modelProperties.
   *
   * The model properties will depend on the ModelDefinition. A model definition is based on a DHIS2 Schema.
   */
  function Model(modelDefinition) {
    var _this = this;

    _classCallCheck(this, Model);

    (0, _check.checkType)(modelDefinition, 'object', 'modelDefinition');
    (0, _check.checkType)(modelDefinition.modelProperties, 'object', 'modelProperties');

    /**
     * @property {ModelDefinition} modelDefinition Stores reference to the modelDefinition that was used when
     * creating the model. This property is not enumerable or writable and will therefore not show up when looping
     * over the object properties.
     */
    Object.defineProperty(this, 'modelDefinition', { value: modelDefinition });

    /**
     * @property {Boolean} dirty Represents the state of the model. When the model is concidered `dirty`
     * there are pending changes.
     * This property is not enumerable or writable and will therefore not show up when looping
     * over the object properties.
     */
    Object.defineProperty(this, 'dirty', { writable: true, value: false });

    /**
     * @private
     * @property {Object} dataValues Values object used to store the actual model values. Normally access to the
     * Model data will be done through accessor properties that are generated from the modelDefinition.
     *
     * @note {warning} This should not be accessed directly.
     */
    Object.defineProperty(this, 'dataValues', { configurable: true, writable: true, value: {} });

    /**
     * Attach the modelDefinition modelProperties (the properties from the schema) onto the Model.
     *
     * For a data element model the modelProperties would be the following
     * https://play.dhis2.org/demo/api/schemas/dataElement.json?fields=properties
     */
    Object.defineProperties(this, modelDefinition.modelProperties);

    var attributes = {};
    var attributeProperties = modelDefinition.attributeProperties;
    if ((0, _check.hasKeys)(attributeProperties)) {
      /**
       * @property {Object} attributes The attributes objects contains references to custom attributes defined
       * on the metadata object.
       *
       * @description
       * These properties are generated based of the attributes that are created for the the specific schema.
       * As these properties are not defined on the schemas they're put on a separate attributes object.
       * When there are no attributes defined for the object type, the attributes property will not be attached
       * to the model.
       *
       * @see https://docs.dhis2.org/2.27/en/user/html/dhis2_user_manual_en_full.html#manage_attribute
       */
      Object.defineProperty(this, 'attributes', { value: attributes });

      var getAttributeValues = function getAttributeValues() {
        return pickAttributeValues(_this);
      };
      var setAttributeValues = function setAttributeValues(attributeValues) {
        return _this.attributeValues = attributeValues;
      };
      var setDirty = function setDirty() {
        return _this.dirty = true;
      };
      var attributeDefinitions = (0, _attibutes2.default)(attributeProperties, getAttributeValues, setAttributeValues, setDirty);

      Object.defineProperties(attributes, attributeDefinitions);
    }

    this[_ModelBase.DIRTY_PROPERTY_LIST] = new Set([]);
  }

  /**
   * @static
   *
   * @param {ModelDefinition} modelDefinition ModelDefinition from which the model should be created
   * @returns {Model} Returns an instance of the model.
   *
   * @description The static method is a factory method to create Model objects. It calls `new Model()` with the passed `ModelDefinition`.
   *
   * ```js
   * let myModel = Model.create(modelDefinition);
   * ```
   */


  _createClass(Model, null, [{
    key: 'create',
    value: function create(modelDefinition) {
      return new Model(modelDefinition);
    }
  }]);

  return Model;
}();

// Set the prototype of the Model class, this way we're able to extend from an single object


Model.prototype = _ModelBase2.default;

exports.default = Model;
//# sourceMappingURL=Model.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(243);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(64),
    toKey = __webpack_require__(46);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(562);
var Subscription_1 = __webpack_require__(432);
var Observer_1 = __webpack_require__(566);
var rxSubscriber_1 = __webpack_require__(433);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMapAlerts = exports.createAlert = undefined;

var _uid = __webpack_require__(50);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createAlert = exports.createAlert = function createAlert(title, description) {
    return {
        id: (0, _uid.generateUid)(),
        title: title,
        description: description
    };
};

// Returns array of all alerts from map config and layers (mapViews)
var getMapAlerts = exports.getMapAlerts = function getMapAlerts(mapConfig) {
    var _concat, _ref;

    return (_concat = (_ref = []).concat.apply(_ref, _toConsumableArray(mapConfig && mapConfig.alerts ? mapConfig.alerts : []))).concat.apply(_concat, _toConsumableArray(mapConfig && mapConfig.mapViews && mapConfig.mapViews.filter(function (layer) {
        return layer.alerts;
    }).map(function (layer) {
        return layer.alerts;
    })));
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.drillLayer = exports.closeLayersDialog = exports.openLayersDialog = exports.sortLayers = exports.changeLayerOpacity = exports.toggleLayerVisibility = exports.toggleLayerExpand = exports.loadLayer = exports.updateLayer = exports.cancelLayer = exports.editLayer = exports.removeLayer = exports.addLayer = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Add new layer
var addLayer = exports.addLayer = function addLayer(config) {
    return {
        type: types.LAYER_ADD,
        payload: config
    };
};

// Remove an overlay
var removeLayer = exports.removeLayer = function removeLayer(id) {
    return {
        type: types.LAYER_REMOVE,
        id: id
    };
};

// Edit overlay
var editLayer = exports.editLayer = function editLayer(layer) {
    return {
        type: types.LAYER_EDIT,
        payload: layer
    };
};

// Cancel overlay (stop editing)
var cancelLayer = exports.cancelLayer = function cancelLayer() {
    return {
        type: types.LAYER_CANCEL
    };
};

// Update existing overlay
var updateLayer = exports.updateLayer = function updateLayer(layer) {
    return {
        type: types.LAYER_UPDATE,
        payload: layer
    };
};

// Load layer data
var loadLayer = exports.loadLayer = function loadLayer(layer) {
    return {
        type: types.LAYER_LOAD,
        payload: layer
    };
};

// Expand/collapse overlay card
var toggleLayerExpand = exports.toggleLayerExpand = function toggleLayerExpand(id) {
    return {
        type: types.LAYER_TOGGLE_EXPAND,
        id: id
    };
};

// Show/hide overlay on map
var toggleLayerVisibility = exports.toggleLayerVisibility = function toggleLayerVisibility(id) {
    return {
        type: types.LAYER_TOGGLE_VISIBILITY,
        id: id
    };
};

// Set overlay opacity
var changeLayerOpacity = exports.changeLayerOpacity = function changeLayerOpacity(id, opacity) {
    return {
        type: types.LAYER_CHANGE_OPACITY,
        id: id,
        opacity: opacity
    };
};

// Change ordering of overlays
var sortLayers = exports.sortLayers = function sortLayers(_ref) {
    var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
    return {
        type: types.LAYER_SORT,
        oldIndex: oldIndex,
        newIndex: newIndex
    };
};

// Open overlay selection dialog
var openLayersDialog = exports.openLayersDialog = function openLayersDialog() {
    return {
        type: types.LAYERS_DIALOG_OPEN
    };
};

// Close overlay selection dialog
var closeLayersDialog = exports.closeLayersDialog = function closeLayersDialog() {
    return {
        type: types.LAYERS_DIALOG_CLOSE
    };
};

// Add new layer
var drillLayer = exports.drillLayer = function drillLayer(layerId, parentId, parentGraph, level) {
    return {
        type: types.LAYER_DRILL,
        layerId: layerId,
        parentId: parentId,
        parentGraph: parentGraph,
        level: level
    };
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultColorScale = exports.defaultClasses = exports.defaultColorScaleName = exports.getColorScale = exports.getColorPalette = exports.colorScales = undefined;

var _colorbrewer = __webpack_require__(257);

var _colorbrewer2 = _interopRequireDefault(_colorbrewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Allowed color scales from ColorBrewer for EE (needs to have at least 9 classes)
var colorScales = exports.colorScales = ['YlOrBr', 'Reds', 'YlGn', 'Greens', 'Blues', 'BuPu', 'RdPu', 'PuRd', 'Greys', 'YlOrBr_reverse', 'Reds_reverse', 'YlGn_reverse', 'Greens_reverse', 'Blues_reverse', 'BuPu_reverse', 'RdPu_reverse', 'PuRd_reverse', 'Greys_reverse', 'PuOr', 'BrBG', 'PRGn', 'PiYG', 'RdBu', 'RdGy', 'RdYlBu', 'Spectral', 'RdYlGn', 'Paired', 'Pastel1', 'Set1', 'Set3'];

// Returns a color brewer scale for a number of classes
var getColorPalette = exports.getColorPalette = function getColorPalette(scale, classes) {
    return _colorbrewer2.default[scale][classes].join(',');
};

// Returns color scale name for a palette
var getColorScale = exports.getColorScale = function getColorScale(palette) {
    var classes = palette.split(',').length;
    return colorScales.find(function (name) {
        return _colorbrewer2.default[name][classes].join(',') === palette;
    });
};

var defaultColorScaleName = exports.defaultColorScaleName = 'YlOrBr';
var defaultClasses = exports.defaultClasses = 5;
var defaultColorScale = exports.defaultColorScale = getColorPalette(defaultColorScaleName, defaultClasses);

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(103);
var core = __webpack_require__(44);
var ctx = __webpack_require__(509);
var hide = __webpack_require__(155);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(144);
var IE8_DOM_DEFINE = __webpack_require__(594);
var toPrimitive = __webpack_require__(510);
var dP = Object.defineProperty;

exports.f = __webpack_require__(145) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(266);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(528);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(614);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
          _this.handleClick(event);
        }
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
          _this.handleClick(event);
        }
      }
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity,
          key: 'touchRipple'
        },
        children
      ) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(512);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(265);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(612);

var _assign2 = _interopRequireDefault(_assign);

exports.withOptions = withOptions;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(613);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

var _supports = __webpack_require__(948);

var supports = _interopRequireWildcard(_supports);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEventOptions = {
  capture: false,
  passive: false
};
/* eslint-disable prefer-spread */

function mergeDefaultEventOptions(options) {
  return (0, _assign2.default)({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(supports.passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  if (supports.addEventListener) {
    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.attachEvent) {
    // IE8+ Support
    target.attachEvent('on' + eventName, function () {
      callback.call(target);
    });
  }
}

function off(target, eventName, callback, options) {
  if (supports.removeEventListener) {
    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.detachEvent) {
    // IE8+ Support
    target.detachEvent('on' + eventName, callback);
  }
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);


  (0, _keys2.default)(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];
    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
    }
  });
}

function withOptions(handler, options) {
   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;

  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener = function (_Component) {
  (0, _inherits3.default)(EventListener, _Component);

  function EventListener() {
    (0, _classCallCheck3.default)(this, EventListener);
    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: 'applyListeners',
    value: function applyListeners(onOrOff) {
      var target = this.props.target;


      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return EventListener;
}(_react.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: _propTypes2.default.element,
  /**
   * The DOM target to listen to.
   */
  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
} : {};
exports.default = EventListener;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dialog = __webpack_require__(968);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dialog2.default;

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FloatingActionButton__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FloatingActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FloatingActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_helpers_utils__ = __webpack_require__(272);







var Button = function Button(_ref) {
    var raised = _ref.raised,
        fab = _ref.fab,
        color = _ref.color,
        disabled = _ref.disabled,
        onClick = _ref.onClick,
        children = _ref.children,
        style = _ref.style,
        selector = _ref.selector;

    var className = Object(__WEBPACK_IMPORTED_MODULE_5__component_helpers_utils__["a" /* createClassName */])('d2-ui-button', selector);
    var MuiButton = void 0;

    if (fab) {
        // Always raised
        MuiButton = __WEBPACK_IMPORTED_MODULE_4_material_ui_FloatingActionButton___default.a;
    } else if (raised) {
        MuiButton = __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a;
    } else {
        MuiButton = __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a;
    }

    var props = {
        label: typeof children === 'string' ? children : null,
        primary: color === 'primary' || null,
        secondary: color === 'accent' || null,
        disabled: disabled,
        onClick: onClick,
        className: className,
        style: style
    };

    // Property gives error on FAB buttons in Material UI 0.19
    if (fab) {
        delete props.primary;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        MuiButton,
        props,
        typeof children !== 'string' ? children : null
    );
};

Button.propTypes = {
    /**
     * If true, the button will use raised styling
     */
    raised: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * If true, the button will use floating action styling
     */
    fab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     *  If true, the button will be disabled
     */
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * The theme color of the button
     */
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['default', 'primary', 'accent']),

    /**
     * onClick callback, which is triggered when the button is clicked
     *
     * The onClick callback will receive one arguments: TouchTap event targeting the button
     *
     */
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

    /**
     * Override the inline-styles of the root element
     */
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * If set, adds a class to the element in the format d2-ui-button-selector
     */
    selector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["default"] = (Button);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_helpers_utils__ = __webpack_require__(272);





var TextField = function TextField(_ref) {
  var type = _ref.type,
      fullWidth = _ref.fullWidth,
      label = _ref.label,
      multiline = _ref.multiline,
      _onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      rows = _ref.rows,
      rowsMax = _ref.rowsMax,
      selector = _ref.selector,
      style = _ref.style,
      value = _ref.value,
      onClick = _ref.onClick;

  var className = Object(__WEBPACK_IMPORTED_MODULE_3__component_helpers_utils__["a" /* createClassName */])('d2-ui-textfield', selector);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default.a, {
    className: className,
    floatingLabelText: label,
    fullWidth: fullWidth,
    hintText: placeholder,
    multiLine: multiline,
    onChange: function onChange(event, val) {
      return _onChange(val);
    },
    rows: rows,
    rowsMax: rowsMax,
    style: style,
    type: type,
    value: value,
    onClick: onClick,
    floatingLabelStyle: { whiteSpace: 'nowrap' } // Avoids overlapping the input field
  });
};

TextField.propTypes = {
  /**
   * If set, expands the TextField to the full width of its parent
   */
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The textfield label
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * If set, allows textfield to expand to more than one line
   */
  multiline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * onChange callback, that is fired when the textfield's value changes
   *
   * The onChange callback will receive one argument: The new value of the text field
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
  * onClick callback, that is fired when the textfield is clicked
  *
  */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * If set, sets the Hint text (v0.19)
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * If set, and multiline is true, sets the initial number of lines
   */
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * If set, and multiline is true, sets the maximum number of lines
   */
  rowsMax: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * If set, adds a class to the element in the format d2-ui-textfield-selector
   */
  selector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Override the inline-styles of the root element
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The input type of the textfield
   */
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['text', 'number']),

  /**
   * The value of the textfield
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

/* harmony default export */ __webpack_exports__["default"] = (TextField);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numericFilter = exports.stringFilter = exports.filterData = undefined;

var _isNumeric = __webpack_require__(274);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Filters an array of object with a set of filters
var filterData = exports.filterData = function filterData(data, filters) {
    if (!filters) {
        return data;
    }

    var filteredData = [].concat(_toConsumableArray(data));

    Object.keys(filters).forEach(function (field) {
        // Loop through all filters
        var filter = filters[field];

        filteredData = filteredData.filter(function (d) {
            // Loop through all data items
            var props = d.properties || d; // GeoJSON or plain object
            var value = props[field];

            return (0, _isNumeric2.default)(value) ? numericFilter(value, filter) : stringFilter(value, filter);
        });
    });

    return filteredData;
};

// Simple check if string contains another string
var stringFilter = exports.stringFilter = function stringFilter(string, filter) {
    return ('' + string).toLowerCase().indexOf(filter.toLowerCase()) !== -1;
};

// Numeric filter supporting AND, OR, GREATER THAN, LESS THAN or equal number
var numericFilter = exports.numericFilter = function numericFilter(value, filter) {
    // TODO: Syntax error handling
    return filter.split(',').some(function (orFilter) {
        // OR filter
        return orFilter.split('&').every(function (filter) {
            return isTrueFilter(value, filter);
        }); // AND filter
    });
};

// Returns true if the filter is true
var isTrueFilter = function isTrueFilter(value, filter) {
    if (filter.indexOf('>') > -1) {
        // GREATER THAN
        return value >= Number(filter.split('>')[1]);
    }

    if (filter.indexOf('<') > -1) {
        // LESS THAN
        return value <= Number(filter.split('<')[1]);
    }

    return value === Number(filter); // Equal number
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DIRTY_PROPERTY_LIST = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ModelValidation = __webpack_require__(169);

var _ModelValidation2 = _interopRequireDefault(_ModelValidation);

var _json = __webpack_require__(114);

var _models = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var modelValidator = _ModelValidation2.default.getModelValidation();

var DIRTY_PROPERTY_LIST = exports.DIRTY_PROPERTY_LIST = Symbol('List to keep track of dirty properties');

/**
 * Base class that supplies functionality to the Model classes
 *
 * @memberof module:model
 */

var ModelBase = function () {
    function ModelBase() {
        _classCallCheck(this, ModelBase);

        this.modelDefinition = {
            modelValidations: {}
        };
    }
    /**
     * @returns {Promise} Returns a promise that resolves when the model has been saved or rejected with the result from
     * the `validate()` call.
     *
     * @definition
     * Will save model as a new object to the server using a POST request. This method would generally be used if
     * you're creating models with pre-specified IDs. Note that this does not check if the model is marked as dirty.
     */


    _createClass(ModelBase, [{
        key: 'create',
        value: function create() {
            var _this = this;

            return this.validate().then(function (validationState) {
                if (!validationState.status) {
                    return Promise.reject(validationState);
                }

                return _this.modelDefinition.saveNew(_this).then(function (apiResponse) {
                    return _models.updateModelFromResponseStatus.call(_this, apiResponse);
                });
            });
        }

        /**
         * @returns {Promise} Returns a promise that resolves when the model has been saved
         * or rejects with the result from the `validate()` call.
         *
         * @description
         * Checks if the model is dirty. When the model is dirty it will check if the values of the model are valid by calling
         * `validate`. If this is correct it will attempt to save the [Model](#/model/Model) to the api.
         *
         * ```js
         * myModel.save()
         *   .then((message) => console.log(message));
         * ```
         */

    }, {
        key: 'save',
        value: function save(includeChildren) {
            var _this2 = this;

            // Calling save when there's nothing to be saved is a no-op
            if (!this.isDirty(includeChildren)) {
                return Promise.resolve({});
            }

            return this.validate().then(function (validationState) {
                if (!validationState.status) {
                    return Promise.reject(validationState);
                }

                return _this2.modelDefinition.save(_this2).then(function (apiResponse) {
                    return _models.updateModelFromResponseStatus.call(_this2, apiResponse);
                });
            });
        }

        /**
         * @returns {Promise} Promise that resolves with an object with a status property that represents if the model
         * is valid or not the fields array will return the names of the fields that are invalid.
         *
         * @description
         * This will run the validations on the properties which have validations set. Normally these validations are defined
         * through the DHIS2 schema. It will check min/max for strings/numbers etc. Additionally it will
         * run model validations against the schema.
         *
         * ```js
         * myModel.validate()
         *  .then(myModelStatus => {
         *    if (myModelStatus.status === false) {
         *      myModelStatus.fields.forEach((fieldName) => console.log(fieldName));
         *    }
         * });
         * ```
         *
         * @deprecated The api now validates the object on save, so doing the additional request to validate the object
         * is not very useful anymore as the validation on POST/PUT is more extensive than the /api/schemas validation.
         */

    }, {
        key: 'validate',
        value: function validate() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var validationMessages = [];

                function unique(current, property) {
                    if (property && current.indexOf(property) === -1) {
                        current.push(property);
                    }
                    return current;
                }

                function asyncRemoteValidation(model) {
                    return modelValidator.validateAgainstSchema(model);
                }

                // Run async validation against the api
                asyncRemoteValidation(_this3).catch(function (remoteMessages) {
                    // Errors are ok in this case
                    if (Array.isArray(remoteMessages)) {
                        return remoteMessages;
                    }
                    return Promise.reject(remoteMessages);
                }).then(function (remoteMessages) {
                    validationMessages = validationMessages.concat(remoteMessages);

                    var validationState = {
                        status: remoteMessages.length === 0,
                        fields: validationMessages.map(function (validationMessage) {
                            return validationMessage.property;
                        }).reduce(unique, []),
                        messages: validationMessages
                    };
                    resolve(validationState);
                }).catch(function (message) {
                    return reject(message);
                });
            });
        }

        // TODO: Cloning large graphs is very slow

    }, {
        key: 'clone',
        value: function clone() {
            var modelClone = this.modelDefinition.create((0, _json.getJSONForProperties)(this, Object.keys(this.modelDefinition.modelValidations), true));

            if (this.isDirty()) {
                modelClone.dirty = this.isDirty(true);
            }

            return modelClone;
        }

        /**
         * Deletes the object from the server.
         *
         * This will fire a DELETE request to have the object be removed from the system.
         *
         * @returns {Promise} Resolves when the object was successfully deleted.
         */

    }, {
        key: 'delete',
        value: function _delete() {
            return this.modelDefinition.delete(this);
        }

        /**
         * Check if the model is in a dirty state and is a candidate to be saved.
         *
         * It will check for direct properties that have been changed and if any of the children have been changed.
         *
         * @param {boolean} includeChildren If set to false only the models direct properties will be checked.
         * @returns {boolean} Returns true when the model is in a dirty state.
         */

    }, {
        key: 'isDirty',
        value: function isDirty() {
            var includeChildren = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this.dirty || includeChildren === true && this.hasDirtyChildren();
        }

        /**
         * Utility method to reset the dirty state of the object.
         *
         * This is called after a successful save operation was done.
         *
         * @returns {ModelBase} Returns itself for potential chaining
         */

    }, {
        key: 'resetDirtyState',
        value: function resetDirtyState() {
            this.dirty = false;

            // Also set it's children to be clean
            this.getDirtyChildren().forEach(function (value) {
                if (value.resetDirtyState) {
                    value.resetDirtyState();
                } else {
                    value.dirty = false; // eslint-disable-line no-param-reassign
                }
            });

            this[DIRTY_PROPERTY_LIST].clear();

            return this;
        }

        /**
         * Returns a list of properties that have been changed.
         *
         * @returns {Array<string>} The names of the properties that were changed.
         */

    }, {
        key: 'getDirtyPropertyNames',
        value: function getDirtyPropertyNames() {
            return Array.from(this[DIRTY_PROPERTY_LIST].values());
        }

        /**
         * This will return the properties that are marked as `owner: true` in the schema definition for the model.
         *
         * @returns {Array<any>} Returns an array of properties that are owned by the object
         */
        // TODO: This name is very misleading and should probably be renamed to something like `getOwnerProperties` (would be a breaking change)

    }, {
        key: 'getCollectionChildren',
        value: function getCollectionChildren() {
            var _this4 = this;

            return Object.keys(this).filter(function (propertyName) {
                return _this4[propertyName] && (0, _models.hasModelValidationForProperty)(_this4, propertyName) && (0, _models.pickOwnerFromModelValidation)(propertyName, _this4);
            }).map(function (propertyName) {
                return _this4[propertyName];
            });
        }

        /**
         * Gets the names of the properties that are collections on the object.
         *
         * These are usually the properties that contain ModelCollectionProperties.
         *
         * @returns {Array<string>} A list of property names that are marked as type `COLLECTION` in the schema.
         */

    }, {
        key: 'getCollectionChildrenPropertyNames',
        value: function getCollectionChildrenPropertyNames() {
            var _this5 = this;

            return Object.keys(this).filter(function (propertyName) {
                return (0, _models.pickTypeFromModelValidation)(propertyName, _this5) === 'COLLECTION';
            });
        }

        /**
         * Gets the names of the properties that are references on the object.
         *
         * These are usually the properties that contain a Model of a different type. (e.g DataElement -> CategoryCombo)
         *
         * @returns {Array<string>} A list of property names that are marked as type `REFERENCE` in the schema.
         */

    }, {
        key: 'getReferenceProperties',
        value: function getReferenceProperties() {
            var _this6 = this;

            return Object.keys(this).filter(function (propertyName) {
                return (0, _models.pickTypeFromModelValidation)(propertyName, _this6) === 'REFERENCE' && (0, _models.pickEmbeddedObjectFromModelValidation)(propertyName, _this6) === false;
            });
        }

        /**
         * Gets the names of the properties that are embedded objects.
         *
         * These the properties that are not represented by a different Model, but are just plain objects that are
         * embedded within the current object.
         *
         * @returns {Array<string>} A list of property names of embedded objects.
         */

    }, {
        key: 'getEmbeddedObjectCollectionPropertyNames',
        value: function getEmbeddedObjectCollectionPropertyNames() {
            var _this7 = this;

            return this.getCollectionChildrenPropertyNames().filter(function (propertyName) {
                return (0, _models.pickEmbeddedObjectFromModelValidation)(propertyName, _this7);
            });
        }

        /**
         * Returns a list of child properties that are marked as dirty. This uses the `getCollectionChildren()` method
         * to retrieve the children properties and then checks if they are marked as dirty.
         *
         * The method does not check if direct properties are dirty as those are tracked on the Model itself.
         *
         * @returns {Array<any>}
         */

    }, {
        key: 'getDirtyChildren',
        value: function getDirtyChildren() {
            return this.getCollectionChildren().filter(function (property) {
                return property && property.dirty === true;
            });
        }

        /**
         * Check if any of the Model's child collections are dirty.
         *
         * @returns {boolean} True when one of the children is dirty.
         */

    }, {
        key: 'hasDirtyChildren',
        value: function hasDirtyChildren() {
            return this.getDirtyChildren().length > 0;
        }

        /**
         * This method is generally intended to, by default, usefully serialize Model objects during JSON serialization.
         *
         * This method will take all the properties that are defined on the schema and create an object with the keys and
         * values for those properties. This will remove any circular dependencies that could have occurred otherwise.
         *
         * @returns {Object}
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            return (0, _json.getJSONForProperties)(this, Object.keys(this.modelDefinition.modelValidations));
        }
    }]);

    return ModelBase;
}();

exports.default = new ModelBase();
//# sourceMappingURL=ModelBase.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getJSONForProperties = getJSONForProperties;
exports.getOwnedPropertyJSON = getOwnedPropertyJSON;

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

/**
 * Map propertyName to modelType
 * The model with propertyName will be treated as a regular array
 * (no collection) if the combination of [propertyName, modelType] exists in the object
 * Empty arrays means it applies to any modelType.
 *
 * @private
 */
var NON_MODEL_COLLECTIONS = {
    aggregationLevels: ['dataElement'],
    grantTypes: ['oAuth2Client'],
    translations: [],
    deliveryChannels: ['programNotificationTemplate'],
    redirectUris: ['oAuth2Client'],
    organisationUnitLevels: ['validationRule'],
    favorites: []
};

var isNonModelCollection = function isNonModelCollection(propertyName, modelType) {
    var modelTypes = NON_MODEL_COLLECTIONS[propertyName];

    if (!modelTypes) {
        return false;
    }

    return (0, _check.contains)(modelType, modelTypes) || (0, _check.isEmpty)(modelTypes);
};
function isPlainValue(collection) {
    return function isPlainValueInCollection(property) {
        return collection.indexOf(property) === -1;
    };
}

function isCollectionProperty(collection) {
    return function (property) {
        return !isPlainValue(collection)(property);
    };
}

function isReferenceProperty(collection) {
    return function (property) {
        return collection.indexOf(property) >= 0;
    };
}

// TODO: Misnamed as it does not actually return JSON
function getJSONForProperties(model, properties) {
    var keepFullModels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var objectToSave = {};
    var collectionPropertiesNames = model.getCollectionChildrenPropertyNames()
    // Even though attributeValues are considered collections, they are handled separately due to their
    // difference in structure.
    .filter(function (propertyName) {
        return propertyName !== 'attributeValues';
    });

    var propertyNames = Object.keys(model.modelDefinition.modelValidations).filter(function (propertyName) {
        return properties.indexOf(propertyName) >= 0;
    }).filter(function (propertyName) {
        return model.dataValues[propertyName] !== undefined && model.dataValues[propertyName] !== null;
    });

    // Handle plain values
    propertyNames.filter(isPlainValue(collectionPropertiesNames)).filter(function (v) {
        return !isReferenceProperty(model.getReferenceProperties())(v);
    }).forEach(function (propertyName) {
        objectToSave[propertyName] = model.dataValues[propertyName];
    });

    // Handle reference properties
    propertyNames.filter(isPlainValue(collectionPropertiesNames)).filter(isReferenceProperty(model.getReferenceProperties())).forEach(function (propertyName) {
        objectToSave[propertyName] = { id: model.dataValues[propertyName].id };
    });

    // Handle non-embedded collection properties
    propertyNames.filter(isCollectionProperty(collectionPropertiesNames)).forEach(function (propertyName) {
        // TODO: This is not the proper way to do this. We should check if the array contains Models
        // These objects are not marked as embedded objects but they behave like they are
        if (isNonModelCollection(propertyName, model.modelDefinition.name)) {
            objectToSave[propertyName] = Array.from(model.dataValues[propertyName]);
            return;
        }

        var values = Array.isArray(model.dataValues[propertyName]) ? model.dataValues[propertyName] : Array.from(model.dataValues[propertyName].values());

        // If the collection is a embedded collection we can save it as is.
        if (model.getEmbeddedObjectCollectionPropertyNames().indexOf(propertyName) !== -1) {
            objectToSave[propertyName] = values;
            return;
        }

        // Transform an object collection to an array of objects with id properties
        objectToSave[propertyName] = values.filter((0, _utils.pick)('id'))
        // For any other types we return an object with just an id
        .map(function (childModel) {
            if (keepFullModels && (0, _check.isFunction)(childModel.clone)) {
                return childModel.clone();
            }
            return { id: childModel.id };
        });
    });

    return objectToSave;
}

// TODO: Misnamed as it does not actually return JSON
function getOwnedPropertyJSON(model) {
    var ownedProperties = model.modelDefinition.getOwnedPropertyNames();

    return getJSONForProperties(model, ownedProperties);
}
//# sourceMappingURL=json.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {Array} keys an array of the loaded keys.
 * @property {String} namespace name of this namespace as on the server.
 *
 * @memberof module:datastore
 */
var BaseStoreNamespace = function () {
    /**
     * @param {string} namespace - the name of the namespace this represents.
     * @param {string[]} keys - preloaded keys for this namespace.
     * @param {module:api.Api} api - the api implementation, used for testing.
     * @param {string} endPoint - the relative API-endpoint, one of ['dataStore, userDataStore'].
     */
    function BaseStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments[3];

        _classCallCheck(this, BaseStoreNamespace);

        if (!(0, _check.isString)(namespace)) {
            throw new Error('BaseStoreNamespace must be called with a string to identify the Namespace');
        }
        if (!(0, _check.isString)(endPoint)) {
            throw new Error('BaseStoreNamespace must be called with an endPoint');
        }
        if (this.constructor === BaseStoreNamespace) {
            throw new Error('Can\'t instantiate abstract class!');
        }

        this.api = api;

        /**
         * The name of the namespace
         * @type {string}
         */
        this.namespace = namespace;

        /**
         * an array of the loaded keys.
         * @type {string[]}
         */
        this.keys = keys || [];
        this.endPoint = endPoint;
    }

    /**
     * Get the keys for this namespace.
     *
     * @returns {Promise} - The internal list of keys for current namespace.
     */


    _createClass(BaseStoreNamespace, [{
        key: 'getKeys',
        value: function getKeys() {
            var _this = this;

            return this.api.get([this.endPoint, this.namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    _this.keys = response;
                    return response;
                }
                return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
            });
        }

        /**
         * Retrieves the value of given key in current namespace.
         *
         * @param key - key to retrieve.
         * @returns {Promise} - The value of the given key.
         */

    }, {
        key: 'get',
        value: function get(key) {
            return this.api.get([this.endPoint, this.namespace, key].join('/'));
        }

        /**
         * Sets the value of given key to given value.
         *
         * This will also create a new namespace on the API-end if it does not exist.
         * If the key exists <a href='#update'> update</a> will be called, unless <code>overrideUpdate</code> equals
         * true.
         *
         * @param key - key in this namespace to set.
         * @param value - JSON-value to be set.
         * @param [overrideUpdate=false] - If true a post-request is sent even if key exists.
         * @param [encrypt=false] - If the value should be encrypted on the server.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this2 = this;

            var overrideUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var encrypt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            if (!overrideUpdate && this.keys.includes(key)) {
                return this.update(key, value);
            }
            var queryParams = encrypt === true ? '?encrypt=true' : '';
            return this.api.post([this.endPoint, this.namespace, key + queryParams].join('/'), value).then(function (resp) {
                _this2.keys = [].concat(_toConsumableArray(_this2.keys), [key]);
                return resp;
            });
        }

        /**
         * Deletes given key from the API.
         * @param {string} key - key to delete.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'delete',
        value: function _delete(key) {
            var _this3 = this;

            if (!(0, _check.isString)(key)) {
                return Promise.reject(new Error('Expected key to be string, but got ' + (typeof key === 'undefined' ? 'undefined' : _typeof(key))));
            }
            return this.api.delete([this.endPoint, this.namespace, key].join('/')).then(function (resp) {
                _this3.keys = _this3.keys.filter(function (elem) {
                    return elem !== key;
                });
                return resp;
            });
        }

        /**
         * Updates a key with given value.
         * @param key - key to update.
         * @param value - value to update to.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'update',
        value: function update(key, value) {
            return this.api.update([this.endPoint, this.namespace, key].join('/'), value);
        }
    }]);

    return BaseStoreNamespace;
}();

exports.default = BaseStoreNamespace;
//# sourceMappingURL=BaseStoreNamespace.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObject = __webpack_require__(26);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    baseLodash = __webpack_require__(119);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(345),
    shortOut = __webpack_require__(191);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(150),
    eq = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(357),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(181);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(85),
    nativeKeys = __webpack_require__(358);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    arrayEach = __webpack_require__(96),
    assignValue = __webpack_require__(122),
    baseAssign = __webpack_require__(197),
    baseAssignIn = __webpack_require__(382),
    cloneBuffer = __webpack_require__(385),
    copyArray = __webpack_require__(79),
    copySymbols = __webpack_require__(386),
    copySymbolsIn = __webpack_require__(388),
    getAllKeys = __webpack_require__(203),
    getAllKeysIn = __webpack_require__(151),
    getTag = __webpack_require__(53),
    initCloneArray = __webpack_require__(391),
    initCloneByTag = __webpack_require__(392),
    initCloneObject = __webpack_require__(397),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isMap = __webpack_require__(398),
    isObject = __webpack_require__(26),
    isSet = __webpack_require__(400),
    keys = __webpack_require__(58);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    stackClear = __webpack_require__(365),
    stackDelete = __webpack_require__(366),
    stackGet = __webpack_require__(367),
    stackHas = __webpack_require__(368),
    stackSet = __webpack_require__(369);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(370),
    mapCacheDelete = __webpack_require__(377),
    mapCacheGet = __webpack_require__(379),
    mapCacheHas = __webpack_require__(380),
    mapCacheSet = __webpack_require__(381);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(387),
    stubArray = __webpack_require__(201);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(199);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(206);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    getPrototype = __webpack_require__(133),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_3__src_isoParse__["a"]; });






/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(222);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadProgramStageDataElements = exports.loadProgramTrackedEntityAttributes = exports.loadProgramIndicators = exports.loadProgramDataElements = exports.loadProgramStages = exports.loadPrograms = exports.setProgramStageDataElements = exports.setProgramIndicators = exports.setProgramDataElements = exports.setProgramAttributes = exports.setProgramStages = exports.setPrograms = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Set all programs
var setPrograms = exports.setPrograms = function setPrograms(data) {
    return {
        type: types.PROGRAMS_SET,
        payload: data
    };
};

// Set program stages for one program
var setProgramStages = exports.setProgramStages = function setProgramStages(programId, payload) {
    return {
        type: types.PROGRAM_STAGES_SET,
        programId: programId,
        payload: payload
    };
};

// Set tracked entity attributes for one program
var setProgramAttributes = exports.setProgramAttributes = function setProgramAttributes(programId, payload) {
    return {
        type: types.PROGRAM_ATTRIBUTES_SET,
        programId: programId,
        payload: payload
    };
};

// Set data elements for one program
var setProgramDataElements = exports.setProgramDataElements = function setProgramDataElements(programId, payload) {
    return {
        type: types.PROGRAM_DATA_ELEMENTS_SET,
        programId: programId,
        payload: payload
    };
};

// Set program indicators for one program
var setProgramIndicators = exports.setProgramIndicators = function setProgramIndicators(programId, payload) {
    return {
        type: types.PROGRAM_INDICATORS_SET,
        programId: programId,
        payload: payload
    };
};

// Set data elements for one program stage
var setProgramStageDataElements = exports.setProgramStageDataElements = function setProgramStageDataElements(programStageId, payload) {
    return {
        type: types.PROGRAM_STAGE_DATA_ELEMENTS_SET,
        programStageId: programStageId,
        payload: payload
    };
};

// Load all programs
var loadPrograms = exports.loadPrograms = function loadPrograms() {
    return {
        type: types.PROGRAMS_LOAD
    };
};

// Load all stages for one program
var loadProgramStages = exports.loadProgramStages = function loadProgramStages(programId) {
    return {
        type: types.PROGRAM_STAGES_LOAD,
        programId: programId
    };
};

// Load program data elements
var loadProgramDataElements = exports.loadProgramDataElements = function loadProgramDataElements(programId) {
    return {
        type: types.PROGRAM_DATA_ELEMENTS_LOAD,
        programId: programId
    };
};

// Load all indicators for one program
var loadProgramIndicators = exports.loadProgramIndicators = function loadProgramIndicators(programId) {
    return {
        type: types.PROGRAM_INDICATORS_LOAD,
        programId: programId
    };
};

// Load program tracked entity attributes
var loadProgramTrackedEntityAttributes = exports.loadProgramTrackedEntityAttributes = function loadProgramTrackedEntityAttributes(programId) {
    return {
        type: types.PROGRAM_ATTRIBUTES_LOAD,
        programId: programId
    };
};

// Load program stage data elements
var loadProgramStageDataElements = exports.loadProgramStageDataElements = function loadProgramStageDataElements(programStageId) {
    return {
        type: types.PROGRAM_STAGE_DATA_ELEMENTS_LOAD,
        programStageId: programStageId
    };
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(156);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(157)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(599);
var defined = __webpack_require__(505);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(613);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelDefinition = __webpack_require__(171);

var _ModelDefinition2 = _interopRequireDefault(_ModelDefinition);

var _Pager = __webpack_require__(283);

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _throwIfContainsOtherThanModelObjects(values) {
    if (values && values[Symbol.iterator]) {
        var toCheck = [].concat(_toConsumableArray(values));
        toCheck.forEach(function (value) {
            if (!(value instanceof _Model2.default)) {
                (0, _utils.throwError)('Values of a ModelCollection must be instances of Model');
            }
        });
    }
}

function _throwIfContainsModelWithoutUid(values) {
    if (values && values[Symbol.iterator]) {
        var toCheck = [].concat(_toConsumableArray(values));
        toCheck.forEach(function (value) {
            if (!(0, _check.isValidUid)(value.id)) {
                (0, _utils.throwError)('Can not add a Model without id to a ModelCollection');
            }
        });
    }
}

/**
 * Collection of `Model` objects that can be interacted upon. Can contain a pager object to easily navigate
 * pages within the system.
 *
 * @memberof module:model
 */

var ModelCollection = function () {
    /**
     * @constructor
     *
     * @param {ModelDefinition} modelDefinition The `ModelDefinition` that this collection is for. This defines the type of models that
     * are allowed to be added to the collection.
     * @param {Model[]} values Initial values that should be added to the collection.
     * @param {Object} pagerData Object with pager data. This object contains data that will be put into the `Pager` instance.
     *
     * @description
     *
     * Creates a new `ModelCollection` object based on the passed `modelDefinition`. Additionally values can be added by passing
     * `Model` objects in the `values` parameter. The collection also exposes a pager object which can be used to navigate through
     * the pages in the collection. For more information see the `Pager` class.
     */
    function ModelCollection(modelDefinition, values, pagerData) {
        var _this = this;

        _classCallCheck(this, ModelCollection);

        (0, _check.checkType)(modelDefinition, _ModelDefinition2.default);
        /**
         * @property {ModelDefinition} modelDefinition The `ModelDefinition` that this collection is for. This defines the type of models that
         * are allowed to be added to the collection.
         */
        this.modelDefinition = modelDefinition;

        /**
         * @property {Pager} pager Pager object that is created from the pagerData that was passed when the collection was constructed. If no pager data was present
         * the pager will have default values.
         */
        this.pager = new _Pager2.default(pagerData, modelDefinition);

        // We can not extend the Map object right away in v8 contexts.
        this.valuesContainerMap = new Map();
        this[Symbol.iterator] = this.valuesContainerMap[Symbol.iterator].bind(this.valuesContainerMap);

        _throwIfContainsOtherThanModelObjects(values);
        _throwIfContainsModelWithoutUid(values);

        // Add the values separately as not all Iterators return the same values
        if ((0, _check.isArray)(values)) {
            values.forEach(function (value) {
                return _this.valuesContainerMap.set(value.id, value);
            });
        }
    }

    /**
     * @property {Number} size The number of Model objects that are in the collection.
     *
     * @description
     * Contains the number of Model objects that are in this collection. If the collection is a collection with a pager. This
     * does not take into account all the items in the database. Therefore when a pager is present on the collection
     * the size will return the items on that page. To get the total number of items consult the pager.
     */


    _createClass(ModelCollection, [{
        key: 'add',


        /**
         * Adds a Model instance to the collection. The model is checked if it is a correct instance of `Model` and if it has
         * a valid id. A valid id is a uid string of 11 alphanumeric characters.
         *
         * @param {Model} value Model instance to add to the collection.
         * @returns {ModelCollection} Returns itself for chaining purposes.
         *
         * @throws {Error} When the passed value is not an instance of `Model`
         * @throws {Error} Throws error when the passed value does not have a valid id.
         */
        value: function add(value) {
            _throwIfContainsOtherThanModelObjects([value]);
            _throwIfContainsModelWithoutUid([value]);

            this.set(value.id, value);
            return this;
        }

        /**
         * If working with the Map type object is inconvenient this method can be used to return the values
         * of the collection as an Array object.
         *
         * @returns {Array} Returns the values of the collection as an array.
         */

    }, {
        key: 'toArray',
        value: function toArray() {
            var resultArray = [];

            this.forEach(function (model) {
                resultArray.push(model);
            });

            return resultArray;
        }
    }, {
        key: 'clear',


        /**
         * Clear the collection and remove all it's values.
         *
         * @returns {this} Returns itself for chaining purposes;
         */
        // TODO: Reset the pager?
        value: function clear() {
            return this.valuesContainerMap.clear.call(this.valuesContainerMap);
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _valuesContainerMap$d;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return (_valuesContainerMap$d = this.valuesContainerMap.delete).call.apply(_valuesContainerMap$d, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'entries',
        value: function entries() {
            return this.valuesContainerMap.entries.call(this.valuesContainerMap);
        }

        // FIXME: This calls the forEach function with the values Map and not with the ModelCollection as the third argument

    }, {
        key: 'forEach',
        value: function forEach() {
            var _valuesContainerMap$f;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return (_valuesContainerMap$f = this.valuesContainerMap.forEach).call.apply(_valuesContainerMap$f, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'get',
        value: function get() {
            var _valuesContainerMap$g;

            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return (_valuesContainerMap$g = this.valuesContainerMap.get).call.apply(_valuesContainerMap$g, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'has',
        value: function has() {
            var _valuesContainerMap$h;

            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return (_valuesContainerMap$h = this.valuesContainerMap.has).call.apply(_valuesContainerMap$h, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'keys',
        value: function keys() {
            return this.valuesContainerMap.keys.call(this.valuesContainerMap);
        }
    }, {
        key: 'set',
        value: function set() {
            var _valuesContainerMap$s;

            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            return (_valuesContainerMap$s = this.valuesContainerMap.set).call.apply(_valuesContainerMap$s, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'values',
        value: function values() {
            return this.valuesContainerMap.values.call(this.valuesContainerMap);
        }
    }, {
        key: 'size',
        get: function get() {
            return this.valuesContainerMap.size;
        }
    }], [{
        key: 'create',
        value: function create(modelDefinition, values, pagerData) {
            return new ModelCollection(modelDefinition, values, pagerData);
        }
    }, {
        key: 'throwIfContainsOtherThanModelObjects',
        value: function throwIfContainsOtherThanModelObjects(value) {
            return _throwIfContainsOtherThanModelObjects(value);
        }
    }, {
        key: 'throwIfContainsModelWithoutUid',
        value: function throwIfContainsModelWithoutUid(value) {
            return _throwIfContainsModelWithoutUid(value);
        }
    }]);

    return ModelCollection;
}();

exports.default = ModelCollection;
//# sourceMappingURL=ModelCollection.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(193);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(204),
    getSymbolsIn = __webpack_require__(202),
    keysIn = __webpack_require__(200);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(426),
    overRest = __webpack_require__(217),
    setToString = __webpack_require__(120);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    isFlattenable = __webpack_require__(427);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showEarthEngineValue = exports.closeContextMenu = exports.openContextMenu = exports.closeCoordinatePopup = exports.openCoordinatePopup = exports.setMapName = exports.setMap = exports.newMap = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var newMap = exports.newMap = function newMap() {
    return {
        type: types.MAP_NEW
    };
};

var setMap = exports.setMap = function setMap(config) {
    return {
        type: types.MAP_SET,
        payload: config
    };
};

var setMapName = exports.setMapName = function setMapName(name) {
    return {
        type: types.MAP_NAME_SET,
        payload: name
    };
};

var openCoordinatePopup = exports.openCoordinatePopup = function openCoordinatePopup(coord) {
    return {
        type: types.MAP_COORDINATE_OPEN,
        payload: coord
    };
};

var closeCoordinatePopup = exports.closeCoordinatePopup = function closeCoordinatePopup(coord) {
    return {
        type: types.MAP_COORDINATE_CLOSE
    };
};

var openContextMenu = exports.openContextMenu = function openContextMenu(payload) {
    return {
        type: types.MAP_CONTEXT_MENU_OPEN,
        payload: payload
    };
};

var closeContextMenu = exports.closeContextMenu = function closeContextMenu() {
    return {
        type: types.MAP_CONTEXT_MENU_CLOSE
    };
};

var showEarthEngineValue = exports.showEarthEngineValue = function showEarthEngineValue(layerId, coordinate) {
    return {
        type: types.MAP_EARTH_ENGINE_VALUE_SHOW,
        layerId: layerId,
        coordinate: coordinate
    };
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(105);
var createDesc = __webpack_require__(236);
module.exports = __webpack_require__(145) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADER_HEIGHT = exports.HEADER_HEIGHT = 88;
var LAYERS_PANEL_WIDTH = exports.LAYERS_PANEL_WIDTH = 300;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__(943);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _RenderToLayer = __webpack_require__(624);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _lodash = __webpack_require__(950);

var _lodash2 = _interopRequireDefault(_lodash);

var _PopoverAnimationDefault = __webpack_require__(951);

var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'none'
  }
};

var Popover = function (_Component) {
  (0, _inherits3.default)(Popover, _Component);

  function Popover(props, context) {
    (0, _classCallCheck3.default)(this, Popover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));

    _this.timeout = null;

    _this.renderLayer = function () {
      var _this$props = _this.props,
          animated = _this$props.animated,
          animation = _this$props.animation,
          anchorEl = _this$props.anchorEl,
          anchorOrigin = _this$props.anchorOrigin,
          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
          canAutoPosition = _this$props.canAutoPosition,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose,
          style = _this$props.style,
          targetOrigin = _this$props.targetOrigin,
          useLayerForClickAway = _this$props.useLayerForClickAway,
          scrollableContainer = _this$props.scrollableContainer,
          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);


      var styleRoot = style;

      if (!animated) {
        styleRoot = {
          position: 'fixed',
          zIndex: _this.context.muiTheme.zIndex.popover
        };

        if (!_this.state.open) {
          return null;
        }

        return _react2.default.createElement(
          _Paper2.default,
          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
          children
        );
      }

      var Animation = animation || _PopoverAnimationDefault2.default;

      return _react2.default.createElement(
        Animation,
        (0, _extends3.default)({
          targetOrigin: targetOrigin,
          style: styleRoot
        }, other, {
          open: _this.state.open && !_this.state.closing
        }),
        children
      );
    };

    _this.componentClickAway = function () {
      _this.requestClose('clickAway');
    };

    _this.setPlacement = function (scrolling) {
      if (!_this.state.open) {
        return;
      }

      if (!_this.popoverRefs.layer.getLayer()) {
        return;
      }

      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
      if (!targetEl) {
        return;
      }

      var _this$props2 = _this.props,
          targetOrigin = _this$props2.targetOrigin,
          anchorOrigin = _this$props2.anchorOrigin;

      var anchorEl = _this.props.anchorEl || _this.anchorEl;

      var anchor = _this.getAnchorPosition(anchorEl);
      var target = _this.getTargetPosition(targetEl);

      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };

      if (scrolling && _this.props.autoCloseWhenOffScreen) {
        _this.autoCloseWhenOffScreen(anchor);
      }

      if (_this.props.canAutoPosition) {
        target = _this.getTargetPosition(targetEl); // update as height may have changed
        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }

      targetEl.style.top = targetPosition.top + 'px';
      targetEl.style.left = targetPosition.left + 'px';
      targetEl.style.maxHeight = window.innerHeight + 'px';
    };

    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);

    _this.popoverRefs = {};

    _this.state = {
      open: props.open,
      closing: false
    };
    return _this;
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open === this.props.open) {
        return;
      }

      if (nextProps.open) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
        this.setState({
          open: true,
          closing: false
        });
      } else {
        if (nextProps.animated) {
          if (this.timeout !== null) return;
          this.setState({ closing: true });
          this.timeout = setTimeout(function () {
            _this2.setState({
              open: false
            }, function () {
              _this2.timeout = null;
            });
          }, 500);
        } else {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.placementTimeout);
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleScroll.cancel();

      if (this.placementTimeout) {
        clearTimeout(this.placementTimeout);
        this.placementTimeout = null;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(reason) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(reason);
      }
    }
  }, {
    key: 'getAnchorPosition',
    value: function getAnchorPosition(el) {
      if (!el) {
        el = _reactDom2.default.findDOMNode(this);
      }

      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.offsetWidth,
        height: el.offsetHeight
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    }
  }, {
    key: 'getTargetPosition',
    value: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    }
  }, {
    key: 'autoCloseWhenOffScreen',
    value: function autoCloseWhenOffScreen(anchorPosition) {
      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
        this.requestClose('offScreen');
      }
    }
  }, {
    key: 'getOverlapMode',
    value: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    }
  }, {
    key: 'getPositions',
    value: function getPositions(anchor, target) {
      var a = (0, _extends3.default)({}, anchor);
      var t = (0, _extends3.default)({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    }
  }, {
    key: 'applyAutoPositionIfNeeded',
    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
          positions = _getPositions.positions,
          anchorPos = _getPositions.anchorPos;

      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) {
          targetPosition.top = Math.max(0, newTop);
        } else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) {
            targetPosition.top = Math.max(0, newTop);
          }
        }
      }

      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(0, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) {
            targetPosition.left = Math.max(0, newLeft);
          }
        }
      }

      return targetPosition;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(_reactEventListener2.default, {
          target: this.props.scrollableContainer,
          onScroll: this.handleScroll,
          onResize: this.handleResize
        }),
        _react2.default.createElement(_RenderToLayer2.default, {
          ref: function ref(_ref) {
            return _this3.popoverRefs.layer = _ref;
          },
          open: this.state.open,
          componentClickAway: this.componentClickAway,
          useLayerForClickAway: this.props.useLayerForClickAway,
          render: this.renderLayer
        })
      );
    }
  }]);
  return Popover;
}(_react.Component);

Popover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  autoCloseWhenOffScreen: true,
  canAutoPosition: true,
  onRequestClose: function onRequestClose() {},
  open: false,
  scrollableContainer: 'window',
  style: {
    overflowY: 'auto'
  },
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  useLayerForClickAway: true,
  zDepth: 1
};
Popover.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Popover.propTypes =  false ? {
  /**
   * This is the DOM element that will be used to set the position of the
   * popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it is added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, the popover will hide when the anchor is scrolled off the screen.
   */
  autoCloseWhenOffScreen: _propTypes2.default.bool,
  /**
   * If true, the popover (potentially) ignores `targetOrigin`
   * and `anchorOrigin` to make itself fit on screen,
   * which is useful for mobile devices.
   */
  canAutoPosition: _propTypes2.default.bool,
  /**
   * The content of the popover.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {string} reason The reason for the close request. Possibles values
   * are 'clickAway' and 'offScreen'.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * If true, the popover is visible.
   */
  open: _propTypes2.default.bool,
  /**
   * Represents the parent scrollable container.
   * It can be an element or a string like `window`.
   */
  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying
   * elements, and trigger an `onRequestClose('clickAway')` call.
   */
  useLayerForClickAway: _propTypes2.default.bool,
  /**
   * The zDepth of the popover.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Popover;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = __webpack_require__(531);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var babelPluginFlowReactPropTypes_proptype_Index =  true ? null : {
  index: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Index", {
  value: babelPluginFlowReactPropTypes_proptype_Index,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_PositionInfo =  true ? null : {
  x: require("prop-types").number.isRequired,
  y: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_PositionInfo", {
  value: babelPluginFlowReactPropTypes_proptype_PositionInfo,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_ScrollPosition =  true ? null : {
  scrollLeft: require("prop-types").number.isRequired,
  scrollTop: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_ScrollPosition", {
  value: babelPluginFlowReactPropTypes_proptype_ScrollPosition,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo =  true ? null : {
  height: require("prop-types").number.isRequired,
  width: require("prop-types").number.isRequired,
  x: require("prop-types").number.isRequired,
  y: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo", {
  value: babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_SizeInfo =  true ? null : {
  height: require("prop-types").number.isRequired,
  width: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_SizeInfo", {
  value: babelPluginFlowReactPropTypes_proptype_SizeInfo,
  configurable: true
});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window */


var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
    function Logger(logging) {
        _classCallCheck(this, Logger);

        (0, _check.checkType)(logging, 'object', 'console');
        this.logger = logging;
    }

    _createClass(Logger, [{
        key: 'canLog',
        value: function canLog(type) {
            return !!(type && console && (0, _check.isType)(this.logger[type], 'function'));
        }
    }, {
        key: 'logMessage',
        value: function logMessage() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';

            if (this.canLog(type) && this.logger[type]) {
                var _logger;

                for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    rest[_key - 1] = arguments[_key];
                }

                (_logger = this.logger)[type].apply(_logger, rest);
                return true;
            }
            return false;
        }
    }, {
        key: 'debug',
        value: function debug() {
            for (var _len2 = arguments.length, rest = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                rest[_key2] = arguments[_key2];
            }

            return this.logMessage.apply(this, ['debug'].concat(rest));
        }
    }, {
        key: 'error',
        value: function error() {
            for (var _len3 = arguments.length, rest = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                rest[_key3] = arguments[_key3];
            }

            return this.logMessage.apply(this, ['error'].concat(rest));
        }
    }, {
        key: 'log',
        value: function log() {
            for (var _len4 = arguments.length, rest = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                rest[_key4] = arguments[_key4];
            }

            return this.logMessage.apply(this, ['log'].concat(rest));
        }
    }, {
        key: 'warn',
        value: function warn() {
            for (var _len5 = arguments.length, rest = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                rest[_key5] = arguments[_key5];
            }

            return this.logMessage.apply(this, ['warn'].concat(rest));
        }
    }], [{
        key: 'getLogger',
        value: function getLogger() {
            var logger = void 0;

            // TODO: This is not very clean try to figure out a better way to do this.
            try {
                // Node version
                logger = global.console;
            } catch (e) {
                // Browser version fallback
                /* istanbul ignore next */
                logger = window.console;
            }

            if (this.logger) {
                return this.logger;
            }
            return this.logger = new Logger(logger);
        }
    }]);

    return Logger;
}();

exports.default = Logger;
//# sourceMappingURL=Logger.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _Logger = __webpack_require__(168);

var _Logger2 = _interopRequireDefault(_Logger);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _json = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles validation of Model objects based on their modelDefinition.
 *
 * @memberof module:model
 */
var ModelValidation = function () {
    function ModelValidation(providedLogger) {
        _classCallCheck(this, ModelValidation);

        (0, _check.checkType)(providedLogger, 'object', 'logger (Logger)');
        this.logger = providedLogger;
    }

    /**
     * @deprecated Client side model validation is deprecated in favour of server side validation only.
     *
     * @returns {{status: boolean, messages: Array}} Returns {status: true, messages: []}
     */


    _createClass(ModelValidation, [{
        key: 'validate',
        value: function validate() {
            this.logger.warn('Client side model validation is deprecated');
            throw new Error('Client side model validation is deprecated');
        }

        /**
         * Sends a POST request against the `api/schemas` endpoint to check if the model is valid.
         *
         * @param {Model} model The model that should be validated.
         * @returns {Array} Returns an array with validation messages if there are any.
         *
         * @note {warn} Currently only checks
         */

    }, {
        key: 'validateAgainstSchema',
        value: function validateAgainstSchema(model) {
            // eslint-disable-line class-methods-use-this
            if (!(model && model.modelDefinition && model.modelDefinition.name)) {
                return Promise.reject('model.modelDefinition.name can not be found');
            }

            function extractValidationViolations(webmessage) {
                if (webmessage.response && webmessage.response.errorReports) {
                    return webmessage.response.errorReports;
                }
                throw new Error('Response was not a WebMessage with the expected format');
            }

            var url = 'schemas/' + model.modelDefinition.name;

            // TODO: The function getOwnedPropertyJSON should probably not be exposed, perhaps we could have a getJSONForModel(ownedPropertiesOnly=true) method.
            return _Api2.default.getApi().post(url, (0, _json.getOwnedPropertyJSON)(model)).catch(function (e) {
                return Promise.reject(e);
            }).then(function (webMessage) {
                if (webMessage.status === 'OK') {
                    return [];
                }
                return Promise.reject(webMessage);
            }).catch(extractValidationViolations);
        }

        /**
         * Returns the `ModelValidation` singleton. Creates a new one if it does not yet exist.
         * Grabs a logger instance by calling `Logger.getLogger`
         *
         * @returns {ModelValidation} New or memoized instance of `ModelInstance`
         */

    }], [{
        key: 'getModelValidation',
        value: function getModelValidation() {
            if (this.modelValidation) {
                return this.modelValidation;
            }
            return this.modelValidation = new ModelValidation(_Logger2.default.getLogger(console));
        }
    }]);

    return ModelValidation;
}();

exports.default = ModelValidation;
//# sourceMappingURL=ModelValidation.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module system
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @requires module:api/Api
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _SystemSettings = __webpack_require__(279);

var _SystemSettings2 = _interopRequireDefault(_SystemSettings);

var _SystemConfiguration = __webpack_require__(280);

var _SystemConfiguration2 = _interopRequireDefault(_SystemConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Represents the system that can be interacted with. There is a single instance of this pre-defined onto the d2
 * object after initialisation. This can be interacted with using its property objects to among other be used
 * to get and save systemSettings.
 *
 * @memberof module:system
 */
var System = function () {
    function System(settings, configuration) {
        _classCallCheck(this, System);

        /**
         * Contains a reference to a `SystemSettings` instance that can be used
         * to retrieve and save system settings.
         *
         * ```js
         * d2.system.settings.get('keyLastSuccessfulResourceTablesUpdate')
         *  .then(systemSettingsValue => {
         *    console.log('Analytics was last updated on: ' + systemSettingsValue);
         *  });
         * ```
         * @type {SystemSettings}
         *
         */
        this.settings = settings;

        /**
         * A representation of the system configuration,
         * that can be used to retrieve and change system configuration options.
         * @type {SystemConfiguration}
         */
        this.configuration = configuration;

        /**
         * An object containing system information about the DHIS2 instance
         * @type {Object}
         */
        this.systemInfo = undefined;

        /**
         * An object containing version information about the DHIS2 instance
         * @type {Object}
         */
        this.version = undefined;

        /**
         * An array of all the webapps that are installed on the current DHIS2 instance
         * @type {Array}
         */
        this.installedApps = undefined;
    }

    /**
     * Sets the systemInfo and version properties
     *
     * @param systemInfo
     */


    _createClass(System, [{
        key: 'setSystemInfo',
        value: function setSystemInfo(systemInfo) {
            this.version = System.parseVersionString(systemInfo.version);
            this.systemInfo = systemInfo;
        }

        /**
         * Sets the list of currently installed webapps
         *
         * @param apps
         */

    }, {
        key: 'setInstalledApps',
        value: function setInstalledApps(apps) {
            this.installedApps = apps;
        }

        /**
         * Refreshes the list of currently installed webapps
         *
         * @returns {Promise} A promise that resolves to the list of installed apps
         */

    }, {
        key: 'loadInstalledApps',
        value: function loadInstalledApps() {
            var _this = this;

            var api = _Api2.default.getApi();

            return api.get('apps').then(function (apps) {
                _this.setInstalledApps(apps);

                return apps;
            });
        }

        /**
         * Upload and install a zip file containing a new webapp
         *
         * @param zipFile Zip file data from a file input form field
         * @param onProgress An optional callback that will be called whenever file upload progress info is available
         * @returns {Promise}
         */

    }, {
        key: 'uploadApp',
        value: function uploadApp(zipFile, onProgress) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();
            var data = new FormData();
            var xhr = void 0;
            data.append('file', zipFile);

            if (onProgress !== undefined) {
                xhr = new XMLHttpRequest();
                xhr.upload.onprogress = function (progress) {
                    if (progress.lengthComputable) {
                        onProgress(progress.loaded / progress.total);
                    }
                };
            }

            return api.post('apps', data, {
                contentType: false,
                processData: false,
                xhr: xhr !== undefined ? function () {
                    return xhr;
                } : undefined
            });
        }

        /**
         * Load the list of apps available in the DHIS 2 app store
         *
         * @param compatibleOnly If true, apps that are incompatible with the current system will be filtered out
         * @returns {Promise}
         */

    }, {
        key: 'loadAppStore',
        value: function loadAppStore() {
            var _this2 = this;

            var compatibleOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return new Promise(function (resolve, reject) {
                var api = _Api2.default.getApi();
                api.get('appStore').then(function (appStoreData) {
                    return resolve(appStoreData.map(function (appData) {
                        var app = Object.assign({}, appData);

                        if (compatibleOnly) {
                            app.versions = app.versions.filter(function (versionData) {
                                return System.isVersionCompatible(_this2.version, versionData);
                            });
                        }

                        return app;
                    }).filter(function (appData) {
                        return appData.versions.length > 0;
                    }));
                }).catch(function (err) {
                    return reject(err);
                });
            });
        }

        /**
         * Install the specified app version from the DHIS 2 app store
         *
         * @param uid The uid of the app version to install
         * @returns {Promise}
         */

    }, {
        key: 'installAppVersion',
        value: function installAppVersion(uid) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();
            return new Promise(function (resolve, reject) {
                api.post(['appStore', uid].join('/'), '', { dataType: 'text' }).then(function () {
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        }

        /**
         * Remove the specified app from the system
         *
         * @param appKey The key of the app to remove
         * @returns {Promise}
         */

    }, {
        key: 'uninstallApp',
        value: function uninstallApp(appKey) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();

            return api.delete(['apps', appKey].join('/'))
            // TODO: Stop jQuery from rejecting successful promises
            .catch(function () {
                return undefined;
            });
        }

        /**
         * Refresh the list of apps that are installed on the server
         *
         * @returns {Promise} A promise that resolves to the updated list of installed apps
         */

    }, {
        key: 'reloadApps',
        value: function reloadApps() {
            var _this3 = this;

            var api = _Api2.default.getApi();
            return api.update('apps').then(function () {
                return _this3.loadInstalledApps();
            });
        }

        /**
         * @static
         * @typedef {Object} ParsedVersion
         * @property {number} major - Major version of the parsed-string (before .)
         * @property {number} minor - Minor version of the parsed-string (after .)
         * @property {boolean} snapshot - If it's a snapshot-version
         */
        // TODO: Validate string
        // TODO: Handle valid version objects too
        /**
         * Parses a version string into an object describing the version.
         * @param {string} version Version-string to parse
         * @returns {module:system.ParsedVersion}
         */

    }], [{
        key: 'parseVersionString',
        value: function parseVersionString(version) {
            return {
                major: Number.parseInt(version, 10),
                minor: Number.parseInt(version.substring(version.indexOf('.') + 1), 10),
                snapshot: version.indexOf('-SNAPSHOT') >= 0
            };
        }

        // Disable eslint complexity warning
        /* eslint-disable complexity */
        /**
         * Compares version a to version b.
         * @param a {string|module:system.ParsedVersion}
         * @param b {string|module:system.ParsedVersion}
         * @returns {number} 0 if same version, else a - b.
         */

    }, {
        key: 'compareVersions',
        value: function compareVersions(a, b) {
            var from = typeof a === 'string' || a instanceof String ? System.parseVersionString(a) : a;
            var to = typeof b === 'string' || b instanceof String ? System.parseVersionString(b) : b;

            if (from.major !== to.major) {
                return from.major - to.major;
            } else if (from.minor !== to.minor) {
                return from.minor - to.minor;
            }

            return (from.snapshot ? 0 : 1) - (to.snapshot ? 0 : 1);
        }

        /**
         * Checks if systemVersion is compatible with appVersion.
         * Versions are compatible if appVersion.minDhisVersion <= parsed systemVersion and
         * if appVersion.maxDhisVersion >= parsed systemVersion.
         * @param systemVersion {string|module:system.ParsedVersion} systemVersion to check
         * @param {Object} appVersion - AppVersion object to check
         * @returns {boolean} true if compatible, false otherwise.
         */

    }, {
        key: 'isVersionCompatible',
        value: function isVersionCompatible(systemVersion, appVersion) {
            var minVersion = appVersion.minDhisVersion || appVersion.min_platform_version || null;
            var maxVersion = appVersion.maxDhisVersion || appVersion.max_platform_version || null;

            var isNewEnough = minVersion ? System.compareVersions(systemVersion, minVersion) >= 0 : true;
            var isNotTooOld = maxVersion ? System.compareVersions(systemVersion, maxVersion) <= 0 : true;

            return isNewEnough && isNotTooOld;
        }
        /* eslint-enable */

        /**
         * Get a new instance of the system object. This will function as a singleton, when a System object has been created
         * when requesting getSystem again the original version will be returned.
         *
         * @returns {System} Object with the system interaction properties
         */

    }, {
        key: 'getSystem',
        value: function getSystem() {
            if (!System.getSystem.system) {
                System.getSystem.system = new System(new _SystemSettings2.default(), new _SystemConfiguration2.default());
            }

            return System.getSystem.system;
        }
    }]);

    return System;
}();

exports.default = System;
//# sourceMappingURL=System.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _ModelDefinitions = __webpack_require__(172);

var _ModelDefinitions2 = _interopRequireDefault(_ModelDefinitions);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelCollection = __webpack_require__(149);

var _ModelCollection2 = _interopRequireDefault(_ModelCollection);

var _ModelCollectionProperty = __webpack_require__(284);

var _ModelCollectionProperty2 = _interopRequireDefault(_ModelCollectionProperty);

var _SchemaTypes = __webpack_require__(285);

var _SchemaTypes2 = _interopRequireDefault(_SchemaTypes);

var _Filters = __webpack_require__(286);

var _Filters2 = _interopRequireDefault(_Filters);

var _ModelBase = __webpack_require__(113);

var _config = __webpack_require__(173);

var _json = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createModelPropertyDescriptor(propertiesObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var propertyDetails = {
        // Actual property descriptor properties
        configurable: false,
        enumerable: true,
        get: function get() {
            return this.dataValues[propertyName];
        }
    };

    // Store available constants for ENUM type properties
    if (schemaProperty.constants) {
        propertyDetails.constants = schemaProperty.constants;
    }

    // Only add a setter for writable properties
    if (schemaProperty.writable) {
        propertyDetails.set = function dynamicPropertySetter(value) {
            // TODO: Objects and Arrays are considered unequal when their data is the same and therefore trigger a dirty
            if (!(0, _check.isObject)(value) && value !== this.dataValues[propertyName] || (0, _check.isObject)(value)) {
                this.dirty = true;
                this[_ModelBase.DIRTY_PROPERTY_LIST].add(propertyName);
                this.dataValues[propertyName] = value;
            }
        };
    }

    if (propertyName) {
        propertiesObject[propertyName] = propertyDetails; // eslint-disable-line no-param-reassign
    }
}

function createPropertiesObject(schemaProperties) {
    var propertiesObject = {};
    var createModelPropertyDescriptorOn = (0, _utils.curry)(createModelPropertyDescriptor, propertiesObject);

    (schemaProperties || []).forEach(createModelPropertyDescriptorOn);

    return propertiesObject;
}

function createValidationSetting(validationObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var validationDetails = {
        persisted: schemaProperty.persisted,
        type: _SchemaTypes2.default.typeLookup(schemaProperty.propertyType),
        required: schemaProperty.required,
        min: schemaProperty.min,
        max: schemaProperty.max,
        owner: schemaProperty.owner,
        unique: schemaProperty.unique,
        writable: schemaProperty.writable,
        ordered: Boolean(schemaProperty.ordered),
        embeddedObject: Boolean(schemaProperty.embeddedObject)
    };

    function getReferenceTypeFrom(property) {
        if (property.href) {
            return property.href.split('/').pop();
        }

        return undefined;
    }

    // Add a referenceType to be able to get a hold of the reference objects model.
    if (validationDetails.type === 'REFERENCE' || validationDetails.type === 'COLLECTION' && schemaProperty.itemPropertyType === 'REFERENCE') {
        validationDetails.referenceType = getReferenceTypeFrom(schemaProperty);
    }

    if (propertyName) {
        validationObject[propertyName] = validationDetails; // eslint-disable-line no-param-reassign
    }
}

function createValidations(schemaProperties) {
    var validationsObject = {};
    var createModelPropertyOn = (0, _utils.curry)(createValidationSetting, validationsObject);

    (schemaProperties || []).forEach(createModelPropertyOn);

    return validationsObject;
}

function shouldBeModelCollectionProperty(model, models) {
    return function shouldBeModelCollectionPropertyIterator(modelProperty) {
        return model && models && model.modelDefinition && model.modelDefinition.modelValidations && model.modelDefinition.modelValidations[modelProperty] && model.modelDefinition.modelValidations[modelProperty].type === 'COLLECTION' && models.hasOwnProperty(model.modelDefinition.modelValidations[modelProperty].referenceType);
    };
}

function isAnUpdate(modelToCheck) {
    return Boolean(modelToCheck.id);
}

var translatableProperties = new WeakMap();

/**
 * Definition of a Model. Basically this object contains the meta data related to the Model. Like `name`, `apiEndPoint`, `modelValidation`, etc.
 * It also has methods to create and load Models that are based on this definition. The Data element `ModelDefinition` would be used to create Data Element `Model`s
 *
 * Note: ModelDefinition has a property `api` that is used for the communication with the dhis2 api. The value of this
 * property is an instance of `Api`.
 *
 * @memberof module:model
 */

var ModelDefinition = function () {
    function ModelDefinition() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var properties = arguments[1];
        var validations = arguments[2];
        var attributes = arguments[3];
        var authorities = arguments[4];

        _classCallCheck(this, ModelDefinition);

        (0, _check.checkType)(schema.singular, 'string');
        (0, _check.checkType)(schema.plural, 'string', 'Plural');

        (0, _utils.addLockedProperty)(this, 'name', schema.singular);
        (0, _utils.addLockedProperty)(this, 'displayName', schema.displayName);
        (0, _utils.addLockedProperty)(this, 'plural', schema.plural);
        (0, _utils.addLockedProperty)(this, 'isShareable', schema.shareable || false);
        (0, _utils.addLockedProperty)(this, 'isMetaData', schema.metadata || false);
        (0, _utils.addLockedProperty)(this, 'apiEndpoint', schema.apiEndpoint);
        (0, _utils.addLockedProperty)(this, 'javaClass', schema.klass);
        (0, _utils.addLockedProperty)(this, 'identifiableObject', schema && schema.identifiableObject);
        (0, _utils.addLockedProperty)(this, 'modelProperties', properties);
        (0, _utils.addLockedProperty)(this, 'modelValidations', validations);
        (0, _utils.addLockedProperty)(this, 'attributeProperties', attributes);
        (0, _utils.addLockedProperty)(this, 'authorities', authorities);
        (0, _utils.addLockedProperty)(this, 'translatable', schema.translatable || false);

        this.filters = _Filters2.default.getFilters(this);

        translatableProperties.set(this, (schema.properties || []).filter(function (prop) {
            return prop.translationKey;
        }).map(function (_ref) {
            var name = _ref.name,
                translationKey = _ref.translationKey;
            return { name: name, translationKey: translationKey };
        }));

        // TODO: The function getOwnedPropertyJSON should probably not be exposed, perhaps we could have a getJSONForModel(ownedPropertiesOnly=true) method.
        this.getOwnedPropertyJSON = _json.getOwnedPropertyJSON.bind(this);
    }

    _createClass(ModelDefinition, [{
        key: 'filter',
        value: function filter() {
            return this.clone().filters;
        }

        /**
         * Creates a fresh Model instance based on the `ModelDefinition`. If data is passed into the method that
         * data will be loaded into the matching properties of the model.
         *
         * @param {Object} [data] Data values that should be loaded into the model.
         *
         * @returns {Model} Returns the newly created model instance.
         *
         * @example
         * dataElement.create({name: 'ANC', id: 'd2sf33s3ssf'});
         */

    }, {
        key: 'create',
        value: function create(data) {
            var model = _Model2.default.create(this);
            var models = _ModelDefinitions2.default.getModelDefinitions();
            var dataValues = data ? Object.assign({}, data) : (0, _config.getDefaultValuesForModelType)(model.modelDefinition.name);

            Object.keys(model).filter(shouldBeModelCollectionProperty(model, models)).forEach(function (modelProperty) {
                var referenceType = model.modelDefinition.modelValidations[modelProperty].referenceType;
                var values = [];

                if (Array.isArray(dataValues[modelProperty])) {
                    values = dataValues[modelProperty].map(function (value) {
                        return models[referenceType].create(value);
                    });
                } else if (dataValues[modelProperty] === true || dataValues[modelProperty] === undefined) {
                    values = dataValues[modelProperty];
                }

                dataValues[modelProperty] = _ModelCollectionProperty2.default.create(model, models[referenceType], modelProperty, values);
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            Object.keys(model).filter(function (modelProperty) {
                return !shouldBeModelCollectionProperty(model, models)(modelProperty);
            }).forEach(function (modelProperty) {
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            return model;
        }
    }, {
        key: 'clone',
        value: function clone() {
            var ModelDefinitionPrototype = Object.getPrototypeOf(this);
            var priorFilters = this.filters.getFilterList();
            var clonedDefinition = (0, _utils.copyOwnProperties)(Object.create(ModelDefinitionPrototype), this);

            clonedDefinition.filters = _Filters2.default.getFilters(clonedDefinition, priorFilters);

            return clonedDefinition;
        }

        /**
         * Get a `Model` instance from the api loaded with data that relates to `identifier`.
         * This will do an API call and return a Promise that resolves with a `Model` or rejects with the api error message.
         *
         * @param {String} identifier
         * @param {Object} [queryParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} Resolves with a `Model` instance or an error message.
         *
         * @example
         * //Do a get request for the dataElement with given id (d2sf33s3ssf) and print it's name
         * //when that request is complete and the model is loaded.
         * dataElement.get('d2sf33s3ssf')
         *   .then(model => console.log(model.name));
         */

    }, {
        key: 'get',
        value: function get(identifier) {
            var _this = this;

            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,attributeValues[:all,attribute[id,name,displayName]]' };

            (0, _check.checkDefined)(identifier, 'Identifier');

            if (Array.isArray(identifier)) {
                return this.list({ filter: ['id:in:[' + identifier.join(',') + ']'] });
            }

            // TODO: should throw error if API has not been defined
            return this.api.get([this.apiEndpoint, identifier].join('/'), queryParams).then(function (data) {
                return _this.create(data);
            }).catch(function (response) {
                if (response.message) {
                    return Promise.reject(response.message);
                }

                return Promise.reject(response);
            });
        }

        /**
         * Loads a list of models.
         *
         * @param {Object} [listParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} ModelCollection collection of models objects of the `ModelDefinition` type.
         *
         * @example
         * // Loads a list of models and prints their name.
         * dataElement.list()
         *   .then(modelCollection => {
         *     modelCollection.forEach(model => console.log(model.name));
         *   });
         */

    }, {
        key: 'list',
        value: function list() {
            var _this2 = this;

            var listParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var apiEndpoint = listParams.apiEndpoint,
                extraParams = _objectWithoutProperties(listParams, ['apiEndpoint']);

            var params = Object.assign({ fields: ':all' }, extraParams);
            var definedFilters = this.filters.getQueryFilterValues();

            if (!(0, _check.isDefined)(params.filter)) {
                delete params.filter;
                if (definedFilters.length) {
                    params.filter = definedFilters;
                }
            }

            // If listParams.apiEndpoint exists, send the request there in stead of this.apiEndpoint
            return this.api.get(apiEndpoint || this.apiEndpoint, params).then(function (responseData) {
                return _ModelCollection2.default.create(_this2, responseData[_this2.plural].map(function (data) {
                    return _this2.create(data);
                }), Object.assign(responseData.pager || {}, { query: params }));
            });
        }

        /**
         * This method is used by the `Model` instances to save the model when calling `model.save()`.
         *
         * @param {Model} model The model that should be saved to the server.
         * @returns {Promise} A promise which resolves when the save was successful
         * or rejects when it failed. The promise will resolve with the data that is
         * returned from the server.
         *
         * @note {warning} This should generally not be called directly.
         */
        // TODO: check the return status of the save to see if it was actually successful and not ignored

    }, {
        key: 'save',
        value: function save(model) {
            if (isAnUpdate(model)) {
                var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);
                var updateUrl = (0, _utils.updateAPIUrlWithBaseUrlVersionNumber)(model.dataValues.href, this.api.baseUrl);

                // Save the existing model
                return this.api.update(updateUrl, jsonPayload, true);
            }

            return this.saveNew(model);
        }
    }, {
        key: 'saveNew',
        value: function saveNew(model) {
            var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);

            // Its a new object
            return this.api.post(this.apiEndpoint, jsonPayload);
        }

        /**
         * This method returns a list of property names that that are defined
         * as "owner" properties on this schema. This means these properties are used
         * when saving the model to the server.
         *
         * @returns {String[]} Returns an array of property names.
         *
         * @example
         * dataElement.getOwnedPropertyNames()
         */

    }, {
        key: 'getOwnedPropertyNames',
        value: function getOwnedPropertyNames() {
            var _this3 = this;

            return Object.keys(this.modelValidations).filter(function (propertyName) {
                return _this3.modelValidations[propertyName].owner;
            });
        }

        /**
         * This method is used by the `Model` instances to delete the model when calling `model.delete()`.
         *
         * @returns {Promise} Returns a promise to the deletion operation
         *
         * @note {warning} This should generally not be called directly.
         */

    }, {
        key: 'delete',
        value: function _delete(model) {
            if (model.dataValues.href) {
                return this.api.delete(model.dataValues.href);
            }
            return this.api.delete([model.modelDefinition.apiEndpoint, model.dataValues.id].join('/'));
        }

        /**
         * Check for if the Model supports translations
         *
         * @returns {Boolean} True when the schema can be translated, false otherwise
         */

    }, {
        key: 'isTranslatable',
        value: function isTranslatable() {
            return this.translatable;
        }

        /**
         * These properties can be translated using the DHIS2 _database_ translations.
         *
         * @returns {String[]} Returns a list of property names on the object that are translatable.
         */

    }, {
        key: 'getTranslatableProperties',
        value: function getTranslatableProperties() {
            return translatableProperties.get(this).map((0, _utils.pick)('name'));
        }

        /**
         * This method is similar to getTranslatableProperties() but in addition to the property names also returns the
         * `translationKey` that is used to save the translations for the property names.
         *
         * @returns {Object[]} Returns an array with objects that have `name` and `translationKey` properties.
         */

    }, {
        key: 'getTranslatablePropertiesWithKeys',
        value: function getTranslatablePropertiesWithKeys() {
            return translatableProperties.get(this);
        }

        /**
         * @static
         *
         * This method creates a new `ModelDefinition` based on a JSON structure called
         * a schema. A schema represents the structure of a domain model as it is
         * required by DHIS. Since these schemas can not be altered on the server from
         * the modelDefinition is frozen to prevent accidental changes to the definition.
         *
         * @param {Object} schema A schema definition received from the web api (/api/schemas)
         * @param {Object[]} attributes A list of attribute objects that describe custom attributes (/api/attributes)
         *
         * @returns {ModelDefinition} Frozen model definition object.
         *
         * @example
         * ModelDefinition.createFromSchema(schemaDefinition, attributes);
         *
         * @note {info} An example of a schema definition can be found on
         * https://apps.dhis2.org/demo/api/schemas/dataElement
         */

    }], [{
        key: 'createFromSchema',
        value: function createFromSchema(schema) {
            var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var ModelDefinitionClass = void 0;
            (0, _check.checkType)(schema, Object, 'Schema');

            if (typeof ModelDefinition.specialClasses[schema.singular] === 'function') {
                ModelDefinitionClass = ModelDefinition.specialClasses[schema.singular];
            } else {
                ModelDefinitionClass = ModelDefinition;
            }

            return Object.freeze(new ModelDefinitionClass(schema, Object.freeze(createPropertiesObject(schema.properties)), Object.freeze(createValidations(schema.properties)), attributes.reduce(function (current, attributeDefinition) {
                current[attributeDefinition.name] = attributeDefinition; // eslint-disable-line no-param-reassign
                return current;
            }, {}), schema.authorities));
        }
    }]);

    return ModelDefinition;
}();

var UserModelDefinition = function (_ModelDefinition) {
    _inherits(UserModelDefinition, _ModelDefinition);

    function UserModelDefinition() {
        _classCallCheck(this, UserModelDefinition);

        return _possibleConstructorReturn(this, (UserModelDefinition.__proto__ || Object.getPrototypeOf(UserModelDefinition)).apply(this, arguments));
    }

    _createClass(UserModelDefinition, [{
        key: 'get',

        // TODO: userCredentials should always be included, no matter what the query params, that is currently not the case
        value: function get(identifier) {
            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,userCredentials[:owner]' };

            return _get(UserModelDefinition.prototype.__proto__ || Object.getPrototypeOf(UserModelDefinition.prototype), 'get', this).call(this, identifier, queryParams);
        }
    }]);

    return UserModelDefinition;
}(ModelDefinition);

var DataSetModelDefinition = function (_ModelDefinition2) {
    _inherits(DataSetModelDefinition, _ModelDefinition2);

    function DataSetModelDefinition() {
        _classCallCheck(this, DataSetModelDefinition);

        return _possibleConstructorReturn(this, (DataSetModelDefinition.__proto__ || Object.getPrototypeOf(DataSetModelDefinition)).apply(this, arguments));
    }

    _createClass(DataSetModelDefinition, [{
        key: 'create',
        value: function create() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var hasData = Boolean(Object.keys(data).length);

            // Filter out the compulsoryDataElementOperands structure from the retrieved data
            // This structure does not follow the convention of a typical reference. We can not create a proper
            // ModelCollection for this collection.
            var dataClone = Object.keys(data).filter(function (key) {
                return key !== 'compulsoryDataElementOperands';
            }).reduce(function (obj, key) {
                obj[key] = data[key]; // eslint-disable-line no-param-reassign
                return obj;
            }, {});

            // Create the model using the usual way of creating a model
            // Only pass data when there is data in the object passed to the constructor. This will guarantee
            // that the empty ModelCollections are created properly.
            var model = _get(DataSetModelDefinition.prototype.__proto__ || Object.getPrototypeOf(DataSetModelDefinition.prototype), 'create', this).call(this, hasData ? dataClone : undefined);

            // Set the compulsoryDataElementOperands onto the dataValues so it will be included during the save operations
            model.dataValues.compulsoryDataElementOperands = data.compulsoryDataElementOperands;

            return model;
        }
    }]);

    return DataSetModelDefinition;
}(ModelDefinition);

var OrganisationUnitModelDefinition = function (_ModelDefinition3) {
    _inherits(OrganisationUnitModelDefinition, _ModelDefinition3);

    function OrganisationUnitModelDefinition() {
        _classCallCheck(this, OrganisationUnitModelDefinition);

        return _possibleConstructorReturn(this, (OrganisationUnitModelDefinition.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition)).apply(this, arguments));
    }

    _createClass(OrganisationUnitModelDefinition, [{
        key: 'list',

        // If a 'root' is specified when listing organisation units the results will be limited to the root and its
        // descendants. This is special behavior for the organisation unit API endpoint, which is documented here:
        // https://dhis2.github.io/dhis2-docs/master/en/developer/html/webapi_organisation_units.html
        value: function list() {
            var extraParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var root = extraParams.root,
                params = _objectWithoutProperties(extraParams, ['root']);

            if (extraParams.hasOwnProperty('root') && root) {
                params.apiEndpoint = this.apiEndpoint + '/' + root;
            }

            return _get(OrganisationUnitModelDefinition.prototype.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition.prototype), 'list', this).call(this, params);
        }
    }]);

    return OrganisationUnitModelDefinition;
}(ModelDefinition);

ModelDefinition.specialClasses = {
    user: UserModelDefinition,
    dataSet: DataSetModelDefinition,
    organisationUnit: OrganisationUnitModelDefinition
};

exports.default = ModelDefinition;
//# sourceMappingURL=ModelDefinition.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains all the `ModelDefinition`s that are available. The definitions are properties on the object.
 * This would be used as a main entry point to do any interaction.
 *
 * After calling the initialise function `d2({baseUrl: 'dhis/api'})` this object is the `models` property
 * that allows you to access
 *
 * @example
 * models.dataElement.getList();
 *
 * @memberof module:model
 */
var ModelDefinitions = function () {
    function ModelDefinitions() {
        _classCallCheck(this, ModelDefinitions);
    }

    _createClass(ModelDefinitions, [{
        key: 'add',

        // TODO: Elaborate this documentation
        /**
         * This will allow you to add your own custom ModelDefinitions.
         *
         * The Definition object should have the following properties
         * `modelName, modelNamePlural, modelOptions, properties, validations`
         *
         * @param {ModelDefinition} modelDefinition Add a model definition to the definitions collection
         *
         * @example
         * models.add({name: 'MyDefinition', plural: 'MyDefinitions', endPointname: '/myDefinition'});
         */
        value: function add(modelDefinition) {
            try {
                (0, _check.checkType)(modelDefinition.name, 'string');
            } catch (e) {
                throw new Error('Name should be set on the passed ModelDefinition to add one');
            }

            if (this[modelDefinition.name]) {
                throw new Error(['Model', modelDefinition.name, 'already exists'].join(' '));
            }
            this[modelDefinition.name] = modelDefinition;

            if ((0, _check.isType)(modelDefinition.plural, 'string')) {
                this[modelDefinition.plural] = modelDefinition;
            }
        }

        /**
         * Map through the modelDefinitions like you would with a simple `Array.map()`
         *
         * @param {Function} transformer Transformer function that will be run for each `ModelDefinition`
         * @returns {Array} Array with the `ModelDefinition` objects.
         *
         * @example
         * models.mapThroughDefinitions(definition => console.log(definition.name);
         *
         * @note {info} When mapping through the definition list `transformer` is called with the just the definition
         * Unlike other map functions, no index or the full object is being passed.
         *
         * @note {warn} The resulting array contains references to the actual objects. It does not work like immutable array functions.
         *
         */

    }, {
        key: 'mapThroughDefinitions',
        value: function mapThroughDefinitions(transformer) {
            var _this = this;

            (0, _check.checkType)(transformer, 'function', 'transformer');

            return Object.keys(this).filter(function (modelDefinition) {
                return _this.hasOwnProperty(modelDefinition) && !(_this[modelDefinition].plural === modelDefinition);
            }).map(function (modelDefinition) {
                return transformer(_this[modelDefinition]);
            });
        }
    }]);

    return ModelDefinitions;
}();

// Model definitions singleton!


function getModelDefinitions() {
    if (getModelDefinitions.modelDefinitions) {
        return getModelDefinitions.modelDefinitions;
    }
    return getModelDefinitions.modelDefinitions = new ModelDefinitions();
}

ModelDefinitions.getModelDefinitions = getModelDefinitions;

exports.default = ModelDefinitions;
//# sourceMappingURL=ModelDefinitions.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fieldsForSchemas = exports.defaultValues = undefined;
exports.getDefaultValuesForModelType = getDefaultValuesForModelType;

var _organisationUnitGroupSet = __webpack_require__(288);

var _organisationUnitGroupSet2 = _interopRequireDefault(_organisationUnitGroupSet);

var _category = __webpack_require__(289);

var _category2 = _interopRequireDefault(_category);

var _categoryOptionGroupSet = __webpack_require__(290);

var _categoryOptionGroupSet2 = _interopRequireDefault(_categoryOptionGroupSet);

var _dataElement = __webpack_require__(291);

var _dataElement2 = _interopRequireDefault(_dataElement);

var _dataElementGroupSet = __webpack_require__(292);

var _dataElementGroupSet2 = _interopRequireDefault(_dataElementGroupSet);

var _dataSet = __webpack_require__(293);

var _dataSet2 = _interopRequireDefault(_dataSet);

var _externalMapLayer = __webpack_require__(294);

var _externalMapLayer2 = _interopRequireDefault(_externalMapLayer);

var _validationNotificationTemplate = __webpack_require__(295);

var _validationNotificationTemplate2 = _interopRequireDefault(_validationNotificationTemplate);

var _validationRule = __webpack_require__(296);

var _validationRule2 = _interopRequireDefault(_validationRule);

var _program = __webpack_require__(297);

var _program2 = _interopRequireDefault(_program);

var _programNotificationTemplate = __webpack_require__(298);

var _programNotificationTemplate2 = _interopRequireDefault(_programNotificationTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultValues = exports.defaultValues = new Map([['organisationUnitGroupSet', _organisationUnitGroupSet2.default], ['category', _category2.default], ['categoryOptionGroupSet', _categoryOptionGroupSet2.default], ['dataElement', _dataElement2.default], ['dataElementGroupSet', _dataElementGroupSet2.default], ['dataSet', _dataSet2.default], ['externalMapLayer', _externalMapLayer2.default], ['validationNotificationTemplate', _validationNotificationTemplate2.default], ['validationRule', _validationRule2.default], ['program', _program2.default], ['programNotificationTemplate', _programNotificationTemplate2.default]]);

function getDefaultValuesForModelType(modelDefinitionName) {
    if (defaultValues.has(modelDefinitionName)) {
        return defaultValues.get(modelDefinitionName);
    }
    return {};
}

var schemaFields = ['apiEndpoint', 'name', 'displayName', 'authorities', 'singular', 'plural', 'shareable', 'metadata', 'klass', 'identifiableObject', 'translatable'];

var schemaPropertyFields = ['href', 'writable', 'collection', 'collectionName', 'name', 'propertyType', 'persisted', 'required', 'min', 'max', 'ordered', 'unique', 'constants', 'owner', 'itemPropertyType', 'translationKey', 'embeddedObject'];

var fieldsForSchemas = exports.fieldsForSchemas = schemaFields.concat('properties[' + schemaPropertyFields.join(',') + ']').join(',');
//# sourceMappingURL=index.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * List of modelDefinition names that should not allow create. Even when their schema authorities allows the user
 * to create them, the user should not be allowed to create these objects for some business logic reason.
 *
 * @private
 * @type {Set<string>}
 * @readonly
 */
var noCreateAllowedFor = exports.noCreateAllowedFor = new Set([
// Creating categoryOptionCombos is not allowed because they are generated by the backend.
'categoryOptionCombo']);

/**
 * Default options to be used when running the `d2.init` function.
 */
exports.default = {
    baseUrl: '/api',
    i18n: {
        sources: new Set(),
        strings: new Set()
    }
};
//# sourceMappingURL=defaultConfig.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module datastore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _BaseStoreNamespace = __webpack_require__(115);

var _BaseStoreNamespace2 = _interopRequireDefault(_BaseStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Represents a key-value store that can be interacted with. This can be used to get instances of Namespaces, which
 * can be used to interact with the relating namespace API.
 *
 * @memberof module:datastore
 * @abstract
 */
var BaseStore = function () {
    function BaseStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataStore';
        var NamespaceClass = arguments[2];

        _classCallCheck(this, BaseStore);

        if (this.constructor === BaseStore) {
            throw new Error("Can't instantiate abstract class!");
        }
        if (!(NamespaceClass.prototype instanceof _BaseStoreNamespace2.default)) {
            throw new Error('NamespaceClass must be subclass of ' + (typeof _BaseStoreNamespace2.default === 'undefined' ? 'undefined' : _typeof(_BaseStoreNamespace2.default)));
        }
        this.NamespaceClass = NamespaceClass;
        this.endPoint = endPoint;
        this.api = api;
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of 'RetClass' that
     * may be used to interact with this namespace. See {@link DataStoreNamespace}.
     *
     * @param {string} namespace To get.
     * @param {boolean} [autoLoad=true] If true, autoloads the keys of the namespace from the server.
     * before the namespace is created. If false, an instance of he namespace is returned without any keys.
     * @returns {Promise<BaseStoreNamespace>} An instance of a current store-Namespace-instance representing the namespace that can be interacted with.
     * Or an error if namespace does not exist.
     */


    _createClass(BaseStore, [{
        key: 'get',
        value: function get(namespace) {
            var _this = this;

            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!autoLoad) {
                return new Promise(function (resolve) {
                    resolve(new _this.NamespaceClass(namespace));
                });
            }
            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    if (response.length < 1) {
                        // fix for api bug returning empty array instead of 404
                        return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
                    }
                    return new _this.NamespaceClass(namespace, response);
                }
                return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
            });
        }

        /**
         * Retrieves a list of all namespaces on the server.
         * @returns {Promise} An array of namespaces.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            return this.api.get(this.endPoint).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return response;
                }
                throw new Error('No namespaces exist.');
            });
        }

        /**
         * Convenience method to check if a namespace exists on the server.
         * @param {string} namespace - Namespace to check.
         * @returns {Promise<boolean>} True if namespace exists, false otherwise.
         */

    }, {
        key: 'has',
        value: function has(namespace) {
            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    if (response.length < 1) {
                        // fix for api bug returning empty array instead of 404
                        return Promise.reject(response);
                    }
                    return true;
                }
                return Promise.reject(new Error('Response is not an array!'));
            }).catch(function (e) {
                if (e.httpStatusCode === 404 || (0, _check.isArray)(e) && e.length < 1) {
                    return Promise.resolve(false);
                }
                throw e;
            });
        }

        /**
         * Deletes a namespace
         *
         * @param {string} namespace The namespace to delete.
         * @returns {Promise} the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'delete',
        value: function _delete(namespace) {
            return this.api.delete([this.endPoint, namespace].join('/'));
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:dataStore.BaseStoreNamespace.set set}.
         *
         * @param {string} namespace The namespace to create.
         * @returns {Promise<BaseStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            var _this2 = this;

            return this.has(namespace).then(function (exists) {
                return exists ? Promise.reject(new Error('Namespace already exists.')) : new _this2.NamespaceClass(namespace);
            });
        }
    }]);

    return BaseStore;
}();

exports.default = BaseStore;
//# sourceMappingURL=BaseStore.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Base class for communicating with the analytics API endpoint.
 * Its subclasses can be used to get analytics data.
 *
 * @param {Instance} [api=<Api>] Api instance to use for the requests
 *
 * @requires module:api/Api
 *
 * @memberof module:analytics
 * @abstract
 */
var AnalyticsBase = function () {
    function AnalyticsBase() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, AnalyticsBase);

        this.api = api;
    }

    /**
     * Loads the analytics data and returns them as an object from the promise.
     *
     * @param {!AnalyticsRequest} req Analytics request object with the request details
     *
     * @returns {Promise} Promise that resolves with the analytics data from the api.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd']);
     *
     * d2.analytics.aggregate
     *  .get(req)
     *  .then(analyticsData => console.log('Analytics data', analyticsData))
     */


    _createClass(AnalyticsBase, [{
        key: 'get',
        value: function get(req) {
            return this.api.get(req.buildUrl(), req.buildQuery()).then(function (data) {
                return Promise.resolve(data);
            });
        }
    }]);

    return AnalyticsBase;
}();

exports.default = AnalyticsBase;
//# sourceMappingURL=AnalyticsBase.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57),
    metaMap = __webpack_require__(179);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(180);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(184),
    composeArgsRight = __webpack_require__(185),
    countHolders = __webpack_require__(337),
    createCtor = __webpack_require__(77),
    createRecurry = __webpack_require__(186),
    getHolder = __webpack_require__(196),
    reorder = __webpack_require__(351),
    replaceHolders = __webpack_require__(121),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(338),
    setData = __webpack_require__(190),
    setWrapToString = __webpack_require__(192);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(179),
    noop = __webpack_require__(188);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    baseLodash = __webpack_require__(119);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(178),
    shortOut = __webpack_require__(191);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(343),
    insertWrapDetails = __webpack_require__(344),
    setToString = __webpack_require__(120),
    updateWrapDetails = __webpack_require__(347);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(348);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keys = __webpack_require__(58);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(354),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isIndex = __webpack_require__(63),
    isTypedArray = __webpack_require__(123);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(198),
    baseKeysIn = __webpack_require__(383),
    isArrayLike = __webpack_require__(42);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    getPrototype = __webpack_require__(133),
    getSymbols = __webpack_require__(131),
    stubArray = __webpack_require__(201);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(204),
    getSymbols = __webpack_require__(131),
    keys = __webpack_require__(58);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    isArray = __webpack_require__(21);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(407),
    isObjectLike = __webpack_require__(25);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(210),
    arraySome = __webpack_require__(410),
    cacheHas = __webpack_require__(211);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(130),
    setCacheAdd = __webpack_require__(408),
    setCacheHas = __webpack_require__(409);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(417);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(419);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(420),
    hasPath = __webpack_require__(421);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(441),
    keys = __webpack_require__(58);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var periodTypes = exports.periodTypes = [{ id: 'relativePeriods', name: 'Relative' }, { id: 'Daily', name: 'Daily' }, { id: 'Weekly', name: 'Weekly' }, { id: 'Monthly', name: 'Monthly' }, { id: 'BiMonthly', name: 'Bi-monthly' }, { id: 'Quarterly', name: 'Quarterly' }, { id: 'SixMonthly', name: 'Six-monthly' }, { id: 'SixMonthlyApril', name: 'Six-monthly April' }, { id: 'Yearly', name: 'Yearly' }, { id: 'FinancialOctober', name: 'Financial year (Start October)' }, { id: 'FinancialJuly', name: 'Financial year (Start July)' }, { id: 'FinancialApril', name: 'Financial year (Start April)' }];

var relativePeriods = exports.relativePeriods = [{ id: 'TODAY', name: 'Today' }, { id: 'YESTERDAY', name: 'Yesterday' }, { id: 'THIS_WEEK', name: 'This week' }, { id: 'LAST_WEEK', name: 'Last week' }, { id: 'LAST_4_WEEKS', name: 'Last 4 weeks' }, { id: 'LAST_12_WEEKS', name: 'Last 12 weeks' }, { id: 'LAST_52_WEEKS', name: 'Last 52 weeks' }, { id: 'THIS_MONTH', name: 'This month' }, { id: 'LAST_MONTH', name: 'Last month' }, { id: 'LAST_3_MONTHS', name: 'Last 3 months' }, { id: 'LAST_6_MONTHS', name: 'Last 6 months' }, { id: 'LAST_12_MONTHS', name: 'Last 12 months' }, { id: 'THIS_BIMONTH', name: 'This bi-month' }, { id: 'LAST_BIMONTH', name: 'Last bi-month' }, { id: 'LAST_6_BIMONTHS', name: 'Last 6 bi-months' }, { id: 'THIS_QUARTER', name: 'This quarter' }, { id: 'LAST_QUARTER', name: 'Last quarter' }, { id: 'LAST_4_QUARTERS', name: 'Last 4 quarters' }, { id: 'THIS_SIX_MONTH', name: 'This six-month' }, { id: 'LAST_SIX_MONTH', name: 'Last six-month' }, { id: 'LAST_2_SIX_MONTHS', name: 'Last 2 six-months' }, { id: 'THIS_YEAR', name: 'This year' }, { id: 'LAST_YEAR', name: 'Last year' }, { id: 'LAST_5_YEARS', name: 'Last 5 years' }, { id: 'THIS_FINANCIAL_YEAR', name: 'This financial year' }, { id: 'LAST_FINANCIAL_YEAR', name: 'Last financial year' }, { id: 'LAST_5_FINANCIAL_YEARS', name: 'Last 5 financial years' }];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isObject', __webpack_require__(26), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(453);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(140);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ __webpack_exports__["a"] = (formatIso);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addStyleDataItem = exports.getAnalyticsRequest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d = __webpack_require__(19);

var _curry = __webpack_require__(225);

var _curry2 = _interopRequireDefault(_curry);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isEmpty = __webpack_require__(470);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = __webpack_require__(67);

var _classify = __webpack_require__(226);

var _legend = __webpack_require__(231);

var _analytics = __webpack_require__(32);

var _layers = __webpack_require__(68);

var _d3TimeFormat = __webpack_require__(139);

var _colorscale = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Look at: https://github.com/dhis2/maintenance-app/blob/master/src/App/appStateStore.js

var formatTime = function formatTime(date) {
    return (0, _d3TimeFormat.timeFormat)('%Y-%m-%d')(new Date(date));
};

var eventLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var _config$classes, classes, _config$colorScale, colorScale, columns, endDate, eventClustering, eventCoordinateField, eventPointColor, eventPointRadius, filters, _config$method, method, program, programStage, rows, startDate, styleDataItem, orgUnits, period, dataItems, dataFilters, d2, spatialSupport, analyticsRequest, legend, bounds, serverCluster, data, names, response, _response, optionSetHeaders, styleByNumeric, styleByOptionSet, values, bins, colors, getLegendItem;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        _config$classes = config.classes, classes = _config$classes === undefined ? _colorscale.defaultClasses : _config$classes, _config$colorScale = config.colorScale, colorScale = _config$colorScale === undefined ? _colorscale.defaultColorScale : _config$colorScale, columns = config.columns, endDate = config.endDate, eventClustering = config.eventClustering, eventCoordinateField = config.eventCoordinateField, eventPointColor = config.eventPointColor, eventPointRadius = config.eventPointRadius, filters = config.filters, _config$method = config.method, method = _config$method === undefined ? 2 : _config$method, program = config.program, programStage = config.programStage, rows = config.rows, startDate = config.startDate, styleDataItem = config.styleDataItem;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        period = (0, _analytics.getPeriodFromFilters)(filters);
                        dataItems = addStyleDataItem(columns, styleDataItem);
                        dataFilters = (0, _analytics.getFiltersFromColumns)(columns);
                        _context.next = 7;
                        return (0, _d.getInstance)();

                    case 7:
                        d2 = _context.sent;
                        spatialSupport = d2.system.systemInfo.databaseInfo.spatialSupport;
                        _context.next = 11;
                        return getAnalyticsRequest(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField);

                    case 11:
                        analyticsRequest = _context.sent;
                        legend = {
                            period: period ? (0, _analytics.getPeriodNameFromId)(period.id) : formatTime(startDate) + ' - ' + formatTime(endDate),
                            filters: dataFilters && (0, _analytics.getFiltersAsText)(dataFilters)
                        };
                        bounds = void 0;
                        serverCluster = void 0;
                        data = void 0;
                        names = void 0;

                        if (!(spatialSupport && eventClustering)) {
                            _context.next = 23;
                            break;
                        }

                        _context.next = 20;
                        return d2.analytics.events.getCount(analyticsRequest);

                    case 20:
                        response = _context.sent;

                        bounds = getBounds(response.extent);
                        serverCluster = useServerCluster(response.count);

                    case 23:
                        if (serverCluster) {
                            _context.next = 36;
                            break;
                        }

                        _context.next = 26;
                        return d2.analytics.events.getQuery(analyticsRequest);

                    case 26:
                        _response = _context.sent;

                        names = (0, _analytics.getApiResponseNames)(_response);
                        optionSetHeaders = _response.headers.filter(function (header) {
                            return header.optionSet;
                        });

                        // Load option sets used for filtering/styling

                        if (!optionSetHeaders.length) {
                            _context.next = 32;
                            break;
                        }

                        _context.next = 32;
                        return Promise.all(optionSetHeaders.map(function (header) {
                            return d2.models.optionSets.get(header.optionSet, {
                                fields: 'id,options[code,displayName~rename(name)]'
                            }).then(function (model) {
                                return model.options;
                            }).then(function (options) {
                                return options.forEach(function (_ref2) {
                                    var code = _ref2.code,
                                        name = _ref2.name;
                                    return names[code] = name;
                                });
                            });
                        }));

                    case 32:

                        data = _response.rows.map(function (row) {
                            return createEventFeature(_response.headers, names, row, eventCoordinateField);
                        }).filter(function (feature) {
                            return (0, _map.isValidCoordinate)(feature.geometry.coordinates);
                        });

                        styleByNumeric = styleDataItem && styleDataItem.valueType === 'INTEGER';
                        styleByOptionSet = styleDataItem && styleDataItem.optionSet && styleDataItem.optionSet.options;


                        if (Array.isArray(data) && data.length) {
                            if (styleDataItem) {
                                // Set value property to value of styleDataItem
                                data.forEach(function (feature) {
                                    return feature.properties.value = feature.properties[styleDataItem.id];
                                });
                                legend.unit = styleDataItem.name;

                                if (styleByNumeric) {
                                    values = data.map(function (feature) {
                                        return Number(feature.properties.value);
                                    }).sort(function (a, b) {
                                        return a - b;
                                    });
                                    bins = (0, _classify.getClassBins)(values, method, classes);
                                    colors = colorScale ? colorScale.split(',') : [];

                                    legend.items = (0, _legend.getNumericLegendItems)(bins, colors, eventPointRadius || _layers.EVENT_RADIUS);

                                    getLegendItem = (0, _curry2.default)(_classify.getLegendItemForValue)(legend.items);


                                    data.forEach(function (feature) {
                                        return feature.properties.color = getLegendItem(45).color;
                                    });
                                } else if (styleByOptionSet) {
                                    data.forEach(function (feature) {
                                        feature.properties.color = styleDataItem.optionSet.options[feature.properties.value];
                                    });
                                    legend.items = (0, _legend.getCategoryLegendItems)(styleDataItem.optionSet.options, eventPointRadius || _layers.EVENT_RADIUS);
                                }

                                legend.items.push({
                                    name: _i18next2.default.t('Not set'),
                                    color: eventPointColor || _layers.EVENT_COLOR,
                                    radius: eventPointRadius || _layers.EVENT_RADIUS
                                });
                            } else {
                                // Simple style
                                legend.items = [{
                                    name: _i18next2.default.t('Event'),
                                    color: eventPointColor || _layers.EVENT_COLOR,
                                    radius: eventPointRadius || _layers.EVENT_RADIUS
                                }];
                            }
                        }

                    case 36:

                        legend.filters = dataFilters && (0, _analytics.getFiltersAsText)(dataFilters, names);

                        return _context.abrupt('return', _extends({}, config, {
                            name: programStage.name,
                            legend: legend,
                            data: data,
                            bounds: bounds,
                            serverCluster: serverCluster,
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 38:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function eventLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

var getBounds = function getBounds(bbox) {
    if (!bbox) {
        return null;
    }
    var extent = bbox.match(/([-\d\.]+)/g);
    return [[extent[1], extent[0]], [extent[3], extent[2]]];
};

// Server clustering if more than 2000 events
var useServerCluster = function useServerCluster(count) {
    return count > 2000;
}; // TODO: Use constant

// Also used to query for server cluster in map/EventLayer.js
var getAnalyticsRequest = exports.getAnalyticsRequest = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField) {
        var d2, analyticsRequest;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        analyticsRequest = new d2.analytics.request().withProgram(program.id).withStage(programStage.id).withCoordinatesOnly(true);


                        analyticsRequest = period ? analyticsRequest.addPeriodFilter(period.id) : analyticsRequest.withStartDate(startDate).withEndDate(endDate);

                        analyticsRequest = analyticsRequest.addOrgUnitDimension(orgUnits.map(function (ou) {
                            return ou.id;
                        }));

                        (0, _analytics.removeEmptyItems)(dataItems).forEach(function (item) {
                            analyticsRequest = analyticsRequest.addDimension(item.dimension, item.filter);
                        });

                        if (eventCoordinateField) {
                            // If coordinate field other than event coordinate
                            analyticsRequest = analyticsRequest.addDimension(eventCoordinateField) // Used by analytics/events/query/
                            .withCoordinateField(eventCoordinateField); // Used by analytics/events/count and analytics/events/cluster
                        }

                        return _context2.abrupt('return', analyticsRequest);

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function getAnalyticsRequest(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
    };
}();

// Include column for data element used for styling
var addStyleDataItem = exports.addStyleDataItem = function addStyleDataItem(dataItems, styleDataItem) {
    return styleDataItem ? [].concat(_toConsumableArray(dataItems), [styleDataItem && {
        dimension: styleDataItem.id,
        name: styleDataItem.name
    }]) : [].concat(_toConsumableArray(dataItems));
};

var createEventFeature = function createEventFeature(headers, names, event, eventCoordinateField) {
    var properties = event.reduce(function (props, value, i) {
        return _extends({}, props, _defineProperty({}, headers[i].name, names[value] || value));
    }, {});

    var coordinates = void 0;

    if (eventCoordinateField) {
        // If coordinate field other than event location
        var eventCoord = properties[eventCoordinateField];

        if (Array.isArray(eventCoord)) {
            coordinates = eventCoord;
        } else if ((0, _isString2.default)(eventCoord) && !(0, _isEmpty2.default)(eventCoord)) {
            coordinates = JSON.parse(eventCoord);
        } else {
            coordinates = [];
        }
    } else {
        // Use event location
        coordinates = [properties.longitude, properties.latitude]; // Event location
    }

    return {
        type: 'Feature',
        id: properties.psi,
        properties: properties,
        geometry: {
            type: 'Point',
            coordinates: coordinates.map(parseFloat)
        }
    };
};

exports.default = eventLoader;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('curry', __webpack_require__(207));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQuantiles = exports.getEqualIntervals = exports.getClassBins = exports.getLegendItems = exports.getLegendItemForValue = exports.classify = undefined;

var _d3Format = __webpack_require__(474);

var _curryRight = __webpack_require__(484);

var _curryRight2 = _interopRequireDefault(_curryRight);

var _layers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classify = exports.classify = function classify(features, options) {
    var method = options.method,
        classes = options.classes,
        colorScale = options.colorScale;

    var values = features.map(function (feature) {
        return Number(feature.properties.value);
    }).sort(function (a, b) {
        return a - b;
    });
    var bins = getClassBins(values, method, classes);
    var getClassIndex = (0, _curryRight2.default)(getClass)(bins);

    if (bins.length) {
        features.forEach(function (feature) {
            feature.properties.color = colorScale[getClassIndex(feature.properties.value) - 1];
        });
    }
};

// Returns legend item where a value belongs
// Utils for thematic mapping
var getLegendItemForValue = exports.getLegendItemForValue = function getLegendItemForValue(legendItems, value) {
    var isLast = function isLast(index) {
        return index === legendItems.length - 1;
    };
    return legendItems.find(function (item, index) {
        return value >= item.startValue && (value < item.endValue || isLast(index) && value === item.endValue);
    });
};

var getLegendItems = exports.getLegendItems = function getLegendItems(values, method, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = void 0;

    if (method === _layers.CLASSIFICATION_EQUAL_INTERVALS) {
        bins = getEqualIntervals(minValue, maxValue, numClasses);
    } else if (method === _layers.CLASSIFICATION_EQUAL_COUNTS) {
        bins = getQuantiles(values, numClasses);
    }

    return bins;
};

var getClassBins = exports.getClassBins = function getClassBins(values, method, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = void 0;

    if (method === _layers.CLASSIFICATION_EQUAL_INTERVALS) {
        bins = getEqualIntervals(minValue, maxValue, numClasses);
    } else if (method === _layers.CLASSIFICATION_EQUAL_COUNTS) {
        bins = getQuantiles(values, numClasses);
    }

    return bins;
};

var getEqualIntervals = exports.getEqualIntervals = function getEqualIntervals(minValue, maxValue, numClasses) {
    var bins = [];
    var binSize = (maxValue - minValue) / numClasses;
    var precision = (0, _d3Format.precisionRound)(binSize, maxValue);

    var valueFormat = (0, _d3Format.format)('.' + precision + 'f');

    for (var i = 0; i < numClasses; i++) {
        var startValue = minValue + i * binSize;
        var endValue = i < numClasses - 1 ? startValue + binSize : maxValue;

        bins.push({
            startValue: Number(valueFormat(startValue)),
            endValue: Number(valueFormat(endValue))
        });
    }

    return bins;
};

var getQuantiles = exports.getQuantiles = function getQuantiles(values, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = [];
    var binCount = values.length / numClasses;
    var precision = (0, _d3Format.precisionRound)((maxValue - minValue) / numClasses, maxValue);
    var valueFormat = (0, _d3Format.format)('.' + precision + 'f');

    var binLastValPos = binCount === 0 ? 0 : binCount;

    if (values.length > 0) {
        bins[0] = minValue;
        for (var i = 1; i < numClasses; i++) {
            bins[i] = values[Math.round(binLastValPos)];
            binLastValPos += binCount;
        }
    }

    // bin can be undefined if few values
    return bins.filter(function (bin) {
        return bin !== undefined;
    }).map(function (value, index) {
        return {
            startValue: Number(valueFormat(value)),
            endValue: Number(valueFormat(bins[index + 1] || maxValue))
        };
    });
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(480);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(229);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(479);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLegendItems = exports.getNumericLegendItems = exports.getLabelsFromLegendItems = exports.getColorScaleFromLegendItems = exports.getBinsFromLegendItems = exports.formatLegendItems = exports.loadDataItemLegendSet = exports.loadLegendSet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _d = __webpack_require__(19);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _api = __webpack_require__(59);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var loadLegendSet = exports.loadLegendSet = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(legendSet) {
        var fields, d2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        fields = _helpers.legendSetFields.join(',');
                        _context.next = 3;
                        return (0, _d.getInstance)();

                    case 3:
                        d2 = _context.sent;
                        return _context.abrupt('return', d2.models.legendSet.get(legendSet.id));

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function loadLegendSet(_x) {
        return _ref.apply(this, arguments);
    };
}();

var loadDataItemLegendSet = exports.loadDataItemLegendSet = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dataItem) {
        var type, d2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        type = (dataItem.dimensionItemType || '').toLowerCase();
                        _context2.next = 3;
                        return (0, _d.getInstance)();

                    case 3:
                        d2 = _context2.sent;

                        if (!(!type || !d2.models[type])) {
                            _context2.next = 6;
                            break;
                        }

                        return _context2.abrupt('return');

                    case 6:
                        return _context2.abrupt('return', d2.models[type].get(dataItem.id, {
                            fields: 'legendSet[id,displayName~rename(name)]'
                        }).then(function (model) {
                            return model.legendSet;
                        }));

                    case 7:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function loadDataItemLegendSet(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var formatLegendItems = exports.formatLegendItems = function formatLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return {
            color: item.color,
            name: item.name,
            range: item.startValue + ' - ' + item.endValue
        };
    });
};

var getBinsFromLegendItems = exports.getBinsFromLegendItems = function getBinsFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    var lastItem = sortedItems[sortedItems.length - 1];
    var bins = sortedItems.map(function (item) {
        return item.startValue;
    });

    bins.push(lastItem.endValue);
    return bins;
};

var getColorScaleFromLegendItems = exports.getColorScaleFromLegendItems = function getColorScaleFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return item.color;
    });
};

var getLabelsFromLegendItems = exports.getLabelsFromLegendItems = function getLabelsFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return item.name;
    });
};

// TODO: Add support for counts in each class?
var getNumericLegendItems = exports.getNumericLegendItems = function getNumericLegendItems(bins, colors, radius) {
    var items = [];

    for (var i = 0; i < bins.length; i++) {
        items.push(_extends({}, bins[i], {
            color: colors[i],
            radius: radius
        }));
    }

    return items;
};

// TODO: Add support for counts in each class?
var getCategoryLegendItems = exports.getCategoryLegendItems = function getCategoryLegendItems(options, radius) {
    return Object.keys(options).map(function (option) {
        return {
            name: option,
            color: options[option],
            radius: radius
        };
    });
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isPlainObject', __webpack_require__(135), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('pick', __webpack_require__(489));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98),
    baseSet = __webpack_require__(491),
    castPath = __webpack_require__(64);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(505);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(598);
var enumBugKeys = __webpack_require__(517);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelAnimationTimeout", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestAnimationTimeout", function() { return requestAnimationTimeout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animationFrame__ = __webpack_require__(1030);


var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId =  true ? null : {
  id: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId', {
  value: babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId,
  configurable: true
});


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = Date.now();

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var babelPluginFlowReactPropTypes_proptype_CellDataGetterParams =  true ? null : {
  columnData: require("prop-types").any,
  dataKey: require("prop-types").string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_CellDataGetterParams", {
  value: babelPluginFlowReactPropTypes_proptype_CellDataGetterParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRendererParams =  true ? null : {
  cellData: require("prop-types").any,
  columnData: require("prop-types").any,
  dataKey: require("prop-types").string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_CellRendererParams", {
  value: babelPluginFlowReactPropTypes_proptype_CellRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams =  true ? null : {
  className: require("prop-types").string.isRequired,
  columns: require("prop-types").arrayOf(require("prop-types").any).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams", {
  value: babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_HeaderRendererParams =  true ? null : {
  columnData: require("prop-types").any,
  dataKey: require("prop-types").string.isRequired,
  disableSort: require("prop-types").bool,
  label: require("prop-types").any,
  sortBy: require("prop-types").string,
  sortDirection: require("prop-types").string
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_HeaderRendererParams", {
  value: babelPluginFlowReactPropTypes_proptype_HeaderRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RowRendererParams =  true ? null : {
  className: require("prop-types").string.isRequired,
  columns: require("prop-types").arrayOf(require("prop-types").any).isRequired,
  index: require("prop-types").number.isRequired,
  isScrolling: require("prop-types").bool.isRequired,
  onRowClick: require("prop-types").func,
  onRowDoubleClick: require("prop-types").func,
  onRowMouseOver: require("prop-types").func,
  onRowMouseOut: require("prop-types").func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_RowRendererParams", {
  value: babelPluginFlowReactPropTypes_proptype_RowRendererParams,
  configurable: true
});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = exports.Tab = undefined;

var _Tab2 = __webpack_require__(1104);

var _Tab3 = _interopRequireDefault(_Tab2);

var _Tabs2 = __webpack_require__(1105);

var _Tabs3 = _interopRequireDefault(_Tabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tab = _Tab3.default;
exports.Tabs = _Tabs3.default;
exports.default = _Tabs3.default;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultUtils = undefined;
exports.dateTimeFormat = dateTimeFormat;
exports.getYear = getYear;
exports.setYear = setYear;
exports.addDays = addDays;
exports.addMonths = addMonths;
exports.addYears = addYears;
exports.cloneDate = cloneDate;
exports.cloneAsDate = cloneAsDate;
exports.getDaysInMonth = getDaysInMonth;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getWeekArray = getWeekArray;
exports.localizedWeekday = localizedWeekday;
exports.formatIso = formatIso;
exports.isEqualDate = isEqualDate;
exports.isBeforeDate = isBeforeDate;
exports.isAfterDate = isAfterDate;
exports.isBetweenDates = isBetweenDates;
exports.monthDiff = monthDiff;
exports.yearDiff = yearDiff;

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function dateTimeFormat(locale, options) {
   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;

  this.format = function (date) {
    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    } else if (options.year === 'numeric' && options.month === 'long') {
      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
    } else if (options.weekday === 'narrow') {
      return dayAbbreviation[date.getDay()];
    } else if (options.year === 'numeric') {
      return date.getFullYear().toString();
    } else if (options.day === 'numeric') {
      return date.getDate();
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
    }
  };
}

function getYear(d) {
  return d.getFullYear();
}

function setYear(d, year) {
  var newDate = cloneDate(d);
  newDate.setFullYear(year);
  return newDate;
}

function addDays(d, days) {
  var newDate = cloneDate(d);
  newDate.setDate(d.getDate() + days);
  return newDate;
}

function addMonths(d, months) {
  var newDate = cloneDate(d);
  newDate.setMonth(d.getMonth() + months);
  return newDate;
}

function addYears(d, years) {
  var newDate = cloneDate(d);
  newDate.setFullYear(d.getFullYear() + years);
  return newDate;
}

function cloneDate(d) {
  return new Date(d.getTime());
}

function cloneAsDate(d) {
  var clonedDate = cloneDate(d);
  clonedDate.setHours(0, 0, 0, 0);
  return clonedDate;
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

function getFirstDayOfWeek() {
  var now = new Date();
  return new Date(now.setDate(now.getDate() - now.getDay()));
}

function getWeekArray(d, firstDayOfWeek) {
  var dayArray = [];
  var daysInMonth = getDaysInMonth(d);
  var weekArray = [];
  var week = [];

  for (var i = 1; i <= daysInMonth; i++) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
  }

  var addWeek = function addWeek(week) {
    var emptyDays = 7 - week.length;
    for (var _i = 0; _i < emptyDays; ++_i) {
      week[weekArray.length ? 'push' : 'unshift'](null);
    }
    weekArray.push(week);
  };

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      addWeek(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      addWeek(week);
    }
  });

  return weekArray;
}

function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
  var firstDayDate = getFirstDayOfWeek();

  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
}

// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
function formatIso(date) {
  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
}

function isEqualDate(d1, d2) {
  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

function isBeforeDate(d1, d2) {
  var date1 = cloneAsDate(d1);
  var date2 = cloneAsDate(d2);

  return date1.getTime() < date2.getTime();
}

function isAfterDate(d1, d2) {
  var date1 = cloneAsDate(d1);
  var date2 = cloneAsDate(d2);

  return date1.getTime() > date2.getTime();
}

function isBetweenDates(dateToCheck, startDate, endDate) {
  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
}

function monthDiff(d1, d2) {
  var m = void 0;
  m = (d1.getFullYear() - d2.getFullYear()) * 12;
  m += d1.getMonth();
  m -= d2.getMonth();
  return m;
}

function yearDiff(d1, d2) {
  return ~~(monthDiff(d1, d2) / 12);
}

var defaultUtils = exports.defaultUtils = {
  getYear: getYear,
  setYear: setYear,
  addDays: addDays,
  addMonths: addMonths,
  addYears: addYears,
  getFirstDayOfMonth: getFirstDayOfMonth,
  getWeekArray: getWeekArray,
  monthDiff: monthDiff
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var layerDialogStyles = exports.layerDialogStyles = {
    tabs: {
        height: 376
    },
    tabBar: {
        borderBottom: '1px solid #ddd'
    },
    select: {
        width: 'auto',
        maxWidth: 300
    },
    flexColumnFlow: {
        display: 'flex',
        flexFlow: 'column',
        maxHeight: 320,
        overflowY: 'auto',
        paddingBottom: 16
    },
    flexRowFlow: {
        display: 'flex',
        flexFlow: 'row wrap',
        margin: '4px -12px 0'
    },
    flexItem: {},
    flex: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start',
        margin: '4px -12px 0'
    },
    flexRow: {
        flex: '100%',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start'
    },
    flexColumn: {
        flex: '50%',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start',
        boxSizing: 'border-box'
    },
    flexFull: {
        flex: '100%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff'
    },
    flexFullMax: {
        maxWidth: 400,
        flex: '100%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff'
    },

    flexHalf: {
        // flex: '50%',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 20,
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
        overflow: 'auto'
    },
    flexThird: {
        maxWidth: 280,
        flex: '33%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff'
    },
    flexQuarter: {
        flex: '25%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff'
    }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(244);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26),
    isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(153),
    baseOrderBy = __webpack_require__(440),
    baseRest = __webpack_require__(248),
    isIterateeCall = __webpack_require__(249);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(247),
    isArrayLike = __webpack_require__(42);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(218),
    createBaseEach = __webpack_require__(443);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57),
    overRest = __webpack_require__(217),
    setToString = __webpack_require__(120);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(80),
    isArrayLike = __webpack_require__(42),
    isIndex = __webpack_require__(63),
    isObject = __webpack_require__(26);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIteratee = __webpack_require__(38),
    toInteger = __webpack_require__(97);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDataElementOperands = exports.loadDataElementOperands = exports.setDataElements = exports.loadDataElements = exports.setDataElementGroups = exports.loadDataElementGroups = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load all data element groups
var loadDataElementGroups = exports.loadDataElementGroups = function loadDataElementGroups() {
    return {
        type: types.DATA_ELEMENT_GROUPS_LOAD
    };
};

// Set all data element groups
var setDataElementGroups = exports.setDataElementGroups = function setDataElementGroups(data) {
    return {
        type: types.DATA_ELEMENT_GROUPS_SET,
        payload: data
    };
};

// Load data elements in one group
var loadDataElements = exports.loadDataElements = function loadDataElements(groupId) {
    return {
        type: types.DATA_ELEMENTS_LOAD,
        groupId: groupId
    };
};

// Set data elements for one group
var setDataElements = exports.setDataElements = function setDataElements(groupId, payload) {
    return {
        type: types.DATA_ELEMENTS_SET,
        groupId: groupId,
        payload: payload
    };
};

// Load data element operands in one group
var loadDataElementOperands = exports.loadDataElementOperands = function loadDataElementOperands(groupId) {
    return {
        type: types.DATA_ELEMENT_OPERANDS_LOAD,
        groupId: groupId
    };
};

// Set data element operands for one group
var setDataElementOperands = exports.setDataElementOperands = function setDataElementOperands(groupId, payload) {
    return {
        type: types.DATA_ELEMENT_OPERANDS_SET,
        groupId: groupId,
        payload: payload
    };
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrlParameter = exports.getExternalLayer = exports.mapRequest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _d = __webpack_require__(19);

var _helpers = __webpack_require__(36);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isObject = __webpack_require__(221);

var _isObject2 = _interopRequireDefault(_isObject);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// API requests

// Fetch one favorite
var mapRequest = exports.mapRequest = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var d2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context.sent;
                        _context.t0 = d2.models.map;
                        _context.t1 = id;
                        _context.next = 7;
                        return (0, _helpers.mapFields)();

                    case 7:
                        _context.t2 = _context.sent;
                        _context.t3 = {
                            fields: _context.t2
                        };
                        _context.t4 = getBasemap;

                        _context.t5 = function (config) {
                            return _extends({}, config, {
                                mapViews: upgradeGisAppLayers(config.mapViews)
                            });
                        };

                        return _context.abrupt('return', _context.t0.get.call(_context.t0, _context.t1, _context.t3).then(_context.t4).then(_context.t5));

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function mapRequest(_x) {
        return _ref.apply(this, arguments);
    };
}();

// Fetch one external layer
var getExternalLayer = exports.getExternalLayer = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var d2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        return _context2.abrupt('return', d2.models.externalMapLayers.get(id));

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function getExternalLayer(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

// Different ways of specifying a basemap - TODO: simplify!
var getBasemap = function getBasemap(config) {
    var externalBasemap = config.mapViews.find(function (view) {
        return view.layer === 'external' && JSON.parse(view.config || {}).mapLayerPosition === 'BASEMAP';
    });
    var basemap = { id: 'osmLight' }; // Default basemap
    var mapViews = config.mapViews;

    if (externalBasemap) {
        basemap = JSON.parse(externalBasemap.config);
        mapViews = config.mapViews.filter(function (view) {
            return view.id !== externalBasemap.id;
        });
    } else if ((0, _isString2.default)(config.basemap)) {
        basemap = config.basemap === 'none' ? { id: 'osmLight', isVisible: false } : { id: config.basemap };
    } else if ((0, _isObject2.default)(config.basemap)) {
        basemap = config.basemap;
    }

    return _extends({}, config, {
        basemap: basemap,
        mapViews: mapViews
    });
};

// Layer order in the previous GIS app (bottom to top)
var gisAppLayerOrder = {
    externalLayer: 1, // TODO: Distinguish between basemaps and overlays
    earthEngine: 2,
    thematic4: 3,
    thematic3: 4,
    thematic2: 5,
    thematic1: 6,
    boundary: 7,
    facility: 8,
    event: 9
};

// Detection if map config is from previous GIS app
// TODO: Better to store app version as part of config object?
var isGisAppFormat = function isGisAppFormat(layers) {
    return layers.some(function (config) {
        return config.layer.match(/thematic[1-4]/);
    });
};

var upgradeGisAppLayers = function upgradeGisAppLayers(layers) {
    if (!isGisAppFormat(layers)) {
        return layers;
    }

    return (0, _sortBy2.default)(function (config) {
        return gisAppLayerOrder[config.layer];
    }, layers).map(function (config) {
        return _extends({}, config, {
            layer: config.layer.replace(/\d$/, '') // Remove thematic number used in previous versions
        });
    });
};

// https://davidwalsh.name/query-string-javascript
var getUrlParameter = exports.getUrlParameter = function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchLayer = undefined;

var _eventLoader = __webpack_require__(224);

var _eventLoader2 = _interopRequireDefault(_eventLoader);

var _facilityLoader = __webpack_require__(486);

var _facilityLoader2 = _interopRequireDefault(_facilityLoader);

var _thematicLoader = __webpack_require__(487);

var _thematicLoader2 = _interopRequireDefault(_thematicLoader);

var _boundaryLoader = __webpack_require__(492);

var _boundaryLoader2 = _interopRequireDefault(_boundaryLoader);

var _earthEngineLoader = __webpack_require__(259);

var _earthEngineLoader2 = _interopRequireDefault(_earthEngineLoader);

var _externalLoader = __webpack_require__(497);

var _externalLoader2 = _interopRequireDefault(_externalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var layerType = {
    event: _eventLoader2.default,
    facility: _facilityLoader2.default,
    thematic: _thematicLoader2.default,
    boundary: _boundaryLoader2.default,
    earthEngine: _earthEngineLoader2.default,
    external: _externalLoader2.default
};

var fetchLayer = exports.fetchLayer = function fetchLayer(config) {
    var Loader = layerType[config.layer];

    if (Loader) {
        return Loader(config);
    } else {
        console.log('Unknown layer type', config.layer, config);
    }
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
// Please see license at http://colorbrewer.org/export/LICENSE.txt
/* harmony default export */ __webpack_exports__["default"] = ({ YlGn: {
        3: ['#f7fcb9', '#addd8e', '#31a354'],
        4: ['#ffffcc', '#c2e699', '#78c679', '#238443'],
        5: ['#ffffcc', '#c2e699', '#78c679', '#31a354', '#006837'],
        6: ['#ffffcc', '#d9f0a3', '#addd8e', '#78c679', '#31a354', '#006837'],
        7: ['#ffffcc', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#005a32'],
        8: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#005a32'],
        9: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529']
    },
    YlGnBu: {
        3: ['#edf8b1', '#7fcdbb', '#2c7fb8'],
        4: ['#ffffcc', '#a1dab4', '#41b6c4', '#225ea8'],
        5: ['#ffffcc', '#a1dab4', '#41b6c4', '#2c7fb8', '#253494'],
        6: ['#ffffcc', '#c7e9b4', '#7fcdbb', '#41b6c4', '#2c7fb8', '#253494'],
        7: ['#ffffcc', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#0c2c84'],
        8: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#0c2c84'],
        9: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58']
    },
    GnBu: {
        3: ['#e0f3db', '#a8ddb5', '#43a2ca'],
        4: ['#f0f9e8', '#bae4bc', '#7bccc4', '#2b8cbe'],
        5: ['#f0f9e8', '#bae4bc', '#7bccc4', '#43a2ca', '#0868ac'],
        6: ['#f0f9e8', '#ccebc5', '#a8ddb5', '#7bccc4', '#43a2ca', '#0868ac'],
        7: ['#f0f9e8', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e'],
        8: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e'],
        9: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081']
    },
    BuGn: {
        3: ['#e5f5f9', '#99d8c9', '#2ca25f'],
        4: ['#edf8fb', '#b2e2e2', '#66c2a4', '#238b45'],
        5: ['#edf8fb', '#b2e2e2', '#66c2a4', '#2ca25f', '#006d2c'],
        6: ['#edf8fb', '#ccece6', '#99d8c9', '#66c2a4', '#2ca25f', '#006d2c'],
        7: ['#edf8fb', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#005824'],
        8: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#005824'],
        9: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b']
    },
    PuBuGn: {
        3: ['#ece2f0', '#a6bddb', '#1c9099'],
        4: ['#f6eff7', '#bdc9e1', '#67a9cf', '#02818a'],
        5: ['#f6eff7', '#bdc9e1', '#67a9cf', '#1c9099', '#016c59'],
        6: ['#f6eff7', '#d0d1e6', '#a6bddb', '#67a9cf', '#1c9099', '#016c59'],
        7: ['#f6eff7', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016450'],
        8: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016450'],
        9: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636']
    },
    PuBu: {
        3: ['#ece7f2', '#a6bddb', '#2b8cbe'],
        4: ['#f1eef6', '#bdc9e1', '#74a9cf', '#0570b0'],
        5: ['#f1eef6', '#bdc9e1', '#74a9cf', '#2b8cbe', '#045a8d'],
        6: ['#f1eef6', '#d0d1e6', '#a6bddb', '#74a9cf', '#2b8cbe', '#045a8d'],
        7: ['#f1eef6', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#034e7b'],
        8: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#034e7b'],
        9: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858']
    },
    BuPu: {
        3: ['#e0ecf4', '#9ebcda', '#8856a7'],
        4: ['#edf8fb', '#b3cde3', '#8c96c6', '#88419d'],
        5: ['#edf8fb', '#b3cde3', '#8c96c6', '#8856a7', '#810f7c'],
        6: ['#edf8fb', '#bfd3e6', '#9ebcda', '#8c96c6', '#8856a7', '#810f7c'],
        7: ['#edf8fb', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#6e016b'],
        8: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#6e016b'],
        9: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b']
    },
    RdPu: {
        3: ['#fde0dd', '#fa9fb5', '#c51b8a'],
        4: ['#feebe2', '#fbb4b9', '#f768a1', '#ae017e'],
        5: ['#feebe2', '#fbb4b9', '#f768a1', '#c51b8a', '#7a0177'],
        6: ['#feebe2', '#fcc5c0', '#fa9fb5', '#f768a1', '#c51b8a', '#7a0177'],
        7: ['#feebe2', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177'],
        8: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177'],
        9: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a']
    },
    PuRd: {
        3: ['#e7e1ef', '#c994c7', '#dd1c77'],
        4: ['#f1eef6', '#d7b5d8', '#df65b0', '#ce1256'],
        5: ['#f1eef6', '#d7b5d8', '#df65b0', '#dd1c77', '#980043'],
        6: ['#f1eef6', '#d4b9da', '#c994c7', '#df65b0', '#dd1c77', '#980043'],
        7: ['#f1eef6', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#91003f'],
        8: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#91003f'],
        9: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f']
    },
    OrRd: {
        3: ['#fee8c8', '#fdbb84', '#e34a33'],
        4: ['#fef0d9', '#fdcc8a', '#fc8d59', '#d7301f'],
        5: ['#fef0d9', '#fdcc8a', '#fc8d59', '#e34a33', '#b30000'],
        6: ['#fef0d9', '#fdd49e', '#fdbb84', '#fc8d59', '#e34a33', '#b30000'],
        7: ['#fef0d9', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#990000'],
        8: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#990000'],
        9: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000']
    },
    YlOrRd: {
        3: ['#ffeda0', '#feb24c', '#f03b20'],
        4: ['#ffffb2', '#fecc5c', '#fd8d3c', '#e31a1c'],
        5: ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'],
        6: ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026'],
        7: ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#b10026'],
        8: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#b10026'],
        9: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026']
    },
    YlOrBr: {
        3: ['#fff7bc', '#fec44f', '#d95f0e'],
        4: ['#ffffd4', '#fed98e', '#fe9929', '#cc4c02'],
        5: ['#ffffd4', '#fed98e', '#fe9929', '#d95f0e', '#993404'],
        6: ['#ffffd4', '#fee391', '#fec44f', '#fe9929', '#d95f0e', '#993404'],
        7: ['#ffffd4', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#8c2d04'],
        8: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#8c2d04'],
        9: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506']
    },
    Purples: {
        3: ['#efedf5', '#bcbddc', '#756bb1'],
        4: ['#f2f0f7', '#cbc9e2', '#9e9ac8', '#6a51a3'],
        5: ['#f2f0f7', '#cbc9e2', '#9e9ac8', '#756bb1', '#54278f'],
        6: ['#f2f0f7', '#dadaeb', '#bcbddc', '#9e9ac8', '#756bb1', '#54278f'],
        7: ['#f2f0f7', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486'],
        8: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486'],
        9: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d']
    },
    Blues: {
        3: ['#deebf7', '#9ecae1', '#3182bd'],
        4: ['#eff3ff', '#bdd7e7', '#6baed6', '#2171b5'],
        5: ['#eff3ff', '#bdd7e7', '#6baed6', '#3182bd', '#08519c'],
        6: ['#eff3ff', '#c6dbef', '#9ecae1', '#6baed6', '#3182bd', '#08519c'],
        7: ['#eff3ff', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#084594'],
        8: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#084594'],
        9: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b']
    },
    Greens: {
        3: ['#e5f5e0', '#a1d99b', '#31a354'],
        4: ['#edf8e9', '#bae4b3', '#74c476', '#238b45'],
        5: ['#edf8e9', '#bae4b3', '#74c476', '#31a354', '#006d2c'],
        6: ['#edf8e9', '#c7e9c0', '#a1d99b', '#74c476', '#31a354', '#006d2c'],
        7: ['#edf8e9', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#005a32'],
        8: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#005a32'],
        9: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b']
    },
    Oranges: {
        3: ['#fee6ce', '#fdae6b', '#e6550d'],
        4: ['#feedde', '#fdbe85', '#fd8d3c', '#d94701'],
        5: ['#feedde', '#fdbe85', '#fd8d3c', '#e6550d', '#a63603'],
        6: ['#feedde', '#fdd0a2', '#fdae6b', '#fd8d3c', '#e6550d', '#a63603'],
        7: ['#feedde', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#8c2d04'],
        8: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#8c2d04'],
        9: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704']
    },
    Reds: {
        3: ['#fee0d2', '#fc9272', '#de2d26'],
        4: ['#fee5d9', '#fcae91', '#fb6a4a', '#cb181d'],
        5: ['#fee5d9', '#fcae91', '#fb6a4a', '#de2d26', '#a50f15'],
        6: ['#fee5d9', '#fcbba1', '#fc9272', '#fb6a4a', '#de2d26', '#a50f15'],
        7: ['#fee5d9', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#99000d'],
        8: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#99000d'],
        9: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d']
    },
    Greys: {
        3: ['#f0f0f0', '#bdbdbd', '#636363'],
        4: ['#f7f7f7', '#cccccc', '#969696', '#525252'],
        5: ['#f7f7f7', '#cccccc', '#969696', '#636363', '#252525'],
        6: ['#f7f7f7', '#d9d9d9', '#bdbdbd', '#969696', '#636363', '#252525'],
        7: ['#f7f7f7', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525'],
        8: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525'],
        9: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000']
    },
    PuOr: {
        3: ['#f1a340', '#f7f7f7', '#998ec3'],
        4: ['#e66101', '#fdb863', '#b2abd2', '#5e3c99'],
        5: ['#e66101', '#fdb863', '#f7f7f7', '#b2abd2', '#5e3c99'],
        6: ['#b35806', '#f1a340', '#fee0b6', '#d8daeb', '#998ec3', '#542788'],
        7: ['#b35806', '#f1a340', '#fee0b6', '#f7f7f7', '#d8daeb', '#998ec3', '#542788'],
        8: ['#b35806', '#e08214', '#fdb863', '#fee0b6', '#d8daeb', '#b2abd2', '#8073ac', '#542788'],
        9: ['#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788'],
        10: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
        11: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b']
    },
    BrBG: {
        3: ['#d8b365', '#f5f5f5', '#5ab4ac'],
        4: ['#a6611a', '#dfc27d', '#80cdc1', '#018571'],
        5: ['#a6611a', '#dfc27d', '#f5f5f5', '#80cdc1', '#018571'],
        6: ['#8c510a', '#d8b365', '#f6e8c3', '#c7eae5', '#5ab4ac', '#01665e'],
        7: ['#8c510a', '#d8b365', '#f6e8c3', '#f5f5f5', '#c7eae5', '#5ab4ac', '#01665e'],
        8: ['#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#c7eae5', '#80cdc1', '#35978f', '#01665e'],
        9: ['#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e'],
        10: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
        11: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30']
    },
    PRGn: {
        3: ['#af8dc3', '#f7f7f7', '#7fbf7b'],
        4: ['#7b3294', '#c2a5cf', '#a6dba0', '#008837'],
        5: ['#7b3294', '#c2a5cf', '#f7f7f7', '#a6dba0', '#008837'],
        6: ['#762a83', '#af8dc3', '#e7d4e8', '#d9f0d3', '#7fbf7b', '#1b7837'],
        7: ['#762a83', '#af8dc3', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#7fbf7b', '#1b7837'],
        8: ['#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837'],
        9: ['#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837'],
        10: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
        11: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b']
    },
    PiYG: {
        3: ['#e9a3c9', '#f7f7f7', '#a1d76a'],
        4: ['#d01c8b', '#f1b6da', '#b8e186', '#4dac26'],
        5: ['#d01c8b', '#f1b6da', '#f7f7f7', '#b8e186', '#4dac26'],
        6: ['#c51b7d', '#e9a3c9', '#fde0ef', '#e6f5d0', '#a1d76a', '#4d9221'],
        7: ['#c51b7d', '#e9a3c9', '#fde0ef', '#f7f7f7', '#e6f5d0', '#a1d76a', '#4d9221'],
        8: ['#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221'],
        9: ['#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221'],
        10: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
        11: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419']
    },
    RdBu: {
        3: ['#ef8a62', '#f7f7f7', '#67a9cf'],
        4: ['#ca0020', '#f4a582', '#92c5de', '#0571b0'],
        5: ['#ca0020', '#f4a582', '#f7f7f7', '#92c5de', '#0571b0'],
        6: ['#b2182b', '#ef8a62', '#fddbc7', '#d1e5f0', '#67a9cf', '#2166ac'],
        7: ['#b2182b', '#ef8a62', '#fddbc7', '#f7f7f7', '#d1e5f0', '#67a9cf', '#2166ac'],
        8: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac'],
        9: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac'],
        10: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
        11: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061']
    },
    RdGy: {
        3: ['#ef8a62', '#ffffff', '#999999'],
        4: ['#ca0020', '#f4a582', '#bababa', '#404040'],
        5: ['#ca0020', '#f4a582', '#ffffff', '#bababa', '#404040'],
        6: ['#b2182b', '#ef8a62', '#fddbc7', '#e0e0e0', '#999999', '#4d4d4d'],
        7: ['#b2182b', '#ef8a62', '#fddbc7', '#ffffff', '#e0e0e0', '#999999', '#4d4d4d'],
        8: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#e0e0e0', '#bababa', '#878787', '#4d4d4d'],
        9: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d'],
        10: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
        11: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a']
    },
    RdYlBu: {
        3: ['#fc8d59', '#ffffbf', '#91bfdb'],
        4: ['#d7191c', '#fdae61', '#abd9e9', '#2c7bb6'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#abd9e9', '#2c7bb6'],
        6: ['#d73027', '#fc8d59', '#fee090', '#e0f3f8', '#91bfdb', '#4575b4'],
        7: ['#d73027', '#fc8d59', '#fee090', '#ffffbf', '#e0f3f8', '#91bfdb', '#4575b4'],
        8: ['#d73027', '#f46d43', '#fdae61', '#fee090', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4'],
        9: ['#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4'],
        10: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
        11: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695']
    },
    Spectral: {
        3: ['#fc8d59', '#ffffbf', '#99d594'],
        4: ['#d7191c', '#fdae61', '#abdda4', '#2b83ba'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#abdda4', '#2b83ba'],
        6: ['#d53e4f', '#fc8d59', '#fee08b', '#e6f598', '#99d594', '#3288bd'],
        7: ['#d53e4f', '#fc8d59', '#fee08b', '#ffffbf', '#e6f598', '#99d594', '#3288bd'],
        8: ['#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#e6f598', '#abdda4', '#66c2a5', '#3288bd'],
        9: ['#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd'],
        10: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
        11: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2']
    },
    RdYlGn: {
        3: ['#fc8d59', '#ffffbf', '#91cf60'],
        4: ['#d7191c', '#fdae61', '#a6d96a', '#1a9641'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#a6d96a', '#1a9641'],
        6: ['#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'],
        7: ['#d73027', '#fc8d59', '#fee08b', '#ffffbf', '#d9ef8b', '#91cf60', '#1a9850'],
        8: ['#d73027', '#f46d43', '#fdae61', '#fee08b', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850'],
        9: ['#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850'],
        10: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
        11: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837']
    },
    Accent: {
        3: ['#7fc97f', '#beaed4', '#fdc086'],
        4: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99'],
        5: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0'],
        6: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f'],
        7: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17'],
        8: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666']
    },
    Dark2: {
        3: ['#1b9e77', '#d95f02', '#7570b3'],
        4: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a'],
        5: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e'],
        6: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02'],
        7: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d'],
        8: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666']
    },
    Paired: {
        3: ['#a6cee3', '#1f78b4', '#b2df8a'],
        4: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c'],
        5: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99'],
        6: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c'],
        7: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f'],
        8: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00'],
        9: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6'],
        10: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a'],
        11: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99'],
        12: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928']
    },
    Pastel1: {
        3: ['#fbb4ae', '#b3cde3', '#ccebc5'],
        4: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4'],
        5: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6'],
        6: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc'],
        7: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd'],
        8: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec'],
        9: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
    },
    Pastel2: {
        3: ['#b3e2cd', '#fdcdac', '#cbd5e8'],
        4: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4'],
        5: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9'],
        6: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae'],
        7: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc'],
        8: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc']
    },
    Set1: {
        3: ['#e41a1c', '#377eb8', '#4daf4a'],
        4: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3'],
        5: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00'],
        6: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33'],
        7: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628'],
        8: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'],
        9: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999']
    },
    Set2: {
        3: ['#66c2a5', '#fc8d62', '#8da0cb'],
        4: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3'],
        5: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854'],
        6: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f'],
        7: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494'],
        8: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3']
    },
    Set3: {
        3: ['#8dd3c7', '#ffffb3', '#bebada'],
        4: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072'],
        5: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3'],
        6: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462'],
        7: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69'],
        8: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5'],
        9: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9'],
        10: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd'],
        11: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5'],
        12: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f']
    },
    YlOrBr_reverse: {
        3: ['#d95f0e', '#fec44f', '#fff7bc'],
        4: ['#cc4c02', '#fe9929', '#fed98e', '#ffffd4'],
        5: ['#993404', '#d95f0e', '#fe9929', '#fed98e', '#ffffd4'],
        6: ['#993404', '#d95f0e', '#fe9929', '#fec44f', '#fee391', '#ffffd4'],
        7: ['#8c2d04', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#ffffd4'],
        8: ['#8c2d04', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#fff7bc', '#ffffe5'],
        9: ['#662506', '#993404', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#fff7bc', '#ffffe5']
    },
    Reds_reverse: {
        3: ['#de2d26', '#fc9272', '#fee0d2'],
        4: ['#cb181d', '#fb6a4a', '#fcae91', '#fee5d9'],
        5: ['#a50f15', '#de2d26', '#fb6a4a', '#fcae91', '#fee5d9'],
        6: ['#a50f15', '#de2d26', '#fb6a4a', '#fc9272', '#fcbba1', '#fee5d9'],
        7: ['#99000d', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee5d9'],
        8: ['#99000d', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee0d2', '#fff5f0'],
        9: ['#67000d', '#a50f15', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee0d2', '#fff5f0']
    },
    YlGn_reverse: {
        3: ['#31a354', '#addd8e', '#f7fcb9'],
        4: ['#238443', '#78c679', '#c2e699', '#ffffcc'],
        5: ['#006837', '#31a354', '#78c679', '#c2e699', '#ffffcc'],
        6: ['#006837', '#31a354', '#78c679', '#addd8e', '#d9f0a3', '#ffffcc'],
        7: ['#005a32', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#ffffcc'],
        8: ['#005a32', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#f7fcb9', '#ffffe5'],
        9: ['#004529', '#006837', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#f7fcb9', '#ffffe5']
    },
    Greens_reverse: {
        3: ['#31a354', '#a1d99b', '#e5f5e0'],
        4: ['#238b45', '#74c476', '#bae4b3', '#edf8e9'],
        5: ['#006d2c', '#31a354', '#74c476', '#bae4b3', '#edf8e9'],
        6: ['#006d2c', '#31a354', '#74c476', '#a1d99b', '#c7e9c0', '#edf8e9'],
        7: ['#005a32', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#edf8e9'],
        8: ['#005a32', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#e5f5e0', '#f7fcf5'],
        9: ['#00441b', '#006d2c', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#e5f5e0', '#f7fcf5']
    },
    Blues_reverse: {
        3: ['#3182bd', '#9ecae1', '#deebf7'],
        4: ['#2171b5', '#6baed6', '#bdd7e7', '#eff3ff'],
        5: ['#08519c', '#3182bd', '#6baed6', '#bdd7e7', '#eff3ff'],
        6: ['#08519c', '#3182bd', '#6baed6', '#9ecae1', '#c6dbef', '#eff3ff'],
        7: ['#084594', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#eff3ff'],
        8: ['#084594', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#f7fbff'],
        9: ['#08306b', '#08519c', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#f7fbff']
    },
    BuPu_reverse: {
        3: ['#8856a7', '#9ebcda', '#e0ecf4'],
        4: ['#88419d', '#8c96c6', '#b3cde3', '#edf8fb'],
        5: ['#810f7c', '#8856a7', '#8c96c6', '#b3cde3', '#edf8fb'],
        6: ['#810f7c', '#8856a7', '#8c96c6', '#9ebcda', '#bfd3e6', '#edf8fb'],
        7: ['#6e016b', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#edf8fb'],
        8: ['#6e016b', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#e0ecf4', '#f7fcfd'],
        9: ['#4d004b', '#810f7c', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#e0ecf4', '#f7fcfd']
    },
    RdPu_reverse: {
        3: ['#c51b8a', '#fa9fb5', '#fde0dd'],
        4: ['#ae017e', '#f768a1', '#fbb4b9', '#feebe2'],
        5: ['#7a0177', '#c51b8a', '#f768a1', '#fbb4b9', '#feebe2'],
        6: ['#7a0177', '#c51b8a', '#f768a1', '#fa9fb5', '#fcc5c0', '#feebe2'],
        7: ['#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#feebe2'],
        8: ['#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#fde0dd', '#fff7f3'],
        9: ['#49006a', '#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#fde0dd', '#fff7f3']
    },
    PuRd_reverse: {
        3: ['#dd1c77', '#c994c7', '#e7e1ef'],
        4: ['#ce1256', '#df65b0', '#d7b5d8', '#f1eef6'],
        5: ['#980043', '#dd1c77', '#df65b0', '#d7b5d8', '#f1eef6'],
        6: ['#980043', '#dd1c77', '#df65b0', '#c994c7', '#d4b9da', '#f1eef6'],
        7: ['#91003f', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#f1eef6'],
        8: ['#91003f', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#e7e1ef', '#f7f4f9'],
        9: ['#67001f', '#980043', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#e7e1ef', '#f7f4f9']
    },
    Greys_reverse: {
        3: ['#636363', '#bdbdbd', '#f0f0f0'],
        4: ['#525252', '#969696', '#cccccc', '#f7f7f7'],
        5: ['#252525', '#636363', '#969696', '#cccccc', '#f7f7f7'],
        6: ['#252525', '#636363', '#969696', '#bdbdbd', '#d9d9d9', '#f7f7f7'],
        7: ['#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f7f7f7'],
        8: ['#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f0f0f0', '#ffffff'],
        9: ['#000000', '#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f0f0f0', '#ffffff']
    } });

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(210),
    arrayIncludes = __webpack_require__(194),
    arrayIncludesWith = __webpack_require__(495),
    cacheHas = __webpack_require__(211),
    createSet = __webpack_require__(496),
    setToArray = __webpack_require__(136);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var datasets = {
    'USGS/SRTMGL1_003': {
        name: 'Elevation',
        band: 'elevation',
        mask: true,
        legend: {
            unit: 'metres',
            description: 'Elevation above sea-level.',
            source: 'NASA / USGS / JPL-Caltech / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/USGS%2FSRTMGL1_003'
        }
    },
    'WorldPop/POP': {
        name: 'Population density',
        aggregation: 'mosaic',
        mask: true,
        methods: {
            multiply: [100] // Convert from people/hectare to people/km2
        },
        resolution: 100,
        projection: 'EPSG:4326',
        value: function value(_value) {
            return Math.round(_value);
        },

        legend: {
            unit: 'people per km²',
            description: 'Population density estimates with national totals adjusted to match UN population division estimates.',
            source: 'WorldPop / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/WorldPop%2FPOP'
        }
    },
    'NOAA/DMSP-OLS/NIGHTTIME_LIGHTS': {
        name: 'Nighttime lights',
        band: 'stable_lights',
        mask: true,
        popup: '{name}: {value}',
        legend: {
            unit: 'light intensity',
            description: 'Light intensity from cities, towns, and other sites with persistent lighting, including gas flares.',
            source: 'NOAA / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/NOAA%2FDMSP-OLS%2FNIGHTTIME_LIGHTS'
        }
    },
    'UCSB-CHG/CHIRPS/PENTAD': {
        name: 'Precipitation',
        band: 'precipitation',
        mask: true,
        value: function value(_value2) {
            return _value2.toFixed(1);
        },

        legend: {
            unit: 'millimeter',
            description: 'Precipitation collected from satellite and weather stations on the ground.',
            source: 'UCSB / CHG / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/UCSB-CHG%2FCHIRPS%2FPENTAD'
        }
    },
    'MODIS/MOD11A2': {
        name: 'Temperature',
        band: 'LST_Day_1km',
        mask: true,
        methods: {
            toFloat: [],
            multiply: [0.02],
            subtract: [273.15]
        },
        value: function value(_value3) {
            return Math.round(_value3);
        },

        popup: '{name}: {value}{unit}',
        legend: {
            unit: '°C during daytime',
            description: 'Land surface temperatures collected from satellite. Blank spots will appear in areas with a persistent cloud cover.',
            source: 'NASA LP DAAC / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/MODIS%2FMOD11A2'
        }
    },
    'MODIS/051/MCD12Q1': {
        name: 'Landcover',
        band: 'Land_Cover_Type_1',
        params: {
            min: 0,
            max: 17,
            palette: 'aec3d6,162103,235123,399b38,38eb38,39723b,6a2424,c3a55f,b76124,d99125,92af1f,10104c,cdb400,cc0202,332808,d7cdcc,f7e174,743411'
        },
        mask: false,
        legend: {
            description: 'Distinct landcover types collected from satellites.',
            source: 'NASA LP DAAC / Google Earth Engine',
            sourceUrl: 'https://code.earthengine.google.com/dataset/MODIS/051/MCD12Q1',
            items: [{
                color: '#aec3d6',
                name: 'Water'
            }, {
                color: '#162103',
                name: 'Evergreen Needleleaf forest'
            }, {
                color: '#235123',
                name: 'Evergreen Broadleaf forest'
            }, {
                color: '#399b38',
                name: 'Deciduous Needleleaf forest'
            }, {
                color: '#38eb38',
                name: 'Deciduous Broadleaf forest'
            }, {
                color: '#39723b',
                name: 'Mixed forest'
            }, {
                color: '#6a2424',
                name: 'Closed shrublands'
            }, {
                color: '#c3a55f',
                name: 'Open shrublands'
            }, {
                color: '#b76124',
                name: 'Woody savannas'
            }, {
                color: '#d99125',
                name: 'Savannas'
            }, {
                color: '#92af1f',
                name: 'Grasslands'
            }, {
                color: '#10104c',
                name: 'Permanent wetlands'
            }, {
                color: '#cdb400',
                name: 'Croplands'
            }, {
                color: '#cc0202',
                name: 'Urban and built-up'
            }, {
                color: '#332808',
                name: 'Cropland/Natural vegetation mosaic'
            }, {
                color: '#d7cdcc',
                name: 'Snow and ice'
            }, {
                color: '#f7e174',
                name: 'Barren or sparsely vegetated'
            }, {
                color: '#743411',
                name: 'Unclassified'
            }]
        },
        popup: '{name}: {value}'
    }
};

// Returns a promise
var earthEngineLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var layerConfig, dataset, layer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        layerConfig = {};
                        dataset = void 0;


                        if (typeof config.config === 'string') {
                            // From database as favorite
                            layerConfig = JSON.parse(config.config);

                            dataset = datasets[layerConfig.id];

                            if (dataset) {
                                dataset.datasetId = layerConfig.id;
                                delete layerConfig.id;
                            }

                            delete config.config;
                        } else {
                            dataset = datasets[config.datasetId];
                        }

                        layer = _extends({}, config, layerConfig, dataset);

                        // Create legend items from params

                        if (layer.legend && !layer.legend.items && layer.params) {
                            layer.legend = _extends({}, layer.legend, {
                                items: createLegend(layer.params)
                            });
                        }

                        return _context.abrupt('return', _extends({}, layer, {
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function earthEngineLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

// TODO: This function is currently duplicated from  GIS API
var createLegend = exports.createLegend = function createLegend(params) {
    var min = params.min;
    var max = params.max;
    var palette = params.palette.split(',');
    var step = (params.max - min) / (palette.length - (min > 0 ? 2 : 1));

    var from = min;
    var to = Math.round(min + step);

    return palette.map(function (color, index) {
        var item = {
            color: color
        };

        if (index === 0 && min > 0) {
            // Less than min
            item.name = '< ' + min;
            to = min;
        } else if (from < max) {
            item.name = from + ' - ' + to;
        } else {
            // Higher than max
            item.name = '> ' + from;
        }

        from = to;
        to = Math.round(min + step * (index + (min > 0 ? 1 : 2)));

        return item;
    });
};

exports.default = earthEngineLoader;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadOptionSet = exports.addOptionSet = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addOptionSet = exports.addOptionSet = function addOptionSet(data) {
    return {
        type: types.OPTION_SET_ADD,
        payload: data
    };
};

// Load all stages for one program
var loadOptionSet = exports.loadOptionSet = function loadOptionSet(id) {
    return {
        type: types.OPTION_SET_LOAD,
        id: id
    };
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translateConfig = exports.cleanMapConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isNil = __webpack_require__(499);

var _isNil2 = _interopRequireDefault(_isNil);

var _omitBy = __webpack_require__(501);

var _omitBy2 = _interopRequireDefault(_omitBy);

var _pick = __webpack_require__(233);

var _pick2 = _interopRequireDefault(_pick);

var _uid = __webpack_require__(50);

var _alerts = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// TODO: get latitude, longitude, zoom from map + basemap: 'none'
var validMapProperties = ['basemap', 'id', 'latitude', 'longitude', 'mapViews', 'name', 'user', 'zoom'];

var validLayerProperties = ['aggregationType', 'areaRadius', 'classes', 'colorHigh', // Deprecated
'colorLow', // Deprecated
'colorScale', 'columns', 'config', 'datasetId', 'displayName', 'endDate', 'eventClustering', 'eventPointColor', 'eventPointRadius', 'filter', 'filters', 'id', 'labels', 'labelFontSize', 'labelFontStyle', 'labelFontWeight', 'labelFontColor', 'layer', 'legendSet', 'method', 'opacity', 'organisationUnitGroupSet', 'params', 'program', 'programStage', 'radiusHigh', 'radiusLow', 'rows', 'serverCluster', 'startDate', 'valueType'];

// TODO:
//  "hidden": false,
//  "userOrganisationUnit": false,
//  "userOrganisationUnitChildren": false,
//  "userOrganisationUnitGrandChildren": false,
//  "parentGraphMap": null,

var models = [
// TODO: Better way to translate models to pure object?
'program', 'programStage', 'organisationUnitGroupSet'];

var validModelProperties = ['id', 'name', 'dimensionType', 'dimensionItemType'];

// TODO: Set hidden attribute
var cleanMapConfig = exports.cleanMapConfig = function cleanMapConfig(config) {
    return _extends({}, (0, _omitBy2.default)(_isNil2.default, (0, _pick2.default)(validMapProperties, config)), {
        basemap: getBasemapString(config.basemap),
        mapViews: config.mapViews.map(cleanLayerConfig)
    });
};

var getBasemapString = function getBasemapString(basemap) {
    if (!basemap) {
        return 'osmLight';
    }

    if (basemap.isVisible === false) {
        return 'none';
    }

    return basemap.id;
};

var cleanLayerConfig = function cleanLayerConfig(config) {
    return _extends({}, models2objects((0, _pick2.default)(validLayerProperties, config)));
};

// TODO: This feels hacky, find better way to clean map configs before saving
var models2objects = function models2objects(config) {
    Object.keys(config).forEach(function (key) {
        config[key] = models.includes(key) ? (0, _pick2.default)(validModelProperties, config[key]) : config[key];
    });

    if (config.rows) {
        config.rows = config.rows.map(cleanDimension);
    }

    if (config.params) {
        // EE layer config
        config.config = JSON.stringify({
            id: config.datasetId,
            params: config.params,
            image: config.filter ? config.filter[0].arguments[1] : null,
            filter: config.filter
        });
        delete config.datasetId;
        delete config.params;
        delete config.filter;
    }

    return config;
};

var cleanDimension = function cleanDimension(dim) {
    return _extends({}, dim, {
        items: dim.items.map(function (item) {
            return (0, _pick2.default)(validModelProperties, item);
        })
    });
};

// Translate from chart/pivot config to map config
var translateConfig = exports.translateConfig = function translateConfig(config) {
    if (!config.mapViews) {
        // TODO: Best way to detect chart/pivot config
        var el = config.el,
            name = config.name;

        var dimensions = [].concat(_toConsumableArray(config.columns || []), _toConsumableArray(config.rows || []), _toConsumableArray(config.filters || []));
        var columns = [dimensions.find(function (dim) {
            return dim.dimension === 'dx';
        })]; // Data item
        var rows = [dimensions.find(function (dim) {
            return dim.dimension === 'ou';
        })]; // Org units
        var filters = [dimensions.find(function (dim) {
            return dim.dimension === 'pe';
        })]; // Period

        if (!columns.length || !rows.length || !filters.length) {
            return {
                el: el,
                name: name,
                alerts: [(0, _alerts.createAlert)(name, i18next.t('Map could not be created'))]
            };
        }

        return {
            el: el,
            name: name,
            mapViews: [{
                layer: 'thematic',
                id: (0, _uid.generateUid)(),
                name: name,
                columns: columns,
                rows: rows,
                filters: filters
            }]
        };
    }

    return config;
};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(814)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(596)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 264 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(875), __esModule: true };

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(887);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(888);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;

var _Popover2 = __webpack_require__(163);

var _Popover3 = _interopRequireDefault(_Popover2);

var _PopoverAnimationVertical2 = __webpack_require__(529);

var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Popover = _Popover3.default;
exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
exports.default = _Popover3.default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toArray2 = __webpack_require__(615);

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _ClickAwayListener = __webpack_require__(626);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _List = __webpack_require__(627);

var _List2 = _interopRequireDefault(_List);

var _menuUtils = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var desktop = props.desktop,
      maxHeight = props.maxHeight,
      width = props.width;
  var muiTheme = context.muiTheme;


  var styles = {
    root: {
      // Nested div because the List scales x faster than it scales y
      zIndex: muiTheme.zIndex.menu,
      maxHeight: maxHeight,
      overflowY: maxHeight ? 'auto' : null
    },
    divider: {
      marginTop: 7,
      marginBottom: 8
    },
    list: {
      display: 'table-cell',
      paddingBottom: desktop ? 16 : 8,
      paddingTop: desktop ? 16 : 8,
      userSelect: 'none',
      width: width
    },
    selectedMenuItem: {
      color: muiTheme.menuItem.selectedTextColor
    }
  };

  return styles;
}

var Menu = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props, context) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));

    _initialiseProps.call(_this);

    var filteredChildren = _this.getFilteredChildren(props.children);
    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);

    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
      props.onMenuItemFocusChange(null, newFocusIndex);
    }
    _this.state = {
      focusIndex: newFocusIndex,
      isKeyboardFocused: props.initiallyKeyboardFocused,
      keyWidth: props.desktop ? 64 : 56
    };

    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
      this.setScollPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedIndex = void 0;
      var filteredChildren = this.getFilteredChildren(nextProps.children);

      if (this.props.multiple !== true) {
        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
      } else {
        selectedIndex = this.state.focusIndex;
      }

      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
        this.props.onMenuItemFocusChange(null, newFocusIndex);
      }
      this.setState({
        focusIndex: newFocusIndex,
        keyWidth: nextProps.desktop ? 64 : 56
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoWidth) this.setWidth();
    }
  }, {
    key: 'getValueLink',


    // Do not use outside of this component, it will be removed once valueLink is deprecated
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'setKeyboardFocused',
    value: function setKeyboardFocused(keyboardFocused) {
      this.setState({
        isKeyboardFocused: keyboardFocused
      });
    }
  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(children) {
      var filteredChildren = [];
      _react2.default.Children.forEach(children, function (child) {
        if (child) {
          filteredChildren.push(child);
        }
      });
      return filteredChildren;
    }
  }, {
    key: 'cloneMenuItem',
    value: function cloneMenuItem(child, childIndex, styles, index) {
      var _this2 = this;

      var childIsDisabled = child.props.disabled;

      var selectedChildStyles = {};
      if (!childIsDisabled) {
        var selected = this.isChildSelected(child, this.props);

        if (selected) {
          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
        }
      }
      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);

      var extraProps = {
        desktop: this.props.desktop,
        style: mergedChildStyles
      };
      if (!childIsDisabled) {
        var isFocused = childIndex === this.state.focusIndex;
        var focusState = 'none';
        if (isFocused) {
          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
        }

        (0, _simpleAssign2.default)(extraProps, {
          focusState: focusState,
          onClick: function onClick(event) {
            _this2.handleMenuItemClick(event, child, index);
            if (child.props.onClick) child.props.onClick(event);
          },
          ref: isFocused ? 'focusedMenuItem' : null
        });
      }
      return _react2.default.cloneElement(child, extraProps);
    }
  }, {
    key: 'decrementKeyboardFocusIndex',
    value: function decrementKeyboardFocusIndex(event) {
      var index = this.state.focusIndex;

      index--;
      if (index < 0) index = 0;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'getMenuItemCount',
    value: function getMenuItemCount(filteredChildren) {
      var menuItemCount = 0;
      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        if (!childIsADivider && !childIsDisabled) menuItemCount++;
      });
      return menuItemCount;
    }
  }, {
    key: 'getLastSelectedIndex',
    value: function getLastSelectedIndex(props, filteredChildren) {
      var _this3 = this;

      var selectedIndex = -1;
      var menuItemIndex = 0;

      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';

        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
        if (!childIsADivider) menuItemIndex++;
      });

      return selectedIndex;
    }
  }, {
    key: 'setFocusIndexStartsWith',
    value: function setFocusIndexStartsWith(event, keys, filteredChildren) {
      var foundIndex = -1;
      _react2.default.Children.forEach(filteredChildren, function (child, index) {
        if (foundIndex >= 0) {
          return;
        }
        var primaryText = child.props.primaryText;

        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
          foundIndex = index;
        }
      });
      if (foundIndex >= 0) {
        this.setFocusIndex(event, foundIndex, true);
        return true;
      }
      return false;
    }
  }, {
    key: 'handleMenuItemClick',
    value: function handleMenuItemClick(event, item, index) {
      var children = this.props.children;
      var multiple = this.props.multiple;
      var valueLink = this.getValueLink(this.props);
      var menuValue = valueLink.value;
      var itemValue = item.props.value;
      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);

      this.setFocusIndex(event, focusIndex, false);

      if (multiple) {
        menuValue = menuValue || [];

        var itemIndex = menuValue.indexOf(itemValue);

        var _menuValue = menuValue,
            _menuValue2 = (0, _toArray3.default)(_menuValue),
            newMenuValue = _menuValue2.slice(0);

        if (itemIndex === -1) {
          newMenuValue.push(itemValue);
        } else {
          newMenuValue.splice(itemIndex, 1);
        }

        valueLink.requestChange(event, newMenuValue);
      } else if (!multiple && itemValue !== menuValue) {
        valueLink.requestChange(event, itemValue);
      }

      this.props.onItemClick(event, item, index);
    }
  }, {
    key: 'incrementKeyboardFocusIndex',
    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
      var index = this.state.focusIndex;
      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;

      index++;
      if (index > maxIndex) index = maxIndex;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'isChildSelected',
    value: function isChildSelected(child, props) {
      var menuValue = this.getValueLink(props).value;
      var childValue = child.props.value;

      if (props.multiple) {
        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
      } else {
        return child.props.hasOwnProperty('value') && menuValue === childValue;
      }
    }
  }, {
    key: 'setFocusIndex',
    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
      if (this.props.onMenuItemFocusChange) {
        // Do this even if `newIndex === this.state.focusIndex` to allow users
        // to detect up-arrow on the first MenuItem or down-arrow on the last.
        this.props.onMenuItemFocusChange(event, newIndex);
      }
      this.setState({
        focusIndex: newIndex,
        isKeyboardFocused: isKeyboardFocused
      });
    }
  }, {
    key: 'setScollPosition',
    value: function setScollPosition() {
      var desktop = this.props.desktop;
      var focusedMenuItem = this.refs.focusedMenuItem;
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;

        // Make the focused item be the 2nd item in the list the user sees
        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;

        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
      }
    }
  }, {
    key: 'cancelScrollEvent',
    value: function cancelScrollEvent(event) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = _reactDom2.default.findDOMNode(this);
      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
      var elWidth = el.offsetWidth;
      var keyWidth = this.state.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          desktop = _props.desktop,
          disableAutoFocus = _props.disableAutoFocus,
          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          multiple = _props.multiple,
          onItemClick = _props.onItemClick,
          onEscKeyDown = _props.onEscKeyDown,
          onMenuItemFocusChange = _props.onMenuItemFocusChange,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          menuItemStyle = _props.menuItemStyle,
          style = _props.style,
          value = _props.value,
          valueLink = _props.valueLink,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemClick', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);

      var filteredChildren = this.getFilteredChildren(children);

      var menuItemIndex = 0;
      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
        var childIsDisabled = child.props.disabled;
        var childName = child.type ? child.type.muiName : '';
        var newChild = child;

        switch (childName) {
          case 'MenuItem':
            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
            break;

          case 'Divider':
            newChild = _react2.default.cloneElement(child, {
              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
            });
            break;
        }

        if (childName === 'MenuItem' && !childIsDisabled) {
          menuItemIndex++;
        }

        return newChild;
      });

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.handleKeyDown,
            onWheel: this.handleOnWheel,
            style: prepareStyles(mergedRootStyles),
            ref: 'scrollContainer',
            role: 'presentation'
          },
          _react2.default.createElement(
            _List2.default,
            (0, _extends3.default)({}, other, {
              ref: 'list',
              style: mergedListStyles,
              role: 'menu'
            }),
            newChildren
          )
        )
      );
    }
  }]);
  return Menu;
}(_react.Component);

Menu.defaultProps = {
  autoWidth: true,
  desktop: false,
  disableAutoFocus: false,
  initiallyKeyboardFocused: false,
  maxHeight: null,
  multiple: false,
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  onItemClick: function onItemClick() {},
  onKeyDown: function onKeyDown() {}
};
Menu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleClickAway = function (event) {
    if (event.defaultPrevented) {
      return;
    }

    var focusIndex = _this5.state.focusIndex;

    if (focusIndex < 0) {
      return;
    }

    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var focusedItem = filteredChildren[focusIndex];
    if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
      return;
    }

    _this5.setFocusIndex(event, -1, false);
  };

  this.handleKeyDown = function (event) {
    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var key = (0, _keycode2.default)(event);
    switch (key) {
      case 'down':
        event.preventDefault();
        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        break;
      case 'esc':
        _this5.props.onEscKeyDown(event);
        break;
      case 'tab':
        event.preventDefault();
        if (event.shiftKey) {
          _this5.decrementKeyboardFocusIndex(event);
        } else {
          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        }
        break;
      case 'up':
        event.preventDefault();
        _this5.decrementKeyboardFocusIndex(event);
        break;
      default:
        if (key && key.length === 1) {
          var hotKeys = _this5.hotKeyHolder.append(key);
          if (_this5.setFocusIndexStartsWith(event, hotKeys, filteredChildren)) {
            event.preventDefault();
          }
        }
    }
    _this5.props.onKeyDown(event);
  };

  this.handleOnWheel = function (event) {
    var scrollContainer = _this5.refs.scrollContainer;
    // Only scroll lock if the the Menu is scrollable.
    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;

    var scrollTop = scrollContainer.scrollTop,
        scrollHeight = scrollContainer.scrollHeight,
        clientHeight = scrollContainer.clientHeight;

    var wheelDelta = event.deltaY;
    var isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
      scrollContainer.scrollTop = scrollHeight;
      return _this5.cancelScrollEvent(event);
    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
      scrollContainer.scrollTop = 0;
      return _this5.cancelScrollEvent(event);
    }
  };
};

Menu.propTypes =  false ? {
  /**
   * If true, the width of the menu will be set automatically
   * according to the widths of its children,
   * using proper keyline increments (64px for desktop,
   * 56px otherwise).
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The content of the menu. This is usually used to pass `MenuItem`
   * elements.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the menu item will render with compact desktop styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu will not be auto-focused.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If true, the menu will be keyboard-focused initially.
   */
  initiallyKeyboardFocused: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the menu in pixels. If specified,
   * the menu will be scrollable if it is taller than the provided
   * height.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item with `value` not
   * equal to the current `value` of the menu is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {any}  value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is focused and the *Esc* key
   * is pressed.
   *
   * @param {object} event `keydown` event targeting the menu.
   */
  onEscKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {object} menuItem The menu item.
   * @param {number} index The index of the menu item.
   */
  onItemClick: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when the focus on a `MenuItem` is changed.
   * There will be some "duplicate" changes reported if two different
   * focusing event happen, for example if a `MenuItem` is focused via
   * the keyboard and then it is clicked on.
   *
   * @param {object} event The event that triggered the focus change.
   * The event can be null since the focus can be changed for non-event
   * reasons such as prop changes.
   * @param {number} newFocusIndex The index of the newly focused
   * `MenuItem` or `-1` if focus was lost.
   */
  onMenuItemFocusChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   * This component also supports valueLink.
   */
  value: _propTypes2.default.any,
  /**
   * ValueLink for the menu's `value`.
   */
  valueLink: _propTypes2.default.object,
  /**
   * The width of the menu. If not specified, the menu's width
   * will be set according to the widths of its children, using
   * proper keyline increments (64px for desktop, 56px otherwise).
   */
  width: _propTypes4.default.stringOrNumber
} : {};
exports.default = Menu;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeSaveNewFavoriteDialog = exports.openSaveNewFavoriteDialog = exports.closeFavoritesDialog = exports.openFavoritesDialog = exports.saveFavoriteInterpretation = exports.saveNewFavorite = exports.saveFavorite = exports.loadFavorite = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var loadFavorite = exports.loadFavorite = function loadFavorite(id) {
    return {
        type: types.FAVORITE_LOAD,
        id: id
    };
};

var saveFavorite = exports.saveFavorite = function saveFavorite() {
    return {
        type: types.FAVORITE_SAVE
    };
};

var saveNewFavorite = exports.saveNewFavorite = function saveNewFavorite(config) {
    return {
        type: types.FAVORITE_SAVE_NEW,
        config: config
    };
};

var saveFavoriteInterpretation = exports.saveFavoriteInterpretation = function saveFavoriteInterpretation(id, interpretation) {
    return {
        type: types.FAVORITE_INTERPRETATION_SAVE,
        id: id,
        interpretation: interpretation
    };
};

var openFavoritesDialog = exports.openFavoritesDialog = function openFavoritesDialog() {
    return {
        type: types.FAVORITES_DIALOG_OPEN
    };
};

var closeFavoritesDialog = exports.closeFavoritesDialog = function closeFavoritesDialog() {
    return {
        type: types.FAVORITES_DIALOG_CLOSE
    };
};

var openSaveNewFavoriteDialog = exports.openSaveNewFavoriteDialog = function openSaveNewFavoriteDialog() {
    return {
        type: types.FAVORITE_SAVE_NEW_DIALOG_OPEN
    };
};

var closeSaveNewFavoriteDialog = exports.closeSaveNewFavoriteDialog = function closeSaveNewFavoriteDialog() {
    return {
        type: types.FAVORITE_SAVE_NEW_DIALOG_CLOSE
    };
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resizeDataTable = exports.toggleDataTable = exports.closeDataTable = exports.openDataTable = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openDataTable = exports.openDataTable = function openDataTable(id) {
    return {
        type: types.DATA_TABLE_OPEN,
        id: id
    };
};

var closeDataTable = exports.closeDataTable = function closeDataTable() {
    return {
        type: types.DATA_TABLE_CLOSE
    };
};

var toggleDataTable = exports.toggleDataTable = function toggleDataTable(id) {
    return {
        type: types.DATA_TABLE_TOGGLE,
        id: id
    };
};

var resizeDataTable = exports.resizeDataTable = function resizeDataTable(height) {
    return {
        type: types.DATA_TABLE_RESIZE,
        height: height
    };
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createClassName; });
/**
 * @module lib/utils
 */

/**
 * Function to create CSS class names
 *
 * @param {String} name The base name
 * @param {String} selector string to append to the base name
 * @returns String
 */
var createClassName = function createClassName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return selector ? name + ' ' + name + '-' + selector : name;
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextField = __webpack_require__(974);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextField2.default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumeric;
/**
 * Check if a value is numeric
 *
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is a numeric value
 */
function isNumeric(param) {
    if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'symbol') {
        return false;
    }

    return !isNaN(parseFloat(param)) && global.isFinite(param);
}
//# sourceMappingURL=isNumeric.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrgUnitTree = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _once = __webpack_require__(671);

var _once2 = _interopRequireDefault(_once);

var _OrgUnitTree = __webpack_require__(1172);

var _OrgUnitTree2 = _interopRequireDefault(_OrgUnitTree);

var _orgUnits = __webpack_require__(93);

var _layerEdit = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    container: {
        position: 'relative',
        marginTop: 12,
        width: '100%',
        height: 310,
        padding: 8,
        overflow: 'auto',
        boxSizing: 'border-box',
        border: '1px solid #ddd'
    },
    label: {
        cursor: 'pointer'
    },
    selectedLabel: {
        cursor: 'pointer'
    },
    disabled: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: 'rgba(255,255,255,0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 40,
        lineHeight: '30px',
        fontStyle: 'italic'
    }
};

var OrgUnitTree = exports.OrgUnitTree = function (_Component) {
    _inherits(OrgUnitTree, _Component);

    function OrgUnitTree(props, context) {
        _classCallCheck(this, OrgUnitTree);

        var _this = _possibleConstructorReturn(this, (OrgUnitTree.__proto__ || Object.getPrototypeOf(OrgUnitTree)).call(this, props, context));

        _this.selectDefault = (0, _once2.default)(function (node) {
            return props.onClick(node);
        }); // only select default node once
        return _this;
    }

    _createClass(OrgUnitTree, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                root = _props.root,
                loadOrgUnitTree = _props.loadOrgUnitTree;


            if (!root) {
                loadOrgUnitTree();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props2 = this.props,
                root = _props2.root,
                selectRootAsDefault = _props2.selectRootAsDefault;

            // Select org.unit root as default

            if (selectRootAsDefault && root) {
                this.selectDefault(root);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                root = _props3.root,
                selected = _props3.selected,
                disabled = _props3.disabled,
                onClick = _props3.onClick;


            if (!root) {
                // TODO: Add loading indicator
                return null;
            }

            return _react2.default.createElement(
                'div',
                { style: styles.container },
                _react2.default.createElement(_OrgUnitTree2.default, {
                    root: root,
                    selected: selected.filter(function (item) {
                        return item.path;
                    }).map(function (item) {
                        return item.path;
                    }) // TODO: Need to select all
                    , initiallyExpanded: [root.path],
                    hideCheckboxes: true,
                    hideMemberCount: true,
                    onSelectClick: function onSelectClick(evt, orgUnit) {
                        return !disabled ? onClick(orgUnit) : null;
                    },
                    labelStyle: styles.label,
                    selectedLabelStyle: styles.selectedLabel
                }),
                disabled ? _react2.default.createElement(
                    'div',
                    { style: styles.disabled },
                    'It\u2019s not possible to combine user organisation units and select individual units.'
                ) : null
            );
        }
    }]);

    return OrgUnitTree;
}(_react.Component);

OrgUnitTree.propTypes = {
    root: _propTypes2.default.object,
    selected: _propTypes2.default.array,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        root: state.orgUnitTree
    };
}, { loadOrgUnitTree: _orgUnits.loadOrgUnitTree, toggleOrganisationUnit: _layerEdit.toggleOrganisationUnit })(OrgUnitTree);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserOrgUnitsFirstLevel = __webpack_require__(1176);

var _UserOrgUnitsFirstLevel2 = _interopRequireDefault(_UserOrgUnitsFirstLevel);

var _UserOrgUnitsSecondLevel = __webpack_require__(1177);

var _UserOrgUnitsSecondLevel2 = _interopRequireDefault(_UserOrgUnitsSecondLevel);

var _UserOrgUnitsThirdLevel = __webpack_require__(1178);

var _UserOrgUnitsThirdLevel2 = _interopRequireDefault(_UserOrgUnitsThirdLevel);

__webpack_require__(1179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var styles = {
    title: {
        paddingTop: 12,
        color: 'rgba(0, 0, 0, 0.3)'
    },
    container: {
        display: 'flex'
    },
    level: {
        flex: '33%',
        // padding: '8px 8px 12px 8px',
        cursor: 'pointer',
        margin: 5,
        textAlign: 'center'
    },
    icon: {
        display: 'block',
        margin: '10px auto'
    }
};

var levels = [{
    id: 'USER_ORGUNIT',
    label: 'Main',
    Icon: _UserOrgUnitsFirstLevel2.default
}, {
    id: 'USER_ORGUNIT_CHILDREN',
    label: 'Below',
    Icon: _UserOrgUnitsSecondLevel2.default
}, {
    id: 'USER_ORGUNIT_GRANDCHILDREN',
    label: '2 x below',
    Icon: _UserOrgUnitsThirdLevel2.default
}];

var UserOrgUnitSelect = function UserOrgUnitSelect(_ref) {
    var selected = _ref.selected,
        onChange = _ref.onChange,
        style = _ref.style;
    return _react2.default.createElement(
        'div',
        { className: 'UserOrgUnits', style: style },
        _react2.default.createElement(
            'div',
            { style: styles.title },
            'User organisation units'
        ),
        _react2.default.createElement(
            'div',
            { style: styles.container },
            levels.map(function (level) {
                var isSelected = selected.indexOf(level.id) !== -1;

                return _react2.default.createElement(
                    'div',
                    {
                        key: level.id,
                        className: isSelected ? 'selected' : null,
                        style: _extends({}, styles.level, {
                            outline: isSelected ? '3px solid orange' : '1px solid #ddd'
                        }),
                        onClick: function onClick() {
                            return onChange(!isSelected ? [].concat(_toConsumableArray(selected), [level.id]) : selected.filter(function (id) {
                                return id !== level.id;
                            }));
                        }
                    },
                    _react2.default.createElement(level.Icon, { style: styles.icon }),
                    level.label
                );
            })
        )
    );
};

UserOrgUnitSelect.propTypes = {
    selected: _propTypes2.default.array,
    onChange: _propTypes2.default.func
};

exports.default = UserOrgUnitSelect;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModelBase = __webpack_require__(113);

var _ModelBase2 = _interopRequireDefault(_ModelBase);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelDefinition = __webpack_require__(171);

var _ModelDefinition2 = _interopRequireDefault(_ModelDefinition);

var _ModelDefinitions = __webpack_require__(172);

var _ModelDefinitions2 = _interopRequireDefault(_ModelDefinitions);

var _ModelValidation = __webpack_require__(169);

var _ModelValidation2 = _interopRequireDefault(_ModelValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ModelBase: _ModelBase2.default,
  Model: _Model2.default,
  ModelDefinition: _ModelDefinition2.default,
  ModelDefinitions: _ModelDefinitions2.default,
  ModelValidation: _ModelValidation2.default
}; /**
    * @module model
    *
    * @description
    *
    * This page will give you an introduction on one of the largest and more complex parts of d2, the metadata models.
    *
    * Models are an abstraction on top of the dhis2 metadata api. We can use these models to interact with the dhis2 api.
    * The models are accessible on the `.models` property that is attached to the d2 instance (that is retrieved by calling
    * `getInstance()`).
    *
    * A schema is a description of a type of metadata object. To find out which schemas are available for you to use with
    * d2 take a look at https://play.dhis2.org/demo/api/schemas.json?fields=name,metadata. Any schema that is marked as
    * `metadata: true` can be used with d2.
    *
    * There are a few concepts that you should familiarise yourself with before you start. (More documentation on the following
    * concepts can be found on the classes that represent them.)
    *
    * ### ModelDefinitions
    *
    * A {@link module:model.ModelDefinition} is where it all starts. In d2 the schemas you have loaded are represented by a `ModelDefinition`.
    * A `ModelDefinition` is essentially a wrapper around the schemas that allows you to create `Model` instances for that
    * specific schema (e.g. the dataElementModelDefinition allows you to create dataElement Models).
    * ```js
    * d2.models.dataElement // This is the dataElement ModelDefinition
    *  .create()            // Creates a Model object based of the dataElement ModelDefinition
    * ```
    *
    * When working with the d2 object the `d2.models` object contains modelDefinitions for the schemas that you have loaded.
    * (by default that is all schemas). To get a modelDefinition for a specific schema you ask for it by the name of the schema.
    * A few examples other than the dataElement one from above would be:
    *
    * ```js
    * d2.models.user
    * d2.models.legendSet
    * d2.models.organisationUnit
    * ```
    *
    * The ModelDefinition allows you to load objects from the api. You can either load individual items or items in bulk.
    *
    * We can use it to get specific objects
    * ```js
    * d2.models.organisationUnit.get('ImspTQPwCqd')
    *  .then(organisationUnitModel => console.log(organisationUnitModel));
    * ```
    *
    * or to load a list of objects (by default paging is enabled and it will only load the first 50 entries).
    * ```js
    * d2.models.organisationUnit.list()
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    *
    * The ModelDefinition also allows you to filter on properties using a programatic syntax. To find out which
    * filter methods are available you can a look at the {@link module:model.Filter|Filter} class.
    * ```js
    * d2.models.organisationUnit
    *  .filter().on('level').equals(2)
    *  .list()
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    * Applying a filter like this will create a clone of the modelDefinition with the filter applied, so you can
    * store the reference to the cloned modelDefinition and use it later, without globally applying the filter everywhere.
    *
    * ```js
    * const organisationUnitsOnLevel3 = d2.models.organisationUnit
    *  .filter().on('level').equals(3);
    *
    * const organisationUnitsOnLevel3WithParent = organisationUnitsOnLevel3
    *  .filter().on('parent.id').equals('O6uvpzGd5pu);
    *
    * organisationUnitsOnLevel3
    *  .list({ paging: false }) // Loads all organisation units on level 3
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    *
    * organisationUnitsOnLevel3WithParent
    *  .list({ paging: false }) // Loads all organisation units on level 3 with O6uvpzGd5pu as their parent
   *   .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    *
    * As you might have noticed we passed `{ paging: false }` to the `.list` method. Any options passed to the list method
    * (with the exception of filter) will be passed through as regular query parameters.
    *
    * If you ran the above examples you would notice that the `.list` method returns a ModelCollection.
    *
    * ## ModelCollection
    * A {@link module:model.ModelCollection|ModelCollection} is simple a collection of Model objects. The ModelCollection is
    * sometimes somewhat cumbersome to work with and often you would like to transform the ModelCollection to an array using
    * the `.toArray()` method or spreading the values of the ModelCollection.
    *
    * ```js
    * d2.models.organisationUnit
    *  .filter().on('level').equals(2)
    *  .list()
    *  .then(organisationUnitCollection => {
    *    let organisationUnits = organisationUnitCollection.toArray();
    *    // or
    *    organisationUnits = [...organisationUnitCollection.values()];
    * });
    * ```
    *
    * The ModelCollection does not only contain the Models, it also gives you access to a {@link module:model.Pager|Pager}.
    * The pager objects keeps track of which page was loaded and how many pages there are.
    *
    * The following example will load the first page of organisation units and then keep loading a new page every second
    * until we run out of pages.
    * ```js
    * function loadNextPage(pager, callback) {
    *   if (pager.hasNextPage()) {
    *     pager.getNextPage()
    *       .then(organisationUnitCollection  => {
    *         setTimeout(() => {
    *           callback(organisationUnitCollection);
    *           loadNextPage(organisationUnitCollection.pager, callback);
    *         }, 1000);
    *       });
    *   }
    * }
    *
    * const printCollection = collection => console.log(collection.toArray());
    *
    * d2.models.organisationUnit
    *   .list()
    *   .then(organisationUnitCollection => {
    *     printCollection(organisationUnitCollection);
    *     loadNextPage(organisationUnitCollection.pager, printCollection);
    *   });
    * ```
    *
    * ## Model
    * TODO: :(
    */
//# sourceMappingURL=index.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Handles communication with the systemSettings endpoint. Can be used to get or save systemSettings.
 *
 * @memberof module:system
 * @requires lib/check
 * @requires api/Api
 */
// TODO: Return the values from the local cache if we have not updated it? We could
var SystemSettings = function () {
    function SystemSettings() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, SystemSettings);

        this.api = api;
    }

    /**
     * Loads all the system settings in the system and returns them as an object from the promise.
     *
     * @returns {Promise} Promise that resolves with the systemsettings object from the api.
     *
     * @example
     * d2.system.settings.all()
     *  .then(systemSettings => {
     *    console.log('Analytics was last updated on: ' + systemSettings.keyLastSuccessfulResourceTablesUpdate);
     *  });
     */


    _createClass(SystemSettings, [{
        key: 'all',
        value: function all() {
            var _this = this;

            return this.settings ? Promise.resolve(this.settings) : this.api.get('systemSettings').then(function (settings) {
                _this.settings = settings;
                return Promise.resolve(_this.settings);
            });
        }

        /**
         * Get a single systemSetting for the given key.
         *
         * This will use the cached value of the key if it has been previously loaded.
         *
         * @param {String} systemSettingsKey The identifier of the system setting that should be retrieved.
         * @returns {Promise} A promise that resolves with the value or will fail if the value is not available.
         *
         * @example
         * d2.system.settings.get('keyLastSuccessfulResourceTablesUpdate')
         *  .then(systemSettingsValue => {
         *    console.log('Analytics was last updated on: ' + systemSettingsValue);
         *  });
         */

    }, {
        key: 'get',
        value: function get(systemSettingsKey) {
            var _this2 = this;

            if (this.settings && this.settings[systemSettingsKey]) {
                return Promise.resolve(this.settings[systemSettingsKey]);
            }

            function processValue(value) {
                // Attempt to parse the response as JSON. If this fails we return the value as is.
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                if (!(0, _check.isString)(systemSettingsKey)) {
                    throw new TypeError('A "key" parameter should be specified when calling get() on systemSettings');
                }

                var options = { headers: { accept: 'text/plain' } };
                _this2.api.get(['systemSettings', systemSettingsKey].join('/'), undefined, options).then(function (response) {
                    if (response) {
                        resolve(processValue(response));
                    }
                    reject(new Error('The requested systemSetting has no value or does not exist.'));
                });
            });
        }
    }, {
        key: 'set',
        value: function set(systemSettingsKey, value) {
            delete this.settings;

            var settingUrl = ['systemSettings', systemSettingsKey].join('/');
            if (value === null || ('' + value).length === 0) {
                return this.api.delete(settingUrl);
            }
            return this.api.post(settingUrl, value, { headers: { 'Content-Type': 'text/plain' } });
        }
    }]);

    return SystemSettings;
}();

exports.default = SystemSettings;
//# sourceMappingURL=SystemSettings.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles communication with the configuration endpoint. Can be used to get or set configuration options.
 *
 * @memberof module:system
 */
var SystemConfiguration = function () {
    function SystemConfiguration() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, SystemConfiguration);

        this.api = api;

        this.configuration = undefined;
        this.configPromise = null;
    }

    /**
     * Fetches all system configuration settings from the API and caches them so that future
     * calls to this function won't call the API again.
     *
     * @param {boolean} [ignoreCache=false] If set to true, calls the API regardless of cache status
     * @returns {Promise} Promise that resolves with all the individual configuration options from the api.
     */


    _createClass(SystemConfiguration, [{
        key: 'all',
        value: function all(ignoreCache) {
            var _this = this;

            if (this.configPromise === null || ignoreCache === true) {
                this.configPromise = this.api.get('configuration').then(function (configuration) {
                    _this.configuration = configuration;
                    return _this.configuration;
                });
            }

            return this.configPromise;
        }

        /**
         * Returns the value of the specified configuration option.
         *
         * This is a convenience method that works exactly the same as calling `configuration.all()[name]`.
         *
         * @param key {String}
         * @param {boolean} [ignoreCache=false] If set to true, calls the API regardless of cache status
         * @returns {Promise}
         */

    }, {
        key: 'get',
        value: function get(key, ignoreCache) {
            return this.all(ignoreCache).then(function (config) {
                if (config.hasOwnProperty(key)) {
                    return Promise.resolve(config[key]);
                }

                return Promise.reject('Unknown config option: ' + key);
            });
        }

        /**
         * Send a query to the API to change the value of a configuration key to the specified value.
         *
         * @param key {String}
         * @param value {String|null}
         * @returns {Promise}
         */
        /* eslint-disable complexity */

    }, {
        key: 'set',
        value: function set(key, value) {
            var that = this;
            var req = void 0;

            if (key === 'systemId') {
                return Promise.reject('The system ID can\'t be changed');
            } else if ((key === 'feedbackRecipients' || key === 'selfRegistrationOrgUnit' || key === 'selfRegistrationRole') && (value === 'null' || value === null)) {
                // Only valid UIDs are accepted when POST'ing, so we have to use DELETE in stead of POST'ing a null value.
                req = this.api.delete(['configuration', key].join('/'));
            } else if (key === 'corsWhitelist') {
                // The corsWhitelist endpoint expects a JSON array (of URLs), while here value is expected to be a string.
                req = this.api.post(['configuration', key].join('/'), value.trim().split('\n'));
            } else {
                req = this.api.post(['configuration', key].join('/'), value, {
                    dataType: 'text',
                    contentType: 'text/plain'
                });
            }

            return req.then(function () {
                // Ideally we'd update the cache here, but doing so requires another trip to the server
                // For now, just bust the cache to ensure it's not incorrect
                that.configuration = undefined;
                return Promise.resolve();
            }).catch(function () {
                return Promise.reject('No configuration found for ' + key);
            });
        }
        /* eslint-enable complexity */

    }]);

    return SystemConfiguration;
}();

exports.default = SystemConfiguration;
//# sourceMappingURL=SystemConfiguration.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickOwnerFromModelValidation = exports.pickEmbeddedObjectFromModelValidation = exports.pickTypeFromModelValidation = undefined;
exports.hasModelValidationForProperty = hasModelValidationForProperty;
exports.updateModelFromResponseStatus = updateModelFromResponseStatus;

var _uid = __webpack_require__(50);

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var hasPropertyOnModelValidation = function hasPropertyOnModelValidation(property, model) {
    return Boolean((0, _utils.pick)('modelDefinition.modelValidations.' + property)(model));
};

function hasModelValidationForProperty(model, property) {
    return Boolean(hasPropertyOnModelValidation(property, model) && (0, _check.hasOwnProperty)(model.modelDefinition.modelValidations, property));
}

var pickHttpStatus = (0, _utils.pick)('httpStatus');
var pickResponseUid = (0, _utils.pick)('response.uid');
var getModelValidationForProperty = function getModelValidationForProperty(propertyName) {
    return (0, _utils.pick)('modelDefinition.modelValidations.' + propertyName);
};
var pickType = (0, _utils.pick)('type');
var pickEmbeddedObject = (0, _utils.pick)('embeddedObject');
var pickOwner = (0, _utils.pick)('owner');

var pickTypeFromModelValidation = exports.pickTypeFromModelValidation = function pickTypeFromModelValidation(property, model) {
    return pickType(getModelValidationForProperty(property)(model));
};
var pickEmbeddedObjectFromModelValidation = exports.pickEmbeddedObjectFromModelValidation = function pickEmbeddedObjectFromModelValidation(property, model) {
    return pickEmbeddedObject(getModelValidationForProperty(property)(model));
};

var pickOwnerFromModelValidation = exports.pickOwnerFromModelValidation = function pickOwnerFromModelValidation(property, model) {
    return pickOwner(getModelValidationForProperty(property)(model));
};

// This function is called with `.call` with the Model as it's `this`
function updateModelFromResponseStatus(result) {
    var responseUid = pickResponseUid(result);

    // Set the id and href of the newly created object if we got an id in the response
    if (pickHttpStatus(result) === 'Created' && (0, _uid.isValidUid)(responseUid)) {
        this.dataValues.id = responseUid;
        this.dataValues.href = [this.modelDefinition.apiEndpoint, this.dataValues.id].join('/');
    }

    // Object is saved to the api, so it's now clean
    this.resetDirtyState();

    return result;
}
//# sourceMappingURL=models.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var getValue = (0, _utils.pick)('value');
var getAttributeValueAttributeName = (0, _utils.pick)('attribute.name');

function createPropertyDefinitionsForAttributes(attributeProperties, getAttributeValues, setAttributeValues, setDirty) {
    return Object.keys(attributeProperties).reduce(function (propertyDefinitions, attributeName) {
        propertyDefinitions[attributeName] = { // eslint-disable-line no-param-reassign
            enumerable: true,
            get: function get() {
                var attributeValues = getAttributeValues();

                return attributeValues.filter(function (attributeValue) {
                    return getAttributeValueAttributeName(attributeValue) === attributeName;
                }).reduce(function (current, attributeValue) {
                    return attributeValue.value;
                }, undefined);
            },
            set: function set(value) {
                var attributeValue = getAttributeValues().filter(function (av) {
                    return av.attribute.name === attributeName;
                }).reduce(function (current, av) {
                    return av;
                }, undefined);

                if ((0, _check.areDefinedAndEqual)(getValue(attributeValue), value)) {
                    return; // Don't do anything if the value stayed the same
                }

                if (attributeValue) {
                    // Remove the attributeValue from the array of attributeValues on the object
                    // This is done because the server can not handle them properly when empty strings
                    // as values are sent. It will properly remove the attributeValue
                    // on the server side when they are not being send to the server at all.
                    if ((0, _check.isNullUndefinedOrEmptyString)(value)) {
                        var remainingAttributeValues = getAttributeValues().filter(function (av) {
                            return av !== attributeValue;
                        });
                        setAttributeValues(remainingAttributeValues);
                    }

                    attributeValue.value = value;
                } else {
                    // Add the new attribute value to the attributeValues collection
                    setAttributeValues(getAttributeValues().concat({
                        value: value,
                        attribute: {
                            id: attributeProperties[attributeName].id,
                            name: attributeProperties[attributeName].name
                        }
                    }));
                }

                // Set the model to be dirty
                setDirty();
            }
        };

        return propertyDefinitions;
    }, {});
}

exports.default = createPropertyDefinitionsForAttributes;
//# sourceMappingURL=attibutes.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Pager object that can be used to navigate pages within a `Modelcollection`
 *
 * @memberof module:model
 */

/**
  * @memberof module:model
  */
// TODO: Move to the model map
var Pager = function () {
  /**
   * @constructor
   *
   * @param {Object} [pager={page: 1, pageCount: 1}] Paging information object.
   * @param {Object} [pagingHandler={list: () => Promise.reject('No handler available')}] Paging handler object. The requirement for this object is that it has a list method.
   *
   * @description
   * Returns a newly created pager object with methods to navigate pages.
   */
  function Pager() {
    var pager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: 1, pageCount: 1, query: {} };
    var pagingHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { list: function list() {
        return Promise.reject('No handler available');
      } };

    _classCallCheck(this, Pager);

    /**
     * @property {number} page Current page number
     */
    this.page = pager.page;

    /**
     * @property {number} pageCount The total number of pages available
     */
    this.pageCount = pager.pageCount;

    /**
     * @property {number} total The total number of items available.
     *
     * @description
     * This represents the total number of items available in the system. Note it is not the number of items
     * on the current page.
     */
    this.total = pager.total;

    /**
     * @property {string} nextPage The url to the next page.
     *
     * @description
     * If there is no next page then this will be undefined.
     */
    this.nextPage = pager.nextPage;

    /**
     * @property {string} prevPage The url to the previous page
     *
     * @description
     * If there is no previous page then this will be undefined.
     */
    this.prevPage = pager.prevPage;

    /**
     * @property {object} query Query parameters
     *
     * @description
     * Query parameters are used for things like filtering and field selection. Used to guarantee that pages are
     * from the same collection.
     */
    this.query = pager.query;

    this.pagingHandler = pagingHandler;
  }

  /**
   * @returns {Boolean} Result is true when there is a next page, false when there is not.
   *
   * @description
   * Check whether there is a next page.
   */


  _createClass(Pager, [{
    key: 'hasNextPage',
    value: function hasNextPage() {
      return (0, _check.isDefined)(this.nextPage);
    }

    /**
     * Check whether there is a previous page.
     *
     * @returns {Boolean} Result is true when there is a previous page, false when there is not.
     */

  }, {
    key: 'hasPreviousPage',
    value: function hasPreviousPage() {
      return (0, _check.isDefined)(this.prevPage);
    }

    /**
     * @description
     * Loads the next page in the collection if there is one. If no additional pages are available the Promise will reject.
     *
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the next page's data. Or rejects with
     * a string when there is no next page for this collection or when the request for the next page failed.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.getNextPage()
     *       .then(secondPageCollection => {
     *         console.log(secondPageCollection.toArray());
     *       });
     *   });
     */

  }, {
    key: 'getNextPage',
    value: function getNextPage() {
      if (this.hasNextPage()) {
        return this.goToPage(this.page + 1);
      }
      return Promise.reject('There is no next page for this collection');
    }

    /**
     * @description
     * Loads the previous page in the collection if there is one. If no previous pages are available the Promise will reject.
     *
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the previous page's data. Or rejects with
     * a string when there is no previous page for this collection or when the request for the previous page failed.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.goToPage(3)
     *       .then(collection => collection.pager.getPreviousPage())
     *       .then(secondPageCollection => {
     *         console.log(secondPageCollection.toArray());
     *       });
     *   });
     */

  }, {
    key: 'getPreviousPage',
    value: function getPreviousPage() {
      if (this.hasPreviousPage()) {
        return this.goToPage(this.page - 1);
      }
      return Promise.reject('There is no previous page for this collection');
    }

    /**
     * Loads a specific page for the collection. If the requested page is out of the range of available pages (e.g < 0 or > page count)
     * the Promise will reject with an error.
     *
     * @param {Number} pageNr The number of the page you wish to navigate to.
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the data for the requested page.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.goToPage(4)
     *       .then(fourthPageCollection => {
     *         console.log(fourthPageCollection.toArray());
     *       });
     *   });
     */
    // TODO: Throwing the errors here is not really consistent with the rejection of promises for the getNextPage and getPreviousPage

  }, {
    key: 'goToPage',
    value: function goToPage(pageNr) {
      if (pageNr < 1) {
        throw new Error('PageNr can not be less than 1');
      }
      if (pageNr > this.pageCount) {
        throw new Error('PageNr can not be larger than the total page count of ' + this.pageCount);
      }

      return this.pagingHandler.list(Object.assign({}, this.query, { page: pageNr }));
    }
  }]);

  return Pager;
}();

exports.default = Pager;
//# sourceMappingURL=Pager.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _ModelCollection2 = __webpack_require__(149);

var _ModelCollection3 = _interopRequireDefault(_ModelCollection2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A ModelCollectionProperty instance is a ModelCollection that is a property of
 * a model instance. ModelCollectionProperties can be operated on independently of
 * the Model that owns them.
 *
 * @memberof module:model
 */
var ModelCollectionProperty = function (_ModelCollection) {
    _inherits(ModelCollectionProperty, _ModelCollection);

    /**
     * @constructor
     *
     * @param {Model} parentModel The `Model` of the parent of this `ModelCollectionProperty`
     * @param {ModelDefinition} modelDefinition The `ModelDefinition` that this `ModelCollection` property is for
     * @param {String} propName The name of this property on the parent model
     * @param {Model[]|boolean} values Initial values that should be added to the collection property
     * @param {Api} api The class to use for API calls
     *
     * @description
     *
     * Creates a new `ModelCollectionProperty` object. This is a subclass of `ModelCollection`, which adds logic
     * for adding and removing elements to the collection and saving the changes to the API.
     *
     * If the value is `true` or `undefined` is specified instead of an array of data values, this indicates that the
     * collection contains (or may contain) data that has not yet been loaded from the API.
     */
    function ModelCollectionProperty(parentModel, modelDefinition, propName, values, api) {
        _classCallCheck(this, ModelCollectionProperty);

        // The name of this property on the parent object - necessary for loading values lazily
        var _this = _possibleConstructorReturn(this, (ModelCollectionProperty.__proto__ || Object.getPrototypeOf(ModelCollectionProperty)).call(this, modelDefinition, values, undefined));

        _this.propName = propName;

        // Dirty bit - true if any models have been added to or removed from the collection
        _this.dirty = false;

        // Keep track of added and removed elements
        _this.added = new Set();
        _this.removed = new Set();

        // Using field transformers, it's possible to query the API for the presence of data without actually fetching
        // the data. For instance this is used to determine if an organization unit has any children without actually
        // loading the children. If yes, it will be displayed as an expandable branch within the tree.
        // For more information, see the documentation about field transformers, specifically the isNotEmpty operator:
        // https://docs.dhis2.org/master/en/developer/html/dhis2_developer_manual_full.html#webapi_field_transformers
        _this.hasUnloadedData = values === true || values === undefined;

        _this.api = api;

        // Store the parent model of this collection so we can construct the URI for API calls
        _this.parentModel = parentModel;
        return _this;
    }

    /**
     * @param {Model} value Model instance to add to the collection.
     * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
     *
     * @description
     * Calls the `add` method on the parent `ModelCollection` class, and then performs checks to keep track of
     * what, if any, changes that have been made to the collection.
     */


    _createClass(ModelCollectionProperty, [{
        key: 'add',
        value: function add(value) {
            if (this.valuesContainerMap.has(value.id)) {
                return this;
            }

            _get(ModelCollectionProperty.prototype.__proto__ || Object.getPrototypeOf(ModelCollectionProperty.prototype), 'add', this).call(this, value);

            if (this.removed.has(value.id)) {
                this.removed.delete(value.id);
            } else {
                this.added.add(value.id);
            }

            this.updateDirty();
            return this;
        }

        /**
         * If the collection contains an object with the same id as the `value` parameter, that object is removed
         * from the collection. Checks are then performed to keep track of what, if any, changes that have been
         * made to the collection.
         *
         * @param {Model} value Model instance to remove from the collection.
         * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
         */

    }, {
        key: 'remove',
        value: function remove(value) {
            _ModelCollection3.default.throwIfContainsOtherThanModelObjects([value]);
            _ModelCollection3.default.throwIfContainsModelWithoutUid([value]);

            if (this.delete(value.id)) {
                if (this.added.has(value.id)) {
                    this.added.delete(value.id);
                } else {
                    this.removed.add(value.id);
                }
            }

            this.updateDirty();
            return this;
        }

        /**
         * Checks whether any changes have been made to the collection, and updates the dirty flag accordingly.
         *
         * @returns {boolean} True if the collection has changed, false otherwise.
         */

    }, {
        key: 'updateDirty',
        value: function updateDirty() {
            this.dirty = this.added.size > 0 || this.removed.size > 0;
            return this.dirty;
        }

        /**
         * Sets dirty=false and resets the added and removed sets used for dirty state tracking.
         */

    }, {
        key: 'resetDirtyState',
        value: function resetDirtyState() {
            this.dirty = false;
            this.added = new Set();
            this.removed = new Set();
        }

        /**
         * Checks if the collection property has been modified.
         * @param {boolean} [includeValues=true] If true, also checks if any models in the collection
         * has been edited by checking the dirty flag on each model.
         * @returns {boolean} true if any elements have been added to or removed from the collection
         */

    }, {
        key: 'isDirty',
        value: function isDirty() {
            var includeValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (includeValues) {
                return this.dirty || this.toArray().filter(function (model) {
                    return model && model.isDirty() === true;
                }).length > 0;
            }
            return this.dirty;
        }

        /**
         * If any changes have been made to the collection, these changes will be submitted to the API. The returned
         * promise will resolve successfully when the changes have been saved to the API, and will be rejected if
         * either the changes weren't saved or if there were no changes to save.
         *
         * @returns {Promise} A `Promise`
         */

    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            // Calling save when there's nothing to be saved is a no-op (not an error)
            if (!this.isDirty()) {
                return Promise.resolve({});
            }

            var url = [this.parentModel.href, this.modelDefinition.plural].join('/');
            var data = {
                additions: Array.from(this.added).map(function (id) {
                    return { id: id };
                }),
                deletions: Array.from(this.removed).map(function (id) {
                    return { id: id };
                })
            };

            return this.api.post(url, data).then(function () {
                _this2.resetDirtyState();
                return Promise.resolve({});
            }).catch(function (err) {
                return Promise.reject('Failed to alter collection:', err);
            });
        }
    }, {
        key: 'load',
        value: function load(options) {
            var _this3 = this;

            var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.hasUnloadedData && !forceReload) {
                return Promise.resolve(this);
            }

            var url = [this.parentModel.modelDefinition.apiEndpoint, this.parentModel.id].join('/');
            var requestOptions = Object.assign({
                paging: false
            }, options, { fields: this.propName + '[' + (options && options.fields || ':all') + ']' });

            return this.api.get(url, requestOptions).then(function (data) {
                return data[_this3.propName];
            }).then(function (values) {
                if (Array.isArray(values)) {
                    values.forEach(function (value) {
                        return _this3.valuesContainerMap.set(value.id, _this3.modelDefinition.create(value));
                    });
                }
                _this3.hasUnloadedData = false;
                return Promise.resolve(_this3);
            });
        }

        /**
         * See `ModelCollectionProperty.constructor`.
         *
         * @param {Model} parentModel
         * @param {ModelDefinition} modelDefinition
         * @param {Model[]} values
         * @returns {ModelCollectionProperty}
         */

    }], [{
        key: 'create',
        value: function create(parentModel, modelDefinition, propName, values) {
            return new ModelCollectionProperty(parentModel, modelDefinition, propName, values, _Api2.default.getApi());
        }
    }]);

    return ModelCollectionProperty;
}(_ModelCollection3.default);

exports.default = ModelCollectionProperty;
//# sourceMappingURL=ModelCollectionProperty.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(29);

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchemaTypes = function () {
    function SchemaTypes() {
        _classCallCheck(this, SchemaTypes);
    }

    _createClass(SchemaTypes, [{
        key: 'getTypes',
        value: function getTypes() {
            // eslint-disable-line class-methods-use-this
            return ['TEXT', 'NUMBER', 'INTEGER', 'BOOLEAN', 'EMAIL', 'PASSWORD', 'URL', 'PHONENUMBER', 'GEOLOCATION', // TODO: Geo location could be an advanced type of 2 numbers / strings?
            'COLOR', 'COMPLEX', 'COLLECTION', 'REFERENCE', 'DATE', 'COMPLEX', 'IDENTIFIER', 'CONSTANT'];
        }
    }, {
        key: 'typeLookup',
        value: function typeLookup(propertyType) {
            if (this.getTypes().indexOf(propertyType) >= 0 && (0, _check.isString)(propertyType)) {
                return propertyType;
            }

            return (0, _utils.throwError)(['Type from schema "', propertyType, '" not found available type list.'].join(''));
        }
    }]);

    return SchemaTypes;
}();

exports.default = new SchemaTypes();
//# sourceMappingURL=SchemaTypes.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _Filter = __webpack_require__(287);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Collection class that contains filters that are to be applied when loading Model objects from the api.
 *
 * @memberof module:model
 */
var Filters = function () {
  /**
   * Creates a new Filters instance.
   *
   * The Filters instance keeps a list of all the applied filters for a modelDefinition.
   *
   * @param {ModelDefinition} modelDefinition The ModelDefinition for which this Filters object should create filters.
   * @param {Filter[]} filters A list of Filter objects
   */
  function Filters(modelDefinition) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Filters);

    /**
     * @type {Array<Filter>}
     * @private
     */
    this.filters = filters;
    this.modelDefinition = modelDefinition;
  }

  /**
   * Shortcut for triggering the creation of a Filter. This is the function that is triggered when creating new
   * filters on a ModelDefinition. The Filter will receive a callback that can be used to add the finalized filter
   * to the list of filters.
   *
   * @param {string} propertyName The property that the filter should apply to. (e.g. `name`)
   * @returns {Filter} The created filter object for `propertyName`.
   */


  _createClass(Filters, [{
    key: 'on',
    value: function on(propertyName) {
      var addFilter = this.add.bind(this);

      return _Filter2.default.getFilter(addFilter).on(propertyName);
    }

    /**
     * Utility method to add a filter to the list of filters.
     *
     * @private
     * @param {Filter} filter The Filter to be added to the list of current filters.
     * @returns {ModelDefinition} The modelDefiniton that the filter applies to. This is used to support calling `.list()`
     * on the modelDefinition after the filter was created.
     * @throws {TypeError} Thrown when the given filter is not a Filter object.
     */

  }, {
    key: 'add',
    value: function add(filter) {
      if (!(0, _check.isType)(filter, _Filter2.default)) {
        throw new TypeError('filter should be an instance of Filter');
      }
      this.filters.push(filter);

      return this.modelDefinition;
    }

    /**
     * @deprecated
     * @returns {Promise} Proxy the list() call on the filters object.
     */

  }, {
    key: 'list',
    value: function list() {
      return this.modelDefinition.list();
    }

    /**
     * Get an array of DHIS2 metadata filter values to send to the API.
     *
     * This will return ['id:eq:UYXOT4A7JMI', 'name:like:ANC'] for filters created as follows
     * dataElement
     *  .filter().on('id').equals(UYXOT4A7JMI)
     *  .filter().on('name').like('ANC')
     *
     * @returns {Array<string>} A list of query param values to be used with the filter key.
     */

  }, {
    key: 'getQueryFilterValues',
    value: function getQueryFilterValues() {
      return this.filters.map(function (filter) {
        return filter.getQueryParamFormat();
      });
    }

    /**
     * @deprecated Deprecated since 2.28, use getQueryFilterValues instead.
     * @returns {Array.<string>}
     */

  }, {
    key: 'getFilters',
    value: function getFilters() {
      return this.getQueryFilterValues();
    }

    /**
     * Get a list of Filter objects that are in applied in this Filters instance
     *
     * @returns {Array<Filter>} The list of Filter objects.
     */

  }, {
    key: 'getFilterList',
    value: function getFilterList() {
      return this.filters.map(_utils.identity);
    }

    /**
     * Factory method to create a Filters object.
     *
     * @param {ModelDefinition} modelDefinition The modelDefinition that the filters should apply to.
     * @param {Filter[]} priorFilters List of previously applied filters that the new filter list should start with.
     * @returns {Filters} A Filters object for the given modelDefinition.
     */

  }], [{
    key: 'getFilters',
    value: function getFilters(modelDefinition) {
      var priorFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return new Filters(modelDefinition, priorFilters);
    }
  }]);

  return Filters;
}();

exports.default = Filters;
//# sourceMappingURL=Filters.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FILTER_COMPARATORS = {
  /**
   * @function equals
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a equals filter value
   */
  equals: 'eq',
  /**
   * @function like
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a like filter value
   */
  like: 'like',
  /**
   * @function ilike
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a ilike filter value
   */
  ilike: 'ilike',
  /**
   * @function
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a ne filter value
   */
  notEqual: 'ne'
};

/**
 * Filter class that can be used to build api endpoint filters using a semi-natural language style.
 *
 * @memberof module:model
 */

var Filter = function () {
  /**
   * @constructor
   * @param {Function} addFilterCallback Callback that will be used to notify Filters that the filter is completed
   * so it can be added to the list of filters.
   */
  function Filter(addFilterCallback) {
    _classCallCheck(this, Filter);

    this.addFilterCallback = addFilterCallback;
    this.propertyName = 'name';
    this.comparator = 'like';
    this.filterValue = undefined;
  }

  /**
   * @param {String} propertyName Property name that the filter should be applied on.
   * @returns {Filter}
   */


  _createClass(Filter, [{
    key: 'on',
    value: function on(propertyName) {
      (0, _check.checkDefined)(propertyName, 'Property name to filter on');

      this.propertyName = propertyName;
      return this;
    }

    /**
     * Utility function used to get the query parameter value in a DHIS2 metadata filter format that can be
     * send to the api. This returned value is appended to the `filter=` part of the query.
     *
     * @private
     * @note {warning} Usually not used directly and only used by Filters to create the query param values.
     *
     * @returns {string} The query param value to be appended to `filter=`
     */

  }, {
    key: 'getQueryParamFormat',
    value: function getQueryParamFormat() {
      return [this.propertyName, this.comparator, this.filterValue].join(':');
    }

    /**
     * @static
     *
     * @param {Function} addFilterCallback Callback to be called when the filter is completed.
     *
     * @returns {Filter} A instance of the Filter class that can be used to create
     * filters.
     *
     * @description
     * Create a filter instance
     */

  }], [{
    key: 'getFilter',
    value: function getFilter(addFilterCallback) {
      return new Filter(addFilterCallback);
    }
  }]);

  return Filter;
}();

// Add the filters to the Filter prototype


Object.keys(FILTER_COMPARATORS).forEach(function (filter) {
  Object.defineProperty(Filter.prototype, filter, {
    value: function filterGetter(filterValue) {
      (0, _check.checkDefined)(filterValue, 'filterValue');

      this.comparator = FILTER_COMPARATORS[filter];
      this.filterValue = filterValue;

      return this.addFilterCallback(this);
    }
  });
});

exports.default = Filter;
//# sourceMappingURL=Filter.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=organisationUnitGroupSet.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=category.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=categoryOptionGroupSet.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    aggregationType: 'SUM',
    valueType: 'NUMBER'
};
//# sourceMappingURL=dataElement.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=dataElementGroupSet.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    expiryDays: 0,
    openFuturePeriods: 0,
    timelyDays: 15,
    periodType: 'Monthly'
};
//# sourceMappingURL=dataSet.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    mapService: 'WMS',
    imageFormat: 'PNG',
    mapLayerPosition: 'BASEMAP'
};
//# sourceMappingURL=externalMapLayer.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationRecipient: 'ORGANISATION_UNIT_CONTACT',
    deliveryChannels: [],
    notifyUsersInHierarchyOnly: false
};
//# sourceMappingURL=validationNotificationTemplate.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    importance: 'MEDIUM',
    periodType: 'Monthly',
    operator: 'not_equal_to',
    leftSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    },
    rightSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    }
};
//# sourceMappingURL=validationRule.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    version: 0,
    completeEventsExpiryDays: 0,
    expiryDays: 0
};
//# sourceMappingURL=program.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationTrigger: 'COMPLETION',
    notificationRecipient: 'USERS_AT_ORGANISATION_UNIT'
};
//# sourceMappingURL=programNotificationTemplate.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module i18n
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * I18n class for dealing with translations
 */
var I18n = function () {
    function I18n() {
        var sources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default.getApi();

        _classCallCheck(this, I18n);

        this.sources = sources;
        this.api = api;
        this.strings = new Set();
        this.translations = undefined;
    }

    /**
     * Adds a .properties file to the list of sources to load translations from
     *
     * Files are loaded in the order they're added, and the first translation of each string that's encountered will be
     * used.
     *
     * @param {String} path
     */


    _createClass(I18n, [{
        key: 'addSource',
        value: function addSource(path) {
            this.sources.push(path);
        }

        /**
         * Adds one or more strings to the list of strings to translate
         *
         * @param {(String[]|String)} strings
         */

    }, {
        key: 'addStrings',
        value: function addStrings(strings) {
            var _this = this;

            if (typeof strings === 'string' && strings.trim().length > 0) {
                this.strings.add(strings.trim());
            } else {
                Array.from(strings).filter(function (string) {
                    return string && ('' + string).trim().length > 0;
                }).forEach(function (string) {
                    return _this.strings.add(string);
                });
            }
        }

        /**
         * Load translations
         *
         * First, all properties files (specified with addSource) are loaded.
         * Then, if any untranslated strings remain, these are POSTed to the i18n endpoint of the DHIS2 API.
         *
         * @returns {Promise}
         */

    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            var i18n = this;
            i18n.translations = {};

            function parseProperties(text) {
                return text.split('\n').reduce(function (props, line) {
                    var _line$split$map = line.split('=').map(function (out) {
                        return out.trim();
                    }),
                        _line$split$map2 = _slicedToArray(_line$split$map, 2),
                        key = _line$split$map2[0],
                        value = _line$split$map2[1];

                    if (key !== undefined && value !== undefined && !props.hasOwnProperty(key)) {
                        props[key] = value // eslint-disable-line no-param-reassign
                        .replace(/\\u([0-9a-f]{4})/gi, function (match, grp) {
                            return String.fromCharCode(parseInt(grp, 16));
                        });
                    }
                    return props;
                }, {});
            }

            var propFiles = [];

            this.sources.forEach(function (source) {
                propFiles.push(i18n.api.request('GET', source).then(function (data) {
                    return Promise.resolve(parseProperties(data));
                },

                // Resolve errors to an empty object, so that one missing file doesn't prevent
                // the rest from being loaded
                function () {
                    return Promise.resolve({});
                }));
            });

            return Promise.all(propFiles).then(function (propFile) {
                propFile.forEach(function (props) {
                    Object.keys(props).forEach(function (str) {
                        if (!i18n.translations.hasOwnProperty(str)) {
                            i18n.translations[str] = props[str];
                        }
                        _this2.strings.delete(str);
                    });
                });

                if (_this2.strings.size > 0) {
                    return i18n.api.post('i18n', Array.from(i18n.strings)).then(function (res) {
                        Object.keys(res).filter(function (str) {
                            return str !== res[str];
                        }).forEach(function (str) {
                            i18n.translations[str] = res[str];
                            i18n.strings.delete(str);
                        });

                        return Promise.resolve(i18n.translations);
                    });
                }

                return Promise.resolve(i18n.translations);
            });
        }

        /**
         * Gets the translated version of the specified string
         *
         * If no translation exists for the specified string, the string is returned as is with two asterisks on each side,
         * in order to easily identify missing translations in the UI
         *
         * @param string
         * @returns {String}
         */

    }, {
        key: 'getTranslation',
        value: function getTranslation(string) {
            var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.translations === undefined) {
                throw new Error('Tried to translate before loading translations!');
            }
            var translatedString = this.translations.hasOwnProperty(string) ? this.translations[string] : '** ' + string + ' **';

            if (Object.keys(variables).length) {
                return translatedString.replace(/\$\$(.+?)\$\$/gi, function (match, partial) {
                    return variables[partial] || '';
                });
            }

            return translatedString;
        }

        /**
         * Check if a translation exists for the specified string
         *
         * @param string
         * @returns {boolean} True if a translation exists, false otherwise
         */

    }, {
        key: 'isTranslated',
        value: function isTranslated(string) {
            if (this.translations === undefined) {
                throw new Error('Tried to translate before loading translations!');
            }
            return this.translations.hasOwnProperty(string);
        }

        /**
         * Get the list of strings that don't have translations
         *
         * If no translations have been loaded yet, `undefined` is returned in stead.
         *
         * @returns {Array|undefined} Array of untranslated strings, or undefined if translations haven't been loaded
         */

    }, {
        key: 'getUntranslatedStrings',
        value: function getUntranslatedStrings() {
            return this.translations ? Array.from(this.strings) : undefined;
        }

        /**
         * Return a new instance of this class
         *
         * @returns {I18n}
         */

    }], [{
        key: 'getI18n',
        value: function getI18n() {
            return new I18n();
        }
    }]);

    return I18n;
}();

exports.default = I18n;
//# sourceMappingURL=I18n.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaultConfig = __webpack_require__(174);

var _defaultConfig2 = _interopRequireDefault(_defaultConfig);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function () {
    function Config() {
        _classCallCheck(this, Config);
    }

    _createClass(Config, null, [{
        key: 'create',
        value: function create() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var configObjects = args.filter(function (arg) {
                return arg;
            });

            if (!configObjects.every(function (configObject) {
                return (0, _check.isType)(configObject, 'object');
            })) {
                throw new Error('Expected Config parameter to have type object');
            }

            return Object.assign.apply(Object, [{}, _defaultConfig2.default].concat(args));
        }
    }, {
        key: 'processConfigForD2',
        value: function processConfigForD2(config, d2) {
            var api = d2.Api.getApi();
            d2.model.ModelDefinition.prototype.api = api; // eslint-disable-line no-param-reassign
            d2.models = d2.model.ModelDefinitions.getModelDefinitions(); // eslint-disable-line no-param-reassign

            if ((0, _check.isString)(config.baseUrl)) {
                api.setBaseUrl(config.baseUrl);
            } else {
                // default to the current version of the `/api`
                api.setBaseUrl('/api');
            }

            if (config.i18n && config.i18n.sources) {
                Array.from(config.i18n.sources).forEach(function (source) {
                    return d2.i18n.addSource(source);
                });
            }

            if (config.i18n && config.i18n.strings) {
                d2.i18n.addStrings(Array.from(config.i18n.strings));
            }
        }
    }]);

    return Config;
}();

exports.default = Config;
//# sourceMappingURL=config.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module current-user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _UserAuthorities = __webpack_require__(302);

var _UserAuthorities2 = _interopRequireDefault(_UserAuthorities);

var _UserSettings = __webpack_require__(303);

var _UserSettings2 = _interopRequireDefault(_UserSettings);

var _defaultConfig = __webpack_require__(174);

var _UserDataStore = __webpack_require__(304);

var _UserDataStore2 = _interopRequireDefault(_UserDataStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var models = Symbol('models');
var propertiesToIgnore = new Set(['userCredentials', 'userGroups', 'userRoles', 'organisationUnits', 'dataViewOrganisationUnits']);

/**
 * Authorities lookup map to be used for determining the list of authorities to check.
 *
 * @private
 * @type {Object.<string, string[]>}
 * @readonly
 * @typedef {Object} AuthorityType
 * @memberof module:current-user
 */
var authTypes = {
    READ: ['READ'],
    CREATE: ['CREATE', 'CREATE_PUBLIC', 'CREATE_PRIVATE'],
    CREATE_PUBLIC: ['CREATE_PUBLIC'],
    CREATE_PRIVATE: ['CREATE_PRIVATE'],
    DELETE: ['DELETE'],
    UPDATE: ['UPDATE'],
    EXTERNALIZE: ['EXTERNALIZE']
};

/**
 * Create a map of `propertyName` -> `Symbol`. This map is used to hide values for these properties. We will instead add
 * add convenience methods for these properties. (e.g. the `userGroups` property on the currentUser object becomes
 * `getUserGroups()`
 *
 * @private
 * @type {Object.<string, Symbol>}
 */
var propertySymbols = Array.from(propertiesToIgnore).reduce(function (result, property) {
    result[property] = Symbol(property); // eslint-disable-line no-param-reassign
    return result;
}, {});

/**
 * Creates a map of propertyName and propertyValue pairs of properties to be attached to the currentUser object.
 * These are all the regular properties that are returned when calling `api/27/me` but with the `userCredentials`
 * merged onto the same object.
 *
 * What would originally be `currentUser.userCredentials.username` would just be `currentUser.username`
 *
 * @private
 * @param {Object} currentUserObject The user payload as it is received from the api. https://play.dhis2.org/demo/api/27/me
 * @returns {Object} A map with propertyName/propertyValue pairs.
 */
function getPropertiesForCurrentUserObject(currentUserObject) {
    var properties = void 0;
    // The userCredentials object on the userObject is confusing so we set the properties straight onto the currentUser
    // object itself
    if (currentUserObject.userCredentials) {
        properties = Object.assign({}, currentUserObject.userCredentials, currentUserObject);
    } else {
        properties = Object.assign({}, currentUserObject);
    }

    return Object.keys(properties).reduce(function (result, property) {
        if (propertiesToIgnore.has(property)) {
            if (properties[property].map) {
                result[propertySymbols[property]] = properties[property] // eslint-disable-line no-param-reassign
                .map(function (value) {
                    return value.id;
                });
            }
        } else {
            result[property] = properties[property]; // eslint-disable-line no-param-reassign
        }
        return result;
    }, {});
}

/**
 * Checks the noCreateAllowedFor list if the object can be created.
 *
 * @private
 * @param {ModelDefinition} modelDefinition The modelDefinition to check for.
 * @returns {boolean} True when it exists in the list, false otherwise.
 */
function isInNoCreateAllowedForList(modelDefinition) {
    return Boolean(modelDefinition && _defaultConfig.noCreateAllowedFor.has(modelDefinition.name));
}

/**
 * Represents the current logged in user
 *
 * @memberof module:current-user
 */

var CurrentUser = function () {
    /**
     * Creates the CurrentUser.
     *
     * @param {Object} userData Payload as returned from the api when requesting the currentUser object.
     * @param {UserAuthorities} userAuthorities The UserAuthorities object for the currentUsers authorities.
     * @param {ModelDefinition[]} modelDefinitions The modelDefinitions that need to be used for checking access.
     * @param {UserSettings} settings The userSettings object to be set onto the current user object.
     */
    function CurrentUser(userData, userAuthorities, modelDefinitions, settings) {
        _classCallCheck(this, CurrentUser);

        Object.assign(this, getPropertiesForCurrentUserObject(userData));

        /**
         *
         * @type {UserAuthorities}
         */
        this.authorities = userAuthorities;

        this[models] = modelDefinitions;

        /**
         * Contains a reference to a `UserSettings` instance that can be used
         * to retrieve and save system settings.
         * @type {UserSettings}
         * @description
         * ```js
         * d2.currentUser.userSettings.get('keyUiLocale')
         *  .then(userSettingsValue => {
         *    console.log('UI Locale: ' + userSettingsValue);
         *  });
         * ```
         */
        this.userSettings = settings;

        /**
         * Contains a reference to {@link module:current-user.UserDataStore UserDataStore}
         * @type UserDataStore
         *
         */
        this.dataStore = _UserDataStore2.default.getUserDataStore();
    }

    /**
     * Get a ModelCollection of userGroup models that are assigned to the currentUser
     *
     * The user groups are lazy loaded on init of the library. This method can be used to load the full representation
     * of the userGroups.
     *
     * The request done is equivalent do doing https://play.dhis2.org/demo/api/27/me.json?fields=userGroups[:all]
     *
     * @returns {Promise<ModelCollection>} The model collection that contains the user's groups.
     */


    _createClass(CurrentUser, [{
        key: 'getUserGroups',
        value: function getUserGroups() {
            var userGroupIds = this[propertySymbols.userGroups];

            return this[models].userGroup.list({ filter: ['id:in:[' + userGroupIds.join(',') + ']'], paging: false });
        }

        /**
         * Get a ModelCollection of userRole models that are assigned to the currentUser
         *
         * The user roles are lazy loaded on init of the library. This method can be used to load the full representation
         * of the userGroups.
         *
         * The request done is equivalent do doing https://play.dhis2.org/demo/api/27/me.json?fields=userCredentials[userRoles[:all]]
         *
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's groups.
         */

    }, {
        key: 'getUserRoles',
        value: function getUserRoles() {
            var userRoleIds = this[propertySymbols.userRoles];

            return this[models].userRole.list({ filter: ['id:in:[' + userRoleIds.join(',') + ']'], paging: false });
        }

        /**
         * Requests a users primary organisation units from the api.
         *
         * The users organisation units are lazy loaded on init of the library (just the ids). This method can be used to
         * load the full representation of the organisationUnits.
         *
         * @param {Object} [listOptions={}] Additional query parameters that should be send with the request.
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's organisationUnits.
         */

    }, {
        key: 'getOrganisationUnits',
        value: function getOrganisationUnits() {
            var listOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var organisationUnitsIds = this[propertySymbols.organisationUnits];

            return this[models].organisationUnit.list(Object.assign({ fields: ':all,displayName,path,children[id,displayName,path,children::isNotEmpty]', paging: false }, listOptions, { filter: ['id:in:[' + organisationUnitsIds.join(',') + ']'] }));
        }

        /**
         * Requests a users data view organisation units from the api.
         *
         * The users data view organisation units are lazy loaded on init of the library (just the ids). This method can
         * be used to load the full representation of the dataViewOrganisationUnits.
         *
         * @param {Object} [listOptions={}] Additional query parameters that should be send with the request.
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's dataViewOrganisationUnits.
         */

    }, {
        key: 'getDataViewOrganisationUnits',
        value: function getDataViewOrganisationUnits(listOptions) {
            var organisationUnitsIds = this[propertySymbols.dataViewOrganisationUnits];

            return this[models].organisationUnit.list(Object.assign({ fields: ':all,displayName,path,children[id,displayName,path,children::isNotEmpty]', paging: false }, listOptions, { filter: ['id:in:[' + organisationUnitsIds.join(',') + ']'] }));
        }

        /**
         * Helper function to check if the currentUser can perform an action.
         *
         * A schema from the api defines the authorities as follows:
         * "authorities": [
         *   {
         *     "type": "CREATE_PUBLIC",
         *     "authorities": [
         *       "F_DATAELEMENT_PUBLIC_ADD"
         *     ]
         *   }, {
         *      "type": "CREATE_PRIVATE",
         *      "authorities": [
         *        "F_DATAELEMENT_PRIVATE_ADD"
         *      ]
         *    }, {
         *      "type": "DELETE",
         *      "authorities": [
         *        "F_DATAELEMENT_DELETE"
         *      ]
         *    }
         *
         * ],
         *
         * So for example, when asking for `currentUser.canCreate(modelDefinition)` we look at the authorities map for CREATE, we
         * collect the authorities from the schema based on the values of `CREATE`. So in the case of above schema authorities
         * we take the authorities for 'CREATE_PUBLIC' and 'CREATE_PRIVATE' and check if the user has at least one of the
         * authorities in the combined list. If we had asked for `currentUser.canCreatePrivate(modelDefinition)` we would only
         * need to check if the user has `F_DATAELEMENT_PRIVATE_ADD` However for just create the user could still create when he
         * has either private or public.
         *
         * @private
         * @param {AuthorityType} authorityType The type of authority to check for.
         * @param {ModelDefinition} modelDefinition The ModelDefinition for the type of object that the authority should
         * be checked for.
         * @returns {boolean} True when the user has the authority to perform the action, otherwise false.
         */

    }, {
        key: 'checkAuthorityForType',
        value: function checkAuthorityForType(authorityType, modelDefinition) {
            var _this = this;

            if (!modelDefinition || !Array.isArray(modelDefinition.authorities)) {
                return false;
            }

            return modelDefinition.authorities
            // Filter the correct authority to check for from the model
            .filter(function (authority) {
                return authorityType.some(function (authToHave) {
                    return authToHave === authority.type;
                });
            })
            // Check the left over schema authority types
            .some(function (schemaAuthority) {
                return schemaAuthority.authorities.some(function (authorityToCheckFor) {
                    return _this.authorities.has(authorityToCheckFor);
                });
            } // Check if one of the schema authorities are available in the users authorities
            );
        }

        /**
         * Helper method to first check the special "not allowed to create list" before checking the users authorities.
         *
         * @private
         * @param {AuthorityType} authType The type of authority that should be checked. (CREATE, CREATE_PRIVATE
         * or CREATE_PUBLIC)
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'checkCreateAuthorityForType',
        value: function checkCreateAuthorityForType(authType, modelDefinition) {
            // When the modelDefinition is mentioned in the the list of modelTypes that are not
            // allowed to be created we return false
            if (isInNoCreateAllowedForList(modelDefinition)) {
                return false;
            }

            // Otherwise we check using the normal procedure for checking authorities
            return this.checkAuthorityForType(authType, modelDefinition);
        }

        /**
         * Check if the user has the authority to create objects of a type of Model (based on it's modelDefinition)
         * If the object supports public and private objects then both are checked, and the method will return true if one
         * of them is true. (e.g. will also return true if the user can only create private objects)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreate',
        value: function canCreate(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE, modelDefinition);
        }

        /**
         * Check if the user has the authority to create public objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreatePublic',
        value: function canCreatePublic(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE_PUBLIC, modelDefinition);
        }

        /**
         * Check if the user has the authority to create private objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreatePrivate',
        value: function canCreatePrivate(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE_PRIVATE, modelDefinition);
        }

        /**
         * Check if the user has the authority to delete objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to delete the object
         *
         * @deprecated Delete should be checked through the `Model.access.delete` property instead, as that also takes into
         * account sharing. Just checking if the user has the authority to delete a specific object does not take into account
         * the full ACL.
         */

    }, {
        key: 'canDelete',
        value: function canDelete(modelDefinition) {
            return this.checkAuthorityForType(authTypes.DELETE, modelDefinition);
        }

        /**
         * Check if the user has the authority to update objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to update the object
         *
         * @deprecated Update should be checked through the `Model.access.update` property instead, as that also takes into
         * account sharing. Just checking if the user has the authority to update a specific object does not take into account
         * the full ACL.
         */

    }, {
        key: 'canUpdate',
        value: function canUpdate(modelDefinition) {
            if (this.checkAuthorityForType(authTypes.UPDATE, modelDefinition)) {
                return true;
            }
            return this.checkAuthorityForType(authTypes.CREATE, modelDefinition);
        }

        /**
         * Factory method for creating a CurrentUser instance
         *
         * @param {Object} userData Payload as returned from the api when requesting the currentUser object.
         * @param {string[]} authorities A list of authorities that the currentUser has.
         * @param {ModelDefinition[]} modelDefinitions The modelDefinitions that need to be used for checking access.
         * @param {Object} userSettings Payload as returned from the api when request the userSettings
         * @returns {CurrentUser} The created CurrentUser object based on the data given.
         */

    }], [{
        key: 'create',
        value: function create(userData, authorities, modelDefinitions, userSettings) {
            return new CurrentUser(userData, _UserAuthorities2.default.create(authorities), modelDefinitions, new _UserSettings2.default(userSettings));
        }
    }]);

    return CurrentUser;
}();

exports.default = CurrentUser;
//# sourceMappingURL=CurrentUser.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var auths = Symbol('authorities');

/**
 * Simple wrapper class for the user authorities list
 *
 * @memberof module:current-user
 */

var UserAuthorities = function () {
    /**
     * Creates the UserAuthorities object based off the given set of the user's authorities.
     *
     * @param {string[]} authorities A set of the user's authorities.
     */
    function UserAuthorities() {
        var authorities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, UserAuthorities);

        this[auths] = new Set(authorities);
    }

    /**
     * Checks if the given authority is in the user's authority list.
     *
     * If the user has the 'ALL' authority any request for a authority will return `true`.
     *
     * @param {string} authority The authority to check for
     */


    _createClass(UserAuthorities, [{
        key: 'has',
        value: function has(authority) {
            if (this[auths].has('ALL')) {
                return true;
            }
            return this[auths].has(authority);
        }

        /**
         * Factory method for a UserAuthorities instance
         *
         * @param {string[]} authorities A set of the user's authorities as recieved from the api.
         */

    }], [{
        key: 'create',
        value: function create(authorities) {
            return new UserAuthorities(authorities);
        }
    }]);

    return UserAuthorities;
}();

exports.default = UserAuthorities;
//# sourceMappingURL=UserAuthorities.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Handles communication with the userSettings endpoint. Can be used to get or save userSettings.
 *
 * @memberof module:current-user
 */

var UserSettings = function () {
    function UserSettings(userSettings) {
        var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default.getApi();

        _classCallCheck(this, UserSettings);

        this.api = api;

        if (userSettings) {
            this.settings = userSettings;
        }
    }

    /**
     * @returns {Promise} Promise that resolves with the usersettings object from the api.
     *
     * @description
     * Loads all the user settings of current user and returns them as an object from the promise.
     * ```js
     * d2.currentUser.userSettings.all()
     *  .then(userSettings => {
     *    console.log('UI Locale: ' + userSettings.keyUiLocale);
     *  });
     * ```
     */


    _createClass(UserSettings, [{
        key: 'all',
        value: function all() {
            var _this = this;

            return this.settings ? Promise.resolve(this.settings) : this.api.get('userSettings').then(function (userSettings) {
                _this.settings = userSettings;return Promise.resolve(_this.settings);
            });
        }

        /**
         * @param {String} key The identifier of the user setting that should be retrieved.
         * @returns {Promise} A promise that resolves with the value or will fail if the value is not available.
         *
         * @description
         * ```js
         * d2.currentUser.userSettings.get('keyUiLocale')
         *  .then(userSettingValue => {
         *    console.log('UI Locale: ' + userSettingValue);
         *  });
         * ```
         */

    }, {
        key: 'get',
        value: function get(key) {
            var _this2 = this;

            if (this.settings && this.settings[key]) {
                return Promise.resolve(this.settings[key]);
            }

            function processValue(value) {
                // Attempt to parse the response as JSON. If this fails we return the value as is.
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                if (!(0, _check.isString)(key)) {
                    throw new TypeError('A "key" parameter should be specified when calling get() on userSettings');
                }

                _this2.api.get(['userSettings', key].join('/')).then(function (response) {
                    var value = processValue(response);
                    // Store the value on the user settings object
                    _this2[key] = value;
                    if (value) {
                        resolve(value);
                    }
                    reject(new Error('The requested userSetting has no value or does not exist.'));
                });
            });
        }

        /**
         * @param {String} key The identifier of the user setting that should be saved.
         * @param {String} value The new value of the user setting.
         * @returns {Promise} A promise that will resolve when the new value has been saved, or fail if saving fails.
         *
         * @description
         * ```js
         * d2.currentUser.userSettings.set('keyUiLocale', 'fr')
         *  .then(() => {
         *   console.log('UI Locale is now "fr");
         *  });
         * ```
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            delete this.settings;

            var settingUrl = ['userSettings', key].join('/');
            if (value === null || ('' + value).length === 0) {
                return this.api.delete(settingUrl);
            }
            return this.api.post(settingUrl, value, { headers: { 'Content-Type': 'text/plain' } });
        }
    }]);

    return UserSettings;
}();

exports.default = UserSettings;
//# sourceMappingURL=UserSettings.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseStore2 = __webpack_require__(175);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _UserDataStoreNamespace = __webpack_require__(305);

var _UserDataStoreNamespace2 = _interopRequireDefault(_UserDataStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStore
 * @description
 * Represents the UserDataStore that can be interacted with. This can be used to get instances of UserDataStoreNamespace, which
 * can be used to interact with the {@link module:current-user.UserDataStoreNamespace namespace API}.
 *
 * The store is a key-value store, where a namespace contains a list of keys, and
 * a key corresponds to an arbitrary JSON-object. The store is per-user, and only the currently logged-in user
 * has access to the namespaces.
 *
 * Note that a namespace cannot exist without at least one key-value pair, for this reason
 * you need to call {@link module:current-user.UserDataStoreNamespace#set set()} after {@link module:current-user.UserDataStore#create create()} to save a namespace
 * with a key and a value.
 *
 * @example <caption>Getting a value with promise-syntax</caption>
 * import { init } from 'd2';
 *
 * init({baseUrl: 'https://play.dhis2.org/demo/api'})
 *   .then((d2) => {
 *     d2.currentUser.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 *
 * @example <caption>Creation of namespace with async-syntax</caption>
 * const namespace = await d2.currentUser.dataStore.create('new namespace', false);
 * // The namespace is not actually created on the server before 'set' is called
 * await namespace.set('new key', value);
 *
 * @memberof module:current-user
 */
var UserDataStore = function (_BaseStore) {
    _inherits(UserDataStore, _BaseStore);

    function UserDataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'userDataStore';

        _classCallCheck(this, UserDataStore);

        return _possibleConstructorReturn(this, (UserDataStore.__proto__ || Object.getPrototypeOf(UserDataStore)).call(this, api, endPoint, _UserDataStoreNamespace2.default));
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of 'UserDataStore' that
     * may be used to interact with this namespace. See {@link module:current-user.UserDataStoreNamespace UserDataStoreNamespace}.
     *
     * @example <caption>Getting a namespace</caption>
     * d2.currentUser.dataStore.get('namespace').then(namespace => {
     *     namespace.set('new key', value);
     *});
     *
     * @param {string} namespace - Namespace to get.
     * @param {boolean} [autoLoad=true] - If true, autoloads the keys of the namespace from the server.
     * If false, an instance of the namespace is returned without any keys (no request is sent to the server).
     *
     * @returns {Promise<UserDataStoreNamespace>} An instance of a UserDataStoreNamespace representing the namespace that can be interacted with.
     */


    _createClass(UserDataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return _get(UserDataStore.prototype.__proto__ || Object.getPrototypeOf(UserDataStore.prototype), 'get', this).call(this, namespace, autoLoad);
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:current-user.UserDataStoreNamespace#set set}.
         *
         * @example <caption>Creating a namespace</caption>
         * d2.currentUser.dataStore.create('new namespace').then(namespace => {
         *     namespace.set('new key', value);
         * });
         * @param {string} namespace The namespace to create.
         * @returns {Promise<UserDataStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            return _get(UserDataStore.prototype.__proto__ || Object.getPrototypeOf(UserDataStore.prototype), 'create', this).call(this, namespace);
        }

        /**
         * @static
         *
         * @returns {UserDataStore} Object with the userDataStore interaction properties
         *
         * @description
         * Get a new instance of the userDataStore object. This will function as a singleton - when a UserDataStore object has been created
         * when requesting getUserDataStore again, the original version will be returned.
         */

    }], [{
        key: 'getUserDataStore',
        value: function getUserDataStore() {
            if (!UserDataStore.getUserDataStore.dataStore) {
                UserDataStore.getUserDataStore.dataStore = new UserDataStore(_Api2.default.getApi(), 'userDataStore');
            }

            return UserDataStore.getUserDataStore.dataStore;
        }
    }]);

    return UserDataStore;
}(_BaseStore3.default);

exports.default = UserDataStore;
//# sourceMappingURL=UserDataStore.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _BaseStoreNamespace2 = __webpack_require__(115);

var _BaseStoreNamespace3 = _interopRequireDefault(_BaseStoreNamespace2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStoreNamespace
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {array} keys an array of the loaded keys.
 * @property {string} namespace Name of the namespace as on the server.
 *
 * @memberof module:current-user
 */
var UserDataStoreNamespace = function (_BaseStoreNamespace) {
    _inherits(UserDataStoreNamespace, _BaseStoreNamespace);

    function UserDataStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'userDataStore';

        _classCallCheck(this, UserDataStoreNamespace);

        return _possibleConstructorReturn(this, (UserDataStoreNamespace.__proto__ || Object.getPrototypeOf(UserDataStoreNamespace)).call(this, namespace, keys, api, endPoint));
    }

    return UserDataStoreNamespace;
}(_BaseStoreNamespace3.default);

exports.default = UserDataStoreNamespace;
//# sourceMappingURL=UserDataStoreNamespace.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseStore2 = __webpack_require__(175);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _DataStoreNamespace = __webpack_require__(307);

var _DataStoreNamespace2 = _interopRequireDefault(_DataStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStore
 * @description
 * Represents the dataStore that can be interacted with. This can be used to get instances of DataStoreNamespace, which
 * can be used to interact with the {@link module:datastore.DataStoreNamespace namespace API}.
 *
 * The store is a key-value store, where a namespace contains a list of keys, and
 * a key corresponds to an arbitrary JSON-object. The dataStore is DHIS2-instance wide.
 *
 * Note that a namespace cannot exist without at least one key-value pair, for this reason
 * you need to call {@link module:datastore.DataStoreNamespace#set set()} after {@link module:datastore.DataStore#create create()} to save a namespace
 * with a key and a value.
 *
 * @example
 * import { init } from 'd2';
 *
 * init({baseUrl: 'https://play.dhis2.org/demo/api'})
 *   .then((d2) => {
 *     d2.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 *
 * @memberof module:datastore
 */
var DataStore = function (_BaseStore) {
    _inherits(DataStore, _BaseStore);

    function DataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataStore';

        _classCallCheck(this, DataStore);

        return _possibleConstructorReturn(this, (DataStore.__proto__ || Object.getPrototypeOf(DataStore)).call(this, api, endPoint, _DataStoreNamespace2.default));
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of DataStore that
     * may be used to interact with this namespace. See {@link module:datastore.DataStoreNamespace DataStore}.
     *
     * @example <caption>Getting a namespace</caption>
     * d2.dataStore.get('namespace').then(namespace => {
     *     namespace.set('new key', value);
     *});
     * @param namespace - Namespace to get.
     * @param [autoLoad=true] If true, autoloads the keys of the namespace from the server.
     * If false, an instance of the namespace is returned without any keys (no request is sent to the server).
     * @returns {Promise<DataStoreNamespace>} An instance of a DataStore representing the namespace that can be interacted with,
     * or an error if namespace exists.
     */


    _createClass(DataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return _get(DataStore.prototype.__proto__ || Object.getPrototypeOf(DataStore.prototype), 'get', this).call(this, namespace, autoLoad);
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:datastore.DataStoreNamespace#set set}.
         *
         * @example <caption>Creating a namespace</caption>
         * d2.dataStore.create('new namespace').then(namespace => {
         *     namespace.set('new key', value);
         * });
         * @param {string} namespace The namespace to create.
         * @returns {Promise<DataStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            return _get(DataStore.prototype.__proto__ || Object.getPrototypeOf(DataStore.prototype), 'create', this).call(this, namespace);
        }

        /**
         * @static
         *
         * @returns {DataStore} Object with the dataStore interaction properties
         *
         * @description
         * Get a new instance of the dataStore object. This will function as a singleton, when a DataStore object has been created
         * when requesting getDataStore again the original version will be returned.
         */

    }], [{
        key: 'getDataStore',
        value: function getDataStore() {
            if (!DataStore.getDataStore.dataStore) {
                DataStore.getDataStore.dataStore = new DataStore();
            }

            return DataStore.getDataStore.dataStore;
        }
    }]);

    return DataStore;
}(_BaseStore3.default);

exports.default = DataStore;
//# sourceMappingURL=DataStore.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _BaseStoreNamespace2 = __webpack_require__(115);

var _BaseStoreNamespace3 = _interopRequireDefault(_BaseStoreNamespace2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStoreNamespace
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {array} keys an array of the loaded keys.
 * @property {string} namespace Name of the namespace as on the server.
 * @memberof module:datastore
 */
var DataStoreNamespace = function (_BaseStoreNamespace) {
    _inherits(DataStoreNamespace, _BaseStoreNamespace);

    function DataStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'dataStore';

        _classCallCheck(this, DataStoreNamespace);

        return _possibleConstructorReturn(this, (DataStoreNamespace.__proto__ || Object.getPrototypeOf(DataStoreNamespace)).call(this, namespace, keys, api, endPoint));
    }

    /**
     * Retrieves metaData of given key in current namespace.
     *
     * @param key - the key to retrieve metaData for.
     */


    _createClass(DataStoreNamespace, [{
        key: 'getMetaData',
        value: function getMetaData(key) {
            return this.api.get([this.endPoint, this.namespace, key, 'metaData'].join('/'));
        }
    }]);

    return DataStoreNamespace;
}(_BaseStoreNamespace3.default);

exports.default = DataStoreNamespace;
//# sourceMappingURL=DataStoreNamespace.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module analytics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _AnalyticsAggregate = __webpack_require__(309);

var _AnalyticsAggregate2 = _interopRequireDefault(_AnalyticsAggregate);

var _AnalyticsEvents = __webpack_require__(310);

var _AnalyticsEvents2 = _interopRequireDefault(_AnalyticsEvents);

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Analytics class used to request analytics data from Web API.
 *
 * @requires analytics.AnalyticsAggregate
 * @requires analytics.AnalyticsEvents
 * @requires analytics.AnalyticsRequest
 *
 * @example
 * const d2Analytics = new Analytics(
 *  new AnalyticsAggregate(),
 *  new AnalyticsEvents(),
 *  AnalyticsRequest
 * )
 *
 * @memberof module:analytics
 * @see {@link https://docs.dhis2.org/master/en/developer/html/webapi_analytics.html} Analytics API documentation
 * @see {@link https://docs.dhis2.org/master/en/developer/html/webapi_event_analytics.html} Event analytics API documentation
 */
var Analytics = function () {
    /**
     * @param {!module:analytics.AnalyticsAggregate} analyticsAggregate The AnalyticsAggregate instance
     * @param {!module:analytics.AnalyticsEvents} analyticsEvents The AnalyticsEvents instance
     * @param {!module:analytics.AnalyticsRequest} analyticsRequest The AnalyticsRequest class
     */
    function Analytics(analyticsAggregate, analyticsEvents, analyticsRequest) {
        _classCallCheck(this, Analytics);

        this.aggregate = analyticsAggregate;
        this.events = analyticsEvents;
        this.request = analyticsRequest;
    }

    /**
     * @static
     *
     * @description
     * Get a new instance of the Analytics object. This will function as a singleton, once Analytics object
     * has been created when requesting getAnalytics again the original version will be returned.
     *
     * @returns {Analytics} Object with the analytics interaction properties
     *
     * @example
     * const d2Analytics = d2.getAnalytics();
     */


    _createClass(Analytics, null, [{
        key: 'getAnalytics',
        value: function getAnalytics() {
            if (!Analytics.getAnalytics.analytics) {
                Analytics.getAnalytics.analytics = new Analytics(new _AnalyticsAggregate2.default(), new _AnalyticsEvents2.default(), _AnalyticsRequest2.default);
            }

            return Analytics.getAnalytics.analytics;
        }
    }]);

    return Analytics;
}();

exports.default = Analytics;
//# sourceMappingURL=Analytics.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsBase2 = __webpack_require__(176);

var _AnalyticsBase3 = _interopRequireDefault(_AnalyticsBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @extends module:analytics.AnalyticsBase
 *
 * @description
 * Analytics aggregate class used to request aggregate analytics data from Web API.
 *
 * @memberof module:analytics
 *
 * @see https://docs.dhis2.org/master/en/developer/html/webapi_analytics.html
 */
var AnalyticsAggregate = function (_AnalyticsBase) {
  _inherits(AnalyticsAggregate, _AnalyticsBase);

  function AnalyticsAggregate() {
    _classCallCheck(this, AnalyticsAggregate);

    return _possibleConstructorReturn(this, (AnalyticsAggregate.__proto__ || Object.getPrototypeOf(AnalyticsAggregate)).apply(this, arguments));
  }

  _createClass(AnalyticsAggregate, [{
    key: 'getDataValueSet',

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics data value set data from the API.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     * d2.analytics.aggregate.getDataValueSet(req)
     * .then(console.log);
     */
    value: function getDataValueSet(req) {
      return this.get(req.withPath('dataValueSet'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the raw data from the API.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw', 'PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu');
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31')
     *  .withFormat('xml');
     *
     *  d2.analytics.aggregate.getRawData(req)
     *  .then(console.log);
     */

  }, {
    key: 'getRawData',
    value: function getRawData(req) {
      return this.get(req.withPath('rawData'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the SQL statement used to query the database.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw', 'PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu');
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.aggregate.getDebugSql(req);
     *  .then(console.log);
     */

  }, {
    key: 'getDebugSql',
    value: function getDebugSql(req) {
      return this.get(req.withPath('debug/sql'));
    }
  }]);

  return AnalyticsAggregate;
}(_AnalyticsBase3.default);

exports.default = AnalyticsAggregate;
//# sourceMappingURL=AnalyticsAggregate.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsBase2 = __webpack_require__(176);

var _AnalyticsBase3 = _interopRequireDefault(_AnalyticsBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @extends module:analytics.AnalyticsBase
 *
 * @description
 * Analytics events class used to request analytics events data from Web API.
 *
 * @memberof module:analytics
 *
 * @see https://docs.dhis2.org/master/en/developer/html/webapi_event_analytics.html
 */
var AnalyticsEvents = function (_AnalyticsBase) {
  _inherits(AnalyticsEvents, _AnalyticsBase);

  function AnalyticsEvents() {
    _classCallCheck(this, AnalyticsEvents);

    return _possibleConstructorReturn(this, (AnalyticsEvents.__proto__ || Object.getPrototypeOf(AnalyticsEvents)).apply(this, arguments));
  }

  _createClass(AnalyticsEvents, [{
    key: 'getAggregate',

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics aggregate data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getAggregate(req)
     *  .then(console.log);
     */
    value: function getAggregate(req) {
      return this.get(req.withPath('events/aggregate'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics count data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getCount(req)
     *  .then(console.log);
     */

  }, {
    key: 'getCount',
    value: function getCount(req) {
      return this.get(req.withPath('events/count'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     * Must contain clusterSize and bbox parameters.
     *
     * @returns {Promise} Promise that resolves with the analytics cluster data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31')
     *  .withClusterSize(100000)
     *  .withBbox('-13.2682125,7.3721619,-10.4261178,9.904012');
     *
     *  d2.analytics.events.getCluster(req)
     *  .then(console.log);
     */

  }, {
    key: 'getCluster',
    value: function getCluster(req) {
      return this.get(req.withPath('events/cluster'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics query data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getQuery(req)
     *  .then(console.log);
     */

  }, {
    key: 'getQuery',
    value: function getQuery(req) {
      return this.get(req.withPath('events/query'));
    }
  }]);

  return AnalyticsEvents;
}(_AnalyticsBase3.default);

exports.default = AnalyticsEvents;
//# sourceMappingURL=AnalyticsEvents.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @private
 * @description
 * AnalyticsRequest dimensions mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestDimensionsMixin} The mixin class
 */
var AnalyticsRequestDimensionsMixin = function AnalyticsRequestDimensionsMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest dimensions mixin class
         *
         * @alias module:analytics.AnalyticsRequestDimensionsMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'addDataDimension',

                /**
                 * Adds/updates the dx dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the dx dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDataDimension(['fbfJHSPpUQD', 'cYeuwXTCPkU'])
                 *    .addDataDimension('BfMAe6Itzgt.REPORTING_RATE');
                 *
                 * // dimension=dx:fbfJHSPpUQD;cYeuwXTCPkU;BfMAe6Itzgt.REPORTING_RATE
                 *
                 */
                value: function addDataDimension(values) {
                    return this.addDimension('dx', values);
                }

                /**
                 * Adds/updates the pe dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the pe dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addPeriodDimension(['201701', '201702'])
                 *    .addPeriodDimension('LAST_4_QUARTERS');
                 *
                 * // dimension=pe:201701;201702;LAST_4_QUARTERS
                 */

            }, {
                key: 'addPeriodDimension',
                value: function addPeriodDimension(values) {
                    return this.addDimension('pe', values);
                }

                /**
                 * Adds/updates the ou dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the ou dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addOrgUnitDimension(['O6uvpzGd5pu', 'lc3eMKXaEfw'])
                 *    .addOrgUnitDimension('OU_GROUP-w0gFTTmsUcF');
                 *
                 * // dimension=ou:O6uvpzGd5pu;lc3eMKXaEfw;OU_GROUP-w0gFTTmsUcF
                 */

            }, {
                key: 'addOrgUnitDimension',
                value: function addOrgUnitDimension(values) {
                    return this.addDimension('ou', values);
                }

                /**
                 * Adds a new dimension or updates an existing one to use in the request.
                 *
                 * @param {!String} dimension The dimension to add to the request
                 * @param {(String|Array)} values The dimension items to add to the dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDimension('Bpx0589u8y0', ['oRVt7g429ZO', 'MAs88nJc9nL'])
                 *    .addDimension('qrur9Dvnyt5-Yf6UHoPkdS6');
                 *
                 * // dimension=Bpx0589u8y0:oRVt7g429ZO;MAs88nJc9nL&dimension=qrur9Dvnyt5-Yf6UHoPkdS6
                 */

            }, {
                key: 'addDimension',
                value: function addDimension(dimension, values) {
                    var existingValues = this.dimensions[dimension] || [];

                    if (typeof values === 'string') {
                        this.dimensions[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), [values]))));
                    } else if (Array.isArray(values)) {
                        this.dimensions[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), _toConsumableArray(values)))));
                    } else {
                        this.dimensions[dimension] = existingValues;
                    }

                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestDimensionsMixin;
//# sourceMappingURL=AnalyticsRequestDimensionsMixin.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @private
 * @description
 * AnalyticsRequest filters mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestFiltersMixin} The mixin class
 * @mixin
 */
var AnalyticsRequestFiltersMixin = function AnalyticsRequestFiltersMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest filters mixin class
         *
         * @alias module:analytics.AnalyticsRequestFiltersMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'addDataFilter',

                /**
                 * Adds/updates the dx dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the dx dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDataFilter(['fbfJHSPpUQD', 'cYeuwXTCPkU'])
                 *    .addDataFilter('BfMAe6Itzgt.REPORTING_RATE');
                 *
                 * // filter=dx:fbfJHSPpUQD;cYeuwXTCPkU;BfMAe6Itzgt.REPORTING_RATE
                 */
                value: function addDataFilter(values) {
                    return this.addFilter('dx', values);
                }

                /**
                 * Adds/updates the pe dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the pe dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addPeriodFilter(['201701', '201702'])
                 *    .addPeriodFilter('LAST_4_QUARTERS')
                 *
                 * // filter=pe:201701;201702;LAST_4_QUARTERS
                 */

            }, {
                key: 'addPeriodFilter',
                value: function addPeriodFilter(values) {
                    return this.addFilter('pe', values);
                }

                /**
                 * Adds/updates the ou dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the ou dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addOrgUnitFilter(['O6uvpzGd5pu', 'lc3eMKXaEfw'])
                 *    .addOrgUnitFilter('OU_GROUP-w0gFTTmsUcF')
                 *
                 * // filter=ou:O6uvpzGd5pu;lc3eMKXaEfw;OU_GROUP-w0gFTTmsUcF
                 */

            }, {
                key: 'addOrgUnitFilter',
                value: function addOrgUnitFilter(values) {
                    return this.addFilter('ou', values);
                }

                /**
                 * Adds a filter to the request.
                 *
                 * @param {!String} dimension The dimension to add as filter to the request
                 * @param {(String|Array)} values The dimension items to add to the dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addFilter('Bpx0589u8y0', ['oRVt7g429ZO', 'MAs88nJc9nL'])
                 *    .addFilter('qrur9Dvnyt5-Yf6UHoPkdS6');
                 *
                 * // filter=Bpx0589u8y0:oRVt7g429ZO;MAs88nJc9nL&filter=qrur9Dvnyt5-Yf6UHoPkdS6
                 */

            }, {
                key: 'addFilter',
                value: function addFilter(dimension, values) {
                    var existingValues = this.filters[dimension] || [];

                    if (typeof values === 'string') {
                        this.filters[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), [values]))));
                    } else if (Array.isArray(values)) {
                        this.filters[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), _toConsumableArray(values)))));
                    } else {
                        this.filters[dimension] = existingValues;
                    }

                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestFiltersMixin;
//# sourceMappingURL=AnalyticsRequestFiltersMixin.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

/**
 * @private
 * @description
 * AnalyticsRequest properties mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestPropertiesMixin} The mixin class
 */
var AnalyticsRequestPropertiesMixin = function AnalyticsRequestPropertiesMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest properties mixin
         *
         * @alias module:analytics.AnalyticsRequestPropertiesMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'withPath',

                /**
                 * Sets the URL path for the request.
                 * It appends the given path to the request's URL.
                 *
                 * @param {!String} path The path of the response
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPath('aggregate');
                 */
                value: function withPath(path) {
                    if (path) {
                        this.path = path;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Sets the response format for the request.
                 * It appends the file extension to the request's path.
                 *
                 * @param {String} [format=json] The format of the response
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withFormat('xml');
                 */

            }, {
                key: 'withFormat',
                value: function withFormat() {
                    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'json';

                    this.format = format;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the aggregationType query parameter to the request.
                 *
                 * @param {String} aggregationType The aggregationType value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAggregationType('SUM');
                 */

            }, {
                key: 'withAggregationType',
                value: function withAggregationType(value) {
                    var aggregationType = value.toUpperCase();

                    var aggregationTypes = new Set(['AVERAGE', 'AVERAGE_SUM_ORG_UNIT', 'COUNT', 'LAST', 'LAST_AVERAGE_ORG_UNIT', 'MIN', 'MAX', 'STDDEV', 'SUM', 'VARIANCE']);

                    if (aggregationTypes.has(aggregationType)) {
                        this.parameters.aggregationType = aggregationType;
                    } else {
                        console.warn('d2.analytics.request.withAggregationType(): "' + value + '" not listed as possible value');
                        this.parameters.aggregationType = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the measureCriteria query parameter to the request.
                 *
                 * @param {!String} measureCriteria The measureCriteria value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withMeasureCriteria('GE:10;LT:50');
                 */

            }, {
                key: 'withMeasureCriteria',
                value: function withMeasureCriteria(criteria) {
                    if (criteria) {
                        this.parameters.measureCriteria = criteria;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the preAggregationMeasureCriteria query parameter to the request.
                 *
                 * @param {!String} preAggregationMeasureCriteria The preAggregationMeasureCriteria value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPreAggregationMeasureCriteria('GE:10;LT:50');
                 */

            }, {
                key: 'withPreAggregationMeasureCriteria',
                value: function withPreAggregationMeasureCriteria(criteria) {
                    if (criteria) {
                        this.parameters.preAggregationMeasureCriteria = criteria;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipMeta query parameter to the request.
                 *
                 * @param {Boolean} [skipMeta=true] The skipMeta value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipMeta();
                 */

            }, {
                key: 'withSkipMeta',
                value: function withSkipMeta() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipMeta = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipData query parameter to the request.
                 *
                 * @param {Boolean} [skipData=true] The skipData value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipData();
                 */

            }, {
                key: 'withSkipData',
                value: function withSkipData() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipData = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hierarchyMeta query parameter to the request.
                 *
                 * @param {Boolean} [hierarchyMeta=true] The hierarchyMeta value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHierarchyMeta();
                 */

            }, {
                key: 'withHierarchyMeta',
                value: function withHierarchyMeta() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hierarchyMeta = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the ignoreLimit query parameter to the request.
                 *
                 * @param {Boolean} [ignoreLimit=true] The ignoreLimit value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIgnoreLimit();
                 */

            }, {
                key: 'withIgnoreLimit',
                value: function withIgnoreLimit() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.ignoreLimit = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the tableLayout query parameter to the request.
                 *
                 * @param {Boolean} [tableLayout=true] The tableLayout value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withTableLayout();
                 */

            }, {
                key: 'withTableLayout',
                value: function withTableLayout() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.tableLayout = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hideEmptyRows query parameter to the request.
                 *
                 * @param {Boolean} [hideEmptyRows=true] The hideEmptyRows value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHideEmptyRows();
                 */

            }, {
                key: 'withHideEmptyRows',
                value: function withHideEmptyRows() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hideEmptyRows = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hideEmptyColumns query parameter to the request.
                 *
                 * @param {Boolean} [hideEmptyColumns=true] The hideEmptyColumns value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHideEmptyColumns();
                 */

            }, {
                key: 'withHideEmptyColumns',
                value: function withHideEmptyColumns() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hideEmptyColumns = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the showHierarchy query parameter to the request.
                 *
                 * @param {Boolean} [showHierarchy=true] The showHierarchy value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withShowHierarchy();
                 */

            }, {
                key: 'withShowHierarchy',
                value: function withShowHierarchy() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.showHierarchy = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the includeNumDen query parameter to the request.
                 *
                 * @param {Boolean} [includeNumDen=true] The includeNumDen value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIncludeNumDen();
                 */

            }, {
                key: 'withIncludeNumDen',
                value: function withIncludeNumDen() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.includeNumDen = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the displayProperty query parameter to the request.
                 *
                 * @param {!String} displayProperty The displayProperty value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDisplayProperty('SHORTNAME');
                 */

            }, {
                key: 'withDisplayProperty',
                value: function withDisplayProperty(value) {
                    var displayProperty = value.toUpperCase();

                    var displayProperties = new Set(['NAME', 'SHORTNAME']);

                    if (displayProperties.has(displayProperty)) {
                        this.parameters.displayProperty = displayProperty;
                    } else {
                        console.warn('d2.analytics.request.withDisplayProperty(): "' + value + '" not listed as possible value');
                        this.parameters.displayProperty = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the displayProperty query parameter to the request.
                 *
                 * @param {!String} displayProperty The displayProperty value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDisplayProperty('SHORTNAME');
                 */

            }, {
                key: 'withOutputIdScheme',
                value: function withOutputIdScheme(scheme) {
                    if (scheme) {
                        this.parameters.outputIdScheme = scheme;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the inputIdScheme query parameter to the request.
                 *
                 * @param {!String} inputIdScheme The inputIdScheme value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withInputIdScheme('CODE');
                 */

            }, {
                key: 'withInputIdScheme',
                value: function withInputIdScheme(scheme) {
                    if (scheme) {
                        this.parameters.inputIdScheme = scheme;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the approvalLevel query parameter to the request.
                 *
                 * @param {!String} approvalLevel The approvalLevel value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withApprovalLevel('');
                 */

            }, {
                key: 'withApprovalLevel',
                value: function withApprovalLevel(level) {
                    if (level) {
                        this.parameters.approvalLevel = level;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the relativePeriodDate query parameter to the request.
                 *
                 * @param {!String} relativePeriodDate The relativePeriodDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withRelativePeriodDate('LAST_12_MONTHS');
                 */

            }, {
                key: 'withRelativePeriodDate',
                value: function withRelativePeriodDate(date) {
                    if (date) {
                        this.parameters.relativePeriodDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the userOrgUnit query parameter to the request.
                 *
                 * @param {!String} userOrgUnit The userOrgUnit value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withUserOrgUnit('O6uvpzGd5pu');
                 */

            }, {
                key: 'withUserOrgUnit',
                value: function withUserOrgUnit(orgUnit) {
                    if (orgUnit) {
                        this.parameters.userOrgUnit = orgUnit;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the columns query parameter to the request.
                 *
                 * @param {!String} columns The dimensions identifiers (separated by ;)
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withColumns('dx;ou');
                 */

            }, {
                key: 'withColumns',
                value: function withColumns(dimensions) {
                    if (dimensions) {
                        this.parameters.columns = dimensions;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the rows query parameter to the request.
                 *
                 * @param {!String} rows The dimensions identifiers (separated by ;)
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withRows('pe');
                 */

            }, {
                key: 'withRows',
                value: function withRows(dimensions) {
                    if (dimensions) {
                        this.parameters.rows = dimensions;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the startDate query parameter to the request.
                 *
                 * @param {!String} startDate The startDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withStartDate('2017-11-28');
                 */

            }, {
                key: 'withStartDate',
                value: function withStartDate(date) {
                    if (date) {
                        this.parameters.startDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the endDate query parameter to the request.
                 *
                 * @param {!String} endDate The endDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withEndDate('2017-12-31');
                 */

            }, {
                key: 'withEndDate',
                value: function withEndDate(date) {
                    if (date) {
                        this.parameters.endDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Sets the program for the request.
                 * It appends the program id to the request's path.
                 *
                 * @param {!String} program The program id
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withProgram('eBAyeGv0exc');
                 */

            }, {
                key: 'withProgram',
                value: function withProgram(program) {
                    if (program) {
                        this.program = program;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the stage query parameter to the request.
                 *
                 * @param {!String} stage The stage value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withStage('Zj7UnCAulEk');
                 */

            }, {
                key: 'withStage',
                value: function withStage(stage) {
                    if (stage) {
                        this.parameters.stage = stage;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the eventStatus query parameter to the request.
                 *
                 * @param {!String} eventStatus The eventStatus value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withEventStatus('COMPLETED');
                 */

            }, {
                key: 'withEventStatus',
                value: function withEventStatus(value) {
                    var eventStatus = value.toUpperCase();

                    var eventStatuses = new Set(['ACTIVE', 'COMPLETED', 'SCHEDULED', 'OVERDUE', 'SKIPPED']);

                    if (eventStatuses.has(eventStatus)) {
                        this.parameters.eventStatus = eventStatus;
                    } else {
                        console.warn('d2.analytics.request.withEventStatus(): "' + value + '" not listed as possible value');
                        this.parameters.eventStatus = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the programStatus query parameter to the request.
                 *
                 * @param {!String} programStatus The programStatus value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withProgramStatus('COMPLETED');
                 */

            }, {
                key: 'withProgramStatus',
                value: function withProgramStatus(value) {
                    var programStatus = value.toUpperCase();

                    var programStatuses = new Set(['ACTIVE', 'COMPLETED', 'CANCELLED']);

                    if (programStatuses.has(programStatus)) {
                        this.parameters.programStatus = programStatus;
                    } else {
                        console.warn('d2.analytics.request.withProgramStatus(): "' + value + '" not listed as possible value');
                        this.parameters.programStatus = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the ouMode query parameter to the request.
                 *
                 * @param {!String} ouMode The ouMode value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withOuMode('CHILDREN');
                 */

            }, {
                key: 'withOuMode',
                value: function withOuMode(value) {
                    var ouMode = value.toUpperCase();

                    var ouModes = new Set(['DESCENDANTS', 'CHILDREN', 'SELECTED']);

                    if (ouModes.has(ouMode)) {
                        this.parameters.ouMode = ouMode;
                    } else {
                        console.warn('d2.analytics.request.withOuMode(): "' + value + '" not listed as possible value');
                        this.parameters.ouMode = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the asc query parameter to the request.
                 *
                 * @param {!String} value The dimensions to be sorted ascending
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAsc('EVENTDATE');
                 */

            }, {
                key: 'withAsc',
                value: function withAsc(value) {
                    if (value) {
                        this.parameters.asc = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the desc query parameter to the request.
                 *
                 * @param {!String} value The dimensions to be sorted descending
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDesc('OUNAME');
                 */

            }, {
                key: 'withDesc',
                value: function withDesc(value) {
                    if (value) {
                        this.parameters.desc = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the coordinatesOnly query parameter to the request.
                 *
                 * @param {Boolean} [coordinatesOnly=true] The coordinatesOnly value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCoordinatesOnly();
                 */

            }, {
                key: 'withCoordinatesOnly',
                value: function withCoordinatesOnly() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.coordinatesOnly = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the page query parameter to the request.
                 *
                 * @param {!Number} [page=1] The page number
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPage(2);
                 */

            }, {
                key: 'withPage',
                value: function withPage() {
                    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

                    this.parameters.page = page;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the pageSize query parameter to the request.
                 *
                 * @param {!Number} [size=50] The number of items per page
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPageSize(10);
                 */

            }, {
                key: 'withPageSize',
                value: function withPageSize() {
                    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

                    this.parameters.pageSize = size;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the value query parameter to the request.
                 *
                 * @param {!String} value A data element or attribute identifier
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withValue('UXz7xuGCEhU');
                 */

            }, {
                key: 'withValue',
                value: function withValue(value) {
                    // must be a data element or attribute of numeric value type
                    if (value) {
                        this.parameters.value = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the sortOrder query parameter to the request.
                 *
                 * @param {!String} sortOrder The sortOrder value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSortOrder('DESC');
                 */

            }, {
                key: 'withSortOrder',
                value: function withSortOrder(value) {
                    var sortOrder = value.toUpperCase();

                    var sortOrders = new Set(['ASC', 'DESC']);

                    if (sortOrders.has(sortOrder)) {
                        this.parameters.sortOrder = sortOrder;
                    } else {
                        console.warn('d2.analytics.request.withSortOrder(): "' + value + '" not listed as possible value');
                        this.parameters.sortOrder = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the limit query parameter to the request.
                 *
                 * @param {!Number} limit The maximum number of records to return
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withLimit('5000');
                 */

            }, {
                key: 'withLimit',
                value: function withLimit(value) {
                    if (value) {
                        var limit = value > 10000 ? 10000 : value;

                        this.parameters.limit = limit;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the outputType query parameter to the request.
                 *
                 * @param {!String} outputType The output type
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withOutputType('ENROLLMENT');
                 */

            }, {
                key: 'withOutputType',
                value: function withOutputType(value) {
                    var type = value.toUpperCase();

                    var outputTypes = new Set(['EVENT', 'ENROLLMENT', 'TRACKED_ENTITY_INSTANCE']);

                    if (outputTypes.has(type)) {
                        this.parameters.outputType = type;
                    } else {
                        console.warn('d2.analytics.request.withOutputType(): "' + value + '" not listed as possible value');
                        this.parameters.outputType = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the collapseDataDimensions query parameter to the request.
                 *
                 * @param {Boolean} [collapseDataDimensions=true] The collapseDataDimensions value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCollapseDataDimensions();
                 */

            }, {
                key: 'withCollapseDataDimensions',
                value: function withCollapseDataDimensions() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.collapseDataDimensions = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipRounding query parameter to the request.
                 *
                 * @param {Boolean} [skipRounding=true] The skipRounding value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipRounding();
                 */

            }, {
                key: 'withSkipRounding',
                value: function withSkipRounding() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipRounding = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the aggregateData query parameter to the request.
                 *
                 * @param {Boolean} [aggregateData=true] The aggregateData value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAggregateData();
                 */

            }, {
                key: 'withAggregateData',
                value: function withAggregateData() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.aggregateData = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the clusterSize query parameter to the request.
                 *
                 * @param {!Number} clusterSize The size of cluster in meters
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withClusterSize(1000);
                 */

            }, {
                key: 'withClusterSize',
                value: function withClusterSize(size) {
                    if (size) {
                        this.parameters.clusterSize = size;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the coordinateField query parameter to the request.
                 *
                 * @param {!String} [coordinateField=EVENT] The field to base geospatial event analytics on
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCoordinateField('<attribute-id>');
                 */

            }, {
                key: 'withCoordinateField',
                value: function withCoordinateField() {
                    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EVENT';

                    // EVENT, <attribute-id>, <dataelement-id>
                    this.parameters.coordinateField = field;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the bbox query parameter to the request.
                 *
                 * @param {!String} bbox The bounding box coordinates in the format "min lng, min lat, max lng, max lat"
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withBbox('11.1768827285209, 60.141691309755, 11.1694071634997, 60.287796722512');
                 */

            }, {
                key: 'withBbox',
                value: function withBbox(bbox) {
                    if (bbox) {
                        this.parameters.bbox = bbox;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the includeClusterPoints query parameter to the request.
                 *
                 * @param {Boolean} [includeClusterPoints=true] The includeClusterPoints value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIncludeClusterPoints();
                 */

            }, {
                key: 'withIncludeClusterPoints',
                value: function withIncludeClusterPoints() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.includeClusterPoints = flag;
                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestPropertiesMixin;
//# sourceMappingURL=AnalyticsRequestPropertiesMixin.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(29);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @requires module:lib/utils
 *
 * @memberof module:analytics
 * @abstract
 */
var AnalyticsRequestBase = function () {
    function AnalyticsRequestBase() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$endPoint = _ref.endPoint,
            endPoint = _ref$endPoint === undefined ? 'analytics' : _ref$endPoint,
            _ref$format = _ref.format,
            format = _ref$format === undefined ? 'json' : _ref$format,
            path = _ref.path,
            program = _ref.program,
            _ref$dimensions = _ref.dimensions,
            dimensions = _ref$dimensions === undefined ? {} : _ref$dimensions,
            _ref$filters = _ref.filters,
            filters = _ref$filters === undefined ? {} : _ref$filters,
            _ref$parameters = _ref.parameters,
            parameters = _ref$parameters === undefined ? {} : _ref$parameters;

        _classCallCheck(this, AnalyticsRequestBase);

        this.endPoint = endPoint;
        this.format = format.toLowerCase();
        this.path = path;
        this.program = program;

        this.dimensions = _extends({}, dimensions);
        this.filters = _extends({}, filters);
        this.parameters = _extends({}, parameters);
    }

    /**
     * @private
     * @description
     * Builds the URL to pass to the Api object.
     * The URL includes the dimension(s) parameters.
     * Used internally.
     *
     * @returns {String} URL URL for the request with dimensions included
     */


    _createClass(AnalyticsRequestBase, [{
        key: 'buildUrl',
        value: function buildUrl() {
            // at least 1 dimension is required
            var encodedDimensions = Object.entries(this.dimensions).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    dimension = _ref3[0],
                    values = _ref3[1];

                if (Array.isArray(values) && values.length) {
                    return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
                }

                return dimension;
            });

            var endPoint = [this.endPoint, this.path, this.program].filter(function (e) {
                return !!e;
            }).join('/');

            return endPoint + '.' + this.format + '?dimension=' + encodedDimensions.join('&dimension=');
        }

        /**
         * @private
         * @description
         * Builds the query object passed to the API instance.
         * The object includes all the parameters added via with*() methods
         * and the filters added via addDataFilter(), addPeriodFilter(), addOrgUnitFilter(), addFilter().
         * The filters are handled by the API instance when building the final URL.
         * Used internally.
         *
         * @returns {Object} Query parameters
         */

    }, {
        key: 'buildQuery',
        value: function buildQuery() {
            var encodedFilters = Object.entries(this.filters).map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    dimension = _ref5[0],
                    values = _ref5[1];

                return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
            });

            if (encodedFilters.length) {
                this.parameters.filter = encodedFilters;
            }

            return this.parameters;
        }
    }]);

    return AnalyticsRequestBase;
}();

exports.default = AnalyticsRequestBase;
//# sourceMappingURL=AnalyticsRequestBase.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _uid = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class GeoFeatures
 * @description
 * GeoFeatures class used to request organisation unit coordinates from the Web API.
 */
var GeoFeatures = function () {
    /**
     * @constructor
     *
     * @param {Array} orgUnits Organisation units (UID, level, group, user org. unit) to include in the response.
     * @param {String} displayName The name property to display (NAME|SHORTNAME).
     */
    function GeoFeatures() {
        var orgUnits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var displayName = arguments[1];

        _classCallCheck(this, GeoFeatures);

        this.orgUnits = orgUnits;
        this.displayName = displayName;
    }

    /**
     * @method byOrgUnit
     *
     * @param {Array} orgUnits Organisation units (UID, level, group, user org. unit) to include in the response.
     *
     * @returns {GeoFeatures}
     */


    _createClass(GeoFeatures, [{
        key: 'byOrgUnit',
        value: function byOrgUnit(orgUnits) {
            if (!orgUnits) {
                return this;
            }

            var orgUnitsArray = [].concat(orgUnits);

            if (!orgUnitsArray.every(GeoFeatures.isValidOrgUnit)) {
                throw new Error('Invalid organisation unit: ' + orgUnits);
            }

            return new GeoFeatures(orgUnitsArray, this.displayName);
        }

        /**
         * @method byOrgUnit
         *
         * @param {String} displayName The name property to display (NAME|SHORTNAME).
         *
         * @returns {GeoFeatures}
         */

    }, {
        key: 'displayProperty',
        value: function displayProperty(displayName) {
            if (!displayName) {
                return this;
            }

            if (!GeoFeatures.isValidDisplayName(displayName)) {
                throw new Error('Invalid display property: ' + displayName);
            }

            return new GeoFeatures(this.orgUnits, displayName);
        }

        /**
         * @method getAll
         *
         * @param {Object} params Extra URL params to pass to the Web API endpoint.
         *
         * @returns {Promise} with an array of geofeatures.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var api = _Api2.default.getApi();
            var urlParams = params;

            if (this.orgUnits.length) {
                urlParams.ou = 'ou:' + this.orgUnits.join(';');
            }

            if (this.displayName) {
                urlParams.displayProperty = this.displayName;
            }

            return api.get('geoFeatures', urlParams);
        }

        /**
         * @method isValidOrgUnit
         * @static
         *
         * @returns {boolean} True if the org. unit is valid
         *
         * @description
         * Checks if the org. unit is valid (UID, level, group, user org. unit)
         */

    }], [{
        key: 'isValidOrgUnit',
        value: function isValidOrgUnit(orgUnit) {
            return (0, _uid.isValidUid)(orgUnit) || GeoFeatures.isValidOrgUnitLevel(orgUnit) || GeoFeatures.isValidOrgUnitGroup(orgUnit) || GeoFeatures.isValidUserOrgUnit(orgUnit);
        }

        /**
         * @method isValidOrgUnitLevel
         * @static
         *
         * @returns {boolean} True if the org. unit level is valid
         *
         * @description
         * Checks if the org. unit level is valid.
         */

    }, {
        key: 'isValidOrgUnitLevel',
        value: function isValidOrgUnitLevel(level) {
            return (/^LEVEL-[0-9]+$/.test(level)
            );
        }

        /**
         * @method isValidOrgUnitGroup
         * @static
         *
         * @returns {boolean} True if the org. unit group is valid
         *
         * @description
         * Checks if the org. unit group is valid.
         */

    }, {
        key: 'isValidOrgUnitGroup',
        value: function isValidOrgUnitGroup(group) {
            var match = group.match(/OU_GROUP-(.*)$/);
            return Array.isArray(match) && (0, _uid.isValidUid)(match[1]);
        }

        /**
         * @method isValidUserOrgUnit
         * @static
         *
         * @returns {boolean} True if the user org. unit is valid
         *
         * @description
         * Checks if the user org. unit is valid.
         */

    }, {
        key: 'isValidUserOrgUnit',
        value: function isValidUserOrgUnit(orgUnit) {
            return orgUnit === GeoFeatures.USER_ORGUNIT || orgUnit === GeoFeatures.USER_ORGUNIT_CHILDREN || orgUnit === GeoFeatures.USER_ORGUNIT_GRANDCHILDREN;
        }

        /**
         * @method isValidDisplayName
         * @static
         *
         * @returns {boolean} True if display name is valid
         *
         * @description
         * Checks if the display name is valid.
         */

    }, {
        key: 'isValidDisplayName',
        value: function isValidDisplayName(displayName) {
            return displayName === GeoFeatures.DISPLAY_PROPERTY_NAME || displayName === GeoFeatures.DISPLAY_PROPERTY_SHORTNAME;
        }

        /**
         * @method getGeoFeatures
         * @static
         *
         * @returns {GeoFeatures} Object with interaction properties
         *
         * @description
         * Get a new instance of the GeoFeatures object.
         */

    }, {
        key: 'getGeoFeatures',
        value: function getGeoFeatures() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return new (Function.prototype.bind.apply(GeoFeatures, [null].concat(args)))();
        }
    }]);

    return GeoFeatures;
}();

GeoFeatures.DISPLAY_PROPERTY_NAME = 'NAME';
GeoFeatures.DISPLAY_PROPERTY_SHORTNAME = 'SHORTNAME';
GeoFeatures.USER_ORGUNIT = 'USER_ORGUNIT';
GeoFeatures.USER_ORGUNIT_CHILDREN = 'USER_ORGUNIT_CHILDREN';
GeoFeatures.USER_ORGUNIT_GRANDCHILDREN = 'USER_ORGUNIT_GRANDCHILDREN';
exports.default = GeoFeatures;
//# sourceMappingURL=GeoFeatures.js.map

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaults_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__ = __webpack_require__(177);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }













function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__["a" /* default */](createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len4 = arguments.length, rest = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        rest[_key4 - 2] = arguments[_key4];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && options.count) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this3 = this;

    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this3.translate.apply(_this3, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = _extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(326),
    fallbackHolder = __webpack_require__(16);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(328),
  'assign': __webpack_require__(197),
  'clone': __webpack_require__(359),
  'curry': __webpack_require__(207),
  'forEach': __webpack_require__(96),
  'isArray': __webpack_require__(21),
  'isError': __webpack_require__(402),
  'isFunction': __webpack_require__(116),
  'isWeakMap': __webpack_require__(403),
  'iteratee': __webpack_require__(404),
  'keys': __webpack_require__(126),
  'rearg': __webpack_require__(425),
  'toInteger': __webpack_require__(97),
  'toPath': __webpack_require__(428)
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(116),
    isMasked = __webpack_require__(332),
    isObject = __webpack_require__(26),
    toSource = __webpack_require__(182);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(333);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(77),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117),
    createCtor = __webpack_require__(77),
    createHybrid = __webpack_require__(183),
    createRecurry = __webpack_require__(186),
    getHolder = __webpack_require__(196),
    replaceHolders = __webpack_require__(121),
    root = __webpack_require__(23);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    getData = __webpack_require__(187),
    getFuncName = __webpack_require__(339),
    lodash = __webpack_require__(341);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(340);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    LodashWrapper = __webpack_require__(189),
    baseLodash = __webpack_require__(119),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(25),
    wrapperClone = __webpack_require__(342);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    LodashWrapper = __webpack_require__(189),
    copyArray = __webpack_require__(79);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(346),
    defineProperty = __webpack_require__(193),
    identity = __webpack_require__(57);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(96),
    arrayIncludes = __webpack_require__(194);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIsNaN = __webpack_require__(349),
    strictIndexOf = __webpack_require__(350);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(79),
    isIndex = __webpack_require__(63);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117),
    createCtor = __webpack_require__(77),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(184),
    composeArgsRight = __webpack_require__(185),
    replaceHolders = __webpack_require__(121);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isLength = __webpack_require__(124),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(199);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(127);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    Map = __webpack_require__(129),
    MapCache = __webpack_require__(130);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(371),
    ListCache = __webpack_require__(86),
    Map = __webpack_require__(129);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(372),
    hashDelete = __webpack_require__(373),
    hashGet = __webpack_require__(374),
    hashHas = __webpack_require__(375),
    hashSet = __webpack_require__(376);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keysIn = __webpack_require__(200);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26),
    isPrototype = __webpack_require__(85),
    nativeKeysIn = __webpack_require__(384);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbols = __webpack_require__(131);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbolsIn = __webpack_require__(202);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134),
    cloneDataView = __webpack_require__(393),
    cloneRegExp = __webpack_require__(394),
    cloneSymbol = __webpack_require__(395),
    cloneTypedArray = __webpack_require__(396);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    getPrototype = __webpack_require__(133),
    isPrototype = __webpack_require__(85);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(399),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(401),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25),
    isPlainObject = __webpack_require__(135);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(127),
    baseIteratee = __webpack_require__(38);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(406),
    getMatchData = __webpack_require__(414),
    matchesStrictComparable = __webpack_require__(213);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    baseIsEqual = __webpack_require__(208);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    equalArrays = __webpack_require__(209),
    equalByTag = __webpack_require__(411),
    equalObjects = __webpack_require__(413),
    getTag = __webpack_require__(53),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isTypedArray = __webpack_require__(123);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    Uint8Array = __webpack_require__(206),
    eq = __webpack_require__(80),
    equalArrays = __webpack_require__(209),
    mapToArray = __webpack_require__(412),
    setToArray = __webpack_require__(136);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(212),
    keys = __webpack_require__(58);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(208),
    get = __webpack_require__(416),
    hasIn = __webpack_require__(216),
    isKey = __webpack_require__(137),
    isStrictComparable = __webpack_require__(212),
    matchesStrictComparable = __webpack_require__(213),
    toKey = __webpack_require__(46);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(418);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(130);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    arrayMap = __webpack_require__(65),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(64),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isIndex = __webpack_require__(63),
    isLength = __webpack_require__(124),
    toKey = __webpack_require__(46);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(423),
    basePropertyDeep = __webpack_require__(424),
    isKey = __webpack_require__(137),
    toKey = __webpack_require__(46);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76),
    flatRest = __webpack_require__(152);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(153);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    copyArray = __webpack_require__(79),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52),
    stringToPath = __webpack_require__(214),
    toKey = __webpack_require__(46),
    toString = __webpack_require__(215);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26),
    now = __webpack_require__(679),
    toNumber = __webpack_require__(244);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(688);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(563);
var isObject_1 = __webpack_require__(564);
var isFunction_1 = __webpack_require__(562);
var tryCatch_1 = __webpack_require__(698);
var errorObject_1 = __webpack_require__(565);
var UnsubscriptionError_1 = __webpack_require__(699);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(138);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(138);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(138);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(30);
var ScalarObservable_1 = __webpack_require__(573);
var EmptyObservable_1 = __webpack_require__(437);
var isScheduler_1 = __webpack_require__(574);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(30);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(569);
var OuterSubscriber_1 = __webpack_require__(568);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
    };
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var defaultBasemaps = exports.defaultBasemaps = [{
    id: 'osmLight',
    name: 'OSM Light',
    img: 'images/osmlight.png',
    config: {
        type: 'tileLayer',
        url: '//cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
    }
}, {
    id: 'openStreetMap',
    name: 'OSM Detailed',
    img: 'images/osm.png',
    config: {
        type: 'tileLayer',
        url: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }
}, {
    id: 'googleStreets',
    name: 'Google Streets',
    img: 'images/googlestreets.png',
    config: {
        type: 'googleLayer',
        style: 'ROADMAP',
        apiKey: 'AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc'
    }
}, {
    id: 'googleHybrid',
    name: 'Google Hybrid',
    img: 'images/googlehybrid.jpeg',
    config: {
        type: 'googleLayer',
        style: 'HYBRID',
        apiKey: 'AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc'
    }
}];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseIteratee = __webpack_require__(38),
    baseMap = __webpack_require__(246),
    baseSortBy = __webpack_require__(444),
    baseUnary = __webpack_require__(84),
    compareMultiple = __webpack_require__(445),
    identity = __webpack_require__(57);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(442);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(42);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(446);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(52);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('negate', __webpack_require__(219), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(250);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(744);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(748);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(749);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(450);
var invariant = __webpack_require__(451);
var ReactPropTypesSecret = __webpack_require__(452);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(22);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(454);
/* unused harmony reexport timeMillisecond */
/* unused harmony reexport timeMilliseconds */
/* unused harmony reexport utcMillisecond */
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(455);
/* unused harmony reexport timeSecond */
/* unused harmony reexport timeSeconds */
/* unused harmony reexport utcSecond */
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(456);
/* unused harmony reexport timeMinute */
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(457);
/* unused harmony reexport timeHour */
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(459);
/* unused harmony reexport timeWeek */
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(460);
/* unused harmony reexport timeMonth */
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(462);
/* unused harmony reexport utcMinute */
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(463);
/* unused harmony reexport utcHour */
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(465);
/* unused harmony reexport utcWeek */
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(466);
/* unused harmony reexport utcMonth */
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* unused harmony default export */ var _unused_webpack_default_export = (second);
var seconds = second.range;


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* unused harmony default export */ var _unused_webpack_default_export = (minute);
var minutes = minute.range;


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* unused harmony default export */ var _unused_webpack_default_export = (hour);
var hours = hour.range;


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* unused harmony default export */ var _unused_webpack_default_export = (month);
var months = month.range;


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(140);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" /* isoSpecifier */]);

/* harmony default export */ __webpack_exports__["a"] = (parseIso);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadIndicatorGroups = exports.loadIndicators = exports.setIndicatorGroups = exports.setIndicators = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setIndicators = exports.setIndicators = function setIndicators(groupId, data) {
    return {
        type: types.INDICATORS_SET,
        groupId: groupId,
        payload: data
    };
};

// Set all indicator groups
var setIndicatorGroups = exports.setIndicatorGroups = function setIndicatorGroups(data) {
    return {
        type: types.INDICATOR_GROUPS_SET,
        payload: data
    };
};

var loadIndicators = exports.loadIndicators = function loadIndicators(groupId) {
    return {
        type: types.INDICATORS_LOAD,
        groupId: groupId
    };
};

// Load all indicator groups
var loadIndicatorGroups = exports.loadIndicatorGroups = function loadIndicatorGroups() {
    return {
        type: types.INDICATOR_GROUPS_LOAD
    };
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isEmpty', __webpack_require__(471), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(126),
    getTag = __webpack_require__(53),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isArrayLike = __webpack_require__(42),
    isBuffer = __webpack_require__(82),
    isPrototype = __webpack_require__(85),
    isTypedArray = __webpack_require__(123);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('compact', __webpack_require__(473), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(227);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('curryRight', __webpack_require__(485));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

module.exports = curryRight;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _isPlainObject = __webpack_require__(232);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _d2 = __webpack_require__(19);

var _map = __webpack_require__(67);

var _helpers = __webpack_require__(36);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var facilityLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var organisationUnitGroupSet, rows, groupSetId, orgUnits, orgUnitParams, d2, contextPath, displayProperty, groupSetReq, facilitiesReq, _ref2, _ref3, groupSet, facilities, features;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        organisationUnitGroupSet = config.organisationUnitGroupSet, rows = config.rows;
                        groupSetId = organisationUnitGroupSet.id;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        _context.next = 6;
                        return (0, _d2.getInstance)();

                    case 6:
                        d2 = _context.sent;
                        contextPath = d2.system.systemInfo.contextPath;
                        displayProperty = (0, _helpers.getDisplayProperty)(d2);
                        groupSetReq = d2.models.organisationUnitGroupSet.get(groupSetId, {
                            fields: 'organisationUnitGroups[id,' + displayProperty + '~rename(name),symbol]'
                        }).then(parseGroupSet);
                        facilitiesReq = d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayProperty.toUpperCase()).getAll({
                            includeGroupSets: true
                        }).then(function (facilities) {
                            return parseFacilities(facilities, groupSetId);
                        });
                        _context.next = 13;
                        return Promise.all([groupSetReq, facilitiesReq]);

                    case 13:
                        _ref2 = _context.sent;
                        _ref3 = _slicedToArray(_ref2, 2);
                        groupSet = _ref3[0];
                        facilities = _ref3[1];


                        // Convert API response to GeoJSON features
                        features = facilities.map(function (facility) {
                            var id = facility.dimensions[groupSetId];
                            return toGeoJson(facility, groupSet[id], contextPath);
                        });
                        return _context.abrupt('return', _extends({}, config, {
                            data: features,
                            name: _i18next2.default.t('Facilities'),
                            legend: {
                                unit: organisationUnitGroupSet.name,
                                items: Object.keys(groupSet).map(function (id) {
                                    return {
                                        image: contextPath + '/images/orgunitgroup/' + groupSet[id].symbol,
                                        name: groupSet[id].name
                                    };
                                })
                            },
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 19:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function facilityLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

var parseFacilities = function parseFacilities(facilities, groupSetId) {
    return facilities.filter(function (facility // Only add valid points belonging to an org.unit group
    ) {
        return facility.ty === 1 && (0, _isPlainObject2.default)(facility.dimensions) && facility.dimensions[groupSetId] && (0, _map.isValidCoordinate)(JSON.parse(facility.co));
    });
};

var parseGroupSet = function parseGroupSet(groupSet) {
    return groupSet.organisationUnitGroups.toArray().reduce(function (symbols, group, index) {
        // Easier lookup of unit group symbols
        group.symbol = group.symbol || 21 + index + '.png'; // Default symbol 21-25 are coloured circles
        symbols[group.id] = group;
        return symbols;
    }, {});
};

var toGeoJson = function toGeoJson(facility, group, contextPath) {
    return {
        type: 'Feature',
        id: facility.id,
        properties: {
            id: facility.id,
            name: facility.na,
            label: facility.na + ' (' + group.name + ')',
            icon: {
                iconUrl: contextPath + '/images/orgunitgroup/' + group.symbol,
                iconSize: [16, 16]
            },
            type: 'Point' // Accessible in data table
        },
        geometry: {
            type: 'Point',
            coordinates: JSON.parse(facility.co)
        }
    };
};

exports.default = facilityLoader;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d2 = __webpack_require__(19);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _findIndex = __webpack_require__(488);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _pick = __webpack_require__(233);

var _pick2 = _interopRequireDefault(_pick);

var _curry = __webpack_require__(225);

var _curry2 = _interopRequireDefault(_curry);

var _map = __webpack_require__(67);

var _dimension = __webpack_require__(90);

var _classify = __webpack_require__(226);

var _helpers = __webpack_require__(36);

var _legend = __webpack_require__(231);

var _analytics = __webpack_require__(32);

var _colorscale = __webpack_require__(102);

var _alerts = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var thematicLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var columns, radiusLow, radiusHigh, _ref2, _ref3, features, data, names, valueById, valueFeatures, orderedValues, minValue, maxValue, dataItem, name, legendSet, method, legend, getLegendItem, alerts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        columns = config.columns, radiusLow = config.radiusLow, radiusHigh = config.radiusHigh;
                        _context.next = 3;
                        return loadData(config);

                    case 3:
                        _ref2 = _context.sent;
                        _ref3 = _slicedToArray(_ref2, 2);
                        features = _ref3[0];
                        data = _ref3[1];
                        names = (0, _analytics.getApiResponseNames)(data);
                        valueById = getValueById(data);
                        valueFeatures = features.filter(function (_ref4) {
                            var id = _ref4.id;
                            return valueById[id] !== undefined;
                        });
                        orderedValues = getOrderedValues(data);
                        minValue = orderedValues[0];
                        maxValue = orderedValues[orderedValues.length - 1];
                        dataItem = (0, _analytics.getDataItemFromColumns)(columns);
                        name = names[dataItem.id];
                        legendSet = config.legendSet;
                        method = legendSet ? 1 : config.method; // Favorites often have wrong method

                        // Check if data item has legend set (needed if config is converted for chart/pivot layout)

                        if (!(!legendSet && !method)) {
                            _context.next = 21;
                            break;
                        }

                        _context.next = 20;
                        return (0, _legend.loadDataItemLegendSet)(dataItem);

                    case 20:
                        legendSet = _context.sent;

                    case 21:
                        if (!legendSet) {
                            _context.next = 27;
                            break;
                        }

                        _context.next = 24;
                        return createLegendFromLegendSet(legendSet);

                    case 24:
                        _context.t0 = _context.sent;
                        _context.next = 28;
                        break;

                    case 27:
                        _context.t0 = createLegendFromConfig(orderedValues, config);

                    case 28:
                        legend = _context.t0;
                        getLegendItem = (0, _curry2.default)(_classify.getLegendItemForValue)(legend.items);
                        alerts = [];


                        legend.title = name;
                        legend.items.forEach(function (item) {
                            return item.count = 0;
                        });
                        legend.period = names[data.metaData.dimensions.pe[0]];

                        if (!valueFeatures.length) {
                            alerts.push((0, _alerts.createAlert)(name, _i18next2.default.t('No data found')));
                        }

                        valueFeatures.forEach(function (_ref5) {
                            var id = _ref5.id,
                                geometry = _ref5.geometry,
                                properties = _ref5.properties;

                            var value = valueById[id];
                            var item = getLegendItem(value);

                            item.count++;
                            properties.value = value;
                            properties.color = item && item.color;
                            properties.radius = (value - minValue) / (maxValue - minValue) * (radiusHigh - radiusLow) + radiusLow;
                            properties.legend = item.name; // Shown in data table
                            properties.range = item.startValue + ' - ' + item.endValue; // Shown in data table
                            properties.type = geometry.type; // Shown in data table
                        });

                        return _context.abrupt('return', _extends({}, config, {
                            data: valueFeatures,
                            name: name,
                            legend: legend,
                            method: method
                        }, alerts.length ? { alerts: alerts } : {}, {
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 37:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function thematicLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

// Returns an object mapping org. units and values
var getValueById = function getValueById(data) {
    var headers = data.headers,
        rows = data.rows;

    var ouIndex = (0, _findIndex2.default)(['name', 'ou'], headers);
    var valueIndex = (0, _findIndex2.default)(['name', 'value'], headers);

    return rows.reduce(function (obj, row) {
        obj[row[ouIndex]] = parseFloat(row[valueIndex]);
        return obj;
    }, {});
};

// Returns an array of ordered values
var getOrderedValues = function getOrderedValues(data) {
    var headers = data.headers,
        rows = data.rows;

    var valueIndex = (0, _findIndex2.default)(['name', 'value'], headers);

    return rows.map(function (row) {
        return parseFloat(row[valueIndex]);
    }).sort(function (a, b) {
        return a - b;
    });
};

// Returns a legend created from a pre-defined legend set
var createLegendFromLegendSet = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(legendSet) {
        var d2, _ref7, legends, pickSome;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d2.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        _context2.next = 5;
                        return d2.models.legendSet.get(legendSet.id);

                    case 5:
                        _ref7 = _context2.sent;
                        legends = _ref7.legends;
                        pickSome = (0, _pick2.default)(['name', 'startValue', 'endValue', 'color']);
                        return _context2.abrupt('return', {
                            items: (0, _sortBy2.default)('startValue', legends).map(pickSome)
                        });

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function createLegendFromLegendSet(_x2) {
        return _ref6.apply(this, arguments);
    };
}();

var createLegendFromConfig = function createLegendFromConfig(data, config) {
    var _config$method = config.method,
        method = _config$method === undefined ? 2 : _config$method,
        _config$classes = config.classes,
        classes = _config$classes === undefined ? _colorscale.defaultClasses : _config$classes,
        _config$colorScale = config.colorScale,
        colorScale = _config$colorScale === undefined ? _colorscale.defaultColorScale : _config$colorScale;


    var items = data.length ? (0, _classify.getLegendItems)(data, method, classes) : [];
    var colors = colorScale.split(',');

    return {
        items: items.map(function (item, index) {
            return _extends({}, item, {
                color: colors[index]
            });
        })
    };
};

// Load features and data values from api
var loadData = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config) {
        var rows, columns, filters, displayProperty, userOrgUnit, valueType, relativePeriodDate, aggregationType, orgUnits, period, dataItem, isOperand, d2, displayPropertyUpper, orgUnitParams, dataDimension, analyticsRequest, orgUnitReq, dataReq;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        rows = config.rows, columns = config.columns, filters = config.filters, displayProperty = config.displayProperty, userOrgUnit = config.userOrgUnit, valueType = config.valueType, relativePeriodDate = config.relativePeriodDate, aggregationType = config.aggregationType;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        period = (0, _analytics.getPeriodFromFilters)(filters);
                        dataItem = (0, _analytics.getDataItemFromColumns)(columns);
                        isOperand = columns[0].dimension === _dimension.dimConf.operand.objectName;
                        _context3.next = 7;
                        return (0, _d2.getInstance)();

                    case 7:
                        d2 = _context3.sent;
                        displayPropertyUpper = (0, _helpers.getDisplayProperty)(d2, displayProperty).toUpperCase();
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        dataDimension = isOperand ? dataItem.id.split('.')[0] : dataItem.id;


                        if (valueType === 'ds') {
                            dataDimension += '.REPORTING_RATE';
                        }

                        analyticsRequest = new d2.analytics.request().addOrgUnitDimension(orgUnits.map(function (ou) {
                            return ou.id;
                        })).addDataDimension(dataDimension).addPeriodFilter(period.id).withDisplayProperty(displayPropertyUpper);


                        if (Array.isArray(userOrgUnit) && userOrgUnit.length) {
                            orgUnitParams += '&userOrgUnit=' + userOrgUnit.join(';');
                            analyticsRequest = analyticsRequest.withUserOrgUnit(userOrgUnit.join(';'));
                        }

                        if (relativePeriodDate) {
                            analyticsRequest = analyticsRequest.withRelativePeriodDate(relativePeriodDate);
                        }

                        if (aggregationType) {
                            analyticsRequest = analyticsRequest.withAggregationType(aggregationType);
                        }

                        if (Array.isArray(userOrgUnit) && userOrgUnit.length) {
                            analyticsRequest = analyticsRequest.addUserOrgUnit(userOrgUnit.map(function (ou) {
                                return ou;
                            }));
                        }

                        if (isOperand) {
                            analyticsRequest = analyticsRequest.addDimension('co');
                        }

                        // Features request
                        orgUnitReq = d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayPropertyUpper).getAll().then(_map.toGeoJson);

                        // Data request

                        dataReq = d2.analytics.aggregate.get(analyticsRequest);

                        // Return promise with both requests

                        return _context3.abrupt('return', Promise.all([orgUnitReq, dataReq]));

                    case 21:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined);
    }));

    return function loadData(_x3) {
        return _ref8.apply(this, arguments);
    };
}();

exports.default = thematicLoader;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('findIndex', __webpack_require__(252));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(490),
    flatRest = __webpack_require__(152);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(234),
    hasIn = __webpack_require__(216);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(122),
    castPath = __webpack_require__(64),
    isIndex = __webpack_require__(63),
    isObject = __webpack_require__(26),
    toKey = __webpack_require__(46);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _uniqBy = __webpack_require__(493);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _d = __webpack_require__(19);

var _map = __webpack_require__(67);

var _analytics = __webpack_require__(32);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var colors = ['black', 'blue', 'red', 'green', 'yellow'];
var weights = [2, 1, 0.75, 0.5, 0.5];

var boundaryLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var rows, radiusLow, orgUnits, orgUnitParams, d2, displayProperty, features, levels, levelStyle;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        rows = config.rows, radiusLow = config.radiusLow;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        _context.next = 5;
                        return (0, _d.getInstance)();

                    case 5:
                        d2 = _context.sent;
                        displayProperty = (0, _helpers.getDisplayProperty)(d2).toUpperCase();
                        _context.next = 9;
                        return d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayProperty).getAll().then(_map.toGeoJson);

                    case 9:
                        features = _context.sent;

                        if (features.length) {
                            _context.next = 12;
                            break;
                        }

                        return _context.abrupt('return');

                    case 12:
                        levels = (0, _uniqBy2.default)(function (f) {
                            return f.properties.level;
                        }, features).map(function (f) {
                            return f.properties.level;
                        }).sort();
                        levelStyle = levels.reduce(function (obj, level, index) {
                            return _extends({}, obj, _defineProperty({}, level, {
                                color: colors[index],
                                weight: levels.length === 1 ? 1 : weights[index]
                            }));
                        }, {});


                        features.forEach(function (feature) {
                            feature.properties.style = levelStyle[feature.properties.level];
                            feature.properties.labelStyle = {
                                paddingTop: feature.geometry.type === 'Point' ? 5 + (radiusLow || 5) + 'px' : '0'
                            };
                            feature.properties.type = feature.geometry.type;
                        });

                        return _context.abrupt('return', _extends({}, config, {
                            data: features,
                            name: _i18next2.default.t('Boundaries'),
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 16:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function boundaryLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = boundaryLoader;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('uniqBy', __webpack_require__(494));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(38),
    baseUniq = __webpack_require__(258);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(205),
    noop = __webpack_require__(188),
    setToArray = __webpack_require__(136);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var externalLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        if ((0, _isString2.default)(config.config)) {
                            // From database as favorite
                            config.config = JSON.parse(config.config);
                            config.name = config.config.name;
                        }

                        return _context.abrupt('return', _extends({}, config, {
                            type: 'external',
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function externalLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = externalLoader;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearMessage = exports.setMessage = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Set snackbar message
var setMessage = exports.setMessage = function setMessage(message) {
    return {
        type: types.MESSAGE_SET,
        payload: message
    };
};

// Set snackbar message
var clearMessage = exports.clearMessage = function clearMessage() {
    return {
        type: types.MESSAGE_CLEAR
    };
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isNil', __webpack_require__(500), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('omitBy', __webpack_require__(502));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(38),
    negate = __webpack_require__(219),
    pickBy = __webpack_require__(503);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseIteratee = __webpack_require__(38),
    basePickBy = __webpack_require__(234),
    getAllKeysIn = __webpack_require__(151);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(507)('keys');
var uid = __webpack_require__(262);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(103);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(104);
var core = __webpack_require__(44);
var fails = __webpack_require__(157);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(809);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(156);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(810), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(812);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(823);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(144);
var dPs = __webpack_require__(816);
var enumBugKeys = __webpack_require__(517);
var IE_PROTO = __webpack_require__(506)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(595)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(819).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 516 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 517 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(105).f;
var has = __webpack_require__(143);
var TAG = __webpack_require__(69)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(820);
var global = __webpack_require__(103);
var hide = __webpack_require__(155);
var Iterators = __webpack_require__(158);
var TO_STRING_TAG = __webpack_require__(69)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(69);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(103);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(514);
var wksExt = __webpack_require__(520);
var defineProperty = __webpack_require__(105).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 522 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(264);
var createDesc = __webpack_require__(236);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(510);
var has = __webpack_require__(143);
var IE8_DOM_DEFINE = __webpack_require__(594);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(145) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(603);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports=function(modules){function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}var installedModules={};return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{configurable:!1,enumerable:!0,get:getter})},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=63)}([function(module,__webpack_exports__,__webpack_require__){"use strict";function newInterval(floori,offseti,count,field){function interval(date){return floori(date=new Date(+date)),date}return interval.floor=interval,interval.ceil=function(date){return floori(date=new Date(date-1)),offseti(date,1),floori(date),date},interval.round=function(date){var d0=interval(date),d1=interval.ceil(date);return date-d0<d1-date?d0:d1},interval.offset=function(date,step){return offseti(date=new Date(+date),null==step?1:Math.floor(step)),date},interval.range=function(start,stop,step){var range=[];if(start=interval.ceil(start),step=null==step?1:Math.floor(step),!(start<stop&&step>0))return range;do{range.push(new Date(+start))}while(offseti(start,step),floori(start),start<stop);return range},interval.filter=function(test){return newInterval(function(date){if(date>=date)for(;floori(date),!test(date);)date.setTime(date-1)},function(date,step){if(date>=date)for(;--step>=0;)for(;offseti(date,1),!test(date););})},count&&(interval.count=function(start,end){return t0.setTime(+start),t1.setTime(+end),floori(t0),floori(t1),Math.floor(count(t0,t1))},interval.every=function(step){return step=Math.floor(step),isFinite(step)&&step>0?step>1?interval.filter(field?function(d){return field(d)%step==0}:function(d){return interval.count(0,d)%step==0}):interval:null}),interval}__webpack_exports__.a=newInterval;var t0=new Date,t1=new Date},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_bisect__=__webpack_require__(31);__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_bisect__.a});var __WEBPACK_IMPORTED_MODULE_1__src_ascending__=__webpack_require__(5);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_1__src_ascending__.a});var __WEBPACK_IMPORTED_MODULE_2__src_bisector__=__webpack_require__(32);__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_2__src_bisector__.a});var __WEBPACK_IMPORTED_MODULE_18__src_quantile__=(__webpack_require__(86),__webpack_require__(87),__webpack_require__(34),__webpack_require__(36),__webpack_require__(88),__webpack_require__(91),__webpack_require__(92),__webpack_require__(40),__webpack_require__(93),__webpack_require__(94),__webpack_require__(95),__webpack_require__(96),__webpack_require__(41),__webpack_require__(33),__webpack_require__(97),__webpack_require__(18));__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_18__src_quantile__.a});var __WEBPACK_IMPORTED_MODULE_19__src_range__=__webpack_require__(38);__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_19__src_range__.a});var __WEBPACK_IMPORTED_MODULE_23__src_ticks__=(__webpack_require__(98),__webpack_require__(99),__webpack_require__(100),__webpack_require__(39));__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.a}),__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.b}),__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.c});__webpack_require__(42),__webpack_require__(35),__webpack_require__(101)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"d",function(){return durationSecond}),__webpack_require__.d(__webpack_exports__,"c",function(){return durationMinute}),__webpack_require__.d(__webpack_exports__,"b",function(){return durationHour}),__webpack_require__.d(__webpack_exports__,"a",function(){return durationDay}),__webpack_require__.d(__webpack_exports__,"e",function(){return durationWeek});var durationSecond=1e3,durationMinute=6e4,durationHour=36e5,durationDay=864e5,durationWeek=6048e5},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__src_color__=__webpack_require__(16);__webpack_require__.d(__webpack_exports__,"color",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.e}),__webpack_require__.d(__webpack_exports__,"rgb",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.g}),__webpack_require__.d(__webpack_exports__,"hsl",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.f});var __WEBPACK_IMPORTED_MODULE_1__src_lab__=__webpack_require__(83);__webpack_require__.d(__webpack_exports__,"lab",function(){return __WEBPACK_IMPORTED_MODULE_1__src_lab__.a}),__webpack_require__.d(__webpack_exports__,"hcl",function(){return __WEBPACK_IMPORTED_MODULE_1__src_lab__.b});var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__=__webpack_require__(84);__webpack_require__.d(__webpack_exports__,"cubehelix",function(){return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return map}),__webpack_require__.d(__webpack_exports__,"b",function(){return slice});var array=Array.prototype,map=array.map,slice=array.slice},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a<b?-1:a>b?1:a>=b?0:NaN}},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function geoJson(options){return new GeoJson(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.GeoJson=void 0,exports.default=geoJson;var _Label=__webpack_require__(72),_Label2=_interopRequireDefault(_Label),_polylabel=__webpack_require__(73),_polylabel2=_interopRequireDefault(_polylabel);__webpack_require__(75);var geojsonArea=__webpack_require__(76),GeoJson=exports.GeoJson=L.GeoJSON.extend({options:{highlightStyle:{weight:2},resetStyle:{weight:1}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.label&&(this._labels=L.layerGroup({margin:2})),L.GeoJSON.prototype.initialize.call(this,options.data,options)},addLayer:function(layer){var options=this.options,feature=layer.feature;if(options.label&&this.addLabel(layer,L.Util.template(options.label,feature.properties)),options.hoverLabel||options.label){var tooltip=L.Util.template(options.hoverLabel||options.label,feature.properties);layer.bindTooltip(tooltip,{sticky:!0})}!options.popup||options.popup instanceof Function||layer.bindPopup(L.Util.template(options.popup,feature.properties)),L.GeoJSON.prototype.addLayer.call(this,layer)},addLabel:function(layer,text){var prop=layer.feature.properties,geometry=layer.feature.geometry,labelStyle=L.extend(prop.labelStyle||{},this.options.labelStyle),latlng=this._getLabelLatlng(geometry);prop.style&&prop.style.color&&(labelStyle.color=prop.style.color),layer._label=(0,_Label2.default)(latlng,{html:text,position:"Point"===geometry.type?"below":"middle",labelStyle:labelStyle,pane:this.options.labelPane||"markerPane"}),this._labels.addLayer(layer._label)},setOpacity:function(opacity){this.setStyle({opacity:opacity,fillOpacity:opacity})},findById:function(id){for(var i in this._layers)if(this._layers[i].feature.id===id)return this._layers[i];return null},onAdd:function(map){L.GeoJSON.prototype.onAdd.call(this,map),this._labels&&map.addLayer(this._labels),this.options.highlightStyle&&(this.on("mouseover",this.onMouseOver,this),this.on("mouseout",this.onMouseOut,this)),this.options.contextmenu&&this.on("contextmenu",this.options.contextmenu),this.fire("ready")},onRemove:function(map){L.GeoJSON.prototype.onRemove.call(this,map),this._labels&&map.removeLayer(this._labels),this.options.highlightStyle&&(this.off("mouseover",this.onMouseOver,this),this.off("mouseout",this.onMouseOut,this)),this.options.contextmenu&&this.off("contextmenu",this.options.contextmenu)},onMouseOver:function(evt){evt.layer.setStyle(this.options.highlightStyle)},onMouseOut:function(evt){evt.layer.feature.isSelected||evt.layer.setStyle(this.options.resetStyle)},_getLabelLatlng:function(geometry){var coords=geometry.coordinates,biggestRing=void 0;if("Point"===geometry.type)return[coords[1],coords[0]];if("Polygon"===geometry.type)biggestRing=coords;else if("MultiPolygon"===geometry.type&&(biggestRing=coords[0],coords.length>1)){var biggestSize=0;coords.forEach(function(ring){var size=geojsonArea.ring(ring[0]);size>biggestSize&&(biggestRing=ring,biggestSize=size)})}return(0,_polylabel2.default)(biggestRing,2).reverse()}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return null===x?NaN:+x}},function(module,__webpack_exports__,__webpack_require__){"use strict";function linearish(scale){var domain=scale.domain;return scale.ticks=function(count){var d=domain();return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.h)(d[0],d[d.length-1],null==count?10:count)},scale.tickFormat=function(count,specifier){return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__.a)(domain(),count,specifier)},scale.nice=function(count){null==count&&(count=10);var step,d=domain(),i0=0,i1=d.length-1,start=d[i0],stop=d[i1];return stop<start&&(step=start,start=stop,stop=step,step=i0,i0=i1,i1=step),step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count),step>0?(start=Math.floor(start/step)*step,stop=Math.ceil(stop/step)*step,step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count)):step<0&&(start=Math.ceil(start*step)/step,stop=Math.floor(stop*step)/step,step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count)),step>0?(d[i0]=Math.floor(start/step)*step,d[i1]=Math.ceil(stop/step)*step,domain(d)):step<0&&(d[i0]=Math.ceil(start*step)/step,d[i1]=Math.floor(stop*step)/step,domain(d)),scale},scale}function linear(){var scale=Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.b)(__WEBPACK_IMPORTED_MODULE_2__continuous__.c,__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.b);return scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.a)(scale,linear())},linearish(scale)}__webpack_exports__.b=linearish,__webpack_exports__.a=linear;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2__continuous__=__webpack_require__(13),__WEBPACK_IMPORTED_MODULE_3__tickFormat__=__webpack_require__(119)},function(module,__webpack_exports__,__webpack_require__){"use strict";function linear(a,d){return function(t){return a+t*d}}function exponential(a,b,y){return a=Math.pow(a,y),b=Math.pow(b,y)-a,y=1/y,function(t){return Math.pow(a+t*b,y)}}function hue(a,b){var d=b-a;return d?linear(a,d>180||d<-180?d-360*Math.round(d/360):d):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}function gamma(y){return 1==(y=+y)?nogamma:function(a,b){return b-a?exponential(a,b,y):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}}function nogamma(a,b){var d=b-a;return d?linear(a,d):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}__webpack_exports__.c=hue,__webpack_exports__.b=gamma,__webpack_exports__.a=nogamma;var __WEBPACK_IMPORTED_MODULE_0__constant__=__webpack_require__(46)},function(module,exports){function cssWithMappingToString(item,useSourceMap){var content=item[1]||"",cssMapping=item[3];if(!cssMapping)return content;if(useSourceMap&&"function"==typeof btoa){var sourceMapping=toComment(cssMapping);return[content].concat(cssMapping.sources.map(function(source){return"/*# sourceURL="+cssMapping.sourceRoot+source+" */"})).concat([sourceMapping]).join("\n")}return[content].join("\n")}function toComment(sourceMap){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+" */"}module.exports=function(useSourceMap){var list=[];return list.toString=function(){return this.map(function(item){var content=cssWithMappingToString(item,useSourceMap);return item[2]?"@media "+item[2]+"{"+content+"}":content}).join("")},list.i=function(modules,mediaQuery){"string"==typeof modules&&(modules=[[null,modules,""]]);for(var alreadyImportedModules={},i=0;i<this.length;i++){var id=this[i][0];"number"==typeof id&&(alreadyImportedModules[id]=!0)}for(i=0;i<modules.length;i++){var item=modules[i];"number"==typeof item[0]&&alreadyImportedModules[item[0]]||(mediaQuery&&!item[2]?item[2]=mediaQuery:mediaQuery&&(item[2]="("+item[2]+") and ("+mediaQuery+")"),list.push(item))}},list}},function(module,exports,__webpack_require__){"use strict";function circleMarker(feature,options){return new CircleMarker(feature,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=circleMarker;var CircleMarker=exports.CircleMarker=L.CircleMarker.extend({options:{strokeColor:"#fff",weight:.5,radius:6},initialize:function(feature,opts){var options=L.setOptions(this,opts);options.fillColor=feature.properties.color||options.color,options.fillOpacity=options.opacity,options.color=options.strokeColor,this._feature=feature,this._latlng=L.GeoJSON.coordsToLatLng(feature.geometry.coordinates),this._radius=this.options.radius},getFeature:function(){return this._feature},showPopup:function(content){var popup=content||this.options.popup;"string"==typeof popup?this.bindPopup(L.Util.template(popup,this._feature.properties)).openPopup():popup instanceof Function&&popup(this._feature,L.bind(function(response){this.bindPopup(response).openPopup()},this))},setOpacity:function(opacity){this.setStyle({opacity:opacity,fillOpacity:opacity})}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a=+a,b-=a,function(t){return a+b*t}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function deinterpolateLinear(a,b){return(b-=a=+a)?function(x){return(x-a)/b}:Object(__WEBPACK_IMPORTED_MODULE_3__constant__.a)(b)}function deinterpolateClamp(deinterpolate){return function(a,b){var d=deinterpolate(a=+a,b=+b);return function(x){return x<=a?0:x>=b?1:d(x)}}}function reinterpolateClamp(reinterpolate){return function(a,b){var r=reinterpolate(a=+a,b=+b);return function(t){return t<=0?a:t>=1?b:r(t)}}}function bimap(domain,range,deinterpolate,reinterpolate){var d0=domain[0],d1=domain[1],r0=range[0],r1=range[1];return d1<d0?(d0=deinterpolate(d1,d0),r0=reinterpolate(r1,r0)):(d0=deinterpolate(d0,d1),r0=reinterpolate(r0,r1)),function(x){return r0(d0(x))}}function polymap(domain,range,deinterpolate,reinterpolate){var j=Math.min(domain.length,range.length)-1,d=new Array(j),r=new Array(j),i=-1;for(domain[j]<domain[0]&&(domain=domain.slice().reverse(),range=range.slice().reverse());++i<j;)d[i]=deinterpolate(domain[i],domain[i+1]),r[i]=reinterpolate(range[i],range[i+1]);return function(x){var i=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,1,j)-1;return r[i](d[i](x))}}function copy(source,target){return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp())}function continuous(deinterpolate,reinterpolate){function rescale(){return piecewise=Math.min(domain.length,range.length)>2?polymap:bimap,output=input=null,scale}function scale(x){return(output||(output=piecewise(domain,range,clamp?deinterpolateClamp(deinterpolate):deinterpolate,interpolate)))(+x)}var piecewise,output,input,domain=unit,range=unit,interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.a,clamp=!1;return scale.invert=function(y){return(input||(input=piecewise(range,domain,deinterpolateLinear,clamp?reinterpolateClamp(reinterpolate):reinterpolate)))(+y)},scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_2__array__.a.call(_,__WEBPACK_IMPORTED_MODULE_4__number__.a),rescale()):domain.slice()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_2__array__.b.call(_),rescale()):range.slice()},scale.rangeRound=function(_){return range=__WEBPACK_IMPORTED_MODULE_2__array__.b.call(_),interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.c,rescale()},scale.clamp=function(_){return arguments.length?(clamp=!!_,rescale()):clamp},scale.interpolate=function(_){return arguments.length?(interpolate=_,rescale()):interpolate},rescale()}__webpack_exports__.c=deinterpolateLinear,__webpack_exports__.a=copy,__webpack_exports__.b=continuous;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_3__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(51),unit=[0,1]},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x){return x=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(Math.abs(x)),x?x[1]:NaN}},function(module,exports){var g;g=function(){return this}();try{g=g||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(g=window)}module.exports=g},function(module,__webpack_exports__,__webpack_require__){"use strict";function Color(){}function color(format){var m;return format=(format+"").trim().toLowerCase(),(m=reHex3.exec(format))?(m=parseInt(m[1],16),new Rgb(m>>8&15|m>>4&240,m>>4&15|240&m,(15&m)<<4|15&m,1)):(m=reHex6.exec(format))?rgbn(parseInt(m[1],16)):(m=reRgbInteger.exec(format))?new Rgb(m[1],m[2],m[3],1):(m=reRgbPercent.exec(format))?new Rgb(255*m[1]/100,255*m[2]/100,255*m[3]/100,1):(m=reRgbaInteger.exec(format))?rgba(m[1],m[2],m[3],m[4]):(m=reRgbaPercent.exec(format))?rgba(255*m[1]/100,255*m[2]/100,255*m[3]/100,m[4]):(m=reHslPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,1):(m=reHslaPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,m[4]):named.hasOwnProperty(format)?rgbn(named[format]):"transparent"===format?new Rgb(NaN,NaN,NaN,0):null}function rgbn(n){return new Rgb(n>>16&255,n>>8&255,255&n,1)}function rgba(r,g,b,a){return a<=0&&(r=g=b=NaN),new Rgb(r,g,b,a)}function rgbConvert(o){return o instanceof Color||(o=color(o)),o?(o=o.rgb(),new Rgb(o.r,o.g,o.b,o.opacity)):new Rgb}function rgb(r,g,b,opacity){return 1===arguments.length?rgbConvert(r):new Rgb(r,g,b,null==opacity?1:opacity)}function Rgb(r,g,b,opacity){this.r=+r,this.g=+g,this.b=+b,this.opacity=+opacity}function hsla(h,s,l,a){return a<=0?h=s=l=NaN:l<=0||l>=1?h=s=NaN:s<=0&&(h=NaN),new Hsl(h,s,l,a)}function hslConvert(o){if(o instanceof Hsl)return new Hsl(o.h,o.s,o.l,o.opacity);if(o instanceof Color||(o=color(o)),!o)return new Hsl;if(o instanceof Hsl)return o;o=o.rgb();var r=o.r/255,g=o.g/255,b=o.b/255,min=Math.min(r,g,b),max=Math.max(r,g,b),h=NaN,s=max-min,l=(max+min)/2;return s?(h=r===max?(g-b)/s+6*(g<b):g===max?(b-r)/s+2:(r-g)/s+4,s/=l<.5?max+min:2-max-min,h*=60):s=l>0&&l<1?0:h,new Hsl(h,s,l,o.opacity)}function hsl(h,s,l,opacity){return 1===arguments.length?hslConvert(h):new Hsl(h,s,l,null==opacity?1:opacity)}function Hsl(h,s,l,opacity){this.h=+h,this.s=+s,this.l=+l,this.opacity=+opacity}function hsl2rgb(h,m1,m2){return 255*(h<60?m1+(m2-m1)*h/60:h<180?m2:h<240?m1+(m2-m1)*(240-h)/60:m1)}__webpack_exports__.a=Color,__webpack_require__.d(__webpack_exports__,"d",function(){return darker}),__webpack_require__.d(__webpack_exports__,"c",function(){return brighter}),__webpack_exports__.e=color,__webpack_exports__.h=rgbConvert,__webpack_exports__.g=rgb,__webpack_exports__.b=Rgb,__webpack_exports__.f=hsl;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),darker=.7,brighter=1/darker,reI="\\s*([+-]?\\d+)\\s*",reN="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",reP="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",reHex3=/^#([0-9a-f]{3})$/,reHex6=/^#([0-9a-f]{6})$/,reRgbInteger=new RegExp("^rgb\\("+[reI,reI,reI]+"\\)$"),reRgbPercent=new RegExp("^rgb\\("+[reP,reP,reP]+"\\)$"),reRgbaInteger=new RegExp("^rgba\\("+[reI,reI,reI,reN]+"\\)$"),reRgbaPercent=new RegExp("^rgba\\("+[reP,reP,reP,reN]+"\\)$"),reHslPercent=new RegExp("^hsl\\("+[reN,reP,reP]+"\\)$"),reHslaPercent=new RegExp("^hsla\\("+[reN,reP,reP,reN]+"\\)$"),named={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Rgb,rgb,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(Color,{brighter:function(k){return k=null==k?brighter:Math.pow(brighter,k),new Rgb(this.r*k,this.g*k,this.b*k,this.opacity)},darker:function(k){return k=null==k?darker:Math.pow(darker,k),new Rgb(this.r*k,this.g*k,this.b*k,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var a=this.opacity;return a=isNaN(a)?1:Math.max(0,Math.min(1,a)),(1===a?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===a?")":", "+a+")")}})),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Hsl,hsl,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(Color,{brighter:function(k){return k=null==k?brighter:Math.pow(brighter,k),new Hsl(this.h,this.s,this.l*k,this.opacity)},darker:function(k){return k=null==k?darker:Math.pow(darker,k),new Hsl(this.h,this.s,this.l*k,this.opacity)},rgb:function(){var h=this.h%360+360*(this.h<0),s=isNaN(h)||isNaN(this.s)?0:this.s,l=this.l,m2=l+(l<.5?l:1-l)*s,m1=2*l-m2;return new Rgb(hsl2rgb(h>=240?h-240:h+120,m1,m2),hsl2rgb(h,m1,m2),hsl2rgb(h<120?h+240:h-120,m1,m2),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function extend(parent,definition){var prototype=Object.create(parent.prototype);for(var key in definition)prototype[key]=definition[key];return prototype}__webpack_exports__.b=extend,__webpack_exports__.a=function(constructor,factory,prototype){constructor.prototype=factory.prototype=prototype,prototype.constructor=constructor}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(7);__webpack_exports__.a=function(values,p,valueof){if(null==valueof&&(valueof=__WEBPACK_IMPORTED_MODULE_0__number__.a),n=values.length){if((p=+p)<=0||n<2)return+valueof(values[0],0,values);if(p>=1)return+valueof(values[n-1],n-1,values);var n,i=(n-1)*p,i0=Math.floor(i),value0=+valueof(values[i0],i0,values);return value0+(+valueof(values[i0+1],i0+1,values)-value0)*(i-i0)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function Map(){}function map(object,f){var map=new Map;if(object instanceof Map)object.each(function(value,key){map.set(key,value)});else if(Array.isArray(object)){var o,i=-1,n=object.length;if(null==f)for(;++i<n;)map.set(i,object[i]);else for(;++i<n;)map.set(f(o=object[i],i,object),o)}else if(object)for(var key in object)map.set(key,object[key]);return map}__webpack_require__.d(__webpack_exports__,"b",function(){return prefix});var prefix="$";Map.prototype=map.prototype={constructor:Map,has:function(key){return prefix+key in this},get:function(key){return this[prefix+key]},set:function(key,value){return this[prefix+key]=value,this},remove:function(key){var property=prefix+key;return property in this&&delete this[property]},clear:function(){for(var property in this)property[0]===prefix&&delete this[property]},keys:function(){var keys=[];for(var property in this)property[0]===prefix&&keys.push(property.slice(1));return keys},values:function(){var values=[];for(var property in this)property[0]===prefix&&values.push(this[property]);return values},entries:function(){var entries=[];for(var property in this)property[0]===prefix&&entries.push({key:property.slice(1),value:this[property]});return entries},size:function(){var size=0;for(var property in this)property[0]===prefix&&++size;return size},empty:function(){for(var property in this)if(property[0]===prefix)return!1;return!0},each:function(f){for(var property in this)property[0]===prefix&&f(this[property],property.slice(1),this)}},__webpack_exports__.a=map},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_value__=__webpack_require__(21);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_value__.a});var __WEBPACK_IMPORTED_MODULE_5__src_number__=(__webpack_require__(47),__webpack_require__(22),__webpack_require__(45),__webpack_require__(48),__webpack_require__(12));__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_5__src_number__.a});var __WEBPACK_IMPORTED_MODULE_7__src_round__=(__webpack_require__(49),__webpack_require__(109));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_7__src_round__.a});__webpack_require__(50),__webpack_require__(110),__webpack_require__(113),__webpack_require__(44),__webpack_require__(114),__webpack_require__(115),__webpack_require__(116),__webpack_require__(117),__webpack_require__(118)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__rgb__=__webpack_require__(44),__WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(47),__WEBPACK_IMPORTED_MODULE_3__date__=__webpack_require__(48),__WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(12),__WEBPACK_IMPORTED_MODULE_5__object__=__webpack_require__(49),__WEBPACK_IMPORTED_MODULE_6__string__=__webpack_require__(50),__WEBPACK_IMPORTED_MODULE_7__constant__=__webpack_require__(46);__webpack_exports__.a=function(a,b){var c,t=typeof b;return null==b||"boolean"===t?Object(__WEBPACK_IMPORTED_MODULE_7__constant__.a)(b):("number"===t?__WEBPACK_IMPORTED_MODULE_4__number__.a:"string"===t?(c=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.color)(b))?(b=c,__WEBPACK_IMPORTED_MODULE_1__rgb__.a):__WEBPACK_IMPORTED_MODULE_6__string__.a:b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__.color?__WEBPACK_IMPORTED_MODULE_1__rgb__.a:b instanceof Date?__WEBPACK_IMPORTED_MODULE_3__date__.a:Array.isArray(b)?__WEBPACK_IMPORTED_MODULE_2__array__.a:isNaN(b)?__WEBPACK_IMPORTED_MODULE_5__object__.a:__WEBPACK_IMPORTED_MODULE_4__number__.a)(a,b)}},function(module,__webpack_exports__,__webpack_require__){"use strict";function basis(t1,v0,v1,v2,v3){var t2=t1*t1,t3=t2*t1;return((1-3*t1+3*t2-t3)*v0+(4-6*t2+3*t3)*v1+(1+3*t1+3*t2-3*t3)*v2+t3*v3)/6}__webpack_exports__.a=basis,__webpack_exports__.b=function(values){var n=values.length-1;return function(t){var i=t<=0?t=0:t>=1?(t=1,n-1):Math.floor(t*n),v1=values[i],v2=values[i+1],v0=i>0?values[i-1]:2*v1-v2,v3=i<n-1?values[i+2]:2*v2-v1;return basis((t-i/n)*n,v0,v1,v2,v3)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x,p){if((i=(x=p?x.toExponential(p-1):x.toExponential()).indexOf("e"))<0)return null;var i,coefficient=x.slice(0,i);return[coefficient.length>1?coefficient[0]+coefficient.slice(2):coefficient,+x.slice(i+1)]}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__=(__webpack_require__(0),__webpack_require__(132));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__.a}),__webpack_require__.d(__webpack_exports__,"m",function(){return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__.a});var __WEBPACK_IMPORTED_MODULE_2__src_second__=__webpack_require__(133);__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_2__src_second__.a}),__webpack_require__.d(__webpack_exports__,"q",function(){return __WEBPACK_IMPORTED_MODULE_2__src_second__.a});var __WEBPACK_IMPORTED_MODULE_3__src_minute__=__webpack_require__(134);__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_3__src_minute__.a});var __WEBPACK_IMPORTED_MODULE_4__src_hour__=__webpack_require__(135);__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_4__src_hour__.a});var __WEBPACK_IMPORTED_MODULE_5__src_day__=__webpack_require__(136);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_5__src_day__.a});var __WEBPACK_IMPORTED_MODULE_6__src_week__=__webpack_require__(137);__webpack_require__.d(__webpack_exports__,"i",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.b}),__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.b}),__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.a});var __WEBPACK_IMPORTED_MODULE_7__src_month__=__webpack_require__(138);__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_7__src_month__.a});var __WEBPACK_IMPORTED_MODULE_8__src_year__=__webpack_require__(139);__webpack_require__.d(__webpack_exports__,"j",function(){return __WEBPACK_IMPORTED_MODULE_8__src_year__.a});var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__=__webpack_require__(140);__webpack_require__.d(__webpack_exports__,"n",function(){return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__.a});var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__=__webpack_require__(141);__webpack_require__.d(__webpack_exports__,"l",function(){return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__.a});var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__=__webpack_require__(142);__webpack_require__.d(__webpack_exports__,"k",function(){return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__.a});var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__=__webpack_require__(143);__webpack_require__.d(__webpack_exports__,"s",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.b}),__webpack_require__.d(__webpack_exports__,"r",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.b}),__webpack_require__.d(__webpack_exports__,"o",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.a});var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__=__webpack_require__(144);__webpack_require__.d(__webpack_exports__,"p",function(){return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__.a});var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__=__webpack_require__(145);__webpack_require__.d(__webpack_exports__,"t",function(){return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return timeFormat}),__webpack_require__.d(__webpack_exports__,"b",function(){return utcFormat}),__webpack_require__.d(__webpack_exports__,"c",function(){return utcParse});var locale,timeFormat,timeParse,utcFormat,utcParse,__WEBPACK_IMPORTED_MODULE_0__locale__=__webpack_require__(60);!function(definition){locale=Object(__WEBPACK_IMPORTED_MODULE_0__locale__.a)(definition),timeFormat=locale.format,timeParse=locale.parse,utcFormat=locale.utcFormat,utcParse=locale.utcParse}({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(module,exports){module.exports=function(url){return"string"!=typeof url?url:(/^['"].*['"]$/.test(url)&&(url=url.slice(1,-1)),/["'() \t\n]/.test(url)?'"'+url.replace(/"/g,'\\"').replace(/\n/g,"\\n")+'"':url)}},function(module,exports,__webpack_require__){"use strict";function clusterIcon(options){return new ClusterIcon(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClusterIcon=void 0,exports.default=clusterIcon;var _d3Color=__webpack_require__(3),ClusterIcon=exports.ClusterIcon=L.Icon.extend({options:{className:"leaflet-cluster-icon"},createIcon:function(oldIcon){var options=this.options;return this._div=oldIcon&&"DIV"===oldIcon.tagName?oldIcon:document.createElement("div"),this.setSize(options.size),this.setCount(options.count),this.setColor(options.color),this.setOpacity(options.opacity),this._div},setSize:function(size){this.options.iconSize=[size,size],this._setIconStyles(this._div,"icon")},setCount:function(count){var num=void 0;count>=1e3&&count<9500?num=(count/1e3).toFixed(1)+"k":count>=9500&&count<999500?num=Math.round(count/1e3)+"k":count>=999500&&count<195e4?num=(count/1e6).toFixed(1)+"M":count>195e4&&(num=Math.round(count/1e6)+"M"),this._div.innerHTML="<span>"+(num||count)+"</span>"},setColor:function(color){this._div.style.background=color,this._div.style.color=(0,_d3Color.hcl)(color).l<70?"#fff":"#000"},setOpacity:function(opacity){this._div.style.opacity=opacity},createShadow:function(){return null}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return deg2rad}),__webpack_require__.d(__webpack_exports__,"b",function(){return rad2deg});var deg2rad=Math.PI/180,rad2deg=180/Math.PI},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__src_band__=__webpack_require__(85);__webpack_require__.d(__webpack_exports__,"scaleBand",function(){return __WEBPACK_IMPORTED_MODULE_0__src_band__.a}),__webpack_require__.d(__webpack_exports__,"scalePoint",function(){return __WEBPACK_IMPORTED_MODULE_0__src_band__.b});var __WEBPACK_IMPORTED_MODULE_1__src_identity__=__webpack_require__(108);__webpack_require__.d(__webpack_exports__,"scaleIdentity",function(){return __WEBPACK_IMPORTED_MODULE_1__src_identity__.a});var __WEBPACK_IMPORTED_MODULE_2__src_linear__=__webpack_require__(8);__webpack_require__.d(__webpack_exports__,"scaleLinear",function(){return __WEBPACK_IMPORTED_MODULE_2__src_linear__.a});var __WEBPACK_IMPORTED_MODULE_3__src_log__=__webpack_require__(127);__webpack_require__.d(__webpack_exports__,"scaleLog",function(){return __WEBPACK_IMPORTED_MODULE_3__src_log__.a});var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__=__webpack_require__(43);__webpack_require__.d(__webpack_exports__,"scaleOrdinal",function(){return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__.a}),__webpack_require__.d(__webpack_exports__,"scaleImplicit",function(){return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__.b});var __WEBPACK_IMPORTED_MODULE_5__src_pow__=__webpack_require__(128);__webpack_require__.d(__webpack_exports__,"scalePow",function(){return __WEBPACK_IMPORTED_MODULE_5__src_pow__.a}),__webpack_require__.d(__webpack_exports__,"scaleSqrt",function(){return __WEBPACK_IMPORTED_MODULE_5__src_pow__.b});var __WEBPACK_IMPORTED_MODULE_6__src_quantile__=__webpack_require__(129);__webpack_require__.d(__webpack_exports__,"scaleQuantile",function(){return __WEBPACK_IMPORTED_MODULE_6__src_quantile__.a});var __WEBPACK_IMPORTED_MODULE_7__src_quantize__=__webpack_require__(130);__webpack_require__.d(__webpack_exports__,"scaleQuantize",function(){return __WEBPACK_IMPORTED_MODULE_7__src_quantize__.a});var __WEBPACK_IMPORTED_MODULE_8__src_threshold__=__webpack_require__(131);__webpack_require__.d(__webpack_exports__,"scaleThreshold",function(){return __WEBPACK_IMPORTED_MODULE_8__src_threshold__.a});var __WEBPACK_IMPORTED_MODULE_9__src_time__=__webpack_require__(58);__webpack_require__.d(__webpack_exports__,"scaleTime",function(){return __WEBPACK_IMPORTED_MODULE_9__src_time__.b});var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__=__webpack_require__(147);__webpack_require__.d(__webpack_exports__,"scaleUtc",function(){return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__.a});var __WEBPACK_IMPORTED_MODULE_11__src_sequential__=__webpack_require__(148);__webpack_require__.d(__webpack_exports__,"scaleSequential",function(){return __WEBPACK_IMPORTED_MODULE_11__src_sequential__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(5),__WEBPACK_IMPORTED_MODULE_1__bisector__=__webpack_require__(32),ascendingBisect=Object(__WEBPACK_IMPORTED_MODULE_1__bisector__.a)(__WEBPACK_IMPORTED_MODULE_0__ascending__.a),bisectRight=ascendingBisect.right;ascendingBisect.left;__webpack_exports__.a=bisectRight},function(module,__webpack_exports__,__webpack_require__){"use strict";function ascendingComparator(f){return function(d,x){return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__.a)(f(d),x)}}var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(5);__webpack_exports__.a=function(compare){return 1===compare.length&&(compare=ascendingComparator(compare)),{left:function(a,x,lo,hi){for(null==lo&&(lo=0),null==hi&&(hi=a.length);lo<hi;){var mid=lo+hi>>>1;compare(a[mid],x)<0?lo=mid+1:hi=mid}return lo},right:function(a,x,lo,hi){for(null==lo&&(lo=0),null==hi&&(hi=a.length);lo<hi;){var mid=lo+hi>>>1;compare(a[mid],x)>0?hi=mid:lo=mid+1}return lo}}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function pair(a,b){return[a,b]}__webpack_exports__.a=pair},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__variance__=__webpack_require__(35);__webpack_exports__.a=function(array,f){var v=Object(__WEBPACK_IMPORTED_MODULE_0__variance__.a)(array,f);return v?Math.sqrt(v):v}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(7);__webpack_exports__.a=function(values,valueof){var value,delta,n=values.length,m=0,i=-1,mean=0,sum=0;if(null==valueof)for(;++i<n;)isNaN(value=Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(values[i]))||(delta=value-mean,mean+=delta/++m,sum+=delta*(value-mean));else for(;++i<n;)isNaN(value=Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(valueof(values[i],i,values)))||(delta=value-mean,mean+=delta/++m,sum+=delta*(value-mean));if(m>1)return sum/(m-1)}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values,valueof){var value,min,max,n=values.length,i=-1;if(null==valueof){for(;++i<n;)if(null!=(value=values[i])&&value>=value)for(min=max=value;++i<n;)null!=(value=values[i])&&(min>value&&(min=value),max<value&&(max=value))}else for(;++i<n;)if(null!=(value=valueof(values[i],i,values))&&value>=value)for(min=max=value;++i<n;)null!=(value=valueof(values[i],i,values))&&(min>value&&(min=value),max<value&&(max=value));return[min,max]}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return slice}),__webpack_require__.d(__webpack_exports__,"a",function(){return map});var array=Array.prototype,slice=array.slice,map=array.map},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(start,stop,step){start=+start,stop=+stop,step=(n=arguments.length)<2?(stop=start,start=0,1):n<3?1:+step;for(var i=-1,n=0|Math.max(0,Math.ceil((stop-start)/step)),range=new Array(n);++i<n;)range[i]=start+i*step;return range}},function(module,__webpack_exports__,__webpack_require__){"use strict";function tickIncrement(start,stop,count){var step=(stop-start)/Math.max(0,count),power=Math.floor(Math.log(step)/Math.LN10),error=step/Math.pow(10,power);return power>=0?(error>=e10?10:error>=e5?5:error>=e2?2:1)*Math.pow(10,power):-Math.pow(10,-power)/(error>=e10?10:error>=e5?5:error>=e2?2:1)}function tickStep(start,stop,count){var step0=Math.abs(stop-start)/Math.max(0,count),step1=Math.pow(10,Math.floor(Math.log(step0)/Math.LN10)),error=step0/step1;return error>=e10?step1*=10:error>=e5?step1*=5:error>=e2&&(step1*=2),stop<start?-step1:step1}__webpack_exports__.b=tickIncrement,__webpack_exports__.c=tickStep;var e10=Math.sqrt(50),e5=Math.sqrt(10),e2=Math.sqrt(2);__webpack_exports__.a=function(start,stop,count){var reverse,n,ticks,step,i=-1;if(stop=+stop,start=+start,count=+count,start===stop&&count>0)return[start];if((reverse=stop<start)&&(n=start,start=stop,stop=n),0===(step=tickIncrement(start,stop,count))||!isFinite(step))return[];if(step>0)for(start=Math.ceil(start/step),stop=Math.floor(stop/step),ticks=new Array(n=Math.ceil(stop-start+1));++i<n;)ticks[i]=(start+i)*step;else for(start=Math.floor(start*step),stop=Math.ceil(stop*step),ticks=new Array(n=Math.ceil(start-stop+1));++i<n;)ticks[i]=(start-i)/step;return reverse&&ticks.reverse(),ticks}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values){return Math.ceil(Math.log(values.length)/Math.LN2)+1}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values,valueof){var value,min,n=values.length,i=-1;if(null==valueof){for(;++i<n;)if(null!=(value=values[i])&&value>=value)for(min=value;++i<n;)null!=(value=values[i])&&min>value&&(min=value)}else for(;++i<n;)if(null!=(value=valueof(values[i],i,values))&&value>=value)for(min=value;++i<n;)null!=(value=valueof(values[i],i,values))&&min>value&&(min=value);return min}},function(module,__webpack_exports__,__webpack_require__){"use strict";function length(d){return d.length}var __WEBPACK_IMPORTED_MODULE_0__min__=__webpack_require__(41);__webpack_exports__.a=function(matrix){if(!(n=matrix.length))return[];for(var i=-1,m=Object(__WEBPACK_IMPORTED_MODULE_0__min__.a)(matrix,length),transpose=new Array(m);++i<m;)for(var n,j=-1,row=transpose[i]=new Array(n);++j<n;)row[j]=matrix[j][i];return transpose}},function(module,__webpack_exports__,__webpack_require__){"use strict";function ordinal(range){function scale(d){var key=d+"",i=index.get(key);if(!i){if(unknown!==implicit)return unknown;index.set(key,i=domain.push(d))}return range[(i-1)%range.length]}var index=Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__.a)(),domain=[],unknown=implicit;return range=null==range?[]:__WEBPACK_IMPORTED_MODULE_1__array__.b.call(range),scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[],index=Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__.a)();for(var d,key,i=-1,n=_.length;++i<n;)index.has(key=(d=_[i])+"")||index.set(key,domain.push(d));return scale},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),scale):range.slice()},scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown},scale.copy=function(){return ordinal().domain(domain).range(range).unknown(unknown)},scale}__webpack_require__.d(__webpack_exports__,"b",function(){return implicit}),__webpack_exports__.a=ordinal;var __WEBPACK_IMPORTED_MODULE_0_d3_collection__=__webpack_require__(102),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4),implicit={name:"implicit"}},function(module,__webpack_exports__,__webpack_require__){"use strict";function rgbSpline(spline){return function(colors){var i,color,n=colors.length,r=new Array(n),g=new Array(n),b=new Array(n);for(i=0;i<n;++i)color=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(colors[i]),r[i]=color.r||0,g[i]=color.g||0,b[i]=color.b||0;return r=spline(r),g=spline(g),b=spline(b),color.opacity=1,function(t){return color.r=r(t),color.g=g(t),color.b=b(t),color+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__basis__=__webpack_require__(22),__WEBPACK_IMPORTED_MODULE_2__basisClosed__=__webpack_require__(45),__WEBPACK_IMPORTED_MODULE_3__color__=__webpack_require__(9);__webpack_exports__.a=function rgbGamma(y){function rgb(start,end){var r=color((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(start)).r,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(end)).r),g=color(start.g,end.g),b=color(start.b,end.b),opacity=Object(__WEBPACK_IMPORTED_MODULE_3__color__.a)(start.opacity,end.opacity);return function(t){return start.r=r(t),start.g=g(t),start.b=b(t),start.opacity=opacity(t),start+""}}var color=Object(__WEBPACK_IMPORTED_MODULE_3__color__.b)(y);return rgb.gamma=rgbGamma,rgb}(1);rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__.b),rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__basis__=__webpack_require__(22);__webpack_exports__.a=function(values){var n=values.length;return function(t){var i=Math.floor(((t%=1)<0?++t:t)*n),v0=values[(i+n-1)%n],v1=values[i%n],v2=values[(i+1)%n],v3=values[(i+2)%n];return Object(__WEBPACK_IMPORTED_MODULE_0__basis__.a)((t-i/n)*n,v0,v1,v2,v3)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(21);__webpack_exports__.a=function(a,b){var i,nb=b?b.length:0,na=a?Math.min(nb,a.length):0,x=new Array(nb),c=new Array(nb);for(i=0;i<na;++i)x[i]=Object(__WEBPACK_IMPORTED_MODULE_0__value__.a)(a[i],b[i]);for(;i<nb;++i)c[i]=b[i];return function(t){for(i=0;i<na;++i)c[i]=x[i](t);return c}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){var d=new Date;return a=+a,b-=a,function(t){return d.setTime(a+b*t),d}}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(21);__webpack_exports__.a=function(a,b){var k,i={},c={};null!==a&&"object"==typeof a||(a={}),null!==b&&"object"==typeof b||(b={});for(k in b)k in a?i[k]=Object(__WEBPACK_IMPORTED_MODULE_0__value__.a)(a[k],b[k]):c[k]=b[k];return function(t){for(k in i)c[k]=i[k](t);return c}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function zero(b){return function(){return b}}function one(b){return function(t){return b(t)+""}}var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12),reA=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,reB=new RegExp(reA.source,"g");__webpack_exports__.a=function(a,b){var am,bm,bs,bi=reA.lastIndex=reB.lastIndex=0,i=-1,s=[],q=[];for(a+="",b+="";(am=reA.exec(a))&&(bm=reB.exec(b));)(bs=bm.index)>bi&&(bs=b.slice(bi,bs),s[i]?s[i]+=bs:s[++i]=bs),(am=am[0])===(bm=bm[0])?s[i]?s[i]+=bm:s[++i]=bm:(s[++i]=null,q.push({i:i,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(am,bm)})),bi=reB.lastIndex;return bi<b.length&&(bs=b.slice(bi),s[i]?s[i]+=bs:s[++i]=bs),s.length<2?q[0]?one(q[0].x):zero(b):(b=q.length,function(t){for(var o,i=0;i<b;++i)s[(o=q[i]).i]=o.x(t);return s.join("")})}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return+x}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__=__webpack_require__(120);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.a}),__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.b});var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__=(__webpack_require__(53),__webpack_require__(54));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__.a});var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__=__webpack_require__(124);__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__.a});var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__=__webpack_require__(125);__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__.a});var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__=__webpack_require__(126);__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";function identity(x){return x}var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14),__WEBPACK_IMPORTED_MODULE_1__formatGroup__=__webpack_require__(121),__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__=__webpack_require__(54),__WEBPACK_IMPORTED_MODULE_3__formatTypes__=__webpack_require__(55),__WEBPACK_IMPORTED_MODULE_4__formatPrefixAuto__=__webpack_require__(56),prefixes=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];__webpack_exports__.a=function(locale){function newFormat(specifier){function format(value){var i,n,c,valuePrefix=prefix,valueSuffix=suffix;if("c"===type)valueSuffix=formatType(value)+valueSuffix,value="";else{value=+value;var valueNegative=(value<0||1/value<0)&&(value*=-1,!0);if(value=formatType(value,precision),valueNegative)for(i=-1,n=value.length,valueNegative=!1;++i<n;)if(48<(c=value.charCodeAt(i))&&c<58||"x"===type&&96<c&&c<103||"X"===type&&64<c&&c<71){valueNegative=!0;break}if(valuePrefix=(valueNegative?"("===sign?sign:"-":"-"===sign||"("===sign?"":sign)+valuePrefix,valueSuffix=valueSuffix+("s"===type?prefixes[8+__WEBPACK_IMPORTED_MODULE_4__formatPrefixAuto__.b/3]:"")+(valueNegative&&"("===sign?")":""),maybeSuffix)for(i=-1,n=value.length;++i<n;)if(48>(c=value.charCodeAt(i))||c>57){valueSuffix=(46===c?decimal+value.slice(i+1):value.slice(i))+valueSuffix,value=value.slice(0,i);break}}comma&&!zero&&(value=group(value,1/0));var length=valuePrefix.length+value.length+valueSuffix.length,padding=length<width?new Array(width-length+1).join(fill):"";switch(comma&&zero&&(value=group(padding+value,padding.length?width-valueSuffix.length:1/0),padding=""),align){case"<":return valuePrefix+value+valueSuffix+padding;case"=":return valuePrefix+padding+value+valueSuffix;case"^":return padding.slice(0,length=padding.length>>1)+valuePrefix+value+valueSuffix+padding.slice(length)}return padding+valuePrefix+value+valueSuffix}specifier=Object(__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__.a)(specifier);var fill=specifier.fill,align=specifier.align,sign=specifier.sign,symbol=specifier.symbol,zero=specifier.zero,width=specifier.width,comma=specifier.comma,precision=specifier.precision,type=specifier.type,prefix="$"===symbol?currency[0]:"#"===symbol&&/[boxX]/.test(type)?"0"+type.toLowerCase():"",suffix="$"===symbol?currency[1]:/[%p]/.test(type)?"%":"",formatType=__WEBPACK_IMPORTED_MODULE_3__formatTypes__.a[type],maybeSuffix=!type||/[defgprs%]/.test(type);return precision=null==precision?type?6:12:/[gprs]/.test(type)?Math.max(1,Math.min(21,precision)):Math.max(0,Math.min(20,precision)),format.toString=function(){return specifier+""},format}function formatPrefix(specifier,value){var f=newFormat((specifier=Object(__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__.a)(specifier),specifier.type="f",specifier)),e=3*Math.max(-8,Math.min(8,Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(value)/3))),k=Math.pow(10,-e),prefix=prefixes[8+e/3];return function(value){return f(k*value)+prefix}}var group=locale.grouping&&locale.thousands?Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__.a)(locale.grouping,locale.thousands):identity,currency=locale.currency,decimal=locale.decimal;return{format:newFormat,formatPrefix:formatPrefix}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function FormatSpecifier(specifier){if(!(match=re.exec(specifier)))throw new Error("invalid format: "+specifier);var match,fill=match[1]||" ",align=match[2]||">",sign=match[3]||"-",symbol=match[4]||"",zero=!!match[5],width=match[6]&&+match[6],comma=!!match[7],precision=match[8]&&+match[8].slice(1),type=match[9]||"";"n"===type?(comma=!0,type="g"):__WEBPACK_IMPORTED_MODULE_0__formatTypes__.a[type]||(type=""),(zero||"0"===fill&&"="===align)&&(zero=!0,fill="0",align="="),this.fill=fill,this.align=align,this.sign=sign,this.symbol=symbol,this.zero=zero,this.width=width,this.comma=comma,this.precision=precision,this.type=type}var __WEBPACK_IMPORTED_MODULE_0__formatTypes__=__webpack_require__(55),re=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;__webpack_exports__.a=function(specifier){return new FormatSpecifier(specifier)},FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDefault__=__webpack_require__(122),__WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__=__webpack_require__(56),__WEBPACK_IMPORTED_MODULE_2__formatRounded__=__webpack_require__(123);__webpack_exports__.a={"":__WEBPACK_IMPORTED_MODULE_0__formatDefault__.a,"%":function(x,p){return(100*x).toFixed(p)},b:function(x){return Math.round(x).toString(2)},c:function(x){return x+""},d:function(x){return Math.round(x).toString(10)},e:function(x,p){return x.toExponential(p)},f:function(x,p){return x.toFixed(p)},g:function(x,p){return x.toPrecision(p)},o:function(x){return Math.round(x).toString(8)},p:function(x,p){return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__.a)(100*x,p)},r:__WEBPACK_IMPORTED_MODULE_2__formatRounded__.a,s:__WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__.a,X:function(x){return Math.round(x).toString(16).toUpperCase()},x:function(x){return Math.round(x).toString(16)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return prefixExponent});var prefixExponent,__WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x,p){var d=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1],i=exponent-(prefixExponent=3*Math.max(-8,Math.min(8,Math.floor(exponent/3))))+1,n=coefficient.length;return i===n?coefficient:i>n?coefficient+new Array(i-n+1).join("0"):i>0?coefficient.slice(0,i)+"."+coefficient.slice(i):"0."+new Array(1-i).join("0")+Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,Math.max(0,p+i-1))[0]}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(domain,interval){domain=domain.slice();var t,i0=0,i1=domain.length-1,x0=domain[i0],x1=domain[i1];return x1<x0&&(t=i0,i0=i1,i1=t,t=x0,x0=x1,x1=t),domain[i0]=interval.floor(x0),domain[i1]=interval.ceil(x1),domain}},function(module,__webpack_exports__,__webpack_require__){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(year,month,week,day,hour,minute,second,millisecond,format){function tickFormat(date){return(second(date)<date?formatMillisecond:minute(date)<date?formatSecond:hour(date)<date?formatMinute:day(date)<date?formatHour:month(date)<date?week(date)<date?formatDay:formatWeek:year(date)<date?formatMonth:formatYear)(date)}function tickInterval(interval,start,stop,step){if(null==interval&&(interval=10),"number"==typeof interval){var target=Math.abs(stop-start)/interval,i=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.c)(function(i){return i[2]}).right(tickIntervals,target);i===tickIntervals.length?(step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start/durationYear,stop/durationYear,interval),interval=year):i?(i=tickIntervals[target/tickIntervals[i-1][2]<tickIntervals[i][2]/target?i-1:i],step=i[1],interval=i[0]):(step=Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start,stop,interval),1),interval=millisecond)}return null==step?interval:interval.every(step)}var scale=Object(__WEBPACK_IMPORTED_MODULE_5__continuous__.b)(__WEBPACK_IMPORTED_MODULE_5__continuous__.c,__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.b),invert=scale.invert,domain=scale.domain,formatMillisecond=format(".%L"),formatSecond=format(":%S"),formatMinute=format("%I:%M"),formatHour=format("%I %p"),formatDay=format("%a %d"),formatWeek=format("%b %d"),formatMonth=format("%B"),formatYear=format("%Y"),tickIntervals=[[second,1,durationSecond],[second,5,5*durationSecond],[second,15,15*durationSecond],[second,30,30*durationSecond],[minute,1,durationMinute],[minute,5,5*durationMinute],[minute,15,15*durationMinute],[minute,30,30*durationMinute],[hour,1,durationHour],[hour,3,3*durationHour],[hour,6,6*durationHour],[hour,12,12*durationHour],[day,1,durationDay],[day,2,2*durationDay],[week,1,durationWeek],[month,1,durationMonth],[month,3,3*durationMonth],[year,1,durationYear]];return scale.invert=function(y){return new Date(invert(y))},scale.domain=function(_){return arguments.length?domain(__WEBPACK_IMPORTED_MODULE_4__array__.a.call(_,number)):domain().map(date)},scale.ticks=function(interval,step){var t,d=domain(),t0=d[0],t1=d[d.length-1],r=t1<t0;return r&&(t=t0,t0=t1,t1=t),t=tickInterval(interval,t0,t1,step),t=t?t.range(t0,t1+1):[],r?t.reverse():t},scale.tickFormat=function(count,specifier){return null==specifier?tickFormat:format(specifier)},scale.nice=function(interval,step){var d=domain();return(interval=tickInterval(interval,d[0],d[d.length-1],step))?domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__.a)(d,interval)):scale},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__.a)(scale,calendar(year,month,week,day,hour,minute,second,millisecond,format))},scale}__webpack_exports__.a=calendar;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2_d3_time__=__webpack_require__(25),__WEBPACK_IMPORTED_MODULE_3_d3_time_format__=__webpack_require__(59),__WEBPACK_IMPORTED_MODULE_4__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_5__continuous__=__webpack_require__(13),__WEBPACK_IMPORTED_MODULE_6__nice__=__webpack_require__(57),durationSecond=1e3,durationMinute=60*durationSecond,durationHour=60*durationMinute,durationDay=24*durationHour,durationWeek=7*durationDay,durationMonth=30*durationDay,durationYear=365*durationDay;__webpack_exports__.b=function(){return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__.j,__WEBPACK_IMPORTED_MODULE_2_d3_time__.f,__WEBPACK_IMPORTED_MODULE_2_d3_time__.i,__WEBPACK_IMPORTED_MODULE_2_d3_time__.a,__WEBPACK_IMPORTED_MODULE_2_d3_time__.b,__WEBPACK_IMPORTED_MODULE_2_d3_time__.d,__WEBPACK_IMPORTED_MODULE_2_d3_time__.g,__WEBPACK_IMPORTED_MODULE_2_d3_time__.c,__WEBPACK_IMPORTED_MODULE_3_d3_time_format__.a).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__=__webpack_require__(26);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.a}),__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.b});__webpack_require__(60),__webpack_require__(61),__webpack_require__(146)},function(module,__webpack_exports__,__webpack_require__){"use strict";function localDate(d){if(0<=d.y&&d.y<100){var date=new Date(-1,d.m,d.d,d.H,d.M,d.S,d.L);return date.setFullYear(d.y),date}return new Date(d.y,d.m,d.d,d.H,d.M,d.S,d.L)}function utcDate(d){if(0<=d.y&&d.y<100){var date=new Date(Date.UTC(-1,d.m,d.d,d.H,d.M,d.S,d.L));return date.setUTCFullYear(d.y),date}return new Date(Date.UTC(d.y,d.m,d.d,d.H,d.M,d.S,d.L))}function newYear(y){return{y:y,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(locale){function newFormat(specifier,formats){return function(date){var c,pad,format,string=[],i=-1,j=0,n=specifier.length;for(date instanceof Date||(date=new Date(+date));++i<n;)37===specifier.charCodeAt(i)&&(string.push(specifier.slice(j,i)),null!=(pad=pads[c=specifier.charAt(++i)])?c=specifier.charAt(++i):pad="e"===c?" ":"0",(format=formats[c])&&(c=format(date,pad)),string.push(c),j=i+1);return string.push(specifier.slice(j,i)),string.join("")}}function newParse(specifier,newDate){return function(string){var d=newYear(1900);if(parseSpecifier(d,specifier,string+="",0)!=string.length)return null;if("p"in d&&(d.H=d.H%12+12*d.p),"W"in d||"U"in d){"w"in d||(d.w="W"in d?1:0);var day="Z"in d?utcDate(newYear(d.y)).getUTCDay():newDate(newYear(d.y)).getDay();d.m=0,d.d="W"in d?(d.w+6)%7+7*d.W-(day+5)%7:d.w+7*d.U-(day+6)%7}return"Z"in d?(d.H+=d.Z/100|0,d.M+=d.Z%100,utcDate(d)):newDate(d)}}function parseSpecifier(d,specifier,string,j){for(var c,parse,i=0,n=specifier.length,m=string.length;i<n;){if(j>=m)return-1;if(37===(c=specifier.charCodeAt(i++))){if(c=specifier.charAt(i++),!(parse=parses[c in pads?specifier.charAt(i++):c])||(j=parse(d,string,j))<0)return-1}else if(c!=string.charCodeAt(j++))return-1}return j}function parsePeriod(d,string,i){var n=periodRe.exec(string.slice(i));return n?(d.p=periodLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseShortWeekday(d,string,i){var n=shortWeekdayRe.exec(string.slice(i));return n?(d.w=shortWeekdayLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseWeekday(d,string,i){var n=weekdayRe.exec(string.slice(i));return n?(d.w=weekdayLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseShortMonth(d,string,i){var n=shortMonthRe.exec(string.slice(i));return n?(d.m=shortMonthLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseMonth(d,string,i){var n=monthRe.exec(string.slice(i));return n?(d.m=monthLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseLocaleDateTime(d,string,i){return parseSpecifier(d,locale_dateTime,string,i)}function parseLocaleDate(d,string,i){return parseSpecifier(d,locale_date,string,i)}function parseLocaleTime(d,string,i){return parseSpecifier(d,locale_time,string,i)}function formatShortWeekday(d){return locale_shortWeekdays[d.getDay()]}function formatWeekday(d){return locale_weekdays[d.getDay()]}function formatShortMonth(d){return locale_shortMonths[d.getMonth()]}function formatMonth(d){return locale_months[d.getMonth()]}function formatPeriod(d){return locale_periods[+(d.getHours()>=12)]}function formatUTCShortWeekday(d){return locale_shortWeekdays[d.getUTCDay()]}function formatUTCWeekday(d){return locale_weekdays[d.getUTCDay()]}function formatUTCShortMonth(d){return locale_shortMonths[d.getUTCMonth()]}function formatUTCMonth(d){return locale_months[d.getUTCMonth()]}function formatUTCPeriod(d){return locale_periods[+(d.getUTCHours()>=12)]}var locale_dateTime=locale.dateTime,locale_date=locale.date,locale_time=locale.time,locale_periods=locale.periods,locale_weekdays=locale.days,locale_shortWeekdays=locale.shortDays,locale_months=locale.months,locale_shortMonths=locale.shortMonths,periodRe=formatRe(locale_periods),periodLookup=formatLookup(locale_periods),weekdayRe=formatRe(locale_weekdays),weekdayLookup=formatLookup(locale_weekdays),shortWeekdayRe=formatRe(locale_shortWeekdays),shortWeekdayLookup=formatLookup(locale_shortWeekdays),monthRe=formatRe(locale_months),monthLookup=formatLookup(locale_months),shortMonthRe=formatRe(locale_shortMonths),shortMonthLookup=formatLookup(locale_shortMonths),formats={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},utcFormats={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},parses={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return formats.x=newFormat(locale_date,formats),formats.X=newFormat(locale_time,formats),formats.c=newFormat(locale_dateTime,formats),utcFormats.x=newFormat(locale_date,utcFormats),utcFormats.X=newFormat(locale_time,utcFormats),utcFormats.c=newFormat(locale_dateTime,utcFormats),{format:function(specifier){var f=newFormat(specifier+="",formats);return f.toString=function(){return specifier},f},parse:function(specifier){var p=newParse(specifier+="",localDate);return p.toString=function(){return specifier},p},utcFormat:function(specifier){var f=newFormat(specifier+="",utcFormats);return f.toString=function(){return specifier},f},utcParse:function(specifier){var p=newParse(specifier,utcDate);return p.toString=function(){return specifier},p}}}function pad(value,fill,width){var sign=value<0?"-":"",string=(sign?-value:value)+"",length=string.length;return sign+(length<width?new Array(width-length+1).join(fill)+string:string)}function requote(s){return s.replace(requoteRe,"\\$&")}function formatRe(names){return new RegExp("^(?:"+names.map(requote).join("|")+")","i")}function formatLookup(names){for(var map={},i=-1,n=names.length;++i<n;)map[names[i].toLowerCase()]=i;return map}function parseWeekdayNumber(d,string,i){var n=numberRe.exec(string.slice(i,i+1));return n?(d.w=+n[0],i+n[0].length):-1}function parseWeekNumberSunday(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.U=+n[0],i+n[0].length):-1}function parseWeekNumberMonday(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.W=+n[0],i+n[0].length):-1}function parseFullYear(d,string,i){var n=numberRe.exec(string.slice(i,i+4));return n?(d.y=+n[0],i+n[0].length):-1}function parseYear(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.y=+n[0]+(+n[0]>68?1900:2e3),i+n[0].length):-1}function parseZone(d,string,i){var n=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i,i+6));return n?(d.Z=n[1]?0:-(n[2]+(n[3]||"00")),i+n[0].length):-1}function parseMonthNumber(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.m=n[0]-1,i+n[0].length):-1}function parseDayOfMonth(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.d=+n[0],i+n[0].length):-1}function parseDayOfYear(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.m=0,d.d=+n[0],i+n[0].length):-1}function parseHour24(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.H=+n[0],i+n[0].length):-1}function parseMinutes(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.M=+n[0],i+n[0].length):-1}function parseSeconds(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.S=+n[0],i+n[0].length):-1}function parseMilliseconds(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.L=+n[0],i+n[0].length):-1}function parseLiteralPercent(d,string,i){var n=percentRe.exec(string.slice(i,i+1));return n?i+n[0].length:-1}function formatDayOfMonth(d,p){return pad(d.getDate(),p,2)}function formatHour24(d,p){return pad(d.getHours(),p,2)}function formatHour12(d,p){return pad(d.getHours()%12||12,p,2)}function formatDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__.a.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,3)}function formatMilliseconds(d,p){return pad(d.getMilliseconds(),p,3)}function formatMonthNumber(d,p){return pad(d.getMonth()+1,p,2)}function formatMinutes(d,p){return pad(d.getMinutes(),p,2)}function formatSeconds(d,p){return pad(d.getSeconds(),p,2)}function formatWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.h.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,2)}function formatWeekdayNumber(d){return d.getDay()}function formatWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.e.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,2)}function formatYear(d,p){return pad(d.getFullYear()%100,p,2)}function formatFullYear(d,p){return pad(d.getFullYear()%1e4,p,4)}function formatZone(d){var z=d.getTimezoneOffset();return(z>0?"-":(z*=-1,"+"))+pad(z/60|0,"0",2)+pad(z%60,"0",2)}function formatUTCDayOfMonth(d,p){return pad(d.getUTCDate(),p,2)}function formatUTCHour24(d,p){return pad(d.getUTCHours(),p,2)}function formatUTCHour12(d,p){return pad(d.getUTCHours()%12||12,p,2)}function formatUTCDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__.k.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,3)}function formatUTCMilliseconds(d,p){return pad(d.getUTCMilliseconds(),p,3)}function formatUTCMonthNumber(d,p){return pad(d.getUTCMonth()+1,p,2)}function formatUTCMinutes(d,p){return pad(d.getUTCMinutes(),p,2)}function formatUTCSeconds(d,p){return pad(d.getUTCSeconds(),p,2)}function formatUTCWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.r.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,2)}function formatUTCWeekdayNumber(d){return d.getUTCDay()}function formatUTCWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.o.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,2)}function formatUTCYear(d,p){return pad(d.getUTCFullYear()%100,p,2)}function formatUTCFullYear(d,p){return pad(d.getUTCFullYear()%1e4,p,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}__webpack_exports__.a=formatLocale;var __WEBPACK_IMPORTED_MODULE_0_d3_time__=__webpack_require__(25),pads={"-":"",_:" ",0:"0"},numberRe=/^\s*\d+/,percentRe=/^%/,requoteRe=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(module,__webpack_exports__,__webpack_require__){"use strict";function formatIsoNative(date){return date.toISOString()}__webpack_require__.d(__webpack_exports__,"a",function(){return isoSpecifier});var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__=__webpack_require__(26),isoSpecifier="%Y-%m-%dT%H:%M:%S.%LZ";Date.prototype.toISOString||Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__.b)(isoSpecifier)},function(module,exports){module.exports=function(src){function log(error){"undefined"!=typeof console&&(console.error||console.log)("[Script Loader]",error)}try{"undefined"!=typeof execScript&&function(){return"undefined"!=typeof attachEvent&&"undefined"==typeof addEventListener}()?execScript(src):"undefined"!=typeof eval?eval.call(null,src):log("EvalError: No eval function available")}catch(error){log(error)}}},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var _Map=__webpack_require__(64),_Map2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_Map);__webpack_require__(159),__webpack_require__(184),__webpack_require__(186),exports.default=_Map2.default},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function map(id,options){return new D2Map(id,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.D2Map=void 0,exports.default=map;var _leaflet=__webpack_require__(65),_leaflet2=_interopRequireDefault(_leaflet),_TileLayer=__webpack_require__(67),_TileLayer2=_interopRequireDefault(_TileLayer),_WmsLayer=__webpack_require__(68),_WmsLayer2=_interopRequireDefault(_WmsLayer),_GoogleLayer=__webpack_require__(69),_GoogleLayer2=_interopRequireDefault(_GoogleLayer),_Boundary=__webpack_require__(71),_Boundary2=_interopRequireDefault(_Boundary),_Dots=__webpack_require__(78),_Dots2=_interopRequireDefault(_Dots),_Markers=__webpack_require__(79),_Markers2=_interopRequireDefault(_Markers),_Circles=__webpack_require__(80),_Circles2=_interopRequireDefault(_Circles),_Choropleth=__webpack_require__(81),_Choropleth2=_interopRequireDefault(_Choropleth),_ClientCluster=__webpack_require__(82),_ClientCluster2=_interopRequireDefault(_ClientCluster),_ServerCluster=__webpack_require__(150),_ServerCluster2=_interopRequireDefault(_ServerCluster),_EarthEngine=__webpack_require__(152),_EarthEngine2=_interopRequireDefault(_EarthEngine),_Legend=__webpack_require__(153),_Legend2=_interopRequireDefault(_Legend),_FitBounds=__webpack_require__(154),_FitBounds2=_interopRequireDefault(_FitBounds),_Search=__webpack_require__(155),_Search2=_interopRequireDefault(_Search),_Measure=__webpack_require__(157),_Measure2=_interopRequireDefault(_Measure),D2Map=exports.D2Map=_leaflet2.default.Map.extend({options:{className:"leaflet-dhis2",layerTypes:{tileLayer:_TileLayer2.default,wmsLayer:_WmsLayer2.default,googleLayer:_GoogleLayer2.default,boundary:_Boundary2.default,dots:_Dots2.default,markers:_Markers2.default,circles:_Circles2.default,choropleth:_Choropleth2.default,clientCluster:_ClientCluster2.default,serverCluster:_ServerCluster2.default,earthEngine:_EarthEngine2.default},controlTypes:{legend:_Legend2.default,fitBounds:_FitBounds2.default,search:_Search2.default,measure:_Measure2.default},zoomControl:!1,controls:[],worldCopyJump:!0,maxZoom:18},initialize:function(id,opts){var options=_leaflet2.default.setOptions(this,opts);this._baseLayers={},this._overlays={},_leaflet2.default.Map.prototype.initialize.call(this,id,options),this.attributionControl.setPrefix(""),_leaflet2.default.DomUtil.addClass(this.getContainer(),options.className),_leaflet2.default.Icon.Default.imagePath="/images/",this.on("mousedown",function(e){e.originalEvent.stopPropagation()}),options.bounds&&this.fitBounds(options.bounds);for(var control in options.controls)options.controls.hasOwnProperty(control)&&this.addControl(control)},addLayer:function(layer){var layerTypes=this.options.layerTypes,newLayer=layer;return layer.type&&layerTypes[layer.type]&&(newLayer=this.createLayer(layer),!0===layer.baseLayer?this._baseLayers[layer.name]=newLayer:!0===layer.overlay&&(this._overlays[layer.name]=newLayer)),_leaflet2.default.Map.prototype.addLayer.call(this,newLayer),newLayer},createLayer:function(layer){return this.options.layerTypes[layer.type](layer)},addControl:function(control){var controlTypes=this.options.controlTypes,newControl=control;return control.type&&controlTypes[control.type]?newControl=controlTypes[control.type](control):control.type&&_leaflet2.default.control[control.type]&&(newControl=_leaflet2.default.control[control.type](control)),_leaflet2.default.Map.prototype.addControl.call(this,newControl),newControl},getLayersBounds:function(){var bounds=new _leaflet2.default.LatLngBounds;return this.eachLayer(function(layer){layer.getBounds&&"circles"!==layer.options.type&&bounds.extend(layer.getBounds())}),bounds}})},function(module,exports,__webpack_require__){(function(global){module.exports=global.L=__webpack_require__(66)}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){/* @preserve
 * Leaflet 1.3.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
!function(global,factory){factory(exports)}(0,function(exports){"use strict";function extend(dest){var i,j,len,src;for(j=1,len=arguments.length;j<len;j++){src=arguments[j];for(i in src)dest[i]=src[i]}return dest}function bind(fn,obj){var slice=Array.prototype.slice;if(fn.bind)return fn.bind.apply(fn,slice.call(arguments,1));var args=slice.call(arguments,2);return function(){return fn.apply(obj,args.length?args.concat(slice.call(arguments)):arguments)}}function stamp(obj){return obj._leaflet_id=obj._leaflet_id||++lastId,obj._leaflet_id}function throttle(fn,time,context){var lock,args,wrapperFn,later;return later=function(){lock=!1,args&&(wrapperFn.apply(context,args),args=!1)},wrapperFn=function(){lock?args=arguments:(fn.apply(context,arguments),setTimeout(later,time),lock=!0)}}function wrapNum(x,range,includeMax){var max=range[1],min=range[0],d=max-min;return x===max&&includeMax?x:((x-min)%d+d)%d+min}function falseFn(){return!1}function formatNum(num,digits){var pow=Math.pow(10,void 0===digits?6:digits);return Math.round(num*pow)/pow}function trim(str){return str.trim?str.trim():str.replace(/^\s+|\s+$/g,"")}function splitWords(str){return trim(str).split(/\s+/)}function setOptions(obj,options){obj.hasOwnProperty("options")||(obj.options=obj.options?create(obj.options):{});for(var i in options)obj.options[i]=options[i];return obj.options}function getParamString(obj,existingUrl,uppercase){var params=[];for(var i in obj)params.push(encodeURIComponent(uppercase?i.toUpperCase():i)+"="+encodeURIComponent(obj[i]));return(existingUrl&&-1!==existingUrl.indexOf("?")?"&":"?")+params.join("&")}function template(str,data){return str.replace(templateRe,function(str,key){var value=data[key];if(void 0===value)throw new Error("No value provided for variable "+str);return"function"==typeof value&&(value=value(data)),value})}function indexOf(array,el){for(var i=0;i<array.length;i++)if(array[i]===el)return i;return-1}function getPrefixed(name){return window["webkit"+name]||window["moz"+name]||window["ms"+name]}function timeoutDefer(fn){var time=+new Date,timeToCall=Math.max(0,16-(time-lastTime));return lastTime=time+timeToCall,window.setTimeout(fn,timeToCall)}function requestAnimFrame(fn,context,immediate){if(!immediate||requestFn!==timeoutDefer)return requestFn.call(window,bind(fn,context));fn.call(context)}function cancelAnimFrame(id){id&&cancelFn.call(window,id)}function Class(){}function checkDeprecatedMixinEvents(includes){if("undefined"!=typeof L&&L&&L.Mixin){includes=isArray(includes)?includes:[includes];for(var i=0;i<includes.length;i++)includes[i]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}}function Point(x,y,round){this.x=round?Math.round(x):x,this.y=round?Math.round(y):y}function toPoint(x,y,round){return x instanceof Point?x:isArray(x)?new Point(x[0],x[1]):void 0===x||null===x?x:"object"==typeof x&&"x"in x&&"y"in x?new Point(x.x,x.y):new Point(x,y,round)}function Bounds(a,b){if(a)for(var points=b?[a,b]:a,i=0,len=points.length;i<len;i++)this.extend(points[i])}function toBounds(a,b){return!a||a instanceof Bounds?a:new Bounds(a,b)}function LatLngBounds(corner1,corner2){if(corner1)for(var latlngs=corner2?[corner1,corner2]:corner1,i=0,len=latlngs.length;i<len;i++)this.extend(latlngs[i])}function toLatLngBounds(a,b){return a instanceof LatLngBounds?a:new LatLngBounds(a,b)}function LatLng(lat,lng,alt){if(isNaN(lat)||isNaN(lng))throw new Error("Invalid LatLng object: ("+lat+", "+lng+")");this.lat=+lat,this.lng=+lng,void 0!==alt&&(this.alt=+alt)}function toLatLng(a,b,c){return a instanceof LatLng?a:isArray(a)&&"object"!=typeof a[0]?3===a.length?new LatLng(a[0],a[1],a[2]):2===a.length?new LatLng(a[0],a[1]):null:void 0===a||null===a?a:"object"==typeof a&&"lat"in a?new LatLng(a.lat,"lng"in a?a.lng:a.lon,a.alt):void 0===b?null:new LatLng(a,b,c)}function Transformation(a,b,c,d){if(isArray(a))return this._a=a[0],this._b=a[1],this._c=a[2],void(this._d=a[3]);this._a=a,this._b=b,this._c=c,this._d=d}function toTransformation(a,b,c,d){return new Transformation(a,b,c,d)}function svgCreate(name){return document.createElementNS("http://www.w3.org/2000/svg",name)}function pointsToPath(rings,closed){var i,j,len,len2,points,p,str="";for(i=0,len=rings.length;i<len;i++){for(points=rings[i],j=0,len2=points.length;j<len2;j++)p=points[j],str+=(j?"L":"M")+p.x+" "+p.y;str+=closed?svg?"z":"x":""}return str||"M0 0"}function userAgentContains(str){return navigator.userAgent.toLowerCase().indexOf(str)>=0}function addPointerListener(obj,type,handler,id){return"touchstart"===type?_addPointerStart(obj,handler,id):"touchmove"===type?_addPointerMove(obj,handler,id):"touchend"===type&&_addPointerEnd(obj,handler,id),this}function removePointerListener(obj,type,id){var handler=obj["_leaflet_"+type+id];return"touchstart"===type?obj.removeEventListener(POINTER_DOWN,handler,!1):"touchmove"===type?obj.removeEventListener(POINTER_MOVE,handler,!1):"touchend"===type&&(obj.removeEventListener(POINTER_UP,handler,!1),obj.removeEventListener(POINTER_CANCEL,handler,!1)),this}function _addPointerStart(obj,handler,id){var onDown=bind(function(e){if("mouse"!==e.pointerType&&e.MSPOINTER_TYPE_MOUSE&&e.pointerType!==e.MSPOINTER_TYPE_MOUSE){if(!(TAG_WHITE_LIST.indexOf(e.target.tagName)<0))return;preventDefault(e)}_handlePointer(e,handler)});obj["_leaflet_touchstart"+id]=onDown,obj.addEventListener(POINTER_DOWN,onDown,!1),_pointerDocListener||(document.documentElement.addEventListener(POINTER_DOWN,_globalPointerDown,!0),document.documentElement.addEventListener(POINTER_MOVE,_globalPointerMove,!0),document.documentElement.addEventListener(POINTER_UP,_globalPointerUp,!0),document.documentElement.addEventListener(POINTER_CANCEL,_globalPointerUp,!0),_pointerDocListener=!0)}function _globalPointerDown(e){_pointers[e.pointerId]=e,_pointersCount++}function _globalPointerMove(e){_pointers[e.pointerId]&&(_pointers[e.pointerId]=e)}function _globalPointerUp(e){delete _pointers[e.pointerId],_pointersCount--}function _handlePointer(e,handler){e.touches=[];for(var i in _pointers)e.touches.push(_pointers[i]);e.changedTouches=[e],handler(e)}function _addPointerMove(obj,handler,id){var onMove=function(e){(e.pointerType!==e.MSPOINTER_TYPE_MOUSE&&"mouse"!==e.pointerType||0!==e.buttons)&&_handlePointer(e,handler)};obj["_leaflet_touchmove"+id]=onMove,obj.addEventListener(POINTER_MOVE,onMove,!1)}function _addPointerEnd(obj,handler,id){var onUp=function(e){_handlePointer(e,handler)};obj["_leaflet_touchend"+id]=onUp,obj.addEventListener(POINTER_UP,onUp,!1),obj.addEventListener(POINTER_CANCEL,onUp,!1)}function addDoubleTapListener(obj,handler,id){function onTouchStart(e){var count;if(pointer){if(!edge||"mouse"===e.pointerType)return;count=_pointersCount}else count=e.touches.length;if(!(count>1)){var now=Date.now(),delta=now-(last||now);touch$$1=e.touches?e.touches[0]:e,doubleTap=delta>0&&delta<=delay,last=now}}function onTouchEnd(e){if(doubleTap&&!touch$$1.cancelBubble){if(pointer){if(!edge||"mouse"===e.pointerType)return;var prop,i,newTouch={};for(i in touch$$1)prop=touch$$1[i],newTouch[i]=prop&&prop.bind?prop.bind(touch$$1):prop;touch$$1=newTouch}touch$$1.type="dblclick",handler(touch$$1),last=null}}var last,touch$$1,doubleTap=!1,delay=250;return obj[_pre+_touchstart+id]=onTouchStart,obj[_pre+_touchend+id]=onTouchEnd,obj[_pre+"dblclick"+id]=handler,obj.addEventListener(_touchstart,onTouchStart,!1),obj.addEventListener(_touchend,onTouchEnd,!1),obj.addEventListener("dblclick",handler,!1),this}function removeDoubleTapListener(obj,id){var touchstart=obj[_pre+_touchstart+id],touchend=obj[_pre+_touchend+id],dblclick=obj[_pre+"dblclick"+id];return obj.removeEventListener(_touchstart,touchstart,!1),obj.removeEventListener(_touchend,touchend,!1),edge||obj.removeEventListener("dblclick",dblclick,!1),this}function on(obj,types,fn,context){if("object"==typeof types)for(var type in types)addOne(obj,type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)addOne(obj,types[i],fn,context)}return this}function off(obj,types,fn,context){if("object"==typeof types)for(var type in types)removeOne(obj,type,types[type],fn);else if(types){types=splitWords(types);for(var i=0,len=types.length;i<len;i++)removeOne(obj,types[i],fn,context)}else{for(var j in obj[eventsKey])removeOne(obj,j,obj[eventsKey][j]);delete obj[eventsKey]}return this}function addOne(obj,type,fn,context){var id=type+stamp(fn)+(context?"_"+stamp(context):"");if(obj[eventsKey]&&obj[eventsKey][id])return this;var handler=function(e){return fn.call(context||obj,e||window.event)},originalHandler=handler;pointer&&0===type.indexOf("touch")?addPointerListener(obj,type,handler,id):!touch||"dblclick"!==type||!addDoubleTapListener||pointer&&chrome?"addEventListener"in obj?"mousewheel"===type?obj.addEventListener("onwheel"in obj?"wheel":"mousewheel",handler,!1):"mouseenter"===type||"mouseleave"===type?(handler=function(e){e=e||window.event,isExternalTarget(obj,e)&&originalHandler(e)},obj.addEventListener("mouseenter"===type?"mouseover":"mouseout",handler,!1)):("click"===type&&android&&(handler=function(e){filterClick(e,originalHandler)}),obj.addEventListener(type,handler,!1)):"attachEvent"in obj&&obj.attachEvent("on"+type,handler):addDoubleTapListener(obj,handler,id),obj[eventsKey]=obj[eventsKey]||{},obj[eventsKey][id]=handler}function removeOne(obj,type,fn,context){var id=type+stamp(fn)+(context?"_"+stamp(context):""),handler=obj[eventsKey]&&obj[eventsKey][id];if(!handler)return this;pointer&&0===type.indexOf("touch")?removePointerListener(obj,type,id):!touch||"dblclick"!==type||!removeDoubleTapListener||pointer&&chrome?"removeEventListener"in obj?"mousewheel"===type?obj.removeEventListener("onwheel"in obj?"wheel":"mousewheel",handler,!1):obj.removeEventListener("mouseenter"===type?"mouseover":"mouseleave"===type?"mouseout":type,handler,!1):"detachEvent"in obj&&obj.detachEvent("on"+type,handler):removeDoubleTapListener(obj,id),obj[eventsKey][id]=null}function stopPropagation(e){return e.stopPropagation?e.stopPropagation():e.originalEvent?e.originalEvent._stopped=!0:e.cancelBubble=!0,skipped(e),this}function disableScrollPropagation(el){return addOne(el,"mousewheel",stopPropagation),this}function disableClickPropagation(el){return on(el,"mousedown touchstart dblclick",stopPropagation),addOne(el,"click",fakeStop),this}function preventDefault(e){return e.preventDefault?e.preventDefault():e.returnValue=!1,this}function stop(e){return preventDefault(e),stopPropagation(e),this}function getMousePosition(e,container){if(!container)return new Point(e.clientX,e.clientY);var rect=container.getBoundingClientRect(),scaleX=rect.width/container.offsetWidth||1,scaleY=rect.height/container.offsetHeight||1;return new Point(e.clientX/scaleX-rect.left-container.clientLeft,e.clientY/scaleY-rect.top-container.clientTop)}function getWheelDelta(e){return edge?e.wheelDeltaY/2:e.deltaY&&0===e.deltaMode?-e.deltaY/wheelPxFactor:e.deltaY&&1===e.deltaMode?20*-e.deltaY:e.deltaY&&2===e.deltaMode?60*-e.deltaY:e.deltaX||e.deltaZ?0:e.wheelDelta?(e.wheelDeltaY||e.wheelDelta)/2:e.detail&&Math.abs(e.detail)<32765?20*-e.detail:e.detail?e.detail/-32765*60:0}function fakeStop(e){skipEvents[e.type]=!0}function skipped(e){var events=skipEvents[e.type];return skipEvents[e.type]=!1,events}function isExternalTarget(el,e){var related=e.relatedTarget;if(!related)return!0;try{for(;related&&related!==el;)related=related.parentNode}catch(err){return!1}return related!==el}function filterClick(e,handler){var timeStamp=e.timeStamp||e.originalEvent&&e.originalEvent.timeStamp,elapsed=lastClick&&timeStamp-lastClick;if(elapsed&&elapsed>100&&elapsed<500||e.target._simulatedClick&&!e._simulated)return void stop(e);lastClick=timeStamp,handler(e)}function get(id){return"string"==typeof id?document.getElementById(id):id}function getStyle(el,style){var value=el.style[style]||el.currentStyle&&el.currentStyle[style];if((!value||"auto"===value)&&document.defaultView){var css=document.defaultView.getComputedStyle(el,null);value=css?css[style]:null}return"auto"===value?null:value}function create$1(tagName,className,container){var el=document.createElement(tagName);return el.className=className||"",container&&container.appendChild(el),el}function remove(el){var parent=el.parentNode;parent&&parent.removeChild(el)}function empty(el){for(;el.firstChild;)el.removeChild(el.firstChild)}function toFront(el){var parent=el.parentNode;parent.lastChild!==el&&parent.appendChild(el)}function toBack(el){var parent=el.parentNode;parent.firstChild!==el&&parent.insertBefore(el,parent.firstChild)}function hasClass(el,name){if(void 0!==el.classList)return el.classList.contains(name);var className=getClass(el);return className.length>0&&new RegExp("(^|\\s)"+name+"(\\s|$)").test(className)}function addClass(el,name){if(void 0!==el.classList)for(var classes=splitWords(name),i=0,len=classes.length;i<len;i++)el.classList.add(classes[i]);else if(!hasClass(el,name)){var className=getClass(el);setClass(el,(className?className+" ":"")+name)}}function removeClass(el,name){void 0!==el.classList?el.classList.remove(name):setClass(el,trim((" "+getClass(el)+" ").replace(" "+name+" "," ")))}function setClass(el,name){void 0===el.className.baseVal?el.className=name:el.className.baseVal=name}function getClass(el){return void 0===el.className.baseVal?el.className:el.className.baseVal}function setOpacity(el,value){"opacity"in el.style?el.style.opacity=value:"filter"in el.style&&_setOpacityIE(el,value)}function _setOpacityIE(el,value){var filter=!1,filterName="DXImageTransform.Microsoft.Alpha";try{filter=el.filters.item(filterName)}catch(e){if(1===value)return}value=Math.round(100*value),filter?(filter.Enabled=100!==value,filter.Opacity=value):el.style.filter+=" progid:"+filterName+"(opacity="+value+")"}function testProp(props){for(var style=document.documentElement.style,i=0;i<props.length;i++)if(props[i]in style)return props[i];return!1}function setTransform(el,offset,scale){var pos=offset||new Point(0,0);el.style[TRANSFORM]=(ie3d?"translate("+pos.x+"px,"+pos.y+"px)":"translate3d("+pos.x+"px,"+pos.y+"px,0)")+(scale?" scale("+scale+")":"")}function setPosition(el,point){el._leaflet_pos=point,any3d?setTransform(el,point):(el.style.left=point.x+"px",el.style.top=point.y+"px")}function getPosition(el){return el._leaflet_pos||new Point(0,0)}function disableImageDrag(){on(window,"dragstart",preventDefault)}function enableImageDrag(){off(window,"dragstart",preventDefault)}function preventOutline(element){for(;-1===element.tabIndex;)element=element.parentNode;element.style&&(restoreOutline(),_outlineElement=element,_outlineStyle=element.style.outline,element.style.outline="none",on(window,"keydown",restoreOutline))}function restoreOutline(){_outlineElement&&(_outlineElement.style.outline=_outlineStyle,_outlineElement=void 0,_outlineStyle=void 0,off(window,"keydown",restoreOutline))}function createMap(id,options){return new Map(id,options)}function simplify(points,tolerance){if(!tolerance||!points.length)return points.slice();var sqTolerance=tolerance*tolerance;return points=_reducePoints(points,sqTolerance),points=_simplifyDP(points,sqTolerance)}function pointToSegmentDistance(p,p1,p2){return Math.sqrt(_sqClosestPointOnSegment(p,p1,p2,!0))}function closestPointOnSegment(p,p1,p2){return _sqClosestPointOnSegment(p,p1,p2)}function _simplifyDP(points,sqTolerance){var len=points.length,ArrayConstructor=typeof Uint8Array!=void 0+""?Uint8Array:Array,markers=new ArrayConstructor(len);markers[0]=markers[len-1]=1,_simplifyDPStep(points,markers,sqTolerance,0,len-1);var i,newPoints=[];for(i=0;i<len;i++)markers[i]&&newPoints.push(points[i]);return newPoints}function _simplifyDPStep(points,markers,sqTolerance,first,last){var index,i,sqDist,maxSqDist=0;for(i=first+1;i<=last-1;i++)(sqDist=_sqClosestPointOnSegment(points[i],points[first],points[last],!0))>maxSqDist&&(index=i,maxSqDist=sqDist);maxSqDist>sqTolerance&&(markers[index]=1,_simplifyDPStep(points,markers,sqTolerance,first,index),_simplifyDPStep(points,markers,sqTolerance,index,last))}function _reducePoints(points,sqTolerance){for(var reducedPoints=[points[0]],i=1,prev=0,len=points.length;i<len;i++)_sqDist(points[i],points[prev])>sqTolerance&&(reducedPoints.push(points[i]),prev=i);return prev<len-1&&reducedPoints.push(points[len-1]),reducedPoints}function clipSegment(a,b,bounds,useLastCode,round){var codeOut,p,newCode,codeA=useLastCode?_lastCode:_getBitCode(a,bounds),codeB=_getBitCode(b,bounds);for(_lastCode=codeB;;){if(!(codeA|codeB))return[a,b];if(codeA&codeB)return!1;codeOut=codeA||codeB,p=_getEdgeIntersection(a,b,codeOut,bounds,round),newCode=_getBitCode(p,bounds),codeOut===codeA?(a=p,codeA=newCode):(b=p,codeB=newCode)}}function _getEdgeIntersection(a,b,code,bounds,round){var x,y,dx=b.x-a.x,dy=b.y-a.y,min=bounds.min,max=bounds.max;return 8&code?(x=a.x+dx*(max.y-a.y)/dy,y=max.y):4&code?(x=a.x+dx*(min.y-a.y)/dy,y=min.y):2&code?(x=max.x,y=a.y+dy*(max.x-a.x)/dx):1&code&&(x=min.x,y=a.y+dy*(min.x-a.x)/dx),new Point(x,y,round)}function _getBitCode(p,bounds){var code=0;return p.x<bounds.min.x?code|=1:p.x>bounds.max.x&&(code|=2),p.y<bounds.min.y?code|=4:p.y>bounds.max.y&&(code|=8),code}function _sqDist(p1,p2){var dx=p2.x-p1.x,dy=p2.y-p1.y;return dx*dx+dy*dy}function _sqClosestPointOnSegment(p,p1,p2,sqDist){var t,x=p1.x,y=p1.y,dx=p2.x-x,dy=p2.y-y,dot=dx*dx+dy*dy;return dot>0&&(t=((p.x-x)*dx+(p.y-y)*dy)/dot,t>1?(x=p2.x,y=p2.y):t>0&&(x+=dx*t,y+=dy*t)),dx=p.x-x,dy=p.y-y,sqDist?dx*dx+dy*dy:new Point(x,y)}function isFlat(latlngs){return!isArray(latlngs[0])||"object"!=typeof latlngs[0][0]&&void 0!==latlngs[0][0]}function _flat(latlngs){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),isFlat(latlngs)}function clipPolygon(points,bounds,round){var clippedPoints,i,j,k,a,b,len,edge,p,edges=[1,4,2,8];for(i=0,len=points.length;i<len;i++)points[i]._code=_getBitCode(points[i],bounds);for(k=0;k<4;k++){for(edge=edges[k],clippedPoints=[],i=0,len=points.length,j=len-1;i<len;j=i++)a=points[i],b=points[j],a._code&edge?b._code&edge||(p=_getEdgeIntersection(b,a,edge,bounds,round),p._code=_getBitCode(p,bounds),clippedPoints.push(p)):(b._code&edge&&(p=_getEdgeIntersection(b,a,edge,bounds,round),p._code=_getBitCode(p,bounds),clippedPoints.push(p)),clippedPoints.push(a));points=clippedPoints}return points}function icon(options){return new Icon(options)}function marker(latlng,options){return new Marker(latlng,options)}function circleMarker(latlng,options){return new CircleMarker(latlng,options)}function circle(latlng,options,legacyOptions){return new Circle(latlng,options,legacyOptions)}function polyline(latlngs,options){return new Polyline(latlngs,options)}function polygon(latlngs,options){return new Polygon(latlngs,options)}function geometryToLayer(geojson,options){var latlng,latlngs,i,len,geometry="Feature"===geojson.type?geojson.geometry:geojson,coords=geometry?geometry.coordinates:null,layers=[],pointToLayer=options&&options.pointToLayer,_coordsToLatLng=options&&options.coordsToLatLng||coordsToLatLng;if(!coords&&!geometry)return null;switch(geometry.type){case"Point":return latlng=_coordsToLatLng(coords),pointToLayer?pointToLayer(geojson,latlng):new Marker(latlng);case"MultiPoint":for(i=0,len=coords.length;i<len;i++)latlng=_coordsToLatLng(coords[i]),layers.push(pointToLayer?pointToLayer(geojson,latlng):new Marker(latlng));return new FeatureGroup(layers);case"LineString":case"MultiLineString":return latlngs=coordsToLatLngs(coords,"LineString"===geometry.type?0:1,_coordsToLatLng),new Polyline(latlngs,options);case"Polygon":case"MultiPolygon":return latlngs=coordsToLatLngs(coords,"Polygon"===geometry.type?1:2,_coordsToLatLng),new Polygon(latlngs,options);case"GeometryCollection":for(i=0,len=geometry.geometries.length;i<len;i++){var layer=geometryToLayer({geometry:geometry.geometries[i],type:"Feature",properties:geojson.properties},options);layer&&layers.push(layer)}return new FeatureGroup(layers);default:throw new Error("Invalid GeoJSON object.")}}function coordsToLatLng(coords){return new LatLng(coords[1],coords[0],coords[2])}function coordsToLatLngs(coords,levelsDeep,_coordsToLatLng){for(var latlng,latlngs=[],i=0,len=coords.length;i<len;i++)latlng=levelsDeep?coordsToLatLngs(coords[i],levelsDeep-1,_coordsToLatLng):(_coordsToLatLng||coordsToLatLng)(coords[i]),latlngs.push(latlng);return latlngs}function latLngToCoords(latlng,precision){return precision="number"==typeof precision?precision:6,void 0!==latlng.alt?[formatNum(latlng.lng,precision),formatNum(latlng.lat,precision),formatNum(latlng.alt,precision)]:[formatNum(latlng.lng,precision),formatNum(latlng.lat,precision)]}function latLngsToCoords(latlngs,levelsDeep,closed,precision){for(var coords=[],i=0,len=latlngs.length;i<len;i++)coords.push(levelsDeep?latLngsToCoords(latlngs[i],levelsDeep-1,closed,precision):latLngToCoords(latlngs[i],precision));return!levelsDeep&&closed&&coords.push(coords[0]),coords}function getFeature(layer,newGeometry){return layer.feature?extend({},layer.feature,{geometry:newGeometry}):asFeature(newGeometry)}function asFeature(geojson){return"Feature"===geojson.type||"FeatureCollection"===geojson.type?geojson:{type:"Feature",properties:{},geometry:geojson}}function geoJSON(geojson,options){return new GeoJSON(geojson,options)}function videoOverlay(video,bounds,options){return new VideoOverlay(video,bounds,options)}function divIcon(options){return new DivIcon(options)}function gridLayer(options){return new GridLayer(options)}function tileLayer(url,options){return new TileLayer(url,options)}function tileLayerWMS(url,options){return new TileLayerWMS(url,options)}function canvas$1(options){return canvas?new Canvas(options):null}function svg$1(options){return svg||vml?new SVG(options):null}function rectangle(latLngBounds,options){return new Rectangle(latLngBounds,options)}function noConflict(){return window.L=oldL,this}var freeze=Object.freeze;Object.freeze=function(obj){return obj};var create=Object.create||function(){function F(){}return function(proto){return F.prototype=proto,new F}}(),lastId=0,templateRe=/\{ *([\w_-]+) *\}/g,isArray=Array.isArray||function(obj){return"[object Array]"===Object.prototype.toString.call(obj)},emptyImageUrl="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",lastTime=0,requestFn=window.requestAnimationFrame||getPrefixed("RequestAnimationFrame")||timeoutDefer,cancelFn=window.cancelAnimationFrame||getPrefixed("CancelAnimationFrame")||getPrefixed("CancelRequestAnimationFrame")||function(id){window.clearTimeout(id)},Util=(Object.freeze||Object)({freeze:freeze,extend:extend,create:create,bind:bind,lastId:lastId,stamp:stamp,throttle:throttle,wrapNum:wrapNum,falseFn:falseFn,formatNum:formatNum,trim:trim,splitWords:splitWords,setOptions:setOptions,getParamString:getParamString,template:template,isArray:isArray,indexOf:indexOf,emptyImageUrl:emptyImageUrl,requestFn:requestFn,cancelFn:cancelFn,requestAnimFrame:requestAnimFrame,cancelAnimFrame:cancelAnimFrame});Class.extend=function(props){var NewClass=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},parentProto=NewClass.__super__=this.prototype,proto=create(parentProto);proto.constructor=NewClass,NewClass.prototype=proto;for(var i in this)this.hasOwnProperty(i)&&"prototype"!==i&&"__super__"!==i&&(NewClass[i]=this[i]);return props.statics&&(extend(NewClass,props.statics),delete props.statics),props.includes&&(checkDeprecatedMixinEvents(props.includes),extend.apply(null,[proto].concat(props.includes)),delete props.includes),proto.options&&(props.options=extend(create(proto.options),props.options)),extend(proto,props),proto._initHooks=[],proto.callInitHooks=function(){if(!this._initHooksCalled){parentProto.callInitHooks&&parentProto.callInitHooks.call(this),this._initHooksCalled=!0;for(var i=0,len=proto._initHooks.length;i<len;i++)proto._initHooks[i].call(this)}},NewClass},Class.include=function(props){return extend(this.prototype,props),this},Class.mergeOptions=function(options){return extend(this.prototype.options,options),this},Class.addInitHook=function(fn){var args=Array.prototype.slice.call(arguments,1),init="function"==typeof fn?fn:function(){this[fn].apply(this,args)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(init),this};var Events={on:function(types,fn,context){if("object"==typeof types)for(var type in types)this._on(type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)this._on(types[i],fn,context)}return this},off:function(types,fn,context){if(types)if("object"==typeof types)for(var type in types)this._off(type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)this._off(types[i],fn,context)}else delete this._events;return this},_on:function(type,fn,context){this._events=this._events||{};var typeListeners=this._events[type];typeListeners||(typeListeners=[],this._events[type]=typeListeners),context===this&&(context=void 0);for(var newListener={fn:fn,ctx:context},listeners=typeListeners,i=0,len=listeners.length;i<len;i++)if(listeners[i].fn===fn&&listeners[i].ctx===context)return;listeners.push(newListener)},_off:function(type,fn,context){var listeners,i,len;if(this._events&&(listeners=this._events[type])){if(!fn){for(i=0,len=listeners.length;i<len;i++)listeners[i].fn=falseFn;return void delete this._events[type]}if(context===this&&(context=void 0),listeners)for(i=0,len=listeners.length;i<len;i++){var l=listeners[i];if(l.ctx===context&&l.fn===fn)return l.fn=falseFn,this._firingCount&&(this._events[type]=listeners=listeners.slice()),void listeners.splice(i,1)}}},fire:function(type,data,propagate){if(!this.listens(type,propagate))return this;var event=extend({},data,{type:type,target:this,sourceTarget:data&&data.sourceTarget||this});if(this._events){var listeners=this._events[type];if(listeners){this._firingCount=this._firingCount+1||1;for(var i=0,len=listeners.length;i<len;i++){var l=listeners[i];l.fn.call(l.ctx||this,event)}this._firingCount--}}return propagate&&this._propagateEvent(event),this},listens:function(type,propagate){var listeners=this._events&&this._events[type];if(listeners&&listeners.length)return!0;if(propagate)for(var id in this._eventParents)if(this._eventParents[id].listens(type,propagate))return!0;return!1},once:function(types,fn,context){if("object"==typeof types){for(var type in types)this.once(type,types[type],fn);return this}var handler=bind(function(){this.off(types,fn,context).off(types,handler,context)},this);return this.on(types,fn,context).on(types,handler,context)},addEventParent:function(obj){return this._eventParents=this._eventParents||{},this._eventParents[stamp(obj)]=obj,this},removeEventParent:function(obj){return this._eventParents&&delete this._eventParents[stamp(obj)],this},_propagateEvent:function(e){for(var id in this._eventParents)this._eventParents[id].fire(e.type,extend({layer:e.target,propagatedFrom:e.target},e),!0)}};Events.addEventListener=Events.on,Events.removeEventListener=Events.clearAllEventListeners=Events.off,Events.addOneTimeEventListener=Events.once,Events.fireEvent=Events.fire,Events.hasEventListeners=Events.listens;var Evented=Class.extend(Events),trunc=Math.trunc||function(v){return v>0?Math.floor(v):Math.ceil(v)};Point.prototype={clone:function(){return new Point(this.x,this.y)},add:function(point){return this.clone()._add(toPoint(point))},_add:function(point){return this.x+=point.x,this.y+=point.y,this},subtract:function(point){return this.clone()._subtract(toPoint(point))},_subtract:function(point){return this.x-=point.x,this.y-=point.y,this},divideBy:function(num){return this.clone()._divideBy(num)},_divideBy:function(num){return this.x/=num,this.y/=num,this},multiplyBy:function(num){return this.clone()._multiplyBy(num)},_multiplyBy:function(num){return this.x*=num,this.y*=num,this},scaleBy:function(point){return new Point(this.x*point.x,this.y*point.y)},unscaleBy:function(point){return new Point(this.x/point.x,this.y/point.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=trunc(this.x),this.y=trunc(this.y),this},distanceTo:function(point){point=toPoint(point);var x=point.x-this.x,y=point.y-this.y;return Math.sqrt(x*x+y*y)},equals:function(point){return point=toPoint(point),point.x===this.x&&point.y===this.y},contains:function(point){return point=toPoint(point),Math.abs(point.x)<=Math.abs(this.x)&&Math.abs(point.y)<=Math.abs(this.y)},toString:function(){return"Point("+formatNum(this.x)+", "+formatNum(this.y)+")"}},Bounds.prototype={extend:function(point){return point=toPoint(point),this.min||this.max?(this.min.x=Math.min(point.x,this.min.x),this.max.x=Math.max(point.x,this.max.x),this.min.y=Math.min(point.y,this.min.y),this.max.y=Math.max(point.y,this.max.y)):(this.min=point.clone(),this.max=point.clone()),this},getCenter:function(round){return new Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,round)},getBottomLeft:function(){return new Point(this.min.x,this.max.y)},getTopRight:function(){return new Point(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(obj){var min,max;return obj="number"==typeof obj[0]||obj instanceof Point?toPoint(obj):toBounds(obj),obj instanceof Bounds?(min=obj.min,max=obj.max):min=max=obj,min.x>=this.min.x&&max.x<=this.max.x&&min.y>=this.min.y&&max.y<=this.max.y},intersects:function(bounds){bounds=toBounds(bounds);var min=this.min,max=this.max,min2=bounds.min,max2=bounds.max,xIntersects=max2.x>=min.x&&min2.x<=max.x,yIntersects=max2.y>=min.y&&min2.y<=max.y;return xIntersects&&yIntersects},overlaps:function(bounds){bounds=toBounds(bounds);var min=this.min,max=this.max,min2=bounds.min,max2=bounds.max,xOverlaps=max2.x>min.x&&min2.x<max.x,yOverlaps=max2.y>min.y&&min2.y<max.y;return xOverlaps&&yOverlaps},isValid:function(){return!(!this.min||!this.max)}},LatLngBounds.prototype={extend:function(obj){var sw2,ne2,sw=this._southWest,ne=this._northEast;if(obj instanceof LatLng)sw2=obj,ne2=obj;else{if(!(obj instanceof LatLngBounds))return obj?this.extend(toLatLng(obj)||toLatLngBounds(obj)):this;if(sw2=obj._southWest,ne2=obj._northEast,!sw2||!ne2)return this}return sw||ne?(sw.lat=Math.min(sw2.lat,sw.lat),sw.lng=Math.min(sw2.lng,sw.lng),ne.lat=Math.max(ne2.lat,ne.lat),ne.lng=Math.max(ne2.lng,ne.lng)):(this._southWest=new LatLng(sw2.lat,sw2.lng),this._northEast=new LatLng(ne2.lat,ne2.lng)),this},pad:function(bufferRatio){var sw=this._southWest,ne=this._northEast,heightBuffer=Math.abs(sw.lat-ne.lat)*bufferRatio,widthBuffer=Math.abs(sw.lng-ne.lng)*bufferRatio;return new LatLngBounds(new LatLng(sw.lat-heightBuffer,sw.lng-widthBuffer),new LatLng(ne.lat+heightBuffer,ne.lng+widthBuffer))},getCenter:function(){return new LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(obj){obj="number"==typeof obj[0]||obj instanceof LatLng||"lat"in obj?toLatLng(obj):toLatLngBounds(obj);var sw2,ne2,sw=this._southWest,ne=this._northEast;return obj instanceof LatLngBounds?(sw2=obj.getSouthWest(),ne2=obj.getNorthEast()):sw2=ne2=obj,sw2.lat>=sw.lat&&ne2.lat<=ne.lat&&sw2.lng>=sw.lng&&ne2.lng<=ne.lng},intersects:function(bounds){bounds=toLatLngBounds(bounds);var sw=this._southWest,ne=this._northEast,sw2=bounds.getSouthWest(),ne2=bounds.getNorthEast(),latIntersects=ne2.lat>=sw.lat&&sw2.lat<=ne.lat,lngIntersects=ne2.lng>=sw.lng&&sw2.lng<=ne.lng;return latIntersects&&lngIntersects},overlaps:function(bounds){bounds=toLatLngBounds(bounds);var sw=this._southWest,ne=this._northEast,sw2=bounds.getSouthWest(),ne2=bounds.getNorthEast(),latOverlaps=ne2.lat>sw.lat&&sw2.lat<ne.lat,lngOverlaps=ne2.lng>sw.lng&&sw2.lng<ne.lng;return latOverlaps&&lngOverlaps},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(bounds,maxMargin){return!!bounds&&(bounds=toLatLngBounds(bounds),this._southWest.equals(bounds.getSouthWest(),maxMargin)&&this._northEast.equals(bounds.getNorthEast(),maxMargin))},isValid:function(){return!(!this._southWest||!this._northEast)}},LatLng.prototype={equals:function(obj,maxMargin){return!!obj&&(obj=toLatLng(obj),Math.max(Math.abs(this.lat-obj.lat),Math.abs(this.lng-obj.lng))<=(void 0===maxMargin?1e-9:maxMargin))},toString:function(precision){return"LatLng("+formatNum(this.lat,precision)+", "+formatNum(this.lng,precision)+")"},distanceTo:function(other){return Earth.distance(this,toLatLng(other))},wrap:function(){return Earth.wrapLatLng(this)},toBounds:function(sizeInMeters){var latAccuracy=180*sizeInMeters/40075017,lngAccuracy=latAccuracy/Math.cos(Math.PI/180*this.lat);return toLatLngBounds([this.lat-latAccuracy,this.lng-lngAccuracy],[this.lat+latAccuracy,this.lng+lngAccuracy])},clone:function(){return new LatLng(this.lat,this.lng,this.alt)}};var CRS={latLngToPoint:function(latlng,zoom){var projectedPoint=this.projection.project(latlng),scale=this.scale(zoom);return this.transformation._transform(projectedPoint,scale)},pointToLatLng:function(point,zoom){var scale=this.scale(zoom),untransformedPoint=this.transformation.untransform(point,scale);return this.projection.unproject(untransformedPoint)},project:function(latlng){return this.projection.project(latlng)},unproject:function(point){return this.projection.unproject(point)},scale:function(zoom){return 256*Math.pow(2,zoom)},zoom:function(scale){return Math.log(scale/256)/Math.LN2},getProjectedBounds:function(zoom){if(this.infinite)return null;var b=this.projection.bounds,s=this.scale(zoom);return new Bounds(this.transformation.transform(b.min,s),this.transformation.transform(b.max,s))},infinite:!1,wrapLatLng:function(latlng){var lng=this.wrapLng?wrapNum(latlng.lng,this.wrapLng,!0):latlng.lng;return new LatLng(this.wrapLat?wrapNum(latlng.lat,this.wrapLat,!0):latlng.lat,lng,latlng.alt)},wrapLatLngBounds:function(bounds){var center=bounds.getCenter(),newCenter=this.wrapLatLng(center),latShift=center.lat-newCenter.lat,lngShift=center.lng-newCenter.lng;if(0===latShift&&0===lngShift)return bounds;var sw=bounds.getSouthWest(),ne=bounds.getNorthEast();return new LatLngBounds(new LatLng(sw.lat-latShift,sw.lng-lngShift),new LatLng(ne.lat-latShift,ne.lng-lngShift))}},Earth=extend({},CRS,{wrapLng:[-180,180],R:6371e3,distance:function(latlng1,latlng2){var rad=Math.PI/180,lat1=latlng1.lat*rad,lat2=latlng2.lat*rad,sinDLat=Math.sin((latlng2.lat-latlng1.lat)*rad/2),sinDLon=Math.sin((latlng2.lng-latlng1.lng)*rad/2),a=sinDLat*sinDLat+Math.cos(lat1)*Math.cos(lat2)*sinDLon*sinDLon,c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));return this.R*c}}),SphericalMercator={R:6378137,MAX_LATITUDE:85.0511287798,project:function(latlng){var d=Math.PI/180,max=this.MAX_LATITUDE,lat=Math.max(Math.min(max,latlng.lat),-max),sin=Math.sin(lat*d);return new Point(this.R*latlng.lng*d,this.R*Math.log((1+sin)/(1-sin))/2)},unproject:function(point){var d=180/Math.PI;return new LatLng((2*Math.atan(Math.exp(point.y/this.R))-Math.PI/2)*d,point.x*d/this.R)},bounds:function(){var d=6378137*Math.PI;return new Bounds([-d,-d],[d,d])}()};Transformation.prototype={transform:function(point,scale){return this._transform(point.clone(),scale)},_transform:function(point,scale){return scale=scale||1,point.x=scale*(this._a*point.x+this._b),point.y=scale*(this._c*point.y+this._d),point},untransform:function(point,scale){return scale=scale||1,new Point((point.x/scale-this._b)/this._a,(point.y/scale-this._d)/this._c)}};var lastClick,disableTextSelection,enableTextSelection,_userSelect,EPSG3857=extend({},Earth,{code:"EPSG:3857",projection:SphericalMercator,transformation:function(){var scale=.5/(Math.PI*SphericalMercator.R);return toTransformation(scale,.5,-scale,.5)}()}),EPSG900913=extend({},EPSG3857,{code:"EPSG:900913"}),style$1=document.documentElement.style,ie="ActiveXObject"in window,ielt9=ie&&!document.addEventListener,edge="msLaunchUri"in navigator&&!("documentMode"in document),webkit=userAgentContains("webkit"),android=userAgentContains("android"),android23=userAgentContains("android 2")||userAgentContains("android 3"),webkitVer=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),androidStock=android&&userAgentContains("Google")&&webkitVer<537&&!("AudioNode"in window),opera=!!window.opera,chrome=userAgentContains("chrome"),gecko=userAgentContains("gecko")&&!webkit&&!opera&&!ie,safari=!chrome&&userAgentContains("safari"),phantom=userAgentContains("phantom"),opera12="OTransition"in style$1,win=0===navigator.platform.indexOf("Win"),ie3d=ie&&"transition"in style$1,webkit3d="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!android23,gecko3d="MozPerspective"in style$1,any3d=!window.L_DISABLE_3D&&(ie3d||webkit3d||gecko3d)&&!opera12&&!phantom,mobile="undefined"!=typeof orientation||userAgentContains("mobile"),mobileWebkit=mobile&&webkit,mobileWebkit3d=mobile&&webkit3d,msPointer=!window.PointerEvent&&window.MSPointerEvent,pointer=!(!window.PointerEvent&&!msPointer),touch=!window.L_NO_TOUCH&&(pointer||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),mobileOpera=mobile&&opera,mobileGecko=mobile&&gecko,retina=(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1,canvas=function(){return!!document.createElement("canvas").getContext}(),svg=!(!document.createElementNS||!svgCreate("svg").createSVGRect),vml=!svg&&function(){try{var div=document.createElement("div");div.innerHTML='<v:shape adj="1"/>';var shape=div.firstChild;return shape.style.behavior="url(#default#VML)",shape&&"object"==typeof shape.adj}catch(e){return!1}}(),Browser=(Object.freeze||Object)({ie:ie,ielt9:ielt9,edge:edge,webkit:webkit,android:android,android23:android23,androidStock:androidStock,opera:opera,chrome:chrome,gecko:gecko,safari:safari,phantom:phantom,opera12:opera12,win:win,ie3d:ie3d,webkit3d:webkit3d,gecko3d:gecko3d,any3d:any3d,mobile:mobile,mobileWebkit:mobileWebkit,mobileWebkit3d:mobileWebkit3d,msPointer:msPointer,pointer:pointer,touch:touch,mobileOpera:mobileOpera,mobileGecko:mobileGecko,retina:retina,canvas:canvas,svg:svg,vml:vml}),POINTER_DOWN=msPointer?"MSPointerDown":"pointerdown",POINTER_MOVE=msPointer?"MSPointerMove":"pointermove",POINTER_UP=msPointer?"MSPointerUp":"pointerup",POINTER_CANCEL=msPointer?"MSPointerCancel":"pointercancel",TAG_WHITE_LIST=["INPUT","SELECT","OPTION"],_pointers={},_pointerDocListener=!1,_pointersCount=0,_touchstart=msPointer?"MSPointerDown":pointer?"pointerdown":"touchstart",_touchend=msPointer?"MSPointerUp":pointer?"pointerup":"touchend",_pre="_leaflet_",eventsKey="_leaflet_events",wheelPxFactor=win&&chrome?2*window.devicePixelRatio:gecko?window.devicePixelRatio:1,skipEvents={},DomEvent=(Object.freeze||Object)({on:on,off:off,stopPropagation:stopPropagation,disableScrollPropagation:disableScrollPropagation,disableClickPropagation:disableClickPropagation,preventDefault:preventDefault,stop:stop,getMousePosition:getMousePosition,getWheelDelta:getWheelDelta,fakeStop:fakeStop,skipped:skipped,isExternalTarget:isExternalTarget,addListener:on,removeListener:off}),TRANSFORM=testProp(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]),TRANSITION=testProp(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),TRANSITION_END="webkitTransition"===TRANSITION||"OTransition"===TRANSITION?TRANSITION+"End":"transitionend";if("onselectstart"in document)disableTextSelection=function(){on(window,"selectstart",preventDefault)},enableTextSelection=function(){off(window,"selectstart",preventDefault)};else{var userSelectProperty=testProp(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);disableTextSelection=function(){if(userSelectProperty){var style=document.documentElement.style;_userSelect=style[userSelectProperty],style[userSelectProperty]="none"}},enableTextSelection=function(){userSelectProperty&&(document.documentElement.style[userSelectProperty]=_userSelect,_userSelect=void 0)}}var _outlineElement,_outlineStyle,DomUtil=(Object.freeze||Object)({TRANSFORM:TRANSFORM,TRANSITION:TRANSITION,TRANSITION_END:TRANSITION_END,get:get,getStyle:getStyle,create:create$1,remove:remove,empty:empty,toFront:toFront,toBack:toBack,hasClass:hasClass,addClass:addClass,removeClass:removeClass,setClass:setClass,getClass:getClass,setOpacity:setOpacity,testProp:testProp,setTransform:setTransform,setPosition:setPosition,getPosition:getPosition,disableTextSelection:disableTextSelection,enableTextSelection:enableTextSelection,disableImageDrag:disableImageDrag,enableImageDrag:enableImageDrag,preventOutline:preventOutline,restoreOutline:restoreOutline}),PosAnimation=Evented.extend({run:function(el,newPos,duration,easeLinearity){this.stop(),this._el=el,this._inProgress=!0,this._duration=duration||.25,this._easeOutPower=1/Math.max(easeLinearity||.5,.2),this._startPos=getPosition(el),this._offset=newPos.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=requestAnimFrame(this._animate,this),this._step()},_step:function(round){var elapsed=+new Date-this._startTime,duration=1e3*this._duration;elapsed<duration?this._runFrame(this._easeOut(elapsed/duration),round):(this._runFrame(1),this._complete())},_runFrame:function(progress,round){var pos=this._startPos.add(this._offset.multiplyBy(progress));round&&pos._round(),setPosition(this._el,pos),this.fire("step")},_complete:function(){cancelAnimFrame(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),Map=Evented.extend({options:{crs:EPSG3857,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(id,options){options=setOptions(this,options),this._initContainer(id),this._initLayout(),this._onResize=bind(this._onResize,this),this._initEvents(),options.maxBounds&&this.setMaxBounds(options.maxBounds),void 0!==options.zoom&&(this._zoom=this._limitZoom(options.zoom)),options.center&&void 0!==options.zoom&&this.setView(toLatLng(options.center),options.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._zoomAnimated=TRANSITION&&any3d&&!mobileOpera&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),on(this._proxy,TRANSITION_END,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(center,zoom,options){if(zoom=void 0===zoom?this._zoom:this._limitZoom(zoom),center=this._limitCenter(toLatLng(center),zoom,this.options.maxBounds),options=options||{},this._stop(),this._loaded&&!options.reset&&!0!==options){void 0!==options.animate&&(options.zoom=extend({animate:options.animate},options.zoom),options.pan=extend({animate:options.animate,duration:options.duration},options.pan));if(this._zoom!==zoom?this._tryAnimatedZoom&&this._tryAnimatedZoom(center,zoom,options.zoom):this._tryAnimatedPan(center,options.pan))return clearTimeout(this._sizeTimer),this}return this._resetView(center,zoom),this},setZoom:function(zoom,options){return this._loaded?this.setView(this.getCenter(),zoom,{zoom:options}):(this._zoom=zoom,this)},zoomIn:function(delta,options){return delta=delta||(any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+delta,options)},zoomOut:function(delta,options){return delta=delta||(any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-delta,options)},setZoomAround:function(latlng,zoom,options){var scale=this.getZoomScale(zoom),viewHalf=this.getSize().divideBy(2),containerPoint=latlng instanceof Point?latlng:this.latLngToContainerPoint(latlng),centerOffset=containerPoint.subtract(viewHalf).multiplyBy(1-1/scale),newCenter=this.containerPointToLatLng(viewHalf.add(centerOffset));return this.setView(newCenter,zoom,{zoom:options})},_getBoundsCenterZoom:function(bounds,options){options=options||{},bounds=bounds.getBounds?bounds.getBounds():toLatLngBounds(bounds);var paddingTL=toPoint(options.paddingTopLeft||options.padding||[0,0]),paddingBR=toPoint(options.paddingBottomRight||options.padding||[0,0]),zoom=this.getBoundsZoom(bounds,!1,paddingTL.add(paddingBR));if((zoom="number"==typeof options.maxZoom?Math.min(options.maxZoom,zoom):zoom)===1/0)return{center:bounds.getCenter(),zoom:zoom};var paddingOffset=paddingBR.subtract(paddingTL).divideBy(2),swPoint=this.project(bounds.getSouthWest(),zoom),nePoint=this.project(bounds.getNorthEast(),zoom);return{center:this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset),zoom),zoom:zoom}},fitBounds:function(bounds,options){if(bounds=toLatLngBounds(bounds),!bounds.isValid())throw new Error("Bounds are not valid.");var target=this._getBoundsCenterZoom(bounds,options);return this.setView(target.center,target.zoom,options)},fitWorld:function(options){return this.fitBounds([[-90,-180],[90,180]],options)},panTo:function(center,options){return this.setView(center,this._zoom,{pan:options})},panBy:function(offset,options){if(offset=toPoint(offset).round(),options=options||{},!offset.x&&!offset.y)return this.fire("moveend");if(!0!==options.animate&&!this.getSize().contains(offset))return this._resetView(this.unproject(this.project(this.getCenter()).add(offset)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),options.noMoveStart||this.fire("movestart"),!1!==options.animate){addClass(this._mapPane,"leaflet-pan-anim");var newPos=this._getMapPanePos().subtract(offset).round();this._panAnim.run(this._mapPane,newPos,options.duration||.25,options.easeLinearity)}else this._rawPanBy(offset),this.fire("move").fire("moveend");return this},flyTo:function(targetCenter,targetZoom,options){function r(i){var s1=i?-1:1,s2=i?w1:w0,t1=w1*w1-w0*w0+s1*rho2*rho2*u1*u1,b1=2*s2*rho2*u1,b=t1/b1,sq=Math.sqrt(b*b+1)-b;return sq<1e-9?-18:Math.log(sq)}function sinh(n){return(Math.exp(n)-Math.exp(-n))/2}function cosh(n){return(Math.exp(n)+Math.exp(-n))/2}function tanh(n){return sinh(n)/cosh(n)}function w(s){return w0*(cosh(r0)/cosh(r0+rho*s))}function u(s){return w0*(cosh(r0)*tanh(r0+rho*s)-sinh(r0))/rho2}function easeOut(t){return 1-Math.pow(1-t,1.5)}function frame(){var t=(Date.now()-start)/duration,s=easeOut(t)*S;t<=1?(this._flyToFrame=requestAnimFrame(frame,this),this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s)/u1)),startZoom),this.getScaleZoom(w0/w(s),startZoom),{flyTo:!0})):this._move(targetCenter,targetZoom)._moveEnd(!0)}if(options=options||{},!1===options.animate||!any3d)return this.setView(targetCenter,targetZoom,options);this._stop();var from=this.project(this.getCenter()),to=this.project(targetCenter),size=this.getSize(),startZoom=this._zoom;targetCenter=toLatLng(targetCenter),targetZoom=void 0===targetZoom?startZoom:targetZoom;var w0=Math.max(size.x,size.y),w1=w0*this.getZoomScale(startZoom,targetZoom),u1=to.distanceTo(from)||1,rho=1.42,rho2=rho*rho,r0=r(0),start=Date.now(),S=(r(1)-r0)/rho,duration=options.duration?1e3*options.duration:1e3*S*.8;return this._moveStart(!0,options.noMoveStart),frame.call(this),this},flyToBounds:function(bounds,options){var target=this._getBoundsCenterZoom(bounds,options);return this.flyTo(target.center,target.zoom,options)},setMaxBounds:function(bounds){return bounds=toLatLngBounds(bounds),bounds.isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=bounds,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(zoom){var oldZoom=this.options.minZoom;return this.options.minZoom=zoom,this._loaded&&oldZoom!==zoom&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(zoom):this},setMaxZoom:function(zoom){var oldZoom=this.options.maxZoom;return this.options.maxZoom=zoom,this._loaded&&oldZoom!==zoom&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(zoom):this},panInsideBounds:function(bounds,options){this._enforcingBounds=!0;var center=this.getCenter(),newCenter=this._limitCenter(center,this._zoom,toLatLngBounds(bounds));return center.equals(newCenter)||this.panTo(newCenter,options),this._enforcingBounds=!1,this},invalidateSize:function(options){if(!this._loaded)return this;options=extend({animate:!1,pan:!0},!0===options?{animate:!0}:options);var oldSize=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var newSize=this.getSize(),oldCenter=oldSize.divideBy(2).round(),newCenter=newSize.divideBy(2).round(),offset=oldCenter.subtract(newCenter);return offset.x||offset.y?(options.animate&&options.pan?this.panBy(offset):(options.pan&&this._rawPanBy(offset),this.fire("move"),options.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(bind(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:oldSize,newSize:newSize})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(options){if(options=this._locateOptions=extend({timeout:1e4,watch:!1},options),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var onResponse=bind(this._handleGeolocationResponse,this),onError=bind(this._handleGeolocationError,this);return options.watch?this._locationWatchId=navigator.geolocation.watchPosition(onResponse,onError,options):navigator.geolocation.getCurrentPosition(onResponse,onError,options),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(error){var c=error.code,message=error.message||(1===c?"permission denied":2===c?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:c,message:"Geolocation error: "+message+"."})},_handleGeolocationResponse:function(pos){var lat=pos.coords.latitude,lng=pos.coords.longitude,latlng=new LatLng(lat,lng),bounds=latlng.toBounds(pos.coords.accuracy),options=this._locateOptions;if(options.setView){var zoom=this.getBoundsZoom(bounds);this.setView(latlng,options.maxZoom?Math.min(zoom,options.maxZoom):zoom)}var data={latlng:latlng,bounds:bounds,timestamp:pos.timestamp};for(var i in pos.coords)"number"==typeof pos.coords[i]&&(data[i]=pos.coords[i]);this.fire("locationfound",data)},addHandler:function(name,HandlerClass){if(!HandlerClass)return this;var handler=this[name]=new HandlerClass(this);return this._handlers.push(handler),this.options[name]&&handler.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(e){this._container._leaflet_id=void 0,this._containerId=void 0}void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),remove(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this._loaded&&this.fire("unload");var i;for(i in this._layers)this._layers[i].remove();for(i in this._panes)remove(this._panes[i]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(name,container){var className="leaflet-pane"+(name?" leaflet-"+name.replace("Pane","")+"-pane":""),pane=create$1("div",className,container||this._mapPane);return name&&(this._panes[name]=pane),pane},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var bounds=this.getPixelBounds();return new LatLngBounds(this.unproject(bounds.getBottomLeft()),this.unproject(bounds.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(bounds,inside,padding){bounds=toLatLngBounds(bounds),padding=toPoint(padding||[0,0]);var zoom=this.getZoom()||0,min=this.getMinZoom(),max=this.getMaxZoom(),nw=bounds.getNorthWest(),se=bounds.getSouthEast(),size=this.getSize().subtract(padding),boundsSize=toBounds(this.project(se,zoom),this.project(nw,zoom)).getSize(),snap=any3d?this.options.zoomSnap:1,scalex=size.x/boundsSize.x,scaley=size.y/boundsSize.y,scale=inside?Math.max(scalex,scaley):Math.min(scalex,scaley);return zoom=this.getScaleZoom(scale,zoom),snap&&(zoom=Math.round(zoom/(snap/100))*(snap/100),zoom=inside?Math.ceil(zoom/snap)*snap:Math.floor(zoom/snap)*snap),Math.max(min,Math.min(max,zoom))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new Point(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(center,zoom){var topLeftPoint=this._getTopLeftPoint(center,zoom);return new Bounds(topLeftPoint,topLeftPoint.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(zoom){return this.options.crs.getProjectedBounds(void 0===zoom?this.getZoom():zoom)},getPane:function(pane){return"string"==typeof pane?this._panes[pane]:pane},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(toZoom,fromZoom){var crs=this.options.crs;return fromZoom=void 0===fromZoom?this._zoom:fromZoom,crs.scale(toZoom)/crs.scale(fromZoom)},getScaleZoom:function(scale,fromZoom){var crs=this.options.crs;fromZoom=void 0===fromZoom?this._zoom:fromZoom;var zoom=crs.zoom(scale*crs.scale(fromZoom));return isNaN(zoom)?1/0:zoom},project:function(latlng,zoom){return zoom=void 0===zoom?this._zoom:zoom,this.options.crs.latLngToPoint(toLatLng(latlng),zoom)},unproject:function(point,zoom){return zoom=void 0===zoom?this._zoom:zoom,this.options.crs.pointToLatLng(toPoint(point),zoom)},layerPointToLatLng:function(point){var projectedPoint=toPoint(point).add(this.getPixelOrigin());return this.unproject(projectedPoint)},latLngToLayerPoint:function(latlng){return this.project(toLatLng(latlng))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(latlng){return this.options.crs.wrapLatLng(toLatLng(latlng))},wrapLatLngBounds:function(latlng){return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng))},distance:function(latlng1,latlng2){return this.options.crs.distance(toLatLng(latlng1),toLatLng(latlng2))},containerPointToLayerPoint:function(point){return toPoint(point).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(point){return toPoint(point).add(this._getMapPanePos())},containerPointToLatLng:function(point){var layerPoint=this.containerPointToLayerPoint(toPoint(point));return this.layerPointToLatLng(layerPoint)},latLngToContainerPoint:function(latlng){return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)))},mouseEventToContainerPoint:function(e){return getMousePosition(e,this._container)},mouseEventToLayerPoint:function(e){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e))},mouseEventToLatLng:function(e){return this.layerPointToLatLng(this.mouseEventToLayerPoint(e))},_initContainer:function(id){var container=this._container=get(id);if(!container)throw new Error("Map container not found.");if(container._leaflet_id)throw new Error("Map container is already initialized.");on(container,"scroll",this._onScroll,this),this._containerId=stamp(container)},_initLayout:function(){var container=this._container;this._fadeAnimated=this.options.fadeAnimation&&any3d,addClass(container,"leaflet-container"+(touch?" leaflet-touch":"")+(retina?" leaflet-retina":"")+(ielt9?" leaflet-oldie":"")+(safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var position=getStyle(container,"position");"absolute"!==position&&"relative"!==position&&"fixed"!==position&&(container.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var panes=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),setPosition(this._mapPane,new Point(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(addClass(panes.markerPane,"leaflet-zoom-hide"),addClass(panes.shadowPane,"leaflet-zoom-hide"))},_resetView:function(center,zoom){setPosition(this._mapPane,new Point(0,0));var loading=!this._loaded;this._loaded=!0,zoom=this._limitZoom(zoom),this.fire("viewprereset");var zoomChanged=this._zoom!==zoom;this._moveStart(zoomChanged,!1)._move(center,zoom)._moveEnd(zoomChanged),this.fire("viewreset"),loading&&this.fire("load")},_moveStart:function(zoomChanged,noMoveStart){return zoomChanged&&this.fire("zoomstart"),noMoveStart||this.fire("movestart"),this},_move:function(center,zoom,data){void 0===zoom&&(zoom=this._zoom);var zoomChanged=this._zoom!==zoom;return this._zoom=zoom,this._lastCenter=center,this._pixelOrigin=this._getNewPixelOrigin(center),(zoomChanged||data&&data.pinch)&&this.fire("zoom",data),this.fire("move",data)},_moveEnd:function(zoomChanged){return zoomChanged&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return cancelAnimFrame(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(offset){setPosition(this._mapPane,this._getMapPanePos().subtract(offset))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(remove$$1){this._targets={},this._targets[stamp(this._container)]=this;var onOff=remove$$1?off:on;onOff(this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&onOff(window,"resize",this._onResize,this),any3d&&this.options.transform3DLimit&&(remove$$1?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){cancelAnimFrame(this._resizeRequest),this._resizeRequest=requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var pos=this._getMapPanePos();Math.max(Math.abs(pos.x),Math.abs(pos.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(e,type){for(var target,targets=[],isHover="mouseout"===type||"mouseover"===type,src=e.target||e.srcElement,dragging=!1;src;){if((target=this._targets[stamp(src)])&&("click"===type||"preclick"===type)&&!e._simulated&&this._draggableMoved(target)){dragging=!0;break}if(target&&target.listens(type,!0)){if(isHover&&!isExternalTarget(src,e))break;if(targets.push(target),isHover)break}if(src===this._container)break;src=src.parentNode}return targets.length||dragging||isHover||!isExternalTarget(src,e)||(targets=[this]),targets},_handleDOMEvent:function(e){if(this._loaded&&!skipped(e)){var type=e.type;"mousedown"!==type&&"keypress"!==type||preventOutline(e.target||e.srcElement),this._fireDOMEvent(e,type)}},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(e,type,targets){if("click"===e.type){var synth=extend({},e);synth.type="preclick",this._fireDOMEvent(synth,synth.type,targets)}if(!e._stopped&&(targets=(targets||[]).concat(this._findEventTargets(e,type)),targets.length)){var target=targets[0];"contextmenu"===type&&target.listens(type,!0)&&preventDefault(e);var data={originalEvent:e};if("keypress"!==e.type){var isMarker=target.getLatLng&&(!target._radius||target._radius<=10);data.containerPoint=isMarker?this.latLngToContainerPoint(target.getLatLng()):this.mouseEventToContainerPoint(e),data.layerPoint=this.containerPointToLayerPoint(data.containerPoint),data.latlng=isMarker?target.getLatLng():this.layerPointToLatLng(data.layerPoint)}for(var i=0;i<targets.length;i++)if(targets[i].fire(type,data,!0),data.originalEvent._stopped||!1===targets[i].options.bubblingMouseEvents&&-1!==indexOf(this._mouseEvents,type))return}},_draggableMoved:function(obj){return obj=obj.dragging&&obj.dragging.enabled()?obj:this,obj.dragging&&obj.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var i=0,len=this._handlers.length;i<len;i++)this._handlers[i].disable()},whenReady:function(callback,context){return this._loaded?callback.call(context||this,{target:this}):this.on("load",callback,context),this},_getMapPanePos:function(){return getPosition(this._mapPane)||new Point(0,0)},_moved:function(){var pos=this._getMapPanePos();return pos&&!pos.equals([0,0])},_getTopLeftPoint:function(center,zoom){return(center&&void 0!==zoom?this._getNewPixelOrigin(center,zoom):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(center,zoom){var viewHalf=this.getSize()._divideBy(2);return this.project(center,zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(latlng,zoom,center){var topLeft=this._getNewPixelOrigin(center,zoom);return this.project(latlng,zoom)._subtract(topLeft)},_latLngBoundsToNewLayerBounds:function(latLngBounds,zoom,center){var topLeft=this._getNewPixelOrigin(center,zoom);return toBounds([this.project(latLngBounds.getSouthWest(),zoom)._subtract(topLeft),this.project(latLngBounds.getNorthWest(),zoom)._subtract(topLeft),this.project(latLngBounds.getSouthEast(),zoom)._subtract(topLeft),this.project(latLngBounds.getNorthEast(),zoom)._subtract(topLeft)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(latlng){return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint())},_limitCenter:function(center,zoom,bounds){if(!bounds)return center;var centerPoint=this.project(center,zoom),viewHalf=this.getSize().divideBy(2),viewBounds=new Bounds(centerPoint.subtract(viewHalf),centerPoint.add(viewHalf)),offset=this._getBoundsOffset(viewBounds,bounds,zoom);return offset.round().equals([0,0])?center:this.unproject(centerPoint.add(offset),zoom)},_limitOffset:function(offset,bounds){if(!bounds)return offset;var viewBounds=this.getPixelBounds(),newBounds=new Bounds(viewBounds.min.add(offset),viewBounds.max.add(offset));return offset.add(this._getBoundsOffset(newBounds,bounds))},_getBoundsOffset:function(pxBounds,maxBounds,zoom){var projectedMaxBounds=toBounds(this.project(maxBounds.getNorthEast(),zoom),this.project(maxBounds.getSouthWest(),zoom)),minOffset=projectedMaxBounds.min.subtract(pxBounds.min),maxOffset=projectedMaxBounds.max.subtract(pxBounds.max);return new Point(this._rebound(minOffset.x,-maxOffset.x),this._rebound(minOffset.y,-maxOffset.y))},_rebound:function(left,right){return left+right>0?Math.round(left-right)/2:Math.max(0,Math.ceil(left))-Math.max(0,Math.floor(right))},_limitZoom:function(zoom){var min=this.getMinZoom(),max=this.getMaxZoom(),snap=any3d?this.options.zoomSnap:1;return snap&&(zoom=Math.round(zoom/snap)*snap),Math.max(min,Math.min(max,zoom))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){removeClass(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(center,options){var offset=this._getCenterOffset(center)._trunc();return!(!0!==(options&&options.animate)&&!this.getSize().contains(offset))&&(this.panBy(offset,options),!0)},_createAnimProxy:function(){var proxy=this._proxy=create$1("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(proxy),this.on("zoomanim",function(e){var prop=TRANSFORM,transform=this._proxy.style[prop];setTransform(this._proxy,this.project(e.center,e.zoom),this.getZoomScale(e.zoom,1)),transform===this._proxy.style[prop]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var c=this.getCenter(),z=this.getZoom();setTransform(this._proxy,this.project(c,z),this.getZoomScale(z,1))},this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){remove(this._proxy),delete this._proxy},_catchTransitionEnd:function(e){this._animatingZoom&&e.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(center,zoom,options){if(this._animatingZoom)return!0;if(options=options||{},!this._zoomAnimated||!1===options.animate||this._nothingToAnimate()||Math.abs(zoom-this._zoom)>this.options.zoomAnimationThreshold)return!1;var scale=this.getZoomScale(zoom),offset=this._getCenterOffset(center)._divideBy(1-1/scale);return!(!0!==options.animate&&!this.getSize().contains(offset))&&(requestAnimFrame(function(){this._moveStart(!0,!1)._animateZoom(center,zoom,!0)},this),!0)},_animateZoom:function(center,zoom,startAnim,noUpdate){this._mapPane&&(startAnim&&(this._animatingZoom=!0,this._animateToCenter=center,this._animateToZoom=zoom,addClass(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:center,zoom:zoom,noUpdate:noUpdate}),setTimeout(bind(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&removeClass(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),requestAnimFrame(function(){this._moveEnd(!0)},this))}}),Control=Class.extend({options:{position:"topright"},initialize:function(options){setOptions(this,options)},getPosition:function(){return this.options.position},setPosition:function(position){var map=this._map;return map&&map.removeControl(this),this.options.position=position,map&&map.addControl(this),this},getContainer:function(){return this._container},addTo:function(map){this.remove(),this._map=map;var container=this._container=this.onAdd(map),pos=this.getPosition(),corner=map._controlCorners[pos];return addClass(container,"leaflet-control"),-1!==pos.indexOf("bottom")?corner.insertBefore(container,corner.firstChild):corner.appendChild(container),this},remove:function(){return this._map?(remove(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(e){this._map&&e&&e.screenX>0&&e.screenY>0&&this._map.getContainer().focus()}}),control=function(options){return new Control(options)};Map.include({addControl:function(control){return control.addTo(this),this},removeControl:function(control){return control.remove(),this},_initControlPos:function(){function createCorner(vSide,hSide){var className=l+vSide+" "+l+hSide;corners[vSide+hSide]=create$1("div",className,container)}var corners=this._controlCorners={},l="leaflet-",container=this._controlContainer=create$1("div",l+"control-container",this._container);createCorner("top","left"),createCorner("top","right"),createCorner("bottom","left"),createCorner("bottom","right")},_clearControlPos:function(){for(var i in this._controlCorners)remove(this._controlCorners[i]);remove(this._controlContainer),delete this._controlCorners,delete this._controlContainer}});var Layers=Control.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(layerA,layerB,nameA,nameB){return nameA<nameB?-1:nameB<nameA?1:0}},initialize:function(baseLayers,overlays,options){setOptions(this,options),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var i in baseLayers)this._addLayer(baseLayers[i],i);for(i in overlays)this._addLayer(overlays[i],i,!0)},onAdd:function(map){this._initLayout(),this._update(),this._map=map,map.on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(map){return Control.prototype.addTo.call(this,map),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(layer,name){return this._addLayer(layer,name),this._map?this._update():this},addOverlay:function(layer,name){return this._addLayer(layer,name,!0),this._map?this._update():this},removeLayer:function(layer){layer.off("add remove",this._onLayerChange,this);var obj=this._getLayer(stamp(layer));return obj&&this._layers.splice(this._layers.indexOf(obj),1),this._map?this._update():this},expand:function(){addClass(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var acceptableHeight=this._map.getSize().y-(this._container.offsetTop+50);return acceptableHeight<this._form.clientHeight?(addClass(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=acceptableHeight+"px"):removeClass(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return removeClass(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var className="leaflet-control-layers",container=this._container=create$1("div",className),collapsed=this.options.collapsed;container.setAttribute("aria-haspopup",!0),disableClickPropagation(container),disableScrollPropagation(container);var form=this._form=create$1("form",className+"-list");collapsed&&(this._map.on("click",this.collapse,this),android||on(container,{mouseenter:this.expand,mouseleave:this.collapse},this));var link=this._layersLink=create$1("a",className+"-toggle",container);link.href="#",link.title="Layers",touch?(on(link,"click",stop),on(link,"click",this.expand,this)):on(link,"focus",this.expand,this),collapsed||this.expand(),this._baseLayersList=create$1("div",className+"-base",form),this._separator=create$1("div",className+"-separator",form),this._overlaysList=create$1("div",className+"-overlays",form),container.appendChild(form)},_getLayer:function(id){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&stamp(this._layers[i].layer)===id)return this._layers[i]},_addLayer:function(layer,name,overlay){this._map&&layer.on("add remove",this._onLayerChange,this),this._layers.push({layer:layer,name:name,overlay:overlay}),this.options.sortLayers&&this._layers.sort(bind(function(a,b){return this.options.sortFunction(a.layer,b.layer,a.name,b.name)},this)),this.options.autoZIndex&&layer.setZIndex&&(this._lastZIndex++,layer.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;empty(this._baseLayersList),empty(this._overlaysList),this._layerControlInputs=[];var baseLayersPresent,overlaysPresent,i,obj,baseLayersCount=0;for(i=0;i<this._layers.length;i++)obj=this._layers[i],this._addItem(obj),overlaysPresent=overlaysPresent||obj.overlay,baseLayersPresent=baseLayersPresent||!obj.overlay,baseLayersCount+=obj.overlay?0:1;return this.options.hideSingleBase&&(baseLayersPresent=baseLayersPresent&&baseLayersCount>1,this._baseLayersList.style.display=baseLayersPresent?"":"none"),this._separator.style.display=overlaysPresent&&baseLayersPresent?"":"none",this},_onLayerChange:function(e){this._handlingClick||this._update();var obj=this._getLayer(stamp(e.target)),type=obj.overlay?"add"===e.type?"overlayadd":"overlayremove":"add"===e.type?"baselayerchange":null;type&&this._map.fire(type,obj)},_createRadioElement:function(name,checked){var radioHtml='<input type="radio" class="leaflet-control-layers-selector" name="'+name+'"'+(checked?' checked="checked"':"")+"/>",radioFragment=document.createElement("div");return radioFragment.innerHTML=radioHtml,radioFragment.firstChild},_addItem:function(obj){var input,label=document.createElement("label"),checked=this._map.hasLayer(obj.layer);obj.overlay?(input=document.createElement("input"),input.type="checkbox",input.className="leaflet-control-layers-selector",input.defaultChecked=checked):input=this._createRadioElement("leaflet-base-layers",checked),this._layerControlInputs.push(input),input.layerId=stamp(obj.layer),on(input,"click",this._onInputClick,this);var name=document.createElement("span");name.innerHTML=" "+obj.name;var holder=document.createElement("div");return label.appendChild(holder),holder.appendChild(input),holder.appendChild(name),(obj.overlay?this._overlaysList:this._baseLayersList).appendChild(label),this._checkDisabledLayers(),label},_onInputClick:function(){var input,layer,inputs=this._layerControlInputs,addedLayers=[],removedLayers=[];this._handlingClick=!0;for(var i=inputs.length-1;i>=0;i--)input=inputs[i],layer=this._getLayer(input.layerId).layer,input.checked?addedLayers.push(layer):input.checked||removedLayers.push(layer);for(i=0;i<removedLayers.length;i++)this._map.hasLayer(removedLayers[i])&&this._map.removeLayer(removedLayers[i]);for(i=0;i<addedLayers.length;i++)this._map.hasLayer(addedLayers[i])||this._map.addLayer(addedLayers[i]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var input,layer,inputs=this._layerControlInputs,zoom=this._map.getZoom(),i=inputs.length-1;i>=0;i--)input=inputs[i],layer=this._getLayer(input.layerId).layer,input.disabled=void 0!==layer.options.minZoom&&zoom<layer.options.minZoom||void 0!==layer.options.maxZoom&&zoom>layer.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),layers=function(baseLayers,overlays,options){return new Layers(baseLayers,overlays,options)},Zoom=Control.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"&#x2212;",zoomOutTitle:"Zoom out"},onAdd:function(map){var zoomName="leaflet-control-zoom",container=create$1("div",zoomName+" leaflet-bar"),options=this.options;return this._zoomInButton=this._createButton(options.zoomInText,options.zoomInTitle,zoomName+"-in",container,this._zoomIn),this._zoomOutButton=this._createButton(options.zoomOutText,options.zoomOutTitle,zoomName+"-out",container,this._zoomOut),this._updateDisabled(),map.on("zoomend zoomlevelschange",this._updateDisabled,this),container},onRemove:function(map){map.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(e){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(e.shiftKey?3:1))},_zoomOut:function(e){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(e.shiftKey?3:1))},_createButton:function(html,title,className,container,fn){var link=create$1("a",className,container);return link.innerHTML=html,link.href="#",link.title=title,link.setAttribute("role","button"),link.setAttribute("aria-label",title),disableClickPropagation(link),on(link,"click",stop),on(link,"click",fn,this),on(link,"click",this._refocusOnMap,this),link},_updateDisabled:function(){var map=this._map,className="leaflet-disabled";removeClass(this._zoomInButton,className),removeClass(this._zoomOutButton,className),(this._disabled||map._zoom===map.getMinZoom())&&addClass(this._zoomOutButton,className),(this._disabled||map._zoom===map.getMaxZoom())&&addClass(this._zoomInButton,className)}});Map.mergeOptions({zoomControl:!0}),Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new Zoom,this.addControl(this.zoomControl))});var zoom=function(options){return new Zoom(options)},Scale=Control.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(map){var container=create$1("div","leaflet-control-scale"),options=this.options;return this._addScales(options,"leaflet-control-scale-line",container),map.on(options.updateWhenIdle?"moveend":"move",this._update,this),map.whenReady(this._update,this),container},onRemove:function(map){map.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(options,className,container){options.metric&&(this._mScale=create$1("div",className,container)),options.imperial&&(this._iScale=create$1("div",className,container))},_update:function(){var map=this._map,y=map.getSize().y/2,maxMeters=map.distance(map.containerPointToLatLng([0,y]),map.containerPointToLatLng([this.options.maxWidth,y]));this._updateScales(maxMeters)},_updateScales:function(maxMeters){this.options.metric&&maxMeters&&this._updateMetric(maxMeters),this.options.imperial&&maxMeters&&this._updateImperial(maxMeters)},_updateMetric:function(maxMeters){var meters=this._getRoundNum(maxMeters),label=meters<1e3?meters+" m":meters/1e3+" km";this._updateScale(this._mScale,label,meters/maxMeters)},_updateImperial:function(maxMeters){var maxMiles,miles,feet,maxFeet=3.2808399*maxMeters;maxFeet>5280?(maxMiles=maxFeet/5280,miles=this._getRoundNum(maxMiles),this._updateScale(this._iScale,miles+" mi",miles/maxMiles)):(feet=this._getRoundNum(maxFeet),this._updateScale(this._iScale,feet+" ft",feet/maxFeet))},_updateScale:function(scale,text,ratio){scale.style.width=Math.round(this.options.maxWidth*ratio)+"px",scale.innerHTML=text},_getRoundNum:function(num){var pow10=Math.pow(10,(Math.floor(num)+"").length-1),d=num/pow10;return d=d>=10?10:d>=5?5:d>=3?3:d>=2?2:1,pow10*d}}),scale=function(options){return new Scale(options)},Attribution=Control.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(options){setOptions(this,options),this._attributions={}},onAdd:function(map){map.attributionControl=this,this._container=create$1("div","leaflet-control-attribution"),disableClickPropagation(this._container);for(var i in map._layers)map._layers[i].getAttribution&&this.addAttribution(map._layers[i].getAttribution());return this._update(),this._container},setPrefix:function(prefix){return this.options.prefix=prefix,this._update(),this},addAttribution:function(text){return text?(this._attributions[text]||(this._attributions[text]=0),this._attributions[text]++,this._update(),this):this},removeAttribution:function(text){return text?(this._attributions[text]&&(this._attributions[text]--,this._update()),this):this},_update:function(){if(this._map){var attribs=[];for(var i in this._attributions)this._attributions[i]&&attribs.push(i);var prefixAndAttribs=[];this.options.prefix&&prefixAndAttribs.push(this.options.prefix),attribs.length&&prefixAndAttribs.push(attribs.join(", ")),this._container.innerHTML=prefixAndAttribs.join(" | ")}}});Map.mergeOptions({attributionControl:!0}),Map.addInitHook(function(){this.options.attributionControl&&(new Attribution).addTo(this)});var attribution=function(options){return new Attribution(options)};Control.Layers=Layers,Control.Zoom=Zoom,Control.Scale=Scale,Control.Attribution=Attribution,control.layers=layers,control.zoom=zoom,control.scale=scale,control.attribution=attribution;var Handler=Class.extend({initialize:function(map){this._map=map},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}});Handler.addTo=function(map,name){return map.addHandler(name,this),this};var _lastCode,Mixin={Events:Events},START=touch?"touchstart mousedown":"mousedown",END={mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},MOVE={mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"},Draggable=Evented.extend({options:{clickTolerance:3},initialize:function(element,dragStartTarget,preventOutline$$1,options){setOptions(this,options),this._element=element,this._dragStartTarget=dragStartTarget||element,this._preventOutline=preventOutline$$1},enable:function(){this._enabled||(on(this._dragStartTarget,START,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Draggable._dragging===this&&this.finishDrag(),off(this._dragStartTarget,START,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(e){if(!e._simulated&&this._enabled&&(this._moved=!1,!hasClass(this._element,"leaflet-zoom-anim")&&!(Draggable._dragging||e.shiftKey||1!==e.which&&1!==e.button&&!e.touches||(Draggable._dragging=this,this._preventOutline&&preventOutline(this._element),disableImageDrag(),disableTextSelection(),this._moving)))){this.fire("down");var first=e.touches?e.touches[0]:e;this._startPoint=new Point(first.clientX,first.clientY),on(document,MOVE[e.type],this._onMove,this),on(document,END[e.type],this._onUp,this)}},_onMove:function(e){if(!e._simulated&&this._enabled){if(e.touches&&e.touches.length>1)return void(this._moved=!0);var first=e.touches&&1===e.touches.length?e.touches[0]:e,newPoint=new Point(first.clientX,first.clientY),offset=newPoint.subtract(this._startPoint);(offset.x||offset.y)&&(Math.abs(offset.x)+Math.abs(offset.y)<this.options.clickTolerance||(preventDefault(e),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=getPosition(this._element).subtract(offset),addClass(document.body,"leaflet-dragging"),this._lastTarget=e.target||e.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),addClass(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(offset),this._moving=!0,cancelAnimFrame(this._animRequest),this._lastEvent=e,this._animRequest=requestAnimFrame(this._updatePosition,this,!0)))}},_updatePosition:function(){var e={originalEvent:this._lastEvent};this.fire("predrag",e),setPosition(this._element,this._newPos),this.fire("drag",e)},_onUp:function(e){!e._simulated&&this._enabled&&this.finishDrag()},finishDrag:function(){removeClass(document.body,"leaflet-dragging"),this._lastTarget&&(removeClass(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var i in MOVE)off(document,MOVE[i],this._onMove,this),off(document,END[i],this._onUp,this);enableImageDrag(),enableTextSelection(),this._moved&&this._moving&&(cancelAnimFrame(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,Draggable._dragging=!1}}),LineUtil=(Object.freeze||Object)({simplify:simplify,pointToSegmentDistance:pointToSegmentDistance,closestPointOnSegment:closestPointOnSegment,clipSegment:clipSegment,_getEdgeIntersection:_getEdgeIntersection,_getBitCode:_getBitCode,_sqClosestPointOnSegment:_sqClosestPointOnSegment,isFlat:isFlat,_flat:_flat}),PolyUtil=(Object.freeze||Object)({clipPolygon:clipPolygon}),LonLat={project:function(latlng){return new Point(latlng.lng,latlng.lat)},unproject:function(point){return new LatLng(point.y,point.x)},bounds:new Bounds([-180,-90],[180,90])},Mercator={R:6378137,R_MINOR:6356752.314245179,bounds:new Bounds([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(latlng){var d=Math.PI/180,r=this.R,y=latlng.lat*d,tmp=this.R_MINOR/r,e=Math.sqrt(1-tmp*tmp),con=e*Math.sin(y),ts=Math.tan(Math.PI/4-y/2)/Math.pow((1-con)/(1+con),e/2);return y=-r*Math.log(Math.max(ts,1e-10)),new Point(latlng.lng*d*r,y)},unproject:function(point){for(var con,d=180/Math.PI,r=this.R,tmp=this.R_MINOR/r,e=Math.sqrt(1-tmp*tmp),ts=Math.exp(-point.y/r),phi=Math.PI/2-2*Math.atan(ts),i=0,dphi=.1;i<15&&Math.abs(dphi)>1e-7;i++)con=e*Math.sin(phi),con=Math.pow((1-con)/(1+con),e/2),dphi=Math.PI/2-2*Math.atan(ts*con)-phi,phi+=dphi;return new LatLng(phi*d,point.x*d/r)}},index=(Object.freeze||Object)({LonLat:LonLat,Mercator:Mercator,SphericalMercator:SphericalMercator}),EPSG3395=extend({},Earth,{code:"EPSG:3395",projection:Mercator,transformation:function(){var scale=.5/(Math.PI*Mercator.R);return toTransformation(scale,.5,-scale,.5)}()}),EPSG4326=extend({},Earth,{code:"EPSG:4326",projection:LonLat,transformation:toTransformation(1/180,1,-1/180,.5)}),Simple=extend({},CRS,{projection:LonLat,transformation:toTransformation(1,0,-1,0),scale:function(zoom){return Math.pow(2,zoom)},zoom:function(scale){return Math.log(scale)/Math.LN2},distance:function(latlng1,latlng2){var dx=latlng2.lng-latlng1.lng,dy=latlng2.lat-latlng1.lat;return Math.sqrt(dx*dx+dy*dy)},infinite:!0});CRS.Earth=Earth,CRS.EPSG3395=EPSG3395,CRS.EPSG3857=EPSG3857,CRS.EPSG900913=EPSG900913,CRS.EPSG4326=EPSG4326,CRS.Simple=Simple;var Layer=Evented.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(map){return map.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(obj){return obj&&obj.removeLayer(this),this},getPane:function(name){return this._map.getPane(name?this.options[name]||name:this.options.pane)},addInteractiveTarget:function(targetEl){return this._map._targets[stamp(targetEl)]=this,this},removeInteractiveTarget:function(targetEl){return delete this._map._targets[stamp(targetEl)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(e){var map=e.target;if(map.hasLayer(this)){if(this._map=map,this._zoomAnimated=map._zoomAnimated,this.getEvents){var events=this.getEvents();map.on(events,this),this.once("remove",function(){map.off(events,this)},this)}this.onAdd(map),this.getAttribution&&map.attributionControl&&map.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),map.fire("layeradd",{layer:this})}}});Map.include({addLayer:function(layer){if(!layer._layerAdd)throw new Error("The provided object is not a Layer.");var id=stamp(layer);return this._layers[id]?this:(this._layers[id]=layer,layer._mapToAdd=this,layer.beforeAdd&&layer.beforeAdd(this),this.whenReady(layer._layerAdd,layer),this)},removeLayer:function(layer){var id=stamp(layer);return this._layers[id]?(this._loaded&&layer.onRemove(this),layer.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(layer.getAttribution()),delete this._layers[id],this._loaded&&(this.fire("layerremove",{layer:layer}),layer.fire("remove")),layer._map=layer._mapToAdd=null,this):this},hasLayer:function(layer){return!!layer&&stamp(layer)in this._layers},eachLayer:function(method,context){for(var i in this._layers)method.call(context,this._layers[i]);return this},_addLayers:function(layers){layers=layers?isArray(layers)?layers:[layers]:[];for(var i=0,len=layers.length;i<len;i++)this.addLayer(layers[i])},_addZoomLimit:function(layer){!isNaN(layer.options.maxZoom)&&isNaN(layer.options.minZoom)||(this._zoomBoundLayers[stamp(layer)]=layer,this._updateZoomLevels())},_removeZoomLimit:function(layer){var id=stamp(layer);this._zoomBoundLayers[id]&&(delete this._zoomBoundLayers[id],this._updateZoomLevels())},_updateZoomLevels:function(){var minZoom=1/0,maxZoom=-1/0,oldZoomSpan=this._getZoomSpan();for(var i in this._zoomBoundLayers){var options=this._zoomBoundLayers[i].options;minZoom=void 0===options.minZoom?minZoom:Math.min(minZoom,options.minZoom),maxZoom=void 0===options.maxZoom?maxZoom:Math.max(maxZoom,options.maxZoom)}this._layersMaxZoom=maxZoom===-1/0?void 0:maxZoom,this._layersMinZoom=minZoom===1/0?void 0:minZoom,oldZoomSpan!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}});var LayerGroup=Layer.extend({initialize:function(layers,options){setOptions(this,options),this._layers={};var i,len;if(layers)for(i=0,len=layers.length;i<len;i++)this.addLayer(layers[i])},addLayer:function(layer){var id=this.getLayerId(layer);return this._layers[id]=layer,this._map&&this._map.addLayer(layer),this},removeLayer:function(layer){var id=layer in this._layers?layer:this.getLayerId(layer);return this._map&&this._layers[id]&&this._map.removeLayer(this._layers[id]),delete this._layers[id],this},hasLayer:function(layer){return!!layer&&(layer in this._layers||this.getLayerId(layer)in this._layers)},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(methodName){var i,layer,args=Array.prototype.slice.call(arguments,1);for(i in this._layers)layer=this._layers[i],layer[methodName]&&layer[methodName].apply(layer,args);return this},onAdd:function(map){this.eachLayer(map.addLayer,map)},onRemove:function(map){this.eachLayer(map.removeLayer,map)},eachLayer:function(method,context){for(var i in this._layers)method.call(context,this._layers[i]);return this},getLayer:function(id){return this._layers[id]},getLayers:function(){var layers=[];return this.eachLayer(layers.push,layers),layers},setZIndex:function(zIndex){return this.invoke("setZIndex",zIndex)},getLayerId:function(layer){return stamp(layer)}}),layerGroup=function(layers,options){return new LayerGroup(layers,options)},FeatureGroup=LayerGroup.extend({addLayer:function(layer){return this.hasLayer(layer)?this:(layer.addEventParent(this),LayerGroup.prototype.addLayer.call(this,layer),this.fire("layeradd",{layer:layer}))},removeLayer:function(layer){return this.hasLayer(layer)?(layer in this._layers&&(layer=this._layers[layer]),layer.removeEventParent(this),LayerGroup.prototype.removeLayer.call(this,layer),this.fire("layerremove",{layer:layer})):this},setStyle:function(style){return this.invoke("setStyle",style)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var bounds=new LatLngBounds;for(var id in this._layers){var layer=this._layers[id];bounds.extend(layer.getBounds?layer.getBounds():layer.getLatLng())}return bounds}}),featureGroup=function(layers){return new FeatureGroup(layers)},Icon=Class.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0]},initialize:function(options){setOptions(this,options)},createIcon:function(oldIcon){return this._createIcon("icon",oldIcon)},createShadow:function(oldIcon){return this._createIcon("shadow",oldIcon)},_createIcon:function(name,oldIcon){var src=this._getIconUrl(name);if(!src){if("icon"===name)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var img=this._createImg(src,oldIcon&&"IMG"===oldIcon.tagName?oldIcon:null);return this._setIconStyles(img,name),img},_setIconStyles:function(img,name){var options=this.options,sizeOption=options[name+"Size"];"number"==typeof sizeOption&&(sizeOption=[sizeOption,sizeOption]);var size=toPoint(sizeOption),anchor=toPoint("shadow"===name&&options.shadowAnchor||options.iconAnchor||size&&size.divideBy(2,!0));img.className="leaflet-marker-"+name+" "+(options.className||""),anchor&&(img.style.marginLeft=-anchor.x+"px",img.style.marginTop=-anchor.y+"px"),size&&(img.style.width=size.x+"px",img.style.height=size.y+"px")},_createImg:function(src,el){return el=el||document.createElement("img"),el.src=src,el},_getIconUrl:function(name){return retina&&this.options[name+"RetinaUrl"]||this.options[name+"Url"]}}),IconDefault=Icon.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(name){return IconDefault.imagePath||(IconDefault.imagePath=this._detectIconPath()),(this.options.imagePath||IconDefault.imagePath)+Icon.prototype._getIconUrl.call(this,name)},_detectIconPath:function(){var el=create$1("div","leaflet-default-icon-path",document.body),path=getStyle(el,"background-image")||getStyle(el,"backgroundImage");return document.body.removeChild(el),path=null===path||0!==path.indexOf("url")?"":path.replace(/^url\(["']?/,"").replace(/marker-icon\.png["']?\)$/,"")}}),MarkerDrag=Handler.extend({initialize:function(marker){this._marker=marker},addHooks:function(){var icon=this._marker._icon;this._draggable||(this._draggable=new Draggable(icon,icon,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),addClass(icon,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&removeClass(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(e){var marker=this._marker,map=marker._map,speed=this._marker.options.autoPanSpeed,padding=this._marker.options.autoPanPadding,iconPos=L.DomUtil.getPosition(marker._icon),bounds=map.getPixelBounds(),origin=map.getPixelOrigin(),panBounds=toBounds(bounds.min._subtract(origin).add(padding),bounds.max._subtract(origin).subtract(padding));if(!panBounds.contains(iconPos)){var movement=toPoint((Math.max(panBounds.max.x,iconPos.x)-panBounds.max.x)/(bounds.max.x-panBounds.max.x)-(Math.min(panBounds.min.x,iconPos.x)-panBounds.min.x)/(bounds.min.x-panBounds.min.x),(Math.max(panBounds.max.y,iconPos.y)-panBounds.max.y)/(bounds.max.y-panBounds.max.y)-(Math.min(panBounds.min.y,iconPos.y)-panBounds.min.y)/(bounds.min.y-panBounds.min.y)).multiplyBy(speed);map.panBy(movement,{animate:!1}),this._draggable._newPos._add(movement),this._draggable._startPos._add(movement),L.DomUtil.setPosition(marker._icon,this._draggable._newPos),this._onDrag(e),this._panRequest=requestAnimFrame(this._adjustPan.bind(this,e))}},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onPreDrag:function(e){this._marker.options.autoPan&&(cancelAnimFrame(this._panRequest),this._panRequest=requestAnimFrame(this._adjustPan.bind(this,e)))},_onDrag:function(e){var marker=this._marker,shadow=marker._shadow,iconPos=getPosition(marker._icon),latlng=marker._map.layerPointToLatLng(iconPos);shadow&&setPosition(shadow,iconPos),marker._latlng=latlng,e.latlng=latlng,e.oldLatLng=this._oldLatLng,marker.fire("move",e).fire("drag",e)},_onDragEnd:function(e){cancelAnimFrame(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",e)}}),Marker=Layer.extend({options:{icon:new IconDefault,interactive:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",bubblingMouseEvents:!1},initialize:function(latlng,options){setOptions(this,options),this._latlng=toLatLng(latlng)},onAdd:function(map){this._zoomAnimated=this._zoomAnimated&&map.options.markerZoomAnimation,this._zoomAnimated&&map.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(map){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&map.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(latlng){var oldLatLng=this._latlng;return this._latlng=toLatLng(latlng),this.update(),this.fire("move",{oldLatLng:oldLatLng,latlng:this._latlng})},setZIndexOffset:function(offset){return this.options.zIndexOffset=offset,this.update()},setIcon:function(icon){return this.options.icon=icon,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon&&this._map){var pos=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(pos)}return this},_initIcon:function(){var options=this.options,classToAdd="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),icon=options.icon.createIcon(this._icon),addIcon=!1;icon!==this._icon&&(this._icon&&this._removeIcon(),addIcon=!0,options.title&&(icon.title=options.title),"IMG"===icon.tagName&&(icon.alt=options.alt||"")),addClass(icon,classToAdd),options.keyboard&&(icon.tabIndex="0"),this._icon=icon,options.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var newShadow=options.icon.createShadow(this._shadow),addShadow=!1;newShadow!==this._shadow&&(this._removeShadow(),addShadow=!0),newShadow&&(addClass(newShadow,classToAdd),newShadow.alt=""),this._shadow=newShadow,options.opacity<1&&this._updateOpacity(),addIcon&&this.getPane().appendChild(this._icon),this._initInteraction(),newShadow&&addShadow&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),remove(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&remove(this._shadow),this._shadow=null},_setPos:function(pos){setPosition(this._icon,pos),this._shadow&&setPosition(this._shadow,pos),this._zIndex=pos.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(offset){this._icon.style.zIndex=this._zIndex+offset},_animateZoom:function(opt){var pos=this._map._latLngToNewLayerPoint(this._latlng,opt.zoom,opt.center).round();this._setPos(pos)},_initInteraction:function(){if(this.options.interactive&&(addClass(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),MarkerDrag)){var draggable=this.options.draggable;this.dragging&&(draggable=this.dragging.enabled(),this.dragging.disable()),this.dragging=new MarkerDrag(this),draggable&&this.dragging.enable()}},setOpacity:function(opacity){return this.options.opacity=opacity,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var opacity=this.options.opacity;setOpacity(this._icon,opacity),this._shadow&&setOpacity(this._shadow,opacity)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}}),Path=Layer.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(map){this._renderer=map.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(style){return setOptions(this,style),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+this._renderer.options.tolerance}}),CircleMarker=Path.extend({options:{fill:!0,radius:10},initialize:function(latlng,options){setOptions(this,options),this._latlng=toLatLng(latlng),this._radius=this.options.radius},setLatLng:function(latlng){return this._latlng=toLatLng(latlng),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(radius){return this.options.radius=this._radius=radius,this.redraw()},getRadius:function(){return this._radius},setStyle:function(options){var radius=options&&options.radius||this._radius;return Path.prototype.setStyle.call(this,options),this.setRadius(radius),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var r=this._radius,r2=this._radiusY||r,w=this._clickTolerance(),p=[r+w,r2+w];this._pxBounds=new Bounds(this._point.subtract(p),this._point.add(p))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(p){return p.distanceTo(this._point)<=this._radius+this._clickTolerance()}}),Circle=CircleMarker.extend({initialize:function(latlng,options,legacyOptions){if("number"==typeof options&&(options=extend({},legacyOptions,{radius:options})),setOptions(this,options),this._latlng=toLatLng(latlng),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(radius){return this._mRadius=radius,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var half=[this._radius,this._radiusY||this._radius];return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)),this._map.layerPointToLatLng(this._point.add(half)))},setStyle:Path.prototype.setStyle,_project:function(){var lng=this._latlng.lng,lat=this._latlng.lat,map=this._map,crs=map.options.crs;if(crs.distance===Earth.distance){var d=Math.PI/180,latR=this._mRadius/Earth.R/d,top=map.project([lat+latR,lng]),bottom=map.project([lat-latR,lng]),p=top.add(bottom).divideBy(2),lat2=map.unproject(p).lat,lngR=Math.acos((Math.cos(latR*d)-Math.sin(lat*d)*Math.sin(lat2*d))/(Math.cos(lat*d)*Math.cos(lat2*d)))/d;(isNaN(lngR)||0===lngR)&&(lngR=latR/Math.cos(Math.PI/180*lat)),this._point=p.subtract(map.getPixelOrigin()),this._radius=isNaN(lngR)?0:p.x-map.project([lat2,lng-lngR]).x,this._radiusY=p.y-top.y}else{var latlng2=crs.unproject(crs.project(this._latlng).subtract([this._mRadius,0]));this._point=map.latLngToLayerPoint(this._latlng),this._radius=this._point.x-map.latLngToLayerPoint(latlng2).x}this._updateBounds()}}),Polyline=Path.extend({options:{smoothFactor:1,noClip:!1},initialize:function(latlngs,options){setOptions(this,options),this._setLatLngs(latlngs)},getLatLngs:function(){return this._latlngs},setLatLngs:function(latlngs){return this._setLatLngs(latlngs),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(p){for(var p1,p2,minDistance=1/0,minPoint=null,closest=_sqClosestPointOnSegment,j=0,jLen=this._parts.length;j<jLen;j++)for(var points=this._parts[j],i=1,len=points.length;i<len;i++){p1=points[i-1],p2=points[i];var sqDist=closest(p,p1,p2,!0);sqDist<minDistance&&(minDistance=sqDist,minPoint=closest(p,p1,p2))}return minPoint&&(minPoint.distance=Math.sqrt(minDistance)),minPoint},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var i,halfDist,segDist,dist,p1,p2,ratio,points=this._rings[0],len=points.length;if(!len)return null;for(i=0,halfDist=0;i<len-1;i++)halfDist+=points[i].distanceTo(points[i+1])/2;if(0===halfDist)return this._map.layerPointToLatLng(points[0]);for(i=0,dist=0;i<len-1;i++)if(p1=points[i],p2=points[i+1],segDist=p1.distanceTo(p2),(dist+=segDist)>halfDist)return ratio=(dist-halfDist)/segDist,this._map.layerPointToLatLng([p2.x-ratio*(p2.x-p1.x),p2.y-ratio*(p2.y-p1.y)])},getBounds:function(){return this._bounds},addLatLng:function(latlng,latlngs){return latlngs=latlngs||this._defaultShape(),latlng=toLatLng(latlng),latlngs.push(latlng),this._bounds.extend(latlng),this.redraw()},_setLatLngs:function(latlngs){this._bounds=new LatLngBounds,this._latlngs=this._convertLatLngs(latlngs)},_defaultShape:function(){return isFlat(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(latlngs){for(var result=[],flat=isFlat(latlngs),i=0,len=latlngs.length;i<len;i++)flat?(result[i]=toLatLng(latlngs[i]),this._bounds.extend(result[i])):result[i]=this._convertLatLngs(latlngs[i]);return result},_project:function(){var pxBounds=new Bounds;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,pxBounds);var w=this._clickTolerance(),p=new Point(w,w);this._bounds.isValid()&&pxBounds.isValid()&&(pxBounds.min._subtract(p),pxBounds.max._add(p),this._pxBounds=pxBounds)},_projectLatlngs:function(latlngs,result,projectedBounds){var i,ring,flat=latlngs[0]instanceof LatLng,len=latlngs.length;if(flat){for(ring=[],i=0;i<len;i++)ring[i]=this._map.latLngToLayerPoint(latlngs[i]),projectedBounds.extend(ring[i]);result.push(ring)}else for(i=0;i<len;i++)this._projectLatlngs(latlngs[i],result,projectedBounds)},_clipPoints:function(){var bounds=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(bounds)){if(this.options.noClip)return void(this._parts=this._rings);var i,j,k,len,len2,segment,points,parts=this._parts;for(i=0,k=0,len=this._rings.length;i<len;i++)for(points=this._rings[i],j=0,len2=points.length;j<len2-1;j++)(segment=clipSegment(points[j],points[j+1],bounds,j,!0))&&(parts[k]=parts[k]||[],parts[k].push(segment[0]),segment[1]===points[j+1]&&j!==len2-2||(parts[k].push(segment[1]),k++))}},_simplifyPoints:function(){for(var parts=this._parts,tolerance=this.options.smoothFactor,i=0,len=parts.length;i<len;i++)parts[i]=simplify(parts[i],tolerance)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(p,closed){var i,j,k,len,len2,part,w=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(p))return!1;for(i=0,len=this._parts.length;i<len;i++)for(part=this._parts[i],j=0,len2=part.length,k=len2-1;j<len2;k=j++)if((closed||0!==j)&&pointToSegmentDistance(p,part[k],part[j])<=w)return!0;return!1}});Polyline._flat=_flat;var Polygon=Polyline.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var i,j,p1,p2,f,area,x,y,center,points=this._rings[0],len=points.length;if(!len)return null;for(area=x=y=0,i=0,j=len-1;i<len;j=i++)p1=points[i],p2=points[j],f=p1.y*p2.x-p2.y*p1.x,x+=(p1.x+p2.x)*f,y+=(p1.y+p2.y)*f,area+=3*f;return center=0===area?points[0]:[x/area,y/area],this._map.layerPointToLatLng(center)},_convertLatLngs:function(latlngs){var result=Polyline.prototype._convertLatLngs.call(this,latlngs),len=result.length;return len>=2&&result[0]instanceof LatLng&&result[0].equals(result[len-1])&&result.pop(),result},_setLatLngs:function(latlngs){Polyline.prototype._setLatLngs.call(this,latlngs),isFlat(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return isFlat(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var bounds=this._renderer._bounds,w=this.options.weight,p=new Point(w,w);if(bounds=new Bounds(bounds.min.subtract(p),bounds.max.add(p)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(bounds)){if(this.options.noClip)return void(this._parts=this._rings);for(var clipped,i=0,len=this._rings.length;i<len;i++)clipped=clipPolygon(this._rings[i],bounds,!0),clipped.length&&this._parts.push(clipped)}},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(p){var part,p1,p2,i,j,k,len,len2,inside=!1;if(!this._pxBounds.contains(p))return!1;for(i=0,len=this._parts.length;i<len;i++)for(part=this._parts[i],j=0,len2=part.length,k=len2-1;j<len2;k=j++)p1=part[j],p2=part[k],p1.y>p.y!=p2.y>p.y&&p.x<(p2.x-p1.x)*(p.y-p1.y)/(p2.y-p1.y)+p1.x&&(inside=!inside);return inside||Polyline.prototype._containsPoint.call(this,p,!0)}}),GeoJSON=FeatureGroup.extend({initialize:function(geojson,options){setOptions(this,options),this._layers={},geojson&&this.addData(geojson)},addData:function(geojson){var i,len,feature,features=isArray(geojson)?geojson:geojson.features;if(features){for(i=0,len=features.length;i<len;i++)feature=features[i],(feature.geometries||feature.geometry||feature.features||feature.coordinates)&&this.addData(feature);return this}var options=this.options;if(options.filter&&!options.filter(geojson))return this;var layer=geometryToLayer(geojson,options);return layer?(layer.feature=asFeature(geojson),layer.defaultOptions=layer.options,this.resetStyle(layer),options.onEachFeature&&options.onEachFeature(geojson,layer),this.addLayer(layer)):this},resetStyle:function(layer){return layer.options=extend({},layer.defaultOptions),this._setLayerStyle(layer,this.options.style),this},setStyle:function(style){return this.eachLayer(function(layer){this._setLayerStyle(layer,style)},this)},_setLayerStyle:function(layer,style){"function"==typeof style&&(style=style(layer.feature)),layer.setStyle&&layer.setStyle(style)}}),PointToGeoJSON={toGeoJSON:function(precision){return getFeature(this,{type:"Point",coordinates:latLngToCoords(this.getLatLng(),precision)})}};Marker.include(PointToGeoJSON),Circle.include(PointToGeoJSON),CircleMarker.include(PointToGeoJSON),Polyline.include({toGeoJSON:function(precision){var multi=!isFlat(this._latlngs),coords=latLngsToCoords(this._latlngs,multi?1:0,!1,precision);return getFeature(this,{type:(multi?"Multi":"")+"LineString",coordinates:coords})}}),Polygon.include({toGeoJSON:function(precision){var holes=!isFlat(this._latlngs),multi=holes&&!isFlat(this._latlngs[0]),coords=latLngsToCoords(this._latlngs,multi?2:holes?1:0,!0,precision);return holes||(coords=[coords]),getFeature(this,{type:(multi?"Multi":"")+"Polygon",coordinates:coords})}}),LayerGroup.include({toMultiPoint:function(precision){var coords=[];return this.eachLayer(function(layer){coords.push(layer.toGeoJSON(precision).geometry.coordinates)}),getFeature(this,{type:"MultiPoint",coordinates:coords})},toGeoJSON:function(precision){var type=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===type)return this.toMultiPoint(precision);var isGeometryCollection="GeometryCollection"===type,jsons=[];return this.eachLayer(function(layer){if(layer.toGeoJSON){var json=layer.toGeoJSON(precision);if(isGeometryCollection)jsons.push(json.geometry);else{var feature=asFeature(json);"FeatureCollection"===feature.type?jsons.push.apply(jsons,feature.features):jsons.push(feature)}}}),isGeometryCollection?getFeature(this,{geometries:jsons,type:"GeometryCollection"}):{type:"FeatureCollection",features:jsons}}});var geoJson=geoJSON,ImageOverlay=Layer.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(url,bounds,options){this._url=url,this._bounds=toLatLngBounds(bounds),setOptions(this,options)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(addClass(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){remove(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(opacity){return this.options.opacity=opacity,this._image&&this._updateOpacity(),this},setStyle:function(styleOpts){return styleOpts.opacity&&this.setOpacity(styleOpts.opacity),this},bringToFront:function(){return this._map&&toFront(this._image),this},bringToBack:function(){return this._map&&toBack(this._image),this},setUrl:function(url){return this._url=url,this._image&&(this._image.src=url),this},setBounds:function(bounds){return this._bounds=toLatLngBounds(bounds),this._map&&this._reset(),this},getEvents:function(){var events={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},setZIndex:function(value){return this.options.zIndex=value,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var wasElementSupplied="IMG"===this._url.tagName,img=this._image=wasElementSupplied?this._url:create$1("img");if(addClass(img,"leaflet-image-layer"),this._zoomAnimated&&addClass(img,"leaflet-zoom-animated"),this.options.className&&addClass(img,this.options.className),img.onselectstart=falseFn,img.onmousemove=falseFn,img.onload=bind(this.fire,this,"load"),img.onerror=bind(this._overlayOnError,this,"error"),this.options.crossOrigin&&(img.crossOrigin=""),this.options.zIndex&&this._updateZIndex(),wasElementSupplied)return void(this._url=img.src);img.src=this._url,img.alt=this.options.alt},_animateZoom:function(e){var scale=this._map.getZoomScale(e.zoom),offset=this._map._latLngBoundsToNewLayerBounds(this._bounds,e.zoom,e.center).min;setTransform(this._image,offset,scale)},_reset:function(){var image=this._image,bounds=new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),size=bounds.getSize();setPosition(image,bounds.min),image.style.width=size.x+"px",image.style.height=size.y+"px"},_updateOpacity:function(){setOpacity(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var errorUrl=this.options.errorOverlayUrl;errorUrl&&this._url!==errorUrl&&(this._url=errorUrl,this._image.src=errorUrl)}}),imageOverlay=function(url,bounds,options){return new ImageOverlay(url,bounds,options)},VideoOverlay=ImageOverlay.extend({options:{autoplay:!0,loop:!0},_initImage:function(){var wasElementSupplied="VIDEO"===this._url.tagName,vid=this._image=wasElementSupplied?this._url:create$1("video");if(addClass(vid,"leaflet-image-layer"),this._zoomAnimated&&addClass(vid,"leaflet-zoom-animated"),vid.onselectstart=falseFn,vid.onmousemove=falseFn,vid.onloadeddata=bind(this.fire,this,"load"),wasElementSupplied){for(var sourceElements=vid.getElementsByTagName("source"),sources=[],j=0;j<sourceElements.length;j++)sources.push(sourceElements[j].src);return void(this._url=sourceElements.length>0?sources:[vid.src])}isArray(this._url)||(this._url=[this._url]),vid.autoplay=!!this.options.autoplay,vid.loop=!!this.options.loop;for(var i=0;i<this._url.length;i++){var source=create$1("source");source.src=this._url[i],vid.appendChild(source)}}}),DivOverlay=Layer.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(options,source){setOptions(this,options),this._source=source},onAdd:function(map){this._zoomAnimated=map._zoomAnimated,this._container||this._initLayout(),map._fadeAnimated&&setOpacity(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),map._fadeAnimated&&setOpacity(this._container,1),this.bringToFront()},onRemove:function(map){map._fadeAnimated?(setOpacity(this._container,0),this._removeTimeout=setTimeout(bind(remove,void 0,this._container),200)):remove(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(latlng){return this._latlng=toLatLng(latlng),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(content){return this._content=content,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var events={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&toFront(this._container),this},bringToBack:function(){return this._map&&toBack(this._container),this},_updateContent:function(){if(this._content){var node=this._contentNode,content="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof content)node.innerHTML=content;else{for(;node.hasChildNodes();)node.removeChild(node.firstChild);node.appendChild(content)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var pos=this._map.latLngToLayerPoint(this._latlng),offset=toPoint(this.options.offset),anchor=this._getAnchor();this._zoomAnimated?setPosition(this._container,pos.add(anchor)):offset=offset.add(pos).add(anchor);var bottom=this._containerBottom=-offset.y,left=this._containerLeft=-Math.round(this._containerWidth/2)+offset.x;this._container.style.bottom=bottom+"px",this._container.style.left=left+"px"}},_getAnchor:function(){return[0,0]}}),Popup=DivOverlay.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(map){return map.openPopup(this),this},onAdd:function(map){DivOverlay.prototype.onAdd.call(this,map),map.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof Path||this._source.on("preclick",stopPropagation))},onRemove:function(map){DivOverlay.prototype.onRemove.call(this,map),map.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof Path||this._source.off("preclick",stopPropagation))},getEvents:function(){var events=DivOverlay.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(events.preclick=this._close),this.options.keepInView&&(events.moveend=this._adjustPan),events},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var prefix="leaflet-popup",container=this._container=create$1("div",prefix+" "+(this.options.className||"")+" leaflet-zoom-animated"),wrapper=this._wrapper=create$1("div",prefix+"-content-wrapper",container);if(this._contentNode=create$1("div",prefix+"-content",wrapper),disableClickPropagation(wrapper),disableScrollPropagation(this._contentNode),on(wrapper,"contextmenu",stopPropagation),this._tipContainer=create$1("div",prefix+"-tip-container",container),this._tip=create$1("div",prefix+"-tip",this._tipContainer),this.options.closeButton){var closeButton=this._closeButton=create$1("a",prefix+"-close-button",container);closeButton.href="#close",closeButton.innerHTML="&#215;",on(closeButton,"click",this._onCloseButtonClick,this)}},_updateLayout:function(){var container=this._contentNode,style=container.style;style.width="",style.whiteSpace="nowrap";var width=container.offsetWidth;width=Math.min(width,this.options.maxWidth),width=Math.max(width,this.options.minWidth),style.width=width+1+"px",style.whiteSpace="",style.height="";var height=container.offsetHeight,maxHeight=this.options.maxHeight;maxHeight&&height>maxHeight?(style.height=maxHeight+"px",addClass(container,"leaflet-popup-scrolled")):removeClass(container,"leaflet-popup-scrolled"),this._containerWidth=this._container.offsetWidth},_animateZoom:function(e){var pos=this._map._latLngToNewLayerPoint(this._latlng,e.zoom,e.center),anchor=this._getAnchor();setPosition(this._container,pos.add(anchor))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var map=this._map,marginBottom=parseInt(getStyle(this._container,"marginBottom"),10)||0,containerHeight=this._container.offsetHeight+marginBottom,containerWidth=this._containerWidth,layerPos=new Point(this._containerLeft,-containerHeight-this._containerBottom);layerPos._add(getPosition(this._container));var containerPos=map.layerPointToContainerPoint(layerPos),padding=toPoint(this.options.autoPanPadding),paddingTL=toPoint(this.options.autoPanPaddingTopLeft||padding),paddingBR=toPoint(this.options.autoPanPaddingBottomRight||padding),size=map.getSize(),dx=0,dy=0;containerPos.x+containerWidth+paddingBR.x>size.x&&(dx=containerPos.x+containerWidth-size.x+paddingBR.x),containerPos.x-dx-paddingTL.x<0&&(dx=containerPos.x-paddingTL.x),containerPos.y+containerHeight+paddingBR.y>size.y&&(dy=containerPos.y+containerHeight-size.y+paddingBR.y),containerPos.y-dy-paddingTL.y<0&&(dy=containerPos.y-paddingTL.y),(dx||dy)&&map.fire("autopanstart").panBy([dx,dy])}},_onCloseButtonClick:function(e){this._close(),stop(e)},_getAnchor:function(){return toPoint(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}}),popup=function(options,source){return new Popup(options,source)};Map.mergeOptions({closePopupOnClick:!0}),Map.include({openPopup:function(popup,latlng,options){return popup instanceof Popup||(popup=new Popup(options).setContent(popup)),latlng&&popup.setLatLng(latlng),this.hasLayer(popup)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=popup,this.addLayer(popup))},closePopup:function(popup){return popup&&popup!==this._popup||(popup=this._popup,this._popup=null),popup&&this.removeLayer(popup),this}}),Layer.include({bindPopup:function(content,options){return content instanceof Popup?(setOptions(content,options),this._popup=content,content._source=this):(this._popup&&!options||(this._popup=new Popup(options,this)),this._popup.setContent(content)),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(layer,latlng){if(layer instanceof Layer||(latlng=layer,layer=this),layer instanceof FeatureGroup)for(var id in this._layers){layer=this._layers[id];break}return latlng||(latlng=layer.getCenter?layer.getCenter():layer.getLatLng()),this._popup&&this._map&&(this._popup._source=layer,this._popup.update(),this._map.openPopup(this._popup,latlng)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(target){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(target)),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(content){return this._popup&&this._popup.setContent(content),this},getPopup:function(){return this._popup},_openPopup:function(e){var layer=e.layer||e.target;if(this._popup&&this._map){if(stop(e),layer instanceof Path)return void this.openPopup(e.layer||e.target,e.latlng);this._map.hasLayer(this._popup)&&this._popup._source===layer?this.closePopup():this.openPopup(layer,e.latlng)}},_movePopup:function(e){this._popup.setLatLng(e.latlng)},_onKeyPress:function(e){13===e.originalEvent.keyCode&&this._openPopup(e)}});var Tooltip=DivOverlay.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(map){DivOverlay.prototype.onAdd.call(this,map),this.setOpacity(this.options.opacity),map.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(map){DivOverlay.prototype.onRemove.call(this,map),map.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var events=DivOverlay.prototype.getEvents.call(this);return touch&&!this.options.permanent&&(events.preclick=this._close),events},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var className="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=create$1("div",className)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(pos){var map=this._map,container=this._container,centerPoint=map.latLngToContainerPoint(map.getCenter()),tooltipPoint=map.layerPointToContainerPoint(pos),direction=this.options.direction,tooltipWidth=container.offsetWidth,tooltipHeight=container.offsetHeight,offset=toPoint(this.options.offset),anchor=this._getAnchor();"top"===direction?pos=pos.add(toPoint(-tooltipWidth/2+offset.x,-tooltipHeight+offset.y+anchor.y,!0)):"bottom"===direction?pos=pos.subtract(toPoint(tooltipWidth/2-offset.x,-offset.y,!0)):"center"===direction?pos=pos.subtract(toPoint(tooltipWidth/2+offset.x,tooltipHeight/2-anchor.y+offset.y,!0)):"right"===direction||"auto"===direction&&tooltipPoint.x<centerPoint.x?(direction="right",pos=pos.add(toPoint(offset.x+anchor.x,anchor.y-tooltipHeight/2+offset.y,!0))):(direction="left",pos=pos.subtract(toPoint(tooltipWidth+anchor.x-offset.x,tooltipHeight/2-anchor.y-offset.y,!0))),removeClass(container,"leaflet-tooltip-right"),removeClass(container,"leaflet-tooltip-left"),removeClass(container,"leaflet-tooltip-top"),removeClass(container,"leaflet-tooltip-bottom"),addClass(container,"leaflet-tooltip-"+direction),setPosition(container,pos)},_updatePosition:function(){var pos=this._map.latLngToLayerPoint(this._latlng);this._setPosition(pos)},setOpacity:function(opacity){this.options.opacity=opacity,this._container&&setOpacity(this._container,opacity)},_animateZoom:function(e){var pos=this._map._latLngToNewLayerPoint(this._latlng,e.zoom,e.center);this._setPosition(pos)},_getAnchor:function(){return toPoint(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}}),tooltip=function(options,source){return new Tooltip(options,source)};Map.include({openTooltip:function(tooltip,latlng,options){return tooltip instanceof Tooltip||(tooltip=new Tooltip(options).setContent(tooltip)),latlng&&tooltip.setLatLng(latlng),this.hasLayer(tooltip)?this:this.addLayer(tooltip)},closeTooltip:function(tooltip){return tooltip&&this.removeLayer(tooltip),this}}),Layer.include({bindTooltip:function(content,options){return content instanceof Tooltip?(setOptions(content,options),this._tooltip=content,content._source=this):(this._tooltip&&!options||(this._tooltip=new Tooltip(options,this)),this._tooltip.setContent(content)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(remove$$1){if(remove$$1||!this._tooltipHandlersAdded){var onOff=remove$$1?"off":"on",events={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?events.add=this._openTooltip:(events.mouseover=this._openTooltip,events.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(events.mousemove=this._moveTooltip),touch&&(events.click=this._openTooltip)),this[onOff](events),this._tooltipHandlersAdded=!remove$$1}},openTooltip:function(layer,latlng){if(layer instanceof Layer||(latlng=layer,layer=this),layer instanceof FeatureGroup)for(var id in this._layers){layer=this._layers[id];break}return latlng||(latlng=layer.getCenter?layer.getCenter():layer.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=layer,this._tooltip.update(),this._map.openTooltip(this._tooltip,latlng),this._tooltip.options.interactive&&this._tooltip._container&&(addClass(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(removeClass(this._tooltip._container,"leaflet-clickable"),this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(target){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(target)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(content){return this._tooltip&&this._tooltip.setContent(content),this},getTooltip:function(){return this._tooltip},_openTooltip:function(e){var layer=e.layer||e.target;this._tooltip&&this._map&&this.openTooltip(layer,this._tooltip.options.sticky?e.latlng:void 0)},_moveTooltip:function(e){var containerPoint,layerPoint,latlng=e.latlng;this._tooltip.options.sticky&&e.originalEvent&&(containerPoint=this._map.mouseEventToContainerPoint(e.originalEvent),layerPoint=this._map.containerPointToLayerPoint(containerPoint),latlng=this._map.layerPointToLatLng(layerPoint)),this._tooltip.setLatLng(latlng)}});var DivIcon=Icon.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(oldIcon){var div=oldIcon&&"DIV"===oldIcon.tagName?oldIcon:document.createElement("div"),options=this.options;if(div.innerHTML=!1!==options.html?options.html:"",options.bgPos){var bgPos=toPoint(options.bgPos);div.style.backgroundPosition=-bgPos.x+"px "+-bgPos.y+"px"}return this._setIconStyles(div,"icon"),div},createShadow:function(){return null}});Icon.Default=IconDefault;var GridLayer=Layer.extend({options:{tileSize:256,opacity:1,updateWhenIdle:mobile,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(options){setOptions(this,options)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(map){map._addZoomLimit(this)},onRemove:function(map){this._removeAllTiles(),remove(this._container),map._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(toFront(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(toBack(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(opacity){return this.options.opacity=opacity,this._updateOpacity(),this},setZIndex:function(zIndex){return this.options.zIndex=zIndex,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){var events={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=throttle(this._onMoveEnd,this.options.updateInterval,this)),events.move=this._onMove),this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},createTile:function(){return document.createElement("div")},getTileSize:function(){var s=this.options.tileSize;return s instanceof Point?s:new Point(s,s)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(compare){for(var zIndex,layers=this.getPane().children,edgeZIndex=-compare(-1/0,1/0),i=0,len=layers.length;i<len;i++)zIndex=layers[i].style.zIndex,layers[i]!==this._container&&zIndex&&(edgeZIndex=compare(edgeZIndex,+zIndex));isFinite(edgeZIndex)&&(this.options.zIndex=edgeZIndex+compare(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!ielt9){setOpacity(this._container,this.options.opacity);var now=+new Date,nextFrame=!1,willPrune=!1;for(var key in this._tiles){var tile=this._tiles[key];if(tile.current&&tile.loaded){var fade=Math.min(1,(now-tile.loaded)/200);setOpacity(tile.el,fade),fade<1?nextFrame=!0:(tile.active?willPrune=!0:this._onOpaqueTile(tile),tile.active=!0)}}willPrune&&!this._noPrune&&this._pruneTiles(),nextFrame&&(cancelAnimFrame(this._fadeFrame),this._fadeFrame=requestAnimFrame(this._updateOpacity,this))}},_onOpaqueTile:falseFn,_initContainer:function(){this._container||(this._container=create$1("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var zoom=this._tileZoom,maxZoom=this.options.maxZoom;if(void 0!==zoom){for(var z in this._levels)this._levels[z].el.children.length||z===zoom?(this._levels[z].el.style.zIndex=maxZoom-Math.abs(zoom-z),this._onUpdateLevel(z)):(remove(this._levels[z].el),this._removeTilesAtZoom(z),this._onRemoveLevel(z),delete this._levels[z]);var level=this._levels[zoom],map=this._map;return level||(level=this._levels[zoom]={},level.el=create$1("div","leaflet-tile-container leaflet-zoom-animated",this._container),level.el.style.zIndex=maxZoom,level.origin=map.project(map.unproject(map.getPixelOrigin()),zoom).round(),level.zoom=zoom,this._setZoomTransform(level,map.getCenter(),map.getZoom()),level.el.offsetWidth,this._onCreateLevel(level)),this._level=level,level}},_onUpdateLevel:falseFn,_onRemoveLevel:falseFn,_onCreateLevel:falseFn,_pruneTiles:function(){if(this._map){var key,tile,zoom=this._map.getZoom();if(zoom>this.options.maxZoom||zoom<this.options.minZoom)return void this._removeAllTiles();for(key in this._tiles)tile=this._tiles[key],tile.retain=tile.current;for(key in this._tiles)if(tile=this._tiles[key],tile.current&&!tile.active){var coords=tile.coords;this._retainParent(coords.x,coords.y,coords.z,coords.z-5)||this._retainChildren(coords.x,coords.y,coords.z,coords.z+2)}for(key in this._tiles)this._tiles[key].retain||this._removeTile(key)}},_removeTilesAtZoom:function(zoom){for(var key in this._tiles)this._tiles[key].coords.z===zoom&&this._removeTile(key)},_removeAllTiles:function(){for(var key in this._tiles)this._removeTile(key)},_invalidateAll:function(){for(var z in this._levels)remove(this._levels[z].el),this._onRemoveLevel(z),delete this._levels[z];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(x,y,z,minZoom){var x2=Math.floor(x/2),y2=Math.floor(y/2),z2=z-1,coords2=new Point(+x2,+y2);coords2.z=+z2;var key=this._tileCoordsToKey(coords2),tile=this._tiles[key];return tile&&tile.active?(tile.retain=!0,!0):(tile&&tile.loaded&&(tile.retain=!0),z2>minZoom&&this._retainParent(x2,y2,z2,minZoom))},_retainChildren:function(x,y,z,maxZoom){for(var i=2*x;i<2*x+2;i++)for(var j=2*y;j<2*y+2;j++){var coords=new Point(i,j);coords.z=z+1;var key=this._tileCoordsToKey(coords),tile=this._tiles[key];tile&&tile.active?tile.retain=!0:(tile&&tile.loaded&&(tile.retain=!0),z+1<maxZoom&&this._retainChildren(i,j,z+1,maxZoom))}},_resetView:function(e){var animating=e&&(e.pinch||e.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),animating,animating)},_animateZoom:function(e){this._setView(e.center,e.zoom,!0,e.noUpdate)},_clampZoom:function(zoom){var options=this.options;return void 0!==options.minNativeZoom&&zoom<options.minNativeZoom?options.minNativeZoom:void 0!==options.maxNativeZoom&&options.maxNativeZoom<zoom?options.maxNativeZoom:zoom},_setView:function(center,zoom,noPrune,noUpdate){var tileZoom=this._clampZoom(Math.round(zoom));(void 0!==this.options.maxZoom&&tileZoom>this.options.maxZoom||void 0!==this.options.minZoom&&tileZoom<this.options.minZoom)&&(tileZoom=void 0);var tileZoomChanged=this.options.updateWhenZooming&&tileZoom!==this._tileZoom;noUpdate&&!tileZoomChanged||(this._tileZoom=tileZoom,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==tileZoom&&this._update(center),noPrune||this._pruneTiles(),this._noPrune=!!noPrune),this._setZoomTransforms(center,zoom)},_setZoomTransforms:function(center,zoom){for(var i in this._levels)this._setZoomTransform(this._levels[i],center,zoom)},_setZoomTransform:function(level,center,zoom){var scale=this._map.getZoomScale(zoom,level.zoom),translate=level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center,zoom)).round();any3d?setTransform(level.el,translate,scale):setPosition(level.el,translate)},_resetGrid:function(){var map=this._map,crs=map.options.crs,tileSize=this._tileSize=this.getTileSize(),tileZoom=this._tileZoom,bounds=this._map.getPixelWorldBounds(this._tileZoom);bounds&&(this._globalTileRange=this._pxBoundsToTileRange(bounds)),this._wrapX=crs.wrapLng&&!this.options.noWrap&&[Math.floor(map.project([0,crs.wrapLng[0]],tileZoom).x/tileSize.x),Math.ceil(map.project([0,crs.wrapLng[1]],tileZoom).x/tileSize.y)],this._wrapY=crs.wrapLat&&!this.options.noWrap&&[Math.floor(map.project([crs.wrapLat[0],0],tileZoom).y/tileSize.x),Math.ceil(map.project([crs.wrapLat[1],0],tileZoom).y/tileSize.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(center){var map=this._map,mapZoom=map._animatingZoom?Math.max(map._animateToZoom,map.getZoom()):map.getZoom(),scale=map.getZoomScale(mapZoom,this._tileZoom),pixelCenter=map.project(center,this._tileZoom).floor(),halfSize=map.getSize().divideBy(2*scale);return new Bounds(pixelCenter.subtract(halfSize),pixelCenter.add(halfSize))},_update:function(center){var map=this._map;if(map){var zoom=this._clampZoom(map.getZoom());if(void 0===center&&(center=map.getCenter()),void 0!==this._tileZoom){var pixelBounds=this._getTiledPixelBounds(center),tileRange=this._pxBoundsToTileRange(pixelBounds),tileCenter=tileRange.getCenter(),queue=[],margin=this.options.keepBuffer,noPruneRange=new Bounds(tileRange.getBottomLeft().subtract([margin,-margin]),tileRange.getTopRight().add([margin,-margin]));if(!(isFinite(tileRange.min.x)&&isFinite(tileRange.min.y)&&isFinite(tileRange.max.x)&&isFinite(tileRange.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(var key in this._tiles){var c=this._tiles[key].coords;c.z===this._tileZoom&&noPruneRange.contains(new Point(c.x,c.y))||(this._tiles[key].current=!1)}if(Math.abs(zoom-this._tileZoom)>1)return void this._setView(center,zoom);for(var j=tileRange.min.y;j<=tileRange.max.y;j++)for(var i=tileRange.min.x;i<=tileRange.max.x;i++){var coords=new Point(i,j);if(coords.z=this._tileZoom,this._isValidTile(coords)){var tile=this._tiles[this._tileCoordsToKey(coords)];tile?tile.current=!0:queue.push(coords)}}if(queue.sort(function(a,b){return a.distanceTo(tileCenter)-b.distanceTo(tileCenter)}),0!==queue.length){this._loading||(this._loading=!0,this.fire("loading"));var fragment=document.createDocumentFragment();for(i=0;i<queue.length;i++)this._addTile(queue[i],fragment);this._level.el.appendChild(fragment)}}}},_isValidTile:function(coords){var crs=this._map.options.crs;if(!crs.infinite){var bounds=this._globalTileRange;if(!crs.wrapLng&&(coords.x<bounds.min.x||coords.x>bounds.max.x)||!crs.wrapLat&&(coords.y<bounds.min.y||coords.y>bounds.max.y))return!1}if(!this.options.bounds)return!0;var tileBounds=this._tileCoordsToBounds(coords);return toLatLngBounds(this.options.bounds).overlaps(tileBounds)},_keyToBounds:function(key){return this._tileCoordsToBounds(this._keyToTileCoords(key))},_tileCoordsToNwSe:function(coords){var map=this._map,tileSize=this.getTileSize(),nwPoint=coords.scaleBy(tileSize),sePoint=nwPoint.add(tileSize);return[map.unproject(nwPoint,coords.z),map.unproject(sePoint,coords.z)]},_tileCoordsToBounds:function(coords){var bp=this._tileCoordsToNwSe(coords),bounds=new LatLngBounds(bp[0],bp[1]);return this.options.noWrap||(bounds=this._map.wrapLatLngBounds(bounds)),bounds},_tileCoordsToKey:function(coords){return coords.x+":"+coords.y+":"+coords.z},_keyToTileCoords:function(key){var k=key.split(":"),coords=new Point(+k[0],+k[1]);return coords.z=+k[2],coords},_removeTile:function(key){var tile=this._tiles[key];tile&&(androidStock||tile.el.setAttribute("src",emptyImageUrl),remove(tile.el),delete this._tiles[key],this.fire("tileunload",{tile:tile.el,coords:this._keyToTileCoords(key)}))},_initTile:function(tile){addClass(tile,"leaflet-tile");var tileSize=this.getTileSize();tile.style.width=tileSize.x+"px",tile.style.height=tileSize.y+"px",tile.onselectstart=falseFn,tile.onmousemove=falseFn,ielt9&&this.options.opacity<1&&setOpacity(tile,this.options.opacity),android&&!android23&&(tile.style.WebkitBackfaceVisibility="hidden")},_addTile:function(coords,container){var tilePos=this._getTilePos(coords),key=this._tileCoordsToKey(coords),tile=this.createTile(this._wrapCoords(coords),bind(this._tileReady,this,coords));this._initTile(tile),this.createTile.length<2&&requestAnimFrame(bind(this._tileReady,this,coords,null,tile)),setPosition(tile,tilePos),this._tiles[key]={el:tile,coords:coords,current:!0},container.appendChild(tile),this.fire("tileloadstart",{tile:tile,coords:coords})},_tileReady:function(coords,err,tile){if(this._map){err&&this.fire("tileerror",{error:err,tile:tile,coords:coords});var key=this._tileCoordsToKey(coords);tile=this._tiles[key],tile&&(tile.loaded=+new Date,this._map._fadeAnimated?(setOpacity(tile.el,0),cancelAnimFrame(this._fadeFrame),this._fadeFrame=requestAnimFrame(this._updateOpacity,this)):(tile.active=!0,this._pruneTiles()),err||(addClass(tile.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:tile.el,coords:coords})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),ielt9||!this._map._fadeAnimated?requestAnimFrame(this._pruneTiles,this):setTimeout(bind(this._pruneTiles,this),250)))}},_getTilePos:function(coords){return coords.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(coords){var newCoords=new Point(this._wrapX?wrapNum(coords.x,this._wrapX):coords.x,this._wrapY?wrapNum(coords.y,this._wrapY):coords.y);return newCoords.z=coords.z,newCoords},_pxBoundsToTileRange:function(bounds){var tileSize=this.getTileSize();return new Bounds(bounds.min.unscaleBy(tileSize).floor(),bounds.max.unscaleBy(tileSize).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var key in this._tiles)if(!this._tiles[key].loaded)return!1;return!0}}),TileLayer=GridLayer.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(url,options){this._url=url,options=setOptions(this,options),options.detectRetina&&retina&&options.maxZoom>0&&(options.tileSize=Math.floor(options.tileSize/2),options.zoomReverse?(options.zoomOffset--,options.minZoom++):(options.zoomOffset++,options.maxZoom--),options.minZoom=Math.max(0,options.minZoom)),"string"==typeof options.subdomains&&(options.subdomains=options.subdomains.split("")),android||this.on("tileunload",this._onTileRemove)},setUrl:function(url,noRedraw){return this._url=url,noRedraw||this.redraw(),this},createTile:function(coords,done){var tile=document.createElement("img");return on(tile,"load",bind(this._tileOnLoad,this,done,tile)),on(tile,"error",bind(this._tileOnError,this,done,tile)),this.options.crossOrigin&&(tile.crossOrigin=""),tile.alt="",tile.setAttribute("role","presentation"),tile.src=this.getTileUrl(coords),tile},getTileUrl:function(coords){var data={r:retina?"@2x":"",s:this._getSubdomain(coords),x:coords.x,y:coords.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var invertedY=this._globalTileRange.max.y-coords.y;this.options.tms&&(data.y=invertedY),data["-y"]=invertedY}return template(this._url,extend(data,this.options))},_tileOnLoad:function(done,tile){ielt9?setTimeout(bind(done,this,null,tile),0):done(null,tile)},_tileOnError:function(done,tile,e){var errorUrl=this.options.errorTileUrl;errorUrl&&tile.getAttribute("src")!==errorUrl&&(tile.src=errorUrl),done(e,tile)},_onTileRemove:function(e){e.tile.onload=null},_getZoomForUrl:function(){var zoom=this._tileZoom,maxZoom=this.options.maxZoom,zoomReverse=this.options.zoomReverse,zoomOffset=this.options.zoomOffset;return zoomReverse&&(zoom=maxZoom-zoom),zoom+zoomOffset},_getSubdomain:function(tilePoint){var index=Math.abs(tilePoint.x+tilePoint.y)%this.options.subdomains.length;return this.options.subdomains[index]},_abortLoading:function(){var i,tile;for(i in this._tiles)this._tiles[i].coords.z!==this._tileZoom&&(tile=this._tiles[i].el,tile.onload=falseFn,tile.onerror=falseFn,tile.complete||(tile.src=emptyImageUrl,remove(tile),delete this._tiles[i]))}}),TileLayerWMS=TileLayer.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(url,options){this._url=url;var wmsParams=extend({},this.defaultWmsParams);for(var i in options)i in this.options||(wmsParams[i]=options[i]);options=setOptions(this,options);var realRetina=options.detectRetina&&retina?2:1,tileSize=this.getTileSize();wmsParams.width=tileSize.x*realRetina,wmsParams.height=tileSize.y*realRetina,this.wmsParams=wmsParams},onAdd:function(map){this._crs=this.options.crs||map.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var projectionKey=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[projectionKey]=this._crs.code,TileLayer.prototype.onAdd.call(this,map)},getTileUrl:function(coords){var tileBounds=this._tileCoordsToNwSe(coords),crs=this._crs,bounds=toBounds(crs.project(tileBounds[0]),crs.project(tileBounds[1])),min=bounds.min,max=bounds.max,bbox=(this._wmsVersion>=1.3&&this._crs===EPSG4326?[min.y,min.x,max.y,max.x]:[min.x,min.y,max.x,max.y]).join(","),url=L.TileLayer.prototype.getTileUrl.call(this,coords);return url+getParamString(this.wmsParams,url,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+bbox},setParams:function(params,noRedraw){return extend(this.wmsParams,params),noRedraw||this.redraw(),this}});TileLayer.WMS=TileLayerWMS,tileLayer.wms=tileLayerWMS;var Renderer=Layer.extend({options:{padding:.1,tolerance:0},initialize:function(options){setOptions(this,options),stamp(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&addClass(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var events={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(events.zoomanim=this._onAnimZoom),events},_onAnimZoom:function(ev){this._updateTransform(ev.center,ev.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(center,zoom){var scale=this._map.getZoomScale(zoom,this._zoom),position=getPosition(this._container),viewHalf=this._map.getSize().multiplyBy(.5+this.options.padding),currentCenterPoint=this._map.project(this._center,zoom),destCenterPoint=this._map.project(center,zoom),centerOffset=destCenterPoint.subtract(currentCenterPoint),topLeftOffset=viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);any3d?setTransform(this._container,topLeftOffset,scale):setPosition(this._container,topLeftOffset)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom);for(var id in this._layers)this._layers[id]._reset()},_onZoomEnd:function(){for(var id in this._layers)this._layers[id]._project()},_updatePaths:function(){for(var id in this._layers)this._layers[id]._update()},_update:function(){var p=this.options.padding,size=this._map.getSize(),min=this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();this._bounds=new Bounds(min,min.add(size.multiplyBy(1+2*p)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),Canvas=Renderer.extend({getEvents:function(){var events=Renderer.prototype.getEvents.call(this);return events.viewprereset=this._onViewPreReset,events},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){Renderer.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var container=this._container=document.createElement("canvas");on(container,"mousemove",throttle(this._onMouseMove,32,this),this),on(container,"click dblclick mousedown mouseup contextmenu",this._onClick,this),on(container,"mouseout",this._handleMouseOut,this),this._ctx=container.getContext("2d")},_destroyContainer:function(){delete this._ctx,remove(this._container),off(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){var layer;this._redrawBounds=null;for(var id in this._layers)layer=this._layers[id],layer._update();this._redraw()}},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},Renderer.prototype._update.call(this);var b=this._bounds,container=this._container,size=b.getSize(),m=retina?2:1;setPosition(container,b.min),container.width=m*size.x,container.height=m*size.y,container.style.width=size.x+"px",container.style.height=size.y+"px",retina&&this._ctx.scale(2,2),this._ctx.translate(-b.min.x,-b.min.y),this.fire("update")}},_reset:function(){Renderer.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(layer){this._updateDashArray(layer),this._layers[stamp(layer)]=layer;var order=layer._order={layer:layer,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=order),this._drawLast=order,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(layer){this._requestRedraw(layer)},_removePath:function(layer){var order=layer._order,next=order.next,prev=order.prev;next?next.prev=prev:this._drawLast=prev,prev?prev.next=next:this._drawFirst=next,delete layer._order,delete this._layers[L.stamp(layer)],this._requestRedraw(layer)},_updatePath:function(layer){this._extendRedrawBounds(layer),layer._project(),layer._update(),this._requestRedraw(layer)},_updateStyle:function(layer){this._updateDashArray(layer),this._requestRedraw(layer)},_updateDashArray:function(layer){if(layer.options.dashArray){var i,parts=layer.options.dashArray.split(","),dashArray=[];for(i=0;i<parts.length;i++)dashArray.push(Number(parts[i]));layer.options._dashArray=dashArray}},_requestRedraw:function(layer){this._map&&(this._extendRedrawBounds(layer),this._redrawRequest=this._redrawRequest||requestAnimFrame(this._redraw,this))},_extendRedrawBounds:function(layer){if(layer._pxBounds){var padding=(layer.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new Bounds,this._redrawBounds.extend(layer._pxBounds.min.subtract([padding,padding])),this._redrawBounds.extend(layer._pxBounds.max.add([padding,padding]))}},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var bounds=this._redrawBounds;if(bounds){var size=bounds.getSize();this._ctx.clearRect(bounds.min.x,bounds.min.y,size.x,size.y)}else this._ctx.clearRect(0,0,this._container.width,this._container.height)},_draw:function(){var layer,bounds=this._redrawBounds;if(this._ctx.save(),bounds){var size=bounds.getSize();this._ctx.beginPath(),this._ctx.rect(bounds.min.x,bounds.min.y,size.x,size.y),this._ctx.clip()}this._drawing=!0;for(var order=this._drawFirst;order;order=order.next)layer=order.layer,(!bounds||layer._pxBounds&&layer._pxBounds.intersects(bounds))&&layer._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(layer,closed){if(this._drawing){var i,j,len2,p,parts=layer._parts,len=parts.length,ctx=this._ctx;if(len){for(this._drawnLayers[layer._leaflet_id]=layer,ctx.beginPath(),i=0;i<len;i++){for(j=0,len2=parts[i].length;j<len2;j++)p=parts[i][j],ctx[j?"lineTo":"moveTo"](p.x,p.y);closed&&ctx.closePath()}this._fillStroke(ctx,layer)}}},_updateCircle:function(layer){if(this._drawing&&!layer._empty()){var p=layer._point,ctx=this._ctx,r=Math.max(Math.round(layer._radius),1),s=(Math.max(Math.round(layer._radiusY),1)||r)/r;this._drawnLayers[layer._leaflet_id]=layer,1!==s&&(ctx.save(),ctx.scale(1,s)),ctx.beginPath(),ctx.arc(p.x,p.y/s,r,0,2*Math.PI,!1),1!==s&&ctx.restore(),this._fillStroke(ctx,layer)}},_fillStroke:function(ctx,layer){var options=layer.options;options.fill&&(ctx.globalAlpha=options.fillOpacity,ctx.fillStyle=options.fillColor||options.color,ctx.fill(options.fillRule||"evenodd")),options.stroke&&0!==options.weight&&(ctx.setLineDash&&ctx.setLineDash(layer.options&&layer.options._dashArray||[]),ctx.globalAlpha=options.opacity,ctx.lineWidth=options.weight,ctx.strokeStyle=options.color,ctx.lineCap=options.lineCap,ctx.lineJoin=options.lineJoin,ctx.stroke())},_onClick:function(e){for(var layer,clickedLayer,point=this._map.mouseEventToLayerPoint(e),order=this._drawFirst;order;order=order.next)layer=order.layer,layer.options.interactive&&layer._containsPoint(point)&&!this._map._draggableMoved(layer)&&(clickedLayer=layer);clickedLayer&&(fakeStop(e),this._fireEvent([clickedLayer],e))},_onMouseMove:function(e){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var point=this._map.mouseEventToLayerPoint(e);this._handleMouseHover(e,point)}},_handleMouseOut:function(e){var layer=this._hoveredLayer;layer&&(removeClass(this._container,"leaflet-interactive"),this._fireEvent([layer],e,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(e,point){for(var layer,candidateHoveredLayer,order=this._drawFirst;order;order=order.next)layer=order.layer,layer.options.interactive&&layer._containsPoint(point)&&(candidateHoveredLayer=layer);candidateHoveredLayer!==this._hoveredLayer&&(this._handleMouseOut(e),candidateHoveredLayer&&(addClass(this._container,"leaflet-interactive"),this._fireEvent([candidateHoveredLayer],e,"mouseover"),this._hoveredLayer=candidateHoveredLayer)),this._hoveredLayer&&this._fireEvent([this._hoveredLayer],e)},_fireEvent:function(layers,e,type){this._map._fireDOMEvent(e,type||e.type,layers)},_bringToFront:function(layer){var order=layer._order,next=order.next,prev=order.prev;next&&(next.prev=prev,prev?prev.next=next:next&&(this._drawFirst=next),order.prev=this._drawLast,this._drawLast.next=order,order.next=null,this._drawLast=order,this._requestRedraw(layer))},_bringToBack:function(layer){var order=layer._order,next=order.next,prev=order.prev;prev&&(prev.next=next,next?next.prev=prev:prev&&(this._drawLast=prev),order.prev=null,order.next=this._drawFirst,this._drawFirst.prev=order,this._drawFirst=order,this._requestRedraw(layer))}}),vmlCreate=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(name){return document.createElement("<lvml:"+name+' class="lvml">')}}catch(e){return function(name){return document.createElement("<"+name+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}(),vmlMixin={_initContainer:function(){this._container=create$1("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(Renderer.prototype._update.call(this),this.fire("update"))},_initPath:function(layer){var container=layer._container=vmlCreate("shape");addClass(container,"leaflet-vml-shape "+(this.options.className||"")),container.coordsize="1 1",layer._path=vmlCreate("path"),container.appendChild(layer._path),this._updateStyle(layer),this._layers[stamp(layer)]=layer},_addPath:function(layer){var container=layer._container;this._container.appendChild(container),layer.options.interactive&&layer.addInteractiveTarget(container)},_removePath:function(layer){var container=layer._container;remove(container),layer.removeInteractiveTarget(container),delete this._layers[stamp(layer)]},_updateStyle:function(layer){var stroke=layer._stroke,fill=layer._fill,options=layer.options,container=layer._container;container.stroked=!!options.stroke,container.filled=!!options.fill,options.stroke?(stroke||(stroke=layer._stroke=vmlCreate("stroke")),container.appendChild(stroke),stroke.weight=options.weight+"px",stroke.color=options.color,stroke.opacity=options.opacity,options.dashArray?stroke.dashStyle=isArray(options.dashArray)?options.dashArray.join(" "):options.dashArray.replace(/( *, *)/g," "):stroke.dashStyle="",stroke.endcap=options.lineCap.replace("butt","flat"),stroke.joinstyle=options.lineJoin):stroke&&(container.removeChild(stroke),layer._stroke=null),options.fill?(fill||(fill=layer._fill=vmlCreate("fill")),container.appendChild(fill),fill.color=options.fillColor||options.color,fill.opacity=options.fillOpacity):fill&&(container.removeChild(fill),layer._fill=null)},_updateCircle:function(layer){var p=layer._point.round(),r=Math.round(layer._radius),r2=Math.round(layer._radiusY||r);this._setPath(layer,layer._empty()?"M0 0":"AL "+p.x+","+p.y+" "+r+","+r2+" 0,23592600")},_setPath:function(layer,path){layer._path.v=path},_bringToFront:function(layer){toFront(layer._container)},_bringToBack:function(layer){toBack(layer._container)}},create$2=vml?vmlCreate:svgCreate,SVG=Renderer.extend({getEvents:function(){var events=Renderer.prototype.getEvents.call(this);return events.zoomstart=this._onZoomStart,events},_initContainer:function(){this._container=create$2("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=create$2("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){remove(this._container),off(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){Renderer.prototype._update.call(this);var b=this._bounds,size=b.getSize(),container=this._container;this._svgSize&&this._svgSize.equals(size)||(this._svgSize=size,container.setAttribute("width",size.x),container.setAttribute("height",size.y)),setPosition(container,b.min),container.setAttribute("viewBox",[b.min.x,b.min.y,size.x,size.y].join(" ")),this.fire("update")}},_initPath:function(layer){var path=layer._path=create$2("path");layer.options.className&&addClass(path,layer.options.className),layer.options.interactive&&addClass(path,"leaflet-interactive"),this._updateStyle(layer),this._layers[stamp(layer)]=layer},_addPath:function(layer){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(layer._path),layer.addInteractiveTarget(layer._path)},_removePath:function(layer){remove(layer._path),layer.removeInteractiveTarget(layer._path),delete this._layers[stamp(layer)]},_updatePath:function(layer){layer._project(),layer._update()},_updateStyle:function(layer){var path=layer._path,options=layer.options;path&&(options.stroke?(path.setAttribute("stroke",options.color),path.setAttribute("stroke-opacity",options.opacity),path.setAttribute("stroke-width",options.weight),path.setAttribute("stroke-linecap",options.lineCap),path.setAttribute("stroke-linejoin",options.lineJoin),options.dashArray?path.setAttribute("stroke-dasharray",options.dashArray):path.removeAttribute("stroke-dasharray"),options.dashOffset?path.setAttribute("stroke-dashoffset",options.dashOffset):path.removeAttribute("stroke-dashoffset")):path.setAttribute("stroke","none"),options.fill?(path.setAttribute("fill",options.fillColor||options.color),path.setAttribute("fill-opacity",options.fillOpacity),path.setAttribute("fill-rule",options.fillRule||"evenodd")):path.setAttribute("fill","none"))},_updatePoly:function(layer,closed){this._setPath(layer,pointsToPath(layer._parts,closed))},_updateCircle:function(layer){var p=layer._point,r=Math.max(Math.round(layer._radius),1),r2=Math.max(Math.round(layer._radiusY),1)||r,arc="a"+r+","+r2+" 0 1,0 ",d=layer._empty()?"M0 0":"M"+(p.x-r)+","+p.y+arc+2*r+",0 "+arc+2*-r+",0 ";this._setPath(layer,d)},_setPath:function(layer,path){layer._path.setAttribute("d",path)},_bringToFront:function(layer){toFront(layer._path)},_bringToBack:function(layer){toBack(layer._path)}});vml&&SVG.include(vmlMixin),Map.include({getRenderer:function(layer){var renderer=layer.options.renderer||this._getPaneRenderer(layer.options.pane)||this.options.renderer||this._renderer;return renderer||(renderer=this._renderer=this.options.preferCanvas&&canvas$1()||svg$1()),this.hasLayer(renderer)||this.addLayer(renderer),renderer},_getPaneRenderer:function(name){if("overlayPane"===name||void 0===name)return!1;var renderer=this._paneRenderers[name];return void 0===renderer&&(renderer=SVG&&svg$1({pane:name})||Canvas&&canvas$1({pane:name}),this._paneRenderers[name]=renderer),renderer}});var Rectangle=Polygon.extend({initialize:function(latLngBounds,options){Polygon.prototype.initialize.call(this,this._boundsToLatLngs(latLngBounds),options)},setBounds:function(latLngBounds){return this.setLatLngs(this._boundsToLatLngs(latLngBounds))},_boundsToLatLngs:function(latLngBounds){return latLngBounds=toLatLngBounds(latLngBounds),[latLngBounds.getSouthWest(),latLngBounds.getNorthWest(),latLngBounds.getNorthEast(),latLngBounds.getSouthEast()]}});SVG.create=create$2,SVG.pointsToPath=pointsToPath,GeoJSON.geometryToLayer=geometryToLayer,GeoJSON.coordsToLatLng=coordsToLatLng,GeoJSON.coordsToLatLngs=coordsToLatLngs,GeoJSON.latLngToCoords=latLngToCoords,GeoJSON.latLngsToCoords=latLngsToCoords,GeoJSON.getFeature=getFeature,GeoJSON.asFeature=asFeature,Map.mergeOptions({boxZoom:!0});var BoxZoom=Handler.extend({initialize:function(map){this._map=map,this._container=map._container,this._pane=map._panes.overlayPane,this._resetStateTimeout=0,map.on("unload",this._destroy,this)},addHooks:function(){on(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){off(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){remove(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(e){if(!e.shiftKey||1!==e.which&&1!==e.button)return!1;this._clearDeferredResetState(),this._resetState(),disableTextSelection(),disableImageDrag(),this._startPoint=this._map.mouseEventToContainerPoint(e),on(document,{contextmenu:stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(e){this._moved||(this._moved=!0,this._box=create$1("div","leaflet-zoom-box",this._container),addClass(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(e);var bounds=new Bounds(this._point,this._startPoint),size=bounds.getSize();setPosition(this._box,bounds.min),this._box.style.width=size.x+"px",this._box.style.height=size.y+"px"},_finish:function(){this._moved&&(remove(this._box),removeClass(this._container,"leaflet-crosshair")),enableTextSelection(),enableImageDrag(),off(document,{contextmenu:stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(e){if((1===e.which||1===e.button)&&(this._finish(),this._moved)){this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(bind(this._resetState,this),0);var bounds=new LatLngBounds(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(bounds).fire("boxzoomend",{boxZoomBounds:bounds})}},_onKeyDown:function(e){27===e.keyCode&&this._finish()}});Map.addInitHook("addHandler","boxZoom",BoxZoom),Map.mergeOptions({doubleClickZoom:!0});var DoubleClickZoom=Handler.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(e){var map=this._map,oldZoom=map.getZoom(),delta=map.options.zoomDelta,zoom=e.originalEvent.shiftKey?oldZoom-delta:oldZoom+delta;"center"===map.options.doubleClickZoom?map.setZoom(zoom):map.setZoomAround(e.containerPoint,zoom)}});Map.addInitHook("addHandler","doubleClickZoom",DoubleClickZoom),Map.mergeOptions({dragging:!0,inertia:!android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0});var Drag=Handler.extend({addHooks:function(){if(!this._draggable){var map=this._map;this._draggable=new Draggable(map._mapPane,map._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),map.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),map.on("zoomend",this._onZoomEnd,this),map.whenReady(this._onZoomEnd,this))}addClass(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){removeClass(this._map._container,"leaflet-grab"),removeClass(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var map=this._map;if(map._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var bounds=toLatLngBounds(this._map.options.maxBounds);this._offsetLimit=toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;map.fire("movestart").fire("dragstart"),map.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(e){if(this._map.options.inertia){var time=this._lastTime=+new Date,pos=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(pos),this._times.push(time),this._prunePositions(time)}this._map.fire("move",e).fire("drag",e)},_prunePositions:function(time){for(;this._positions.length>1&&time-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var pxCenter=this._map.getSize().divideBy(2),pxWorldCenter=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=pxWorldCenter.subtract(pxCenter).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(value,threshold){return value-(value-threshold)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var offset=this._draggable._newPos.subtract(this._draggable._startPos),limit=this._offsetLimit;offset.x<limit.min.x&&(offset.x=this._viscousLimit(offset.x,limit.min.x)),offset.y<limit.min.y&&(offset.y=this._viscousLimit(offset.y,limit.min.y)),offset.x>limit.max.x&&(offset.x=this._viscousLimit(offset.x,limit.max.x)),offset.y>limit.max.y&&(offset.y=this._viscousLimit(offset.y,limit.max.y)),this._draggable._newPos=this._draggable._startPos.add(offset)}},_onPreDragWrap:function(){var worldWidth=this._worldWidth,halfWidth=Math.round(worldWidth/2),dx=this._initialWorldOffset,x=this._draggable._newPos.x,newX1=(x-halfWidth+dx)%worldWidth+halfWidth-dx,newX2=(x+halfWidth+dx)%worldWidth-halfWidth-dx,newX=Math.abs(newX1+dx)<Math.abs(newX2+dx)?newX1:newX2;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=newX},_onDragEnd:function(e){var map=this._map,options=map.options,noInertia=!options.inertia||this._times.length<2;if(map.fire("dragend",e),noInertia)map.fire("moveend");else{this._prunePositions(+new Date);var direction=this._lastPos.subtract(this._positions[0]),duration=(this._lastTime-this._times[0])/1e3,ease=options.easeLinearity,speedVector=direction.multiplyBy(ease/duration),speed=speedVector.distanceTo([0,0]),limitedSpeed=Math.min(options.inertiaMaxSpeed,speed),limitedSpeedVector=speedVector.multiplyBy(limitedSpeed/speed),decelerationDuration=limitedSpeed/(options.inertiaDeceleration*ease),offset=limitedSpeedVector.multiplyBy(-decelerationDuration/2).round();offset.x||offset.y?(offset=map._limitOffset(offset,map.options.maxBounds),requestAnimFrame(function(){map.panBy(offset,{duration:decelerationDuration,easeLinearity:ease,noMoveStart:!0,animate:!0})})):map.fire("moveend")}}});Map.addInitHook("addHandler","dragging",Drag),Map.mergeOptions({keyboard:!0,keyboardPanDelta:80});var Keyboard=Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(map){this._map=map,this._setPanDelta(map.options.keyboardPanDelta),this._setZoomDelta(map.options.zoomDelta)},addHooks:function(){var container=this._map._container;container.tabIndex<=0&&(container.tabIndex="0"),on(container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),off(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var body=document.body,docEl=document.documentElement,top=body.scrollTop||docEl.scrollTop,left=body.scrollLeft||docEl.scrollLeft;this._map._container.focus(),window.scrollTo(left,top)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(panDelta){var i,len,keys=this._panKeys={},codes=this.keyCodes;for(i=0,len=codes.left.length;i<len;i++)keys[codes.left[i]]=[-1*panDelta,0];for(i=0,len=codes.right.length;i<len;i++)keys[codes.right[i]]=[panDelta,0];for(i=0,len=codes.down.length;i<len;i++)keys[codes.down[i]]=[0,panDelta];for(i=0,len=codes.up.length;i<len;i++)keys[codes.up[i]]=[0,-1*panDelta]},_setZoomDelta:function(zoomDelta){var i,len,keys=this._zoomKeys={},codes=this.keyCodes;for(i=0,len=codes.zoomIn.length;i<len;i++)keys[codes.zoomIn[i]]=zoomDelta;for(i=0,len=codes.zoomOut.length;i<len;i++)keys[codes.zoomOut[i]]=-zoomDelta},_addHooks:function(){on(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){off(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(e){if(!(e.altKey||e.ctrlKey||e.metaKey)){var offset,key=e.keyCode,map=this._map;if(key in this._panKeys){if(map._panAnim&&map._panAnim._inProgress)return;offset=this._panKeys[key],e.shiftKey&&(offset=toPoint(offset).multiplyBy(3)),map.panBy(offset),map.options.maxBounds&&map.panInsideBounds(map.options.maxBounds)}else if(key in this._zoomKeys)map.setZoom(map.getZoom()+(e.shiftKey?3:1)*this._zoomKeys[key]);else{if(27!==key||!map._popup||!map._popup.options.closeOnEscapeKey)return;map.closePopup()}stop(e)}}});Map.addInitHook("addHandler","keyboard",Keyboard),Map.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60});var ScrollWheelZoom=Handler.extend({addHooks:function(){on(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){off(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(e){var delta=getWheelDelta(e),debounce=this._map.options.wheelDebounceTime;this._delta+=delta,this._lastMousePos=this._map.mouseEventToContainerPoint(e),this._startTime||(this._startTime=+new Date);var left=Math.max(debounce-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(bind(this._performZoom,this),left),stop(e)},_performZoom:function(){var map=this._map,zoom=map.getZoom(),snap=this._map.options.zoomSnap||0;map._stop();var d2=this._delta/(4*this._map.options.wheelPxPerZoomLevel),d3=4*Math.log(2/(1+Math.exp(-Math.abs(d2))))/Math.LN2,d4=snap?Math.ceil(d3/snap)*snap:d3,delta=map._limitZoom(zoom+(this._delta>0?d4:-d4))-zoom;this._delta=0,this._startTime=null,delta&&("center"===map.options.scrollWheelZoom?map.setZoom(zoom+delta):map.setZoomAround(this._lastMousePos,zoom+delta))}});Map.addInitHook("addHandler","scrollWheelZoom",ScrollWheelZoom),Map.mergeOptions({tap:!0,tapTolerance:15});var Tap=Handler.extend({addHooks:function(){on(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){off(this._map._container,"touchstart",this._onDown,this)},_onDown:function(e){if(e.touches){if(preventDefault(e),this._fireClick=!0,e.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var first=e.touches[0],el=first.target;this._startPos=this._newPos=new Point(first.clientX,first.clientY),el.tagName&&"a"===el.tagName.toLowerCase()&&addClass(el,"leaflet-active"),this._holdTimeout=setTimeout(bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",first))},this),1e3),this._simulateEvent("mousedown",first),on(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(e){if(clearTimeout(this._holdTimeout),off(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&e&&e.changedTouches){var first=e.changedTouches[0],el=first.target;el&&el.tagName&&"a"===el.tagName.toLowerCase()&&removeClass(el,"leaflet-active"),this._simulateEvent("mouseup",first),this._isTapValid()&&this._simulateEvent("click",first)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(e){var first=e.touches[0];this._newPos=new Point(first.clientX,first.clientY),this._simulateEvent("mousemove",first)},_simulateEvent:function(type,e){var simulatedEvent=document.createEvent("MouseEvents");simulatedEvent._simulated=!0,e.target._simulatedClick=!0,simulatedEvent.initMouseEvent(type,!0,!0,window,1,e.screenX,e.screenY,e.clientX,e.clientY,!1,!1,!1,!1,0,null),e.target.dispatchEvent(simulatedEvent)}});touch&&!pointer&&Map.addInitHook("addHandler","tap",Tap),Map.mergeOptions({touchZoom:touch&&!android23,bounceAtZoomLimits:!0});var TouchZoom=Handler.extend({addHooks:function(){addClass(this._map._container,"leaflet-touch-zoom"),on(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){removeClass(this._map._container,"leaflet-touch-zoom"),off(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(e){var map=this._map;if(e.touches&&2===e.touches.length&&!map._animatingZoom&&!this._zooming){var p1=map.mouseEventToContainerPoint(e.touches[0]),p2=map.mouseEventToContainerPoint(e.touches[1]);this._centerPoint=map.getSize()._divideBy(2),this._startLatLng=map.containerPointToLatLng(this._centerPoint),"center"!==map.options.touchZoom&&(this._pinchStartLatLng=map.containerPointToLatLng(p1.add(p2)._divideBy(2))),this._startDist=p1.distanceTo(p2),this._startZoom=map.getZoom(),this._moved=!1,this._zooming=!0,map._stop(),on(document,"touchmove",this._onTouchMove,this),on(document,"touchend",this._onTouchEnd,this),preventDefault(e)}},_onTouchMove:function(e){if(e.touches&&2===e.touches.length&&this._zooming){var map=this._map,p1=map.mouseEventToContainerPoint(e.touches[0]),p2=map.mouseEventToContainerPoint(e.touches[1]),scale=p1.distanceTo(p2)/this._startDist;if(this._zoom=map.getScaleZoom(scale,this._startZoom),!map.options.bounceAtZoomLimits&&(this._zoom<map.getMinZoom()&&scale<1||this._zoom>map.getMaxZoom()&&scale>1)&&(this._zoom=map._limitZoom(this._zoom)),"center"===map.options.touchZoom){if(this._center=this._startLatLng,1===scale)return}else{var delta=p1._add(p2)._divideBy(2)._subtract(this._centerPoint);if(1===scale&&0===delta.x&&0===delta.y)return;this._center=map.unproject(map.project(this._pinchStartLatLng,this._zoom).subtract(delta),this._zoom)}this._moved||(map._moveStart(!0,!1),this._moved=!0),cancelAnimFrame(this._animRequest);var moveFn=bind(map._move,map,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=requestAnimFrame(moveFn,this,!0),preventDefault(e)}},_onTouchEnd:function(){if(!this._moved||!this._zooming)return void(this._zooming=!1);this._zooming=!1,cancelAnimFrame(this._animRequest),off(document,"touchmove",this._onTouchMove),off(document,"touchend",this._onTouchEnd),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))}});Map.addInitHook("addHandler","touchZoom",TouchZoom),Map.BoxZoom=BoxZoom,Map.DoubleClickZoom=DoubleClickZoom,Map.Drag=Drag,Map.Keyboard=Keyboard,Map.ScrollWheelZoom=ScrollWheelZoom,Map.Tap=Tap,Map.TouchZoom=TouchZoom;var oldL=window.L;window.L=exports,Object.freeze=freeze,exports.version="1.3.1",exports.noConflict=noConflict,exports.Control=Control,exports.control=control,exports.Browser=Browser,exports.Evented=Evented,exports.Mixin=Mixin,exports.Util=Util,exports.Class=Class,exports.Handler=Handler,exports.extend=extend,exports.bind=bind,exports.stamp=stamp,exports.setOptions=setOptions,exports.DomEvent=DomEvent,exports.DomUtil=DomUtil,exports.PosAnimation=PosAnimation,exports.Draggable=Draggable,exports.LineUtil=LineUtil,exports.PolyUtil=PolyUtil,exports.Point=Point,exports.point=toPoint,exports.Bounds=Bounds,exports.bounds=toBounds,exports.Transformation=Transformation,exports.transformation=toTransformation,exports.Projection=index,exports.LatLng=LatLng,exports.latLng=toLatLng,exports.LatLngBounds=LatLngBounds,exports.latLngBounds=toLatLngBounds,exports.CRS=CRS,exports.GeoJSON=GeoJSON,exports.geoJSON=geoJSON,exports.geoJson=geoJson,exports.Layer=Layer,exports.LayerGroup=LayerGroup,exports.layerGroup=layerGroup,exports.FeatureGroup=FeatureGroup,exports.featureGroup=featureGroup,exports.ImageOverlay=ImageOverlay,exports.imageOverlay=imageOverlay,exports.VideoOverlay=VideoOverlay,exports.videoOverlay=videoOverlay,exports.DivOverlay=DivOverlay,exports.Popup=Popup,exports.popup=popup,exports.Tooltip=Tooltip,exports.tooltip=tooltip,exports.Icon=Icon,exports.icon=icon,exports.DivIcon=DivIcon,exports.divIcon=divIcon,exports.Marker=Marker,exports.marker=marker,exports.TileLayer=TileLayer,exports.tileLayer=tileLayer,exports.GridLayer=GridLayer,exports.gridLayer=gridLayer,exports.SVG=SVG,exports.svg=svg$1,exports.Renderer=Renderer,exports.Canvas=Canvas,exports.canvas=canvas$1,exports.Path=Path,exports.CircleMarker=CircleMarker,exports.circleMarker=circleMarker,exports.Circle=Circle,exports.circle=circle,exports.Polyline=Polyline,exports.polyline=polyline,exports.Polygon=Polygon,exports.polygon=polygon,exports.Rectangle=Rectangle,exports.rectangle=rectangle,exports.Map=Map,exports.map=createMap})},function(module,exports,__webpack_require__){"use strict";function tileLayer(options){return new TileLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=tileLayer;var TileLayer=exports.TileLayer=L.TileLayer.extend({options:{errorTileUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="},initialize:function(){var opts=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},options=L.setOptions(this,opts);L.TileLayer.prototype.initialize.call(this,options.url,options),this.on("load",this.onLoad,this)},onLoad:function(){this.fire("ready"),this.off("load",this.onLoad,this)}})},function(module,exports,__webpack_require__){"use strict";function wmsLayer(options){return new WmsLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=wmsLayer;var WmsLayer=exports.WmsLayer=L.TileLayer.WMS.extend({initialize:function(opts){var options=L.extend({errorTileUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",format:"image/png",transparent:!0},opts);L.TileLayer.WMS.prototype.initialize.call(this,options.url,options)}})},function(module,exports,__webpack_require__){"use strict";function googleLayer(options){return new GoogleLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.GoogleLayer=void 0,exports.default=googleLayer,__webpack_require__(70);var GoogleLayer=exports.GoogleLayer=L.GridLayer.GoogleMutant.extend({options:{style:"ROADMAP",version:"3.30",apiKey:"AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc"},initialize:function(){var opts=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},options=L.setOptions(this,opts);options.type=options.style.toLowerCase(),this.googleMapsApiLoaded()||GoogleLayer._mapsApiLoading||this.loadGoogleMapsApi(),L.GridLayer.GoogleMutant.prototype.initialize.call(this)},setOpacity:function(opacity){opacity!==this.options.opacity&&(this.options.opacity=opacity,this.googleMapsApiLoaded()&&(this.onRemove(this._map),this.onAdd(this._map)))},onAdd:function(map){L.DomUtil.addClass(map.getContainer(),"leaflet-google"),L.GridLayer.GoogleMutant.prototype.onAdd.call(this,map)},onRemove:function(map){L.DomUtil.removeClass(map.getContainer(),"leaflet-google"),L.GridLayer.prototype.onRemove.call(this,map),map._container.removeChild(this._mutantContainer),this._mutantContainer=void 0,google.maps.event.clearListeners(map,"idle"),this._mutant&&google.maps.event.clearListeners(this._mutant,"idle"),map.off("viewreset",this._reset,this),map.off("move",this._update,this),map.off("zoomend",this._handleZoomAnim,this),map.off("resize",this._resize,this),map._controlCorners&&(map._controlCorners.bottomright.style.marginBottom="0em",map._controlCorners.bottomleft.style.marginBottom="0em")},googleMapsApiLoaded:function(){return"undefined"!=typeof google&&void 0!==google.maps},loadGoogleMapsApi:function(){GoogleLayer._mapsApiLoading=!0;var script=document.createElement("script");script.src="//maps.googleapis.com/maps/api/js?key="+this.options.apiKey+"&v="+this.options.version,document.getElementsByTagName("head")[0].appendChild(script)}})},function(module,exports){L.GridLayer.GoogleMutant=L.GridLayer.extend({options:{minZoom:0,maxZoom:23,tileSize:256,subdomains:"abc",errorTileUrl:"",attribution:"",opacity:1,continuousWorld:!1,noWrap:!1,type:"roadmap",maxNativeZoom:21},initialize:function(options){L.GridLayer.prototype.initialize.call(this,options),this._ready=!!window.google&&!!window.google.maps&&!!window.google.maps.Map,this._GAPIPromise=this._ready?Promise.resolve(window.google):new Promise(function(resolve,reject){var checkCounter=0,intervalId=null;intervalId=setInterval(function(){return checkCounter>=10?(clearInterval(intervalId),reject(new Error("window.google not found after 10 attempts"))):window.google&&window.google.maps&&window.google.maps.Map?(clearInterval(intervalId),resolve(window.google)):void checkCounter++},500)}),this._tileCallbacks={},this._freshTiles={},this._imagesPerTile="hybrid"===this.options.type?2:1},onAdd:function(map){L.GridLayer.prototype.onAdd.call(this,map),this._initMutantContainer(),this._GAPIPromise.then(function(){if(this._ready=!0,this._map=map,this._initMutant(),map.on("viewreset",this._reset,this),map.on("move",this._update,this),map.on("zoomend",this._handleZoomAnim,this),map.on("resize",this._resize,this),google.maps.event.addListenerOnce(this._mutant,"idle",function(){this._checkZoomLevels(),this._mutantIsReady=!0}.bind(this)),map._controlCorners.bottomright.style.marginBottom="20px",map._controlCorners.bottomleft.style.marginBottom="20px",this._reset(),this._update(),this._subLayers)for(var layerName in this._subLayers)this._subLayers[layerName].setMap(this._mutant)}.bind(this))},onRemove:function(map){L.GridLayer.prototype.onRemove.call(this,map),map._container.removeChild(this._mutantContainer),this._mutantContainer=void 0,google.maps.event.clearListeners(map,"idle"),google.maps.event.clearListeners(this._mutant,"idle"),map.off("viewreset",this._reset,this),map.off("move",this._update,this),map.off("zoomend",this._handleZoomAnim,this),map.off("resize",this._resize,this),map._controlCorners&&(map._controlCorners.bottomright.style.marginBottom="0em",map._controlCorners.bottomleft.style.marginBottom="0em")},getAttribution:function(){return this.options.attribution},setOpacity:function(opacity){this.options.opacity=opacity,opacity<1&&L.DomUtil.setOpacity(this._mutantContainer,opacity)},setElementSize:function(e,size){e.style.width=size.x+"px",e.style.height=size.y+"px"},addGoogleLayer:function(googleLayerName,options){return this._subLayers||(this._subLayers={}),this._GAPIPromise.then(function(){var Constructor=google.maps[googleLayerName],googleLayer=new Constructor(options);return googleLayer.setMap(this._mutant),this._subLayers[googleLayerName]=googleLayer,googleLayer}.bind(this))},removeGoogleLayer:function(googleLayerName){var googleLayer=this._subLayers&&this._subLayers[googleLayerName];googleLayer&&(googleLayer.setMap(null),delete this._subLayers[googleLayerName])},_initMutantContainer:function(){this._mutantContainer||(this._mutantContainer=L.DomUtil.create("div","leaflet-google-mutant leaflet-top leaflet-left"),this._mutantContainer.id="_MutantContainer_"+L.Util.stamp(this._mutantContainer),this._mutantContainer.style.zIndex="800",this._mutantContainer.style.pointerEvents="none",this._map.getContainer().appendChild(this._mutantContainer)),this.setOpacity(this.options.opacity),this.setElementSize(this._mutantContainer,this._map.getSize()),this._attachObserver(this._mutantContainer)},_initMutant:function(){if(this._ready&&this._mutantContainer){this._mutantCenter=new google.maps.LatLng(0,0);var map=new google.maps.Map(this._mutantContainer,{center:this._mutantCenter,zoom:0,tilt:0,mapTypeId:this.options.type,disableDefaultUI:!0,keyboardShortcuts:!1,draggable:!1,disableDoubleClickZoom:!0,scrollwheel:!1,streetViewControl:!1,styles:this.options.styles||{},backgroundColor:"transparent"});this._mutant=map,google.maps.event.addListenerOnce(map,"idle",function(){for(var nodes=this._mutantContainer.querySelectorAll("a"),i=0;i<nodes.length;i++)nodes[i].style.pointerEvents="auto"}.bind(this)),this.fire("spawned",{mapObject:map})}},_attachObserver:function(node){new MutationObserver(this._onMutations.bind(this)).observe(node,{childList:!0,subtree:!0})},_onMutations:function(mutations){for(var i=0;i<mutations.length;++i)for(var mutation=mutations[i],j=0;j<mutation.addedNodes.length;++j){var node=mutation.addedNodes[j];node instanceof HTMLImageElement?this._onMutatedImage(node):node instanceof HTMLElement&&Array.prototype.forEach.call(node.querySelectorAll("img"),this._onMutatedImage.bind(this))}},_roadRegexp:/!1i(\d+)!2i(\d+)!3i(\d+)!/,_satRegexp:/x=(\d+)&y=(\d+)&z=(\d+)/,_staticRegExp:/StaticMapService\.GetMapImage/,_onMutatedImage:function(imgNode){var coords,match=imgNode.src.match(this._roadRegexp),sublayer=0;if(match?(coords={z:match[1],x:match[2],y:match[3]},this._imagesPerTile>1&&(imgNode.style.zIndex=1,sublayer=1)):(match=imgNode.src.match(this._satRegexp),match&&(coords={x:match[1],y:match[2],z:match[3]}),sublayer=0),coords){var tileKey=this._tileCoordsToKey(coords);imgNode.style.position="absolute",imgNode.style.visibility="hidden";var key=tileKey+"/"+sublayer;if(this._freshTiles[key]=imgNode,key in this._tileCallbacks&&this._tileCallbacks[key])this._tileCallbacks[key].pop()(imgNode),this._tileCallbacks[key].length||delete this._tileCallbacks[key];else if(this._tiles[tileKey]){var c=this._tiles[tileKey].el,oldImg=0===sublayer?c.firstChild:c.firstChild.nextSibling,cloneImgNode=this._clone(imgNode);c.replaceChild(cloneImgNode,oldImg)}}else imgNode.src.match(this._staticRegExp)&&(imgNode.style.visibility="hidden")},createTile:function(coords,done){var key=this._tileCoordsToKey(coords),tileContainer=L.DomUtil.create("div");tileContainer.dataset.pending=this._imagesPerTile,done=done.bind(this,null,tileContainer);for(var i=0;i<this._imagesPerTile;i++){var key2=key+"/"+i;if(key2 in this._freshTiles){var imgNode=this._freshTiles[key2];tileContainer.appendChild(this._clone(imgNode)),tileContainer.dataset.pending--}else this._tileCallbacks[key2]=this._tileCallbacks[key2]||[],this._tileCallbacks[key2].push(function(c){return function(imgNode){c.appendChild(this._clone(imgNode)),c.dataset.pending--,parseInt(c.dataset.pending)||done()}.bind(this)}.bind(this)(tileContainer))}return parseInt(tileContainer.dataset.pending)||L.Util.requestAnimFrame(done),tileContainer},_clone:function(imgNode){var clonedImgNode=imgNode.cloneNode(!0);return clonedImgNode.style.visibility="visible",clonedImgNode},_checkZoomLevels:function(){var zoomLevel=this._map.getZoom(),gMapZoomLevel=this._mutant.getZoom();zoomLevel&&gMapZoomLevel&&(gMapZoomLevel!==zoomLevel||gMapZoomLevel>this.options.maxNativeZoom)&&this._setMaxNativeZoom(gMapZoomLevel)},_setMaxNativeZoom:function(zoomLevel){zoomLevel!=this.options.maxNativeZoom&&(this.options.maxNativeZoom=zoomLevel,this._resetView())},_reset:function(){this._initContainer()},_update:function(){if(this._mutant){var center=this._map.getCenter(),_center=new google.maps.LatLng(center.lat,center.lng);this._mutant.setCenter(_center);var zoom=this._map.getZoom(),fractionalLevel=zoom!==Math.round(zoom),mutantZoom=this._mutant.getZoom();fractionalLevel||zoom==mutantZoom||(this._mutant.setZoom(zoom),this._mutantIsReady&&this._checkZoomLevels())}L.GridLayer.prototype._update.call(this)},_resize:function(){var size=this._map.getSize();this._mutantContainer.style.width===size.x&&this._mutantContainer.style.height===size.y||(this.setElementSize(this._mutantContainer,size),this._mutant&&google.maps.event.trigger(this._mutant,"resize"))},_handleZoomAnim:function(){if(this._mutant){var center=this._map.getCenter(),_center=new google.maps.LatLng(center.lat,center.lng);this._mutant.setCenter(_center),this._mutant.setZoom(Math.round(this._map.getZoom()))}},_removeTile:function(key){if(this._mutant)return setTimeout(this._pruneTile.bind(this,key),1e3),L.GridLayer.prototype._removeTile.call(this,key)},_pruneTile:function(key){for(var gZoom=this._mutant.getZoom(),tileZoom=key.split(":")[2],googleBounds=this._mutant.getBounds(),sw=googleBounds.getSouthWest(),ne=googleBounds.getNorthEast(),gMapBounds=L.latLngBounds([[sw.lat(),sw.lng()],[ne.lat(),ne.lng()]]),i=0;i<this._imagesPerTile;i++){var key2=key+"/"+i;if(key2 in this._freshTiles){var tileBounds=this._map&&this._keyToBounds(key);this._map&&tileBounds.overlaps(gMapBounds)&&tileZoom==gZoom||delete this._freshTiles[key2]}}}}),L.gridLayer.googleMutant=function(options){return new L.GridLayer.GoogleMutant(options)}},function(module,exports,__webpack_require__){"use strict";function boundary(options){return new Boundary(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Boundary=void 0,exports.default=boundary;var _GeoJson=__webpack_require__(6),Boundary=exports.Boundary=_GeoJson.GeoJson.extend({options:{style:{opacity:1,fillOpacity:0,fill:!1,radius:5},highlightStyle:{weight:3}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},addLayer:function(layer){var prop=layer.feature.properties;prop.style&&layer.setStyle(prop.style),_GeoJson.GeoJson.prototype.addLayer.call(this,layer)},setOpacity:function(opacity){this.setStyle({opacity:opacity})},pointToLayer:function(geojson,latlng){return this.options.style.pane=this.options.pane,new L.CircleMarker(latlng,this.options.style)},highlight:function(id){var layer=this.findById(id);if(this.removeHighlight(),layer)return this._highlight=layer.setStyle({fillOpacity:.5}),layer},removeHighlight:function(){this._highlight&&this._highlight.setStyle({fillOpacity:0})}})},function(module,exports,__webpack_require__){"use strict";function label(latlng,options){return new Label(latlng,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=label;var Label=exports.Label=L.Marker.extend({options:{html:"Label",className:"leaflet-div-label",iconSize:null},initialize:function(latlng,opts){var options=L.setOptions(this,opts);this._latlng=L.latLng(latlng),options.icon=L.divIcon(options)},onAdd:function(map){L.Marker.prototype.onAdd.call(this,map);var options=this.options,iconDiv=this._icon;options.labelStyle&&L.extend(iconDiv.style,options.labelStyle),iconDiv.style.marginLeft="-"+iconDiv.offsetWidth/2+"px","below"!==options.position&&(iconDiv.style.marginTop="-"+iconDiv.offsetHeight/2+"px")}})},function(module,exports,__webpack_require__){"use strict";function polylabel(polygon,precision,debug){precision=precision||1;for(var minX,minY,maxX,maxY,i=0;i<polygon[0].length;i++){var p=polygon[0][i];(!i||p[0]<minX)&&(minX=p[0]),(!i||p[1]<minY)&&(minY=p[1]),(!i||p[0]>maxX)&&(maxX=p[0]),(!i||p[1]>maxY)&&(maxY=p[1])}var width=maxX-minX,height=maxY-minY,cellSize=Math.min(width,height),h=cellSize/2,cellQueue=new Queue(null,compareMax);if(0===cellSize)return[minX,minY];for(var x=minX;x<maxX;x+=cellSize)for(var y=minY;y<maxY;y+=cellSize)cellQueue.push(new Cell(x+h,y+h,h,polygon));var bestCell=getCentroidCell(polygon),bboxCell=new Cell(minX+width/2,minY+height/2,0,polygon);bboxCell.d>bestCell.d&&(bestCell=bboxCell);for(var numProbes=cellQueue.length;cellQueue.length;){var cell=cellQueue.pop();cell.d>bestCell.d&&(bestCell=cell,debug&&console.log("found best %d after %d probes",Math.round(1e4*cell.d)/1e4,numProbes)),cell.max-bestCell.d<=precision||(h=cell.h/2,cellQueue.push(new Cell(cell.x-h,cell.y-h,h,polygon)),cellQueue.push(new Cell(cell.x+h,cell.y-h,h,polygon)),cellQueue.push(new Cell(cell.x-h,cell.y+h,h,polygon)),cellQueue.push(new Cell(cell.x+h,cell.y+h,h,polygon)),numProbes+=4)}return debug&&(console.log("num probes: "+numProbes),console.log("best distance: "+bestCell.d)),[bestCell.x,bestCell.y]}function compareMax(a,b){return b.max-a.max}function Cell(x,y,h,polygon){this.x=x,this.y=y,this.h=h,this.d=pointToPolygonDist(x,y,polygon),this.max=this.d+this.h*Math.SQRT2}function pointToPolygonDist(x,y,polygon){for(var inside=!1,minDistSq=1/0,k=0;k<polygon.length;k++)for(var ring=polygon[k],i=0,len=ring.length,j=len-1;i<len;j=i++){var a=ring[i],b=ring[j];a[1]>y!=b[1]>y&&x<(b[0]-a[0])*(y-a[1])/(b[1]-a[1])+a[0]&&(inside=!inside),minDistSq=Math.min(minDistSq,getSegDistSq(x,y,a,b))}return(inside?1:-1)*Math.sqrt(minDistSq)}function getCentroidCell(polygon){for(var area=0,x=0,y=0,points=polygon[0],i=0,len=points.length,j=len-1;i<len;j=i++){var a=points[i],b=points[j],f=a[0]*b[1]-b[0]*a[1];x+=(a[0]+b[0])*f,y+=(a[1]+b[1])*f,area+=3*f}return 0===area?new Cell(points[0][0],points[0][1],0,polygon):new Cell(x/area,y/area,0,polygon)}function getSegDistSq(px,py,a,b){var x=a[0],y=a[1],dx=b[0]-x,dy=b[1]-y;if(0!==dx||0!==dy){var t=((px-x)*dx+(py-y)*dy)/(dx*dx+dy*dy);t>1?(x=b[0],y=b[1]):t>0&&(x+=dx*t,y+=dy*t)}return dx=px-x,dy=py-y,dx*dx+dy*dy}var Queue=__webpack_require__(74);module.exports=polylabel,module.exports.default=polylabel},function(module,exports,__webpack_require__){"use strict";function TinyQueue(data,compare){if(!(this instanceof TinyQueue))return new TinyQueue(data,compare);if(this.data=data||[],this.length=this.data.length,this.compare=compare||defaultCompare,data)for(var i=Math.floor(this.length/2);i>=0;i--)this._down(i)}function defaultCompare(a,b){return a<b?-1:a>b?1:0}function swap(data,i,j){var tmp=data[i];data[i]=data[j],data[j]=tmp}module.exports=TinyQueue,TinyQueue.prototype={push:function(item){this.data.push(item),this.length++,this._up(this.length-1)},pop:function(){var top=this.data[0];return this.data[0]=this.data[this.length-1],this.length--,this.data.pop(),this._down(0),top},peek:function(){return this.data[0]},_up:function(pos){for(var data=this.data,compare=this.compare;pos>0;){var parent=Math.floor((pos-1)/2);if(!(compare(data[pos],data[parent])<0))break;swap(data,parent,pos),pos=parent}},_down:function(pos){for(var data=this.data,compare=this.compare,len=this.length;;){var left=2*pos+1,right=left+1,min=pos;if(left<len&&compare(data[left],data[min])<0&&(min=left),right<len&&compare(data[right],data[min])<0&&(min=right),min===pos)return;swap(data,min,pos),pos=min}}}},function(module,exports){function extensions(parentClass){return{initialize:function(options){parentClass.prototype.initialize.call(this,options),this._originalLayers=[],this._visibleLayers=[],this._staticLayers=[],this._rbush=[],this._cachedRelativeBoxes=[],this._margin=options.margin||0,this._rbush=null},addLayer:function(layer){if(!("options"in layer&&"icon"in layer.options))return this._staticLayers.push(layer),void parentClass.prototype.addLayer.call(this,layer);this._originalLayers.push(layer),this._map&&this._maybeAddLayerToRBush(layer)},removeLayer:function(layer){this._rbush.remove(this._cachedRelativeBoxes[layer._leaflet_id]),delete this._cachedRelativeBoxes[layer._leaflet_id],parentClass.prototype.removeLayer.call(this,layer);var i;i=this._originalLayers.indexOf(layer),-1!==i&&this._originalLayers.splice(i,1),i=this._visibleLayers.indexOf(layer),-1!==i&&this._visibleLayers.splice(i,1),-1!==(i=this._staticLayers.indexOf(layer))&&this._staticLayers.splice(i,1)},clearLayers:function(){this._rbush=rbush(),this._originalLayers=[],this._visibleLayers=[],this._staticLayers=[],this._cachedRelativeBoxes=[],parentClass.prototype.clearLayers.call(this)},onAdd:function(map){this._map=map;for(var i in this._staticLayers)map.addLayer(this._staticLayers[i]);this._onZoomEnd(),map.on("zoomend",this._onZoomEnd,this)},onRemove:function(map){for(var i in this._staticLayers)map.removeLayer(this._staticLayers[i]);map.off("zoomend",this._onZoomEnd,this),parentClass.prototype.onRemove.call(this,map)},_maybeAddLayerToRBush:function(layer){var bush=(this._map.getZoom(),this._rbush),boxes=this._cachedRelativeBoxes[layer._leaflet_id],visible=!1;if(!boxes){parentClass.prototype.addLayer.call(this,layer);var visible=!0,box=this._getIconBox(layer._icon);boxes=this._getRelativeBoxes(layer._icon.children,box),boxes.push(box),this._cachedRelativeBoxes[layer._leaflet_id]=boxes}boxes=this._positionBoxes(this._map.latLngToLayerPoint(layer.getLatLng()),boxes);for(var collision=!1,i=0;i<boxes.length&&!collision;i++)collision=bush.search(boxes[i]).length>0;collision?parentClass.prototype.removeLayer.call(this,layer):(visible||parentClass.prototype.addLayer.call(this,layer),this._visibleLayers.push(layer),bush.load(boxes))},_getIconBox:function(el){if(isMSIE8)return[0,0,el.offsetWidth,el.offsetHeight];var styles=window.getComputedStyle(el);return[parseInt(styles.marginLeft),parseInt(styles.marginTop),parseInt(styles.marginLeft)+parseInt(styles.width),parseInt(styles.marginTop)+parseInt(styles.height)]},_getRelativeBoxes:function(els,baseBox){for(var boxes=[],i=0;i<els.length;i++){var el=els[i],box=[el.offsetLeft,el.offsetTop,el.offsetLeft+el.offsetWidth,el.offsetTop+el.offsetHeight];if(box=this._offsetBoxes(box,baseBox),boxes.push(box),el.children.length){var parentBox=baseBox;if(!isMSIE8){var positionStyle=window.getComputedStyle(el).position;"absolute"!==positionStyle&&"relative"!==positionStyle||(parentBox=box)}boxes=boxes.concat(this._getRelativeBoxes(el.children,parentBox))}}return boxes},_offsetBoxes:function(a,b){return[a[0]+b[0],a[1]+b[1],a[2]+b[0],a[3]+b[1]]},_positionBoxes:function(offset,boxes){for(var newBoxes=[],i=0;i<boxes.length;i++)newBoxes.push(this._positionBox(offset,boxes[i]));return newBoxes},_positionBox:function(offset,box){return[box[0]+offset.x-this._margin,box[1]+offset.y-this._margin,box[2]+offset.x+this._margin,box[3]+offset.y+this._margin]},_onZoomEnd:function(){for(var i=0;i<this._visibleLayers.length;i++)parentClass.prototype.removeLayer.call(this,this._visibleLayers[i]);this._rbush=rbush();for(var i=0;i<this._originalLayers.length;i++)this._maybeAddLayerToRBush(this._originalLayers[i])}}}var isMSIE8=!("getComputedStyle"in window&&"function"==typeof window.getComputedStyle);L.LayerGroup.Collision=L.LayerGroup.extend(extensions(L.LayerGroup)),L.FeatureGroup.Collision=L.FeatureGroup.extend(extensions(L.FeatureGroup)),L.GeoJSON.Collision=L.GeoJSON.extend(extensions(L.GeoJSON)),L.LayerGroup.collision=function(options){return new L.LayerGroup.Collision(options||{})},L.FeatureGroup.collision=function(options){return new L.FeatureGroup.Collision(options||{})},L.GeoJSON.collision=function(options){return new L.GeoJSON.Collision(options||{})},L.layerGroup.collision=function(options){return new L.LayerGroup.Collision(options||{})},L.featureGroup.collision=function(options){return new L.FeatureGroup.Collision(options||{})},L.geoJson.collision=function(options){return new L.GeoJSON.Collision(options||{})}},function(module,exports,__webpack_require__){function geometry(_){var i,area=0;switch(_.type){case"Polygon":return polygonArea(_.coordinates);case"MultiPolygon":for(i=0;i<_.coordinates.length;i++)area+=polygonArea(_.coordinates[i]);return area;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(i=0;i<_.geometries.length;i++)area+=geometry(_.geometries[i]);return area}}function polygonArea(coords){var area=0;if(coords&&coords.length>0){area+=Math.abs(ringArea(coords[0]));for(var i=1;i<coords.length;i++)area-=Math.abs(ringArea(coords[i]))}return area}function ringArea(coords){var p1,p2,p3,lowerIndex,middleIndex,upperIndex,area=0,coordsLength=coords.length;if(coordsLength>2){for(i=0;i<coordsLength;i++)i===coordsLength-2?(lowerIndex=coordsLength-2,middleIndex=coordsLength-1,upperIndex=0):i===coordsLength-1?(lowerIndex=coordsLength-1,middleIndex=0,upperIndex=1):(lowerIndex=i,middleIndex=i+1,upperIndex=i+2),p1=coords[lowerIndex],p2=coords[middleIndex],p3=coords[upperIndex],area+=(rad(p3[0])-rad(p1[0]))*Math.sin(rad(p2[1]));area=area*wgs84.RADIUS*wgs84.RADIUS/2}return area}function rad(_){return _*Math.PI/180}var wgs84=__webpack_require__(77);module.exports.geometry=geometry,module.exports.ring=ringArea},function(module,exports){module.exports.RADIUS=6378137,module.exports.FLATTENING=1/298.257223563,module.exports.POLAR_RADIUS=6356752.3142},function(module,exports,__webpack_require__){"use strict";function dots(options){return new Dots(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Dots=void 0,exports.default=dots;var _GeoJson=__webpack_require__(6),_CircleMarker=__webpack_require__(11),_CircleMarker2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_CircleMarker),Dots=exports.Dots=_GeoJson.GeoJson.extend({initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options),this.on("click",this.onMarkerClick,this)},onMarkerClick:function(evt){evt.layer.showPopup()},pointToLayer:function(feature){return(0,_CircleMarker2.default)(feature,this.options)}})},function(module,exports,__webpack_require__){"use strict";function markers(options){return new Markers(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Markers=void 0,exports.default=markers;var _GeoJson=__webpack_require__(6),Markers=exports.Markers=_GeoJson.GeoJson.extend({options:{highlightStyle:!1,markerOptions:{riseOnHover:!0},iconProperty:"icon"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},pointToLayer:function(feature,latlng){var iconProperty=this.options.iconProperty,markerOptions=L.extend({},this.options.markerOptions);return this.options.pane&&(markerOptions.pane=this.options.pane),this.options.label&&(markerOptions.label=L.Util.template(this.options.label,feature.properties),markerOptions.labelStyle=this.options.labelStyle),iconProperty&&feature.properties[iconProperty]&&(markerOptions.icon=L.icon(feature.properties[iconProperty])),L.marker(latlng,markerOptions)},setOpacity:function(opacity){this.eachLayer(function(layer){layer.setOpacity(opacity)})},highlight:function(id){var layer=this.findById(id);if(this.removeHighlight(),layer)return this._highlight=L.circleMarker(layer.getLatLng(),{radius:5,color:"orange",fillOpacity:0,className:"leaflet-marker-highlight"}).addTo(this._map),layer},removeHighlight:function(){this._highlight&&this._map.removeLayer(this._highlight)}})},function(module,exports,__webpack_require__){"use strict";function circles(options){return new Circles(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Circles=void 0,exports.default=circles;var _GeoJson=__webpack_require__(6),Circles=exports.Circles=_GeoJson.GeoJson.extend({options:{radius:1e3,style:{color:"#95c8fb",weight:1}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},pointToLayer:function(feature,latlng){return L.circle(latlng,{radius:this.options.radius,pane:this.options.pane})}})},function(module,exports,__webpack_require__){"use strict";function choropleth(options){return new Choropleth(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Choropleth=void 0,exports.default=choropleth;var _GeoJson=__webpack_require__(6),Choropleth=exports.Choropleth=_GeoJson.GeoJson.extend({options:{style:{color:"#333",weight:1,fillOpacity:.8},highlightStyle:{weight:3},valueKey:"value",colorKey:"color",radiusKey:"radius"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},addLayer:function(layer){var feature=layer.feature,prop=feature.properties,color=prop[this.options.colorKey],radius=prop[this.options.radiusKey];color&&layer.setStyle&&layer.setStyle({fillColor:color}),feature.isSelected&&layer.setStyle(this.options.highlightStyle),radius&&layer.setRadius&&layer.setRadius(radius),_GeoJson.GeoJson.prototype.addLayer.call(this,layer)},highlight:function(id){var layer=this.findById(id);if(layer)return layer.setStyle(this.options.highlightStyle)},removeHighlight:function(id){var layer=this.findById(id);if(layer)return layer.setStyle(this.options.resetStyle)},pointToLayer:function(feature,latlng){return L.circleMarker(latlng,{pane:this.options.pane})}})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function clientCluster(options){return new ClientCluster(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClientCluster=void 0,exports.default=clientCluster;var _ClusterIcon=__webpack_require__(28),_ClusterIcon2=_interopRequireDefault(_ClusterIcon),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),_d3Scale=__webpack_require__(30);__webpack_require__(149);var ClientCluster=exports.ClientCluster=L.MarkerClusterGroup.extend({options:{maxClusterRadius:40,showCoverageOnHover:!1,iconCreateFunction:function(cluster){var count=cluster.getChildCount();return cluster.options.opacity=this.opacity,(0,_ClusterIcon2.default)({color:this.color,opacity:this.opacity,size:this.scale(count),count:count})},domain:[1,1e3],range:[16,40],radius:6},initialize:function(opts){var options=L.setOptions(this,opts);L.MarkerClusterGroup.prototype.initialize.call(this,options),options.data&&this.addData(options.data),this.on("click",this.onMarkerClick,this)},onMarkerClick:function(evt){evt.layer.showPopup()},addData:function(data){var options=this.options;data.length&&(options.domain=[1,data.length],options.scale=(0,_d3Scale.scaleLog)().domain(options.domain).range(options.range).clamp(!0),this.addLayers(data.map(function(d){return(0,_CircleMarker2.default)(d,options)})))},setOpacity:function(opacity){this.options.opacity=opacity,this.eachLayer(function(layer){return layer.setOpacity(opacity)}),this._featureGroup.eachLayer(function(layer){return layer.setOpacity(opacity)})}})},function(module,__webpack_exports__,__webpack_require__){"use strict";function labConvert(o){if(o instanceof Lab)return new Lab(o.l,o.a,o.b,o.opacity);if(o instanceof Hcl){var h=o.h*__WEBPACK_IMPORTED_MODULE_2__math__.a;return new Lab(o.l,Math.cos(h)*o.c,Math.sin(h)*o.c,o.opacity)}o instanceof __WEBPACK_IMPORTED_MODULE_1__color__.b||(o=Object(__WEBPACK_IMPORTED_MODULE_1__color__.h)(o));var b=rgb2xyz(o.r),a=rgb2xyz(o.g),l=rgb2xyz(o.b),x=xyz2lab((.4124564*b+.3575761*a+.1804375*l)/Xn),y=xyz2lab((.2126729*b+.7151522*a+.072175*l)/Yn);return new Lab(116*y-16,500*(x-y),200*(y-xyz2lab((.0193339*b+.119192*a+.9503041*l)/Zn)),o.opacity)}function lab(l,a,b,opacity){return 1===arguments.length?labConvert(l):new Lab(l,a,b,null==opacity?1:opacity)}function Lab(l,a,b,opacity){this.l=+l,this.a=+a,this.b=+b,this.opacity=+opacity}function xyz2lab(t){return t>t3?Math.pow(t,1/3):t/t2+t0}function lab2xyz(t){return t>t1?t*t*t:t2*(t-t0)}function xyz2rgb(x){return 255*(x<=.0031308?12.92*x:1.055*Math.pow(x,1/2.4)-.055)}function rgb2xyz(x){return(x/=255)<=.04045?x/12.92:Math.pow((x+.055)/1.055,2.4)}function hclConvert(o){if(o instanceof Hcl)return new Hcl(o.h,o.c,o.l,o.opacity);o instanceof Lab||(o=labConvert(o));var h=Math.atan2(o.b,o.a)*__WEBPACK_IMPORTED_MODULE_2__math__.b;return new Hcl(h<0?h+360:h,Math.sqrt(o.a*o.a+o.b*o.b),o.l,o.opacity)}function hcl(h,c,l,opacity){return 1===arguments.length?hclConvert(h):new Hcl(h,c,l,null==opacity?1:opacity)}function Hcl(h,c,l,opacity){this.h=+h,this.c=+c,this.l=+l,this.opacity=+opacity}__webpack_exports__.a=lab,__webpack_exports__.b=hcl;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(16),__WEBPACK_IMPORTED_MODULE_2__math__=__webpack_require__(29),Xn=.95047,Yn=1,Zn=1.08883,t0=4/29,t1=6/29,t2=3*t1*t1,t3=t1*t1*t1;Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Lab,lab,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return new Lab(this.l+18*(null==k?1:k),this.a,this.b,this.opacity)},darker:function(k){return new Lab(this.l-18*(null==k?1:k),this.a,this.b,this.opacity)},rgb:function(){var y=(this.l+16)/116,x=isNaN(this.a)?y:y+this.a/500,z=isNaN(this.b)?y:y-this.b/200;return y=Yn*lab2xyz(y),x=Xn*lab2xyz(x),z=Zn*lab2xyz(z),new __WEBPACK_IMPORTED_MODULE_1__color__.b(xyz2rgb(3.2404542*x-1.5371385*y-.4985314*z),xyz2rgb(-.969266*x+1.8760108*y+.041556*z),xyz2rgb(.0556434*x-.2040259*y+1.0572252*z),this.opacity)}})),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Hcl,hcl,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return new Hcl(this.h,this.c,this.l+18*(null==k?1:k),this.opacity)},darker:function(k){return new Hcl(this.h,this.c,this.l-18*(null==k?1:k),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function cubehelixConvert(o){if(o instanceof Cubehelix)return new Cubehelix(o.h,o.s,o.l,o.opacity);o instanceof __WEBPACK_IMPORTED_MODULE_1__color__.b||(o=Object(__WEBPACK_IMPORTED_MODULE_1__color__.h)(o));var r=o.r/255,g=o.g/255,b=o.b/255,l=(BC_DA*b+ED*r-EB*g)/(BC_DA+ED-EB),bl=b-l,k=(E*(g-l)-C*bl)/D,s=Math.sqrt(k*k+bl*bl)/(E*l*(1-l)),h=s?Math.atan2(k,bl)*__WEBPACK_IMPORTED_MODULE_2__math__.b-120:NaN;return new Cubehelix(h<0?h+360:h,s,l,o.opacity)}function cubehelix(h,s,l,opacity){return 1===arguments.length?cubehelixConvert(h):new Cubehelix(h,s,l,null==opacity?1:opacity)}function Cubehelix(h,s,l,opacity){this.h=+h,this.s=+s,this.l=+l,this.opacity=+opacity}__webpack_exports__.a=cubehelix;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(16),__WEBPACK_IMPORTED_MODULE_2__math__=__webpack_require__(29),A=-.14861,B=1.78277,C=-.29227,D=-.90649,E=1.97294,ED=E*D,EB=E*B,BC_DA=B*C-D*A;Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Cubehelix,cubehelix,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return k=null==k?__WEBPACK_IMPORTED_MODULE_1__color__.c:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__.c,k),new Cubehelix(this.h,this.s,this.l*k,this.opacity)},darker:function(k){return k=null==k?__WEBPACK_IMPORTED_MODULE_1__color__.d:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__.d,k),new Cubehelix(this.h,this.s,this.l*k,this.opacity)},rgb:function(){var h=isNaN(this.h)?0:(this.h+120)*__WEBPACK_IMPORTED_MODULE_2__math__.a,l=+this.l,a=isNaN(this.s)?0:this.s*l*(1-l),cosh=Math.cos(h),sinh=Math.sin(h);return new __WEBPACK_IMPORTED_MODULE_1__color__.b(255*(l+a*(A*cosh+B*sinh)),255*(l+a*(C*cosh+D*sinh)),255*(l+a*(E*cosh)),this.opacity)}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function band(){function rescale(){var n=domain().length,reverse=range[1]<range[0],start=range[reverse-0],stop=range[1-reverse];step=(stop-start)/Math.max(1,n-paddingInner+2*paddingOuter),round&&(step=Math.floor(step)),start+=(stop-start-step*(n-paddingInner))*align,bandwidth=step*(1-paddingInner),round&&(start=Math.round(start),bandwidth=Math.round(bandwidth));var values=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.e)(n).map(function(i){return start+step*i});return ordinalRange(reverse?values.reverse():values)}var step,bandwidth,scale=Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__.a)().unknown(void 0),domain=scale.domain,ordinalRange=scale.range,range=[0,1],round=!1,paddingInner=0,paddingOuter=0,align=.5;return delete scale.unknown,scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain()},scale.range=function(_){return arguments.length?(range=[+_[0],+_[1]],rescale()):range.slice()},scale.rangeRound=function(_){return range=[+_[0],+_[1]],round=!0,rescale()},scale.bandwidth=function(){return bandwidth},scale.step=function(){return step},scale.round=function(_){return arguments.length?(round=!!_,rescale()):round},scale.padding=function(_){return arguments.length?(paddingInner=paddingOuter=Math.max(0,Math.min(1,_)),rescale()):paddingInner},scale.paddingInner=function(_){return arguments.length?(paddingInner=Math.max(0,Math.min(1,_)),rescale()):paddingInner},scale.paddingOuter=function(_){return arguments.length?(paddingOuter=Math.max(0,Math.min(1,_)),rescale()):paddingOuter},scale.align=function(_){return arguments.length?(align=Math.max(0,Math.min(1,_)),rescale()):align},scale.copy=function(){return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align)},rescale()}function pointish(scale){var copy=scale.copy;return scale.padding=scale.paddingOuter,delete scale.paddingInner,delete scale.paddingOuter,scale.copy=function(){return pointish(copy())},scale}function point(){return pointish(band().paddingInner(1))}__webpack_exports__.a=band,__webpack_exports__.b=point;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__ordinal__=__webpack_require__(43)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(33)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(37),__webpack_require__(31),__webpack_require__(89),__webpack_require__(36),__webpack_require__(90),__webpack_require__(38),__webpack_require__(39),__webpack_require__(40)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return x}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(37),__webpack_require__(5),__webpack_require__(7),__webpack_require__(18)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(34)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(7)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(5),__webpack_require__(7),__webpack_require__(18)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(5)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(42)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_2__src_map__=(__webpack_require__(103),__webpack_require__(104),__webpack_require__(19));__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_2__src_map__.a});__webpack_require__(105),__webpack_require__(106),__webpack_require__(107)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(19)},function(module,__webpack_exports__,__webpack_require__){"use strict";function Set(){}function set(object,f){var set=new Set;if(object instanceof Set)object.each(function(value){set.add(value)});else if(object){var i=-1,n=object.length;if(null==f)for(;++i<n;)set.add(object[i]);else for(;++i<n;)set.add(f(object[i],i,object))}return set}var __WEBPACK_IMPORTED_MODULE_0__map__=__webpack_require__(19),proto=__WEBPACK_IMPORTED_MODULE_0__map__.a.prototype;Set.prototype=set.prototype={constructor:Set,has:proto.has,add:function(value){return value+="",this[__WEBPACK_IMPORTED_MODULE_0__map__.b+value]=value,this},remove:proto.remove,clear:proto.clear,values:proto.keys,size:proto.size,empty:proto.empty,each:proto.each}},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";function identity(){function scale(x){return+x}var domain=[0,1];return scale.invert=scale,scale.domain=scale.range=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_0__array__.a.call(_,__WEBPACK_IMPORTED_MODULE_2__number__.a),scale):domain.slice()},scale.copy=function(){return identity().domain(domain)},Object(__WEBPACK_IMPORTED_MODULE_1__linear__.b)(scale)}__webpack_exports__.a=identity;var __WEBPACK_IMPORTED_MODULE_0__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_1__linear__=__webpack_require__(8),__WEBPACK_IMPORTED_MODULE_2__number__=__webpack_require__(51)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a=+a,b-=a,function(t){return Math.round(a+b*t)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function interpolateTransform(parse,pxComma,pxParen,degParen){function pop(s){return s.length?s.pop()+" ":""}function translate(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push("translate(",null,pxComma,null,pxParen);q.push({i:i-4,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(xa,xb)},{i:i-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(ya,yb)})}else(xb||yb)&&s.push("translate("+xb+pxComma+yb+pxParen)}function rotate(a,b,s,q){a!==b?(a-b>180?b+=360:b-a>180&&(a+=360),q.push({i:s.push(pop(s)+"rotate(",null,degParen)-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(a,b)})):b&&s.push(pop(s)+"rotate("+b+degParen)}function skewX(a,b,s,q){a!==b?q.push({i:s.push(pop(s)+"skewX(",null,degParen)-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(a,b)}):b&&s.push(pop(s)+"skewX("+b+degParen)}function scale(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push(pop(s)+"scale(",null,",",null,")");q.push({i:i-4,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(xa,xb)},{i:i-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(ya,yb)})}else 1===xb&&1===yb||s.push(pop(s)+"scale("+xb+","+yb+")")}return function(a,b){var s=[],q=[];return a=parse(a),b=parse(b),translate(a.translateX,a.translateY,b.translateX,b.translateY,s,q),rotate(a.rotate,b.rotate,s,q),skewX(a.skewX,b.skewX,s,q),scale(a.scaleX,a.scaleY,b.scaleX,b.scaleY,s,q),a=b=null,function(t){for(var o,i=-1,n=q.length;++i<n;)s[(o=q[i]).i]=o.x(t);return s.join("")}}}var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12),__WEBPACK_IMPORTED_MODULE_1__parse__=__webpack_require__(111);interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__.a,"px, ","px)","deg)"),interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__.b,", ",")",")")},function(module,__webpack_exports__,__webpack_require__){"use strict";function parseCss(value){return"none"===value?__WEBPACK_IMPORTED_MODULE_0__decompose__.b:(cssNode||(cssNode=document.createElement("DIV"),cssRoot=document.documentElement,cssView=document.defaultView),cssNode.style.transform=value,value=cssView.getComputedStyle(cssRoot.appendChild(cssNode),null).getPropertyValue("transform"),cssRoot.removeChild(cssNode),value=value.slice(7,-1).split(","),Object(__WEBPACK_IMPORTED_MODULE_0__decompose__.a)(+value[0],+value[1],+value[2],+value[3],+value[4],+value[5]))}function parseSvg(value){return null==value?__WEBPACK_IMPORTED_MODULE_0__decompose__.b:(svgNode||(svgNode=document.createElementNS("http://www.w3.org/2000/svg","g")),svgNode.setAttribute("transform",value),(value=svgNode.transform.baseVal.consolidate())?(value=value.matrix,Object(__WEBPACK_IMPORTED_MODULE_0__decompose__.a)(value.a,value.b,value.c,value.d,value.e,value.f)):__WEBPACK_IMPORTED_MODULE_0__decompose__.b)}__webpack_exports__.a=parseCss,__webpack_exports__.b=parseSvg;var cssNode,cssRoot,cssView,svgNode,__WEBPACK_IMPORTED_MODULE_0__decompose__=__webpack_require__(112)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return identity});var degrees=180/Math.PI,identity={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};__webpack_exports__.a=function(a,b,c,d,e,f){var scaleX,scaleY,skewX;return(scaleX=Math.sqrt(a*a+b*b))&&(a/=scaleX,b/=scaleX),(skewX=a*c+b*d)&&(c-=a*skewX,d-=b*skewX),(scaleY=Math.sqrt(c*c+d*d))&&(c/=scaleY,d/=scaleY,skewX/=scaleY),a*d<b*c&&(a=-a,b=-b,skewX=-skewX,scaleX=-scaleX),{translateX:e,translateY:f,rotate:Math.atan2(b,a)*degrees,skewX:Math.atan(skewX)*degrees,scaleX:scaleX,scaleY:scaleY}}},function(module,__webpack_exports__,__webpack_require__){"use strict";Math.SQRT2},function(module,__webpack_exports__,__webpack_require__){"use strict";function hsl(hue){return function(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hsl)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hsl)(end)).h),s=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.s,end.s),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.s=s(t),start.l=l(t),start.opacity=opacity(t),start+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);hsl(__WEBPACK_IMPORTED_MODULE_1__color__.c),hsl(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(3),__webpack_require__(9)},function(module,__webpack_exports__,__webpack_require__){"use strict";function hcl(hue){return function(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hcl)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hcl)(end)).h),c=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.c,end.c),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.c=c(t),start.l=l(t),start.opacity=opacity(t),start+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);hcl(__WEBPACK_IMPORTED_MODULE_1__color__.c),hcl(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";function cubehelix(hue){return function cubehelixGamma(y){function cubehelix(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.cubehelix)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.cubehelix)(end)).h),s=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.s,end.s),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.s=s(t),start.l=l(Math.pow(t,y)),start.opacity=opacity(t),start+""}}return y=+y,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__.c),cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(52);__webpack_exports__.a=function(domain,count,specifier){var precision,start=domain[0],stop=domain[domain.length-1],step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start,stop,null==count?10:count);switch(specifier=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.c)(null==specifier?",f":specifier),specifier.type){case"s":var value=Math.max(Math.abs(start),Math.abs(stop));return null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.e)(step,value))||(specifier.precision=precision),Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.b)(specifier,value);case"":case"e":case"g":case"p":case"r":null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.f)(step,Math.max(Math.abs(start),Math.abs(stop))))||(specifier.precision=precision-("e"===specifier.type));break;case"f":case"%":null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.d)(step))||(specifier.precision=precision-2*("%"===specifier.type))}return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.a)(specifier)}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return format}),__webpack_require__.d(__webpack_exports__,"b",function(){return formatPrefix});var locale,format,formatPrefix,__WEBPACK_IMPORTED_MODULE_0__locale__=__webpack_require__(53);!function(definition){locale=Object(__WEBPACK_IMPORTED_MODULE_0__locale__.a)(definition),format=locale.format,formatPrefix=locale.formatPrefix}({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(grouping,thousands){return function(value,width){for(var i=value.length,t=[],j=0,g=grouping[0],length=0;i>0&&g>0&&(length+g+1>width&&(g=Math.max(1,width-length)),t.push(value.substring(i-=g,i+g)),!((length+=g+1)>width));)g=grouping[j=(j+1)%grouping.length];return t.reverse().join(thousands)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x,p){x=x.toPrecision(p);out:for(var i1,n=x.length,i=1,i0=-1;i<n;++i)switch(x[i]){case".":i0=i1=i;break;case"0":0===i0&&(i0=i),i1=i;break;case"e":break out;default:i0>0&&(i0=0)}return i0>0?x.slice(0,i0)+x.slice(i1+1):x}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x,p){var d=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1];return exponent<0?"0."+new Array(-exponent).join("0")+coefficient:coefficient.length>exponent+1?coefficient.slice(0,exponent+1)+"."+coefficient.slice(exponent+1):coefficient+new Array(exponent-coefficient.length+2).join("0")}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step){return Math.max(0,-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(Math.abs(step)))}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step,value){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(value)/3)))-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(Math.abs(step)))}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step,max){return step=Math.abs(step),max=Math.abs(max)-step,Math.max(0,Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(max)-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(step))+1}},function(module,__webpack_exports__,__webpack_require__){"use strict";function deinterpolate(a,b){return(b=Math.log(b/a))?function(x){return Math.log(x/a)/b}:Object(__WEBPACK_IMPORTED_MODULE_2__constant__.a)(b)}function reinterpolate(a,b){return a<0?function(t){return-Math.pow(-b,t)*Math.pow(-a,1-t)}:function(t){return Math.pow(b,t)*Math.pow(a,1-t)}}function pow10(x){return isFinite(x)?+("1e"+x):x<0?0:x}function powp(base){return 10===base?pow10:base===Math.E?Math.exp:function(x){return Math.pow(base,x)}}function logp(base){return base===Math.E?Math.log:10===base&&Math.log10||2===base&&Math.log2||(base=Math.log(base),function(x){return Math.log(x)/base})}function reflect(f){return function(x){return-f(-x)}}function log(){function rescale(){return logs=logp(base),pows=powp(base),domain()[0]<0&&(logs=reflect(logs),pows=reflect(pows)),scale}var scale=Object(__WEBPACK_IMPORTED_MODULE_4__continuous__.b)(deinterpolate,reinterpolate).domain([1,10]),domain=scale.domain,base=10,logs=logp(10),pows=powp(10);return scale.base=function(_){return arguments.length?(base=+_,rescale()):base},scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain()},scale.ticks=function(count){var r,d=domain(),u=d[0],v=d[d.length-1];(r=v<u)&&(i=u,u=v,v=i);var p,k,t,i=logs(u),j=logs(v),n=null==count?10:+count,z=[];if(!(base%1)&&j-i<n){if(i=Math.round(i)-1,j=Math.round(j)+1,u>0){for(;i<j;++i)for(k=1,p=pows(i);k<base;++k)if(!((t=p*k)<u)){if(t>v)break;z.push(t)}}else for(;i<j;++i)for(k=base-1,p=pows(i);k>=1;--k)if(!((t=p*k)<u)){if(t>v)break;z.push(t)}}else z=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.h)(i,j,Math.min(j-i,n)).map(pows);return r?z.reverse():z},scale.tickFormat=function(count,specifier){if(null==specifier&&(specifier=10===base?".0e":","),"function"!=typeof specifier&&(specifier=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.a)(specifier)),count===1/0)return specifier;null==count&&(count=10);var k=Math.max(1,base*count/scale.ticks().length);return function(d){var i=d/pows(Math.round(logs(d)));return i*base<base-.5&&(i*=base),i<=k?specifier(d):""}},scale.nice=function(){return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__.a)(domain(),{floor:function(x){return pows(Math.floor(logs(x)))},ceil:function(x){return pows(Math.ceil(logs(x)))}}))},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__.a)(scale,log().base(base))},scale}__webpack_exports__.a=log;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(52),__WEBPACK_IMPORTED_MODULE_2__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_3__nice__=__webpack_require__(57),__WEBPACK_IMPORTED_MODULE_4__continuous__=__webpack_require__(13)},function(module,__webpack_exports__,__webpack_require__){"use strict";function raise(x,exponent){return x<0?-Math.pow(-x,exponent):Math.pow(x,exponent)}function pow(){function deinterpolate(a,b){return(b=raise(b,exponent)-(a=raise(a,exponent)))?function(x){return(raise(x,exponent)-a)/b}:Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(b)}function reinterpolate(a,b){return b=raise(b,exponent)-(a=raise(a,exponent)),function(t){return raise(a+b*t,1/exponent)}}var exponent=1,scale=Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.b)(deinterpolate,reinterpolate),domain=scale.domain;return scale.exponent=function(_){return arguments.length?(exponent=+_,domain(domain())):exponent},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.a)(scale,pow().exponent(exponent))},Object(__WEBPACK_IMPORTED_MODULE_1__linear__.b)(scale)}function sqrt(){return pow().exponent(.5)}__webpack_exports__.a=pow,__webpack_exports__.b=sqrt;var __WEBPACK_IMPORTED_MODULE_0__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_1__linear__=__webpack_require__(8),__WEBPACK_IMPORTED_MODULE_2__continuous__=__webpack_require__(13)},function(module,__webpack_exports__,__webpack_require__){"use strict";function quantile(){function rescale(){var i=0,n=Math.max(1,range.length);for(thresholds=new Array(n-1);++i<n;)thresholds[i-1]=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.d)(domain,i/n);return scale}function scale(x){if(!isNaN(x=+x))return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(thresholds,x)]}var domain=[],range=[],thresholds=[];return scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:[i>0?thresholds[i-1]:domain[0],i<thresholds.length?thresholds[i]:domain[domain.length-1]]},scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[];for(var d,i=0,n=_.length;i<n;++i)null==(d=_[i])||isNaN(d=+d)||domain.push(d);return domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__.a),rescale()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),rescale()):range.slice()},scale.quantiles=function(){return thresholds.slice()},scale.copy=function(){return quantile().domain(domain).range(range)},scale}__webpack_exports__.a=quantile;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4)},function(module,__webpack_exports__,__webpack_require__){"use strict";function quantize(){function scale(x){if(x<=x)return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,0,n)]}function rescale(){var i=-1;for(domain=new Array(n);++i<n;)domain[i]=((i+1)*x1-(i-n)*x0)/(n+1);return scale}var x0=0,x1=1,n=1,domain=[.5],range=[0,1];return scale.domain=function(_){return arguments.length?(x0=+_[0],x1=+_[1],rescale()):[x0,x1]},scale.range=function(_){return arguments.length?(n=(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_)).length-1,rescale()):range.slice()},scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:i<1?[x0,domain[0]]:i>=n?[domain[n-1],x1]:[domain[i-1],domain[i]]},scale.copy=function(){return quantize().domain([x0,x1]).range(range)},Object(__WEBPACK_IMPORTED_MODULE_2__linear__.b)(scale)}__webpack_exports__.a=quantize;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8)},function(module,__webpack_exports__,__webpack_require__){"use strict";function threshold(){function scale(x){if(x<=x)return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,0,n)]}var domain=[.5],range=[0,1],n=1;return scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),n=Math.min(domain.length,range.length-1),scale):domain.slice()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),n=Math.min(domain.length,range.length-1),scale):range.slice()},scale.invertExtent=function(y){var i=range.indexOf(y);return[domain[i-1],domain[i]]},scale.copy=function(){return threshold().domain(domain).range(range)},scale}__webpack_exports__.a=threshold;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),millisecond=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(){},function(date,step){date.setTime(+date+step)},function(start,end){return end-start});millisecond.every=function(k){return k=Math.floor(k),isFinite(k)&&k>0?k>1?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/k)*k)},function(date,step){date.setTime(+date+step*k)},function(start,end){return(end-start)/k}):millisecond:null},__webpack_exports__.a=millisecond;millisecond.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),second=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/__WEBPACK_IMPORTED_MODULE_1__duration__.d)*__WEBPACK_IMPORTED_MODULE_1__duration__.d)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.d)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.d},function(date){return date.getUTCSeconds()});__webpack_exports__.a=second;second.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),minute=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/__WEBPACK_IMPORTED_MODULE_1__duration__.c)*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.c},function(date){return date.getMinutes()});__webpack_exports__.a=minute;minute.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),hour=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){var offset=date.getTimezoneOffset()*__WEBPACK_IMPORTED_MODULE_1__duration__.c%__WEBPACK_IMPORTED_MODULE_1__duration__.b;offset<0&&(offset+=__WEBPACK_IMPORTED_MODULE_1__duration__.b),date.setTime(Math.floor((+date-offset)/__WEBPACK_IMPORTED_MODULE_1__duration__.b)*__WEBPACK_IMPORTED_MODULE_1__duration__.b+offset)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.b)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.b},function(date){return date.getHours()});__webpack_exports__.a=hour;hour.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),day=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setHours(0,0,0,0)},function(date,step){date.setDate(date.getDate()+step)},function(start,end){return(end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration__.c)/__WEBPACK_IMPORTED_MODULE_1__duration__.a},function(date){return date.getDate()-1});__webpack_exports__.a=day;day.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function weekday(i){return Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setDate(date.getDate()-(date.getDay()+7-i)%7),date.setHours(0,0,0,0)},function(date,step){date.setDate(date.getDate()+7*step)},function(start,end){return(end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration__.c)/__WEBPACK_IMPORTED_MODULE_1__duration__.e})}__webpack_require__.d(__webpack_exports__,"b",function(){return sunday}),__webpack_require__.d(__webpack_exports__,"a",function(){return monday});var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),sunday=weekday(0),monday=weekday(1),tuesday=weekday(2),wednesday=weekday(3),thursday=weekday(4),friday=weekday(5),saturday=weekday(6);sunday.range,monday.range,tuesday.range,wednesday.range,thursday.range,friday.range,saturday.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),month=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setDate(1),date.setHours(0,0,0,0)},function(date,step){date.setMonth(date.getMonth()+step)},function(start,end){return end.getMonth()-start.getMonth()+12*(end.getFullYear()-start.getFullYear())},function(date){return date.getMonth()});__webpack_exports__.a=month;month.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),year=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setMonth(0,1),date.setHours(0,0,0,0)},function(date,step){date.setFullYear(date.getFullYear()+step)},function(start,end){return end.getFullYear()-start.getFullYear()},function(date){return date.getFullYear()});year.every=function(k){return isFinite(k=Math.floor(k))&&k>0?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setFullYear(Math.floor(date.getFullYear()/k)*k),date.setMonth(0,1),date.setHours(0,0,0,0)},function(date,step){date.setFullYear(date.getFullYear()+step*k)}):null},__webpack_exports__.a=year;year.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcMinute=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCSeconds(0,0)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.c},function(date){return date.getUTCMinutes()});__webpack_exports__.a=utcMinute;utcMinute.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcHour=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCMinutes(0,0,0)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.b)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.b},function(date){return date.getUTCHours()});__webpack_exports__.a=utcHour;utcHour.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcDay=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCDate(date.getUTCDate()+step)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.a},function(date){return date.getUTCDate()-1});__webpack_exports__.a=utcDay;utcDay.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function utcWeekday(i){return Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCDate(date.getUTCDate()-(date.getUTCDay()+7-i)%7),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCDate(date.getUTCDate()+7*step)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.e})}__webpack_require__.d(__webpack_exports__,"b",function(){return utcSunday}),__webpack_require__.d(__webpack_exports__,"a",function(){return utcMonday});var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcSunday=utcWeekday(0),utcMonday=utcWeekday(1),utcTuesday=utcWeekday(2),utcWednesday=utcWeekday(3),utcThursday=utcWeekday(4),utcFriday=utcWeekday(5),utcSaturday=utcWeekday(6);utcSunday.range,utcMonday.range,utcTuesday.range,utcWednesday.range,utcThursday.range,utcFriday.range,utcSaturday.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),utcMonth=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCDate(1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCMonth(date.getUTCMonth()+step)},function(start,end){return end.getUTCMonth()-start.getUTCMonth()+12*(end.getUTCFullYear()-start.getUTCFullYear())},function(date){return date.getUTCMonth()});__webpack_exports__.a=utcMonth;utcMonth.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),utcYear=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCMonth(0,1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step)},function(start,end){return end.getUTCFullYear()-start.getUTCFullYear()},function(date){return date.getUTCFullYear()});utcYear.every=function(k){return isFinite(k=Math.floor(k))&&k>0?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCFullYear(Math.floor(date.getUTCFullYear()/k)*k),date.setUTCMonth(0,1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step*k)}):null},__webpack_exports__.a=utcYear;utcYear.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function parseIsoNative(string){var date=new Date(string);return isNaN(date)?null:date}var __WEBPACK_IMPORTED_MODULE_0__isoFormat__=__webpack_require__(61),__WEBPACK_IMPORTED_MODULE_1__defaultLocale__=__webpack_require__(26);+new Date("2000-01-01T00:00:00.000Z")||Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__.c)(__WEBPACK_IMPORTED_MODULE_0__isoFormat__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__time__=__webpack_require__(58),__WEBPACK_IMPORTED_MODULE_1_d3_time_format__=__webpack_require__(59),__WEBPACK_IMPORTED_MODULE_2_d3_time__=__webpack_require__(25);__webpack_exports__.a=function(){return Object(__WEBPACK_IMPORTED_MODULE_0__time__.a)(__WEBPACK_IMPORTED_MODULE_2_d3_time__.t,__WEBPACK_IMPORTED_MODULE_2_d3_time__.p,__WEBPACK_IMPORTED_MODULE_2_d3_time__.s,__WEBPACK_IMPORTED_MODULE_2_d3_time__.k,__WEBPACK_IMPORTED_MODULE_2_d3_time__.l,__WEBPACK_IMPORTED_MODULE_2_d3_time__.n,__WEBPACK_IMPORTED_MODULE_2_d3_time__.q,__WEBPACK_IMPORTED_MODULE_2_d3_time__.m,__WEBPACK_IMPORTED_MODULE_1_d3_time_format__.b).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(module,__webpack_exports__,__webpack_require__){"use strict";function sequential(interpolator){function scale(x){var t=(x-x0)/(x1-x0);return interpolator(clamp?Math.max(0,Math.min(1,t)):t)}var x0=0,x1=1,clamp=!1;return scale.domain=function(_){return arguments.length?(x0=+_[0],x1=+_[1],scale):[x0,x1]},scale.clamp=function(_){return arguments.length?(clamp=!!_,scale):clamp},scale.interpolator=function(_){return arguments.length?(interpolator=_,scale):interpolator},scale.copy=function(){return sequential(interpolator).domain([x0,x1]).clamp(clamp)},Object(__WEBPACK_IMPORTED_MODULE_0__linear__.b)(scale)}__webpack_exports__.a=sequential;var __WEBPACK_IMPORTED_MODULE_0__linear__=__webpack_require__(8)},function(module,exports,__webpack_require__){!function(global,factory){factory(exports)}(0,function(exports){"use strict";var MarkerClusterGroup=L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,clusterPane:L.Marker.prototype.options.pane,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(options){L.Util.setOptions(this,options),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var animate=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,animate?this._withAnimation:this._noAnimation),this._markerCluster=animate?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(layer){if(layer instanceof L.LayerGroup)return this.addLayers([layer]);if(!layer.getLatLng)return this._nonPointGroup.addLayer(layer),this.fire("layeradd",{layer:layer}),this;if(!this._map)return this._needsClustering.push(layer),this.fire("layeradd",{layer:layer}),this;if(this.hasLayer(layer))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(layer,this._maxZoom),this.fire("layeradd",{layer:layer}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var visibleLayer=layer,currentZoom=this._zoom;if(layer.__parent)for(;visibleLayer.__parent._zoom>=currentZoom;)visibleLayer=visibleLayer.__parent;return this._currentShownBounds.contains(visibleLayer.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(layer,visibleLayer):this._animationAddLayerNonAnimated(layer,visibleLayer)),this},removeLayer:function(layer){return layer instanceof L.LayerGroup?this.removeLayers([layer]):layer.getLatLng?this._map?layer.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(layer)),this._removeLayer(layer,!0),this.fire("layerremove",{layer:layer}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),layer.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(layer)&&(this._featureGroup.removeLayer(layer),layer.clusterShow&&layer.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,layer)&&this.hasLayer(layer)&&this._needsRemoving.push({layer:layer,latlng:layer._latlng}),this.fire("layerremove",{layer:layer}),this):(this._nonPointGroup.removeLayer(layer),this.fire("layerremove",{layer:layer}),this)},addLayers:function(layersArray,skipLayerAddEvent){if(!L.Util.isArray(layersArray))return this.addLayer(layersArray);var m,fg=this._featureGroup,npg=this._nonPointGroup,chunked=this.options.chunkedLoading,chunkInterval=this.options.chunkInterval,chunkProgress=this.options.chunkProgress,l=layersArray.length,offset=0,originalArray=!0;if(this._map){var started=(new Date).getTime(),process=L.bind(function(){for(var start=(new Date).getTime();offset<l;offset++){if(chunked&&offset%200==0){if((new Date).getTime()-start>chunkInterval)break}if((m=layersArray[offset])instanceof L.LayerGroup)originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length;else if(m.getLatLng){if(!this.hasLayer(m)&&(this._addLayer(m,this._maxZoom),skipLayerAddEvent||this.fire("layeradd",{layer:m}),m.__parent&&2===m.__parent.getChildCount())){var markers=m.__parent.getAllChildMarkers(),otherMarker=markers[0]===m?markers[1]:markers[0];fg.removeLayer(otherMarker)}}else npg.addLayer(m),skipLayerAddEvent||this.fire("layeradd",{layer:m})}chunkProgress&&chunkProgress(offset,l,(new Date).getTime()-started),offset===l?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(process,this.options.chunkDelay)},this);process()}else for(var needsClustering=this._needsClustering;offset<l;offset++)m=layersArray[offset],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):m.getLatLng?this.hasLayer(m)||needsClustering.push(m):npg.addLayer(m);return this},removeLayers:function(layersArray){var i,m,l=layersArray.length,fg=this._featureGroup,npg=this._nonPointGroup,originalArray=!0;if(!this._map){for(i=0;i<l;i++)m=layersArray[i],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):(this._arraySplice(this._needsClustering,m),npg.removeLayer(m),this.hasLayer(m)&&this._needsRemoving.push({layer:m,latlng:m._latlng}),this.fire("layerremove",{layer:m}));return this}if(this._unspiderfy){this._unspiderfy();var layersArray2=layersArray.slice(),l2=l;for(i=0;i<l2;i++)m=layersArray2[i],m instanceof L.LayerGroup?(this._extractNonGroupLayers(m,layersArray2),l2=layersArray2.length):this._unspiderfyLayer(m)}for(i=0;i<l;i++)m=layersArray[i],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):m.__parent?(this._removeLayer(m,!0,!0),this.fire("layerremove",{layer:m}),fg.hasLayer(m)&&(fg.removeLayer(m),m.clusterShow&&m.clusterShow())):(npg.removeLayer(m),this.fire("layerremove",{layer:m}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(marker){marker.off(this._childMarkerEventHandlers,this),delete marker.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var bounds=new L.LatLngBounds;this._topClusterLevel&&bounds.extend(this._topClusterLevel._bounds);for(var i=this._needsClustering.length-1;i>=0;i--)bounds.extend(this._needsClustering[i].getLatLng());return bounds.extend(this._nonPointGroup.getBounds()),bounds},eachLayer:function(method,context){var thisNeedsRemoving,i,j,markers=this._needsClustering.slice(),needsRemoving=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(markers),i=markers.length-1;i>=0;i--){for(thisNeedsRemoving=!0,j=needsRemoving.length-1;j>=0;j--)if(needsRemoving[j].layer===markers[i]){thisNeedsRemoving=!1;break}thisNeedsRemoving&&method.call(context,markers[i])}this._nonPointGroup.eachLayer(method,context)},getLayers:function(){var layers=[];return this.eachLayer(function(l){layers.push(l)}),layers},getLayer:function(id){var result=null;return id=parseInt(id,10),this.eachLayer(function(l){L.stamp(l)===id&&(result=l)}),result},hasLayer:function(layer){if(!layer)return!1;var i,anArray=this._needsClustering;for(i=anArray.length-1;i>=0;i--)if(anArray[i]===layer)return!0;for(anArray=this._needsRemoving,i=anArray.length-1;i>=0;i--)if(anArray[i].layer===layer)return!1;return!(!layer.__parent||layer.__parent._group!==this)||this._nonPointGroup.hasLayer(layer)},zoomToShowLayer:function(layer,callback){"function"!=typeof callback&&(callback=function(){});var showMarker=function(){!layer._icon&&!layer.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",showMarker,this),this.off("animationend",showMarker,this),layer._icon?callback():layer.__parent._icon&&(this.once("spiderfied",callback,this),layer.__parent.spiderfy()))};layer._icon&&this._map.getBounds().contains(layer.getLatLng())?callback():layer.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",showMarker,this),this._map.panTo(layer.getLatLng())):(this._map.on("moveend",showMarker,this),this.on("animationend",showMarker,this),layer.__parent.zoomToBounds())},onAdd:function(map){this._map=map;var i,l,layer;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(map),this._nonPointGroup.addTo(map),this._gridClusters||this._generateInitialClusters(),this._maxLat=map.options.crs.projection.MAX_LATITUDE,i=0,l=this._needsRemoving.length;i<l;i++)layer=this._needsRemoving[i],layer.newlatlng=layer.layer._latlng,layer.layer._latlng=layer.latlng;for(i=0,l=this._needsRemoving.length;i<l;i++)layer=this._needsRemoving[i],this._removeLayer(layer.layer,!0),layer.layer._latlng=layer.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),l=this._needsClustering,this._needsClustering=[],this.addLayers(l,!0)},onRemove:function(map){map.off("zoomend",this._zoomEnd,this),map.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(marker){for(var vMarker=marker;vMarker&&!vMarker._icon;)vMarker=vMarker.__parent;return vMarker||null},_arraySplice:function(anArray,obj){for(var i=anArray.length-1;i>=0;i--)if(anArray[i]===obj)return anArray.splice(i,1),!0},_removeFromGridUnclustered:function(marker,z){for(var map=this._map,gridUnclustered=this._gridUnclustered,minZoom=Math.floor(this._map.getMinZoom());z>=minZoom&&gridUnclustered[z].removeObject(marker,map.project(marker.getLatLng(),z));z--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var isPopupOpen=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),isPopupOpen&&e.target.openPopup()}},_moveChild:function(layer,from,to){layer._latlng=from,this.removeLayer(layer),layer._latlng=to,this.addLayer(layer)},_childMarkerDragEnd:function(e){e.target.__dragStart&&this._moveChild(e.target,e.target.__dragStart,e.target._latlng),delete e.target.__dragStart},_removeLayer:function(marker,removeFromDistanceGrid,dontUpdateMap){var gridClusters=this._gridClusters,gridUnclustered=this._gridUnclustered,fg=this._featureGroup,map=this._map,minZoom=Math.floor(this._map.getMinZoom());removeFromDistanceGrid&&this._removeFromGridUnclustered(marker,this._maxZoom);var otherMarker,cluster=marker.__parent,markers=cluster._markers;for(this._arraySplice(markers,marker);cluster&&(cluster._childCount--,cluster._boundsNeedUpdate=!0,!(cluster._zoom<minZoom));)removeFromDistanceGrid&&cluster._childCount<=1?(otherMarker=cluster._markers[0]===marker?cluster._markers[1]:cluster._markers[0],gridClusters[cluster._zoom].removeObject(cluster,map.project(cluster._cLatLng,cluster._zoom)),gridUnclustered[cluster._zoom].addObject(otherMarker,map.project(otherMarker.getLatLng(),cluster._zoom)),this._arraySplice(cluster.__parent._childClusters,cluster),cluster.__parent._markers.push(otherMarker),otherMarker.__parent=cluster.__parent,cluster._icon&&(fg.removeLayer(cluster),dontUpdateMap||fg.addLayer(otherMarker))):cluster._iconNeedsUpdate=!0,cluster=cluster.__parent;delete marker.__parent},_isOrIsParent:function(el,oel){for(;oel;){if(el===oel)return!0;oel=oel.parentNode}return!1},fire:function(type,data,propagate){if(data&&data.layer instanceof L.MarkerCluster){if(data.originalEvent&&this._isOrIsParent(data.layer._icon,data.originalEvent.relatedTarget))return;type="cluster"+type}L.FeatureGroup.prototype.fire.call(this,type,data,propagate)},listens:function(type,propagate){return L.FeatureGroup.prototype.listens.call(this,type,propagate)||L.FeatureGroup.prototype.listens.call(this,"cluster"+type,propagate)},_defaultIconCreateFunction:function(cluster){var childCount=cluster.getChildCount(),c=" marker-cluster-";return c+=childCount<10?"small":childCount<100?"medium":"large",new L.DivIcon({html:"<div><span>"+childCount+"</span></div>",className:"marker-cluster"+c,iconSize:new L.Point(40,40)})},_bindEvents:function(){var map=this._map,spiderfyOnMaxZoom=this.options.spiderfyOnMaxZoom,showCoverageOnHover=this.options.showCoverageOnHover,zoomToBoundsOnClick=this.options.zoomToBoundsOnClick;(spiderfyOnMaxZoom||zoomToBoundsOnClick)&&this.on("clusterclick",this._zoomOrSpiderfy,this),showCoverageOnHover&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),map.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var cluster=e.layer,bottomCluster=cluster;1===bottomCluster._childClusters.length;)bottomCluster=bottomCluster._childClusters[0];bottomCluster._zoom===this._maxZoom&&bottomCluster._childCount===cluster._childCount&&this.options.spiderfyOnMaxZoom?cluster.spiderfy():this.options.zoomToBoundsOnClick&&cluster.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var map=this._map;this._inZoomAnimation||(this._shownPolygon&&map.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),map.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var spiderfyOnMaxZoom=this.options.spiderfyOnMaxZoom,showCoverageOnHover=this.options.showCoverageOnHover,zoomToBoundsOnClick=this.options.zoomToBoundsOnClick,map=this._map;(spiderfyOnMaxZoom||zoomToBoundsOnClick)&&this.off("clusterclick",this._zoomOrSpiderfy,this),showCoverageOnHover&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),map.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var newBounds=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,newBounds),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),newBounds),this._currentShownBounds=newBounds}},_generateInitialClusters:function(){var maxZoom=Math.ceil(this._map.getMaxZoom()),minZoom=Math.floor(this._map.getMinZoom()),radius=this.options.maxClusterRadius,radiusFn=radius;"function"!=typeof radius&&(radiusFn=function(){return radius}),null!==this.options.disableClusteringAtZoom&&(maxZoom=this.options.disableClusteringAtZoom-1),this._maxZoom=maxZoom,this._gridClusters={},this._gridUnclustered={};for(var zoom=maxZoom;zoom>=minZoom;zoom--)this._gridClusters[zoom]=new L.DistanceGrid(radiusFn(zoom)),this._gridUnclustered[zoom]=new L.DistanceGrid(radiusFn(zoom));this._topClusterLevel=new this._markerCluster(this,minZoom-1)},_addLayer:function(layer,zoom){var markerPoint,z,gridClusters=this._gridClusters,gridUnclustered=this._gridUnclustered,minZoom=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(layer),layer.on(this._childMarkerEventHandlers,this);zoom>=minZoom;zoom--){markerPoint=this._map.project(layer.getLatLng(),zoom);var closest=gridClusters[zoom].getNearObject(markerPoint);if(closest)return closest._addChild(layer),void(layer.__parent=closest);if(closest=gridUnclustered[zoom].getNearObject(markerPoint)){var parent=closest.__parent;parent&&this._removeLayer(closest,!1);var newCluster=new this._markerCluster(this,zoom,closest,layer);gridClusters[zoom].addObject(newCluster,this._map.project(newCluster._cLatLng,zoom)),closest.__parent=newCluster,layer.__parent=newCluster;var lastParent=newCluster;for(z=zoom-1;z>parent._zoom;z--)lastParent=new this._markerCluster(this,z,lastParent),gridClusters[z].addObject(lastParent,this._map.project(closest.getLatLng(),z));return parent._addChild(lastParent),void this._removeFromGridUnclustered(closest,zoom)}gridUnclustered[zoom].addObject(layer,markerPoint)}this._topClusterLevel._addChild(layer),layer.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(c){c instanceof L.MarkerCluster&&c._iconNeedsUpdate&&c._updateIcon()})},_enqueue:function(fn){this._queue.push(fn),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var i=0;i<this._queue.length;i++)this._queue[i].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var mapZoom=Math.round(this._map._zoom);this._processQueue(),this._zoom<mapZoom&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,mapZoom)):this._zoom>mapZoom?(this._animationStart(),this._animationZoomOut(this._zoom,mapZoom)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(bounds){var maxLat=this._maxLat;return void 0!==maxLat&&(bounds.getNorth()>=maxLat&&(bounds._northEast.lat=1/0),bounds.getSouth()<=-maxLat&&(bounds._southWest.lat=-1/0)),bounds},_animationAddLayerNonAnimated:function(layer,newCluster){if(newCluster===layer)this._featureGroup.addLayer(layer);else if(2===newCluster._childCount){newCluster._addToMap();var markers=newCluster.getAllChildMarkers();this._featureGroup.removeLayer(markers[0]),this._featureGroup.removeLayer(markers[1])}else newCluster._updateIcon()},_extractNonGroupLayers:function(group,output){var layer,layers=group.getLayers(),i=0;for(output=output||[];i<layers.length;i++)layer=layers[i],layer instanceof L.LayerGroup?this._extractNonGroupLayers(layer,output):output.push(layer);return output},_overrideMarkerIcon:function(layer){return layer.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[layer]}})}});L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(previousZoomLevel,newZoomLevel){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(previousZoomLevel,newZoomLevel){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(layer,newCluster){this._animationAddLayerNonAnimated(layer,newCluster)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(previousZoomLevel,newZoomLevel){var i,bounds=this._getExpandedVisibleBounds(),fg=this._featureGroup,minZoom=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(bounds,previousZoomLevel,minZoom,function(c){var m,startPos=c._latlng,markers=c._markers;for(bounds.contains(startPos)||(startPos=null),c._isSingleParent()&&previousZoomLevel+1===newZoomLevel?(fg.removeLayer(c),c._recursivelyAddChildrenToMap(null,newZoomLevel,bounds)):(c.clusterHide(),c._recursivelyAddChildrenToMap(startPos,newZoomLevel,bounds)),i=markers.length-1;i>=0;i--)m=markers[i],bounds.contains(m._latlng)||fg.removeLayer(m)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(bounds,newZoomLevel),fg.eachLayer(function(n){n instanceof L.MarkerCluster||!n._icon||n.clusterShow()}),this._topClusterLevel._recursively(bounds,previousZoomLevel,newZoomLevel,function(c){c._recursivelyRestoreChildPositions(newZoomLevel)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(bounds,previousZoomLevel,minZoom,function(c){fg.removeLayer(c),c.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(previousZoomLevel,newZoomLevel){this._animationZoomOutSingle(this._topClusterLevel,previousZoomLevel-1,newZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel,this._getExpandedVisibleBounds())},_animationAddLayer:function(layer,newCluster){var me=this,fg=this._featureGroup;fg.addLayer(layer),newCluster!==layer&&(newCluster._childCount>2?(newCluster._updateIcon(),this._forceLayout(),this._animationStart(),layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng())),layer.clusterHide(),this._enqueue(function(){fg.removeLayer(layer),layer.clusterShow(),me._animationEnd()})):(this._forceLayout(),me._animationStart(),me._animationZoomOutSingle(newCluster,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(cluster,previousZoomLevel,newZoomLevel){var bounds=this._getExpandedVisibleBounds(),minZoom=Math.floor(this._map.getMinZoom());cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds,minZoom,previousZoomLevel+1,newZoomLevel);var me=this;this._forceLayout(),cluster._recursivelyBecomeVisible(bounds,newZoomLevel),this._enqueue(function(){if(1===cluster._childCount){var m=cluster._markers[0];this._ignoreMove=!0,m.setLatLng(m.getLatLng()),this._ignoreMove=!1,m.clusterShow&&m.clusterShow()}else cluster._recursively(bounds,newZoomLevel,minZoom,function(c){c._recursivelyRemoveChildrenFromMap(bounds,minZoom,previousZoomLevel+1)});me._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(document.body.offsetWidth)}}),L.markerClusterGroup=function(options){return new L.MarkerClusterGroup(options)};var MarkerCluster=L.MarkerCluster=L.Marker.extend({options:L.Icon.prototype.options,initialize:function(group,zoom,a,b){L.Marker.prototype.initialize.call(this,a?a._cLatLng||a.getLatLng():new L.LatLng(0,0),{icon:this,pane:group.options.clusterPane}),this._group=group,this._zoom=zoom,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,a&&this._addChild(a),b&&this._addChild(b)},getAllChildMarkers:function(storageArray){storageArray=storageArray||[];for(var i=this._childClusters.length-1;i>=0;i--)this._childClusters[i].getAllChildMarkers(storageArray);for(var j=this._markers.length-1;j>=0;j--)storageArray.push(this._markers[j]);return storageArray},getChildCount:function(){return this._childCount},zoomToBounds:function(fitBoundsOptions){for(var i,childClusters=this._childClusters.slice(),map=this._group._map,boundsZoom=map.getBoundsZoom(this._bounds),zoom=this._zoom+1,mapZoom=map.getZoom();childClusters.length>0&&boundsZoom>zoom;){zoom++;var newClusters=[];for(i=0;i<childClusters.length;i++)newClusters=newClusters.concat(childClusters[i]._childClusters);childClusters=newClusters}boundsZoom>zoom?this._group._map.setView(this._latlng,zoom):boundsZoom<=mapZoom?this._group._map.setView(this._latlng,mapZoom+1):this._group._map.fitBounds(this._bounds,fitBoundsOptions)},getBounds:function(){var bounds=new L.LatLngBounds;return bounds.extend(this._bounds),bounds},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(new1,isNotificationFromChild){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(new1),new1 instanceof L.MarkerCluster?(isNotificationFromChild||(this._childClusters.push(new1),new1.__parent=this),this._childCount+=new1._childCount):(isNotificationFromChild||this._markers.push(new1),this._childCount++),this.__parent&&this.__parent._addChild(new1,!0)},_setClusterCenter:function(child){this._cLatLng||(this._cLatLng=child._cLatLng||child._latlng)},_resetBounds:function(){var bounds=this._bounds;bounds._southWest&&(bounds._southWest.lat=1/0,bounds._southWest.lng=1/0),bounds._northEast&&(bounds._northEast.lat=-1/0,bounds._northEast.lng=-1/0)},_recalculateBounds:function(){var i,child,childLatLng,childCount,markers=this._markers,childClusters=this._childClusters,latSum=0,lngSum=0,totalCount=this._childCount;if(0!==totalCount){for(this._resetBounds(),i=0;i<markers.length;i++)childLatLng=markers[i]._latlng,this._bounds.extend(childLatLng),latSum+=childLatLng.lat,lngSum+=childLatLng.lng;for(i=0;i<childClusters.length;i++)child=childClusters[i],child._boundsNeedUpdate&&child._recalculateBounds(),this._bounds.extend(child._bounds),childLatLng=child._wLatLng,childCount=child._childCount,latSum+=childLatLng.lat*childCount,lngSum+=childLatLng.lng*childCount;this._latlng=this._wLatLng=new L.LatLng(latSum/totalCount,lngSum/totalCount),this._boundsNeedUpdate=!1}},_addToMap:function(startPos){startPos&&(this._backupLatlng=this._latlng,this.setLatLng(startPos)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(bounds,center,maxZoom){this._recursively(bounds,this._group._map.getMinZoom(),maxZoom-1,function(c){var i,m,markers=c._markers;for(i=markers.length-1;i>=0;i--)m=markers[i],m._icon&&(m._setPos(center),m.clusterHide())},function(c){var j,cm,childClusters=c._childClusters;for(j=childClusters.length-1;j>=0;j--)cm=childClusters[j],cm._icon&&(cm._setPos(center),cm.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(bounds,mapMinZoom,previousZoomLevel,newZoomLevel){this._recursively(bounds,newZoomLevel,mapMinZoom,function(c){c._recursivelyAnimateChildrenIn(bounds,c._group._map.latLngToLayerPoint(c.getLatLng()).round(),previousZoomLevel),c._isSingleParent()&&previousZoomLevel-1===newZoomLevel?(c.clusterShow(),c._recursivelyRemoveChildrenFromMap(bounds,mapMinZoom,previousZoomLevel)):c.clusterHide(),c._addToMap()})},_recursivelyBecomeVisible:function(bounds,zoomLevel){this._recursively(bounds,this._group._map.getMinZoom(),zoomLevel,null,function(c){c.clusterShow()})},_recursivelyAddChildrenToMap:function(startPos,zoomLevel,bounds){this._recursively(bounds,this._group._map.getMinZoom()-1,zoomLevel,function(c){if(zoomLevel!==c._zoom)for(var i=c._markers.length-1;i>=0;i--){var nm=c._markers[i];bounds.contains(nm._latlng)&&(startPos&&(nm._backupLatlng=nm.getLatLng(),nm.setLatLng(startPos),nm.clusterHide&&nm.clusterHide()),c._group._featureGroup.addLayer(nm))}},function(c){c._addToMap(startPos)})},_recursivelyRestoreChildPositions:function(zoomLevel){for(var i=this._markers.length-1;i>=0;i--){var nm=this._markers[i];nm._backupLatlng&&(nm.setLatLng(nm._backupLatlng),delete nm._backupLatlng)}if(zoomLevel-1===this._zoom)for(var j=this._childClusters.length-1;j>=0;j--)this._childClusters[j]._restorePosition();else for(var k=this._childClusters.length-1;k>=0;k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(previousBounds,mapMinZoom,zoomLevel,exceptBounds){var m,i;this._recursively(previousBounds,mapMinZoom-1,zoomLevel-1,function(c){for(i=c._markers.length-1;i>=0;i--)m=c._markers[i],exceptBounds&&exceptBounds.contains(m._latlng)||(c._group._featureGroup.removeLayer(m),m.clusterShow&&m.clusterShow())},function(c){for(i=c._childClusters.length-1;i>=0;i--)m=c._childClusters[i],exceptBounds&&exceptBounds.contains(m._latlng)||(c._group._featureGroup.removeLayer(m),m.clusterShow&&m.clusterShow())})},_recursively:function(boundsToApplyTo,zoomLevelToStart,zoomLevelToStop,runAtEveryLevel,runAtBottomLevel){var i,c,childClusters=this._childClusters,zoom=this._zoom;if(zoomLevelToStart<=zoom&&(runAtEveryLevel&&runAtEveryLevel(this),runAtBottomLevel&&zoom===zoomLevelToStop&&runAtBottomLevel(this)),zoom<zoomLevelToStart||zoom<zoomLevelToStop)for(i=childClusters.length-1;i>=0;i--)c=childClusters[i],boundsToApplyTo.intersects(c._bounds)&&c._recursively(boundsToApplyTo,zoomLevelToStart,zoomLevelToStop,runAtEveryLevel,runAtBottomLevel)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}});L.Marker.include({clusterHide:function(){return this.options.opacityWhenUnclustered=this.options.opacity||1,this.setOpacity(0)},clusterShow:function(){var ret=this.setOpacity(this.options.opacity||this.options.opacityWhenUnclustered);return delete this.options.opacityWhenUnclustered,ret}}),L.DistanceGrid=function(cellSize){this._cellSize=cellSize,this._sqCellSize=cellSize*cellSize,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(obj,point){var x=this._getCoord(point.x),y=this._getCoord(point.y),grid=this._grid,row=grid[y]=grid[y]||{},cell=row[x]=row[x]||[],stamp=L.Util.stamp(obj);this._objectPoint[stamp]=point,cell.push(obj)},updateObject:function(obj,point){this.removeObject(obj),this.addObject(obj,point)},removeObject:function(obj,point){var i,len,x=this._getCoord(point.x),y=this._getCoord(point.y),grid=this._grid,row=grid[y]=grid[y]||{},cell=row[x]=row[x]||[];for(delete this._objectPoint[L.Util.stamp(obj)],i=0,len=cell.length;i<len;i++)if(cell[i]===obj)return cell.splice(i,1),1===len&&delete row[x],!0},eachObject:function(fn,context){var i,j,k,len,row,cell,grid=this._grid;for(i in grid){row=grid[i];for(j in row)for(cell=row[j],k=0,len=cell.length;k<len;k++)fn.call(context,cell[k])&&(k--,len--)}},getNearObject:function(point){var i,j,k,row,cell,len,obj,dist,x=this._getCoord(point.x),y=this._getCoord(point.y),objectPoint=this._objectPoint,closestDistSq=this._sqCellSize,closest=null;for(i=y-1;i<=y+1;i++)if(row=this._grid[i])for(j=x-1;j<=x+1;j++)if(cell=row[j])for(k=0,len=cell.length;k<len;k++)obj=cell[k],((dist=this._sqDist(objectPoint[L.Util.stamp(obj)],point))<closestDistSq||dist<=closestDistSq&&null===closest)&&(closestDistSq=dist,closest=obj);return closest},_getCoord:function(x){var coord=Math.floor(x/this._cellSize);return isFinite(coord)?coord:x},_sqDist:function(p,p2){var dx=p2.x-p.x,dy=p2.y-p.y;return dx*dx+dy*dy}},function(){L.QuickHull={getDistant:function(cpt,bl){var vY=bl[1].lat-bl[0].lat;return(bl[0].lng-bl[1].lng)*(cpt.lat-bl[0].lat)+vY*(cpt.lng-bl[0].lng)},findMostDistantPointFromBaseLine:function(baseLine,latLngs){var i,pt,d,maxD=0,maxPt=null,newPoints=[];for(i=latLngs.length-1;i>=0;i--)pt=latLngs[i],(d=this.getDistant(pt,baseLine))>0&&(newPoints.push(pt),d>maxD&&(maxD=d,maxPt=pt));return{maxPoint:maxPt,newPoints:newPoints}},buildConvexHull:function(baseLine,latLngs){var convexHullBaseLines=[],t=this.findMostDistantPointFromBaseLine(baseLine,latLngs);return t.maxPoint?(convexHullBaseLines=convexHullBaseLines.concat(this.buildConvexHull([baseLine[0],t.maxPoint],t.newPoints)),convexHullBaseLines=convexHullBaseLines.concat(this.buildConvexHull([t.maxPoint,baseLine[1]],t.newPoints))):[baseLine[0]]},getConvexHull:function(latLngs){var i,maxLat=!1,minLat=!1,maxLng=!1,minLng=!1,maxLatPt=null,minLatPt=null,maxLngPt=null,minLngPt=null,maxPt=null,minPt=null;for(i=latLngs.length-1;i>=0;i--){var pt=latLngs[i];(!1===maxLat||pt.lat>maxLat)&&(maxLatPt=pt,maxLat=pt.lat),(!1===minLat||pt.lat<minLat)&&(minLatPt=pt,minLat=pt.lat),(!1===maxLng||pt.lng>maxLng)&&(maxLngPt=pt,maxLng=pt.lng),(!1===minLng||pt.lng<minLng)&&(minLngPt=pt,minLng=pt.lng)}return minLat!==maxLat?(minPt=minLatPt,maxPt=maxLatPt):(minPt=minLngPt,maxPt=maxLngPt),[].concat(this.buildConvexHull([minPt,maxPt],latLngs),this.buildConvexHull([maxPt,minPt],latLngs))}}}(),L.MarkerCluster.include({getConvexHull:function(){var p,i,childMarkers=this.getAllChildMarkers(),points=[];for(i=childMarkers.length-1;i>=0;i--)p=childMarkers[i].getLatLng(),points.push(p);return L.QuickHull.getConvexHull(points)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:0,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var positions,childMarkers=this.getAllChildMarkers(),group=this._group,map=group._map,center=map.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,childMarkers.length>=this._circleSpiralSwitchover?positions=this._generatePointsSpiral(childMarkers.length,center):(center.y+=10,positions=this._generatePointsCircle(childMarkers.length,center)),this._animationSpiderfy(childMarkers,positions)}},unspiderfy:function(zoomDetails){this._group._inZoomAnimation||(this._animationUnspiderfy(zoomDetails),this._group._spiderfied=null)},_generatePointsCircle:function(count,centerPt){var i,angle,circumference=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+count),legLength=circumference/this._2PI,angleStep=this._2PI/count,res=[];for(legLength=Math.max(legLength,35),res.length=count,i=0;i<count;i++)angle=this._circleStartAngle+i*angleStep,res[i]=new L.Point(centerPt.x+legLength*Math.cos(angle),centerPt.y+legLength*Math.sin(angle))._round();return res},_generatePointsSpiral:function(count,centerPt){var i,spiderfyDistanceMultiplier=this._group.options.spiderfyDistanceMultiplier,legLength=spiderfyDistanceMultiplier*this._spiralLengthStart,separation=spiderfyDistanceMultiplier*this._spiralFootSeparation,lengthFactor=spiderfyDistanceMultiplier*this._spiralLengthFactor*this._2PI,angle=0,res=[];for(res.length=count,i=count;i>=0;i--)i<count&&(res[i]=new L.Point(centerPt.x+legLength*Math.cos(angle),centerPt.y+legLength*Math.sin(angle))._round()),angle+=separation/legLength+5e-4*i,legLength+=lengthFactor/angle;return res},_noanimationUnspiderfy:function(){var m,i,group=this._group,map=group._map,fg=group._featureGroup,childMarkers=this.getAllChildMarkers();for(group._ignoreMove=!0,this.setOpacity(1),i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],fg.removeLayer(m),m._preSpiderfyLatlng&&(m.setLatLng(m._preSpiderfyLatlng),delete m._preSpiderfyLatlng),m.setZIndexOffset&&m.setZIndexOffset(0),m._spiderLeg&&(map.removeLayer(m._spiderLeg),delete m._spiderLeg);group.fire("unspiderfied",{cluster:this,markers:childMarkers}),group._ignoreMove=!1,group._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(childMarkers,positions){var i,m,leg,newPos,group=this._group,map=group._map,fg=group._featureGroup,legOptions=this._group.options.spiderLegPolylineOptions;for(group._ignoreMove=!0,i=0;i<childMarkers.length;i++)newPos=map.layerPointToLatLng(positions[i]),m=childMarkers[i],leg=new L.Polyline([this._latlng,newPos],legOptions),map.addLayer(leg),m._spiderLeg=leg,m._preSpiderfyLatlng=m._latlng,m.setLatLng(newPos),m.setZIndexOffset&&m.setZIndexOffset(1e6),fg.addLayer(m);this.setOpacity(.3),group._ignoreMove=!1,group.fire("spiderfied",{cluster:this,markers:childMarkers})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(childMarkers,positions){var i,m,leg,legPath,legLength,newPos,me=this,group=this._group,map=group._map,fg=group._featureGroup,thisLayerLatLng=this._latlng,thisLayerPos=map.latLngToLayerPoint(thisLayerLatLng),svg=L.Path.SVG,legOptions=L.extend({},this._group.options.spiderLegPolylineOptions),finalLegOpacity=legOptions.opacity;for(void 0===finalLegOpacity&&(finalLegOpacity=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),svg?(legOptions.opacity=0,legOptions.className=(legOptions.className||"")+" leaflet-cluster-spider-leg"):legOptions.opacity=finalLegOpacity,group._ignoreMove=!0,i=0;i<childMarkers.length;i++)m=childMarkers[i],newPos=map.layerPointToLatLng(positions[i]),leg=new L.Polyline([thisLayerLatLng,newPos],legOptions),map.addLayer(leg),m._spiderLeg=leg,svg&&(legPath=leg._path,legLength=legPath.getTotalLength()+.1,legPath.style.strokeDasharray=legLength,legPath.style.strokeDashoffset=legLength),m.setZIndexOffset&&m.setZIndexOffset(1e6),m.clusterHide&&m.clusterHide(),fg.addLayer(m),m._setPos&&m._setPos(thisLayerPos);for(group._forceLayout(),group._animationStart(),i=childMarkers.length-1;i>=0;i--)newPos=map.layerPointToLatLng(positions[i]),m=childMarkers[i],m._preSpiderfyLatlng=m._latlng,m.setLatLng(newPos),m.clusterShow&&m.clusterShow(),svg&&(leg=m._spiderLeg,legPath=leg._path,legPath.style.strokeDashoffset=0,leg.setStyle({opacity:finalLegOpacity}));this.setOpacity(.3),group._ignoreMove=!1,setTimeout(function(){group._animationEnd(),group.fire("spiderfied",{cluster:me,markers:childMarkers})},200)},_animationUnspiderfy:function(zoomDetails){var m,i,leg,legPath,legLength,nonAnimatable,me=this,group=this._group,map=group._map,fg=group._featureGroup,thisLayerPos=zoomDetails?map._latLngToNewLayerPoint(this._latlng,zoomDetails.zoom,zoomDetails.center):map.latLngToLayerPoint(this._latlng),childMarkers=this.getAllChildMarkers(),svg=L.Path.SVG;for(group._ignoreMove=!0,group._animationStart(),this.setOpacity(1),i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._preSpiderfyLatlng&&(m.closePopup(),m.setLatLng(m._preSpiderfyLatlng),delete m._preSpiderfyLatlng,nonAnimatable=!0,m._setPos&&(m._setPos(thisLayerPos),nonAnimatable=!1),m.clusterHide&&(m.clusterHide(),nonAnimatable=!1),nonAnimatable&&fg.removeLayer(m),svg&&(leg=m._spiderLeg,legPath=leg._path,legLength=legPath.getTotalLength()+.1,legPath.style.strokeDashoffset=legLength,leg.setStyle({opacity:0})));group._ignoreMove=!1,setTimeout(function(){var stillThereChildCount=0;for(i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._spiderLeg&&stillThereChildCount++;for(i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._spiderLeg&&(m.clusterShow&&m.clusterShow(),m.setZIndexOffset&&m.setZIndexOffset(0),stillThereChildCount>1&&fg.removeLayer(m),map.removeLayer(m._spiderLeg),delete m._spiderLeg);group._animationEnd(),group.fire("unspiderfied",{cluster:me,markers:childMarkers})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(zoomDetails){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(zoomDetails))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(zoomDetails){this._spiderfied&&this._spiderfied.unspiderfy(zoomDetails)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(layer){layer._spiderLeg&&(this._featureGroup.removeLayer(layer),layer.clusterShow&&layer.clusterShow(),layer.setZIndexOffset&&layer.setZIndexOffset(0),this._map.removeLayer(layer._spiderLeg),delete layer._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(layers){return layers?layers instanceof L.MarkerClusterGroup?layers=layers._topClusterLevel.getAllChildMarkers():layers instanceof L.LayerGroup?layers=layers._layers:layers instanceof L.MarkerCluster?layers=layers.getAllChildMarkers():layers instanceof L.Marker&&(layers=[layers]):layers=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(layers),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(layers),this},_flagParentsIconsNeedUpdate:function(layers){var id,parent;for(id in layers)for(parent=layers[id].__parent;parent;)parent._iconNeedsUpdate=!0,parent=parent.__parent},_refreshSingleMarkerModeMarkers:function(layers){var id,layer;for(id in layers)layer=layers[id],this.hasLayer(layer)&&layer.setIcon(this._overrideMarkerIcon(layer))}}),L.Marker.include({refreshIconOptions:function(options,directlyRefreshClusters){var icon=this.options.icon;return L.setOptions(icon,options),this.setIcon(icon),directlyRefreshClusters&&this.__parent&&this.__parent._group.refreshClusters(this),this}}),exports.MarkerClusterGroup=MarkerClusterGroup,exports.MarkerCluster=MarkerCluster})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function serverCluster(options){return new ServerCluster(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ServerCluster=void 0,exports.default=serverCluster;var _d3Scale=__webpack_require__(30),_ClusterMarker=__webpack_require__(151),_ClusterMarker2=_interopRequireDefault(_ClusterMarker),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),ServerCluster=exports.ServerCluster=L.GridLayer.extend({options:{pane:"markerPane",tileSize:512,clusterSize:110,color:"red",opacity:1,domain:[1,1e4],range:[16,40]},initialize:function(opts){var options=L.setOptions(this,opts);this._clusters=L.featureGroup(),this._tileClusters={},this._scale=(0,_d3Scale.scaleLog)().base(Math.E).domain(options.domain).range(options.range).clamp(!0),this._clusters.on("click",this.onClusterClick,this),this._bounds=options.bounds},onAdd:function(map){this._levels={},this._tiles={},this._resetView(),this._update(),map.addLayer(this._clusters),map.on("zoomstart",this._onZoomStart,this)},onRemove:function(map){this._clusters.clearLayers(),map.removeLayer(this._clusters),map.off("zoomstart",this._onZoomStart,this)},createTile:function(coords){var _this=this,tileId=this._tileCoordsToKey(coords),clusters=this._tileClusters[tileId];if(clusters)return void clusters.forEach(function(cluster){return _this._clusters.addLayer(cluster)});var options=this.options,map=this._map,bounds=this._tileCoordsToBounds(coords),params={tileId:tileId,bbox:bounds.toBBoxString(),clusterSize:Math.round(this.getResolution(coords.z)*options.clusterSize),includeClusterPoints:map.getZoom()===map.getMaxZoom()};options.load&&this._isWithinWorldBounds(bounds)&&options.load(params,L.bind(this.addClusters,this),this)},_addTile:function(coords){var key=this._tileCoordsToKey(coords);this._tiles[key]={coords:coords,current:!0},this.createTile(this._wrapCoords(coords)),this.fire("tileloadstart",{key:key,coords:coords})},onClusterClick:function(evt){var marker=evt.layer,map=this._map;marker.getBounds?map.getZoom()!==map.getMaxZoom()?map.fitBounds(marker.getBounds()):(this._spider&&this._spider.unspiderify(),this._spider=marker.spiderify()):this.options.popup&&marker.showPopup()},addClusters:function(tileId,clusters){var _this2=this,tileClusters=[];clusters.forEach(function(d){var cluster=_this2.createCluster(d);_this2._tiles[tileId]&&_this2._clusters.addLayer(cluster),tileClusters.push(cluster)}),this._tileClusters[tileId]=tileClusters},createCluster:function(feature){var marker=void 0;return 1===feature.properties.count?marker=(0,_CircleMarker2.default)(feature,this.options):(feature.properties.size=this._scale(feature.properties.count),marker=(0,_ClusterMarker2.default)(feature,this.options)),marker},getResolution:function(zoom){return Math.PI*L.Projection.SphericalMercator.R*2/256/Math.pow(2,zoom)},getBounds:function(){return this._bounds?L.latLngBounds(this._bounds):this._clusters.getBounds()},setOpacity:function(opacity){var tileClusters=this._tileClusters,tileId=void 0,layer=void 0;for(tileId in tileClusters)if(tileClusters.hasOwnProperty(tileId)){var _iteratorNormalCompletion=!0,_didIteratorError=!1,_iteratorError=void 0;try{for(var _step,_iterator=tileClusters[tileId][Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=!0)layer=_step.value,layer.setOpacity(opacity)}catch(err){_didIteratorError=!0,_iteratorError=err}finally{try{!_iteratorNormalCompletion&&_iterator.return&&_iterator.return()}finally{if(_didIteratorError)throw _iteratorError}}}this.options.opacity=opacity},_removeTile:function(key){var _this3=this;if(this._tiles[key]){var clusters=this._tileClusters[key];clusters&&clusters.forEach(function(layer){return _this3._clusters.removeLayer(layer)}),delete this._tiles[key],this.fire("tileunload",{tileId:key,coords:this._keyToTileCoords(key)})}},_onZoomStart:function(){this._clusters.clearLayers()},_animateZoom:function(){},_isWithinWorldBounds:function(bounds){return bounds.getWest()>=-180&&bounds.getEast()<=180&&bounds.getSouth()>=-90&&bounds.getNorth()<=90}})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function clusterMarker(feature,options){return new ClusterMarker(feature,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClusterMarker=void 0,exports.default=clusterMarker;var _ClusterIcon=__webpack_require__(28),_ClusterIcon2=_interopRequireDefault(_ClusterIcon),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),ClusterMarker=exports.ClusterMarker=L.Marker.extend({initialize:function(feature,options){this._feature=feature,this._latlng=L.GeoJSON.coordsToLatLng(feature.geometry.coordinates),options.icon=(0,_ClusterIcon2.default)({size:feature.properties.size,count:feature.properties.count,color:options.color}),L.setOptions(this,options)},getFeature:function(){return this._feature},getBounds:function(){return this._feature.properties.bounds},spiderify:function(){if(!this._spiderified){var feature=this._feature,options=this.options,map=this._map,latlng=this.getLatLng(),center=map.latLngToLayerPoint(latlng),ids=(this._feature.id||"").split(","),count=feature.properties.count,legOptions={weight:1.5,color:"#222",opacity:.5},_2PI=2*Math.PI,circumference=13*(2+count),startAngle=Math.PI/6,legLength=circumference/_2PI,angleStep=_2PI/count;this._spiderLegs=L.featureGroup(),this._spiderMarkers=L.featureGroup(),this._spiderMarkers.on("click",this.onSpiderMarkerClick,this);for(var angle,point,id,newPos,i=count-1;i>=0;i--)angle=startAngle+i*angleStep,point=L.point(center.x+legLength*Math.cos(angle),center.y+legLength*Math.sin(angle))._round(),id=ids[i],newPos=map.layerPointToLatLng(point),this._spiderLegs.addLayer(L.polyline([latlng,newPos],legOptions)),this._spiderMarkers.addLayer((0,_CircleMarker2.default)({id:id,type:"Feature",geometry:{type:"Point",coordinates:[newPos.lng,newPos.lat]}},this.options));this._spiderLegs.addTo(map),this._spiderMarkers.addTo(map),this._originalOpacity=options.opacity,this.setOpacity(.1),this._spiderified=!0}return this},unspiderify:function(){var map=this._map;return this.setOpacity(this._originalOpacity),this._spiderLegs&&map.hasLayer(this._spiderLegs)&&map.removeLayer(this._spiderLegs),this._spiderMarkers&&map.hasLayer(this._spiderMarkers)&&(map.removeLayer(this._spiderMarkers),this._spiderMarkers.off("click",this.onSpiderMarkerClick,this)),this._spiderified=!1,this},onSpiderMarkerClick:function(evt){evt.layer.showPopup()},onRemove:function(map){this._spiderified&&this.unspiderify(),L.Marker.prototype.onRemove.call(this,map)}})},function(module,exports,__webpack_require__){"use strict";function earthEngine(options){return new EarthEngine(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=earthEngine;var EarthEngine=exports.EarthEngine=L.LayerGroup.extend({options:{url:"https://earthengine.googleapis.com/map/{mapid}/{z}/{x}/{y}?token={token}",tokenType:"Bearer",aggregation:"none",popup:"{name}: {value} {unit}"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};L.setOptions(this,options),this._layers={},this._legend=options.legend||this.createLegend()},onAdd:function(){this.getAuthToken(this.onValidAuthToken.bind(this))},onRemove:function(map){this._popup&&map.closePopup(this._popup),L.GeoJSON.prototype.onRemove.call(this,map)},getAuthToken:function(callback){var accessToken=this.options.accessToken;accessToken&&(accessToken instanceof Function?accessToken(callback):callback(accessToken))},onValidAuthToken:function(token){var _this=this;ee.data.setAuthToken(token.client_id,this.options.tokenType,token.access_token,token.expires_in,null,null,!1),ee.data.setAuthTokenRefresher(this.refreshAccessToken.bind(this)),ee.initialize(null,null,function(){_this.createImage(),_this.fire("initialized")})},refreshAccessToken:function(authArgs,callback){var self=this;this.getAuthToken(function(token){callback({token_type:self.options.tokenType,access_token:token.access_token,state:authArgs.scope,expires_in:token.expires_in})})},createImage:function(){var options=this.options,eeCollection=void 0,eeImage=void 0;options.filter?(eeCollection=ee.ImageCollection(options.id),eeCollection=this.applyFilter(eeCollection),"mosaic"===options.aggregation?(this.eeCollection=eeCollection,eeImage=eeCollection.mosaic()):eeImage=ee.Image(eeCollection.first())):eeImage=ee.Image(options.id),options.band&&(eeImage=eeImage.select(options.band)),options.mask&&(eeImage=eeImage.updateMask(eeImage.gt(0))),eeImage=this.runMethods(eeImage),this.eeImage=eeImage,options.legend||(eeImage=this.classifyImage(eeImage)),this.addLayer(this.visualize(eeImage))},addLayer:function(eeImage){var _this2=this;eeImage.getMap(null,function(eeMap){var layer=L.tileLayer(_this2.options.url,L.extend({token:eeMap.token,mapid:eeMap.mapid},_this2.options));L.LayerGroup.prototype.addLayer.call(_this2,layer)})},applyFilter:function(collection,filterOpt){var _this3=this,filter=filterOpt||this.options.filter;return filter&&filter.forEach(function(item){collection=collection.filter(ee.Filter[item.type].apply(_this3,item.arguments))}),collection},runMethods:function(image){var methods=this.options.methods,eeImage=image;return methods&&Object.keys(methods).forEach(function(method){eeImage[method]&&(eeImage=eeImage[method].apply(eeImage,methods[method]))}),eeImage},classifyImage:function(eeImage){for(var item,legend=this._legend,zones=void 0,i=0;i<legend.length-1;i++)item=legend[i],zones=zones?zones.add(eeImage.gt(item.to)):eeImage.gt(item.to);return zones},visualize:function(eeImage){var options=this.options;return eeImage.visualize(options.legend?options.params:{min:0,max:this._legend.length-1,palette:options.params.palette})},createLegend:function(){var params=this.options.params,min=params.min,max=params.max,palette=params.palette.split(","),step=(params.max-min)/(palette.length-(min>0?2:1)),from=min,to=Math.round(min+step);return palette.map(function(color,index){var item={color:color};return 0===index&&min>0?(item.from=0,item.to=min,item.name="< "+item.to,to=min):from<max?(item.from=from,item.to=to,item.name=item.from+" - "+item.to):(item.from=from,item.name="> "+item.from),from=to,to=Math.round(min+step*(index+(min>0?1:2))),item})},getLegend:function(){var options=this.options,legend='<div class="dhis2-legend">';legend+="<h2>"+options.name,options.image&&(legend+=" "+options.image),legend+="</h2>",options.description&&(legend+="<p>"+options.description+"</p>"),legend+="<dl>",options.unit&&(legend+="<dt></dt><dd><strong>"+options.unit+"</strong></dd>");for(var item,i=0;i<this._legend.length;i++)item=this._legend[i],legend+='<dt style="background-color:'+item.color+';box-shadow:1px 1px 2px #aaa;"></dt>',legend+="<dd>"+item.name;return legend+="</dl>",options.attribution&&(legend+="<p>Data: "+options.attribution+"</p>"),legend+="<div>"},setOpacity:function(opacity){this.options.opacity=opacity,this.eachLayer(function(layer){return layer.setOpacity(opacity)})},getValue:function(latlng,callback){var point=ee.Geometry.Point(latlng.lng,latlng.lat),options=this.options,dictionary=void 0;dictionary="mosaic"===options.aggregation?this.eeImage.reduceRegion(ee.Reducer.mean(),point,options.resolution,options.projection):this.eeImage.reduceRegion(ee.Reducer.mean(),point),dictionary.getInfo(function(valueObj){var band=options.band||Object.keys(valueObj)[0],value=valueObj[band];options.legend&&options.legend[value]?value=options.legend[value].name:options.value&&(value=options.value(value)),callback(value)})},showValue:function(latlng){var _this4=this,options=this.options;this.getValue(latlng,function(value){_this4._popup=L.popup().setLatLng(latlng).setContent(L.Util.template(options.popup,L.extend({},options,{value:value}))).openOn(_this4._map)})}})},function(module,exports,__webpack_require__){"use strict";function legend(options){return new Legend(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=legend;var Legend=exports.Legend=L.Control.extend({options:{position:"topright",collapsed:!0,offset:[0,0]},initialize:function(opts){var options=L.setOptions(this,opts);this._content=options.content||"",this._handlingClick=!1},onAdd:function(map){return this._initLayout(),this._map=map,this._container},setContent:function(content){this._legend.innerHTML=content,this._content=content},getContent:function(){return this._content},_initLayout:function(){var className="leaflet-control-legend",container=this._container=L.DomUtil.create("div",className);if(container.setAttribute("aria-haspopup",!0),L.DomEvent.disableClickPropagation(container),L.Browser.touch||L.DomEvent.disableScrollPropagation(container),this.options.collapsed){L.Browser.android||L.DomEvent.on(container,{mouseenter:this._expand,mouseleave:this._collapse},this);var link=this._legendLink=L.DomUtil.create("a",className+"-toggle",container);link.href="#",link.title="Legend",L.Browser.touch?L.DomEvent.on(link,"click",L.DomEvent.stop).on(link,"click",this._expand,this):L.DomEvent.on(link,"focus",this._expand,this),this._map.on("click",this._collapse,this)}else this._expand();this._legend=L.DomUtil.create("div",className+"-content",container),this.setContent(this._content)},_expand:function(){var offset=L.point(this.options.offset);L.DomUtil.addClass(this._container,"leaflet-control-legend-expanded"),this._container.style.left=offset.x+"px",this._container.style.top=offset.y+"px"},_collapse:function(){L.DomUtil.removeClass(this._container,"leaflet-control-legend-expanded"),this._container.style.left=0,this._container.style.top=0}})},function(module,exports,__webpack_require__){"use strict";function fitBounds(options){return new FitBounds(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=fitBounds;var FitBounds=exports.FitBounds=L.Control.extend({options:{position:"topleft"},onAdd:function(map){return this._map=map,this._initLayout(),this._toggleControl(map.getLayersBounds().isValid()),map.on("layeradd",this._onLayerChange,this),map.on("layerremove",this._onLayerChange,this),this._container},onRemove:function(map){map.off("layeradd",this._onLayerChange,this),map.off("layerremove",this._onLayerChange,this),L.Control.prototype.onRemove.call(this,map)},_initLayout:function(){var container=this._container=L.DomUtil.create("div","leaflet-control-fit-bounds");L.DomEvent.disableClickPropagation(container),L.Browser.touch||L.DomEvent.disableScrollPropagation(container),container.title="Zoom to content",L.DomEvent.on(container,"click",this._onClick,this)},_onClick:function(){var bounds=this._map.getLayersBounds();bounds.isValid()&&this._map.fitBounds(bounds)},_onLayerChange:function(evt){evt.layer instanceof L.FeatureGroup&&this._toggleControl(this._map.getLayersBounds().isValid())},_toggleControl:function(isValidBounds){this._container.style.display=isValidBounds?"block":"none"}})},function(module,exports,__webpack_require__){"use strict";function search(options){return new Search(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Search=void 0,exports.default=search,__webpack_require__(156);var Search=exports.Search=L.Control.Geocoder.extend({})},function(module,exports,__webpack_require__){(function(global){var require,require;!function(f){module.exports=f()}(function(){return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n||e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Nominatim=_dereq_("./geocoders/nominatim").class;module.exports={class:L.Control.extend({options:{showResultIcons:!1,collapsed:!0,expand:"touch",position:"topright",placeholder:"Search...",errorMessage:"Nothing found.",suggestMinLength:3,suggestTimeout:250,defaultMarkGeocode:!0},includes:L.Evented.prototype||L.Mixin.Events,initialize:function(options){L.Util.setOptions(this,options),this.options.geocoder||(this.options.geocoder=new Nominatim),this._requestCount=0},onAdd:function(map){var input,className="leaflet-control-geocoder",container=L.DomUtil.create("div",className+" leaflet-bar"),icon=L.DomUtil.create("button",className+"-icon",container),form=this._form=L.DomUtil.create("div",className+"-form",container);return this._map=map,this._container=container,icon.innerHTML="&nbsp;",icon.type="button",input=this._input=L.DomUtil.create("input","",form),input.type="text",input.placeholder=this.options.placeholder,this._errorElement=L.DomUtil.create("div",className+"-form-no-error",container),this._errorElement.innerHTML=this.options.errorMessage,this._alts=L.DomUtil.create("ul",className+"-alternatives leaflet-control-geocoder-alternatives-minimized",container),L.DomEvent.disableClickPropagation(this._alts),L.DomEvent.addListener(input,"keydown",this._keydown,this),this.options.geocoder.suggest&&L.DomEvent.addListener(input,"input",this._change,this),L.DomEvent.addListener(input,"blur",function(){this.options.collapsed&&!this._preventBlurCollapse&&this._collapse(),this._preventBlurCollapse=!1},this),this.options.collapsed?"click"===this.options.expand?L.DomEvent.addListener(container,"click",function(e){0===e.button&&2!==e.detail&&this._toggle()},this):L.Browser.touch&&"touch"===this.options.expand?L.DomEvent.addListener(container,"touchstart mousedown",function(e){this._toggle(),e.preventDefault(),e.stopPropagation()},this):(L.DomEvent.addListener(container,"mouseover",this._expand,this),L.DomEvent.addListener(container,"mouseout",this._collapse,this),this._map.on("movestart",this._collapse,this)):(this._expand(),L.Browser.touch?L.DomEvent.addListener(container,"touchstart",function(e){this._geocode(e)},this):L.DomEvent.addListener(container,"click",function(e){this._geocode(e)},this)),this.options.defaultMarkGeocode&&this.on("markgeocode",this.markGeocode,this),this.on("startgeocode",function(){L.DomUtil.addClass(this._container,"leaflet-control-geocoder-throbber")},this),this.on("finishgeocode",function(){L.DomUtil.removeClass(this._container,"leaflet-control-geocoder-throbber")},this),L.DomEvent.disableClickPropagation(container),container},_geocodeResult:function(results,suggest){if(suggest||1!==results.length)if(results.length>0){this._alts.innerHTML="",this._results=results,L.DomUtil.removeClass(this._alts,"leaflet-control-geocoder-alternatives-minimized");for(var i=0;i<results.length;i++)this._alts.appendChild(this._createAlt(results[i],i))}else L.DomUtil.addClass(this._errorElement,"leaflet-control-geocoder-error");else this._geocodeResultSelected(results[0])},markGeocode:function(result){return result=result.geocode||result,this._map.fitBounds(result.bbox),this._geocodeMarker&&this._map.removeLayer(this._geocodeMarker),this._geocodeMarker=new L.Marker(result.center).bindPopup(result.html||result.name).addTo(this._map).openPopup(),this},_geocode:function(suggest){var requestCount=++this._requestCount,mode=suggest?"suggest":"geocode",eventData={input:this._input.value};this._lastGeocode=this._input.value,suggest||this._clearResults(),this.fire("start"+mode,eventData),this.options.geocoder[mode](this._input.value,function(results){requestCount===this._requestCount&&(eventData.results=results,this.fire("finish"+mode,eventData),this._geocodeResult(results,suggest))},this)},_geocodeResultSelected:function(result){this.fire("markgeocode",{geocode:result})},_toggle:function(){L.DomUtil.hasClass(this._container,"leaflet-control-geocoder-expanded")?this._collapse():this._expand()},_expand:function(){L.DomUtil.addClass(this._container,"leaflet-control-geocoder-expanded"),this._input.select(),this.fire("expand")},_collapse:function(){L.DomUtil.removeClass(this._container,"leaflet-control-geocoder-expanded"),L.DomUtil.addClass(this._alts,"leaflet-control-geocoder-alternatives-minimized"),L.DomUtil.removeClass(this._errorElement,"leaflet-control-geocoder-error"),this._input.blur(),this.fire("collapse")},_clearResults:function(){L.DomUtil.addClass(this._alts,"leaflet-control-geocoder-alternatives-minimized"),this._selection=null,L.DomUtil.removeClass(this._errorElement,"leaflet-control-geocoder-error")},_createAlt:function(result,index){var li=L.DomUtil.create("li",""),a=L.DomUtil.create("a","",li),icon=this.options.showResultIcons&&result.icon?L.DomUtil.create("img","",a):null,text=result.html?void 0:document.createTextNode(result.name),mouseDownHandler=function(e){this._preventBlurCollapse=!0,L.DomEvent.stop(e),this._geocodeResultSelected(result),L.DomEvent.on(li,"click",function(){this.options.collapsed?this._collapse():this._clearResults()},this)};return icon&&(icon.src=result.icon),li.setAttribute("data-result-index",index),result.html?a.innerHTML=a.innerHTML+result.html:a.appendChild(text),L.DomEvent.addListener(li,"mousedown touchstart",mouseDownHandler,this),li},_keydown:function(e){var _this=this,select=function(dir){_this._selection&&(L.DomUtil.removeClass(_this._selection,"leaflet-control-geocoder-selected"),_this._selection=_this._selection[dir>0?"nextSibling":"previousSibling"]),_this._selection||(_this._selection=_this._alts[dir>0?"firstChild":"lastChild"]),_this._selection&&L.DomUtil.addClass(_this._selection,"leaflet-control-geocoder-selected")};switch(e.keyCode){case 27:this.options.collapsed&&this._collapse();break;case 38:select(-1);break;case 40:select(1);break;case 13:if(this._selection){var index=parseInt(this._selection.getAttribute("data-result-index"),10);this._geocodeResultSelected(this._results[index]),this._clearResults()}else this._geocode()}},_change:function(e){var v=this._input.value;v!==this._lastGeocode&&(clearTimeout(this._suggestTimeout),v.length>=this.options.suggestMinLength?this._suggestTimeout=setTimeout(L.bind(function(){this._geocode(!0)},this),this.options.suggestTimeout):this._clearResults())}}),factory:function(options){return new L.Control.Geocoder(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./geocoders/nominatim":9}],2:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{service_url:"http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"},initialize:function(accessToken,options){L.setOptions(this,options),this._accessToken=accessToken},geocode:function(query,cb,context){var params={SingleLine:query,outFields:"Addr_Type",forStorage:!1,maxLocations:10,f:"json"};this._key&&this._key.length&&(params.token=this._key),Util.getJSON(this.options.service_url+"/findAddressCandidates",params,function(data){var loc,latLng,latLngBounds,results=[];if(data.candidates&&data.candidates.length)for(var i=0;i<=data.candidates.length-1;i++)loc=data.candidates[i],latLng=L.latLng(loc.location.y,loc.location.x),latLngBounds=L.latLngBounds(L.latLng(loc.extent.ymax,loc.extent.xmax),L.latLng(loc.extent.ymin,loc.extent.xmin)),results[i]={name:loc.address,bbox:latLngBounds,center:latLng};cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){var params={location:encodeURIComponent(location.lng)+","+encodeURIComponent(location.lat),distance:100,f:"json"};Util.getJSON(this.options.service_url+"/reverseGeocode",params,function(data){var loc,result=[];data&&!data.error&&(loc=L.latLng(data.location.y,data.location.x),result.push({name:data.address.Match_addr,center:loc,bounds:L.latLngBounds(loc,loc)})),cb.call(context,result)})}}),factory:function(accessToken,options){return new L.Control.Geocoder.ArcGis(accessToken,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],3:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({initialize:function(key){this.key=key},geocode:function(query,cb,context){Util.jsonp("https://dev.virtualearth.net/REST/v1/Locations",{query:query,key:this.key},function(data){var results=[];if(data.resourceSets.length>0)for(var i=data.resourceSets[0].resources.length-1;i>=0;i--){var resource=data.resourceSets[0].resources[i],bbox=resource.bbox;results[i]={name:resource.name,bbox:L.latLngBounds([bbox[0],bbox[1]],[bbox[2],bbox[3]]),center:L.latLng(resource.point.coordinates)}}cb.call(context,results)},this,"jsonp")},reverse:function(location,scale,cb,context){Util.jsonp("//dev.virtualearth.net/REST/v1/Locations/"+location.lat+","+location.lng,{key:this.key},function(data){for(var results=[],i=data.resourceSets[0].resources.length-1;i>=0;i--){var resource=data.resourceSets[0].resources[i],bbox=resource.bbox;results[i]={name:resource.name,bbox:L.latLngBounds([bbox[0],bbox[1]],[bbox[2],bbox[3]]),center:L.latLng(resource.point.coordinates)}}cb.call(context,results)},this,"jsonp")}}),factory:function(key){return new L.Control.Geocoder.Bing(key)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],4:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://maps.googleapis.com/maps/api/geocode/json",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(key,options){this._key=key,L.setOptions(this,options),this.options.serviceUrl=this.options.service_url||this.options.serviceUrl},geocode:function(query,cb,context){var params={address:query};this._key&&this._key.length&&(params.key=this._key),params=L.Util.extend(params,this.options.geocodingQueryParams),Util.getJSON(this.options.serviceUrl,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.results&&data.results.length)for(var i=0;i<=data.results.length-1;i++)loc=data.results[i],latLng=L.latLng(loc.geometry.location),latLngBounds=L.latLngBounds(L.latLng(loc.geometry.viewport.northeast),L.latLng(loc.geometry.viewport.southwest)),results[i]={name:loc.formatted_address,bbox:latLngBounds,center:latLng,properties:loc.address_components};cb.call(context,results)})},reverse:function(location,scale,cb,context){var params={latlng:encodeURIComponent(location.lat)+","+encodeURIComponent(location.lng)};params=L.Util.extend(params,this.options.reverseQueryParams),this._key&&this._key.length&&(params.key=this._key),Util.getJSON(this.options.serviceUrl,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.results&&data.results.length)for(var i=0;i<=data.results.length-1;i++)loc=data.results[i],latLng=L.latLng(loc.geometry.location),latLngBounds=L.latLngBounds(L.latLng(loc.geometry.viewport.northeast),L.latLng(loc.geometry.viewport.southwest)),results[i]={name:loc.formatted_address,bbox:latLngBounds,center:latLng,properties:loc.address_components};cb.call(context,results)})}}),factory:function(key,options){return new L.Control.Geocoder.Google(key,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],5:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{geocodeUrl:"http://geocoder.api.here.com/6.2/geocode.json",reverseGeocodeUrl:"http://reverse.geocoder.api.here.com/6.2/reversegeocode.json",app_id:"<insert your app_id here>",app_code:"<insert your app_code here>",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(options){L.setOptions(this,options)},geocode:function(query,cb,context){var params={searchtext:query,gen:9,app_id:this.options.app_id,app_code:this.options.app_code,jsonattributes:1};params=L.Util.extend(params,this.options.geocodingQueryParams),this.getJSON(this.options.geocodeUrl,params,cb,context)},reverse:function(location,scale,cb,context){var params={prox:encodeURIComponent(location.lat)+","+encodeURIComponent(location.lng),mode:"retrieveAddresses",app_id:this.options.app_id,app_code:this.options.app_code,gen:9,jsonattributes:1};params=L.Util.extend(params,this.options.reverseQueryParams),this.getJSON(this.options.reverseGeocodeUrl,params,cb,context)},getJSON:function(url,params,cb,context){Util.getJSON(url,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.response.view&&data.response.view.length)for(var i=0;i<=data.response.view[0].result.length-1;i++)loc=data.response.view[0].result[i].location,latLng=L.latLng(loc.displayPosition.latitude,loc.displayPosition.longitude),latLngBounds=L.latLngBounds(L.latLng(loc.mapView.topLeft.latitude,loc.mapView.topLeft.longitude),L.latLng(loc.mapView.bottomRight.latitude,loc.mapView.bottomRight.longitude)),results[i]={name:loc.address.label,bbox:latLngBounds,center:latLng};cb.call(context,results)})}}),factory:function(options){return new L.Control.Geocoder.HERE(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],6:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://api.tiles.mapbox.com/v4/geocode/mapbox.places-v1/",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(accessToken,options){L.setOptions(this,options),this.options.geocodingQueryParams.access_token=accessToken,this.options.reverseQueryParams.access_token=accessToken},geocode:function(query,cb,context){var params=this.options.geocodingQueryParams;void 0!==params.proximity&&params.proximity.hasOwnProperty("lat")&&params.proximity.hasOwnProperty("lng")&&(params.proximity=params.proximity.lng+","+params.proximity.lat),Util.getJSON(this.options.serviceUrl+encodeURIComponent(query)+".json",params,function(data){var loc,latLng,latLngBounds,results=[];if(data.features&&data.features.length)for(var i=0;i<=data.features.length-1;i++)loc=data.features[i],latLng=L.latLng(loc.center.reverse()),latLngBounds=loc.hasOwnProperty("bbox")?L.latLngBounds(L.latLng(loc.bbox.slice(0,2).reverse()),L.latLng(loc.bbox.slice(2,4).reverse())):L.latLngBounds(latLng,latLng),results[i]={name:loc.place_name,bbox:latLngBounds,center:latLng};cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){Util.getJSON(this.options.serviceUrl+encodeURIComponent(location.lng)+","+encodeURIComponent(location.lat)+".json",this.options.reverseQueryParams,function(data){var loc,latLng,latLngBounds,results=[];if(data.features&&data.features.length)for(var i=0;i<=data.features.length-1;i++)loc=data.features[i],latLng=L.latLng(loc.center.reverse()),latLngBounds=loc.hasOwnProperty("bbox")?L.latLngBounds(L.latLng(loc.bbox.slice(0,2).reverse()),L.latLng(loc.bbox.slice(2,4).reverse())):L.latLngBounds(latLng,latLng),results[i]={name:loc.place_name,bbox:latLngBounds,center:latLng};cb.call(context,results)})}}),factory:function(accessToken,options){return new L.Control.Geocoder.Mapbox(accessToken,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],7:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://www.mapquestapi.com/geocoding/v1"},initialize:function(key,options){this._key=decodeURIComponent(key),L.Util.setOptions(this,options)},_formatName:function(){var i,r=[];for(i=0;i<arguments.length;i++)arguments[i]&&r.push(arguments[i]);return r.join(", ")},geocode:function(query,cb,context){Util.jsonp(this.options.serviceUrl+"/address",{key:this._key,location:query,limit:5,outFormat:"json"},function(data){var loc,latLng,results=[];if(data.results&&data.results[0].locations)for(var i=data.results[0].locations.length-1;i>=0;i--)loc=data.results[0].locations[i],latLng=L.latLng(loc.latLng),results[i]={name:this._formatName(loc.street,loc.adminArea4,loc.adminArea3,loc.adminArea1),bbox:L.latLngBounds(latLng,latLng),center:latLng};cb.call(context,results)},this)},reverse:function(location,scale,cb,context){Util.jsonp(this.options.serviceUrl+"/reverse",{key:this._key,location:location.lat+","+location.lng,outputFormat:"json"},function(data){var loc,latLng,results=[];if(data.results&&data.results[0].locations)for(var i=data.results[0].locations.length-1;i>=0;i--)loc=data.results[0].locations[i],latLng=L.latLng(loc.latLng),results[i]={name:this._formatName(loc.street,loc.adminArea4,loc.adminArea3,loc.adminArea1),bbox:L.latLngBounds(latLng,latLng),center:latLng};cb.call(context,results)},this)}}),factory:function(key,options){return new L.Control.Geocoder.MapQuest(key,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],8:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://search.mapzen.com/v1",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(apiKey,options){L.Util.setOptions(this,options),this._apiKey=apiKey,this._lastSuggest=0},geocode:function(query,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/search",L.extend({api_key:this._apiKey,text:query},this.options.geocodingQueryParams),function(data){cb.call(context,_this._parseResults(data,"bbox"))})},suggest:function(query,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/autocomplete",L.extend({api_key:this._apiKey,text:query},this.options.geocodingQueryParams),L.bind(function(data){data.geocoding.timestamp>this._lastSuggest&&(this._lastSuggest=data.geocoding.timestamp,cb.call(context,_this._parseResults(data,"bbox")))},this))},reverse:function(location,scale,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/reverse",L.extend({api_key:this._apiKey,"point.lat":location.lat,"point.lon":location.lng},this.options.reverseQueryParams),function(data){cb.call(context,_this._parseResults(data,"bounds"))})},_parseResults:function(data,bboxname){var results=[];return L.geoJson(data,{pointToLayer:function(feature,latlng){return L.circleMarker(latlng)},onEachFeature:function(feature,layer){var bbox,center,result={};layer.getBounds?(bbox=layer.getBounds(),center=bbox.getCenter()):(center=layer.getLatLng(),bbox=L.latLngBounds(center,center)),result.name=layer.feature.properties.label,result.center=center,result[bboxname]=bbox,result.properties=layer.feature.properties,results.push(result)}}),results}}),factory:function(apiKey,options){return new L.Control.Geocoder.Mapzen(apiKey,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],9:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://nominatim.openstreetmap.org/",geocodingQueryParams:{},reverseQueryParams:{},htmlTemplate:function(r){var a=r.address,parts=[];return(a.road||a.building)&&parts.push("{building} {road} {house_number}"),(a.city||a.town||a.village||a.hamlet)&&parts.push('<span class="'+(parts.length>0?"leaflet-control-geocoder-address-detail":"")+'">{postcode} {city} {town} {village} {hamlet}</span>'),(a.state||a.country)&&parts.push('<span class="'+(parts.length>0?"leaflet-control-geocoder-address-context":"")+'">{state} {country}</span>'),Util.template(parts.join("<br/>"),a,!0)}},initialize:function(options){L.Util.setOptions(this,options)},geocode:function(query,cb,context){Util.jsonp(this.options.serviceUrl+"search",L.extend({q:query,limit:5,format:"json",addressdetails:1},this.options.geocodingQueryParams),function(data){for(var results=[],i=data.length-1;i>=0;i--){for(var bbox=data[i].boundingbox,j=0;j<4;j++)bbox[j]=parseFloat(bbox[j]);results[i]={icon:data[i].icon,name:data[i].display_name,html:this.options.htmlTemplate?this.options.htmlTemplate(data[i]):void 0,bbox:L.latLngBounds([bbox[0],bbox[2]],[bbox[1],bbox[3]]),center:L.latLng(data[i].lat,data[i].lon),properties:data[i]}}cb.call(context,results)},this,"json_callback")},reverse:function(location,scale,cb,context){Util.jsonp(this.options.serviceUrl+"reverse",L.extend({lat:location.lat,lon:location.lng,zoom:Math.round(Math.log(scale/256)/Math.log(2)),addressdetails:1,format:"json"},this.options.reverseQueryParams),function(data){var loc,result=[];data&&data.lat&&data.lon&&(loc=L.latLng(data.lat,data.lon),result.push({name:data.display_name,html:this.options.htmlTemplate?this.options.htmlTemplate(data):void 0,center:loc,bounds:L.latLngBounds(loc,loc),properties:data})),cb.call(context,result)},this,"json_callback")}}),factory:function(options){return new L.Control.Geocoder.Nominatim(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],10:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://photon.komoot.de/api/",reverseUrl:"https://photon.komoot.de/reverse/",nameProperties:["name","street","suburb","hamlet","town","city","state","country"]},initialize:function(options){L.setOptions(this,options)},geocode:function(query,cb,context){var params=L.extend({q:query},this.options.geocodingQueryParams);Util.getJSON(this.options.serviceUrl,params,L.bind(function(data){cb.call(context,this._decodeFeatures(data))},this))},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(latLng,scale,cb,context){var params=L.extend({lat:latLng.lat,lon:latLng.lng},this.options.geocodingQueryParams);Util.getJSON(this.options.reverseUrl,params,L.bind(function(data){cb.call(context,this._decodeFeatures(data))},this))},_decodeFeatures:function(data){var i,f,c,latLng,extent,bbox,results=[];if(data&&data.features)for(i=0;i<data.features.length;i++)f=data.features[i],c=f.geometry.coordinates,latLng=L.latLng(c[1],c[0]),extent=f.properties.extent,bbox=extent?L.latLngBounds([extent[1],extent[0]],[extent[3],extent[2]]):L.latLngBounds(latLng,latLng),results.push({name:this._deocodeFeatureName(f),html:this.options.htmlTemplate?this.options.htmlTemplate(f):void 0,center:latLng,bbox:bbox,properties:f.properties});return results},_deocodeFeatureName:function(f){var j,name;for(j=0;!name&&j<this.options.nameProperties.length;j++)name=f.properties[this.options.nameProperties[j]];return name}}),factory:function(options){return new L.Control.Geocoder.Photon(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],11:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://api.what3words.com/v2/"},initialize:function(accessToken){this._accessToken=accessToken},geocode:function(query,cb,context){Util.getJSON(this.options.serviceUrl+"forward",{key:this._accessToken,addr:query.split(/\s+/).join(".")},function(data){var latLng,latLngBounds,results=[];data.hasOwnProperty("geometry")&&(latLng=L.latLng(data.geometry.lat,data.geometry.lng),latLngBounds=L.latLngBounds(latLng,latLng),results[0]={name:data.words,bbox:latLngBounds,center:latLng}),cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){Util.getJSON(this.options.serviceUrl+"reverse",{key:this._accessToken,coords:[location.lat,location.lng].join(",")},function(data){var latLng,latLngBounds,results=[];200==data.status.status&&(latLng=L.latLng(data.geometry.lat,data.geometry.lng),latLngBounds=L.latLngBounds(latLng,latLng),results[0]={name:data.words,bbox:latLngBounds,center:latLng}),cb.call(context,results)})}}),factory:function(accessToken){return new L.Control.Geocoder.What3Words(accessToken)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],12:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Control=_dereq_("./control"),Nominatim=_dereq_("./geocoders/nominatim"),Bing=_dereq_("./geocoders/bing"),MapQuest=_dereq_("./geocoders/mapquest"),Mapbox=_dereq_("./geocoders/mapbox"),What3Words=_dereq_("./geocoders/what3words"),Google=_dereq_("./geocoders/google"),Photon=_dereq_("./geocoders/photon"),Mapzen=_dereq_("./geocoders/mapzen"),ArcGis=_dereq_("./geocoders/arcgis"),HERE=_dereq_("./geocoders/here");module.exports=L.Util.extend(Control.class,{Nominatim:Nominatim.class,nominatim:Nominatim.factory,Bing:Bing.class,bing:Bing.factory,MapQuest:MapQuest.class,mapQuest:MapQuest.factory,Mapbox:Mapbox.class,mapbox:Mapbox.factory,What3Words:What3Words.class,what3words:What3Words.factory,Google:Google.class,google:Google.factory,Photon:Photon.class,photon:Photon.factory,Mapzen:Mapzen.class,mapzen:Mapzen.factory,ArcGis:ArcGis.class,arcgis:ArcGis.factory,HERE:HERE.class,here:HERE.factory}),L.Util.extend(L.Control,{Geocoder:module.exports,geocoder:Control.factory})}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./control":1,"./geocoders/arcgis":2,"./geocoders/bing":3,"./geocoders/google":4,"./geocoders/here":5,"./geocoders/mapbox":6,"./geocoders/mapquest":7,"./geocoders/mapzen":8,"./geocoders/nominatim":9,"./geocoders/photon":10,"./geocoders/what3words":11}],13:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,lastCallbackId=0,htmlEscape=function(){function escapeChar(chr){return escape[chr]}var badChars=/[&<>"'`]/g,possible=/[&<>"'`]/,escape={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};return function(string){return null==string?"":string?(string=""+string,possible.test(string)?string.replace(badChars,escapeChar):string):string+""}}();module.exports={jsonp:function(url,params,callback,context,jsonpParam){var callbackId="_l_geocoder_"+lastCallbackId++;params[jsonpParam||"callback"]=callbackId,window[callbackId]=L.Util.bind(callback,context);var script=document.createElement("script");script.type="text/javascript",script.src=url+L.Util.getParamString(params),script.id=callbackId,document.getElementsByTagName("head")[0].appendChild(script)},getJSON:function(url,params,callback){var xmlHttp=new XMLHttpRequest;xmlHttp.onreadystatechange=function(){if(4===xmlHttp.readyState)return 200!==xmlHttp.status&&304!==xmlHttp.status?void callback(""):void callback(JSON.parse(xmlHttp.response))},xmlHttp.open("GET",url+L.Util.getParamString(params),!0),xmlHttp.setRequestHeader("Accept","application/json"),xmlHttp.send(null)},template:function(str,data){return str.replace(/\{ *([\w_]+) *\}/g,function(str,key){var value=data[key];return void 0===value?value="":"function"==typeof value&&(value=value(data)),htmlEscape(value)})},htmlEscape:htmlEscape}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[12])(12)})}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){"use strict";function measure(options){return new Measure(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Measure=void 0,exports.default=measure,__webpack_require__(158);var Measure=exports.Measure=L.Control.Measure.extend({options:{position:"topright",primaryLengthUnit:"kilometers",secondaryLengthUnit:"miles",primaryAreaUnit:"hectares",secondaryAreaUnit:"acres",activeColor:"#ffa500",completedColor:"#ffa500"}})},function(module,exports,__webpack_require__){(function(global){var require,require,__WEBPACK_AMD_DEFINE_RESULT__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;!function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n||e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(require,module,exports){},{}],2:[function(require,module,exports){function rgb2hsl(rgb){var h,s,l,r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255,min=Math.min(r,g,b),max=Math.max(r,g,b),delta=max-min;return max==min?h=0:r==max?h=(g-b)/delta:g==max?h=2+(b-r)/delta:b==max&&(h=4+(r-g)/delta),h=Math.min(60*h,360),h<0&&(h+=360),l=(min+max)/2,s=max==min?0:l<=.5?delta/(max+min):delta/(2-max-min),[h,100*s,100*l]}function rgb2hsv(rgb){var h,s,v,r=rgb[0],g=rgb[1],b=rgb[2],min=Math.min(r,g,b),max=Math.max(r,g,b),delta=max-min;return s=0==max?0:delta/max*1e3/10,max==min?h=0:r==max?h=(g-b)/delta:g==max?h=2+(b-r)/delta:b==max&&(h=4+(r-g)/delta),h=Math.min(60*h,360),h<0&&(h+=360),v=max/255*1e3/10,[h,s,v]}function rgb2hwb(rgb){var r=rgb[0],g=rgb[1],b=rgb[2],h=rgb2hsl(rgb)[0],w=1/255*Math.min(r,Math.min(g,b)),b=1-1/255*Math.max(r,Math.max(g,b));return[h,100*w,100*b]}function rgb2cmyk(rgb){var c,m,y,k,r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255;return k=Math.min(1-r,1-g,1-b),c=(1-r-k)/(1-k)||0,m=(1-g-k)/(1-k)||0,y=(1-b-k)/(1-k)||0,[100*c,100*m,100*y,100*k]}function rgb2keyword(rgb){return reverseKeywords[JSON.stringify(rgb)]}function rgb2xyz(rgb){var r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255;return r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92,g=g>.04045?Math.pow((g+.055)/1.055,2.4):g/12.92,b=b>.04045?Math.pow((b+.055)/1.055,2.4):b/12.92,[100*(.4124*r+.3576*g+.1805*b),100*(.2126*r+.7152*g+.0722*b),100*(.0193*r+.1192*g+.9505*b)]}function rgb2lab(rgb){var l,a,b,xyz=rgb2xyz(rgb),x=xyz[0],y=xyz[1],z=xyz[2];return x/=95.047,y/=100,z/=108.883,x=x>.008856?Math.pow(x,1/3):7.787*x+16/116,y=y>.008856?Math.pow(y,1/3):7.787*y+16/116,z=z>.008856?Math.pow(z,1/3):7.787*z+16/116,l=116*y-16,a=500*(x-y),b=200*(y-z),[l,a,b]}function rgb2lch(args){return lab2lch(rgb2lab(args))}function hsl2rgb(hsl){var t1,t2,t3,rgb,val,h=hsl[0]/360,s=hsl[1]/100,l=hsl[2]/100;if(0==s)return val=255*l,[val,val,val];t2=l<.5?l*(1+s):l+s-l*s,t1=2*l-t2,rgb=[0,0,0];for(var i=0;i<3;i++)t3=h+1/3*-(i-1),t3<0&&t3++,t3>1&&t3--,val=6*t3<1?t1+6*(t2-t1)*t3:2*t3<1?t2:3*t3<2?t1+(t2-t1)*(2/3-t3)*6:t1,rgb[i]=255*val;return rgb}function hsl2hsv(hsl){var sv,v,h=hsl[0],s=hsl[1]/100,l=hsl[2]/100;return 0===l?[0,0,0]:(l*=2,s*=l<=1?l:2-l,v=(l+s)/2,sv=2*s/(l+s),[h,100*sv,100*v])}function hsl2hwb(args){return rgb2hwb(hsl2rgb(args))}function hsl2cmyk(args){return rgb2cmyk(hsl2rgb(args))}function hsl2keyword(args){return rgb2keyword(hsl2rgb(args))}function hsv2rgb(hsv){var h=hsv[0]/60,s=hsv[1]/100,v=hsv[2]/100,hi=Math.floor(h)%6,f=h-Math.floor(h),p=255*v*(1-s),q=255*v*(1-s*f),t=255*v*(1-s*(1-f)),v=255*v;switch(hi){case 0:return[v,t,p];case 1:return[q,v,p];case 2:return[p,v,t];case 3:return[p,q,v];case 4:return[t,p,v];case 5:return[v,p,q]}}function hsv2hsl(hsv){var sl,l,h=hsv[0],s=hsv[1]/100,v=hsv[2]/100;return l=(2-s)*v,sl=s*v,sl/=l<=1?l:2-l,sl=sl||0,l/=2,[h,100*sl,100*l]}function hsv2hwb(args){return rgb2hwb(hsv2rgb(args))}function hsv2cmyk(args){return rgb2cmyk(hsv2rgb(args))}function hsv2keyword(args){return rgb2keyword(hsv2rgb(args))}function hwb2rgb(hwb){var i,v,f,n,h=hwb[0]/360,wh=hwb[1]/100,bl=hwb[2]/100,ratio=wh+bl;switch(ratio>1&&(wh/=ratio,bl/=ratio),i=Math.floor(6*h),v=1-bl,f=6*h-i,0!=(1&i)&&(f=1-f),n=wh+f*(v-wh),i){default:case 6:case 0:r=v,g=n,b=wh;break;case 1:r=n,g=v,b=wh;break;case 2:r=wh,g=v,b=n;break;case 3:r=wh,g=n,b=v;break;case 4:r=n,g=wh,b=v;break;case 5:r=v,g=wh,b=n}return[255*r,255*g,255*b]}function hwb2hsl(args){return rgb2hsl(hwb2rgb(args))}function hwb2hsv(args){return rgb2hsv(hwb2rgb(args))}function hwb2cmyk(args){return rgb2cmyk(hwb2rgb(args))}function hwb2keyword(args){return rgb2keyword(hwb2rgb(args))}function cmyk2rgb(cmyk){var r,g,b,c=cmyk[0]/100,m=cmyk[1]/100,y=cmyk[2]/100,k=cmyk[3]/100;return r=1-Math.min(1,c*(1-k)+k),g=1-Math.min(1,m*(1-k)+k),b=1-Math.min(1,y*(1-k)+k),[255*r,255*g,255*b]}function cmyk2hsl(args){return rgb2hsl(cmyk2rgb(args))}function cmyk2hsv(args){return rgb2hsv(cmyk2rgb(args))}function cmyk2hwb(args){return rgb2hwb(cmyk2rgb(args))}function cmyk2keyword(args){return rgb2keyword(cmyk2rgb(args))}function xyz2rgb(xyz){var r,g,b,x=xyz[0]/100,y=xyz[1]/100,z=xyz[2]/100;return r=3.2406*x+-1.5372*y+-.4986*z,g=-.9689*x+1.8758*y+.0415*z,b=.0557*x+-.204*y+1.057*z,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:r*=12.92,g=g>.0031308?1.055*Math.pow(g,1/2.4)-.055:g*=12.92,b=b>.0031308?1.055*Math.pow(b,1/2.4)-.055:b*=12.92,r=Math.min(Math.max(0,r),1),g=Math.min(Math.max(0,g),1),b=Math.min(Math.max(0,b),1),[255*r,255*g,255*b]}function xyz2lab(xyz){var l,a,b,x=xyz[0],y=xyz[1],z=xyz[2];return x/=95.047,y/=100,z/=108.883,x=x>.008856?Math.pow(x,1/3):7.787*x+16/116,y=y>.008856?Math.pow(y,1/3):7.787*y+16/116,z=z>.008856?Math.pow(z,1/3):7.787*z+16/116,l=116*y-16,a=500*(x-y),b=200*(y-z),[l,a,b]}function xyz2lch(args){return lab2lch(xyz2lab(args))}function lab2xyz(lab){var x,y,z,y2,l=lab[0],a=lab[1],b=lab[2];return l<=8?(y=100*l/903.3,y2=y/100*7.787+16/116):(y=100*Math.pow((l+16)/116,3),y2=Math.pow(y/100,1/3)),x=x/95.047<=.008856?x=95.047*(a/500+y2-16/116)/7.787:95.047*Math.pow(a/500+y2,3),z=z/108.883<=.008859?z=108.883*(y2-b/200-16/116)/7.787:108.883*Math.pow(y2-b/200,3),[x,y,z]}function lab2lch(lab){var hr,h,c,l=lab[0],a=lab[1],b=lab[2];return hr=Math.atan2(b,a),h=360*hr/2/Math.PI,h<0&&(h+=360),c=Math.sqrt(a*a+b*b),[l,c,h]}function lab2rgb(args){return xyz2rgb(lab2xyz(args))}function lch2lab(lch){var a,b,hr,l=lch[0],c=lch[1],h=lch[2];return hr=h/360*2*Math.PI,a=c*Math.cos(hr),b=c*Math.sin(hr),[l,a,b]}function lch2xyz(args){return lab2xyz(lch2lab(args))}function lch2rgb(args){return lab2rgb(lch2lab(args))}function keyword2rgb(keyword){return cssKeywords[keyword]}function keyword2hsl(args){return rgb2hsl(keyword2rgb(args))}function keyword2hsv(args){return rgb2hsv(keyword2rgb(args))}function keyword2hwb(args){return rgb2hwb(keyword2rgb(args))}function keyword2cmyk(args){return rgb2cmyk(keyword2rgb(args))}function keyword2lab(args){return rgb2lab(keyword2rgb(args))}function keyword2xyz(args){return rgb2xyz(keyword2rgb(args))}module.exports={rgb2hsl:rgb2hsl,rgb2hsv:rgb2hsv,rgb2hwb:rgb2hwb,rgb2cmyk:rgb2cmyk,rgb2keyword:rgb2keyword,rgb2xyz:rgb2xyz,rgb2lab:rgb2lab,rgb2lch:rgb2lch,hsl2rgb:hsl2rgb,hsl2hsv:hsl2hsv,hsl2hwb:hsl2hwb,hsl2cmyk:hsl2cmyk,hsl2keyword:hsl2keyword,hsv2rgb:hsv2rgb,hsv2hsl:hsv2hsl,hsv2hwb:hsv2hwb,hsv2cmyk:hsv2cmyk,hsv2keyword:hsv2keyword,hwb2rgb:hwb2rgb,hwb2hsl:hwb2hsl,hwb2hsv:hwb2hsv,hwb2cmyk:hwb2cmyk,hwb2keyword:hwb2keyword,cmyk2rgb:cmyk2rgb,cmyk2hsl:cmyk2hsl,cmyk2hsv:cmyk2hsv,cmyk2hwb:cmyk2hwb,cmyk2keyword:cmyk2keyword,keyword2rgb:keyword2rgb,keyword2hsl:keyword2hsl,keyword2hsv:keyword2hsv,keyword2hwb:keyword2hwb,keyword2cmyk:keyword2cmyk,keyword2lab:keyword2lab,keyword2xyz:keyword2xyz,xyz2rgb:xyz2rgb,xyz2lab:xyz2lab,xyz2lch:xyz2lch,lab2xyz:lab2xyz,lab2rgb:lab2rgb,lab2lch:lab2lch,lch2lab:lch2lab,lch2xyz:lch2xyz,lch2rgb:lch2rgb};var cssKeywords={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},reverseKeywords={};for(var key in cssKeywords)reverseKeywords[JSON.stringify(cssKeywords[key])]=key},{}],3:[function(require,module,exports){var conversions=require("./conversions"),convert=function(){return new Converter};for(var func in conversions){convert[func+"Raw"]=function(func){return function(arg){return"number"==typeof arg&&(arg=Array.prototype.slice.call(arguments)),conversions[func](arg)}}(func);var pair=/(\w+)2(\w+)/.exec(func),from=pair[1],to=pair[2];convert[from]=convert[from]||{},convert[from][to]=convert[func]=function(func){return function(arg){"number"==typeof arg&&(arg=Array.prototype.slice.call(arguments));var val=conversions[func](arg);if("string"==typeof val||void 0===val)return val;for(var i=0;i<val.length;i++)val[i]=Math.round(val[i]);return val}}(func)}var Converter=function(){this.convs={}};Converter.prototype.routeSpace=function(space,args){var values=args[0];return void 0===values?this.getValues(space):("number"==typeof values&&(values=Array.prototype.slice.call(args)),this.setValues(space,values))},Converter.prototype.setValues=function(space,values){return this.space=space,this.convs={},this.convs[space]=values,this},Converter.prototype.getValues=function(space){var vals=this.convs[space];if(!vals){var fspace=this.space,from=this.convs[fspace];vals=convert[fspace][space](from),this.convs[space]=vals}return vals},["rgb","hsl","hsv","cmyk","keyword"].forEach(function(space){Converter.prototype[space]=function(vals){return this.routeSpace(space,arguments)}}),module.exports=convert},{"./conversions":2}],4:[function(require,module,exports){module.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},{}],5:[function(require,module,exports){function getRgba(string){if(string){var abbr=/^#([a-fA-F0-9]{3})$/,hex=/^#([a-fA-F0-9]{6})$/,rgba=/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,per=/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,keyword=/(\D+)/,rgb=[0,0,0],a=1,match=string.match(abbr);if(match){match=match[1];for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match[i]+match[i],16)}else if(match=string.match(hex)){match=match[1];for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match.slice(2*i,2*i+2),16)}else if(match=string.match(rgba)){for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match[i+1]);a=parseFloat(match[4])}else if(match=string.match(per)){for(var i=0;i<rgb.length;i++)rgb[i]=Math.round(2.55*parseFloat(match[i+1]));a=parseFloat(match[4])}else if(match=string.match(keyword)){if("transparent"==match[1])return[0,0,0,0];if(!(rgb=colorNames[match[1]]))return}for(var i=0;i<rgb.length;i++)rgb[i]=scale(rgb[i],0,255);return a=a||0==a?scale(a,0,1):1,rgb[3]=a,rgb}}function getHsla(string){if(string){var hsl=/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,match=string.match(hsl);if(match){var alpha=parseFloat(match[4]);return[scale(parseInt(match[1]),0,360),scale(parseFloat(match[2]),0,100),scale(parseFloat(match[3]),0,100),scale(isNaN(alpha)?1:alpha,0,1)]}}}function getHwb(string){if(string){var hwb=/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,match=string.match(hwb);if(match){var alpha=parseFloat(match[4]);return[scale(parseInt(match[1]),0,360),scale(parseFloat(match[2]),0,100),scale(parseFloat(match[3]),0,100),scale(isNaN(alpha)?1:alpha,0,1)]}}}function getRgb(string){var rgba=getRgba(string);return rgba&&rgba.slice(0,3)}function getHsl(string){var hsla=getHsla(string);return hsla&&hsla.slice(0,3)}function getAlpha(string){var vals=getRgba(string);return vals?vals[3]:(vals=getHsla(string))?vals[3]:(vals=getHwb(string))?vals[3]:void 0}function hexString(rgb){return"#"+hexDouble(rgb[0])+hexDouble(rgb[1])+hexDouble(rgb[2])}function rgbString(rgba,alpha){return alpha<1||rgba[3]&&rgba[3]<1?rgbaString(rgba,alpha):"rgb("+rgba[0]+", "+rgba[1]+", "+rgba[2]+")"}function rgbaString(rgba,alpha){return void 0===alpha&&(alpha=void 0!==rgba[3]?rgba[3]:1),"rgba("+rgba[0]+", "+rgba[1]+", "+rgba[2]+", "+alpha+")"}function percentString(rgba,alpha){return alpha<1||rgba[3]&&rgba[3]<1?percentaString(rgba,alpha):"rgb("+Math.round(rgba[0]/255*100)+"%, "+Math.round(rgba[1]/255*100)+"%, "+Math.round(rgba[2]/255*100)+"%)"}function percentaString(rgba,alpha){return"rgba("+Math.round(rgba[0]/255*100)+"%, "+Math.round(rgba[1]/255*100)+"%, "+Math.round(rgba[2]/255*100)+"%, "+(alpha||rgba[3]||1)+")"}function hslString(hsla,alpha){return alpha<1||hsla[3]&&hsla[3]<1?hslaString(hsla,alpha):"hsl("+hsla[0]+", "+hsla[1]+"%, "+hsla[2]+"%)"}function hslaString(hsla,alpha){return void 0===alpha&&(alpha=void 0!==hsla[3]?hsla[3]:1),"hsla("+hsla[0]+", "+hsla[1]+"%, "+hsla[2]+"%, "+alpha+")"}function hwbString(hwb,alpha){return void 0===alpha&&(alpha=void 0!==hwb[3]?hwb[3]:1),"hwb("+hwb[0]+", "+hwb[1]+"%, "+hwb[2]+"%"+(void 0!==alpha&&1!==alpha?", "+alpha:"")+")"}function keyword(rgb){return reverseNames[rgb.slice(0,3)]}function scale(num,min,max){return Math.min(Math.max(min,num),max)}function hexDouble(num){var str=num.toString(16).toUpperCase();return str.length<2?"0"+str:str}var colorNames=require("color-name");module.exports={getRgba:getRgba,getHsla:getHsla,getRgb:getRgb,getHsl:getHsl,getHwb:getHwb,getAlpha:getAlpha,hexString:hexString,rgbString:rgbString,rgbaString:rgbaString,percentString:percentString,percentaString:percentaString,hslString:hslString,hslaString:hslaString,hwbString:hwbString,keyword:keyword};var reverseNames={};for(var name in colorNames)reverseNames[colorNames[name]]=name},{"color-name":4}],6:[function(require,module,exports){var convert=require("color-convert"),string=require("color-string"),Color=function(obj){if(obj instanceof Color)return obj;if(!(this instanceof Color))return new Color(obj);if(this.values={rgb:[0,0,0],hsl:[0,0,0],hsv:[0,0,0],hwb:[0,0,0],cmyk:[0,0,0,0],alpha:1},"string"==typeof obj){var vals=string.getRgba(obj);if(vals)this.setValues("rgb",vals);else if(vals=string.getHsla(obj))this.setValues("hsl",vals);else{if(!(vals=string.getHwb(obj)))throw new Error('Unable to parse color from string "'+obj+'"');this.setValues("hwb",vals)}}else if("object"==typeof obj){var vals=obj;if(void 0!==vals.r||void 0!==vals.red)this.setValues("rgb",vals);else if(void 0!==vals.l||void 0!==vals.lightness)this.setValues("hsl",vals);else if(void 0!==vals.v||void 0!==vals.value)this.setValues("hsv",vals);else if(void 0!==vals.w||void 0!==vals.whiteness)this.setValues("hwb",vals);else{if(void 0===vals.c&&void 0===vals.cyan)throw new Error("Unable to parse color from object "+JSON.stringify(obj));this.setValues("cmyk",vals)}}};Color.prototype={rgb:function(vals){return this.setSpace("rgb",arguments)},hsl:function(vals){return this.setSpace("hsl",arguments)},hsv:function(vals){return this.setSpace("hsv",arguments)},hwb:function(vals){return this.setSpace("hwb",arguments)},cmyk:function(vals){return this.setSpace("cmyk",arguments)},rgbArray:function(){return this.values.rgb},hslArray:function(){return this.values.hsl},hsvArray:function(){return this.values.hsv},hwbArray:function(){return 1!==this.values.alpha?this.values.hwb.concat([this.values.alpha]):this.values.hwb},cmykArray:function(){return this.values.cmyk},rgbaArray:function(){return this.values.rgb.concat([this.values.alpha])},hslaArray:function(){return this.values.hsl.concat([this.values.alpha])},alpha:function(val){return void 0===val?this.values.alpha:(this.setValues("alpha",val),this)},red:function(val){return this.setChannel("rgb",0,val)},green:function(val){return this.setChannel("rgb",1,val)},blue:function(val){return this.setChannel("rgb",2,val)},hue:function(val){return this.setChannel("hsl",0,val)},saturation:function(val){return this.setChannel("hsl",1,val)},lightness:function(val){return this.setChannel("hsl",2,val)},saturationv:function(val){return this.setChannel("hsv",1,val)},whiteness:function(val){return this.setChannel("hwb",1,val)},blackness:function(val){return this.setChannel("hwb",2,val)},value:function(val){return this.setChannel("hsv",2,val)},cyan:function(val){return this.setChannel("cmyk",0,val)},magenta:function(val){return this.setChannel("cmyk",1,val)},yellow:function(val){return this.setChannel("cmyk",2,val)},black:function(val){return this.setChannel("cmyk",3,val)},hexString:function(){return string.hexString(this.values.rgb)},rgbString:function(){return string.rgbString(this.values.rgb,this.values.alpha)},rgbaString:function(){return string.rgbaString(this.values.rgb,this.values.alpha)},percentString:function(){return string.percentString(this.values.rgb,this.values.alpha)},hslString:function(){return string.hslString(this.values.hsl,this.values.alpha)},hslaString:function(){return string.hslaString(this.values.hsl,this.values.alpha)},hwbString:function(){return string.hwbString(this.values.hwb,this.values.alpha)},keyword:function(){return string.keyword(this.values.rgb,this.values.alpha)},rgbNumber:function(){return this.values.rgb[0]<<16|this.values.rgb[1]<<8|this.values.rgb[2]},luminosity:function(){for(var rgb=this.values.rgb,lum=[],i=0;i<rgb.length;i++){var chan=rgb[i]/255;lum[i]=chan<=.03928?chan/12.92:Math.pow((chan+.055)/1.055,2.4)}return.2126*lum[0]+.7152*lum[1]+.0722*lum[2]},contrast:function(color2){var lum1=this.luminosity(),lum2=color2.luminosity();return lum1>lum2?(lum1+.05)/(lum2+.05):(lum2+.05)/(lum1+.05)},level:function(color2){var contrastRatio=this.contrast(color2);return contrastRatio>=7.1?"AAA":contrastRatio>=4.5?"AA":""},dark:function(){var rgb=this.values.rgb;return(299*rgb[0]+587*rgb[1]+114*rgb[2])/1e3<128},light:function(){return!this.dark()},negate:function(){for(var rgb=[],i=0;i<3;i++)rgb[i]=255-this.values.rgb[i];return this.setValues("rgb",rgb),this},lighten:function(ratio){return this.values.hsl[2]+=this.values.hsl[2]*ratio,this.setValues("hsl",this.values.hsl),this},darken:function(ratio){return this.values.hsl[2]-=this.values.hsl[2]*ratio,this.setValues("hsl",this.values.hsl),this},saturate:function(ratio){return this.values.hsl[1]+=this.values.hsl[1]*ratio,this.setValues("hsl",this.values.hsl),this},desaturate:function(ratio){return this.values.hsl[1]-=this.values.hsl[1]*ratio,this.setValues("hsl",this.values.hsl),this},whiten:function(ratio){return this.values.hwb[1]+=this.values.hwb[1]*ratio,this.setValues("hwb",this.values.hwb),this},blacken:function(ratio){return this.values.hwb[2]+=this.values.hwb[2]*ratio,this.setValues("hwb",this.values.hwb),this},greyscale:function(){var rgb=this.values.rgb,val=.3*rgb[0]+.59*rgb[1]+.11*rgb[2];return this.setValues("rgb",[val,val,val]),this},clearer:function(ratio){return this.setValues("alpha",this.values.alpha-this.values.alpha*ratio),this},opaquer:function(ratio){return this.setValues("alpha",this.values.alpha+this.values.alpha*ratio),this},rotate:function(degrees){var hue=this.values.hsl[0];return hue=(hue+degrees)%360,hue=hue<0?360+hue:hue,this.values.hsl[0]=hue,this.setValues("hsl",this.values.hsl),this},mix:function(color2,weight){weight=1-(null==weight?.5:weight);for(var t1=2*weight-1,d=this.alpha()-color2.alpha(),weight1=((t1*d==-1?t1:(t1+d)/(1+t1*d))+1)/2,weight2=1-weight1,rgb=this.rgbArray(),rgb2=color2.rgbArray(),i=0;i<rgb.length;i++)rgb[i]=rgb[i]*weight1+rgb2[i]*weight2;this.setValues("rgb",rgb);var alpha=this.alpha()*weight+color2.alpha()*(1-weight);return this.setValues("alpha",alpha),this},toJSON:function(){return this.rgb()},clone:function(){return new Color(this.rgb())}},Color.prototype.getValues=function(space){for(var vals={},i=0;i<space.length;i++)vals[space.charAt(i)]=this.values[space][i];return 1!=this.values.alpha&&(vals.a=this.values.alpha),vals},Color.prototype.setValues=function(space,vals){var spaces={rgb:["red","green","blue"],hsl:["hue","saturation","lightness"],hsv:["hue","saturation","value"],hwb:["hue","whiteness","blackness"],cmyk:["cyan","magenta","yellow","black"]},maxes={rgb:[255,255,255],hsl:[360,100,100],hsv:[360,100,100],hwb:[360,100,100],cmyk:[100,100,100,100]},alpha=1;if("alpha"==space)alpha=vals;else if(vals.length)this.values[space]=vals.slice(0,space.length),alpha=vals[space.length];else if(void 0!==vals[space.charAt(0)]){for(var i=0;i<space.length;i++)this.values[space][i]=vals[space.charAt(i)];alpha=vals.a}else if(void 0!==vals[spaces[space][0]]){for(var chans=spaces[space],i=0;i<space.length;i++)this.values[space][i]=vals[chans[i]];alpha=vals.alpha}if(this.values.alpha=Math.max(0,Math.min(1,void 0!==alpha?alpha:this.values.alpha)),"alpha"!=space){for(var i=0;i<space.length;i++){var capped=Math.max(0,Math.min(maxes[space][i],this.values[space][i]));this.values[space][i]=Math.round(capped)}for(var sname in spaces){sname!=space&&(this.values[sname]=convert[space][sname](this.values[space]));for(var i=0;i<sname.length;i++){var capped=Math.max(0,Math.min(maxes[sname][i],this.values[sname][i]));this.values[sname][i]=Math.round(capped)}}return!0}},Color.prototype.setSpace=function(space,args){var vals=args[0];return void 0===vals?this.getValues(space):("number"==typeof vals&&(vals=Array.prototype.slice.call(args)),this.setValues(space,vals),this)},Color.prototype.setChannel=function(space,index,val){return void 0===val?this.values[space][index]:(this.values[space][index]=val,this.setValues(space,this.values[space]),this)},module.exports=Color},{"color-convert":3,"color-string":5}],7:[function(require,module,exports){module.exports=require("./lib/geocrunch")},{"./lib/geocrunch":12}],8:[function(require,module,exports){var _=require("underscore"),R=require("./constants").EARTHRADIUS,units=require("./units"),flipCoords=require("./flipcoords"),convertFuncs={sqmeters:function(a){return a},sqmiles:function(a){return units.sqMeters.toSqMiles(a)},acres:function(a){return units.sqMeters.toAcres(a)}},calcArea=function(coordArray){var i,l,c1,c2,area=0;for(i=0,l=coordArray.length;i<l;i+=1)c1=coordArray[i],c2=coordArray[(i+1)%coordArray.length],area+=units.degrees.toRadians(c2[0]-c1[0])*(2+Math.sin(units.degrees.toRadians(c1[1]))+Math.sin(units.degrees.toRadians(c2[1])));return Math.abs(area*R*R/2)},calcCenter=function(coordArray){var i,l,c1,c2,f,offset=coordArray[0],twiceArea=0,x=0,y=0;if(1===coordArray.length)return coordArray[0];for(i=0,l=coordArray.length;i<l;i+=1)c1=coordArray[i],c2=coordArray[(i+1)%coordArray.length],f=(c1[1]-offset[1])*(c2[0]-offset[0])-(c2[1]-offset[1])*(c1[0]-offset[0]),twiceArea+=f,x+=(c1[0]+c2[0]-2*offset[0])*f,y+=(c1[1]+c2[1]-2*offset[1])*f;return f=3*twiceArea,[x/f+offset[0],y/f+offset[1]]};module.exports={_internalAreaCalc:function(){this._calcedArea||(this._coords.length<3?this._calcedArea=0:this._calcedArea=calcArea(this._coords))},_internalCenterCalc:function(){!this._calcedCenter&&this._coords.length&&(this._calcedCenter=calcCenter(this._coords))},area:function(options){var opts=_.extend({units:"sqmeters"},options);if(this._internalAreaCalc(),_.isFunction(convertFuncs[opts.units]))return convertFuncs[opts.units](this._calcedArea)},center:function(){return this._internalCenterCalc(),!0===this._options.imBackwards?flipCoords(this._calcedCenter):this._calcedCenter}}},{"./constants":9,"./flipcoords":11,"./units":14,underscore:15}],9:[function(require,module,exports){module.exports={EARTHRADIUS:6371e3}},{}],10:[function(require,module,exports){var _=require("underscore"),R=require("./constants").EARTHRADIUS,units=require("./units"),convertFuncs={meters:function(d){return d},kilometers:function(d){return units.meters.toKilometers(d)},feet:function(d){return units.meters.toFeet(d)},miles:function(d){return units.meters.toMiles(d)}},calcDistance=function(coord1,coord2){var deltaLng=units.degrees.toRadians(coord1[0]-coord2[0]),deltaLat=units.degrees.toRadians(coord1[1]-coord2[1]),lat1=units.degrees.toRadians(coord1[1]),lat2=units.degrees.toRadians(coord2[1]),hvsLng=Math.sin(deltaLng/2),hvsLat=Math.sin(deltaLat/2),a=hvsLat*hvsLat+hvsLng*hvsLng*Math.cos(lat1)*Math.cos(lat2);return 2*R*Math.atan2(Math.sqrt(a),Math.sqrt(1-a))};module.exports={_internalDistanceCalc:function(){var i,l,distance=0;if(!this._calcedDistance){for(i=0,l=this._coords.length;i<l;i+=1)i>0&&(distance+=calcDistance(this._coords[i-1],this._coords[i]));this._calcedDistance=distance}},distance:function(options){var opts=_.extend({units:"meters"},options);if(this._internalDistanceCalc(),_.isFunction(convertFuncs[opts.units]))return convertFuncs[opts.units](this._calcedDistance)}}},{"./constants":9,"./units":14,underscore:15}],11:[function(require,module,exports){var _=require("underscore");module.exports=function(backwardsCoordArray){return _.map(backwardsCoordArray,function(backwardsCoord){return[backwardsCoord[1],backwardsCoord[0]]})}},{underscore:15}],12:[function(require,module,exports){var _=require("underscore"),Path=require("./path"),distanceMixins=require("./distance"),areaMixins=require("./area");_.extend(Path.prototype,distanceMixins,areaMixins),exports.path=function(coords,options){return new Path(coords,options)}},{"./area":8,"./distance":10,"./path":13,underscore:15}],13:[function(require,module,exports){var flipCoords=require("./flipcoords"),Path=function(coords,options){this._options=options||{},coords=coords||[],this._coords=!0===this._options.imBackwards?flipCoords(coords):coords};module.exports=Path},{"./flipcoords":11}],14:[function(require,module,exports){exports.meters={toFeet:function(m){return 3.28084*m},toKilometers:function(m){return.001*m},toMiles:function(m){return 621371e-9*m}},exports.sqMeters={toSqMiles:function(m){return 3.86102e-7*m},toAcres:function(m){return 247105e-9*m}},exports.degrees={toRadians:function(d){return d*Math.PI/180}}},{}],15:[function(require,module,exports){(function(){var root=this,previousUnderscore=root._,breaker={},ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype,push=ArrayProto.push,slice=ArrayProto.slice,concat=ArrayProto.concat,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty,nativeForEach=ArrayProto.forEach,nativeMap=ArrayProto.map,nativeReduce=ArrayProto.reduce,nativeReduceRight=ArrayProto.reduceRight,nativeFilter=ArrayProto.filter,nativeEvery=ArrayProto.every,nativeSome=ArrayProto.some,nativeIndexOf=ArrayProto.indexOf,nativeLastIndexOf=ArrayProto.lastIndexOf,nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind,_=function(obj){return obj instanceof _?obj:this instanceof _?void(this._wrapped=obj):new _(obj)};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=_),exports._=_):root._=_,_.VERSION="1.5.2";var each=_.each=_.forEach=function(obj,iterator,context){if(null!=obj)if(nativeForEach&&obj.forEach===nativeForEach)obj.forEach(iterator,context);else if(obj.length===+obj.length){for(var i=0,length=obj.length;i<length;i++)if(iterator.call(context,obj[i],i,obj)===breaker)return}else for(var keys=_.keys(obj),i=0,length=keys.length;i<length;i++)if(iterator.call(context,obj[keys[i]],keys[i],obj)===breaker)return};_.map=_.collect=function(obj,iterator,context){var results=[];return null==obj?results:nativeMap&&obj.map===nativeMap?obj.map(iterator,context):(each(obj,function(value,index,list){results.push(iterator.call(context,value,index,list))}),results)};var reduceError="Reduce of empty array with no initial value";_.reduce=_.foldl=_.inject=function(obj,iterator,memo,context){var initial=arguments.length>2;if(null==obj&&(obj=[]),nativeReduce&&obj.reduce===nativeReduce)return context&&(iterator=_.bind(iterator,context)),initial?obj.reduce(iterator,memo):obj.reduce(iterator);if(each(obj,function(value,index,list){initial?memo=iterator.call(context,memo,value,index,list):(memo=value,initial=!0)}),!initial)throw new TypeError(reduceError);return memo},_.reduceRight=_.foldr=function(obj,iterator,memo,context){var initial=arguments.length>2;if(null==obj&&(obj=[]),nativeReduceRight&&obj.reduceRight===nativeReduceRight)return context&&(iterator=_.bind(iterator,context)),initial?obj.reduceRight(iterator,memo):obj.reduceRight(iterator);var length=obj.length;if(length!==+length){var keys=_.keys(obj);length=keys.length}if(each(obj,function(value,index,list){index=keys?keys[--length]:--length,initial?memo=iterator.call(context,memo,obj[index],index,list):(memo=obj[index],initial=!0)}),!initial)throw new TypeError(reduceError);return memo},_.find=_.detect=function(obj,iterator,context){var result;return any(obj,function(value,index,list){if(iterator.call(context,value,index,list))return result=value,!0}),result},_.filter=_.select=function(obj,iterator,context){var results=[];return null==obj?results:nativeFilter&&obj.filter===nativeFilter?obj.filter(iterator,context):(each(obj,function(value,index,list){iterator.call(context,value,index,list)&&results.push(value)}),results)},_.reject=function(obj,iterator,context){return _.filter(obj,function(value,index,list){return!iterator.call(context,value,index,list)},context)},_.every=_.all=function(obj,iterator,context){iterator||(iterator=_.identity);var result=!0;return null==obj?result:nativeEvery&&obj.every===nativeEvery?obj.every(iterator,context):(each(obj,function(value,index,list){if(!(result=result&&iterator.call(context,value,index,list)))return breaker}),!!result)};var any=_.some=_.any=function(obj,iterator,context){iterator||(iterator=_.identity);var result=!1;return null==obj?result:nativeSome&&obj.some===nativeSome?obj.some(iterator,context):(each(obj,function(value,index,list){if(result||(result=iterator.call(context,value,index,list)))return breaker}),!!result)};_.contains=_.include=function(obj,target){return null!=obj&&(nativeIndexOf&&obj.indexOf===nativeIndexOf?-1!=obj.indexOf(target):any(obj,function(value){return value===target}))},_.invoke=function(obj,method){var args=slice.call(arguments,2),isFunc=_.isFunction(method);return _.map(obj,function(value){return(isFunc?method:value[method]).apply(value,args)})},_.pluck=function(obj,key){return _.map(obj,function(value){return value[key]})},_.where=function(obj,attrs,first){return _.isEmpty(attrs)?first?void 0:[]:_[first?"find":"filter"](obj,function(value){for(var key in attrs)if(attrs[key]!==value[key])return!1;return!0})},_.findWhere=function(obj,attrs){return _.where(obj,attrs,!0)},_.max=function(obj,iterator,context){if(!iterator&&_.isArray(obj)&&obj[0]===+obj[0]&&obj.length<65535)return Math.max.apply(Math,obj);if(!iterator&&_.isEmpty(obj))return-1/0;var result={computed:-1/0,value:-1/0};return each(obj,function(value,index,list){var computed=iterator?iterator.call(context,value,index,list):value;computed>result.computed&&(result={value:value,computed:computed})}),result.value},_.min=function(obj,iterator,context){if(!iterator&&_.isArray(obj)&&obj[0]===+obj[0]&&obj.length<65535)return Math.min.apply(Math,obj);if(!iterator&&_.isEmpty(obj))return 1/0;var result={computed:1/0,value:1/0};return each(obj,function(value,index,list){var computed=iterator?iterator.call(context,value,index,list):value;computed<result.computed&&(result={value:value,computed:computed})}),result.value},_.shuffle=function(obj){var rand,index=0,shuffled=[];return each(obj,function(value){rand=_.random(index++),shuffled[index-1]=shuffled[rand],shuffled[rand]=value}),shuffled},_.sample=function(obj,n,guard){return arguments.length<2||guard?obj[_.random(obj.length-1)]:_.shuffle(obj).slice(0,Math.max(0,n))};var lookupIterator=function(value){return _.isFunction(value)?value:function(obj){return obj[value]}};_.sortBy=function(obj,value,context){var iterator=lookupIterator(value);return _.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iterator.call(context,value,index,list)}}).sort(function(left,right){var a=left.criteria,b=right.criteria;if(a!==b){if(a>b||void 0===a)return 1;if(a<b||void 0===b)return-1}return left.index-right.index}),"value")};var group=function(behavior){return function(obj,value,context){var result={},iterator=null==value?_.identity:lookupIterator(value);return each(obj,function(value,index){var key=iterator.call(context,value,index,obj);behavior(result,key,value)}),result}};_.groupBy=group(function(result,key,value){(_.has(result,key)?result[key]:result[key]=[]).push(value)}),_.indexBy=group(function(result,key,value){result[key]=value}),_.countBy=group(function(result,key){_.has(result,key)?result[key]++:result[key]=1}),_.sortedIndex=function(array,obj,iterator,context){iterator=null==iterator?_.identity:lookupIterator(iterator);for(var value=iterator.call(context,obj),low=0,high=array.length;low<high;){var mid=low+high>>>1;iterator.call(context,array[mid])<value?low=mid+1:high=mid}return low},_.toArray=function(obj){return obj?_.isArray(obj)?slice.call(obj):obj.length===+obj.length?_.map(obj,_.identity):_.values(obj):[]},_.size=function(obj){return null==obj?0:obj.length===+obj.length?obj.length:_.keys(obj).length},_.first=_.head=_.take=function(array,n,guard){if(null!=array)return null==n||guard?array[0]:slice.call(array,0,n)},_.initial=function(array,n,guard){return slice.call(array,0,array.length-(null==n||guard?1:n))},_.last=function(array,n,guard){if(null!=array)return null==n||guard?array[array.length-1]:slice.call(array,Math.max(array.length-n,0))},_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,null==n||guard?1:n)},_.compact=function(array){return _.filter(array,_.identity)};var flatten=function(input,shallow,output){return shallow&&_.every(input,_.isArray)?concat.apply(output,input):(each(input,function(value){_.isArray(value)||_.isArguments(value)?shallow?push.apply(output,value):flatten(value,shallow,output):output.push(value)}),output)};_.flatten=function(array,shallow){return flatten(array,shallow,[])},_.without=function(array){return _.difference(array,slice.call(arguments,1))},_.uniq=_.unique=function(array,isSorted,iterator,context){_.isFunction(isSorted)&&(context=iterator,iterator=isSorted,isSorted=!1);var initial=iterator?_.map(array,iterator,context):array,results=[],seen=[];return each(initial,function(value,index){(isSorted?index&&seen[seen.length-1]===value:_.contains(seen,value))||(seen.push(value),results.push(array[index]))}),results},_.union=function(){return _.uniq(_.flatten(arguments,!0))},_.intersection=function(array){var rest=slice.call(arguments,1);return _.filter(_.uniq(array),function(item){return _.every(rest,function(other){return _.indexOf(other,item)>=0})})},_.difference=function(array){var rest=concat.apply(ArrayProto,slice.call(arguments,1));return _.filter(array,function(value){return!_.contains(rest,value)})},_.zip=function(){for(var length=_.max(_.pluck(arguments,"length").concat(0)),results=new Array(length),i=0;i<length;i++)results[i]=_.pluck(arguments,""+i);return results},_.object=function(list,values){if(null==list)return{};for(var result={},i=0,length=list.length;i<length;i++)values?result[list[i]]=values[i]:result[list[i][0]]=list[i][1];return result},_.indexOf=function(array,item,isSorted){if(null==array)return-1;var i=0,length=array.length;if(isSorted){if("number"!=typeof isSorted)return i=_.sortedIndex(array,item),array[i]===item?i:-1;i=isSorted<0?Math.max(0,length+isSorted):isSorted}if(nativeIndexOf&&array.indexOf===nativeIndexOf)return array.indexOf(item,isSorted);for(;i<length;i++)if(array[i]===item)return i;return-1},_.lastIndexOf=function(array,item,from){if(null==array)return-1;var hasIndex=null!=from;if(nativeLastIndexOf&&array.lastIndexOf===nativeLastIndexOf)return hasIndex?array.lastIndexOf(item,from):array.lastIndexOf(item);for(var i=hasIndex?from:array.length;i--;)if(array[i]===item)return i;return-1},_.range=function(start,stop,step){arguments.length<=1&&(stop=start||0,start=0),step=arguments[2]||1;for(var length=Math.max(Math.ceil((stop-start)/step),0),idx=0,range=new Array(length);idx<length;)range[idx++]=start,start+=step;return range};var ctor=function(){};_.bind=function(func,context){var args,bound;if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError;return args=slice.call(arguments,2),bound=function(){if(!(this instanceof bound))return func.apply(context,args.concat(slice.call(arguments)));ctor.prototype=func.prototype;var self=new ctor;ctor.prototype=null;var result=func.apply(self,args.concat(slice.call(arguments)));return Object(result)===result?result:self}},_.partial=function(func){var args=slice.call(arguments,1);return function(){return func.apply(this,args.concat(slice.call(arguments)))}},_.bindAll=function(obj){var funcs=slice.call(arguments,1);if(0===funcs.length)throw new Error("bindAll must be passed function names");return each(funcs,function(f){obj[f]=_.bind(obj[f],obj)}),obj},_.memoize=function(func,hasher){var memo={};return hasher||(hasher=_.identity),function(){var key=hasher.apply(this,arguments);return _.has(memo,key)?memo[key]:memo[key]=func.apply(this,arguments)}},_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args)},wait)},_.defer=function(func){return _.delay.apply(_,[func,1].concat(slice.call(arguments,1)))},_.throttle=function(func,wait,options){var context,args,result,timeout=null,previous=0;options||(options={});var later=function(){previous=!1===options.leading?0:new Date,timeout=null,result=func.apply(context,args)};return function(){var now=new Date;previous||!1!==options.leading||(previous=now);var remaining=wait-(now-previous);return context=this,args=arguments,remaining<=0?(clearTimeout(timeout),timeout=null,previous=now,result=func.apply(context,args)):timeout||!1===options.trailing||(timeout=setTimeout(later,remaining)),result}},_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result;return function(){context=this,args=arguments,timestamp=new Date;var later=function(){var last=new Date-timestamp;last<wait?timeout=setTimeout(later,wait-last):(timeout=null,immediate||(result=func.apply(context,args)))},callNow=immediate&&!timeout;return timeout||(timeout=setTimeout(later,wait)),callNow&&(result=func.apply(context,args)),result}},_.once=function(func){var memo,ran=!1;return function(){return ran?memo:(ran=!0,memo=func.apply(this,arguments),func=null,memo)}},_.wrap=function(func,wrapper){return function(){var args=[func];return push.apply(args,arguments),wrapper.apply(this,args)}},_.compose=function(){var funcs=arguments;return function(){for(var args=arguments,i=funcs.length-1;i>=0;i--)args=[funcs[i].apply(this,args)];return args[0]}},_.after=function(times,func){return function(){if(--times<1)return func.apply(this,arguments)}},_.keys=nativeKeys||function(obj){if(obj!==Object(obj))throw new TypeError("Invalid object");var keys=[];for(var key in obj)_.has(obj,key)&&keys.push(key);return keys},_.values=function(obj){for(var keys=_.keys(obj),length=keys.length,values=new Array(length),i=0;i<length;i++)values[i]=obj[keys[i]];return values},_.pairs=function(obj){for(var keys=_.keys(obj),length=keys.length,pairs=new Array(length),i=0;i<length;i++)pairs[i]=[keys[i],obj[keys[i]]];return pairs},_.invert=function(obj){for(var result={},keys=_.keys(obj),i=0,length=keys.length;i<length;i++)result[obj[keys[i]]]=keys[i];return result},_.functions=_.methods=function(obj){var names=[];for(var key in obj)_.isFunction(obj[key])&&names.push(key);return names.sort()},_.extend=function(obj){return each(slice.call(arguments,1),function(source){if(source)for(var prop in source)obj[prop]=source[prop]}),obj},_.pick=function(obj){var copy={},keys=concat.apply(ArrayProto,slice.call(arguments,1));return each(keys,function(key){key in obj&&(copy[key]=obj[key])}),copy},_.omit=function(obj){var copy={},keys=concat.apply(ArrayProto,slice.call(arguments,1));for(var key in obj)_.contains(keys,key)||(copy[key]=obj[key]);return copy},_.defaults=function(obj){return each(slice.call(arguments,1),function(source){if(source)for(var prop in source)void 0===obj[prop]&&(obj[prop]=source[prop])}),obj},_.clone=function(obj){return _.isObject(obj)?_.isArray(obj)?obj.slice():_.extend({},obj):obj},_.tap=function(obj,interceptor){return interceptor(obj),obj};var eq=function(a,b,aStack,bStack){if(a===b)return 0!==a||1/a==1/b;if(null==a||null==b)return a===b;a instanceof _&&(a=a._wrapped),b instanceof _&&(b=b._wrapped);var className=toString.call(a);if(className!=toString.call(b))return!1;switch(className){case"[object String]":return a==String(b);case"[object Number]":return a!=+a?b!=+b:0==a?1/a==1/b:a==+b;case"[object Date]":case"[object Boolean]":return+a==+b;case"[object RegExp]":return a.source==b.source&&a.global==b.global&&a.multiline==b.multiline&&a.ignoreCase==b.ignoreCase}if("object"!=typeof a||"object"!=typeof b)return!1;for(var length=aStack.length;length--;)if(aStack[length]==a)return bStack[length]==b;var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&aCtor instanceof aCtor&&_.isFunction(bCtor)&&bCtor instanceof bCtor))return!1;aStack.push(a),bStack.push(b);var size=0,result=!0;if("[object Array]"==className){if(size=a.length,result=size==b.length)for(;size--&&(result=eq(a[size],b[size],aStack,bStack)););}else{for(var key in a)if(_.has(a,key)&&(size++,!(result=_.has(b,key)&&eq(a[key],b[key],aStack,bStack))))break;if(result){for(key in b)if(_.has(b,key)&&!size--)break;result=!size}}return aStack.pop(),bStack.pop(),result};_.isEqual=function(a,b){return eq(a,b,[],[])},_.isEmpty=function(obj){if(null==obj)return!0;if(_.isArray(obj)||_.isString(obj))return 0===obj.length;for(var key in obj)if(_.has(obj,key))return!1;return!0},_.isElement=function(obj){return!(!obj||1!==obj.nodeType)},_.isArray=nativeIsArray||function(obj){return"[object Array]"==toString.call(obj)},_.isObject=function(obj){return obj===Object(obj)},each(["Arguments","Function","String","Number","Date","RegExp"],function(name){_["is"+name]=function(obj){return toString.call(obj)=="[object "+name+"]"}}),_.isArguments(arguments)||(_.isArguments=function(obj){return!(!obj||!_.has(obj,"callee"))}),_.isFunction=function(obj){return"function"==typeof obj},_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj))},_.isNaN=function(obj){return _.isNumber(obj)&&obj!=+obj},_.isBoolean=function(obj){return!0===obj||!1===obj||"[object Boolean]"==toString.call(obj)},_.isNull=function(obj){return null===obj},_.isUndefined=function(obj){return void 0===obj},_.has=function(obj,key){return hasOwnProperty.call(obj,key)},_.noConflict=function(){return root._=previousUnderscore,this},_.identity=function(value){return value},_.times=function(n,iterator,context){for(var accum=Array(Math.max(0,n)),i=0;i<n;i++)accum[i]=iterator.call(context,i);return accum},_.random=function(min,max){return null==max&&(max=min,min=0),min+Math.floor(Math.random()*(max-min+1))};var entityMap={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}};entityMap.unescape=_.invert(entityMap.escape);var entityRegexes={escape:new RegExp("["+_.keys(entityMap.escape).join("")+"]","g"),unescape:new RegExp("("+_.keys(entityMap.unescape).join("|")+")","g")};_.each(["escape","unescape"],function(method){_[method]=function(string){return null==string?"":(""+string).replace(entityRegexes[method],function(match){return entityMap[method][match]})}}),_.result=function(object,property){if(null!=object){var value=object[property];return _.isFunction(value)?value.call(object):value}},_.mixin=function(obj){each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];return push.apply(args,arguments),result.call(this,func.apply(_,args))}})};var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+"";return prefix?prefix+id:id},_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var noMatch=/(.)^/,escapes={"'":"'","\\":"\\","\r":"r","\n":"n","\t":"t","\u2028":"u2028","\u2029":"u2029"},escaper=/\\|'|\r|\n|\t|\u2028|\u2029/g;_.template=function(text,data,settings){var render;settings=_.defaults({},settings,_.templateSettings);var matcher=new RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join("|")+"|$","g"),index=0,source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){return source+=text.slice(index,offset).replace(escaper,function(match){return"\\"+escapes[match]}),escape&&(source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'"),interpolate&&(source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'"),evaluate&&(source+="';\n"+evaluate+"\n__p+='"),index=offset+match.length,match}),source+="';\n",settings.variable||(source="with(obj||{}){\n"+source+"}\n"),source="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+source+"return __p;\n";try{render=new Function(settings.variable||"obj","_",source)}catch(e){throw e.source=source,e}if(data)return render(data,_);var template=function(data){return render.call(this,data,_)};return template.source="function("+(settings.variable||"obj")+"){\n"+source+"}",template},_.chain=function(obj){return _(obj).chain()};var result=function(obj){return this._chain?_(obj).chain():obj};_.mixin(_),each(["pop","push","reverse","shift","sort","splice","unshift"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;return method.apply(obj,arguments),"shift"!=name&&"splice"!=name||0!==obj.length||delete obj[0],result.call(this,obj)}}),each(["concat","join","slice"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result.call(this,method.apply(this._wrapped,arguments))}}),_.extend(_.prototype,{chain:function(){return this._chain=!0,this},value:function(){return this._wrapped}})}).call(this)},{}],16:[function(require,module,exports){(function(){var root=this,previousHumanize=root.humanize,humanize={};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=humanize),exports.humanize=humanize):(void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(){return humanize}.call(exports,__webpack_require__,exports,module))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__),root.humanize=humanize),humanize.noConflict=function(){return root.humanize=previousHumanize,this},humanize.pad=function(str,count,padChar,type){if(str+="",padChar?padChar.length>1&&(padChar=padChar.charAt(0)):padChar=" ","right"===(type=void 0===type?"left":"right"))for(;str.length<count;)str+=padChar;else for(;str.length<count;)str=padChar+str;return str},humanize.time=function(){return(new Date).getTime()/1e3};var dayTableCommon=[0,0,31,59,90,120,151,181,212,243,273,304,334],dayTableLeap=[0,0,31,60,91,121,152,182,213,244,274,305,335];humanize.date=function(format,timestamp){var jsdate=void 0===timestamp?new Date:timestamp instanceof Date?new Date(timestamp):new Date(1e3*timestamp),formatChr=/\\?([a-z])/gi,formatChrCb=function(t,s){return f[t]?f[t]():s},shortDayTxt=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthTxt=["January","February","March","April","May","June","July","August","September","October","November","December"],f={d:function(){return humanize.pad(f.j(),2,"0")},D:function(){return f.l().slice(0,3)},j:function(){return jsdate.getDate()},l:function(){return shortDayTxt[f.w()]},N:function(){return f.w()||7},S:function(){var j=f.j();return j>4&&j<21?"th":{1:"st",2:"nd",3:"rd"}[j%10]||"th"},w:function(){return jsdate.getDay()},z:function(){return(f.L()?dayTableLeap[f.n()]:dayTableCommon[f.n()])+f.j()-1},W:function(){var midWeekDaysFromJan4=f.z()-f.N()+1.5;return humanize.pad(1+Math.floor(Math.abs(midWeekDaysFromJan4)/7)+(midWeekDaysFromJan4%7>3.5?1:0),2,"0")},F:function(){return monthTxt[jsdate.getMonth()]},m:function(){return humanize.pad(f.n(),2,"0")},M:function(){return f.F().slice(0,3)},n:function(){return jsdate.getMonth()+1},t:function(){return new Date(f.Y(),f.n(),0).getDate()},L:function(){return 1===new Date(f.Y(),1,29).getMonth()?1:0},o:function(){var n=f.n(),W=f.W();return f.Y()+(12===n&&W<9?-1:1===n&&W>9)},Y:function(){return jsdate.getFullYear()},y:function(){return String(f.Y()).slice(-2)},a:function(){return jsdate.getHours()>11?"pm":"am"},A:function(){return f.a().toUpperCase()},B:function(){var unixTime=jsdate.getTime()/1e3,secondsPassedToday=unixTime%86400+3600;secondsPassedToday<0&&(secondsPassedToday+=86400);var beats=secondsPassedToday/86.4%1e3;return unixTime<0?Math.ceil(beats):Math.floor(beats)},g:function(){return f.G()%12||12},G:function(){return jsdate.getHours()},h:function(){return humanize.pad(f.g(),2,"0")},H:function(){return humanize.pad(f.G(),2,"0")},i:function(){return humanize.pad(jsdate.getMinutes(),2,"0")},s:function(){return humanize.pad(jsdate.getSeconds(),2,"0")},u:function(){return humanize.pad(1e3*jsdate.getMilliseconds(),6,"0")},O:function(){var tzo=jsdate.getTimezoneOffset(),tzoNum=Math.abs(tzo);return(tzo>0?"-":"+")+humanize.pad(100*Math.floor(tzoNum/60)+tzoNum%60,4,"0")},P:function(){var O=f.O();return O.substr(0,3)+":"+O.substr(3,2)},Z:function(){return 60*-jsdate.getTimezoneOffset()},c:function(){return"Y-m-d\\TH:i:sP".replace(formatChr,formatChrCb)},r:function(){return"D, d M Y H:i:s O".replace(formatChr,formatChrCb)},U:function(){return jsdate.getTime()/1e3||0}};return format.replace(formatChr,formatChrCb)},humanize.numberFormat=function(number,decimals,decPoint,thousandsSep){decimals=isNaN(decimals)?2:Math.abs(decimals),decPoint=void 0===decPoint?".":decPoint,thousandsSep=void 0===thousandsSep?",":thousandsSep;var sign=number<0?"-":"";number=Math.abs(+number||0);var intPart=parseInt(number.toFixed(decimals),10)+"",j=intPart.length>3?intPart.length%3:0;return sign+(j?intPart.substr(0,j)+thousandsSep:"")+intPart.substr(j).replace(/(\d{3})(?=\d)/g,"$1"+thousandsSep)+(decimals?decPoint+Math.abs(number-intPart).toFixed(decimals).slice(2):"")},humanize.naturalDay=function(timestamp,format){timestamp=void 0===timestamp?humanize.time():timestamp,format=void 0===format?"Y-m-d":format;var d=new Date,today=new Date(d.getFullYear(),d.getMonth(),d.getDate()).getTime()/1e3;return timestamp<today&&timestamp>=today-86400?"yesterday":timestamp>=today&&timestamp<today+86400?"today":timestamp>=today+86400&&timestamp<today+172800?"tomorrow":humanize.date(format,timestamp)},humanize.relativeTime=function(timestamp){timestamp=void 0===timestamp?humanize.time():timestamp;var currTime=humanize.time(),timeDiff=currTime-timestamp;if(timeDiff<2&&timeDiff>-2)return(timeDiff>=0?"just ":"")+"now";if(timeDiff<60&&timeDiff>-60)return timeDiff>=0?Math.floor(timeDiff)+" seconds ago":"in "+Math.floor(-timeDiff)+" seconds";if(timeDiff<120&&timeDiff>-120)return timeDiff>=0?"about a minute ago":"in about a minute";if(timeDiff<3600&&timeDiff>-3600)return timeDiff>=0?Math.floor(timeDiff/60)+" minutes ago":"in "+Math.floor(-timeDiff/60)+" minutes";if(timeDiff<7200&&timeDiff>-7200)return timeDiff>=0?"about an hour ago":"in about an hour";if(timeDiff<86400&&timeDiff>-86400)return timeDiff>=0?Math.floor(timeDiff/3600)+" hours ago":"in "+Math.floor(-timeDiff/3600)+" hours";if(timeDiff<172800&&timeDiff>-172800)return timeDiff>=0?"1 day ago":"in 1 day";if(timeDiff<2505600&&timeDiff>-2505600)return timeDiff>=0?Math.floor(timeDiff/86400)+" days ago":"in "+Math.floor(-timeDiff/86400)+" days";if(timeDiff<5184e3&&timeDiff>-5184e3)return timeDiff>=0?"about a month ago":"in about a month";var currTimeYears=parseInt(humanize.date("Y",currTime),10),timestampYears=parseInt(humanize.date("Y",timestamp),10),currTimeMonths=12*currTimeYears+parseInt(humanize.date("n",currTime),10),timestampMonths=12*timestampYears+parseInt(humanize.date("n",timestamp),10),monthDiff=currTimeMonths-timestampMonths;if(monthDiff<12&&monthDiff>-12)return monthDiff>=0?monthDiff+" months ago":"in "+-monthDiff+" months";var yearDiff=currTimeYears-timestampYears;return yearDiff<2&&yearDiff>-2?yearDiff>=0?"a year ago":"in a year":yearDiff>=0?yearDiff+" years ago":"in "+-yearDiff+" years"},humanize.ordinal=function(number){number=parseInt(number,10),number=isNaN(number)?0:number;var sign=number<0?"-":"";number=Math.abs(number);var tens=number%100;return sign+number+(tens>4&&tens<21?"th":{1:"st",2:"nd",3:"rd"}[number%10]||"th")},humanize.filesize=function(filesize,kilo,decimals,decPoint,thousandsSep,suffixSep){return kilo=void 0===kilo?1024:kilo,filesize<=0?"0 bytes":(filesize<kilo&&void 0===decimals&&(decimals=0),void 0===suffixSep&&(suffixSep=" "),humanize.intword(filesize,["bytes","KB","MB","GB","TB","PB"],kilo,decimals,decPoint,thousandsSep,suffixSep))},humanize.intword=function(number,units,kilo,decimals,decPoint,thousandsSep,suffixSep){var humanized,unit;units=units||["","K","M","B","T"],unit=units.length-1,kilo=kilo||1e3,decimals=isNaN(decimals)?2:Math.abs(decimals),decPoint=decPoint||".",thousandsSep=thousandsSep||",",suffixSep=suffixSep||"";for(var i=0;i<units.length;i++)if(number<Math.pow(kilo,i+1)){unit=i;break}humanized=number/Math.pow(kilo,unit);var suffix=units[unit]?suffixSep+units[unit]:"";return humanize.numberFormat(humanized,decimals,decPoint,thousandsSep)+suffix},humanize.linebreaks=function(str){return str=str.replace(/^([\n|\r]*)/,""),str=str.replace(/([\n|\r]*)$/,""),str=str.replace(/(\r\n|\n|\r)/g,"\n"),str=str.replace(/(\n{2,})/g,"</p><p>"),"<p>"+(str=str.replace(/\n/g,"<br />"))+"</p>"},humanize.nl2br=function(str){return str.replace(/(\r\n|\n|\r)/g,"<br />")},humanize.truncatechars=function(string,length){return string.length<=length?string:string.substr(0,length)+"…"},humanize.truncatewords=function(string,numWords){var words=string.split(" ");return words.length<numWords?string:words.slice(0,numWords).join(" ")+"…"}}).call(this)},{}],17:[function(require,module,exports){(function(process){function dotNotation(obj,is,value){return obj.hasOwnProperty(is)?obj[is]:"string"==typeof is?dotNotation(obj,is.split("."),value):1===is.length&&void 0!==value?obj[is[0]]=value:0===is.length?obj:obj.hasOwnProperty(is[0])?dotNotation(obj[is[0]],is.slice(1),value):obj[is.join(".")]=is.join(".")}/**
 * @author  John Resig <jeresig@gmail.com>
 * @author  Originally by Marcus Spiegel <marcus.spiegel@gmail.com>
 * @link    https://github.com/jeresig/i18n-node
 * @license http://opensource.org/licenses/MIT
 *
 * @version 0.4.7
 */
var vsprintf=require("sprintf").vsprintf,fs=require("fs"),path=require("path"),i18n=module.exports=function(opt){var self=this;this.devMode="production"!==process.env.NODE_ENV;for(var prop in opt)this[prop]=opt[prop];"object"==typeof this.register&&i18n.resMethods.forEach(function(method){self.register[method]=self[method].bind(self)}),opt.locales&&opt.locales.forEach&&(this.locales={},opt.locales.forEach(function(locale){self.readFile(locale)}),this.defaultLocale=opt.locales[0]),this.setLocale(this.defaultLocale),this.locales[this.defaultLocale]||console.error("Not a valid default locale."),this.request&&(this.subdomain&&this.setLocaleFromSubdomain(this.request),!1!==this.query&&this.setLocaleFromQuery(this.request),!1!==this.session&&this.setLocaleFromSessionVar(this.request),this.prefLocale=this.preferredLocale(),!1!==this.prefLocale&&this.prefLocale!==this.locale&&this.setLocale(this.prefLocale))};i18n.version="0.4.7",i18n.localeCache={},i18n.resMethods=["__","__n","getLocale","isPreferredLocale"],i18n.expressBind=function(app,opt){app&&(app.use(function(req,res,next){opt.request=req,req.i18n=new i18n(opt),res.locals&&i18n.registerMethods(res.locals,req),next()}),app.dynamicHelpers&&app.dynamicHelpers(i18n.registerMethods({})))},i18n.registerMethods=function(helpers,req){return i18n.resMethods.forEach(function(method){helpers[method]=req?req.i18n[method].bind(req.i18n):function(req){return req.i18n[method].bind(req.i18n)}}),helpers},i18n.prototype={defaultLocale:"en",extension:".js",directory:"./locales",cookieName:"lang",sessionVarName:"locale",indent:"\t",parse:JSON.parse,dump:function(data,indent){return JSON.stringify(data,null,indent)},__:function(){var msg=this.translate(this.locale,arguments[0]);return arguments.length>1&&(msg=vsprintf(msg,Array.prototype.slice.call(arguments,1))),msg},__n:function(pathOrSingular,countOrPlural,additionalOrCount){var msg;if("number"==typeof countOrPlural){var path=pathOrSingular,count=countOrPlural;msg=this.translate(this.locale,path),msg=vsprintf(parseInt(count,10)>1?msg.other:msg.one,Array.prototype.slice.call(arguments,1))}else{var singular=pathOrSingular,plural=countOrPlural,count=additionalOrCount;msg=this.translate(this.locale,singular,plural),msg=vsprintf(parseInt(count,10)>1?msg.other:msg.one,[count]),arguments.length>3&&(msg=vsprintf(msg,Array.prototype.slice.call(arguments,3)))}return msg},setLocale:function(locale){if(locale)return this.locales[locale]||(this.devMode&&console.warn("Locale ("+locale+") not found."),locale=this.defaultLocale),this.locale=locale},getLocale:function(){return this.locale},isPreferredLocale:function(){return!this.prefLocale||this.prefLocale===this.getLocale()},setLocaleFromSessionVar:function(req){if((req=req||this.request)&&req.session&&req.session[this.sessionVarName]){var locale=req.session[this.sessionVarName];this.locales[locale]&&(this.devMode&&console.log("Overriding locale from query: "+locale),this.setLocale(locale))}},setLocaleFromQuery:function(req){if((req=req||this.request)&&req.query&&req.query.lang){var locale=(req.query.lang+"").toLowerCase();this.locales[locale]&&(this.devMode&&console.log("Overriding locale from query: "+locale),this.setLocale(locale))}},setLocaleFromSubdomain:function(req){(req=req||this.request)&&req.headers&&req.headers.host&&/^([^.]+)/.test(req.headers.host)&&this.locales[RegExp.$1]&&(this.devMode&&console.log("Overriding locale from host: "+RegExp.$1),this.setLocale(RegExp.$1))},setLocaleFromCookie:function(req){if((req=req||this.request)&&req.cookies&&this.cookieName&&req.cookies[this.cookieName]){var locale=req.cookies[this.cookieName].toLowerCase();this.locales[locale]&&(this.devMode&&console.log("Overriding locale from cookie: "+locale),this.setLocale(locale))}},setLocaleFromEnvironmentVariable:function(){if(process.env.LANG){var locale=process.env.LANG.split("_")[0];this.locales[locale]&&(this.devMode&&console.log("Overriding locale from environment variable: "+locale),this.setLocale(locale))}},preferredLocale:function(req){if((req=req||this.request)&&req.headers){for(var prefLocale,accept=req.headers["accept-language"]||"",regExp=/(^|,\s*)([a-z0-9-]+)/gi,self=this;!prefLocale&&(match=regExp.exec(accept));){var locale=match[2].toLowerCase(),parts=locale.split("-");self.locales[locale]?prefLocale=locale:parts.length>1&&self.locales[parts[0]]&&(prefLocale=parts[0])}return prefLocale||this.defaultLocale}},translate:function(locale,singular,plural){return locale&&this.locales[locale]||(this.devMode&&console.warn("WARN: No locale found. Using the default ("+this.defaultLocale+") as current locale"),locale=this.defaultLocale,this.initLocale(locale,{})),this.locales[locale][singular]||this.devMode&&(dotNotation(this.locales[locale],singular,plural?{one:singular,other:plural}:void 0),this.writeFile(locale)),dotNotation(this.locales[locale],singular,plural?{one:singular,other:plural}:void 0)},readFile:function(locale){var file=this.locateFile(locale);if(!this.devMode&&i18n.localeCache[file])return void this.initLocale(locale,i18n.localeCache[file]);try{var base,localeFile=fs.readFileSync(file);if("function"==typeof this.base){var baseFilename;try{baseFilename=this.base(locale)}catch(e){console.error("base function threw exception for locale %s",locale,e)}if("string"==typeof baseFilename)try{base=this.parse(fs.readFileSync(this.locateFile(baseFilename)))}catch(e){console.error("unable to read or parse base file %s for locale %s",baseFilename,locale,e)}}try{var content=this.parse(localeFile);if(base){for(var prop in content)base[prop]=content[prop];content=base}this.initLocale(locale,content)}catch(e){console.error("unable to parse locales from file (maybe "+file+" is empty or invalid "+this.extension+"?): ",e)}}catch(e){fs.existsSync(file)||this.writeFile(locale)}},writeFile:function(locale){if(!this.devMode)return void this.initLocale(locale,{});try{fs.lstatSync(this.directory)}catch(e){this.devMode&&console.log("creating locales dir in: "+this.directory),fs.mkdirSync(this.directory,493)}this.initLocale(locale,{});try{var target=this.locateFile(locale),tmp=target+".tmp";fs.writeFileSync(tmp,this.dump(this.locales[locale],this.indent),"utf8"),fs.statSync(tmp).isFile()?fs.renameSync(tmp,target):console.error("unable to write locales to file (either "+tmp+" or "+target+" are not writeable?): ")}catch(e){console.error("unexpected error writing files (either "+tmp+" or "+target+" are not writeable?): ",e)}},locateFile:function(locale){return path.normalize(this.directory+"/"+locale+this.extension)},initLocale:function(locale,data){if(!this.locales[locale]&&(this.locales[locale]=data,!this.devMode)){var file=this.locateFile(locale);i18n.localeCache[file]||(i18n.localeCache[file]=data)}}}}).call(this,require("_process"))},{_process:20,fs:1,path:19,sprintf:21}],18:[function(require,module,exports){module.exports=require("./i18n")},{"./i18n":17}],19:[function(require,module,exports){(function(process){function normalizeArray(parts,allowAboveRoot){for(var up=0,i=parts.length-1;i>=0;i--){var last=parts[i];"."===last?parts.splice(i,1):".."===last?(parts.splice(i,1),up++):up&&(parts.splice(i,1),up--)}if(allowAboveRoot)for(;up--;up)parts.unshift("..");return parts}function filter(xs,f){if(xs.filter)return xs.filter(f);for(var res=[],i=0;i<xs.length;i++)f(xs[i],i,xs)&&res.push(xs[i]);return res}var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,splitPath=function(filename){return splitPathRe.exec(filename).slice(1)};exports.resolve=function(){for(var resolvedPath="",resolvedAbsolute=!1,i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:process.cwd();if("string"!=typeof path)throw new TypeError("Arguments to path.resolve must be strings");path&&(resolvedPath=path+"/"+resolvedPath,resolvedAbsolute="/"===path.charAt(0))}return resolvedPath=normalizeArray(filter(resolvedPath.split("/"),function(p){return!!p}),!resolvedAbsolute).join("/"),(resolvedAbsolute?"/":"")+resolvedPath||"."},exports.normalize=function(path){var isAbsolute=exports.isAbsolute(path),trailingSlash="/"===substr(path,-1);return path=normalizeArray(filter(path.split("/"),function(p){return!!p}),!isAbsolute).join("/"),path||isAbsolute||(path="."),path&&trailingSlash&&(path+="/"),(isAbsolute?"/":"")+path},exports.isAbsolute=function(path){return"/"===path.charAt(0)},exports.join=function(){var paths=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(paths,function(p,index){if("string"!=typeof p)throw new TypeError("Arguments to path.join must be strings");return p}).join("/"))},exports.relative=function(from,to){function trim(arr){for(var start=0;start<arr.length&&""===arr[start];start++);for(var end=arr.length-1;end>=0&&""===arr[end];end--);return start>end?[]:arr.slice(start,end-start+1)}from=exports.resolve(from).substr(1),to=exports.resolve(to).substr(1);for(var fromParts=trim(from.split("/")),toParts=trim(to.split("/")),length=Math.min(fromParts.length,toParts.length),samePartsLength=length,i=0;i<length;i++)if(fromParts[i]!==toParts[i]){samePartsLength=i;break}for(var outputParts=[],i=samePartsLength;i<fromParts.length;i++)outputParts.push("..");return outputParts=outputParts.concat(toParts.slice(samePartsLength)),outputParts.join("/")},exports.sep="/",exports.delimiter=":",exports.dirname=function(path){var result=splitPath(path),root=result[0],dir=result[1];return root||dir?(dir&&(dir=dir.substr(0,dir.length-1)),root+dir):"."},exports.basename=function(path,ext){var f=splitPath(path)[2];return ext&&f.substr(-1*ext.length)===ext&&(f=f.substr(0,f.length-ext.length)),f},exports.extname=function(path){return splitPath(path)[3]};var substr="b"==="ab".substr(-1)?function(str,start,len){return str.substr(start,len)}:function(str,start,len){return start<0&&(start=str.length+start),str.substr(start,len)}}).call(this,require("_process"))},{_process:20}],20:[function(require,module,exports){function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(fun){if(cachedSetTimeout===setTimeout)return setTimeout(fun,0);if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout)return cachedSetTimeout=setTimeout,setTimeout(fun,0);try{return cachedSetTimeout(fun,0)}catch(e){try{return cachedSetTimeout.call(null,fun,0)}catch(e){return cachedSetTimeout.call(this,fun,0)}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout)return clearTimeout(marker);if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout)return cachedClearTimeout=clearTimeout,clearTimeout(marker);try{return cachedClearTimeout(marker)}catch(e){try{return cachedClearTimeout.call(null,marker)}catch(e){return cachedClearTimeout.call(this,marker)}}}function cleanUpNextTick(){draining&&currentQueue&&(draining=!1,currentQueue.length?queue=currentQueue.concat(queue):queueIndex=-1,queue.length&&drainQueue())}function drainQueue(){if(!draining){var timeout=runTimeout(cleanUpNextTick);draining=!0;for(var len=queue.length;len;){for(currentQueue=queue,queue=[];++queueIndex<len;)currentQueue&&currentQueue[queueIndex].run();queueIndex=-1,len=queue.length}currentQueue=null,draining=!1,runClearTimeout(timeout)}}function Item(fun,array){this.fun=fun,this.array=array}function noop(){}var cachedSetTimeout,cachedClearTimeout,process=module.exports={};!function(){try{cachedSetTimeout="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(e){cachedSetTimeout=defaultSetTimout}try{cachedClearTimeout="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(e){cachedClearTimeout=defaultClearTimeout}}();var currentQueue,queue=[],draining=!1,queueIndex=-1;process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)args[i-1]=arguments[i];queue.push(new Item(fun,args)),1!==queue.length||draining||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},process.title="browser",process.browser=!0,process.env={},process.argv=[],process.version="",process.versions={},process.on=noop,process.addListener=noop,process.once=noop,process.off=noop,process.removeListener=noop,process.removeAllListeners=noop,process.emit=noop,process.binding=function(name){throw new Error("process.binding is not supported")},process.cwd=function(){return"/"},process.chdir=function(dir){throw new Error("process.chdir is not supported")},process.umask=function(){return 0}},{}],21:[function(require,module,exports){var sprintf=function(){function get_type(variable){return Object.prototype.toString.call(variable).slice(8,-1).toLowerCase()}function str_repeat(input,multiplier){for(var output=[];multiplier>0;output[--multiplier]=input);return output.join("")}var str_format=function(){return str_format.cache.hasOwnProperty(arguments[0])||(str_format.cache[arguments[0]]=str_format.parse(arguments[0])),str_format.format.call(null,str_format.cache[arguments[0]],arguments)};return str_format.object_stringify=function(obj,depth,maxdepth,seen){var str="";if(null!=obj)switch(typeof obj){case"function":return"[Function"+(obj.name?": "+obj.name:"")+"]";case"object":if(obj instanceof Error)return"["+obj.toString()+"]";if(depth>=maxdepth)return"[Object]";if(seen&&(seen=seen.slice(0),seen.push(obj)),null!=obj.length){str+="[";var arr=[];for(var i in obj)seen&&seen.indexOf(obj[i])>=0?arr.push("[Circular]"):arr.push(str_format.object_stringify(obj[i],depth+1,maxdepth,seen));str+=arr.join(", ")+"]"}else{if("getMonth"in obj)return"Date("+obj+")";str+="{";var arr=[];for(var k in obj)obj.hasOwnProperty(k)&&(seen&&seen.indexOf(obj[k])>=0?arr.push(k+": [Circular]"):arr.push(k+": "+str_format.object_stringify(obj[k],depth+1,maxdepth,seen)));str+=arr.join(", ")+"}"}return str;case"string":return'"'+obj+'"'}return""+obj},str_format.format=function(parse_tree,argv){var arg,i,k,match,pad,pad_character,pad_length,cursor=1,tree_length=parse_tree.length,node_type="",output=[];for(i=0;i<tree_length;i++)if("string"===(node_type=get_type(parse_tree[i])))output.push(parse_tree[i]);else if("array"===node_type){if(match=parse_tree[i],match[2])for(arg=argv[cursor],k=0;k<match[2].length;k++){if(!arg.hasOwnProperty(match[2][k]))throw new Error(sprintf('[sprintf] property "%s" does not exist',match[2][k]));arg=arg[match[2][k]]}else arg=match[1]?argv[match[1]]:argv[cursor++];if(/[^sO]/.test(match[8])&&"number"!=get_type(arg))throw new Error(sprintf('[sprintf] expecting number but found %s "'+arg+'"',get_type(arg)));switch(match[8]){case"b":arg=arg.toString(2);break;case"c":arg=String.fromCharCode(arg);break;case"d":arg=parseInt(arg,10);break;case"e":arg=match[7]?arg.toExponential(match[7]):arg.toExponential();break;case"f":arg=match[7]?parseFloat(arg).toFixed(match[7]):parseFloat(arg);break;case"O":arg=str_format.object_stringify(arg,0,parseInt(match[7])||5);break;case"o":arg=arg.toString(8);break;case"s":arg=(arg=String(arg))&&match[7]?arg.substring(0,match[7]):arg;break;case"u":arg=Math.abs(arg);break;case"x":arg=arg.toString(16);break;case"X":arg=arg.toString(16).toUpperCase()}arg=/[def]/.test(match[8])&&match[3]&&arg>=0?"+"+arg:arg,pad_character=match[4]?"0"==match[4]?"0":match[4].charAt(1):" ",pad_length=match[6]-String(arg).length,pad=match[6]?str_repeat(pad_character,pad_length):"",output.push(match[5]?arg+pad:pad+arg)}return output.join("")},str_format.cache={},str_format.parse=function(fmt){for(var _fmt=fmt,match=[],parse_tree=[],arg_names=0;_fmt;){if(null!==(match=/^[^\x25]+/.exec(_fmt)))parse_tree.push(match[0]);else if(null!==(match=/^\x25{2}/.exec(_fmt)))parse_tree.push("%");else{if(null===(match=/^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosOuxX])/.exec(_fmt)))throw new Error("[sprintf] "+_fmt);if(match[2]){arg_names|=1;var field_list=[],replacement_field=match[2],field_match=[];if(null===(field_match=/^([a-z_][a-z_\d]*)/i.exec(replacement_field)))throw new Error("[sprintf] "+replacement_field);for(field_list.push(field_match[1]);""!==(replacement_field=replacement_field.substring(field_match[0].length));)if(null!==(field_match=/^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)))field_list.push(field_match[1]);else{if(null===(field_match=/^\[(\d+)\]/.exec(replacement_field)))throw new Error("[sprintf] "+replacement_field);field_list.push(field_match[1])}match[2]=field_list}else arg_names|=2;if(3===arg_names)throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");parse_tree.push(match)}_fmt=_fmt.substring(match[0].length)}return parse_tree},str_format}(),vsprintf=function(fmt,argv){var argvClone=argv.slice();return argvClone.unshift(fmt),sprintf.apply(null,argvClone)};module.exports=sprintf,sprintf.sprintf=sprintf,sprintf.vsprintf=vsprintf},{}],22:[function(require,module,exports){(function(){function createReduce(dir){function iterator(obj,iteratee,memo,keys,index,length){for(;index>=0&&index<length;index+=dir){var currentKey=keys?keys[index]:index;memo=iteratee(memo,obj[currentKey],currentKey,obj)}return memo}return function(obj,iteratee,memo,context){iteratee=optimizeCb(iteratee,context,4);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=dir>0?0:length-1;return arguments.length<3&&(memo=obj[keys?keys[index]:index],index+=dir),iterator(obj,iteratee,memo,keys,index,length)}}function createPredicateIndexFinder(dir){return function(array,predicate,context){predicate=cb(predicate,context);for(var length=getLength(array),index=dir>0?0:length-1;index>=0&&index<length;index+=dir)if(predicate(array[index],index,array))return index;return-1}}function createIndexFinder(dir,predicateFind,sortedIndex){return function(array,item,idx){var i=0,length=getLength(array);if("number"==typeof idx)dir>0?i=idx>=0?idx:Math.max(idx+length,i):length=idx>=0?Math.min(idx+1,length):idx+length+1;else if(sortedIndex&&idx&&length)return idx=sortedIndex(array,item),array[idx]===item?idx:-1;if(item!==item)return idx=predicateFind(slice.call(array,i,length),_.isNaN),idx>=0?idx+i:-1;for(idx=dir>0?i:length-1;idx>=0&&idx<length;idx+=dir)if(array[idx]===item)return idx;return-1}}function collectNonEnumProps(obj,keys){var nonEnumIdx=nonEnumerableProps.length,constructor=obj.constructor,proto=_.isFunction(constructor)&&constructor.prototype||ObjProto,prop="constructor";for(_.has(obj,prop)&&!_.contains(keys,prop)&&keys.push(prop);nonEnumIdx--;)(prop=nonEnumerableProps[nonEnumIdx])in obj&&obj[prop]!==proto[prop]&&!_.contains(keys,prop)&&keys.push(prop)}var root=this,previousUnderscore=root._,ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype,push=ArrayProto.push,slice=ArrayProto.slice,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty,nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind,nativeCreate=Object.create,Ctor=function(){},_=function(obj){return obj instanceof _?obj:this instanceof _?void(this._wrapped=obj):new _(obj)};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=_),exports._=_):root._=_,_.VERSION="1.8.3";var optimizeCb=function(func,context,argCount){if(void 0===context)return func;switch(null==argCount?3:argCount){case 1:return function(value){return func.call(context,value)};case 2:return function(value,other){return func.call(context,value,other)};case 3:return function(value,index,collection){return func.call(context,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(context,accumulator,value,index,collection)}}return function(){return func.apply(context,arguments)}},cb=function(value,context,argCount){return null==value?_.identity:_.isFunction(value)?optimizeCb(value,context,argCount):_.isObject(value)?_.matcher(value):_.property(value)};_.iteratee=function(value,context){return cb(value,context,1/0)};var createAssigner=function(keysFunc,undefinedOnly){return function(obj){var length=arguments.length;if(length<2||null==obj)return obj;for(var index=1;index<length;index++)for(var source=arguments[index],keys=keysFunc(source),l=keys.length,i=0;i<l;i++){var key=keys[i];undefinedOnly&&void 0!==obj[key]||(obj[key]=source[key])}return obj}},baseCreate=function(prototype){if(!_.isObject(prototype))return{};if(nativeCreate)return nativeCreate(prototype);Ctor.prototype=prototype;var result=new Ctor;return Ctor.prototype=null,result},property=function(key){return function(obj){return null==obj?void 0:obj[key]}},MAX_ARRAY_INDEX=Math.pow(2,53)-1,getLength=property("length"),isArrayLike=function(collection){var length=getLength(collection);return"number"==typeof length&&length>=0&&length<=MAX_ARRAY_INDEX};_.each=_.forEach=function(obj,iteratee,context){iteratee=optimizeCb(iteratee,context);var i,length;if(isArrayLike(obj))for(i=0,length=obj.length;i<length;i++)iteratee(obj[i],i,obj);else{var keys=_.keys(obj);for(i=0,length=keys.length;i<length;i++)iteratee(obj[keys[i]],keys[i],obj)}return obj},_.map=_.collect=function(obj,iteratee,context){iteratee=cb(iteratee,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,results=Array(length),index=0;index<length;index++){var currentKey=keys?keys[index]:index;results[index]=iteratee(obj[currentKey],currentKey,obj)}return results},_.reduce=_.foldl=_.inject=createReduce(1),_.reduceRight=_.foldr=createReduce(-1),_.find=_.detect=function(obj,predicate,context){var key;if(void 0!==(key=isArrayLike(obj)?_.findIndex(obj,predicate,context):_.findKey(obj,predicate,context))&&-1!==key)return obj[key]},_.filter=_.select=function(obj,predicate,context){var results=[];return predicate=cb(predicate,context),_.each(obj,function(value,index,list){predicate(value,index,list)&&results.push(value)}),results},_.reject=function(obj,predicate,context){return _.filter(obj,_.negate(cb(predicate)),context)},_.every=_.all=function(obj,predicate,context){predicate=cb(predicate,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(!predicate(obj[currentKey],currentKey,obj))return!1}return!0},_.some=_.any=function(obj,predicate,context){predicate=cb(predicate,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(predicate(obj[currentKey],currentKey,obj))return!0}return!1},_.contains=_.includes=_.include=function(obj,item,fromIndex,guard){return isArrayLike(obj)||(obj=_.values(obj)),("number"!=typeof fromIndex||guard)&&(fromIndex=0),_.indexOf(obj,item,fromIndex)>=0},_.invoke=function(obj,method){var args=slice.call(arguments,2),isFunc=_.isFunction(method);return _.map(obj,function(value){var func=isFunc?method:value[method];return null==func?func:func.apply(value,args)})},_.pluck=function(obj,key){return _.map(obj,_.property(key))},_.where=function(obj,attrs){return _.filter(obj,_.matcher(attrs))},_.findWhere=function(obj,attrs){return _.find(obj,_.matcher(attrs))},_.max=function(obj,iteratee,context){var value,computed,result=-1/0,lastComputed=-1/0;if(null==iteratee&&null!=obj){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++)(value=obj[i])>result&&(result=value)}else iteratee=cb(iteratee,context),_.each(obj,function(value,index,list){((computed=iteratee(value,index,list))>lastComputed||computed===-1/0&&result===-1/0)&&(result=value,lastComputed=computed)});return result},_.min=function(obj,iteratee,context){var value,computed,result=1/0,lastComputed=1/0;if(null==iteratee&&null!=obj){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++)(value=obj[i])<result&&(result=value)}else iteratee=cb(iteratee,context),_.each(obj,function(value,index,list){((computed=iteratee(value,index,list))<lastComputed||computed===1/0&&result===1/0)&&(result=value,lastComputed=computed)});return result},_.shuffle=function(obj){for(var rand,set=isArrayLike(obj)?obj:_.values(obj),length=set.length,shuffled=Array(length),index=0;index<length;index++)rand=_.random(0,index),rand!==index&&(shuffled[index]=shuffled[rand]),shuffled[rand]=set[index];return shuffled},_.sample=function(obj,n,guard){return null==n||guard?(isArrayLike(obj)||(obj=_.values(obj)),obj[_.random(obj.length-1)]):_.shuffle(obj).slice(0,Math.max(0,n))},_.sortBy=function(obj,iteratee,context){return iteratee=cb(iteratee,context),_.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iteratee(value,index,list)}}).sort(function(left,right){var a=left.criteria,b=right.criteria;if(a!==b){if(a>b||void 0===a)return 1;if(a<b||void 0===b)return-1}return left.index-right.index}),"value")};var group=function(behavior){return function(obj,iteratee,context){var result={};return iteratee=cb(iteratee,context),_.each(obj,function(value,index){var key=iteratee(value,index,obj);behavior(result,value,key)}),result}};_.groupBy=group(function(result,value,key){_.has(result,key)?result[key].push(value):result[key]=[value]}),_.indexBy=group(function(result,value,key){result[key]=value}),_.countBy=group(function(result,value,key){_.has(result,key)?result[key]++:result[key]=1}),_.toArray=function(obj){return obj?_.isArray(obj)?slice.call(obj):isArrayLike(obj)?_.map(obj,_.identity):_.values(obj):[]},_.size=function(obj){return null==obj?0:isArrayLike(obj)?obj.length:_.keys(obj).length},_.partition=function(obj,predicate,context){predicate=cb(predicate,context);var pass=[],fail=[];return _.each(obj,function(value,key,obj){(predicate(value,key,obj)?pass:fail).push(value)}),[pass,fail]},_.first=_.head=_.take=function(array,n,guard){if(null!=array)return null==n||guard?array[0]:_.initial(array,array.length-n)},_.initial=function(array,n,guard){return slice.call(array,0,Math.max(0,array.length-(null==n||guard?1:n)))},_.last=function(array,n,guard){if(null!=array)return null==n||guard?array[array.length-1]:_.rest(array,Math.max(0,array.length-n))},_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,null==n||guard?1:n)},_.compact=function(array){return _.filter(array,_.identity)};var flatten=function(input,shallow,strict,startIndex){for(var output=[],idx=0,i=startIndex||0,length=getLength(input);i<length;i++){var value=input[i];if(isArrayLike(value)&&(_.isArray(value)||_.isArguments(value))){shallow||(value=flatten(value,shallow,strict));var j=0,len=value.length;for(output.length+=len;j<len;)output[idx++]=value[j++]}else strict||(output[idx++]=value)}return output};_.flatten=function(array,shallow){return flatten(array,shallow,!1)},_.without=function(array){return _.difference(array,slice.call(arguments,1))},_.uniq=_.unique=function(array,isSorted,iteratee,context){_.isBoolean(isSorted)||(context=iteratee,iteratee=isSorted,isSorted=!1),null!=iteratee&&(iteratee=cb(iteratee,context));for(var result=[],seen=[],i=0,length=getLength(array);i<length;i++){var value=array[i],computed=iteratee?iteratee(value,i,array):value;isSorted?(i&&seen===computed||result.push(value),seen=computed):iteratee?_.contains(seen,computed)||(seen.push(computed),result.push(value)):_.contains(result,value)||result.push(value)}return result},_.union=function(){return _.uniq(flatten(arguments,!0,!0))},_.intersection=function(array){for(var result=[],argsLength=arguments.length,i=0,length=getLength(array);i<length;i++){var item=array[i];if(!_.contains(result,item)){for(var j=1;j<argsLength&&_.contains(arguments[j],item);j++);j===argsLength&&result.push(item)}}return result},_.difference=function(array){var rest=flatten(arguments,!0,!0,1);return _.filter(array,function(value){return!_.contains(rest,value)})},_.zip=function(){return _.unzip(arguments)},_.unzip=function(array){for(var length=array&&_.max(array,getLength).length||0,result=Array(length),index=0;index<length;index++)result[index]=_.pluck(array,index);return result},_.object=function(list,values){for(var result={},i=0,length=getLength(list);i<length;i++)values?result[list[i]]=values[i]:result[list[i][0]]=list[i][1];return result},_.findIndex=createPredicateIndexFinder(1),_.findLastIndex=createPredicateIndexFinder(-1),_.sortedIndex=function(array,obj,iteratee,context){iteratee=cb(iteratee,context,1);for(var value=iteratee(obj),low=0,high=getLength(array);low<high;){var mid=Math.floor((low+high)/2);iteratee(array[mid])<value?low=mid+1:high=mid}return low},_.indexOf=createIndexFinder(1,_.findIndex,_.sortedIndex),_.lastIndexOf=createIndexFinder(-1,_.findLastIndex),_.range=function(start,stop,step){null==stop&&(stop=start||0,start=0),step=step||1;for(var length=Math.max(Math.ceil((stop-start)/step),0),range=Array(length),idx=0;idx<length;idx++,start+=step)range[idx]=start;return range};var executeBound=function(sourceFunc,boundFunc,context,callingContext,args){if(!(callingContext instanceof boundFunc))return sourceFunc.apply(context,args);var self=baseCreate(sourceFunc.prototype),result=sourceFunc.apply(self,args);return _.isObject(result)?result:self};_.bind=function(func,context){if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError("Bind must be called on a function");var args=slice.call(arguments,2),bound=function(){return executeBound(func,bound,context,this,args.concat(slice.call(arguments)))};return bound},_.partial=function(func){var boundArgs=slice.call(arguments,1),bound=function(){for(var position=0,length=boundArgs.length,args=Array(length),i=0;i<length;i++)args[i]=boundArgs[i]===_?arguments[position++]:boundArgs[i];for(;position<arguments.length;)args.push(arguments[position++]);return executeBound(func,bound,this,this,args)};return bound},_.bindAll=function(obj){var i,key,length=arguments.length;if(length<=1)throw new Error("bindAll must be passed function names");for(i=1;i<length;i++)key=arguments[i],obj[key]=_.bind(obj[key],obj);return obj},_.memoize=function(func,hasher){var memoize=function(key){var cache=memoize.cache,address=""+(hasher?hasher.apply(this,arguments):key);return _.has(cache,address)||(cache[address]=func.apply(this,arguments)),cache[address]};return memoize.cache={},memoize},_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args)},wait)},_.defer=_.partial(_.delay,_,1),_.throttle=function(func,wait,options){var context,args,result,timeout=null,previous=0;options||(options={});var later=function(){previous=!1===options.leading?0:_.now(),timeout=null,result=func.apply(context,args),timeout||(context=args=null)};return function(){var now=_.now();previous||!1!==options.leading||(previous=now);var remaining=wait-(now-previous);return context=this,args=arguments,remaining<=0||remaining>wait?(timeout&&(clearTimeout(timeout),timeout=null),previous=now,result=func.apply(context,args),timeout||(context=args=null)):timeout||!1===options.trailing||(timeout=setTimeout(later,remaining)),result}},_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result,later=function(){var last=_.now()-timestamp;last<wait&&last>=0?timeout=setTimeout(later,wait-last):(timeout=null,immediate||(result=func.apply(context,args),timeout||(context=args=null)))};return function(){context=this,args=arguments,timestamp=_.now();var callNow=immediate&&!timeout;return timeout||(timeout=setTimeout(later,wait)),callNow&&(result=func.apply(context,args),context=args=null),result}},_.wrap=function(func,wrapper){return _.partial(wrapper,func)},_.negate=function(predicate){return function(){return!predicate.apply(this,arguments)}},_.compose=function(){var args=arguments,start=args.length-1;return function(){for(var i=start,result=args[start].apply(this,arguments);i--;)result=args[i].call(this,result);return result}},_.after=function(times,func){return function(){if(--times<1)return func.apply(this,arguments)}},_.before=function(times,func){var memo;return function(){return--times>0&&(memo=func.apply(this,arguments)),times<=1&&(func=null),memo}},_.once=_.partial(_.before,2);var hasEnumBug=!{toString:null}.propertyIsEnumerable("toString"),nonEnumerableProps=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];_.keys=function(obj){if(!_.isObject(obj))return[];if(nativeKeys)return nativeKeys(obj);var keys=[];for(var key in obj)_.has(obj,key)&&keys.push(key);return hasEnumBug&&collectNonEnumProps(obj,keys),keys},_.allKeys=function(obj){if(!_.isObject(obj))return[];var keys=[];for(var key in obj)keys.push(key);return hasEnumBug&&collectNonEnumProps(obj,keys),keys},_.values=function(obj){for(var keys=_.keys(obj),length=keys.length,values=Array(length),i=0;i<length;i++)values[i]=obj[keys[i]];return values},_.mapObject=function(obj,iteratee,context){iteratee=cb(iteratee,context);for(var currentKey,keys=_.keys(obj),length=keys.length,results={},index=0;index<length;index++)currentKey=keys[index],results[currentKey]=iteratee(obj[currentKey],currentKey,obj);return results},_.pairs=function(obj){for(var keys=_.keys(obj),length=keys.length,pairs=Array(length),i=0;i<length;i++)pairs[i]=[keys[i],obj[keys[i]]];return pairs},_.invert=function(obj){for(var result={},keys=_.keys(obj),i=0,length=keys.length;i<length;i++)result[obj[keys[i]]]=keys[i];return result},_.functions=_.methods=function(obj){var names=[];for(var key in obj)_.isFunction(obj[key])&&names.push(key);return names.sort()},_.extend=createAssigner(_.allKeys),_.extendOwn=_.assign=createAssigner(_.keys),_.findKey=function(obj,predicate,context){predicate=cb(predicate,context);for(var key,keys=_.keys(obj),i=0,length=keys.length;i<length;i++)if(key=keys[i],predicate(obj[key],key,obj))return key},_.pick=function(object,oiteratee,context){var iteratee,keys,result={},obj=object;if(null==obj)return result;_.isFunction(oiteratee)?(keys=_.allKeys(obj),iteratee=optimizeCb(oiteratee,context)):(keys=flatten(arguments,!1,!1,1),iteratee=function(value,key,obj){return key in obj},obj=Object(obj));for(var i=0,length=keys.length;i<length;i++){var key=keys[i],value=obj[key];iteratee(value,key,obj)&&(result[key]=value)}return result},_.omit=function(obj,iteratee,context){if(_.isFunction(iteratee))iteratee=_.negate(iteratee);else{var keys=_.map(flatten(arguments,!1,!1,1),String);iteratee=function(value,key){return!_.contains(keys,key)}}return _.pick(obj,iteratee,context)},_.defaults=createAssigner(_.allKeys,!0),_.create=function(prototype,props){var result=baseCreate(prototype);return props&&_.extendOwn(result,props),result},_.clone=function(obj){return _.isObject(obj)?_.isArray(obj)?obj.slice():_.extend({},obj):obj},_.tap=function(obj,interceptor){return interceptor(obj),obj},_.isMatch=function(object,attrs){var keys=_.keys(attrs),length=keys.length;if(null==object)return!length;for(var obj=Object(object),i=0;i<length;i++){var key=keys[i];if(attrs[key]!==obj[key]||!(key in obj))return!1}return!0};var eq=function(a,b,aStack,bStack){if(a===b)return 0!==a||1/a==1/b;if(null==a||null==b)return a===b;a instanceof _&&(a=a._wrapped),b instanceof _&&(b=b._wrapped);var className=toString.call(a);if(className!==toString.call(b))return!1;switch(className){case"[object RegExp]":case"[object String]":return""+a==""+b;case"[object Number]":return+a!=+a?+b!=+b:0==+a?1/+a==1/b:+a==+b;case"[object Date]":case"[object Boolean]":return+a==+b}var areArrays="[object Array]"===className;if(!areArrays){if("object"!=typeof a||"object"!=typeof b)return!1;var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&aCtor instanceof aCtor&&_.isFunction(bCtor)&&bCtor instanceof bCtor)&&"constructor"in a&&"constructor"in b)return!1}aStack=aStack||[],bStack=bStack||[];for(var length=aStack.length;length--;)if(aStack[length]===a)return bStack[length]===b;if(aStack.push(a),bStack.push(b),areArrays){if((length=a.length)!==b.length)return!1;for(;length--;)if(!eq(a[length],b[length],aStack,bStack))return!1}else{var key,keys=_.keys(a);if(length=keys.length,_.keys(b).length!==length)return!1;for(;length--;)if(key=keys[length],!_.has(b,key)||!eq(a[key],b[key],aStack,bStack))return!1}return aStack.pop(),bStack.pop(),!0};_.isEqual=function(a,b){return eq(a,b)},_.isEmpty=function(obj){return null==obj||(isArrayLike(obj)&&(_.isArray(obj)||_.isString(obj)||_.isArguments(obj))?0===obj.length:0===_.keys(obj).length)},_.isElement=function(obj){return!(!obj||1!==obj.nodeType)},_.isArray=nativeIsArray||function(obj){return"[object Array]"===toString.call(obj)},_.isObject=function(obj){var type=typeof obj;return"function"===type||"object"===type&&!!obj},_.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(name){_["is"+name]=function(obj){return toString.call(obj)==="[object "+name+"]"}}),_.isArguments(arguments)||(_.isArguments=function(obj){return _.has(obj,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(_.isFunction=function(obj){return"function"==typeof obj||!1}),_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj))},_.isNaN=function(obj){return _.isNumber(obj)&&obj!==+obj},_.isBoolean=function(obj){return!0===obj||!1===obj||"[object Boolean]"===toString.call(obj)},_.isNull=function(obj){return null===obj},_.isUndefined=function(obj){return void 0===obj},_.has=function(obj,key){return null!=obj&&hasOwnProperty.call(obj,key)},_.noConflict=function(){return root._=previousUnderscore,this},_.identity=function(value){return value},_.constant=function(value){return function(){return value}},_.noop=function(){},_.property=property,_.propertyOf=function(obj){return null==obj?function(){}:function(key){return obj[key]}},_.matcher=_.matches=function(attrs){return attrs=_.extendOwn({},attrs),function(obj){return _.isMatch(obj,attrs)}},_.times=function(n,iteratee,context){var accum=Array(Math.max(0,n));iteratee=optimizeCb(iteratee,context,1);for(var i=0;i<n;i++)accum[i]=iteratee(i);return accum},_.random=function(min,max){return null==max&&(max=min,min=0),min+Math.floor(Math.random()*(max-min+1))},_.now=Date.now||function(){return(new Date).getTime()};var escapeMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},unescapeMap=_.invert(escapeMap),createEscaper=function(map){var escaper=function(match){return map[match]},source="(?:"+_.keys(map).join("|")+")",testRegexp=RegExp(source),replaceRegexp=RegExp(source,"g");return function(string){return string=null==string?"":""+string,testRegexp.test(string)?string.replace(replaceRegexp,escaper):string}};_.escape=createEscaper(escapeMap),_.unescape=createEscaper(unescapeMap),_.result=function(object,property,fallback){var value=null==object?void 0:object[property];return void 0===value&&(value=fallback),_.isFunction(value)?value.call(object):value};var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+"";return prefix?prefix+id:id},_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var noMatch=/(.)^/,escapes={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},escaper=/\\|'|\r|\n|\u2028|\u2029/g,escapeChar=function(match){return"\\"+escapes[match]};_.template=function(text,settings,oldSettings){!settings&&oldSettings&&(settings=oldSettings),settings=_.defaults({},settings,_.templateSettings);var matcher=RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join("|")+"|$","g"),index=0,source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){return source+=text.slice(index,offset).replace(escaper,escapeChar),index=offset+match.length,escape?source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'":interpolate?source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'":evaluate&&(source+="';\n"+evaluate+"\n__p+='"),match}),source+="';\n",settings.variable||(source="with(obj||{}){\n"+source+"}\n"),source="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+source+"return __p;\n";try{var render=new Function(settings.variable||"obj","_",source)}catch(e){throw e.source=source,e}var template=function(data){return render.call(this,data,_)};return template.source="function("+(settings.variable||"obj")+"){\n"+source+"}",template},_.chain=function(obj){var instance=_(obj);return instance._chain=!0,instance};var result=function(instance,obj){return instance._chain?_(obj).chain():obj};_.mixin=function(obj){_.each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];return push.apply(args,arguments),result(this,func.apply(_,args))}})},_.mixin(_),_.each(["pop","push","reverse","shift","sort","splice","unshift"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;return method.apply(obj,arguments),"shift"!==name&&"splice"!==name||0!==obj.length||delete obj[0],result(this,obj)}}),_.each(["concat","join","slice"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result(this,method.apply(this._wrapped,arguments))}}),_.prototype.value=function(){return this._wrapped},_.prototype.valueOf=_.prototype.toJSON=_.prototype.value,_.prototype.toString=function(){return""+this._wrapped},__WEBPACK_AMD_DEFINE_ARRAY__=[],void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(){return _}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)}).call(this)},{}],23:[function(require,module,exports){var _=require("underscore"),geocrunch=require("geocrunch"),pad=function(num){return num<10?"0"+num.toString():num.toString()},ddToDms=function(coordinate,posSymbol,negSymbol){var dd=Math.abs(coordinate),d=Math.floor(dd),m=Math.floor(60*(dd-d)),s=Math.round(3600*(dd-d-m/60)*100)/100,directionSymbol=dd===coordinate?posSymbol:negSymbol;return pad(d)+"&deg; "+pad(m)+"' "+pad(s)+'" '+directionSymbol},measure=function(latlngs){var last=_.last(latlngs),path=geocrunch.path(_.map(latlngs,function(latlng){return[latlng.lng,latlng.lat]})),meters=path.distance({units:"meters"}),sqMeters=path.area({units:"sqmeters"});return{lastCoord:{dd:{x:last.lng,y:last.lat},dms:{x:ddToDms(last.lng,"E","W"),y:ddToDms(last.lat,"N","S")}},length:meters,area:sqMeters}};module.exports={measure:measure}},{geocrunch:7,underscore:22}],24:[function(require,module,exports){var selectOne=function(selector,el){return el||(el=document),el.querySelector(selector)},selectAll=function(selector,el){return el||(el=document),Array.prototype.slice.call(el.querySelectorAll(selector))},hide=function(el){if(el)return el.setAttribute("style","display:none;"),el},show=function(el){if(el)return el.removeAttribute("style"),el};module.exports={$:selectOne,$$:selectAll,hide:hide,show:show}},{}],25:[function(require,module,exports){module.exports={measure:"Medir",measureDistancesAndAreas:"Medeix distancies i àreas",createNewMeasurement:"Crear nova medicio",startCreating:"Començi a crear la medicio afegint punts al mapa",finishMeasurement:"Acabar la medició",lastPoint:"Últim punt",area:"Área",perimeter:"Perómetre",pointLocation:"Localizació del punt",areaMeasurement:"Medició d'área",linearMeasurement:"Medició lineal",pathDistance:"Distancia de ruta",centerOnArea:"Centrar en aquesta área",centerOnLine:"Centrar en aquesta línia",centerOnLocation:"Centrar en aquesta localizació",cancel:"Cancel·lar",delete:"Eliminar",acres:"Acres",feet:"Peus",kilometers:"Quilòmetres",hectares:"Hectàreas",meters:"Metros",miles:"Milles",sqfeet:"Peus cuadrats",sqmeters:"Metres cuadrats",sqmiles:"Milles cuadrades",decPoint:".",thousandsSep:" "}},{}],26:[function(require,module,exports){module.exports={measure:"测量",measureDistancesAndAreas:"同时测量距离和面积",createNewMeasurement:"开始一次新的测量",startCreating:"点击地图加点以开始创建测量",finishMeasurement:"完成测量",lastPoint:"最后点的坐标",area:"面积",perimeter:"周长",pointLocation:"点的坐标",areaMeasurement:"面积测量",linearMeasurement:"距离测量",pathDistance:"路径长度",centerOnArea:"该面积居中",centerOnLine:"该线段居中",centerOnLocation:"该位置居中",cancel:"取消",delete:"删除",acres:"公亩",feet:"英尺",kilometers:"公里",hectares:"公顷",meters:"米",miles:"英里",sqfeet:"平方英尺",sqmeters:"平方米",sqmiles:"平方英里",decPoint:".",thousandsSep:","}},{}],27:[function(require,module,exports){module.exports={measure:"Mål",measureDistancesAndAreas:"Mål afstande og arealer",createNewMeasurement:"Lav en ny måling",startCreating:"Begynd målingen ved at tilføje punkter på kortet",finishMeasurement:"Afslut måling",lastPoint:"Sidste punkt",area:"Areal",perimeter:"Omkreds",pointLocation:"Punkt",areaMeasurement:"Areal",linearMeasurement:"Linje",pathDistance:"Sti afstand",centerOnArea:"Centrér dette område",centerOnLine:"Centrér denne linje",centerOnLocation:"Centrér dette punkt",cancel:"Annuller",delete:"Slet",acres:"acre",feet:"fod",kilometers:"km",hectares:"ha",meters:"m",miles:"mil",sqfeet:"kvadratfod",sqmeters:"m²",sqmiles:"kvadratmil",decPoint:",",thousandsSep:"."}},{}],28:[function(require,module,exports){module.exports={measure:"Messung",measureDistancesAndAreas:"Messung von Abständen und Flächen",createNewMeasurement:"Eine neue Messung durchführen",startCreating:"Führen Sie die Messung durch, indem Sie der Karte Punkte hinzufügen.",finishMeasurement:"Messung beenden",lastPoint:"Letzter Punkt",area:"Fläche",perimeter:"Rand",pointLocation:"Lage des Punkts",areaMeasurement:"Gemessene Fläche",linearMeasurement:"Gemessener Abstand",pathDistance:"Abstand entlang des Pfads",centerOnArea:"Auf diese Fläche zentrieren",centerOnLine:"Auf diesen Linienzug zentrieren",centerOnLocation:"Auf diesen Ort zentrieren",cancel:"Abbrechen",delete:"Löschen",acres:"Morgen",feet:"Fuß",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Meilen",sqfeet:"Quadratfuß",sqmeters:"Quadratmeter",sqmiles:"Quadratmeilen",decPoint:",",thousandsSep:"."}},{}],29:[function(require,module,exports){module.exports={measure:"Messung",measureDistancesAndAreas:"Abstände und Flächen messen",createNewMeasurement:"Eine neue Messung durchführen",startCreating:"Messen sie, indem Sie der Karte Punkte hinzufügen",finishMeasurement:"Messung beenden",lastPoint:"Letzter Punkt",area:"Fläche",perimeter:"Umfang",pointLocation:"Lage des Punkts",areaMeasurement:"Fläche",linearMeasurement:"Abstand",pathDistance:"Umfang",centerOnArea:"Auf diese Fläche zentrieren",centerOnLine:"Auf diese Linie zentrieren",centerOnLocation:"Auf diesen Ort zentrieren",cancel:"Abbrechen",delete:"Löschen",acres:"Morgen",feet:"Fuß",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Meilen",sqfeet:"Quadratfuß",sqmeters:"Quadratmeter",sqmiles:"Quadratmeilen",decPoint:".",thousandsSep:"'"}},{}],30:[function(require,module,exports){module.exports={measure:"Measure",measureDistancesAndAreas:"Measure distances and areas",createNewMeasurement:"Create a new measurement",startCreating:"Start creating a measurement by adding points to the map",finishMeasurement:"Finish measurement",lastPoint:"Last point",area:"Area",perimeter:"Perimeter",pointLocation:"Point location",areaMeasurement:"Area measurement",linearMeasurement:"Linear measurement",pathDistance:"Path distance",centerOnArea:"Center on this area",centerOnLine:"Center on this line",centerOnLocation:"Center on this location",cancel:"Cancel",delete:"Delete",acres:"Acres",feet:"Feet",kilometers:"Kilometers",hectares:"Hectares",meters:"Meters",miles:"Miles",sqfeet:"Sq Feet",sqmeters:"Sq Meters",sqmiles:"Sq Miles",decPoint:".",thousandsSep:","}},{}],31:[function(require,module,exports){module.exports={measure:"Measure",measureDistancesAndAreas:"Measure distances and areas",createNewMeasurement:"Create a new measurement",startCreating:"Start creating a measurement by adding points to the map",finishMeasurement:"Finish measurement",lastPoint:"Last point",area:"Area",perimeter:"Perimeter",pointLocation:"Point location",areaMeasurement:"Area measurement",linearMeasurement:"Linear measurement",pathDistance:"Path distance",centerOnArea:"Centre on this area",centerOnLine:"Centre on this line",centerOnLocation:"Centre on this location",cancel:"Cancel",delete:"Delete",acres:"Acres",feet:"Feet",kilometers:"Kilometres",hectares:"Hectares",meters:"Meters",miles:"Miles",sqfeet:"Sq Feet",sqmeters:"Sq Meters",sqmiles:"Sq Miles",decPoint:".",thousandsSep:","}},{}],32:[function(require,module,exports){module.exports={measure:"Medición",measureDistancesAndAreas:"Mida distancias y áreas",createNewMeasurement:"Crear nueva medición",startCreating:"Empiece a crear la medición añadiendo puntos al mapa",finishMeasurement:"Terminar medición",lastPoint:"Último punto",area:"Área",perimeter:"Perímetro",pointLocation:"Localización del punto",areaMeasurement:"Medición de área",linearMeasurement:"Medición linear",pathDistance:"Distancia de ruta",centerOnArea:"Centrar en este área",centerOnLine:"Centrar en esta línea",centerOnLocation:"Centrar en esta localización",cancel:"Cancelar",delete:"Eliminar",acres:"Acres",feet:"Pies",kilometers:"Kilómetros",hectares:"Hectáreas",meters:"Metros",miles:"Millas",sqfeet:"Pies cuadrados",sqmeters:"Metros cuadrados",sqmiles:"Millas cuadradas",decPoint:".",thousandsSep:" "}},{}],33:[function(require,module,exports){module.exports={measure:"اندازه گیری",measureDistancesAndAreas:"اندازه گیری فاصله و مساحت",createNewMeasurement:"ثبت اندازه گیری جدید",startCreating:"برای ثبت اندازه گیری جدید نقاطی را به نقشه اضافه کنید.",finishMeasurement:"پایان اندازه گیری",lastPoint:"آخرین نقطه",area:"مساحت",perimeter:"محیط",pointLocation:"مکان نقطه",areaMeasurement:"اندازه گیری مساحت",linearMeasurement:"اندازه گیری خطی",pathDistance:"فاصله مسیر",centerOnArea:"مرکز این سطح",centerOnLine:"مرکز این خط",centerOnLocation:"مرکز این مکان",cancel:"لغو",delete:"حذف",acres:"ایکر",feet:"پا",kilometers:"کیلومتر",hectares:"هکتار",meters:"متر",miles:"مایل",sqfeet:"پا مربع",sqmeters:"متر مربع",sqmiles:"مایل مربع",decPoint:"/",thousandsSep:","}},{}],34:[function(require,module,exports){module.exports={measure:"Sukat",measureDistancesAndAreas:"Kalkulahin ang tamang distansya at sukat",createNewMeasurement:"Lumikha ng isang bagong pagsukat",startCreating:"Simulan ang paglikha ng isang pagsukat sa pamamagitan ng pagdaragdag ng mga puntos sa mapa",finishMeasurement:"Tapusin ang pagsukat",lastPoint:"Huling punto sa mapa",area:"Sukat",perimeter:"Palibot",pointLocation:"Lokasyon ng punto",areaMeasurement:"Kabuuang sukat",linearMeasurement:"Pagsukat ng guhit",pathDistance:"Distansya ng daanan",centerOnArea:"I-sentro sa lugar na ito",centerOnLine:"I-sentro sa linya na ito",centerOnLocation:"I-sentro sa lokasyong ito",cancel:"Kanselahin",delete:"Tanggalin",acres:"Acres",feet:"Talampakan",kilometers:"Kilometro",hectares:"Hektarya",meters:"Metro",miles:"Milya",sqfeet:"Talampakang Kwadrado",sqmeters:"Metro Kwadrado",sqmiles:"Milya Kwadrado",decPoint:".",thousandsSep:","}},{}],35:[function(require,module,exports){module.exports={measure:"Mesure",measureDistancesAndAreas:"Mesurer les distances et superficies",createNewMeasurement:"Créer une nouvelle mesure",startCreating:"Débuter la création d'une nouvelle mesure en ajoutant des points sur la carte",finishMeasurement:"Finir la mesure",lastPoint:"Dernier point",area:"Superficie",perimeter:"Périmètre",pointLocation:"Placement du point",areaMeasurement:"Mesure de superficie",linearMeasurement:"Mesure linéaire",pathDistance:"Distance du chemin",centerOnArea:"Centrer sur cette zone",centerOnLine:"Centrer sur cette ligne",centerOnLocation:"Centrer à cet endroit",cancel:"Annuler",delete:"Supprimer",acres:"Acres",feet:"Pieds",kilometers:"Kilomètres",hectares:"Hectares",meters:"Mètres",miles:"Miles",sqfeet:"Pieds carrés",sqmeters:"Mètres carrés",sqmiles:"Miles carrés",decPoint:",",thousandsSep:" "}},{}],36:[function(require,module,exports){module.exports={measure:"Misura",measureDistancesAndAreas:"Misura distanze e aree",createNewMeasurement:"Crea una nuova misurazione",startCreating:"Comincia a creare una misurazione aggiungendo punti alla mappa",finishMeasurement:"Misurazione conclusa",lastPoint:"Ultimo punto",area:"Area",perimeter:"Perimetro",pointLocation:"Posizione punto",areaMeasurement:"Misura area",linearMeasurement:"Misura lineare",pathDistance:"Distanza percorso",centerOnArea:"Centra su questa area",centerOnLine:"Centra su questa linea",centerOnLocation:"Centra su questa posizione",cancel:"Annulla",delete:"Cancella",acres:"Acri",feet:"Piedi",kilometers:"Chilometri",hectares:"Ettari",meters:"Metri",miles:"Miglia",sqfeet:"Piedi quadri",sqmeters:"Metri quadri",sqmiles:"Miglia quadre",decPoint:".",thousandsSep:","}},{}],37:[function(require,module,exports){module.exports={measure:"Meet",measureDistancesAndAreas:"Meet afstanden en oppervlakten",createNewMeasurement:"Maak een nieuwe meting",startCreating:"Begin een meting door punten toe te voegen aan de kaart",finishMeasurement:"Beëindig meting",lastPoint:"Laatste punt",area:"Oppervlakte",perimeter:"Omtrek",pointLocation:"Locatie punt",areaMeasurement:"Oppervlakte meting",linearMeasurement:"Gemeten afstand",pathDistance:"Afstand over de lijn",centerOnArea:"Centreer op dit gebied",centerOnLine:"Centreer op deze lijn",centerOnLocation:"Centreer op deze locatie",cancel:"Annuleer",delete:"Wis",acres:"are",feet:"Voet",kilometers:"km",hectares:"ha",meters:"m",miles:"Mijl",sqfeet:"Vierkante Feet",sqmeters:"m2",sqmiles:"Vierkante Mijl",decPoint:",",thousandsSep:"."}},{}],38:[function(require,module,exports){module.exports={measure:"Pomiar",measureDistancesAndAreas:"Pomiar odległości i powierzchni",createNewMeasurement:"Utwórz nowy pomiar",startCreating:"Rozpocznij tworzenie nowego pomiaru poprzez dodanie punktów na mapie",finishMeasurement:"Zakończ pomiar",lastPoint:"Ostatni punkt",area:"Powierzchnia",perimeter:"Obwód",pointLocation:"Punkt lokalizacji",areaMeasurement:"Pomiar powierzchni",linearMeasurement:"Pomiar liniowy",pathDistance:"Długość ścieżki",centerOnArea:"Środek tego obszaru",centerOnLine:"Środek tej linii",centerOnLocation:"Środek w tej lokalizacji",cancel:"Anuluj",delete:"Skasuj",acres:"akrów",feet:"stóp",kilometers:"kilometrów",hectares:"hektarów",meters:"metrów",miles:"mil",sqfeet:"stóp kwadratowych",sqmeters:"metrów kwadratowych",sqmiles:"mil kwadratowych",decPoint:",",thousandsSep:"."}},{}],39:[function(require,module,exports){module.exports={measure:"Medidas",measureDistancesAndAreas:"Mede distâncias e áreas",createNewMeasurement:"Criar nova medida",startCreating:"Comece criando uma medida, adicionando pontos no mapa",finishMeasurement:"Finalizar medida",lastPoint:"Último ponto",area:"Área",perimeter:"Perímetro",pointLocation:"Localização do ponto",areaMeasurement:"Medida de área",linearMeasurement:"Medida linear",pathDistance:"Distância",centerOnArea:"Centralizar nesta área",centerOnLine:"Centralizar nesta linha",centerOnLocation:"Centralizar nesta localização",cancel:"Cancelar",delete:"Excluir",acres:"Acres",feet:"Pés",kilometers:"Quilômetros",hectares:"Hectares",meters:"Metros",miles:"Milhas",sqfeet:"Pés²",sqmeters:"Metros²",sqmiles:"Milhas²",decPoint:",",thousandsSep:"."}},{}],40:[function(require,module,exports){module.exports={measure:"Medições",measureDistancesAndAreas:"Medir distâncias e áreas",createNewMeasurement:"Criar uma nova medição",startCreating:"Adicione pontos no mapa, para criar uma nova medição",finishMeasurement:"Finalizar medição",lastPoint:"Último ponto",area:"Área",perimeter:"Perímetro",pointLocation:"Localização do ponto",areaMeasurement:"Medição da área",linearMeasurement:"Medição linear",pathDistance:"Distância",centerOnArea:"Centrar nesta área",centerOnLine:"Centrar nesta linha",centerOnLocation:"Centrar nesta localização",cancel:"Cancelar",delete:"Eliminar",acres:"Acres",feet:"Pés",kilometers:"Kilômetros",hectares:"Hectares",meters:"Metros",miles:"Milhas",sqfeet:"Pés²",sqmeters:"Metros²",sqmiles:"Milhas²",decPoint:",",thousandsSep:"."}},{}],41:[function(require,module,exports){module.exports={measure:"Измерение",measureDistancesAndAreas:"Измерение расстояний и площади",createNewMeasurement:"Создать новое измерение",startCreating:"Для начала измерения добавьте точку на карту",finishMeasurement:"Закончить измерение",lastPoint:"Последняя точка",area:"Область",perimeter:"Периметр",pointLocation:"Местоположение точки",areaMeasurement:"Измерение области",linearMeasurement:"Линейное измерение",pathDistance:"Расстояние",centerOnArea:"Сфокусироваться на данной области",centerOnLine:"Сфокусироваться на данной линии",centerOnLocation:"Сфокусироваться на данной местности",cancel:"Отменить",delete:"Удалить",acres:"акры",feet:"фут",kilometers:"км",hectares:"га",meters:"м",miles:"миль",sqfeet:"футов²",sqmeters:"м²",sqmiles:"миль²",decPoint:".",thousandsSep:","}},{}],42:[function(require,module,exports){module.exports={measure:"Mäta",measureDistancesAndAreas:"Mäta avstånd och yta",createNewMeasurement:"Skapa ny mätning",startCreating:"Börja mätning genom att lägga till punkter på kartan",finishMeasurement:"Avsluta mätning",lastPoint:"Sista punkt",area:"Yta",perimeter:"Omkrets",pointLocation:"Punktens Läge",areaMeasurement:"Arealmätning",linearMeasurement:"Längdmätning",pathDistance:"Total linjelängd",centerOnArea:"Centrera på detta område",centerOnLine:"Centrera på denna linje",centerOnLocation:"Centrera på denna punkt",cancel:"Avbryt",delete:"Radera",acres:"Tunnland",feet:"Fot",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Miles",sqfeet:"Kvadratfot",sqmeters:"Kvadratmeter",sqmiles:"Kvadratmiles",decPoint:",",thousandsSep:" "}},{}],43:[function(require,module,exports){module.exports={measure:"Hesapla",measureDistancesAndAreas:"Uzaklık ve alan hesapla",createNewMeasurement:"Yeni hesaplama",startCreating:"Yeni nokta ekleyerek hesaplamaya başla",finishMeasurement:"Hesaplamayı bitir",lastPoint:"Son nokta",area:"Alan",perimeter:"Çevre uzunluğu",pointLocation:"Nokta yeri",areaMeasurement:"Alan hesaplaması",linearMeasurement:"Doğrusal hesaplama",pathDistance:"Yol uzunluğu",centerOnArea:"Bu alana odaklan",centerOnLine:"Bu doğtuya odaklan",centerOnLocation:"Bu yere odaklan",cancel:"Çıkış",delete:"Sil",acres:"Dönüm",feet:"Feet",kilometers:"Kilometre",hectares:"Hektar",meters:"Metre",miles:"Mil",sqfeet:"Feet kare",sqmeters:"Metre kare",sqmiles:"Mil kare",decPoint:".",thousandsSep:","}},{}],44:[function(require,module,exports){(function(global){var _=require("underscore"),L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,humanize=require("humanize"),units=require("./units"),calc=require("./calc"),dom=require("./dom"),$=dom.$,Symbology=require("./mapsymbology"),controlTemplate=_.template('<a class="<%= model.className %>-toggle js-toggle" href="#" title="<%= i18n.__(\'measureDistancesAndAreas\') %>"><%= i18n.__(\'measure\') %></a>\n<div class="<%= model.className %>-interaction js-interaction">\n  <div class="js-startprompt startprompt">\n    <h3><%= i18n.__(\'measureDistancesAndAreas\') %></h3>\n    <ul class="tasks">\n      <a href="#" class="js-start start"><%= i18n.__(\'createNewMeasurement\') %></a>\n    </ul>\n  </div>\n  <div class="js-measuringprompt">\n    <h3><%= i18n.__(\'measureDistancesAndAreas\') %></h3>\n    <p class="js-starthelp"><%= i18n.__(\'startCreating\') %></p>\n    <div class="js-results results"></div>\n    <ul class="js-measuretasks tasks">\n      <li><a href="#" class="js-cancel cancel"><%= i18n.__(\'cancel\') %></a></li>\n      <li><a href="#" class="js-finish finish"><%= i18n.__(\'finishMeasurement\') %></a></li>\n    </ul>\n  </div>\n</div>'),resultsTemplate=_.template('<div class="group">\n<p class="lastpoint heading"><%= i18n.__(\'lastPoint\') %></p>\n<p><%= model.lastCoord.dms.y %> <span class="coorddivider">/</span> <%= model.lastCoord.dms.x %></p>\n<p><%= humanize.numberFormat(model.lastCoord.dd.y, 6) %> <span class="coorddivider">/</span> <%= humanize.numberFormat(model.lastCoord.dd.x, 6) %></p>\n</div>\n<% if (model.pointCount > 1) { %>\n<div class="group">\n<p><span class="heading"><%= i18n.__(\'pathDistance\') %></span> <%= model.lengthDisplay %></p>\n</div>\n<% } %>\n<% if (model.pointCount > 2) { %>\n<div class="group">\n<p><span class="heading"><%= i18n.__(\'area\') %></span> <%= model.areaDisplay %></p>\n</div>\n<% } %>'),pointPopupTemplate=_.template('<h3><%= i18n.__(\'pointLocation\') %></h3>\n<p><%= model.lastCoord.dms.y %> <span class="coorddivider">/</span> <%= model.lastCoord.dms.x %></p>\n<p><%= humanize.numberFormat(model.lastCoord.dd.y, 6) %> <span class="coorddivider">/</span> <%= humanize.numberFormat(model.lastCoord.dd.x, 6) %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnLocation\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),linePopupTemplate=_.template('<h3><%= i18n.__(\'linearMeasurement\') %></h3>\n<p><%= model.lengthDisplay %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnLine\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),areaPopupTemplate=_.template('<h3><%= i18n.__(\'areaMeasurement\') %></h3>\n<p><%= model.areaDisplay %></p>\n<p><%= model.lengthDisplay %> <%= i18n.__(\'perimeter\') %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnArea\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),i18n=new(require("i18n-2"))({devMode:!1,locales:{ca:require("./i18n/ca"),cn:require("./i18n/cn"),da:require("./i18n/da"),de:require("./i18n/de"),de_CH:require("./i18n/de_CH"),en:require("./i18n/en"),en_UK:require("./i18n/en_UK"),es:require("./i18n/es"),fa:require("./i18n/fa"),fil_PH:require("./i18n/fil_PH"),fr:require("./i18n/fr"),it:require("./i18n/it"),nl:require("./i18n/nl"),pl:require("./i18n/pl"),pt_BR:require("./i18n/pt_BR"),pt_PT:require("./i18n/pt_PT"),ru:require("./i18n/ru"),sv:require("./i18n/sv"),tr:require("./i18n/tr")}});L.Control.Measure=L.Control.extend({_className:"leaflet-control-measure",options:{units:{},position:"topright",primaryLengthUnit:"feet",secondaryLengthUnit:"miles",primaryAreaUnit:"acres",activeColor:"#ABE67E",completedColor:"#C8F2BE",captureZIndex:1e4,popupOptions:{className:"leaflet-measure-resultpopup",autoPanPadding:[10,10]}},initialize:function(options){L.setOptions(this,options),this.options.units=L.extend({},units,this.options.units),this._symbols=new Symbology(_.pick(this.options,"activeColor","completedColor")),i18n.setLocale(this.options.localization)},onAdd:function(map){return this._map=map,this._latlngs=[],this._initLayout(),map.on("click",this._collapse,this),this._layer=L.layerGroup().addTo(map),this._container},onRemove:function(map){map.off("click",this._collapse,this),map.removeLayer(this._layer)},_initLayout:function(){var $toggle,$start,$cancel,$finish,className=this._className,container=this._container=L.DomUtil.create("div",className);container.innerHTML=controlTemplate({model:{className:className},i18n:i18n}),container.setAttribute("aria-haspopup",!0),L.Browser.touch?L.DomEvent.on(container,"click",L.DomEvent.stopPropagation):(L.DomEvent.disableClickPropagation(container),L.DomEvent.disableScrollPropagation(container)),$toggle=this.$toggle=$(".js-toggle",container),this.$interaction=$(".js-interaction",container),$start=$(".js-start",container),$cancel=$(".js-cancel",container),$finish=$(".js-finish",container),this.$startPrompt=$(".js-startprompt",container),this.$measuringPrompt=$(".js-measuringprompt",container),this.$startHelp=$(".js-starthelp",container),this.$results=$(".js-results",container),this.$measureTasks=$(".js-measuretasks",container),this._collapse(),this._updateMeasureNotStarted(),L.Browser.android||(L.DomEvent.on(container,"mouseenter",this._expand,this),L.DomEvent.on(container,"mouseleave",this._collapse,this)),L.DomEvent.on($toggle,"click",L.DomEvent.stop),L.Browser.touch?L.DomEvent.on($toggle,"click",this._expand,this):L.DomEvent.on($toggle,"focus",this._expand,this),L.DomEvent.on($start,"click",L.DomEvent.stop),L.DomEvent.on($start,"click",this._startMeasure,this),L.DomEvent.on($cancel,"click",L.DomEvent.stop),L.DomEvent.on($cancel,"click",this._finishMeasure,this),L.DomEvent.on($finish,"click",L.DomEvent.stop),L.DomEvent.on($finish,"click",this._handleMeasureDoubleClick,this)},_expand:function(){dom.hide(this.$toggle),dom.show(this.$interaction)},_collapse:function(){this._locked||(dom.hide(this.$interaction),dom.show(this.$toggle))},_updateMeasureNotStarted:function(){dom.hide(this.$startHelp),dom.hide(this.$results),dom.hide(this.$measureTasks),dom.hide(this.$measuringPrompt),dom.show(this.$startPrompt)},_updateMeasureStartedNoPoints:function(){dom.hide(this.$results),dom.show(this.$startHelp),dom.show(this.$measureTasks),dom.hide(this.$startPrompt),dom.show(this.$measuringPrompt)},_updateMeasureStartedWithPoints:function(){dom.hide(this.$startHelp),dom.show(this.$results),dom.show(this.$measureTasks),dom.hide(this.$startPrompt),dom.show(this.$measuringPrompt)},_startMeasure:function(){this._locked=!0,this._measureVertexes=L.featureGroup().addTo(this._layer),this._captureMarker=L.marker(this._map.getCenter(),{clickable:!0,zIndexOffset:this.options.captureZIndex,opacity:0}).addTo(this._layer),this._setCaptureMarkerIcon(),this._captureMarker.on("mouseout",this._handleMapMouseOut,this).on("dblclick",this._handleMeasureDoubleClick,this).on("click",this._handleMeasureClick,this),this._map.on("mousemove",this._handleMeasureMove,this).on("mouseout",this._handleMapMouseOut,this).on("move",this._centerCaptureMarker,this).on("resize",this._setCaptureMarkerIcon,this),L.DomEvent.on(this._container,"mouseenter",this._handleMapMouseOut,this),this._updateMeasureStartedNoPoints(),this._map.fire("measurestart",null,!1)},_finishMeasure:function(){var model=_.extend({},this._resultsModel,{points:this._latlngs});this._locked=!1,L.DomEvent.off(this._container,"mouseover",this._handleMapMouseOut,this),this._clearMeasure(),this._captureMarker.off("mouseout",this._handleMapMouseOut,this).off("dblclick",this._handleMeasureDoubleClick,this).off("click",this._handleMeasureClick,this),this._map.off("mousemove",this._handleMeasureMove,this).off("mouseout",this._handleMapMouseOut,this).off("move",this._centerCaptureMarker,this).off("resize",this._setCaptureMarkerIcon,this),this._layer.removeLayer(this._measureVertexes).removeLayer(this._captureMarker),this._measureVertexes=null,this._updateMeasureNotStarted(),this._collapse(),this._map.fire("measurefinish",model,!1)},_clearMeasure:function(){this._latlngs=[],this._resultsModel=null,this._measureVertexes.clearLayers(),this._measureDrag&&this._layer.removeLayer(this._measureDrag),this._measureArea&&this._layer.removeLayer(this._measureArea),this._measureBoundary&&this._layer.removeLayer(this._measureBoundary),this._measureDrag=null,this._measureArea=null,this._measureBoundary=null},_centerCaptureMarker:function(){this._captureMarker.setLatLng(this._map.getCenter())},_setCaptureMarkerIcon:function(){this._captureMarker.setIcon(L.divIcon({iconSize:this._map.getSize().multiplyBy(2)}))},_getMeasurementDisplayStrings:function(measurement){function buildDisplay(val,primaryUnit,secondaryUnit,decPoint,thousandsSep){var display;return primaryUnit&&unitDefinitions[primaryUnit]?(display=formatMeasure(val,unitDefinitions[primaryUnit],decPoint,thousandsSep),secondaryUnit&&unitDefinitions[secondaryUnit]&&(display=display+" ("+formatMeasure(val,unitDefinitions[secondaryUnit],decPoint,thousandsSep)+")")):display=formatMeasure(val,null,decPoint,thousandsSep),display}function formatMeasure(val,unit,decPoint,thousandsSep){return unit&&unit.factor&&unit.display?humanize.numberFormat(val*unit.factor,unit.decimals||0,decPoint||i18n.__("decPoint"),thousandsSep||i18n.__("thousandsSep"))+" "+i18n.__([unit.display])||unit.display:humanize.numberFormat(val,0,decPoint||i18n.__("decPoint"),thousandsSep||i18n.__("thousandsSep"))}var unitDefinitions=this.options.units;return{lengthDisplay:buildDisplay(measurement.length,this.options.primaryLengthUnit,this.options.secondaryLengthUnit,this.options.decPoint,this.options.thousandsSep),areaDisplay:buildDisplay(measurement.area,this.options.primaryAreaUnit,this.options.secondaryAreaUnit,this.options.decPoint,this.options.thousandsSep)}},_updateResults:function(){var calced=calc.measure(this._latlngs),resultsModel=this._resultsModel=_.extend({},calced,this._getMeasurementDisplayStrings(calced),{pointCount:this._latlngs.length});this.$results.innerHTML=resultsTemplate({model:resultsModel,humanize:humanize,i18n:i18n})},_handleMeasureMove:function(evt){this._measureDrag?this._measureDrag.setLatLng(evt.latlng):this._measureDrag=L.circleMarker(evt.latlng,this._symbols.getSymbol("measureDrag")).addTo(this._layer),this._measureDrag.bringToFront()},_handleMeasureDoubleClick:function(){var calced,resultFeature,popupContainer,popupContent,zoomLink,deleteLink,latlngs=this._latlngs;this._finishMeasure(),latlngs.length&&(latlngs.length>2&&latlngs.push(_.first(latlngs)),calced=calc.measure(latlngs),1===latlngs.length?(resultFeature=L.circleMarker(latlngs[0],this._symbols.getSymbol("resultPoint")),popupContent=pointPopupTemplate({model:calced,humanize:humanize,i18n:i18n})):2===latlngs.length?(resultFeature=L.polyline(latlngs,this._symbols.getSymbol("resultLine")),popupContent=linePopupTemplate({model:_.extend({},calced,this._getMeasurementDisplayStrings(calced)),humanize:humanize,i18n:i18n})):(resultFeature=L.polygon(latlngs,this._symbols.getSymbol("resultArea")),popupContent=areaPopupTemplate({model:_.extend({},calced,this._getMeasurementDisplayStrings(calced)),humanize:humanize,i18n:i18n})),popupContainer=L.DomUtil.create("div",""),popupContainer.innerHTML=popupContent,zoomLink=$(".js-zoomto",popupContainer),zoomLink&&(L.DomEvent.on(zoomLink,"click",L.DomEvent.stop),L.DomEvent.on(zoomLink,"click",function(){resultFeature.getBounds?this._map.fitBounds(resultFeature.getBounds(),{padding:[20,20],maxZoom:17}):resultFeature.getLatLng&&this._map.panTo(resultFeature.getLatLng())},this)),deleteLink=$(".js-deletemarkup",popupContainer),deleteLink&&(L.DomEvent.on(deleteLink,"click",L.DomEvent.stop),L.DomEvent.on(deleteLink,"click",function(){this._layer.removeLayer(resultFeature)},this)),resultFeature.addTo(this._layer),resultFeature.bindPopup(popupContainer,this.options.popupOptions),resultFeature.getBounds?resultFeature.openPopup(resultFeature.getBounds().getCenter()):resultFeature.getLatLng&&resultFeature.openPopup(resultFeature.getLatLng()))},_handleMeasureClick:function(evt){var latlng=this._map.mouseEventToLatLng(evt.originalEvent),lastClick=_.last(this._latlngs),vertexSymbol=this._symbols.getSymbol("measureVertex");lastClick&&latlng.equals(lastClick)||(this._latlngs.push(latlng),this._addMeasureArea(this._latlngs),this._addMeasureBoundary(this._latlngs),this._measureVertexes.eachLayer(function(layer){layer.setStyle(vertexSymbol),layer._path.setAttribute("class",vertexSymbol.className)}),this._addNewVertex(latlng),this._measureBoundary&&this._measureBoundary.bringToFront(),this._measureVertexes.bringToFront()),this._updateResults(),this._updateMeasureStartedWithPoints()},_handleMapMouseOut:function(){this._measureDrag&&(this._layer.removeLayer(this._measureDrag),this._measureDrag=null)},_addNewVertex:function(latlng){L.circleMarker(latlng,this._symbols.getSymbol("measureVertexActive")).addTo(this._measureVertexes)},_addMeasureArea:function(latlngs){if(latlngs.length<3)return void(this._measureArea&&(this._layer.removeLayer(this._measureArea),this._measureArea=null));this._measureArea?this._measureArea.setLatLngs(latlngs):this._measureArea=L.polygon(latlngs,this._symbols.getSymbol("measureArea")).addTo(this._layer)},_addMeasureBoundary:function(latlngs){if(latlngs.length<2)return void(this._measureBoundary&&(this._layer.removeLayer(this._measureBoundary),this._measureBoundary=null));this._measureBoundary?this._measureBoundary.setLatLngs(latlngs):this._measureBoundary=L.polyline(latlngs,this._symbols.getSymbol("measureBoundary")).addTo(this._layer)}}),L.Map.mergeOptions({measureControl:!1}),L.Map.addInitHook(function(){this.options.measureControl&&(this.measureControl=(new L.Control.Measure).addTo(this))}),L.control.measure=function(options){return new L.Control.Measure(options)}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./calc":23,"./dom":24,"./i18n/ca":25,"./i18n/cn":26,"./i18n/da":27,"./i18n/de":28,"./i18n/de_CH":29,"./i18n/en":30,"./i18n/en_UK":31,"./i18n/es":32,"./i18n/fa":33,"./i18n/fil_PH":34,"./i18n/fr":35,"./i18n/it":36,"./i18n/nl":37,"./i18n/pl":38,"./i18n/pt_BR":39,"./i18n/pt_PT":40,"./i18n/ru":41,"./i18n/sv":42,"./i18n/tr":43,"./mapsymbology":45,"./units":46,humanize:16,"i18n-2":18,underscore:22}],45:[function(require,module,exports){var _=require("underscore"),color=require("color"),Symbology=function(options){this.setOptions(options)};Symbology.DEFAULTS={activeColor:"#ABE67E",completedColor:"#C8F2BE"},_.extend(Symbology.prototype,{setOptions:function(options){return this._options=_.extend({},Symbology.DEFAULTS,this._options,options),this},getSymbol:function(name){return{measureDrag:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:.7,fillColor:this._options.activeColor,fillOpacity:.5,className:"layer-measuredrag"},measureArea:{clickable:!1,stroke:!1,fillColor:this._options.activeColor,fillOpacity:.2,className:"layer-measurearea"},measureBoundary:{clickable:!1,color:this._options.activeColor,weight:2,opacity:.9,fill:!1,className:"layer-measureboundary"},measureVertex:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:1,fillColor:this._options.activeColor,fillOpacity:.7,className:"layer-measurevertex"},measureVertexActive:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:1,fillColor:color(this._options.activeColor).darken(.15),fillOpacity:.7,className:"layer-measurevertex active"},resultArea:{clickable:!0,color:this._options.completedColor,weight:2,opacity:.9,fillColor:this._options.completedColor,fillOpacity:.2,className:"layer-measure-resultarea"},resultLine:{clickable:!0,color:this._options.completedColor,weight:3,opacity:.9,fill:!1,className:"layer-measure-resultline"},resultPoint:{clickable:!0,radius:4,color:this._options.completedColor,weight:2,opacity:1,fillColor:this._options.completedColor,fillOpacity:.7,className:"layer-measure-resultpoint"}}[name]}}),module.exports=Symbology},{color:6,underscore:22}],46:[function(require,module,exports){module.exports={acres:{factor:24711e-8,display:"acres",decimals:2},feet:{factor:3.2808,display:"feet",decimals:0},kilometers:{factor:.001,display:"kilometers",decimals:2},hectares:{factor:1e-4,display:"hectares",decimals:2},meters:{factor:1,display:"meters",decimals:0},miles:{factor:3.2808/5280,display:"miles",decimals:2},sqfeet:{factor:10.7639,display:"sqfeet",decimals:0},sqmeters:{factor:1,display:"sqmeters",decimals:0},sqmiles:{factor:3.86102e-7,display:"sqmiles",decimals:2}}},{}]},{},[44])}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){var content=__webpack_require__(160);"string"==typeof content&&(content=[[module.i,content,""]]);var options={hmr:!0};options.transform=void 0,options.insertInto=void 0;__webpack_require__(182)(content,options);content.locals&&(module.exports=content.locals)},function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(10)(!1),exports.i(__webpack_require__(161),""),exports.i(__webpack_require__(165),""),exports.i(__webpack_require__(166),""),exports.i(__webpack_require__(169),""),exports.push([module.i,'.leaflet-dhis2 {\n  background: #fff; }\n  .leaflet-dhis2 .leaflet-bar {\n    border-radius: 0; }\n    .leaflet-dhis2 .leaflet-bar a:first-child, .leaflet-dhis2 .leaflet-bar a:last-child {\n      border-radius: 0; }\n  .leaflet-dhis2.leaflet-touch .leaflet-bar {\n    border: 0;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n    .leaflet-dhis2.leaflet-touch .leaflet-bar a {\n      width: 26px;\n      height: 26px;\n      line-height: 26px;\n      font-size: 20px; }\n  .leaflet-dhis2 .leaflet-control-attribution {\n    font-size: 9px; }\n    .leaflet-dhis2 .leaflet-control-attribution a {\n      color: #333; }\n  .leaflet-dhis2 .leaflet-control-layers {\n    border-radius: 0; }\n  .leaflet-dhis2 .leaflet-control-scale-line {\n    padding: 2px 2px 1px; }\n\n.leaflet-dhis2.leaflet-google .leaflet-control-scale-line {\n  margin-left: 76px; }\n\n.leaflet-dhis2 .leaflet-marker-label {\n  position: absolute;\n  display: inline-block;\n  width: 160px;\n  margin-left: -80px;\n  text-align: center; }\n\n.leaflet-dhis2 .leaflet-div-label {\n  text-align: center;\n  line-height: 12px;\n  text-shadow: -1px 0 #f5f5f5, 0 1px #f5f5f5, 1px 0 #f5f5f5, 0 -1px #f5f5f5;\n  min-width: 80px;\n  pointer-events: none; }\n\n.leaflet-dhis2 .leaflet-marker-highlight {\n  -webkit-animation: pulse 2s ease-out;\n  animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite; }\n\n@-webkit-keyframes pulse {\n  from {\n    stroke-width: 15;\n    stroke-opacity: 1; }\n  to {\n    stroke-width: 50;\n    stroke-opacity: 0; } }\n\n@keyframes pulse {\n  from {\n    stroke-width: 15;\n    stroke-opacity: 1; }\n  to {\n    stroke-width: 50;\n    stroke-opacity: 0; } }\n\n.leaflet-dhis2 .leaflet-popup-content-wrapper {\n  border-radius: 0; }\n  .leaflet-dhis2 .leaflet-popup-content-wrapper .leaflet-popup-content em {\n    font-style: normal;\n    font-weight: bold; }\n  .leaflet-dhis2 .leaflet-popup-content-wrapper .leaflet-popup-content th {\n    white-space: nowrap;\n    vertical-align: top; }\n\n.leaflet-dhis2 .leaflet-tooltip {\n  border-radius: 0;\n  padding: 0 6px;\n  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif; }\n\n.leaflet-dhis2 .leaflet-tooltip-left {\n  margin-left: -8px; }\n\n.leaflet-dhis2 .leaflet-tooltip-right {\n  margin-left: 13px; }\n\n.leaflet-dhis2 .leaflet-tooltip-left:before {\n  border-left-color: transparent; }\n\n.leaflet-dhis2 .leaflet-tooltip-right:before {\n  border-right-color: transparent; }\n\n.leaflet-dhis2 .marker-cluster {\n  background-color: rgba(255, 255, 255, 0.6);\n  background-clip: padding-box;\n  border-radius: 20px; }\n  .leaflet-dhis2 .marker-cluster div {\n    background-color: rgba(255, 255, 255, 0.8);\n    width: 30px;\n    height: 30px;\n    margin-left: 5px;\n    margin-top: 5px;\n    text-align: center;\n    border-radius: 15px;\n    font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif; }\n  .leaflet-dhis2 .marker-cluster span {\n    line-height: 30px; }\n\n.leaflet-dhis2 .leaflet-cluster-icon {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.65);\n  color: #fff;\n  border-radius: 50%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  background-clip: padding-box; }\n  .leaflet-dhis2 .leaflet-cluster-icon span {\n    align-self: center; }\n\n.leaflet-dhis2 .marker-cluster-small {\n  background-color: rgba(181, 226, 140, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-small div {\n  background-color: rgba(110, 204, 57, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-medium {\n  background-color: rgba(241, 211, 87, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-medium div {\n  background-color: rgba(240, 194, 12, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-large {\n  background-color: rgba(253, 156, 115, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-large div {\n  background-color: rgba(241, 128, 23, 0.6); }\n\n.leaflet-dhis2 .leaflet-tile-cluster-debug {\n  background: rgba(255, 0, 0, 0.1);\n  border: 1px dashed black; }\n\n.leaflet-dhis2 .leaflet-control-measure {\n  border-radius: 0;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n  .leaflet-dhis2 .leaflet-control-measure .leaflet-control-measure-toggle {\n    width: 26px;\n    height: 26px; }\n\n.leaflet-dhis2 .leaflet-control-fit-bounds {\n  width: 26px;\n  height: 26px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);\n  cursor: pointer;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-color: #fff;\n  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDcwNzFDMTZDODRBMTFFNTg1MzFEQjY0MEU0MEY4RDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDcwNzFDMTVDODRBMTFFNTg1MzFEQjY0MEU0MEY4RDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wICI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSI3MTRDNEJCNEM4MEZBOERDRUNDRkMwNEJERkMyRTE5MyIgc3RSZWY6ZG9jdW1lbnRJRD0iNzE0QzRCQjRDODBGQThEQ0VDQ0ZDMDRCREZDMkUxOTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4nLlFTAAABcklEQVR42mJggIGS8qq///5jAqAgUIoBDRSWlP/HC4AKsKv+9/fP2jWrq6uqKiurVqxc9ePnb3Q9BcWlcKH9e3epqSgh2ywrr7h563a4AqBiBjjnxNGDEEUq6podHR2dHR262loQke2798GVQTX8/f1LVlIcKJeQkoHs9OL8bKAgn6Do1+8/UTRs37QeKCElp4jpXS11FaDUspVrIFwmiKVXrl0DklExCQwYID01CazgBoQL1cDIyAgkf//+hanh1+/fIHWMMD7Eor27tgHZomISmE5SkJUCSq1etxHFD8AI0FBRBEr4BoS8+/AJIvT96+e4qHCgoJmlLXooAcH1KxfZWUAu5OcXysjMys3NERcVhrjC0Nj0+YuXUA3IEXfh3GlzUxNkDzi7uNlYW4ECUEb24eMnIA2YCenggf29YLBr915wYvltqK8LVCYhJX35yhWiEt+Pb1/0dbWByorKaxgIJm8I+PLp/eTJUx49fQ4QYACpprSK2+4o1AAAAABJRU5ErkJggg=="); }\n  .leaflet-retina .leaflet-dhis2 .leaflet-control-fit-bounds {\n    background-image: url("data:image/png;base64,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");\n    background-size: 16px 16px; }\n\n.leaflet-dhis2 .leaflet-control-legend {\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);\n  background-color: #fff; }\n  .leaflet-dhis2 .leaflet-control-legend .leaflet-control-legend-content {\n    display: none; }\n\n.leaflet-dhis2 .leaflet-control-legend-toggle {\n  width: 26px;\n  height: 26px;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAy5pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIEVsZW1lbnRzIDE0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUJCQzgyMDdDRTU2MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUJCQzgyMDhDRTU2MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QkJDODIwNUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QkJDODIwNkNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnV8j0MAAABmSURBVHjaYqxXZ/nPAAUffoOZjBPu/mEgFrDgkmBkZPxPkQE21lbEuQDqbKyOINYFjAwUAJxeOHzkKHEGZKn9g/vh+U8mBlJdNAhiAersoRwLtj6W8MD6+PnrUIwFqLPJjgWAAAMAR5ghoelZsw4AAAAASUVORK5CYII=");\n  display: block; }\n  .leaflet-retina .leaflet-dhis2 .leaflet-control-legend-toggle {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAy5pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIEVsZW1lbnRzIDE0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0VDMTEyQzZDRTU4MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0VDMTEyQzdDRTU4MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QkJDODIwOUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QkJDODIwQUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjzimhsAAACgSURBVHjaYqxXZ/nPgAN8+A2WYgQRE+7+YaAFYGIYYMBCqgZGRsb/wyoEhl4U2FhbDawDjhw9xkhVB0Cz2sCFgAArI14fkepAmofAgCfCw0eODrNsmKX2D2ccPP/JBK8LRgui0bpgtC6gWV0AzWoDFwKS7P/w+ohUB9I8BEbrAqqHgK2PJc6S7ePnr6N1wWhdMFoX0L4ugGa1AQsBgAADAHQ1NZdoV4oTAAAAAElFTkSuQmCC");\n    background-size: 16px 16px; }\n\n.leaflet-dhis2 .leaflet-control-legend-expanded {\n  position: relative; }\n  .leaflet-dhis2 .leaflet-control-legend-expanded .leaflet-control-legend-toggle {\n    display: none; }\n  .leaflet-dhis2 .leaflet-control-legend-expanded .leaflet-control-legend-content {\n    overflow-y: auto;\n    min-width: 150px;\n    max-width: 200px;\n    min-height: 80px;\n    max-height: 260px;\n    padding: 6px 10px 6px 6px;\n    color: #333;\n    display: block; }\n\n.dhis2-legend {\n  display: block;\n  padding-top: 15px; }\n  .dhis2-legend h2 {\n    font-weight: bold;\n    font-size: 13px;\n    line-height: 13px;\n    margin: 0; }\n    .dhis2-legend h2 span {\n      display: block;\n      font-size: 12px;\n      font-weight: normal; }\n  .dhis2-legend p {\n    margin: 5px 0; }\n  .dhis2-legend dl {\n    margin: 10px 0; }\n    .dhis2-legend dl dt {\n      float: left;\n      clear: left;\n      width: 30px;\n      height: 16px; }\n    .dhis2-legend dl dd {\n      margin: 0;\n      padding: 1px 0 1px 38px;\n      height: 16px;\n      font-size: 11px;\n      line-height: 14px;\n      white-space: nowrap; }\n      .dhis2-legend dl dd strong {\n        line-height: 12px;\n        font-weight: bold;\n        display: block; }\n  .dhis2-legend .dhis2-legend-predefined dt {\n    height: 25px; }\n  .dhis2-legend .dhis2-legend-predefined dd {\n    height: 25px; }\n  .dhis2-legend .dhis2-legend-image dt {\n    width: 16px;\n    background-repeat: no-repeat;\n    background-position: center center; }\n  .dhis2-legend .dhis2-legend-image dd {\n    padding-left: 23px; }\n\n.dhis2-legend:first-child {\n  padding-top: 0; }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder {\n  border: 0;\n  min-width: 26px;\n  min-height: 26px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder-icon {\n  width: 26px;\n  height: 26px; }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder-alternatives li a {\n  font-size: 14px; }\n',""])},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,"/* required styles */\r\n\r\n.leaflet-pane,\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-tile-container,\r\n.leaflet-pane > svg,\r\n.leaflet-pane > canvas,\r\n.leaflet-zoom-box,\r\n.leaflet-image-layer,\r\n.leaflet-layer {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\t}\r\n.leaflet-container {\r\n\toverflow: hidden;\r\n\t}\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t        user-select: none;\r\n\t  -webkit-user-drag: none;\r\n\t}\r\n/* Safari renders non-retina tile on retina better with this, but Chrome is worse */\r\n.leaflet-safari .leaflet-tile {\r\n\timage-rendering: -webkit-optimize-contrast;\r\n\t}\r\n/* hack that prevents hw layers \"stretching\" when loading new tiles */\r\n.leaflet-safari .leaflet-tile-container {\r\n\twidth: 1600px;\r\n\theight: 1600px;\r\n\t-webkit-transform-origin: 0 0;\r\n\t}\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\tdisplay: block;\r\n\t}\r\n/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */\r\n/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */\r\n.leaflet-container .leaflet-overlay-pane svg,\r\n.leaflet-container .leaflet-marker-pane img,\r\n.leaflet-container .leaflet-shadow-pane img,\r\n.leaflet-container .leaflet-tile-pane img,\r\n.leaflet-container img.leaflet-image-layer {\r\n\tmax-width: none !important;\r\n\tmax-height: none !important;\r\n\t}\r\n\r\n.leaflet-container.leaflet-touch-zoom {\r\n\t-ms-touch-action: pan-x pan-y;\r\n\ttouch-action: pan-x pan-y;\r\n\t}\r\n.leaflet-container.leaflet-touch-drag {\r\n\t-ms-touch-action: pinch-zoom;\r\n\t/* Fallback for FF which doesn't support pinch-zoom */\r\n\ttouch-action: none;\r\n\ttouch-action: pinch-zoom;\r\n}\r\n.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.leaflet-container {\r\n\t-webkit-tap-highlight-color: transparent;\r\n}\r\n.leaflet-container a {\r\n\t-webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);\r\n}\r\n.leaflet-tile {\r\n\tfilter: inherit;\r\n\tvisibility: hidden;\r\n\t}\r\n.leaflet-tile-loaded {\r\n\tvisibility: inherit;\r\n\t}\r\n.leaflet-zoom-box {\r\n\twidth: 0;\r\n\theight: 0;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\tz-index: 800;\r\n\t}\r\n/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */\r\n.leaflet-overlay-pane svg {\r\n\t-moz-user-select: none;\r\n\t}\r\n\r\n.leaflet-pane         { z-index: 400; }\r\n\r\n.leaflet-tile-pane    { z-index: 200; }\r\n.leaflet-overlay-pane { z-index: 400; }\r\n.leaflet-shadow-pane  { z-index: 500; }\r\n.leaflet-marker-pane  { z-index: 600; }\r\n.leaflet-tooltip-pane   { z-index: 650; }\r\n.leaflet-popup-pane   { z-index: 700; }\r\n\r\n.leaflet-map-pane canvas { z-index: 100; }\r\n.leaflet-map-pane svg    { z-index: 200; }\r\n\r\n.leaflet-vml-shape {\r\n\twidth: 1px;\r\n\theight: 1px;\r\n\t}\r\n.lvml {\r\n\tbehavior: url(#default#VML);\r\n\tdisplay: inline-block;\r\n\tposition: absolute;\r\n\t}\r\n\r\n\r\n/* control positioning */\r\n\r\n.leaflet-control {\r\n\tposition: relative;\r\n\tz-index: 800;\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-top,\r\n.leaflet-bottom {\r\n\tposition: absolute;\r\n\tz-index: 1000;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-top {\r\n\ttop: 0;\r\n\t}\r\n.leaflet-right {\r\n\tright: 0;\r\n\t}\r\n.leaflet-bottom {\r\n\tbottom: 0;\r\n\t}\r\n.leaflet-left {\r\n\tleft: 0;\r\n\t}\r\n.leaflet-control {\r\n\tfloat: left;\r\n\tclear: both;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tfloat: right;\r\n\t}\r\n.leaflet-top .leaflet-control {\r\n\tmargin-top: 10px;\r\n\t}\r\n.leaflet-bottom .leaflet-control {\r\n\tmargin-bottom: 10px;\r\n\t}\r\n.leaflet-left .leaflet-control {\r\n\tmargin-left: 10px;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tmargin-right: 10px;\r\n\t}\r\n\r\n\r\n/* zoom and fade animations */\r\n\r\n.leaflet-fade-anim .leaflet-tile {\r\n\twill-change: opacity;\r\n\t}\r\n.leaflet-fade-anim .leaflet-popup {\r\n\topacity: 0;\r\n\t-webkit-transition: opacity 0.2s linear;\r\n\t   -moz-transition: opacity 0.2s linear;\r\n\t     -o-transition: opacity 0.2s linear;\r\n\t        transition: opacity 0.2s linear;\r\n\t}\r\n.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {\r\n\topacity: 1;\r\n\t}\r\n.leaflet-zoom-animated {\r\n\t-webkit-transform-origin: 0 0;\r\n\t    -ms-transform-origin: 0 0;\r\n\t        transform-origin: 0 0;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\twill-change: transform;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\t-webkit-transition: -webkit-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t   -moz-transition:    -moz-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t     -o-transition:      -o-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t        transition:         transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t}\r\n.leaflet-zoom-anim .leaflet-tile,\r\n.leaflet-pan-anim .leaflet-tile {\r\n\t-webkit-transition: none;\r\n\t   -moz-transition: none;\r\n\t     -o-transition: none;\r\n\t        transition: none;\r\n\t}\r\n\r\n.leaflet-zoom-anim .leaflet-zoom-hide {\r\n\tvisibility: hidden;\r\n\t}\r\n\r\n\r\n/* cursors */\r\n\r\n.leaflet-interactive {\r\n\tcursor: pointer;\r\n\t}\r\n.leaflet-grab {\r\n\tcursor: -webkit-grab;\r\n\tcursor:    -moz-grab;\r\n\t}\r\n.leaflet-crosshair,\r\n.leaflet-crosshair .leaflet-interactive {\r\n\tcursor: crosshair;\r\n\t}\r\n.leaflet-popup-pane,\r\n.leaflet-control {\r\n\tcursor: auto;\r\n\t}\r\n.leaflet-dragging .leaflet-grab,\r\n.leaflet-dragging .leaflet-grab .leaflet-interactive,\r\n.leaflet-dragging .leaflet-marker-draggable {\r\n\tcursor: move;\r\n\tcursor: -webkit-grabbing;\r\n\tcursor:    -moz-grabbing;\r\n\t}\r\n\r\n/* marker & overlays interactivity */\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-image-layer,\r\n.leaflet-pane > svg path,\r\n.leaflet-tile-container {\r\n\tpointer-events: none;\r\n\t}\r\n\r\n.leaflet-marker-icon.leaflet-interactive,\r\n.leaflet-image-layer.leaflet-interactive,\r\n.leaflet-pane > svg path.leaflet-interactive {\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n\r\n/* visual tweaks */\r\n\r\n.leaflet-container {\r\n\tbackground: #ddd;\r\n\toutline: 0;\r\n\t}\r\n.leaflet-container a {\r\n\tcolor: #0078A8;\r\n\t}\r\n.leaflet-container a.leaflet-active {\r\n\toutline: 2px solid orange;\r\n\t}\r\n.leaflet-zoom-box {\r\n\tborder: 2px dotted #38f;\r\n\tbackground: rgba(255,255,255,0.5);\r\n\t}\r\n\r\n\r\n/* general typography */\r\n.leaflet-container {\r\n\tfont: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n\t}\r\n\r\n\r\n/* general toolbar styles */\r\n\r\n.leaflet-bar {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.65);\r\n\tborder-radius: 4px;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #ccc;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tline-height: 26px;\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\ttext-decoration: none;\r\n\tcolor: black;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-control-layers-toggle {\r\n\tbackground-position: 50% 50%;\r\n\tbackground-repeat: no-repeat;\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #f4f4f4;\r\n\t}\r\n.leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 4px;\r\n\tborder-top-right-radius: 4px;\r\n\t}\r\n.leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 4px;\r\n\tborder-bottom-right-radius: 4px;\r\n\tborder-bottom: none;\r\n\t}\r\n.leaflet-bar a.leaflet-disabled {\r\n\tcursor: default;\r\n\tbackground-color: #f4f4f4;\r\n\tcolor: #bbb;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-bar a {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 2px;\r\n\tborder-top-right-radius: 2px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 2px;\r\n\tborder-bottom-right-radius: 2px;\r\n\t}\r\n\r\n/* zoom control */\r\n\r\n.leaflet-control-zoom-in,\r\n.leaflet-control-zoom-out {\r\n\tfont: bold 18px 'Lucida Console', Monaco, monospace;\r\n\ttext-indent: 1px;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out  {\r\n\tfont-size: 22px;\r\n\t}\r\n\r\n\r\n/* layers control */\r\n\r\n.leaflet-control-layers {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.4);\r\n\tbackground: #fff;\r\n\tborder-radius: 5px;\r\n\t}\r\n.leaflet-control-layers-toggle {\r\n\tbackground-image: url("+escape(__webpack_require__(162))+");\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\t}\r\n.leaflet-retina .leaflet-control-layers-toggle {\r\n\tbackground-image: url("+escape(__webpack_require__(163))+");\r\n\tbackground-size: 26px 26px;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers-toggle {\r\n\twidth: 44px;\r\n\theight: 44px;\r\n\t}\r\n.leaflet-control-layers .leaflet-control-layers-list,\r\n.leaflet-control-layers-expanded .leaflet-control-layers-toggle {\r\n\tdisplay: none;\r\n\t}\r\n.leaflet-control-layers-expanded .leaflet-control-layers-list {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\t}\r\n.leaflet-control-layers-expanded {\r\n\tpadding: 6px 10px 6px 6px;\r\n\tcolor: #333;\r\n\tbackground: #fff;\r\n\t}\r\n.leaflet-control-layers-scrollbar {\r\n\toverflow-y: scroll;\r\n\toverflow-x: hidden;\r\n\tpadding-right: 5px;\r\n\t}\r\n.leaflet-control-layers-selector {\r\n\tmargin-top: 2px;\r\n\tposition: relative;\r\n\ttop: 1px;\r\n\t}\r\n.leaflet-control-layers label {\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-control-layers-separator {\r\n\theight: 0;\r\n\tborder-top: 1px solid #ddd;\r\n\tmargin: 5px -10px 5px -6px;\r\n\t}\r\n\r\n/* Default icon URLs */\r\n.leaflet-default-icon-path {\r\n\tbackground-image: url("+escape(__webpack_require__(164))+');\r\n\t}\r\n\r\n\r\n/* attribution and scale controls */\r\n\r\n.leaflet-container .leaflet-control-attribution {\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.7);\r\n\tmargin: 0;\r\n\t}\r\n.leaflet-control-attribution,\r\n.leaflet-control-scale-line {\r\n\tpadding: 0 5px;\r\n\tcolor: #333;\r\n\t}\r\n.leaflet-control-attribution a {\r\n\ttext-decoration: none;\r\n\t}\r\n.leaflet-control-attribution a:hover {\r\n\ttext-decoration: underline;\r\n\t}\r\n.leaflet-container .leaflet-control-attribution,\r\n.leaflet-container .leaflet-control-scale {\r\n\tfont-size: 11px;\r\n\t}\r\n.leaflet-left .leaflet-control-scale {\r\n\tmargin-left: 5px;\r\n\t}\r\n.leaflet-bottom .leaflet-control-scale {\r\n\tmargin-bottom: 5px;\r\n\t}\r\n.leaflet-control-scale-line {\r\n\tborder: 2px solid #777;\r\n\tborder-top: none;\r\n\tline-height: 1.1;\r\n\tpadding: 2px 5px 1px;\r\n\tfont-size: 11px;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.5);\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child) {\r\n\tborder-top: 2px solid #777;\r\n\tborder-bottom: none;\r\n\tmargin-top: -2px;\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child):not(:last-child) {\r\n\tborder-bottom: 2px solid #777;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-attribution,\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tbox-shadow: none;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tborder: 2px solid rgba(0,0,0,0.2);\r\n\tbackground-clip: padding-box;\r\n\t}\r\n\r\n\r\n/* popup */\r\n\r\n.leaflet-popup {\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\tmargin-bottom: 20px;\r\n\t}\r\n.leaflet-popup-content-wrapper {\r\n\tpadding: 1px;\r\n\ttext-align: left;\r\n\tborder-radius: 12px;\r\n\t}\r\n.leaflet-popup-content {\r\n\tmargin: 13px 19px;\r\n\tline-height: 1.4;\r\n\t}\r\n.leaflet-popup-content p {\r\n\tmargin: 18px 0;\r\n\t}\r\n.leaflet-popup-tip-container {\r\n\twidth: 40px;\r\n\theight: 20px;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tmargin-left: -20px;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-popup-tip {\r\n\twidth: 17px;\r\n\theight: 17px;\r\n\tpadding: 1px;\r\n\r\n\tmargin: -10px auto 0;\r\n\r\n\t-webkit-transform: rotate(45deg);\r\n\t   -moz-transform: rotate(45deg);\r\n\t    -ms-transform: rotate(45deg);\r\n\t     -o-transform: rotate(45deg);\r\n\t        transform: rotate(45deg);\r\n\t}\r\n.leaflet-popup-content-wrapper,\r\n.leaflet-popup-tip {\r\n\tbackground: white;\r\n\tcolor: #333;\r\n\tbox-shadow: 0 3px 14px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tpadding: 4px 4px 0 0;\r\n\tborder: none;\r\n\ttext-align: center;\r\n\twidth: 18px;\r\n\theight: 14px;\r\n\tfont: 16px/14px Tahoma, Verdana, sans-serif;\r\n\tcolor: #c3c3c3;\r\n\ttext-decoration: none;\r\n\tfont-weight: bold;\r\n\tbackground: transparent;\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button:hover {\r\n\tcolor: #999;\r\n\t}\r\n.leaflet-popup-scrolled {\r\n\toverflow: auto;\r\n\tborder-bottom: 1px solid #ddd;\r\n\tborder-top: 1px solid #ddd;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-popup-content-wrapper {\r\n\tzoom: 1;\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\twidth: 24px;\r\n\tmargin: 0 auto;\r\n\r\n\t-ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";\r\n\tfilter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip-container {\r\n\tmargin-top: -1px;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-control-zoom,\r\n.leaflet-oldie .leaflet-control-layers,\r\n.leaflet-oldie .leaflet-popup-content-wrapper,\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\tborder: 1px solid #999;\r\n\t}\r\n\r\n\r\n/* div icon */\r\n\r\n.leaflet-div-icon {\r\n\tbackground: #fff;\r\n\tborder: 1px solid #666;\r\n\t}\r\n\r\n\r\n/* Tooltip */\r\n/* Base styles for the element that has a tooltip */\r\n.leaflet-tooltip {\r\n\tposition: absolute;\r\n\tpadding: 6px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #fff;\r\n\tborder-radius: 3px;\r\n\tcolor: #222;\r\n\twhite-space: nowrap;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tpointer-events: none;\r\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-tooltip.leaflet-clickable {\r\n\tcursor: pointer;\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-tooltip-top:before,\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\tposition: absolute;\r\n\tpointer-events: none;\r\n\tborder: 6px solid transparent;\r\n\tbackground: transparent;\r\n\tcontent: "";\r\n\t}\r\n\r\n/* Directions */\r\n\r\n.leaflet-tooltip-bottom {\r\n\tmargin-top: 6px;\r\n}\r\n.leaflet-tooltip-top {\r\n\tmargin-top: -6px;\r\n}\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-top:before {\r\n\tleft: 50%;\r\n\tmargin-left: -6px;\r\n\t}\r\n.leaflet-tooltip-top:before {\r\n\tbottom: 0;\r\n\tmargin-bottom: -12px;\r\n\tborder-top-color: #fff;\r\n\t}\r\n.leaflet-tooltip-bottom:before {\r\n\ttop: 0;\r\n\tmargin-top: -12px;\r\n\tmargin-left: -6px;\r\n\tborder-bottom-color: #fff;\r\n\t}\r\n.leaflet-tooltip-left {\r\n\tmargin-left: -6px;\r\n}\r\n.leaflet-tooltip-right {\r\n\tmargin-left: 6px;\r\n}\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\ttop: 50%;\r\n\tmargin-top: -6px;\r\n\t}\r\n.leaflet-tooltip-left:before {\r\n\tright: 0;\r\n\tmargin-right: -12px;\r\n\tborder-left-color: #fff;\r\n\t}\r\n.leaflet-tooltip-right:before {\r\n\tleft: 0;\r\n\tmargin-left: -12px;\r\n\tborder-right-color: #fff;\r\n\t}\r\n',""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAACf0lEQVR4AY1UM3gkARTePdvdoTxXKc+qTl3aU5U6b2Kbkz3Gtq3Zw6ziLGNPzrYx7946Tr6/ee/XeCQ4D3ykPtL5tHno4n0d/h3+xfuWHGLX81cn7r0iTNzjr7LrlxCqPtkbTQEHeqOrTy4Yyt3VCi/IOB0v7rVC7q45Q3Gr5K6jt+3Gl5nCoDD4MtO+j96Wu8atmhGqcNGHObuf8OM/x3AMx38+4Z2sPqzCxRFK2aF2e5Jol56XTLyggAMTL56XOMoS1W4pOyjUcGGQdZxU6qRh7B9Zp+PfpOFlqt0zyDZckPi1ttmIp03jX8gyJ8a/PG2yutpS/Vol7peZIbZcKBAEEheEIAgFbDkz5H6Zrkm2hVWGiXKiF4Ycw0RWKdtC16Q7qe3X4iOMxruonzegJzWaXFrU9utOSsLUmrc0YjeWYjCW4PDMADElpJSSQ0vQvA1Tm6/JlKnqFs1EGyZiFCqnRZTEJJJiKRYzVYzJck2Rm6P4iH+cmSY0YzimYa8l0EtTODFWhcMIMVqdsI2uiTvKmTisIDHJ3od5GILVhBCarCfVRmo4uTjkhrhzkiBV7SsaqS+TzrzM1qpGGUFt28pIySQHR6h7F6KSwGWm97ay+Z+ZqMcEjEWebE7wxCSQwpkhJqoZA5ivCdZDjJepuJ9IQjGGUmuXJdBFUygxVqVsxFsLMbDe8ZbDYVCGKxs+W080max1hFCarCfV+C1KATwcnvE9gRRuMP2prdbWGowm1KB1y+zwMMENkM755cJ2yPDtqhTI6ED1M/82yIDtC/4j4BijjeObflpO9I9MwXTCsSX8jWAFeHr05WoLTJ5G8IQVS/7vwR6ohirYM7f6HzYpogfS3R2OAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAQAAABvcdNgAAAEsklEQVR4AWL4TydIhpZK1kpWOlg0w3ZXP6D2soBtG42jeI6ZmQTHzAxiTbSJsYLjO9HhP+WOmcuhciVnmHVQcJnp7DFvScowZorad/+V/fVzMdMT2g9Cv9guXGv/7pYOrXh2U+RRR3dSd9JRx6bIFc/ekqHI29JC6pJ5ZEh1yWkhkbcFeSjxgx3L2m1cb1C7bceyxA+CNjT/Ifff+/kDk2u/w/33/IeCMOSaWZ4glosqT3DNnNZQ7Cs58/3Ce5HL78iZH/vKVIaYlqzfdLu8Vi7dnvUbEza5Idt36tquZFldl6N5Z/POLof0XLK61mZCmJSWjVF9tEjUluu74IUXvgttuVIHE7YxSkaYhJZam7yiM9Pv82JYfl9nptxZaxMJE4YSPty+vF0+Y2up9d3wwijfjZbabqm/3bZ9ecKHsiGmRflnn1MW4pjHf9oLufyn2z3y1D6n8g8TZhxyzipLNPnAUpsOiuWimg52psrTZYnOWYNDTMuWBWa0tJb4rgq1UvmutpaYEbZlwU3CLJm/ayYjHW5/h7xWLn9Hh1vepDkyf7dE7MtT5LR4e7yYpHrkhOUpEfssBLq2pPhAqoSWKUkk7EDqkmK6RrCEzqDjhNDWNE+XSMvkJRDWlZTmCW0l0PHQGRZY5t1L83kT0Y3l2SItk5JAWHl2dCOBm+fPu3fo5/3v61RMCO9Jx2EEYYhb0rmNQMX/vm7gqOEJLcXTGw3CAuRNeyaPWwjR8PRqKQ1PDA/dpv+on9Shox52WFnx0KY8onHayrJzm87i5h9xGw/tfkev0jGsQizqezUKjk12hBMKJ4kbCqGPVNXudyyrShovGw5CgxsRICxF6aRmSjlBnHRzg7Gx8fKqEubI2rahQYdR1YgDIRQO7JvQyD52hoIQx0mxa0ODtW2Iozn1le2iIRdzwWewedyZzewidueOGqlsn1MvcnQpuVwLGG3/IR1hIKxCjelIDZ8ldqWz25jWAsnldEnK0Zxro19TGVb2ffIZEsIO89EIEDvKMPrzmBOQcKQ+rroye6NgRRxqR4U8EAkz0CL6uSGOm6KQCdWjvjRiSP1BPalCRS5iQYiEIvxuBMJEWgzSoHADcVMuN7IuqqTeyUPq22qFimFtxDyBBJEwNyt6TM88blFHao/6tWWhuuOM4SAK4EI4QmFHA+SEyWlp4EQoJ13cYGzMu7yszEIBOm2rVmHUNqwAIQabISNMRstmdhNWcFLsSm+0tjJH1MdRxO5Nx0WDMhCtgD6OKgZeljJqJKc9po8juskR9XN0Y1lZ3mWjLR9JCO1jRDMd0fpYC2VnvjBSEFg7wBENc0R9HFlb0xvF1+TBEpF68d+DHR6IOWVv2BECtxo46hOFUBd/APU57WIoEwJhIi2CdpyZX0m93BZicktMj1AS9dClteUFAUNUIEygRZCtik5zSxI9MubTBH1GOiHsiLJ3OCoSZkILa9PxiN0EbvhsAo8tdAf9Seepd36lGWHmtNANTv5Jd0z4QYyeo/UEJqxKRpg5LZx6btLPsOaEmdMyxYdlc8LMaJnikDlhclqmPiQnTEpLUIZEwkRagjYkEibQErwhkTAKCLQEbUgkzJQWc/0PstHHcfEdQ+UAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="},function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\r\n\t-webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\t-moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\t-o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\ttransition: transform 0.3s ease-out, opacity 0.3s ease-in;\r\n}\r\n\r\n.leaflet-cluster-spider-leg {\r\n\t/* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\r\n\t-webkit-transition: -webkit-stroke-dashoffset 0.3s ease-out, -webkit-stroke-opacity 0.3s ease-in;\r\n\t-moz-transition: -moz-stroke-dashoffset 0.3s ease-out, -moz-stroke-opacity 0.3s ease-in;\r\n\t-o-transition: -o-stroke-dashoffset 0.3s ease-out, -o-stroke-opacity 0.3s ease-in;\r\n\ttransition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;\r\n}\r\n",""])},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-control-geocoder {\n\tborder-radius: 4px;\n\tbackground: white;\n\tmin-width: 26px;\n\tmin-height: 26px;\n}\n\n.leaflet-touch .leaflet-control-geocoder {\n\tmin-width: 30px;\n\tmin-height: 30px;\n}\n\n.leaflet-control-geocoder a, .leaflet-control-geocoder .leaflet-control-geocoder-icon {\n\tborder-bottom: none;\n\tdisplay: inline-block;\n}\n\n.leaflet-control-geocoder .leaflet-control-geocoder-alternatives a {\n\twidth: inherit;\n\theight: inherit;\n\tline-height: inherit;\n}\n\n.leaflet-control-geocoder a:hover, .leaflet-control-geocoder .leaflet-control-geocoder-icon:hover {\n\tborder-bottom: none;\n\tdisplay: inline-block;\n}\n\n.leaflet-control-geocoder-form {\n\tdisplay: none;\n\tvertical-align: middle;\n}\n.leaflet-control-geocoder-expanded .leaflet-control-geocoder-form {\n\tdisplay: inline-block;\n}\n.leaflet-control-geocoder-form input {\n\tfont-size: 120%;\n\tborder: 0;\n\tbackground-color: transparent;\n\twidth: 246px;\n}\n\n.leaflet-control-geocoder-icon {\n\tborder-radius: 4px;\n\twidth: 26px;\n\theight: 26px;\n\tborder: none;\n\tbackground-color: white;\n\tbackground-image: url("+escape(__webpack_require__(167))+");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n}\n\n.leaflet-touch .leaflet-control-geocoder-icon {\n\twidth: 30px;\n\theight: 30px;\n}\n\n.leaflet-control-geocoder-throbber .leaflet-control-geocoder-icon {\n\tbackground-image: url("+escape(__webpack_require__(168))+");\n}\n\n.leaflet-control-geocoder-form-no-error {\n\tdisplay: none;\n}\n\n.leaflet-control-geocoder-form input:focus {\n\toutline: none;\n}\n\n.leaflet-control-geocoder-form button {\n\tdisplay: none;\n}\n.leaflet-control-geocoder-error {\n\tmargin-top: 8px;\n\tmargin-left: 8px;\n\tdisplay: block;\n\tcolor: #444;\n}\n.leaflet-control-geocoder-alternatives {\n\tdisplay: block;\n\twidth: 272px;\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.leaflet-control-geocoder-alternatives-minimized {\n\tdisplay: none;\n\theight: 0;\n}\n.leaflet-control-geocoder-alternatives li {\n\twhite-space: nowrap;\n\tdisplay: block;\n\toverflow: hidden;\n\tpadding: 5px 8px;\n\ttext-overflow: ellipsis;\n\tborder-bottom: 1px solid #ccc;\n\tcursor: pointer;\n}\n\n.leaflet-control-geocoder-alternatives li a, .leaflet-control-geocoder-alternatives li a:hover {\n\twidth: inherit;\n\theight: inherit;\n\tline-height: inherit;\n\tbackground: inherit;\n\tborder-radius: inherit;\n\ttext-align: left;\n}\n\n.leaflet-control-geocoder-alternatives li:last-child {\n\tborder-bottom: none;\n}\n.leaflet-control-geocoder-alternatives li:hover, .leaflet-control-geocoder-selected {\n\tbackground-color: #f5f5f5;\n}\n.leaflet-control-geocoder-address-detail {\n\t\n}\n.leaflet-control-geocoder-address-context {\n\tcolor: #666;\n}",""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAz1BMVEUAAAAkJCQmJiYmJiYlJSUkJCQAAAAqKiokJCQmJiYzMzMlJSUkJCQmJiYlJSUmJiYoKCgmJiYmJiYnJycmJiYAAAAmJiYmJiYlJSUZGRklJSUmJiYmJiYlJSUlJSUmJiYmJiYtLS0mJiYlJSUmJiYnJyccHBwmJiYmJiYlJSUiIiImJiYmJiYmJiYlJSUkJCQlJSUjIyMuLi4mJiYmJiYlJSUlJSUlJSUAAAAmJiYlJSUoKCglJSUlJSUmJiYmJiYlJSUlJSUlJSUlJSUmJiawjvnZAAAARHRSTlMARfbw3jEDBkb+BatNZMu1GfHGDdQBoPjyCsOfFD2C/LQRaqiTVQmMcFkW4uR961pnOQshyWDgnAKuzDP5uPVW+tp5S3AUDfcAAACGSURBVBgZzcFFAoMwAATARQN1d3d3d9n/v6n0SsKdGYROrW7ZUMlWm+SsD1kkw1ZnPnXHkMTZADAxFwP4JdMCnhU1+CVy+NO4hF+02IbnwzX8YuwKwDLeNiQFHo7nG7+Q5UcmX/eH/oTK5oQLjS3Urjp3Amp7cogAPboO1ESl5CBAOYVQ+QEjbg1iCZEUOgAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/gif;base64,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"},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-control-measure h3,.leaflet-measure-resultpopup h3{margin:0 0 12px 0;padding-bottom:10px;line-height:1em;font-weight:normal;font-size:1.1em;border-bottom:solid 1px #DDD}.leaflet-control-measure p,.leaflet-measure-resultpopup p{margin:10px 0 0;line-height:1em}.leaflet-control-measure p:first-child,.leaflet-measure-resultpopup p:first-child{margin-top:0}.leaflet-control-measure a,.leaflet-measure-resultpopup a{color:#5E66CC;text-decoration:none}.leaflet-control-measure a:hover,.leaflet-measure-resultpopup a:hover{opacity:0.5;text-decoration:none}.leaflet-control-measure .tasks,.leaflet-measure-resultpopup .tasks{margin:12px 0 0;padding:10px 0 0;border-top:solid 1px #DDD;list-style:none;list-style-image:none}.leaflet-control-measure .tasks li,.leaflet-measure-resultpopup .tasks li{display:inline;margin:0 10px 0 0}.leaflet-control-measure .tasks li:last-child,.leaflet-measure-resultpopup .tasks li:last-child{margin-right:0}.leaflet-control-measure .coorddivider,.leaflet-measure-resultpopup .coorddivider{color:#999}.leaflet-control-measure{background:#fff;border-radius:5px;box-shadow:0 1px 5px rgba(0,0,0,0.4)}.leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-control-measure .leaflet-control-measure-toggle:hover{display:block;width:36px;height:36px;background-position:50% 50%;background-repeat:no-repeat;background-image:url("+escape(__webpack_require__(170))+");border-radius:5px;text-indent:100%;white-space:nowrap;overflow:hidden}.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle:hover{background-image:url("+escape(__webpack_require__(171))+");background-size:16px 16px}.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle:hover{width:44px;height:44px}.leaflet-control-measure .startprompt h3{margin-bottom:10px}.leaflet-control-measure .startprompt .tasks{margin-top:0;padding-top:0;border-top:0}.leaflet-control-measure .leaflet-control-measure-interaction{padding:10px 12px}.leaflet-control-measure .results .group{margin-top:10px;padding-top:10px;border-top:dotted 1px #eaeaea}.leaflet-control-measure .results .group:first-child{margin-top:0;padding-top:0;border-top:0}.leaflet-control-measure .results .heading{margin-right:5px;color:#999}.leaflet-control-measure a.start{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(172))+")}.leaflet-retina .leaflet-control-measure a.start{background-image:url("+escape(__webpack_require__(173))+");background-size:12px 12px}.leaflet-control-measure a.cancel{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(174))+")}.leaflet-retina .leaflet-control-measure a.cancel{background-image:url("+escape(__webpack_require__(175))+");background-size:12px 12px}.leaflet-control-measure a.finish{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(176))+")}.leaflet-retina .leaflet-control-measure a.finish{background-image:url("+escape(__webpack_require__(177))+");background-size:12px 12px}.leaflet-measure-resultpopup a.zoomto{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(178))+")}.leaflet-retina .leaflet-measure-resultpopup a.zoomto{background-image:url("+escape(__webpack_require__(179))+");background-size:12px 12px}.leaflet-measure-resultpopup a.deletemarkup{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(180))+")}.leaflet-retina .leaflet-measure-resultpopup a.deletemarkup{background-image:url("+escape(__webpack_require__(181))+");background-size:11px 12px}\n",""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAGJJREFUOI1jYGBgOM3AwPAfCTMwMDA8QxPDhT8xoAlIM5AG/jMi2QoDjKQYwITEkSFRM9w2qrkA5oqBc8EIDYNHDAzkp0I4QE/fMDF5YvnoBsiTwscWBiQBJgYGhpMU6D8CAJDrOVecOVsbAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAALdJREFUWIXtl0EKwkAMRZ+iR1LwCC5ceekKHsSqN3ARF5pFi41lmGQU8iDQkkB/0k/aATgCV0AmQjkbNaXRAdy+FCmdgwDBSGzwRQBZGgUrZwEALBiOearGAwGwJhDCJwFbXl1rhAsIefdKesASoF5oJiD3QAi5B9IDuQeaeyDU8SNOwEOVRP4LDvirPSAe9yXd7oB1rXzJBKrm50ygasdj5kzAlZ/4FtwbPr8HOLwvPE6+VlyA/ROEjYEpRhLQZgAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAY1JREFUKJF9kL9PEwEcxd/3y+XaXrwKCZsx4uLQiQQRZHOUmYEU45mL1CCVpH+JwxEx6CB6HfixM7KQ8sM2TB2cHHRzMCTt2cbe+zrUSxsHP+PLey/v+xX8ZaXWKHgddxNAmcYSACjQNpW69jtv9vYe9QBAAKActu44TnpMwlXRyEQuhzW2IMAWgcSZ4OMPOw++yUqtUfC6TgvEl8QflI9eL/3CGJVK0+uB+4TencoV59TruJsk3MwcvLiaCZ635rLA7u79hIm7qqR/3bt+qQDKKhplzTROm6aNp+ufq1kojme7prpNsTWlsTTanKEuRKIn683DtVfnxeGxcqHUkuI/iBj/1RwF2gZbAHCWiST7KlL79G5+Z2TlQwBtNZW6AFuVStMDgHSAHxOwxY9j5jA89QGpQiSWIDjJpzm/qeBXJu5qHM92xyeE4an/W3MHgN2aLEzOCwA827i8PUj1WEnfVLcFcjGaIVUjfxJcrr9f/C5ZUxCc5M29sTF8nZaGqrUhEt/MF99G0b0+APwB15Gn8fy9beQAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAA41JREFUSImNlU9oVFcUxn/ne28UxKWIRKiYpRaqZpIUagm6aZfiQlLNRBzyT+nGNmiLe2nUtkLBJhnRxolRoVBc1GXqIoqZTEoW6sZN/VNqTXdWsJl553YxkzSkM5N8m/feved837mP891jNMCx44XmJFEnsA/3nQ6bAEzMG3pMYNIU3Rgb2f1bPQ6rtdjV82A7Fp8j+EFJalSEu7vJfkzKOjVxpeXpqgKZ3kImBIYlbagSlGS6G2Aa+APAjCag3d07JKWqUm/M1T92OX29rkB338xpsK8AHN5aCN/E5eji1at75muedGBus8oLJx1OSloPEEIYzOdav/6fQKa3kDHTNYDg4YlH0YHrI3seN/o9/wkV3rVEt81oroocyedaJ5YEunoebAc9lLQheHgS4tTe8eFdr9ZCvoijJ6a3eCm6Z0Yz7n8HaWd+NP1MAFI8JGmDw1uPogMrybPZ2SYINRtiEWOX2l8G6SD4AtJGgyEAO3a80Fwq8USSQghn87nWMyuTM30zA0Y4UEJdN0bTfzUS6u4pXED63N3dPWpWkqhTkty9FJeji/VT9VHkYe5IT/HDRgK2LlwAEkmKY+8UsA9Aprv1umVJQrY1Er909xa/rPfLxi61vwSmANzDfuG+E6Da52tBhHE201O880lfcVPNiBAKlYK0Q4v2p2qitcJkH0ce5jJ9xb01dn+vPH1zw2tgNUgWVo0xMQ9L9l87AndCKtmVH01P1djcWqV/FRt6DJW7ZU3ETtktnBnPpc9D7RN4oF0G4I9EYBLA3Tu6BuY2N+QOPHfzjvFc67l65NnsbJNkH1TibVKm6Ia7u6SUygsn65EH959tXbJ7PNd2v1ERpTgMAhGQmNlNA8j0zdwy7JC7/0NMeny47eHypKMnpreMXWr7s17Vi8gMFHaHMtOSUrhPXLvcdkQASVmnwN9IWm+Jbh89Mb1leWLFPI3Js9nZJnN+kpRyeJ3gpwEEMHGl5am5+gHMaPZSdK+r/9f3GhGurLwcJ/dB2wAM671++f0Xlfdl6O4tDmKcr3z5As53ti5cqNq/ZtWlOAwG90+XJlsIn13LtX67GFNjZM4cthBGkDZWlxJgqmL/RYeGrR5or3ZLBODw2rDe/GjLreV8NS+sTF/xHYMhdz+02tAHEtxvKcUXP3zf9nzlZsMhcjg7uy2OvdM97Je0A7zqE70Cf+TBJs3sZn40/awex78erYTTwi3/3gAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAS9JREFUKJGFkDFOAlEURc8dRphJFNmBHYnQYbTHDnsa0BDBRq1YC4naIQbWYEloqKQyswIXQEgwDIn5z2IATUR95X/nvpz7xWqq7XEYztO3QM2wAoCkyLCBt5zf9XrlGEAAtebkwPfdM+iQLWMQpVKu8nh/8qZqexyG7zuT3+DvoVwme+QlGmtYTcMGG8h4MnOtlUpxFs9ufKD2BbjTULqMwZlhobhaoO5mL+q+YQUlVZB0HoMF0EKwwLpC9XVApoL3w9UwgOk00LYuvqQIKK2dEw3rBrmFhSR6wMXqXOQbNhAqJQ9utECJhiAGc7KRZ1oF1FejMQxcZu9FUPznW19zmeyx1+uV41TKVQyiv2DnPs46nfxyU6zRGAaW3r02UZepsHYG9feD7EOnk18CfAKwIX1qvqPBeQAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAApxJREFUSImtlr1PWlEYxp/ncE1KYWy6Gh3FwUZiOtiYuqlbGwxRaKJRjI5tqon/gf4BpqIxERC1doaNxLaD8SNxUOdqOukoiLHc83YALdwPhLbP+J5zfs977n3OPZeoo7Hp/XbTVGEArwEEBHhWHpErgmcQ5Kg8m+vLL364MehUjEzstZHGIiBvSKp6TYiIBvHFLKnZ9Fr3+aMG0cn9KKg+EXhaD+xgVaDm1PpqcKO6WtPdu9jBHKkSzcMBgD5RSEVjhx9qqtWdkyrRPNguAUaT8WD6wSAysddGZZz8XedODpIXMpCMBy8UAChlLNjgInmIHgTwvQ5qtzxHCjVV0k9gAQDU2PR+u4i8ta4kVSix0pMtGk8GAPnmBNc3xlBipScLkZB9EzI8Mn7UqkxThZ2iKNDzoZkT/85SZ75oeActJrv6xhhKpboKoZkTP6jm7Q1SGYYOK5QPkYP4ylsqZiKRY9/OUmde37QMiMhXK9xbus0C6HUiCNivAAScDcom9P7KRCLHvlSqqyDFlsFG4QBAoIPR2OEdgRZ3E6C6awBoBF7Zw13dz8D/kALk6pE5Nc/8z4t3TVeVeKkInjUK95Zus95SMVMnXRbJqYIg1ygcQG+ddNmkBTlF5dkUEW031wvuaalNF1T51FpkktwiAERjB9sEhy0OBYiEKofILS27Qlmk4DNAn2UsnYgHRw0AMEtq1jD0UO0k+kBmXMD36qOwz7Z54Frr0hxQuQ/Sa93n1Jx6BNaEOLmx+vLngwEArK8GNyD4+M9skffJePf2g5V1PBo7HKHIMkh/U1zgGuBkNRywXJkAkIwH00IGAGw5pssuE0Da49EBKxxw+au418j4Uath6LCA/QQ6AHleWXYJyKkW5EhuJePBCzfGbyl+TiY9AObiAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASVJREFUKJF1kDFLAgEYhp/37tQ7KPMftAnZZtjSkg2B7S5KHLRVk3O/IQiEakzQra2h0SannOR+QWuLYKF03teQwkHeO3483/e+7ydWanZGQTDLXwMtwyoAkiLDBs5idt/r1ecAAmhdjHc9L3kF7bFBBpHrJo2nh8MPNTujIPjKjbPg9FKpUDxw/mJkw2Y8G3wL9qfz6ZUDtLLP2l0gQiACMNF21gVX+kzDvnQzx14ENQCZKk7K+s39cSoGkzQMOkmbepIioCpxHOeW57l4ceR5/nITDBZ5hg2EqgBCt7FXyMXY6X8YQH2F4dBPCtvvgv3M8oDBpFQo1pxerz533aRhq09kwUkSn3W75YXWwzAc+pbfujTRlqmyzgzq7/jFx263vAD4BStdctyYQ7zEAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAlZJREFUSImllr9PU1EYhp/3tJMyGqIuBhYNnQyXhMRJNlcHg0AxIC3pqhFi4iCLCf4FtFaUFgok/AMmBldSqpOwuAhhghFx6r2fAwX641Jy6zu+57vP+30n5+Rc0UYTmXKv77th4CGQMLhxumJHQrsYm3Kx1aXs/d+XMRRmjk1t9Ujx92CPJbl2TZhZgNjwq26mtNi/d2VAMlVOIrcguNYOHBJ1okDTS3lvpd5t6G48vT0ruUJ0OICum2M5ma68bHDrO5dcITq4VQajxZxXOg8Ym9rqkYv/7KzzsAT7Y1KimPP2HYBz8fn/gRv8bTCkLsE8gCYy5d5qVb+uOi1ttOQH1Tcxxb8i7l4MYYHvu17n+264c7h97rnVP7mSHzxAZBqHkIvHg2HH6SXqEO49n5tT8CxduWdGqaUCDTkgERlt9qkeHhjfJG421wn63MX1b8F8waiGwXtve1NXwWvV3aF7b5At5LxHOHtaHxINfioHdtRq6gfICtmBjbOQTuCgQye02zpBsDCerkwB1EIeRIcD2I7GU5XXiHchixaI1HJ24OOZEw0Ogdmsk4utmlkQMp6c8SGZKk92Agd8SWsCSKa314WehNeZmektkIkABygVct6oA/CrbgbsJLxOkpiLAjc49oPqLNTeg9Ji/54CTUfo7goptZIfPDgPAFjKeysYr/6bbfaimOtfP49qXk+mKyMyyyJ1ReLCMShVD4emJxOgmPNKJiWAtfDT1SIfKMViQaIZDpf8VZxpZPL7nXg8GDY0JOgD6659dgi2ExibktaKOW//MsY/pXkXxnBJQFMAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAOhJREFUKJGVkTFug0AQRd+sgBOkyT1MvxVdipQpbDcBrsExAq4iipQWpbvt1xeJlBNgsZPCYK1sJ1GmfX//PM3CP0cAXqrjQwqVqmbG4N7b3AFsa29DwIrIeILuo1t9GYAUKqD4pbiYMyQAqpoBrt/lTZyaN7l16RsguzwwBreENq/HZ0TfEFEVrfs2H2Iu17s3pf/E8CSTmCDs+93qMebm9gyiMomZJNyyRWlbe7s4q2itInvBgFJe8wQgBOxc4Po2H4Ahbo15craQESjWpW9++AeLcrgonaBLzw3ZPW+UQxrG9i77a74B+z5bQloZOFAAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAXBJREFUSIntlb8uBFEUxn/n7hAV1XoIpazYll5ETbays56AZ+AJGBJBoRPUotVsRCmeACsRiUQx636KRWbHnzvIavi6c/J95zvnzJ174R8BWDaozTdnMK1iNpzNbycV4x3U4qaysVALo76zNnbwknPddm+Lf61bK5snyeaibkan+Ecd55Hn1eKm8g12T9AD9NwgClNgtnE64uRXgAlDQhyb2eJWUjkPaYO7nm2cjpS8P8EYzOYFdw6qIZPgipz8CsYg0l4K5VLqhhEHBkMeloP6EAGYAEjNGrtJ5WZzc7TlS1EMYNLkjw0MCWAgda/rbKcPhY4xFPnI4hhj6jHy63MLZ3E7fbB+F6133O0oJA9PYLYouMOYdr591V/qu8RsCulW/nHpSwa1uKn8/bKVVM4dVAWHSPdI98C+5Ks7G+MXIX2h/+D5KE4X4X46QS/wu1eFUMuwcn6PRd+DZ1xlg9x7QB3p+nu9dop7rP4D/V/EE6UhikMKpx/oAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAALlJREFUKJFjZEACcWmn5zMwMCbA+P///ZuzeI5ZKozPaF+/n4WBgYFB7gmfKiPj30PfeP/Irem3+h5SeIyT4yvLQxZGFuv7Eh/vMzAwMDDGpJz6wcTExM5AEPz7BbX+zH98ymDyTMiCsamnq7HRMICimJGRsQUbjVUxIUAvxf8ZqrDSSCoY49JO/UtLO8OFzbSkpCO8cSlnfjMwMDCwMDAw/mdgOD3nBwPDp7i0MxiK/0BsmMbAwMAAACl8PxDSJvyvAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAW5JREFUSIntlbtKA2EQhc8/axIVrUQFBRsRRLCL+gIRQeuAxbpNLq2laGklpLYxVkkh2lip4AsIZkmZRiy0sPCCoEYwlxmLJLLZi+wmYpXTnRnmm/mHYVfBQ+uJq/EwhfJQHANItWdZAFxWQfrRQfTZrZ68wGEtlIHCshMKNGK0EhLsedW7FDWn1bR7ACGImsllF26teSNVmIaSG2ZUVEQm8/tLLw5wPH6iPc6NtjWYehjaVkrtQnCey0bX3JobKfMMCqsQ7NxNvGesubHSkygjaX6CMOD1pM7EZRJCBUD9L7ECqv0YI22KkTalU5i93vMqutX/g/XkdVlPm29+vV19nh2JBoN43xN3qx64B3bK847B/CFEdd/eLzh3uDgcxNvVXIVYPvTi+lf5Xc4ay465DAAbieJsUKyRKM43EPzaijVXoYSlcEoKutKkZKTNoBM3MXRsAwMRrm5+aeERMMeIKNC1MDMrogvur221Yt/I6IasMWr/dwAAAABJRU5ErkJggg=="},function(module,exports,__webpack_require__){function addStylesToDom(styles,options){for(var i=0;i<styles.length;i++){var item=styles[i],domStyle=stylesInDom[item.id];if(domStyle){domStyle.refs++;for(var j=0;j<domStyle.parts.length;j++)domStyle.parts[j](item.parts[j]);for(;j<item.parts.length;j++)domStyle.parts.push(addStyle(item.parts[j],options))}else{for(var parts=[],j=0;j<item.parts.length;j++)parts.push(addStyle(item.parts[j],options));stylesInDom[item.id]={id:item.id,refs:1,parts:parts}}}}function listToStyles(list,options){for(var styles=[],newStyles={},i=0;i<list.length;i++){var item=list[i],id=options.base?item[0]+options.base:item[0],css=item[1],media=item[2],sourceMap=item[3],part={css:css,media:media,sourceMap:sourceMap};newStyles[id]?newStyles[id].parts.push(part):styles.push(newStyles[id]={id:id,parts:[part]})}return styles}function insertStyleElement(options,style){var target=getElement(options.insertInto);if(!target)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var lastStyleElementInsertedAtTop=stylesInsertedAtTop[stylesInsertedAtTop.length-1];if("top"===options.insertAt)lastStyleElementInsertedAtTop?lastStyleElementInsertedAtTop.nextSibling?target.insertBefore(style,lastStyleElementInsertedAtTop.nextSibling):target.appendChild(style):target.insertBefore(style,target.firstChild),stylesInsertedAtTop.push(style);else if("bottom"===options.insertAt)target.appendChild(style);else{if("object"!=typeof options.insertAt||!options.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var nextSibling=getElement(options.insertInto+" "+options.insertAt.before);target.insertBefore(style,nextSibling)}}function removeStyleElement(style){if(null===style.parentNode)return!1;style.parentNode.removeChild(style);var idx=stylesInsertedAtTop.indexOf(style);idx>=0&&stylesInsertedAtTop.splice(idx,1)}function createStyleElement(options){var style=document.createElement("style");return options.attrs.type="text/css",addAttrs(style,options.attrs),insertStyleElement(options,style),style}function createLinkElement(options){var link=document.createElement("link");return options.attrs.type="text/css",options.attrs.rel="stylesheet",addAttrs(link,options.attrs),insertStyleElement(options,link),link}function addAttrs(el,attrs){Object.keys(attrs).forEach(function(key){el.setAttribute(key,attrs[key])})}function addStyle(obj,options){var style,update,remove,result;if(options.transform&&obj.css){if(!(result=options.transform(obj.css)))return function(){};obj.css=result}if(options.singleton){var styleIndex=singletonCounter++;style=singleton||(singleton=createStyleElement(options)),update=applyToSingletonTag.bind(null,style,styleIndex,!1),remove=applyToSingletonTag.bind(null,style,styleIndex,!0)}else obj.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(style=createLinkElement(options),update=updateLink.bind(null,style,options),remove=function(){removeStyleElement(style),style.href&&URL.revokeObjectURL(style.href)}):(style=createStyleElement(options),update=applyToTag.bind(null,style),remove=function(){removeStyleElement(style)});return update(obj),function(newObj){if(newObj){if(newObj.css===obj.css&&newObj.media===obj.media&&newObj.sourceMap===obj.sourceMap)return;update(obj=newObj)}else remove()}}function applyToSingletonTag(style,index,remove,obj){var css=remove?"":obj.css;if(style.styleSheet)style.styleSheet.cssText=replaceText(index,css);else{var cssNode=document.createTextNode(css),childNodes=style.childNodes;childNodes[index]&&style.removeChild(childNodes[index]),childNodes.length?style.insertBefore(cssNode,childNodes[index]):style.appendChild(cssNode)}}function applyToTag(style,obj){var css=obj.css,media=obj.media;if(media&&style.setAttribute("media",media),style.styleSheet)style.styleSheet.cssText=css;else{for(;style.firstChild;)style.removeChild(style.firstChild);style.appendChild(document.createTextNode(css))}}function updateLink(link,options,obj){var css=obj.css,sourceMap=obj.sourceMap,autoFixUrls=void 0===options.convertToAbsoluteUrls&&sourceMap;(options.convertToAbsoluteUrls||autoFixUrls)&&(css=fixUrls(css)),sourceMap&&(css+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+" */");var blob=new Blob([css],{type:"text/css"}),oldSrc=link.href;link.href=URL.createObjectURL(blob),oldSrc&&URL.revokeObjectURL(oldSrc)}var stylesInDom={},isOldIE=function(fn){var memo;return function(){return void 0===memo&&(memo=fn.apply(this,arguments)),memo}}(function(){return window&&document&&document.all&&!window.atob}),getTarget=function(target){return document.querySelector(target)},getElement=function(fn){var memo={};return function(target){if("function"==typeof target)return target();if(void 0===memo[target]){var styleTarget=getTarget.call(this,target);if(window.HTMLIFrameElement&&styleTarget instanceof window.HTMLIFrameElement)try{styleTarget=styleTarget.contentDocument.head}catch(e){styleTarget=null}memo[target]=styleTarget}return memo[target]}}(),singleton=null,singletonCounter=0,stylesInsertedAtTop=[],fixUrls=__webpack_require__(183);module.exports=function(list,options){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");options=options||{},options.attrs="object"==typeof options.attrs?options.attrs:{},options.singleton||"boolean"==typeof options.singleton||(options.singleton=isOldIE()),options.insertInto||(options.insertInto="head"),options.insertAt||(options.insertAt="bottom");var styles=listToStyles(list,options);return addStylesToDom(styles,options),function(newList){for(var mayRemove=[],i=0;i<styles.length;i++){var item=styles[i],domStyle=stylesInDom[item.id];domStyle.refs--,mayRemove.push(domStyle)}if(newList){addStylesToDom(listToStyles(newList,options),options)}for(var i=0;i<mayRemove.length;i++){var domStyle=mayRemove[i];if(0===domStyle.refs){for(var j=0;j<domStyle.parts.length;j++)domStyle.parts[j]();delete stylesInDom[domStyle.id]}}}};var replaceText=function(){var textStore=[];return function(index,replacement){return textStore[index]=replacement,textStore.filter(Boolean).join("\n")}}()},function(module,exports){module.exports=function(css){var location="undefined"!=typeof window&&window.location;if(!location)throw new Error("fixUrls requires window.location");if(!css||"string"!=typeof css)return css;var baseUrl=location.protocol+"//"+location.host,currentDir=baseUrl+location.pathname.replace(/\/[^\/]*$/,"/");return css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(fullMatch,origUrl){var unquotedOrigUrl=origUrl.trim().replace(/^"(.*)"$/,function(o,$1){return $1}).replace(/^'(.*)'$/,function(o,$1){return $1});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl))return fullMatch;var newUrl;return newUrl=0===unquotedOrigUrl.indexOf("//")?unquotedOrigUrl:0===unquotedOrigUrl.indexOf("/")?baseUrl+unquotedOrigUrl:currentDir+unquotedOrigUrl.replace(/^\.\//,""),"url("+JSON.stringify(newUrl)+")"})}},function(module,exports,__webpack_require__){__webpack_require__(62)(__webpack_require__(185))},function(module,exports){module.exports="(function(f){if(typeof exports===\"object\"&&typeof module!==\"undefined\"){module.exports=f()}else if(typeof define===\"function\"&&define.amd){define([],f)}else{var g;if(typeof window!==\"undefined\"){g=window}else if(typeof global!==\"undefined\"){g=global}else if(typeof self!==\"undefined\"){g=self}else{g=this}g.rbush = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require==\"function\"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error(\"Cannot find module '\"+o+\"'\");throw f.code=\"MODULE_NOT_FOUND\",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require==\"function\"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){\n'use strict';\n\nmodule.exports = rbush;\nmodule.exports.default = rbush;\n\nvar quickselect = require('quickselect');\n\nfunction rbush(maxEntries, format) {\n    if (!(this instanceof rbush)) return new rbush(maxEntries, format);\n\n    // max entries in a node is 9 by default; min node fill is 40% for best performance\n    this._maxEntries = Math.max(4, maxEntries || 9);\n    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));\n\n    if (format) {\n        this._initFormat(format);\n    }\n\n    this.clear();\n}\n\nrbush.prototype = {\n\n    all: function () {\n        return this._all(this.data, []);\n    },\n\n    search: function (bbox) {\n\n        var node = this.data,\n            result = [],\n            toBBox = this.toBBox;\n\n        if (!intersects(bbox, node)) return result;\n\n        var nodesToSearch = [],\n            i, len, child, childBBox;\n\n        while (node) {\n            for (i = 0, len = node.children.length; i < len; i++) {\n\n                child = node.children[i];\n                childBBox = node.leaf ? toBBox(child) : child;\n\n                if (intersects(bbox, childBBox)) {\n                    if (node.leaf) result.push(child);\n                    else if (contains(bbox, childBBox)) this._all(child, result);\n                    else nodesToSearch.push(child);\n                }\n            }\n            node = nodesToSearch.pop();\n        }\n\n        return result;\n    },\n\n    collides: function (bbox) {\n\n        var node = this.data,\n            toBBox = this.toBBox;\n\n        if (!intersects(bbox, node)) return false;\n\n        var nodesToSearch = [],\n            i, len, child, childBBox;\n\n        while (node) {\n            for (i = 0, len = node.children.length; i < len; i++) {\n\n                child = node.children[i];\n                childBBox = node.leaf ? toBBox(child) : child;\n\n                if (intersects(bbox, childBBox)) {\n                    if (node.leaf || contains(bbox, childBBox)) return true;\n                    nodesToSearch.push(child);\n                }\n            }\n            node = nodesToSearch.pop();\n        }\n\n        return false;\n    },\n\n    load: function (data) {\n        if (!(data && data.length)) return this;\n\n        if (data.length < this._minEntries) {\n            for (var i = 0, len = data.length; i < len; i++) {\n                this.insert(data[i]);\n            }\n            return this;\n        }\n\n        // recursively build the tree with the given data from scratch using OMT algorithm\n        var node = this._build(data.slice(), 0, data.length - 1, 0);\n\n        if (!this.data.children.length) {\n            // save as is if tree is empty\n            this.data = node;\n\n        } else if (this.data.height === node.height) {\n            // split root if trees have the same height\n            this._splitRoot(this.data, node);\n\n        } else {\n            if (this.data.height < node.height) {\n                // swap trees if inserted one is bigger\n                var tmpNode = this.data;\n                this.data = node;\n                node = tmpNode;\n            }\n\n            // insert the small tree into the large tree at appropriate level\n            this._insert(node, this.data.height - node.height - 1, true);\n        }\n\n        return this;\n    },\n\n    insert: function (item) {\n        if (item) this._insert(item, this.data.height - 1);\n        return this;\n    },\n\n    clear: function () {\n        this.data = createNode([]);\n        return this;\n    },\n\n    remove: function (item, equalsFn) {\n        if (!item) return this;\n\n        var node = this.data,\n            bbox = this.toBBox(item),\n            path = [],\n            indexes = [],\n            i, parent, index, goingUp;\n\n        // depth-first iterative tree traversal\n        while (node || path.length) {\n\n            if (!node) { // go up\n                node = path.pop();\n                parent = path[path.length - 1];\n                i = indexes.pop();\n                goingUp = true;\n            }\n\n            if (node.leaf) { // check current node\n                index = findItem(item, node.children, equalsFn);\n\n                if (index !== -1) {\n                    // item found, remove the item and condense tree upwards\n                    node.children.splice(index, 1);\n                    path.push(node);\n                    this._condense(path);\n                    return this;\n                }\n            }\n\n            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down\n                path.push(node);\n                indexes.push(i);\n                i = 0;\n                parent = node;\n                node = node.children[0];\n\n            } else if (parent) { // go right\n                i++;\n                node = parent.children[i];\n                goingUp = false;\n\n            } else node = null; // nothing found\n        }\n\n        return this;\n    },\n\n    toBBox: function (item) { return item; },\n\n    compareMinX: compareNodeMinX,\n    compareMinY: compareNodeMinY,\n\n    toJSON: function () { return this.data; },\n\n    fromJSON: function (data) {\n        this.data = data;\n        return this;\n    },\n\n    _all: function (node, result) {\n        var nodesToSearch = [];\n        while (node) {\n            if (node.leaf) result.push.apply(result, node.children);\n            else nodesToSearch.push.apply(nodesToSearch, node.children);\n\n            node = nodesToSearch.pop();\n        }\n        return result;\n    },\n\n    _build: function (items, left, right, height) {\n\n        var N = right - left + 1,\n            M = this._maxEntries,\n            node;\n\n        if (N <= M) {\n            // reached leaf level; return leaf\n            node = createNode(items.slice(left, right + 1));\n            calcBBox(node, this.toBBox);\n            return node;\n        }\n\n        if (!height) {\n            // target height of the bulk-loaded tree\n            height = Math.ceil(Math.log(N) / Math.log(M));\n\n            // target number of root entries to maximize storage utilization\n            M = Math.ceil(N / Math.pow(M, height - 1));\n        }\n\n        node = createNode([]);\n        node.leaf = false;\n        node.height = height;\n\n        // split the items into M mostly square tiles\n\n        var N2 = Math.ceil(N / M),\n            N1 = N2 * Math.ceil(Math.sqrt(M)),\n            i, j, right2, right3;\n\n        multiSelect(items, left, right, N1, this.compareMinX);\n\n        for (i = left; i <= right; i += N1) {\n\n            right2 = Math.min(i + N1 - 1, right);\n\n            multiSelect(items, i, right2, N2, this.compareMinY);\n\n            for (j = i; j <= right2; j += N2) {\n\n                right3 = Math.min(j + N2 - 1, right2);\n\n                // pack each entry recursively\n                node.children.push(this._build(items, j, right3, height - 1));\n            }\n        }\n\n        calcBBox(node, this.toBBox);\n\n        return node;\n    },\n\n    _chooseSubtree: function (bbox, node, level, path) {\n\n        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;\n\n        while (true) {\n            path.push(node);\n\n            if (node.leaf || path.length - 1 === level) break;\n\n            minArea = minEnlargement = Infinity;\n\n            for (i = 0, len = node.children.length; i < len; i++) {\n                child = node.children[i];\n                area = bboxArea(child);\n                enlargement = enlargedArea(bbox, child) - area;\n\n                // choose entry with the least area enlargement\n                if (enlargement < minEnlargement) {\n                    minEnlargement = enlargement;\n                    minArea = area < minArea ? area : minArea;\n                    targetNode = child;\n\n                } else if (enlargement === minEnlargement) {\n                    // otherwise choose one with the smallest area\n                    if (area < minArea) {\n                        minArea = area;\n                        targetNode = child;\n                    }\n                }\n            }\n\n            node = targetNode || node.children[0];\n        }\n\n        return node;\n    },\n\n    _insert: function (item, level, isNode) {\n\n        var toBBox = this.toBBox,\n            bbox = isNode ? item : toBBox(item),\n            insertPath = [];\n\n        // find the best node for accommodating the item, saving all nodes along the path too\n        var node = this._chooseSubtree(bbox, this.data, level, insertPath);\n\n        // put the item into the node\n        node.children.push(item);\n        extend(node, bbox);\n\n        // split on node overflow; propagate upwards if necessary\n        while (level >= 0) {\n            if (insertPath[level].children.length > this._maxEntries) {\n                this._split(insertPath, level);\n                level--;\n            } else break;\n        }\n\n        // adjust bboxes along the insertion path\n        this._adjustParentBBoxes(bbox, insertPath, level);\n    },\n\n    // split overflowed node into two\n    _split: function (insertPath, level) {\n\n        var node = insertPath[level],\n            M = node.children.length,\n            m = this._minEntries;\n\n        this._chooseSplitAxis(node, m, M);\n\n        var splitIndex = this._chooseSplitIndex(node, m, M);\n\n        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));\n        newNode.height = node.height;\n        newNode.leaf = node.leaf;\n\n        calcBBox(node, this.toBBox);\n        calcBBox(newNode, this.toBBox);\n\n        if (level) insertPath[level - 1].children.push(newNode);\n        else this._splitRoot(node, newNode);\n    },\n\n    _splitRoot: function (node, newNode) {\n        // split root node\n        this.data = createNode([node, newNode]);\n        this.data.height = node.height + 1;\n        this.data.leaf = false;\n        calcBBox(this.data, this.toBBox);\n    },\n\n    _chooseSplitIndex: function (node, m, M) {\n\n        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;\n\n        minOverlap = minArea = Infinity;\n\n        for (i = m; i <= M - m; i++) {\n            bbox1 = distBBox(node, 0, i, this.toBBox);\n            bbox2 = distBBox(node, i, M, this.toBBox);\n\n            overlap = intersectionArea(bbox1, bbox2);\n            area = bboxArea(bbox1) + bboxArea(bbox2);\n\n            // choose distribution with minimum overlap\n            if (overlap < minOverlap) {\n                minOverlap = overlap;\n                index = i;\n\n                minArea = area < minArea ? area : minArea;\n\n            } else if (overlap === minOverlap) {\n                // otherwise choose distribution with minimum area\n                if (area < minArea) {\n                    minArea = area;\n                    index = i;\n                }\n            }\n        }\n\n        return index;\n    },\n\n    // sorts node children by the best axis for split\n    _chooseSplitAxis: function (node, m, M) {\n\n        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,\n            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,\n            xMargin = this._allDistMargin(node, m, M, compareMinX),\n            yMargin = this._allDistMargin(node, m, M, compareMinY);\n\n        // if total distributions margin value is minimal for x, sort by minX,\n        // otherwise it's already sorted by minY\n        if (xMargin < yMargin) node.children.sort(compareMinX);\n    },\n\n    // total margin of all possible split distributions where each node is at least m full\n    _allDistMargin: function (node, m, M, compare) {\n\n        node.children.sort(compare);\n\n        var toBBox = this.toBBox,\n            leftBBox = distBBox(node, 0, m, toBBox),\n            rightBBox = distBBox(node, M - m, M, toBBox),\n            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),\n            i, child;\n\n        for (i = m; i < M - m; i++) {\n            child = node.children[i];\n            extend(leftBBox, node.leaf ? toBBox(child) : child);\n            margin += bboxMargin(leftBBox);\n        }\n\n        for (i = M - m - 1; i >= m; i--) {\n            child = node.children[i];\n            extend(rightBBox, node.leaf ? toBBox(child) : child);\n            margin += bboxMargin(rightBBox);\n        }\n\n        return margin;\n    },\n\n    _adjustParentBBoxes: function (bbox, path, level) {\n        // adjust bboxes along the given tree path\n        for (var i = level; i >= 0; i--) {\n            extend(path[i], bbox);\n        }\n    },\n\n    _condense: function (path) {\n        // go through the path, removing empty nodes and updating bboxes\n        for (var i = path.length - 1, siblings; i >= 0; i--) {\n            if (path[i].children.length === 0) {\n                if (i > 0) {\n                    siblings = path[i - 1].children;\n                    siblings.splice(siblings.indexOf(path[i]), 1);\n\n                } else this.clear();\n\n            } else calcBBox(path[i], this.toBBox);\n        }\n    },\n\n    _initFormat: function (format) {\n        // data format (minX, minY, maxX, maxY accessors)\n\n        // uses eval-type function compilation instead of just accepting a toBBox function\n        // because the algorithms are very sensitive to sorting functions performance,\n        // so they should be dead simple and without inner calls\n\n        var compareArr = ['return a', ' - b', ';'];\n\n        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));\n        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));\n\n        this.toBBox = new Function('a',\n            'return {minX: a' + format[0] +\n            ', minY: a' + format[1] +\n            ', maxX: a' + format[2] +\n            ', maxY: a' + format[3] + '};');\n    }\n};\n\nfunction findItem(item, items, equalsFn) {\n    if (!equalsFn) return items.indexOf(item);\n\n    for (var i = 0; i < items.length; i++) {\n        if (equalsFn(item, items[i])) return i;\n    }\n    return -1;\n}\n\n// calculate node's bbox from bboxes of its children\nfunction calcBBox(node, toBBox) {\n    distBBox(node, 0, node.children.length, toBBox, node);\n}\n\n// min bounding rectangle of node children from k to p-1\nfunction distBBox(node, k, p, toBBox, destNode) {\n    if (!destNode) destNode = createNode(null);\n    destNode.minX = Infinity;\n    destNode.minY = Infinity;\n    destNode.maxX = -Infinity;\n    destNode.maxY = -Infinity;\n\n    for (var i = k, child; i < p; i++) {\n        child = node.children[i];\n        extend(destNode, node.leaf ? toBBox(child) : child);\n    }\n\n    return destNode;\n}\n\nfunction extend(a, b) {\n    a.minX = Math.min(a.minX, b.minX);\n    a.minY = Math.min(a.minY, b.minY);\n    a.maxX = Math.max(a.maxX, b.maxX);\n    a.maxY = Math.max(a.maxY, b.maxY);\n    return a;\n}\n\nfunction compareNodeMinX(a, b) { return a.minX - b.minX; }\nfunction compareNodeMinY(a, b) { return a.minY - b.minY; }\n\nfunction bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }\nfunction bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }\n\nfunction enlargedArea(a, b) {\n    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *\n           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));\n}\n\nfunction intersectionArea(a, b) {\n    var minX = Math.max(a.minX, b.minX),\n        minY = Math.max(a.minY, b.minY),\n        maxX = Math.min(a.maxX, b.maxX),\n        maxY = Math.min(a.maxY, b.maxY);\n\n    return Math.max(0, maxX - minX) *\n           Math.max(0, maxY - minY);\n}\n\nfunction contains(a, b) {\n    return a.minX <= b.minX &&\n           a.minY <= b.minY &&\n           b.maxX <= a.maxX &&\n           b.maxY <= a.maxY;\n}\n\nfunction intersects(a, b) {\n    return b.minX <= a.maxX &&\n           b.minY <= a.maxY &&\n           b.maxX >= a.minX &&\n           b.maxY >= a.minY;\n}\n\nfunction createNode(children) {\n    return {\n        children: children,\n        height: 1,\n        leaf: true,\n        minX: Infinity,\n        minY: Infinity,\n        maxX: -Infinity,\n        maxY: -Infinity\n    };\n}\n\n// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;\n// combines selection algorithm with binary divide & conquer approach\n\nfunction multiSelect(arr, left, right, n, compare) {\n    var stack = [left, right],\n        mid;\n\n    while (stack.length) {\n        right = stack.pop();\n        left = stack.pop();\n\n        if (right - left <= n) continue;\n\n        mid = left + Math.ceil((right - left) / n / 2) * n;\n        quickselect(arr, mid, left, right, compare);\n\n        stack.push(left, mid, mid, right);\n    }\n}\n\n},{\"quickselect\":2}],2:[function(require,module,exports){\n'use strict';\n\nmodule.exports = quickselect;\nmodule.exports.default = quickselect;\n\nfunction quickselect(arr, k, left, right, compare) {\n    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);\n};\n\nfunction quickselectStep(arr, k, left, right, compare) {\n\n    while (right > left) {\n        if (right - left > 600) {\n            var n = right - left + 1;\n            var m = k - left + 1;\n            var z = Math.log(n);\n            var s = 0.5 * Math.exp(2 * z / 3);\n            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);\n            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));\n            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));\n            quickselectStep(arr, k, newLeft, newRight, compare);\n        }\n\n        var t = arr[k];\n        var i = left;\n        var j = right;\n\n        swap(arr, left, k);\n        if (compare(arr[right], t) > 0) swap(arr, left, right);\n\n        while (i < j) {\n            swap(arr, i, j);\n            i++;\n            j--;\n            while (compare(arr[i], t) < 0) i++;\n            while (compare(arr[j], t) > 0) j--;\n        }\n\n        if (compare(arr[left], t) === 0) swap(arr, left, j);\n        else {\n            j++;\n            swap(arr, j, right);\n        }\n\n        if (j <= k) left = j + 1;\n        if (k <= j) right = j - 1;\n    }\n}\n\nfunction swap(arr, i, j) {\n    var tmp = arr[i];\n    arr[i] = arr[j];\n    arr[j] = tmp;\n}\n\nfunction defaultCompare(a, b) {\n    return a < b ? -1 : a > b ? 1 : 0;\n}\n\n},{}]},{},[1])(1)\n});"},function(module,exports,__webpack_require__){__webpack_require__(62)(__webpack_require__(187))},function(module,exports){module.exports='"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*\n\n This file is changed from the original on:\n https://github.com/google/earthengine-api/blob/master/javascript/build/ee_api_js_debug.js\n\n Line 2:\n goog.global = window (not this)\n\n window.ee = ee; is added at the end of this file.\n\n This to make it work with the webpack build setup\n\n */var goog=goog||{};goog.global=window;goog.isDef=function(val){return void 0!==val;};goog.isString=function(val){return"string"==typeof val;};goog.isBoolean=function(val){return"boolean"==typeof val;};goog.isNumber=function(val){return"number"==typeof val;};goog.isString=function(val){return"string"==typeof val;};goog.isBoolean=function(val){return"boolean"==typeof val;};goog.isNumber=function(val){return"number"==typeof val;};goog.exportPath_=function(name,opt_object,opt_objectToExportTo){var parts=name.split("."),cur=opt_objectToExportTo||goog.global;parts[0]in cur||!cur.execScript||cur.execScript("var "+parts[0]);for(var part;parts.length&&(part=parts.shift());){!parts.length&&goog.isDef(opt_object)?cur[part]=opt_object:cur=cur[part]&&cur[part]!==Object.prototype[part]?cur[part]:cur[part]={};}};goog.define=function(name,defaultValue){goog.exportPath_(name,defaultValue);};goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.STRICT_MODE_COMPATIBLE=!1;goog.DISALLOW_TEST_ONLY_CODE=!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;goog.provide=function(name){if(goog.isInModuleLoader_()){throw Error("goog.provide can not be used within a goog.module.");}goog.constructNamespace_(name);};goog.constructNamespace_=function(name,opt_obj){var namespace;goog.exportPath_(name,opt_obj);};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;goog.module=function(name){if(!goog.isString(name)||!name||-1==name.search(goog.VALID_MODULE_RE_)){throw Error("Invalid module identifier");}if(!goog.isInModuleLoader_()){throw Error("Module "+name+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You\'re likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");}if(goog.moduleLoaderState_.moduleName){throw Error("goog.module may only be called once per module.");}goog.moduleLoaderState_.moduleName=name;};goog.module.get=function(name){return goog.module.getInternal_(name);};goog.module.getInternal_=function(name){var ns;return null;};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return null!=goog.moduleLoaderState_;};goog.module.declareLegacyNamespace=function(){goog.moduleLoaderState_.declareLegacyNamespace=!0;};goog.setTestOnly=function(opt_message){if(goog.DISALLOW_TEST_ONLY_CODE){throw opt_message=opt_message||"",Error("Importing test-only code into non-debug environment"+(opt_message?": "+opt_message:"."));}};goog.forwardDeclare=function(name){};goog.getObjectByName=function(name,opt_obj){for(var parts=name.split("."),cur=opt_obj||goog.global,part;part=parts.shift();){if(goog.isDefAndNotNull(cur[part])){cur=cur[part];}else{return null;}}return cur;};goog.globalize=function(obj,opt_global){var global=opt_global||goog.global,x;for(x in obj){global[x]=obj[x];}};goog.addDependency=function(relPath,provides,requires,opt_loadFlags){if(goog.DEPENDENCIES_ENABLED){var provide,require,path=relPath.replace(/\\\\/g,"/"),deps=goog.dependencies_;opt_loadFlags&&"boolean"!==typeof opt_loadFlags||(opt_loadFlags=opt_loadFlags?{module:"goog"}:{});for(var i=0;provide=provides[i];i++){deps.nameToPath[provide]=path,deps.loadFlags[path]=opt_loadFlags;}for(var j=0;require=requires[j];j++){path in deps.requires||(deps.requires[path]={}),deps.requires[path][require]=!0;}}};goog.useStrictRequires=!1;goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(msg){goog.global.console&&goog.global.console.error(msg);};goog.require=function(name){var errorMessage,path;};goog.basePath="";goog.nullFunction=function(){};goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(ctor){ctor.instance_=void 0;ctor.getInstance=function(){if(ctor.instance_){return ctor.instance_;}goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=ctor);return ctor.instance_=new ctor();};};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!1;goog.TRANSPILE="detect";goog.TRANSPILER="transpile.js";goog.DEPENDENCIES_ENABLED&&(goog.dependencies_={loadFlags:{},nameToPath:{},requires:{},visited:{},written:{},deferred:{}},goog.inHtmlDocument_=function(){var doc=goog.global.document;return null!=doc&&"write"in doc;},goog.findBasePath_=function(){if(goog.isDef(goog.global.CLOSURE_BASE_PATH)&&goog.isString(goog.global.CLOSURE_BASE_PATH)){goog.basePath=goog.global.CLOSURE_BASE_PATH;}else{if(goog.inHtmlDocument_()){var doc=goog.global.document,currentScript=doc.currentScript;var scripts=currentScript?[currentScript]:doc.getElementsByTagName("SCRIPT");for(var i=scripts.length-1;0<=i;--i){var src=scripts[i].src,qmark=src.lastIndexOf("?"),l=-1==qmark?src.length:qmark;if("base.js"==src.substr(l-7,7)){goog.basePath=src.substr(0,l-7);break;}}}}},goog.importScript_=function(src,opt_sourceText){(goog.global.CLOSURE_IMPORT_SCRIPT||goog.writeScriptTag_)(src,opt_sourceText)&&(goog.dependencies_.written[src]=!0);},goog.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.oldIeWaiting_=!1,goog.importProcessedScript_=function(src,isModule,needsTranspile){goog.importScript_("",\'goog.retrieveAndExec_("\'+src+\'", \'+isModule+", "+needsTranspile+");");},goog.queuedModules_=[],goog.wrapModule_=function(srcUrl,scriptText){return goog.LOAD_MODULE_USING_EVAL&&goog.isDef(goog.global.JSON)?"goog.loadModule("+goog.global.JSON.stringify(scriptText+"\\n//# sourceURL="+srcUrl+"\\n")+");":\'goog.loadModule(function(exports) {"use strict";\'+scriptText+"\\n;return exports});\\n//# sourceURL="+srcUrl+"\\n";},goog.loadQueuedModules_=function(){var count=goog.queuedModules_.length;if(0<count){var queue=goog.queuedModules_;goog.queuedModules_=[];for(var i=0;i<count;i++){goog.maybeProcessDeferredPath_(queue[i]);}}goog.oldIeWaiting_=!1;},goog.maybeProcessDeferredDep_=function(name){goog.isDeferredModule_(name)&&goog.allDepsAreAvailable_(name)&&goog.maybeProcessDeferredPath_(goog.basePath+goog.getPathFromDeps_(name));},goog.isDeferredModule_=function(name){var path=goog.getPathFromDeps_(name),loadFlags=path&&goog.dependencies_.loadFlags[path]||{},languageLevel=loadFlags.lang||"es3";return path&&("goog"==loadFlags.module||goog.needsTranspile_(languageLevel))?goog.basePath+path in goog.dependencies_.deferred:!1;},goog.allDepsAreAvailable_=function(name){var path=goog.getPathFromDeps_(name);if(path&&path in goog.dependencies_.requires){for(var requireName in goog.dependencies_.requires[path]){if(!goog.isProvided_(requireName)&&!goog.isDeferredModule_(requireName)){return!1;}}}return!0;},goog.maybeProcessDeferredPath_=function(abspath){if(abspath in goog.dependencies_.deferred){var src=goog.dependencies_.deferred[abspath];delete goog.dependencies_.deferred[abspath];goog.globalEval(src);}},goog.loadModuleFromUrl=function(url){},goog.writeScriptSrcNode_=function(src){goog.global.document.write(\'<script type="text/javascript" src="\'+src+\'">\\x3c/script>\');},goog.appendScriptSrcNode_=function(src){var doc=goog.global.document,scriptEl=doc.createElement("script");scriptEl.type="text/javascript";scriptEl.src=src;scriptEl.defer=!1;scriptEl.async=!1;doc.head.appendChild(scriptEl);},goog.writeScriptTag_=function(src,opt_sourceText){if(goog.inHtmlDocument_()){var doc=goog.global.document;if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&"complete"==doc.readyState){if(/\\bdeps.js$/.test(src)){return!1;}throw Error(\'Cannot write "\'+src+\'" after document load\');}if(void 0===opt_sourceText){if(goog.IS_OLD_IE_){goog.oldIeWaiting_=!0;var state=" onreadystatechange=\'goog.onScriptLoad_(this, "+ ++goog.lastNonModuleScriptIndex_+")\' ";doc.write(\'<script type="text/javascript" src="\'+src+\'"\'+state+">\\x3c/script>");}else{goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING?goog.appendScriptSrcNode_(src):goog.writeScriptSrcNode_(src);}}else{doc.write(\'<script type="text/javascript">\'+goog.protectScriptTag_(opt_sourceText)+"\\x3c/script>");}return!0;}return!1;},goog.protectScriptTag_=function(str){return str.replace(/<\\/(SCRIPT)/ig,"\\\\x3c/$1");},goog.needsTranspile_=function(lang){if("always"==goog.TRANSPILE){return!0;}if("never"==goog.TRANSPILE){return!1;}goog.requiresTranspilation_||(goog.requiresTranspilation_=goog.createRequiresTranspilation_());if(lang in goog.requiresTranspilation_){return goog.requiresTranspilation_[lang];}throw Error("Unknown language mode: "+lang);},goog.requiresTranspilation_=null,goog.lastNonModuleScriptIndex_=0,goog.onScriptLoad_=function(script,scriptIndex){"complete"==script.readyState&&goog.lastNonModuleScriptIndex_==scriptIndex&&goog.loadQueuedModules_();return!0;},goog.writeScripts_=function(pathToLoad){function visitNode(path){if(!(path in deps.written||path in deps.visited)){deps.visited[path]=!0;if(path in deps.requires){for(var requireName in deps.requires[path]){if(!goog.isProvided_(requireName)){if(requireName in deps.nameToPath){visitNode(deps.nameToPath[requireName]);}else{throw Error("Undefined nameToPath for "+requireName);}}}}path in seenScript||(seenScript[path]=!0,scripts.push(path));}}var scripts=[],seenScript={},deps=goog.dependencies_;visitNode(pathToLoad);for(var i=0;i<scripts.length;i++){var path$jscomp$0=scripts[i];goog.dependencies_.written[path$jscomp$0]=!0;}var moduleState=goog.moduleLoaderState_;goog.moduleLoaderState_=null;for(i=0;i<scripts.length;i++){if(path$jscomp$0=scripts[i]){var loadFlags=deps.loadFlags[path$jscomp$0]||{},needsTranspile=goog.needsTranspile_(loadFlags.lang||"es3");"goog"==loadFlags.module||needsTranspile?goog.importProcessedScript_(goog.basePath+path$jscomp$0,"goog"==loadFlags.module,needsTranspile):goog.importScript_(goog.basePath+path$jscomp$0);}else{throw goog.moduleLoaderState_=moduleState,Error("Undefined script input");}}goog.moduleLoaderState_=moduleState;},goog.getPathFromDeps_=function(rule){return rule in goog.dependencies_.nameToPath?goog.dependencies_.nameToPath[rule]:null;},goog.findBasePath_(),goog.global.CLOSURE_NO_DEPS||goog.importScript_(goog.basePath+"deps.js"));goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var hasBadLetScoping=!eval(\'"use strict";let x = 1; function f() { return typeof x; };f() == "number";\');}catch(e){hasBadLetScoping=!1;}goog.hasBadLetScoping=hasBadLetScoping;}return goog.hasBadLetScoping;};goog.workaroundSafari10EvalBug=function(moduleDef){return"(function(){"+moduleDef+"\\n;})();\\n";};goog.loadModule=function(moduleDef){var previousState=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:void 0,declareLegacyNamespace:!1};if(goog.isFunction(moduleDef)){var exports=moduleDef.call(void 0,{});}else{if(goog.isString(moduleDef)){goog.useSafari10Workaround()&&(moduleDef=goog.workaroundSafari10EvalBug(moduleDef)),exports=goog.loadModuleFromSource_.call(void 0,moduleDef);}else{throw Error("Invalid module definition");}}var moduleName=goog.moduleLoaderState_.moduleName;if(!goog.isString(moduleName)||!moduleName){throw Error(\'Invalid module name "\'+moduleName+\'"\');}goog.moduleLoaderState_.declareLegacyNamespace?goog.constructNamespace_(moduleName,exports):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==(typeof exports==="undefined"?"undefined":_typeof(exports))&&null!=exports&&Object.seal(exports);goog.loadedModules_[moduleName]=exports;}finally{goog.moduleLoaderState_=previousState;}};goog.loadModuleFromSource_=function(JSCompiler_OptimizeArgumentsArray_p0){eval(JSCompiler_OptimizeArgumentsArray_p0);return{};};goog.normalizePath_=function(path){for(var components=path.split("/"),i=0;i<components.length;){"."==components[i]?components.splice(i,1):i&&".."==components[i]&&components[i-1]&&".."!=components[i-1]?components.splice(--i,2):i++;}return components.join("/");};goog.loadFileSync_=function(src){if(goog.global.CLOSURE_LOAD_FILE_SYNC){return goog.global.CLOSURE_LOAD_FILE_SYNC(src);}try{var xhr=new goog.global.XMLHttpRequest();xhr.open("get",src,!1);xhr.send();return 0==xhr.status||200==xhr.status?xhr.responseText:null;}catch(err){return null;}};goog.retrieveAndExec_=function(src,isModule,needsTranspile){var scriptText,importScript,originalPath;};goog.transpile_=function(code$jscomp$0,path$jscomp$0){var jscomp=goog.global.$jscomp;jscomp||(goog.global.$jscomp=jscomp={});var transpile=jscomp.transpile;if(!transpile){var transpilerPath=goog.basePath+goog.TRANSPILER,transpilerCode=goog.loadFileSync_(transpilerPath);if(transpilerCode){eval(transpilerCode+"\\n//# sourceURL="+transpilerPath);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile){throw Error(\'The transpiler did not properly export the "transpile" method. $gwtExport: \'+JSON.stringify(goog.global.$gwtExport));}goog.global.$jscomp.transpile=goog.global.$gwtExport.$jscomp.transpile;jscomp=goog.global.$jscomp;transpile=jscomp.transpile;}}if(!transpile){var suffix=" requires transpilation but no transpiler was found.",suffix=suffix+\' Please add "//javascript/closure:transpiler" as a data dependency to ensure it is included.\',transpile=jscomp.transpile=function(code,path){goog.logToConsole_(path+suffix);return code;};}return transpile(code$jscomp$0,path$jscomp$0);};goog.typeOf=function(value){var s=typeof value==="undefined"?"undefined":_typeof(value);if("object"==s){if(value){if(value instanceof Array){return"array";}if(value instanceof Object){return s;}var className=Object.prototype.toString.call(value);if("[object Window]"==className){return"object";}if("[object Array]"==className||"number"==typeof value.length&&"undefined"!=typeof value.splice&&"undefined"!=typeof value.propertyIsEnumerable&&!value.propertyIsEnumerable("splice")){return"array";}if("[object Function]"==className||"undefined"!=typeof value.call&&"undefined"!=typeof value.propertyIsEnumerable&&!value.propertyIsEnumerable("call")){return"function";}}else{return"null";}}else{if("function"==s&&"undefined"==typeof value.call){return"object";}}return s;};goog.isNull=function(val){return null===val;};goog.isDefAndNotNull=function(val){return null!=val;};goog.isArray=function(val){return"array"==goog.typeOf(val);};goog.isArrayLike=function(val){var type=goog.typeOf(val);return"array"==type||"object"==type&&"number"==typeof val.length;};goog.isDateLike=function(val){return goog.isObject(val)&&"function"==typeof val.getFullYear;};goog.isFunction=function(val){return"function"==goog.typeOf(val);};goog.isObject=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&null!=val||"function"==type;};goog.getUid=function(obj){return obj[goog.UID_PROPERTY_]||(obj[goog.UID_PROPERTY_]=++goog.uidCounter_);};goog.hasUid=function(obj){return!!obj[goog.UID_PROPERTY_];};goog.removeUid=function(obj){null!==obj&&"removeAttribute"in obj&&obj.removeAttribute(goog.UID_PROPERTY_);try{delete obj[goog.UID_PROPERTY_];}catch(ex){}};goog.UID_PROPERTY_="closure_uid_"+(1e9*Math.random()>>>0);goog.uidCounter_=0;goog.getHashCode=goog.getUid;goog.removeHashCode=goog.removeUid;goog.cloneObject=function(obj){var type=goog.typeOf(obj);if("object"==type||"array"==type){if(obj.clone){return obj.clone();}var clone="array"==type?[]:{},key;for(key in obj){clone[key]=goog.cloneObject(obj[key]);}return clone;}return obj;};goog.bindNative_=function(fn,selfObj,var_args){return fn.call.apply(fn.bind,arguments);};goog.bindJs_=function(fn,selfObj,var_args){if(!fn){throw Error();}if(2<arguments.length){var boundArgs=Array.prototype.slice.call(arguments,2);return function(){var newArgs=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(newArgs,boundArgs);return fn.apply(selfObj,newArgs);};}return function(){return fn.apply(selfObj,arguments);};};goog.bind=function(fn,selfObj,var_args){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments);};goog.partial=function(fn,var_args){var args=Array.prototype.slice.call(arguments,1);return function(){var newArgs=args.slice();newArgs.push.apply(newArgs,arguments);return fn.apply(this,newArgs);};};goog.mixin=function(target,source){for(var x in source){target[x]=source[x];}};goog.now=goog.TRUSTED_SITE&&Date.now||function(){return+new Date();};goog.globalEval=function(script){if(goog.global.execScript){goog.global.execScript(script,"JavaScript");}else{if(goog.global.eval){if(null==goog.evalWorksForGlobals_){if(goog.global.eval("var _evalTest_ = 1;"),"undefined"!=typeof goog.global._evalTest_){try{delete goog.global._evalTest_;}catch(ignore){}goog.evalWorksForGlobals_=!0;}else{goog.evalWorksForGlobals_=!1;}}if(goog.evalWorksForGlobals_){goog.global.eval(script);}else{var doc=goog.global.document,scriptElt=doc.createElement("SCRIPT");scriptElt.type="text/javascript";scriptElt.defer=!1;scriptElt.appendChild(doc.createTextNode(script));doc.body.appendChild(scriptElt);doc.body.removeChild(scriptElt);}}else{throw Error("goog.globalEval not available");}}};goog.evalWorksForGlobals_=null;goog.getCssName=function(className,opt_modifier){if("."==String(className).charAt(0)){throw Error(\'className passed in goog.getCssName must not start with ".". You passed: \'+className);}var getMapping=function getMapping(cssName){return goog.cssNameMapping_[cssName]||cssName;},renameByParts=function renameByParts(cssName){for(var parts=cssName.split("-"),mapped=[],i=0;i<parts.length;i++){mapped.push(getMapping(parts[i]));}return mapped.join("-");};var rename=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?getMapping:renameByParts:function(a){return a;};var result=opt_modifier?className+"-"+rename(opt_modifier):rename(className);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(result):result;};goog.setCssNameMapping=function(mapping,opt_style){goog.cssNameMapping_=mapping;goog.cssNameMappingStyle_=opt_style;};goog.getMsg=function(str,opt_values){opt_values&&(str=str.replace(/\\{\\$([^}]+)}/g,function(match,key){return null!=opt_values&&key in opt_values?opt_values[key]:match;}));return str;};goog.getMsgWithFallback=function(a,b){return a;};goog.exportSymbol=function(publicPath,object,opt_objectToExportTo){goog.exportPath_(publicPath,object,opt_objectToExportTo);};goog.exportProperty=function(object,publicName,symbol){object[publicName]=symbol;};goog.inherits=function(childCtor,parentCtor){function tempCtor(){}tempCtor.prototype=parentCtor.prototype;childCtor.superClass_=parentCtor.prototype;childCtor.prototype=new tempCtor();childCtor.prototype.constructor=childCtor;childCtor.base=function(me,methodName,var_args){for(var args=Array(arguments.length-2),i=2;i<arguments.length;i++){args[i-2]=arguments[i];}return parentCtor.prototype[methodName].apply(me,args);};};goog.base=function(me,opt_methodName,var_args){var caller=arguments.callee.caller;if(goog.STRICT_MODE_COMPATIBLE||goog.DEBUG&&!caller){throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");}if(caller.superClass_){for(var ctorArgs=Array(arguments.length-1),i=1;i<arguments.length;i++){ctorArgs[i-1]=arguments[i];}return caller.superClass_.constructor.apply(me,ctorArgs);}for(var args=Array(arguments.length-2),i=2;i<arguments.length;i++){args[i-2]=arguments[i];}for(var foundCaller=!1,ctor=me.constructor;ctor;ctor=ctor.superClass_&&ctor.superClass_.constructor){if(ctor.prototype[opt_methodName]===caller){foundCaller=!0;}else{if(foundCaller){return ctor.prototype[opt_methodName].apply(me,args);}}}if(me[opt_methodName]===caller){return me.constructor.prototype[opt_methodName].apply(me,args);}throw Error("goog.base called from a method of one name to a method of a different name");};goog.scope=function(fn){if(goog.isInModuleLoader_()){throw Error("goog.scope is not supported within a goog.module.");}fn.call(goog.global);};goog.defineClass=function(superClass,def){var constructor=def.constructor,statics=def.statics;constructor&&constructor!=Object.prototype.constructor||(constructor=function constructor(){throw Error("cannot instantiate an interface (no constructor defined).");});var cls=goog.defineClass.createSealingConstructor_(constructor,superClass);superClass&&goog.inherits(cls,superClass);delete def.constructor;delete def.statics;goog.defineClass.applyProperties_(cls.prototype,def);null!=statics&&(statics instanceof Function?statics(cls):goog.defineClass.applyProperties_(cls,statics));return cls;};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;goog.defineClass.createSealingConstructor_=function(ctr,superClass){if(!goog.defineClass.SEAL_CLASS_INSTANCES){return ctr;}var superclassSealable=!goog.defineClass.isUnsealable_(superClass),wrappedCtr=function wrappedCtr(){var instance=ctr.apply(this,arguments)||this;instance[goog.UID_PROPERTY_]=instance[goog.UID_PROPERTY_];this.constructor===wrappedCtr&&superclassSealable&&Object.seal instanceof Function&&Object.seal(instance);return instance;};return wrappedCtr;};goog.defineClass.isUnsealable_=function(ctr){return ctr&&ctr.prototype&&ctr.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");goog.defineClass.applyProperties_=function(target,source){for(var key in source){Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}for(var i=0;i<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;i++){key=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[i],Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}};goog.tagUnsealableClass=function(ctr){};goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_="goog_defineClass_legacy_unsealable";goog.createRequiresTranspilation_=function(){function addNewerLanguageTranspilationCheck(modeName,isSupported){transpilationRequiredForAllLaterModes?requiresTranspilation[modeName]=!0:isSupported()?requiresTranspilation[modeName]=!1:transpilationRequiredForAllLaterModes=requiresTranspilation[modeName]=!0;}function evalCheck(code){try{return!!eval(code);}catch(ignored){return!1;}}var requiresTranspilation={es3:!1},transpilationRequiredForAllLaterModes=!1,userAgent=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";addNewerLanguageTranspilationCheck("es5",function(){return evalCheck("[1,].length==1");});addNewerLanguageTranspilationCheck("es6",function(){var edgeUserAgent=userAgent.match(/Edge\\/(\\d+)(\\.\\d)*/i);return edgeUserAgent&&15>Number(edgeUserAgent[1])?!1:evalCheck(\'(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()\');});addNewerLanguageTranspilationCheck("es6-impl",function(){return!0;});addNewerLanguageTranspilationCheck("es7",function(){return evalCheck("2 ** 2 == 4");});addNewerLanguageTranspilationCheck("es8",function(){return evalCheck("async () => 1, true");});return requiresTranspilation;};goog.debug={};goog.debug.Error=function(opt_msg){if(Error.captureStackTrace){Error.captureStackTrace(this,goog.debug.Error);}else{var stack=Error().stack;stack&&(this.stack=stack);}opt_msg&&(this.message=String(opt_msg));this.reportErrorToServer=!0;};goog.inherits(goog.debug.Error,Error);goog.debug.Error.prototype.name="CustomError";goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.string={};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\\xA0"};goog.string.startsWith=function(str,prefix){return 0==str.lastIndexOf(prefix,0);};goog.string.endsWith=function(str,suffix){var l=str.length-suffix.length;return 0<=l&&str.indexOf(suffix,l)==l;};goog.string.caseInsensitiveStartsWith=function(str,prefix){return 0==goog.string.caseInsensitiveCompare(prefix,str.substr(0,prefix.length));};goog.string.caseInsensitiveEndsWith=function(str,suffix){return 0==goog.string.caseInsensitiveCompare(suffix,str.substr(str.length-suffix.length,suffix.length));};goog.string.caseInsensitiveEquals=function(str1,str2){return str1.toLowerCase()==str2.toLowerCase();};goog.string.subs=function(str,var_args){for(var splitParts=str.split("%s"),returnString="",subsArguments=Array.prototype.slice.call(arguments,1);subsArguments.length&&1<splitParts.length;){returnString+=splitParts.shift()+subsArguments.shift();}return returnString+splitParts.join("%s");};goog.string.collapseWhitespace=function(str){return str.replace(/[\\s\\xa0]+/g," ").replace(/^\\s+|\\s+$/g,"");};goog.string.isEmptyOrWhitespace=function(str){return /^[\\s\\xa0]*$/.test(str);};goog.string.isEmptyString=function(str){return 0==str.length;};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(str){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(str));};goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(str){return!/[^\\t\\n\\r ]/.test(str);};goog.string.isAlpha=function(str){return!/[^a-zA-Z]/.test(str);};goog.string.isNumeric=function(str){return!/[^0-9]/.test(str);};goog.string.isAlphaNumeric=function(str){return!/[^a-zA-Z0-9]/.test(str);};goog.string.isSpace=function(ch){return" "==ch;};goog.string.isUnicodeChar=function(ch){return 1==ch.length&&" "<=ch&&"~">=ch||"\\x80"<=ch&&"\\uFFFD">=ch;};goog.string.stripNewlines=function(str){return str.replace(/(\\r\\n|\\r|\\n)+/g," ");};goog.string.canonicalizeNewlines=function(str){return str.replace(/(\\r\\n|\\r|\\n)/g,"\\n");};goog.string.normalizeWhitespace=function(str){return str.replace(/\\xa0|\\s/g," ");};goog.string.normalizeSpaces=function(str){return str.replace(/\\xa0|[ \\t]+/g," ");};goog.string.collapseBreakingSpaces=function(str){return str.replace(/[\\t\\r\\n ]+/g," ").replace(/^[\\t\\r\\n ]+|[\\t\\r\\n ]+$/g,"");};goog.string.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(str){return str.trim();}:function(str){return str.replace(/^[\\s\\xa0]+|[\\s\\xa0]+$/g,"");};goog.string.trimLeft=function(str){return str.replace(/^[\\s\\xa0]+/,"");};goog.string.trimRight=function(str){return str.replace(/[\\s\\xa0]+$/,"");};goog.string.caseInsensitiveCompare=function(str1,str2){var test1=String(str1).toLowerCase(),test2=String(str2).toLowerCase();return test1<test2?-1:test1==test2?0:1;};goog.string.numberAwareCompare_=function(str1,str2,tokenizerRegExp){if(str1==str2){return 0;}if(!str1){return-1;}if(!str2){return 1;}for(var tokens1=str1.toLowerCase().match(tokenizerRegExp),tokens2=str2.toLowerCase().match(tokenizerRegExp),count=Math.min(tokens1.length,tokens2.length),i=0;i<count;i++){var a=tokens1[i],b=tokens2[i];if(a!=b){var num1=parseInt(a,10);if(!isNaN(num1)){var num2=parseInt(b,10);if(!isNaN(num2)&&num1-num2){return num1-num2;}}return a<b?-1:1;}}return tokens1.length!=tokens2.length?tokens1.length-tokens2.length:str1<str2?-1:1;};goog.string.intAwareCompare=function(str1,str2){return goog.string.numberAwareCompare_(str1,str2,/\\d+|\\D+/g);};goog.string.floatAwareCompare=function(str1,str2){return goog.string.numberAwareCompare_(str1,str2,/\\d+|\\.\\d+|\\D+/g);};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(str){return encodeURIComponent(String(str));};goog.string.urlDecode=function(str){return decodeURIComponent(str.replace(/\\+/g," "));};goog.string.newLineToBr=function(str,opt_xml){return str.replace(/(\\r\\n|\\r|\\n)/g,opt_xml?"<br />":"<br>");};goog.string.htmlEscape=function(str,opt_isLikelyToContainHtmlChars){if(opt_isLikelyToContainHtmlChars){str=str.replace(goog.string.AMP_RE_,"&amp;").replace(goog.string.LT_RE_,"&lt;").replace(goog.string.GT_RE_,"&gt;").replace(goog.string.QUOT_RE_,"&quot;").replace(goog.string.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.NULL_RE_,"&#0;"),goog.string.DETECT_DOUBLE_ESCAPING&&(str=str.replace(goog.string.E_RE_,"&#101;"));}else{if(!goog.string.ALL_RE_.test(str)){return str;}-1!=str.indexOf("&")&&(str=str.replace(goog.string.AMP_RE_,"&amp;"));-1!=str.indexOf("<")&&(str=str.replace(goog.string.LT_RE_,"&lt;"));-1!=str.indexOf(">")&&(str=str.replace(goog.string.GT_RE_,"&gt;"));-1!=str.indexOf(\'"\')&&(str=str.replace(goog.string.QUOT_RE_,"&quot;"));-1!=str.indexOf("\'")&&(str=str.replace(goog.string.SINGLE_QUOTE_RE_,"&#39;"));-1!=str.indexOf("\\x00")&&(str=str.replace(goog.string.NULL_RE_,"&#0;"));goog.string.DETECT_DOUBLE_ESCAPING&&-1!=str.indexOf("e")&&(str=str.replace(goog.string.E_RE_,"&#101;"));}return str;};goog.string.AMP_RE_=/&/g;goog.string.LT_RE_=/</g;goog.string.GT_RE_=/>/g;goog.string.QUOT_RE_=/"/g;goog.string.SINGLE_QUOTE_RE_=/\'/g;goog.string.NULL_RE_=/\\x00/g;goog.string.E_RE_=/e/g;goog.string.ALL_RE_=goog.string.DETECT_DOUBLE_ESCAPING?/[\\x00&<>"\'e]/:/[\\x00&<>"\']/;goog.string.unescapeEntities=function(str){return goog.string.contains(str,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(str):goog.string.unescapePureXmlEntities_(str):str;};goog.string.unescapeEntitiesWithDocument=function(str,document){return goog.string.contains(str,"&")?goog.string.unescapeEntitiesUsingDom_(str,document):str;};goog.string.unescapeEntitiesUsingDom_=function(str,opt_document){var seen={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":\'"\'};var div=opt_document?opt_document.createElement("div"):goog.global.document.createElement("div");return str.replace(goog.string.HTML_ENTITY_PATTERN_,function(s,entity){var value=seen[s];if(value){return value;}if("#"==entity.charAt(0)){var n=Number("0"+entity.substr(1));isNaN(n)||(value=String.fromCharCode(n));}value||(div.innerHTML=s+" ",value=div.firstChild.nodeValue.slice(0,-1));return seen[s]=value;});};goog.string.unescapePureXmlEntities_=function(str){return str.replace(/&([^;]+);/g,function(s,entity){switch(entity){case"amp":return"&";case"lt":return"<";case"gt":return">";case"quot":return\'"\';default:if("#"==entity.charAt(0)){var n=Number("0"+entity.substr(1));if(!isNaN(n)){return String.fromCharCode(n);}}return s;}});};goog.string.HTML_ENTITY_PATTERN_=/&([^;\\s<&]+);?/g;goog.string.whitespaceEscape=function(str,opt_xml){return goog.string.newLineToBr(str.replace(/  /g," &#160;"),opt_xml);};goog.string.preserveSpaces=function(str){return str.replace(/(^|[\\n ]) /g,"$1"+goog.string.Unicode.NBSP);};goog.string.stripQuotes=function(str,quoteChars){for(var length=quoteChars.length,i=0;i<length;i++){var quoteChar=1==length?quoteChars:quoteChars.charAt(i);if(str.charAt(0)==quoteChar&&str.charAt(str.length-1)==quoteChar){return str.substring(1,str.length-1);}}return str;};goog.string.truncate=function(str,chars,opt_protectEscapedCharacters){opt_protectEscapedCharacters&&(str=goog.string.unescapeEntities(str));str.length>chars&&(str=str.substring(0,chars-3)+"...");opt_protectEscapedCharacters&&(str=goog.string.htmlEscape(str));return str;};goog.string.truncateMiddle=function(str,chars,opt_protectEscapedCharacters,opt_trailingChars){opt_protectEscapedCharacters&&(str=goog.string.unescapeEntities(str));if(opt_trailingChars&&str.length>chars){opt_trailingChars>chars&&(opt_trailingChars=chars),str=str.substring(0,chars-opt_trailingChars)+"..."+str.substring(str.length-opt_trailingChars);}else{if(str.length>chars){var half=Math.floor(chars/2);str=str.substring(0,half+chars%2)+"..."+str.substring(str.length-half);}}opt_protectEscapedCharacters&&(str=goog.string.htmlEscape(str));return str;};goog.string.specialEscapeChars_={"\\x00":"\\\\0","\\b":"\\\\b","\\f":"\\\\f","\\n":"\\\\n","\\r":"\\\\r","\\t":"\\\\t","\\x0B":"\\\\x0B",\'"\':\'\\\\"\',"\\\\":"\\\\\\\\","<":"<"};goog.string.jsEscapeCache_={"\'":"\\\\\'"};goog.string.quote=function(s){s=String(s);for(var sb=[\'"\'],i=0;i<s.length;i++){var ch=s.charAt(i),cc=ch.charCodeAt(0);sb[i+1]=goog.string.specialEscapeChars_[ch]||(31<cc&&127>cc?ch:goog.string.escapeChar(ch));}sb.push(\'"\');return sb.join("");};goog.string.escapeString=function(str){for(var sb=[],i=0;i<str.length;i++){sb[i]=goog.string.escapeChar(str.charAt(i));}return sb.join("");};goog.string.escapeChar=function(c){if(c in goog.string.jsEscapeCache_){return goog.string.jsEscapeCache_[c];}if(c in goog.string.specialEscapeChars_){return goog.string.jsEscapeCache_[c]=goog.string.specialEscapeChars_[c];}var rv=c,cc=c.charCodeAt(0);if(31<cc&&127>cc){rv=c;}else{if(256>cc){if(rv="\\\\x",16>cc||256<cc){rv+="0";}}else{rv="\\\\u",4096>cc&&(rv+="0");}rv+=cc.toString(16).toUpperCase();}return goog.string.jsEscapeCache_[c]=rv;};goog.string.contains=function(str,subString){return-1!=str.indexOf(subString);};goog.string.caseInsensitiveContains=function(str,subString){return goog.string.contains(str.toLowerCase(),subString.toLowerCase());};goog.string.countOf=function(s,ss){return s&&ss?s.split(ss).length-1:0;};goog.string.removeAt=function(s,index,stringLength){var resultStr=s;0<=index&&index<s.length&&0<stringLength&&(resultStr=s.substr(0,index)+s.substr(index+stringLength,s.length-index-stringLength));return resultStr;};goog.string.remove=function(str,substr){return str.replace(substr,"");};goog.string.removeAll=function(s,ss){var re=new RegExp(goog.string.regExpEscape(ss),"g");return s.replace(re,"");};goog.string.replaceAll=function(s,ss,replacement){var re=new RegExp(goog.string.regExpEscape(ss),"g");return s.replace(re,replacement.replace(/\\$/g,"$$$$"));};goog.string.regExpEscape=function(s){return String(s).replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1").replace(/\\x08/g,"\\\\x08");};goog.string.repeat=String.prototype.repeat?function(string,length){return string.repeat(length);}:function(string,length){return Array(length+1).join(string);};goog.string.padNumber=function(num,length,opt_precision){var s=goog.isDef(opt_precision)?num.toFixed(opt_precision):String(num),index=s.indexOf(".");-1==index&&(index=s.length);return goog.string.repeat("0",Math.max(0,length-index))+s;};goog.string.makeSafe=function(obj){return null==obj?"":String(obj);};goog.string.buildString=function(var_args){return Array.prototype.join.call(arguments,"");};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36);};goog.string.compareVersions=function(version1,version2){for(var order=0,v1Subs=goog.string.trim(String(version1)).split("."),v2Subs=goog.string.trim(String(version2)).split("."),subCount=Math.max(v1Subs.length,v2Subs.length),subIdx=0;0==order&&subIdx<subCount;subIdx++){var v1Sub=v1Subs[subIdx]||"",v2Sub=v2Subs[subIdx]||"";do{var v1Comp=/(\\d*)(\\D*)(.*)/.exec(v1Sub)||["","","",""],v2Comp=/(\\d*)(\\D*)(.*)/.exec(v2Sub)||["","","",""];if(0==v1Comp[0].length&&0==v2Comp[0].length){break;}order=goog.string.compareElements_(0==v1Comp[1].length?0:parseInt(v1Comp[1],10),0==v2Comp[1].length?0:parseInt(v2Comp[1],10))||goog.string.compareElements_(0==v1Comp[2].length,0==v2Comp[2].length)||goog.string.compareElements_(v1Comp[2],v2Comp[2]);v1Sub=v1Comp[3];v2Sub=v2Comp[3];}while(0==order);}return order;};goog.string.compareElements_=function(left,right){return left<right?-1:left>right?1:0;};goog.string.hashCode=function(str){for(var result=0,i=0;i<str.length;++i){result=31*result+str.charCodeAt(i)>>>0;}return result;};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++;};goog.string.toNumber=function(str){var num=Number(str);return 0==num&&goog.string.isEmptyOrWhitespace(str)?NaN:num;};goog.string.isLowerCamelCase=function(str){return /^[a-z]+([A-Z][a-z]*)*$/.test(str);};goog.string.isUpperCamelCase=function(str){return /^([A-Z][a-z]*)+$/.test(str);};goog.string.toCamelCase=function(str){return String(str).replace(/\\-([a-z])/g,function(all,match){return match.toUpperCase();});};goog.string.toSelectorCase=function(str){return String(str).replace(/([A-Z])/g,"-$1").toLowerCase();};goog.string.toTitleCase=function(str,opt_delimiters){var delimiters=goog.isString(opt_delimiters)?goog.string.regExpEscape(opt_delimiters):"\\\\s";return str.replace(new RegExp("(^"+(delimiters?"|["+delimiters+"]+":"")+")([a-z])","g"),function(all,p1,p2){return p1+p2.toUpperCase();});};goog.string.capitalize=function(str){return String(str.charAt(0)).toUpperCase()+String(str.substr(1)).toLowerCase();};goog.string.parseInt=function(value){isFinite(value)&&(value=String(value));return goog.isString(value)?/^\\s*-?0x/i.test(value)?parseInt(value,16):parseInt(value,10):NaN;};goog.string.splitLimit=function(str,separator,limit){for(var parts=str.split(separator),returnVal=[];0<limit&&parts.length;){returnVal.push(parts.shift()),limit--;}parts.length&&returnVal.push(parts.join(separator));return returnVal;};goog.string.lastComponent=function(str,separators){if(separators){"string"==typeof separators&&(separators=[separators]);}else{return str;}for(var lastSeparatorIndex=-1,i=0;i<separators.length;i++){if(""!=separators[i]){var currentSeparatorIndex=str.lastIndexOf(separators[i]);currentSeparatorIndex>lastSeparatorIndex&&(lastSeparatorIndex=currentSeparatorIndex);}}return-1==lastSeparatorIndex?str:str.slice(lastSeparatorIndex+1);};goog.string.editDistance=function(a,b){var v0=[],v1=[];if(a==b){return 0;}if(!a.length||!b.length){return Math.max(a.length,b.length);}for(var i=0;i<b.length+1;i++){v0[i]=i;}for(i=0;i<a.length;i++){v1[0]=i+1;for(var j=0;j<b.length;j++){v1[j+1]=Math.min(v1[j]+1,v0[j+1]+1,v0[j]+Number(a[i]!=b[j]));}for(j=0;j<v0.length;j++){v0[j]=v1[j];}}return v1[b.length];};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(messagePattern,messageArgs){messageArgs.unshift(messagePattern);goog.debug.Error.call(this,goog.string.subs.apply(null,messageArgs));messageArgs.shift();this.messagePattern=messagePattern;};goog.inherits(goog.asserts.AssertionError,goog.debug.Error);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(e){throw e;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;goog.asserts.doAssertFailure_=function(defaultMessage,defaultArgs,givenMessage,givenArgs){var message="Assertion failed";if(givenMessage){message+=": "+givenMessage;var args=givenArgs;}else{defaultMessage&&(message+=": "+defaultMessage,args=defaultArgs);}var e=new goog.asserts.AssertionError(""+message,args||[]);goog.asserts.errorHandler_(e);};goog.asserts.setErrorHandler=function(errorHandler){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=errorHandler);};goog.asserts.assert=function(condition,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!condition&&goog.asserts.doAssertFailure_("",null,opt_message,Array.prototype.slice.call(arguments,2));return condition;};goog.asserts.fail=function(opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(opt_message?": "+opt_message:""),Array.prototype.slice.call(arguments,1)));};goog.asserts.assertNumber=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isNumber(value)&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertString=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isString(value)&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertFunction=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isFunction(value)&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertObject=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(value)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertArray=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isArray(value)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertBoolean=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isBoolean(value)&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertElement=function(value,opt_message,var_args){!goog.asserts.ENABLE_ASSERTS||goog.isObject(value)&&value.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertInstanceof=function(value,type,opt_message,var_args){!goog.asserts.ENABLE_ASSERTS||value instanceof type||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(type),goog.asserts.getType_(value)],opt_message,Array.prototype.slice.call(arguments,3));return value;};goog.asserts.assertObjectPrototypeIsIntact=function(){for(var key in Object.prototype){goog.asserts.fail(key+" should not be enumerable in Object.prototype.");}};goog.asserts.getType_=function(value){return value instanceof Function?value.displayName||value.name||"unknown type name":value instanceof Object?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;goog.array.ASSUME_NATIVE_FUNCTIONS=!1;goog.array.peek=function(array){return array[array.length-1];};goog.array.last=goog.array.peek;goog.array.indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(arr,obj,opt_fromIndex){goog.asserts.assert(null!=arr.length);return Array.prototype.indexOf.call(arr,obj,opt_fromIndex);}:function(arr,obj,opt_fromIndex){var fromIndex=null==opt_fromIndex?0:0>opt_fromIndex?Math.max(0,arr.length+opt_fromIndex):opt_fromIndex;if(goog.isString(arr)){return goog.isString(obj)&&1==obj.length?arr.indexOf(obj,fromIndex):-1;}for(var i=fromIndex;i<arr.length;i++){if(i in arr&&arr[i]===obj){return i;}}return-1;};goog.array.lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(arr,obj,opt_fromIndex){goog.asserts.assert(null!=arr.length);return Array.prototype.lastIndexOf.call(arr,obj,null==opt_fromIndex?arr.length-1:opt_fromIndex);}:function(arr,obj,opt_fromIndex){var fromIndex=null==opt_fromIndex?arr.length-1:opt_fromIndex;0>fromIndex&&(fromIndex=Math.max(0,arr.length+fromIndex));if(goog.isString(arr)){return goog.isString(obj)&&1==obj.length?arr.lastIndexOf(obj,fromIndex):-1;}for(var i=fromIndex;0<=i;i--){if(i in arr&&arr[i]===obj){return i;}}return-1;};goog.array.forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);Array.prototype.forEach.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){i in arr2&&f.call(opt_obj,arr2[i],i,arr);}};goog.array.forEachRight=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=l-1;0<=i;--i){i in arr2&&f.call(opt_obj,arr2[i],i,arr);}};goog.array.filter=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.filter.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,res=[],resLength=0,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2){var val=arr2[i];f.call(opt_obj,val,i,arr)&&(res[resLength++]=val);}}return res;};goog.array.map=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.map.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,res=Array(l),arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){i in arr2&&(res[i]=f.call(opt_obj,arr2[i],i,arr));}return res;};goog.array.reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(arr,f,val,opt_obj){goog.asserts.assert(null!=arr.length);opt_obj&&(f=goog.bind(f,opt_obj));return Array.prototype.reduce.call(arr,f,val);}:function(arr,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.array.forEach(arr,function(val,index){rval=f.call(opt_obj,rval,val,index,arr);});return rval;};goog.array.reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(arr,f,val,opt_obj){goog.asserts.assert(null!=arr.length);goog.asserts.assert(null!=f);opt_obj&&(f=goog.bind(f,opt_obj));return Array.prototype.reduceRight.call(arr,f,val);}:function(arr,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.array.forEachRight(arr,function(val,index){rval=f.call(opt_obj,rval,val,index,arr);});return rval;};goog.array.some=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.some.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return!0;}}return!1;};goog.array.every=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.every.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&!f.call(opt_obj,arr2[i],i,arr)){return!1;}}return!0;};goog.array.count=function(arr$jscomp$0,f,opt_obj){var count=0;goog.array.forEach(arr$jscomp$0,function(element,index,arr){f.call(opt_obj,element,index,arr)&&++count;},opt_obj);return count;};goog.array.find=function(arr,f,opt_obj){var i=goog.array.findIndex(arr,f,opt_obj);return 0>i?null:goog.isString(arr)?arr.charAt(i):arr[i];};goog.array.findIndex=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return i;}}return-1;};goog.array.findRight=function(arr,f,opt_obj){var i=goog.array.findIndexRight(arr,f,opt_obj);return 0>i?null:goog.isString(arr)?arr.charAt(i):arr[i];};goog.array.findIndexRight=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=l-1;0<=i;i--){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return i;}}return-1;};goog.array.contains=function(arr,obj){return 0<=goog.array.indexOf(arr,obj);};goog.array.isEmpty=function(arr){return 0==arr.length;};goog.array.clear=function(arr){if(!goog.isArray(arr)){for(var i=arr.length-1;0<=i;i--){delete arr[i];}}arr.length=0;};goog.array.insert=function(arr,obj){goog.array.contains(arr,obj)||arr.push(obj);};goog.array.insertAt=function(arr,obj,opt_i){goog.array.splice(arr,opt_i,0,obj);};goog.array.insertArrayAt=function(arr,elementsToAdd,opt_i){goog.partial(goog.array.splice,arr,opt_i,0).apply(null,elementsToAdd);};goog.array.insertBefore=function(arr,obj,opt_obj2){var i;2==arguments.length||0>(i=goog.array.indexOf(arr,opt_obj2))?arr.push(obj):goog.array.insertAt(arr,obj,i);};goog.array.remove=function(arr,obj){var i=goog.array.indexOf(arr,obj),rv;(rv=0<=i)&&goog.array.removeAt(arr,i);return rv;};goog.array.removeLast=function(arr,obj){var i=goog.array.lastIndexOf(arr,obj);return 0<=i?(goog.array.removeAt(arr,i),!0):!1;};goog.array.removeAt=function(arr,i){goog.asserts.assert(null!=arr.length);return 1==Array.prototype.splice.call(arr,i,1).length;};goog.array.removeIf=function(arr,f,opt_obj){var i=goog.array.findIndex(arr,f,opt_obj);return 0<=i?(goog.array.removeAt(arr,i),!0):!1;};goog.array.removeAllIf=function(arr,f,opt_obj){var removedCount=0;goog.array.forEachRight(arr,function(val,index){f.call(opt_obj,val,index,arr)&&goog.array.removeAt(arr,index)&&removedCount++;});return removedCount;};goog.array.concat=function(var_args){return Array.prototype.concat.apply([],arguments);};goog.array.join=function(var_args){return Array.prototype.concat.apply([],arguments);};goog.array.toArray=function(object){var length=object.length;if(0<length){for(var rv=Array(length),i=0;i<length;i++){rv[i]=object[i];}return rv;}return[];};goog.array.clone=goog.array.toArray;goog.array.extend=function(arr1,var_args){for(var i=1;i<arguments.length;i++){var arr2=arguments[i];if(goog.isArrayLike(arr2)){var len1=arr1.length||0,len2=arr2.length||0;arr1.length=len1+len2;for(var j=0;j<len2;j++){arr1[len1+j]=arr2[j];}}else{arr1.push(arr2);}}};goog.array.splice=function(arr,index,howMany,var_args){goog.asserts.assert(null!=arr.length);return Array.prototype.splice.apply(arr,goog.array.slice(arguments,1));};goog.array.slice=function(arr,start,opt_end){goog.asserts.assert(null!=arr.length);return 2>=arguments.length?Array.prototype.slice.call(arr,start):Array.prototype.slice.call(arr,start,opt_end);};goog.array.removeDuplicates=function(arr,opt_rv,opt_hashFn){for(var returnArray=opt_rv||arr,defaultHashFn=function defaultHashFn(item){return goog.isObject(item)?"o"+goog.getUid(item):(typeof item==="undefined"?"undefined":_typeof(item)).charAt(0)+item;},hashFn=opt_hashFn||defaultHashFn,seen={},cursorInsert=0,cursorRead=0;cursorRead<arr.length;){var current=arr[cursorRead++],key=hashFn(current);Object.prototype.hasOwnProperty.call(seen,key)||(seen[key]=!0,returnArray[cursorInsert++]=current);}returnArray.length=cursorInsert;};goog.array.binarySearch=function(arr,target,opt_compareFn){return goog.array.binarySearch_(arr,opt_compareFn||goog.array.defaultCompare,!1,target);};goog.array.binarySelect=function(arr,evaluator,opt_obj){return goog.array.binarySearch_(arr,evaluator,!0,void 0,opt_obj);};goog.array.binarySearch_=function(arr,compareFn,isEvaluator,opt_target,opt_selfObj){for(var left=0,right=arr.length,found;left<right;){var middle=left+right>>1;var compareResult=isEvaluator?compareFn.call(opt_selfObj,arr[middle],middle,arr):compareFn(opt_target,arr[middle]);0<compareResult?left=middle+1:(right=middle,found=!compareResult);}return found?left:~left;};goog.array.sort=function(arr,opt_compareFn){arr.sort(opt_compareFn||goog.array.defaultCompare);};goog.array.stableSort=function(arr,opt_compareFn){for(var compArr=Array(arr.length),i=0;i<arr.length;i++){compArr[i]={index:i,value:arr[i]};}var valueCompareFn=opt_compareFn||goog.array.defaultCompare;goog.array.sort(compArr,function stableCompareFn(obj1,obj2){return valueCompareFn(obj1.value,obj2.value)||obj1.index-obj2.index;});for(i=0;i<arr.length;i++){arr[i]=compArr[i].value;}};goog.array.sortByKey=function(arr,keyFn,opt_compareFn){var keyCompareFn=opt_compareFn||goog.array.defaultCompare;goog.array.sort(arr,function(a,b){return keyCompareFn(keyFn(a),keyFn(b));});};goog.array.sortObjectsByKey=function(arr,key,opt_compareFn){goog.array.sortByKey(arr,function(obj){return obj[key];},opt_compareFn);};goog.array.isSorted=function(arr,opt_compareFn,opt_strict){for(var compare=opt_compareFn||goog.array.defaultCompare,i=1;i<arr.length;i++){var compareResult=compare(arr[i-1],arr[i]);if(0<compareResult||0==compareResult&&opt_strict){return!1;}}return!0;};goog.array.equals=function(arr1,arr2,opt_equalsFn){if(!goog.isArrayLike(arr1)||!goog.isArrayLike(arr2)||arr1.length!=arr2.length){return!1;}for(var l=arr1.length,equalsFn=opt_equalsFn||goog.array.defaultCompareEquality,i=0;i<l;i++){if(!equalsFn(arr1[i],arr2[i])){return!1;}}return!0;};goog.array.compare3=function(arr1,arr2,opt_compareFn){for(var compare=opt_compareFn||goog.array.defaultCompare,l=Math.min(arr1.length,arr2.length),i=0;i<l;i++){var result=compare(arr1[i],arr2[i]);if(0!=result){return result;}}return goog.array.defaultCompare(arr1.length,arr2.length);};goog.array.defaultCompare=function(a,b){return a>b?1:a<b?-1:0;};goog.array.inverseDefaultCompare=function(a,b){return-goog.array.defaultCompare(a,b);};goog.array.defaultCompareEquality=function(a,b){return a===b;};goog.array.binaryInsert=function(array,value,opt_compareFn){var index=goog.array.binarySearch(array,value,opt_compareFn);return 0>index?(goog.array.insertAt(array,value,-(index+1)),!0):!1;};goog.array.binaryRemove=function(array,value,opt_compareFn){var index=goog.array.binarySearch(array,value,opt_compareFn);return 0<=index?goog.array.removeAt(array,index):!1;};goog.array.bucket=function(array,sorter,opt_obj){for(var buckets={},i=0;i<array.length;i++){var value=array[i],key=sorter.call(opt_obj,value,i,array);goog.isDef(key)&&(buckets[key]||(buckets[key]=[])).push(value);}return buckets;};goog.array.toObject=function(arr,keyFunc,opt_obj){var ret={};goog.array.forEach(arr,function(element,index){ret[keyFunc.call(opt_obj,element,index,arr)]=element;});return ret;};goog.array.range=function(startOrEnd,opt_end,opt_step){var array=[],start=0,end=startOrEnd,step=opt_step||1;void 0!==opt_end&&(start=startOrEnd,end=opt_end);if(0>step*(end-start)){return[];}if(0<step){for(var i=start;i<end;i+=step){array.push(i);}}else{for(i=start;i>end;i+=step){array.push(i);}}return array;};goog.array.repeat=function(value,n){for(var array=[],i=0;i<n;i++){array[i]=value;}return array;};goog.array.flatten=function(var_args){for(var result=[],i=0;i<arguments.length;i++){var element=arguments[i];if(goog.isArray(element)){for(var c=0;c<element.length;c+=8192){for(var chunk=goog.array.slice(element,c,c+8192),recurseResult=goog.array.flatten.apply(null,chunk),r=0;r<recurseResult.length;r++){result.push(recurseResult[r]);}}}else{result.push(element);}}return result;};goog.array.rotate=function(array,n){goog.asserts.assert(null!=array.length);array.length&&(n%=array.length,0<n?Array.prototype.unshift.apply(array,array.splice(-n,n)):0>n&&Array.prototype.push.apply(array,array.splice(0,-n)));return array;};goog.array.moveItem=function(arr,fromIndex,toIndex){goog.asserts.assert(0<=fromIndex&&fromIndex<arr.length);goog.asserts.assert(0<=toIndex&&toIndex<arr.length);var removedItems=Array.prototype.splice.call(arr,fromIndex,1);Array.prototype.splice.call(arr,toIndex,0,removedItems[0]);};goog.array.zip=function(var_args){if(!arguments.length){return[];}for(var result=[],minLen=arguments[0].length,i=1;i<arguments.length;i++){arguments[i].length<minLen&&(minLen=arguments[i].length);}for(i=0;i<minLen;i++){for(var value=[],j=0;j<arguments.length;j++){value.push(arguments[j][i]);}result.push(value);}return result;};goog.array.shuffle=function(arr,opt_randFn){for(var randFn=opt_randFn||Math.random,i=arr.length-1;0<i;i--){var j=Math.floor(randFn()*(i+1)),tmp=arr[i];arr[i]=arr[j];arr[j]=tmp;}};goog.array.copyByIndex=function(arr,index_arr){var result=[];goog.array.forEach(index_arr,function(index){result.push(arr[index]);});return result;};goog.array.concatMap=function(arr,f,opt_obj){return goog.array.concat.apply([],goog.array.map(arr,f,opt_obj));};goog.disposable={};goog.disposable.IDisposable=function(){};goog.Disposable=function(){goog.Disposable.MONITORING_MODE!=goog.Disposable.MonitoringMode.OFF&&(goog.Disposable.INCLUDE_STACK_ON_CREATION&&(this.creationStack=Error().stack),goog.Disposable.instances_[goog.getUid(this)]=this);this.disposed_=this.disposed_;this.onDisposeCallbacks_=this.onDisposeCallbacks_;};goog.Disposable.MonitoringMode={OFF:0,PERMANENT:1,INTERACTIVE:2};goog.Disposable.MONITORING_MODE=0;goog.Disposable.INCLUDE_STACK_ON_CREATION=!0;goog.Disposable.instances_={};goog.Disposable.getUndisposedObjects=function(){var ret=[],id;for(id in goog.Disposable.instances_){goog.Disposable.instances_.hasOwnProperty(id)&&ret.push(goog.Disposable.instances_[Number(id)]);}return ret;};goog.Disposable.clearUndisposedObjects=function(){goog.Disposable.instances_={};};goog.Disposable.prototype.disposed_=!1;goog.Disposable.prototype.isDisposed=function(){return this.disposed_;};goog.Disposable.prototype.getDisposed=goog.Disposable.prototype.isDisposed;goog.Disposable.prototype.dispose=function(){if(!this.disposed_&&(this.disposed_=!0,this.disposeInternal(),goog.Disposable.MONITORING_MODE!=goog.Disposable.MonitoringMode.OFF)){var uid=goog.getUid(this);if(goog.Disposable.MONITORING_MODE==goog.Disposable.MonitoringMode.PERMANENT&&!goog.Disposable.instances_.hasOwnProperty(uid)){throw Error(this+" did not call the goog.Disposable base constructor or was disposed of after a clearUndisposedObjects call");}delete goog.Disposable.instances_[uid];}};goog.Disposable.prototype.registerDisposable=function(disposable){this.addOnDisposeCallback(goog.partial(goog.dispose,disposable));};goog.Disposable.prototype.addOnDisposeCallback=function(callback,opt_scope){this.disposed_?goog.isDef(opt_scope)?callback.call(opt_scope):callback():(this.onDisposeCallbacks_||(this.onDisposeCallbacks_=[]),this.onDisposeCallbacks_.push(goog.isDef(opt_scope)?goog.bind(callback,opt_scope):callback));};goog.Disposable.prototype.disposeInternal=function(){if(this.onDisposeCallbacks_){for(;this.onDisposeCallbacks_.length;){this.onDisposeCallbacks_.shift()();}}};goog.Disposable.isDisposed=function(obj){return obj&&"function"==typeof obj.isDisposed?obj.isDisposed():!1;};goog.dispose=function(obj){obj&&"function"==typeof obj.dispose&&obj.dispose();};goog.disposeAll=function(var_args){for(var i=0,len=arguments.length;i<len;++i){var disposable=arguments[i];goog.isArrayLike(disposable)?goog.disposeAll.apply(null,disposable):goog.dispose(disposable);}};goog.events={};goog.events.EventId=function(eventId){this.id=eventId;};goog.events.EventId.prototype.toString=function(){return this.id;};goog.events.Event=function(type,opt_target){this.type=type instanceof goog.events.EventId?String(type):type;this.currentTarget=this.target=opt_target;this.defaultPrevented=this.propagationStopped_=!1;this.returnValue_=!0;};goog.events.Event.prototype.stopPropagation=function(){this.propagationStopped_=!0;};goog.events.Event.prototype.preventDefault=function(){this.defaultPrevented=!0;this.returnValue_=!1;};goog.events.Event.stopPropagation=function(e){e.stopPropagation();};goog.events.Event.preventDefault=function(e){e.preventDefault();};goog.debug.entryPointRegistry={};goog.debug.EntryPointMonitor=function(){};goog.debug.entryPointRegistry.refList_=[];goog.debug.entryPointRegistry.monitors_=[];goog.debug.entryPointRegistry.monitorsMayExist_=!1;goog.debug.entryPointRegistry.register=function(callback){goog.debug.entryPointRegistry.refList_[goog.debug.entryPointRegistry.refList_.length]=callback;if(goog.debug.entryPointRegistry.monitorsMayExist_){for(var monitors=goog.debug.entryPointRegistry.monitors_,i=0;i<monitors.length;i++){callback(goog.bind(monitors[i].wrap,monitors[i]));}}};goog.debug.entryPointRegistry.monitorAll=function(monitor){goog.debug.entryPointRegistry.monitorsMayExist_=!0;for(var transformer=goog.bind(monitor.wrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}goog.debug.entryPointRegistry.monitors_.push(monitor);};goog.debug.entryPointRegistry.unmonitorAllIfPossible=function(monitor){var monitors=goog.debug.entryPointRegistry.monitors_;goog.asserts.assert(monitor==monitors[monitors.length-1],"Only the most recent monitor can be unwrapped.");for(var transformer=goog.bind(monitor.unwrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}monitors.length--;};goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var navigator=goog.labs.userAgent.util.getNavigator_();if(navigator){var userAgent=navigator.userAgent;if(userAgent){return userAgent;}}return"";};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator;};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(opt_userAgent){goog.labs.userAgent.util.userAgent_=opt_userAgent||goog.labs.userAgent.util.getNativeUserAgentString_();};goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_;};goog.labs.userAgent.util.matchUserAgent=function(str){return goog.string.contains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(str){return goog.string.caseInsensitiveContains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.extractVersionTuples=function(userAgent){for(var versionRegExp=/(\\w[\\w ]+)\\/([^\\s]+)\\s*(?:\\((.*?)\\))?/g,data=[],match;match=versionRegExp.exec(userAgent);){data.push([match[1],match[2],match[3]||void 0]);}return data;};goog.debug.entryPointRegistry={};goog.debug.EntryPointMonitor=function(){};goog.debug.entryPointRegistry.refList_=[];goog.debug.entryPointRegistry.monitors_=[];goog.debug.entryPointRegistry.monitorsMayExist_=!1;goog.debug.entryPointRegistry.register=function(callback){goog.debug.entryPointRegistry.refList_[goog.debug.entryPointRegistry.refList_.length]=callback;if(goog.debug.entryPointRegistry.monitorsMayExist_){for(var monitors=goog.debug.entryPointRegistry.monitors_,i=0;i<monitors.length;i++){callback(goog.bind(monitors[i].wrap,monitors[i]));}}};goog.debug.entryPointRegistry.monitorAll=function(monitor){goog.debug.entryPointRegistry.monitorsMayExist_=!0;for(var transformer=goog.bind(monitor.wrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}goog.debug.entryPointRegistry.monitors_.push(monitor);};goog.debug.entryPointRegistry.unmonitorAllIfPossible=function(monitor){var monitors=goog.debug.entryPointRegistry.monitors_;goog.asserts.assert(monitor==monitors[monitors.length-1],"Only the most recent monitor can be unwrapped.");for(var transformer=goog.bind(monitor.unwrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}monitors.length--;};goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var navigator=goog.labs.userAgent.util.getNavigator_();if(navigator){var userAgent=navigator.userAgent;if(userAgent){return userAgent;}}return"";};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator;};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(opt_userAgent){goog.labs.userAgent.util.userAgent_=opt_userAgent||goog.labs.userAgent.util.getNativeUserAgentString_();};goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_;};goog.labs.userAgent.util.matchUserAgent=function(str){return goog.string.contains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(str){return goog.string.caseInsensitiveContains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.extractVersionTuples=function(userAgent){for(var versionRegExp=/(\\w[\\w ]+)\\/([^\\s]+)\\s*(?:\\((.*?)\\))?/g,data=[],match;match=versionRegExp.exec(userAgent);){data.push([match[1],match[2],match[3]||void 0]);}return data;};goog.object={};goog.object.is=function(v,v2){return v===v2?0!==v||1/v===1/v2:v!==v&&v2!==v2;};goog.object.forEach=function(obj,f,opt_obj){for(var key in obj){f.call(opt_obj,obj[key],key,obj);}};goog.object.filter=function(obj,f,opt_obj){var res={},key;for(key in obj){f.call(opt_obj,obj[key],key,obj)&&(res[key]=obj[key]);}return res;};goog.object.map=function(obj,f,opt_obj){var res={},key;for(key in obj){res[key]=f.call(opt_obj,obj[key],key,obj);}return res;};goog.object.some=function(obj,f,opt_obj){for(var key in obj){if(f.call(opt_obj,obj[key],key,obj)){return!0;}}return!1;};goog.object.every=function(obj,f,opt_obj){for(var key in obj){if(!f.call(opt_obj,obj[key],key,obj)){return!1;}}return!0;};goog.object.getCount=function(obj){var rv=0,key;for(key in obj){rv++;}return rv;};goog.object.getAnyKey=function(obj){for(var key in obj){return key;}};goog.object.getAnyValue=function(obj){for(var key in obj){return obj[key];}};goog.object.contains=function(obj,val){return goog.object.containsValue(obj,val);};goog.object.getValues=function(obj){var res=[],i=0,key;for(key in obj){res[i++]=obj[key];}return res;};goog.object.getKeys=function(obj){var res=[],i=0,key;for(key in obj){res[i++]=key;}return res;};goog.object.getValueByKeys=function(obj,var_args){for(var isArrayLike=goog.isArrayLike(var_args),keys=isArrayLike?var_args:arguments,i=isArrayLike?0:1;i<keys.length&&(obj=obj[keys[i]],goog.isDef(obj));i++){}return obj;};goog.object.containsKey=function(obj,key){return null!==obj&&key in obj;};goog.object.containsValue=function(obj,val){for(var key in obj){if(obj[key]==val){return!0;}}return!1;};goog.object.findKey=function(obj,f,opt_this){for(var key in obj){if(f.call(opt_this,obj[key],key,obj)){return key;}}};goog.object.findValue=function(obj,f,opt_this){var key=goog.object.findKey(obj,f,opt_this);return key&&obj[key];};goog.object.isEmpty=function(obj){for(var key in obj){return!1;}return!0;};goog.object.clear=function(obj){for(var i in obj){delete obj[i];}};goog.object.remove=function(obj,key){var rv;(rv=key in obj)&&delete obj[key];return rv;};goog.object.add=function(obj,key,val){if(null!==obj&&key in obj){throw Error(\'The object already contains the key "\'+key+\'"\');}goog.object.set(obj,key,val);};goog.object.get=function(obj,key,opt_val){return null!==obj&&key in obj?obj[key]:opt_val;};goog.object.set=function(obj,key,value){obj[key]=value;};goog.object.setIfUndefined=function(obj,key,value){return key in obj?obj[key]:obj[key]=value;};goog.object.setWithReturnValueIfNotSet=function(obj,key,f){if(key in obj){return obj[key];}var val=f();return obj[key]=val;};goog.object.equals=function(a,b){for(var k in a){if(!(k in b)||a[k]!==b[k]){return!1;}}for(k in b){if(!(k in a)){return!1;}}return!0;};goog.object.clone=function(obj){var res={},key;for(key in obj){res[key]=obj[key];}return res;};goog.object.unsafeClone=function(obj){var type=goog.typeOf(obj);if("object"==type||"array"==type){if(goog.isFunction(obj.clone)){return obj.clone();}var clone="array"==type?[]:{},key;for(key in obj){clone[key]=goog.object.unsafeClone(obj[key]);}return clone;}return obj;};goog.object.transpose=function(obj){var transposed={},key;for(key in obj){transposed[obj[key]]=key;}return transposed;};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");goog.object.extend=function(target,var_args){for(var key,source,i=1;i<arguments.length;i++){source=arguments[i];for(key in source){target[key]=source[key];}for(var j=0;j<goog.object.PROTOTYPE_FIELDS_.length;j++){key=goog.object.PROTOTYPE_FIELDS_[j],Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}}};goog.object.create=function(var_args){var argLength=arguments.length;if(1==argLength&&goog.isArray(arguments[0])){return goog.object.create.apply(null,arguments[0]);}if(argLength%2){throw Error("Uneven number of arguments");}for(var rv={},i=0;i<argLength;i+=2){rv[arguments[i]]=arguments[i+1];}return rv;};goog.object.createSet=function(var_args){var argLength=arguments.length;if(1==argLength&&goog.isArray(arguments[0])){return goog.object.createSet.apply(null,arguments[0]);}for(var rv={},i=0;i<argLength;i++){rv[arguments[i]]=!0;}return rv;};goog.object.createImmutableView=function(obj){var result=obj;Object.isFrozen&&!Object.isFrozen(obj)&&(result=Object.create(obj),Object.freeze(result));return result;};goog.object.isImmutableView=function(obj){return!!Object.isFrozen&&Object.isFrozen(obj);};goog.object.getAllPropertyNames=function(obj,opt_includeObjectPrototype,opt_includeFunctionPrototype){if(!obj){return[];}if(!Object.getOwnPropertyNames||!Object.getPrototypeOf){return goog.object.getKeys(obj);}for(var visitedSet={},proto=obj;proto&&(proto!==Object.prototype||opt_includeObjectPrototype)&&(proto!==Function.prototype||opt_includeFunctionPrototype);){for(var names=Object.getOwnPropertyNames(proto),i=0;i<names.length;i++){visitedSet[names[i]]=!0;}proto=Object.getPrototypeOf(proto);}return goog.object.getKeys(visitedSet);};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera");};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE");};goog.labs.userAgent.browser.matchEdge_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge");};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox");};goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdge_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"));};goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast");};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit");};goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdge_();};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk());};goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdge_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk");};goog.labs.userAgent.browser.getVersion=function(){function lookUpValueWithKeys(keys){var key=goog.array.find(keys,versionMapHasKey);return versionMap[key]||"";}var userAgentString=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE()){return goog.labs.userAgent.browser.getIEVersion_(userAgentString);}var versionTuples=goog.labs.userAgent.util.extractVersionTuples(userAgentString),versionMap={};goog.array.forEach(versionTuples,function(tuple){versionMap[tuple[0]]=tuple[1];});var versionMapHasKey=goog.partial(goog.object.containsKey,versionMap);if(goog.labs.userAgent.browser.isOpera()){return lookUpValueWithKeys(["Version","Opera"]);}if(goog.labs.userAgent.browser.isEdge()){return lookUpValueWithKeys(["Edge"]);}if(goog.labs.userAgent.browser.isChrome()){return lookUpValueWithKeys(["Chrome","CriOS"]);}var tuple=versionTuples[2];return tuple&&tuple[1]||"";};goog.labs.userAgent.browser.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.browser.getVersion(),version);};goog.labs.userAgent.browser.getIEVersion_=function(userAgent){var rv=/rv: *([\\d\\.]*)/.exec(userAgent);if(rv&&rv[1]){return rv[1];}var version="",msie=/MSIE +([\\d\\.]+)/.exec(userAgent);if(msie&&msie[1]){var tridentVersion=/Trident\\/(\\d.\\d)/.exec(userAgent);if("7.0"==msie[1]){if(tridentVersion&&tridentVersion[1]){switch(tridentVersion[1]){case"4.0":version="8.0";break;case"5.0":version="9.0";break;case"6.0":version="10.0";break;case"7.0":version="11.0";}}else{version="7.0";}}else{version=msie[1];}}return version;};goog.labs.userAgent.engine={};goog.labs.userAgent.engine.isPresto=function(){return goog.labs.userAgent.util.matchUserAgent("Presto");};goog.labs.userAgent.engine.isTrident=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE");};goog.labs.userAgent.engine.isEdge=function(){return goog.labs.userAgent.util.matchUserAgent("Edge");};goog.labs.userAgent.engine.isWebKit=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit")&&!goog.labs.userAgent.engine.isEdge();};goog.labs.userAgent.engine.isGecko=function(){return goog.labs.userAgent.util.matchUserAgent("Gecko")&&!goog.labs.userAgent.engine.isWebKit()&&!goog.labs.userAgent.engine.isTrident()&&!goog.labs.userAgent.engine.isEdge();};goog.labs.userAgent.engine.getVersion=function(){var userAgentString=goog.labs.userAgent.util.getUserAgent();if(userAgentString){var tuples=goog.labs.userAgent.util.extractVersionTuples(userAgentString),engineTuple=goog.labs.userAgent.engine.getEngineTuple_(tuples);if(engineTuple){return"Gecko"==engineTuple[0]?goog.labs.userAgent.engine.getVersionForKey_(tuples,"Firefox"):engineTuple[1];}var browserTuple=tuples[0],info;if(browserTuple&&(info=browserTuple[2])){var match=/Trident\\/([^\\s;]+)/.exec(info);if(match){return match[1];}}}return"";};goog.labs.userAgent.engine.getEngineTuple_=function(tuples){if(!goog.labs.userAgent.engine.isEdge()){return tuples[1];}for(var i=0;i<tuples.length;i++){var tuple=tuples[i];if("Edge"==tuple[0]){return tuple;}}};goog.labs.userAgent.engine.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(),version);};goog.labs.userAgent.engine.getVersionForKey_=function(tuples,key){var pair=goog.array.find(tuples,function(pair){return key==pair[0];});return pair&&pair[1]||"";};goog.labs.userAgent.platform={};goog.labs.userAgent.platform.isAndroid=function(){return goog.labs.userAgent.util.matchUserAgent("Android");};goog.labs.userAgent.platform.isIpod=function(){return goog.labs.userAgent.util.matchUserAgent("iPod");};goog.labs.userAgent.platform.isIphone=function(){return goog.labs.userAgent.util.matchUserAgent("iPhone")&&!goog.labs.userAgent.util.matchUserAgent("iPod")&&!goog.labs.userAgent.util.matchUserAgent("iPad");};goog.labs.userAgent.platform.isIpad=function(){return goog.labs.userAgent.util.matchUserAgent("iPad");};goog.labs.userAgent.platform.isIos=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpad()||goog.labs.userAgent.platform.isIpod();};goog.labs.userAgent.platform.isMacintosh=function(){return goog.labs.userAgent.util.matchUserAgent("Macintosh");};goog.labs.userAgent.platform.isLinux=function(){return goog.labs.userAgent.util.matchUserAgent("Linux");};goog.labs.userAgent.platform.isWindows=function(){return goog.labs.userAgent.util.matchUserAgent("Windows");};goog.labs.userAgent.platform.isChromeOS=function(){return goog.labs.userAgent.util.matchUserAgent("CrOS");};goog.labs.userAgent.platform.getVersion=function(){var match,userAgentString=goog.labs.userAgent.util.getUserAgent(),version="";if(goog.labs.userAgent.platform.isWindows()){var re=/Windows (?:NT|Phone) ([0-9.]+)/;version=(match=re.exec(userAgentString))?match[1]:"0.0";}else{goog.labs.userAgent.platform.isIos()?(re=/(?:iPhone|iPod|iPad|CPU)\\s+OS\\s+(\\S+)/,version=(match=re.exec(userAgentString))&&match[1].replace(/_/g,".")):goog.labs.userAgent.platform.isMacintosh()?(re=/Mac OS X ([0-9_.]+)/,version=(match=re.exec(userAgentString))?match[1].replace(/_/g,"."):"10"):goog.labs.userAgent.platform.isAndroid()?(re=/Android\\s+([^\\);]+)(\\)|;)/,version=(match=re.exec(userAgentString))&&match[1]):goog.labs.userAgent.platform.isChromeOS()&&(re=/(?:CrOS\\s+(?:i686|x86_64)\\s+([0-9.]+))/,version=(match=re.exec(userAgentString))&&match[1]);}return version||"";};goog.labs.userAgent.platform.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(),version);};goog.reflect={};goog.reflect.object=function(type,object){return object;};goog.reflect.objectProperty=function(prop,object){return prop;};goog.reflect.sinkValue=function(x){goog.reflect.sinkValue[" "](x);return x;};goog.reflect.sinkValue[" "]=goog.nullFunction;goog.reflect.canAccessProperty=function(obj,prop){try{return goog.reflect.sinkValue(obj[prop]),!0;}catch(e){}return!1;};goog.reflect.cache=function(cacheObj,key,valueFn,opt_keyFn){var storedKey=opt_keyFn?opt_keyFn(key):key;return Object.prototype.hasOwnProperty.call(cacheObj,storedKey)?cacheObj[storedKey]:cacheObj[storedKey]=valueFn(key);};goog.reflect={};goog.reflect.object=function(type,object){return object;};goog.reflect.objectProperty=function(prop,object){return prop;};goog.reflect.sinkValue=function(x){goog.reflect.sinkValue[" "](x);return x;};goog.reflect.sinkValue[" "]=goog.nullFunction;goog.reflect.canAccessProperty=function(obj,prop){try{return goog.reflect.sinkValue(obj[prop]),!0;}catch(e){}return!1;};goog.reflect.cache=function(cacheObj,key,valueFn,opt_keyFn){var storedKey=opt_keyFn?opt_keyFn(key):key;return Object.prototype.hasOwnProperty.call(cacheObj,storedKey)?cacheObj[storedKey]:cacheObj[storedKey]=valueFn(key);};goog.userAgent={};goog.userAgent.ASSUME_IE=!1;goog.userAgent.ASSUME_EDGE=!1;goog.userAgent.ASSUME_GECKO=!1;goog.userAgent.ASSUME_WEBKIT=!1;goog.userAgent.ASSUME_MOBILE_WEBKIT=!1;goog.userAgent.ASSUME_OPERA=!1;goog.userAgent.ASSUME_ANY_VERSION=!1;goog.userAgent.BROWSER_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_GECKO||goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_OPERA;goog.userAgent.getUserAgentString=function(){return goog.labs.userAgent.util.getUserAgent();};goog.userAgent.getNavigator=function(){return goog.global.navigator||null;};goog.userAgent.OPERA=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_OPERA:goog.labs.userAgent.browser.isOpera();goog.userAgent.IE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_IE:goog.labs.userAgent.browser.isIE();goog.userAgent.EDGE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_EDGE:goog.labs.userAgent.engine.isEdge();goog.userAgent.EDGE_OR_IE=goog.userAgent.EDGE||goog.userAgent.IE;goog.userAgent.GECKO=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_GECKO:goog.labs.userAgent.engine.isGecko();goog.userAgent.WEBKIT=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_MOBILE_WEBKIT:goog.labs.userAgent.engine.isWebKit();goog.userAgent.isMobile_=function(){return goog.userAgent.WEBKIT&&goog.labs.userAgent.util.matchUserAgent("Mobile");};goog.userAgent.MOBILE=goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.isMobile_();goog.userAgent.SAFARI=goog.userAgent.WEBKIT;goog.userAgent.determinePlatform_=function(){var navigator=goog.userAgent.getNavigator();return navigator&&navigator.platform||"";};goog.userAgent.PLATFORM=goog.userAgent.determinePlatform_();goog.userAgent.ASSUME_MAC=!1;goog.userAgent.ASSUME_WINDOWS=!1;goog.userAgent.ASSUME_LINUX=!1;goog.userAgent.ASSUME_X11=!1;goog.userAgent.ASSUME_ANDROID=!1;goog.userAgent.ASSUME_IPHONE=!1;goog.userAgent.ASSUME_IPAD=!1;goog.userAgent.ASSUME_IPOD=!1;goog.userAgent.PLATFORM_KNOWN_=goog.userAgent.ASSUME_MAC||goog.userAgent.ASSUME_WINDOWS||goog.userAgent.ASSUME_LINUX||goog.userAgent.ASSUME_X11||goog.userAgent.ASSUME_ANDROID||goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD;goog.userAgent.MAC=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_MAC:goog.labs.userAgent.platform.isMacintosh();goog.userAgent.WINDOWS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_WINDOWS:goog.labs.userAgent.platform.isWindows();goog.userAgent.isLegacyLinux_=function(){return goog.labs.userAgent.platform.isLinux()||goog.labs.userAgent.platform.isChromeOS();};goog.userAgent.LINUX=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_LINUX:goog.userAgent.isLegacyLinux_();goog.userAgent.isX11_=function(){var navigator=goog.userAgent.getNavigator();return!!navigator&&goog.string.contains(navigator.appVersion||"","X11");};goog.userAgent.X11=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_X11:goog.userAgent.isX11_();goog.userAgent.ANDROID=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_ANDROID:goog.labs.userAgent.platform.isAndroid();goog.userAgent.IPHONE=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE:goog.labs.userAgent.platform.isIphone();goog.userAgent.IPAD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();goog.userAgent.IPOD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIpod();goog.userAgent.IOS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIos();goog.userAgent.determineVersion_=function(){var version="",arr=goog.userAgent.getVersionRegexResult_();arr&&(version=arr?arr[1]:"");if(goog.userAgent.IE){var docMode=goog.userAgent.getDocumentMode_();if(null!=docMode&&docMode>parseFloat(version)){return String(docMode);}}return version;};goog.userAgent.getVersionRegexResult_=function(){var userAgent=goog.userAgent.getUserAgentString();if(goog.userAgent.GECKO){return /rv\\:([^\\);]+)(\\)|;)/.exec(userAgent);}if(goog.userAgent.EDGE){return /Edge\\/([\\d\\.]+)/.exec(userAgent);}if(goog.userAgent.IE){return /\\b(?:MSIE|rv)[: ]([^\\);]+)(\\)|;)/.exec(userAgent);}if(goog.userAgent.WEBKIT){return /WebKit\\/(\\S+)/.exec(userAgent);}if(goog.userAgent.OPERA){return /(?:Version)[ \\/]?(\\S+)/.exec(userAgent);}};goog.userAgent.getDocumentMode_=function(){var doc=goog.global.document;return doc?doc.documentMode:void 0;};goog.userAgent.VERSION=goog.userAgent.determineVersion_();goog.userAgent.compare=function(v1,v2){return goog.string.compareVersions(v1,v2);};goog.userAgent.isVersionOrHigherCache_={};goog.userAgent.isVersionOrHigher=function(version){return goog.userAgent.ASSUME_ANY_VERSION||goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_,version,function(){return 0<=goog.string.compareVersions(goog.userAgent.VERSION,version);});};goog.userAgent.isVersion=goog.userAgent.isVersionOrHigher;goog.userAgent.isDocumentModeOrHigher=function(documentMode){return Number(goog.userAgent.DOCUMENT_MODE)>=documentMode;};goog.userAgent.isDocumentMode=goog.userAgent.isDocumentModeOrHigher;goog.userAgent.DOCUMENT_MODE=function(){var doc=goog.global.document;if(doc&&goog.userAgent.IE){return goog.userAgent.getDocumentMode_()||("CSS1Compat"==doc.compatMode?parseInt(goog.userAgent.VERSION,10):5);}}();goog.events.BrowserFeature={HAS_W3C_BUTTON:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),HAS_W3C_EVENT_SUPPORT:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),SET_KEY_CODE_TO_PREVENT_DEFAULT:goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),HAS_NAVIGATOR_ONLINE_PROPERTY:!goog.userAgent.WEBKIT||goog.userAgent.isVersionOrHigher("528"),HAS_HTML5_NETWORK_EVENT_SUPPORT:goog.userAgent.GECKO&&goog.userAgent.isVersionOrHigher("1.9b")||goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("8")||goog.userAgent.OPERA&&goog.userAgent.isVersionOrHigher("9.5")||goog.userAgent.WEBKIT&&goog.userAgent.isVersionOrHigher("528"),HTML5_NETWORK_EVENTS_FIRE_ON_BODY:goog.userAgent.GECKO&&!goog.userAgent.isVersionOrHigher("8")||goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),TOUCH_ENABLED:"ontouchstart"in goog.global||!!(goog.global.document&&document.documentElement&&"ontouchstart"in document.documentElement)||!(!goog.global.navigator||!goog.global.navigator.msMaxTouchPoints)};goog.events.getVendorPrefixedName_=function(eventName){return goog.userAgent.WEBKIT?"webkit"+eventName:goog.userAgent.OPERA?"o"+eventName.toLowerCase():eventName.toLowerCase();};goog.events.EventType={CLICK:"click",RIGHTCLICK:"rightclick",DBLCLICK:"dblclick",MOUSEDOWN:"mousedown",MOUSEUP:"mouseup",MOUSEOVER:"mouseover",MOUSEOUT:"mouseout",MOUSEMOVE:"mousemove",MOUSEENTER:"mouseenter",MOUSELEAVE:"mouseleave",SELECTIONCHANGE:"selectionchange",SELECTSTART:"selectstart",WHEEL:"wheel",KEYPRESS:"keypress",KEYDOWN:"keydown",KEYUP:"keyup",BLUR:"blur",FOCUS:"focus",DEACTIVATE:"deactivate",FOCUSIN:goog.userAgent.IE?"focusin":"DOMFocusIn",FOCUSOUT:goog.userAgent.IE?"focusout":"DOMFocusOut",CHANGE:"change",RESET:"reset",SELECT:"select",SUBMIT:"submit",INPUT:"input",PROPERTYCHANGE:"propertychange",DRAGSTART:"dragstart",DRAG:"drag",DRAGENTER:"dragenter",DRAGOVER:"dragover",DRAGLEAVE:"dragleave",DROP:"drop",DRAGEND:"dragend",TOUCHSTART:"touchstart",TOUCHMOVE:"touchmove",TOUCHEND:"touchend",TOUCHCANCEL:"touchcancel",BEFOREUNLOAD:"beforeunload",CONSOLEMESSAGE:"consolemessage",CONTEXTMENU:"contextmenu",DEVICEMOTION:"devicemotion",DEVICEORIENTATION:"deviceorientation",DOMCONTENTLOADED:"DOMContentLoaded",ERROR:"error",HELP:"help",LOAD:"load",LOSECAPTURE:"losecapture",ORIENTATIONCHANGE:"orientationchange",READYSTATECHANGE:"readystatechange",RESIZE:"resize",SCROLL:"scroll",UNLOAD:"unload",CANPLAY:"canplay",CANPLAYTHROUGH:"canplaythrough",DURATIONCHANGE:"durationchange",EMPTIED:"emptied",ENDED:"ended",LOADEDDATA:"loadeddata",LOADEDMETADATA:"loadedmetadata",PAUSE:"pause",PLAY:"play",PLAYING:"playing",RATECHANGE:"ratechange",SEEKED:"seeked",SEEKING:"seeking",STALLED:"stalled",SUSPEND:"suspend",TIMEUPDATE:"timeupdate",VOLUMECHANGE:"volumechange",WAITING:"waiting",SOURCEOPEN:"sourceopen",SOURCEENDED:"sourceended",SOURCECLOSED:"sourceclosed",ABORT:"abort",UPDATE:"update",UPDATESTART:"updatestart",UPDATEEND:"updateend",HASHCHANGE:"hashchange",PAGEHIDE:"pagehide",PAGESHOW:"pageshow",POPSTATE:"popstate",COPY:"copy",PASTE:"paste",CUT:"cut",BEFORECOPY:"beforecopy",BEFORECUT:"beforecut",BEFOREPASTE:"beforepaste",ONLINE:"online",OFFLINE:"offline",MESSAGE:"message",CONNECT:"connect",INSTALL:"install",ACTIVATE:"activate",FETCH:"fetch",FOREIGNFETCH:"foreignfetch",MESSAGEERROR:"messageerror",STATECHANGE:"statechange",UPDATEFOUND:"updatefound",CONTROLLERCHANGE:"controllerchange",ANIMATIONSTART:goog.events.getVendorPrefixedName_("AnimationStart"),ANIMATIONEND:goog.events.getVendorPrefixedName_("AnimationEnd"),ANIMATIONITERATION:goog.events.getVendorPrefixedName_("AnimationIteration"),TRANSITIONEND:goog.events.getVendorPrefixedName_("TransitionEnd"),POINTERDOWN:"pointerdown",POINTERUP:"pointerup",POINTERCANCEL:"pointercancel",POINTERMOVE:"pointermove",POINTEROVER:"pointerover",POINTEROUT:"pointerout",POINTERENTER:"pointerenter",POINTERLEAVE:"pointerleave",GOTPOINTERCAPTURE:"gotpointercapture",LOSTPOINTERCAPTURE:"lostpointercapture",MSGESTURECHANGE:"MSGestureChange",MSGESTUREEND:"MSGestureEnd",MSGESTUREHOLD:"MSGestureHold",MSGESTURESTART:"MSGestureStart",MSGESTURETAP:"MSGestureTap",MSGOTPOINTERCAPTURE:"MSGotPointerCapture",MSINERTIASTART:"MSInertiaStart",MSLOSTPOINTERCAPTURE:"MSLostPointerCapture",MSPOINTERCANCEL:"MSPointerCancel",MSPOINTERDOWN:"MSPointerDown",MSPOINTERENTER:"MSPointerEnter",MSPOINTERHOVER:"MSPointerHover",MSPOINTERLEAVE:"MSPointerLeave",MSPOINTERMOVE:"MSPointerMove",MSPOINTEROUT:"MSPointerOut",MSPOINTEROVER:"MSPointerOver",MSPOINTERUP:"MSPointerUp",TEXT:"text",TEXTINPUT:goog.userAgent.IE?"textinput":"textInput",COMPOSITIONSTART:"compositionstart",COMPOSITIONUPDATE:"compositionupdate",COMPOSITIONEND:"compositionend",BEFOREINPUT:"beforeinput",EXIT:"exit",LOADABORT:"loadabort",LOADCOMMIT:"loadcommit",LOADREDIRECT:"loadredirect",LOADSTART:"loadstart",LOADSTOP:"loadstop",RESPONSIVE:"responsive",SIZECHANGED:"sizechanged",UNRESPONSIVE:"unresponsive",VISIBILITYCHANGE:"visibilitychange",STORAGE:"storage",DOMSUBTREEMODIFIED:"DOMSubtreeModified",DOMNODEINSERTED:"DOMNodeInserted",DOMNODEREMOVED:"DOMNodeRemoved",DOMNODEREMOVEDFROMDOCUMENT:"DOMNodeRemovedFromDocument",DOMNODEINSERTEDINTODOCUMENT:"DOMNodeInsertedIntoDocument",DOMATTRMODIFIED:"DOMAttrModified",DOMCHARACTERDATAMODIFIED:"DOMCharacterDataModified",BEFOREPRINT:"beforeprint",AFTERPRINT:"afterprint"};goog.events.BrowserEvent=function(opt_e,opt_currentTarget){goog.events.Event.call(this,opt_e?opt_e.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.platformModifierKey=!1;this.event_=null;opt_e&&this.init(opt_e,opt_currentTarget);};goog.inherits(goog.events.BrowserEvent,goog.events.Event);goog.events.BrowserEvent.MouseButton={LEFT:0,MIDDLE:1,RIGHT:2};goog.events.BrowserEvent.IEButtonMap=[1,4,2];goog.events.BrowserEvent.prototype.init=function(e,opt_currentTarget){var type=this.type=e.type,relevantTouch=e.changedTouches?e.changedTouches[0]:null;this.target=e.target||e.srcElement;this.currentTarget=opt_currentTarget;var relatedTarget=e.relatedTarget;relatedTarget?goog.userAgent.GECKO&&(goog.reflect.canAccessProperty(relatedTarget,"nodeName")||(relatedTarget=null)):type==goog.events.EventType.MOUSEOVER?relatedTarget=e.fromElement:type==goog.events.EventType.MOUSEOUT&&(relatedTarget=e.toElement);this.relatedTarget=relatedTarget;goog.isNull(relevantTouch)?(this.offsetX=goog.userAgent.WEBKIT||void 0!==e.offsetX?e.offsetX:e.layerX,this.offsetY=goog.userAgent.WEBKIT||void 0!==e.offsetY?e.offsetY:e.layerY,this.clientX=void 0!==e.clientX?e.clientX:e.pageX,this.clientY=void 0!==e.clientY?e.clientY:e.pageY,this.screenX=e.screenX||0,this.screenY=e.screenY||0):(this.clientX=void 0!==relevantTouch.clientX?relevantTouch.clientX:relevantTouch.pageX,this.clientY=void 0!==relevantTouch.clientY?relevantTouch.clientY:relevantTouch.pageY,this.screenX=relevantTouch.screenX||0,this.screenY=relevantTouch.screenY||0);this.button=e.button;this.keyCode=e.keyCode||0;this.key=e.key||"";this.charCode=e.charCode||("keypress"==type?e.keyCode:0);this.ctrlKey=e.ctrlKey;this.altKey=e.altKey;this.shiftKey=e.shiftKey;this.metaKey=e.metaKey;this.platformModifierKey=goog.userAgent.MAC?e.metaKey:e.ctrlKey;this.state=e.state;this.event_=e;e.defaultPrevented&&this.preventDefault();};goog.events.BrowserEvent.prototype.isButton=function(button){return goog.events.BrowserFeature.HAS_W3C_BUTTON?this.event_.button==button:"click"==this.type?button==goog.events.BrowserEvent.MouseButton.LEFT:!!(this.event_.button&goog.events.BrowserEvent.IEButtonMap[button]);};goog.events.BrowserEvent.prototype.isMouseActionButton=function(){return this.isButton(goog.events.BrowserEvent.MouseButton.LEFT)&&!(goog.userAgent.WEBKIT&&goog.userAgent.MAC&&this.ctrlKey);};goog.events.BrowserEvent.prototype.stopPropagation=function(){goog.events.BrowserEvent.superClass_.stopPropagation.call(this);this.event_.stopPropagation?this.event_.stopPropagation():this.event_.cancelBubble=!0;};goog.events.BrowserEvent.prototype.preventDefault=function(){goog.events.BrowserEvent.superClass_.preventDefault.call(this);var be=this.event_;if(be.preventDefault){be.preventDefault();}else{if(be.returnValue=!1,goog.events.BrowserFeature.SET_KEY_CODE_TO_PREVENT_DEFAULT){try{if(be.ctrlKey||112<=be.keyCode&&123>=be.keyCode){be.keyCode=-1;}}catch(ex){}}}};goog.events.BrowserEvent.prototype.getBrowserEvent=function(){return this.event_;};goog.events.Listenable=function(){};goog.events.Listenable.IMPLEMENTED_BY_PROP="closure_listenable_"+(1e6*Math.random()|0);goog.events.Listenable.addImplementation=function(cls){cls.prototype[goog.events.Listenable.IMPLEMENTED_BY_PROP]=!0;};goog.events.Listenable.isImplementedBy=function(obj){return!(!obj||!obj[goog.events.Listenable.IMPLEMENTED_BY_PROP]);};goog.events.ListenableKey=function(){};goog.events.ListenableKey.counter_=0;goog.events.ListenableKey.reserveKey=function(){return++goog.events.ListenableKey.counter_;};goog.events.Listener=function(listener,proxy,src,type,capture,opt_handler){goog.events.Listener.ENABLE_MONITORING&&(this.creationStack=Error().stack);this.listener=listener;this.proxy=proxy;this.src=src;this.type=type;this.capture=!!capture;this.handler=opt_handler;this.key=goog.events.ListenableKey.reserveKey();this.removed=this.callOnce=!1;};goog.events.Listener.ENABLE_MONITORING=!1;goog.events.Listener.prototype.markAsRemoved=function(){this.removed=!0;this.handler=this.src=this.proxy=this.listener=null;};goog.events.ListenerMap=function(src){this.src=src;this.listeners={};this.typeCount_=0;};goog.events.ListenerMap.prototype.getTypeCount=function(){return this.typeCount_;};goog.events.ListenerMap.prototype.getListenerCount=function(){var count=0,type;for(type in this.listeners){count+=this.listeners[type].length;}return count;};goog.events.ListenerMap.prototype.add=function(type,listener,callOnce,opt_useCapture,opt_listenerScope){var typeStr=type.toString(),listenerArray=this.listeners[typeStr];listenerArray||(listenerArray=this.listeners[typeStr]=[],this.typeCount_++);var index=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,opt_useCapture,opt_listenerScope);if(-1<index){var listenerObj=listenerArray[index];callOnce||(listenerObj.callOnce=!1);}else{listenerObj=new goog.events.Listener(listener,null,this.src,typeStr,!!opt_useCapture,opt_listenerScope),listenerObj.callOnce=callOnce,listenerArray.push(listenerObj);}return listenerObj;};goog.events.ListenerMap.prototype.remove=function(type,listener,opt_useCapture,opt_listenerScope){var typeStr=type.toString();if(!(typeStr in this.listeners)){return!1;}var listenerArray=this.listeners[typeStr],index=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,opt_useCapture,opt_listenerScope);return-1<index?(listenerArray[index].markAsRemoved(),goog.array.removeAt(listenerArray,index),0==listenerArray.length&&(delete this.listeners[typeStr],this.typeCount_--),!0):!1;};goog.events.ListenerMap.prototype.removeByKey=function(listener){var type=listener.type;if(!(type in this.listeners)){return!1;}var removed=goog.array.remove(this.listeners[type],listener);removed&&(listener.markAsRemoved(),0==this.listeners[type].length&&(delete this.listeners[type],this.typeCount_--));return removed;};goog.events.ListenerMap.prototype.removeAll=function(opt_type){var typeStr=opt_type&&opt_type.toString(),count=0,type;for(type in this.listeners){if(!typeStr||type==typeStr){for(var listenerArray=this.listeners[type],i=0;i<listenerArray.length;i++){++count,listenerArray[i].markAsRemoved();}delete this.listeners[type];this.typeCount_--;}}return count;};goog.events.ListenerMap.prototype.getListeners=function(type,capture){var listenerArray=this.listeners[type.toString()],rv=[];if(listenerArray){for(var i=0;i<listenerArray.length;++i){var listenerObj=listenerArray[i];listenerObj.capture==capture&&rv.push(listenerObj);}}return rv;};goog.events.ListenerMap.prototype.getListener=function(type,listener,capture,opt_listenerScope){var listenerArray=this.listeners[type.toString()],i=-1;listenerArray&&(i=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,capture,opt_listenerScope));return-1<i?listenerArray[i]:null;};goog.events.ListenerMap.prototype.hasListener=function(opt_type,opt_capture){var hasType=goog.isDef(opt_type),typeStr=hasType?opt_type.toString():"",hasCapture=goog.isDef(opt_capture);return goog.object.some(this.listeners,function(listenerArray,type){for(var i=0;i<listenerArray.length;++i){if(!(hasType&&listenerArray[i].type!=typeStr||hasCapture&&listenerArray[i].capture!=opt_capture)){return!0;}}return!1;});};goog.events.ListenerMap.findListenerIndex_=function(listenerArray,listener,opt_useCapture,opt_listenerScope){for(var i=0;i<listenerArray.length;++i){var listenerObj=listenerArray[i];if(!listenerObj.removed&&listenerObj.listener==listener&&listenerObj.capture==!!opt_useCapture&&listenerObj.handler==opt_listenerScope){return i;}}return-1;};goog.events.LISTENER_MAP_PROP_="closure_lm_"+(1e6*Math.random()|0);goog.events.onString_="on";goog.events.onStringMap_={};goog.events.CaptureSimulationMode={OFF_AND_FAIL:0,OFF_AND_SILENT:1,ON:2};goog.events.CAPTURE_SIMULATION_MODE=2;goog.events.listenerCountEstimate_=0;goog.events.listen=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.listen(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);return goog.events.Listenable.isImplementedBy(src)?src.listen(type,listener,opt_capt,opt_handler):goog.events.listen_(src,type,listener,!1,opt_capt,opt_handler);};goog.events.listen_=function(src,type,listener,callOnce,opt_capt,opt_handler){if(!type){throw Error("Invalid event type");}var capture=!!opt_capt;if(capture&&!goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT){if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.OFF_AND_FAIL){return goog.asserts.fail("Can not register capture listener in IE8-."),null;}if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.OFF_AND_SILENT){return null;}}var listenerMap=goog.events.getListenerMap_(src);listenerMap||(src[goog.events.LISTENER_MAP_PROP_]=listenerMap=new goog.events.ListenerMap(src));var listenerObj=listenerMap.add(type,listener,callOnce,opt_capt,opt_handler);if(listenerObj.proxy){return listenerObj;}var proxy=goog.events.getProxy();listenerObj.proxy=proxy;proxy.src=src;proxy.listener=listenerObj;if(src.addEventListener){src.addEventListener(type.toString(),proxy,capture);}else{if(src.attachEvent){src.attachEvent(goog.events.getOnString_(type.toString()),proxy);}else{throw Error("addEventListener and attachEvent are unavailable.");}}goog.events.listenerCountEstimate_++;return listenerObj;};goog.events.getProxy=function(){var proxyCallbackFunction=goog.events.handleBrowserEvent_,f=goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT?function(eventObject){return proxyCallbackFunction.call(f.src,f.listener,eventObject);}:function(eventObject){var v=proxyCallbackFunction.call(f.src,f.listener,eventObject);if(!v){return v;}};return f;};goog.events.listenOnce=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.listenOnce(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);return goog.events.Listenable.isImplementedBy(src)?src.listenOnce(type,listener,opt_capt,opt_handler):goog.events.listen_(src,type,listener,!0,opt_capt,opt_handler);};goog.events.listenWithWrapper=function(src,wrapper,listener,opt_capt,opt_handler){wrapper.listen(src,listener,opt_capt,opt_handler);};goog.events.unlisten=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.unlisten(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);if(goog.events.Listenable.isImplementedBy(src)){return src.unlisten(type,listener,opt_capt,opt_handler);}if(!src){return!1;}var capture,listenerMap=goog.events.getListenerMap_(src);if(listenerMap){var listenerObj=listenerMap.getListener(type,listener,!!opt_capt,opt_handler);if(listenerObj){return goog.events.unlistenByKey(listenerObj);}}return!1;};goog.events.unlistenByKey=function(key){if(goog.isNumber(key)||!key||key.removed){return!1;}var src=key.src;if(goog.events.Listenable.isImplementedBy(src)){return src.unlistenByKey(key);}var type=key.type,proxy=key.proxy;src.removeEventListener?src.removeEventListener(type,proxy,key.capture):src.detachEvent&&src.detachEvent(goog.events.getOnString_(type),proxy);goog.events.listenerCountEstimate_--;var listenerMap=goog.events.getListenerMap_(src);listenerMap?(listenerMap.removeByKey(key),0==listenerMap.getTypeCount()&&(listenerMap.src=null,src[goog.events.LISTENER_MAP_PROP_]=null)):key.markAsRemoved();return!0;};goog.events.unlistenWithWrapper=function(src,wrapper,listener,opt_capt,opt_handler){wrapper.unlisten(src,listener,opt_capt,opt_handler);};goog.events.removeAll=function(obj,opt_type){if(!obj){return 0;}if(goog.events.Listenable.isImplementedBy(obj)){return obj.removeAllListeners(opt_type);}var listenerMap=goog.events.getListenerMap_(obj);if(!listenerMap){return 0;}var count=0,typeStr=opt_type&&opt_type.toString(),type;for(type in listenerMap.listeners){if(!typeStr||type==typeStr){for(var listeners=listenerMap.listeners[type].concat(),i=0;i<listeners.length;++i){goog.events.unlistenByKey(listeners[i])&&++count;}}}return count;};goog.events.getListeners=function(obj,type,capture){if(goog.events.Listenable.isImplementedBy(obj)){return obj.getListeners(type,capture);}if(!obj){return[];}var listenerMap=goog.events.getListenerMap_(obj);return listenerMap?listenerMap.getListeners(type,capture):[];};goog.events.getListener=function(src,type,listener,opt_capt,opt_handler){listener=goog.events.wrapListener(listener);var capture=!!opt_capt;if(goog.events.Listenable.isImplementedBy(src)){return src.getListener(type,listener,capture,opt_handler);}if(!src){return null;}var listenerMap=goog.events.getListenerMap_(src);return listenerMap?listenerMap.getListener(type,listener,capture,opt_handler):null;};goog.events.hasListener=function(obj,opt_type,opt_capture){if(goog.events.Listenable.isImplementedBy(obj)){return obj.hasListener(opt_type,opt_capture);}var listenerMap=goog.events.getListenerMap_(obj);return!!listenerMap&&listenerMap.hasListener(opt_type,opt_capture);};goog.events.expose=function(e){var str=[],key;for(key in e){e[key]&&e[key].id?str.push(key+" = "+e[key]+" ("+e[key].id+")"):str.push(key+" = "+e[key]);}return str.join("\\n");};goog.events.getOnString_=function(type){return type in goog.events.onStringMap_?goog.events.onStringMap_[type]:goog.events.onStringMap_[type]=goog.events.onString_+type;};goog.events.fireListeners=function(obj,type,capture,eventObject){return goog.events.Listenable.isImplementedBy(obj)?obj.fireListeners(type,capture,eventObject):goog.events.fireListeners_(obj,type,capture,eventObject);};goog.events.fireListeners_=function(obj,type,capture,eventObject){var retval=!0,listenerMap=goog.events.getListenerMap_(obj);if(listenerMap){var listenerArray=listenerMap.listeners[type.toString()];if(listenerArray){for(var listenerArray=listenerArray.concat(),i=0;i<listenerArray.length;i++){var listener=listenerArray[i];if(listener&&listener.capture==capture&&!listener.removed){var result=goog.events.fireListener(listener,eventObject),retval=retval&&!1!==result;}}}}return retval;};goog.events.fireListener=function(listener,eventObject){var listenerFn=listener.listener,listenerHandler=listener.handler||listener.src;listener.callOnce&&goog.events.unlistenByKey(listener);return listenerFn.call(listenerHandler,eventObject);};goog.events.getTotalListenerCount=function(){return goog.events.listenerCountEstimate_;};goog.events.dispatchEvent=function(src,e){goog.asserts.assert(goog.events.Listenable.isImplementedBy(src),"Can not use goog.events.dispatchEvent with non-goog.events.Listenable instance.");return src.dispatchEvent(e);};goog.events.protectBrowserEventEntryPoint=function(errorHandler){goog.events.handleBrowserEvent_=errorHandler.protectEntryPoint(goog.events.handleBrowserEvent_);};goog.events.handleBrowserEvent_=function(listener,opt_evt){if(listener.removed){return!0;}if(!goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT){var ieEvent=opt_evt||goog.getObjectByName("window.event");var evt=new goog.events.BrowserEvent(ieEvent,this);var retval=!0;if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.ON){if(!goog.events.isMarkedIeEvent_(ieEvent)){goog.events.markIeEvent_(ieEvent);var ancestors=[];for(var parent=evt.currentTarget;parent;parent=parent.parentNode){ancestors.push(parent);}var type=listener.type;for(var i=ancestors.length-1;!evt.propagationStopped_&&0<=i;i--){evt.currentTarget=ancestors[i];var result=goog.events.fireListeners_(ancestors[i],type,!0,evt);retval=retval&&result;}for(i=0;!evt.propagationStopped_&&i<ancestors.length;i++){evt.currentTarget=ancestors[i],result=goog.events.fireListeners_(ancestors[i],type,!1,evt),retval=retval&&result;}}}else{retval=goog.events.fireListener(listener,evt);}return retval;}return goog.events.fireListener(listener,new goog.events.BrowserEvent(opt_evt,this));};goog.events.markIeEvent_=function(e){var useReturnValue=!1;if(0==e.keyCode){try{e.keyCode=-1;return;}catch(ex){useReturnValue=!0;}}if(useReturnValue||void 0==e.returnValue){e.returnValue=!0;}};goog.events.isMarkedIeEvent_=function(e){return 0>e.keyCode||void 0!=e.returnValue;};goog.events.uniqueIdCounter_=0;goog.events.getUniqueId=function(identifier){return identifier+"_"+goog.events.uniqueIdCounter_++;};goog.events.getListenerMap_=function(src){var listenerMap=src[goog.events.LISTENER_MAP_PROP_];return listenerMap instanceof goog.events.ListenerMap?listenerMap:null;};goog.events.LISTENER_WRAPPER_PROP_="__closure_events_fn_"+(1e9*Math.random()>>>0);goog.events.wrapListener=function(listener){goog.asserts.assert(listener,"Listener can not be null.");if(goog.isFunction(listener)){return listener;}goog.asserts.assert(listener.handleEvent,"An object listener must have handleEvent method.");listener[goog.events.LISTENER_WRAPPER_PROP_]||(listener[goog.events.LISTENER_WRAPPER_PROP_]=function(e){return listener.handleEvent(e);});return listener[goog.events.LISTENER_WRAPPER_PROP_];};goog.debug.entryPointRegistry.register(function(transformer){goog.events.handleBrowserEvent_=transformer(goog.events.handleBrowserEvent_);});goog.events.EventHandler=function(opt_scope){goog.Disposable.call(this);this.handler_=opt_scope;this.keys_={};};goog.inherits(goog.events.EventHandler,goog.Disposable);goog.events.EventHandler.typeArray_=[];goog.events.EventHandler.prototype.listen=function(src,type,opt_fn,opt_capture){return this.listen_(src,type,opt_fn,opt_capture);};goog.events.EventHandler.prototype.listenWithScope=function(src,type,fn,capture,scope){return this.listen_(src,type,fn,capture,scope);};goog.events.EventHandler.prototype.listen_=function(src,type,opt_fn,opt_capture,opt_scope){goog.isArray(type)||(type&&(goog.events.EventHandler.typeArray_[0]=type.toString()),type=goog.events.EventHandler.typeArray_);for(var i=0;i<type.length;i++){var listenerObj=goog.events.listen(src,type[i],opt_fn||this.handleEvent,opt_capture||!1,opt_scope||this.handler_||this);if(!listenerObj){break;}this.keys_[listenerObj.key]=listenerObj;}return this;};goog.events.EventHandler.prototype.listenOnce=function(src,type,opt_fn,opt_capture){return this.listenOnce_(src,type,opt_fn,opt_capture);};goog.events.EventHandler.prototype.listenOnceWithScope=function(src,type,fn,capture,scope){return this.listenOnce_(src,type,fn,capture,scope);};goog.events.EventHandler.prototype.listenOnce_=function(src,type,opt_fn,opt_capture,opt_scope){if(goog.isArray(type)){for(var i=0;i<type.length;i++){this.listenOnce_(src,type[i],opt_fn,opt_capture,opt_scope);}}else{var listenerObj=goog.events.listenOnce(src,type,opt_fn||this.handleEvent,opt_capture,opt_scope||this.handler_||this);if(!listenerObj){return this;}this.keys_[listenerObj.key]=listenerObj;}return this;};goog.events.EventHandler.prototype.listenWithWrapper=function(src,wrapper,listener,opt_capt){return this.listenWithWrapper_(src,wrapper,listener,opt_capt);};goog.events.EventHandler.prototype.listenWithWrapperAndScope=function(src,wrapper,listener,capture,scope){return this.listenWithWrapper_(src,wrapper,listener,capture,scope);};goog.events.EventHandler.prototype.listenWithWrapper_=function(src,wrapper,listener,opt_capt,opt_scope){wrapper.listen(src,listener,opt_capt,opt_scope||this.handler_||this,this);return this;};goog.events.EventHandler.prototype.getListenerCount=function(){var count=0,key;for(key in this.keys_){Object.prototype.hasOwnProperty.call(this.keys_,key)&&count++;}return count;};goog.events.EventHandler.prototype.unlisten=function(src,type,opt_fn,opt_capture,opt_scope){if(goog.isArray(type)){for(var i=0;i<type.length;i++){this.unlisten(src,type[i],opt_fn,opt_capture,opt_scope);}}else{var listener=goog.events.getListener(src,type,opt_fn||this.handleEvent,opt_capture,opt_scope||this.handler_||this);listener&&(goog.events.unlistenByKey(listener),delete this.keys_[listener.key]);}return this;};goog.events.EventHandler.prototype.unlistenWithWrapper=function(src,wrapper,listener,opt_capt,opt_scope){wrapper.unlisten(src,listener,opt_capt,opt_scope||this.handler_||this,this);return this;};goog.events.EventHandler.prototype.removeAll=function(){goog.object.forEach(this.keys_,function(listenerObj,key){this.keys_.hasOwnProperty(key)&&goog.events.unlistenByKey(listenerObj);},this);this.keys_={};};goog.events.EventHandler.prototype.disposeInternal=function(){goog.events.EventHandler.superClass_.disposeInternal.call(this);this.removeAll();};goog.events.EventHandler.prototype.handleEvent=function(e){throw Error("EventHandler.handleEvent not implemented");};goog.events.EventTarget=function(){goog.Disposable.call(this);this.eventTargetListeners_=new goog.events.ListenerMap(this);this.actualEventTarget_=this;this.parentEventTarget_=null;};goog.inherits(goog.events.EventTarget,goog.Disposable);goog.events.Listenable.addImplementation(goog.events.EventTarget);goog.events.EventTarget.MAX_ANCESTORS_=1000;goog.events.EventTarget.prototype.getParentEventTarget=function(){return this.parentEventTarget_;};goog.events.EventTarget.prototype.setParentEventTarget=function(parent){this.parentEventTarget_=parent;};goog.events.EventTarget.prototype.addEventListener=function(type,handler,opt_capture,opt_handlerScope){goog.events.listen(this,type,handler,opt_capture,opt_handlerScope);};goog.events.EventTarget.prototype.removeEventListener=function(type,handler,opt_capture,opt_handlerScope){goog.events.unlisten(this,type,handler,opt_capture,opt_handlerScope);};goog.events.EventTarget.prototype.dispatchEvent=function(e){this.assertInitialized_();var ancestor=this.getParentEventTarget();if(ancestor){var ancestorsTree=[];for(var ancestorCount=1;ancestor;ancestor=ancestor.getParentEventTarget()){ancestorsTree.push(ancestor),goog.asserts.assert(++ancestorCount<goog.events.EventTarget.MAX_ANCESTORS_,"infinite loop");}}return goog.events.EventTarget.dispatchEventInternal_(this.actualEventTarget_,e,ancestorsTree);};goog.events.EventTarget.prototype.disposeInternal=function(){goog.events.EventTarget.superClass_.disposeInternal.call(this);this.removeAllListeners();this.parentEventTarget_=null;};goog.events.EventTarget.prototype.listen=function(type,listener,opt_useCapture,opt_listenerScope){this.assertInitialized_();return this.eventTargetListeners_.add(String(type),listener,!1,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.listenOnce=function(type,listener,opt_useCapture,opt_listenerScope){return this.eventTargetListeners_.add(String(type),listener,!0,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.unlisten=function(type,listener,opt_useCapture,opt_listenerScope){return this.eventTargetListeners_.remove(String(type),listener,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.unlistenByKey=function(key){return this.eventTargetListeners_.removeByKey(key);};goog.events.EventTarget.prototype.removeAllListeners=function(opt_type){return this.eventTargetListeners_?this.eventTargetListeners_.removeAll(opt_type):0;};goog.events.EventTarget.prototype.fireListeners=function(type,capture,eventObject){var listenerArray=this.eventTargetListeners_.listeners[String(type)];if(!listenerArray){return!0;}for(var listenerArray=listenerArray.concat(),rv=!0,i=0;i<listenerArray.length;++i){var listener=listenerArray[i];if(listener&&!listener.removed&&listener.capture==capture){var listenerFn=listener.listener,listenerHandler=listener.handler||listener.src;listener.callOnce&&this.unlistenByKey(listener);rv=!1!==listenerFn.call(listenerHandler,eventObject)&&rv;}}return rv&&0!=eventObject.returnValue_;};goog.events.EventTarget.prototype.getListeners=function(type,capture){return this.eventTargetListeners_.getListeners(String(type),capture);};goog.events.EventTarget.prototype.getListener=function(type,listener,capture,opt_listenerScope){return this.eventTargetListeners_.getListener(String(type),listener,capture,opt_listenerScope);};goog.events.EventTarget.prototype.hasListener=function(opt_type,opt_capture){return this.eventTargetListeners_.hasListener(goog.isDef(opt_type)?String(opt_type):void 0,opt_capture);};goog.events.EventTarget.prototype.setTargetForTesting=function(target){this.actualEventTarget_=target;};goog.events.EventTarget.prototype.assertInitialized_=function(){goog.asserts.assert(this.eventTargetListeners_,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");};goog.events.EventTarget.dispatchEventInternal_=function(target,e,opt_ancestorsTree){var type=e.type||e;if(goog.isString(e)){e=new goog.events.Event(e,target);}else{if(e instanceof goog.events.Event){e.target=e.target||target;}else{var oldEvent=e;e=new goog.events.Event(type,target);goog.object.extend(e,oldEvent);}}var rv=!0;if(opt_ancestorsTree){for(var i=opt_ancestorsTree.length-1;!e.propagationStopped_&&0<=i;i--){var currentTarget=e.currentTarget=opt_ancestorsTree[i];rv=currentTarget.fireListeners(type,!0,e)&&rv;}}e.propagationStopped_||(currentTarget=e.currentTarget=target,rv=currentTarget.fireListeners(type,!0,e)&&rv,e.propagationStopped_||(rv=currentTarget.fireListeners(type,!1,e)&&rv));if(opt_ancestorsTree){for(i=0;!e.propagationStopped_&&i<opt_ancestorsTree.length;i++){currentTarget=e.currentTarget=opt_ancestorsTree[i],rv=currentTarget.fireListeners(type,!1,e)&&rv;}}return rv;};goog.async={};goog.async.FreeList=function(create,reset,limit){this.limit_=limit;this.create_=create;this.reset_=reset;this.occupants_=0;this.head_=null;};goog.async.FreeList.prototype.get=function(){if(0<this.occupants_){this.occupants_--;var item=this.head_;this.head_=item.next;item.next=null;}else{item=this.create_();}return item;};goog.async.FreeList.prototype.put=function(item){this.reset_(item);this.occupants_<this.limit_&&(this.occupants_++,item.next=this.head_,this.head_=item);};goog.async.FreeList.prototype.occupants=function(){return this.occupants_;};goog.dom.TagName=function(tagName){this.tagName_=tagName;};goog.dom.TagName.prototype.toString=function(){return this.tagName_;};goog.dom.TagName.A=new goog.dom.TagName("A");goog.dom.TagName.ABBR=new goog.dom.TagName("ABBR");goog.dom.TagName.ACRONYM=new goog.dom.TagName("ACRONYM");goog.dom.TagName.ADDRESS=new goog.dom.TagName("ADDRESS");goog.dom.TagName.APPLET=new goog.dom.TagName("APPLET");goog.dom.TagName.AREA=new goog.dom.TagName("AREA");goog.dom.TagName.ARTICLE=new goog.dom.TagName("ARTICLE");goog.dom.TagName.ASIDE=new goog.dom.TagName("ASIDE");goog.dom.TagName.AUDIO=new goog.dom.TagName("AUDIO");goog.dom.TagName.B=new goog.dom.TagName("B");goog.dom.TagName.BASE=new goog.dom.TagName("BASE");goog.dom.TagName.BASEFONT=new goog.dom.TagName("BASEFONT");goog.dom.TagName.BDI=new goog.dom.TagName("BDI");goog.dom.TagName.BDO=new goog.dom.TagName("BDO");goog.dom.TagName.BIG=new goog.dom.TagName("BIG");goog.dom.TagName.BLOCKQUOTE=new goog.dom.TagName("BLOCKQUOTE");goog.dom.TagName.BODY=new goog.dom.TagName("BODY");goog.dom.TagName.BR=new goog.dom.TagName("BR");goog.dom.TagName.BUTTON=new goog.dom.TagName("BUTTON");goog.dom.TagName.CANVAS=new goog.dom.TagName("CANVAS");goog.dom.TagName.CAPTION=new goog.dom.TagName("CAPTION");goog.dom.TagName.CENTER=new goog.dom.TagName("CENTER");goog.dom.TagName.CITE=new goog.dom.TagName("CITE");goog.dom.TagName.CODE=new goog.dom.TagName("CODE");goog.dom.TagName.COL=new goog.dom.TagName("COL");goog.dom.TagName.COLGROUP=new goog.dom.TagName("COLGROUP");goog.dom.TagName.COMMAND=new goog.dom.TagName("COMMAND");goog.dom.TagName.DATA=new goog.dom.TagName("DATA");goog.dom.TagName.DATALIST=new goog.dom.TagName("DATALIST");goog.dom.TagName.DD=new goog.dom.TagName("DD");goog.dom.TagName.DEL=new goog.dom.TagName("DEL");goog.dom.TagName.DETAILS=new goog.dom.TagName("DETAILS");goog.dom.TagName.DFN=new goog.dom.TagName("DFN");goog.dom.TagName.DIALOG=new goog.dom.TagName("DIALOG");goog.dom.TagName.DIR=new goog.dom.TagName("DIR");goog.dom.TagName.DIV=new goog.dom.TagName("DIV");goog.dom.TagName.DL=new goog.dom.TagName("DL");goog.dom.TagName.DT=new goog.dom.TagName("DT");goog.dom.TagName.EM=new goog.dom.TagName("EM");goog.dom.TagName.EMBED=new goog.dom.TagName("EMBED");goog.dom.TagName.FIELDSET=new goog.dom.TagName("FIELDSET");goog.dom.TagName.FIGCAPTION=new goog.dom.TagName("FIGCAPTION");goog.dom.TagName.FIGURE=new goog.dom.TagName("FIGURE");goog.dom.TagName.FONT=new goog.dom.TagName("FONT");goog.dom.TagName.FOOTER=new goog.dom.TagName("FOOTER");goog.dom.TagName.FORM=new goog.dom.TagName("FORM");goog.dom.TagName.FRAME=new goog.dom.TagName("FRAME");goog.dom.TagName.FRAMESET=new goog.dom.TagName("FRAMESET");goog.dom.TagName.H1=new goog.dom.TagName("H1");goog.dom.TagName.H2=new goog.dom.TagName("H2");goog.dom.TagName.H3=new goog.dom.TagName("H3");goog.dom.TagName.H4=new goog.dom.TagName("H4");goog.dom.TagName.H5=new goog.dom.TagName("H5");goog.dom.TagName.H6=new goog.dom.TagName("H6");goog.dom.TagName.HEAD=new goog.dom.TagName("HEAD");goog.dom.TagName.HEADER=new goog.dom.TagName("HEADER");goog.dom.TagName.HGROUP=new goog.dom.TagName("HGROUP");goog.dom.TagName.HR=new goog.dom.TagName("HR");goog.dom.TagName.HTML=new goog.dom.TagName("HTML");goog.dom.TagName.I=new goog.dom.TagName("I");goog.dom.TagName.IFRAME=new goog.dom.TagName("IFRAME");goog.dom.TagName.IMG=new goog.dom.TagName("IMG");goog.dom.TagName.INPUT=new goog.dom.TagName("INPUT");goog.dom.TagName.INS=new goog.dom.TagName("INS");goog.dom.TagName.ISINDEX=new goog.dom.TagName("ISINDEX");goog.dom.TagName.KBD=new goog.dom.TagName("KBD");goog.dom.TagName.KEYGEN=new goog.dom.TagName("KEYGEN");goog.dom.TagName.LABEL=new goog.dom.TagName("LABEL");goog.dom.TagName.LEGEND=new goog.dom.TagName("LEGEND");goog.dom.TagName.LI=new goog.dom.TagName("LI");goog.dom.TagName.LINK=new goog.dom.TagName("LINK");goog.dom.TagName.MAP=new goog.dom.TagName("MAP");goog.dom.TagName.MARK=new goog.dom.TagName("MARK");goog.dom.TagName.MATH=new goog.dom.TagName("MATH");goog.dom.TagName.MENU=new goog.dom.TagName("MENU");goog.dom.TagName.META=new goog.dom.TagName("META");goog.dom.TagName.METER=new goog.dom.TagName("METER");goog.dom.TagName.NAV=new goog.dom.TagName("NAV");goog.dom.TagName.NOFRAMES=new goog.dom.TagName("NOFRAMES");goog.dom.TagName.NOSCRIPT=new goog.dom.TagName("NOSCRIPT");goog.dom.TagName.OBJECT=new goog.dom.TagName("OBJECT");goog.dom.TagName.OL=new goog.dom.TagName("OL");goog.dom.TagName.OPTGROUP=new goog.dom.TagName("OPTGROUP");goog.dom.TagName.OPTION=new goog.dom.TagName("OPTION");goog.dom.TagName.OUTPUT=new goog.dom.TagName("OUTPUT");goog.dom.TagName.P=new goog.dom.TagName("P");goog.dom.TagName.PARAM=new goog.dom.TagName("PARAM");goog.dom.TagName.PRE=new goog.dom.TagName("PRE");goog.dom.TagName.PROGRESS=new goog.dom.TagName("PROGRESS");goog.dom.TagName.Q=new goog.dom.TagName("Q");goog.dom.TagName.RP=new goog.dom.TagName("RP");goog.dom.TagName.RT=new goog.dom.TagName("RT");goog.dom.TagName.RUBY=new goog.dom.TagName("RUBY");goog.dom.TagName.S=new goog.dom.TagName("S");goog.dom.TagName.SAMP=new goog.dom.TagName("SAMP");goog.dom.TagName.SCRIPT=new goog.dom.TagName("SCRIPT");goog.dom.TagName.SECTION=new goog.dom.TagName("SECTION");goog.dom.TagName.SELECT=new goog.dom.TagName("SELECT");goog.dom.TagName.SMALL=new goog.dom.TagName("SMALL");goog.dom.TagName.SOURCE=new goog.dom.TagName("SOURCE");goog.dom.TagName.SPAN=new goog.dom.TagName("SPAN");goog.dom.TagName.STRIKE=new goog.dom.TagName("STRIKE");goog.dom.TagName.STRONG=new goog.dom.TagName("STRONG");goog.dom.TagName.STYLE=new goog.dom.TagName("STYLE");goog.dom.TagName.SUB=new goog.dom.TagName("SUB");goog.dom.TagName.SUMMARY=new goog.dom.TagName("SUMMARY");goog.dom.TagName.SUP=new goog.dom.TagName("SUP");goog.dom.TagName.SVG=new goog.dom.TagName("SVG");goog.dom.TagName.TABLE=new goog.dom.TagName("TABLE");goog.dom.TagName.TBODY=new goog.dom.TagName("TBODY");goog.dom.TagName.TD=new goog.dom.TagName("TD");goog.dom.TagName.TEMPLATE=new goog.dom.TagName("TEMPLATE");goog.dom.TagName.TEXTAREA=new goog.dom.TagName("TEXTAREA");goog.dom.TagName.TFOOT=new goog.dom.TagName("TFOOT");goog.dom.TagName.TH=new goog.dom.TagName("TH");goog.dom.TagName.THEAD=new goog.dom.TagName("THEAD");goog.dom.TagName.TIME=new goog.dom.TagName("TIME");goog.dom.TagName.TITLE=new goog.dom.TagName("TITLE");goog.dom.TagName.TR=new goog.dom.TagName("TR");goog.dom.TagName.TRACK=new goog.dom.TagName("TRACK");goog.dom.TagName.TT=new goog.dom.TagName("TT");goog.dom.TagName.U=new goog.dom.TagName("U");goog.dom.TagName.UL=new goog.dom.TagName("UL");goog.dom.TagName.VAR=new goog.dom.TagName("VAR");goog.dom.TagName.VIDEO=new goog.dom.TagName("VIDEO");goog.dom.TagName.WBR=new goog.dom.TagName("WBR");goog.functions={};goog.functions.constant=function(retValue){return function(){return retValue;};};goog.functions.FALSE=goog.functions.constant(!1);goog.functions.TRUE=goog.functions.constant(!0);goog.functions.NULL=goog.functions.constant(null);goog.functions.identity=function(opt_returnValue,var_args){return opt_returnValue;};goog.functions.error=function(message){return function(){throw Error(message);};};goog.functions.fail=function(err){return function(){throw err;};};goog.functions.lock=function(f,opt_numArgs){opt_numArgs=opt_numArgs||0;return function(){return f.apply(this,Array.prototype.slice.call(arguments,0,opt_numArgs));};};goog.functions.nth=function(n){return function(){return arguments[n];};};goog.functions.partialRight=function(fn,var_args){var rightArgs=Array.prototype.slice.call(arguments,1);return function(){var newArgs=Array.prototype.slice.call(arguments);newArgs.push.apply(newArgs,rightArgs);return fn.apply(this,newArgs);};};goog.functions.withReturnValue=function(f,retValue){return goog.functions.sequence(f,goog.functions.constant(retValue));};goog.functions.equalTo=function(value,opt_useLooseComparison){return function(other){return opt_useLooseComparison?value==other:value===other;};};goog.functions.compose=function(fn,var_args){var functions=arguments,length=functions.length;return function(){var result;length&&(result=functions[length-1].apply(this,arguments));for(var i=length-2;0<=i;i--){result=functions[i].call(this,result);}return result;};};goog.functions.sequence=function(var_args){var functions=arguments,length=functions.length;return function(){for(var result,i=0;i<length;i++){result=functions[i].apply(this,arguments);}return result;};};goog.functions.and=function(var_args){var functions=arguments,length=functions.length;return function(){for(var i=0;i<length;i++){if(!functions[i].apply(this,arguments)){return!1;}}return!0;};};goog.functions.or=function(var_args){var functions=arguments,length=functions.length;return function(){for(var i=0;i<length;i++){if(functions[i].apply(this,arguments)){return!0;}}return!1;};};goog.functions.not=function(f){return function(){return!f.apply(this,arguments);};};goog.functions.create=function(constructor,var_args){var temp=function temp(){};temp.prototype=constructor.prototype;var obj=new temp();constructor.apply(obj,Array.prototype.slice.call(arguments,1));return obj;};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(fn){var called=!1,value;return function(){if(!goog.functions.CACHE_RETURN_VALUE){return fn();}called||(value=fn(),called=!0);return value;};};goog.functions.once=function(f){var inner=f;return function(){if(inner){var tmp=inner;inner=null;tmp();}};};goog.functions.debounce=function(f,interval,opt_scope){var timeout=0;return function(var_args){goog.global.clearTimeout(timeout);var args=arguments;timeout=goog.global.setTimeout(function(){f.apply(opt_scope,args);},interval);};};goog.functions.throttle=function(f,interval,opt_scope){var timeout=0,shouldFire=!1,args=[],handleTimeout=function handleTimeout(){timeout=0;shouldFire&&(shouldFire=!1,fire());},fire=function fire(){timeout=goog.global.setTimeout(handleTimeout,interval);f.apply(opt_scope,args);};return function(var_args){args=arguments;timeout?shouldFire=!0:fire();};};goog.functions.rateLimit=function(f,interval,opt_scope){var timeout=0,handleTimeout=function handleTimeout(){timeout=0;};return function(var_args){timeout||(timeout=goog.global.setTimeout(handleTimeout,interval),f.apply(opt_scope,arguments));};};goog.functions.rateLimit=function(f,interval,opt_scope){var timeout=0,handleTimeout=function handleTimeout(){timeout=0;};return function(var_args){timeout||(timeout=goog.global.setTimeout(handleTimeout,interval),f.apply(opt_scope,arguments));};};goog.async.throwException=function(exception){goog.global.setTimeout(function(){throw exception;},0);};goog.async.nextTick=function(callback,opt_context,opt_useSetImmediate){var cb=callback;opt_context&&(cb=goog.bind(callback,opt_context));cb=goog.async.nextTick.wrapCallback_(cb);goog.isFunction(goog.global.setImmediate)&&(opt_useSetImmediate||goog.async.nextTick.useSetImmediate_())?goog.global.setImmediate(cb):(goog.async.nextTick.setImmediate_||(goog.async.nextTick.setImmediate_=goog.async.nextTick.getSetImmediateEmulator_()),goog.async.nextTick.setImmediate_(cb));};goog.async.nextTick.useSetImmediate_=function(){return goog.global.Window&&goog.global.Window.prototype&&!goog.labs.userAgent.browser.isEdge()&&goog.global.Window.prototype.setImmediate==goog.global.setImmediate?!1:!0;};goog.async.nextTick.getSetImmediateEmulator_=function(){var Channel=goog.global.MessageChannel;"undefined"===typeof Channel&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!goog.labs.userAgent.engine.isPresto()&&(Channel=function Channel(){var iframe=document.createElement("IFRAME");iframe.style.display="none";iframe.src="";document.documentElement.appendChild(iframe);var win=iframe.contentWindow,doc=win.document;doc.open();doc.write("");doc.close();var message="callImmediate"+Math.random(),origin="file:"==win.location.protocol?"*":win.location.protocol+"//"+win.location.host,onmessage=goog.bind(function(e){if(("*"==origin||e.origin==origin)&&e.data==message){this.port1.onmessage();}},this);win.addEventListener("message",onmessage,!1);this.port1={};this.port2={postMessage:function postMessage(){win.postMessage(message,origin);}};});if("undefined"!==typeof Channel&&!goog.labs.userAgent.browser.isIE()){var channel=new Channel(),head={},tail=head;channel.port1.onmessage=function(){if(goog.isDef(head.next)){head=head.next;var cb=head.cb;head.cb=null;cb();}};return function(cb){tail.next={cb:cb};tail=tail.next;channel.port2.postMessage(0);};}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(cb){var script=document.createElement("SCRIPT");script.onreadystatechange=function(){script.onreadystatechange=null;script.parentNode.removeChild(script);script=null;cb();cb=null;};document.documentElement.appendChild(script);}:function(cb){goog.global.setTimeout(cb,0);};};goog.async.nextTick.wrapCallback_=goog.functions.identity;goog.debug.entryPointRegistry.register(function(transformer){goog.async.nextTick.wrapCallback_=transformer;});goog.async.WorkQueue=function(){this.workTail_=this.workHead_=null;};goog.async.WorkQueue.DEFAULT_MAX_UNUSED=100;goog.async.WorkQueue.freelist_=new goog.async.FreeList(function(){return new goog.async.WorkItem();},function(item){item.reset();},goog.async.WorkQueue.DEFAULT_MAX_UNUSED);goog.async.WorkQueue.prototype.add=function(fn,scope){var item=this.getUnusedItem_();item.set(fn,scope);this.workTail_?this.workTail_.next=item:(goog.asserts.assert(!this.workHead_),this.workHead_=item);this.workTail_=item;};goog.async.WorkQueue.prototype.remove=function(){var item=null;this.workHead_&&(item=this.workHead_,this.workHead_=this.workHead_.next,this.workHead_||(this.workTail_=null),item.next=null);return item;};goog.async.WorkQueue.prototype.returnUnused=function(item){goog.async.WorkQueue.freelist_.put(item);};goog.async.WorkQueue.prototype.getUnusedItem_=function(){return goog.async.WorkQueue.freelist_.get();};goog.async.WorkItem=function(){this.next=this.scope=this.fn=null;};goog.async.WorkItem.prototype.set=function(fn,scope){this.fn=fn;this.scope=scope;this.next=null;};goog.async.WorkItem.prototype.reset=function(){this.next=this.scope=this.fn=null;};goog.async.run=function(callback,opt_context){goog.async.run.schedule_||goog.async.run.initializeRunner_();goog.async.run.workQueueScheduled_||(goog.async.run.schedule_(),goog.async.run.workQueueScheduled_=!0);goog.async.run.workQueue_.add(callback,opt_context);};goog.async.run.initializeRunner_=function(){if(-1!=String(goog.global.Promise).indexOf("[native code]")){var promise=goog.global.Promise.resolve(void 0);goog.async.run.schedule_=function(){promise.then(goog.async.run.processWorkQueue);};}else{goog.async.run.schedule_=function(){goog.async.nextTick(goog.async.run.processWorkQueue);};}};goog.async.run.forceNextTick=function(opt_realSetTimeout){goog.async.run.schedule_=function(){goog.async.nextTick(goog.async.run.processWorkQueue);opt_realSetTimeout&&opt_realSetTimeout(goog.async.run.processWorkQueue);};};goog.async.run.workQueueScheduled_=!1;goog.async.run.workQueue_=new goog.async.WorkQueue();goog.DEBUG&&(goog.async.run.resetQueue=function(){goog.async.run.workQueueScheduled_=!1;goog.async.run.workQueue_=new goog.async.WorkQueue();});goog.async.run.processWorkQueue=function(){for(var item=null;item=goog.async.run.workQueue_.remove();){try{item.fn.call(item.scope);}catch(e){goog.async.throwException(e);}goog.async.run.workQueue_.returnUnused(item);}goog.async.run.workQueueScheduled_=!1;};goog.fs={};goog.fs.DOMErrorLike=function(){};goog.fs.Error=function(error,action){goog.isDef(error.name)?(this.name=error.name,this.code=goog.fs.Error.getCodeFromName_(error.name)):(this.code=goog.asserts.assertNumber(error.code),this.name=goog.fs.Error.getNameFromCode_(error.code));goog.debug.Error.call(this,goog.string.subs("%s %s",this.name,action));};goog.inherits(goog.fs.Error,goog.debug.Error);goog.fs.Error.ErrorName={ABORT:"AbortError",ENCODING:"EncodingError",INVALID_MODIFICATION:"InvalidModificationError",INVALID_STATE:"InvalidStateError",NOT_FOUND:"NotFoundError",NOT_READABLE:"NotReadableError",NO_MODIFICATION_ALLOWED:"NoModificationAllowedError",PATH_EXISTS:"PathExistsError",QUOTA_EXCEEDED:"QuotaExceededError",SECURITY:"SecurityError",SYNTAX:"SyntaxError",TYPE_MISMATCH:"TypeMismatchError"};goog.fs.Error.ErrorCode={NOT_FOUND:1,SECURITY:2,ABORT:3,NOT_READABLE:4,ENCODING:5,NO_MODIFICATION_ALLOWED:6,INVALID_STATE:7,SYNTAX:8,INVALID_MODIFICATION:9,QUOTA_EXCEEDED:10,TYPE_MISMATCH:11,PATH_EXISTS:12};goog.fs.Error.getNameFromCode_=function(code){var name=goog.object.findKey(goog.fs.Error.NameToCodeMap_,function(c){return code==c;});if(!goog.isDef(name)){throw Error("Invalid code: "+code);}return name;};goog.fs.Error.getCodeFromName_=function(name){return goog.fs.Error.NameToCodeMap_[name];};goog.fs.Error.NameToCodeMap_=goog.object.create(goog.fs.Error.ErrorName.ABORT,goog.fs.Error.ErrorCode.ABORT,goog.fs.Error.ErrorName.ENCODING,goog.fs.Error.ErrorCode.ENCODING,goog.fs.Error.ErrorName.INVALID_MODIFICATION,goog.fs.Error.ErrorCode.INVALID_MODIFICATION,goog.fs.Error.ErrorName.INVALID_STATE,goog.fs.Error.ErrorCode.INVALID_STATE,goog.fs.Error.ErrorName.NOT_FOUND,goog.fs.Error.ErrorCode.NOT_FOUND,goog.fs.Error.ErrorName.NOT_READABLE,goog.fs.Error.ErrorCode.NOT_READABLE,goog.fs.Error.ErrorName.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorCode.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorName.PATH_EXISTS,goog.fs.Error.ErrorCode.PATH_EXISTS,goog.fs.Error.ErrorName.QUOTA_EXCEEDED,goog.fs.Error.ErrorCode.QUOTA_EXCEEDED,goog.fs.Error.ErrorName.SECURITY,goog.fs.Error.ErrorCode.SECURITY,goog.fs.Error.ErrorName.SYNTAX,goog.fs.Error.ErrorCode.SYNTAX,goog.fs.Error.ErrorName.TYPE_MISMATCH,goog.fs.Error.ErrorCode.TYPE_MISMATCH);goog.fs.ProgressEvent=function(event,target){goog.events.Event.call(this,event.type,target);this.event_=event;};goog.inherits(goog.fs.ProgressEvent,goog.events.Event);goog.fs.ProgressEvent.prototype.isLengthComputable=function(){return this.event_.lengthComputable;};goog.fs.ProgressEvent.prototype.getLoaded=function(){return this.event_.loaded;};goog.fs.ProgressEvent.prototype.getTotal=function(){return this.event_.total;};goog.fs={};goog.fs.DOMErrorLike=function(){};goog.fs.Error=function(error,action){goog.isDef(error.name)?(this.name=error.name,this.code=goog.fs.Error.getCodeFromName_(error.name)):(this.code=goog.asserts.assertNumber(error.code),this.name=goog.fs.Error.getNameFromCode_(error.code));goog.debug.Error.call(this,goog.string.subs("%s %s",this.name,action));};goog.inherits(goog.fs.Error,goog.debug.Error);goog.fs.Error.ErrorName={ABORT:"AbortError",ENCODING:"EncodingError",INVALID_MODIFICATION:"InvalidModificationError",INVALID_STATE:"InvalidStateError",NOT_FOUND:"NotFoundError",NOT_READABLE:"NotReadableError",NO_MODIFICATION_ALLOWED:"NoModificationAllowedError",PATH_EXISTS:"PathExistsError",QUOTA_EXCEEDED:"QuotaExceededError",SECURITY:"SecurityError",SYNTAX:"SyntaxError",TYPE_MISMATCH:"TypeMismatchError"};goog.fs.Error.ErrorCode={NOT_FOUND:1,SECURITY:2,ABORT:3,NOT_READABLE:4,ENCODING:5,NO_MODIFICATION_ALLOWED:6,INVALID_STATE:7,SYNTAX:8,INVALID_MODIFICATION:9,QUOTA_EXCEEDED:10,TYPE_MISMATCH:11,PATH_EXISTS:12};goog.fs.Error.getNameFromCode_=function(code){var name=goog.object.findKey(goog.fs.Error.NameToCodeMap_,function(c){return code==c;});if(!goog.isDef(name)){throw Error("Invalid code: "+code);}return name;};goog.fs.Error.getCodeFromName_=function(name){return goog.fs.Error.NameToCodeMap_[name];};goog.fs.Error.NameToCodeMap_=goog.object.create(goog.fs.Error.ErrorName.ABORT,goog.fs.Error.ErrorCode.ABORT,goog.fs.Error.ErrorName.ENCODING,goog.fs.Error.ErrorCode.ENCODING,goog.fs.Error.ErrorName.INVALID_MODIFICATION,goog.fs.Error.ErrorCode.INVALID_MODIFICATION,goog.fs.Error.ErrorName.INVALID_STATE,goog.fs.Error.ErrorCode.INVALID_STATE,goog.fs.Error.ErrorName.NOT_FOUND,goog.fs.Error.ErrorCode.NOT_FOUND,goog.fs.Error.ErrorName.NOT_READABLE,goog.fs.Error.ErrorCode.NOT_READABLE,goog.fs.Error.ErrorName.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorCode.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorName.PATH_EXISTS,goog.fs.Error.ErrorCode.PATH_EXISTS,goog.fs.Error.ErrorName.QUOTA_EXCEEDED,goog.fs.Error.ErrorCode.QUOTA_EXCEEDED,goog.fs.Error.ErrorName.SECURITY,goog.fs.Error.ErrorCode.SECURITY,goog.fs.Error.ErrorName.SYNTAX,goog.fs.Error.ErrorCode.SYNTAX,goog.fs.Error.ErrorName.TYPE_MISMATCH,goog.fs.Error.ErrorCode.TYPE_MISMATCH);goog.fs.ProgressEvent=function(event,target){goog.events.Event.call(this,event.type,target);this.event_=event;};goog.inherits(goog.fs.ProgressEvent,goog.events.Event);goog.fs.ProgressEvent.prototype.isLengthComputable=function(){return this.event_.lengthComputable;};goog.fs.ProgressEvent.prototype.getLoaded=function(){return this.event_.loaded;};goog.fs.ProgressEvent.prototype.getTotal=function(){return this.event_.total;};goog.promise={};goog.promise.Resolver=function(){};goog.Thenable=function(){};goog.Thenable.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){};goog.Thenable.IMPLEMENTED_BY_PROP="$goog_Thenable";goog.Thenable.addImplementation=function(ctor){ctor.prototype.then=ctor.prototype.then;ctor.prototype[goog.Thenable.IMPLEMENTED_BY_PROP]=!0;};goog.Thenable.isImplementedBy=function(object){if(!object){return!1;}try{return!!object[goog.Thenable.IMPLEMENTED_BY_PROP];return!!object.$goog_Thenable;}catch(e){return!1;}};goog.Promise=function(resolver,opt_context){this.state_=goog.Promise.State_.PENDING;this.result_=void 0;this.callbackEntriesTail_=this.callbackEntries_=this.parent_=null;this.executing_=!1;0<goog.Promise.UNHANDLED_REJECTION_DELAY?this.unhandledRejectionId_=0:0==goog.Promise.UNHANDLED_REJECTION_DELAY&&(this.hadUnhandledRejection_=!1);goog.Promise.LONG_STACK_TRACES&&(this.stack_=[],this.addStackTrace_(Error("created")),this.currentStep_=0);if(resolver!=goog.nullFunction){try{var self=this;resolver.call(opt_context,function(value){self.resolve_(goog.Promise.State_.FULFILLED,value);},function(reason){if(goog.DEBUG&&!(reason instanceof goog.Promise.CancellationError)){try{if(reason instanceof Error){throw reason;}throw Error("Promise rejected.");}catch(e){}}self.resolve_(goog.Promise.State_.REJECTED,reason);});}catch(e){this.resolve_(goog.Promise.State_.REJECTED,e);}}};goog.Promise.LONG_STACK_TRACES=!1;goog.Promise.UNHANDLED_REJECTION_DELAY=0;goog.Promise.State_={PENDING:0,BLOCKED:1,FULFILLED:2,REJECTED:3};goog.Promise.CallbackEntry_=function(){this.next=this.context=this.onRejected=this.onFulfilled=this.child=null;this.always=!1;};goog.Promise.CallbackEntry_.prototype.reset=function(){this.context=this.onRejected=this.onFulfilled=this.child=null;this.always=!1;};goog.Promise.DEFAULT_MAX_UNUSED=100;goog.Promise.freelist_=new goog.async.FreeList(function(){return new goog.Promise.CallbackEntry_();},function(item){item.reset();},goog.Promise.DEFAULT_MAX_UNUSED);goog.Promise.getCallbackEntry_=function(onFulfilled,onRejected,context){var entry=goog.Promise.freelist_.get();entry.onFulfilled=onFulfilled;entry.onRejected=onRejected;entry.context=context;return entry;};goog.Promise.returnEntry_=function(entry){goog.Promise.freelist_.put(entry);};goog.Promise.resolve=function(opt_value){if(opt_value instanceof goog.Promise){return opt_value;}var promise=new goog.Promise(goog.nullFunction);promise.resolve_(goog.Promise.State_.FULFILLED,opt_value);return promise;};goog.Promise.reject=function(opt_reason){return new goog.Promise(function(resolve,reject){reject(opt_reason);});};goog.Promise.resolveThen_=function(value,onFulfilled,onRejected){goog.Promise.maybeThen_(value,onFulfilled,onRejected,null)||goog.async.run(goog.partial(onFulfilled,value));};goog.Promise.race=function(promises){return new goog.Promise(function(resolve,reject){promises.length||resolve(void 0);for(var i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,resolve,reject);}});};goog.Promise.all=function(promises){return new goog.Promise(function(resolve,reject){var toFulfill=promises.length,values=[];if(toFulfill){for(var onFulfill=function onFulfill(index,value){toFulfill--;values[index]=value;0==toFulfill&&resolve(values);},onReject=function onReject(reason){reject(reason);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,goog.partial(onFulfill,i),onReject);}}else{resolve(values);}});};goog.Promise.allSettled=function(promises){return new goog.Promise(function(resolve,reject){var toSettle=promises.length,results=[];if(toSettle){for(var onSettled=function onSettled(index,fulfilled,result){toSettle--;results[index]=fulfilled?{fulfilled:!0,value:result}:{fulfilled:!1,reason:result};0==toSettle&&resolve(results);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,goog.partial(onSettled,i,!0),goog.partial(onSettled,i,!1));}}else{resolve(results);}});};goog.Promise.firstFulfilled=function(promises){return new goog.Promise(function(resolve,reject){var toReject=promises.length,reasons=[];if(toReject){for(var onFulfill=function onFulfill(value){resolve(value);},onReject=function onReject(index,reason){toReject--;reasons[index]=reason;0==toReject&&reject(reasons);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,onFulfill,goog.partial(onReject,i));}}else{resolve(void 0);}});};goog.Promise.withResolver=function(){var resolve,reject,promise=new goog.Promise(function(rs,rj){resolve=rs;reject=rj;});return new goog.Promise.Resolver_(promise,resolve,reject);};goog.Promise.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){null!=opt_onFulfilled&&goog.asserts.assertFunction(opt_onFulfilled,"opt_onFulfilled should be a function.");null!=opt_onRejected&&goog.asserts.assertFunction(opt_onRejected,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("then"));return this.addChildPromise_(goog.isFunction(opt_onFulfilled)?opt_onFulfilled:null,goog.isFunction(opt_onRejected)?opt_onRejected:null,opt_context);};goog.Thenable.addImplementation(goog.Promise);goog.Promise.prototype.thenVoid=function(opt_onFulfilled,opt_onRejected,opt_context){null!=opt_onFulfilled&&goog.asserts.assertFunction(opt_onFulfilled,"opt_onFulfilled should be a function.");null!=opt_onRejected&&goog.asserts.assertFunction(opt_onRejected,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("then"));this.addCallbackEntry_(goog.Promise.getCallbackEntry_(opt_onFulfilled||goog.nullFunction,opt_onRejected||null,opt_context));};goog.Promise.prototype.thenAlways=function(onSettled,opt_context){goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("thenAlways"));var entry=goog.Promise.getCallbackEntry_(onSettled,onSettled,opt_context);entry.always=!0;this.addCallbackEntry_(entry);return this;};goog.Promise.prototype.thenCatch=function(onRejected,opt_context){goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("thenCatch"));return this.addChildPromise_(null,onRejected,opt_context);};goog.Promise.prototype.cancel=function(opt_message){this.state_==goog.Promise.State_.PENDING&&goog.async.run(function(){var err=new goog.Promise.CancellationError(opt_message);this.cancelInternal_(err);},this);};goog.Promise.prototype.cancelInternal_=function(err){this.state_==goog.Promise.State_.PENDING&&(this.parent_?(this.parent_.cancelChild_(this,err),this.parent_=null):this.resolve_(goog.Promise.State_.REJECTED,err));};goog.Promise.prototype.cancelChild_=function(childPromise,err){if(this.callbackEntries_){for(var childCount=0,childEntry=null,beforeChildEntry=null,entry=this.callbackEntries_;entry&&(entry.always||(childCount++,entry.child==childPromise&&(childEntry=entry),!(childEntry&&1<childCount)));entry=entry.next){childEntry||(beforeChildEntry=entry);}childEntry&&(this.state_==goog.Promise.State_.PENDING&&1==childCount?this.cancelInternal_(err):(beforeChildEntry?this.removeEntryAfter_(beforeChildEntry):this.popEntry_(),this.executeCallback_(childEntry,goog.Promise.State_.REJECTED,err)));}};goog.Promise.prototype.addCallbackEntry_=function(callbackEntry){this.hasEntry_()||this.state_!=goog.Promise.State_.FULFILLED&&this.state_!=goog.Promise.State_.REJECTED||this.scheduleCallbacks_();this.queueEntry_(callbackEntry);};goog.Promise.prototype.addChildPromise_=function(onFulfilled,onRejected,opt_context){var callbackEntry=goog.Promise.getCallbackEntry_(null,null,null);callbackEntry.child=new goog.Promise(function(resolve,reject){callbackEntry.onFulfilled=onFulfilled?function(value){try{var result=onFulfilled.call(opt_context,value);resolve(result);}catch(err){reject(err);}}:resolve;callbackEntry.onRejected=onRejected?function(reason){try{var result=onRejected.call(opt_context,reason);!goog.isDef(result)&&reason instanceof goog.Promise.CancellationError?reject(reason):resolve(result);}catch(err){reject(err);}}:reject;});callbackEntry.child.parent_=this;this.addCallbackEntry_(callbackEntry);return callbackEntry.child;};goog.Promise.prototype.unblockAndFulfill_=function(value){goog.asserts.assert(this.state_==goog.Promise.State_.BLOCKED);this.state_=goog.Promise.State_.PENDING;this.resolve_(goog.Promise.State_.FULFILLED,value);};goog.Promise.prototype.unblockAndReject_=function(reason){goog.asserts.assert(this.state_==goog.Promise.State_.BLOCKED);this.state_=goog.Promise.State_.PENDING;this.resolve_(goog.Promise.State_.REJECTED,reason);};goog.Promise.prototype.resolve_=function(state,x){this.state_==goog.Promise.State_.PENDING&&(this===x&&(state=goog.Promise.State_.REJECTED,x=new TypeError("Promise cannot resolve to itself")),this.state_=goog.Promise.State_.BLOCKED,goog.Promise.maybeThen_(x,this.unblockAndFulfill_,this.unblockAndReject_,this)||(this.result_=x,this.state_=state,this.parent_=null,this.scheduleCallbacks_(),state!=goog.Promise.State_.REJECTED||x instanceof goog.Promise.CancellationError||goog.Promise.addUnhandledRejection_(this,x)));};goog.Promise.maybeThen_=function(value,onFulfilled,onRejected,context){if(value instanceof goog.Promise){return value.thenVoid(onFulfilled,onRejected,context),!0;}if(goog.Thenable.isImplementedBy(value)){return value.then(onFulfilled,onRejected,context),!0;}if(goog.isObject(value)){try{var then=value.then;if(goog.isFunction(then)){return goog.Promise.tryThen_(value,then,onFulfilled,onRejected,context),!0;}}catch(e){return onRejected.call(context,e),!0;}}return!1;};goog.Promise.tryThen_=function(thenable,then,onFulfilled,onRejected,context){var called=!1,resolve=function resolve(value){called||(called=!0,onFulfilled.call(context,value));},reject=function reject(reason){called||(called=!0,onRejected.call(context,reason));};try{then.call(thenable,resolve,reject);}catch(e){reject(e);}};goog.Promise.prototype.scheduleCallbacks_=function(){this.executing_||(this.executing_=!0,goog.async.run(this.executeCallbacks_,this));};goog.Promise.prototype.hasEntry_=function(){return!!this.callbackEntries_;};goog.Promise.prototype.queueEntry_=function(entry){goog.asserts.assert(null!=entry.onFulfilled);this.callbackEntriesTail_?this.callbackEntriesTail_.next=entry:this.callbackEntries_=entry;this.callbackEntriesTail_=entry;};goog.Promise.prototype.popEntry_=function(){var entry=null;this.callbackEntries_&&(entry=this.callbackEntries_,this.callbackEntries_=entry.next,entry.next=null);this.callbackEntries_||(this.callbackEntriesTail_=null);null!=entry&&goog.asserts.assert(null!=entry.onFulfilled);return entry;};goog.Promise.prototype.removeEntryAfter_=function(previous){goog.asserts.assert(this.callbackEntries_);goog.asserts.assert(null!=previous);previous.next==this.callbackEntriesTail_&&(this.callbackEntriesTail_=previous);previous.next=previous.next.next;};goog.Promise.prototype.executeCallbacks_=function(){for(var entry=null;entry=this.popEntry_();){goog.Promise.LONG_STACK_TRACES&&this.currentStep_++,this.executeCallback_(entry,this.state_,this.result_);}this.executing_=!1;};goog.Promise.prototype.executeCallback_=function(callbackEntry,state,result){state==goog.Promise.State_.REJECTED&&callbackEntry.onRejected&&!callbackEntry.always&&this.removeUnhandledRejection_();if(callbackEntry.child){callbackEntry.child.parent_=null,goog.Promise.invokeCallback_(callbackEntry,state,result);}else{try{callbackEntry.always?callbackEntry.onFulfilled.call(callbackEntry.context):goog.Promise.invokeCallback_(callbackEntry,state,result);}catch(err){goog.Promise.handleRejection_.call(null,err);}}goog.Promise.returnEntry_(callbackEntry);};goog.Promise.invokeCallback_=function(callbackEntry,state,result){state==goog.Promise.State_.FULFILLED?callbackEntry.onFulfilled.call(callbackEntry.context,result):callbackEntry.onRejected&&callbackEntry.onRejected.call(callbackEntry.context,result);};goog.Promise.prototype.addStackTrace_=function(err){if(goog.Promise.LONG_STACK_TRACES&&goog.isString(err.stack)){var trace=err.stack.split("\\n",4)[3],message=err.message,message=message+Array(11-message.length).join(" ");this.stack_.push(message+trace);}};goog.Promise.prototype.appendLongStack_=function(err){if(goog.Promise.LONG_STACK_TRACES&&err&&goog.isString(err.stack)&&this.stack_.length){for(var longTrace=["Promise trace:"],promise=this;promise;promise=promise.parent_){for(var i=this.currentStep_;0<=i;i--){longTrace.push(promise.stack_[i]);}longTrace.push("Value: ["+(promise.state_==goog.Promise.State_.REJECTED?"REJECTED":"FULFILLED")+"] <"+String(promise.result_)+">");}err.stack+="\\n\\n"+longTrace.join("\\n");}};goog.Promise.prototype.removeUnhandledRejection_=function(){if(0<goog.Promise.UNHANDLED_REJECTION_DELAY){for(var p=this;p&&p.unhandledRejectionId_;p=p.parent_){goog.global.clearTimeout(p.unhandledRejectionId_),p.unhandledRejectionId_=0;}}else{if(0==goog.Promise.UNHANDLED_REJECTION_DELAY){for(p=this;p&&p.hadUnhandledRejection_;p=p.parent_){p.hadUnhandledRejection_=!1;}}}};goog.Promise.addUnhandledRejection_=function(promise,reason){0<goog.Promise.UNHANDLED_REJECTION_DELAY?promise.unhandledRejectionId_=goog.global.setTimeout(function(){promise.appendLongStack_(reason);goog.Promise.handleRejection_.call(null,reason);},goog.Promise.UNHANDLED_REJECTION_DELAY):0==goog.Promise.UNHANDLED_REJECTION_DELAY&&(promise.hadUnhandledRejection_=!0,goog.async.run(function(){promise.hadUnhandledRejection_&&(promise.appendLongStack_(reason),goog.Promise.handleRejection_.call(null,reason));}));};goog.Promise.handleRejection_=goog.async.throwException;goog.Promise.setUnhandledRejectionHandler=function(handler){goog.Promise.handleRejection_=handler;};goog.Promise.CancellationError=function(opt_message){goog.debug.Error.call(this,opt_message);};goog.inherits(goog.Promise.CancellationError,goog.debug.Error);goog.Promise.CancellationError.prototype.name="cancel";goog.Promise.Resolver_=function(promise,resolve,reject){this.promise=promise;this.resolve=resolve;this.reject=reject;};/*\n Portions of this code are from MochiKit, received by\n The Closure Authors under the MIT license. All other code is Copyright\n 2005-2009 The Closure Authors. All Rights Reserved.\n */goog.async.Deferred=function(opt_onCancelFunction,opt_defaultScope){this.sequence_=[];this.onCancelFunction_=opt_onCancelFunction;this.defaultScope_=opt_defaultScope||null;this.hadError_=this.fired_=!1;this.result_=void 0;this.silentlyCanceled_=this.blocking_=this.blocked_=!1;this.unhandledErrorId_=0;this.parent_=null;this.branches_=0;if(goog.async.Deferred.LONG_STACK_TRACES&&(this.constructorStack_=null,Error.captureStackTrace)){var target={stack:""};Error.captureStackTrace(target,goog.async.Deferred);"string"==typeof target.stack&&(this.constructorStack_=target.stack.replace(/^[^\\n]*\\n/,""));}};goog.async.Deferred.STRICT_ERRORS=!1;goog.async.Deferred.LONG_STACK_TRACES=!1;goog.async.Deferred.prototype.cancel=function(opt_deepCancel){if(this.hasFired()){this.result_ instanceof goog.async.Deferred&&this.result_.cancel();}else{if(this.parent_){var parent=this.parent_;delete this.parent_;opt_deepCancel?parent.cancel(opt_deepCancel):parent.branchCancel_();}this.onCancelFunction_?this.onCancelFunction_.call(this.defaultScope_,this):this.silentlyCanceled_=!0;this.hasFired()||this.errback(new goog.async.Deferred.CanceledError(this));}};goog.async.Deferred.prototype.branchCancel_=function(){this.branches_--;0>=this.branches_&&this.cancel();};goog.async.Deferred.prototype.continue_=function(isSuccess,res){this.blocked_=!1;this.updateResult_(isSuccess,res);};goog.async.Deferred.prototype.updateResult_=function(isSuccess,res){this.fired_=!0;this.result_=res;this.hadError_=!isSuccess;this.fire_();};goog.async.Deferred.prototype.check_=function(){if(this.hasFired()){if(!this.silentlyCanceled_){throw new goog.async.Deferred.AlreadyCalledError(this);}this.silentlyCanceled_=!1;}};goog.async.Deferred.prototype.callback=function(opt_result){this.check_();this.assertNotDeferred_(opt_result);this.updateResult_(!0,opt_result);};goog.async.Deferred.prototype.errback=function(opt_result){this.check_();this.assertNotDeferred_(opt_result);this.makeStackTraceLong_(opt_result);this.updateResult_(!1,opt_result);};goog.async.Deferred.prototype.makeStackTraceLong_=function(error){goog.async.Deferred.LONG_STACK_TRACES&&this.constructorStack_&&goog.isObject(error)&&error.stack&&/^[^\\n]+(\\n   [^\\n]+)+/.test(error.stack)&&(error.stack=error.stack+"\\nDEFERRED OPERATION:\\n"+this.constructorStack_);};goog.async.Deferred.prototype.assertNotDeferred_=function(obj){goog.asserts.assert(!(obj instanceof goog.async.Deferred),"An execution sequence may not be initiated with a blocking Deferred.");};goog.async.Deferred.prototype.addCallback=function(cb,opt_scope){return this.addCallbacks(cb,null,opt_scope);};goog.async.Deferred.prototype.addErrback=function(eb,opt_scope){return this.addCallbacks(null,eb,opt_scope);};goog.async.Deferred.prototype.addBoth=function(f,opt_scope){return this.addCallbacks(f,f,opt_scope);};goog.async.Deferred.prototype.addFinally=function(f,opt_scope){return this.addCallbacks(f,function(err){var result=f.call(this,err);if(!goog.isDef(result)){throw err;}return result;},opt_scope);};goog.async.Deferred.prototype.addCallbacks=function(cb,eb,opt_scope){goog.asserts.assert(!this.blocking_,"Blocking Deferreds can not be re-used");this.sequence_.push([cb,eb,opt_scope]);this.hasFired()&&this.fire_();return this;};goog.async.Deferred.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){var resolve,reject,promise=new goog.Promise(function(res,rej){resolve=res;reject=rej;});this.addCallbacks(resolve,function(reason){reason instanceof goog.async.Deferred.CanceledError?promise.cancel():reject(reason);});return promise.then(opt_onFulfilled,opt_onRejected,opt_context);};goog.Thenable.addImplementation(goog.async.Deferred);goog.async.Deferred.prototype.chainDeferred=function(otherDeferred){this.addCallbacks(otherDeferred.callback,otherDeferred.errback,otherDeferred);return this;};goog.async.Deferred.prototype.awaitDeferred=function(otherDeferred){return otherDeferred instanceof goog.async.Deferred?this.addCallback(goog.bind(otherDeferred.branch,otherDeferred)):this.addCallback(function(){return otherDeferred;});};goog.async.Deferred.prototype.branch=function(opt_propagateCancel){var d=new goog.async.Deferred();this.chainDeferred(d);opt_propagateCancel&&(d.parent_=this,this.branches_++);return d;};goog.async.Deferred.prototype.hasFired=function(){return this.fired_;};goog.async.Deferred.prototype.isError=function(res){return res instanceof Error;};goog.async.Deferred.prototype.hasErrback_=function(){return goog.array.some(this.sequence_,function(sequenceRow){return goog.isFunction(sequenceRow[1]);});};goog.async.Deferred.prototype.fire_=function(){this.unhandledErrorId_&&this.hasFired()&&this.hasErrback_()&&(goog.async.Deferred.unscheduleError_(this.unhandledErrorId_),this.unhandledErrorId_=0);this.parent_&&(this.parent_.branches_--,delete this.parent_);for(var res=this.result_,unhandledException=!1,isNewlyBlocked=!1;this.sequence_.length&&!this.blocked_;){var sequenceEntry=this.sequence_.shift(),callback=sequenceEntry[0],errback=sequenceEntry[1],scope=sequenceEntry[2],f=this.hadError_?errback:callback;if(f){try{var ret=f.call(scope||this.defaultScope_,res);goog.isDef(ret)&&(this.hadError_=this.hadError_&&(ret==res||this.isError(ret)),this.result_=res=ret);if(goog.Thenable.isImplementedBy(res)||"function"===typeof goog.global.Promise&&res instanceof goog.global.Promise){this.blocked_=isNewlyBlocked=!0;}}catch(ex){res=ex,this.hadError_=!0,this.makeStackTraceLong_(res),this.hasErrback_()||(unhandledException=!0);}}}this.result_=res;if(isNewlyBlocked){var onCallback=goog.bind(this.continue_,this,!0),onErrback=goog.bind(this.continue_,this,!1);res instanceof goog.async.Deferred?(res.addCallbacks(onCallback,onErrback),res.blocking_=!0):res.then(onCallback,onErrback);}else{!goog.async.Deferred.STRICT_ERRORS||!this.isError(res)||res instanceof goog.async.Deferred.CanceledError||(unhandledException=this.hadError_=!0);}unhandledException&&(this.unhandledErrorId_=goog.async.Deferred.scheduleError_(res));};goog.async.Deferred.succeed=function(opt_result){var d=new goog.async.Deferred();d.callback(opt_result);return d;};goog.async.Deferred.fromPromise=function(promise){var d=new goog.async.Deferred();d.callback();d.addCallback(function(){return promise;});return d;};goog.async.Deferred.fail=function(res){var d=new goog.async.Deferred();d.errback(res);return d;};goog.async.Deferred.canceled=function(){var d=new goog.async.Deferred();d.cancel();return d;};goog.async.Deferred.when=function(value,callback,opt_scope){return value instanceof goog.async.Deferred?value.branch(!0).addCallback(callback,opt_scope):goog.async.Deferred.succeed(value).addCallback(callback,opt_scope);};goog.async.Deferred.AlreadyCalledError=function(deferred){goog.debug.Error.call(this);this.deferred=deferred;};goog.inherits(goog.async.Deferred.AlreadyCalledError,goog.debug.Error);goog.async.Deferred.AlreadyCalledError.prototype.message="Deferred has already fired";goog.async.Deferred.AlreadyCalledError.prototype.name="AlreadyCalledError";goog.async.Deferred.CanceledError=function(deferred){goog.debug.Error.call(this);this.deferred=deferred;};goog.inherits(goog.async.Deferred.CanceledError,goog.debug.Error);goog.async.Deferred.CanceledError.prototype.message="Deferred was canceled";goog.async.Deferred.CanceledError.prototype.name="CanceledError";goog.async.Deferred.Error_=function(error){this.id_=goog.global.setTimeout(goog.bind(this.throwError,this),0);this.error_=error;};goog.async.Deferred.Error_.prototype.throwError=function(){goog.asserts.assert(goog.async.Deferred.errorMap_[this.id_],"Cannot throw an error that is not scheduled.");delete goog.async.Deferred.errorMap_[this.id_];throw this.error_;};goog.async.Deferred.Error_.prototype.resetTimer=function(){goog.global.clearTimeout(this.id_);};goog.async.Deferred.errorMap_={};goog.async.Deferred.scheduleError_=function(error){var deferredError=new goog.async.Deferred.Error_(error);goog.async.Deferred.errorMap_[deferredError.id_]=deferredError;return deferredError.id_;};goog.async.Deferred.unscheduleError_=function(id){var error=goog.async.Deferred.errorMap_[id];error&&(error.resetTimer(),delete goog.async.Deferred.errorMap_[id]);};goog.async.Deferred.assertNoErrors=function(){var map=goog.async.Deferred.errorMap_,key;for(key in map){var error=map[key];error.resetTimer();error.throwError();}};goog.fs.FileReader=function(){goog.events.EventTarget.call(this);this.reader_=new FileReader();this.reader_.onloadstart=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onprogress=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onload=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onabort=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onerror=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onloadend=goog.bind(this.dispatchProgressEvent_,this);};goog.inherits(goog.fs.FileReader,goog.events.EventTarget);goog.fs.FileReader.ReadyState={INIT:0,LOADING:1,DONE:2};goog.fs.FileReader.EventType={LOAD_START:"loadstart",PROGRESS:"progress",LOAD:"load",ABORT:"abort",ERROR:"error",LOAD_END:"loadend"};goog.fs.FileReader.prototype.abort=function(){try{this.reader_.abort();}catch(e){throw new goog.fs.Error(e,"aborting read");}};goog.fs.FileReader.prototype.getReadyState=function(){return this.reader_.readyState;};goog.fs.FileReader.prototype.getResult=function(){return this.reader_.result;};goog.fs.FileReader.prototype.getError=function(){return this.reader_.error&&new goog.fs.Error(this.reader_.error,"reading file");};goog.fs.FileReader.prototype.dispatchProgressEvent_=function(event){this.dispatchEvent(new goog.fs.ProgressEvent(event,this));};goog.fs.FileReader.prototype.disposeInternal=function(){goog.fs.FileReader.superClass_.disposeInternal.call(this);delete this.reader_;};goog.fs.FileReader.prototype.readAsBinaryString=function(blob){this.reader_.readAsBinaryString(blob);};goog.fs.FileReader.readAsBinaryString=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsBinaryString(blob);return d;};goog.fs.FileReader.prototype.readAsArrayBuffer=function(blob){this.reader_.readAsArrayBuffer(blob);};goog.fs.FileReader.readAsArrayBuffer=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsArrayBuffer(blob);return d;};goog.fs.FileReader.prototype.readAsText=function(blob,opt_encoding){this.reader_.readAsText(blob,opt_encoding);};goog.fs.FileReader.readAsText=function(blob,opt_encoding){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsText(blob,opt_encoding);return d;};goog.fs.FileReader.prototype.readAsDataUrl=function(blob){this.reader_.readAsDataURL(blob);};goog.fs.FileReader.readAsDataUrl=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsDataUrl(blob);return d;};goog.fs.FileReader.createDeferred_=function(reader){var deferred=new goog.async.Deferred();reader.listen(goog.fs.FileReader.EventType.LOAD_END,goog.partial(function(d,r,e){var result=r.getResult(),error=r.getError();null==result||error?d.errback(error):d.callback(result);r.dispose();},deferred,reader));return deferred;};goog.net={};goog.net.EventType={COMPLETE:"complete",SUCCESS:"success",ERROR:"error",ABORT:"abort",READY:"ready",READY_STATE_CHANGE:"readystatechange",TIMEOUT:"timeout",INCREMENTAL_DATA:"incrementaldata",PROGRESS:"progress",DOWNLOAD_PROGRESS:"downloadprogress",UPLOAD_PROGRESS:"uploadprogress"};goog.net.HttpStatus={CONTINUE:100,SWITCHING_PROTOCOLS:101,OK:200,CREATED:201,ACCEPTED:202,NON_AUTHORITATIVE_INFORMATION:203,NO_CONTENT:204,RESET_CONTENT:205,PARTIAL_CONTENT:206,MULTIPLE_CHOICES:300,MOVED_PERMANENTLY:301,FOUND:302,SEE_OTHER:303,NOT_MODIFIED:304,USE_PROXY:305,TEMPORARY_REDIRECT:307,BAD_REQUEST:400,UNAUTHORIZED:401,PAYMENT_REQUIRED:402,FORBIDDEN:403,NOT_FOUND:404,METHOD_NOT_ALLOWED:405,NOT_ACCEPTABLE:406,PROXY_AUTHENTICATION_REQUIRED:407,REQUEST_TIMEOUT:408,CONFLICT:409,GONE:410,LENGTH_REQUIRED:411,PRECONDITION_FAILED:412,REQUEST_ENTITY_TOO_LARGE:413,REQUEST_URI_TOO_LONG:414,UNSUPPORTED_MEDIA_TYPE:415,REQUEST_RANGE_NOT_SATISFIABLE:416,EXPECTATION_FAILED:417,PRECONDITION_REQUIRED:428,TOO_MANY_REQUESTS:429,REQUEST_HEADER_FIELDS_TOO_LARGE:431,INTERNAL_SERVER_ERROR:500,NOT_IMPLEMENTED:501,BAD_GATEWAY:502,SERVICE_UNAVAILABLE:503,GATEWAY_TIMEOUT:504,HTTP_VERSION_NOT_SUPPORTED:505,NETWORK_AUTHENTICATION_REQUIRED:511,QUIRK_IE_NO_CONTENT:1223};goog.net.HttpStatus.isSuccess=function(status){switch(status){case goog.net.HttpStatus.OK:case goog.net.HttpStatus.CREATED:case goog.net.HttpStatus.ACCEPTED:case goog.net.HttpStatus.NO_CONTENT:case goog.net.HttpStatus.PARTIAL_CONTENT:case goog.net.HttpStatus.NOT_MODIFIED:case goog.net.HttpStatus.QUIRK_IE_NO_CONTENT:return!0;default:return!1;}};goog.debug.LOGGING_ENABLED=goog.DEBUG;goog.debug.FORCE_SLOPPY_STACKS=!1;goog.debug.catchErrors=function(logFunc,opt_cancel,opt_target){var target=opt_target||goog.global,oldErrorHandler=target.onerror,retVal=!!opt_cancel;goog.userAgent.WEBKIT&&!goog.userAgent.isVersionOrHigher("535.3")&&(retVal=!retVal);target.onerror=function(message,url,line,opt_col,opt_error){oldErrorHandler&&oldErrorHandler(message,url,line,opt_col,opt_error);logFunc({message:message,fileName:url,line:line,col:opt_col,error:opt_error});return retVal;};};goog.debug.expose=function(obj,opt_showFn){if("undefined"==typeof obj){return"undefined";}if(null==obj){return"NULL";}var str=[],x;for(x in obj){if(opt_showFn||!goog.isFunction(obj[x])){var s=x+" = ";try{s+=obj[x];}catch(e){s+="*** "+e+" ***";}str.push(s);}}return str.join("\\n");};goog.debug.deepExpose=function(obj$jscomp$0,opt_showFn){var str=[],uidsToCleanup=[],ancestorUids={},helper=function helper(obj,space){var nestspace=space+"  ";try{if(goog.isDef(obj)){if(goog.isNull(obj)){str.push("NULL");}else{if(goog.isString(obj)){str.push(\'"\'+obj.replace(/\\n/g,"\\n"+space)+\'"\');}else{if(goog.isFunction(obj)){str.push(String(obj).replace(/\\n/g,"\\n"+space));}else{if(goog.isObject(obj)){goog.hasUid(obj)||uidsToCleanup.push(obj);var uid=goog.getUid(obj);if(ancestorUids[uid]){str.push("*** reference loop detected (id="+uid+") ***");}else{ancestorUids[uid]=!0;str.push("{");for(var x in obj){if(opt_showFn||!goog.isFunction(obj[x])){str.push("\\n"),str.push(nestspace),str.push(x+" = "),helper(obj[x],nestspace);}}str.push("\\n"+space+"}");delete ancestorUids[uid];}}else{str.push(obj);}}}}}else{str.push("undefined");}}catch(e){str.push("*** "+e+" ***");}};helper(obj$jscomp$0,"");for(var i=0;i<uidsToCleanup.length;i++){goog.removeUid(uidsToCleanup[i]);}return str.join("");};goog.debug.exposeArray=function(arr){for(var str=[],i=0;i<arr.length;i++){goog.isArray(arr[i])?str.push(goog.debug.exposeArray(arr[i])):str.push(arr[i]);}return"[ "+str.join(", ")+" ]";};goog.debug.normalizeErrorObject=function(err){var href=goog.getObjectByName("window.location.href");if(goog.isString(err)){return{message:err,name:"Unknown error",lineNumber:"Not available",fileName:href,stack:"Not available"};}var threwError=!1;try{var lineNumber=err.lineNumber||err.line||"Not available";}catch(e){lineNumber="Not available",threwError=!0;}try{var fileName=err.fileName||err.filename||err.sourceURL||goog.global.$googDebugFname||href;}catch(e$0){fileName="Not available",threwError=!0;}return!threwError&&err.lineNumber&&err.fileName&&err.stack&&err.message&&err.name?err:{message:err.message||"Not available",name:err.name||"UnknownError",lineNumber:lineNumber,fileName:fileName,stack:err.stack||"Not available"};};goog.debug.enhanceError=function(err,opt_message){if(err instanceof Error){var error=err;}else{error=Error(err),Error.captureStackTrace&&Error.captureStackTrace(error,goog.debug.enhanceError);}error.stack||(error.stack=goog.debug.getStacktrace(goog.debug.enhanceError));if(opt_message){for(var x=0;error["message"+x];){++x;}error["message"+x]=String(opt_message);}return error;};goog.debug.getStacktraceSimple=function(opt_depth){if(!goog.debug.FORCE_SLOPPY_STACKS){var stack=goog.debug.getNativeStackTrace_(goog.debug.getStacktraceSimple);if(stack){return stack;}}for(var sb=[],fn=arguments.callee.caller,depth=0;fn&&(!opt_depth||depth<opt_depth);){sb.push(goog.debug.getFunctionName(fn));sb.push("()\\n");try{fn=fn.caller;}catch(e){sb.push("[exception trying to get caller]\\n");break;}depth++;if(depth>=goog.debug.MAX_STACK_DEPTH){sb.push("[...long stack...]");break;}}opt_depth&&depth>=opt_depth?sb.push("[...reached max depth limit...]"):sb.push("[end]");return sb.join("");};goog.debug.MAX_STACK_DEPTH=50;goog.debug.getNativeStackTrace_=function(fn){var tempErr=Error();if(Error.captureStackTrace){return Error.captureStackTrace(tempErr,fn),String(tempErr.stack);}try{throw tempErr;}catch(e){tempErr=e;}var stack=tempErr.stack;return stack?String(stack):null;};goog.debug.getStacktrace=function(fn){var stack;goog.debug.FORCE_SLOPPY_STACKS||(stack=goog.debug.getNativeStackTrace_(fn||goog.debug.getStacktrace));stack||(stack=goog.debug.getStacktraceHelper_(fn||arguments.callee.caller,[]));return stack;};goog.debug.getStacktraceHelper_=function(fn,visited){var sb=[];if(goog.array.contains(visited,fn)){sb.push("[...circular reference...]");}else{if(fn&&visited.length<goog.debug.MAX_STACK_DEPTH){sb.push(goog.debug.getFunctionName(fn)+"(");for(var args=fn.arguments,i=0;args&&i<args.length;i++){0<i&&sb.push(", ");var arg=args[i];switch(typeof arg==="undefined"?"undefined":_typeof(arg)){case"object":var argDesc=arg?"object":"null";break;case"string":argDesc=arg;break;case"number":argDesc=String(arg);break;case"boolean":argDesc=arg?"true":"false";break;case"function":argDesc=(argDesc=goog.debug.getFunctionName(arg))?argDesc:"[fn]";break;default:argDesc=typeof arg==="undefined"?"undefined":_typeof(arg);}40<argDesc.length&&(argDesc=argDesc.substr(0,40)+"...");sb.push(argDesc);}visited.push(fn);sb.push(")\\n");try{sb.push(goog.debug.getStacktraceHelper_(fn.caller,visited));}catch(e){sb.push("[exception trying to get caller]\\n");}}else{fn?sb.push("[...long stack...]"):sb.push("[end]");}}return sb.join("");};goog.debug.setFunctionResolver=function(resolver){goog.debug.fnNameResolver_=resolver;};goog.debug.getFunctionName=function(fn){if(goog.debug.fnNameCache_[fn]){return goog.debug.fnNameCache_[fn];}if(goog.debug.fnNameResolver_){var name=goog.debug.fnNameResolver_(fn);if(name){return goog.debug.fnNameCache_[fn]=name;}}var functionSource=String(fn);if(!goog.debug.fnNameCache_[functionSource]){var matches=/function ([^\\(]+)/.exec(functionSource);goog.debug.fnNameCache_[functionSource]=matches?matches[1]:"[Anonymous]";}return goog.debug.fnNameCache_[functionSource];};goog.debug.makeWhitespaceVisible=function(string){return string.replace(/ /g,"[_]").replace(/\\f/g,"[f]").replace(/\\n/g,"[n]\\n").replace(/\\r/g,"[r]").replace(/\\t/g,"[t]");};goog.debug.runtimeType=function(value){return value instanceof Function?value.displayName||value.name||"unknown type name":value instanceof Object?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.debug.fnNameCache_={};goog.debug.LogRecord=function(level,msg,loggerName,opt_time,opt_sequenceNumber){this.reset(level,msg,loggerName,opt_time,opt_sequenceNumber);};goog.debug.LogRecord.prototype.sequenceNumber_=0;goog.debug.LogRecord.prototype.exception_=null;goog.debug.LogRecord.ENABLE_SEQUENCE_NUMBERS=!0;goog.debug.LogRecord.nextSequenceNumber_=0;goog.debug.LogRecord.prototype.reset=function(level,msg,loggerName,opt_time,opt_sequenceNumber){goog.debug.LogRecord.ENABLE_SEQUENCE_NUMBERS&&(this.sequenceNumber_="number"==typeof opt_sequenceNumber?opt_sequenceNumber:goog.debug.LogRecord.nextSequenceNumber_++);this.time_=opt_time||goog.now();this.level_=level;this.msg_=msg;this.loggerName_=loggerName;delete this.exception_;};goog.debug.LogRecord.prototype.getLoggerName=function(){return this.loggerName_;};goog.debug.LogRecord.prototype.getException=function(){return this.exception_;};goog.debug.LogRecord.prototype.setException=function(exception){this.exception_=exception;};goog.debug.LogRecord.prototype.setLoggerName=function(loggerName){this.loggerName_=loggerName;};goog.debug.LogRecord.prototype.getLevel=function(){return this.level_;};goog.debug.LogRecord.prototype.setLevel=function(level){this.level_=level;};goog.debug.LogRecord.prototype.getMessage=function(){return this.msg_;};goog.debug.LogRecord.prototype.setMessage=function(msg){this.msg_=msg;};goog.debug.LogRecord.prototype.getMillis=function(){return this.time_;};goog.debug.LogRecord.prototype.setMillis=function(time){this.time_=time;};goog.debug.LogRecord.prototype.getSequenceNumber=function(){return this.sequenceNumber_;};goog.debug.LogBuffer=function(){goog.asserts.assert(goog.debug.LogBuffer.isBufferingEnabled(),"Cannot use goog.debug.LogBuffer without defining goog.debug.LogBuffer.CAPACITY.");this.clear();};goog.debug.LogBuffer.getInstance=function(){goog.debug.LogBuffer.instance_||(goog.debug.LogBuffer.instance_=new goog.debug.LogBuffer());return goog.debug.LogBuffer.instance_;};goog.debug.LogBuffer.CAPACITY=0;goog.debug.LogBuffer.prototype.addRecord=function(level,msg,loggerName){var curIndex=(this.curIndex_+1)%goog.debug.LogBuffer.CAPACITY;this.curIndex_=curIndex;if(this.isFull_){var ret=this.buffer_[curIndex];ret.reset(level,msg,loggerName);return ret;}this.isFull_=curIndex==goog.debug.LogBuffer.CAPACITY-1;return this.buffer_[curIndex]=new goog.debug.LogRecord(level,msg,loggerName);};goog.debug.LogBuffer.isBufferingEnabled=function(){return 0<goog.debug.LogBuffer.CAPACITY;};goog.debug.LogBuffer.prototype.clear=function(){this.buffer_=Array(goog.debug.LogBuffer.CAPACITY);this.curIndex_=-1;this.isFull_=!1;};goog.debug.LogBuffer.prototype.forEachRecord=function(func){var buffer=this.buffer_;if(buffer[0]){var curIndex=this.curIndex_,i=this.isFull_?curIndex:-1;do{i=(i+1)%goog.debug.LogBuffer.CAPACITY,func(buffer[i]);}while(i!=curIndex);}};goog.debug.Logger=function(name){this.name_=name;this.handlers_=this.children_=this.level_=this.parent_=null;};goog.debug.Logger.ROOT_LOGGER_NAME="";goog.debug.Logger.ENABLE_HIERARCHY=!0;goog.debug.Logger.ENABLE_HIERARCHY||(goog.debug.Logger.rootHandlers_=[]);goog.debug.Logger.Level=function(name,value){this.name=name;this.value=value;};goog.debug.Logger.Level.prototype.toString=function(){return this.name;};goog.debug.Logger.Level.OFF=new goog.debug.Logger.Level("OFF",Infinity);goog.debug.Logger.Level.SHOUT=new goog.debug.Logger.Level("SHOUT",1200);goog.debug.Logger.Level.SEVERE=new goog.debug.Logger.Level("SEVERE",1000);goog.debug.Logger.Level.WARNING=new goog.debug.Logger.Level("WARNING",900);goog.debug.Logger.Level.INFO=new goog.debug.Logger.Level("INFO",800);goog.debug.Logger.Level.CONFIG=new goog.debug.Logger.Level("CONFIG",700);goog.debug.Logger.Level.FINE=new goog.debug.Logger.Level("FINE",500);goog.debug.Logger.Level.FINER=new goog.debug.Logger.Level("FINER",400);goog.debug.Logger.Level.FINEST=new goog.debug.Logger.Level("FINEST",300);goog.debug.Logger.Level.ALL=new goog.debug.Logger.Level("ALL",0);goog.debug.Logger.Level.PREDEFINED_LEVELS=[goog.debug.Logger.Level.OFF,goog.debug.Logger.Level.SHOUT,goog.debug.Logger.Level.SEVERE,goog.debug.Logger.Level.WARNING,goog.debug.Logger.Level.INFO,goog.debug.Logger.Level.CONFIG,goog.debug.Logger.Level.FINE,goog.debug.Logger.Level.FINER,goog.debug.Logger.Level.FINEST,goog.debug.Logger.Level.ALL];goog.debug.Logger.Level.predefinedLevelsCache_=null;goog.debug.Logger.Level.createPredefinedLevelsCache_=function(){goog.debug.Logger.Level.predefinedLevelsCache_={};for(var i=0,level;level=goog.debug.Logger.Level.PREDEFINED_LEVELS[i];i++){goog.debug.Logger.Level.predefinedLevelsCache_[level.value]=level,goog.debug.Logger.Level.predefinedLevelsCache_[level.name]=level;}};goog.debug.Logger.Level.getPredefinedLevel=function(name){goog.debug.Logger.Level.predefinedLevelsCache_||goog.debug.Logger.Level.createPredefinedLevelsCache_();return goog.debug.Logger.Level.predefinedLevelsCache_[name]||null;};goog.debug.Logger.Level.getPredefinedLevelByValue=function(value){goog.debug.Logger.Level.predefinedLevelsCache_||goog.debug.Logger.Level.createPredefinedLevelsCache_();if(value in goog.debug.Logger.Level.predefinedLevelsCache_){return goog.debug.Logger.Level.predefinedLevelsCache_[value];}for(var i=0;i<goog.debug.Logger.Level.PREDEFINED_LEVELS.length;++i){var level=goog.debug.Logger.Level.PREDEFINED_LEVELS[i];if(level.value<=value){return level;}}return null;};goog.debug.Logger.getLogger=function(name){return goog.debug.LogManager.getLogger(name);};goog.debug.Logger.logToProfilers=function(msg){goog.global.console&&(goog.global.console.timeStamp?goog.global.console.timeStamp(msg):goog.global.console.markTimeline&&goog.global.console.markTimeline(msg));goog.global.msWriteProfilerMark&&goog.global.msWriteProfilerMark(msg);};goog.debug.Logger.prototype.getName=function(){return this.name_;};goog.debug.Logger.prototype.addHandler=function(handler){goog.debug.LOGGING_ENABLED&&(goog.debug.Logger.ENABLE_HIERARCHY?(this.handlers_||(this.handlers_=[]),this.handlers_.push(handler)):(goog.asserts.assert(!this.name_,"Cannot call addHandler on a non-root logger when goog.debug.Logger.ENABLE_HIERARCHY is false."),goog.debug.Logger.rootHandlers_.push(handler)));};goog.debug.Logger.prototype.removeHandler=function(handler){if(goog.debug.LOGGING_ENABLED){var handlers=goog.debug.Logger.ENABLE_HIERARCHY?this.handlers_:goog.debug.Logger.rootHandlers_;return!!handlers&&goog.array.remove(handlers,handler);}return!1;};goog.debug.Logger.prototype.getParent=function(){return this.parent_;};goog.debug.Logger.prototype.getChildren=function(){this.children_||(this.children_={});return this.children_;};goog.debug.Logger.prototype.setLevel=function(level){goog.debug.LOGGING_ENABLED&&(goog.debug.Logger.ENABLE_HIERARCHY?this.level_=level:(goog.asserts.assert(!this.name_,"Cannot call setLevel() on a non-root logger when goog.debug.Logger.ENABLE_HIERARCHY is false."),goog.debug.Logger.rootLevel_=level));};goog.debug.Logger.prototype.getLevel=function(){return goog.debug.LOGGING_ENABLED?this.level_:goog.debug.Logger.Level.OFF;};goog.debug.Logger.prototype.getEffectiveLevel=function(){if(!goog.debug.LOGGING_ENABLED){return goog.debug.Logger.Level.OFF;}if(!goog.debug.Logger.ENABLE_HIERARCHY){return goog.debug.Logger.rootLevel_;}if(this.level_){return this.level_;}if(this.parent_){return this.parent_.getEffectiveLevel();}goog.asserts.fail("Root logger has no level set.");return null;};goog.debug.Logger.prototype.isLoggable=function(level){return goog.debug.LOGGING_ENABLED&&level.value>=this.getEffectiveLevel().value;};goog.debug.Logger.prototype.log=function(level,msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.isLoggable(level)&&(goog.isFunction(msg)&&(msg=msg()),this.doLogRecord_(this.getLogRecord(level,msg,opt_exception)));};goog.debug.Logger.prototype.getLogRecord=function(level,msg,opt_exception){var logRecord=goog.debug.LogBuffer.isBufferingEnabled()?goog.debug.LogBuffer.getInstance().addRecord(level,msg,this.name_):new goog.debug.LogRecord(level,String(msg),this.name_);opt_exception&&logRecord.setException(opt_exception);return logRecord;};goog.debug.Logger.prototype.shout=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.SHOUT,msg,opt_exception);};goog.debug.Logger.prototype.severe=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.SEVERE,msg,opt_exception);};goog.debug.Logger.prototype.warning=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.WARNING,msg,opt_exception);};goog.debug.Logger.prototype.info=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.INFO,msg,opt_exception);};goog.debug.Logger.prototype.config=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.CONFIG,msg,opt_exception);};goog.debug.Logger.prototype.fine=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINE,msg,opt_exception);};goog.debug.Logger.prototype.finer=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINER,msg,opt_exception);};goog.debug.Logger.prototype.finest=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINEST,msg,opt_exception);};goog.debug.Logger.prototype.logRecord=function(logRecord){goog.debug.LOGGING_ENABLED&&this.isLoggable(logRecord.getLevel())&&this.doLogRecord_(logRecord);};goog.debug.Logger.prototype.doLogRecord_=function(logRecord){goog.debug.Logger.logToProfilers("log:"+logRecord.getMessage());if(goog.debug.Logger.ENABLE_HIERARCHY){for(var target=this;target;){target.callPublish_(logRecord),target=target.getParent();}}else{for(var i=0,handler;handler=goog.debug.Logger.rootHandlers_[i++];){handler(logRecord);}}};goog.debug.Logger.prototype.callPublish_=function(logRecord){if(this.handlers_){for(var i=0,handler;handler=this.handlers_[i];i++){handler(logRecord);}}};goog.debug.Logger.prototype.setParent_=function(parent){this.parent_=parent;};goog.debug.Logger.prototype.addChild_=function(name,logger){this.getChildren()[name]=logger;};goog.debug.LogManager={};goog.debug.LogManager.loggers_={};goog.debug.LogManager.rootLogger_=null;goog.debug.LogManager.initialize=function(){goog.debug.LogManager.rootLogger_||(goog.debug.LogManager.rootLogger_=new goog.debug.Logger(goog.debug.Logger.ROOT_LOGGER_NAME),goog.debug.LogManager.loggers_[goog.debug.Logger.ROOT_LOGGER_NAME]=goog.debug.LogManager.rootLogger_,goog.debug.LogManager.rootLogger_.setLevel(goog.debug.Logger.Level.CONFIG));};goog.debug.LogManager.getLoggers=function(){return goog.debug.LogManager.loggers_;};goog.debug.LogManager.getRoot=function(){goog.debug.LogManager.initialize();return goog.debug.LogManager.rootLogger_;};goog.debug.LogManager.getLogger=function(name){goog.debug.LogManager.initialize();return goog.debug.LogManager.loggers_[name]||goog.debug.LogManager.createLogger_(name);};goog.debug.LogManager.createFunctionForCatchErrors=function(opt_logger){return function(info){(opt_logger||goog.debug.LogManager.getRoot()).severe("Error: "+info.message+" ("+info.fileName+" @ Line: "+info.line+")");};};goog.debug.LogManager.createLogger_=function(name){var logger=new goog.debug.Logger(name);if(goog.debug.Logger.ENABLE_HIERARCHY){var lastDotIndex=name.lastIndexOf("."),leafName=name.substr(lastDotIndex+1),parentLogger=goog.debug.LogManager.getLogger(name.substr(0,lastDotIndex));parentLogger.addChild_(leafName,logger);logger.setParent_(parentLogger);}return goog.debug.LogManager.loggers_[name]=logger;};goog.math={};goog.math.randomInt=function(a){return Math.floor(Math.random()*a);};goog.math.uniformRandom=function(a,b){return a+Math.random()*(b-a);};goog.math.clamp=function(value,min,max){return Math.min(Math.max(value,min),max);};goog.math.modulo=function(a,b){var r=a%b;return 0>r*b?r+b:r;};goog.math.lerp=function(a,b,x){return a+x*(b-a);};goog.math.nearlyEquals=function(a,b,opt_tolerance){return Math.abs(a-b)<=(opt_tolerance||0.000001);};goog.math.standardAngle=function(angle){return goog.math.modulo(angle,360);};goog.math.standardAngleInRadians=function(angle){return goog.math.modulo(angle,2*Math.PI);};goog.math.toRadians=function(angleDegrees){return angleDegrees*Math.PI/180;};goog.math.toDegrees=function(angleRadians){return 180*angleRadians/Math.PI;};goog.math.angleDx=function(degrees,radius){return radius*Math.cos(goog.math.toRadians(degrees));};goog.math.angleDy=function(degrees,radius){return radius*Math.sin(goog.math.toRadians(degrees));};goog.math.angle=function(x1,y1,x2,y2){return goog.math.standardAngle(goog.math.toDegrees(Math.atan2(y2-y1,x2-x1)));};goog.math.angleDifference=function(startAngle,endAngle){var d=goog.math.standardAngle(endAngle)-goog.math.standardAngle(startAngle);180<d?d-=360:-180>=d&&(d=360+d);return d;};goog.math.sign=function(x){return 0<x?1:0>x?-1:x;};goog.math.longestCommonSubsequence=function(array1,array2,opt_compareFn,opt_collectorFn){for(var compare=opt_compareFn||function(a,b){return a==b;},collect=opt_collectorFn||function(i1,i2){return array1[i1];},length1=array1.length,length2=array2.length,arr=[],i=0;i<length1+1;i++){arr[i]=[],arr[i][0]=0;}for(var j=0;j<length2+1;j++){arr[0][j]=0;}for(i=1;i<=length1;i++){for(j=1;j<=length2;j++){compare(array1[i-1],array2[j-1])?arr[i][j]=arr[i-1][j-1]+1:arr[i][j]=Math.max(arr[i-1][j],arr[i][j-1]);}}for(var result=[],i=length1,j=length2;0<i&&0<j;){compare(array1[i-1],array2[j-1])?(result.unshift(collect(i-1,j-1)),i--,j--):arr[i-1][j]>arr[i][j-1]?i--:j--;}return result;};goog.math.sum=function(var_args){return goog.array.reduce(arguments,function(sum,value){return sum+value;},0);};goog.math.average=function(var_args){return goog.math.sum.apply(null,arguments)/arguments.length;};goog.math.sampleVariance=function(var_args){var sampleSize=arguments.length;if(2>sampleSize){return 0;}var mean=goog.math.average.apply(null,arguments);return goog.math.sum.apply(null,goog.array.map(arguments,function(val){return Math.pow(val-mean,2);}))/(sampleSize-1);};goog.math.standardDeviation=function(var_args){return Math.sqrt(goog.math.sampleVariance.apply(null,arguments));};goog.math.isInt=function(num){return isFinite(num)&&0==num%1;};goog.math.isFiniteNumber=function(num){return isFinite(num);};goog.math.isNegativeZero=function(num){return 0==num&&0>1/num;};goog.math.log10Floor=function(num){if(0<num){var x=Math.round(Math.log(num)*Math.LOG10E);return x-(parseFloat("1e"+x)>num?1:0);}return 0==num?-Infinity:NaN;};goog.math.safeFloor=function(num,opt_epsilon){goog.asserts.assert(!goog.isDef(opt_epsilon)||0<opt_epsilon);return Math.floor(num+(opt_epsilon||2e-15));};goog.math.safeCeil=function(num,opt_epsilon){goog.asserts.assert(!goog.isDef(opt_epsilon)||0<opt_epsilon);return Math.ceil(num-(opt_epsilon||2e-15));};goog.iter={};goog.iter.StopIteration="StopIteration"in goog.global?goog.global.StopIteration:{message:"StopIteration",stack:""};goog.iter.Iterator=function(){};goog.iter.Iterator.prototype.next=function(){throw goog.iter.StopIteration;};goog.iter.Iterator.prototype.__iterator__=function(opt_keys){return this;};goog.iter.toIterator=function(iterable){if(iterable instanceof goog.iter.Iterator){return iterable;}if("function"==typeof iterable.__iterator__){return iterable.__iterator__(!1);}if(goog.isArrayLike(iterable)){var i=0,newIter=new goog.iter.Iterator();newIter.next=function(){for(;;){if(i>=iterable.length){throw goog.iter.StopIteration;}if(i in iterable){return iterable[i++];}i++;}};return newIter;}throw Error("Not implemented");};goog.iter.forEach=function(iterable,f,opt_obj){if(goog.isArrayLike(iterable)){try{goog.array.forEach(iterable,f,opt_obj);}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}}else{iterable=goog.iter.toIterator(iterable);try{for(;;){f.call(opt_obj,iterable.next(),void 0,iterable);}}catch(ex$1){if(ex$1!==goog.iter.StopIteration){throw ex$1;}}}};goog.iter.filter=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator();newIter.next=function(){for(;;){var val=iterator.next();if(f.call(opt_obj,val,void 0,iterator)){return val;}}};return newIter;};goog.iter.filterFalse=function(iterable,f,opt_obj){return goog.iter.filter(iterable,goog.functions.not(f),opt_obj);};goog.iter.range=function(startOrStop,opt_stop,opt_step){var start=0,stop=startOrStop,step=opt_step||1;1<arguments.length&&(start=startOrStop,stop=opt_stop);if(0==step){throw Error("Range step argument must not be zero");}var newIter=new goog.iter.Iterator();newIter.next=function(){if(0<step&&start>=stop||0>step&&start<=stop){throw goog.iter.StopIteration;}var rv=start;start+=step;return rv;};return newIter;};goog.iter.join=function(iterable,deliminator){return goog.iter.toArray(iterable).join(deliminator);};goog.iter.map=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator();newIter.next=function(){var val=iterator.next();return f.call(opt_obj,val,void 0,iterator);};return newIter;};goog.iter.reduce=function(iterable,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.iter.forEach(iterable,function(val){rval=f.call(opt_obj,rval,val);});return rval;};goog.iter.some=function(iterable,f,opt_obj){iterable=goog.iter.toIterator(iterable);try{for(;;){if(f.call(opt_obj,iterable.next(),void 0,iterable)){return!0;}}}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}return!1;};goog.iter.every=function(iterable,f,opt_obj){iterable=goog.iter.toIterator(iterable);try{for(;;){if(!f.call(opt_obj,iterable.next(),void 0,iterable)){return!1;}}}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}return!0;};goog.iter.chain=function(var_args){return goog.iter.chainFromIterable(arguments);};goog.iter.chainFromIterable=function(iterable){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator(),current=null;iter.next=function(){for(;;){if(null==current){var it=iterator.next();current=goog.iter.toIterator(it);}try{return current.next();}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}current=null;}}};return iter;};goog.iter.dropWhile=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator(),dropping=!0;newIter.next=function(){for(;;){var val=iterator.next();if(!dropping||!f.call(opt_obj,val,void 0,iterator)){return dropping=!1,val;}}};return newIter;};goog.iter.takeWhile=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator();iter.next=function(){var val=iterator.next();if(f.call(opt_obj,val,void 0,iterator)){return val;}throw goog.iter.StopIteration;};return iter;};goog.iter.toArray=function(iterable){if(goog.isArrayLike(iterable)){return goog.array.toArray(iterable);}iterable=goog.iter.toIterator(iterable);var array=[];goog.iter.forEach(iterable,function(val){array.push(val);});return array;};goog.iter.equals=function(iterable1,iterable2,opt_equalsFn){var pairs=goog.iter.zipLongest({},iterable1,iterable2),equalsFn=opt_equalsFn||goog.array.defaultCompareEquality;return goog.iter.every(pairs,function(pair){return equalsFn(pair[0],pair[1]);});};goog.iter.nextOrValue=function(iterable,defaultValue){try{return goog.iter.toIterator(iterable).next();}catch(e){if(e!=goog.iter.StopIteration){throw e;}return defaultValue;}};goog.iter.product=function(var_args){if(goog.array.some(arguments,function(arr){return!arr.length;})||!arguments.length){return new goog.iter.Iterator();}var iter=new goog.iter.Iterator(),arrays=arguments,indicies=goog.array.repeat(0,arrays.length);iter.next=function(){if(indicies){for(var retVal=goog.array.map(indicies,function(valueIndex,arrayIndex){return arrays[arrayIndex][valueIndex];}),i=indicies.length-1;0<=i;i--){goog.asserts.assert(indicies);if(indicies[i]<arrays[i].length-1){indicies[i]++;break;}if(0==i){indicies=null;break;}indicies[i]=0;}return retVal;}throw goog.iter.StopIteration;};return iter;};goog.iter.cycle=function(iterable){var baseIterator=goog.iter.toIterator(iterable),cache=[],cacheIndex=0,iter=new goog.iter.Iterator(),useCache=!1;iter.next=function(){var returnElement=null;if(!useCache){try{return returnElement=baseIterator.next(),cache.push(returnElement),returnElement;}catch(e){if(e!=goog.iter.StopIteration||goog.array.isEmpty(cache)){throw e;}useCache=!0;}}returnElement=cache[cacheIndex];cacheIndex=(cacheIndex+1)%cache.length;return returnElement;};return iter;};goog.iter.count=function(opt_start,opt_step){var counter=opt_start||0,step=goog.isDef(opt_step)?opt_step:1,iter=new goog.iter.Iterator();iter.next=function(){var returnValue=counter;counter+=step;return returnValue;};return iter;};goog.iter.repeat=function(value){var iter=new goog.iter.Iterator();iter.next=goog.functions.constant(value);return iter;};goog.iter.accumulate=function(iterable){var iterator=goog.iter.toIterator(iterable),total=0,iter=new goog.iter.Iterator();iter.next=function(){return total+=iterator.next();};return iter;};goog.iter.zip=function(var_args){var args=arguments,iter=new goog.iter.Iterator();if(0<args.length){var iterators=goog.array.map(args,goog.iter.toIterator);iter.next=function(){return goog.array.map(iterators,function(it){return it.next();});};}return iter;};goog.iter.zipLongest=function(fillValue,var_args){var args=goog.array.slice(arguments,1),iter=new goog.iter.Iterator();if(0<args.length){var iterators=goog.array.map(args,goog.iter.toIterator);iter.next=function(){var iteratorsHaveValues=!1,arr=goog.array.map(iterators,function(it){try{var returnValue=it.next();iteratorsHaveValues=!0;}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}returnValue=fillValue;}return returnValue;});if(!iteratorsHaveValues){throw goog.iter.StopIteration;}return arr;};}return iter;};goog.iter.compress=function(iterable,selectors){var selectorIterator=goog.iter.toIterator(selectors);return goog.iter.filter(iterable,function(){return!!selectorIterator.next();});};goog.iter.GroupByIterator_=function(iterable,opt_keyFunc){this.iterator=goog.iter.toIterator(iterable);this.keyFunc=opt_keyFunc||goog.functions.identity;};goog.inherits(goog.iter.GroupByIterator_,goog.iter.Iterator);goog.iter.GroupByIterator_.prototype.next=function(){for(;this.currentKey==this.targetKey;){this.currentValue=this.iterator.next(),this.currentKey=this.keyFunc(this.currentValue);}this.targetKey=this.currentKey;return[this.currentKey,this.groupItems_(this.targetKey)];};goog.iter.GroupByIterator_.prototype.groupItems_=function(targetKey){for(var arr=[];this.currentKey==targetKey;){arr.push(this.currentValue);try{this.currentValue=this.iterator.next();}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}break;}this.currentKey=this.keyFunc(this.currentValue);}return arr;};goog.iter.groupBy=function(iterable,opt_keyFunc){return new goog.iter.GroupByIterator_(iterable,opt_keyFunc);};goog.iter.starMap=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator();iter.next=function(){var args=goog.iter.toArray(iterator.next());return f.apply(opt_obj,goog.array.concat(args,void 0,iterator));};return iter;};goog.iter.tee=function(iterable,opt_num){var iterator=goog.iter.toIterator(iterable),num=goog.isNumber(opt_num)?opt_num:2,buffers=goog.array.map(goog.array.range(num),function(){return[];}),addNextIteratorValueToBuffers=function addNextIteratorValueToBuffers(){var val=iterator.next();goog.array.forEach(buffers,function(buffer){buffer.push(val);});};return goog.array.map(buffers,function(buffer){var iter=new goog.iter.Iterator();iter.next=function(){goog.array.isEmpty(buffer)&&addNextIteratorValueToBuffers();goog.asserts.assert(!goog.array.isEmpty(buffer));return buffer.shift();};return iter;});};goog.iter.enumerate=function(iterable,opt_start){return goog.iter.zip(goog.iter.count(opt_start),iterable);};goog.iter.limit=function(iterable,limitSize){goog.asserts.assert(goog.math.isInt(limitSize)&&0<=limitSize);var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator(),remaining=limitSize;iter.next=function(){if(0<remaining--){return iterator.next();}throw goog.iter.StopIteration;};return iter;};goog.iter.consume=function(iterable,count){goog.asserts.assert(goog.math.isInt(count)&&0<=count);for(var iterator=goog.iter.toIterator(iterable);0<count--;){goog.iter.nextOrValue(iterator,null);}return iterator;};goog.iter.slice=function(iterable,start,opt_end){goog.asserts.assert(goog.math.isInt(start)&&0<=start);var iterator=goog.iter.consume(iterable,start);goog.isNumber(opt_end)&&(goog.asserts.assert(goog.math.isInt(opt_end)&&opt_end>=start),iterator=goog.iter.limit(iterator,opt_end-start));return iterator;};goog.iter.hasDuplicates_=function(arr){var deduped=[];goog.array.removeDuplicates(arr,deduped);return arr.length!=deduped.length;};goog.iter.permutations=function(iterable,opt_length){var elements=goog.iter.toArray(iterable),length=goog.isNumber(opt_length)?opt_length:elements.length,sets=goog.array.repeat(elements,length),product=goog.iter.product.apply(void 0,sets);return goog.iter.filter(product,function(arr){return!goog.iter.hasDuplicates_(arr);});};goog.iter.combinations=function(iterable,length){function getIndexFromElements(index){return elements[index];}var elements=goog.iter.toArray(iterable),indexes=goog.iter.range(elements.length),indexIterator=goog.iter.permutations(indexes,length),sortedIndexIterator=goog.iter.filter(indexIterator,function(arr){return goog.array.isSorted(arr);}),iter=new goog.iter.Iterator();iter.next=function(){return goog.array.map(sortedIndexIterator.next(),getIndexFromElements);};return iter;};goog.iter.combinationsWithReplacement=function(iterable,length){function getIndexFromElements(index){return elements[index];}var elements=goog.iter.toArray(iterable),indexes=goog.array.range(elements.length),sets=goog.array.repeat(indexes,length),indexIterator=goog.iter.product.apply(void 0,sets),sortedIndexIterator=goog.iter.filter(indexIterator,function(arr){return goog.array.isSorted(arr);}),iter=new goog.iter.Iterator();iter.next=function(){return goog.array.map(sortedIndexIterator.next(),getIndexFromElements);};return iter;};goog.json={};goog.json.USE_NATIVE_JSON=!1;goog.json.TRY_NATIVE_JSON=!1;goog.json.isValid=function(s){return /^\\s*$/.test(s)?!1:/^[\\],:{}\\s\\u2028\\u2029]*$/.test(s.replace(/\\\\["\\\\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\\\\n\\r\\u2028\\u2029\\x00-\\x08\\x0a-\\x1f]*"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?)[\\s\\u2028\\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\\s\\u2028\\u2029]*\\[)+/g,""));};goog.json.errorLogger_=goog.nullFunction;goog.json.setErrorLogger=function(errorLogger){goog.json.errorLogger_=errorLogger;};goog.json.parse=goog.json.USE_NATIVE_JSON?goog.global.JSON.parse:function(s){if(goog.json.TRY_NATIVE_JSON){try{return goog.global.JSON.parse(s);}catch(ex){var error=ex;}}var o=String(s);if(goog.json.isValid(o)){try{var result=eval("("+o+")");error&&goog.json.errorLogger_("Invalid JSON: "+o,error);return result;}catch(ex$2){}}throw Error("Invalid JSON string: "+o);};goog.json.unsafeParse=goog.json.USE_NATIVE_JSON?goog.global.JSON.parse:function(s){if(goog.json.TRY_NATIVE_JSON){try{return goog.global.JSON.parse(s);}catch(ex){var error=ex;}}var result=eval("("+s+")");error&&goog.json.errorLogger_("Invalid JSON: "+s,error);return result;};goog.json.serialize=goog.json.USE_NATIVE_JSON?goog.global.JSON.stringify:function(object,opt_replacer){return new goog.json.Serializer(opt_replacer).serialize(object);};goog.json.Serializer=function(opt_replacer){this.replacer_=opt_replacer;};goog.json.Serializer.prototype.serialize=function(object){var sb=[];this.serializeInternal(object,sb);return sb.join("");};goog.json.Serializer.prototype.serializeInternal=function(object,sb){if(null==object){sb.push("null");}else{if("object"==(typeof object==="undefined"?"undefined":_typeof(object))){if(goog.isArray(object)){this.serializeArray(object,sb);return;}if(object instanceof String||object instanceof Number||object instanceof Boolean){object=object.valueOf();}else{this.serializeObject_(object,sb);return;}}switch(typeof object==="undefined"?"undefined":_typeof(object)){case"string":this.serializeString_(object,sb);break;case"number":this.serializeNumber_(object,sb);break;case"boolean":sb.push(String(object));break;case"function":sb.push("null");break;default:throw Error("Unknown type: "+(typeof object==="undefined"?"undefined":_typeof(object)));}}};goog.json.Serializer.charToJsonCharCache_={\'"\':\'\\\\"\',"\\\\":"\\\\\\\\","/":"\\\\/","\\b":"\\\\b","\\f":"\\\\f","\\n":"\\\\n","\\r":"\\\\r","\\t":"\\\\t","\\x0B":"\\\\u000b"};goog.json.Serializer.charsToReplace_=/\\uffff/.test("\\uFFFF")?/[\\\\\\"\\x00-\\x1f\\x7f-\\uffff]/g:/[\\\\\\"\\x00-\\x1f\\x7f-\\xff]/g;goog.json.Serializer.prototype.serializeString_=function(s,sb){sb.push(\'"\',s.replace(goog.json.Serializer.charsToReplace_,function(c){var rv=goog.json.Serializer.charToJsonCharCache_[c];rv||(rv="\\\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),goog.json.Serializer.charToJsonCharCache_[c]=rv);return rv;}),\'"\');};goog.json.Serializer.prototype.serializeNumber_=function(n,sb){sb.push(isFinite(n)&&!isNaN(n)?String(n):"null");};goog.json.Serializer.prototype.serializeArray=function(arr,sb){var l=arr.length;sb.push("[");for(var sep="",i=0;i<l;i++){sb.push(sep);var value=arr[i];this.serializeInternal(this.replacer_?this.replacer_.call(arr,String(i),value):value,sb);sep=",";}sb.push("]");};goog.json.Serializer.prototype.serializeObject_=function(obj,sb){sb.push("{");var sep="",key;for(key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){var value=obj[key];"function"!=typeof value&&(sb.push(sep),this.serializeString_(key,sb),sb.push(":"),this.serializeInternal(this.replacer_?this.replacer_.call(obj,key,value):value,sb),sep=",");}}sb.push("}");};goog.log={};goog.log.ENABLED=goog.debug.LOGGING_ENABLED;goog.log.ROOT_LOGGER_NAME=goog.debug.Logger.ROOT_LOGGER_NAME;goog.log.Logger=goog.debug.Logger;goog.log.Level=goog.debug.Logger.Level;goog.log.LogRecord=goog.debug.LogRecord;goog.log.getLogger=function(name,opt_level){if(goog.log.ENABLED){var logger=goog.debug.LogManager.getLogger(name);opt_level&&logger&&logger.setLevel(opt_level);return logger;}return null;};goog.log.addHandler=function(logger,handler){goog.log.ENABLED&&logger&&logger.addHandler(handler);};goog.log.removeHandler=function(logger,handler){return goog.log.ENABLED&&logger?logger.removeHandler(handler):!1;};goog.log.log=function(logger,level,msg,opt_exception){goog.log.ENABLED&&logger&&logger.log(level,msg,opt_exception);};goog.log.error=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.severe(msg,opt_exception);};goog.log.warning=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.warning(msg,opt_exception);};goog.log.info=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.info(msg,opt_exception);};goog.log.fine=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.fine(msg,opt_exception);};goog.net.ErrorCode={NO_ERROR:0,ACCESS_DENIED:1,FILE_NOT_FOUND:2,FF_SILENT_ERROR:3,CUSTOM_ERROR:4,EXCEPTION:5,HTTP_ERROR:6,ABORT:7,TIMEOUT:8,OFFLINE:9};goog.net.ErrorCode.getDebugMessage=function(errorCode){switch(errorCode){case goog.net.ErrorCode.NO_ERROR:return"No Error";case goog.net.ErrorCode.ACCESS_DENIED:return"Access denied to content document";case goog.net.ErrorCode.FILE_NOT_FOUND:return"File not found";case goog.net.ErrorCode.FF_SILENT_ERROR:return"Firefox silently errored";case goog.net.ErrorCode.CUSTOM_ERROR:return"Application custom error";case goog.net.ErrorCode.EXCEPTION:return"An exception occurred";case goog.net.ErrorCode.HTTP_ERROR:return"Http response at 400 or 500 level";case goog.net.ErrorCode.ABORT:return"Request was aborted";case goog.net.ErrorCode.TIMEOUT:return"Request timed out";case goog.net.ErrorCode.OFFLINE:return"The resource is not available offline";default:return"Unrecognized error code";}};goog.net.XhrLike=function(){};goog.net.XhrLike.prototype.open=function(method,url,opt_async,opt_user,opt_password){};goog.net.XhrLike.prototype.send=function(opt_data){};goog.net.XhrLike.prototype.abort=function(){};goog.net.XhrLike.prototype.setRequestHeader=function(header,value){};goog.net.XhrLike.prototype.getResponseHeader=function(header){};goog.net.XhrLike.prototype.getAllResponseHeaders=function(){};goog.net.XmlHttpFactory=function(){};goog.net.XmlHttpFactory.prototype.cachedOptions_=null;goog.net.XmlHttpFactory.prototype.getOptions=function(){return this.cachedOptions_||(this.cachedOptions_=this.internalGetOptions());};goog.net.WrapperXmlHttpFactory=function(xhrFactory,optionsFactory){this.xhrFactory_=xhrFactory;this.optionsFactory_=optionsFactory;};goog.inherits(goog.net.WrapperXmlHttpFactory,goog.net.XmlHttpFactory);goog.net.WrapperXmlHttpFactory.prototype.createInstance=function(){return this.xhrFactory_();};goog.net.WrapperXmlHttpFactory.prototype.getOptions=function(){return this.optionsFactory_();};goog.net.XmlHttp=function(){return goog.net.XmlHttp.factory_.createInstance();};goog.net.XmlHttp.ASSUME_NATIVE_XHR=!1;goog.net.XmlHttpDefines={};goog.net.XmlHttpDefines.ASSUME_NATIVE_XHR=!1;goog.net.XmlHttp.getOptions=function(){return goog.net.XmlHttp.factory_.getOptions();};goog.net.XmlHttp.OptionType={USE_NULL_FUNCTION:0,LOCAL_REQUEST_ERROR:1};goog.net.XmlHttp.ReadyState={UNINITIALIZED:0,LOADING:1,LOADED:2,INTERACTIVE:3,COMPLETE:4};goog.net.XmlHttp.setFactory=function(factory,optionsFactory){goog.net.XmlHttp.setGlobalFactory(new goog.net.WrapperXmlHttpFactory(goog.asserts.assert(factory),goog.asserts.assert(optionsFactory)));};goog.net.XmlHttp.setGlobalFactory=function(factory){goog.net.XmlHttp.factory_=factory;};goog.net.DefaultXmlHttpFactory=function(){};goog.inherits(goog.net.DefaultXmlHttpFactory,goog.net.XmlHttpFactory);goog.net.DefaultXmlHttpFactory.prototype.createInstance=function(){var progId=this.getProgId_();return progId?new ActiveXObject(progId):new XMLHttpRequest();};goog.net.DefaultXmlHttpFactory.prototype.internalGetOptions=function(){var options={};this.getProgId_()&&(options[goog.net.XmlHttp.OptionType.USE_NULL_FUNCTION]=!0,options[goog.net.XmlHttp.OptionType.LOCAL_REQUEST_ERROR]=!0);return options;};goog.net.DefaultXmlHttpFactory.prototype.getProgId_=function(){if(goog.net.XmlHttp.ASSUME_NATIVE_XHR||goog.net.XmlHttpDefines.ASSUME_NATIVE_XHR){return"";}if(!this.ieProgId_&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var ACTIVE_X_IDENTS=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],i=0;i<ACTIVE_X_IDENTS.length;i++){var candidate=ACTIVE_X_IDENTS[i];try{return new ActiveXObject(candidate),this.ieProgId_=candidate;}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return this.ieProgId_;};goog.net.XmlHttp.setGlobalFactory(new goog.net.DefaultXmlHttpFactory());goog.structs={};goog.structs.Map=function(opt_map,var_args){this.map_={};this.keys_=[];this.version_=this.count_=0;var argLength=arguments.length;if(1<argLength){if(argLength%2){throw Error("Uneven number of arguments");}for(var i=0;i<argLength;i+=2){this.set(arguments[i],arguments[i+1]);}}else{opt_map&&this.addAll(opt_map);}};goog.structs.Map.prototype.getCount=function(){return this.count_;};goog.structs.Map.prototype.getValues=function(){this.cleanupKeysArray_();for(var rv=[],i=0;i<this.keys_.length;i++){rv.push(this.map_[this.keys_[i]]);}return rv;};goog.structs.Map.prototype.getKeys=function(){this.cleanupKeysArray_();return this.keys_.concat();};goog.structs.Map.prototype.containsKey=function(key){return goog.structs.Map.hasKey_(this.map_,key);};goog.structs.Map.prototype.containsValue=function(val){for(var i=0;i<this.keys_.length;i++){var key=this.keys_[i];if(goog.structs.Map.hasKey_(this.map_,key)&&this.map_[key]==val){return!0;}}return!1;};goog.structs.Map.prototype.equals=function(otherMap,opt_equalityFn){if(this===otherMap){return!0;}if(this.count_!=otherMap.getCount()){return!1;}var equalityFn=opt_equalityFn||goog.structs.Map.defaultEquals;this.cleanupKeysArray_();for(var key,i=0;key=this.keys_[i];i++){if(!equalityFn(this.get(key),otherMap.get(key))){return!1;}}return!0;};goog.structs.Map.defaultEquals=function(a,b){return a===b;};goog.structs.Map.prototype.isEmpty=function(){return 0==this.count_;};goog.structs.Map.prototype.clear=function(){this.map_={};this.version_=this.count_=this.keys_.length=0;};goog.structs.Map.prototype.remove=function(key){return goog.structs.Map.hasKey_(this.map_,key)?(delete this.map_[key],this.count_--,this.version_++,this.keys_.length>2*this.count_&&this.cleanupKeysArray_(),!0):!1;};goog.structs.Map.prototype.cleanupKeysArray_=function(){var destIndex,srcIndex;if(this.count_!=this.keys_.length){for(destIndex=srcIndex=0;srcIndex<this.keys_.length;){var key=this.keys_[srcIndex];goog.structs.Map.hasKey_(this.map_,key)&&(this.keys_[destIndex++]=key);srcIndex++;}this.keys_.length=destIndex;}if(this.count_!=this.keys_.length){var seen={};for(destIndex=srcIndex=0;srcIndex<this.keys_.length;){key=this.keys_[srcIndex],goog.structs.Map.hasKey_(seen,key)||(this.keys_[destIndex++]=key,seen[key]=1),srcIndex++;}this.keys_.length=destIndex;}};goog.structs.Map.prototype.get=function(key,opt_val){return goog.structs.Map.hasKey_(this.map_,key)?this.map_[key]:opt_val;};goog.structs.Map.prototype.set=function(key,value){goog.structs.Map.hasKey_(this.map_,key)||(this.count_++,this.keys_.push(key),this.version_++);this.map_[key]=value;};goog.structs.Map.prototype.addAll=function(map){if(map instanceof goog.structs.Map){var keys=map.getKeys();var values=map.getValues();}else{keys=goog.object.getKeys(map),values=goog.object.getValues(map);}for(var i=0;i<keys.length;i++){this.set(keys[i],values[i]);}};goog.structs.Map.prototype.forEach=function(f,opt_obj){for(var keys=this.getKeys(),i=0;i<keys.length;i++){var key=keys[i],value=this.get(key);f.call(opt_obj,value,key,this);}};goog.structs.Map.prototype.clone=function(){return new goog.structs.Map(this);};goog.structs.Map.prototype.transpose=function(){for(var transposed=new goog.structs.Map(),i=0;i<this.keys_.length;i++){var key=this.keys_[i];transposed.set(this.map_[key],key);}return transposed;};goog.structs.Map.prototype.toObject=function(){this.cleanupKeysArray_();for(var obj={},i=0;i<this.keys_.length;i++){var key=this.keys_[i];obj[key]=this.map_[key];}return obj;};goog.structs.Map.prototype.getKeyIterator=function(){return this.__iterator__(!0);};goog.structs.Map.prototype.getValueIterator=function(){return this.__iterator__(!1);};goog.structs.Map.prototype.__iterator__=function(opt_keys){this.cleanupKeysArray_();var i=0,version=this.version_,selfObj=this,newIter=new goog.iter.Iterator();newIter.next=function(){if(version!=selfObj.version_){throw Error("The map has changed since the iterator was created");}if(i>=selfObj.keys_.length){throw goog.iter.StopIteration;}var key=selfObj.keys_[i++];return opt_keys?key:selfObj.map_[key];};return newIter;};goog.structs.Map.hasKey_=function(obj,key){return Object.prototype.hasOwnProperty.call(obj,key);};goog.structs.getCount=function(col){return col.getCount&&"function"==typeof col.getCount?col.getCount():goog.isArrayLike(col)||goog.isString(col)?col.length:goog.object.getCount(col);};goog.structs.getValues=function(col){if(col.getValues&&"function"==typeof col.getValues){return col.getValues();}if(goog.isString(col)){return col.split("");}if(goog.isArrayLike(col)){for(var rv=[],l=col.length,i=0;i<l;i++){rv.push(col[i]);}return rv;}return goog.object.getValues(col);};goog.structs.getKeys=function(col){if(col.getKeys&&"function"==typeof col.getKeys){return col.getKeys();}if(!col.getValues||"function"!=typeof col.getValues){if(goog.isArrayLike(col)||goog.isString(col)){for(var rv=[],l=col.length,i=0;i<l;i++){rv.push(i);}return rv;}return goog.object.getKeys(col);}};goog.structs.contains=function(col,val){return col.contains&&"function"==typeof col.contains?col.contains(val):col.containsValue&&"function"==typeof col.containsValue?col.containsValue(val):goog.isArrayLike(col)||goog.isString(col)?goog.array.contains(col,val):goog.object.containsValue(col,val);};goog.structs.isEmpty=function(col){return col.isEmpty&&"function"==typeof col.isEmpty?col.isEmpty():goog.isArrayLike(col)||goog.isString(col)?goog.array.isEmpty(col):goog.object.isEmpty(col);};goog.structs.clear=function(col){col.clear&&"function"==typeof col.clear?col.clear():goog.isArrayLike(col)?goog.array.clear(col):goog.object.clear(col);};goog.structs.forEach=function(col,f,opt_obj){if(col.forEach&&"function"==typeof col.forEach){col.forEach(f,opt_obj);}else{if(goog.isArrayLike(col)||goog.isString(col)){goog.array.forEach(col,f,opt_obj);}else{for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){f.call(opt_obj,values[i],keys&&keys[i],col);}}}};goog.structs.filter=function(col,f,opt_obj){if("function"==typeof col.filter){return col.filter(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.filter(col,f,opt_obj);}var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length;if(keys){var rv={};for(var i=0;i<l;i++){f.call(opt_obj,values[i],keys[i],col)&&(rv[keys[i]]=values[i]);}}else{for(rv=[],i=0;i<l;i++){f.call(opt_obj,values[i],void 0,col)&&rv.push(values[i]);}}return rv;};goog.structs.map=function(col,f,opt_obj){if("function"==typeof col.map){return col.map(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.map(col,f,opt_obj);}var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length;if(keys){var rv={};for(var i=0;i<l;i++){rv[keys[i]]=f.call(opt_obj,values[i],keys[i],col);}}else{for(rv=[],i=0;i<l;i++){rv[i]=f.call(opt_obj,values[i],void 0,col);}}return rv;};goog.structs.some=function(col,f,opt_obj){if("function"==typeof col.some){return col.some(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.some(col,f,opt_obj);}for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){if(f.call(opt_obj,values[i],keys&&keys[i],col)){return!0;}}return!1;};goog.structs.every=function(col,f,opt_obj){if("function"==typeof col.every){return col.every(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.every(col,f,opt_obj);}for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){if(!f.call(opt_obj,values[i],keys&&keys[i],col)){return!1;}}return!0;};goog.Timer=function(opt_interval,opt_timerObject){goog.events.EventTarget.call(this);this.interval_=opt_interval||1;this.timerObject_=opt_timerObject||goog.Timer.defaultTimerObject;this.boundTick_=goog.bind(this.tick_,this);this.last_=goog.now();};goog.inherits(goog.Timer,goog.events.EventTarget);goog.Timer.MAX_TIMEOUT_=2147483647;goog.Timer.INVALID_TIMEOUT_ID_=-1;goog.Timer.prototype.enabled=!1;goog.Timer.defaultTimerObject=goog.global;goog.Timer.intervalScale=0.8;goog.Timer.prototype.timer_=null;goog.Timer.prototype.getInterval=function(){return this.interval_;};goog.Timer.prototype.setInterval=function(interval){this.interval_=interval;this.timer_&&this.enabled?(this.stop(),this.start()):this.timer_&&this.stop();};goog.Timer.prototype.tick_=function(){if(this.enabled){var elapsed=goog.now()-this.last_;0<elapsed&&elapsed<this.interval_*goog.Timer.intervalScale?this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_-elapsed):(this.timer_&&(this.timerObject_.clearTimeout(this.timer_),this.timer_=null),this.dispatchTick(),this.enabled&&(this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_),this.last_=goog.now()));}};goog.Timer.prototype.dispatchTick=function(){this.dispatchEvent(goog.Timer.TICK);};goog.Timer.prototype.start=function(){this.enabled=!0;this.timer_||(this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_),this.last_=goog.now());};goog.Timer.prototype.stop=function(){this.enabled=!1;this.timer_&&(this.timerObject_.clearTimeout(this.timer_),this.timer_=null);};goog.Timer.prototype.disposeInternal=function(){goog.Timer.superClass_.disposeInternal.call(this);this.stop();delete this.timerObject_;};goog.Timer.TICK="tick";goog.Timer.callOnce=function(listener,opt_delay,opt_handler){if(goog.isFunction(listener)){opt_handler&&(listener=goog.bind(listener,opt_handler));}else{if(listener&&"function"==typeof listener.handleEvent){listener=goog.bind(listener.handleEvent,listener);}else{throw Error("Invalid listener argument");}}return Number(opt_delay)>goog.Timer.MAX_TIMEOUT_?goog.Timer.INVALID_TIMEOUT_ID_:goog.Timer.defaultTimerObject.setTimeout(listener,opt_delay||0);};goog.Timer.clear=function(timerId){goog.Timer.defaultTimerObject.clearTimeout(timerId);};goog.Timer.promise=function(delay,opt_result){var timerKey=null;return new goog.Promise(function(resolve,reject){timerKey=goog.Timer.callOnce(function(){resolve(opt_result);},delay);timerKey==goog.Timer.INVALID_TIMEOUT_ID_&&reject(Error("Failed to schedule timer."));}).thenCatch(function(error){goog.Timer.clear(timerKey);throw error;});};goog.uri={};goog.uri.utils={};goog.uri.utils.CharCode_={AMPERSAND:38,EQUAL:61,HASH:35,QUESTION:63};goog.uri.utils.buildFromEncodedParts=function(opt_scheme,opt_userInfo,opt_domain,opt_port,opt_path,opt_queryData,opt_fragment){var out="";opt_scheme&&(out+=opt_scheme+":");opt_domain&&(out+="//",opt_userInfo&&(out+=opt_userInfo+"@"),out+=opt_domain,opt_port&&(out+=":"+opt_port));opt_path&&(out+=opt_path);opt_queryData&&(out+="?"+opt_queryData);opt_fragment&&(out+="#"+opt_fragment);return out;};goog.uri.utils.splitRe_=/^(?:([^:/?#.]+):)?(?:\\/\\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$/;goog.uri.utils.ComponentIndex={SCHEME:1,USER_INFO:2,DOMAIN:3,PORT:4,PATH:5,QUERY_DATA:6,FRAGMENT:7};goog.uri.utils.split=function(uri){return uri.match(goog.uri.utils.splitRe_);};goog.uri.utils.decodeIfPossible_=function(uri,opt_preserveReserved){return uri?opt_preserveReserved?decodeURI(uri):decodeURIComponent(uri):uri;};goog.uri.utils.getComponentByIndex_=function(componentIndex,uri){return goog.uri.utils.split(uri)[componentIndex]||null;};goog.uri.utils.getScheme=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.SCHEME,uri);};goog.uri.utils.getEffectiveScheme=function(uri){var scheme=goog.uri.utils.getScheme(uri);if(!scheme&&goog.global.self&&goog.global.self.location){var protocol=goog.global.self.location.protocol,scheme=protocol.substr(0,protocol.length-1);}return scheme?scheme.toLowerCase():"";};goog.uri.utils.getUserInfoEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.USER_INFO,uri);};goog.uri.utils.getUserInfo=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getUserInfoEncoded(uri));};goog.uri.utils.getDomainEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.DOMAIN,uri);};goog.uri.utils.getDomain=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getDomainEncoded(uri),!0);};goog.uri.utils.getPort=function(uri){return Number(goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.PORT,uri))||null;};goog.uri.utils.getPathEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.PATH,uri);};goog.uri.utils.getPath=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getPathEncoded(uri),!0);};goog.uri.utils.getQueryData=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.QUERY_DATA,uri);};goog.uri.utils.getFragmentEncoded=function(uri){var hashIndex=uri.indexOf("#");return 0>hashIndex?null:uri.substr(hashIndex+1);};goog.uri.utils.setFragmentEncoded=function(uri,fragment){return goog.uri.utils.removeFragment(uri)+(fragment?"#"+fragment:"");};goog.uri.utils.getFragment=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getFragmentEncoded(uri));};goog.uri.utils.getHost=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(pieces[goog.uri.utils.ComponentIndex.SCHEME],pieces[goog.uri.utils.ComponentIndex.USER_INFO],pieces[goog.uri.utils.ComponentIndex.DOMAIN],pieces[goog.uri.utils.ComponentIndex.PORT]);};goog.uri.utils.getOrigin=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(pieces[goog.uri.utils.ComponentIndex.SCHEME],null,pieces[goog.uri.utils.ComponentIndex.DOMAIN],pieces[goog.uri.utils.ComponentIndex.PORT]);};goog.uri.utils.getPathAndAfter=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(null,null,null,null,pieces[goog.uri.utils.ComponentIndex.PATH],pieces[goog.uri.utils.ComponentIndex.QUERY_DATA],pieces[goog.uri.utils.ComponentIndex.FRAGMENT]);};goog.uri.utils.removeFragment=function(uri){var hashIndex=uri.indexOf("#");return 0>hashIndex?uri:uri.substr(0,hashIndex);};goog.uri.utils.haveSameDomain=function(uri1,uri2){var pieces1=goog.uri.utils.split(uri1),pieces2=goog.uri.utils.split(uri2);return pieces1[goog.uri.utils.ComponentIndex.DOMAIN]==pieces2[goog.uri.utils.ComponentIndex.DOMAIN]&&pieces1[goog.uri.utils.ComponentIndex.SCHEME]==pieces2[goog.uri.utils.ComponentIndex.SCHEME]&&pieces1[goog.uri.utils.ComponentIndex.PORT]==pieces2[goog.uri.utils.ComponentIndex.PORT];};goog.uri.utils.assertNoFragmentsOrQueries_=function(uri){goog.asserts.assert(0>uri.indexOf("#")&&0>uri.indexOf("?"),"goog.uri.utils: Fragment or query identifiers are not supported: [%s]",uri);};goog.uri.utils.parseQueryData=function(encodedQuery,callback){if(encodedQuery){for(var pairs=encodedQuery.split("&"),i=0;i<pairs.length;i++){var indexOfEquals=pairs[i].indexOf("="),name=null,value=null;0<=indexOfEquals?(name=pairs[i].substring(0,indexOfEquals),value=pairs[i].substring(indexOfEquals+1)):name=pairs[i];callback(name,value?goog.string.urlDecode(value):"");}}};goog.uri.utils.appendQueryData_=function(buffer){if(buffer[1]){var baseUri=buffer[0],hashIndex=baseUri.indexOf("#");0<=hashIndex&&(buffer.push(baseUri.substr(hashIndex)),buffer[0]=baseUri=baseUri.substr(0,hashIndex));var questionIndex=baseUri.indexOf("?");0>questionIndex?buffer[1]="?":questionIndex==baseUri.length-1&&(buffer[1]=void 0);}return buffer.join("");};goog.uri.utils.appendKeyValuePairs_=function(key,value,pairs){goog.asserts.assertString(key);if(goog.isArray(value)){goog.asserts.assertArray(value);for(var j=0;j<value.length;j++){goog.uri.utils.appendKeyValuePairs_(key,String(value[j]),pairs);}}else{null!=value&&pairs.push("&",key,""===value?"":"=",goog.string.urlEncode(value));}};goog.uri.utils.buildQueryDataBuffer_=function(buffer,keysAndValues,opt_startIndex){goog.asserts.assert(0==Math.max(keysAndValues.length-(opt_startIndex||0),0)%2,"goog.uri.utils: Key/value lists must be even in length.");for(var i=opt_startIndex||0;i<keysAndValues.length;i+=2){goog.uri.utils.appendKeyValuePairs_(keysAndValues[i],keysAndValues[i+1],buffer);}return buffer;};goog.uri.utils.buildQueryData=function(keysAndValues,opt_startIndex){var buffer=goog.uri.utils.buildQueryDataBuffer_([],keysAndValues,opt_startIndex);buffer[0]="";return buffer.join("");};goog.uri.utils.buildQueryDataBufferFromMap_=function(buffer,map){for(var key in map){goog.uri.utils.appendKeyValuePairs_(key,map[key],buffer);}return buffer;};goog.uri.utils.buildQueryDataFromMap=function(map){var buffer=goog.uri.utils.buildQueryDataBufferFromMap_([],map);buffer[0]="";return buffer.join("");};goog.uri.utils.appendParams=function(uri,var_args){return goog.uri.utils.appendQueryData_(2==arguments.length?goog.uri.utils.buildQueryDataBuffer_([uri],arguments[1],0):goog.uri.utils.buildQueryDataBuffer_([uri],arguments,1));};goog.uri.utils.appendParamsFromMap=function(uri,map){return goog.uri.utils.appendQueryData_(goog.uri.utils.buildQueryDataBufferFromMap_([uri],map));};goog.uri.utils.appendParam=function(uri,key,opt_value){var paramArr=[uri,"&",key];goog.isDefAndNotNull(opt_value)&&paramArr.push("=",goog.string.urlEncode(opt_value));return goog.uri.utils.appendQueryData_(paramArr);};goog.uri.utils.findParam_=function(uri,startIndex,keyEncoded,hashOrEndIndex){for(var index=startIndex,keyLength=keyEncoded.length;0<=(index=uri.indexOf(keyEncoded,index))&&index<hashOrEndIndex;){var precedingChar=uri.charCodeAt(index-1);if(precedingChar==goog.uri.utils.CharCode_.AMPERSAND||precedingChar==goog.uri.utils.CharCode_.QUESTION){var followingChar=uri.charCodeAt(index+keyLength);if(!followingChar||followingChar==goog.uri.utils.CharCode_.EQUAL||followingChar==goog.uri.utils.CharCode_.AMPERSAND||followingChar==goog.uri.utils.CharCode_.HASH){return index;}}index+=keyLength+1;}return-1;};goog.uri.utils.hashOrEndRe_=/#|$/;goog.uri.utils.hasParam=function(uri,keyEncoded){return 0<=goog.uri.utils.findParam_(uri,0,keyEncoded,uri.search(goog.uri.utils.hashOrEndRe_));};goog.uri.utils.getParamValue=function(uri,keyEncoded){var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),foundIndex=goog.uri.utils.findParam_(uri,0,keyEncoded,hashOrEndIndex);if(0>foundIndex){return null;}var endPosition=uri.indexOf("&",foundIndex);if(0>endPosition||endPosition>hashOrEndIndex){endPosition=hashOrEndIndex;}foundIndex+=keyEncoded.length+1;return goog.string.urlDecode(uri.substr(foundIndex,endPosition-foundIndex));};goog.uri.utils.getParamValues=function(uri,keyEncoded){for(var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),position=0,foundIndex,result=[];0<=(foundIndex=goog.uri.utils.findParam_(uri,position,keyEncoded,hashOrEndIndex));){position=uri.indexOf("&",foundIndex);if(0>position||position>hashOrEndIndex){position=hashOrEndIndex;}foundIndex+=keyEncoded.length+1;result.push(goog.string.urlDecode(uri.substr(foundIndex,position-foundIndex)));}return result;};goog.uri.utils.trailingQueryPunctuationRe_=/[?&]($|#)/;goog.uri.utils.removeParam=function(uri,keyEncoded){for(var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),position=0,foundIndex,buffer=[];0<=(foundIndex=goog.uri.utils.findParam_(uri,position,keyEncoded,hashOrEndIndex));){buffer.push(uri.substring(position,foundIndex)),position=Math.min(uri.indexOf("&",foundIndex)+1||hashOrEndIndex,hashOrEndIndex);}buffer.push(uri.substr(position));return buffer.join("").replace(goog.uri.utils.trailingQueryPunctuationRe_,"$1");};goog.uri.utils.setParam=function(uri,keyEncoded,value){return goog.uri.utils.appendParam(goog.uri.utils.removeParam(uri,keyEncoded),keyEncoded,value);};goog.uri.utils.appendPath=function(baseUri,path){goog.uri.utils.assertNoFragmentsOrQueries_(baseUri);goog.string.endsWith(baseUri,"/")&&(baseUri=baseUri.substr(0,baseUri.length-1));goog.string.startsWith(path,"/")&&(path=path.substr(1));return goog.string.buildString(baseUri,"/",path);};goog.uri.utils.setPath=function(uri,path){goog.string.startsWith(path,"/")||(path="/"+path);var parts=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(parts[goog.uri.utils.ComponentIndex.SCHEME],parts[goog.uri.utils.ComponentIndex.USER_INFO],parts[goog.uri.utils.ComponentIndex.DOMAIN],parts[goog.uri.utils.ComponentIndex.PORT],path,parts[goog.uri.utils.ComponentIndex.QUERY_DATA],parts[goog.uri.utils.ComponentIndex.FRAGMENT]);};goog.uri.utils.StandardQueryParam={RANDOM:"zx"};goog.uri.utils.makeUnique=function(uri){return goog.uri.utils.setParam(uri,goog.uri.utils.StandardQueryParam.RANDOM,goog.string.getRandomString());};goog.net.XhrIo=function(opt_xmlHttpFactory){goog.events.EventTarget.call(this);this.headers=new goog.structs.Map();this.xmlHttpFactory_=opt_xmlHttpFactory||null;this.active_=!1;this.xhrOptions_=this.xhr_=null;this.lastMethod_=this.lastUri_="";this.lastErrorCode_=goog.net.ErrorCode.NO_ERROR;this.lastError_="";this.inAbort_=this.inOpen_=this.inSend_=this.errorDispatched_=!1;this.timeoutInterval_=0;this.timeoutId_=null;this.responseType_=goog.net.XhrIo.ResponseType.DEFAULT;this.useXhr2Timeout_=this.progressEventsEnabled_=this.withCredentials_=!1;};goog.inherits(goog.net.XhrIo,goog.events.EventTarget);goog.net.XhrIo.ResponseType={DEFAULT:"",TEXT:"text",DOCUMENT:"document",BLOB:"blob",ARRAY_BUFFER:"arraybuffer"};goog.net.XhrIo.prototype.logger_=goog.log.getLogger("goog.net.XhrIo");goog.net.XhrIo.CONTENT_TYPE_HEADER="Content-Type";goog.net.XhrIo.CONTENT_TRANSFER_ENCODING="Content-Transfer-Encoding";goog.net.XhrIo.HTTP_SCHEME_PATTERN=/^https?$/i;goog.net.XhrIo.METHODS_WITH_FORM_DATA=["POST","PUT"];goog.net.XhrIo.FORM_CONTENT_TYPE="application/x-www-form-urlencoded;charset=utf-8";goog.net.XhrIo.XHR2_TIMEOUT_="timeout";goog.net.XhrIo.XHR2_ON_TIMEOUT_="ontimeout";goog.net.XhrIo.sendInstances_=[];goog.net.XhrIo.send=function(url,opt_callback,opt_method,opt_content,opt_headers,opt_timeoutInterval,opt_withCredentials){var x=new goog.net.XhrIo();goog.net.XhrIo.sendInstances_.push(x);opt_callback&&x.listen(goog.net.EventType.COMPLETE,opt_callback);x.listenOnce(goog.net.EventType.READY,x.cleanupSend_);opt_timeoutInterval&&x.setTimeoutInterval(opt_timeoutInterval);opt_withCredentials&&x.setWithCredentials(opt_withCredentials);x.send(url,opt_method,opt_content,opt_headers);return x;};goog.net.XhrIo.cleanup=function(){for(var instances=goog.net.XhrIo.sendInstances_;instances.length;){instances.pop().dispose();}};goog.net.XhrIo.protectEntryPoints=function(errorHandler){goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=errorHandler.protectEntryPoint(goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_);};goog.net.XhrIo.prototype.cleanupSend_=function(){this.dispose();goog.array.remove(goog.net.XhrIo.sendInstances_,this);};goog.net.XhrIo.prototype.getTimeoutInterval=function(){return this.timeoutInterval_;};goog.net.XhrIo.prototype.setTimeoutInterval=function(ms){this.timeoutInterval_=Math.max(0,ms);};goog.net.XhrIo.prototype.setResponseType=function(type){this.responseType_=type;};goog.net.XhrIo.prototype.getResponseType=function(){return this.responseType_;};goog.net.XhrIo.prototype.setWithCredentials=function(withCredentials){this.withCredentials_=withCredentials;};goog.net.XhrIo.prototype.getWithCredentials=function(){return this.withCredentials_;};goog.net.XhrIo.prototype.setProgressEventsEnabled=function(enabled){this.progressEventsEnabled_=enabled;};goog.net.XhrIo.prototype.getProgressEventsEnabled=function(){return this.progressEventsEnabled_;};goog.net.XhrIo.prototype.send=function(url,opt_method,opt_content,opt_headers){if(this.xhr_){throw Error("[goog.net.XhrIo] Object is active with another request="+this.lastUri_+"; newUri="+url);}var method=opt_method?opt_method.toUpperCase():"GET";this.lastUri_=url;this.lastError_="";this.lastErrorCode_=goog.net.ErrorCode.NO_ERROR;this.lastMethod_=method;this.errorDispatched_=!1;this.active_=!0;this.xhr_=this.createXhr();this.xhrOptions_=this.xmlHttpFactory_?this.xmlHttpFactory_.getOptions():goog.net.XmlHttp.getOptions();this.xhr_.onreadystatechange=goog.bind(this.onReadyStateChange_,this);this.getProgressEventsEnabled()&&"onprogress"in this.xhr_&&(this.xhr_.onprogress=goog.bind(function(e){this.onProgressHandler_(e,!0);},this),this.xhr_.upload&&(this.xhr_.upload.onprogress=goog.bind(this.onProgressHandler_,this)));try{goog.log.fine(this.logger_,this.formatMsg_("Opening Xhr")),this.inOpen_=!0,this.xhr_.open(method,String(url),!0),this.inOpen_=!1;}catch(err){goog.log.fine(this.logger_,this.formatMsg_("Error opening Xhr: "+err.message));this.error_(goog.net.ErrorCode.EXCEPTION,err);return;}var content=opt_content||"",headers=this.headers.clone();opt_headers&&goog.structs.forEach(opt_headers,function(value,key){headers.set(key,value);});var contentTypeKey=goog.array.find(headers.getKeys(),goog.net.XhrIo.isContentTypeHeader_),contentIsFormData=goog.global.FormData&&content instanceof goog.global.FormData;!goog.array.contains(goog.net.XhrIo.METHODS_WITH_FORM_DATA,method)||contentTypeKey||contentIsFormData||headers.set(goog.net.XhrIo.CONTENT_TYPE_HEADER,goog.net.XhrIo.FORM_CONTENT_TYPE);headers.forEach(function(value,key){this.xhr_.setRequestHeader(key,value);},this);this.responseType_&&(this.xhr_.responseType=this.responseType_);"withCredentials"in this.xhr_&&this.xhr_.withCredentials!==this.withCredentials_&&(this.xhr_.withCredentials=this.withCredentials_);try{this.cleanUpTimeoutTimer_(),0<this.timeoutInterval_&&(this.useXhr2Timeout_=goog.net.XhrIo.shouldUseXhr2Timeout_(this.xhr_),goog.log.fine(this.logger_,this.formatMsg_("Will abort after "+this.timeoutInterval_+"ms if incomplete, xhr2 "+this.useXhr2Timeout_)),this.useXhr2Timeout_?(this.xhr_[goog.net.XhrIo.XHR2_TIMEOUT_]=this.timeoutInterval_,this.xhr_[goog.net.XhrIo.XHR2_ON_TIMEOUT_]=goog.bind(this.timeout_,this)):this.timeoutId_=goog.Timer.callOnce(this.timeout_,this.timeoutInterval_,this)),goog.log.fine(this.logger_,this.formatMsg_("Sending request")),this.inSend_=!0,this.xhr_.send(content),this.inSend_=!1;}catch(err$3){goog.log.fine(this.logger_,this.formatMsg_("Send error: "+err$3.message)),this.error_(goog.net.ErrorCode.EXCEPTION,err$3);}};goog.net.XhrIo.shouldUseXhr2Timeout_=function(xhr){return goog.userAgent.IE&&goog.userAgent.isVersionOrHigher(9)&&goog.isNumber(xhr[goog.net.XhrIo.XHR2_TIMEOUT_])&&goog.isDef(xhr[goog.net.XhrIo.XHR2_ON_TIMEOUT_]);};goog.net.XhrIo.isContentTypeHeader_=function(header){return goog.string.caseInsensitiveEquals(goog.net.XhrIo.CONTENT_TYPE_HEADER,header);};goog.net.XhrIo.prototype.createXhr=function(){return this.xmlHttpFactory_?this.xmlHttpFactory_.createInstance():goog.net.XmlHttp();};goog.net.XhrIo.prototype.timeout_=function(){"undefined"!=typeof goog&&this.xhr_&&(this.lastError_="Timed out after "+this.timeoutInterval_+"ms, aborting",this.lastErrorCode_=goog.net.ErrorCode.TIMEOUT,goog.log.fine(this.logger_,this.formatMsg_(this.lastError_)),this.dispatchEvent(goog.net.EventType.TIMEOUT),this.abort(goog.net.ErrorCode.TIMEOUT));};goog.net.XhrIo.prototype.error_=function(errorCode,err){this.active_=!1;this.xhr_&&(this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1);this.lastError_=err;this.lastErrorCode_=errorCode;this.dispatchErrors_();this.cleanUpXhr_();};goog.net.XhrIo.prototype.dispatchErrors_=function(){this.errorDispatched_||(this.errorDispatched_=!0,this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.ERROR));};goog.net.XhrIo.prototype.abort=function(opt_failureCode){this.xhr_&&this.active_&&(goog.log.fine(this.logger_,this.formatMsg_("Aborting")),this.active_=!1,this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1,this.lastErrorCode_=opt_failureCode||goog.net.ErrorCode.ABORT,this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.ABORT),this.cleanUpXhr_());};goog.net.XhrIo.prototype.disposeInternal=function(){this.xhr_&&(this.active_&&(this.active_=!1,this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1),this.cleanUpXhr_(!0));goog.net.XhrIo.superClass_.disposeInternal.call(this);};goog.net.XhrIo.prototype.onReadyStateChange_=function(){if(!this.isDisposed()){if(this.inOpen_||this.inSend_||this.inAbort_){this.onReadyStateChangeHelper_();}else{this.onReadyStateChangeEntryPoint_();}}};goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=function(){this.onReadyStateChangeHelper_();};goog.net.XhrIo.prototype.onReadyStateChangeHelper_=function(){if(this.active_&&"undefined"!=typeof goog){if(this.xhrOptions_[goog.net.XmlHttp.OptionType.LOCAL_REQUEST_ERROR]&&this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE&&2==this.getStatus()){goog.log.fine(this.logger_,this.formatMsg_("Local request error detected and ignored"));}else{if(this.inSend_&&this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE){goog.Timer.callOnce(this.onReadyStateChange_,0,this);}else{if(this.dispatchEvent(goog.net.EventType.READY_STATE_CHANGE),this.isComplete()){goog.log.fine(this.logger_,this.formatMsg_("Request complete"));this.active_=!1;try{this.isSuccess()?(this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.SUCCESS)):(this.lastErrorCode_=goog.net.ErrorCode.HTTP_ERROR,this.lastError_=this.getStatusText()+" ["+this.getStatus()+"]",this.dispatchErrors_());}finally{this.cleanUpXhr_();}}}}}};goog.net.XhrIo.prototype.onProgressHandler_=function(e,opt_isDownload){goog.asserts.assert(e.type===goog.net.EventType.PROGRESS,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(goog.net.XhrIo.buildProgressEvent_(e,goog.net.EventType.PROGRESS));this.dispatchEvent(goog.net.XhrIo.buildProgressEvent_(e,opt_isDownload?goog.net.EventType.DOWNLOAD_PROGRESS:goog.net.EventType.UPLOAD_PROGRESS));};goog.net.XhrIo.buildProgressEvent_=function(e,eventType){return{type:eventType,lengthComputable:e.lengthComputable,loaded:e.loaded,total:e.total};};goog.net.XhrIo.prototype.cleanUpXhr_=function(opt_fromDispose){if(this.xhr_){this.cleanUpTimeoutTimer_();var xhr=this.xhr_,clearedOnReadyStateChange=this.xhrOptions_[goog.net.XmlHttp.OptionType.USE_NULL_FUNCTION]?goog.nullFunction:null;this.xhrOptions_=this.xhr_=null;opt_fromDispose||this.dispatchEvent(goog.net.EventType.READY);try{xhr.onreadystatechange=clearedOnReadyStateChange;}catch(e){goog.log.error(this.logger_,"Problem encountered resetting onreadystatechange: "+e.message);}}};goog.net.XhrIo.prototype.cleanUpTimeoutTimer_=function(){this.xhr_&&this.useXhr2Timeout_&&(this.xhr_[goog.net.XhrIo.XHR2_ON_TIMEOUT_]=null);goog.isNumber(this.timeoutId_)&&(goog.Timer.clear(this.timeoutId_),this.timeoutId_=null);};goog.net.XhrIo.prototype.isActive=function(){return!!this.xhr_;};goog.net.XhrIo.prototype.isComplete=function(){return this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE;};goog.net.XhrIo.prototype.isSuccess=function(){var status=this.getStatus();return goog.net.HttpStatus.isSuccess(status)||0===status&&!this.isLastUriEffectiveSchemeHttp_();};goog.net.XhrIo.prototype.isLastUriEffectiveSchemeHttp_=function(){var scheme=goog.uri.utils.getEffectiveScheme(String(this.lastUri_));return goog.net.XhrIo.HTTP_SCHEME_PATTERN.test(scheme);};goog.net.XhrIo.prototype.getReadyState=function(){return this.xhr_?this.xhr_.readyState:goog.net.XmlHttp.ReadyState.UNINITIALIZED;};goog.net.XhrIo.prototype.getStatus=function(){try{return this.getReadyState()>goog.net.XmlHttp.ReadyState.LOADED?this.xhr_.status:-1;}catch(e){return-1;}};goog.net.XhrIo.prototype.getStatusText=function(){try{return this.getReadyState()>goog.net.XmlHttp.ReadyState.LOADED?this.xhr_.statusText:"";}catch(e){return goog.log.fine(this.logger_,"Can not get status: "+e.message),"";}};goog.net.XhrIo.prototype.getLastUri=function(){return String(this.lastUri_);};goog.net.XhrIo.prototype.getResponseText=function(){try{return this.xhr_?this.xhr_.responseText:"";}catch(e){return goog.log.fine(this.logger_,"Can not get responseText: "+e.message),"";}};goog.net.XhrIo.prototype.getResponseBody=function(){try{if(this.xhr_&&"responseBody"in this.xhr_){return this.xhr_.responseBody;}}catch(e){goog.log.fine(this.logger_,"Can not get responseBody: "+e.message);}return null;};goog.net.XhrIo.prototype.getResponseXml=function(){try{return this.xhr_?this.xhr_.responseXML:null;}catch(e){return goog.log.fine(this.logger_,"Can not get responseXML: "+e.message),null;}};goog.net.XhrIo.prototype.getResponseJson=function(opt_xssiPrefix){if(this.xhr_){var responseText=this.xhr_.responseText;opt_xssiPrefix&&0==responseText.indexOf(opt_xssiPrefix)&&(responseText=responseText.substring(opt_xssiPrefix.length));return goog.json.parse(responseText);}};goog.net.XhrIo.prototype.getResponse=function(){try{if(!this.xhr_){return null;}if("response"in this.xhr_){return this.xhr_.response;}switch(this.responseType_){case goog.net.XhrIo.ResponseType.DEFAULT:case goog.net.XhrIo.ResponseType.TEXT:return this.xhr_.responseText;case goog.net.XhrIo.ResponseType.ARRAY_BUFFER:if("mozResponseArrayBuffer"in this.xhr_){return this.xhr_.mozResponseArrayBuffer;}}goog.log.error(this.logger_,"Response type "+this.responseType_+" is not supported on this browser");return null;}catch(e){return goog.log.fine(this.logger_,"Can not get response: "+e.message),null;}};goog.net.XhrIo.prototype.getResponseHeader=function(key){if(this.xhr_&&this.isComplete()){var value=this.xhr_.getResponseHeader(key);return goog.isNull(value)?void 0:value;}};goog.net.XhrIo.prototype.getAllResponseHeaders=function(){return this.xhr_&&this.isComplete()?this.xhr_.getAllResponseHeaders():"";};goog.net.XhrIo.prototype.getResponseHeaders=function(){for(var headersObject={},headersArray=this.getAllResponseHeaders().split("\\r\\n"),i=0;i<headersArray.length;i++){if(!goog.string.isEmptyOrWhitespace(headersArray[i])){var keyValue=goog.string.splitLimit(headersArray[i],": ",2);headersObject[keyValue[0]]=headersObject[keyValue[0]]?headersObject[keyValue[0]]+(", "+keyValue[1]):keyValue[1];}}return headersObject;};goog.net.XhrIo.prototype.getStreamingResponseHeader=function(key){return this.xhr_?this.xhr_.getResponseHeader(key):null;};goog.net.XhrIo.prototype.getAllStreamingResponseHeaders=function(){return this.xhr_?this.xhr_.getAllResponseHeaders():"";};goog.net.XhrIo.prototype.getLastErrorCode=function(){return this.lastErrorCode_;};goog.net.XhrIo.prototype.getLastError=function(){return goog.isString(this.lastError_)?this.lastError_:String(this.lastError_);};goog.net.XhrIo.prototype.formatMsg_=function(msg){return msg+" ["+this.lastMethod_+" "+this.lastUri_+" "+this.getStatus()+"]";};goog.debug.entryPointRegistry.register(function(transformer){goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=transformer(goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_);});goog.dom.BrowserFeature={CAN_ADD_NAME_OR_TYPE_ATTRIBUTES:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),CAN_USE_CHILDREN_ATTRIBUTE:!goog.userAgent.GECKO&&!goog.userAgent.IE||goog.userAgent.IE&&goog.userAgent.isDocumentModeOrHigher(9)||goog.userAgent.GECKO&&goog.userAgent.isVersionOrHigher("1.9.1"),CAN_USE_INNER_TEXT:goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),CAN_USE_PARENT_ELEMENT_PROPERTY:goog.userAgent.IE||goog.userAgent.OPERA||goog.userAgent.WEBKIT,INNER_HTML_NEEDS_SCOPED_ELEMENT:goog.userAgent.IE,LEGACY_IE_RANGES:goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)};goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(tagName){return!0===goog.dom.tags.VOID_TAGS_[tagName];};goog.string.TypedString=function(){};goog.string.Const=function(){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_="";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_;};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;};goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}";};goog.string.Const.unwrap=function(stringConst){if(stringConst instanceof goog.string.Const&&stringConst.constructor===goog.string.Const&&stringConst.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_){return stringConst.stringConstValueWithSecurityContract__googStringSecurityPrivate_;}goog.asserts.fail("expected object of type Const, got \'"+stringConst+"\'");return"type_error:Const";};goog.string.Const.from=function(s){return goog.string.Const.create__googStringSecurityPrivate_(s);};goog.string.Const.TYPE_MARKER_={};goog.string.Const.create__googStringSecurityPrivate_=function(s){var stringConst=new goog.string.Const();stringConst.stringConstValueWithSecurityContract__googStringSecurityPrivate_=s;return stringConst;};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html={};goog.html.SafeScript=function(){this.privateDoNotAccessOrElseSafeScriptWrappedValue_="";this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeScript.prototype.implementsGoogStringTypedString=!0;goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeScript.fromConstant=function(script){var scriptString=goog.string.Const.unwrap(script);return 0===scriptString.length?goog.html.SafeScript.EMPTY:goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(scriptString);};goog.html.SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_;};goog.DEBUG&&(goog.html.SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}";});goog.html.SafeScript.unwrap=function(safeScript){if(safeScript instanceof goog.html.SafeScript&&safeScript.constructor===goog.html.SafeScript&&safeScript.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeScript.privateDoNotAccessOrElseSafeScriptWrappedValue_;}goog.asserts.fail("expected object of type SafeScript, got \'"+safeScript+"\' of type "+goog.typeOf(safeScript));return"type_error:SafeScript";};goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(script){return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(script);};goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_=function(script){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=script;return this;};goog.html.SafeScript.EMPTY=goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle=function(){this.privateDoNotAccessOrElseSafeStyleWrappedValue_="";this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeStyle.fromConstant=function(style){var styleString=goog.string.Const.unwrap(style);if(0===styleString.length){return goog.html.SafeStyle.EMPTY;}goog.html.SafeStyle.checkStyle_(styleString);goog.asserts.assert(goog.string.endsWith(styleString,";"),"Last character of style string is not \';\': "+styleString);goog.asserts.assert(goog.string.contains(styleString,":"),"Style string must contain at least one \':\', to specify a \\"name: value\\" pair: "+styleString);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(styleString);};goog.html.SafeStyle.checkStyle_=function(style){goog.asserts.assert(!/[<>]/.test(style),"Forbidden characters in style string: "+style);};goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}";});goog.html.SafeStyle.unwrap=function(safeStyle){if(safeStyle instanceof goog.html.SafeStyle&&safeStyle.constructor===goog.html.SafeStyle&&safeStyle.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeStyle.privateDoNotAccessOrElseSafeStyleWrappedValue_;}goog.asserts.fail("expected object of type SafeStyle, got \'"+safeStyle+"\' of type "+goog.typeOf(safeStyle));return"type_error:SafeStyle";};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(style){return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(style);};goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_=function(style){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=style;return this;};goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";goog.html.SafeStyle.create=function(map){var style="",name;for(name in map){if(!/^[-_a-zA-Z0-9]+$/.test(name)){throw Error("Name allows only [-_a-zA-Z0-9], got: "+name);}var value=map[name];null!=value&&(value instanceof goog.string.Const?(value=goog.string.Const.unwrap(value),goog.asserts.assert(!/[{;}]/.test(value),"Value does not allow [{;}].")):goog.html.SafeStyle.VALUE_RE_.test(value)?goog.html.SafeStyle.hasBalancedQuotes_(value)||(goog.asserts.fail("String value requires balanced quotes, got: "+value),value=goog.html.SafeStyle.INNOCUOUS_STRING):(goog.asserts.fail("String value allows only [-,.\\"\'%_!# a-zA-Z0-9], rgb() and rgba(), got: "+value),value=goog.html.SafeStyle.INNOCUOUS_STRING),style+=name+":"+value+";");}if(!style){return goog.html.SafeStyle.EMPTY;}goog.html.SafeStyle.checkStyle_(style);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.SafeStyle.hasBalancedQuotes_=function(value){for(var outsideSingle=!0,outsideDouble=!0,i=0;i<value.length;i++){var c=value.charAt(i);"\'"==c&&outsideDouble?outsideSingle=!outsideSingle:\'"\'==c&&outsideSingle&&(outsideDouble=!outsideDouble);}return outsideSingle&&outsideDouble;};goog.html.SafeStyle.VALUE_RE_=/^([-,."\'%_!# a-zA-Z0-9]+|(?:rgb|hsl)a?\\([0-9.%, ]+\\))$/;goog.html.SafeStyle.concat=function(var_args){var style="",addArgument=function addArgument(argument){goog.isArray(argument)?goog.array.forEach(argument,addArgument):style+=goog.html.SafeStyle.unwrap(argument);};goog.array.forEach(arguments,addArgument);return style?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style):goog.html.SafeStyle.EMPTY;};goog.html.SafeStyleSheet=function(){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_="";this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeStyleSheet.concat=function(var_args){var result="",addArgument=function addArgument(argument){goog.isArray(argument)?goog.array.forEach(argument,addArgument):result+=goog.html.SafeStyleSheet.unwrap(argument);};goog.array.forEach(arguments,addArgument);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(result);};goog.html.SafeStyleSheet.fromConstant=function(styleSheet){var styleSheetString=goog.string.Const.unwrap(styleSheet);if(0===styleSheetString.length){return goog.html.SafeStyleSheet.EMPTY;}goog.asserts.assert(!goog.string.contains(styleSheetString,"<"),"Forbidden \'<\' character in style sheet string: "+styleSheetString);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheetString);};goog.html.SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;};goog.DEBUG&&(goog.html.SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}";});goog.html.SafeStyleSheet.unwrap=function(safeStyleSheet){if(safeStyleSheet instanceof goog.html.SafeStyleSheet&&safeStyleSheet.constructor===goog.html.SafeStyleSheet&&safeStyleSheet.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeStyleSheet.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;}goog.asserts.fail("expected object of type SafeStyleSheet, got \'"+safeStyleSheet+"\' of type "+goog.typeOf(safeStyleSheet));return"type_error:SafeStyleSheet";};goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(styleSheet){return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(styleSheet);};goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_=function(styleSheet){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=styleSheet;return this;};goog.html.SafeStyleSheet.EMPTY=goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.fs.url={};goog.fs.url.createObjectUrl=function(blob){return goog.fs.url.getUrlObject_().createObjectURL(blob);};goog.fs.url.revokeObjectUrl=function(url){goog.fs.url.getUrlObject_().revokeObjectURL(url);};goog.fs.url.getUrlObject_=function(){var urlObject=goog.fs.url.findUrlObject_();if(null!=urlObject){return urlObject;}throw Error("This browser doesn\'t seem to support blob URLs");};goog.fs.url.findUrlObject_=function(){return goog.isDef(goog.global.URL)&&goog.isDef(goog.global.URL.createObjectURL)?goog.global.URL:goog.isDef(goog.global.webkitURL)&&goog.isDef(goog.global.webkitURL.createObjectURL)?goog.global.webkitURL:goog.isDef(goog.global.createObjectURL)?goog.global:null;};goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_();};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4));goog.i18n.bidi.Format={LRE:"\\u202A",RLE:"\\u202B",PDF:"\\u202C",LRM:"\\u200E",RLM:"\\u200F"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;goog.i18n.bidi.toDir=function(givenDir,opt_noNeutral){return"number"==typeof givenDir?0<givenDir?goog.i18n.bidi.Dir.LTR:0>givenDir?goog.i18n.bidi.Dir.RTL:opt_noNeutral?null:goog.i18n.bidi.Dir.NEUTRAL:null==givenDir?null:givenDir?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR;};goog.i18n.bidi.ltrChars_="A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02B8\\u0300-\\u0590\\u0800-\\u1FFF\\u200E\\u2C00-\\uFB1C\\uFE00-\\uFE6F\\uFEFD-\\uFFFF";goog.i18n.bidi.rtlChars_="\\u0591-\\u06EF\\u06FA-\\u07FF\\u200F\\uFB1D-\\uFDFF\\uFE70-\\uFEFC";goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(str,opt_isStripNeeded){return opt_isStripNeeded?str.replace(goog.i18n.bidi.htmlSkipReg_,""):str;};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;goog.i18n.bidi.hasAnyLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(str){return goog.i18n.bidi.rtlRe_.test(str);};goog.i18n.bidi.isLtrChar=function(str){return goog.i18n.bidi.ltrRe_.test(str);};goog.i18n.bidi.isNeutralChar=function(str){return!goog.i18n.bidi.isLtrChar(str)&&!goog.i18n.bidi.isRtlChar(str);};goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;goog.i18n.bidi.startsWithLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\\/\\/.*/;goog.i18n.bidi.isNeutralText=function(str,opt_isHtml){str=goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml);return goog.i18n.bidi.isRequiredLtrRe_.test(str)||!goog.i18n.bidi.hasAnyLtr(str)&&!goog.i18n.bidi.hasAnyRtl(str);};goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;goog.i18n.bidi.endsWithRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Arab|Hebr|Thaa|Nkoo|Tfng))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(lang){return goog.i18n.bidi.rtlLocalesRe_.test(lang);};goog.i18n.bidi.bracketGuardTextRe_=/(\\(.*?\\)+)|(\\[.*?\\]+)|(\\{.*?\\}+)|(<.*?>+)/g;goog.i18n.bidi.guardBracketInText=function(s,opt_isRtlContext){var mark=(void 0===opt_isRtlContext?goog.i18n.bidi.hasAnyRtl(s):opt_isRtlContext)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return s.replace(goog.i18n.bidi.bracketGuardTextRe_,mark+"$&"+mark);};goog.i18n.bidi.enforceRtlInHtml=function(html){return"<"==html.charAt(0)?html.replace(/<\\w+/,"$& dir=rtl"):"\\n<span dir=rtl>"+html+"</span>";};goog.i18n.bidi.enforceRtlInText=function(text){return goog.i18n.bidi.Format.RLE+text+goog.i18n.bidi.Format.PDF;};goog.i18n.bidi.enforceLtrInHtml=function(html){return"<"==html.charAt(0)?html.replace(/<\\w+/,"$& dir=ltr"):"\\n<span dir=ltr>"+html+"</span>";};goog.i18n.bidi.enforceLtrInText=function(text){return goog.i18n.bidi.Format.LRE+text+goog.i18n.bidi.Format.PDF;};goog.i18n.bidi.dimensionsRe_=/:\\s*([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;goog.i18n.bidi.mirrorCSS=function(cssStr){return cssStr.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT);};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\\u0591-\\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\\u0591-\\u05f2])\'/g;goog.i18n.bidi.normalizeHebrewQuote=function(str){return str.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\\u05F3");};goog.i18n.bidi.wordSeparatorRe_=/\\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\\d\\u06f0-\\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=0.40;goog.i18n.bidi.estimateDirection=function(str,opt_isHtml){for(var rtlCount=0,totalCount=0,hasWeaklyLtr=!1,tokens=goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml).split(goog.i18n.bidi.wordSeparatorRe_),i=0;i<tokens.length;i++){var token=tokens[i];goog.i18n.bidi.startsWithRtl(token)?(rtlCount++,totalCount++):goog.i18n.bidi.isRequiredLtrRe_.test(token)?hasWeaklyLtr=!0:goog.i18n.bidi.hasAnyLtr(token)?totalCount++:goog.i18n.bidi.hasNumeralsRe_.test(token)&&(hasWeaklyLtr=!0);}return 0==totalCount?hasWeaklyLtr?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:rtlCount/totalCount>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR;};goog.i18n.bidi.detectRtlDirectionality=function(str,opt_isHtml){return goog.i18n.bidi.estimateDirection(str,opt_isHtml)==goog.i18n.bidi.Dir.RTL;};goog.i18n.bidi.setElementDirAndAlign=function(element,dir){element&&(dir=goog.i18n.bidi.toDir(dir))&&(element.style.textAlign=dir==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,element.dir=dir==goog.i18n.bidi.Dir.RTL?"rtl":"ltr");};goog.i18n.bidi.setElementDirByTextDirectionality=function(element,text){switch(goog.i18n.bidi.estimateDirection(text)){case goog.i18n.bidi.Dir.LTR:element.dir="ltr";break;case goog.i18n.bidi.Dir.RTL:element.dir="rtl";break;default:element.removeAttribute("dir");}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_="";this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;};goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR;};goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}";});goog.html.TrustedResourceUrl.unwrap=function(trustedResourceUrl){if(trustedResourceUrl instanceof goog.html.TrustedResourceUrl&&trustedResourceUrl.constructor===goog.html.TrustedResourceUrl&&trustedResourceUrl.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return trustedResourceUrl.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;}goog.asserts.fail("expected object of type TrustedResourceUrl, got \'"+trustedResourceUrl+"\' of type "+goog.typeOf(trustedResourceUrl));return"type_error:TrustedResourceUrl";};goog.html.TrustedResourceUrl.format=function(format,args){var formatStr=goog.string.Const.unwrap(format);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(formatStr)){throw Error("Invalid TrustedResourceUrl format: "+formatStr);}var result=formatStr.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(match,id){if(!Object.prototype.hasOwnProperty.call(args,id)){throw Error(\'Found marker, "\'+id+\'", in format string, "\'+formatStr+\'", but no valid label mapping found in args: \'+JSON.stringify(args));}var arg=args[id];return arg instanceof goog.string.Const?goog.string.Const.unwrap(arg):encodeURIComponent(String(arg));});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(result);};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^(?:https:)?\\/\\/[0-9a-z.:[\\]-]+\\/|^\\/[^\\/\\\\]|^about:blank(#|$)/i;goog.html.TrustedResourceUrl.fromConstant=function(url){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(url));};goog.html.TrustedResourceUrl.fromConstants=function(parts){for(var unwrapped="",i=0;i<parts.length;i++){unwrapped+=goog.string.Const.unwrap(parts[i]);}return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(unwrapped);};goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(url){var trustedResourceUrl=new goog.html.TrustedResourceUrl();trustedResourceUrl.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=url;return trustedResourceUrl;};goog.html.SafeUrl=function(){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_="";this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_;};goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR;};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}";});goog.html.SafeUrl.unwrap=function(safeUrl){if(safeUrl instanceof goog.html.SafeUrl&&safeUrl.constructor===goog.html.SafeUrl&&safeUrl.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeUrl.privateDoNotAccessOrElseSafeHtmlWrappedValue_;}goog.asserts.fail("expected object of type SafeUrl, got \'"+safeUrl+"\' of type "+goog.typeOf(safeUrl));return"type_error:SafeUrl";};goog.html.SafeUrl.fromConstant=function(url){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(url));};goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:image\\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\\/(?:mpeg|mp4|ogg|webm))$/i;goog.html.SafeUrl.fromBlob=function(blob){var url=goog.html.SAFE_MIME_TYPE_PATTERN_.test(blob.type)?goog.fs.url.createObjectUrl(blob):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.DATA_URL_PATTERN_=/^data:([^;,]*);base64,[a-z0-9+\\/]+=*$/i;goog.html.SafeUrl.fromDataUrl=function(dataUrl){var match=dataUrl.match(goog.html.DATA_URL_PATTERN_),valid=match&&goog.html.SAFE_MIME_TYPE_PATTERN_.test(match[1]);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(valid?dataUrl:goog.html.SafeUrl.INNOCUOUS_STRING);};goog.html.SafeUrl.fromTelUrl=function(telUrl){goog.string.caseInsensitiveStartsWith(telUrl,"tel:")||(telUrl=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(telUrl);};goog.html.SafeUrl.fromTrustedResourceUrl=function(trustedResourceUrl){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(trustedResourceUrl));};goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.sanitize=function(url){if(url instanceof goog.html.SafeUrl){return url;}url=url.implementsGoogStringTypedString?url.getTypedStringValue():String(url);goog.html.SAFE_URL_PATTERN_.test(url)||(url=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(url){var safeUrl=new goog.html.SafeUrl();safeUrl.privateDoNotAccessOrElseSafeHtmlWrappedValue_=url;return safeUrl;};goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeHtml=function(){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_="";this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;this.dir_=null;};goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_;};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_;};goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}";});goog.html.SafeHtml.unwrap=function(safeHtml){if(safeHtml instanceof goog.html.SafeHtml&&safeHtml.constructor===goog.html.SafeHtml&&safeHtml.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeHtml.privateDoNotAccessOrElseSafeHtmlWrappedValue_;}goog.asserts.fail("expected object of type SafeHtml, got \'"+safeHtml+"\' of type "+goog.typeOf(safeHtml));return"type_error:SafeHtml";};goog.html.SafeHtml.htmlEscape=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var dir=null;textOrHtml.implementsGoogI18nBidiDirectionalString&&(dir=textOrHtml.getDirection());return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.htmlEscape(textOrHtml.implementsGoogStringTypedString?textOrHtml.getTypedStringValue():String(textOrHtml)),dir);};goog.html.SafeHtml.htmlEscapePreservingNewlines=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var html=goog.html.SafeHtml.htmlEscape(textOrHtml);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.newLineToBr(goog.html.SafeHtml.unwrap(html)),html.getDirection());};goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var html=goog.html.SafeHtml.htmlEscape(textOrHtml);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.whitespaceEscape(goog.html.SafeHtml.unwrap(html)),html.getDirection());};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_={APPLET:!0,BASE:!0,EMBED:!0,IFRAME:!0,LINK:!0,MATH:!0,META:!0,OBJECT:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};goog.html.SafeHtml.create=function(tagName,opt_attributes,opt_content){goog.html.SafeHtml.verifyTagName(String(tagName));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(tagName),opt_attributes,opt_content);};goog.html.SafeHtml.verifyTagName=function(tagName){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(tagName)){throw Error("Invalid tag name <"+tagName+">.");}if(tagName.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_){throw Error("Tag name <"+tagName+"> is not allowed for SafeHtml.");}};goog.html.SafeHtml.createIframe=function(opt_src,opt_srcdoc,opt_attributes,opt_content){opt_src&&goog.html.TrustedResourceUrl.unwrap(opt_src);var fixedAttributes={};fixedAttributes.src=opt_src||null;fixedAttributes.srcdoc=opt_srcdoc&&goog.html.SafeHtml.unwrap(opt_srcdoc);var attributes=goog.html.SafeHtml.combineAttributes(fixedAttributes,{sandbox:""},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",attributes,opt_content);};goog.html.SafeHtml.createSandboxIframe=function(opt_src,opt_srcdoc,opt_attributes,opt_content){if(!goog.html.SafeHtml.canUseSandboxIframe()){throw Error("The browser does not support sandboxed iframes.");}var fixedAttributes={};fixedAttributes.src=opt_src?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(opt_src)):null;fixedAttributes.srcdoc=opt_srcdoc||null;fixedAttributes.sandbox="";var attributes=goog.html.SafeHtml.combineAttributes(fixedAttributes,{},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",attributes,opt_content);};goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype;};goog.html.SafeHtml.createScriptSrc=function(src,opt_attributes){goog.html.TrustedResourceUrl.unwrap(src);var attributes=goog.html.SafeHtml.combineAttributes({src:src},{},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",attributes);};goog.html.SafeHtml.createScript=function(script,opt_attributes){for(var attr in opt_attributes){var attrLower=attr.toLowerCase();if("language"==attrLower||"src"==attrLower||"text"==attrLower||"type"==attrLower){throw Error(\'Cannot set "\'+attrLower+\'" attribute\');}}var content="";script=goog.array.concat(script);for(var i=0;i<script.length;i++){content+=goog.html.SafeScript.unwrap(script[i]);}var htmlContent=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",opt_attributes,htmlContent);};goog.html.SafeHtml.createStyle=function(styleSheet,opt_attributes){var attributes=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},opt_attributes),content="";styleSheet=goog.array.concat(styleSheet);for(var i=0;i<styleSheet.length;i++){content+=goog.html.SafeStyleSheet.unwrap(styleSheet[i]);}var htmlContent=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",attributes,htmlContent);};goog.html.SafeHtml.createMetaRefresh=function(url,opt_secs){var unwrappedUrl=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(url));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.contains(unwrappedUrl,";")&&(unwrappedUrl="\'"+unwrappedUrl.replace(/\'/g,"%27")+"\'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(opt_secs||0)+"; url="+unwrappedUrl});};goog.html.SafeHtml.getAttrNameAndValue_=function(tagName,name,value){if(value instanceof goog.string.Const){value=goog.string.Const.unwrap(value);}else{if("style"==name.toLowerCase()){value=goog.html.SafeHtml.getStyleValue_(value);}else{if(/^on/i.test(name)){throw Error(\'Attribute "\'+name+\'" requires goog.string.Const value, "\'+value+\'" given.\');}if(name.toLowerCase()in goog.html.SafeHtml.URL_ATTRIBUTES_){if(value instanceof goog.html.TrustedResourceUrl){value=goog.html.TrustedResourceUrl.unwrap(value);}else{if(value instanceof goog.html.SafeUrl){value=goog.html.SafeUrl.unwrap(value);}else{if(goog.isString(value)){value=goog.html.SafeUrl.sanitize(value).getTypedStringValue();}else{throw Error(\'Attribute "\'+name+\'" on tag "\'+tagName+\'" requires goog.html.SafeUrl, goog.string.Const, or string, value "\'+value+\'" given.\');}}}}}}value.implementsGoogStringTypedString&&(value=value.getTypedStringValue());goog.asserts.assert(goog.isString(value)||goog.isNumber(value),"String or number value expected, got "+(typeof value==="undefined"?"undefined":_typeof(value))+" with value: "+value);return name+\'="\'+goog.string.htmlEscape(String(value))+\'"\';};goog.html.SafeHtml.getStyleValue_=function(value){if(!goog.isObject(value)){throw Error(\'The "style" attribute requires goog.html.SafeStyle or map of style properties, \'+(typeof value==="undefined"?"undefined":_typeof(value))+" given: "+value);}value instanceof goog.html.SafeStyle||(value=goog.html.SafeStyle.create(value));return goog.html.SafeStyle.unwrap(value);};goog.html.SafeHtml.createWithDir=function(dir,tagName,opt_attributes,opt_content){var html=goog.html.SafeHtml.create(tagName,opt_attributes,opt_content);html.dir_=dir;return html;};goog.html.SafeHtml.concat=function(var_args){var dir=goog.i18n.bidi.Dir.NEUTRAL,content="",addArgument=function addArgument(argument){if(goog.isArray(argument)){goog.array.forEach(argument,addArgument);}else{var html=goog.html.SafeHtml.htmlEscape(argument);content+=goog.html.SafeHtml.unwrap(html);var htmlDir=html.getDirection();dir==goog.i18n.bidi.Dir.NEUTRAL?dir=htmlDir:htmlDir!=goog.i18n.bidi.Dir.NEUTRAL&&dir!=htmlDir&&(dir=null);}};goog.array.forEach(arguments,addArgument);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,dir);};goog.html.SafeHtml.concatWithDir=function(dir,var_args){var html=goog.html.SafeHtml.concat(goog.array.slice(arguments,1));html.dir_=dir;return html;};goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(html,dir){return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(html,dir);};goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_=function(html,dir){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=html;this.dir_=dir;return this;};goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(tagName,opt_attributes,opt_content){var dir=null;var result="<"+tagName+goog.html.SafeHtml.stringifyAttributes(tagName,opt_attributes);var content=opt_content;goog.isDefAndNotNull(content)?goog.isArray(content)||(content=[content]):content=[];if(goog.dom.tags.isVoidTag(tagName.toLowerCase())){goog.asserts.assert(!content.length,"Void tag <"+tagName+"> does not allow content."),result+=">";}else{var html=goog.html.SafeHtml.concat(content);result+=">"+goog.html.SafeHtml.unwrap(html)+"</"+tagName+">";dir=html.getDirection();}var dirAttribute=opt_attributes&&opt_attributes.dir;dirAttribute&&(dir=/^(ltr|rtl|auto)$/i.test(dirAttribute)?goog.i18n.bidi.Dir.NEUTRAL:null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(result,dir);};goog.html.SafeHtml.stringifyAttributes=function(tagName,opt_attributes){var result="";if(opt_attributes){for(var name in opt_attributes){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(name)){throw Error(\'Invalid attribute name "\'+name+\'".\');}var value=opt_attributes[name];goog.isDefAndNotNull(value)&&(result+=" "+goog.html.SafeHtml.getAttrNameAndValue_(tagName,name,value));}}return result;};goog.html.SafeHtml.combineAttributes=function(fixedAttributes,defaultAttributes,opt_attributes){var combinedAttributes={},name;for(name in fixedAttributes){goog.asserts.assert(name.toLowerCase()==name,"Must be lower case"),combinedAttributes[name]=fixedAttributes[name];}for(name in defaultAttributes){goog.asserts.assert(name.toLowerCase()==name,"Must be lower case"),combinedAttributes[name]=defaultAttributes[name];}for(name in opt_attributes){var nameLower=name.toLowerCase();if(nameLower in fixedAttributes){throw Error(\'Cannot override "\'+nameLower+\'" attribute, got "\'+name+\'" with value "\'+opt_attributes[name]+\'"\');}nameLower in defaultAttributes&&delete combinedAttributes[nameLower];combinedAttributes[name]=opt_attributes[name];}return combinedAttributes;};goog.html.SafeHtml.DOCTYPE_HTML=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.EMPTY=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.BR=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL);goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(node,position,html){node.insertAdjacentHTML(position,goog.html.SafeHtml.unwrap(html));};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};goog.dom.safe.setInnerHtml=function(elem,html){if(goog.asserts.ENABLE_ASSERTS&&goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[elem.tagName.toUpperCase()]){throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+elem.tagName+".");}elem.innerHTML=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setOuterHtml=function(elem,html){elem.outerHTML=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setStyle=function(elem,style){elem.style.cssText=goog.html.SafeStyle.unwrap(style);};goog.dom.safe.documentWrite=function(doc,html){doc.write(goog.html.SafeHtml.unwrap(html));};goog.dom.safe.setAnchorHref=function(anchor,url){goog.dom.safe.assertIsHTMLAnchorElement_(anchor);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);anchor.href=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.setImageSrc=function(imageElement,url){goog.dom.safe.assertIsHTMLImageElement_(imageElement);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);imageElement.src=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.setEmbedSrc=function(embed,url){goog.dom.safe.assertIsHTMLEmbedElement_(embed);embed.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setFrameSrc=function(frame,url){goog.dom.safe.assertIsHTMLFrameElement_(frame);frame.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setIframeSrc=function(iframe,url){goog.dom.safe.assertIsHTMLIFrameElement_(iframe);iframe.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setIframeSrcdoc=function(iframe,html){goog.dom.safe.assertIsHTMLIFrameElement_(iframe);iframe.srcdoc=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setLinkHrefAndRel=function(link,url,rel){goog.dom.safe.assertIsHTMLLinkElement_(link);link.rel=rel;goog.string.caseInsensitiveContains(rel,"stylesheet")?(goog.asserts.assert(url instanceof goog.html.TrustedResourceUrl,\'URL must be TrustedResourceUrl because "rel" contains "stylesheet"\'),link.href=goog.html.TrustedResourceUrl.unwrap(url)):link.href=url instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrap(url):url instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrap(url):goog.html.SafeUrl.sanitize(url).getTypedStringValue();};goog.dom.safe.setObjectData=function(object,url){goog.dom.safe.assertIsHTMLObjectElement_(object);object.data=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setScriptSrc=function(script,url){goog.dom.safe.assertIsHTMLScriptElement_(script);script.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setScriptContent=function(script,content){goog.dom.safe.assertIsHTMLScriptElement_(script);script.text=goog.html.SafeScript.unwrap(content);};goog.dom.safe.setLocationHref=function(loc,url){goog.dom.safe.assertIsLocation_(loc);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);loc.href=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.openInWindow=function(url,opt_openerWin,opt_name,opt_specs,opt_replace){var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);return(opt_openerWin||window).open(goog.html.SafeUrl.unwrap(safeUrl),opt_name?goog.string.Const.unwrap(opt_name):"",opt_specs,opt_replace);};goog.dom.safe.assertIsLocation_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof Location||!(o instanceof Element)),"Argument is not a Location (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLAnchorElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLAnchorElement||!(o instanceof Location||o instanceof Element)),"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLLinkElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLLinkElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLLinkElement||!(o instanceof Location||o instanceof Element)),"Argument is not a HTMLLinkElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLImageElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLImageElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLImageElement||!(o instanceof Element)),"Argument is not a HTMLImageElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLEmbedElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLEmbedElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLEmbedElement||!(o instanceof Element)),"Argument is not a HTMLEmbedElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLFrameElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLFrameElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLFrameElement||!(o instanceof Element)),"Argument is not a HTMLFrameElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLIFrameElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLIFrameElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLIFrameElement||!(o instanceof Element)),"Argument is not a HTMLIFrameElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLObjectElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLObjectElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLObjectElement||!(o instanceof Element)),"Argument is not a HTMLObjectElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLScriptElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLScriptElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLScriptElement||!(o instanceof Element)),"Argument is not a HTMLScriptElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.debugStringForType_=function(value){return goog.isObject(value)?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):void 0===value?"undefined":null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(justification,html,opt_dir){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(html,opt_dir||null);};goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(justification,script){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(script);};goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(justification,style){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(justification,styleSheet){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheet);};goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(justification,url){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(justification,url){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(url);};goog.math.Coordinate=function(opt_x,opt_y){this.x=goog.isDef(opt_x)?opt_x:0;this.y=goog.isDef(opt_y)?opt_y:0;};goog.math.Coordinate.prototype.clone=function(){return new goog.math.Coordinate(this.x,this.y);};goog.DEBUG&&(goog.math.Coordinate.prototype.toString=function(){return"("+this.x+", "+this.y+")";});goog.math.Coordinate.prototype.equals=function(other){return other instanceof goog.math.Coordinate&&goog.math.Coordinate.equals(this,other);};goog.math.Coordinate.equals=function(a,b){return a==b?!0:a&&b?a.x==b.x&&a.y==b.y:!1;};goog.math.Coordinate.distance=function(a,b){var dx=a.x-b.x,dy=a.y-b.y;return Math.sqrt(dx*dx+dy*dy);};goog.math.Coordinate.magnitude=function(a){return Math.sqrt(a.x*a.x+a.y*a.y);};goog.math.Coordinate.azimuth=function(a){return goog.math.angle(0,0,a.x,a.y);};goog.math.Coordinate.squaredDistance=function(a,b){var dx=a.x-b.x,dy=a.y-b.y;return dx*dx+dy*dy;};goog.math.Coordinate.difference=function(a,b){return new goog.math.Coordinate(a.x-b.x,a.y-b.y);};goog.math.Coordinate.sum=function(a,b){return new goog.math.Coordinate(a.x+b.x,a.y+b.y);};goog.math.Coordinate.prototype.ceil=function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);return this;};goog.math.Coordinate.prototype.floor=function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);return this;};goog.math.Coordinate.prototype.round=function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this;};goog.math.Coordinate.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.x+=tx.x,this.y+=tx.y):(this.x+=Number(tx),goog.isNumber(opt_ty)&&(this.y+=opt_ty));return this;};goog.math.Coordinate.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.x*=sx;this.y*=sy;return this;};goog.math.Coordinate.prototype.rotateRadians=function(radians,opt_center){var center=opt_center||new goog.math.Coordinate(0,0),x=this.x,y=this.y,cos=Math.cos(radians),sin=Math.sin(radians);this.x=(x-center.x)*cos-(y-center.y)*sin+center.x;this.y=(x-center.x)*sin+(y-center.y)*cos+center.y;};goog.math.Coordinate.prototype.rotateDegrees=function(degrees,opt_center){this.rotateRadians(goog.math.toRadians(degrees),opt_center);};goog.math.Size=function(width,height){this.width=width;this.height=height;};goog.math.Size.equals=function(a,b){return a==b?!0:a&&b?a.width==b.width&&a.height==b.height:!1;};goog.math.Size.prototype.clone=function(){return new goog.math.Size(this.width,this.height);};goog.DEBUG&&(goog.math.Size.prototype.toString=function(){return"("+this.width+" x "+this.height+")";});goog.math.Size.prototype.getLongest=function(){return Math.max(this.width,this.height);};goog.math.Size.prototype.getShortest=function(){return Math.min(this.width,this.height);};goog.math.Size.prototype.area=function(){return this.width*this.height;};goog.math.Size.prototype.perimeter=function(){return 2*(this.width+this.height);};goog.math.Size.prototype.aspectRatio=function(){return this.width/this.height;};goog.math.Size.prototype.isEmpty=function(){return!this.area();};goog.math.Size.prototype.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this;};goog.math.Size.prototype.fitsInside=function(target){return this.width<=target.width&&this.height<=target.height;};goog.math.Size.prototype.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this;};goog.math.Size.prototype.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this;};goog.math.Size.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.width*=sx;this.height*=sy;return this;};goog.math.Size.prototype.scaleToCover=function(target){return this.scale(this.aspectRatio()<=target.aspectRatio()?target.width/this.width:target.height/this.height);};goog.math.Size.prototype.scaleToFit=function(target){return this.scale(this.aspectRatio()>target.aspectRatio()?target.width/this.width:target.height/this.height);};goog.dom.ASSUME_QUIRKS_MODE=!1;goog.dom.ASSUME_STANDARDS_MODE=!1;goog.dom.COMPAT_MODE_KNOWN_=goog.dom.ASSUME_QUIRKS_MODE||goog.dom.ASSUME_STANDARDS_MODE;goog.dom.getDomHelper=function(opt_element){return opt_element?new goog.dom.DomHelper(goog.dom.getOwnerDocument(opt_element)):goog.dom.defaultDomHelper_||(goog.dom.defaultDomHelper_=new goog.dom.DomHelper());};goog.dom.getDocument=function(){return document;};goog.dom.getElement=function(element){return goog.dom.getElementHelper_(document,element);};goog.dom.getElementHelper_=function(doc,element){return goog.isString(element)?doc.getElementById(element):element;};goog.dom.getRequiredElement=function(id){return goog.dom.getRequiredElementHelper_(document,id);};goog.dom.getRequiredElementHelper_=function(doc,id){goog.asserts.assertString(id);var element=goog.dom.getElementHelper_(doc,id);return element=goog.asserts.assertElement(element,"No element found with id: "+id);};goog.dom.$=goog.dom.getElement;goog.dom.getElementsByTagName=function(tagName,opt_parent){return(opt_parent||document).getElementsByTagName(String(tagName));};goog.dom.getElementsByTagNameAndClass=function(opt_tag,opt_class,opt_el){return goog.dom.getElementsByTagNameAndClass_(document,opt_tag,opt_class,opt_el);};goog.dom.getElementsByClass=function(className,opt_el){var parent=opt_el||document;return goog.dom.canUseQuerySelector_(parent)?parent.querySelectorAll("."+className):goog.dom.getElementsByTagNameAndClass_(document,"*",className,opt_el);};goog.dom.getElementByClass=function(className,opt_el){var parent=opt_el||document,retVal=null;return(retVal=parent.getElementsByClassName?parent.getElementsByClassName(className)[0]:goog.dom.canUseQuerySelector_(parent)?parent.querySelector("."+className):goog.dom.getElementsByTagNameAndClass_(document,"*",className,opt_el)[0])||null;};goog.dom.getRequiredElementByClass=function(className,opt_root){var retValue=goog.dom.getElementByClass(className,opt_root);return goog.asserts.assert(retValue,"No element found with className: "+className);};goog.dom.canUseQuerySelector_=function(parent){return!(!parent.querySelectorAll||!parent.querySelector);};goog.dom.getElementsByTagNameAndClass_=function(doc,opt_tag,opt_class,opt_el){var len,parent=opt_el||doc,tagName=opt_tag&&"*"!=opt_tag?String(opt_tag).toUpperCase():"";if(goog.dom.canUseQuerySelector_(parent)&&(tagName||opt_class)){return parent.querySelectorAll(tagName+(opt_class?"."+opt_class:""));}if(opt_class&&parent.getElementsByClassName){var els=parent.getElementsByClassName(opt_class);if(tagName){var arrayLike={};for(var i=len=0,el;el=els[i];i++){tagName==el.nodeName&&(arrayLike[len++]=el);}arrayLike.length=len;return arrayLike;}return els;}els=parent.getElementsByTagName(tagName||"*");if(opt_class){arrayLike={};for(i=len=0;el=els[i];i++){var className=el.className;"function"==typeof className.split&&goog.array.contains(className.split(/\\s+/),opt_class)&&(arrayLike[len++]=el);}arrayLike.length=len;return arrayLike;}return els;};goog.dom.$$=goog.dom.getElementsByTagNameAndClass;goog.dom.setProperties=function(element,properties){goog.object.forEach(properties,function(val,key){val&&val.implementsGoogStringTypedString&&(val=val.getTypedStringValue());"style"==key?element.style.cssText=val:"class"==key?element.className=val:"for"==key?element.htmlFor=val:goog.dom.DIRECT_ATTRIBUTE_MAP_.hasOwnProperty(key)?element.setAttribute(goog.dom.DIRECT_ATTRIBUTE_MAP_[key],val):goog.string.startsWith(key,"aria-")||goog.string.startsWith(key,"data-")?element.setAttribute(key,val):element[key]=val;});};goog.dom.DIRECT_ATTRIBUTE_MAP_={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};goog.dom.getViewportSize=function(opt_window){return goog.dom.getViewportSize_(opt_window||window);};goog.dom.getViewportSize_=function(win){var doc=win.document,el=goog.dom.isCss1CompatMode_(doc)?doc.documentElement:doc.body;return new goog.math.Size(el.clientWidth,el.clientHeight);};goog.dom.getDocumentHeight=function(){return goog.dom.getDocumentHeight_(window);};goog.dom.getDocumentHeightForWindow=function(win){return goog.dom.getDocumentHeight_(win);};goog.dom.getDocumentHeight_=function(win){var doc=win.document,height=0;if(doc){var body=doc.body,docEl=doc.documentElement;if(!docEl||!body){return 0;}var vh=goog.dom.getViewportSize_(win).height;if(goog.dom.isCss1CompatMode_(doc)&&docEl.scrollHeight){height=docEl.scrollHeight!=vh?docEl.scrollHeight:docEl.offsetHeight;}else{var sh=docEl.scrollHeight,oh=docEl.offsetHeight;docEl.clientHeight!=oh&&(sh=body.scrollHeight,oh=body.offsetHeight);height=sh>vh?sh>oh?sh:oh:sh<oh?sh:oh;}}return height;};goog.dom.getPageScroll=function(opt_window){return goog.dom.getDomHelper((opt_window||goog.global||window).document).getDocumentScroll();};goog.dom.getDocumentScroll=function(){return goog.dom.getDocumentScroll_(document);};goog.dom.getDocumentScroll_=function(doc){var el=goog.dom.getDocumentScrollElement_(doc),win=goog.dom.getWindow_(doc);return goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("10")&&win.pageYOffset!=el.scrollTop?new goog.math.Coordinate(el.scrollLeft,el.scrollTop):new goog.math.Coordinate(win.pageXOffset||el.scrollLeft,win.pageYOffset||el.scrollTop);};goog.dom.getDocumentScrollElement=function(){return goog.dom.getDocumentScrollElement_(document);};goog.dom.getDocumentScrollElement_=function(doc){return doc.scrollingElement?doc.scrollingElement:!goog.userAgent.WEBKIT&&goog.dom.isCss1CompatMode_(doc)?doc.documentElement:doc.body||doc.documentElement;};goog.dom.getWindow=function(opt_doc){return opt_doc?goog.dom.getWindow_(opt_doc):window;};goog.dom.getWindow_=function(doc){return doc.parentWindow||doc.defaultView;};goog.dom.createDom=function(tagName,opt_properties,var_args){return goog.dom.createDom_(document,arguments);};goog.dom.createDom_=function(doc,args){var tagName=String(args[0]),attributes=args[1];if(!goog.dom.BrowserFeature.CAN_ADD_NAME_OR_TYPE_ATTRIBUTES&&attributes&&(attributes.name||attributes.type)){var tagNameArr=["<",tagName];attributes.name&&tagNameArr.push(\' name="\',goog.string.htmlEscape(attributes.name),\'"\');if(attributes.type){tagNameArr.push(\' type="\',goog.string.htmlEscape(attributes.type),\'"\');var clone={};goog.object.extend(clone,attributes);delete clone.type;attributes=clone;}tagNameArr.push(">");tagName=tagNameArr.join("");}var element=doc.createElement(tagName);attributes&&(goog.isString(attributes)?element.className=attributes:goog.isArray(attributes)?element.className=attributes.join(" "):goog.dom.setProperties(element,attributes));2<args.length&&goog.dom.append_(doc,element,args,2);return element;};goog.dom.append_=function(doc,parent,args,startIndex){function childHandler(child){child&&parent.appendChild(goog.isString(child)?doc.createTextNode(child):child);}for(var i=startIndex;i<args.length;i++){var arg=args[i];goog.isArrayLike(arg)&&!goog.dom.isNodeLike(arg)?goog.array.forEach(goog.dom.isNodeList(arg)?goog.array.toArray(arg):arg,childHandler):childHandler(arg);}};goog.dom.$dom=goog.dom.createDom;goog.dom.createElement=function(name){return goog.dom.createElement_(document,name);};goog.dom.createElement_=function(doc,name){return doc.createElement(String(name));};goog.dom.createTextNode=function(content){return document.createTextNode(String(content));};goog.dom.createTable=function(rows,columns,opt_fillWithNbsp){return goog.dom.createTable_(document,rows,columns,!!opt_fillWithNbsp);};goog.dom.createTable_=function(doc,rows,columns,fillWithNbsp){for(var table=goog.dom.createElement_(doc,"TABLE"),tbody=table.appendChild(goog.dom.createElement_(doc,"TBODY")),i=0;i<rows;i++){for(var tr=goog.dom.createElement_(doc,"TR"),j=0;j<columns;j++){var td=goog.dom.createElement_(doc,"TD");fillWithNbsp&&goog.dom.setTextContent(td,goog.string.Unicode.NBSP);tr.appendChild(td);}tbody.appendChild(tr);}return table;};goog.dom.constHtmlToNode=function(var_args){var stringArray=goog.array.map(arguments,goog.string.Const.unwrap),safeHtml=goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML string, that gets turned into a Node later, so it will be automatically balanced."),stringArray.join(""));return goog.dom.safeHtmlToNode(safeHtml);};goog.dom.safeHtmlToNode=function(html){return goog.dom.safeHtmlToNode_(document,html);};goog.dom.safeHtmlToNode_=function(doc,html){var tempDiv=goog.dom.createElement_(doc,"DIV");goog.dom.BrowserFeature.INNER_HTML_NEEDS_SCOPED_ELEMENT?(goog.dom.safe.setInnerHtml(tempDiv,goog.html.SafeHtml.concat(goog.html.SafeHtml.BR,html)),tempDiv.removeChild(tempDiv.firstChild)):goog.dom.safe.setInnerHtml(tempDiv,html);return goog.dom.childrenToNode_(doc,tempDiv);};goog.dom.childrenToNode_=function(doc,tempDiv){if(1==tempDiv.childNodes.length){return tempDiv.removeChild(tempDiv.firstChild);}for(var fragment=doc.createDocumentFragment();tempDiv.firstChild;){fragment.appendChild(tempDiv.firstChild);}return fragment;};goog.dom.isCss1CompatMode=function(){return goog.dom.isCss1CompatMode_(document);};goog.dom.isCss1CompatMode_=function(doc){return goog.dom.COMPAT_MODE_KNOWN_?goog.dom.ASSUME_STANDARDS_MODE:"CSS1Compat"==doc.compatMode;};goog.dom.canHaveChildren=function(node){if(node.nodeType!=goog.dom.NodeType.ELEMENT){return!1;}switch(node.tagName){case"APPLET":case"AREA":case"BASE":case"BR":case"COL":case"COMMAND":case"EMBED":case"FRAME":case"HR":case"IMG":case"INPUT":case"IFRAME":case"ISINDEX":case"KEYGEN":case"LINK":case"NOFRAMES":case"NOSCRIPT":case"META":case"OBJECT":case"PARAM":case"SCRIPT":case"SOURCE":case"STYLE":case"TRACK":case"WBR":return!1;}return!0;};goog.dom.appendChild=function(parent,child){parent.appendChild(child);};goog.dom.append=function(parent,var_args){goog.dom.append_(goog.dom.getOwnerDocument(parent),parent,arguments,1);};goog.dom.removeChildren=function(node){for(var child;child=node.firstChild;){node.removeChild(child);}};goog.dom.insertSiblingBefore=function(newNode,refNode){refNode.parentNode&&refNode.parentNode.insertBefore(newNode,refNode);};goog.dom.insertSiblingAfter=function(newNode,refNode){refNode.parentNode&&refNode.parentNode.insertBefore(newNode,refNode.nextSibling);};goog.dom.insertChildAt=function(parent,child,index){parent.insertBefore(child,parent.childNodes[index]||null);};goog.dom.removeNode=function(node){return node&&node.parentNode?node.parentNode.removeChild(node):null;};goog.dom.replaceNode=function(newNode,oldNode){var parent=oldNode.parentNode;parent&&parent.replaceChild(newNode,oldNode);};goog.dom.flattenElement=function(element){var child,parent=element.parentNode;if(parent&&parent.nodeType!=goog.dom.NodeType.DOCUMENT_FRAGMENT){if(element.removeNode){return element.removeNode(!1);}for(;child=element.firstChild;){parent.insertBefore(child,element);}return goog.dom.removeNode(element);}};goog.dom.getChildren=function(element){return goog.dom.BrowserFeature.CAN_USE_CHILDREN_ATTRIBUTE&&void 0!=element.children?element.children:goog.array.filter(element.childNodes,function(node){return node.nodeType==goog.dom.NodeType.ELEMENT;});};goog.dom.getFirstElementChild=function(node){return goog.isDef(node.firstElementChild)?node.firstElementChild:goog.dom.getNextElementNode_(node.firstChild,!0);};goog.dom.getLastElementChild=function(node){return goog.isDef(node.lastElementChild)?node.lastElementChild:goog.dom.getNextElementNode_(node.lastChild,!1);};goog.dom.getNextElementSibling=function(node){return goog.isDef(node.nextElementSibling)?node.nextElementSibling:goog.dom.getNextElementNode_(node.nextSibling,!0);};goog.dom.getPreviousElementSibling=function(node){return goog.isDef(node.previousElementSibling)?node.previousElementSibling:goog.dom.getNextElementNode_(node.previousSibling,!1);};goog.dom.getNextElementNode_=function(node,forward){for(;node&&node.nodeType!=goog.dom.NodeType.ELEMENT;){node=forward?node.nextSibling:node.previousSibling;}return node;};goog.dom.getNextNode=function(node){if(!node){return null;}if(node.firstChild){return node.firstChild;}for(;node&&!node.nextSibling;){node=node.parentNode;}return node?node.nextSibling:null;};goog.dom.getPreviousNode=function(node){if(!node){return null;}if(!node.previousSibling){return node.parentNode;}for(node=node.previousSibling;node&&node.lastChild;){node=node.lastChild;}return node;};goog.dom.isNodeLike=function(obj){return goog.isObject(obj)&&0<obj.nodeType;};goog.dom.isElement=function(obj){return goog.isObject(obj)&&obj.nodeType==goog.dom.NodeType.ELEMENT;};goog.dom.isWindow=function(obj){return goog.isObject(obj)&&obj.window==obj;};goog.dom.getParentElement=function(element){var parent;if(goog.dom.BrowserFeature.CAN_USE_PARENT_ELEMENT_PROPERTY&&!(goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("9")&&!goog.userAgent.isVersionOrHigher("10")&&goog.global.SVGElement&&element instanceof goog.global.SVGElement)&&(parent=element.parentElement)){return parent;}parent=element.parentNode;return goog.dom.isElement(parent)?parent:null;};goog.dom.contains=function(parent,descendant){if(!parent||!descendant){return!1;}if(parent.contains&&descendant.nodeType==goog.dom.NodeType.ELEMENT){return parent==descendant||parent.contains(descendant);}if("undefined"!=typeof parent.compareDocumentPosition){return parent==descendant||!!(parent.compareDocumentPosition(descendant)&16);}for(;descendant&&parent!=descendant;){descendant=descendant.parentNode;}return descendant==parent;};goog.dom.compareNodeOrder=function(node1,node2){if(node1==node2){return 0;}if(node1.compareDocumentPosition){return node1.compareDocumentPosition(node2)&2?1:-1;}if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)){if(node1.nodeType==goog.dom.NodeType.DOCUMENT){return-1;}if(node2.nodeType==goog.dom.NodeType.DOCUMENT){return 1;}}if("sourceIndex"in node1||node1.parentNode&&"sourceIndex"in node1.parentNode){var isElement1=node1.nodeType==goog.dom.NodeType.ELEMENT,isElement2=node2.nodeType==goog.dom.NodeType.ELEMENT;if(isElement1&&isElement2){return node1.sourceIndex-node2.sourceIndex;}var parent1=node1.parentNode,parent2=node2.parentNode;return parent1==parent2?goog.dom.compareSiblingOrder_(node1,node2):!isElement1&&goog.dom.contains(parent1,node2)?-1*goog.dom.compareParentsDescendantNodeIe_(node1,node2):!isElement2&&goog.dom.contains(parent2,node1)?goog.dom.compareParentsDescendantNodeIe_(node2,node1):(isElement1?node1.sourceIndex:parent1.sourceIndex)-(isElement2?node2.sourceIndex:parent2.sourceIndex);}var doc=goog.dom.getOwnerDocument(node1);var range1=doc.createRange();range1.selectNode(node1);range1.collapse(!0);var range2=doc.createRange();range2.selectNode(node2);range2.collapse(!0);return range1.compareBoundaryPoints(goog.global.Range.START_TO_END,range2);};goog.dom.compareParentsDescendantNodeIe_=function(textNode,node){var parent=textNode.parentNode;if(parent==node){return-1;}for(var sibling=node;sibling.parentNode!=parent;){sibling=sibling.parentNode;}return goog.dom.compareSiblingOrder_(sibling,textNode);};goog.dom.compareSiblingOrder_=function(node1,node2){for(var s=node2;s=s.previousSibling;){if(s==node1){return-1;}}return 1;};goog.dom.findCommonAncestor=function(var_args){var i,count=arguments.length;if(!count){return null;}if(1==count){return arguments[0];}var paths=[],minLength=Infinity;for(i=0;i<count;i++){for(var ancestors=[],node=arguments[i];node;){ancestors.unshift(node),node=node.parentNode;}paths.push(ancestors);minLength=Math.min(minLength,ancestors.length);}var output=null;for(i=0;i<minLength;i++){for(var first=paths[0][i],j=1;j<count;j++){if(first!=paths[j][i]){return output;}}output=first;}return output;};goog.dom.getOwnerDocument=function(node){goog.asserts.assert(node,"Node cannot be null or undefined.");return node.nodeType==goog.dom.NodeType.DOCUMENT?node:node.ownerDocument||node.document;};goog.dom.getFrameContentDocument=function(frame){return frame.contentDocument||frame.contentWindow.document;};goog.dom.getFrameContentWindow=function(frame){try{return frame.contentWindow||(frame.contentDocument?goog.dom.getWindow(frame.contentDocument):null);}catch(e){}return null;};goog.dom.setTextContent=function(node,text){goog.asserts.assert(null!=node,"goog.dom.setTextContent expects a non-null value for node");if("textContent"in node){node.textContent=text;}else{if(node.nodeType==goog.dom.NodeType.TEXT){node.data=text;}else{if(node.firstChild&&node.firstChild.nodeType==goog.dom.NodeType.TEXT){for(;node.lastChild!=node.firstChild;){node.removeChild(node.lastChild);}node.firstChild.data=text;}else{goog.dom.removeChildren(node);var doc=goog.dom.getOwnerDocument(node);node.appendChild(doc.createTextNode(String(text)));}}}};goog.dom.getOuterHtml=function(element){goog.asserts.assert(null!==element,"goog.dom.getOuterHtml expects a non-null value for element");if("outerHTML"in element){return element.outerHTML;}var doc=goog.dom.getOwnerDocument(element),div=goog.dom.createElement_(doc,"DIV");div.appendChild(element.cloneNode(!0));return div.innerHTML;};goog.dom.findNode=function(root,p){var rv=[];return goog.dom.findNodes_(root,p,rv,!0)?rv[0]:void 0;};goog.dom.findNodes=function(root,p){var rv=[];goog.dom.findNodes_(root,p,rv,!1);return rv;};goog.dom.findNodes_=function(root,p,rv,findOne){if(null!=root){for(var child=root.firstChild;child;){if(p(child)&&(rv.push(child),findOne)||goog.dom.findNodes_(child,p,rv,findOne)){return!0;}child=child.nextSibling;}}return!1;};goog.dom.TAGS_TO_IGNORE_={SCRIPT:1,STYLE:1,HEAD:1,IFRAME:1,OBJECT:1};goog.dom.PREDEFINED_TAG_VALUES_={IMG:" ",BR:"\\n"};goog.dom.isFocusableTabIndex=function(element){return goog.dom.hasSpecifiedTabIndex_(element)&&goog.dom.isTabIndexFocusable_(element);};goog.dom.setFocusableTabIndex=function(element,enable){enable?element.tabIndex=0:(element.tabIndex=-1,element.removeAttribute("tabIndex"));};goog.dom.isFocusable=function(element){var focusable;return(focusable=goog.dom.nativelySupportsFocus_(element)?!element.disabled&&(!goog.dom.hasSpecifiedTabIndex_(element)||goog.dom.isTabIndexFocusable_(element)):goog.dom.isFocusableTabIndex(element))&&goog.userAgent.IE?goog.dom.hasNonZeroBoundingRect_(element):focusable;};goog.dom.hasSpecifiedTabIndex_=function(element){if(goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9")){var attrNode=element.getAttributeNode("tabindex");return goog.isDefAndNotNull(attrNode)&&attrNode.specified;}return element.hasAttribute("tabindex");};goog.dom.isTabIndexFocusable_=function(element){var index=element.tabIndex;return goog.isNumber(index)&&0<=index&&32768>index;};goog.dom.nativelySupportsFocus_=function(element){return"A"==element.tagName||"INPUT"==element.tagName||"TEXTAREA"==element.tagName||"SELECT"==element.tagName||"BUTTON"==element.tagName;};goog.dom.hasNonZeroBoundingRect_=function(element){var rect=!goog.isFunction(element.getBoundingClientRect)||goog.userAgent.IE&&null==element.parentElement?{height:element.offsetHeight,width:element.offsetWidth}:element.getBoundingClientRect();return goog.isDefAndNotNull(rect)&&0<rect.height&&0<rect.width;};goog.dom.getTextContent=function(node){if(goog.dom.BrowserFeature.CAN_USE_INNER_TEXT&&null!==node&&"innerText"in node){var textContent=goog.string.canonicalizeNewlines(node.innerText);}else{var buf=[];goog.dom.getTextContent_(node,buf,!0);textContent=buf.join("");}textContent=textContent.replace(/ \\xAD /g," ").replace(/\\xAD/g,"");textContent=textContent.replace(/\\u200B/g,"");goog.dom.BrowserFeature.CAN_USE_INNER_TEXT||(textContent=textContent.replace(/ +/g," "));" "!=textContent&&(textContent=textContent.replace(/^\\s*/,""));return textContent;};goog.dom.getRawTextContent=function(node){var buf=[];goog.dom.getTextContent_(node,buf,!1);return buf.join("");};goog.dom.getTextContent_=function(node,buf,normalizeWhitespace){if(!(node.nodeName in goog.dom.TAGS_TO_IGNORE_)){if(node.nodeType==goog.dom.NodeType.TEXT){normalizeWhitespace?buf.push(String(node.nodeValue).replace(/(\\r\\n|\\r|\\n)/g,"")):buf.push(node.nodeValue);}else{if(node.nodeName in goog.dom.PREDEFINED_TAG_VALUES_){buf.push(goog.dom.PREDEFINED_TAG_VALUES_[node.nodeName]);}else{for(var child=node.firstChild;child;){goog.dom.getTextContent_(child,buf,normalizeWhitespace),child=child.nextSibling;}}}}};goog.dom.getNodeTextLength=function(node){return goog.dom.getTextContent(node).length;};goog.dom.getNodeTextOffset=function(node,opt_offsetParent){for(var root=opt_offsetParent||goog.dom.getOwnerDocument(node).body,buf=[];node&&node!=root;){for(var cur=node;cur=cur.previousSibling;){buf.unshift(goog.dom.getTextContent(cur));}node=node.parentNode;}return goog.string.trimLeft(buf.join("")).replace(/ +/g," ").length;};goog.dom.getNodeAtOffset=function(parent,offset,opt_result){for(var stack=[parent],pos=0,cur=null;0<stack.length&&pos<offset;){if(cur=stack.pop(),!(cur.nodeName in goog.dom.TAGS_TO_IGNORE_)){if(cur.nodeType==goog.dom.NodeType.TEXT){var text=cur.nodeValue.replace(/(\\r\\n|\\r|\\n)/g,"").replace(/ +/g," "),pos=pos+text.length;}else{if(cur.nodeName in goog.dom.PREDEFINED_TAG_VALUES_){pos+=goog.dom.PREDEFINED_TAG_VALUES_[cur.nodeName].length;}else{for(var i=cur.childNodes.length-1;0<=i;i--){stack.push(cur.childNodes[i]);}}}}}goog.isObject(opt_result)&&(opt_result.remainder=cur?cur.nodeValue.length+offset-pos-1:0,opt_result.node=cur);return cur;};goog.dom.isNodeList=function(val){if(val&&"number"==typeof val.length){if(goog.isObject(val)){return"function"==typeof val.item||"string"==typeof val.item;}if(goog.isFunction(val)){return"function"==typeof val.item;}}return!1;};goog.dom.getAncestorByTagNameAndClass=function(element,opt_tag,opt_class,opt_maxSearchSteps){if(!opt_tag&&!opt_class){return null;}var tagName=opt_tag?String(opt_tag).toUpperCase():null;return goog.dom.getAncestor(element,function(node){return(!tagName||node.nodeName==tagName)&&(!opt_class||goog.isString(node.className)&&goog.array.contains(node.className.split(/\\s+/),opt_class));},!0,opt_maxSearchSteps);};goog.dom.getAncestorByClass=function(element,className,opt_maxSearchSteps){return goog.dom.getAncestorByTagNameAndClass(element,null,className,opt_maxSearchSteps);};goog.dom.getAncestor=function(element,matcher,opt_includeNode,opt_maxSearchSteps){element&&!opt_includeNode&&(element=element.parentNode);for(var steps=0;element&&(null==opt_maxSearchSteps||steps<=opt_maxSearchSteps);){goog.asserts.assert("parentNode"!=element.name);if(matcher(element)){return element;}element=element.parentNode;steps++;}return null;};goog.dom.getActiveElement=function(doc){try{return doc&&doc.activeElement;}catch(e){}return null;};goog.dom.getPixelRatio=function(){var win=goog.dom.getWindow();return goog.isDef(win.devicePixelRatio)?win.devicePixelRatio:win.matchMedia?goog.dom.matchesPixelRatio_(3)||goog.dom.matchesPixelRatio_(2)||goog.dom.matchesPixelRatio_(1.5)||goog.dom.matchesPixelRatio_(1)||.75:1;};goog.dom.matchesPixelRatio_=function(pixelRatio){return goog.dom.getWindow().matchMedia("(min-resolution: "+pixelRatio+"dppx),(min--moz-device-pixel-ratio: "+pixelRatio+"),(min-resolution: "+96*pixelRatio+"dpi)").matches?pixelRatio:0;};goog.dom.getCanvasContext2D=function(canvas){return canvas.getContext("2d");};goog.dom.DomHelper=function(opt_document){this.document_=opt_document||goog.global.document||document;};goog.dom.DomHelper.prototype.getDomHelper=goog.dom.getDomHelper;goog.dom.DomHelper.prototype.setDocument=function(document){this.document_=document;};goog.dom.DomHelper.prototype.getDocument=function(){return this.document_;};goog.dom.DomHelper.prototype.getElement=function(element){return goog.dom.getElementHelper_(this.document_,element);};goog.dom.DomHelper.prototype.getRequiredElement=function(id){return goog.dom.getRequiredElementHelper_(this.document_,id);};goog.dom.DomHelper.prototype.$=goog.dom.DomHelper.prototype.getElement;goog.dom.DomHelper.prototype.getElementsByTagName=function(tagName,opt_parent){return(opt_parent||this.document_).getElementsByTagName(String(tagName));};goog.dom.DomHelper.prototype.getElementsByTagNameAndClass=function(opt_tag,opt_class,opt_el){return goog.dom.getElementsByTagNameAndClass_(this.document_,opt_tag,opt_class,opt_el);};goog.dom.DomHelper.prototype.getElementsByClass=function(className,opt_el){return goog.dom.getElementsByClass(className,opt_el||this.document_);};goog.dom.DomHelper.prototype.getElementByClass=function(className,opt_el){return goog.dom.getElementByClass(className,opt_el||this.document_);};goog.dom.DomHelper.prototype.getRequiredElementByClass=function(className,opt_root){return goog.dom.getRequiredElementByClass(className,opt_root||this.document_);};goog.dom.DomHelper.prototype.$$=goog.dom.DomHelper.prototype.getElementsByTagNameAndClass;goog.dom.DomHelper.prototype.setProperties=goog.dom.setProperties;goog.dom.DomHelper.prototype.getViewportSize=function(opt_window){return goog.dom.getViewportSize(opt_window||this.getWindow());};goog.dom.DomHelper.prototype.getDocumentHeight=function(){return goog.dom.getDocumentHeight_(this.getWindow());};goog.dom.DomHelper.prototype.createDom=function(tagName,opt_attributes,var_args){return goog.dom.createDom_(this.document_,arguments);};goog.dom.DomHelper.prototype.$dom=goog.dom.DomHelper.prototype.createDom;goog.dom.DomHelper.prototype.createElement=function(name){return goog.dom.createElement_(this.document_,name);};goog.dom.DomHelper.prototype.createTextNode=function(content){return this.document_.createTextNode(String(content));};goog.dom.DomHelper.prototype.createTable=function(rows,columns,opt_fillWithNbsp){return goog.dom.createTable_(this.document_,rows,columns,!!opt_fillWithNbsp);};goog.dom.DomHelper.prototype.safeHtmlToNode=function(html){return goog.dom.safeHtmlToNode_(this.document_,html);};goog.dom.DomHelper.prototype.isCss1CompatMode=function(){return goog.dom.isCss1CompatMode_(this.document_);};goog.dom.DomHelper.prototype.getWindow=function(){return goog.dom.getWindow_(this.document_);};goog.dom.DomHelper.prototype.getDocumentScrollElement=function(){return goog.dom.getDocumentScrollElement_(this.document_);};goog.dom.DomHelper.prototype.getDocumentScroll=function(){return goog.dom.getDocumentScroll_(this.document_);};goog.dom.DomHelper.prototype.getActiveElement=function(opt_doc){return goog.dom.getActiveElement(opt_doc||this.document_);};goog.dom.DomHelper.prototype.appendChild=goog.dom.appendChild;goog.dom.DomHelper.prototype.append=goog.dom.append;goog.dom.DomHelper.prototype.canHaveChildren=goog.dom.canHaveChildren;goog.dom.DomHelper.prototype.removeChildren=goog.dom.removeChildren;goog.dom.DomHelper.prototype.insertSiblingBefore=goog.dom.insertSiblingBefore;goog.dom.DomHelper.prototype.insertSiblingAfter=goog.dom.insertSiblingAfter;goog.dom.DomHelper.prototype.insertChildAt=goog.dom.insertChildAt;goog.dom.DomHelper.prototype.removeNode=goog.dom.removeNode;goog.dom.DomHelper.prototype.replaceNode=goog.dom.replaceNode;goog.dom.DomHelper.prototype.flattenElement=goog.dom.flattenElement;goog.dom.DomHelper.prototype.getChildren=goog.dom.getChildren;goog.dom.DomHelper.prototype.getFirstElementChild=goog.dom.getFirstElementChild;goog.dom.DomHelper.prototype.getLastElementChild=goog.dom.getLastElementChild;goog.dom.DomHelper.prototype.getNextElementSibling=goog.dom.getNextElementSibling;goog.dom.DomHelper.prototype.getPreviousElementSibling=goog.dom.getPreviousElementSibling;goog.dom.DomHelper.prototype.getNextNode=goog.dom.getNextNode;goog.dom.DomHelper.prototype.getPreviousNode=goog.dom.getPreviousNode;goog.dom.DomHelper.prototype.isNodeLike=goog.dom.isNodeLike;goog.dom.DomHelper.prototype.isElement=goog.dom.isElement;goog.dom.DomHelper.prototype.isWindow=goog.dom.isWindow;goog.dom.DomHelper.prototype.getParentElement=goog.dom.getParentElement;goog.dom.DomHelper.prototype.contains=goog.dom.contains;goog.dom.DomHelper.prototype.compareNodeOrder=goog.dom.compareNodeOrder;goog.dom.DomHelper.prototype.findCommonAncestor=goog.dom.findCommonAncestor;goog.dom.DomHelper.prototype.getOwnerDocument=goog.dom.getOwnerDocument;goog.dom.DomHelper.prototype.getFrameContentDocument=goog.dom.getFrameContentDocument;goog.dom.DomHelper.prototype.getFrameContentWindow=goog.dom.getFrameContentWindow;goog.dom.DomHelper.prototype.setTextContent=goog.dom.setTextContent;goog.dom.DomHelper.prototype.getOuterHtml=goog.dom.getOuterHtml;goog.dom.DomHelper.prototype.findNode=goog.dom.findNode;goog.dom.DomHelper.prototype.findNodes=goog.dom.findNodes;goog.dom.DomHelper.prototype.isFocusableTabIndex=goog.dom.isFocusableTabIndex;goog.dom.DomHelper.prototype.setFocusableTabIndex=goog.dom.setFocusableTabIndex;goog.dom.DomHelper.prototype.isFocusable=goog.dom.isFocusable;goog.dom.DomHelper.prototype.getTextContent=goog.dom.getTextContent;goog.dom.DomHelper.prototype.getNodeTextLength=goog.dom.getNodeTextLength;goog.dom.DomHelper.prototype.getNodeTextOffset=goog.dom.getNodeTextOffset;goog.dom.DomHelper.prototype.getNodeAtOffset=goog.dom.getNodeAtOffset;goog.dom.DomHelper.prototype.isNodeList=goog.dom.isNodeList;goog.dom.DomHelper.prototype.getAncestorByTagNameAndClass=goog.dom.getAncestorByTagNameAndClass;goog.dom.DomHelper.prototype.getAncestorByClass=goog.dom.getAncestorByClass;goog.dom.DomHelper.prototype.getAncestor=goog.dom.getAncestor;goog.dom.DomHelper.prototype.getCanvasContext2D=goog.dom.getCanvasContext2D;goog.dom.vendor={};goog.dom.vendor.getVendorJsPrefix=function(){return goog.userAgent.WEBKIT?"Webkit":goog.userAgent.GECKO?"Moz":goog.userAgent.IE?"ms":goog.userAgent.OPERA?"O":null;};goog.dom.vendor.getVendorPrefix=function(){return goog.userAgent.WEBKIT?"-webkit":goog.userAgent.GECKO?"-moz":goog.userAgent.IE?"-ms":goog.userAgent.OPERA?"-o":null;};goog.dom.vendor.getPrefixedPropertyName=function(propertyName,opt_object){if(opt_object&&propertyName in opt_object){return propertyName;}var prefix=goog.dom.vendor.getVendorJsPrefix();if(prefix){var prefix=prefix.toLowerCase(),prefixedPropertyName=prefix+goog.string.toTitleCase(propertyName);return!goog.isDef(opt_object)||prefixedPropertyName in opt_object?prefixedPropertyName:null;}return null;};goog.dom.vendor.getPrefixedEventType=function(eventType){return((goog.dom.vendor.getVendorJsPrefix()||"")+eventType).toLowerCase();};goog.html.legacyconversions={};goog.html.legacyconversions.safeHtmlFromString=function(html){goog.html.legacyconversions.reportCallback_();return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(html,null);};goog.html.legacyconversions.safeStyleFromString=function(style){goog.html.legacyconversions.reportCallback_();return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.legacyconversions.safeStyleSheetFromString=function(styleSheet){goog.html.legacyconversions.reportCallback_();return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheet);};goog.html.legacyconversions.safeUrlFromString=function(url){goog.html.legacyconversions.reportCallback_();return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.legacyconversions.trustedResourceUrlFromString=function(url){goog.html.legacyconversions.reportCallback_();return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.legacyconversions.reportCallback_=goog.nullFunction;goog.html.legacyconversions.setReportCallback=function(callback){goog.html.legacyconversions.reportCallback_=callback;};goog.math.Box=function(top,right,bottom,left){this.top=top;this.right=right;this.bottom=bottom;this.left=left;};goog.math.Box.boundingBox=function(var_args){for(var box=new goog.math.Box(arguments[0].y,arguments[0].x,arguments[0].y,arguments[0].x),i=1;i<arguments.length;i++){box.expandToIncludeCoordinate(arguments[i]);}return box;};goog.math.Box.prototype.getWidth=function(){return this.right-this.left;};goog.math.Box.prototype.getHeight=function(){return this.bottom-this.top;};goog.math.Box.prototype.clone=function(){return new goog.math.Box(this.top,this.right,this.bottom,this.left);};goog.DEBUG&&(goog.math.Box.prototype.toString=function(){return"("+this.top+"t, "+this.right+"r, "+this.bottom+"b, "+this.left+"l)";});goog.math.Box.prototype.contains=function(other){return goog.math.Box.contains(this,other);};goog.math.Box.prototype.expand=function(top,opt_right,opt_bottom,opt_left){goog.isObject(top)?(this.top-=top.top,this.right+=top.right,this.bottom+=top.bottom,this.left-=top.left):(this.top-=top,this.right+=Number(opt_right),this.bottom+=Number(opt_bottom),this.left-=Number(opt_left));return this;};goog.math.Box.prototype.expandToInclude=function(box){this.left=Math.min(this.left,box.left);this.top=Math.min(this.top,box.top);this.right=Math.max(this.right,box.right);this.bottom=Math.max(this.bottom,box.bottom);};goog.math.Box.prototype.expandToIncludeCoordinate=function(coord){this.top=Math.min(this.top,coord.y);this.right=Math.max(this.right,coord.x);this.bottom=Math.max(this.bottom,coord.y);this.left=Math.min(this.left,coord.x);};goog.math.Box.equals=function(a,b){return a==b?!0:a&&b?a.top==b.top&&a.right==b.right&&a.bottom==b.bottom&&a.left==b.left:!1;};goog.math.Box.contains=function(box,other){return box&&other?other instanceof goog.math.Box?other.left>=box.left&&other.right<=box.right&&other.top>=box.top&&other.bottom<=box.bottom:other.x>=box.left&&other.x<=box.right&&other.y>=box.top&&other.y<=box.bottom:!1;};goog.math.Box.relativePositionX=function(box,coord){return coord.x<box.left?coord.x-box.left:coord.x>box.right?coord.x-box.right:0;};goog.math.Box.relativePositionY=function(box,coord){return coord.y<box.top?coord.y-box.top:coord.y>box.bottom?coord.y-box.bottom:0;};goog.math.Box.distance=function(box,coord){var x=goog.math.Box.relativePositionX(box,coord),y=goog.math.Box.relativePositionY(box,coord);return Math.sqrt(x*x+y*y);};goog.math.Box.intersects=function(a,b){return a.left<=b.right&&b.left<=a.right&&a.top<=b.bottom&&b.top<=a.bottom;};goog.math.Box.intersectsWithPadding=function(a,b,padding){return a.left<=b.right+padding&&b.left<=a.right+padding&&a.top<=b.bottom+padding&&b.top<=a.bottom+padding;};goog.math.Box.prototype.ceil=function(){this.top=Math.ceil(this.top);this.right=Math.ceil(this.right);this.bottom=Math.ceil(this.bottom);this.left=Math.ceil(this.left);return this;};goog.math.Box.prototype.floor=function(){this.top=Math.floor(this.top);this.right=Math.floor(this.right);this.bottom=Math.floor(this.bottom);this.left=Math.floor(this.left);return this;};goog.math.Box.prototype.round=function(){this.top=Math.round(this.top);this.right=Math.round(this.right);this.bottom=Math.round(this.bottom);this.left=Math.round(this.left);return this;};goog.math.Box.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.left+=tx.x,this.right+=tx.x,this.top+=tx.y,this.bottom+=tx.y):(goog.asserts.assertNumber(tx),this.left+=tx,this.right+=tx,goog.isNumber(opt_ty)&&(this.top+=opt_ty,this.bottom+=opt_ty));return this;};goog.math.Box.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.left*=sx;this.right*=sx;this.top*=sy;this.bottom*=sy;return this;};goog.math.IRect=function(){};goog.math.Rect=function(x,y,w,h){this.left=x;this.top=y;this.width=w;this.height=h;};goog.math.Rect.prototype.clone=function(){return new goog.math.Rect(this.left,this.top,this.width,this.height);};goog.math.Rect.prototype.toBox=function(){return new goog.math.Box(this.top,this.left+this.width,this.top+this.height,this.left);};goog.math.Rect.createFromPositionAndSize=function(position,size){return new goog.math.Rect(position.x,position.y,size.width,size.height);};goog.math.Rect.createFromBox=function(box){return new goog.math.Rect(box.left,box.top,box.right-box.left,box.bottom-box.top);};goog.DEBUG&&(goog.math.Rect.prototype.toString=function(){return"("+this.left+", "+this.top+" - "+this.width+"w x "+this.height+"h)";});goog.math.Rect.equals=function(a,b){return a==b?!0:a&&b?a.left==b.left&&a.width==b.width&&a.top==b.top&&a.height==b.height:!1;};goog.math.Rect.prototype.intersection=function(rect){var x0=Math.max(this.left,rect.left),x1=Math.min(this.left+this.width,rect.left+rect.width);if(x0<=x1){var y0=Math.max(this.top,rect.top),y1=Math.min(this.top+this.height,rect.top+rect.height);if(y0<=y1){return this.left=x0,this.top=y0,this.width=x1-x0,this.height=y1-y0,!0;}}return!1;};goog.math.Rect.intersection=function(a,b){var x0=Math.max(a.left,b.left),x1=Math.min(a.left+a.width,b.left+b.width);if(x0<=x1){var y0=Math.max(a.top,b.top),y1=Math.min(a.top+a.height,b.top+b.height);if(y0<=y1){return new goog.math.Rect(x0,y0,x1-x0,y1-y0);}}return null;};goog.math.Rect.intersects=function(a,b){return a.left<=b.left+b.width&&b.left<=a.left+a.width&&a.top<=b.top+b.height&&b.top<=a.top+a.height;};goog.math.Rect.prototype.intersects=function(rect){return goog.math.Rect.intersects(this,rect);};goog.math.Rect.difference=function(a,b){var intersection=goog.math.Rect.intersection(a,b);if(!intersection||!intersection.height||!intersection.width){return[a.clone()];}var result=[],top=a.top,height=a.height,ar=a.left+a.width,ab=a.top+a.height,br=b.left+b.width,bb=b.top+b.height;b.top>a.top&&(result.push(new goog.math.Rect(a.left,a.top,a.width,b.top-a.top)),top=b.top,height-=b.top-a.top);bb<ab&&(result.push(new goog.math.Rect(a.left,bb,a.width,ab-bb)),height=bb-top);b.left>a.left&&result.push(new goog.math.Rect(a.left,top,b.left-a.left,height));br<ar&&result.push(new goog.math.Rect(br,top,ar-br,height));return result;};goog.math.Rect.prototype.difference=function(rect){return goog.math.Rect.difference(this,rect);};goog.math.Rect.prototype.boundingRect=function(rect){var right=Math.max(this.left+this.width,rect.left+rect.width),bottom=Math.max(this.top+this.height,rect.top+rect.height);this.left=Math.min(this.left,rect.left);this.top=Math.min(this.top,rect.top);this.width=right-this.left;this.height=bottom-this.top;};goog.math.Rect.boundingRect=function(a,b){if(!a||!b){return null;}var newRect=new goog.math.Rect(a.left,a.top,a.width,a.height);newRect.boundingRect(b);return newRect;};goog.math.Rect.prototype.contains=function(another){return another instanceof goog.math.Coordinate?another.x>=this.left&&another.x<=this.left+this.width&&another.y>=this.top&&another.y<=this.top+this.height:this.left<=another.left&&this.left+this.width>=another.left+another.width&&this.top<=another.top&&this.top+this.height>=another.top+another.height;};goog.math.Rect.prototype.squaredDistance=function(point){var dx=point.x<this.left?this.left-point.x:Math.max(point.x-(this.left+this.width),0),dy=point.y<this.top?this.top-point.y:Math.max(point.y-(this.top+this.height),0);return dx*dx+dy*dy;};goog.math.Rect.prototype.distance=function(point){return Math.sqrt(this.squaredDistance(point));};goog.math.Rect.prototype.getSize=function(){return new goog.math.Size(this.width,this.height);};goog.math.Rect.prototype.getTopLeft=function(){return new goog.math.Coordinate(this.left,this.top);};goog.math.Rect.prototype.getCenter=function(){return new goog.math.Coordinate(this.left+this.width/2,this.top+this.height/2);};goog.math.Rect.prototype.getBottomRight=function(){return new goog.math.Coordinate(this.left+this.width,this.top+this.height);};goog.math.Rect.prototype.ceil=function(){this.left=Math.ceil(this.left);this.top=Math.ceil(this.top);this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this;};goog.math.Rect.prototype.floor=function(){this.left=Math.floor(this.left);this.top=Math.floor(this.top);this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this;};goog.math.Rect.prototype.round=function(){this.left=Math.round(this.left);this.top=Math.round(this.top);this.width=Math.round(this.width);this.height=Math.round(this.height);return this;};goog.math.Rect.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.left+=tx.x,this.top+=tx.y):(this.left+=goog.asserts.assertNumber(tx),goog.isNumber(opt_ty)&&(this.top+=opt_ty));return this;};goog.math.Rect.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.left*=sx;this.width*=sx;this.top*=sy;this.height*=sy;return this;};goog.style={};goog.style.setStyle=function(element,style,opt_value){if(goog.isString(style)){goog.style.setStyle_(element,opt_value,style);}else{for(var key in style){goog.style.setStyle_(element,style[key],key);}}};goog.style.setStyle_=function(element,value,style){var propertyName=goog.style.getVendorJsStyleName_(element,style);propertyName&&(element.style[propertyName]=value);};goog.style.styleNameCache_={};goog.style.getVendorJsStyleName_=function(element,style){var propertyName=goog.style.styleNameCache_[style];if(!propertyName){var camelStyle=goog.string.toCamelCase(style),propertyName=camelStyle;if(void 0===element.style[camelStyle]){var prefixedStyle=goog.dom.vendor.getVendorJsPrefix()+goog.string.toTitleCase(camelStyle);void 0!==element.style[prefixedStyle]&&(propertyName=prefixedStyle);}goog.style.styleNameCache_[style]=propertyName;}return propertyName;};goog.style.getVendorStyleName_=function(element,style){var camelStyle=goog.string.toCamelCase(style);if(void 0===element.style[camelStyle]){var prefixedStyle=goog.dom.vendor.getVendorJsPrefix()+goog.string.toTitleCase(camelStyle);if(void 0!==element.style[prefixedStyle]){return goog.dom.vendor.getVendorPrefix()+"-"+style;}}return style;};goog.style.getStyle=function(element,property){var styleValue=element.style[goog.string.toCamelCase(property)];return"undefined"!==typeof styleValue?styleValue:element.style[goog.style.getVendorJsStyleName_(element,property)]||"";};goog.style.getComputedStyle=function(element,property){var doc=goog.dom.getOwnerDocument(element);if(doc.defaultView&&doc.defaultView.getComputedStyle){var styles=doc.defaultView.getComputedStyle(element,null);if(styles){return styles[property]||styles.getPropertyValue(property)||"";}}return"";};goog.style.getCascadedStyle=function(element,style){return element.currentStyle?element.currentStyle[style]:null;};goog.style.getStyle_=function(element,style){return goog.style.getComputedStyle(element,style)||goog.style.getCascadedStyle(element,style)||element.style&&element.style[style];};goog.style.getComputedBoxSizing=function(element){return goog.style.getStyle_(element,"boxSizing")||goog.style.getStyle_(element,"MozBoxSizing")||goog.style.getStyle_(element,"WebkitBoxSizing")||null;};goog.style.getComputedPosition=function(element){return goog.style.getStyle_(element,"position");};goog.style.getBackgroundColor=function(element){return goog.style.getStyle_(element,"backgroundColor");};goog.style.getComputedOverflowX=function(element){return goog.style.getStyle_(element,"overflowX");};goog.style.getComputedOverflowY=function(element){return goog.style.getStyle_(element,"overflowY");};goog.style.getComputedZIndex=function(element){return goog.style.getStyle_(element,"zIndex");};goog.style.getComputedTextAlign=function(element){return goog.style.getStyle_(element,"textAlign");};goog.style.getComputedCursor=function(element){return goog.style.getStyle_(element,"cursor");};goog.style.getComputedTransform=function(element){var property=goog.style.getVendorStyleName_(element,"transform");return goog.style.getStyle_(element,property)||goog.style.getStyle_(element,"transform");};goog.style.setPosition=function(el,arg1,opt_arg2){if(arg1 instanceof goog.math.Coordinate){var x=arg1.x;var y=arg1.y;}else{x=arg1,y=opt_arg2;}el.style.left=goog.style.getPixelStyleValue_(x,!1);el.style.top=goog.style.getPixelStyleValue_(y,!1);};goog.style.getPosition=function(element){return new goog.math.Coordinate(element.offsetLeft,element.offsetTop);};goog.style.getClientViewportElement=function(opt_node){var doc=opt_node?goog.dom.getOwnerDocument(opt_node):goog.dom.getDocument();return!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9)||goog.dom.getDomHelper(doc).isCss1CompatMode()?doc.documentElement:doc.body;};goog.style.getViewportPageOffset=function(doc){var body=doc.body,documentElement=doc.documentElement;return new goog.math.Coordinate(body.scrollLeft||documentElement.scrollLeft,body.scrollTop||documentElement.scrollTop);};goog.style.getBoundingClientRect_=function(el){try{var rect=el.getBoundingClientRect();}catch(e){return{left:0,top:0,right:0,bottom:0};}if(goog.userAgent.IE&&el.ownerDocument.body){var doc=el.ownerDocument;rect.left-=doc.documentElement.clientLeft+doc.body.clientLeft;rect.top-=doc.documentElement.clientTop+doc.body.clientTop;}return rect;};goog.style.getOffsetParent=function(element){if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(8)){return goog.asserts.assert(element&&"offsetParent"in element),element.offsetParent;}for(var doc=goog.dom.getOwnerDocument(element),positionStyle=goog.style.getStyle_(element,"position"),skipStatic="fixed"==positionStyle||"absolute"==positionStyle,parent=element.parentNode;parent&&parent!=doc;parent=parent.parentNode){if(parent.nodeType==goog.dom.NodeType.DOCUMENT_FRAGMENT&&parent.host&&(parent=parent.host),positionStyle=goog.style.getStyle_(parent,"position"),skipStatic=skipStatic&&"static"==positionStyle&&parent!=doc.documentElement&&parent!=doc.body,!skipStatic&&(parent.scrollWidth>parent.clientWidth||parent.scrollHeight>parent.clientHeight||"fixed"==positionStyle||"absolute"==positionStyle||"relative"==positionStyle)){return parent;}}return null;};goog.style.getVisibleRectForElement=function(element){for(var visibleRect=new goog.math.Box(0,Infinity,Infinity,0),dom=goog.dom.getDomHelper(element),body=dom.getDocument().body,documentElement=dom.getDocument().documentElement,scrollEl=dom.getDocumentScrollElement(),el=element;el=goog.style.getOffsetParent(el);){if(!(goog.userAgent.IE&&0==el.clientWidth||goog.userAgent.WEBKIT&&0==el.clientHeight&&el==body)&&el!=body&&el!=documentElement&&"visible"!=goog.style.getStyle_(el,"overflow")){var pos=goog.style.getPageOffset(el),client=goog.style.getClientLeftTop(el);pos.x+=client.x;pos.y+=client.y;visibleRect.top=Math.max(visibleRect.top,pos.y);visibleRect.right=Math.min(visibleRect.right,pos.x+el.clientWidth);visibleRect.bottom=Math.min(visibleRect.bottom,pos.y+el.clientHeight);visibleRect.left=Math.max(visibleRect.left,pos.x);}}var scrollX=scrollEl.scrollLeft,scrollY=scrollEl.scrollTop;visibleRect.left=Math.max(visibleRect.left,scrollX);visibleRect.top=Math.max(visibleRect.top,scrollY);var winSize=dom.getViewportSize();visibleRect.right=Math.min(visibleRect.right,scrollX+winSize.width);visibleRect.bottom=Math.min(visibleRect.bottom,scrollY+winSize.height);return 0<=visibleRect.top&&0<=visibleRect.left&&visibleRect.bottom>visibleRect.top&&visibleRect.right>visibleRect.left?visibleRect:null;};goog.style.getContainerOffsetToScrollInto=function(element,opt_container,opt_center){var container=opt_container||goog.dom.getDocumentScrollElement(),elementPos=goog.style.getPageOffset(element),containerPos=goog.style.getPageOffset(container),containerBorder=goog.style.getBorderBox(container);if(container==goog.dom.getDocumentScrollElement()){var relX=elementPos.x-container.scrollLeft;var relY=elementPos.y-container.scrollTop;goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(10)&&(relX+=containerBorder.left,relY+=containerBorder.top);}else{relX=elementPos.x-containerPos.x-containerBorder.left,relY=elementPos.y-containerPos.y-containerBorder.top;}var elementSize=goog.style.getSizeWithDisplay_(element),spaceX=container.clientWidth-elementSize.width,spaceY=container.clientHeight-elementSize.height,scrollLeft=container.scrollLeft,scrollTop=container.scrollTop;opt_center?(scrollLeft+=relX-spaceX/2,scrollTop+=relY-spaceY/2):(scrollLeft+=Math.min(relX,Math.max(relX-spaceX,0)),scrollTop+=Math.min(relY,Math.max(relY-spaceY,0)));return new goog.math.Coordinate(scrollLeft,scrollTop);};goog.style.scrollIntoContainerView=function(element,opt_container,opt_center){var container=opt_container||goog.dom.getDocumentScrollElement(),offset=goog.style.getContainerOffsetToScrollInto(element,container,opt_center);container.scrollLeft=offset.x;container.scrollTop=offset.y;};goog.style.getClientLeftTop=function(el){return new goog.math.Coordinate(el.clientLeft,el.clientTop);};goog.style.getPageOffset=function(el){var doc=goog.dom.getOwnerDocument(el);goog.asserts.assertObject(el,"Parameter is required");var pos=new goog.math.Coordinate(0,0),viewportElement=goog.style.getClientViewportElement(doc);if(el==viewportElement){return pos;}var box=goog.style.getBoundingClientRect_(el),scrollCoord=goog.dom.getDomHelper(doc).getDocumentScroll();pos.x=box.left+scrollCoord.x;pos.y=box.top+scrollCoord.y;return pos;};goog.style.getPageOffsetLeft=function(el){return goog.style.getPageOffset(el).x;};goog.style.getPageOffsetTop=function(el){return goog.style.getPageOffset(el).y;};goog.style.getFramedPageOffset=function(el,relativeWin){var position=new goog.math.Coordinate(0,0),currentWin=goog.dom.getWindow(goog.dom.getOwnerDocument(el));if(!goog.reflect.canAccessProperty(currentWin,"parent")){return position;}var currentEl=el;do{var offset=currentWin==relativeWin?goog.style.getPageOffset(currentEl):goog.style.getClientPositionForElement_(goog.asserts.assert(currentEl));position.x+=offset.x;position.y+=offset.y;}while(currentWin&&currentWin!=relativeWin&&currentWin!=currentWin.parent&&(currentEl=currentWin.frameElement)&&(currentWin=currentWin.parent));return position;};goog.style.translateRectForAnotherFrame=function(rect,origBase,newBase){if(origBase.getDocument()!=newBase.getDocument()){var body=origBase.getDocument().body,pos=goog.style.getFramedPageOffset(body,newBase.getWindow()),pos=goog.math.Coordinate.difference(pos,goog.style.getPageOffset(body));!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9)||origBase.isCss1CompatMode()||(pos=goog.math.Coordinate.difference(pos,origBase.getDocumentScroll()));rect.left+=pos.x;rect.top+=pos.y;}};goog.style.getRelativePosition=function(a,b){var ap=goog.style.getClientPosition(a),bp=goog.style.getClientPosition(b);return new goog.math.Coordinate(ap.x-bp.x,ap.y-bp.y);};goog.style.getClientPositionForElement_=function(el){var box=goog.style.getBoundingClientRect_(el);return new goog.math.Coordinate(box.left,box.top);};goog.style.getClientPosition=function(el){goog.asserts.assert(el);if(el.nodeType==goog.dom.NodeType.ELEMENT){return goog.style.getClientPositionForElement_(el);}var targetEvent=el.changedTouches?el.changedTouches[0]:el;return new goog.math.Coordinate(targetEvent.clientX,targetEvent.clientY);};goog.style.setPageOffset=function(el,x,opt_y){var cur=goog.style.getPageOffset(el);x instanceof goog.math.Coordinate&&(opt_y=x.y,x=x.x);var dx=goog.asserts.assertNumber(x)-cur.x;goog.style.setPosition(el,el.offsetLeft+dx,el.offsetTop+(Number(opt_y)-cur.y));};goog.style.setSize=function(element,w,opt_h){if(w instanceof goog.math.Size){var h=w.height;w=w.width;}else{if(void 0==opt_h){throw Error("missing height argument");}h=opt_h;}goog.style.setWidth(element,w);goog.style.setHeight(element,h);};goog.style.getPixelStyleValue_=function(value,round){"number"==typeof value&&(value=(round?Math.round(value):value)+"px");return value;};goog.style.setHeight=function(element,height){element.style.height=goog.style.getPixelStyleValue_(height,!0);};goog.style.setWidth=function(element,width){element.style.width=goog.style.getPixelStyleValue_(width,!0);};goog.style.getSize=function(element){return goog.style.evaluateWithTemporaryDisplay_(goog.style.getSizeWithDisplay_,element);};goog.style.evaluateWithTemporaryDisplay_=function(fn,element){if("none"!=goog.style.getStyle_(element,"display")){return fn(element);}var style=element.style,originalDisplay=style.display,originalVisibility=style.visibility,originalPosition=style.position;style.visibility="hidden";style.position="absolute";style.display="inline";var retVal=fn(element);style.display=originalDisplay;style.position=originalPosition;style.visibility=originalVisibility;return retVal;};goog.style.getSizeWithDisplay_=function(element){var offsetWidth=element.offsetWidth,offsetHeight=element.offsetHeight,webkitOffsetsZero=goog.userAgent.WEBKIT&&!offsetWidth&&!offsetHeight;if((!goog.isDef(offsetWidth)||webkitOffsetsZero)&&element.getBoundingClientRect){var clientRect=goog.style.getBoundingClientRect_(element);return new goog.math.Size(clientRect.right-clientRect.left,clientRect.bottom-clientRect.top);}return new goog.math.Size(offsetWidth,offsetHeight);};goog.style.getTransformedSize=function(element){if(!element.getBoundingClientRect){return null;}var clientRect=goog.style.evaluateWithTemporaryDisplay_(goog.style.getBoundingClientRect_,element);return new goog.math.Size(clientRect.right-clientRect.left,clientRect.bottom-clientRect.top);};goog.style.getBounds=function(element){var o=goog.style.getPageOffset(element),s=goog.style.getSize(element);return new goog.math.Rect(o.x,o.y,s.width,s.height);};goog.style.toCamelCase=function(selector){return goog.string.toCamelCase(String(selector));};goog.style.toSelectorCase=function(selector){return goog.string.toSelectorCase(selector);};goog.style.getOpacity=function(el){goog.asserts.assert(el);var style=el.style,result="";if("opacity"in style){result=style.opacity;}else{if("MozOpacity"in style){result=style.MozOpacity;}else{if("filter"in style){var match=style.filter.match(/alpha\\(opacity=([\\d.]+)\\)/);match&&(result=String(match[1]/100));}}}return""==result?result:Number(result);};goog.style.setOpacity=function(el,alpha){goog.asserts.assert(el);var style=el.style;"opacity"in style?style.opacity=alpha:"MozOpacity"in style?style.MozOpacity=alpha:"filter"in style&&(style.filter=""===alpha?"":"alpha(opacity="+100*Number(alpha)+")");};goog.style.setTransparentBackgroundImage=function(el,src){var style=el.style;goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?style.filter=\'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="\'+src+\'", sizingMethod="crop")\':(style.backgroundImage="url("+src+")",style.backgroundPosition="top left",style.backgroundRepeat="no-repeat");};goog.style.clearTransparentBackgroundImage=function(el){var style=el.style;"filter"in style?style.filter="":style.backgroundImage="none";};goog.style.showElement=function(el,display){goog.style.setElementShown(el,display);};goog.style.setElementShown=function(el,isShown){el.style.display=isShown?"":"none";};goog.style.isElementShown=function(el){return"none"!=el.style.display;};goog.style.installStyles=function(stylesString,opt_node){return goog.style.installSafeStyleSheet(goog.html.legacyconversions.safeStyleSheetFromString(stylesString),opt_node);};goog.style.installSafeStyleSheet=function(safeStyleSheet,opt_node){var dh=goog.dom.getDomHelper(opt_node),styleSheet=null,doc=dh.getDocument();if(goog.userAgent.IE&&doc.createStyleSheet){styleSheet=doc.createStyleSheet(),goog.style.setSafeStyleSheet(styleSheet,safeStyleSheet);}else{var head=dh.getElementsByTagNameAndClass("HEAD")[0];if(!head){var body=dh.getElementsByTagNameAndClass("BODY")[0],head=dh.createDom("HEAD");body.parentNode.insertBefore(head,body);}styleSheet=dh.createDom("STYLE");goog.style.setSafeStyleSheet(styleSheet,safeStyleSheet);dh.appendChild(head,styleSheet);}return styleSheet;};goog.style.uninstallStyles=function(styleSheet){goog.dom.removeNode(styleSheet.ownerNode||styleSheet.owningElement||styleSheet);};goog.style.setStyles=function(element,stylesString){goog.style.setSafeStyleSheet(element,goog.html.legacyconversions.safeStyleSheetFromString(stylesString));};goog.style.setSafeStyleSheet=function(element,safeStyleSheet){var stylesString=goog.html.SafeStyleSheet.unwrap(safeStyleSheet);goog.userAgent.IE&&goog.isDef(element.cssText)?element.cssText=stylesString:element.innerHTML=stylesString;};goog.style.setPreWrap=function(el){var style=el.style;goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?(style.whiteSpace="pre",style.wordWrap="break-word"):style.whiteSpace=goog.userAgent.GECKO?"-moz-pre-wrap":"pre-wrap";};goog.style.setInlineBlock=function(el){var style=el.style;style.position="relative";goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?(style.zoom="1",style.display="inline"):style.display="inline-block";};goog.style.isRightToLeft=function(el){return"rtl"==goog.style.getStyle_(el,"direction");};goog.style.unselectableStyle_=goog.userAgent.GECKO?"MozUserSelect":goog.userAgent.WEBKIT||goog.userAgent.EDGE?"WebkitUserSelect":null;goog.style.isUnselectable=function(el){return goog.style.unselectableStyle_?"none"==el.style[goog.style.unselectableStyle_].toLowerCase():goog.userAgent.IE||goog.userAgent.OPERA?"on"==el.getAttribute("unselectable"):!1;};goog.style.setUnselectable=function(el,unselectable,opt_noRecurse){var descendants=opt_noRecurse?null:el.getElementsByTagName("*"),name=goog.style.unselectableStyle_;if(name){var value=unselectable?"none":"";el.style&&(el.style[name]=value);if(descendants){for(var i=0,descendant;descendant=descendants[i];i++){descendant.style&&(descendant.style[name]=value);}}}else{if(goog.userAgent.IE||goog.userAgent.OPERA){if(value=unselectable?"on":"",el.setAttribute("unselectable",value),descendants){for(i=0;descendant=descendants[i];i++){descendant.setAttribute("unselectable",value);}}}}};goog.style.getBorderBoxSize=function(element){return new goog.math.Size(element.offsetWidth,element.offsetHeight);};goog.style.setBorderBoxSize=function(element,size){var doc=goog.dom.getOwnerDocument(element),isCss1CompatMode=goog.dom.getDomHelper(doc).isCss1CompatMode();if(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10")||isCss1CompatMode&&goog.userAgent.isVersionOrHigher("8")){goog.style.setBoxSizingSize_(element,size,"border-box");}else{var style=element.style;if(isCss1CompatMode){var paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);style.pixelWidth=size.width-borderBox.left-paddingBox.left-paddingBox.right-borderBox.right;style.pixelHeight=size.height-borderBox.top-paddingBox.top-paddingBox.bottom-borderBox.bottom;}else{style.pixelWidth=size.width,style.pixelHeight=size.height;}}};goog.style.getContentBoxSize=function(element){var doc=goog.dom.getOwnerDocument(element),ieCurrentStyle=goog.userAgent.IE&&element.currentStyle;if(ieCurrentStyle&&goog.dom.getDomHelper(doc).isCss1CompatMode()&&"auto"!=ieCurrentStyle.width&&"auto"!=ieCurrentStyle.height&&!ieCurrentStyle.boxSizing){var width=goog.style.getIePixelValue_(element,ieCurrentStyle.width,"width","pixelWidth"),height=goog.style.getIePixelValue_(element,ieCurrentStyle.height,"height","pixelHeight");return new goog.math.Size(width,height);}var borderBoxSize=goog.style.getBorderBoxSize(element),paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);return new goog.math.Size(borderBoxSize.width-borderBox.left-paddingBox.left-paddingBox.right-borderBox.right,borderBoxSize.height-borderBox.top-paddingBox.top-paddingBox.bottom-borderBox.bottom);};goog.style.setContentBoxSize=function(element,size){var doc=goog.dom.getOwnerDocument(element),isCss1CompatMode=goog.dom.getDomHelper(doc).isCss1CompatMode();if(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10")||isCss1CompatMode&&goog.userAgent.isVersionOrHigher("8")){goog.style.setBoxSizingSize_(element,size,"content-box");}else{var style=element.style;if(isCss1CompatMode){style.pixelWidth=size.width,style.pixelHeight=size.height;}else{var paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);style.pixelWidth=size.width+borderBox.left+paddingBox.left+paddingBox.right+borderBox.right;style.pixelHeight=size.height+borderBox.top+paddingBox.top+paddingBox.bottom+borderBox.bottom;}}};goog.style.setBoxSizingSize_=function(element,size,boxSizing){var style=element.style;goog.userAgent.GECKO?style.MozBoxSizing=boxSizing:goog.userAgent.WEBKIT?style.WebkitBoxSizing=boxSizing:style.boxSizing=boxSizing;style.width=Math.max(size.width,0)+"px";style.height=Math.max(size.height,0)+"px";};goog.style.getIePixelValue_=function(element,value,name,pixelName){if(/^\\d+px?$/.test(value)){return parseInt(value,10);}var oldStyleValue=element.style[name],oldRuntimeValue=element.runtimeStyle[name];element.runtimeStyle[name]=element.currentStyle[name];element.style[name]=value;var pixelValue=element.style[pixelName];element.style[name]=oldStyleValue;element.runtimeStyle[name]=oldRuntimeValue;return+pixelValue;};goog.style.getIePixelDistance_=function(element,propName){var value=goog.style.getCascadedStyle(element,propName);return value?goog.style.getIePixelValue_(element,value,"left","pixelLeft"):0;};goog.style.getBox_=function(element,stylePrefix){if(goog.userAgent.IE){var left=goog.style.getIePixelDistance_(element,stylePrefix+"Left");var right=goog.style.getIePixelDistance_(element,stylePrefix+"Right");var top=goog.style.getIePixelDistance_(element,stylePrefix+"Top");var bottom=goog.style.getIePixelDistance_(element,stylePrefix+"Bottom");return new goog.math.Box(top,right,bottom,left);}left=goog.style.getComputedStyle(element,stylePrefix+"Left");right=goog.style.getComputedStyle(element,stylePrefix+"Right");top=goog.style.getComputedStyle(element,stylePrefix+"Top");bottom=goog.style.getComputedStyle(element,stylePrefix+"Bottom");return new goog.math.Box(parseFloat(top),parseFloat(right),parseFloat(bottom),parseFloat(left));};goog.style.getPaddingBox=function(element){return goog.style.getBox_(element,"padding");};goog.style.getMarginBox=function(element){return goog.style.getBox_(element,"margin");};goog.style.ieBorderWidthKeywords_={thin:2,medium:4,thick:6};goog.style.getIePixelBorder_=function(element,prop){if("none"==goog.style.getCascadedStyle(element,prop+"Style")){return 0;}var width=goog.style.getCascadedStyle(element,prop+"Width");return width in goog.style.ieBorderWidthKeywords_?goog.style.ieBorderWidthKeywords_[width]:goog.style.getIePixelValue_(element,width,"left","pixelLeft");};goog.style.getBorderBox=function(element){if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)){var left=goog.style.getIePixelBorder_(element,"borderLeft");var right=goog.style.getIePixelBorder_(element,"borderRight");var top=goog.style.getIePixelBorder_(element,"borderTop");var bottom=goog.style.getIePixelBorder_(element,"borderBottom");return new goog.math.Box(top,right,bottom,left);}left=goog.style.getComputedStyle(element,"borderLeftWidth");right=goog.style.getComputedStyle(element,"borderRightWidth");top=goog.style.getComputedStyle(element,"borderTopWidth");bottom=goog.style.getComputedStyle(element,"borderBottomWidth");return new goog.math.Box(parseFloat(top),parseFloat(right),parseFloat(bottom),parseFloat(left));};goog.style.getFontFamily=function(el){var doc=goog.dom.getOwnerDocument(el),font="";if(doc.body.createTextRange&&goog.dom.contains(doc,el)){var range=doc.body.createTextRange();range.moveToElementText(el);try{font=range.queryCommandValue("FontName");}catch(e){font="";}}font||(font=goog.style.getStyle_(el,"fontFamily"));var fontsArray=font.split(",");1<fontsArray.length&&(font=fontsArray[0]);return goog.string.stripQuotes(font,"\\"\'");};goog.style.lengthUnitRegex_=/[^\\d]+$/;goog.style.getLengthUnits=function(value){var units=value.match(goog.style.lengthUnitRegex_);return units&&units[0]||null;};goog.style.ABSOLUTE_CSS_LENGTH_UNITS_={cm:1,"in":1,mm:1,pc:1,pt:1};goog.style.CONVERTIBLE_RELATIVE_CSS_UNITS_={em:1,ex:1};goog.style.getFontSize=function(el){var fontSize=goog.style.getStyle_(el,"fontSize"),sizeUnits=goog.style.getLengthUnits(fontSize);if(fontSize&&"px"==sizeUnits){return parseInt(fontSize,10);}if(goog.userAgent.IE){if(String(sizeUnits)in goog.style.ABSOLUTE_CSS_LENGTH_UNITS_){return goog.style.getIePixelValue_(el,fontSize,"left","pixelLeft");}if(el.parentNode&&el.parentNode.nodeType==goog.dom.NodeType.ELEMENT&&String(sizeUnits)in goog.style.CONVERTIBLE_RELATIVE_CSS_UNITS_){var parentElement=el.parentNode,parentSize=goog.style.getStyle_(parentElement,"fontSize");return goog.style.getIePixelValue_(parentElement,fontSize==parentSize?"1em":fontSize,"left","pixelLeft");}}var sizeElement=goog.dom.createDom("SPAN",{style:"visibility:hidden;position:absolute;line-height:0;padding:0;margin:0;border:0;height:1em;"});goog.dom.appendChild(el,sizeElement);fontSize=sizeElement.offsetHeight;goog.dom.removeNode(sizeElement);return fontSize;};goog.style.parseStyleAttribute=function(value){var result={};goog.array.forEach(value.split(/\\s*;\\s*/),function(pair){var keyValue=pair.match(/\\s*([\\w-]+)\\s*\\:(.+)/);if(keyValue){var styleName=keyValue[1],styleValue=goog.string.trim(keyValue[2]);result[goog.string.toCamelCase(styleName.toLowerCase())]=styleValue;}});return result;};goog.style.toStyleAttribute=function(obj){var buffer=[];goog.object.forEach(obj,function(value,key){buffer.push(goog.string.toSelectorCase(key),":",value,";");});return buffer.join("");};goog.style.setFloat=function(el,value){el.style[goog.userAgent.IE?"styleFloat":"cssFloat"]=value;};goog.style.getFloat=function(el){return el.style[goog.userAgent.IE?"styleFloat":"cssFloat"]||"";};goog.style.getScrollbarWidth=function(opt_className){var outerDiv=goog.dom.createElement("DIV");opt_className&&(outerDiv.className=opt_className);outerDiv.style.cssText="overflow:auto;position:absolute;top:0;width:100px;height:100px";var innerDiv=goog.dom.createElement("DIV");goog.style.setSize(innerDiv,"200px","200px");outerDiv.appendChild(innerDiv);goog.dom.appendChild(goog.dom.getDocument().body,outerDiv);var width=outerDiv.offsetWidth-outerDiv.clientWidth;goog.dom.removeNode(outerDiv);return width;};goog.style.MATRIX_TRANSLATION_REGEX_=/matrix\\([0-9\\.\\-]+, [0-9\\.\\-]+, [0-9\\.\\-]+, [0-9\\.\\-]+, ([0-9\\.\\-]+)p?x?, ([0-9\\.\\-]+)p?x?\\)/;goog.style.getCssTranslation=function(element){var transform=goog.style.getComputedTransform(element);if(!transform){return new goog.math.Coordinate(0,0);}var matches=transform.match(goog.style.MATRIX_TRANSLATION_REGEX_);return matches?new goog.math.Coordinate(parseFloat(matches[1]),parseFloat(matches[2])):new goog.math.Coordinate(0,0);};var ee={layers:{}};ee.layers.AbstractOverlay=function(tileSource,opt_options){goog.events.EventTarget.call(this);var options=opt_options||{};this.minZoom=options.minZoom||0;this.maxZoom=options.maxZoom||20;if(!window.google||!window.google.maps){throw Error("Google Maps API hasn\'t been initialized.");}this.tileSize=options.tileSize||new google.maps.Size(ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH,ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH);this.isPng="isPng"in options?options.isPng:!0;this.name=options.name;this.opacity="opacity"in options?options.opacity:1;this.tilesById=new goog.structs.Map();this.tileCounter=0;this.tileSource=tileSource;this.handler=new goog.events.EventHandler(this);this.alt=this.radius=this.projection=void 0;};goog.inherits(ee.layers.AbstractOverlay,goog.events.EventTarget);ee.layers.AbstractOverlay.EventType={TILE_FAIL:"tile-fail",TILE_THROTTLE:"tile-throttle",TILE_LOAD:"tile-load"};ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH=256;ee.layers.AbstractOverlay.prototype.addTileCallback=function(callback){return goog.events.listen(this,ee.layers.AbstractOverlay.EventType.TILE_LOAD,callback);};ee.layers.AbstractOverlay.prototype.removeTileCallback=function(callbackId){goog.events.unlistenByKey(callbackId);};ee.layers.AbstractOverlay.prototype.getLoadingTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.THROTTLED)+this.getTileCountForStatus_(ee.layers.AbstractTile.Status.LOADING)+this.getTileCountForStatus_(ee.layers.AbstractTile.Status.NEW);};ee.layers.AbstractOverlay.prototype.getFailedTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.FAILED);};ee.layers.AbstractOverlay.prototype.getLoadedTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.LOADED);};ee.layers.AbstractOverlay.prototype.setOpacity=function(opacity){this.opacity=opacity;this.tilesById.forEach(function(tile){goog.style.setOpacity(tile.div,this.opacity);},this);};ee.layers.AbstractOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var maxCoord=1<<zoom;if(zoom<this.minZoom||0>coord.y||coord.y>=maxCoord){return ownerDocument.createElement("div");}var x=coord.x%maxCoord;0>x&&(x+=maxCoord);var normalizedCoord=new google.maps.Point(x,coord.y),uniqueId=this.getUniqueTileId_(coord,zoom),tile=this.createTile(normalizedCoord,zoom,ownerDocument,uniqueId);tile.tileSize=this.tileSize;goog.style.setOpacity(tile.div,this.opacity);this.tilesById.set(uniqueId,tile);this.handler.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){var Status=ee.layers.AbstractTile.Status;switch(tile.getStatus()){case Status.LOADED:this.dispatchEvent(new ee.layers.TileLoadEvent(this.getLoadingTilesCount()));break;case Status.THROTTLED:this.dispatchEvent(new ee.layers.TileThrottleEvent(tile.sourceUrl));break;case Status.FAILED:this.dispatchEvent(new ee.layers.TileFailEvent(tile.sourceUrl,tile.errorMessage_));}});this.tileSource.loadTile(tile,new Date().getTime()/1000);return tile.div;};ee.layers.AbstractOverlay.prototype.releaseTile=function(tileDiv){var tile=this.tilesById.get(tileDiv.id);this.tilesById.remove(tileDiv.id);tile&&(tile.abort(),goog.dispose(tile));};ee.layers.AbstractOverlay.prototype.getUniqueTileId_=function(coord,z){var tileId=[coord.x,coord.y,z,this.tileCounter].join("-"),sourceId=this.tileSource.getUniqueId();return[tileId,sourceId].join("-");};ee.layers.AbstractOverlay.prototype.disposeInternal=function(){ee.layers.AbstractOverlay.superClass_.disposeInternal.call(this);this.tilesById.forEach(goog.dispose);this.tilesById.clear();this.tilesById=null;goog.dispose(this.handler);this.tileSource=this.handler=null;};ee.layers.AbstractOverlay.prototype.getTileCountForStatus_=function(status){return goog.array.count(this.tilesById.getValues(),function(tile){return tile.getStatus()==status;});};ee.layers.TileLoadEvent=function(loadingTileCount){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_LOAD);this.loadingTileCount=loadingTileCount;};goog.inherits(ee.layers.TileLoadEvent,goog.events.Event);ee.layers.TileThrottleEvent=function(tileUrl){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_THROTTLE);this.tileUrl=tileUrl;};goog.inherits(ee.layers.TileThrottleEvent,goog.events.Event);ee.layers.TileFailEvent=function(tileUrl,opt_errorMessage){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_FAIL);this.tileUrl=tileUrl;this.errorMessage=opt_errorMessage;};goog.inherits(ee.layers.TileFailEvent,goog.events.Event);ee.layers.AbstractTile=function(coord,zoom,ownerDocument,uniqueId){goog.events.EventTarget.call(this);this.coord=coord;this.zoom=zoom;this.div=ownerDocument.createElement("div");this.div.id=uniqueId;this.maxRetries=ee.layers.AbstractTile.DEFAULT_MAX_LOAD_RETRIES_;this.renderer=function(){};this.status_=ee.layers.AbstractTile.Status.NEW;this.retryAttemptCount_=0;this.isRetrying_=!1;};goog.inherits(ee.layers.AbstractTile,goog.events.EventTarget);ee.layers.AbstractTile.EventType={STATUS_CHANGED:"status-changed"};ee.layers.AbstractTile.Status={NEW:"new",LOADING:"loading",THROTTLED:"throttled",LOADED:"loaded",FAILED:"failed",ABORTED:"aborted"};ee.layers.AbstractTile.prototype.startLoad=function(){if(!this.isRetrying_&&this.getStatus()==ee.layers.AbstractTile.Status.LOADING){throw Error("startLoad() can only be invoked once. Use retryLoad() after the first attempt.");}this.setStatus(ee.layers.AbstractTile.Status.LOADING);this.xhrIo_=new goog.net.XhrIo();this.xhrIo_.setResponseType(goog.net.XhrIo.ResponseType.BLOB);this.xhrIo_.listen(goog.net.EventType.COMPLETE,function(event){var blob=this.xhrIo_.getResponse(),status=this.xhrIo_.getStatus(),HttpStatus=goog.net.HttpStatus;status==HttpStatus.TOO_MANY_REQUESTS&&this.setStatus(ee.layers.AbstractTile.Status.THROTTLED);if(status>=HttpStatus.OK&&status<HttpStatus.MULTIPLE_CHOICES){this.sourceResponseHeaders=this.xhrIo_.getResponseHeaders(),this.sourceData=blob,this.finishLoad();}else{if(blob){var reader=new goog.fs.FileReader();reader.listen(goog.fs.FileReader.EventType.LOAD_END,function(){this.retryLoad(reader.getResult());},void 0,this);reader.readAsText(blob);}else{this.retryLoad("Failed to load tile.");}}},!1,this);this.xhrIo_.listenOnce(goog.net.EventType.READY,goog.partial(goog.dispose,this.xhrIo_));this.xhrIo_.send(this.sourceUrl,"GET");};ee.layers.AbstractTile.prototype.finishLoad=function(){this.renderer(this);this.setStatus(ee.layers.AbstractTile.Status.LOADED);};ee.layers.AbstractTile.prototype.cancelLoad=function(){goog.dispose(this.xhrIo_);};ee.layers.AbstractTile.prototype.retryLoad=function(opt_errorMessage){var parseError=function parseError(error){try{if(error=JSON.parse(error),error.error&&error.error.message){return error.error.message;}}catch(e){}return error;};this.retryAttemptCount_>=this.maxRetries?(this.errorMessage_=parseError(opt_errorMessage),this.setStatus(ee.layers.AbstractTile.Status.FAILED)):(this.cancelLoad(),setTimeout(goog.bind(function(){this.isDisposed()||(this.isRetrying_=!0,this.startLoad(),this.isRetrying_=!1);},this),1000*Math.pow(2,this.retryAttemptCount_++)));};ee.layers.AbstractTile.prototype.abort=function(){this.cancelLoad();this.setStatus(ee.layers.AbstractTile.Status.ABORTED);};ee.layers.AbstractTile.prototype.isDone=function(){return this.status_ in ee.layers.AbstractTile.DONE_STATUS_SET_;};ee.layers.AbstractTile.prototype.getStatus=function(){return this.status_;};ee.layers.AbstractTile.prototype.setStatus=function(status){this.status_=status;this.dispatchEvent(ee.layers.AbstractTile.EventType.STATUS_CHANGED);};ee.layers.AbstractTile.DONE_STATUS_SET_=goog.object.createSet(ee.layers.AbstractTile.Status.ABORTED,ee.layers.AbstractTile.Status.FAILED,ee.layers.AbstractTile.Status.LOADED);ee.layers.AbstractTile.prototype.disposeInternal=function(){ee.layers.AbstractTile.superClass_.disposeInternal.call(this);this.cancelLoad();this.div.remove();this.renderer=null;};ee.layers.AbstractTile.DEFAULT_MAX_LOAD_RETRIES_=5;ee.layers.AbstractTileSource=function(){goog.Disposable.call(this);};goog.inherits(ee.layers.AbstractTileSource,goog.Disposable);ee.layers.BinaryOverlay=function(tileSource,opt_options){ee.layers.AbstractOverlay.call(this,tileSource,opt_options);this.buffersByCoord_=new goog.structs.Map();this.divsByCoord_=new goog.structs.Map();};goog.inherits(ee.layers.BinaryOverlay,ee.layers.AbstractOverlay);ee.layers.BinaryOverlay.prototype.createTile=function(coord,zoom,ownerDocument,uniqueId){var tile=new ee.layers.BinaryTile(coord,zoom,ownerDocument,uniqueId);this.handler.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){tile.getStatus()==ee.layers.AbstractTile.Status.LOADED&&(this.buffersByCoord_.set(coord,new Float32Array(tile.buffer_)),this.divsByCoord_.set(coord,tile.div));});return tile;};ee.layers.BinaryOverlay.prototype.getBuffersByCoord=function(){return this.buffersByCoord_;};ee.layers.BinaryOverlay.prototype.getDivsByCoord=function(){return this.divsByCoord_;};ee.layers.BinaryOverlay.prototype.disposeInternal=function(){ee.layers.BinaryOverlay.superClass_.disposeInternal.call(this);this.divsByCoord_=this.buffersByCoord_=null;};ee.layers.BinaryTile=function(coord,zoom,ownerDocument,uniqueId){ee.layers.AbstractTile.call(this,coord,zoom,ownerDocument,uniqueId);};goog.inherits(ee.layers.BinaryTile,ee.layers.AbstractTile);ee.layers.BinaryTile.prototype.finishLoad=function(){var reader=new goog.fs.FileReader();reader.listen(goog.fs.FileReader.EventType.LOAD_END,function(){this.buffer_=reader.getResult();ee.layers.AbstractTile.prototype.finishLoad.call(this);},void 0,this);reader.readAsArrayBuffer(this.sourceData);};goog.string.path={};goog.string.path.baseName=function(path){var i=path.lastIndexOf("/")+1;return path.slice(i);};goog.string.path.basename=goog.string.path.baseName;goog.string.path.dirname=function(path){var i=path.lastIndexOf("/")+1,head=path.slice(0,i);/^\\/+$/.test(head)||(head=head.replace(/\\/+$/,""));return head;};goog.string.path.extension=function(path){var baseName=goog.string.path.baseName(path).replace(/\\.+/g,"."),separatorIndex=baseName.lastIndexOf(".");return 0>=separatorIndex?"":baseName.substr(separatorIndex+1);};goog.string.path.join=function(var_args){for(var path=arguments[0],i=1;i<arguments.length;i++){var arg=arguments[i],path=goog.string.startsWith(arg,"/")?arg:""==path||goog.string.endsWith(path,"/")?path+arg:path+("/"+arg);}return path;};goog.string.path.normalizePath=function(path){if(""==path){return".";}var initialSlashes="";goog.string.startsWith(path,"/")&&(initialSlashes="/",goog.string.startsWith(path,"//")&&!goog.string.startsWith(path,"///")&&(initialSlashes="//"));for(var parts=path.split("/"),newParts=[],i=0;i<parts.length;i++){var part=parts[i];""!=part&&"."!=part&&(".."!=part||!initialSlashes&&!newParts.length||".."==goog.array.peek(newParts)?newParts.push(part):newParts.pop());}return initialSlashes+newParts.join("/")||".";};goog.string.path.split=function(path){var head=goog.string.path.dirname(path),tail=goog.string.path.baseName(path);return[head,tail];};ee.layers.CloudStorageTileSource=function(bucket,path,maxZoom,opt_suffix){ee.layers.AbstractTileSource.call(this);this.bucket_=bucket;this.path_=path;this.suffix_=opt_suffix||"";this.maxZoom_=maxZoom;};goog.inherits(ee.layers.CloudStorageTileSource,ee.layers.AbstractTileSource);ee.layers.CloudStorageTileSource.prototype.loadTile=function(tile,opt_priority){if(tile.zoom<=this.maxZoom_){tile.sourceUrl=this.getTileUrl_(tile.coord,tile.zoom);}else{var zoomSteps=tile.zoom-this.maxZoom_,zoomFactor=Math.pow(2,zoomSteps),upperCoord=new google.maps.Point(Math.floor(tile.coord.x/zoomFactor),Math.floor(tile.coord.y/zoomFactor));tile.sourceUrl=this.getTileUrl_(upperCoord,tile.zoom-zoomSteps);tile.renderer=goog.partial(ee.layers.CloudStorageTileSource.zoomTileRenderer_,this.maxZoom_);}var originalRetryLoad=goog.bind(tile.retryLoad,tile);tile.retryLoad=goog.bind(function(opt_errorMessage){opt_errorMessage&&goog.string.contains(opt_errorMessage,ee.layers.CloudStorageTileSource.MISSING_TILE_ERROR_)?tile.setStatus(ee.layers.AbstractTile.Status.LOADED):originalRetryLoad(opt_errorMessage);},tile);tile.startLoad();};ee.layers.CloudStorageTileSource.prototype.getUniqueId=function(){return[this.bucket_,this.path_,this.maxZoom_,this.suffix_].join("-");};ee.layers.CloudStorageTileSource.prototype.getTileUrl_=function(coord,zoom){var url=goog.string.path.join(ee.layers.CloudStorageTileSource.BASE_URL_,this.bucket_,this.path_,String(zoom),String(coord.x),String(coord.y));this.suffix_&&(url+=this.suffix_);return url;};ee.layers.CloudStorageTileSource.zoomTileRenderer_=function(maxZoom,tile){if(!tile.imageEl){throw Error("Tile must have an image element to be rendered.");}var zoomFactor=Math.pow(2,tile.zoom-maxZoom),sideLength=tile.tileSize.width,canv=tile.div.ownerDocument.createElement("canvas");canv.setAttribute("width",sideLength);canv.setAttribute("height",sideLength);tile.div.appendChild(canv);var context=canv.getContext("2d");context.imageSmoothingEnabled=!1;context.mozImageSmoothingEnabled=!1;context.webkitImageSmoothingEnabled=!1;context.drawImage(tile.imageEl,sideLength/zoomFactor*(tile.coord.x%zoomFactor),sideLength/zoomFactor*(tile.coord.y%zoomFactor),sideLength/zoomFactor,sideLength/zoomFactor,0,0,sideLength,sideLength);};ee.layers.CloudStorageTileSource.BASE_URL_="https://storage.googleapis.com";ee.layers.CloudStorageTileSource.MISSING_TILE_ERROR_="The specified key does not exist.";goog.async.Throttle=function(listener,interval,opt_handler){goog.Disposable.call(this);this.listener_=null!=opt_handler?goog.bind(listener,opt_handler):listener;this.interval_=interval;this.callback_=goog.bind(this.onTimer_,this);this.args_=[];};goog.inherits(goog.async.Throttle,goog.Disposable);goog.Throttle=goog.async.Throttle;goog.async.Throttle.prototype.shouldFire_=!1;goog.async.Throttle.prototype.pauseCount_=0;goog.async.Throttle.prototype.timer_=null;goog.async.Throttle.prototype.fire=function(var_args){this.args_=arguments;this.timer_||this.pauseCount_?this.shouldFire_=!0:this.doAction_();};goog.async.Throttle.prototype.stop=function(){this.timer_&&(goog.Timer.clear(this.timer_),this.timer_=null,this.shouldFire_=!1,this.args_=[]);};goog.async.Throttle.prototype.pause=function(){this.pauseCount_++;};goog.async.Throttle.prototype.resume=function(){this.pauseCount_--;this.pauseCount_||!this.shouldFire_||this.timer_||(this.shouldFire_=!1,this.doAction_());};goog.async.Throttle.prototype.disposeInternal=function(){goog.async.Throttle.superClass_.disposeInternal.call(this);this.stop();};goog.async.Throttle.prototype.onTimer_=function(){this.timer_=null;this.shouldFire_&&!this.pauseCount_&&(this.shouldFire_=!1,this.doAction_());};goog.async.Throttle.prototype.doAction_=function(){this.timer_=goog.Timer.callOnce(this.callback_,this.interval_);this.listener_.apply(null,this.args_);};goog.net.jsloader={};goog.net.jsloader.GLOBAL_VERIFY_OBJS_="closure_verification";goog.net.jsloader.DEFAULT_TIMEOUT=5000;goog.net.jsloader.scriptsToLoad_=[];goog.net.jsloader.loadMany=function(uris,opt_options){var trustedUris=goog.array.map(uris,goog.html.legacyconversions.trustedResourceUrlFromString);return goog.net.jsloader.safeLoadMany(trustedUris,opt_options);};goog.net.jsloader.safeLoadMany=function(trustedUris,opt_options){if(!trustedUris.length){return goog.async.Deferred.succeed(null);}var isAnotherModuleLoading=goog.net.jsloader.scriptsToLoad_.length;goog.array.extend(goog.net.jsloader.scriptsToLoad_,trustedUris);if(isAnotherModuleLoading){return goog.net.jsloader.scriptLoadingDeferred_;}trustedUris=goog.net.jsloader.scriptsToLoad_;var popAndLoadNextScript=function popAndLoadNextScript(){var trustedUri=trustedUris.shift(),deferred=goog.net.jsloader.safeLoad(trustedUri,opt_options);trustedUris.length&&deferred.addBoth(popAndLoadNextScript);return deferred;};goog.net.jsloader.scriptLoadingDeferred_=popAndLoadNextScript();return goog.net.jsloader.scriptLoadingDeferred_;};goog.net.jsloader.load=function(uri,opt_options){var trustedUri=goog.html.legacyconversions.trustedResourceUrlFromString(uri);return goog.net.jsloader.safeLoad(trustedUri,opt_options);};goog.net.jsloader.safeLoad=function(trustedUri,opt_options){var options=opt_options||{},doc=options.document||document,uri=goog.html.TrustedResourceUrl.unwrap(trustedUri),script=goog.dom.createElement("SCRIPT"),request={script_:script,timeout_:void 0},deferred=new goog.async.Deferred(goog.net.jsloader.cancel_,request),timeout=null,timeoutDuration=goog.isDefAndNotNull(options.timeout)?options.timeout:goog.net.jsloader.DEFAULT_TIMEOUT;0<timeoutDuration&&(timeout=window.setTimeout(function(){goog.net.jsloader.cleanup_(script,!0);deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.TIMEOUT,"Timeout reached for loading script "+uri));},timeoutDuration),request.timeout_=timeout);script.onload=script.onreadystatechange=function(){script.readyState&&"loaded"!=script.readyState&&"complete"!=script.readyState||(goog.net.jsloader.cleanup_(script,options.cleanupWhenDone||!1,timeout),deferred.callback(null));};script.onerror=function(){goog.net.jsloader.cleanup_(script,!0,timeout);deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.LOAD_ERROR,"Error while loading script "+uri));};var properties=options.attributes||{};goog.object.extend(properties,{type:"text/javascript",charset:"UTF-8",src:uri});goog.dom.setProperties(script,properties);goog.net.jsloader.getScriptParentElement_(doc).appendChild(script);return deferred;};goog.net.jsloader.loadAndVerify=function(uri,verificationObjName,options){var trustedUri=goog.html.legacyconversions.trustedResourceUrlFromString(uri);return goog.net.jsloader.safeLoadAndVerify(trustedUri,verificationObjName,options);};goog.net.jsloader.safeLoadAndVerify=function(trustedUri,verificationObjName,options){goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_]||(goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_]={});var verifyObjs=goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_],uri=goog.html.TrustedResourceUrl.unwrap(trustedUri);if(goog.isDef(verifyObjs[verificationObjName])){return goog.async.Deferred.fail(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.VERIFY_OBJECT_ALREADY_EXISTS,"Verification object "+verificationObjName+" already defined."));}var sendDeferred=goog.net.jsloader.safeLoad(trustedUri,options),deferred=new goog.async.Deferred(goog.bind(sendDeferred.cancel,sendDeferred));sendDeferred.addCallback(function(){var result=verifyObjs[verificationObjName];goog.isDef(result)?(deferred.callback(result),delete verifyObjs[verificationObjName]):deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.VERIFY_ERROR,"Script "+uri+" loaded, but verification object "+verificationObjName+" was not defined."));});sendDeferred.addErrback(function(error){goog.isDef(verifyObjs[verificationObjName])&&delete verifyObjs[verificationObjName];deferred.errback(error);});return deferred;};goog.net.jsloader.getScriptParentElement_=function(doc){var headElements=goog.dom.getElementsByTagName("HEAD",doc);return!headElements||goog.array.isEmpty(headElements)?doc.documentElement:headElements[0];};goog.net.jsloader.cancel_=function(){if(this&&this.script_){var scriptNode=this.script_;scriptNode&&"SCRIPT"==scriptNode.tagName&&goog.net.jsloader.cleanup_(scriptNode,!0,this.timeout_);}};goog.net.jsloader.cleanup_=function(scriptNode,removeScriptNode,opt_timeout){goog.isDefAndNotNull(opt_timeout)&&goog.global.clearTimeout(opt_timeout);scriptNode.onload=goog.nullFunction;scriptNode.onerror=goog.nullFunction;scriptNode.onreadystatechange=goog.nullFunction;removeScriptNode&&window.setTimeout(function(){goog.dom.removeNode(scriptNode);},0);};goog.net.jsloader.ErrorCode={LOAD_ERROR:0,TIMEOUT:1,VERIFY_ERROR:2,VERIFY_OBJECT_ALREADY_EXISTS:3};goog.net.jsloader.Error=function(code,opt_message){var msg="Jsloader error (code #"+code+")";opt_message&&(msg+=": "+opt_message);goog.debug.Error.call(this,msg);this.code=code;};goog.inherits(goog.net.jsloader.Error,goog.debug.Error);goog.Uri=function(opt_uri,opt_ignoreCase){this.domain_=this.userInfo_=this.scheme_="";this.port_=null;this.fragment_=this.path_="";this.ignoreCase_=this.isReadOnly_=!1;var m;opt_uri instanceof goog.Uri?(this.ignoreCase_=goog.isDef(opt_ignoreCase)?opt_ignoreCase:opt_uri.getIgnoreCase(),this.setScheme(opt_uri.getScheme()),this.setUserInfo(opt_uri.getUserInfo()),this.setDomain(opt_uri.getDomain()),this.setPort(opt_uri.getPort()),this.setPath(opt_uri.getPath()),this.setQueryData(opt_uri.getQueryData().clone()),this.setFragment(opt_uri.getFragment())):opt_uri&&(m=goog.uri.utils.split(String(opt_uri)))?(this.ignoreCase_=!!opt_ignoreCase,this.setScheme(m[goog.uri.utils.ComponentIndex.SCHEME]||"",!0),this.setUserInfo(m[goog.uri.utils.ComponentIndex.USER_INFO]||"",!0),this.setDomain(m[goog.uri.utils.ComponentIndex.DOMAIN]||"",!0),this.setPort(m[goog.uri.utils.ComponentIndex.PORT]),this.setPath(m[goog.uri.utils.ComponentIndex.PATH]||"",!0),this.setQueryData(m[goog.uri.utils.ComponentIndex.QUERY_DATA]||"",!0),this.setFragment(m[goog.uri.utils.ComponentIndex.FRAGMENT]||"",!0)):(this.ignoreCase_=!!opt_ignoreCase,this.queryData_=new goog.Uri.QueryData(null,null,this.ignoreCase_));};goog.Uri.preserveParameterTypesCompatibilityFlag=!1;goog.Uri.RANDOM_PARAM=goog.uri.utils.StandardQueryParam.RANDOM;goog.Uri.prototype.toString=function(){var out=[],scheme=this.getScheme();scheme&&out.push(goog.Uri.encodeSpecialChars_(scheme,goog.Uri.reDisallowedInSchemeOrUserInfo_,!0),":");var domain=this.getDomain();if(domain||"file"==scheme){out.push("//");var userInfo=this.getUserInfo();userInfo&&out.push(goog.Uri.encodeSpecialChars_(userInfo,goog.Uri.reDisallowedInSchemeOrUserInfo_,!0),"@");out.push(goog.Uri.removeDoubleEncoding_(goog.string.urlEncode(domain)));var port=this.getPort();null!=port&&out.push(":",String(port));}var path=this.getPath();path&&(this.hasDomain()&&"/"!=path.charAt(0)&&out.push("/"),out.push(goog.Uri.encodeSpecialChars_(path,"/"==path.charAt(0)?goog.Uri.reDisallowedInAbsolutePath_:goog.Uri.reDisallowedInRelativePath_,!0)));var query=this.getEncodedQuery();query&&out.push("?",query);var fragment=this.getFragment();fragment&&out.push("#",goog.Uri.encodeSpecialChars_(fragment,goog.Uri.reDisallowedInFragment_));return out.join("");};goog.Uri.prototype.resolve=function(relativeUri){var absoluteUri=this.clone(),overridden=relativeUri.hasScheme();overridden?absoluteUri.setScheme(relativeUri.getScheme()):overridden=relativeUri.hasUserInfo();overridden?absoluteUri.setUserInfo(relativeUri.getUserInfo()):overridden=relativeUri.hasDomain();overridden?absoluteUri.setDomain(relativeUri.getDomain()):overridden=relativeUri.hasPort();var path=relativeUri.getPath();if(overridden){absoluteUri.setPort(relativeUri.getPort());}else{if(overridden=relativeUri.hasPath()){if("/"!=path.charAt(0)){if(this.hasDomain()&&!this.hasPath()){path="/"+path;}else{var lastSlashIndex=absoluteUri.getPath().lastIndexOf("/");-1!=lastSlashIndex&&(path=absoluteUri.getPath().substr(0,lastSlashIndex+1)+path);}}path=goog.Uri.removeDotSegments(path);}}overridden?absoluteUri.setPath(path):overridden=relativeUri.hasQuery();overridden?absoluteUri.setQueryData(relativeUri.getQueryData().clone()):overridden=relativeUri.hasFragment();overridden&&absoluteUri.setFragment(relativeUri.getFragment());return absoluteUri;};goog.Uri.prototype.clone=function(){return new goog.Uri(this);};goog.Uri.prototype.getScheme=function(){return this.scheme_;};goog.Uri.prototype.setScheme=function(newScheme,opt_decode){this.enforceReadOnly();if(this.scheme_=opt_decode?goog.Uri.decodeOrEmpty_(newScheme,!0):newScheme){this.scheme_=this.scheme_.replace(/:$/,"");}return this;};goog.Uri.prototype.hasScheme=function(){return!!this.scheme_;};goog.Uri.prototype.getUserInfo=function(){return this.userInfo_;};goog.Uri.prototype.setUserInfo=function(newUserInfo,opt_decode){this.enforceReadOnly();this.userInfo_=opt_decode?goog.Uri.decodeOrEmpty_(newUserInfo):newUserInfo;return this;};goog.Uri.prototype.hasUserInfo=function(){return!!this.userInfo_;};goog.Uri.prototype.getDomain=function(){return this.domain_;};goog.Uri.prototype.setDomain=function(newDomain,opt_decode){this.enforceReadOnly();this.domain_=opt_decode?goog.Uri.decodeOrEmpty_(newDomain,!0):newDomain;return this;};goog.Uri.prototype.hasDomain=function(){return!!this.domain_;};goog.Uri.prototype.getPort=function(){return this.port_;};goog.Uri.prototype.setPort=function(newPort){this.enforceReadOnly();if(newPort){newPort=Number(newPort);if(isNaN(newPort)||0>newPort){throw Error("Bad port number "+newPort);}this.port_=newPort;}else{this.port_=null;}return this;};goog.Uri.prototype.hasPort=function(){return null!=this.port_;};goog.Uri.prototype.getPath=function(){return this.path_;};goog.Uri.prototype.setPath=function(newPath,opt_decode){this.enforceReadOnly();this.path_=opt_decode?goog.Uri.decodeOrEmpty_(newPath,!0):newPath;return this;};goog.Uri.prototype.hasPath=function(){return!!this.path_;};goog.Uri.prototype.hasQuery=function(){return""!==this.queryData_.toString();};goog.Uri.prototype.setQueryData=function(queryData,opt_decode){this.enforceReadOnly();queryData instanceof goog.Uri.QueryData?(this.queryData_=queryData,this.queryData_.setIgnoreCase(this.ignoreCase_)):(opt_decode||(queryData=goog.Uri.encodeSpecialChars_(queryData,goog.Uri.reDisallowedInQuery_)),this.queryData_=new goog.Uri.QueryData(queryData,null,this.ignoreCase_));return this;};goog.Uri.prototype.setQuery=function(newQuery,opt_decode){return this.setQueryData(newQuery,opt_decode);};goog.Uri.prototype.getEncodedQuery=function(){return this.queryData_.toString();};goog.Uri.prototype.getDecodedQuery=function(){return this.queryData_.toDecodedString();};goog.Uri.prototype.getQueryData=function(){return this.queryData_;};goog.Uri.prototype.getQuery=function(){return this.getEncodedQuery();};goog.Uri.prototype.setParameterValue=function(key,value){this.enforceReadOnly();this.queryData_.set(key,value);return this;};goog.Uri.prototype.setParameterValues=function(key,values){this.enforceReadOnly();goog.isArray(values)||(values=[String(values)]);this.queryData_.setValues(key,values);return this;};goog.Uri.prototype.getParameterValues=function(name){return this.queryData_.getValues(name);};goog.Uri.prototype.getParameterValue=function(paramName){return this.queryData_.get(paramName);};goog.Uri.prototype.getFragment=function(){return this.fragment_;};goog.Uri.prototype.setFragment=function(newFragment,opt_decode){this.enforceReadOnly();this.fragment_=opt_decode?goog.Uri.decodeOrEmpty_(newFragment):newFragment;return this;};goog.Uri.prototype.hasFragment=function(){return!!this.fragment_;};goog.Uri.prototype.hasSameDomainAs=function(uri2){return(!this.hasDomain()&&!uri2.hasDomain()||this.getDomain()==uri2.getDomain())&&(!this.hasPort()&&!uri2.hasPort()||this.getPort()==uri2.getPort());};goog.Uri.prototype.makeUnique=function(){this.enforceReadOnly();this.setParameterValue(goog.Uri.RANDOM_PARAM,goog.string.getRandomString());return this;};goog.Uri.prototype.removeParameter=function(key){this.enforceReadOnly();this.queryData_.remove(key);return this;};goog.Uri.prototype.setReadOnly=function(isReadOnly){this.isReadOnly_=isReadOnly;return this;};goog.Uri.prototype.isReadOnly=function(){return this.isReadOnly_;};goog.Uri.prototype.enforceReadOnly=function(){if(this.isReadOnly_){throw Error("Tried to modify a read-only Uri");}};goog.Uri.prototype.setIgnoreCase=function(ignoreCase){this.ignoreCase_=ignoreCase;this.queryData_&&this.queryData_.setIgnoreCase(ignoreCase);return this;};goog.Uri.prototype.getIgnoreCase=function(){return this.ignoreCase_;};goog.Uri.parse=function(uri,opt_ignoreCase){return uri instanceof goog.Uri?uri.clone():new goog.Uri(uri,opt_ignoreCase);};goog.Uri.create=function(opt_scheme,opt_userInfo,opt_domain,opt_port,opt_path,opt_query,opt_fragment,opt_ignoreCase){var uri=new goog.Uri(null,opt_ignoreCase);opt_scheme&&uri.setScheme(opt_scheme);opt_userInfo&&uri.setUserInfo(opt_userInfo);opt_domain&&uri.setDomain(opt_domain);opt_port&&uri.setPort(opt_port);opt_path&&uri.setPath(opt_path);opt_query&&uri.setQueryData(opt_query);opt_fragment&&uri.setFragment(opt_fragment);return uri;};goog.Uri.resolve=function(base,rel){base instanceof goog.Uri||(base=goog.Uri.parse(base));rel instanceof goog.Uri||(rel=goog.Uri.parse(rel));return base.resolve(rel);};goog.Uri.removeDotSegments=function(path){if(".."==path||"."==path){return"";}if(goog.string.contains(path,"./")||goog.string.contains(path,"/.")){for(var leadingSlash=goog.string.startsWith(path,"/"),segments=path.split("/"),out=[],pos=0;pos<segments.length;){var segment=segments[pos++];"."==segment?leadingSlash&&pos==segments.length&&out.push(""):".."==segment?((1<out.length||1==out.length&&""!=out[0])&&out.pop(),leadingSlash&&pos==segments.length&&out.push("")):(out.push(segment),leadingSlash=!0);}return out.join("/");}return path;};goog.Uri.decodeOrEmpty_=function(val,opt_preserveReserved){return val?opt_preserveReserved?decodeURI(val.replace(/%25/g,"%2525")):decodeURIComponent(val):"";};goog.Uri.encodeSpecialChars_=function(unescapedPart,extra,opt_removeDoubleEncoding){if(goog.isString(unescapedPart)){var encoded=encodeURI(unescapedPart).replace(extra,goog.Uri.encodeChar_);opt_removeDoubleEncoding&&(encoded=goog.Uri.removeDoubleEncoding_(encoded));return encoded;}return null;};goog.Uri.encodeChar_=function(ch){var n=ch.charCodeAt(0);return"%"+(n>>4&15).toString(16)+(n&15).toString(16);};goog.Uri.removeDoubleEncoding_=function(doubleEncodedString){return doubleEncodedString.replace(/%25([0-9a-fA-F]{2})/g,"%$1");};goog.Uri.reDisallowedInSchemeOrUserInfo_=/[#\\/\\?@]/g;goog.Uri.reDisallowedInRelativePath_=/[\\#\\?:]/g;goog.Uri.reDisallowedInAbsolutePath_=/[\\#\\?]/g;goog.Uri.reDisallowedInQuery_=/[\\#\\?@]/g;goog.Uri.reDisallowedInFragment_=/#/g;goog.Uri.haveSameDomain=function(uri1String,uri2String){var pieces1=goog.uri.utils.split(uri1String),pieces2=goog.uri.utils.split(uri2String);return pieces1[goog.uri.utils.ComponentIndex.DOMAIN]==pieces2[goog.uri.utils.ComponentIndex.DOMAIN]&&pieces1[goog.uri.utils.ComponentIndex.PORT]==pieces2[goog.uri.utils.ComponentIndex.PORT];};goog.Uri.QueryData=function(opt_query,opt_uri,opt_ignoreCase){this.count_=this.keyMap_=null;this.encodedQuery_=opt_query||null;this.ignoreCase_=!!opt_ignoreCase;};goog.Uri.QueryData.prototype.ensureKeyMapInitialized_=function(){if(!this.keyMap_&&(this.keyMap_=new goog.structs.Map(),this.count_=0,this.encodedQuery_)){var self=this;goog.uri.utils.parseQueryData(this.encodedQuery_,function(name,value){self.add(goog.string.urlDecode(name),value);});}};goog.Uri.QueryData.createFromMap=function(map,opt_uri,opt_ignoreCase){var keys=goog.structs.getKeys(map);if("undefined"==typeof keys){throw Error("Keys are undefined");}for(var queryData=new goog.Uri.QueryData(null,null,opt_ignoreCase),values=goog.structs.getValues(map),i=0;i<keys.length;i++){var key=keys[i],value=values[i];goog.isArray(value)?queryData.setValues(key,value):queryData.add(key,value);}return queryData;};goog.Uri.QueryData.createFromKeysValues=function(keys,values,opt_uri,opt_ignoreCase){if(keys.length!=values.length){throw Error("Mismatched lengths for keys/values");}for(var queryData=new goog.Uri.QueryData(null,null,opt_ignoreCase),i=0;i<keys.length;i++){queryData.add(keys[i],values[i]);}return queryData;};goog.Uri.QueryData.prototype.getCount=function(){this.ensureKeyMapInitialized_();return this.count_;};goog.Uri.QueryData.prototype.add=function(key,value){this.ensureKeyMapInitialized_();this.invalidateCache_();key=this.getKeyName_(key);var values=this.keyMap_.get(key);values||this.keyMap_.set(key,values=[]);values.push(value);this.count_=goog.asserts.assertNumber(this.count_)+1;return this;};goog.Uri.QueryData.prototype.remove=function(key){this.ensureKeyMapInitialized_();key=this.getKeyName_(key);return this.keyMap_.containsKey(key)?(this.invalidateCache_(),this.count_=goog.asserts.assertNumber(this.count_)-this.keyMap_.get(key).length,this.keyMap_.remove(key)):!1;};goog.Uri.QueryData.prototype.clear=function(){this.invalidateCache_();this.keyMap_=null;this.count_=0;};goog.Uri.QueryData.prototype.isEmpty=function(){this.ensureKeyMapInitialized_();return 0==this.count_;};goog.Uri.QueryData.prototype.containsKey=function(key){this.ensureKeyMapInitialized_();key=this.getKeyName_(key);return this.keyMap_.containsKey(key);};goog.Uri.QueryData.prototype.containsValue=function(value){var vals=this.getValues();return goog.array.contains(vals,value);};goog.Uri.QueryData.prototype.forEach=function(f,opt_scope){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(values,key){goog.array.forEach(values,function(value){f.call(opt_scope,value,key,this);},this);},this);};goog.Uri.QueryData.prototype.forEach=function(f,opt_scope){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(values,key){goog.array.forEach(values,function(value){f.call(opt_scope,value,key,this);},this);},this);};goog.Uri.QueryData.prototype.getKeys=function(){this.ensureKeyMapInitialized_();for(var vals=this.keyMap_.getValues(),keys=this.keyMap_.getKeys(),rv=[],i=0;i<keys.length;i++){for(var val=vals[i],j=0;j<val.length;j++){rv.push(keys[i]);}}return rv;};goog.Uri.QueryData.prototype.getValues=function(opt_key){this.ensureKeyMapInitialized_();var rv=[];if(goog.isString(opt_key)){this.containsKey(opt_key)&&(rv=goog.array.concat(rv,this.keyMap_.get(this.getKeyName_(opt_key))));}else{for(var values=this.keyMap_.getValues(),i=0;i<values.length;i++){rv=goog.array.concat(rv,values[i]);}}return rv;};goog.Uri.QueryData.prototype.set=function(key,value){this.ensureKeyMapInitialized_();this.invalidateCache_();key=this.getKeyName_(key);this.containsKey(key)&&(this.count_=goog.asserts.assertNumber(this.count_)-this.keyMap_.get(key).length);this.keyMap_.set(key,[value]);this.count_=goog.asserts.assertNumber(this.count_)+1;return this;};goog.Uri.QueryData.prototype.get=function(key,opt_default){var values=key?this.getValues(key):[];return goog.Uri.preserveParameterTypesCompatibilityFlag?0<values.length?values[0]:opt_default:0<values.length?String(values[0]):opt_default;};goog.Uri.QueryData.prototype.setValues=function(key,values){this.remove(key);0<values.length&&(this.invalidateCache_(),this.keyMap_.set(this.getKeyName_(key),goog.array.clone(values)),this.count_=goog.asserts.assertNumber(this.count_)+values.length);};goog.Uri.QueryData.prototype.toString=function(){if(this.encodedQuery_){return this.encodedQuery_;}if(!this.keyMap_){return"";}for(var sb=[],keys=this.keyMap_.getKeys(),i=0;i<keys.length;i++){for(var key=keys[i],encodedKey=goog.string.urlEncode(key),val=this.getValues(key),j=0;j<val.length;j++){var param=encodedKey;""!==val[j]&&(param+="="+goog.string.urlEncode(val[j]));sb.push(param);}}return this.encodedQuery_=sb.join("&");};goog.Uri.QueryData.prototype.toDecodedString=function(){return goog.Uri.decodeOrEmpty_(this.toString());};goog.Uri.QueryData.prototype.invalidateCache_=function(){this.encodedQuery_=null;};goog.Uri.QueryData.prototype.filterKeys=function(keys){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(value,key){goog.array.contains(keys,key)||this.remove(key);},this);return this;};goog.Uri.QueryData.prototype.clone=function(){var rv=new goog.Uri.QueryData();rv.encodedQuery_=this.encodedQuery_;this.keyMap_&&(rv.keyMap_=this.keyMap_.clone(),rv.count_=this.count_);return rv;};goog.Uri.QueryData.prototype.getKeyName_=function(arg){var keyName=String(arg);this.ignoreCase_&&(keyName=keyName.toLowerCase());return keyName;};goog.Uri.QueryData.prototype.setIgnoreCase=function(ignoreCase){ignoreCase&&!this.ignoreCase_&&(this.ensureKeyMapInitialized_(),this.invalidateCache_(),this.keyMap_.forEach(function(value,key){var lowerCase=key.toLowerCase();key!=lowerCase&&(this.remove(key),this.setValues(lowerCase,value));},this));this.ignoreCase_=ignoreCase;};goog.Uri.QueryData.prototype.extend=function(var_args){for(var i=0;i<arguments.length;i++){goog.structs.forEach(arguments[i],function(value,key){this.add(key,value);},this);}};ee.data={};ee.data.authenticate=function(clientId,success,opt_error,opt_extraScopes,opt_onImmediateFailed){var scopes=[ee.data.AUTH_SCOPE_];opt_extraScopes&&(goog.array.extend(scopes,opt_extraScopes),goog.array.removeDuplicates(scopes));ee.data.authClientId_=clientId;ee.data.authScopes_=scopes;goog.isNull(clientId)?ee.data.authToken_=null:ee.data.ensureAuthLibLoaded_(function(){var onImmediateFailed=opt_onImmediateFailed||goog.partial(ee.data.authenticateViaPopup,success,opt_error);ee.data.refreshAuthToken(success,opt_error,onImmediateFailed);});};ee.data.authenticateViaPopup=function(opt_success,opt_error){goog.global.gapi.auth.authorize({client_id:ee.data.authClientId_,immediate:!1,scope:ee.data.authScopes_.join(" ")},goog.partial(ee.data.handleAuthResult_,opt_success,opt_error));};ee.data.setAuthToken=function(clientId,tokenType,accessToken,expiresIn,opt_extraScopes,opt_callback,opt_updateAuthLibrary){var scopes=[ee.data.AUTH_SCOPE_];opt_extraScopes&&(goog.array.extend(scopes,opt_extraScopes),goog.array.removeDuplicates(scopes));ee.data.authClientId_=clientId;ee.data.authScopes_=scopes;var tokenObject={token_type:tokenType,access_token:accessToken,state:scopes.join(" "),expires_in:expiresIn};ee.data.handleAuthResult_(void 0,void 0,tokenObject);!1===opt_updateAuthLibrary?opt_callback&&opt_callback():ee.data.ensureAuthLibLoaded_(function(){goog.global.gapi.auth.setToken(tokenObject);opt_callback&&opt_callback();});};ee.data.refreshAuthToken=function(opt_success,opt_error,opt_onImmediateFailed){if(ee.data.isAuthTokenRefreshingEnabled_()){var authArgs={client_id:String(ee.data.authClientId_),immediate:!0,scope:ee.data.authScopes_.join(" ")};ee.data.authTokenRefresher_(authArgs,function(result){"immediate_failed"==result.error&&opt_onImmediateFailed?opt_onImmediateFailed():ee.data.handleAuthResult_(opt_success,opt_error,result);});}};ee.data.setAuthTokenRefresher=function(refresher){ee.data.authTokenRefresher_=refresher;};ee.data.getAuthToken=function(){ee.data.authTokenExpiration_&&0<=goog.now()-ee.data.authTokenExpiration_&&ee.data.clearAuthToken();return ee.data.authToken_;};ee.data.clearAuthToken=function(){ee.data.authToken_=null;ee.data.authTokenExpiration_=null;};ee.data.getAuthClientId=function(){return ee.data.authClientId_;};ee.data.getAuthScopes=function(){return ee.data.authScopes_;};ee.data.initialize=function(opt_apiBaseUrl,opt_tileBaseUrl,opt_xsrfToken){goog.isDefAndNotNull(opt_apiBaseUrl)?ee.data.apiBaseUrl_=opt_apiBaseUrl:ee.data.initialized_||(ee.data.apiBaseUrl_=ee.data.DEFAULT_API_BASE_URL_);goog.isDefAndNotNull(opt_tileBaseUrl)?ee.data.tileBaseUrl_=opt_tileBaseUrl:ee.data.initialized_||(ee.data.tileBaseUrl_=ee.data.DEFAULT_TILE_BASE_URL_);goog.isDef(opt_xsrfToken)&&(ee.data.xsrfToken_=opt_xsrfToken);ee.data.initialized_=!0;};ee.data.reset=function(){ee.data.apiBaseUrl_=null;ee.data.tileBaseUrl_=null;ee.data.xsrfToken_=null;ee.data.initialized_=!1;};ee.data.setDeadline=function(milliseconds){ee.data.deadlineMs_=milliseconds;};ee.data.setParamAugmenter=function(augmenter){ee.data.paramAugmenter_=augmenter||goog.functions.identity;};goog.exportSymbol("ee.data.setParamAugmenter",ee.data.setParamAugmenter);ee.data.getApiBaseUrl=function(){return ee.data.apiBaseUrl_;};ee.data.getTileBaseUrl=function(){return ee.data.tileBaseUrl_;};ee.data.getXsrfToken=function(){return ee.data.xsrfToken_;};ee.data.getAlgorithms=function(opt_callback){return ee.data.send_("/algorithms",null,opt_callback,"GET");};ee.data.getMapId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/mapid",ee.data.makeRequest_(params),opt_callback);};ee.data.getTileUrl=function(mapid,x,y,z){var width=Math.pow(2,z);x%=width;0>x&&(x+=width);return[ee.data.tileBaseUrl_,"map",mapid.mapid,z,x,y].join("/")+"?token="+mapid.token;};ee.data.getValue=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/value",ee.data.makeRequest_(params),opt_callback);};ee.data.getThumbId=function(params,opt_callback){params=goog.object.clone(params);goog.isArray(params.dimensions)&&(params.dimensions=params.dimensions.join("x"));var request=ee.data.makeRequest_(params).add("getid","1");return ee.data.send_("/thumb",request,opt_callback);};ee.data.makeThumbUrl=function(id){return ee.data.tileBaseUrl_+"/api/thumb?thumbid="+id.thumbid+"&token="+id.token;};ee.data.getDownloadId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/download",ee.data.makeRequest_(params),opt_callback);};ee.data.makeDownloadUrl=function(id){return ee.data.tileBaseUrl_+"/api/download?docid="+id.docid+"&token="+id.token;};ee.data.getTableDownloadId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/table",ee.data.makeRequest_(params),opt_callback);};ee.data.makeTableDownloadUrl=function(id){return ee.data.tileBaseUrl_+"/api/table?docid="+id.docid+"&token="+id.token;};ee.data.withProfiling=function(hook,body,opt_this){var saved=ee.data.profileHook_;try{return ee.data.profileHook_=hook,body.call(opt_this);}finally{ee.data.profileHook_=saved;}};goog.exportSymbol("ee.data.withProfiling",ee.data.withProfiling);ee.data.newTaskId=function(opt_count,opt_callback){var params={};goog.isNumber(opt_count)&&(params.count=opt_count);return ee.data.send_("/newtaskid",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.newTaskId",ee.data.newTaskId);ee.data.getTaskStatus=function(taskId,opt_callback){if(goog.isString(taskId)){taskId=[taskId];}else{if(!goog.isArray(taskId)){throw Error("Invalid taskId: expected a string or an array of strings.");}}var url="/taskstatus?q="+taskId.join();return ee.data.send_(url,null,opt_callback,"GET");};goog.exportSymbol("ee.data.getTaskStatus",ee.data.getTaskStatus);ee.data.getTaskList=function(opt_callback){return ee.data.send_("/tasklist",null,opt_callback,"GET");};goog.exportSymbol("ee.data.getTaskList",ee.data.getTaskList);ee.data.cancelTask=function(taskId,opt_callback){return ee.data.updateTask(taskId,ee.data.TaskUpdateActions.CANCEL,opt_callback);};goog.exportSymbol("ee.data.cancelTask",ee.data.cancelTask);ee.data.updateTask=function(taskId,action,opt_callback){if(goog.isString(taskId)){taskId=[taskId];}else{if(!goog.isArray(taskId)){throw Error("Invalid taskId: expected a string or an array of strings.");}}if(!goog.object.containsValue(ee.data.TaskUpdateActions,action)){throw Error("Invalid action: "+action);}return ee.data.send_("/updatetask",ee.data.makeRequest_({id:taskId,action:action}),opt_callback,"POST");};goog.exportSymbol("ee.data.updateTask",ee.data.updateTask);ee.data.startProcessing=function(taskId,params,opt_callback){params=goog.object.clone(params);params.id=taskId;return ee.data.send_("/processingrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startProcessing",ee.data.startProcessing);ee.data.startIngestion=function(taskId,request,opt_callback){var params={id:taskId,request:goog.json.serialize(request)};return ee.data.send_("/ingestionrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startIngestion",ee.data.startIngestion);ee.data.startTableIngestion=function(taskId,request,opt_callback){var params={id:taskId,tableRequest:goog.json.serialize(request)};return ee.data.send_("/ingestionrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startTableIngestion",ee.data.startTableIngestion);ee.data.getInfo=function(id,opt_callback){return ee.data.send_("/info",new goog.Uri.QueryData().add("id",id),opt_callback);};ee.data.getList=function(params,opt_callback){var request=ee.data.makeRequest_(params);return ee.data.send_("/list",request,opt_callback);};ee.data.getAssetRoots=function(opt_callback){return ee.data.send_("/buckets",null,opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetRoots",ee.data.getAssetRoots);ee.data.createAssetHome=function(requestedId,opt_callback){var request=ee.data.makeRequest_({id:requestedId});ee.data.send_("/createbucket",request,opt_callback);};goog.exportSymbol("ee.data.createAssetHome",ee.data.createAssetHome);ee.data.createAsset=function(value,opt_path,opt_force,opt_callback){goog.isString(value)||(value=goog.json.serialize(value));var args={value:value};void 0!==opt_path&&(args.id=opt_path);args.force=opt_force||!1;return ee.data.send_("/create",ee.data.makeRequest_(args),opt_callback);};goog.exportSymbol("ee.data.createAsset",ee.data.createAsset);ee.data.createFolder=function(path,opt_force,opt_callback){return ee.data.send_("/createfolder",ee.data.makeRequest_({id:path,force:opt_force||!1}),opt_callback);};goog.exportSymbol("ee.data.createFolder",ee.data.createFolder);ee.data.search=function(query,opt_callback){return ee.data.send_("/search",ee.data.makeRequest_({q:query}),opt_callback);};ee.data.renameAsset=function(sourceId,destinationId,opt_callback){ee.data.send_("/rename",ee.data.makeRequest_({sourceId:sourceId,destinationId:destinationId}),opt_callback);};goog.exportSymbol("ee.data.renameAsset",ee.data.renameAsset);ee.data.copyAsset=function(sourceId,destinationId,opt_callback){ee.data.send_("/copy",ee.data.makeRequest_({sourceId:sourceId,destinationId:destinationId}),opt_callback);};goog.exportSymbol("ee.data.copyAsset",ee.data.copyAsset);ee.data.deleteAsset=function(assetId,opt_callback){ee.data.send_("/delete",ee.data.makeRequest_({id:assetId}),opt_callback);};goog.exportSymbol("ee.data.deleteAsset",ee.data.deleteAsset);ee.data.getAssetAcl=function(assetId,opt_callback){return ee.data.send_("/getacl",ee.data.makeRequest_({id:assetId}),opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetAcl",ee.data.getAssetAcl);ee.data.setAssetAcl=function(assetId,aclUpdate,opt_callback){var request={id:assetId,value:goog.json.serialize(aclUpdate)};ee.data.send_("/setacl",ee.data.makeRequest_(request),opt_callback);};goog.exportSymbol("ee.data.setAssetAcl",ee.data.setAssetAcl);ee.data.setAssetProperties=function(assetId,properties,opt_callback){var request={id:assetId,properties:goog.json.serialize(properties)};ee.data.send_("/setproperties",ee.data.makeRequest_(request),opt_callback);};goog.exportSymbol("ee.data.setAssetProperties",ee.data.setAssetProperties);ee.data.getAssetRootQuota=function(rootId,opt_callback){return ee.data.send_("/quota",ee.data.makeRequest_({id:rootId}),opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetRootQuota",ee.data.getAssetRootQuota);ee.data.AssetType={ALGORITHM:"Algorithm",FOLDER:"Folder",IMAGE:"Image",IMAGE_COLLECTION:"ImageCollection",TABLE:"Table",UNKNOWN:"Unknown"};ee.data.ExportType={IMAGE:"EXPORT_IMAGE",MAP:"EXPORT_TILES",TABLE:"EXPORT_FEATURES",VIDEO:"EXPORT_VIDEO"};ee.data.SystemTimeProperty={START:"system:time_start",END:"system:time_end"};ee.data.SYSTEM_ASSET_SIZE_PROPERTY="system:asset_size";ee.data.AssetDetailsProperty={TITLE:"system:title",DESCRIPTION:"system:description",TAGS:"system:tags"};ee.data.ALLOWED_DESCRIPTION_HTML_TABLE_ELEMENTS_="col colgroup caption table tbody td tfoot th thead tr".split(" ");ee.data.ALLOWED_DESCRIPTION_HTML_ELEMENTS=ee.data.ALLOWED_DESCRIPTION_HTML_TABLE_ELEMENTS_.concat("a code em i li ol p strong sub sup ul".split(" "));ee.data.MapZoomRange={MIN:0,MAX:24};ee.data.TaskUpdateActions={CANCEL:"CANCEL",UPDATE:"UPDATE"};ee.data.PyramidingPolicy={MEAN:"MEAN",MODE:"MODE",MIN:"MIN",MAX:"MAX",SAMPLE:"SAMPLE"};ee.data.send_=function(path,params,opt_callback,opt_method){ee.data.initialize();var profileHookAtCallTime=ee.data.profileHook_,headers={"Content-Type":"application/x-www-form-urlencoded"},authToken=ee.data.getAuthToken();if(goog.isDefAndNotNull(authToken)){headers.Authorization=authToken;}else{if(opt_callback&&ee.data.isAuthTokenRefreshingEnabled_()){return ee.data.refreshAuthToken(function(){ee.data.withProfiling(profileHookAtCallTime,function(){ee.data.send_(path,params,opt_callback,opt_method);});}),null;}}var method=opt_method||"POST";params=params?params.clone():new goog.Uri.QueryData();profileHookAtCallTime&&params.add("profiling","1");params=ee.data.paramAugmenter_(params,path);goog.isDefAndNotNull(ee.data.xsrfToken_)&&(headers["X-XSRF-Token"]=ee.data.xsrfToken_);var requestData=params?params.toString():"";"GET"!=method||goog.string.isEmptyOrWhitespace(requestData)||(path+=goog.string.contains(path,"?")?"&":"?",path+=requestData,requestData=null);var url=ee.data.apiBaseUrl_+path;if(opt_callback){var request=ee.data.buildAsyncRequest_(url,opt_callback,method,requestData,headers);ee.data.requestQueue_.push(request);ee.data.RequestThrottle_.fire();return null;}for(var setRequestHeader=function setRequestHeader(value,key){this.setRequestHeader&&this.setRequestHeader(key,value);},xmlHttp,retries=0;;){xmlHttp=goog.net.XmlHttp();xmlHttp.open(method,url,!1);goog.object.forEach(headers,setRequestHeader,xmlHttp);xmlHttp.send(requestData);if(429!=xmlHttp.status||retries>ee.data.MAX_SYNC_RETRIES_){break;}retries++;}return ee.data.handleResponse_(xmlHttp.status,function getResponseHeaderSafe(header){try{return xmlHttp.getResponseHeader(header);}catch(e){return null;}},xmlHttp.responseText,profileHookAtCallTime);};ee.data.buildAsyncRequest_=function(url,callback,method,content,headers){var retries=0,request={url:url,method:method,content:content,headers:headers},profileHookAtCallTime=ee.data.profileHook_;request.callback=function(e){var xhrIo=e.target;return 429==xhrIo.getStatus()&&retries<ee.data.MAX_ASYNC_RETRIES_?(retries++,setTimeout(function(){ee.data.requestQueue_.push(request);ee.data.RequestThrottle_.fire();},ee.data.calculateRetryWait_(retries)),null):ee.data.handleResponse_(xhrIo.getStatus(),goog.bind(xhrIo.getResponseHeader,xhrIo),xhrIo.getResponseText(),profileHookAtCallTime,callback);};return request;};ee.data.handleResponse_=function(status,getResponseHeader,responseText,profileHook,opt_callback){var profileId=getResponseHeader(ee.data.PROFILE_HEADER);profileId&&profileHook&&profileHook(profileId);var contentType=getResponseHeader("Content-Type"),contentType=contentType?contentType.replace(/;.*/,""):"application/json";if("application/json"==contentType||"text/json"==contentType){try{var response=JSON.parse(responseText);var data=response.data;}catch(e){var errorMessage="Invalid JSON: "+responseText;}}else{errorMessage="Response was unexpectedly not JSON, but "+contentType;}if(goog.isObject(response)){"error"in response&&"message"in response.error?errorMessage=response.error.message:"data"in response||(errorMessage="Malformed response: "+responseText);}else{if(0===status){errorMessage="Failed to contact Earth Engine servers. Please check your connection, firewall, or browser extension settings.";}else{if(200>status||300<=status){errorMessage="Server returned HTTP code: "+status;}}}if(opt_callback){return opt_callback(data,errorMessage),null;}if(!errorMessage){return data;}throw Error(errorMessage);};ee.data.ensureAuthLibLoaded_=function(callback){var done=function done(){goog.global.gapi.config.update("client/cors",!0);ee.data.authTokenRefresher_||ee.data.setAuthTokenRefresher(goog.global.gapi.auth.authorize);callback();};if(goog.isObject(goog.global.gapi)&&goog.isObject(goog.global.gapi.auth)&&goog.isFunction(goog.global.gapi.auth.authorize)){done();}else{for(var callbackName=goog.now().toString(36);callbackName in goog.global;){callbackName+="_";}goog.global[callbackName]=function(){delete goog.global[callbackName];done();};goog.net.jsloader.load(ee.data.AUTH_LIBRARY_URL_+"?onload="+callbackName);}};ee.data.handleAuthResult_=function(success,error,result){if(result.access_token){var token=result.token_type+" "+result.access_token;if(isFinite(result.expires_in)){var expiresInMs=900*result.expires_in;setTimeout(ee.data.refreshAuthToken,0.9*expiresInMs);ee.data.authTokenExpiration_=goog.now()+expiresInMs;}ee.data.authToken_=token;success&&success();}else{error&&error(result.error||"Unknown error.");}};ee.data.makeRequest_=function(params){var request=new goog.Uri.QueryData(),item;for(item in params){request.set(item,params[item]);}return request;};ee.data.setupMockSend=function(opt_calls){function getResponse(url,method,data){url=url.replace(apiBaseUrl,"");if(url in calls){var response=calls[url];}else{throw Error(url+" mock response not specified");}goog.isFunction(response)&&(response=response(url,method,data));goog.isString(response)&&(response={text:response,status:200,contentType:"application/json; charset=utf-8"});if(!goog.isString(response.text)){throw Error(url+" mock response missing/invalid text");}if(!goog.isNumber(response.status)&&!goog.isFunction(response.status)){throw Error(url+" mock response missing/invalid status");}return response;}var calls=opt_calls?goog.object.clone(opt_calls):{},apiBaseUrl;goog.net.XhrIo.send=function(url,callback,method,data){apiBaseUrl=apiBaseUrl||ee.data.apiBaseUrl_;var responseData=getResponse(url,method,data),e=new function(){}();e.target={};e.target.getResponseText=function(){return responseData.text;};e.target.getStatus=goog.isFunction(responseData.status)?responseData.status:function(){return responseData.status;};e.target.getResponseHeader=function(header){return"Content-Type"===header?responseData.contentType:null;};setTimeout(goog.bind(callback,e,e),0);return new goog.net.XhrIo();};var fakeXmlHttp=function fakeXmlHttp(){};fakeXmlHttp.prototype.open=function(method,urlIn){apiBaseUrl=apiBaseUrl||ee.data.apiBaseUrl_;this.url=urlIn;this.method=method;};fakeXmlHttp.prototype.setRequestHeader=function(){};fakeXmlHttp.prototype.getResponseHeader=function(header){return"Content-Type"===header?this.contentType_||null:null;};fakeXmlHttp.prototype.send=function(data){var responseData=getResponse(this.url,this.method,data);this.responseText=responseData.text;this.status=goog.isFunction(responseData.status)?responseData.status():responseData.status;this.contentType_=responseData.contentType;};goog.net.XmlHttp=function(){return new fakeXmlHttp();};};ee.data.isAuthTokenRefreshingEnabled_=function(){return!(!ee.data.authTokenRefresher_||!ee.data.authClientId_);};ee.data.calculateRetryWait_=function(retryCount){return Math.min(ee.data.MAX_RETRY_WAIT_,Math.pow(2,retryCount)*ee.data.BASE_RETRY_WAIT_);};ee.data.sleep_=function(timeInMs){for(var end=new Date().getTime()+timeInMs;new Date().getTime()<end;){}};ee.data.requestQueue_=[];ee.data.REQUEST_THROTTLE_INTERVAL_MS_=350;ee.data.RequestThrottle_=new goog.async.Throttle(function(){var request=ee.data.requestQueue_.shift();request&&goog.net.XhrIo.send(request.url,request.callback,request.method,request.content,request.headers,ee.data.deadlineMs_);goog.array.isEmpty(ee.data.requestQueue_)||ee.data.RequestThrottle_.fire();},ee.data.REQUEST_THROTTLE_INTERVAL_MS_);ee.data.apiBaseUrl_=null;ee.data.tileBaseUrl_=null;ee.data.xsrfToken_=null;ee.data.paramAugmenter_=goog.functions.identity;ee.data.authToken_=null;ee.data.authTokenExpiration_=null;ee.data.authClientId_=null;ee.data.authScopes_=[];ee.data.authTokenRefresher_=null;ee.data.AUTH_SCOPE_="https://www.googleapis.com/auth/earthengine";ee.data.AUTH_LIBRARY_URL_="https://apis.google.com/js/client.js";ee.data.initialized_=!1;ee.data.deadlineMs_=0;ee.data.profileHook_=null;ee.data.BASE_RETRY_WAIT_=1000;ee.data.MAX_RETRY_WAIT_=120000;ee.data.MAX_ASYNC_RETRIES_=10;ee.data.MAX_SYNC_RETRIES_=5;ee.data.PROFILE_HEADER="X-Earth-Engine-Computation-Profile";ee.data.DEFAULT_API_BASE_URL_="https://earthengine.googleapis.com/api";ee.data.DEFAULT_TILE_BASE_URL_="https://earthengine.googleapis.com";goog.structs.Collection=function(){};goog.structs.Node=function(key,value){this.key_=key;this.value_=value;};goog.structs.Node.prototype.getKey=function(){return this.key_;};goog.structs.Node.prototype.getValue=function(){return this.value_;};goog.structs.Node.prototype.clone=function(){return new goog.structs.Node(this.key_,this.value_);};goog.structs.Heap=function(opt_heap){this.nodes_=[];opt_heap&&this.insertAll(opt_heap);};goog.structs.Heap.prototype.insert=function(key,value){var node=new goog.structs.Node(key,value),nodes=this.nodes_;nodes.push(node);this.moveUp_(nodes.length-1);};goog.structs.Heap.prototype.insertAll=function(heap){if(heap instanceof goog.structs.Heap){var keys=heap.getKeys();var values=heap.getValues();if(0>=this.getCount()){for(var nodes=this.nodes_,i=0;i<keys.length;i++){nodes.push(new goog.structs.Node(keys[i],values[i]));}return;}}else{keys=goog.object.getKeys(heap),values=goog.object.getValues(heap);}for(i=0;i<keys.length;i++){this.insert(keys[i],values[i]);}};goog.structs.Heap.prototype.remove=function(){var nodes=this.nodes_,count=nodes.length,rootNode=nodes[0];if(!(0>=count)){return 1==count?goog.array.clear(nodes):(nodes[0]=nodes.pop(),this.moveDown_(0)),rootNode.getValue();}};goog.structs.Heap.prototype.peek=function(){var nodes=this.nodes_;if(0!=nodes.length){return nodes[0].getValue();}};goog.structs.Heap.prototype.peekKey=function(){return this.nodes_[0]&&this.nodes_[0].getKey();};goog.structs.Heap.prototype.moveDown_=function(index){for(var nodes=this.nodes_,count=nodes.length,node=nodes[index];index<count>>1;){var leftChildIndex=this.getLeftChildIndex_(index),rightChildIndex=this.getRightChildIndex_(index),smallerChildIndex=rightChildIndex<count&&nodes[rightChildIndex].getKey()<nodes[leftChildIndex].getKey()?rightChildIndex:leftChildIndex;if(nodes[smallerChildIndex].getKey()>node.getKey()){break;}nodes[index]=nodes[smallerChildIndex];index=smallerChildIndex;}nodes[index]=node;};goog.structs.Heap.prototype.moveUp_=function(index){for(var nodes=this.nodes_,node=nodes[index];0<index;){var parentIndex=this.getParentIndex_(index);if(nodes[parentIndex].getKey()>node.getKey()){nodes[index]=nodes[parentIndex],index=parentIndex;}else{break;}}nodes[index]=node;};goog.structs.Heap.prototype.getLeftChildIndex_=function(index){return 2*index+1;};goog.structs.Heap.prototype.getRightChildIndex_=function(index){return 2*index+2;};goog.structs.Heap.prototype.getParentIndex_=function(index){return index-1>>1;};goog.structs.Heap.prototype.getValues=function(){for(var nodes=this.nodes_,rv=[],l=nodes.length,i=0;i<l;i++){rv.push(nodes[i].getValue());}return rv;};goog.structs.Heap.prototype.getKeys=function(){for(var nodes=this.nodes_,rv=[],l=nodes.length,i=0;i<l;i++){rv.push(nodes[i].getKey());}return rv;};goog.structs.Heap.prototype.containsValue=function(val){return goog.array.some(this.nodes_,function(node){return node.getValue()==val;});};goog.structs.Heap.prototype.containsKey=function(key){return goog.array.some(this.nodes_,function(node){return node.getKey()==key;});};goog.structs.Heap.prototype.clone=function(){return new goog.structs.Heap(this);};goog.structs.Heap.prototype.getCount=function(){return this.nodes_.length;};goog.structs.Heap.prototype.isEmpty=function(){return goog.array.isEmpty(this.nodes_);};goog.structs.Heap.prototype.clear=function(){goog.array.clear(this.nodes_);};goog.structs.Queue=function(){this.front_=[];this.back_=[];};goog.structs.Queue.prototype.maybeFlip_=function(){goog.array.isEmpty(this.front_)&&(this.front_=this.back_,this.front_.reverse(),this.back_=[]);};goog.structs.Queue.prototype.enqueue=function(element){this.back_.push(element);};goog.structs.Queue.prototype.dequeue=function(){this.maybeFlip_();return this.front_.pop();};goog.structs.Queue.prototype.peek=function(){this.maybeFlip_();return goog.array.peek(this.front_);};goog.structs.Queue.prototype.getCount=function(){return this.front_.length+this.back_.length;};goog.structs.Queue.prototype.isEmpty=function(){return goog.array.isEmpty(this.front_)&&goog.array.isEmpty(this.back_);};goog.structs.Queue.prototype.clear=function(){this.front_=[];this.back_=[];};goog.structs.Queue.prototype.contains=function(obj){return goog.array.contains(this.front_,obj)||goog.array.contains(this.back_,obj);};goog.structs.Queue.prototype.remove=function(obj){return goog.array.removeLast(this.front_,obj)||goog.array.remove(this.back_,obj);};goog.structs.Queue.prototype.getValues=function(){for(var res=[],i=this.front_.length-1;0<=i;--i){res.push(this.front_[i]);}for(var len=this.back_.length,i=0;i<len;++i){res.push(this.back_[i]);}return res;};goog.structs.Set=function(opt_values){this.map_=new goog.structs.Map();opt_values&&this.addAll(opt_values);};goog.structs.Set.getKey_=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&val||"function"==type?"o"+goog.getUid(val):type.substr(0,1)+val;};goog.structs.Set.prototype.getCount=function(){return this.map_.getCount();};goog.structs.Set.prototype.add=function(element){this.map_.set(goog.structs.Set.getKey_(element),element);};goog.structs.Set.prototype.addAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.add(values[i]);}};goog.structs.Set.prototype.removeAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.remove(values[i]);}};goog.structs.Set.prototype.remove=function(element){return this.map_.remove(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.clear=function(){this.map_.clear();};goog.structs.Set.prototype.isEmpty=function(){return this.map_.isEmpty();};goog.structs.Set.prototype.contains=function(element){return this.map_.containsKey(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.containsAll=function(col){return goog.structs.every(col,this.contains,this);};goog.structs.Set.prototype.intersection=function(col){for(var result=new goog.structs.Set(),values=goog.structs.getValues(col),i=0;i<values.length;i++){var value=values[i];this.contains(value)&&result.add(value);}return result;};goog.structs.Set.prototype.difference=function(col){var result=this.clone();result.removeAll(col);return result;};goog.structs.Set.prototype.getValues=function(){return this.map_.getValues();};goog.structs.Set.prototype.clone=function(){return new goog.structs.Set(this);};goog.structs.Set.prototype.equals=function(col){return this.getCount()==goog.structs.getCount(col)&&this.isSubsetOf(col);};goog.structs.Set.prototype.isSubsetOf=function(col){var colCount=goog.structs.getCount(col);if(this.getCount()>colCount){return!1;}!(col instanceof goog.structs.Set)&&5<colCount&&(col=new goog.structs.Set(col));return goog.structs.every(this,function(value){return goog.structs.contains(col,value);});};goog.structs.Set.prototype.__iterator__=function(opt_keys){return this.map_.__iterator__(!1);};goog.structs.Set=function(opt_values){this.map_=new goog.structs.Map();opt_values&&this.addAll(opt_values);};goog.structs.Set.getKey_=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&val||"function"==type?"o"+goog.getUid(val):type.substr(0,1)+val;};goog.structs.Set.prototype.getCount=function(){return this.map_.getCount();};goog.structs.Set.prototype.add=function(element){this.map_.set(goog.structs.Set.getKey_(element),element);};goog.structs.Set.prototype.addAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.add(values[i]);}};goog.structs.Set.prototype.removeAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.remove(values[i]);}};goog.structs.Set.prototype.remove=function(element){return this.map_.remove(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.clear=function(){this.map_.clear();};goog.structs.Set.prototype.isEmpty=function(){return this.map_.isEmpty();};goog.structs.Set.prototype.contains=function(element){return this.map_.containsKey(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.containsAll=function(col){return goog.structs.every(col,this.contains,this);};goog.structs.Set.prototype.intersection=function(col){for(var result=new goog.structs.Set(),values=goog.structs.getValues(col),i=0;i<values.length;i++){var value=values[i];this.contains(value)&&result.add(value);}return result;};goog.structs.Set.prototype.difference=function(col){var result=this.clone();result.removeAll(col);return result;};goog.structs.Set.prototype.getValues=function(){return this.map_.getValues();};goog.structs.Set.prototype.clone=function(){return new goog.structs.Set(this);};goog.structs.Set.prototype.equals=function(col){return this.getCount()==goog.structs.getCount(col)&&this.isSubsetOf(col);};goog.structs.Set.prototype.isSubsetOf=function(col){var colCount=goog.structs.getCount(col);if(this.getCount()>colCount){return!1;}!(col instanceof goog.structs.Set)&&5<colCount&&(col=new goog.structs.Set(col));return goog.structs.every(this,function(value){return goog.structs.contains(col,value);});};goog.structs.Set.prototype.__iterator__=function(opt_keys){return this.map_.__iterator__(!1);};goog.structs.Pool=function(opt_minCount,opt_maxCount){goog.Disposable.call(this);this.minCount_=opt_minCount||0;this.maxCount_=opt_maxCount||10;if(this.minCount_>this.maxCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.freeQueue_=new goog.structs.Queue();this.inUseSet_=new goog.structs.Set();this.delay=0;this.lastAccess=null;this.adjustForMinMax();};goog.inherits(goog.structs.Pool,goog.Disposable);goog.structs.Pool.ERROR_MIN_MAX_="[goog.structs.Pool] Min can not be greater than max";goog.structs.Pool.ERROR_DISPOSE_UNRELEASED_OBJS_="[goog.structs.Pool] Objects not released";goog.structs.Pool.prototype.setMinimumCount=function(min){if(min>this.maxCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.minCount_=min;this.adjustForMinMax();};goog.structs.Pool.prototype.setMaximumCount=function(max){if(max<this.minCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.maxCount_=max;this.adjustForMinMax();};goog.structs.Pool.prototype.setDelay=function(delay){this.delay=delay;};goog.structs.Pool.prototype.getObject=function(){var time=goog.now();if(!(goog.isDefAndNotNull(this.lastAccess)&&time-this.lastAccess<this.delay)){var obj=this.removeFreeObject_();obj&&(this.lastAccess=time,this.inUseSet_.add(obj));return obj;}};goog.structs.Pool.prototype.releaseObject=function(obj){return this.inUseSet_.remove(obj)?(this.addFreeObject(obj),!0):!1;};goog.structs.Pool.prototype.removeFreeObject_=function(){for(var obj;0<this.getFreeCount()&&(obj=this.freeQueue_.dequeue(),!this.objectCanBeReused(obj));){this.adjustForMinMax();}!obj&&this.getCount()<this.maxCount_&&(obj=this.createObject());return obj;};goog.structs.Pool.prototype.addFreeObject=function(obj){this.inUseSet_.remove(obj);this.objectCanBeReused(obj)&&this.getCount()<this.maxCount_?this.freeQueue_.enqueue(obj):this.disposeObject(obj);};goog.structs.Pool.prototype.adjustForMinMax=function(){for(var freeQueue=this.freeQueue_;this.getCount()<this.minCount_;){freeQueue.enqueue(this.createObject());}for(;this.getCount()>this.maxCount_&&0<this.getFreeCount();){this.disposeObject(freeQueue.dequeue());}};goog.structs.Pool.prototype.createObject=function(){return{};};goog.structs.Pool.prototype.disposeObject=function(obj){if("function"==typeof obj.dispose){obj.dispose();}else{for(var i in obj){obj[i]=null;}}};goog.structs.Pool.prototype.objectCanBeReused=function(obj){return"function"==typeof obj.canBeReused?obj.canBeReused():!0;};goog.structs.Pool.prototype.contains=function(obj){return this.freeQueue_.contains(obj)||this.inUseSet_.contains(obj);};goog.structs.Pool.prototype.getCount=function(){return this.freeQueue_.getCount()+this.inUseSet_.getCount();};goog.structs.Pool.prototype.getInUseCount=function(){return this.inUseSet_.getCount();};goog.structs.Pool.prototype.getFreeCount=function(){return this.freeQueue_.getCount();};goog.structs.Pool.prototype.isEmpty=function(){return this.freeQueue_.isEmpty()&&this.inUseSet_.isEmpty();};goog.structs.Pool.prototype.disposeInternal=function(){goog.structs.Pool.superClass_.disposeInternal.call(this);if(0<this.getInUseCount()){throw Error(goog.structs.Pool.ERROR_DISPOSE_UNRELEASED_OBJS_);}delete this.inUseSet_;for(var freeQueue=this.freeQueue_;!freeQueue.isEmpty();){this.disposeObject(freeQueue.dequeue());}delete this.freeQueue_;};goog.structs.PriorityQueue=function(){goog.structs.Heap.call(this);};goog.inherits(goog.structs.PriorityQueue,goog.structs.Heap);goog.structs.PriorityQueue.prototype.enqueue=function(priority,value){this.insert(priority,value);};goog.structs.PriorityQueue.prototype.dequeue=function(){return this.remove();};goog.structs.PriorityPool=function(opt_minCount,opt_maxCount){this.delayTimeout_=void 0;this.requestQueue_=new goog.structs.PriorityQueue();goog.structs.Pool.call(this,opt_minCount,opt_maxCount);};goog.inherits(goog.structs.PriorityPool,goog.structs.Pool);goog.structs.PriorityPool.DEFAULT_PRIORITY_=100;goog.structs.PriorityPool.prototype.setDelay=function(delay){goog.structs.PriorityPool.superClass_.setDelay.call(this,delay);goog.isDefAndNotNull(this.lastAccess)&&(goog.global.clearTimeout(this.delayTimeout_),this.delayTimeout_=goog.global.setTimeout(goog.bind(this.handleQueueRequests_,this),this.delay+this.lastAccess-goog.now()),this.handleQueueRequests_());};goog.structs.PriorityPool.prototype.getObject=function(opt_callback,opt_priority){if(!opt_callback){var result=goog.structs.PriorityPool.superClass_.getObject.call(this);result&&this.delay&&(this.delayTimeout_=goog.global.setTimeout(goog.bind(this.handleQueueRequests_,this),this.delay));return result;}this.requestQueue_.enqueue(goog.isDef(opt_priority)?opt_priority:goog.structs.PriorityPool.DEFAULT_PRIORITY_,opt_callback);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.handleQueueRequests_=function(){for(var requestQueue=this.requestQueue_;0<requestQueue.getCount();){var obj=this.getObject();if(obj){requestQueue.dequeue().apply(this,[obj]);}else{break;}}};goog.structs.PriorityPool.prototype.addFreeObject=function(obj){goog.structs.PriorityPool.superClass_.addFreeObject.call(this,obj);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.adjustForMinMax=function(){goog.structs.PriorityPool.superClass_.adjustForMinMax.call(this);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.disposeInternal=function(){goog.structs.PriorityPool.superClass_.disposeInternal.call(this);goog.global.clearTimeout(this.delayTimeout_);this.requestQueue_.clear();this.requestQueue_=null;};ee.layers.EarthEngineTileSource=function(url,mapId,token,opt_profiler){ee.layers.AbstractTileSource.call(this);this.url_=url;this.mapId_=mapId;this.token_=token;this.profiler_=opt_profiler||null;};goog.inherits(ee.layers.EarthEngineTileSource,ee.layers.AbstractTileSource);ee.layers.EarthEngineTileSource.prototype.loadTile=function(tile,opt_priority){var ProfilerHeader=ee.data.PROFILE_HEADER.toLowerCase(),key=goog.events.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){switch(tile.getStatus()){case ee.layers.AbstractTile.Status.LOADED:var profileId=tile.sourceResponseHeaders[ProfilerHeader];this.profiler_&&profileId&&this.profiler_.addTile(tile.div.id,profileId);break;case ee.layers.AbstractTile.Status.FAILED:case ee.layers.AbstractTile.Status.ABORTED:this.profiler_&&""!==tile.div.id&&this.profiler_.removeTile(tile.div.id),goog.events.unlistenByKey(key);}},void 0,this);tile.sourceUrl=this.getTileUrl_(tile.coord,tile.zoom);var handleAvailableToken=goog.bind(this.handleAvailableToken_,this,tile);ee.layers.EarthEngineTileSource.getGlobalTokenPool_().getObject(handleAvailableToken,opt_priority);};ee.layers.EarthEngineTileSource.prototype.getUniqueId=function(){return[this.mapId_,this.token_].join("-");};ee.layers.EarthEngineTileSource.prototype.handleAvailableToken_=function(tile,token){var tokenPool=ee.layers.EarthEngineTileSource.getGlobalTokenPool_();if(tile.isDisposed()||tile.getStatus()==ee.layers.AbstractTile.Status.ABORTED){tokenPool.releaseObject(token);}else{var key=goog.events.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){tile.isDone()&&(goog.events.unlistenByKey(key),tokenPool.releaseObject(token));});tile.startLoad();}};ee.layers.EarthEngineTileSource.prototype.getTileUrl_=function(coord,zoom){var url=[this.url_,this.mapId_,zoom,coord.x,coord.y].join("/"),url=url+("?token="+this.token_);this.profiler_&&this.profiler_.isEnabled()&&(url+="&profiling=1");return url;};ee.layers.EarthEngineTileSource.getGlobalTokenPool_=function(){ee.layers.EarthEngineTileSource.TOKEN_POOL_||(ee.layers.EarthEngineTileSource.TOKEN_POOL_=new goog.structs.PriorityPool(0,ee.layers.EarthEngineTileSource.TOKEN_COUNT_));return ee.layers.EarthEngineTileSource.TOKEN_POOL_;};ee.layers.EarthEngineTileSource.TOKEN_POOL_=null;ee.layers.EarthEngineTileSource.TOKEN_COUNT_=4;goog.net.ImageLoader=function(opt_parent){goog.events.EventTarget.call(this);this.imageIdToRequestMap_={};this.imageIdToImageMap_={};this.handler_=new goog.events.EventHandler(this);this.parent_=opt_parent;};goog.inherits(goog.net.ImageLoader,goog.events.EventTarget);goog.net.ImageLoader.CorsRequestType={ANONYMOUS:"anonymous",USE_CREDENTIALS:"use-credentials"};goog.net.ImageLoader.IMAGE_LOAD_EVENTS_=[goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("11")?goog.net.EventType.READY_STATE_CHANGE:goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];goog.net.ImageLoader.prototype.addImage=function(id,image,opt_corsRequestType){var src=goog.isString(image)?image:image.src;src&&(this.imageIdToRequestMap_[id]={src:src,corsRequestType:goog.isDef(opt_corsRequestType)?opt_corsRequestType:null});};goog.net.ImageLoader.prototype.removeImage=function(id){delete this.imageIdToRequestMap_[id];var image=this.imageIdToImageMap_[id];image&&(delete this.imageIdToImageMap_[id],this.handler_.unlisten(image,goog.net.ImageLoader.IMAGE_LOAD_EVENTS_,this.onNetworkEvent_),goog.object.isEmpty(this.imageIdToImageMap_)&&goog.object.isEmpty(this.imageIdToRequestMap_)&&this.dispatchEvent(goog.net.EventType.COMPLETE));};goog.net.ImageLoader.prototype.start=function(){var imageIdToRequestMap=this.imageIdToRequestMap_;goog.array.forEach(goog.object.getKeys(imageIdToRequestMap),function(id){var imageRequest=imageIdToRequestMap[id];imageRequest&&(delete imageIdToRequestMap[id],this.loadImage_(imageRequest,id));},this);};goog.net.ImageLoader.prototype.loadImage_=function(imageRequest,id){if(!this.isDisposed()){var image=this.parent_?goog.dom.getDomHelper(this.parent_).createDom("IMG"):new Image();imageRequest.corsRequestType&&(image.crossOrigin=imageRequest.corsRequestType);this.handler_.listen(image,goog.net.ImageLoader.IMAGE_LOAD_EVENTS_,this.onNetworkEvent_);this.imageIdToImageMap_[id]=image;image.id=id;image.src=imageRequest.src;}};goog.net.ImageLoader.prototype.onNetworkEvent_=function(evt){var image=evt.currentTarget;if(image){if(evt.type==goog.net.EventType.READY_STATE_CHANGE){if(image.readyState==goog.net.EventType.COMPLETE){evt.type=goog.events.EventType.LOAD;}else{return;}}"undefined"==typeof image.naturalWidth&&(evt.type==goog.events.EventType.LOAD?(image.naturalWidth=image.width,image.naturalHeight=image.height):(image.naturalWidth=0,image.naturalHeight=0));this.dispatchEvent({type:evt.type,target:image});this.isDisposed()||this.removeImage(image.id);}};goog.net.ImageLoader.prototype.disposeInternal=function(){delete this.imageIdToRequestMap_;delete this.imageIdToImageMap_;goog.dispose(this.handler_);goog.net.ImageLoader.superClass_.disposeInternal.call(this);};ee.layers.ImageOverlay=function(tileSource,opt_options){ee.layers.AbstractOverlay.call(this,tileSource,opt_options);};goog.inherits(ee.layers.ImageOverlay,ee.layers.AbstractOverlay);ee.layers.ImageOverlay.prototype.createTile=function(coord,zoom,ownerDocument,uniqueId){return new ee.layers.ImageTile(coord,zoom,ownerDocument,uniqueId);};ee.layers.ImageTile=function(coord,zoom,ownerDocument,uniqueId){ee.layers.AbstractTile.call(this,coord,zoom,ownerDocument,uniqueId);this.renderer=ee.layers.ImageTile.defaultRenderer_;this.imageLoaderListenerKey_=this.imageLoader_=this.imageEl=null;this.objectUrl_="";};goog.inherits(ee.layers.ImageTile,ee.layers.AbstractTile);ee.layers.ImageTile.prototype.finishLoad=function(){try{var imageUrl=this.objectUrl_=URL.createObjectURL(this.sourceData);}catch(e){imageUrl=this.sourceUrl;}this.imageLoader_=new goog.net.ImageLoader();this.imageLoader_.addImage(this.div.id+"-image",imageUrl);this.imageLoaderListenerKey_=goog.events.listenOnce(this.imageLoader_,ee.layers.ImageTile.IMAGE_LOADER_EVENTS_,function(event){event.type==goog.events.EventType.LOAD?(this.imageEl=event.target,ee.layers.AbstractTile.prototype.finishLoad.call(this)):this.retryLoad();},void 0,this);this.imageLoader_.start();};ee.layers.ImageTile.prototype.cancelLoad=function(){ee.layers.ImageTile.superClass_.cancelLoad.call(this);this.imageLoader_&&(goog.events.unlistenByKey(this.imageLoaderListenerKey_),goog.dispose(this.imageLoader_));};ee.layers.ImageTile.prototype.disposeInternal=function(){ee.layers.ImageTile.superClass_.disposeInternal.call(this);this.objectUrl_&&URL.revokeObjectURL(this.objectUrl_);};ee.layers.ImageTile.prototype.disposeInternal=function(){ee.layers.ImageTile.superClass_.disposeInternal.call(this);this.objectUrl_&&URL.revokeObjectURL(this.objectUrl_);};ee.layers.ImageTile.IMAGE_LOADER_EVENTS_=[goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];ee.layers.ImageTile.defaultRenderer_=function(tile){tile.div.appendChild(tile.imageEl);};ee.AbstractOverlay=function(url,mapId,token,opt_init,opt_profiler){goog.events.EventTarget.call(this);this.mapId=mapId;this.token=token;this.tilesLoading=[];this.tilesFailed=new goog.structs.Set();this.tileCounter=0;this.url=url;};goog.inherits(ee.AbstractOverlay,goog.events.EventTarget);ee.AbstractOverlay.EventType={TILE_LOADED:"tileevent"};ee.AbstractOverlay.prototype.getTileId=function(coord,zoom){var maxCoord=1<<zoom,x=coord.x%maxCoord;0>x&&(x+=maxCoord);return[this.mapId,zoom,x,coord.y].join("/");};ee.AbstractOverlay.prototype.getLoadingTilesCount=function(){return this.tilesLoading.length;};ee.AbstractOverlay.prototype.getFailedTilesCount=function(){return this.tilesFailed.getCount();};ee.TileEvent=function(count){goog.events.Event.call(this,ee.AbstractOverlay.EventType.TILE_LOADED);this.count=count;};goog.inherits(ee.TileEvent,goog.events.Event);ee.Encodable=function(){};goog.crypt={};goog.crypt.Hash=function(){this.blockSize=-1;};goog.crypt.Md5=function(){goog.crypt.Hash.call(this);this.blockSize=64;this.chain_=Array(4);this.block_=Array(this.blockSize);this.totalLength_=this.blockLength_=0;this.reset();};goog.inherits(goog.crypt.Md5,goog.crypt.Hash);goog.crypt.Md5.prototype.reset=function(){this.chain_[0]=1732584193;this.chain_[1]=4023233417;this.chain_[2]=2562383102;this.chain_[3]=271733878;this.totalLength_=this.blockLength_=0;};goog.crypt.Md5.prototype.compress_=function(buf,opt_offset){opt_offset||(opt_offset=0);var X=Array(16);if(goog.isString(buf)){for(var i=0;16>i;++i){X[i]=buf.charCodeAt(opt_offset++)|buf.charCodeAt(opt_offset++)<<8|buf.charCodeAt(opt_offset++)<<16|buf.charCodeAt(opt_offset++)<<24;}}else{for(i=0;16>i;++i){X[i]=buf[opt_offset++]|buf[opt_offset++]<<8|buf[opt_offset++]<<16|buf[opt_offset++]<<24;}}var A=this.chain_[0],B=this.chain_[1],C=this.chain_[2],D=this.chain_[3],sum=0,sum=A+(D^B&(C^D))+X[0]+3614090360&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[1]+3905402710&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[2]+606105819&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[3]+3250441966&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[4]+4118548399&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[5]+1200080426&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[6]+2821735955&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[7]+4249261313&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[8]+1770035416&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[9]+2336552879&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[10]+4294925233&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[11]+2304563134&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[12]+1804603682&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[13]+4254626195&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[14]+2792965006&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[15]+1236535329&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(C^D&(B^C))+X[1]+4129170786&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[6]+3225465664&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[11]+643717713&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[0]+3921069994&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[5]+3593408605&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[10]+38016083&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[15]+3634488961&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[4]+3889429448&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[9]+568446438&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[14]+3275163606&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[3]+4107603335&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[8]+1163531501&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[13]+2850285829&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[2]+4243563512&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[7]+1735328473&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[12]+2368359562&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(B^C^D)+X[5]+4294588738&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[8]+2272392833&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[11]+1839030562&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[14]+4259657740&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[1]+2763975236&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[4]+1272893353&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[7]+4139469664&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[10]+3200236656&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[13]+681279174&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[0]+3936430074&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[3]+3572445317&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[6]+76029189&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[9]+3654602809&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[12]+3873151461&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[15]+530742520&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[2]+3299628645&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(C^(B|~D))+X[0]+4096336452&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[7]+1126891415&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[14]+2878612391&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[5]+4237533241&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[12]+1700485571&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[3]+2399980690&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[10]+4293915773&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[1]+2240044497&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[8]+1873313359&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[15]+4264355552&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[6]+2734768916&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[13]+1309151649&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[4]+4149444226&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[11]+3174756917&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[2]+718787259&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[9]+3951481745&4294967295;this.chain_[0]=this.chain_[0]+A&4294967295;this.chain_[1]=this.chain_[1]+(C+(sum<<21&4294967295|sum>>>11))&4294967295;this.chain_[2]=this.chain_[2]+C&4294967295;this.chain_[3]=this.chain_[3]+D&4294967295;};goog.crypt.Md5.prototype.update=function(bytes,opt_length){goog.isDef(opt_length)||(opt_length=bytes.length);for(var lengthMinusBlock=opt_length-this.blockSize,block=this.block_,blockLength=this.blockLength_,i=0;i<opt_length;){if(0==blockLength){for(;i<=lengthMinusBlock;){this.compress_(bytes,i),i+=this.blockSize;}}if(goog.isString(bytes)){for(;i<opt_length;){if(block[blockLength++]=bytes.charCodeAt(i++),blockLength==this.blockSize){this.compress_(block);blockLength=0;break;}}}else{for(;i<opt_length;){if(block[blockLength++]=bytes[i++],blockLength==this.blockSize){this.compress_(block);blockLength=0;break;}}}}this.blockLength_=blockLength;this.totalLength_+=opt_length;};goog.crypt.Md5.prototype.digest=function(){var pad=Array((56>this.blockLength_?this.blockSize:2*this.blockSize)-this.blockLength_);pad[0]=128;for(var i=1;i<pad.length-8;++i){pad[i]=0;}for(var totalBits=8*this.totalLength_,i=pad.length-8;i<pad.length;++i){pad[i]=totalBits&255,totalBits/=256;}this.update(pad);for(var digest=Array(16),n=0,i=0;4>i;++i){for(var j=0;32>j;j+=8){digest[n++]=this.chain_[i]>>>j&255;}}return digest;};ee.Serializer=function(opt_isCompound){this.HASH_KEY="__ee_hash__";this.isCompound_=!1!==opt_isCompound;this.scope_=[];this.encoded_={};this.withHashes_=[];};goog.exportSymbol("ee.Serializer",ee.Serializer);ee.Serializer.jsonSerializer_=new goog.json.Serializer();ee.Serializer.hash_=new goog.crypt.Md5();ee.Serializer.encode=function(obj,opt_isCompound){return new ee.Serializer(goog.isDef(opt_isCompound)?opt_isCompound:!0).encode_(obj);};ee.Serializer.toJSON=function(obj){return ee.Serializer.jsonSerializer_.serialize(ee.Serializer.encode(obj));};ee.Serializer.toReadableJSON=function(obj){var encoded=new ee.Serializer(!1).encode_(obj);return"JSON"in goog.global?goog.global.JSON.stringify(encoded,null,"  "):ee.Serializer.jsonSerializer_.serialize(encoded);};ee.Serializer.prototype.encode_=function(object){var value=this.encodeValue_(object);this.isCompound_&&(value=goog.isObject(value)&&"ValueRef"==value.type&&1==this.scope_.length?this.scope_[0][1]:{type:"CompoundValue",scope:this.scope_,value:value},this.scope_=[],goog.array.forEach(this.withHashes_,goog.bind(function(obj){delete obj[this.HASH_KEY];},this)),this.withHashes_=[],this.encoded_={});return value;};ee.Serializer.prototype.encodeValue_=function(object){if(!goog.isDef(object)){throw Error("Can\'t encode an undefined value.");}var hash=goog.isObject(object)?object[this.HASH_KEY]:null;if(this.isCompound_&&null!=hash&&this.encoded_[hash]){return{type:"ValueRef",value:this.encoded_[hash]};}if(null===object||goog.isBoolean(object)||goog.isNumber(object)||goog.isString(object)){return object;}if(goog.isDateLike(object)){return{type:"Invocation",functionName:"Date",arguments:{value:Math.floor(object.getTime())}};}if(object instanceof ee.Encodable){var result=object.encode(goog.bind(this.encodeValue_,this));if(!(goog.isArray(result)||goog.isObject(result)&&"ArgumentRef"!=result.type)){return result;}}else{if(goog.isArray(object)){result=goog.array.map(object,function(element){return this.encodeValue_(element);},this);}else{if(goog.isObject(object)&&!goog.isFunction(object)){var encodedObject=goog.object.map(object,function(element){if(!goog.isFunction(element)){return this.encodeValue_(element);}},this);goog.object.remove(encodedObject,this.HASH_KEY);result={type:"Dictionary",value:encodedObject};}else{throw Error("Can\'t encode object: "+object);}}}if(this.isCompound_){ee.Serializer.hash_.reset();ee.Serializer.hash_.update(ee.Serializer.jsonSerializer_.serialize(result));var hash=ee.Serializer.hash_.digest().toString();if(this.encoded_[hash]){var name=this.encoded_[hash];}else{name=String(this.scope_.length),this.scope_.push([name,result]),this.encoded_[hash]=name;}object[this.HASH_KEY]=hash;this.withHashes_.push(object);return{type:"ValueRef",value:name};}return result;};ee.ComputedObject=function(func,args,opt_varName){if(!(this instanceof ee.ComputedObject)){return ee.ComputedObject.construct(ee.ComputedObject,arguments);}if(opt_varName&&(func||args)){throw Error(\'When "opt_varName" is specified, "func" and "args" must be null.\');}if(func&&!args){throw Error(\'When "func" is specified, "args" must not be null.\');}this.func=func;this.args=args;this.varName=opt_varName||null;};goog.inherits(ee.ComputedObject,ee.Encodable);goog.exportSymbol("ee.ComputedObject",ee.ComputedObject);ee.ComputedObject.prototype.evaluate=function(callback){if(!callback||!goog.isFunction(callback)){throw Error("evaluate() requires a callback function.");}ee.data.getValue({json:this.serialize()},callback);};ee.ComputedObject.prototype.getInfo=function(opt_callback){return ee.data.getValue({json:this.serialize()},opt_callback);};ee.ComputedObject.prototype.encode=function(encoder){if(this.isVariable()){return{type:"ArgumentRef",value:this.varName};}var encodedArgs={},name;for(name in this.args){goog.isDef(this.args[name])&&(encodedArgs[name]=encoder(this.args[name]));}var result={type:"Invocation",arguments:encodedArgs},func=encoder(this.func);result[goog.isString(func)?"functionName":"function"]=func;return result;};ee.ComputedObject.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.ComputedObject.prototype.toString=function(){return"ee."+this.name()+"("+ee.Serializer.toReadableJSON(this)+")";};goog.exportSymbol("ee.ComputedObject.prototype.toString",ee.ComputedObject.prototype.toString);ee.ComputedObject.prototype.isVariable=function(){return goog.isNull(this.func)&&goog.isNull(this.args);};ee.ComputedObject.prototype.name=function(){return"ComputedObject";};ee.ComputedObject.prototype.aside=function(func,var_args){var args=goog.array.clone(arguments);args[0]=this;func.apply(goog.global,args);return this;};ee.ComputedObject.prototype.castInternal=function(obj){if(obj instanceof this.constructor){return obj;}var klass=function klass(){};klass.prototype=this.constructor.prototype;var result=new klass();result.func=obj.func;result.args=obj.args;result.varName=obj.varName;return result;};ee.ComputedObject.construct=function(constructor,argsArray){function F(){return constructor.apply(this,argsArray);}F.prototype=constructor.prototype;return new F();};ee.Types={};ee.Types.registeredClasses_={};ee.Types.registerClasses=function(classes){ee.Types.registeredClasses_=classes;};ee.Types.nameToClass=function(name){return name in ee.Types.registeredClasses_?ee.Types.registeredClasses_[name]:null;};ee.Types.classToName=function(klass){return klass.prototype instanceof ee.ComputedObject?klass.prototype.name.call(null):klass==Number?"Number":klass==String?"String":klass==Array?"Array":klass==Date?"Date":"Object";};ee.Types.isSubtype=function(firstType,secondType){if(secondType==firstType){return!0;}switch(firstType){case"Element":return"Element"==secondType||"Image"==secondType||"Feature"==secondType||"Collection"==secondType||"ImageCollection"==secondType||"FeatureCollection"==secondType;case"FeatureCollection":case"Collection":return"Collection"==secondType||"ImageCollection"==secondType||"FeatureCollection"==secondType;case"Object":return!0;default:return!1;}};ee.Types.isNumber=function(obj){return goog.isNumber(obj)||obj instanceof ee.ComputedObject&&"Number"==obj.name();};ee.Types.isString=function(obj){return goog.isString(obj)||obj instanceof ee.ComputedObject&&"String"==obj.name();};ee.Types.isArray=function(obj){return goog.isArray(obj)||obj instanceof ee.ComputedObject&&"List"==obj.name();};ee.Types.isRegularObject=function(obj){if(goog.isObject(obj)&&!goog.isFunction(obj)){var proto=Object.getPrototypeOf(obj);return!goog.isNull(proto)&&goog.isNull(Object.getPrototypeOf(proto));}return!1;};ee.Function=function(){if(!(this instanceof ee.Function)){return new ee.Function();}};goog.inherits(ee.Function,ee.Encodable);goog.exportSymbol("ee.Function",ee.Function);ee.Function.promoter_=goog.functions.identity;ee.Function.registerPromoter=function(promoter){ee.Function.promoter_=promoter;};ee.Function.prototype.call=function(var_args){return this.apply(this.nameArgs(Array.prototype.slice.call(arguments,0)));};ee.Function.prototype.apply=function(namedArgs){var result=new ee.ComputedObject(this,this.promoteArgs(namedArgs));return ee.Function.promoter_(result,this.getReturnType());};ee.Function.prototype.callOrApply=function(thisValue,args){var isInstance=goog.isDef(thisValue),signature=this.getSignature(),useKeywordArgs=!1;if(1==args.length&&ee.Types.isRegularObject(args[0])){var params=signature.args;isInstance&&(params=params.slice(1));params.length&&(useKeywordArgs=!((1==params.length||params[1].optional)&&"Dictionary"==params[0].type));}if(useKeywordArgs){var namedArgs=goog.object.clone(args[0]);if(isInstance){var firstArgName=signature.args[0].name;if(firstArgName in namedArgs){throw Error("Named args for "+signature.name+" can\'t contain keyword "+firstArgName);}namedArgs[firstArgName]=thisValue;}}else{namedArgs=this.nameArgs(isInstance?[thisValue].concat(args):args);}return this.apply(namedArgs);};ee.Function.prototype.promoteArgs=function(args){for(var specs=this.getSignature().args,promotedArgs={},known={},i=0;i<specs.length;i++){var name=specs[i].name;if(name in args&&goog.isDef(args[name])){promotedArgs[name]=ee.Function.promoter_(args[name],specs[i].type);}else{if(!specs[i].optional){throw Error("Required argument ("+name+") missing to function: "+this);}}known[name]=!0;}var unknown=[],argName;for(argName in args){known[argName]||unknown.push(argName);}if(0<unknown.length){throw Error("Unrecognized arguments ("+unknown+") to function: "+this);}return promotedArgs;};ee.Function.prototype.nameArgs=function(args){var specs=this.getSignature().args;if(specs.length<args.length){throw Error("Too many ("+args.length+") arguments to function: "+this);}for(var namedArgs={},i=0;i<args.length;i++){namedArgs[specs[i].name]=args[i];}return namedArgs;};ee.Function.prototype.getReturnType=function(){return this.getSignature().returns;};ee.Function.prototype.toString=function(opt_name,opt_isInstance){var signature=this.getSignature(),buffer=[];buffer.push(opt_name||signature.name);buffer.push("(");buffer.push(goog.array.map(signature.args.slice(opt_isInstance?1:0),function(elem){return elem.name;}).join(", "));buffer.push(")\\n");buffer.push("\\n");signature.description?buffer.push(signature.description):buffer.push("Undocumented.");buffer.push("\\n");if(signature.args.length){buffer.push("\\nArgs:\\n");for(var i=0;i<signature.args.length;i++){opt_isInstance&&0==i?buffer.push("  this:"):buffer.push("\\n  ");var arg=signature.args[i];buffer.push(arg.name);buffer.push(" (");buffer.push(arg.type);arg.optional&&buffer.push(", optional");buffer.push("): ");arg.description?buffer.push(arg.description):buffer.push("Undocumented.");}}return buffer.join("");};ee.Function.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.ApiFunction=function(name,opt_signature){if(!goog.isDef(opt_signature)){return ee.ApiFunction.lookup(name);}if(!(this instanceof ee.ApiFunction)){return ee.ComputedObject.construct(ee.ApiFunction,arguments);}this.signature_=goog.object.unsafeClone(opt_signature);this.signature_.name=name;};goog.inherits(ee.ApiFunction,ee.Function);goog.exportSymbol("ee.ApiFunction",ee.ApiFunction);ee.ApiFunction._call=function(name,var_args){return ee.Function.prototype.call.apply(ee.ApiFunction.lookup(name),Array.prototype.slice.call(arguments,1));};ee.ApiFunction._apply=function(name,namedArgs){return ee.ApiFunction.lookup(name).apply(namedArgs);};ee.ApiFunction.prototype.encode=function(encoder){return this.signature_.name;};ee.ApiFunction.prototype.getSignature=function(){return this.signature_;};ee.ApiFunction.api_=null;ee.ApiFunction.boundSignatures_={};ee.ApiFunction.allSignatures=function(){ee.ApiFunction.initialize();return goog.object.map(ee.ApiFunction.api_,function(func){return func.getSignature();});};ee.ApiFunction.unboundFunctions=function(){ee.ApiFunction.initialize();return goog.object.filter(ee.ApiFunction.api_,function(func,name){return!ee.ApiFunction.boundSignatures_[name];});};ee.ApiFunction.lookup=function(name){var func=ee.ApiFunction.lookupInternal(name);if(!func){throw Error("Unknown built-in function name: "+name);}return func;};ee.ApiFunction.lookupInternal=function(name){ee.ApiFunction.initialize();return ee.ApiFunction.api_[name]||null;};ee.ApiFunction.initialize=function(opt_successCallback,opt_failureCallback){if(ee.ApiFunction.api_){opt_successCallback&&opt_successCallback();}else{var callback=function callback(data,opt_error){opt_error?opt_failureCallback&&opt_failureCallback(Error(opt_error)):(ee.ApiFunction.api_=goog.object.map(data,function(sig,name){sig.returns=sig.returns.replace(/<.*>/,"");for(var i=0;i<sig.args.length;i++){sig.args[i].type=sig.args[i].type.replace(/<.*>/,"");}return new ee.ApiFunction(name,sig);}),opt_successCallback&&opt_successCallback());};opt_successCallback?ee.data.getAlgorithms(callback):callback(ee.data.getAlgorithms());}};ee.ApiFunction.reset=function(){ee.ApiFunction.api_=null;ee.ApiFunction.boundSignatures_={};};ee.ApiFunction.importApi=function(target,prefix,typeName,opt_prepend){ee.ApiFunction.initialize();var prepend=opt_prepend||"";goog.object.forEach(ee.ApiFunction.api_,function(apiFunc,name){var parts=name.split(".");if(2==parts.length&&parts[0]==prefix){var fname=prepend+parts[1],signature=apiFunc.getSignature();ee.ApiFunction.boundSignatures_[name]=!0;var isInstance=!1;if(signature.args.length){var firstArgType=signature.args[0].type,isInstance="Object"!=firstArgType&&ee.Types.isSubtype(firstArgType,typeName);}var destination=isInstance?target.prototype:target;fname in destination&&!destination[fname].signature||(destination[fname]=function(var_args){return apiFunc.callOrApply(isInstance?this:void 0,Array.prototype.slice.call(arguments,0));},destination[fname].toString=goog.bind(apiFunc.toString,apiFunc,fname,isInstance),destination[fname].signature=signature);}});};ee.ApiFunction.clearApi=function(target$jscomp$0){var clear=function clear(target){for(var name in target){goog.isFunction(target[name])&&target[name].signature&&delete target[name];}};clear(target$jscomp$0);clear(target$jscomp$0.prototype);};ee.arguments={};ee.arguments.extract=function(fn,originalArgs){var paramNamesWithOptPrefix=ee.arguments.getParamNames_(fn),paramNames=goog.array.map(paramNamesWithOptPrefix,function(param){return param.replace(/^opt_/,"");}),fnName=ee.arguments.getFnName_(fn),fnNameSnippet=fnName?" to function "+fnName:"",args={},firstArg=originalArgs[0],firstArgCouldBeDictionary=goog.isObject(firstArg)&&!goog.isFunction(firstArg)&&!goog.isArray(firstArg)&&!(firstArg instanceof ee.ComputedObject);if(1<originalArgs.length||!firstArgCouldBeDictionary){if(originalArgs.length>paramNames.length){throw Error("Received too many arguments"+fnNameSnippet+". Expected at most "+paramNames.length+" but got "+originalArgs.length+".");}for(var i=0;i<originalArgs.length;i++){args[paramNames[i]]=originalArgs[i];}}else{var seen=new goog.structs.Set(goog.object.getKeys(firstArg)),expected=new goog.structs.Set(paramNames);if(expected.intersection(seen).isEmpty()){args[paramNames[0]]=originalArgs[0];}else{var unexpected=seen.difference(expected);if(!unexpected.isEmpty()){throw Error("Unexpected arguments"+fnNameSnippet+": "+unexpected.getValues().join(", "));}args=goog.object.clone(firstArg);}}var provided=new goog.structs.Set(goog.object.getKeys(args)),missing=new goog.structs.Set(goog.array.filter(paramNamesWithOptPrefix,function(param){return!goog.string.startsWith(param,"opt_");})).difference(provided);if(!missing.isEmpty()){throw Error("Missing required arguments"+fnNameSnippet+": "+missing.getValues().join(", "));}return args;};ee.arguments.getParamNames_=function(fn){var paramNames=[];if(goog.global.EXPORTED_FN_INFO){var exportedFnInfo=goog.global.EXPORTED_FN_INFO[fn.toString()];goog.asserts.assertObject(exportedFnInfo);paramNames=exportedFnInfo.paramNames;goog.asserts.assertArray(paramNames);}else{paramNames=fn.toString().replace(ee.arguments.JS_COMMENT_MATCHER_,"").match(ee.arguments.JS_PARAM_DECL_MATCHER_)[1].split(",")||[];}return paramNames;};ee.arguments.getFnName_=function(fn){return goog.global.EXPORTED_FN_INFO?goog.global.EXPORTED_FN_INFO[fn.toString()].name.split(".").pop()+"()":null;};ee.arguments.JS_COMMENT_MATCHER_=/((\\/\\/.*$)|(\\/\\*[\\s\\S]*?\\*\\/)|(\\s))/mg;ee.arguments.JS_PARAM_DECL_MATCHER_=/^function\\s*[^\\(]*\\(\\s*([^\\)]*)\\)/m;ee.Element=function(func,args,opt_varName){ee.ComputedObject.call(this,func,args,opt_varName);ee.Element.initialize();};goog.inherits(ee.Element,ee.ComputedObject);goog.exportSymbol("ee.Element",ee.Element);ee.Element.initialized_=!1;ee.Element.initialize=function(){ee.Element.initialized_||(ee.ApiFunction.importApi(ee.Element,"Element","Element"),ee.Element.initialized_=!0);};ee.Element.reset=function(){ee.ApiFunction.clearApi(ee.Element);ee.Element.initialized_=!1;};ee.Element.prototype.name=function(){return"Element";};ee.Element.prototype.set=function(var_args){if(1>=arguments.length){var properties=arguments[0];ee.Types.isRegularObject(properties)&&goog.array.equals(goog.object.getKeys(properties),["properties"])&&goog.isObject(properties.properties)&&(properties=properties.properties);if(ee.Types.isRegularObject(properties)){var result=this;for(key in properties){var value=properties[key];result=ee.ApiFunction._call("Element.set",result,key,value);}}else{if(properties instanceof ee.ComputedObject&&ee.ApiFunction.lookupInternal("Element.setMulti")){result=ee.ApiFunction._call("Element.setMulti",this,properties);}else{throw Error("When Element.set() is passed one argument, it must be a dictionary.");}}}else{if(0!=arguments.length%2){throw Error("When Element.set() is passed multiple arguments, there must be an even number of them.");}result=this;for(var i=0;i<arguments.length;i+=2){var key=arguments[i];value=arguments[i+1];result=ee.ApiFunction._call("Element.set",result,key,value);}}return this.castInternal(result);};ee.Filter=function(opt_filter){if(!(this instanceof ee.Filter)){return ee.ComputedObject.construct(ee.Filter,arguments);}if(opt_filter instanceof ee.Filter){return opt_filter;}ee.Filter.initialize();if(goog.isArray(opt_filter)){if(0==opt_filter.length){throw Error("Empty list specified for ee.Filter().");}if(1==opt_filter.length){return new ee.Filter(opt_filter[0]);}ee.ComputedObject.call(this,new ee.ApiFunction("Filter.and"),{filters:opt_filter});this.filter_=opt_filter;}else{if(opt_filter instanceof ee.ComputedObject){ee.ComputedObject.call(this,opt_filter.func,opt_filter.args,opt_filter.varName),this.filter_=[opt_filter];}else{if(goog.isDef(opt_filter)){throw Error("Invalid argument specified for ee.Filter(): "+opt_filter);}ee.ComputedObject.call(this,null,null);this.filter_=[];}}};goog.inherits(ee.Filter,ee.ComputedObject);ee.Filter.initialized_=!1;ee.Filter.initialize=function(){ee.Filter.initialized_||(ee.ApiFunction.importApi(ee.Filter,"Filter","Filter"),ee.Filter.initialized_=!0);};ee.Filter.reset=function(){ee.ApiFunction.clearApi(ee.Filter);ee.Filter.initialized_=!1;};ee.Filter.functionNames_={equals:"equals",less_than:"lessThan",greater_than:"greaterThan",contains:"stringContains",starts_with:"stringStartsWith",ends_with:"stringEndsWith"};ee.Filter.prototype.append_=function(newFilter){var prev=this.filter_.slice(0);newFilter instanceof ee.Filter?goog.array.extend(prev,newFilter.filter_):newFilter instanceof Array?goog.array.extend(prev,newFilter):prev.push(newFilter);return new ee.Filter(prev);};ee.Filter.prototype.not=function(){return ee.ApiFunction._call("Filter.not",this);};ee.Filter.eq=function(name,value){var args=ee.arguments.extract(ee.Filter.eq,arguments);return ee.ApiFunction._call("Filter.equals",args.name,args.value);};ee.Filter.neq=function(name,value){var args=ee.arguments.extract(ee.Filter.neq,arguments);return ee.Filter.eq(args.name,args.value).not();};ee.Filter.lt=function(name,value){var args=ee.arguments.extract(ee.Filter.lt,arguments);return ee.ApiFunction._call("Filter.lessThan",args.name,args.value);};ee.Filter.gte=function(name,value){var args=ee.arguments.extract(ee.Filter.gte,arguments);return ee.Filter.lt(args.name,args.value).not();};ee.Filter.gt=function(name,value){var args=ee.arguments.extract(ee.Filter.gt,arguments);return ee.ApiFunction._call("Filter.greaterThan",args.name,args.value);};ee.Filter.lte=function(name,value){var args=ee.arguments.extract(ee.Filter.lte,arguments);return ee.Filter.gt(args.name,args.value).not();};ee.Filter.and=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.ApiFunction._call("Filter.and",args);};ee.Filter.or=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.ApiFunction._call("Filter.or",args);};ee.Filter.date=function(start,opt_end){var args=ee.arguments.extract(ee.Filter.date,arguments),range=ee.ApiFunction._call("DateRange",args.start,args.end);return ee.ApiFunction._apply("Filter.dateRangeContains",{leftValue:range,rightField:"system:time_start"});};ee.Filter.inList=function(opt_leftField,opt_rightValue,opt_rightField,opt_leftValue){var args=ee.arguments.extract(ee.Filter.inList,arguments);return ee.ApiFunction._apply("Filter.listContains",{leftField:args.rightField,rightValue:args.leftValue,rightField:args.leftField,leftValue:args.rightValue});};ee.Filter.bounds=function(geometry,opt_errorMargin){return ee.ApiFunction._apply("Filter.intersects",{leftField:".all",rightValue:ee.ApiFunction._call("Feature",geometry),maxError:opt_errorMargin});};ee.Filter.prototype.name=function(){return"Filter";};ee.Filter.metadata=function(name,operator,value){operator=operator.toLowerCase();var negated=!1;goog.string.startsWith(operator,"not_")&&(negated=!0,operator=operator.substring(4));if(!(operator in ee.Filter.functionNames_)){throw Error("Unknown filtering operator: "+operator);}var filter=ee.ApiFunction._call("Filter."+ee.Filter.functionNames_[operator],name,value);return negated?filter.not():filter;};ee.Collection=function(func,args,opt_varName){ee.Element.call(this,func,args,opt_varName);ee.Collection.initialize();};goog.inherits(ee.Collection,ee.Element);goog.exportSymbol("ee.Collection",ee.Collection);ee.Collection.initialized_=!1;ee.Collection.initialize=function(){ee.Collection.initialized_||(ee.ApiFunction.importApi(ee.Collection,"Collection","Collection"),ee.ApiFunction.importApi(ee.Collection,"AggregateFeatureCollection","Collection","aggregate_"),ee.Collection.initialized_=!0);};ee.Collection.reset=function(){ee.ApiFunction.clearApi(ee.Collection);ee.Collection.initialized_=!1;};ee.Collection.prototype.filter=function(newFilter){if(!newFilter){throw Error("Empty filters.");}return this.castInternal(ee.ApiFunction._call("Collection.filter",this,newFilter));};ee.Collection.prototype.filterMetadata=function(name,operator,value){var args=ee.arguments.extract(ee.Collection.prototype.filterMetadata,arguments);return this.filter(ee.Filter.metadata(args.name,args.operator,args.value));};ee.Collection.prototype.filterBounds=function(geometry){return this.filter(ee.Filter.bounds(geometry));};ee.Collection.prototype.filterDate=function(start,opt_end){var args=ee.arguments.extract(ee.Collection.prototype.filterDate,arguments);return this.filter(ee.Filter.date(args.start,args.end));};ee.Collection.prototype.limit=function(max,opt_property,opt_ascending){var args=ee.arguments.extract(ee.Collection.prototype.limit,arguments);return this.castInternal(ee.ApiFunction._call("Collection.limit",this,args.max,args.property,args.ascending));};ee.Collection.prototype.sort=function(property,opt_ascending){var args=ee.arguments.extract(ee.Collection.prototype.sort,arguments);return this.castInternal(ee.ApiFunction._call("Collection.limit",this,void 0,args.property,args.ascending));};ee.Collection.prototype.name=function(){return"Collection";};ee.Collection.prototype.elementType=function(){return ee.Element;};ee.Collection.prototype.map=function(algorithm,opt_dropNulls){var elementType=this.elementType();return this.castInternal(ee.ApiFunction._call("Collection.map",this,function(e){return algorithm(new elementType(e));},opt_dropNulls));};ee.Collection.prototype.iterate=function(algorithm,opt_first){var first=goog.isDef(opt_first)?opt_first:null,elementType=this.elementType();return ee.ApiFunction._call("Collection.iterate",this,function(e,p){return algorithm(new elementType(e),p);},first);};ee.Number=function(number){if(!(this instanceof ee.Number)){return ee.ComputedObject.construct(ee.Number,arguments);}if(number instanceof ee.Number){return number;}ee.Number.initialize();if(goog.isNumber(number)){ee.ComputedObject.call(this,null,null),this.number_=number;}else{if(number instanceof ee.ComputedObject){ee.ComputedObject.call(this,number.func,number.args,number.varName),this.number_=null;}else{throw Error("Invalid argument specified for ee.Number(): "+number);}}};goog.inherits(ee.Number,ee.ComputedObject);ee.Number.initialized_=!1;ee.Number.initialize=function(){ee.Number.initialized_||(ee.ApiFunction.importApi(ee.Number,"Number","Number"),ee.Number.initialized_=!0);};ee.Number.reset=function(){ee.ApiFunction.clearApi(ee.Number);ee.Number.initialized_=!1;};ee.Number.prototype.encode=function(encoder){return goog.isNumber(this.number_)?this.number_:ee.Number.superClass_.encode.call(this,encoder);};ee.Number.prototype.name=function(){return"Number";};ee.String=function(string){if(!(this instanceof ee.String)){return ee.ComputedObject.construct(ee.String,arguments);}if(string instanceof ee.String){return string;}ee.String.initialize();if(goog.isString(string)){ee.ComputedObject.call(this,null,null),this.string_=string;}else{if(string instanceof ee.ComputedObject){this.string_=null,string.func&&"String"==string.func.getSignature().returns?ee.ComputedObject.call(this,string.func,string.args,string.varName):ee.ComputedObject.call(this,new ee.ApiFunction("String"),{input:string},null);}else{throw Error("Invalid argument specified for ee.String(): "+string);}}};goog.inherits(ee.String,ee.ComputedObject);ee.String.initialized_=!1;ee.String.initialize=function(){ee.String.initialized_||(ee.ApiFunction.importApi(ee.String,"String","String"),ee.String.initialized_=!0);};ee.String.reset=function(){ee.ApiFunction.clearApi(ee.String);ee.String.initialized_=!1;};ee.String.prototype.encode=function(encoder){return goog.isString(this.string_)?this.string_:ee.String.superClass_.encode.call(this,encoder);};ee.String.prototype.name=function(){return"String";};ee.CustomFunction=function(signature,body){if(!(this instanceof ee.CustomFunction)){return ee.ComputedObject.construct(ee.CustomFunction,arguments);}for(var vars=[],args=signature.args,i=0;i<args.length;i++){var arg=args[i];vars.push(ee.CustomFunction.variable(ee.Types.nameToClass(arg.type),arg.name));}if(!goog.isDef(body.apply(null,vars))){throw Error("User-defined methods must return a value.");}this.signature_=ee.CustomFunction.resolveNamelessArgs_(signature,vars,body);this.body_=body.apply(null,vars);};goog.inherits(ee.CustomFunction,ee.Function);goog.exportSymbol("ee.CustomFunction",ee.CustomFunction);ee.CustomFunction.prototype.encode=function(encoder){return{type:"Function",argumentNames:goog.array.map(this.signature_.args,function(arg){return arg.name;}),body:encoder(this.body_)};};ee.CustomFunction.prototype.getSignature=function(){return this.signature_;};ee.CustomFunction.variable=function(type,name){type=type||Object;if(!(type.prototype instanceof ee.ComputedObject)){if(type&&type!=Object){if(type==String){type=ee.String;}else{if(type==Number){type=ee.Number;}else{if(type==Array){type=goog.global.ee.List;}else{throw Error("Variables must be of an EE type, e.g. ee.Image or ee.Number.");}}}}else{type=ee.ComputedObject;}}var klass=function klass(){};klass.prototype=type.prototype;var obj=new klass();obj.func=null;obj.args=null;obj.varName=name;return obj;};ee.CustomFunction.create=function(func,returnType,arg_types){var stringifyType=function stringifyType(type){return goog.isString(type)?type:ee.Types.classToName(type);},args=goog.array.map(arg_types,function(argType){return{name:null,type:stringifyType(argType)};}),signature={name:"",returns:stringifyType(returnType),args:args};return new ee.CustomFunction(signature,func);};ee.CustomFunction.resolveNamelessArgs_=function(signature,vars,body){for(var namelessArgIndices=[],i=0;i<vars.length;i++){goog.isNull(vars[i].varName)&&namelessArgIndices.push(i);}if(0==namelessArgIndices.length){return signature;}for(var countFunctions=function countFunctions(expression){var count=0;goog.isObject(expression)&&!goog.isFunction(expression)&&("Function"==expression.type&&count++,goog.object.forEach(expression,function(subExpression){count+=countFunctions(subExpression);}));return count;},serializedBody=ee.Serializer.encode(body.apply(null,vars)),baseName="_MAPPING_VAR_"+countFunctions(serializedBody)+"_",i=0;i<namelessArgIndices.length;i++){var index=namelessArgIndices[i],name=baseName+i;vars[index].varName=name;signature.args[index].name=name;}return signature;};ee.Date=function(date,opt_tz){if(!(this instanceof ee.Date)){return ee.ComputedObject.construct(ee.Date,arguments);}if(date instanceof ee.Date){return date;}ee.Date.initialize();var jsArgs=ee.arguments.extract(ee.Date,arguments);date=jsArgs.date;var tz=jsArgs.tz,func=new ee.ApiFunction("Date"),args={},varName=null;if(ee.Types.isString(date)){if(args.value=date,tz){if(ee.Types.isString(tz)){args.timeZone=tz;}else{throw Error("Invalid argument specified for ee.Date(..., opt_tz): "+tz);}}}else{if(ee.Types.isNumber(date)){args.value=date;}else{if(goog.isDateLike(date)){args.value=Math.floor(date.getTime());}else{if(date instanceof ee.ComputedObject){date.func&&"Date"==date.func.getSignature().returns?(func=date.func,args=date.args,varName=date.varName):args.value=date;}else{throw Error("Invalid argument specified for ee.Date(): "+date);}}}}ee.ComputedObject.call(this,func,args,varName);};goog.inherits(ee.Date,ee.ComputedObject);ee.Date.initialized_=!1;ee.Date.initialize=function(){ee.Date.initialized_||(ee.ApiFunction.importApi(ee.Date,"Date","Date"),ee.Date.initialized_=!0);};ee.Date.reset=function(){ee.ApiFunction.clearApi(ee.Date);ee.Date.initialized_=!1;};ee.Date.prototype.name=function(){return"Date";};ee.Geometry=function(geoJson,opt_proj,opt_geodesic,opt_evenOdd){if(!(this instanceof ee.Geometry)){return ee.ComputedObject.construct(ee.Geometry,arguments);}if(!("type"in geoJson)){var args=ee.arguments.extract(ee.Geometry,arguments);geoJson=args.geoJson;opt_proj=args.proj;opt_geodesic=args.geodesic;opt_evenOdd=args.evenOdd;}ee.Geometry.initialize();var options=goog.isDefAndNotNull(opt_proj)||goog.isDefAndNotNull(opt_geodesic)||goog.isDefAndNotNull(opt_evenOdd);if(geoJson instanceof ee.ComputedObject&&!(geoJson instanceof ee.Geometry&&geoJson.type_)){if(options){throw Error("Setting the CRS, geodesic, or evenOdd flag on a computed Geometry is not supported.  Use Geometry.transform().");}ee.ComputedObject.call(this,geoJson.func,geoJson.args,geoJson.varName);}else{geoJson instanceof ee.Geometry&&(geoJson=geoJson.encode());if(!ee.Geometry.isValidGeometry_(geoJson)){throw Error("Invalid GeoJSON geometry: "+JSON.stringify(geoJson));}ee.ComputedObject.call(this,null,null);this.type_=geoJson.type;this.coordinates_=goog.isDefAndNotNull(geoJson.coordinates)?goog.object.unsafeClone(geoJson.coordinates):null;this.geometries_=geoJson.geometries||null;if(goog.isDefAndNotNull(opt_proj)){this.proj_=opt_proj;}else{if("crs"in geoJson){if(goog.isObject(geoJson.crs)&&"name"==geoJson.crs.type&&goog.isObject(geoJson.crs.properties)&&goog.isString(geoJson.crs.properties.name)){this.proj_=geoJson.crs.properties.name;}else{throw Error("Invalid CRS declaration in GeoJSON: "+new goog.json.Serializer().serialize(geoJson.crs));}}}this.geodesic_=opt_geodesic;!goog.isDef(this.geodesic_)&&"geodesic"in geoJson&&(this.geodesic_=!!geoJson.geodesic);this.evenOdd_=opt_evenOdd;!goog.isDef(this.evenOdd_)&&"evenOdd"in geoJson&&(this.evenOdd_=!!geoJson.evenOdd);}};goog.inherits(ee.Geometry,ee.ComputedObject);ee.Geometry.initialized_=!1;ee.Geometry.initialize=function(){ee.Geometry.initialized_||(ee.ApiFunction.importApi(ee.Geometry,"Geometry","Geometry"),ee.Geometry.initialized_=!0);};ee.Geometry.reset=function(){ee.ApiFunction.clearApi(ee.Geometry);ee.Geometry.initialized_=!1;};ee.Geometry.Point=function(coords,opt_proj){if(!(this instanceof ee.Geometry.Point)){return ee.Geometry.createInstance_(ee.Geometry.Point,arguments);}var init=ee.Geometry.construct_(ee.Geometry.Point,"Point",1,arguments);if(!(init instanceof ee.ComputedObject)){var xy=init.coordinates;if(!goog.isArray(xy)||2!=xy.length){throw Error("The Geometry.Point constructor requires 2 coordinates.");}}ee.Geometry.call(this,init);};goog.inherits(ee.Geometry.Point,ee.Geometry);ee.Geometry.MultiPoint=function(coords,opt_proj){if(!(this instanceof ee.Geometry.MultiPoint)){return ee.Geometry.createInstance_(ee.Geometry.MultiPoint,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiPoint,"MultiPoint",2,arguments));};goog.inherits(ee.Geometry.MultiPoint,ee.Geometry);ee.Geometry.Rectangle=function(coords,opt_proj,opt_geodesic,opt_evenOdd){if(!(this instanceof ee.Geometry.Rectangle)){return ee.Geometry.createInstance_(ee.Geometry.Rectangle,arguments);}var init=ee.Geometry.construct_(ee.Geometry.Rectangle,"Rectangle",2,arguments);if(!(init instanceof ee.ComputedObject)){var xy=init.coordinates;if(2!=xy.length){throw Error("The Geometry.Rectangle constructor requires 2 points or 4 coordinates.");}var x1=xy[0][0],y1=xy[0][1],x2=xy[1][0],y2=xy[1][1];init.coordinates=[[[x1,y2],[x1,y1],[x2,y1],[x2,y2]]];init.type="Polygon";}ee.Geometry.call(this,init);};goog.inherits(ee.Geometry.Rectangle,ee.Geometry);ee.Geometry.LineString=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.LineString)){return ee.Geometry.createInstance_(ee.Geometry.LineString,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.LineString,"LineString",2,arguments));};goog.inherits(ee.Geometry.LineString,ee.Geometry);ee.Geometry.LinearRing=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.LinearRing)){return ee.Geometry.createInstance_(ee.Geometry.LinearRing,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.LinearRing,"LinearRing",2,arguments));};goog.inherits(ee.Geometry.LinearRing,ee.Geometry);ee.Geometry.MultiLineString=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.MultiLineString)){return ee.Geometry.createInstance_(ee.Geometry.MultiLineString,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiLineString,"MultiLineString",3,arguments));};goog.inherits(ee.Geometry.MultiLineString,ee.Geometry);ee.Geometry.Polygon=function(coords,opt_proj,opt_geodesic,opt_maxError,opt_evenOdd){if(!(this instanceof ee.Geometry.Polygon)){return ee.Geometry.createInstance_(ee.Geometry.Polygon,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.Polygon,"Polygon",3,arguments));};goog.inherits(ee.Geometry.Polygon,ee.Geometry);ee.Geometry.MultiPolygon=function(coords,opt_proj,opt_geodesic,opt_maxError,opt_evenOdd){if(!(this instanceof ee.Geometry.MultiPolygon)){return ee.Geometry.createInstance_(ee.Geometry.MultiPolygon,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiPolygon,"MultiPolygon",4,arguments));};goog.inherits(ee.Geometry.MultiPolygon,ee.Geometry);ee.Geometry.prototype.encode=function(opt_encoder){if(!this.type_){if(!opt_encoder){throw Error("Must specify an encode function when encoding a computed geometry.");}return ee.ComputedObject.prototype.encode.call(this,opt_encoder);}var result={type:this.type_};"GeometryCollection"==this.type_?result.geometries=this.geometries_:result.coordinates=this.coordinates_;goog.isDefAndNotNull(this.proj_)&&(result.crs={type:"name",properties:{name:this.proj_}});goog.isDefAndNotNull(this.geodesic_)&&(result.geodesic=this.geodesic_);goog.isDefAndNotNull(this.evenOdd_)&&(result.evenOdd=this.evenOdd_);return result;};ee.Geometry.prototype.toGeoJSON=function(){if(this.func){throw Error("Can\'t convert a computed Geometry to GeoJSON. Use getInfo() instead.");}return this.encode();};ee.Geometry.prototype.toGeoJSONString=function(){if(this.func){throw Error("Can\'t convert a computed Geometry to GeoJSON. Use getInfo() instead.");}return new goog.json.Serializer().serialize(this.toGeoJSON());};ee.Geometry.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.Geometry.prototype.toString=function(){return"ee.Geometry("+this.toGeoJSONString()+")";};ee.Geometry.isValidGeometry_=function(geometry){var type=geometry.type;if("GeometryCollection"==type){var geometries=geometry.geometries;if(!goog.isArray(geometries)){return!1;}for(var i=0;i<geometries.length;i++){if(!ee.Geometry.isValidGeometry_(geometries[i])){return!1;}}return!0;}var coords=geometry.coordinates,nesting=ee.Geometry.isValidCoordinates_(coords);return"Point"==type&&1==nesting||"MultiPoint"==type&&(2==nesting||0==coords.length)||"LineString"==type&&2==nesting||"LinearRing"==type&&2==nesting||"MultiLineString"==type&&(3==nesting||0==coords.length)||"Polygon"==type&&3==nesting||"MultiPolygon"==type&&(4==nesting||0==coords.length);};ee.Geometry.isValidCoordinates_=function(shape){if(!goog.isArray(shape)){return-1;}if(goog.isArray(shape[0])){for(var count=ee.Geometry.isValidCoordinates_(shape[0]),i=1;i<shape.length;i++){if(ee.Geometry.isValidCoordinates_(shape[i])!=count){return-1;}}return count+1;}for(i=0;i<shape.length;i++){if(!goog.isNumber(shape[i])){return-1;}}return 0==shape.length%2?1:-1;};ee.Geometry.coordinatesToLine_=function(coordinates){if(!goog.isNumber(coordinates[0])||2==coordinates.length){return coordinates;}if(0!=coordinates.length%2){throw Error("Invalid number of coordinates: "+coordinates.length);}for(var line=[],i=0;i<coordinates.length;i+=2){line.push([coordinates[i],coordinates[i+1]]);}return line;};ee.Geometry.construct_=function(jsConstructorFn,apiConstructorName,depth,originalArgs){var eeArgs=ee.Geometry.getEeApiArgs_(jsConstructorFn,originalArgs);if(ee.Geometry.hasServerValue_(eeArgs.coordinates)||goog.isDefAndNotNull(eeArgs.crs)||goog.isDefAndNotNull(eeArgs.maxError)){return new ee.ApiFunction("GeometryConstructors."+apiConstructorName).apply(eeArgs);}eeArgs.type=apiConstructorName;eeArgs.coordinates=ee.Geometry.fixDepth_(depth,eeArgs.coordinates);var isPolygon=goog.array.contains(["Polygon","Rectangle","MultiPolygon"],apiConstructorName);isPolygon&&!goog.isDefAndNotNull(eeArgs.evenOdd)&&(eeArgs.evenOdd=!0);if(isPolygon&&!1===eeArgs.geodesic&&!1===eeArgs.evenOdd){throw Error("Planar interiors must be even/odd.");}return eeArgs;};ee.Geometry.getEeApiArgs_=function(jsConstructorFn,originalArgs){if(goog.array.every(originalArgs,ee.Types.isNumber)){return{coordinates:goog.array.toArray(originalArgs)};}var args=ee.arguments.extract(jsConstructorFn,originalArgs);args.coordinates=args.coords;delete args.coords;args.crs=args.proj;delete args.proj;return goog.object.filter(args,goog.isDefAndNotNull);};ee.Geometry.hasServerValue_=function(coordinates){return goog.isArray(coordinates)?goog.array.some(coordinates,ee.Geometry.hasServerValue_):coordinates instanceof ee.ComputedObject;};ee.Geometry.fixDepth_=function(depth,coords){if(1>depth||4<depth){throw Error("Unexpected nesting level.");}goog.array.every(coords,goog.isNumber)&&(coords=ee.Geometry.coordinatesToLine_(coords));for(var item=coords,count=0;goog.isArray(item);){item=item[0],count++;}for(;count<depth;){coords=[coords],count++;}if(ee.Geometry.isValidCoordinates_(coords)!=depth){throw Error("Invalid geometry");}for(item=coords;goog.isArray(item)&&1==item.length;){item=item[0];}return goog.isArray(item)&&0==item.length?[]:coords;};ee.Geometry.createInstance_=function(klass,args){var f=function f(){};f.prototype=klass.prototype;var instance=new f(),result=klass.apply(instance,args);return void 0!==result?result:instance;};ee.Geometry.prototype.name=function(){return"Geometry";};ee.Deserializer=function(){};goog.exportSymbol("ee.Deserializer",ee.Deserializer);ee.Deserializer.fromJSON=function(json){return ee.Deserializer.decode(goog.json.parse(json));};ee.Deserializer.decode=function(json){var namedValues={};if(goog.isObject(json)&&"CompoundValue"==json.type){for(var scopes=json.scope,i=0;i<scopes.length;i++){var key=scopes[i][0],value=scopes[i][1];if(key in namedValues){throw Error(\'Duplicate scope key "\'+key+\'" in scope #\'+i+".");}namedValues[key]=ee.Deserializer.decodeValue_(value,namedValues);}json=json.value;}return ee.Deserializer.decodeValue_(json,namedValues);};ee.Deserializer.decodeValue_=function(json,namedValues){if(goog.isNull(json)||goog.isNumber(json)||goog.isBoolean(json)||goog.isString(json)){return json;}if(goog.isArray(json)){return goog.array.map(json,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});}if(!goog.isObject(json)||goog.isFunction(json)){throw Error("Cannot decode object: "+json);}var typeName=json.type;switch(typeName){case"ValueRef":if(json.value in namedValues){return namedValues[json.value];}throw Error("Unknown ValueRef: "+json);case"ArgumentRef":var varName=json.value;if(!goog.isString(varName)){throw Error("Invalid variable name: "+varName);}return ee.CustomFunction.variable(Object,varName);case"Date":var microseconds=json.value;if(!goog.isNumber(microseconds)){throw Error("Invalid date value: "+microseconds);}return new ee.Date(microseconds/1000);case"Bytes":var result=new ee.Encodable();result.encode=function(encoder){return json;};return result;case"Invocation":var func="functionName"in json?ee.ApiFunction.lookup(json.functionName):ee.Deserializer.decodeValue_(json["function"],namedValues);var args=goog.object.map(json.arguments,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});if(func instanceof ee.Function){return func.apply(args);}if(func instanceof ee.ComputedObject){return new ee.ComputedObject(func,args);}throw Error("Invalid function value: "+json["function"]);case"Dictionary":return goog.object.map(json.value,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});case"Function":var body=ee.Deserializer.decodeValue_(json.body,namedValues),signature={name:"",args:goog.array.map(json.argumentNames,function(argName){return{name:argName,type:"Object",optional:!1};}),returns:"Object"};return new ee.CustomFunction(signature,function(){return body;});case"Point":case"MultiPoint":case"LineString":case"MultiLineString":case"Polygon":case"MultiPolygon":case"LinearRing":case"GeometryCollection":return new ee.Geometry(json);case"CompoundValue":throw Error("Nested CompoundValues are disallowed.");default:throw Error("Unknown encoded object type: "+typeName);}};ee.Dictionary=function(opt_dict){if(!(this instanceof ee.Dictionary)){return ee.ComputedObject.construct(ee.Dictionary,arguments);}if(opt_dict instanceof ee.Dictionary){return opt_dict;}ee.Dictionary.initialize();ee.Types.isRegularObject(opt_dict)?(ee.ComputedObject.call(this,null,null),this.dict_=opt_dict):(opt_dict instanceof ee.ComputedObject&&opt_dict.func&&"Dictionary"==opt_dict.func.getSignature().returns?ee.ComputedObject.call(this,opt_dict.func,opt_dict.args,opt_dict.varName):ee.ComputedObject.call(this,new ee.ApiFunction("Dictionary"),{input:opt_dict},null),this.dict_=null);};goog.inherits(ee.Dictionary,ee.ComputedObject);ee.Dictionary.initialized_=!1;ee.Dictionary.initialize=function(){ee.Dictionary.initialized_||(ee.ApiFunction.importApi(ee.Dictionary,"Dictionary","Dictionary"),ee.Dictionary.initialized_=!0);};ee.Dictionary.reset=function(){ee.ApiFunction.clearApi(ee.Dictionary);ee.Dictionary.initialized_=!1;};ee.Dictionary.prototype.encode=function(encoder){return goog.isNull(this.dict_)?ee.Dictionary.superClass_.encode.call(this,encoder):encoder(this.dict_);};ee.Dictionary.prototype.name=function(){return"Dictionary";};ee.Feature=function(geometry,opt_properties){if(!(this instanceof ee.Feature)){return ee.ComputedObject.construct(ee.Feature,arguments);}if(geometry instanceof ee.Feature){if(opt_properties){throw Error("Can\'t create Feature out of a Feature and properties.");}return geometry;}if(2<arguments.length){throw Error("The Feature constructor takes at most 2 arguments ("+arguments.length+" given)");}ee.Feature.initialize();if(geometry instanceof ee.Geometry||null===geometry){ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:geometry,metadata:opt_properties||null});}else{if(geometry instanceof ee.ComputedObject){ee.Element.call(this,geometry.func,geometry.args,geometry.varName);}else{if("Feature"==geometry.type){var properties=geometry.properties||{};if("id"in geometry){if("system:index"in properties){throw Error(\'Can\\\'t specify both "id" and "system:index".\');}properties=goog.object.clone(properties);properties["system:index"]=geometry.id;}ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:new ee.Geometry(geometry.geometry),metadata:properties});}else{ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:new ee.Geometry(geometry),metadata:opt_properties||null});}}}};goog.inherits(ee.Feature,ee.Element);ee.Feature.initialized_=!1;ee.Feature.initialize=function(){ee.Feature.initialized_||(ee.ApiFunction.importApi(ee.Feature,"Feature","Feature"),ee.Feature.initialized_=!0);};ee.Feature.reset=function(){ee.ApiFunction.clearApi(ee.Feature);ee.Feature.initialized_=!1;};ee.Feature.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.Feature.prototype.getMap,arguments);return ee.ApiFunction._call("Collection",[this]).getMap(args.visParams,args.callback);};ee.Feature.prototype.name=function(){return"Feature";};ee.List=function(list){if(this instanceof ee.List){if(1<arguments.length){throw Error("ee.List() only accepts 1 argument.");}if(list instanceof ee.List){return list;}}else{return ee.ComputedObject.construct(ee.List,arguments);}ee.List.initialize();if(goog.isArray(list)){ee.ComputedObject.call(this,null,null),this.list_=list;}else{if(list instanceof ee.ComputedObject){ee.ComputedObject.call(this,list.func,list.args,list.varName),this.list_=null;}else{throw Error("Invalid argument specified for ee.List(): "+list);}}};goog.inherits(ee.List,ee.ComputedObject);ee.List.initialized_=!1;ee.List.initialize=function(){ee.List.initialized_||(ee.ApiFunction.importApi(ee.List,"List","List"),ee.List.initialized_=!0);};ee.List.reset=function(){ee.ApiFunction.clearApi(ee.List);ee.List.initialized_=!1;};ee.List.prototype.encode=function(opt_encoder){return goog.isArray(this.list_)?goog.array.map(this.list_,function(elem){return opt_encoder(elem);}):ee.List.superClass_.encode.call(this,opt_encoder);};ee.List.prototype.name=function(){return"List";};ee.FeatureCollection=function(args,opt_column){if(!(this instanceof ee.FeatureCollection)){return ee.ComputedObject.construct(ee.FeatureCollection,arguments);}if(args instanceof ee.FeatureCollection){return args;}if(2<arguments.length){throw Error("The FeatureCollection constructor takes at most 2 arguments ("+arguments.length+" given)");}ee.FeatureCollection.initialize();args instanceof ee.Geometry&&(args=new ee.Feature(args));args instanceof ee.Feature&&(args=[args]);if(ee.Types.isNumber(args)||ee.Types.isString(args)){var actualArgs={tableId:args};opt_column&&(actualArgs.geometryColumn=opt_column);ee.Collection.call(this,new ee.ApiFunction("Collection.loadTable"),actualArgs);}else{if(goog.isArray(args)){ee.Collection.call(this,new ee.ApiFunction("Collection"),{features:goog.array.map(args,function(elem){return new ee.Feature(elem);})});}else{if(args instanceof ee.List){ee.Collection.call(this,new ee.ApiFunction("Collection"),{features:args});}else{if(args instanceof ee.ComputedObject){ee.Collection.call(this,args.func,args.args,args.varName);}else{throw Error("Unrecognized argument type to convert to a FeatureCollection: "+args);}}}}};goog.inherits(ee.FeatureCollection,ee.Collection);ee.FeatureCollection.initialized_=!1;ee.FeatureCollection.initialize=function(){ee.FeatureCollection.initialized_||(ee.ApiFunction.importApi(ee.FeatureCollection,"FeatureCollection","FeatureCollection"),ee.FeatureCollection.initialized_=!0);};ee.FeatureCollection.reset=function(){ee.ApiFunction.clearApi(ee.FeatureCollection);ee.FeatureCollection.initialized_=!1;};ee.FeatureCollection.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.FeatureCollection.prototype.getMap,arguments),painted=ee.ApiFunction._apply("Collection.draw",{collection:this,color:(args.visParams||{}).color||"000000"});if(args.callback){painted.getMap(null,args.callback);}else{return painted.getMap();}};ee.FeatureCollection.prototype.getDownloadURL=function(opt_format,opt_selectors,opt_filename,opt_callback){var args=ee.arguments.extract(ee.FeatureCollection.prototype.getDownloadURL,arguments),request={};request.table=this.serialize();args.format&&(request.format=args.format.toUpperCase());args.filename&&(request.filename=args.filename);if(args.selectors){var selectors=args.selectors;goog.isArrayLike(selectors)&&(selectors=selectors.join(","));request.selectors=selectors;}if(args.callback){ee.data.getTableDownloadId(request,function(downloadId,error){downloadId?args.callback(ee.data.makeTableDownloadUrl(downloadId)):args.callback(null,error);});}else{return ee.data.makeTableDownloadUrl(ee.data.getTableDownloadId(request));}};ee.FeatureCollection.prototype.select=function(selectors,opt_names){var varargs=arguments;return this.map(function(feature){return feature.select.apply(feature,varargs);});};ee.FeatureCollection.prototype.name=function(){return"FeatureCollection";};ee.FeatureCollection.prototype.elementType=function(){return ee.Feature;};ee.Image=function(opt_args){if(!(this instanceof ee.Image)){return ee.ComputedObject.construct(ee.Image,arguments);}if(opt_args instanceof ee.Image){return opt_args;}ee.Image.initialize();var argCount=arguments.length;if(0==argCount||1==argCount&&!goog.isDef(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.mask"),{image:new ee.Image(0),mask:new ee.Image(0)});}else{if(1==argCount){if(ee.Types.isNumber(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.constant"),{value:opt_args});}else{if(ee.Types.isString(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.load"),{id:opt_args});}else{if(goog.isArray(opt_args)){return ee.Image.combine_(goog.array.map(opt_args,function(elem){return new ee.Image(elem);}));}if(opt_args instanceof ee.ComputedObject){"Array"==opt_args.name()?ee.Element.call(this,new ee.ApiFunction("Image.constant"),{value:opt_args}):ee.Element.call(this,opt_args.func,opt_args.args,opt_args.varName);}else{throw Error("Unrecognized argument type to convert to an Image: "+opt_args);}}}}else{if(2==argCount){var id=arguments[0],version=arguments[1];if(ee.Types.isString(id)&&ee.Types.isNumber(version)){ee.Element.call(this,new ee.ApiFunction("Image.load"),{id:id,version:version});}else{throw Error("Unrecognized argument types to convert to an Image: "+arguments);}}else{throw Error("The Image constructor takes at most 2 arguments ("+argCount+" given)");}}}};goog.inherits(ee.Image,ee.Element);ee.Image.initialized_=!1;ee.Image.initialize=function(){ee.Image.initialized_||(ee.ApiFunction.importApi(ee.Image,"Image","Image"),ee.ApiFunction.importApi(ee.Image,"Window","Image","focal_"),ee.Image.initialized_=!0);};ee.Image.reset=function(){ee.ApiFunction.clearApi(ee.Image);ee.Image.initialized_=!1;};ee.Image.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getMap,arguments),request=args.visParams?goog.object.clone(args.visParams):{};request.image=this.serialize();if(args.callback){ee.data.getMapId(request,goog.bind(function(data,error){data&&(data.image=this);args.callback(data,error);},this));}else{var response=ee.data.getMapId(request);response.image=this;return response;}};ee.Image.prototype.getDownloadURL=function(params,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getDownloadURL,arguments),request=args.params?goog.object.clone(args.params):{};request.image=this.serialize();if(args.callback){var callback=args.callback;ee.data.getDownloadId(request,function(downloadId,error){downloadId?callback(ee.data.makeDownloadUrl(downloadId)):callback(null,error);});}else{return ee.data.makeDownloadUrl(ee.data.getDownloadId(request));}};ee.Image.prototype.getThumbURL=function(params,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getThumbURL,arguments),request=args.params?goog.object.clone(args.params):{};request.image=this.serialize();if(request.region){if(goog.isArray(request.region)||ee.Types.isRegularObject(request.region)){request.region=goog.json.serialize(request.region);}else{if(!goog.isString(request.region)){throw Error("The region parameter must be an array or a GeoJSON object.");}}}if(args.callback){ee.data.getThumbId(request,function(thumbId,opt_error){var thumbUrl="";if(!goog.isDef(opt_error)){try{thumbUrl=ee.data.makeThumbUrl(thumbId);}catch(e){opt_error=String(e.message);}}args.callback(thumbUrl,opt_error);});}else{return ee.data.makeThumbUrl(ee.data.getThumbId(request));}};ee.Image.rgb=function(r,g,b){var args=ee.arguments.extract(ee.Image.rgb,arguments);return ee.Image.combine_([args.r,args.g,args.b],["vis-red","vis-green","vis-blue"]);};ee.Image.cat=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.Image.combine_(args,null);};ee.Image.combine_=function(images,opt_names){if(0==images.length){return ee.ApiFunction._call("Image.constant",[]);}for(var result=new ee.Image(images[0]),i=1;i<images.length;i++){result=ee.ApiFunction._call("Image.addBands",result,images[i]);}opt_names&&(result=result.select([".*"],opt_names));return result;};ee.Image.prototype.select=function(var_args){var args=Array.prototype.slice.call(arguments),algorithmArgs={input:this,bandSelectors:args[0]||[]};if(2<args.length||ee.Types.isString(args[0])||ee.Types.isNumber(args[0])){for(var i=0;i<args.length;i++){if(!(ee.Types.isString(args[i])||ee.Types.isNumber(args[i])||args[i]instanceof ee.ComputedObject)){throw Error("Illegal argument to select(): "+args[i]);}}algorithmArgs.bandSelectors=args;}else{args[1]&&(algorithmArgs.newNames=args[1]);}return ee.ApiFunction._apply("Image.select",algorithmArgs);};ee.Image.prototype.expression=function(expression,opt_map){var originalArgs=ee.arguments.extract(ee.Image.prototype.expression,arguments),vars=["DEFAULT_EXPRESSION_IMAGE"],eeArgs={DEFAULT_EXPRESSION_IMAGE:this};if(originalArgs.map){var map=originalArgs.map,name$jscomp$0;for(name$jscomp$0 in map){vars.push(name$jscomp$0),eeArgs[name$jscomp$0]=new ee.Image(map[name$jscomp$0]);}}var body=ee.ApiFunction._call("Image.parseExpression",originalArgs.expression,"DEFAULT_EXPRESSION_IMAGE",vars),func=new ee.Function();func.encode=function(encoder){return body.encode(encoder);};func.getSignature=function(){return{name:"",args:goog.array.map(vars,function(name){return{name:name,type:"Image",optional:!1};},this),returns:"Image"};};return func.apply(eeArgs);};ee.Image.prototype.clip=function(geometry){try{geometry=new ee.Geometry(geometry);}catch(e){}return ee.ApiFunction._call("Image.clip",this,geometry);};ee.Image.prototype.rename=function(var_args){var names=1!=arguments.length||ee.Types.isString(arguments[0])?goog.array.clone(arguments):arguments[0];return ee.ApiFunction._call("Image.rename",this,names);};ee.Image.prototype.name=function(){return"Image";};ee.ImageCollection=function(args){if(!(this instanceof ee.ImageCollection)){return ee.ComputedObject.construct(ee.ImageCollection,arguments);}if(args instanceof ee.ImageCollection){return args;}if(1!=arguments.length){throw Error("The ImageCollection constructor takes exactly 1 argument ("+arguments.length+" given)");}ee.ImageCollection.initialize();args instanceof ee.Image&&(args=[args]);if(ee.Types.isString(args)){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.load"),{id:args});}else{if(goog.isArray(args)){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.fromImages"),{images:goog.array.map(args,function(elem){return new ee.Image(elem);})});}else{if(args instanceof ee.List){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.fromImages"),{images:args});}else{if(args instanceof ee.ComputedObject){ee.Collection.call(this,args.func,args.args,args.varName);}else{throw Error("Unrecognized argument type to convert to an ImageCollection: "+args);}}}}};goog.inherits(ee.ImageCollection,ee.Collection);ee.ImageCollection.initialized_=!1;ee.ImageCollection.initialize=function(){ee.ImageCollection.initialized_||(ee.ApiFunction.importApi(ee.ImageCollection,"ImageCollection","ImageCollection"),ee.ApiFunction.importApi(ee.ImageCollection,"reduce","ImageCollection"),ee.ImageCollection.initialized_=!0);};ee.ImageCollection.reset=function(){ee.ApiFunction.clearApi(ee.ImageCollection);ee.ImageCollection.initialized_=!1;};ee.ImageCollection.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.ImageCollection.prototype.getMap,arguments),mosaic=ee.ApiFunction._call("ImageCollection.mosaic",this);if(args.callback){mosaic.getMap(args.visParams,args.callback);}else{return mosaic.getMap(args.visParams);}};ee.ImageCollection.prototype.select=function(selectors,opt_names){var varargs=arguments;return this.map(function(img){return img.select.apply(img,varargs);});};ee.ImageCollection.prototype.name=function(){return"ImageCollection";};ee.ImageCollection.prototype.elementType=function(){return ee.Image;};ee.Terrain={};ee.Terrain.initialized_=!1;ee.Terrain.initialize=function(){ee.Terrain.initialized_||(ee.ApiFunction.importApi(ee.Terrain,"Terrain","Terrain"),ee.Terrain.initialized_=!0);};ee.Terrain.reset=function(){ee.ApiFunction.clearApi(ee.Terrain);ee.Terrain.initialized_=!1;};ee.initialize=function(opt_baseurl,opt_tileurl,opt_successCallback,opt_errorCallback,opt_xsrfToken){if(ee.ready_!=ee.InitState.READY||opt_baseurl||opt_tileurl){var isAsynchronous=goog.isDefAndNotNull(opt_successCallback);if(opt_errorCallback){if(isAsynchronous){ee.errorCallbacks_.push(opt_errorCallback);}else{throw Error("Can\'t pass an error callback without a success callback.");}}if(ee.ready_==ee.InitState.LOADING&&isAsynchronous){ee.successCallbacks_.push(opt_successCallback);}else{if(ee.ready_=ee.InitState.LOADING,ee.data.initialize(opt_baseurl,opt_tileurl,opt_xsrfToken),isAsynchronous){ee.successCallbacks_.push(opt_successCallback),ee.ApiFunction.initialize(ee.initializationSuccess_,ee.initializationFailure_);}else{try{ee.ApiFunction.initialize(),ee.initializationSuccess_();}catch(e){throw ee.initializationFailure_(e),e;}}}}else{opt_successCallback&&opt_successCallback();}};ee.reset=function(){ee.ready_=ee.InitState.NOT_READY;ee.data.reset();ee.ApiFunction.reset();ee.Date.reset();ee.Dictionary.reset();ee.Element.reset();ee.Image.reset();ee.Feature.reset();ee.Collection.reset();ee.ImageCollection.reset();ee.FeatureCollection.reset();ee.Filter.reset();ee.Geometry.reset();ee.List.reset();ee.Number.reset();ee.String.reset();ee.Terrain.reset();ee.resetGeneratedClasses_();goog.object.clear(ee.Algorithms);};ee.InitState={NOT_READY:"not_ready",LOADING:"loading",READY:"ready"};goog.exportSymbol("ee.InitState.NOT_READY",ee.InitState.NOT_READY);goog.exportSymbol("ee.InitState.LOADING",ee.InitState.LOADING);goog.exportSymbol("ee.InitState.READY",ee.InitState.READY);ee.ready_=ee.InitState.NOT_READY;ee.successCallbacks_=[];ee.errorCallbacks_=[];ee.TILE_SIZE=256;ee.generatedClasses_=[];ee.Algorithms={};ee.ready=function(){return ee.ready_;};ee.call=function(func,var_args){goog.isString(func)&&(func=new ee.ApiFunction(func));var args=Array.prototype.slice.call(arguments,1);return ee.Function.prototype.call.apply(func,args);};ee.apply=function(func,namedArgs){goog.isString(func)&&(func=new ee.ApiFunction(func));return func.apply(namedArgs);};ee.initializationSuccess_=function(){if(ee.ready_==ee.InitState.LOADING){try{ee.Date.initialize(),ee.Dictionary.initialize(),ee.Element.initialize(),ee.Image.initialize(),ee.Feature.initialize(),ee.Collection.initialize(),ee.ImageCollection.initialize(),ee.FeatureCollection.initialize(),ee.Filter.initialize(),ee.Geometry.initialize(),ee.List.initialize(),ee.Number.initialize(),ee.String.initialize(),ee.Terrain.initialize(),ee.initializeGeneratedClasses_(),ee.initializeUnboundMethods_();}catch(e){ee.initializationFailure_(e);return;}ee.ready_=ee.InitState.READY;for(ee.errorCallbacks_=[];0<ee.successCallbacks_.length;){ee.successCallbacks_.shift()();}}};ee.initializationFailure_=function(e){if(ee.ready_==ee.InitState.LOADING){for(ee.ready_=ee.InitState.NOT_READY,ee.successCallbacks_=[];0<ee.errorCallbacks_.length;){ee.errorCallbacks_.shift()(e);}}};ee.promote_=function(arg,klass){if(goog.isNull(arg)){return null;}if(goog.isDef(arg)){var exportedEE=goog.global.ee;switch(klass){case"Image":return new ee.Image(arg);case"Feature":return arg instanceof ee.Collection?ee.ApiFunction._call("Feature",ee.ApiFunction._call("Collection.geometry",arg)):new ee.Feature(arg);case"Element":if(arg instanceof ee.Element){return arg;}if(arg instanceof ee.Geometry){return new ee.Feature(arg);}if(arg instanceof ee.ComputedObject){return new ee.Element(arg.func,arg.args,arg.varName);}throw Error("Cannot convert "+arg+" to Element.");case"Geometry":return arg instanceof ee.FeatureCollection?ee.ApiFunction._call("Collection.geometry",arg):new ee.Geometry(arg);case"FeatureCollection":case"Collection":return arg instanceof ee.Collection?arg:new ee.FeatureCollection(arg);case"ImageCollection":return new ee.ImageCollection(arg);case"Filter":return new ee.Filter(arg);case"Algorithm":if(goog.isString(arg)){return new ee.ApiFunction(arg);}if(goog.isFunction(arg)){return ee.CustomFunction.create(arg,"Object",goog.array.repeat("Object",arg.length));}if(arg instanceof ee.Encodable){return arg;}throw Error("Argument is not a function: "+arg);case"String":return ee.Types.isString(arg)||arg instanceof ee.String||arg instanceof ee.ComputedObject?new ee.String(arg):arg;case"Dictionary":return ee.Types.isRegularObject(arg)?arg:new ee.Dictionary(arg);case"List":return new ee.List(arg);case"Number":case"Float":case"Long":case"Integer":case"Short":case"Byte":return new ee.Number(arg);default:if(klass in exportedEE){var ctor=ee.ApiFunction.lookupInternal(klass);if(arg instanceof exportedEE[klass]){return arg;}if(ctor){return new exportedEE[klass](arg);}if(goog.isString(arg)){if(arg in exportedEE[klass]){return exportedEE[klass][arg].call();}throw Error("Unknown algorithm: "+klass+"."+arg);}return new exportedEE[klass](arg);}return arg;}}};ee.initializeUnboundMethods_=function(){var unbound=ee.ApiFunction.unboundFunctions();goog.object.getKeys(unbound).sort().forEach(function(name){var func=unbound[name],signature=func.getSignature();if(!signature.hidden){var nameParts=name.split("."),target=ee.Algorithms;for(target.signature={};1<nameParts.length;){var first=nameParts[0];first in target||(target[first]={signature:{}});target=target[first];nameParts=goog.array.slice(nameParts,1);}var bound=function bound(var_args){return func.callOrApply(void 0,Array.prototype.slice.call(arguments,0));};bound.signature=signature;bound.toString=goog.bind(func.toString,func);target[nameParts[0]]=bound;}});};ee.initializeGeneratedClasses_=function(){var signatures=ee.ApiFunction.allSignatures(),names={},returnTypes={},sig;for(sig in signatures){var type=-1!=sig.indexOf(".")?sig.slice(0,sig.indexOf(".")):sig;names[type]=!0;var rtype=signatures[sig].returns.replace(/<.*>/,"");returnTypes[rtype]=!0;}var exportedEE=goog.global.ee,name;for(name in names){name in returnTypes&&!(name in exportedEE)&&(exportedEE[name]=ee.makeClass_(name),ee.generatedClasses_.push(name),signatures[name]?(exportedEE[name].signature=signatures[name],exportedEE[name].signature.isConstructor=!0,ee.ApiFunction.boundSignatures_[name]=!0):exportedEE[name].signature={});}ee.Types.registerClasses(exportedEE);};ee.resetGeneratedClasses_=function(){for(var exportedEE=goog.global.ee,i=0;i<ee.generatedClasses_.length;i++){var name=ee.generatedClasses_[i];ee.ApiFunction.clearApi(exportedEE[name]);delete exportedEE[name];}ee.generatedClasses_=[];ee.Types.registerClasses(exportedEE);};ee.makeClass_=function(name){var target=function target(var_args){var klass=goog.global.ee[name],args=Array.prototype.slice.call(arguments),onlyOneArg=1==args.length;if(onlyOneArg&&args[0]instanceof klass){return args[0];}if(!(this instanceof klass)){return ee.ComputedObject.construct(klass,args);}var ctor=ee.ApiFunction.lookupInternal(name),firstArgIsPrimitive=!(args[0]instanceof ee.ComputedObject),shouldUseConstructor=!1;ctor&&(onlyOneArg?firstArgIsPrimitive?shouldUseConstructor=!0:args[0].func!=ctor&&(shouldUseConstructor=!0):shouldUseConstructor=!0);if(shouldUseConstructor){ee.ComputedObject.call(this,ctor,ctor.promoteArgs(ctor.nameArgs(args)));}else{if(!onlyOneArg){throw Error("Too many arguments for ee."+name+"(): "+args);}if(firstArgIsPrimitive){throw Error("Invalid argument for ee."+name+"(): "+args+". Must be a ComputedObject.");}var theOneArg=args[0];ee.ComputedObject.call(this,theOneArg.func,theOneArg.args,theOneArg.varName);}};goog.inherits(target,ee.ComputedObject);target.prototype.name=function(){return name;};ee.ApiFunction.importApi(target,name,name);return target;};ee.Function.registerPromoter(ee.promote_);ee.FloatTileOverlay=function(url,mapId,token){ee.AbstractOverlay.call(this,url,mapId,token);this.tileSize=new google.maps.Size(ee.FloatTileOverlay.TILE_EDGE_LENGTH,ee.FloatTileOverlay.TILE_EDGE_LENGTH);this.floatTiles_=new goog.structs.Map();this.floatTileDivs_=new goog.structs.Map();};goog.inherits(ee.FloatTileOverlay,ee.AbstractOverlay);ee.FloatTileOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var tileId=this.getTileId(coord,zoom),src=[this.url,tileId].join("/")+"?token="+this.token,uniqueTileId=[tileId,this.tileCounter,this.token].join("/");this.tilesLoading.push(uniqueTileId);this.tileCounter+=1;var div=goog.dom.createDom("DIV"),floatTile=this.loadFloatTile_(src,coord,uniqueTileId,div);this.dispatchTileEvent_();return div;};ee.FloatTileOverlay.TILE_EDGE_LENGTH=256;ee.FloatTileOverlay.prototype.loadFloatTile_=function(tileUrl,coord,tileId,div){var tileRequest=goog.net.XmlHttp();tileRequest.open("GET",tileUrl,!0);tileRequest.responseType="arraybuffer";tileRequest.onreadystatechange=goog.bind(function(){if(tileRequest.readyState===XMLHttpRequest.DONE&&200===tileRequest.status){var tileResponse=tileRequest.response;if(tileResponse){var floatBuffer=new Float32Array(tileResponse);this.handleFloatTileLoaded_(floatBuffer,coord,tileId,div);}else{throw this.tilesFailed.add(tileId),Error("Unable to request floating point array buffers.");}}},this);tileRequest.send();};ee.FloatTileOverlay.prototype.handleFloatTileLoaded_=function(floatTile,coord,tileId,div){this.floatTiles_.set(coord,floatTile);this.floatTileDivs_.set(coord,div);goog.array.remove(this.tilesLoading,tileId);this.dispatchTileEvent_();};ee.FloatTileOverlay.prototype.getAllFloatTiles=function(){return this.floatTiles_;};ee.FloatTileOverlay.prototype.getAllFloatTileDivs=function(){return this.floatTileDivs_;};ee.FloatTileOverlay.prototype.getLoadedFloatTilesCount=function(){return this.floatTiles_.getCount();};ee.FloatTileOverlay.prototype.dispatchTileEvent_=function(){this.dispatchEvent(new ee.TileEvent(this.tilesLoading.length));};ee.FloatTileOverlay.prototype.disposeInternal=function(){this.floatTileDivs_=this.floatTiles_=null;ee.FloatTileOverlay.superClass_.disposeInternal.call(this);};ee.MapTileManager=function(){goog.events.EventTarget.call(this);this.tokenPool_=new ee.MapTileManager.TokenPool_(0,60);this.requests_=new goog.structs.Map();};goog.inherits(ee.MapTileManager,goog.events.EventTarget);goog.addSingletonGetter(ee.MapTileManager);ee.MapTileManager.MAX_RETRIES=1;ee.MapTileManager.ERROR_ID_IN_USE_="[ee.MapTileManager] ID in use";ee.MapTileManager.prototype.getOutstandingCount=function(){return this.requests_.getCount();};ee.MapTileManager.prototype.send=function(id,url,opt_priority,opt_imageCompletedCallback,opt_maxRetries){if(this.requests_.get(id)){throw Error(ee.MapTileManager.ERROR_ID_IN_USE_);}var request=new ee.MapTileManager.Request_(id,url,opt_imageCompletedCallback,goog.bind(this.releaseRequest_,this),goog.isDef(opt_maxRetries)?opt_maxRetries:ee.MapTileManager.MAX_RETRIES);this.requests_.set(id,request);var callback=goog.bind(this.handleAvailableToken_,this,request);this.tokenPool_.getObject(callback,opt_priority);return request;};ee.MapTileManager.prototype.abort=function(id){var request=this.requests_.get(id);request&&(request.setAborted(!0),this.releaseRequest_(request));};ee.MapTileManager.prototype.handleAvailableToken_=function(request,token){if(request.getImageLoader()||request.getAborted()){this.releaseObject_(token);}else{if(request.setToken(token),token.setActive(!0),request.setImageLoader(new goog.net.ImageLoader()),!request.retry()){throw Error("Cannot dispatch first request!");}}};ee.MapTileManager.prototype.releaseRequest_=function(request){this.requests_.remove(request.getId());request.getImageLoader()&&(this.releaseObject_(request.getToken()),request.getImageLoader().dispose());request.fireImageEventCallback();};ee.MapTileManager.prototype.releaseObject_=function(token){token.setActive(!1);if(!this.tokenPool_.releaseObject(token)){throw Error("Object not released");}};ee.MapTileManager.prototype.disposeInternal=function(){ee.MapTileManager.superClass_.disposeInternal.call(this);this.tokenPool_.dispose();this.tokenPool_=null;var requests=this.requests_;goog.array.forEach(requests.getValues(),function(value){value.dispose();});requests.clear();this.requests_=null;};ee.MapTileManager.Request_=function(id,url,opt_imageEventCallback,opt_requestCompleteCallback,opt_maxRetries){goog.Disposable.call(this);this.id_=id;this.url_=url;this.maxRetries_=goog.isDef(opt_maxRetries)?opt_maxRetries:ee.MapTileManager.MAX_RETRIES;this.imageEventCallback_=opt_imageEventCallback;this.requestCompleteCallback_=opt_requestCompleteCallback;};goog.inherits(ee.MapTileManager.Request_,goog.Disposable);ee.MapTileManager.Request_.prototype.attemptCount_=0;ee.MapTileManager.Request_.prototype.aborted_=!1;ee.MapTileManager.Request_.prototype.imageLoader_=null;ee.MapTileManager.Request_.prototype.token_=null;ee.MapTileManager.Request_.prototype.event_=null;ee.MapTileManager.Request_.prototype.profileId_=null;ee.MapTileManager.Request_.IMAGE_LOADER_EVENT_TYPES_=[goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];ee.MapTileManager.Request_.prototype.getImageLoader=function(){return this.imageLoader_;};ee.MapTileManager.Request_.prototype.setImageLoader=function(imageLoader){this.imageLoader_=imageLoader;};ee.MapTileManager.Request_.prototype.getToken=function(){return this.token_;};ee.MapTileManager.Request_.prototype.setToken=function(token){this.token_=token;};ee.MapTileManager.Request_.prototype.addImageEventListener=function(){goog.events.listenOnce(this.imageLoader_,ee.MapTileManager.Request_.IMAGE_LOADER_EVENT_TYPES_,goog.bind(this.handleImageEvent_,this));};ee.MapTileManager.Request_.prototype.fireImageEventCallback=function(){this.imageEventCallback_&&this.imageEventCallback_(this.event_,this.profileId_);};ee.MapTileManager.Request_.prototype.getId=function(){return this.id_;};ee.MapTileManager.Request_.prototype.getUrl=function(){return this.url_;};ee.MapTileManager.Request_.prototype.getMaxRetries=function(){return this.maxRetries_;};ee.MapTileManager.Request_.prototype.getAttemptCount=function(){return this.attemptCount_;};ee.MapTileManager.Request_.prototype.increaseAttemptCount=function(){this.attemptCount_++;};ee.MapTileManager.Request_.prototype.hasReachedMaxRetries=function(){return this.attemptCount_>this.maxRetries_;};ee.MapTileManager.Request_.prototype.setAborted=function(aborted){aborted&&!this.aborted_&&(this.aborted_=aborted,this.event_=new goog.events.Event(goog.net.EventType.ABORT));};ee.MapTileManager.Request_.prototype.getAborted=function(){return this.aborted_;};ee.MapTileManager.Request_.prototype.handleImageEvent_=function(e){if(this.getAborted()){this.markCompleted_();}else{switch(e.type){case goog.events.EventType.LOAD:this.handleSuccess_(e);this.markCompleted_();break;case goog.net.EventType.ERROR:case goog.net.EventType.ABORT:this.handleError_(e);}}};ee.MapTileManager.Request_.prototype.markCompleted_=function(){this.requestCompleteCallback_&&this.requestCompleteCallback_(this);};ee.MapTileManager.Request_.prototype.handleSuccess_=function(e){this.event_=e;};ee.MapTileManager.Request_.prototype.handleError_=function(e){this.retry()||(this.event_=e,this.markCompleted_());};ee.MapTileManager.Request_.prototype.disposeInternal=function(){ee.MapTileManager.Request_.superClass_.disposeInternal.call(this);delete this.imageEventCallback_;delete this.requestCompleteCallback_;};ee.MapTileManager.Request_.prototype.retry=function(){if(this.hasReachedMaxRetries()){return!1;}this.increaseAttemptCount();this.imageLoader_.removeImage(this.id_);setTimeout(goog.bind(this.start_,this),0);return!0;};ee.MapTileManager.Request_.prototype.start_=function(){if(!this.getAborted()){var actuallyLoadImage=goog.bind(function(imageUrl){this.getAborted()||(this.imageLoader_.addImage(this.id_,imageUrl),this.addImageEventListener(),this.imageLoader_.start());},this),sourceUrl=this.getUrl();if(goog.Uri.parse(sourceUrl).getQueryData().containsKey("profiling")){var xhrIo=new goog.net.XhrIo();xhrIo.setResponseType(goog.net.XhrIo.ResponseType.BLOB);xhrIo.listen(goog.net.EventType.COMPLETE,goog.bind(function(event){this.profileId_=xhrIo.getResponseHeader(ee.data.PROFILE_HEADER)||null;if(200<=xhrIo.getStatus()&&300>xhrIo.getStatus()){try{var objectUrl=URL.createObjectURL(xhrIo.getResponse());}catch(e){}}actuallyLoadImage(objectUrl||sourceUrl);},this));xhrIo.listenOnce(goog.net.EventType.READY,goog.bind(xhrIo.dispose,xhrIo));xhrIo.send(sourceUrl,"GET");}else{actuallyLoadImage(sourceUrl);}}};ee.MapTileManager.Token_=function(){this.active_=!1;};goog.inherits(ee.MapTileManager.Token_,goog.Disposable);ee.MapTileManager.Token_.prototype.setActive=function(val){this.active_=val;};ee.MapTileManager.Token_.prototype.isActive=function(){return this.active_;};ee.MapTileManager.TokenPool_=function(opt_minCount,opt_maxCount){goog.structs.PriorityPool.call(this,opt_minCount,opt_maxCount);};goog.inherits(ee.MapTileManager.TokenPool_,goog.structs.PriorityPool);ee.MapTileManager.TokenPool_.prototype.createObject=function(){return new ee.MapTileManager.Token_();};ee.MapTileManager.TokenPool_.prototype.disposeObject=function(obj){obj.dispose();};ee.MapTileManager.TokenPool_.prototype.objectCanBeReused=function(obj){return!obj.isDisposed()&&!obj.isActive();};ee.MapLayerOverlay=function(url,mapId,token,init,opt_profiler){ee.AbstractOverlay.call(this,url,mapId,token,init,opt_profiler);this.minZoom=init.minZoom||0;this.maxZoom=init.maxZoom||20;if(!window.google||!window.google.maps){throw Error("Google Maps API hasn\'t been initialized.");}this.tileSize=init.tileSize||new google.maps.Size(256,256);this.isPng=goog.isDef(init.isPng)?init.isPng:!0;this.name=init.name;this.tiles_=new goog.structs.Set();this.opacity_=1.0;this.visible_=!0;this.profiler_=opt_profiler||null;};goog.inherits(ee.MapLayerOverlay,ee.AbstractOverlay);ee.MapLayerOverlay.prototype.addTileCallback=function(callback){return goog.events.listen(this,ee.AbstractOverlay.EventType.TILE_LOADED,callback);};ee.MapLayerOverlay.prototype.removeTileCallback=function(callbackId){goog.events.unlistenByKey(callbackId);};ee.MapLayerOverlay.prototype.dispatchTileEvent_=function(){this.dispatchEvent(new ee.TileEvent(this.tilesLoading.length));};ee.MapLayerOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var maxCoord;if(zoom<this.minZoom||0>coord.y||coord.y>=1<<zoom){var img=ownerDocument.createElement("IMG");img.style.width="0px";img.style.height="0px";return img;}var profiling=this.profiler_&&this.profiler_.isEnabled(),tileId=this.getTileId(coord,zoom),src=[this.url,tileId].join("/")+"?token="+this.token;profiling&&(src+="&profiling=1");var uniqueTileId=[tileId,this.tileCounter,this.token].join("/");this.tileCounter+=1;var div=goog.dom.createDom("DIV",{id:uniqueTileId}),priority=new Date().getTime()/1000;this.tilesLoading.push(uniqueTileId);ee.MapTileManager.getInstance().send(uniqueTileId,src,priority,goog.bind(this.handleImageCompleted_,this,div,uniqueTileId));this.dispatchTileEvent_();return div;};ee.MapLayerOverlay.prototype.getLoadedTilesCount=function(){return this.tiles_.getCount();};ee.MapLayerOverlay.prototype.getLoadingTilesCount=function(){return this.tilesLoading.length;};ee.MapLayerOverlay.prototype.releaseTile=function(tileDiv){ee.MapTileManager.getInstance().abort(tileDiv.id);var tileImg=goog.dom.getFirstElementChild(tileDiv);this.tiles_.remove(tileImg);""!==tileDiv.id&&(this.tilesFailed.remove(tileDiv.id),this.profiler_&&this.profiler_.removeTile(tileDiv.id));};ee.MapLayerOverlay.prototype.setOpacity=function(opacity){this.opacity_=opacity;var iter=this.tiles_.__iterator__();goog.iter.forEach(iter,function(tile){goog.style.setOpacity(tile,opacity);});};goog.exportProperty(ee.MapLayerOverlay.prototype,"getTile",ee.MapLayerOverlay.prototype.getTile);goog.exportProperty(ee.MapLayerOverlay.prototype,"setOpacity",ee.MapLayerOverlay.prototype.setOpacity);goog.exportProperty(ee.MapLayerOverlay.prototype,"releaseTile",ee.MapLayerOverlay.prototype.releaseTile);ee.MapLayerOverlay.prototype.handleImageCompleted_=function(div,tileId,e,profileId){if(e.type==goog.net.EventType.ERROR){goog.array.remove(this.tilesLoading,tileId),this.tilesFailed.add(tileId),this.dispatchEvent(e);}else{goog.array.remove(this.tilesLoading,tileId);if(e.target&&e.type==goog.events.EventType.LOAD){var tile=e.target;this.tiles_.add(tile);1.0!=this.opacity_&&goog.style.setOpacity(tile,this.opacity_);div.appendChild(tile);}this.dispatchTileEvent_();}this.profiler_&&!goog.isNull(profileId)&&this.profiler_.addTile(tileId,profileId);};ee.SavedFunction=function(path,signature){if(!(this instanceof ee.SavedFunction)){return new ee.SavedFunction(path,signature);}this.path_=path;this.signature_=signature;};goog.inherits(ee.SavedFunction,ee.Function);goog.exportSymbol("ee.SavedFunction",ee.SavedFunction);ee.SavedFunction.prototype.encode=function(encoder){return ee.ApiFunction._call("LoadAlgorithmById",this.path_).encode(encoder);};ee.SavedFunction.prototype.getSignature=function(){return this.signature_;};ee.Package=function(opt_path){if(opt_path&&ee.Package.importedPackages_[opt_path]){return ee.Package.importedPackages_[opt_path];}if(!(this instanceof ee.Package)){return new ee.Package(opt_path);}if(opt_path){for(var contents=ee.Package.getFolder(opt_path),i=0;i<contents.length;i++){var parts=contents[i].id.split("/"),name=parts[parts.length-1];this[name]=ee.Package.makeInvocation_(opt_path,name,contents[i]);}ee.Package.importedPackages_[opt_path]=this;}};ee.Package.importedPackages_={};ee.Package.makeFunction=function(signature,body){"string"==typeof signature&&(signature=ee.Package.decodeDecl(signature));var func=function func(){throw Error("Package not saved.");};func.body=body;func.signature=signature;return func;};ee.Package.save=function(pkg,path){var args=ee.arguments.extract(ee.Package.save,arguments);pkg=args.pkg;path=args.path;if(!path){throw Error("No path specified.");}var original={};for(name in pkg){if(pkg.hasOwnProperty(name)){var member=pkg[name];if(member instanceof Function){if(member.isSaved){var expected=path+"/"+name;if(member.path!=expected){throw Error("Function name mismatch.  Expected path: "+expected+" but found: "+member.path);}}else{if("signature"in member){original[name]=member,pkg[name]=ee.Package.makeInvocation_(path,name,member.signature);}else{throw Error("No signature for function: "+name);}}}else{throw Error("Can\'t save constants: "+name);}}}var custom=[];for(name in original){var body=original[name].body,signature=original[name].signature,func=new ee.CustomFunction(signature,body);custom.push({name:name,algorithm:ee.ApiFunction._call("SavedAlgorithm",func,signature,{text:body.toString()})});}if(custom.length){try{ee.data.createFolder(path);}catch(e){if(!e.message.match(/exists/)){throw e;}}for(var index=0;index<custom.length;index++){var name=custom[index].name;var algorithm=custom[index].algorithm.serialize();ee.data.createAsset(algorithm,path+"/"+name);}}};ee.Package.getFolder=function(path){return ee.ApiFunction.lookup("LoadFolder").call(path).getInfo();};ee.Package.decodeDecl=function(decl){var parts=decl.match(/\\w+|\\S/g),cur=0,expect=function expect(regex){var match=parts[cur]&&parts[cur].match(regex);if(match){return cur++,match[0];}throw Error("Unable to decode declaration.");},type=expect(/\\w+/);expect(/\\w+/);expect(/\\(/);for(var collected=[];parts[cur]&&!parts[cur].match("\\\\)");){collected.length&&expect(","),collected.push({type:expect(/\\w+/),name:expect(/\\w+/)});}expect(/\\)/);";"==parts[cur]&&expect(";");if(parts[cur]){throw Error("Unable to decode declaration.  Found extra trailing input.");}return{returns:type,args:collected};};ee.Package.encodeDecl_=function(signature,name){var out=[signature.returns," ",name,"("];if(signature.args){for(var i=0;i<signature.args.length;i++){0<i&&out.push(", "),out.push(signature.args[i].type+" "+signature.args[i].name);}}out.push(")");return out.join("");};ee.Package.makeInvocation_=function(path,name,signature){var savedFunction=new ee.SavedFunction(path+"/"+name,signature),fn=function fn(var_args){var args=Array.prototype.slice.call(arguments);return savedFunction.call.apply(savedFunction,args);};fn.toString=function(){return signature.returns+" "+savedFunction.toString(name);};fn.isSaved=!0;return fn;};goog.async.Delay=function(listener,opt_interval,opt_handler){goog.Disposable.call(this);this.listener_=listener;this.interval_=opt_interval||0;this.handler_=opt_handler;this.callback_=goog.bind(this.doAction_,this);};goog.inherits(goog.async.Delay,goog.Disposable);goog.Delay=goog.async.Delay;goog.async.Delay.prototype.id_=0;goog.async.Delay.prototype.disposeInternal=function(){goog.async.Delay.superClass_.disposeInternal.call(this);this.stop();delete this.listener_;delete this.handler_;};goog.async.Delay.prototype.start=function(opt_interval){this.stop();this.id_=goog.Timer.callOnce(this.callback_,goog.isDef(opt_interval)?opt_interval:this.interval_);};goog.async.Delay.prototype.startIfNotActive=function(opt_interval){this.isActive()||this.start(opt_interval);};goog.async.Delay.prototype.stop=function(){this.isActive()&&goog.Timer.clear(this.id_);this.id_=0;};goog.async.Delay.prototype.fire=function(){this.stop();this.doAction_();};goog.async.Delay.prototype.fireIfActive=function(){this.isActive()&&this.fire();};goog.async.Delay.prototype.isActive=function(){return 0!=this.id_;};goog.async.Delay.prototype.doAction_=function(){this.id_=0;this.listener_&&this.listener_.call(this.handler_);};ee.data.Profiler=function(format){goog.events.EventTarget.call(this);this.format_=format;this.isEnabled_=!1;this.lastRefreshToken_=null;this.profileIds_=Object.create(null);this.tileProfileIds_=Object.create(null);this.showInternal_=!1;this.throttledRefresh_=new goog.async.Delay(goog.bind(this.refresh_,this),ee.data.Profiler.DELAY_BEFORE_REFRESH_);this.profileData_=ee.data.Profiler.getEmptyProfile_(format);};goog.inherits(ee.data.Profiler,goog.events.EventTarget);ee.data.Profiler.DELAY_BEFORE_REFRESH_=500;ee.data.Profiler.prototype.isEnabled=function(){return this.isEnabled_;};ee.data.Profiler.prototype.setEnabled=function(value){this.isEnabled_=!!value;this.dispatchEvent(new goog.events.Event(ee.data.Profiler.EventType.STATE_CHANGED));};ee.data.Profiler.prototype.isLoading=function(){return null!==this.lastRefreshToken_;};ee.data.Profiler.prototype.isError=function(){return goog.isDefAndNotNull(this.profileError_);};ee.data.Profiler.prototype.getStatusText=function(){if(this.profileError_){return this.profileError_;}if(this.lastRefreshToken_){return"Loading...";}var profiles=0,nonTileProfiles=0,tileProfiles=0;goog.object.forEach(this.profileIds_,function(refCount){profiles++;Infinity===refCount?nonTileProfiles++:tileProfiles++;},this);return"Viewing "+profiles+" profiles, "+nonTileProfiles+" from API calls and "+tileProfiles+" from map tiles.";};ee.data.Profiler.prototype.getProfileData=function(){return this.profileData_;};ee.data.Profiler.prototype.clearAndDrop=function(){this.profileIds_=Object.create(null);this.tileProfileIds_=Object.create(null);this.refresh_();};ee.data.Profiler.prototype.getProfileHook=function(){var profileIds=this.profileIds_;return this.isEnabled_?goog.bind(function(profileId){profileIds[profileId]=Infinity;this.throttledRefresh_.start();},this):null;};ee.data.Profiler.prototype.removeProfile_=function(profileId){var count=this.profileIds_[profileId];1<count?this.profileIds_[profileId]--:void 0!==count&&(delete this.profileIds_[profileId],this.throttledRefresh_.start());};ee.data.Profiler.prototype.refresh_=function(){var marker={};this.lastRefreshToken_=marker;var handleResponse=goog.bind(function(result,error){marker==this.lastRefreshToken_&&(this.profileData_=(this.profileError_=error)?ee.data.Profiler.getEmptyProfile_(this.format_):result,this.lastRefreshToken_=null,this.dispatchEvent(ee.data.Profiler.EventType.STATE_CHANGED),this.dispatchEvent(ee.data.Profiler.EventType.DATA_CHANGED));},this),ids=goog.object.getKeys(this.profileIds_);0===ids.length?handleResponse(ee.data.Profiler.getEmptyProfile_(this.format_),void 0):(ee.ApiFunction._apply(this.showInternal_?"Profile.getProfilesInternal":"Profile.getProfiles",{ids:ids,format:this.format_}).getInfo(handleResponse),this.dispatchEvent(ee.data.Profiler.EventType.STATE_CHANGED));};ee.data.Profiler.prototype.addTile=function(tileId,profileId){this.tileProfileIds_[tileId]||(this.tileProfileIds_[tileId]=profileId,this.profileIds_[profileId]=(this.profileIds_[profileId]||0)+1,this.throttledRefresh_.start());};ee.data.Profiler.prototype.removeTile=function(tileId){var profileId=this.tileProfileIds_[tileId];profileId&&(delete this.tileProfileIds_[tileId],this.removeProfile_(profileId));};ee.data.Profiler.prototype.getShowInternal=function(){return this.showInternal_;};ee.data.Profiler.prototype.setShowInternal=function(value){this.showInternal_=!!value;this.throttledRefresh_.fire();};ee.data.Profiler.prototype.setParentEventTarget=function(parent){throw Error("not applicable");};ee.data.Profiler.getEmptyProfile_=function(format){switch(format){case ee.data.Profiler.Format.TEXT:return"";case ee.data.Profiler.Format.JSON:return ee.data.Profiler.EMPTY_JSON_PROFILE_;default:throw Error("Invalid Profiler data format: "+format);}};ee.data.Profiler.EMPTY_JSON_PROFILE_={cols:[],rows:[]};ee.data.Profiler.EventType={STATE_CHANGED:"statechanged",DATA_CHANGED:"datachanged"};ee.data.Profiler.Format={TEXT:"text",JSON:"json"};window.ee=ee;'}]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(886);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'center');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
      maxHeight: '100%'
    }
  };
}

var PopoverAnimationVertical = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationVertical, _Component);

  function PopoverAnimationVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationVertical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        this.props.children
      );
    }
  }]);
  return PopoverAnimationVertical;
}(_react.Component);

PopoverAnimationVertical.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationVertical.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationVertical.propTypes =  false ? {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationVertical;

/***/ }),
/* 530 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Popover = __webpack_require__(163);

var _Popover2 = _interopRequireDefault(_Popover);

var _check = __webpack_require__(960);

var _check2 = _interopRequireDefault(_check);

var _ListItem = __webpack_require__(961);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Menu = __webpack_require__(269);

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nestedMenuStyle = {
  position: 'relative'
};

function getStyles(props, context) {
  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
  var textColor = context.muiTheme.baseTheme.palette.textColor;
  var indent = props.desktop ? 64 : 72;
  var sidePadding = props.desktop ? 24 : 16;

  var styles = {
    root: {
      color: props.disabled ? disabledColor : textColor,
      cursor: props.disabled ? 'default' : 'pointer',
      minHeight: props.desktop ? '32px' : '48px',
      lineHeight: props.desktop ? '32px' : '48px',
      fontSize: props.desktop ? 15 : 16,
      whiteSpace: 'nowrap'
    },

    innerDivStyle: {
      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
      paddingRight: props.rightIcon ? indent : sidePadding,
      paddingBottom: 0,
      paddingTop: 0
    },

    secondaryText: {
      float: 'right'
    },

    leftIconDesktop: {
      margin: 0,
      left: 24,
      top: 4
    },

    rightIconDesktop: {
      margin: 0,
      right: 24,
      top: 4,
      fill: context.muiTheme.menuItem.rightIconDesktopFill
    }
  };

  return styles;
}

var MenuItem = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.cloneMenuItem = function (item) {
      return _react2.default.cloneElement(item, {
        onClick: function onClick(event) {
          if (!item.props.menuItems) {
            _this.handleRequestClose();
          }

          if (item.props.onClick) {
            item.props.onClick(event);
          }
        }
      });
    }, _this.handleClick = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this)
      });

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleRequestClose = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open && nextProps.focusState === 'none') {
        this.handleRequestClose();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'applyFocusState',
    value: function applyFocusState() {
      this.refs.listItem.applyFocusState(this.props.focusState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          desktop = _props.desktop,
          disabled = _props.disabled,
          focusState = _props.focusState,
          innerDivStyle = _props.innerDivStyle,
          insetChildren = _props.insetChildren,
          leftIcon = _props.leftIcon,
          menuItems = _props.menuItems,
          rightIcon = _props.rightIcon,
          secondaryText = _props.secondaryText,
          style = _props.style,
          animation = _props.animation,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);

      // Left Icon
      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
      if (leftIconElement) {
        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
      }

      // Right Icon
      var rightIconElement = void 0;
      if (rightIcon) {
        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
      }

      // Secondary Text
      var secondaryTextElement = void 0;
      if (secondaryText) {
        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;

        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.secondaryText) },
          secondaryText
        );
      }
      var childMenuPopover = void 0;
      if (menuItems) {
        childMenuPopover = _react2.default.createElement(
          _Popover2.default,
          {
            animation: animation,
            anchorOrigin: anchorOrigin,
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            targetOrigin: targetOrigin,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose
          },
          _react2.default.createElement(
            _Menu2.default,
            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
            _react2.default.Children.map(menuItems, this.cloneMenuItem)
          )
        );
        other.onClick = this.handleClick;
      }

      return _react2.default.createElement(
        _ListItem2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          hoverColor: this.context.muiTheme.menuItem.hoverColor,
          innerDivStyle: mergedInnerDivStyles,
          insetChildren: insetChildren,
          leftIcon: leftIconElement,
          ref: 'listItem',
          rightIcon: rightIconElement,
          role: 'menuitem',
          style: mergedRootStyles
        }),
        children,
        secondaryTextElement,
        childMenuPopover
      );
    }
  }]);
  return MenuItem;
}(_react.Component);

MenuItem.muiName = 'MenuItem';
MenuItem.defaultProps = {
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  checked: false,
  desktop: false,
  disabled: false,
  focusState: 'none',
  insetChildren: false,
  targetOrigin: { horizontal: 'left', vertical: 'top' }
};
MenuItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MenuItem.propTypes =  false ? {
  /**
   * Location of the anchor for the popover of nested `MenuItem`
   * elements.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, a left check mark will be rendered.
   */
  checked: _propTypes2.default.bool,
  /**
   * Elements passed as children to the underlying `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * If true, the menu item will render with compact desktop
   * styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu item will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The focus state of the menu item. This prop is used to set the focus
   * state of the underlying `ListItem`.
   */
  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
  /**
   * Override the inline-styles of the inner div.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented.
   * This is only needed when there is no `leftIcon`.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * `MenuItem` elements to nest within the menu item.
   */
  menuItems: _propTypes2.default.node,
  /**
   * Callback function fired when the menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Can be used to render primary text within the menu item.
   */
  primaryText: _propTypes2.default.node,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * Can be used to render secondary text within the menu item.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Location on the popover of nested `MenuItem` elements that will attach
   * to the anchor's origin.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * The value of the menu item.
   */
  value: _propTypes2.default.any
} : {};
exports.default = MenuItem;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d = __webpack_require__(19);

var _api = __webpack_require__(59);

var _eventLoader = __webpack_require__(224);

var _analytics = __webpack_require__(32);

var _layers = __webpack_require__(68);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventLayer = function (_Layer) {
    _inherits(EventLayer, _Layer);

    function EventLayer() {
        _classCallCheck(this, EventLayer);

        return _possibleConstructorReturn(this, (EventLayer.__proto__ || Object.getPrototypeOf(EventLayer)).apply(this, arguments));
    }

    _createClass(EventLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _this2 = this;

            var _props = this.props,
                bounds = _props.bounds,
                columns = _props.columns,
                data = _props.data,
                endDate = _props.endDate,
                eventClustering = _props.eventClustering,
                eventCoordinateField = _props.eventCoordinateField,
                eventPointColor = _props.eventPointColor,
                eventPointRadius = _props.eventPointRadius,
                filters = _props.filters,
                id = _props.id,
                program = _props.program,
                programStage = _props.programStage,
                rows = _props.rows,
                serverCluster = _props.serverCluster,
                startDate = _props.startDate,
                styleDataItem = _props.styleDataItem;

            // Some older favorites don't have a valid color code

            var color = eventPointColor && eventPointColor.charAt(0) !== '#' ? '#' + eventPointColor : eventPointColor;

            var orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
            var period = (0, _analytics.getPeriodFromFilters)(filters);
            var dataItems = (0, _eventLoader.addStyleDataItem)(columns, styleDataItem);
            var map = this.context.map;
            var d2 = void 0;
            var eventRequest = void 0;

            // Data elements to display in event popup
            this.displayElements = {};

            // Default props = no cluster
            var config = {
                type: 'dots',
                pane: id,
                data: data,
                color: color || _layers.EVENT_COLOR,
                radius: eventPointRadius || _layers.EVENT_RADIUS,
                popup: this.onEventClick.bind(this)
            };

            if (eventClustering) {
                if (serverCluster) {
                    config.type = 'serverCluster';
                    config.bounds = bounds;

                    config.load = function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, callback) {
                            var clusterData;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _context.t0 = d2;

                                            if (_context.t0) {
                                                _context.next = 5;
                                                break;
                                            }

                                            _context.next = 4;
                                            return (0, _d.getInstance)();

                                        case 4:
                                            _context.t0 = _context.sent;

                                        case 5:
                                            d2 = _context.t0;
                                            _context.t1 = eventRequest;

                                            if (_context.t1) {
                                                _context.next = 11;
                                                break;
                                            }

                                            _context.next = 10;
                                            return (0, _eventLoader.getAnalyticsRequest)(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField);

                                        case 10:
                                            _context.t1 = _context.sent;

                                        case 11:
                                            eventRequest = _context.t1;


                                            eventRequest = eventRequest.withBbox(params.bbox).withClusterSize(params.clusterSize).withIncludeClusterPoints(params.includeClusterPoints);

                                            _context.next = 15;
                                            return d2.analytics.events.getCluster(eventRequest);

                                        case 15:
                                            clusterData = _context.sent;


                                            callback(params.tileId, _this2.toGeoJson(clusterData));

                                        case 17:
                                        case 'end':
                                            return _context.stop();
                                    }
                                }
                            }, _callee, _this2);
                        }));

                        return function (_x, _x2) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                } else {
                    config.type = 'clientCluster';
                    config.clusterPane = id;
                }
            }

            // Create and add event layer based on config object
            this.layer = map.createLayer(config).addTo(map);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.fitBounds(layerBounds);
            }

            if (program && programStage) {
                this.loadDataElements();
            }
        }

        // Load data elements that should be displayed in popups

    }, {
        key: 'loadDataElements',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var props, d2, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                props = this.props;
                                _context2.next = 3;
                                return (0, _d.getInstance)();

                            case 3:
                                d2 = _context2.sent;
                                _context2.next = 6;
                                return d2.models.programStage.get(props.programStage.id, {
                                    fields: 'programStageDataElements[displayInReports,dataElement[id,' + (0, _helpers.getDisplayPropertyUrl)(d2) + ',optionSet]]',
                                    paging: false
                                });

                            case 6:
                                data = _context2.sent;


                                if (data.programStageDataElements) {
                                    data.programStageDataElements.forEach(function (el) {
                                        var dataElement = el.dataElement;

                                        if (el.displayInReports) {
                                            _this3.displayElements[dataElement.id] = dataElement;

                                            if (dataElement.optionSet && dataElement.optionSet.id) {
                                                d2.models.optionSets.get(dataElement.optionSet.id, {
                                                    fields: 'id,displayName~rename(name),options[code,displayName~rename(name)]',
                                                    paging: false
                                                }).then(function (optionSet) {
                                                    optionSet.options.forEach(function (option) {
                                                        return dataElement.optionSet[option.code] = option.name;
                                                    });
                                                });
                                            }
                                        } else if (props.eventCoordinateField && dataElement.id === props.eventCoordinateField) {
                                            _this3.eventCoordinateFieldName = dataElement.name;
                                        }
                                    });
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function loadDataElements() {
                return _ref2.apply(this, arguments);
            }

            return loadDataElements;
        }()
    }, {
        key: 'onEventClick',
        value: function onEventClick(feature, callback) {
            var _this4 = this;

            var coord = feature.geometry.coordinates;

            (0, _api.apiFetch)('/events/' + feature.id + '.json').then(function (data) {
                var time = data.eventDate.substring(0, 10) + ' ' + data.eventDate.substring(11, 16);
                var dataValues = data.dataValues;
                var content = '<table><tbody>';

                if (Array.isArray(dataValues)) {
                    dataValues.forEach(function (dataValue) {
                        var displayEl = _this4.displayElements[dataValue.dataElement];

                        if (displayEl) {
                            var value = dataValue.value;

                            if (displayEl.optionSet) {
                                value = displayEl.optionSet[value];
                            }

                            content += '<tr><th>' + displayEl.name + '</th><td>' + value + '</td></tr>';
                        }
                    });

                    content += '<tr style="height:5px;"><th></th><td></td></tr>';
                }

                content += '<tr><th>' + _i18next2.default.t('Organisation unit') + '</th><td>' + data.orgUnitName + '</td></tr>\n                            <tr><th>' + _i18next2.default.t('Event time') + '</th><td>' + time + '</td></tr>\n                            <tr><th>' + (_this4.eventCoordinateFieldName || _i18next2.default.t('Event location')) + '</th><td>' + coord[0] + ', ' + coord[1] + '</td></tr> \n                            </tbody></table>';

                callback(content);
            });
        }
    }, {
        key: 'toGeoJson',
        value: function toGeoJson(data) {
            var header = {};
            var features = [];

            // Convert headers to object for easier lookup
            data.headers.forEach(function (h, i) {
                return header[h.name] = i;
            });

            if (Array.isArray(data.rows)) {
                data.rows.forEach(function (row) {
                    var extent = row[header.extent].match(/([-\d\.]+)/g);
                    var coords = row[header.center].match(/([-\d\.]+)/g);

                    // Round to 6 decimals - http://www.jacklmoore.com/notes/rounding-in-javascript/
                    coords[0] = Number(Math.round(coords[0] + 'e6') + 'e-6');
                    coords[1] = Number(Math.round(coords[1] + 'e6') + 'e-6');

                    features.push({
                        type: 'Feature',
                        id: row[header.points],
                        geometry: {
                            type: 'Point',
                            coordinates: coords
                        },
                        properties: {
                            count: parseInt(row[header.count], 10),
                            bounds: [[extent[1], extent[0]], [extent[3], extent[2]]]
                        }
                    });
                });
            }

            return features;
        }
    }]);

    return EventLayer;
}(_Layer3.default);

exports.default = EventLayer;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _isPlainObject = __webpack_require__(232);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacilityLayer = function (_Layer) {
    _inherits(FacilityLayer, _Layer);

    function FacilityLayer() {
        _classCallCheck(this, FacilityLayer);

        return _possibleConstructorReturn(this, (FacilityLayer.__proto__ || Object.getPrototypeOf(FacilityLayer)).apply(this, arguments));
    }

    _createClass(FacilityLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                dataFilters = _props.dataFilters,
                labels = _props.labels,
                areaRadius = _props.areaRadius,
                labelFontColor = _props.labelFontColor,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                labelFontWeight = _props.labelFontWeight;


            var filteredData = (0, _filter.filterData)(data, dataFilters);

            var map = this.context.map;

            // Create layer config object
            var config = {
                type: 'markers',
                pane: id,
                data: filteredData,
                hoverLabel: '{label}'
            };

            // Labels and label style
            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    color: labelFontColor,
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    paddingTop: '10px'
                };
            }

            // Remove area layer instance if already exist
            if (this.areaInstance && map.hasLayer(this.areaInstance)) {}
            // map.removeLayer(this.areaInstance);


            // Create and add facility layer based on config object
            this.layer = map.createLayer(config).addTo(map);

            // Create and add area layer
            if (areaRadius) {
                this.areaInstance = map.addLayer({
                    type: 'circles',
                    pane: id + '-area',
                    radius: areaRadius,
                    highlightStyle: false,
                    data: filteredData
                });
            }

            // Handle facility click
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.fitBounds(layerBounds);
            }
        }

        // Show pupup on facility click

    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var attr = evt.layer.feature.properties;
            var content = '<div class="leaflet-popup-orgunit"><em>' + attr.name + '</em>';

            if ((0, _isPlainObject2.default)(attr.dimensions)) {
                content += '<br/>' + _i18next2.default.t('Groups') + ': ' + Object.keys(attr.dimensions).map(function (id) {
                    return attr.dimensions[id];
                }).join(', ');
            }

            if (attr.pn) {
                content += '<br/>' + _i18next2.default.t('Parent unit') + ': ' + attr.pn;
            }

            content += '</div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(this.context.map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng[1], latlng[0]],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }

        // Remove layer instance (both facilities and areas)

    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            var map = this.context.map;

            if (map.hasLayer(this.areaInstance)) {
                map.removeLayer(this.areaInstance);
            }
            _get(FacilityLayer.prototype.__proto__ || Object.getPrototypeOf(FacilityLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return FacilityLayer;
}(_Layer3.default);

exports.default = FacilityLayer;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThematicLayer = function (_Layer) {
    _inherits(ThematicLayer, _Layer);

    function ThematicLayer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ThematicLayer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThematicLayer.__proto__ || Object.getPrototypeOf(ThematicLayer)).call.apply(_ref, [this].concat(args))), _this), _this.getHtmlLegend = function (_ref2) {
            var title = _ref2.title,
                period = _ref2.period,
                items = _ref2.items;
            return '\n        <div class="dhis2-legend">\n            <h2>' + title + '</h2>\n            <span>' + period + '</span>\n            <dl class="dhis2-legend-automatic">\n                ' + items.map(function (item) {
                return '\n                    <dt style="background-color:' + item.color + '"></dt>\n                    <dd>' + (item.name || '') + ' ' + (!isNaN(item.startValue) ? item.startValue + ' - ' + item.endValue : '') + ' (' + item.count + ')</dd>\n                ';
            }).join('') + '\n            </dl>\n        </div>';
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ThematicLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                dataFilters = _props.dataFilters,
                _props$valueFilter = _props.valueFilter,
                valueFilter = _props$valueFilter === undefined ? { gt: null, lt: null } : _props$valueFilter,
                labels = _props.labels,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                legend = _props.legend,
                isPlugin = _props.isPlugin;


            var map = this.context.map;

            var config = {
                type: 'choropleth',
                pane: id,
                data: (0, _filter.filterData)(data, dataFilters),
                hoverLabel: '{name} ({value})'
            };

            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle
                };
                config.labelPane = id + '-labels';
            }

            this.layer = map.createLayer(config);
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            if (isPlugin && legend) {
                map.legend = (map.legend || '') + this.getHtmlLegend(legend); // TODO: Better way to assemble the legend?
            }

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.invalidateSize();
                map.fitBounds(layerBounds);
            }
        }

        // Used for legend in map plugins

    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var _evt$layer$feature$pr = evt.layer.feature.properties,
                name = _evt$layer$feature$pr.name,
                value = _evt$layer$feature$pr.value;
            var _props2 = this.props,
                columns = _props2.columns,
                aggregationType = _props2.aggregationType,
                legend = _props2.legend;

            var map = this.context.map;
            var indicator = columns[0].items[0].name || '';
            var period = legend.period;
            var content = '\n            <div class="leaflet-popup-orgunit">\n                <em>' + name + '</em><br>\n                ' + indicator + '<br>\n                ' + period + ': ' + value + ' ' + (aggregationType ? '(' + aggregationType + ')' : '') + '\n            </div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng.lng, latlng.lat],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            this.layer.off('click', this.onFeatureClick, this);
            this.layer.off('contextmenu', this.onFeatureRightClick, this);

            _get(ThematicLayer.prototype.__proto__ || Object.getPrototypeOf(ThematicLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return ThematicLayer;
}(_Layer3.default);

exports.default = ThematicLayer;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoundaryLayer = function (_Layer) {
    _inherits(BoundaryLayer, _Layer);

    function BoundaryLayer() {
        _classCallCheck(this, BoundaryLayer);

        return _possibleConstructorReturn(this, (BoundaryLayer.__proto__ || Object.getPrototypeOf(BoundaryLayer)).apply(this, arguments));
    }

    _createClass(BoundaryLayer, [{
        key: 'createLayer',
        value: function createLayer() {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                labels = _props.labels,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                radiusLow = _props.radiusLow,
                dataFilters = _props.dataFilters;


            var filteredData = (0, _filter.filterData)(data, dataFilters);

            var map = this.context.map;

            var config = {
                type: 'boundary',
                pane: id,
                data: filteredData,
                hoverLabel: '{name}',
                style: {
                    opacity: 1,
                    fillOpacity: 0,
                    fill: false
                }
            };

            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle
                };
            }

            if (radiusLow) {
                config.style.radius = radiusLow;
            }

            this.layer = map.createLayer(config);
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.invalidateSize();
                map.fitBounds(layerBounds);
            }
        }
    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var attr = evt.layer.feature.properties;
            var content = '<div class="leaflet-popup-orgunit"><em>' + attr.name + '</em>';

            if (attr.level) {
                content += '<br/>' + _i18next2.default.t('Level') + ': ' + attr.level;
            }

            if (attr.parentName) {
                content += '<br/>' + _i18next2.default.t('Parent unit') + ': ' + attr.parentName;
            }

            content += '</div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(this.context.map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng.lng, latlng.lat],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            this.layer.off('click', this.onFeatureClick, this);
            this.layer.off('contextmenu', this.onFeatureRightClick, this);

            _get(BoundaryLayer.prototype.__proto__ || Object.getPrototypeOf(BoundaryLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return BoundaryLayer;
}(_Layer3.default);

exports.default = BoundaryLayer;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _api = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EarthEngineLayer = function (_Layer) {
    _inherits(EarthEngineLayer, _Layer);

    function EarthEngineLayer() {
        _classCallCheck(this, EarthEngineLayer);

        return _possibleConstructorReturn(this, (EarthEngineLayer.__proto__ || Object.getPrototypeOf(EarthEngineLayer)).apply(this, arguments));
    }

    _createClass(EarthEngineLayer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prev) {
            _get(EarthEngineLayer.prototype.__proto__ || Object.getPrototypeOf(EarthEngineLayer.prototype), 'componentDidUpdate', this).call(this, prev);

            var coordinate = this.props.coordinate;


            if (coordinate && coordinate !== prev.coordinate) {
                try {
                    this.layer.showValue({
                        lng: coordinate[0],
                        lat: coordinate[1]
                    });
                } catch (err) {
                    console.error('Google Earth Engine failed. Is the service configured for this DHIS2 instance?');
                }
            }
        }
    }, {
        key: 'createLayer',
        value: function createLayer() {
            var props = this.props;
            var map = this.context.map;

            var config = {
                type: 'earthEngine',
                pane: props.id,
                id: props.datasetId,
                band: props.band,
                mask: props.mask,
                attribution: props.attribution,
                filter: props.filter,
                methods: props.methods,
                aggregation: props.aggregation,
                name: props.name,
                unit: props.legend.unit,
                value: props.value,
                legend: props.legend && !props.legend.unit ? props.legend.items : null,
                resolution: props.resolution,
                projection: props.projection
            };

            if (props.params) {
                config.params = props.params;
            }

            if (props.popup) {
                config.popup = props.popup;
            }

            config.accessToken = function (callback) {
                return (0, _api.apiFetch)('/tokens/google').then(function (json) {
                    return callback(json);
                });
            };

            this.layer = map.createLayer(config);
        }
    }]);

    return EarthEngineLayer;
}(_Layer3.default);

exports.default = EarthEngineLayer;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExternalLayer = function (_Layer) {
    _inherits(ExternalLayer, _Layer);

    function ExternalLayer() {
        _classCallCheck(this, ExternalLayer);

        return _possibleConstructorReturn(this, (ExternalLayer.__proto__ || Object.getPrototypeOf(ExternalLayer)).apply(this, arguments));
    }

    _createClass(ExternalLayer, [{
        key: 'createLayer',
        value: function createLayer() {
            // console.log('EXTERNAL LAYER', this.props);

            var props = this.props;
            var config = props.config;
            var map = this.context.map;

            config.type = 'tileLayer'; // TODO: Should be part of config object
            config.pane = props.id;

            this.layer = map.createLayer(config);
        }
    }]);

    return ExternalLayer;
}(_Layer3.default);

exports.default = ExternalLayer;

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(1029);




var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(1).any;




/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var babelPluginFlowReactPropTypes_proptype_RowRendererParams =  true ? null : {
  index: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  isVisible: require('prop-types').bool.isRequired,
  key: require('prop-types').string.isRequired,
  parent: require('prop-types').object.isRequired,
  style: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_RowRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RowRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_RowRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: require('prop-types').number.isRequired,
  overscanStopIndex: require('prop-types').number.isRequired,
  startIndex: require('prop-types').number.isRequired,
  stopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedRows', {
  value: babelPluginFlowReactPropTypes_proptype_RenderedRows,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
  clientHeight: require('prop-types').number.isRequired,
  scrollHeight: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
  value: babelPluginFlowReactPropTypes_proptype_Scroll,
  configurable: true
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_SCROLLING_RESET_TIME_INTERVAL", function() { return DEFAULT_SCROLLING_RESET_TIME_INTERVAL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PositionCache__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_requestAnimationTimeout__ = __webpack_require__(238);











var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId = __webpack_require__(238).babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId || __webpack_require__(1).any;

var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Masonry, _PureComponent);

  function Masonry(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call(this, props, context));

    _this._invalidateOnUpdateStartIndex = null;
    _this._invalidateOnUpdateStopIndex = null;
    _this._positionCache = new __WEBPACK_IMPORTED_MODULE_8__PositionCache__["a" /* default */]();
    _this._startIndex = null;
    _this._startIndexMemoized = null;
    _this._stopIndex = null;
    _this._stopIndexMemoized = null;


    _this.state = {
      isScrolling: false,
      scrollTop: 0
    };

    _this._debounceResetIsScrollingCallback = _this._debounceResetIsScrollingCallback.bind(_this);
    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_8__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_8__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var scrollTop = this.props.scrollTop;


      if (scrollTop !== nextProps.scrollTop) {
        this._debounceResetIsScrolling();

        this.setState({
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: {
            height: cellMeasurerCache.getHeight(index),
            left: left,
            position: 'absolute',
            top: top,
            width: cellMeasurerCache.getWidth(index)
          }
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_9__utils_requestAnimationTimeout__["requestAnimationTimeout"])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_debounceResetIsScrollingCallback',
    value: function _debounceResetIsScrollingCallback() {
      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }, {
    key: '_setScrollingContainerRef',
    value: function _setScrollingContainerRef(ref) {
      this._scrollingContainer = ref;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      var height = this.props.height;


      var eventScrollTop = event.target.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollTop !== scrollTop) {
        this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0
};
Masonry.propTypes =  true ? null : {
  autoHeight: require('prop-types').bool.isRequired,
  cellCount: require('prop-types').number.isRequired,
  cellMeasurerCache: typeof CellMeasurerCache === 'function' ? require('prop-types').instanceOf(CellMeasurerCache).isRequired : require('prop-types').any.isRequired,
  cellPositioner: typeof Positioner === 'function' ? require('prop-types').instanceOf(Positioner).isRequired : require('prop-types').any.isRequired,
  cellRenderer: typeof CellRenderer === 'function' ? require('prop-types').instanceOf(CellRenderer).isRequired : require('prop-types').any.isRequired,
  className: require('prop-types').string,
  height: require('prop-types').number.isRequired,
  id: require('prop-types').string,
  keyMapper: typeof KeyMapper === 'function' ? require('prop-types').instanceOf(KeyMapper).isRequired : require('prop-types').any.isRequired,
  onCellsRendered: typeof OnCellsRenderedCallback === 'function' ? require('prop-types').instanceOf(OnCellsRenderedCallback) : require('prop-types').any,
  onScroll: typeof OnScrollCallback === 'function' ? require('prop-types').instanceOf(OnScrollCallback) : require('prop-types').any,
  overscanByPixels: require('prop-types').number.isRequired,
  role: require('prop-types').string.isRequired,
  scrollingResetTimeInterval: require('prop-types').number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: require('prop-types').number.isRequired,
  width: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Masonry);


function identity(value) {
  return value;
}

function noop() {}

var babelPluginFlowReactPropTypes_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: require('prop-types').number.isRequired,
  defaultWidth: require('prop-types').number.isRequired,
  getHeight: require('prop-types').func.isRequired,
  getWidth: require('prop-types').func.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellMeasurerCache', {
  value: babelPluginFlowReactPropTypes_proptype_CellMeasurerCache,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Positioner =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Positioner', {
  value: babelPluginFlowReactPropTypes_proptype_Positioner,
  configurable: true
});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearDataFilter = exports.setDataFilter = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setDataFilter = exports.setDataFilter = function setDataFilter(layerId, fieldId, filter) {
    return {
        type: types.DATA_FILTER_SET,
        layerId: layerId,
        fieldId: fieldId,
        filter: filter
    };
};

var clearDataFilter = exports.clearDataFilter = function clearDataFilter(layerId, fieldId) {
    return {
        type: types.DATA_FILTER_CLEAR,
        layerId: layerId,
        fieldId: fieldId
    };
};

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(544);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(267);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _SlideInChild = __webpack_require__(1120);

var _SlideInChild2 = _interopRequireDefault(_SlideInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideIn = function (_Component) {
  (0, _inherits3.default)(SlideIn, _Component);

  function SlideIn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SlideIn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
      return _this.props.direction;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SlideIn, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          enterDelay = _props.enterDelay,
          children = _props.children,
          childStyle = _props.childStyle,
          direction = _props.direction,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _SlideInChild2.default,
          {
            key: child.key,
            direction: direction,
            enterDelay: enterDelay,
            getLeaveDirection: _this2.getLeaveDirection,
            style: childStyle
          },
          child
        );
      }, this);

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return SlideIn;
}(_react.Component);

SlideIn.defaultProps = {
  enterDelay: 0,
  direction: 'left'
};
SlideIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SlideIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
  enterDelay: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = SlideIn;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Popover = __webpack_require__(268);

var _Popover2 = _interopRequireDefault(_Popover);

var _arrowDropDown = __webpack_require__(656);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Chrome = __webpack_require__(1136);

var _Chrome2 = _interopRequireDefault(_Chrome);

var _d3Color = __webpack_require__(657);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    wrapper: {
        display: 'inline-block'
    },
    color: {
        padding: 0,
        textAlign: 'right'
    }
};

var ColorPicker = function (_Component) {
    _inherits(ColorPicker, _Component);

    function ColorPicker() {
        var _ref;

        _classCallCheck(this, ColorPicker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call.apply(_ref, [this].concat(args)));

        _this.handleOpen = function (event) {
            _this.setState({
                isOpen: true,
                anchorEl: event.currentTarget
            });
        };

        _this.handleClose = function () {
            _this.setState({ isOpen: false });
        };

        _this.handleChange = function (color) {
            var hexColor = color.hex.toUpperCase();

            _this.setState({ color: hexColor });
            _this.props.onChange(hexColor);
        };

        _this.state = {
            isOpen: false,
            color: _this.props.color
        };
        return _this;
    }

    _createClass(ColorPicker, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                color = _state.color,
                isOpen = _state.isOpen,
                anchorEl = _state.anchorEl;


            return _react2.default.createElement(
                'div',
                { style: styles.wrapper },
                _react2.default.createElement(
                    _IconButton2.default,
                    {
                        onClick: this.handleOpen,
                        style: _extends({}, styles.color, {
                            background: color
                        }, this.props.style),
                        disableTouchRipple: true
                    },
                    _react2.default.createElement(_arrowDropDown2.default // TODO: Switch to d2-ui cmp
                    , { color: (0, _d3Color.hcl)(color).l < 70 ? '#fff' : '#333'
                    })
                ),
                _react2.default.createElement(
                    _Popover2.default,
                    {
                        open: isOpen,
                        onRequestClose: this.handleClose,
                        anchorEl: anchorEl
                    },
                    _react2.default.createElement(_Chrome2.default, { color: color, onChange: this.handleChange })
                )
            );
        }
    }]);

    return ColorPicker;
}(_react.Component);

exports.default = ColorPicker;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(218),
    castFunction = __webpack_require__(666);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = __webpack_require__(1145);

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(667);

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(1148);

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = __webpack_require__(1149);

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(1151);

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(1152);

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(1155);

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(1159);

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(664);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function Checkbox(_ref) {
    var label = _ref.label,
        checked = _ref.checked,
        _onCheck = _ref.onCheck,
        style = _ref.style,
        labelStyle = _ref.labelStyle,
        iconStyle = _ref.iconStyle;
    return _react2.default.createElement(_Checkbox2.default, {
        label: label,
        checked: checked,
        onCheck: function onCheck(event, isChecked) {
            return _onCheck(isChecked);
        },
        style: style,
        labelStyle: labelStyle,
        iconStyle: iconStyle
    });
};

Checkbox.propTypes = {
    label: _propTypes2.default.string,
    checked: _propTypes2.default.bool,
    onCheck: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    labelStyle: _propTypes2.default.object,
    iconStyle: _propTypes2.default.object
};

exports.default = Checkbox;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _formatBold = __webpack_require__(1183);

var _formatBold2 = _interopRequireDefault(_formatBold);

var _formatItalic = __webpack_require__(1184);

var _formatItalic2 = _interopRequireDefault(_formatItalic);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _ColorPicker = __webpack_require__(546);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    sizeField: {
        width: 48,
        marginRight: 5
    },
    button: {
        background: '#fafafa',
        marginRight: 5
    },
    buttonPressed: {
        background: '#555',
        marginRight: 5
    }
};

var FontStyle = function FontStyle(_ref) {
    var color = _ref.color,
        size = _ref.size,
        weight = _ref.weight,
        fontStyle = _ref.fontStyle,
        onColorChange = _ref.onColorChange,
        onSizeChange = _ref.onSizeChange,
        onWeightChange = _ref.onWeightChange,
        onStyleChange = _ref.onStyleChange,
        style = _ref.style;
    return _react2.default.createElement(
        'div',
        { style: style },
        onSizeChange && _react2.default.createElement(_TextField2.default, {
            type: 'number',
            label: 'Size',
            value: size !== undefined ? size : 11,
            onChange: onSizeChange,
            style: styles.sizeField
        }),
        onWeightChange && _react2.default.createElement(
            _IconButton2.default,
            {
                onClick: function onClick() {
                    return onWeightChange(weight === 'bold' ? 'normal' : 'bold');
                },
                style: weight === 'bold' ? styles.buttonPressed : styles.button,
                disableTouchRipple: true
            },
            _react2.default.createElement(_formatBold2.default, { color: weight === 'bold' ? '#fff' : '#555' })
        ),
        onStyleChange && _react2.default.createElement(
            _IconButton2.default,
            {
                onClick: function onClick() {
                    return onStyleChange(fontStyle === 'italic' ? 'normal' : 'italic');
                },
                style: fontStyle === 'italic' ? styles.buttonPressed : styles.button,
                disableTouchRipple: true
            },
            _react2.default.createElement(_formatItalic2.default, { color: fontStyle === 'italic' ? '#fff' : '#555' })
        ),
        onColorChange && _react2.default.createElement(_ColorPicker2.default, { color: color || '#333333', onChange: onColorChange })
    );
};

FontStyle.propTypes = {};

exports.default = FontStyle;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrgUnitGroupSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _orgUnits = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
    width: '100%',
    marginTop: -12
};

var OrgUnitGroupSelect = exports.OrgUnitGroupSelect = function (_Component) {
    _inherits(OrgUnitGroupSelect, _Component);

    function OrgUnitGroupSelect() {
        _classCallCheck(this, OrgUnitGroupSelect);

        return _possibleConstructorReturn(this, (OrgUnitGroupSelect.__proto__ || Object.getPrototypeOf(OrgUnitGroupSelect)).apply(this, arguments));
    }

    _createClass(OrgUnitGroupSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                orgUnitGroups = _props.orgUnitGroups,
                loadOrgUnitGroups = _props.loadOrgUnitGroups;


            if (!orgUnitGroups) {
                loadOrgUnitGroups();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                orgUnitGroup = _props2.orgUnitGroup,
                orgUnitGroups = _props2.orgUnitGroups,
                onChange = _props2.onChange;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Select groups'),
                loading: orgUnitGroups ? false : true,
                items: orgUnitGroups,
                value: orgUnitGroup,
                multiple: true,
                onChange: onChange,
                style: style
            });
        }
    }]);

    return OrgUnitGroupSelect;
}(_react.Component);

OrgUnitGroupSelect.propTypes = {
    orgUnitGroup: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    orgUnitGroups: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        orgUnitGroups: state.orgUnitGroups
    };
}, { loadOrgUnitGroups: _orgUnits.loadOrgUnitGroups })(OrgUnitGroupSelect);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrgUnitLevelSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _once = __webpack_require__(671);

var _once2 = _interopRequireDefault(_once);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _orgUnits = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
    width: '100%',
    marginTop: -7
};

var OrgUnitLevelSelect = exports.OrgUnitLevelSelect = function (_Component) {
    _inherits(OrgUnitLevelSelect, _Component);

    function OrgUnitLevelSelect(props, context) {
        _classCallCheck(this, OrgUnitLevelSelect);

        var _this = _possibleConstructorReturn(this, (OrgUnitLevelSelect.__proto__ || Object.getPrototypeOf(OrgUnitLevelSelect)).call(this, props, context));

        _this.selectDefault = (0, _once2.default)(function (level) {
            return props.onChange(level);
        }); // only select default level once
        return _this;
    }

    _createClass(OrgUnitLevelSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                orgUnitLevels = _props.orgUnitLevels,
                loadOrgUnitLevels = _props.loadOrgUnitLevels;


            if (!orgUnitLevels) {
                loadOrgUnitLevels();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props2 = this.props,
                defaultLevel = _props2.defaultLevel,
                orgUnitLevel = _props2.orgUnitLevel,
                orgUnitLevels = _props2.orgUnitLevels,
                onChange = _props2.onChange;


            if (!orgUnitLevel.length && defaultLevel && orgUnitLevels) {
                var levelItem = orgUnitLevels.find(function (item) {
                    return item.level === defaultLevel;
                });

                if (levelItem) {
                    this.selectDefault([levelItem.level.toString()]);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                orgUnitLevel = _props3.orgUnitLevel,
                orgUnitLevels = _props3.orgUnitLevels,
                onChange = _props3.onChange;

            var sortedOrgUnitLevels = void 0;

            if (orgUnitLevels) {
                sortedOrgUnitLevels = (0, _sortBy2.default)(function (item) {
                    return item.level;
                }, orgUnitLevels).map(function (_ref) {
                    var level = _ref.level,
                        name = _ref.name;
                    return { id: level.toString(), name: name };
                }); // TODO
            }

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Select levels'),
                loading: orgUnitLevels ? false : true,
                items: sortedOrgUnitLevels,
                value: orgUnitLevel,
                multiple: true,
                onChange: onChange,
                style: style
            });
        }
    }]);

    return OrgUnitLevelSelect;
}(_react.Component);

OrgUnitLevelSelect.propTypes = {
    orgUnitLevel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    orgUnitLevels: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        orgUnitLevels: state.orgUnitLevels
    };
}, { loadOrgUnitLevels: _orgUnits.loadOrgUnitLevels })(OrgUnitLevelSelect);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configI18n = undefined;

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__(554);

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _d = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configI18n = exports.configI18n = function configI18n(userSettings) {
    var uiLocale = userSettings.keyUiLocale;

    if (uiLocale && uiLocale !== 'en') {
        _d.config.i18n.sources.add('./i18n/i18n_module_' + uiLocale + '.properties');
    }

    _d.config.i18n.sources.add('./i18n/i18n_module_en.properties');

    _i18next2.default.use(_i18nextXhrBackend2.default).init({
        returnEmptyString: false,
        fallbackLng: false,
        keySeparator: '|',
        backend: {
            loadPath: '/i18n/{{lng}}.json'
        }
    }, function (err, t) {
        if (uiLocale && uiLocale !== 'en') {
            _i18next2.default.changeLanguage(uiLocale);
        }
    });
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(555).default;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(556);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(557);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(682);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(704);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return map_1.map(project, thisArg)(this);
}
exports.map = map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(138);
var isArrayLike_1 = __webpack_require__(570);
var isPromise_1 = __webpack_require__(571);
var isObject_1 = __webpack_require__(564);
var Observable_1 = __webpack_require__(30);
var iterator_1 = __webpack_require__(435);
var InnerSubscriber_1 = __webpack_require__(707);
var observable_1 = __webpack_require__(434);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators__ = __webpack_require__(575);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ActionsObservable = function (_Observable) {
  _inherits(ActionsObservable, _Observable);

  _createClass(ActionsObservable, null, [{
    key: 'of',
    value: function of() {
      return new this(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"].apply(undefined, arguments));
    }
  }, {
    key: 'from',
    value: function from(actions, scheduler) {
      return new this(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(actions, scheduler));
    }
  }]);

  function ActionsObservable(actionsSubject) {
    _classCallCheck(this, ActionsObservable);

    var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));

    _this.source = actionsSubject;
    return _this;
  }

  _createClass(ActionsObservable, [{
    key: 'lift',
    value: function lift(operator) {
      var observable = new ActionsObservable(this);
      observable.operator = operator;
      return observable;
    }
  }, {
    key: 'ofType',
    value: function ofType() {
      return __WEBPACK_IMPORTED_MODULE_3__operators__["a" /* ofType */].apply(undefined, arguments)(this);
    }
  }]);

  return ActionsObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(30);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ofType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_filter__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_filter__);


var keyHasType = function keyHasType(type, key) {
  return type === key || typeof key === 'function' && type === key.toString();
};

function ofType() {
  for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function ofTypeOperatorFunction(source) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_filter__["filter"].call(source, function (_ref) {
      var type = _ref.type;

      var len = keys.length;
      if (len === 1) {
        return keyHasType(type, keys[0]);
      } else {
        for (var i = 0; i < len; i++) {
          if (keyHasType(type, keys[i])) {
            return true;
          }
        }
      }
      return false;
    });
  };
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var filter_1 = __webpack_require__(716);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return filter_1.filter(predicate, thisArg)(this);
}
exports.filter = filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EPIC_END; });
var EPIC_END = '@@redux-observable/EPIC_END';

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var ArrayObservable_1 = __webpack_require__(436);
var isScheduler_1 = __webpack_require__(574);
var mergeAll_1 = __webpack_require__(579);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(438);
var identity_1 = __webpack_require__(718);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var filter_1 = __webpack_require__(576);
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(438);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return mergeMap_1.mergeMap(project, resultSelector, 1);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDataSets = exports.loadDataSets = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load all programs
var loadDataSets = exports.loadDataSets = function loadDataSets() {
    return {
        type: types.DATA_SETS_LOAD
    };
};

// Set all programs
var setDataSets = exports.setDataSets = function setDataSets(data) {
    return {
        type: types.DATA_SETS_SET,
        payload: data
    };
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadEarthEngineCollection = exports.setEarthEngineCollection = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Set collection (periods) for one EE dataset
var setEarthEngineCollection = exports.setEarthEngineCollection = function setEarthEngineCollection(id, payload) {
    return {
        type: types.EARTH_ENGINE_COLLECTION_SET,
        id: id,
        payload: payload
    };
};

// Load collection (periods) for one EE dataset
var loadEarthEngineCollection = exports.loadEarthEngineCollection = function loadEarthEngineCollection(id) {
    return {
        type: types.EARTH_ENGINE_COLLECTION_LOAD,
        id: id
    };
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearAlerts = exports.setAlert = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setAlert = exports.setAlert = function setAlert(payload) {
    return {
        type: types.ALERT_SET,
        payload: payload
    };
};

var clearAlerts = exports.clearAlerts = function clearAlerts() {
    return {
        type: types.ALERTS_CLEAR
    };
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var mergeMap_1 = __webpack_require__(781);
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeBasemapOpacity = exports.toggleBasemapVisibility = exports.toggleBasemapExpand = exports.selectBasemap = exports.addBasemap = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addBasemap = exports.addBasemap = function addBasemap(layer) {
    return {
        type: types.BASEMAP_ADD,
        payload: layer
    };
};

var selectBasemap = exports.selectBasemap = function selectBasemap(id) {
    return {
        type: types.BASEMAP_SELECTED,
        id: id
    };
};

var toggleBasemapExpand = exports.toggleBasemapExpand = function toggleBasemapExpand() {
    return {
        type: types.BASEMAP_TOGGLE_EXPAND
    };
};

var toggleBasemapVisibility = exports.toggleBasemapVisibility = function toggleBasemapVisibility() {
    return {
        type: types.BASEMAP_TOGGLE_VISIBILITY
    };
};

var changeBasemapOpacity = exports.changeBasemapOpacity = function changeBasemapOpacity(opacity) {
    return {
        type: types.BASEMAP_CHANGE_OPACITY,
        opacity: opacity
    };
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadExternalLayers = exports.removeExternalLayer = exports.addExternalLayer = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Add external overlay
var addExternalLayer = exports.addExternalLayer = function addExternalLayer(layer) {
    return {
        type: types.EXTERNAL_LAYER_ADD,
        payload: layer
    };
};

// Remove external overlay
var removeExternalLayer = exports.removeExternalLayer = function removeExternalLayer(id) {
    return {
        type: types.EXTERNAL_LAYER_REMOVE,
        id: id
    };
};

// Load all external layers
var loadExternalLayers = exports.loadExternalLayers = function loadExternalLayers() {
    return {
        type: types.EXTERNAL_LAYERS_LOAD
    };
};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLegendSets = exports.loadLegendSets = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load all legend sets
var loadLegendSets = exports.loadLegendSets = function loadLegendSets() {
    return {
        type: types.LEGEND_SETS_LOAD
    };
};

// Set all legend sets
var setLegendSets = exports.setLegendSets = function setLegendSets(data) {
    return {
        type: types.LEGEND_SETS_SET,
        payload: data
    };
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(589);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(592);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(504);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(143);
var toObject = __webpack_require__(235);
var IE_PROTO = __webpack_require__(506)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(145) && !__webpack_require__(157)(function () {
  return Object.defineProperty(__webpack_require__(595)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(156);
var document = __webpack_require__(103).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(514);
var $export = __webpack_require__(104);
var redefine = __webpack_require__(597);
var hide = __webpack_require__(155);
var has = __webpack_require__(143);
var Iterators = __webpack_require__(158);
var $iterCreate = __webpack_require__(815);
var setToStringTag = __webpack_require__(518);
var getPrototypeOf = __webpack_require__(593);
var ITERATOR = __webpack_require__(69)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(155);


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(143);
var toIObject = __webpack_require__(146);
var arrayIndexOf = __webpack_require__(817)(false);
var IE_PROTO = __webpack_require__(506)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(516);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(513);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(598);
var hiddenKeys = __webpack_require__(517).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(524);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__(846);

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__(147);

var _lightBaseTheme = __webpack_require__(847);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(848);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(849);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(873);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(874);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(877);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(878);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(840), __esModule: true };

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(605);
var ITERATOR = __webpack_require__(69)('iterator');
var Iterators = __webpack_require__(158);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(516);
var TAG = __webpack_require__(69)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(864);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(883), __esModule: true };

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(524);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__(615);

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(267);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__(616);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(890);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(
          _TransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(603);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = __webpack_require__(891);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendChildren = extendChildren;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendChildren(children, extendedProps, extendedChildren) {
  return _react2.default.Children.map(children, function (child) {
    if (!_react2.default.isValidElement(child)) {
      return child;
    }

    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

    return _react2.default.cloneElement(child, newProps, newChildren);
  });
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(895);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(896);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronLeft = function NavigationChevronLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
  );
};
NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
NavigationChevronLeft.displayName = 'NavigationChevronLeft';
NavigationChevronLeft.muiName = 'SvgIcon';

exports.default = NavigationChevronLeft;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronRight = function NavigationChevronRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
  );
};
NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
NavigationChevronRight.displayName = 'NavigationChevronRight';
NavigationChevronRight.muiName = 'SvgIcon';

exports.default = NavigationChevronRight;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;

var _Toolbar2 = __webpack_require__(939);

var _Toolbar3 = _interopRequireDefault(_Toolbar2);

var _ToolbarGroup2 = __webpack_require__(940);

var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);

var _ToolbarSeparator2 = __webpack_require__(941);

var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);

var _ToolbarTitle2 = __webpack_require__(942);

var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Toolbar = _Toolbar3.default;
exports.ToolbarGroup = _ToolbarGroup3.default;
exports.ToolbarSeparator = _ToolbarSeparator3.default;
exports.ToolbarTitle = _ToolbarTitle3.default;
exports.default = _Toolbar3.default;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _dom = __webpack_require__(616);

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
var RenderToLayer = function (_Component) {
  (0, _inherits3.default)(RenderToLayer, _Component);

  function RenderToLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RenderToLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (!_this.props.componentClickAway) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      var el = _this.layer;
      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
        _this.props.componentClickAway(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RenderToLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unrenderLayer();
    }
  }, {
    key: 'getLayer',
    value: function getLayer() {
      return this.layer;
    }
  }, {
    key: 'unrenderLayer',
    value: function unrenderLayer() {
      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('click', this.onClickAway);
      }

      (0, _reactDom.unmountComponentAtNode)(this.layer);
      document.body.removeChild(this.layer);
      this.layer = null;
    }

    /**
     * By calling this method in componentDidMount() and
     * componentDidUpdate(), you're effectively creating a "wormhole" that
     * funnels React's hierarchical updates through to a DOM node on an
     * entirely different part of the page.
     */

  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          render = _props.render;


      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          document.body.appendChild(this.layer);

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
          } else {
            setTimeout(function () {
              window.addEventListener('click', _this2.onClickAway);
            }, 0);
          }
        }

        var layerElement = render();
        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return RenderToLayer;
}(_react.Component);

RenderToLayer.defaultProps = {
  useLayerForClickAway: true
};
RenderToLayer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RenderToLayer.propTypes =  false ? {
  componentClickAway: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  render: _propTypes2.default.func.isRequired,
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = RenderToLayer;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.Menu = undefined;

var _Menu2 = __webpack_require__(269);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(164);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _Menu3.default;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(266);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  (0, _inherits3.default)(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.element,
  onClickAway: _propTypes2.default.func
} : {};
exports.default = ClickAwayListener;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(957);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var hasSubheader = false;

      var firstChild = _react.Children.toArray(children)[0];
      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
        hasSubheader = true;
      }

      var styles = {
        root: {
          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
        }
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return List;
}(_react.Component);

List.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
List.propTypes =  false ? {
  /**
   * These are usually `ListItem`s that are passed to
   * be part of the list.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = List;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _AutoLockScrolling = __webpack_require__(969);

var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var overlay = context.muiTheme.overlay;


  var style = {
    root: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: 0,
      left: '-100%',
      opacity: 0,
      backgroundColor: overlay.backgroundColor,
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)

      // Two ways to promote overlay to its own render layer
      willChange: 'opacity',
      transform: 'translateZ(0)',

      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    }
  };

  if (props.show) {
    (0, _simpleAssign2.default)(style.root, {
      left: 0,
      opacity: 1,
      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    });
  }

  return style;
}

var Overlay = function (_Component) {
  (0, _inherits3.default)(Overlay, _Component);

  function Overlay() {
    (0, _classCallCheck3.default)(this, Overlay);
    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(Overlay, [{
    key: 'setOpacity',
    value: function setOpacity(opacity) {
      this.refs.overlay.style.opacity = opacity;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoLockScrolling = _props.autoLockScrolling,
          show = _props.show,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
      );
    }
  }]);
  return Overlay;
}(_react.Component);

Overlay.defaultProps = {
  autoLockScrolling: true,
  style: {},
  transitionEnabled: true
};
Overlay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Overlay.propTypes =  false ? {
  autoLockScrolling: _propTypes2.default.bool,
  show: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  transitionEnabled: _propTypes2.default.bool
} : {};
exports.default = Overlay;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeAboutDialog = exports.openAboutDialog = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openAboutDialog = exports.openAboutDialog = function openAboutDialog() {
    return {
        type: types.ABOUT_DIALOG_OPEN
    };
};

var closeAboutDialog = exports.closeAboutDialog = function closeAboutDialog() {
    return {
        type: types.ABOUT_DIALOG_CLOSE
    };
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _Card2 = __webpack_require__(985);

var _Card3 = _interopRequireDefault(_Card2);

var _CardHeader2 = __webpack_require__(988);

var _CardHeader3 = _interopRequireDefault(_CardHeader2);

var _CardTitle2 = __webpack_require__(991);

var _CardTitle3 = _interopRequireDefault(_CardTitle2);

var _CardMedia2 = __webpack_require__(992);

var _CardMedia3 = _interopRequireDefault(_CardMedia2);

var _CardText2 = __webpack_require__(993);

var _CardText3 = _interopRequireDefault(_CardText2);

var _CardActions2 = __webpack_require__(994);

var _CardActions3 = _interopRequireDefault(_CardActions2);

var _CardExpandable2 = __webpack_require__(631);

var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Card = _Card3.default;
exports.CardHeader = _CardHeader3.default;
exports.CardTitle = _CardTitle3.default;
exports.CardMedia = _CardMedia3.default;
exports.CardText = _CardText3.default;
exports.CardActions = _CardActions3.default;
exports.CardExpandable = _CardExpandable3.default;
exports.default = _Card3.default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyboardArrowUp = __webpack_require__(986);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardArrowDown = __webpack_require__(987);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      top: 0,
      bottom: 0,
      right: 4,
      margin: 'auto',
      position: 'absolute'
    }
  };
}

var CardExpandable = function (_Component) {
  (0, _inherits3.default)(CardExpandable, _Component);

  function CardExpandable() {
    (0, _classCallCheck3.default)(this, CardExpandable);
    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardExpandable, [{
    key: 'render',
    value: function render() {
      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _IconButton2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          onClick: this.props.onExpanding,
          iconStyle: this.props.iconStyle
        },
        this.props.expanded ? this.props.openIcon : this.props.closeIcon
      );
    }
  }]);
  return CardExpandable;
}(_react.Component);

CardExpandable.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardExpandable.defaultProps = {
  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
};
CardExpandable.propTypes =  false ? {
  closeIcon: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  onExpanding: _propTypes2.default.func.isRequired,
  openIcon: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = CardExpandable;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Slider = __webpack_require__(1001);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    container: {
        float: 'left',
        width: 100,
        marginBottom: 0
    },
    slider: {
        margin: 8
    }
};

var OpacitySlider = function OpacitySlider(_ref) {
    var opacity = _ref.opacity,
        _onChange = _ref.onChange;
    return _react2.default.createElement(_Slider2.default, {
        defaultValue: opacity,
        onChange: function onChange(evt, opacity) {
            return _onChange(opacity);
        },
        style: styles.container,
        sliderStyle: styles.slider
    });
};

OpacitySlider.propTypes = {
    opacity: _propTypes2.default.number.isRequired,
    onChange: _propTypes2.default.func.isRequired
};

exports.default = OpacitySlider;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegendItem = function LegendItem(_ref) {
    var image = _ref.image,
        color = _ref.color,
        radius = _ref.radius,
        name = _ref.name,
        startValue = _ref.startValue,
        endValue = _ref.endValue,
        count = _ref.count;

    if (!name && startValue === undefined) {
        return null;
    }

    var symbol = {
        backgroundImage: image ? 'url(' + image + ')' : 'none',
        backgroundColor: color ? color : 'transparent'
    };

    if (radius) {
        symbol.width = radius * 2 + 'px';
        symbol.height = radius * 2 + 'px';
        symbol.borderRadius = radius ? '50%' : '0';
    }

    return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement('span', { style: symbol })
        ),
        _react2.default.createElement(
            'td',
            null,
            name,
            ' ',
            isNaN(startValue) ? '' : startValue + ' - ' + endValue + ' (' + count + ')'
        )
    );
};

LegendItem.propTypes = {
    image: _propTypes2.default.string,
    color: _propTypes2.default.string,
    radius: _propTypes2.default.number,
    name: _propTypes2.default.string,
    range: _propTypes2.default.string
};

exports.default = LegendItem;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1017);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./Legend.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./Legend.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openLayersPanel = exports.closeLayersPanel = exports.resizeScreen = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var resizeScreen = exports.resizeScreen = function resizeScreen(width, height) {
    return {
        type: types.SCREEN_RESIZE,
        width: width,
        height: height
    };
};

var closeLayersPanel = exports.closeLayersPanel = function closeLayersPanel(id) {
    return {
        type: types.LAYERS_PANEL_CLOSE
    };
};

var openLayersPanel = exports.openLayersPanel = function openLayersPanel() {
    return {
        type: types.LAYERS_PANEL_OPEN
    };
};

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(1036);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurerCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(1038);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return __WEBPACK_IMPORTED_MODULE_3__Collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(1045);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["accessibilityOverscanIndicesGetter"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["defaultCellRangeRenderer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["defaultOverscanIndicesGetter"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["Grid"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(1047);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_7__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(1053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMasonryCellPositioner", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Masonry", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(1065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(1068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return __WEBPACK_IMPORTED_MODULE_10__ScrollSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(1070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTableMultiSort", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortDirection", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(1073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return __WEBPACK_IMPORTED_MODULE_12__WindowScroller__["a"]; });














/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);






var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_ScrollIndices = __webpack_require__(1035).babelPluginFlowReactPropTypes_proptype_ScrollIndices || __webpack_require__(1).any;



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call(this, props));

    _this._columnStartIndex = 0;
    _this._columnStopIndex = 0;
    _this._rowStartIndex = 0;
    _this._rowStopIndex = 0;

    _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    };

    _this._onSectionRendered = function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    };

    _this.state = {
      scrollToColumn: props.scrollToColumn,
      scrollToRow: props.scrollToRow
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isControlled) {
        return;
      }

      var scrollToColumn = nextProps.scrollToColumn,
          scrollToRow = nextProps.scrollToRow;
      var _props = this.props,
          prevScrollToColumn = _props.scrollToColumn,
          prevScrollToRow = _props.scrollToRow;


      if (prevScrollToColumn !== scrollToColumn && prevScrollToRow !== scrollToRow) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      } else if (prevScrollToColumn !== scrollToColumn) {
        this.setState({ scrollToColumn: scrollToColumn });
      } else if (prevScrollToRow !== scrollToRow) {
        this.setState({ scrollToRow: scrollToRow });
      }
    }
  }, {
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _props3 = this.props,
          isControlled = _props3.isControlled,
          onScrollToChange = _props3.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: require('prop-types').func.isRequired,
  className: require('prop-types').string,
  columnCount: require('prop-types').number.isRequired,
  disabled: require('prop-types').bool.isRequired,
  isControlled: require('prop-types').bool.isRequired,
  mode: require('prop-types').oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: require('prop-types').func,
  rowCount: require('prop-types').number.isRequired,
  scrollToColumn: require('prop-types').number.isRequired,
  scrollToRow: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultCellRangeRenderer__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__ = __webpack_require__(238);







var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellRangeRenderer || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellRenderer = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellRenderer || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId = __webpack_require__(238).babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId || __webpack_require__(1).any;












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null
    };
    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._cellCache = {};
    _this._styleCache = {};
    _this._scrollbarSizeMeasured = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      _this._resetStyleCache();
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  // See defaultCellRangeRenderer() for more information on the usage of these caches


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;


      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = getScrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        this.scrollToPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getScrollbarSize = this.props.getScrollbarSize;

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()

      this._scrollbarSize = getScrollbarSize();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var _state2 = this.state,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;


      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
        this.scrollToPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this.scrollToPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      var _props6 = this.props,
          columnCount = _props6.columnCount,
          rowCount = _props6.rowCount;

      // Special case when either cols or rows were 0
      // This would prevent any cells from rendering
      // So we need to reset row scroll if cols changed from 0 (and vice versa)

      if (columnCount === 0 || rowCount === 0) {
        columnCount = 0;
        rowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
        this._resetStyleCache();
      }

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: columnCount,
        cellSize: typeof this.props.columnWidth === 'number' ? this.props.columnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: rowCount,
        cellSize: typeof this.props.rowHeight === 'number' ? this.props.rowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
        }
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          autoContainerWidth = _props7.autoContainerWidth,
          autoHeight = _props7.autoHeight,
          autoWidth = _props7.autoWidth,
          className = _props7.className,
          containerProps = _props7.containerProps,
          containerRole = _props7.containerRole,
          containerStyle = _props7.containerStyle,
          height = _props7.height,
          id = _props7.id,
          noContentRenderer = _props7.noContentRenderer,
          role = _props7.role,
          style = _props7.style,
          tabIndex = _props7.tabIndex,
          width = _props7.width;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          scrollLeft = state.scrollLeft,
          scrollTop = state.scrollTop;


      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                this._columnStartIndex = 0;
                this._columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                this._rowStartIndex = 0;
                this._rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          parent: this,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["requestAnimationTimeout"])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */

  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this4 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props8 = _this4.props,
              height = _props8.height,
              onScroll = _props8.onScroll,
              width = _props8.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this._scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount,
          height = props.height,
          scrollToAlignment = props.scrollToAlignment,
          scrollToColumn = props.scrollToColumn,
          width = props.width;
      var scrollLeft = state.scrollLeft;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;

        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollLeft = state.scrollLeft;

      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        this.scrollToPosition({
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height,
          rowCount = props.rowCount,
          scrollToAlignment = props.scrollToAlignment,
          scrollToRow = props.scrollToRow,
          width = props.width;
      var scrollTop = state.scrollTop;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollTop = state.scrollTop;

      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        this.scrollToPosition({
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize___default.a,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0
};
Grid.propTypes =  true ? null : {
  "aria-label": require('prop-types').string.isRequired,
  "aria-readonly": require('prop-types').bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: require('prop-types').bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: require('prop-types').bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: require('prop-types').bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRenderer).isRequired,


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRangeRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRangeRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRangeRenderer).isRequired,


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: require('prop-types').string,


  /** Number of columns in grid.  */
  columnCount: require('prop-types').number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Unfiltered props for the Grid container. */
  containerProps: require('prop-types').object,


  /** ARIA role for the cell-container.  */
  containerRole: require('prop-types').string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: require('prop-types').object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: require('prop-types').object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: require('prop-types').number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: require('prop-types').number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: require('prop-types').func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: require('prop-types').number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: require('prop-types').string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: require('prop-types').bool,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: require('prop-types').func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: require('prop-types').func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: require('prop-types').func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: require('prop-types').number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: require('prop-types').number.isRequired,


  /** ARIA role for the grid element.  */
  role: require('prop-types').string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Number of rows in grid.  */
  rowCount: require('prop-types').number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: require('prop-types').number.isRequired,


  /** Horizontal offset. */
  scrollLeft: require('prop-types').number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: require('prop-types').number.isRequired,


  /** Vertical offset. */
  scrollTop: require('prop-types').number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: require('prop-types').number.isRequired,


  /** Optional inline style */
  style: require('prop-types').object.isRequired,


  /** Tab index for focus */
  tabIndex: require('prop-types').number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(1).any;

var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams || __webpack_require__(1).any;

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(1033);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(643);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: require('prop-types').func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: require('prop-types').string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: require('prop-types').number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: require('prop-types').number,


  /** Disable dynamic :height property */
  disableHeight: require('prop-types').bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: require('prop-types').bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: require('prop-types').string,


  /** Callback to be invoked on-resize */
  onResize: require('prop-types').func.isRequired,


  /** Optional inline style */
  style: require('prop-types').object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);








var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellRendererParams = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_CellRendererParams || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(540).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_RenderedRows = __webpack_require__(540).babelPluginFlowReactPropTypes_proptype_RenderedRows || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_RowRenderer = __webpack_require__(540).babelPluginFlowReactPropTypes_proptype_RowRenderer || __webpack_require__(1).any;





/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["accessibilityOverscanIndicesGetter"],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": require('prop-types').string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: require('prop-types').bool.isRequired,


  /** Optional CSS class name */
  className: require('prop-types').string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: require('prop-types').number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: require('prop-types').number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: require('prop-types').func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: require('prop-types').func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: require('prop-types').number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: typeof babelPluginFlowReactPropTypes_proptype_RowRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_RowRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_RowRenderer).isRequired,


  /** Number of rows in list. */
  rowCount: require('prop-types').number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: require('prop-types').number.isRequired,


  /** Vertical offset. */
  scrollTop: require('prop-types').number,


  /** Optional inline style */
  style: require('prop-types').object.isRequired,


  /** Tab index for focus */
  tabIndex: require('prop-types').number,


  /** Width of list */
  width: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
var babelPluginFlowReactPropTypes_proptype_CellDataGetterParams = __webpack_require__(239).babelPluginFlowReactPropTypes_proptype_CellDataGetterParams || __webpack_require__(1).any;

function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
var babelPluginFlowReactPropTypes_proptype_CellRendererParams = __webpack_require__(239).babelPluginFlowReactPropTypes_proptype_CellRendererParams || __webpack_require__(1).any;

function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams = __webpack_require__(239).babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams || __webpack_require__(1).any;

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams;

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(651);



/**
 * Default table header renderer.
 */
var babelPluginFlowReactPropTypes_proptype_HeaderRendererParams = __webpack_require__(239).babelPluginFlowReactPropTypes_proptype_HeaderRendererParams || __webpack_require__(1).any;

function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_HeaderRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HeaderRendererParams;

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(275);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



/**
 * Default row renderer for Table.
 */
var babelPluginFlowReactPropTypes_proptype_RowRendererParams = __webpack_require__(239).babelPluginFlowReactPropTypes_proptype_RowRendererParams || __webpack_require__(1).any;

function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_RowRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_RowRendererParams;

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(275);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(643);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var scrollElement = this.props.scrollElement;
      var nextScrollElement = nextProps.scrollElement;

      if (scrollElement !== nextScrollElement && scrollElement && nextScrollElement) {
        this.updatePosition(nextScrollElement, nextProps);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, nextScrollElement);

        this._unregisterResizeListener(scrollElement);
        this._registerResizeListener(nextScrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: require('prop-types').func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: require('prop-types').func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: require('prop-types').func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: require('prop-types').oneOfType([require('prop-types').any, typeof Element === 'function' ? require('prop-types').instanceOf(Element) : require('prop-types').any]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: require('prop-types').number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: require('prop-types').number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SelectField = __webpack_require__(1083);

var _SelectField2 = _interopRequireDefault(_SelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SelectField2.default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
  );
};
NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
NavigationArrowDropDown.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDown;

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(1094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgramSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _programs = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgramSelect = exports.ProgramSelect = function (_Component) {
    _inherits(ProgramSelect, _Component);

    function ProgramSelect() {
        _classCallCheck(this, ProgramSelect);

        return _possibleConstructorReturn(this, (ProgramSelect.__proto__ || Object.getPrototypeOf(ProgramSelect)).apply(this, arguments));
    }

    _createClass(ProgramSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                programs = _props.programs,
                loadPrograms = _props.loadPrograms;


            if (!programs) {
                loadPrograms();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                program = _props2.program,
                programs = _props2.programs,
                onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Program'),
                loading: programs ? false : true,
                items: programs,
                value: program ? program.id : null,
                onChange: onChange,
                style: style,
                errorText: !program && errorText ? errorText : null
            });
        }
    }]);

    return ProgramSelect;
}(_react.Component);

ProgramSelect.propTypes = {
    program: _propTypes2.default.object,
    programs: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programs: state.programs
    };
}, { loadPrograms: _programs.loadPrograms })(ProgramSelect);

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CircularProgress = __webpack_require__(1108);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CircularProgress2.default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _periods = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var periods = void 0;

var RelativePeriodSelect = function RelativePeriodSelect(_ref) {
    var startEndDates = _ref.startEndDates,
        period = _ref.period,
        onChange = _ref.onChange,
        style = _ref.style,
        errorText = _ref.errorText;

    var value = period ? period.id : null;

    if (!periods) {
        // Create periods array on first run
        periods = (startEndDates ? [{
            // Used in event layer dialog
            id: 'START_END_DATES',
            name: 'Start/end dates'
        }] : []).concat(_periods.relativePeriods).map(function (_ref2) {
            var id = _ref2.id,
                name = _ref2.name;
            return {
                id: id,
                name: _i18next2.default.t(name) // Translate period names
            };
        });
    }

    return _react2.default.createElement(_SelectField2.default, {
        label: _i18next2.default.t('Period'),
        items: periods,
        value: value,
        onChange: onChange,
        style: style,
        errorText: !value && errorText ? errorText : null
    });
};

RelativePeriodSelect.propTypes = {
    startEndDates: _propTypes2.default.bool,
    period: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string
    }),
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};

exports.default = RelativePeriodSelect;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DatePicker = __webpack_require__(1110);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _d3TimeFormat = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTime = (0, _d3TimeFormat.timeFormat)('%Y-%m-%d');

var DatePicker = function DatePicker(_ref) {
    var label = _ref.label,
        value = _ref.value,
        _onChange = _ref.onChange,
        style = _ref.style,
        textFieldStyle = _ref.textFieldStyle;
    return _react2.default.createElement(_DatePicker2.default, {
        floatingLabelText: label,
        onChange: function onChange(event, date) {
            return _onChange(formatTime(date));
        },
        value: value && value !== 'undefined' ? new Date(value) : null,
        style: style,
        textFieldStyle: textFieldStyle
    });
};

DatePicker.propTypes = {
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    textFieldStyle: _propTypes2.default.object
};

exports.default = DatePicker;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataItemSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _analytics = __webpack_require__(32);

var _programs = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataItemSelect = exports.DataItemSelect = function (_Component) {
    _inherits(DataItemSelect, _Component);

    function DataItemSelect() {
        _classCallCheck(this, DataItemSelect);

        return _possibleConstructorReturn(this, (DataItemSelect.__proto__ || Object.getPrototypeOf(DataItemSelect)).apply(this, arguments));
    }

    _createClass(DataItemSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadDataItems();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadDataItems();
        }

        // TODO: Make sure data load is only triggered once

    }, {
        key: 'loadDataItems',
        value: function loadDataItems() {
            var _props = this.props,
                program = _props.program,
                programStage = _props.programStage,
                programAttributes = _props.programAttributes,
                dataElements = _props.dataElements,
                loadProgramTrackedEntityAttributes = _props.loadProgramTrackedEntityAttributes,
                loadProgramStageDataElements = _props.loadProgramStageDataElements;


            if (program && !programAttributes[program.id]) {
                loadProgramTrackedEntityAttributes(program.id);
            }

            if (programStage && !dataElements[programStage.id]) {
                loadProgramStageDataElements(programStage.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                label = _props2.label,
                value = _props2.value,
                program = _props2.program,
                programStage = _props2.programStage,
                programAttributes = _props2.programAttributes,
                dataElements = _props2.dataElements,
                onChange = _props2.onChange,
                style = _props2.style;


            if (!program) {
                return null;
            }

            var dataItems = (0, _analytics.combineDataItems)(programAttributes[program.id], programStage ? dataElements[programStage.id] : [], ['FILE_RESOURCE', 'ORGANISATION_UNIT', 'COORDINATE'] // Exclude some value types
            );

            return _react2.default.createElement(_SelectField2.default, {
                label: label || _i18next2.default.t('Data item'),
                items: dataItems,
                value: value,
                onChange: onChange,
                style: style
            });
        }
    }]);

    return DataItemSelect;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programAttributes: state.programTrackedEntityAttributes,
        dataElements: state.programStageDataElements
    };
}, { loadProgramTrackedEntityAttributes: _programs.loadProgramTrackedEntityAttributes, loadProgramStageDataElements: _programs.loadProgramStageDataElements })(DataItemSelect);

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Checkbox = __webpack_require__(1125);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(528);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(614);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      position: 'relative',
      overflow: 'visible',
      display: 'table',
      height: 'auto',
      width: '100%'
    },
    input: {
      position: 'absolute',
      cursor: 'inherit',
      pointerEvents: 'all',
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      left: 0,
      boxSizing: 'border-box',
      padding: 0,
      margin: 0
    },
    controls: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    label: {
      float: 'left',
      position: 'relative',
      display: 'block',
      width: 'calc(100% - 60px)',
      lineHeight: '24px',
      color: baseTheme.palette.textColor,
      fontFamily: baseTheme.fontFamily
    },
    wrap: {
      transition: _transitions2.default.easeOut(),
      float: 'left',
      position: 'relative',
      display: 'block',
      flexShrink: 0,
      width: 60 - baseTheme.spacing.desktopGutterLess,
      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
    },
    ripple: {
      color: props.rippleColor || baseTheme.palette.primary1Color,
      height: '200%',
      width: '200%',
      top: -12,
      left: -12
    }
  };
}

var EnhancedSwitch = function (_Component) {
  (0, _inherits3.default)(EnhancedSwitch, _Component);

  function EnhancedSwitch() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedSwitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleChange = function (event) {
      _this.tabPressed = false;
      _this.setState({
        isKeyboardFocused: false
      });

      var isInputChecked = _this.refs.checkbox.checked;

      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
        _this.props.onParentShouldUpdate(isInputChecked);
      }

      if (_this.props.onSwitch) {
        _this.props.onSwitch(event, isInputChecked);
      }
    }, _this.handleKeyDown = function (event) {
      var code = (0, _keycode2.default)(event);

      if (code === 'tab') {
        _this.tabPressed = true;
      }
      if (_this.state.isKeyboardFocused && code === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.refs.touchRipple.start(event);
      }
    }, _this.handleMouseUp = function () {
      _this.refs.touchRipple.end();
    }, _this.handleMouseLeave = function () {
      _this.refs.touchRipple.end();
    }, _this.handleTouchStart = function (event) {
      _this.refs.touchRipple.start(event);
    }, _this.handleTouchEnd = function () {
      _this.refs.touchRipple.end();
    }, _this.handleBlur = function (event) {
      _this.setState({
        isKeyboardFocused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      // setTimeout is needed becuase the focus event fires first
      // Wait so that we can capture if this was a keyboard focus
      // or touch focus
      setTimeout(function () {
        if (_this.tabPressed) {
          _this.setState({
            isKeyboardFocused: true
          });
        }
      }, 150);

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedSwitch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inputNode = this.refs.checkbox;
      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
        this.props.onParentShouldUpdate(inputNode.checked);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasCheckedProp = nextProps.hasOwnProperty('checked');
      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;

      if (hasCheckedProp || hasNewDefaultProp) {
        var switched = nextProps.checked || nextProps.defaultChecked || false;

        this.setState({
          switched: switched
        });

        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
          this.props.onParentShouldUpdate(switched);
        }
      }
    }
  }, {
    key: 'isSwitched',
    value: function isSwitched() {
      return this.refs.checkbox.checked;
    }

    // no callback here because there is no event

  }, {
    key: 'setSwitched',
    value: function setSwitched(newSwitchedValue) {
      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
        if (this.props.onParentShouldUpdate) {
          this.props.onParentShouldUpdate(newSwitchedValue);
        }
        this.refs.checkbox.checked = newSwitchedValue;
      } else {
         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.checkbox.value;
    }

    // Checkbox inputs only use SPACE to change their state. Using ENTER will
    // update the ui but not the input.


    /**
     * Because both the ripples and the checkbox input cannot share pointer
     * events, the checkbox input takes control of pointer events and calls
     * ripple animations manually.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          value = _props.value,
          checked = _props.checked,
          iconStyle = _props.iconStyle,
          inputStyle = _props.inputStyle,
          inputType = _props.inputType,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          onSwitch = _props.onSwitch,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onParentShouldUpdate = _props.onParentShouldUpdate,
          disabled = _props.disabled,
          disableTouchRipple = _props.disableTouchRipple,
          disableFocusRipple = _props.disableFocusRipple,
          className = _props.className,
          rippleColor = _props.rippleColor,
          rippleStyle = _props.rippleStyle,
          style = _props.style,
          switched = _props.switched,
          switchElement = _props.switchElement,
          thumbStyle = _props.thumbStyle,
          trackStyle = _props.trackStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

      if (thumbStyle) {
        wrapStyles.marginLeft /= 2;
        wrapStyles.marginRight /= 2;
      }

      var labelElement = label && _react2.default.createElement(
        'label',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
        label
      );

      var showTouchRipple = !disabled && !disableTouchRipple;
      var showFocusRipple = !disabled && !disableFocusRipple;

      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
        ref: 'touchRipple',
        key: 'touchRipple',
        style: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        centerRipple: true
      });

      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
        key: 'focusRipple',
        innerStyle: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        show: this.state.isKeyboardFocused
      });

      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];

      var touchHandlers = showTouchRipple ? {
        onMouseUp: this.handleMouseUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};

      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
        ref: 'checkbox',
        type: inputType,
        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
        name: name,
        value: value,
        checked: this.state.switched,
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange
      }, touchHandlers));

      // If toggle component (indicated by whether the style includes thumb) manually lay out
      // elements in order to nest ripple elements
      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        switchElement,
        ripples
      ) : _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
        _react2.default.createElement(
          _Paper2.default,
          { style: thumbStyle, zDepth: 1, circle: true },
          ' ',
          ripples,
          ' '
        )
      );

      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
        'div',
        { style: styles.controls },
        switchOrThumbElement,
        labelElement
      ) : _react2.default.createElement(
        'div',
        { style: styles.controls },
        labelElement,
        switchOrThumbElement
      );

      return _react2.default.createElement(
        'div',
        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp
        }),
        inputElement,
        elementsInOrder
      );
    }
  }]);
  return EnhancedSwitch;
}(_react.Component);

EnhancedSwitch.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedSwitch.propTypes =  false ? {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  disableFocusRipple: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  inputStyle: _propTypes2.default.object,
  inputType: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.node,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelStyle: _propTypes2.default.object,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onParentShouldUpdate: _propTypes2.default.func,
  onSwitch: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  rippleColor: _propTypes2.default.string,
  rippleStyle: _propTypes2.default.object,
  style: _propTypes2.default.object,
  switchElement: _propTypes2.default.element.isRequired,
  switched: _propTypes2.default.bool.isRequired,
  thumbStyle: _propTypes2.default.object,
  trackStyle: _propTypes2.default.object,
  value: _propTypes2.default.any
} : {};
exports.default = EnhancedSwitch;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(1147);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = undefined;

var _each = __webpack_require__(1156);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(1158);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
    var checked = 0;
    var passed = 0;
    (0, _each2.default)(keysToCheck, function (letter) {
      if (data[letter]) {
        checked += 1;
        if (!isNaN(data[letter])) {
          passed += 1;
        }
      }
    });
    return checked === passed ? data : false;
  },
  toState: function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;

    return {
      hsl: hsl,
      hex: transparent ? 'transparent' : '#' + hex,
      rgb: rgb,
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  },
  isValidHex: function isValidHex(hex) {
    return (0, _tinycolor2.default)(hex).isValid();
  }
};
var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _range = __webpack_require__(1164);

var _range2 = _interopRequireDefault(_range);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _ColorScaleSelect = __webpack_require__(670);

var _ColorScaleSelect2 = _interopRequireDefault(_ColorScaleSelect);

var _layerEdit = __webpack_require__(60);

var _layers = __webpack_require__(68);

var _colorscale = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    selectField: {
        width: '100%',
        top: -8
    },
    classes: {
        width: 60,
        marginRight: 16,
        top: -8,
        float: 'left'
    },
    scale: {
        float: 'left',
        width: 200
    }
};

var classRange = (0, _range2.default)(3, 10).map(function (num) {
    return { id: num, name: num.toString() };
}); // 3 - 9

// TODO: Refactoring
var Classification = function Classification(_ref) {
    var method = _ref.method,
        classes = _ref.classes,
        colorScale = _ref.colorScale,
        setClassification = _ref.setClassification,
        setColorScale = _ref.setColorScale,
        style = _ref.style;

    var colorScaleName = colorScale ? (0, _colorscale.getColorScale)(colorScale) : _colorscale.defaultColorScaleName;

    return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(_SelectField2.default, {
            label: _i18next2.default.t('Classification'),
            value: method || 2,
            items: _layers.classificationTypes.map(function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name;
                return {
                    id: id,
                    name: _i18next2.default.t(name)
                };
            }),
            onChange: function onChange(method) {
                return setClassification(method.id);
            },
            style: styles.selectField
        }),
        _react2.default.createElement(
            'div',
            { style: styles.selectField },
            _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Classes'),
                value: classes !== undefined ? classes : _colorscale.defaultClasses,
                items: classRange,
                onChange: function onChange(item) {
                    return setColorScale((0, _colorscale.getColorPalette)(colorScaleName, item.id));
                },
                style: styles.classes
            }),
            _react2.default.createElement(_ColorScaleSelect2.default, {
                palette: colorScale ? colorScale : _colorscale.defaultColorScale,
                onChange: setColorScale,
                style: styles.scale
            })
        )
    );
};

exports.default = (0, _reactRedux.connect)(null, { setClassification: _layerEdit.setClassification, setColorScale: _layerEdit.setColorScale })(Classification);

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ColorScale = __webpack_require__(1168);

var _ColorScale2 = _interopRequireDefault(_ColorScale);

var _Popover = __webpack_require__(163);

var _Popover2 = _interopRequireDefault(_Popover);

var _colorscale = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import PropTypes from 'prop-types';


var styles = {
    scale: {
        marginTop: 19,
        overflow: 'visible',
        whiteSpace: 'nowrap'
    },
    popover: {
        height: '100%',
        whiteSpace: 'nowrap'
    },
    scaleItem: {
        display: 'block',
        margin: '5px 12px 0 12px',
        overflow: 'visible',
        background: 'yellow',
        whiteSpace: 'nowrap'
    }
};

var ColorScaleSelect = function (_Component) {
    _inherits(ColorScaleSelect, _Component);

    function ColorScaleSelect() {
        var _ref;

        _classCallCheck(this, ColorScaleSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ColorScaleSelect.__proto__ || Object.getPrototypeOf(ColorScaleSelect)).call.apply(_ref, [this].concat(args)));

        _this.showColorScales = function (event) {
            _this.setState({
                open: true,
                anchorEl: event.currentTarget
            });
        };

        _this.onColorScaleSelect = function (event, scale) {
            var _this$props = _this.props,
                palette = _this$props.palette,
                onChange = _this$props.onChange;

            var classes = palette.split(',').length;

            onChange((0, _colorscale.getColorPalette)(scale, classes));
            _this.hideColorScales();
        };

        _this.state = {
            open: false,
            anchorEl: null
        };
        return _this;
    }

    // Show popover with allowed color scales


    _createClass(ColorScaleSelect, [{
        key: 'hideColorScales',
        value: function hideColorScales() {
            this.setState({
                open: false
            });
        }

        // Called when a new color scale is selected in the popover

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                palette = _props.palette,
                style = _props.style;

            var classes = palette.split(',').length;
            var scale = (0, _colorscale.getColorScale)(palette);

            return _react2.default.createElement(
                'div',
                { style: style },
                _react2.default.createElement(_ColorScale2.default, {
                    classes: classes,
                    scale: scale,
                    onClick: this.showColorScales,
                    style: styles.scale
                }),
                _react2.default.createElement(
                    _Popover2.default,
                    {
                        style: styles.popover,
                        open: this.state.open,
                        anchorEl: this.state.anchorEl,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        onRequestClose: function onRequestClose() {
                            return _this2.hideColorScales();
                        }
                    },
                    _colorscale.colorScales.map(function (scale, index) {
                        return _react2.default.createElement(_ColorScale2.default, {
                            key: index,
                            scale: scale,
                            classes: classes,
                            style: styles.scaleItem,
                            onClick: _this2.onColorScaleSelect
                        });
                    })
                )
            );
        }
    }]);

    return ColorScaleSelect;
}(_react.Component);

exports.default = ColorScaleSelect;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('once', __webpack_require__(1170), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var aggregationTypes = exports.aggregationTypes = [{ id: 'DEFAULT', name: 'By data element' }, { id: 'COUNT', name: 'Count' }, { id: 'AVERAGE', name: 'Average' }, { id: 'SUM', name: 'Sum' }, { id: 'STDDEV', name: 'Standard deviation' }, { id: 'VARIANCE', name: 'Variance' }, { id: 'MIN', name: 'Min' }, { id: 'MAX', name: 'Max' }];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;

var _RadioButton2 = __webpack_require__(674);

var _RadioButton3 = _interopRequireDefault(_RadioButton2);

var _RadioButtonGroup2 = __webpack_require__(1195);

var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RadioButton = _RadioButton3.default;
exports.RadioButtonGroup = _RadioButtonGroup3.default;
exports.default = _RadioButton3.default;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedSwitch = __webpack_require__(665);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

var _radioButtonUnchecked = __webpack_require__(1193);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _radioButtonChecked = __webpack_require__(1194);

var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var radioButton = context.muiTheme.radioButton;


  return {
    icon: {
      height: radioButton.size,
      width: radioButton.size
    },
    target: {
      transition: _transitions2.default.easeOut(),
      position: 'absolute',
      opacity: 1,
      transform: 'scale(1)',
      fill: radioButton.borderColor
    },
    fill: {
      position: 'absolute',
      opacity: 1,
      transform: 'scale(0)',
      transformOrigin: '50% 50%',
      transition: _transitions2.default.easeOut(),
      fill: radioButton.checkedColor
    },
    targetWhenChecked: {
      opacity: 0,
      transform: 'scale(0)'
    },
    fillWhenChecked: {
      opacity: 1,
      transform: 'scale(1)'
    },
    targetWhenDisabled: {
      fill: radioButton.disabledColor
    },
    fillWhenDisabled: {
      fill: radioButton.disabledColor
    },
    label: {
      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
    },
    ripple: {
      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
    }
  };
}

var RadioButton = function (_Component) {
  (0, _inherits3.default)(RadioButton, _Component);

  function RadioButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
      if (_this.props.onCheck) {
        _this.props.onCheck(event, _this.props.value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // Only called when selected, not when unselected.


  (0, _createClass3.default)(RadioButton, [{
    key: 'isChecked',
    value: function isChecked() {
      return this.refs.enhancedSwitch.isSwitched();
    }

    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
    // RadioButton's checked value.

  }, {
    key: 'setChecked',
    value: function setChecked(newCheckedValue) {
      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.enhancedSwitch.getValue();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checkedIcon = _props.checkedIcon,
          checked = _props.checked,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          onCheck = _props.onCheck,
          uncheckedIcon = _props.uncheckedIcon,
          disabled = _props.disabled,
          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);


      var styles = getStyles(this.props, this.context);

      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);

      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);

      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });

      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });

      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
        ref: 'enhancedSwitch',
        inputType: 'radio',
        checked: checked,
        switched: checked,
        disabled: disabled,
        rippleColor: styles.ripple.color,
        iconStyle: mergedIconStyle,
        labelStyle: mergedLabelStyle,
        labelPosition: labelPosition,
        onSwitch: this.handleSwitch,
        switchElement: _react2.default.createElement(
          'div',
          null,
          uncheckedElement,
          checkedElement
        )
      }));
    }
  }]);
  return RadioButton;
}(_react.Component);

RadioButton.defaultProps = {
  checked: false,
  disabled: false,
  labelPosition: 'right'
};
RadioButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RadioButton.propTypes =  false ? {
  /**
   * @ignore
   * checked if true
   * Used internally by `RadioButtonGroup`.
   */
  checked: _propTypes2.default.bool,
  /**
   * The icon element to show when the radio button is checked.
   */
  checkedIcon: _propTypes2.default.element,
  /**
   * If true, the radio button is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * @ignore
   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
   * Where the label will be placed next to the radio button.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Override the inline-styles of the label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * @ignore
   * Callback function fired when the radio button is checked. Note that this
   * function will not be called if the radio button is part of a
   * radio button group: in this case, use the `onChange` property of
   * `RadioButtonGroup`.
   *
   * @param {object} event `change` event targeting the element.
   * @param {string} value The element's `value`.
   */
  onCheck: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The icon element to show when the radio button is unchecked.
   */
  uncheckedIcon: _propTypes2.default.element,
  /**
   * The value of the radio button.
   */
  value: _propTypes2.default.any
} : {};
exports.default = RadioButton;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _helpers = __webpack_require__(61);

var _periods = __webpack_require__(1202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    select: {
        width: 'calc(100% - 60px)'
    },
    stepper: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginTop: 40,
        marginLeft: 12
    },
    button: {
        backgroundColor: '#eee',
        width: 24,
        height: 24,
        padding: 0
    }
};

var PeriodSelect = function (_Component) {
    _inherits(PeriodSelect, _Component);

    function PeriodSelect(props) {
        _classCallCheck(this, PeriodSelect);

        var _this = _possibleConstructorReturn(this, (PeriodSelect.__proto__ || Object.getPrototypeOf(PeriodSelect)).call(this, props));

        _this.state = {
            year: new Date().getFullYear(),
            periods: null
        };

        _this.nextYear = function () {
            _this.changeYear(1);
        };

        _this.previousYear = function () {
            _this.changeYear(-1);
        };

        _this.changeYear = function (change) {
            var _this$props = _this.props,
                locale = _this$props.locale,
                periodType = _this$props.periodType;

            var year = _this.state.year + change;

            _this.setState({
                year: year,
                periods: (0, _periods.createPeriods)(locale, periodType, year)
            });
        };

        _this.periodIndex = null;
        return _this;
    }

    _createClass(PeriodSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setPeriods();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _props = this.props,
                periodType = _props.periodType,
                period = _props.period,
                onChange = _props.onChange;
            var _state = this.state,
                year = _state.year,
                periods = _state.periods;


            if (periodType !== prevProps.periodType) {
                this.setPeriods();
            } else if (periods && !period) {
                onChange((0, _helpers.filterFuturePeriods)(periods)[0]); // Autoselect most recent period
            }

            // Change period if year is changed (but keep period index)
            if (period && year !== prevState.year) {
                var periodIndex = prevState.periods.findIndex(function (item) {
                    return item.id === period.id;
                });
                onChange(periods[periodIndex]);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                periodType = _props2.periodType,
                period = _props2.period,
                onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;
            var periods = this.state.periods;

            var value = period ? period.id : null;

            return _react2.default.createElement(
                'div',
                { style: _extends({ height: 100 }, style) },
                _react2.default.createElement(_SelectField2.default, {
                    label: _i18next2.default.t('Period'),
                    items: periods,
                    value: value,
                    onChange: onChange,
                    style: styles.select,
                    errorText: !value && errorText ? errorText : null
                }),
                periodType && _react2.default.createElement(
                    'div',
                    { style: styles.stepper },
                    _react2.default.createElement(
                        _IconButton2.default,
                        {
                            tooltip: _i18next2.default.t('Previous year'),
                            onClick: this.previousYear,
                            style: styles.button,
                            disableTouchRipple: true
                        },
                        _react2.default.createElement(_SvgIcon2.default, { icon: 'ChevronLeft' })
                    ),
                    _react2.default.createElement(
                        _IconButton2.default,
                        {
                            tooltip: _i18next2.default.t('Next year'),
                            onClick: this.nextYear,
                            style: styles.button,
                            disableTouchRipple: true
                        },
                        _react2.default.createElement(_SvgIcon2.default, { icon: 'ChevronRight' })
                    )
                )
            );
        }
    }, {
        key: 'setPeriods',
        value: function setPeriods() {
            var _props3 = this.props,
                periodType = _props3.periodType,
                period = _props3.period,
                locale = _props3.locale;

            var periods = void 0;

            if (periodType) {
                periods = (0, _periods.createPeriods)(locale, periodType, this.state.year);
            } else if (period) {
                periods = [period]; // If period is loaded in favorite
            }

            this.setState({ periods: periods });
        }
    }]);

    return PeriodSelect;
}(_react.Component);

PeriodSelect.propTypes = {
    periodType: _propTypes2.default.string,
    period: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    }),
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        locale: state.userSettings.keyUiLocale
    };
})(PeriodSelect);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _loglevel = __webpack_require__(677);

var _loglevel2 = _interopRequireDefault(_loglevel);

var _d = __webpack_require__(19);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _debounce = __webpack_require__(678);

var _debounce2 = _interopRequireDefault(_debounce);

var _store = __webpack_require__(680);

var _store2 = _interopRequireDefault(_store);

var _Root = __webpack_require__(794);

var _Root2 = _interopRequireDefault(_Root);

var _i18n = __webpack_require__(553);

var _externalLayers = __webpack_require__(587);

var _user = __webpack_require__(1235);

var _ui = __webpack_require__(635);

var _favorites = __webpack_require__(270);

var _requests = __webpack_require__(255);

__webpack_require__(1236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_loglevel2.default.setLevel( true ? _loglevel2.default.levels.INFO : _loglevel2.default.levels.TRACE);

_store2.default.dispatch((0, _externalLayers.loadExternalLayers)());

(0, _d.getManifest)('manifest.webapp').then(function (manifest) {
    var baseUrl =  true ? manifest.getBaseUrl() : DHIS_CONFIG.baseUrl;
    _d.config.baseUrl = baseUrl + '/api/29';
    _d.config.context = manifest.activities.dhis; // Added temporarily for util/api.js

    _loglevel2.default.info('Loading: ' + manifest.name + ' v' + manifest.version);
    _loglevel2.default.info('Built ' + manifest.manifest_generated_at);

    // Include all API endpoints in use by this app
    _d.config.schemas = ['dataElement', 'dataElementGroup', 'dataSet', 'externalMapLayer', 'indicator', 'indicatorGroup', 'legendSet', 'map', 'optionSet', 'organisationUnit', 'organisationUnitGroup', 'organisationUnitGroupSet', 'organisationUnitLevel', 'program', 'programStage'];
}).then(_d.getUserSettings).then(function (userSettings) {
    _store2.default.dispatch((0, _user.setUserSettings)(userSettings));
    return userSettings;
}).then(_i18n.configI18n).then(_d.init).then(function (d2) {
    if (!d2.currentUser.authorities.has('F_SYSTEM_SETTING')) {
        document.write(_i18next2.default.t('Access denied'));
        return;
    }

    var mapId = (0, _requests.getUrlParameter)('id');
    if (mapId) {
        _store2.default.dispatch((0, _favorites.loadFavorite)(mapId));
    }

    (0, _reactDom.render)(_react2.default.createElement(_Root2.default, { d2: d2, store: _store2.default }), document.getElementById('app'));
}, function (err) {
    _loglevel2.default.error('Failed to initialize D2:', JSON.stringify(err));
    document.write('D2 initialization error: ' + err);
});

// Window resize listener: http://stackoverflow.com/questions/35073669/window-resize-react-redux
window.addEventListener('resize', (0, _debounce2.default)(150, function () {
    return _store2.default.dispatch((0, _ui.resizeScreen)(window.innerWidth, window.innerHeight));
}));

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('debounce', __webpack_require__(429));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(430);

var _reduxObservable = __webpack_require__(47);

var _reducers = __webpack_require__(719);

var _reducers2 = _interopRequireDefault(_reducers);

var _epics = __webpack_require__(766);

var _epics2 = _interopRequireDefault(_epics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)(_epics2.default);

var store = (0, _redux.createStore)(_reducers2.default, "production" === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), (0, _redux.applyMiddleware)(epicMiddleware));

exports.default = store;

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(685);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(683);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(559);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(687);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(690);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(691);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(83)(module)))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(560);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(561);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEpicMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_switchMap__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionsObservable__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EPIC_END__ = __webpack_require__(577);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var defaultAdapter = {
  input: function input(action$) {
    return action$;
  },
  output: function output(action$) {
    return action$;
  }
};

var defaultOptions = {
  adapter: defaultAdapter
};

function createEpicMiddleware(rootEpic) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  if (typeof rootEpic !== 'function') {
    throw new TypeError('You must provide a root Epic to createEpicMiddleware');
  }

  // even though we used default param, we need to merge the defaults
  // inside the options object as well in case they declare only some
  options = _extends({}, defaultOptions, options);
  var input$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
  var action$ = options.adapter.input(new __WEBPACK_IMPORTED_MODULE_3__ActionsObservable__["a" /* ActionsObservable */](input$));
  var epic$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
  var store = void 0;

  var epicMiddleware = function epicMiddleware(_store) {
    store = _store;

    return function (next) {
      var _context;

      (_context = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__["map"].call(epic$, function (epic) {
        var vault =  true ? store : {
          getState: store.getState,
          dispatch: function dispatch(action) {
            require('./utils/console').deprecate('calling store.dispatch() directly in your Epics is deprecated and will be removed. Instead, emit actions through the Observable your Epic returns.\n\n  https://goo.gl/WWNYSP');
            return store.dispatch(action);
          }
        };

        var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);

        if (!output$) {
          throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
        }

        return output$;
      }), __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_switchMap__["switchMap"]).call(_context, function (output$) {
        return options.adapter.output(output$);
      }).subscribe(function (action) {
        try {
          store.dispatch(action);
        } catch (err) {
          console.error(err);
        }
      });

      // Setup initial root epic
      epic$.next(rootEpic);

      return function (action) {
        var result = next(action);
        input$.next(action);
        return result;
      };
    };
  };

  epicMiddleware.replaceEpic = function (rootEpic) {
    // gives the previous root Epic a last chance
    // to do some clean up
    store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_4__EPIC_END__["a" /* EPIC_END */] });
    // switches to the new root Epic, synchronously terminating
    // the previous one
    epic$.next(rootEpic);
  };

  return epicMiddleware;
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(30);
var Subscriber_1 = __webpack_require__(99);
var Subscription_1 = __webpack_require__(432);
var ObjectUnsubscribedError_1 = __webpack_require__(702);
var SubjectSubscription_1 = __webpack_require__(703);
var rxSubscriber_1 = __webpack_require__(433);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(99);
var rxSubscriber_1 = __webpack_require__(433);
var Observer_1 = __webpack_require__(566);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(565);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__(701);
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(432);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMap_1 = __webpack_require__(706);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return switchMap_1.switchMap(project, resultSelector)(this);
}
exports.switchMap = switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(568);
var subscribeToResult_1 = __webpack_require__(569);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new SwitchMapOperator(project, resultSelector));
    };
}
exports.switchMap = switchMap;
var SwitchMapOperator = (function () {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapSubscriber = (function (_super) {
    __extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(436);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__(710);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(563);
var isArrayLike_1 = __webpack_require__(570);
var isPromise_1 = __webpack_require__(571);
var PromiseObservable_1 = __webpack_require__(711);
var IteratorObservable_1 = __webpack_require__(712);
var ArrayObservable_1 = __webpack_require__(436);
var ArrayLikeObservable_1 = __webpack_require__(713);
var iterator_1 = __webpack_require__(435);
var Observable_1 = __webpack_require__(30);
var observeOn_1 = __webpack_require__(714);
var observable_1 = __webpack_require__(434);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(138);
var Observable_1 = __webpack_require__(30);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(138);
var Observable_1 = __webpack_require__(30);
var iterator_1 = __webpack_require__(435);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(30);
var ScalarObservable_1 = __webpack_require__(573);
var EmptyObservable_1 = __webpack_require__(437);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
var Notification_1 = __webpack_require__(715);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
exports.filter = filter;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FilterSubscriber = (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=filter.js.map

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return combineEpics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_merge__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_merge__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/**
  Merges all epics into a single one.
 */
var combineEpics = function combineEpics() {
  for (var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++) {
    epics[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_merge__["merge"].apply(undefined, _toConsumableArray(epics.map(function (epic) {
      var output$ = epic.apply(undefined, args);
      if (!output$) {
        throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
      }
      return output$;
    })));
  };
};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(430);

var _alert = __webpack_require__(720);

var _alert2 = _interopRequireDefault(_alert);

var _basemaps = __webpack_require__(721);

var _basemaps2 = _interopRequireDefault(_basemaps);

var _contextMenu = __webpack_require__(722);

var _contextMenu2 = _interopRequireDefault(_contextMenu);

var _dataElements = __webpack_require__(723);

var _dataElements2 = _interopRequireDefault(_dataElements);

var _dataElementGroups = __webpack_require__(724);

var _dataElementGroups2 = _interopRequireDefault(_dataElementGroups);

var _dataElementOperands = __webpack_require__(725);

var _dataElementOperands2 = _interopRequireDefault(_dataElementOperands);

var _dataSets = __webpack_require__(726);

var _dataSets2 = _interopRequireDefault(_dataSets);

var _dataTable = __webpack_require__(727);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _earthEngine = __webpack_require__(728);

var _earthEngine2 = _interopRequireDefault(_earthEngine);

var _favorite = __webpack_require__(729);

var _favorite2 = _interopRequireDefault(_favorite);

var _layerEdit = __webpack_require__(730);

var _layerEdit2 = _interopRequireDefault(_layerEdit);

var _indicators = __webpack_require__(738);

var _indicators2 = _interopRequireDefault(_indicators);

var _indicatorGroups = __webpack_require__(739);

var _indicatorGroups2 = _interopRequireDefault(_indicatorGroups);

var _layers = __webpack_require__(740);

var _layers2 = _interopRequireDefault(_layers);

var _legendSets = __webpack_require__(741);

var _legendSets2 = _interopRequireDefault(_legendSets);

var _loading = __webpack_require__(742);

var _loading2 = _interopRequireDefault(_loading);

var _map = __webpack_require__(743);

var _map2 = _interopRequireDefault(_map);

var _message = __webpack_require__(750);

var _message2 = _interopRequireDefault(_message);

var _optionSets = __webpack_require__(751);

var _optionSets2 = _interopRequireDefault(_optionSets);

var _orgUnit = __webpack_require__(752);

var _orgUnit2 = _interopRequireDefault(_orgUnit);

var _orgUnitTree = __webpack_require__(753);

var _orgUnitTree2 = _interopRequireDefault(_orgUnitTree);

var _orgUnitGroups = __webpack_require__(754);

var _orgUnitGroups2 = _interopRequireDefault(_orgUnitGroups);

var _orgUnitGroupSets = __webpack_require__(755);

var _orgUnitGroupSets2 = _interopRequireDefault(_orgUnitGroupSets);

var _orgUnitLevels = __webpack_require__(756);

var _orgUnitLevels2 = _interopRequireDefault(_orgUnitLevels);

var _programs = __webpack_require__(757);

var _programs2 = _interopRequireDefault(_programs);

var _programDataElements = __webpack_require__(758);

var _programDataElements2 = _interopRequireDefault(_programDataElements);

var _programIndicators = __webpack_require__(759);

var _programIndicators2 = _interopRequireDefault(_programIndicators);

var _programStages = __webpack_require__(760);

var _programStages2 = _interopRequireDefault(_programStages);

var _programStageDataElements = __webpack_require__(761);

var _programStageDataElements2 = _interopRequireDefault(_programStageDataElements);

var _programTrackedEntityAttributes = __webpack_require__(762);

var _programTrackedEntityAttributes2 = _interopRequireDefault(_programTrackedEntityAttributes);

var _relocate = __webpack_require__(763);

var _relocate2 = _interopRequireDefault(_relocate);

var _ui = __webpack_require__(764);

var _ui2 = _interopRequireDefault(_ui);

var _userSettings = __webpack_require__(765);

var _userSettings2 = _interopRequireDefault(_userSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    alert: _alert2.default,
    basemaps: _basemaps2.default,
    contextMenu: _contextMenu2.default,
    dataElements: _dataElements2.default,
    dataElementGroups: _dataElementGroups2.default,
    dataElementOperands: _dataElementOperands2.default,
    dataSets: _dataSets2.default,
    dataTable: _dataTable2.default,
    earthEngine: _earthEngine2.default,
    favorite: _favorite2.default,
    indicators: _indicators2.default,
    indicatorGroups: _indicatorGroups2.default,
    layerEdit: _layerEdit2.default,
    layers: _layers2.default,
    legendSets: _legendSets2.default,
    loading: _loading2.default,
    map: _map2.default,
    message: _message2.default,
    optionSets: _optionSets2.default,
    orgUnit: _orgUnit2.default,
    orgUnitTree: _orgUnitTree2.default,
    orgUnitGroupSets: _orgUnitGroupSets2.default,
    orgUnitGroups: _orgUnitGroups2.default,
    orgUnitLevels: _orgUnitLevels2.default,
    programs: _programs2.default,
    programDataElements: _programDataElements2.default,
    programIndicators: _programIndicators2.default,
    programStages: _programStages2.default,
    programStageDataElements: _programStageDataElements2.default,
    programTrackedEntityAttributes: _programTrackedEntityAttributes2.default,
    relocate: _relocate2.default,
    ui: _ui2.default,
    userSettings: _userSettings2.default
});

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var alert = function alert() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ALERT_SET:
            return action.payload;

        case types.ALERTS_CLEAR:
            return null;

        default:
            return state;
    }
};

exports.default = alert;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basemaps = __webpack_require__(439);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var basemaps = function basemaps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _basemaps.defaultBasemaps;
    var action = arguments[1];

    switch (action.type) {
        case types.BASEMAP_ADD:
            return [].concat(_toConsumableArray(state), [action.payload]);

        case types.BASEMAP_REMOVE:
            return state.filter(function (basemap) {
                return basemap.id !== action.id;
            });

        default:
            return state;
    }
};

exports.default = basemaps;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var contextMenu = function contextMenu() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.MAP_CONTEXT_MENU_OPEN:
            return action.payload;

        case types.MAP_CONTEXT_MENU_CLOSE:
            return null;

        default:
            return state;
    }
};

exports.default = contextMenu;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dataElements = function dataElements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.DATA_ELEMENTS_SET:
            return _extends({}, state, _defineProperty({}, action.groupId, action.payload));

        default:
            return state;
    }
};

exports.default = dataElements;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var dataElementGroups = function dataElementGroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.DATA_ELEMENT_GROUPS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = dataElementGroups;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dataElementOperands = function dataElementOperands() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.DATA_ELEMENT_OPERANDS_SET:
            return _extends({}, state, _defineProperty({}, action.groupId, action.payload));

        default:
            return state;
    }
};

exports.default = dataElementOperands;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var dataSets = function dataSets() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.DATA_SETS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = dataSets;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var dataTable = function dataTable() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.DATA_TABLE_OPEN:
            return action.id;

        case types.DATA_TABLE_CLOSE:
            return null;

        case types.DATA_TABLE_TOGGLE:
            return state === action.id ? null : action.id;

        case types.LAYER_REMOVE:
            return state === action.id ? null : state;

        default:
            return state;
    }
};

exports.default = dataTable;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var earthEngine = function earthEngine() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.EARTH_ENGINE_COLLECTION_SET:
            return _extends({}, state, _defineProperty({}, action.id, action.payload));

        default:
            return state;
    }
};

exports.default = earthEngine;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaultState = {
    dialogOpen: false,
    saveNewDialogOpen: false,
    response: null
};

var favorite = function favorite() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case types.FAVORITES_DIALOG_OPEN:
            return _extends({}, state, {
                dialogOpen: true
            });

        case types.FAVORITES_DIALOG_CLOSE:
            return _extends({}, state, {
                dialogOpen: false
            });

        case types.FAVORITE_SAVE_NEW_DIALOG_OPEN:
            return _extends({}, state, {
                saveNewDialogOpen: true
            });

        case types.FAVORITE_SAVE_NEW_DIALOG_CLOSE:
            return _extends({}, state, {
                saveNewDialogOpen: false,
                response: null
            });

        default:
            return state;
    }
};

exports.default = favorite;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = __webpack_require__(731);

var _omit2 = _interopRequireDefault(_omit);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _analytics = __webpack_require__(32);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var layerEdit = function layerEdit() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    var columns = void 0;
    var newState = void 0;

    switch (action.type) {
        case types.LAYER_EDIT:
            delete action.payload.img;
            return action.payload;

        case types.LAYER_CANCEL:
            return null;

        case types.LAYER_EDIT_PROGRAM_SET:
            return _extends({}, state, {
                program: _extends({}, action.program),
                columns: [],
                programStage: null,
                styleDataElement: null
            });

        case types.LAYER_EDIT_PROGRAM_STAGE_SET:
            return _extends({}, state, {
                programStage: _extends({}, action.programStage),
                columns: [],
                styleDataElement: null
            });

        case types.LAYER_EDIT_VALUE_TYPE_SET:
            return _extends({}, state, {
                valueType: action.valueType,
                columns: action.keepColumns ? state.columns : [] // Kept if favorite is loaded
            });

        case types.LAYER_EDIT_INDICATOR_GROUP_SET:
            return _extends({}, state, {
                indicatorGroup: {
                    id: action.indicatorGroup.id,
                    name: action.indicatorGroup.name
                },
                columns: []
            });

        case types.LAYER_EDIT_DATA_ELEMENT_GROUP_SET:
            return _extends({}, state, {
                dataElementGroup: {
                    id: action.dataElementGroup.id,
                    name: action.dataElementGroup.name
                },
                columns: []
            });

        case types.LAYER_EDIT_OPERAND_SET:
            return _extends({}, state, {
                operand: action.operand,
                columns: []
            });

        case types.LAYER_EDIT_DATA_ITEM_SET:
            return _extends({}, state, {
                columns: (0, _analytics.setDataItemInColumns)(action.dataItem, action.dimension),
                name: null
            });

        case types.LAYER_EDIT_PERIOD_TYPE_SET:
            return _extends({}, (0, _omit2.default)('filters', state), {
                periodType: action.periodType
            });

        case types.LAYER_EDIT_PERIOD_SET:
            return _extends({}, state, {
                filters: action.period.id !== 'START_END_DATES' ? (0, _analytics.setFiltersFromPeriod)(action.period) : []
            });

        case types.LAYER_EDIT_START_DATE_SET:
            return _extends({}, state, {
                startDate: action.startDate
            });

        case types.LAYER_EDIT_END_DATE_SET:
            return _extends({}, state, {
                endDate: action.endDate
            });

        case types.LAYER_EDIT_AGGREGATION_TYPE_SET:
            return _extends({}, state, {
                aggregationType: action.aggregationType
            });

        case types.LAYER_EDIT_FILTER_ADD:
            return _extends({}, state, {
                columns: [].concat(_toConsumableArray(state.columns), [action.filter || {
                    dimension: null,
                    name: null,
                    filter: null
                }])
            });

        case types.LAYER_EDIT_FILTER_REMOVE:
            columns = state.columns.filter(function (c) {
                return c.filter !== undefined;
            }); // Also used for style data element without filter

            if (!columns || !columns[action.index]) {
                return state;
            }

            return _extends({}, state, {
                columns: [].concat(_toConsumableArray(state.columns.filter(function (c) {
                    return c.filter === undefined;
                })), _toConsumableArray(columns.filter(function (c, i) {
                    return i !== action.index;
                })))
            });

        case types.LAYER_EDIT_FILTER_CHANGE:
            columns = state.columns.filter(function (c) {
                return c.filter !== undefined;
            }); // Also used for style data element without filter

            if (!columns || !columns[action.index]) {
                return state;
            }

            columns[action.index] = action.filter;

            return _extends({}, state, {
                columns: [].concat(_toConsumableArray(state.columns.filter(function (c) {
                    return c.filter === undefined;
                })), _toConsumableArray(columns))
            });

        case types.LAYER_EDIT_STYLE_DATA_ITEM_SET:
            return _extends({}, state, {
                styleDataItem: action.dataItem
            });

        // Set options to data element option set
        case types.LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET:
            newState = _extends({}, state, {
                styleDataItem: _extends({}, state.styleDataItem, {
                    optionSet: _extends({}, state.styleDataItem.optionSet, {
                        options: action.options
                    })
                })
            });

            delete newState.method;
            delete newState.classes;
            delete newState.colorScale;

            return newState;

        case types.LAYER_EDIT_CLASSIFICATION_SET:
            newState = _extends({}, state, {
                method: action.method
            });

            if (action.method !== 1) {
                // // TODO: Make constant
                delete newState.legendSet;
            }

            if (newState.styleDataItem) {
                delete newState.styleDataItem.optionSet;
            }

            // console.log(action.method, newState);

            return newState;

        case types.LAYER_EDIT_COLOR_SCALE_SET:
            newState = _extends({}, state, {
                colorScale: action.colorScale,
                classes: action.colorScale.split(',').length,
                method: state.method || 2 // TODO: Make constant
            });

            if (newState.styleDataItem) {
                delete newState.styleDataItem.optionSet;
            }

            return newState;

        case types.LAYER_EDIT_EVENT_COORDINATE_FIELD_SET:
            newState = _extends({}, state);

            if (action.fieldId === 'event') {
                // Default
                delete newState.eventCoordinateField;
            } else {
                newState.eventCoordinateField = action.fieldId;
            }

            return newState;

        case types.LAYER_EDIT_EVENT_CLUSTERING_SET:
            return _extends({}, state, {
                eventClustering: action.checked
            });

        case types.LAYER_EDIT_EVENT_POINT_RADIUS_SET:
            return _extends({}, state, {
                eventPointRadius: parseInt(action.radius, 10)
            });

        case types.LAYER_EDIT_EVENT_POINT_COLOR_SET:
            return _extends({}, state, {
                eventPointColor: action.color
            });

        case types.LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET:
            return _extends({}, state, {
                organisationUnitGroupSet: action.organisationUnitGroupSet
            });

        case types.LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET:
            return _extends({}, state, {
                rows: (0, _analytics.addOrgUnitLevelsToRows)(state.rows, action.levels)
            });

        case types.LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET:
            return _extends({}, state, {
                rows: (0, _analytics.addOrgUnitGroupsToRows)(state.rows, action.groups)
            });

        case types.LAYER_EDIT_USER_ORGANISATION_UNITS_SET:
            return _extends({}, state, {
                rows: (0, _analytics.addUserOrgUnitsToRows)(state.rows, action.userOrgUnits)
            });

        case types.LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE:
            return _extends({}, state, {
                rows: (0, _analytics.toggleOrgUnitNodeInRows)(state.rows, action.orgUnit)
            });

        // Set organisation unit tree path (temporary solution, as favorites don't include paths)
        case types.LAYER_EDIT_ORGANISATION_UNIT_PATH_SET:
            return _extends({}, state, {
                rows: (0, _analytics.setOrgUnitPathInRows)(state.rows, action.id, action.path)
            });

        case types.LAYER_EDIT_PARAMS_SET:
            return _extends({}, state, {
                params: {
                    min: action.min,
                    max: action.max,
                    palette: action.palette
                }
            });

        case types.LAYER_EDIT_FILTER_SET:
            return _extends({}, state, {
                filter: action.filter
            });

        case types.LAYER_EDIT_LABELS_SET:
            return _extends({}, state, {
                labels: action.isChecked
            });

        case types.LAYER_EDIT_LABEL_FONT_COLOR_SET:
            return _extends({}, state, {
                labelFontColor: action.color
            });

        case types.LAYER_EDIT_LABEL_FONT_SIZE_SET:
            return _extends({}, state, {
                labelFontSize: action.size
            });

        case types.LAYER_EDIT_LABEL_FONT_WEIGHT_SET:
            return _extends({}, state, {
                labelFontWeight: action.weight
            });

        case types.LAYER_EDIT_LABEL_FONT_STYLE_SET:
            return _extends({}, state, {
                labelFontStyle: action.style
            });

        case types.LAYER_EDIT_AREA_RADIUS_SET:
            return _extends({}, state, {
                areaRadius: action.radius ? parseInt(action.radius, 10) : null
            });

        case types.LAYER_EDIT_RADIUS_LOW_SET:
            return _extends({}, state, {
                radiusLow: parseInt(action.radius, 10)
            });

        case types.LAYER_EDIT_RADIUS_HIGH_SET:
            return _extends({}, state, {
                radiusHigh: parseInt(action.radius, 10)
            });

        case types.LAYER_EDIT_LEGEND_SET_SET:
            return _extends({}, state, {
                legendSet: action.legendSet
            });

        default:
            return state;
    }
};

exports.default = layerEdit;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('omit', __webpack_require__(732));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseClone = __webpack_require__(127),
    baseUnset = __webpack_require__(733),
    castPath = __webpack_require__(64),
    copyObject = __webpack_require__(72),
    customOmitClone = __webpack_require__(737),
    flatRest = __webpack_require__(152),
    getAllKeysIn = __webpack_require__(151);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(64),
    last = __webpack_require__(734),
    parent = __webpack_require__(735),
    toKey = __webpack_require__(46);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98),
    baseSlice = __webpack_require__(736);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(135);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var indicators = function indicators() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.INDICATORS_SET:
            return _extends({}, state, _defineProperty({}, action.groupId, action.payload));

        default:
            return state;
    }
};

exports.default = indicators;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var indicatorGroups = function indicatorGroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.INDICATOR_GROUPS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = indicatorGroups;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defaultLayers = [{
    layer: 'event',
    type: 'Events',
    img: 'images/events.png',
    opacity: 0.95,
    eventClustering: true
}, {
    layer: 'facility',
    type: 'Facilities',
    img: 'images/facilities.png',
    opacity: 1
}, {
    layer: 'thematic',
    type: 'Thematic',
    img: 'images/thematic.png',
    opacity: 0.8
}, {
    layer: 'boundary',
    type: 'Boundaries',
    img: 'images/boundaries.png',
    opacity: 1
}, {
    layer: 'earthEngine',
    datasetId: 'WorldPop/POP',
    type: 'Population density',
    img: 'images/population.png',
    params: {
        min: 0,
        max: 1000,
        palette: '#fee5d9,#fcbba1,#fc9272,#fb6a4a,#de2d26,#a50f15' // Reds
    },
    opacity: 0.9
}, {
    layer: 'earthEngine',
    datasetId: 'USGS/SRTMGL1_003',
    type: 'Elevation',
    img: 'images/elevation.png',
    params: {
        min: 0,
        max: 1500,
        palette: '#ffffd4,#fee391,#fec44f,#fe9929,#d95f0e,#993404' // YlOrBr
    },
    opacity: 0.9
}, {
    layer: 'earthEngine',
    datasetId: 'MODIS/MOD11A2',
    type: 'Temperature',
    img: 'images/temperature.png',
    params: {
        min: 0,
        max: 50,
        palette: '#fee5d9,#fcbba1,#fc9272,#fb6a4a,#ef3b2c,#cb181d,#99000d' // Reds
    },
    opacity: 0.9
}, {
    layer: 'earthEngine',
    datasetId: 'UCSB-CHG/CHIRPS/PENTAD',
    type: 'Precipitation',
    img: 'images/precipitation.png',
    params: {
        min: 0,
        max: 100,
        palette: '#eff3ff,#c6dbef,#9ecae1,#6baed6,#4292c6,#2171b5,#084594' // Blues
    },
    opacity: 0.9
}, {
    layer: 'earthEngine',
    datasetId: 'MODIS/051/MCD12Q1',
    type: 'Landcover',
    img: 'images/landcover.png',
    opacity: 0.9
}, {
    layer: 'earthEngine',
    datasetId: 'NOAA/DMSP-OLS/NIGHTTIME_LIGHTS',
    type: 'Nighttime lights',
    img: 'images/nighttime.png',
    params: {
        min: 0,
        max: 63,
        palette: '#ffffd4,#fee391,#fec44f,#fe9929,#ec7014,#cc4c02,#8c2d04' // YlOrBr
    },
    opacity: 0.9
}];

var layers = function layers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultLayers;
    var action = arguments[1];

    switch (action.type) {
        case types.EXTERNAL_LAYER_ADD:
            return [].concat(_toConsumableArray(state), [_extends({}, action.payload, {
                isVisible: true
            })]);

        case types.EXTERNAL_LAYER_REMOVE:
            return state.filter(function (layer) {
                return layer.id !== action.id;
            });

        default:
            return state;
    }
};

exports.default = layers;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var legendSets = function legendSets() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.LEGEND_SETS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = legendSets;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = loading;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function loading() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case types.LOADING:
            return true;
        case types.LOADED:
            return false;
        default:
            return state;
    }
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _reactSortableHoc = __webpack_require__(448);

var _uid = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
    bounds: [[-34.9, -18.7], [35.9, 50.2]],
    basemap: {
        id: 'osmLight',
        isVisible: true,
        isExpanded: true,
        opacity: 1,
        subtitle: 'Basemap'
    },
    mapViews: []
};

var basemap = function basemap(state, action) {
    switch (action.type) {
        case types.BASEMAP_SELECTED:
            if (state.id === action.id) {
                // No change
                return state;
            }

            return _extends({}, state, {
                id: action.id
            });

        case types.BASEMAP_CHANGE_OPACITY:
            return _extends({}, state, {
                opacity: action.opacity
            });

        case types.BASEMAP_TOGGLE_EXPAND:
            return _extends({}, state, {
                isExpanded: !state.isExpanded
            });

        case types.BASEMAP_TOGGLE_VISIBILITY:
            return _extends({}, state, {
                isVisible: !state.isVisible
            });

        default:
            return state;
    }
};

var layer = function layer(state, action) {
    switch (action.type) {
        case types.LAYER_UPDATE:
            if (state.id !== action.payload.id) {
                return state;
            }

            return _extends({}, action.payload);

        case types.LAYER_CHANGE_OPACITY:
            if (state.id !== action.id) {
                return state;
            }

            return _extends({}, state, {
                opacity: action.opacity
            });

        case types.LAYER_TOGGLE_VISIBILITY:
            if (state.id !== action.id) {
                return state;
            }

            return _extends({}, state, {
                isVisible: !state.isVisible
            });

        case types.LAYER_TOGGLE_EXPAND:
            if (state.id !== action.id) {
                return state;
            }

            return _extends({}, state, {
                isExpanded: !state.isExpanded
            });

        case types.ORGANISATION_UNIT_SELECT:
        case types.ORGANISATION_UNIT_UNSELECT:
        case types.ORGANISATION_UNIT_COORDINATE_CHANGE:
            if (state.id !== action.layerId) {
                return state;
            }

            return _extends({}, state, {
                data: state.data.map(function (l) {
                    return orgUnit(l, action);
                })
            });

        // Add/change filter
        case types.DATA_FILTER_SET:
            if (state.id !== action.layerId) {
                return state;
            }

            return _extends({}, state, {
                dataFilters: _extends({}, state.dataFilters, _defineProperty({}, action.fieldId, action.filter))
                // editCounter: ++state.editCounter, // Will trigger redraw
            });

        // Remove field from filter
        case types.DATA_FILTER_CLEAR:
            if (state.id !== action.layerId) {
                return state;
            }

            var filters = _extends({}, state.dataFilters);
            delete filters[action.fieldId];

            return _extends({}, state, {
                dataFilters: filters
                // editCounter: ++state.editCounter, // Will trigger redraw
            });

        case types.ALERTS_CLEAR:
            return _extends({}, state, {
                alerts: null
            });

        case types.MAP_EARTH_ENGINE_VALUE_SHOW:
            if (state.id !== action.layerId) {
                return state;
            }

            return _extends({}, state, {
                coordinate: action.coordinate
            });

        default:
            return state;
    }
};

var orgUnit = function orgUnit(state, action) {
    switch (action.type) {
        case types.ORGANISATION_UNIT_SELECT:
            if (state.id !== action.featureId) {
                return state;
            }

            return _extends({}, state, {
                isSelected: true
            });

        case types.ORGANISATION_UNIT_UNSELECT:
            if (state.id !== action.featureId) {
                return state;
            }

            return _extends({}, state, {
                isSelected: false
            });

        case types.ORGANISATION_UNIT_COORDINATE_CHANGE:
            if (state.id !== action.featureId) {
                return state;
            }

            return _extends({}, state, {
                geometry: _extends({}, state.geometry, {
                    coordinates: action.coordinate
                })
            });

        default:
            return state;
    }
};

var map = function map() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case types.MAP_NEW:
            return _extends({}, defaultState);

        case types.MAP_SET:
            return _extends({}, defaultState, action.payload);

        case types.MAP_NAME_SET:
            return _extends({}, state, {
                name: action.payload
            });

        case types.MAP_COORDINATE_OPEN:
            return _extends({}, state, {
                coordinatePopup: action.payload
            });

        case types.MAP_COORDINATE_CLOSE:
            return _extends({}, state, {
                coordinatePopup: null
            });

        case types.BASEMAP_SELECTED:
        case types.BASEMAP_CHANGE_OPACITY:
        case types.BASEMAP_TOGGLE_EXPAND:
        case types.BASEMAP_TOGGLE_VISIBILITY:
            return _extends({}, state, {
                basemap: basemap(state.basemap, action)
            });

        case types.LAYER_ADD:
            // Check to only allow external layers to be added once
            if (state.mapViews.filter(function (l) {
                return l.id === action.payload.id;
            }).length) {
                return state;
            }

            return _extends({}, state, {
                mapViews: [].concat(_toConsumableArray(state.mapViews), [_extends({
                    id: (0, _uid.generateUid)()
                }, action.payload)])
            });

        case types.LAYER_ADD_DATA:
            return _extends({}, state);

        case types.LAYER_LOAD:
            return _extends({}, state);

        case types.LAYER_REMOVE:
            return _extends({}, state, {
                mapViews: state.mapViews.filter(function (layer) {
                    return layer.id !== action.id;
                })
            });

        case types.LAYER_SORT:
            var mapViews = [].concat(_toConsumableArray(state.mapViews)).reverse(); // TODO: Refactor
            var sortedMapViews = (0, _reactSortableHoc.arrayMove)(mapViews, action.oldIndex, action.newIndex).reverse();

            return _extends({}, state, {
                mapViews: sortedMapViews
            });

        case types.LAYER_LOAD:
        case types.LAYER_UPDATE:
        case types.LAYER_EDIT:
        case types.LAYER_CHANGE_OPACITY:
        case types.LAYER_TOGGLE_VISIBILITY:
        case types.LAYER_TOGGLE_EXPAND:
        case types.ORGANISATION_UNIT_SELECT:
        case types.ORGANISATION_UNIT_UNSELECT:
        case types.ORGANISATION_UNIT_COORDINATE_CHANGE:
        case types.ORGANISATION_UNITS_FILTER:
        case types.DATA_FILTER_SET:
        case types.DATA_FILTER_CLEAR:
        case types.MAP_EARTH_ENGINE_VALUE_SHOW:
            return _extends({}, state, {
                mapViews: state.mapViews.map(function (l) {
                    return layer(l, action);
                })
            });

        case types.ALERTS_CLEAR:
            return _extends({}, state, {
                alerts: null,
                mapViews: state.mapViews.map(function (l) {
                    return layer(l, action);
                })
            });

        default:
            return state;
    }
};

exports.default = map;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _invariant = __webpack_require__(251);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(745);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;


        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;


        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(746);

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__(245);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(747),
    findIndex = __webpack_require__(252);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(38),
    isArrayLike = __webpack_require__(42),
    keys = __webpack_require__(58);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _invariant = __webpack_require__(251);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _invariant = __webpack_require__(251);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var message = function message() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.MESSAGE_SET:
            return action.payload;

        case types.MESSAGE_CLEAR:
            return null;

        default:
            return state;
    }
};

exports.default = message;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var optionSets = function optionSets() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.OPTION_SET_ADD:
            return _extends({}, state, _defineProperty({}, action.payload.id, action.payload));

        default:
            return state;
    }
};

exports.default = optionSets;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var orgUnit = function orgUnit() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_SET:
            return _extends({}, action.payload);

        case types.ORGANISATION_UNIT_CLOSE:
            return null;

        default:
            return state;
    }
};

exports.default = orgUnit;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var orgUnitTree = function orgUnitTree() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_TREE_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = orgUnitTree;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var orgUnitGroups = function orgUnitGroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_GROUPS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = orgUnitGroups;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var orgUnitGroupSets = function orgUnitGroupSets() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_GROUP_SETS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = orgUnitGroupSets;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var orgUnitLevels = function orgUnitLevels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_LEVELS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = orgUnitLevels;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var programs = function programs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.PROGRAMS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = programs;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var programDataElements = function programDataElements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        // Set data elements for program
        case types.PROGRAM_DATA_ELEMENTS_SET:
            return _extends({}, state, _defineProperty({}, action.programId, action.payload));

        default:
            return state;
    }
};

exports.default = programDataElements;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var programIndicators = function programIndicators() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.PROGRAM_INDICATORS_SET:
            return _extends({}, state, _defineProperty({}, action.programId, action.payload));

        default:
            return state;
    }
};

exports.default = programIndicators;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var programStages = function programStages() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case types.PROGRAM_STAGES_SET:
            return _extends({}, state, _defineProperty({}, action.programId, action.payload));

        default:
            return state;
    }
};

exports.default = programStages;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var programStageDataElements = function programStageDataElements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        // Set data elements for program stage
        case types.PROGRAM_STAGE_DATA_ELEMENTS_SET:
            return _extends({}, state, _defineProperty({}, action.programStageId, action.payload));

        default:
            return state;
    }
};

exports.default = programStageDataElements;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var programTrackedEntityAttributes = function programTrackedEntityAttributes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        // Set attributes for program
        case types.PROGRAM_ATTRIBUTES_SET:
            return _extends({}, state, _defineProperty({}, action.programId, action.payload));

        default:
            return state;
    }
};

exports.default = programTrackedEntityAttributes;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var relocate = function relocate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.ORGANISATION_UNIT_RELOCATE_START:
            return {
                layerId: action.layerId,
                feature: action.feature
            };

        case types.ORGANISATION_UNIT_RELOCATE_STOP:
            return null;

        default:
            return state;
    }
};

exports.default = relocate;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaultState = {
    width: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window.innerWidth : null,
    height: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window.innerHeight : null,
    layersPanelOpen: true,
    dataTableOpen: false,
    dataTableHeight: 300,
    layersDialogOpen: false,
    aboutDialogOpen: false,
    mapContextMenu: true
};

var ui = function ui() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case types.SCREEN_RESIZE:
            return _extends({}, state, {
                width: action.width,
                height: action.height
            });

        case types.LAYERS_PANEL_OPEN:
            return _extends({}, state, {
                layersPanelOpen: true
            });

        case types.LAYERS_PANEL_CLOSE:
            return _extends({}, state, {
                layersPanelOpen: false
            });

        case types.LAYERS_DIALOG_OPEN:
            return _extends({}, state, {
                layersDialogOpen: true
            });

        case types.LAYERS_DIALOG_CLOSE:
            return _extends({}, state, {
                layersDialogOpen: false
            });

        case types.DATA_TABLE_RESIZE:
            return _extends({}, state, {
                dataTableHeight: action.height
            });

        case types.ABOUT_DIALOG_OPEN:
            return _extends({}, state, {
                aboutDialogOpen: true
            });

        case types.ABOUT_DIALOG_CLOSE:
            return _extends({}, state, {
                aboutDialogOpen: false
            });

        default:
            return state;
    }
};

exports.default = ui;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var userSettings = function userSettings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case types.USER_SETTINGS_SET:
            return action.payload;

        default:
            return state;
    }
};

exports.default = userSettings;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(47);

var _Observable = __webpack_require__(30);

__webpack_require__(580);

__webpack_require__(767);

__webpack_require__(770);

__webpack_require__(773);

var _dataElements = __webpack_require__(775);

var _dataElements2 = _interopRequireDefault(_dataElements);

var _dataSets = __webpack_require__(777);

var _dataSets2 = _interopRequireDefault(_dataSets);

var _earthEngine = __webpack_require__(778);

var _earthEngine2 = _interopRequireDefault(_earthEngine);

var _externalLayers = __webpack_require__(779);

var _externalLayers2 = _interopRequireDefault(_externalLayers);

var _maps = __webpack_require__(786);

var _maps2 = _interopRequireDefault(_maps);

var _indicators = __webpack_require__(787);

var _indicators2 = _interopRequireDefault(_indicators);

var _layers = __webpack_require__(788);

var _layers2 = _interopRequireDefault(_layers);

var _legendSets = __webpack_require__(789);

var _legendSets2 = _interopRequireDefault(_legendSets);

var _optionSets = __webpack_require__(790);

var _optionSets2 = _interopRequireDefault(_optionSets);

var _orgUnits = __webpack_require__(791);

var _orgUnits2 = _interopRequireDefault(_orgUnits);

var _programs = __webpack_require__(792);

var _programs2 = _interopRequireDefault(_programs);

var _favorites = __webpack_require__(793);

var _favorites2 = _interopRequireDefault(_favorites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorEpic = function errorEpic(action$) {
    return action$.filter(function (action) {
        return action.type.indexOf('ERROR') !== -1;
    }).do(function (action) {
        return console.error(action.error);
    }).concatMapTo(_Observable.Observable.empty());
}; // Avoid infinite loop, same as .map(action => Observable.empty()).concatAll()

exports.default = (0, _reduxObservable.combineEpics)(_dataElements2.default, _dataSets2.default, _earthEngine2.default, errorEpic, _externalLayers2.default, _maps2.default, _indicators2.default, _layers2.default, _legendSets2.default, _optionSets2.default, _orgUnits2.default, _programs2.default, _favorites2.default);

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var do_1 = __webpack_require__(768);
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tap_1 = __webpack_require__(769);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return tap_1.tap(nextOrObserver, error, complete)(this);
}
exports._do = _do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(99);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
exports.tap = tap;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=tap.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var concatMapTo_1 = __webpack_require__(771);
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMapTo_1 = __webpack_require__(772);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(581);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var empty_1 = __webpack_require__(774);
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EmptyObservable_1 = __webpack_require__(437);
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadDataElementOperands = exports.loadDataElements = exports.loadDataElementGroups = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _api = __webpack_require__(59);

var _dataElements = __webpack_require__(254);

var _helpers = __webpack_require__(66);

var _helpers2 = __webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Load all data element groups
var loadDataElementGroups = exports.loadDataElementGroups = function loadDataElementGroups(action$) {
    return action$.ofType(types.DATA_ELEMENT_GROUPS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.dataElementGroups.list({
                fields: 'id,' + (0, _helpers2.getDisplayPropertyUrl)(),
                paging: false
            });
        }).then(function (groups) {
            return (0, _dataElements.setDataElementGroups)((0, _sortBy2.default)('name', groups.toArray()));
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAMS_LOAD_ERROR));
    });
};

// Load data elements in one group
var loadDataElements = exports.loadDataElements = function loadDataElements(action$) {
    return action$.ofType(types.DATA_ELEMENTS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.dataElement.filter().on('dataElementGroups.id').equals(action.groupId).list({
                fields: 'dimensionItem~rename(id),' + (0, _helpers2.getDisplayPropertyUrl)(d2),
                domainType: 'aggregate',
                paging: false
            });
        }).then(function (dataElements) {
            return (0, _dataElements.setDataElements)(action.groupId, dataElements.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.DATA_ELEMENTS_LOAD_ERROR));
    });
};

// Load data element operands in one group
// dataElementOperands is not supported by d2 as these operands are *not persisted*. They are generated based on the
// data elements, their category combo and then all possible operands (data element+option combo) are generated based on
// that so it does not really follow the standard metadata objects nor does it have a schema
// there should be some flexibility for custom URL requests here, in d2 or elsewhere
var loadDataElementOperands = exports.loadDataElementOperands = function loadDataElementOperands(action$) {
    return action$.ofType(types.DATA_ELEMENT_OPERANDS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return (0, _api.apiFetch)('/dataElementOperands.json?fields=id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + '&paging=false&filter=dataElement.dataElementGroups.id:eq:' + action.groupId);
        }).then(function (data) {
            return (0, _dataElements.setDataElementOperands)(action.groupId, data.dataElementOperands);
        });
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadDataElementGroups, loadDataElements, loadDataElementOperands);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(581);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return concatMap_1.concatMap(project, resultSelector)(this);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadDataSets = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _dataSets = __webpack_require__(582);

var _helpers = __webpack_require__(66);

var _helpers2 = __webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load data sets
var loadDataSets = exports.loadDataSets = function loadDataSets(action$) {
    return action$.ofType(types.DATA_SETS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.dataSets.list({
                fields: 'dimensionItem~rename(id),' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ',legendSet[id]',
                paging: false
            });
        }).then(function (dataSets) {
            return (0, _dataSets.setDataSets)(dataSets.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.DATA_SETS_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadDataSets);

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadCollection = undefined;

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reduxObservable = __webpack_require__(47);

__webpack_require__(91);

var _d3TimeFormat = __webpack_require__(139);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _api = __webpack_require__(59);

var _alerts = __webpack_require__(100);

var _earthEngine = __webpack_require__(583);

var _helpers = __webpack_require__(66);

var _alerts2 = __webpack_require__(584);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var collections = {
    'WorldPop/POP': function WorldPopPOP(resolve, reject) {
        // Population density
        var imageCollection = ee.ImageCollection('WorldPop/POP').filterMetadata('UNadj', 'equals', 'yes').distinct('year').sort('year', false);

        var featureCollection = ee.FeatureCollection(imageCollection).select(['year'], null, false);

        featureCollection.getInfo(function (data) {
            return resolve(data.features.map(function (feature) {
                return {
                    id: feature.properties['year'],
                    name: String(feature.properties['year']) // TODO: Support numbers in d2-ui cmp
                };
            }));
        });
    },
    'NOAA/DMSP-OLS/NIGHTTIME_LIGHTS': function NOAADMSPOLSNIGHTTIME_LIGHTS(resolve, reject) {
        // Nighttime lights
        var imageCollection = ee.ImageCollection('NOAA/DMSP-OLS/NIGHTTIME_LIGHTS').distinct('system:time_start') // TODO: Why two images for some years?
        .sort('system:time_start', false);

        var featureCollection = ee.FeatureCollection(imageCollection).select(['system:time_start'], null, false);

        featureCollection.getInfo(function (data) {
            return resolve(data.features.map(function (feature) {
                return {
                    id: feature.id,
                    name: String(new Date(feature.properties['system:time_start']).getFullYear()) // TODO: Support numbers in d2-ui cmp
                };
            }));
        });
    },
    'UCSB-CHG/CHIRPS/PENTAD': function UCSBCHGCHIRPSPENTAD(resolve, reject) {
        // Precipitation
        var imageCollection = ee.ImageCollection('UCSB-CHG/CHIRPS/PENTAD').filterDate('2000-01-01', '2025-01-01').sort('system:time_start', false);

        var featureCollection = ee.FeatureCollection(imageCollection).select(['system:time_start', 'system:time_end'], null, false);

        featureCollection.getInfo(function (data) {
            return resolve(data.features.map(function (feature) {
                return {
                    id: feature.id,
                    name: (0, _d3TimeFormat.timeFormat)('%-d – ')(feature.properties['system:time_start']) + (0, _d3TimeFormat.timeFormat)('%-d %b %Y')(feature.properties['system:time_end'] - 7200001) // Minus 2 hrs to end the day before
                };
            }));
        });
    },
    'MODIS/MOD11A2': function MODISMOD11A2(resolve, reject) {
        // Temperature
        var imageCollection = ee.ImageCollection('MODIS/MOD11A2').sort('system:time_start', false);

        var featureCollection = ee.FeatureCollection(imageCollection).select(['system:time_start', 'system:time_end'], null, false);

        featureCollection.getInfo(function (data) {
            return resolve(data.features.map(function (feature) {
                return {
                    id: feature.id,
                    name: (0, _d3TimeFormat.timeFormat)('%-d %b – ')(feature.properties['system:time_start']) + (0, _d3TimeFormat.timeFormat)('%-d %b %Y')(feature.properties['system:time_end'] - 7200001) // Minus 2 hrs to end the day before
                };
            }));
        });
    },
    'MODIS/051/MCD12Q1': function MODIS051MCD12Q1(resolve, reject) {
        // Landcover
        var imageCollection = ee.ImageCollection('MODIS/051/MCD12Q1').sort('system:time_start', false);

        var featureCollection = ee.FeatureCollection(imageCollection).select(['system:time_start', 'system:time_end'], null, false);

        featureCollection.getInfo(function (data) {
            return resolve(data.features.map(function (feature) {
                return {
                    id: feature.id,
                    name: String(new Date(feature.properties['system:time_start']).getFullYear()) // TODO: Support numbers in d2-ui cmp
                };
            }));
        });
    }
};

var setAuthToken = function setAuthToken(_ref) {
    var client_id = _ref.client_id,
        access_token = _ref.access_token,
        expires_in = _ref.expires_in;

    ee.data.setAuthToken(client_id, 'Bearer', access_token, expires_in, null, null, false);
    ee.initialize();
};

// Load collection (periods) for one EE dataset
var loadCollection = exports.loadCollection = function loadCollection(action$) {
    return action$.ofType(types.EARTH_ENGINE_COLLECTION_LOAD).concatMap(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
            var token;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return (0, _api.apiFetch)('/tokens/google').catch((0, _helpers.errorActionCreator)(types.EARTH_ENGINE_COLLECTION_LOAD_ERROR));

                        case 2:
                            token = _context.sent;

                            if (!(token && token.status === 'ERROR')) {
                                _context.next = 5;
                                break;
                            }

                            return _context.abrupt('return', (0, _alerts2.setAlert)((0, _alerts.createAlert)(_i18next2.default.t(token.message), _i18next2.default.t('To show this layer you must first sign up for the Earth Engine service at Google. Please check the DHIS 2 documentation.'))));

                        case 5:

                            setAuthToken(token);

                            return _context.abrupt('return', new Promise(collections[action.id]).then(function (data) {
                                return (0, _earthEngine.setEarthEngineCollection)(action.id, data);
                            }));

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }());
};

exports.default = (0, _reduxObservable.combineEpics)(loadCollection);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadExternalLayers = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(780);

__webpack_require__(585);

__webpack_require__(782);

__webpack_require__(580);

__webpack_require__(785);

var _Observable = __webpack_require__(30);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _basemap = __webpack_require__(586);

var _externalLayers = __webpack_require__(587);

var _helpers = __webpack_require__(66);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Loade external layers from Web API
var loadExternalLayers = exports.loadExternalLayers = function loadExternalLayers(action$) {
    var externalMapLayers$ = action$.ofType(types.EXTERNAL_LAYERS_LOAD).mergeMap(loadExternalMapLayers).concatAll(); // Create separate action objects in the stream [[a1], [a2], [a2]] => [a1], [a2], [a3]

    var externalBaseMapLayers$ = externalMapLayers$.filter(isBaseMap).map(createLayerConfig('External basemap')).map(_basemap.addBasemap);

    var externalOverlayLayers$ = externalMapLayers$.filter(isOverlay).map(createLayerConfig('External layer')).map(_externalLayers.addExternalLayer);

    return _Observable.Observable.merge(externalBaseMapLayers$, externalOverlayLayers$);
};

var isBaseMap = function isBaseMap(layer) {
    return layer.mapLayerPosition === 'BASEMAP';
};
var isOverlay = function isOverlay(layer) {
    return !isBaseMap(layer);
};

var loadExternalMapLayers = function loadExternalMapLayers() {
    return (0, _d.getInstance)().then(function (d2) {
        return d2.models.externalMapLayers.list({
            fields: 'id,displayName~rename(name),service,url,attribution,mapService,layer,imageFormat,mapLayerPosition,legendSet,legendSetUrl',
            paging: false
        });
    }).then(function (externalMapLayersCollection) {
        return externalMapLayersCollection.toArray();
    }).catch((0, _helpers.errorActionCreator)(types.EXTERNAL_LAYERS_LOAD_ERROR));
};

// Create external layer config object
var createLayerConfig = function createLayerConfig(subTitle) {
    return function (layer) {
        var config = {
            type: 'tileLayer',
            url: layer.url,
            attribution: layer.attribution
        };

        if (layer.mapService === 'TMS') {
            config.tms = true;
        }

        if (layer.mapService === 'WMS') {
            config.type = 'wmsLayer';
            config.layers = layer.layers;

            if (layer.imageFormat === 'JPG') {
                // PNG is default
                config.format = 'image/jpeg';
            }
        }

        return {
            id: layer.id,
            type: 'external',
            name: layer.name,
            // subtitle: subTitle, // layer.mapLayerPosition === 'BASEMAP' ? 'External basemap' : 'External layer', // TODO: i18n
            // img: layer.img, // TODO: Get from Web API
            opacity: 1,
            config: config
        };
    };
};

exports.default = (0, _reduxObservable.combineEpics)(loadExternalLayers);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var map_1 = __webpack_require__(567);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(438);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
}
exports.mergeMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var concatAll_1 = __webpack_require__(783);
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatAll_1 = __webpack_require__(784);
/* tslint:enable:max-line-length */
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return concatAll_1.concatAll()(this);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__(579);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return mergeAll_1.mergeAll(1);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(30);
var merge_1 = __webpack_require__(578);
Observable_1.Observable.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadFavorite = undefined;

var _reduxObservable = __webpack_require__(47);

__webpack_require__(91);

__webpack_require__(585);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _helpers = __webpack_require__(66);

var _requests = __webpack_require__(255);

var _map = __webpack_require__(154);

var _layers = __webpack_require__(101);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Load one favorite
var loadFavorite = exports.loadFavorite = function loadFavorite(action$) {
    return action$.ofType(types.FAVORITE_LOAD).concatMap(function (action) {
        return (0, _requests.mapRequest)(action.id).catch((0, _helpers.errorActionCreator)(types.FAVORITE_LOAD_ERROR));
    }).mergeMap(function (config) {
        return [(0, _map.setMap)(config)].concat(_toConsumableArray(config.mapViews.map(_layers.loadLayer)));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadFavorite);

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadIndicatorGroups = exports.loadIndicators = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _indicators = __webpack_require__(469);

var _helpers = __webpack_require__(66);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var loadIndicators = exports.loadIndicators = function loadIndicators(action$) {
    return action$.ofType(types.INDICATORS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.indicators.filter().on('indicatorGroups.id').equals(action.groupId).list({
                fields: 'id,displayName~rename(name),legendSet[id]',
                paging: false
            });
        }).then(function (indicators) {
            return (0, _indicators.setIndicators)(action.groupId, indicators.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.INDICATORS_LOAD_ERROR));
    });
};

var loadIndicatorGroups = exports.loadIndicatorGroups = function loadIndicatorGroups(action$) {
    return action$.ofType(types.INDICATOR_GROUPS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.indicatorGroups.list({
                fields: 'id,displayName~rename(name)',
                paging: false
            });
        }).then(function (indicatorGroups) {
            return (0, _indicators.setIndicatorGroups)(indicatorGroups.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.INDICATOR_GROUPS_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadIndicators, loadIndicatorGroups);

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.drillLayer = exports.loadLayerEpic = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxObservable = __webpack_require__(47);

__webpack_require__(91);

var _d = __webpack_require__(19);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _map = __webpack_require__(154);

var _layers = __webpack_require__(101);

var _helpers = __webpack_require__(66);

var _layers2 = __webpack_require__(256);

var _map2 = __webpack_require__(67);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNewLayer = function isNewLayer(config) {
    return config.id === undefined;
};

// Increase edit counter to trigger redraw
var increaseEditCounter = function increaseEditCounter(config) {
    return _extends({}, config, {
        editCounter: config.editCounter === undefined ? 0 : ++config.editCounter
    });
};

// Load one layer
var loadLayerEpic = exports.loadLayerEpic = function loadLayerEpic(action$) {
    return action$.ofType(types.LAYER_LOAD).concatMap(function (action) {
        return (0, _layers2.fetchLayer)(action.payload).then(increaseEditCounter).then(function (config) {
            return isNewLayer(config) ? (0, _layers.addLayer)(config) : (0, _layers.updateLayer)(config);
        }).catch((0, _helpers.errorActionCreator)(types.LAYER_LOAD_ERROR));
    });
};

var drillLayer = exports.drillLayer = function drillLayer(action$, store) {
    return action$.ofType(types.LAYER_DRILL).concatMap(function (_ref) {
        var layerId = _ref.layerId,
            parentId = _ref.parentId,
            parentGraph = _ref.parentGraph,
            level = _ref.level;
        return (0, _d.getInstance)() // TODO: D2 is not needed, just included to return a promise
        .then(function (d2) {
            var state = store.getState();
            var layerConfig = state.map.mapViews.filter(function (config) {
                return config.id === layerId;
            })[0]; // TODO: Add check

            return (0, _map2.drillUpDown)(layerConfig, parentId, parentGraph, level);
        });
    }).mergeMap(function (config) {
        return [(0, _map.closeContextMenu)(), (0, _layers.loadLayer)(config)];
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadLayerEpic, drillLayer);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadLegendSets = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _legendSets = __webpack_require__(588);

var _helpers = __webpack_require__(66);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load data sets
var loadLegendSets = exports.loadLegendSets = function loadLegendSets(action$) {
    return action$.ofType(types.LEGEND_SETS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.legendSets.list({
                fields: 'id,displayName~rename(name)',
                paging: false
            });
        }).then(function (legendSets) {
            return (0, _legendSets.setLegendSets)(legendSets.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.LEGEND_SETS_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadLegendSets);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadOptionSet = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _optionSets = __webpack_require__(260);

var _helpers = __webpack_require__(66);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Load option set
var loadOptionSet = exports.loadOptionSet = function loadOptionSet(action$) {
    return action$.ofType(types.OPTION_SET_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.optionSets.get(action.id, {
                fields: 'id,displayName~rename(name),version,options[code,displayName~rename(name)]',
                paging: false
            });
        }).then(function (optionSet) {
            return (0, _optionSets.addOptionSet)(optionSet);
        }).catch((0, _helpers.errorActionCreator)(types.OPTION_SET_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadOptionSet);

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadOrgUnitPath = exports.changeOrgUnitCoordinate = exports.loadOrgUnitGroupSets = exports.loadOrgUnitGroups = exports.loadOrgUnitLevels = exports.loadOrgUnitTree = exports.loadOrgUnit = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _helpers = __webpack_require__(66);

var _helpers2 = __webpack_require__(36);

var _api = __webpack_require__(59);

var _orgUnits = __webpack_require__(93);

var _layerEdit = __webpack_require__(60);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var loadOrgUnit = exports.loadOrgUnit = function loadOrgUnit(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.organisationUnit.get(action.payload.id, {
                fields: 'id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ',code,address,email,phoneNumber,coordinates,parent[id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + '],organisationUnitGroups[id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ']'
            });
        }).then(_orgUnits.setOrgUnit);
    });
};

var loadOrgUnitTree = exports.loadOrgUnitTree = function loadOrgUnitTree(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_TREE_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.organisationUnits.list({
                level: 1,
                fields: 'id,path,displayName,children[id,path,displayName,children::isNotEmpty]'
            });
        }).then(function (modelCollection) {
            return (0, _orgUnits.setOrgUnitTree)(modelCollection.toArray()[0]);
        }).catch((0, _helpers.errorActionCreator)(types.ORGANISATION_UNIT_TREE_LOAD_ERROR));
    });
};

var loadOrgUnitLevels = exports.loadOrgUnitLevels = function loadOrgUnitLevels(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_LEVELS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(d2) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', d2.models.organisationUnitLevels.list({
                                    fields: 'id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ',level',
                                    pageing: false
                                }));

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, undefined);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }()).then(function (levels) {
            return (0, _orgUnits.setOrgUnitLevels)(levels.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.ORGANISATION_UNIT_LEVELS_LOAD_ERROR));
    });
};

var loadOrgUnitGroups = exports.loadOrgUnitGroups = function loadOrgUnitGroups(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_GROUPS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(d2) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', d2.models.organisationUnitGroups.list({
                                    fields: 'id,' + (0, _helpers2.getDisplayPropertyUrl)(d2),
                                    pageing: false
                                }));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, undefined);
            }));

            return function (_x2) {
                return _ref2.apply(this, arguments);
            };
        }()).then(function (groups) {
            return (0, _orgUnits.setOrgUnitGroups)(groups.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.ORGANISATION_UNIT_GROUPS_LOAD_ERROR));
    });
};

var loadOrgUnitGroupSets = exports.loadOrgUnitGroupSets = function loadOrgUnitGroupSets(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_GROUP_SETS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.organisationUnitGroupSets.list({
                fields: 'id,' + (0, _helpers2.getDisplayPropertyUrl)(d2),
                pageing: false
            });
        }).then(function (groupSets) {
            return (0, _orgUnits.setOrgUnitGroupSets)(groupSets.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR));
    });
};

var changeOrgUnitCoordinate = exports.changeOrgUnitCoordinate = function changeOrgUnitCoordinate(action$) {
    return action$.ofType(types.ORGANISATION_UNIT_COORDINATE_CHANGE).concatMap(function (_ref3) {
        var layerId = _ref3.layerId,
            featureId = _ref3.featureId,
            coordinate = _ref3.coordinate;
        return (0, _api.apiFetch)('/organisationUnits/' + featureId, 'PATCH', {
            coordinates: JSON.stringify(coordinate)
        }).then(function (response) {
            if (response.ok) {
                return (0, _orgUnits.setOrgUnitCoordinate)(layerId, featureId, coordinate); // Update org. unit in redux store
            } else {
                return (0, _helpers.errorActionCreator)(types.ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR);
            }
        });
    });
};

// Load organisation unit tree path (temporary solution, as favorites don't include paths)
var loadOrgUnitPath = exports.loadOrgUnitPath = function loadOrgUnitPath(action$) {
    return action$.ofType(types.LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(d2) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt('return', d2.models.organisationUnit.get(action.id, {
                                    fields: 'path'
                                }));

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, undefined);
            }));

            return function (_x3) {
                return _ref4.apply(this, arguments);
            };
        }()).then(function (ou) {
            return (0, _layerEdit.setOrgUnitPath)(action.id, ou.path);
        }).catch((0, _helpers.errorActionCreator)(types.LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadOrgUnit, loadOrgUnitTree, loadOrgUnitLevels, loadOrgUnitGroups, loadOrgUnitGroupSets, changeOrgUnitCoordinate, loadOrgUnitPath);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadProgramStageDataElements = exports.loadProgramDataElements = exports.loadProgramTrackedEntityAttributes = exports.loadProgramIndicators = exports.loadProgramStages = exports.loadPrograms = undefined;

var _reduxObservable = __webpack_require__(47);

var _d = __webpack_require__(19);

__webpack_require__(91);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _api = __webpack_require__(59);

var _programs = __webpack_require__(142);

var _helpers = __webpack_require__(66);

var _helpers2 = __webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadPrograms = exports.loadPrograms = function loadPrograms(action$) {
    return action$.ofType(types.PROGRAMS_LOAD).concatMap(function () {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.programs.list({
                fields: 'id,displayName~rename(name)',
                paging: false
            });
        }).then(function (programs) {
            return (0, _programs.setPrograms)(programs.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAMS_LOAD_ERROR));
    });
};

// Load program stages
var loadProgramStages = exports.loadProgramStages = function loadProgramStages(action$) {
    return action$.ofType(types.PROGRAM_STAGES_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.program.get(action.programId, {
                fields: 'programStages[id,displayName~rename(name)]',
                paging: false
            });
        }).then(function (program) {
            return (0, _programs.setProgramStages)(action.programId, program.programStages.toArray());
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAM_STAGES_LOAD_ERROR));
    });
};

// Load program indicators
var loadProgramIndicators = exports.loadProgramIndicators = function loadProgramIndicators(action$) {
    return action$.ofType(types.PROGRAM_INDICATORS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.program.get(action.programId, {
                fields: 'programIndicators[dimensionItem~rename(id),displayName~rename(name)]',
                paging: false
            });
        }).then(function (program) {
            return (0, _programs.setProgramIndicators)(action.programId, (0, _sortBy2.default)('name', program.programIndicators));
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAM_INDICATORS_LOAD_ERROR));
    });
};

// Load program tracked entity attributes
var loadProgramTrackedEntityAttributes = exports.loadProgramTrackedEntityAttributes = function loadProgramTrackedEntityAttributes(action$) {
    return action$.ofType(types.PROGRAM_ATTRIBUTES_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.program.get(action.programId, {
                fields: 'programTrackedEntityAttributes[trackedEntityAttribute[id,displayName~rename(name),valueType,optionSet[id,displayName~rename(name)]]]',
                paging: false
            });
        }).then(function (program) {
            return (0, _programs.setProgramAttributes)(action.programId, program.programTrackedEntityAttributes.map(function (d) {
                return d.trackedEntityAttribute;
            }));
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAM_ATTRIBUTES_LOAD_ERROR));
    });
};

// Load program data elements
var loadProgramDataElements = exports.loadProgramDataElements = function loadProgramDataElements(action$) {
    return action$.ofType(types.PROGRAM_DATA_ELEMENTS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return (0, _api.apiFetch)('/programDataElements.json?program=' + action.programId + '&fields=dimensionItem~rename(id),' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ',valueType&paging=false');
        }).then(function (data) {
            return (0, _programs.setProgramDataElements)(action.programId, data.programDataElements);
        });
    });
};

// Load program stage data elements
var loadProgramStageDataElements = exports.loadProgramStageDataElements = function loadProgramStageDataElements(action$) {
    return action$.ofType(types.PROGRAM_STAGE_DATA_ELEMENTS_LOAD).concatMap(function (action) {
        return (0, _d.getInstance)().then(function (d2) {
            return d2.models.programStage.get(action.programStageId, {
                fields: 'programStageDataElements[dataElement[id,' + (0, _helpers2.getDisplayPropertyUrl)(d2) + ',valueType,optionSet[id,displayName~rename(name)]]]',
                paging: false
            });
        }).then(function (programStage) {
            return programStage.programStageDataElements.map(function (d) {
                return d.dataElement;
            });
        }).then(function (dataElements) {
            return (0, _programs.setProgramStageDataElements)(action.programStageId, dataElements);
        }).catch((0, _helpers.errorActionCreator)(types.PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(loadPrograms, loadProgramStages, loadProgramIndicators, loadProgramTrackedEntityAttributes, loadProgramDataElements, loadProgramStageDataElements);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveFavoriteInterpretation = exports.saveNewFavorite = exports.saveFavorite = undefined;

var _reduxObservable = __webpack_require__(47);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

var _message = __webpack_require__(498);

var _api = __webpack_require__(59);

var _favorites = __webpack_require__(261);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Save existing favorite
var saveFavorite = exports.saveFavorite = function saveFavorite(action$, store) {
    return action$.ofType(types.FAVORITE_SAVE).concatMap(function () {
        var config = (0, _favorites.cleanMapConfig)(store.getState().map);

        if (config.mapViews) {
            config.mapViews.forEach(function (view) {
                return delete view.id;
            });
        }

        return (0, _api.apiFetch)('/maps/' + config.id, 'PUT', config).then(function () {
            return (0, _message.setMessage)(_i18next2.default.t('Favorite') + ' "' + config.name + '" ' + _i18next2.default.t('is saved') + '.');
        });
    });
};

// Save new favorite
var saveNewFavorite = exports.saveNewFavorite = function saveNewFavorite(action$) {
    return action$.ofType(types.FAVORITE_SAVE_NEW).concatMap(function (_ref) {
        var config = _ref.config;
        return (0, _api.apiFetch)('/maps/', 'POST', config).then(function (response) {
            return response.status === 'OK' ? (0, _message.setMessage)(_i18next2.default.t('Favorite') + ' "' + config.name + '" ' + _i18next2.default.t('is saved') + '.') : (0, _message.setMessage)(_i18next2.default.t('Error') + ': ' + response.message);
        });
    });
};

// Save new favorite interpretation
var saveFavoriteInterpretation = exports.saveFavoriteInterpretation = function saveFavoriteInterpretation(action$) {
    return action$.ofType(types.FAVORITE_INTERPRETATION_SAVE).concatMap(function (_ref2) {
        var id = _ref2.id,
            interpretation = _ref2.interpretation;
        return (0, _api.apiFetch)('/interpretations/map/' + id, 'POST', interpretation).then(function (response) {
            return (0, _message.setMessage)(_i18next2.default.t(response.message));
        });
    });
};

exports.default = (0, _reduxObservable.combineEpics)(saveFavorite, saveNewFavorite, saveFavoriteInterpretation);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _App = __webpack_require__(805);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = function Root(_ref) {
    var d2 = _ref.d2,
        store = _ref.store;
    return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_App2.default, { d2: d2 })
    );
};

Root.propTypes = {
    store: _propTypes2.default.object.isRequired,
    d2: _propTypes2.default.object.isRequired
};

exports.default = Root;

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(504);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(803);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(591);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(591);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(592);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(804);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(504);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MuiThemeProvider = __webpack_require__(806);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _app = __webpack_require__(879);

var _app2 = _interopRequireDefault(_app);

var _MapProvider = __webpack_require__(880);

var _MapProvider2 = _interopRequireDefault(_MapProvider);

var _AppHeader = __webpack_require__(881);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _AppMenu = __webpack_require__(938);

var _AppMenu2 = _interopRequireDefault(_AppMenu);

var _LayersPanel = __webpack_require__(981);

var _LayersPanel2 = _interopRequireDefault(_LayersPanel);

var _LayersToggle = __webpack_require__(1020);

var _LayersToggle2 = _interopRequireDefault(_LayersToggle);

var _Map = __webpack_require__(1021);

var _Map2 = _interopRequireDefault(_Map);

var _BottomPanel = __webpack_require__(1022);

var _BottomPanel2 = _interopRequireDefault(_BottomPanel);

var _LayerEdit = __webpack_require__(1102);

var _LayerEdit2 = _interopRequireDefault(_LayerEdit);

var _ContextMenu = __webpack_require__(1222);

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

var _AboutDialog = __webpack_require__(1228);

var _AboutDialog2 = _interopRequireDefault(_AboutDialog);

var _AlertsDialog = __webpack_require__(1229);

var _AlertsDialog2 = _interopRequireDefault(_AlertsDialog);

var _Message = __webpack_require__(1230);

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Makes d2 available in all child components
// Not using AppWithD2 from d2-ui because it requires d2 to be a promise
var App = exports.App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                d2: this.props.d2
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _MuiThemeProvider2.default,
                { muiTheme: _app2.default },
                _react2.default.createElement(
                    _MapProvider2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { id: 'dhis-gis-container' },
                        _react2.default.createElement(_AppHeader2.default, null),
                        _react2.default.createElement(_AppMenu2.default, null),
                        _react2.default.createElement(_LayersPanel2.default, null),
                        _react2.default.createElement(_LayersToggle2.default, null),
                        _react2.default.createElement(_Map2.default, null),
                        _react2.default.createElement(_BottomPanel2.default, null),
                        _react2.default.createElement(_LayerEdit2.default, null),
                        _react2.default.createElement(_ContextMenu2.default, null),
                        _react2.default.createElement(_AboutDialog2.default, null),
                        _react2.default.createElement(_AlertsDialog2.default, null),
                        _react2.default.createElement(_Message2.default, null)
                    )
                )
            );
        }
    }]);

    return App;
}(_react.Component);

App.childContextTypes = {
    d2: _propTypes2.default.object.isRequired
};
exports.default = App;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__(602);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(808);
module.exports = __webpack_require__(44).Object.getPrototypeOf;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(235);
var $getPrototypeOf = __webpack_require__(593);

__webpack_require__(508)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(811);
var $Object = __webpack_require__(44).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(104);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(145), 'Object', { defineProperty: __webpack_require__(105).f });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(813), __esModule: true };

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(263);
__webpack_require__(519);
module.exports = __webpack_require__(520).f('iterator');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(513);
var defined = __webpack_require__(505);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(515);
var descriptor = __webpack_require__(236);
var setToStringTag = __webpack_require__(518);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(155)(IteratorPrototype, __webpack_require__(69)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(105);
var anObject = __webpack_require__(144);
var getKeys = __webpack_require__(237);

module.exports = __webpack_require__(145) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(146);
var toLength = __webpack_require__(600);
var toAbsoluteIndex = __webpack_require__(818);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(513);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(103).document;
module.exports = document && document.documentElement;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(821);
var step = __webpack_require__(822);
var Iterators = __webpack_require__(158);
var toIObject = __webpack_require__(146);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(596)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(824), __esModule: true };

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(825);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
module.exports = __webpack_require__(44).Symbol;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(103);
var has = __webpack_require__(143);
var DESCRIPTORS = __webpack_require__(145);
var $export = __webpack_require__(104);
var redefine = __webpack_require__(597);
var META = __webpack_require__(826).KEY;
var $fails = __webpack_require__(157);
var shared = __webpack_require__(507);
var setToStringTag = __webpack_require__(518);
var uid = __webpack_require__(262);
var wks = __webpack_require__(69);
var wksExt = __webpack_require__(520);
var wksDefine = __webpack_require__(521);
var enumKeys = __webpack_require__(827);
var isArray = __webpack_require__(828);
var anObject = __webpack_require__(144);
var isObject = __webpack_require__(156);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(510);
var createDesc = __webpack_require__(236);
var _create = __webpack_require__(515);
var gOPNExt = __webpack_require__(829);
var $GOPD = __webpack_require__(523);
var $DP = __webpack_require__(105);
var $keys = __webpack_require__(237);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(601).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(264).f = $propertyIsEnumerable;
  __webpack_require__(522).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(514)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(155)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(262)('meta');
var isObject = __webpack_require__(156);
var has = __webpack_require__(143);
var setDesc = __webpack_require__(105).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(157)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(237);
var gOPS = __webpack_require__(522);
var pIE = __webpack_require__(264);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(516);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(146);
var gOPN = __webpack_require__(601).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 830 */
/***/ (function(module, exports) {



/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('asyncIterator');


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('observable');


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(834), __esModule: true };

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(835);
module.exports = __webpack_require__(44).Object.setPrototypeOf;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(104);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(836).set });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(156);
var anObject = __webpack_require__(144);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(509)(Function.call, __webpack_require__(523).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(838), __esModule: true };

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(839);
var $Object = __webpack_require__(44).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(104);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(515) });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(263);
__webpack_require__(841);
module.exports = __webpack_require__(44).Array.from;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(509);
var $export = __webpack_require__(104);
var toObject = __webpack_require__(235);
var call = __webpack_require__(842);
var isArrayIter = __webpack_require__(843);
var toLength = __webpack_require__(600);
var createProperty = __webpack_require__(844);
var getIterFn = __webpack_require__(604);

$export($export.S + $export.F * !__webpack_require__(845)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(144);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(158);
var ITERATOR = __webpack_require__(69)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(105);
var createDesc = __webpack_require__(236);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(69)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(83)(module)))

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(106);

var _colorManipulator = __webpack_require__(147);

var _spacing = __webpack_require__(606);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__(850);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(852);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__(856);

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__(865);

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(851);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(607);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(608);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(609);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(525);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(853);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(855);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(525);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(608);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(609);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(607);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(854);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(610)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(857);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(858);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(859);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(860);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(861);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(862);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(863);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(159);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(611);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(866);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(867);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(868);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(869);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(870);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(871);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(872);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(526);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(526);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(611);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(526);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(525);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(265);

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(876);
module.exports = __webpack_require__(44).Object.keys;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(235);
var $keys = __webpack_require__(237);

__webpack_require__(508)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _colors = __webpack_require__(106);

var _colorManipulator = __webpack_require__(147);

var _spacing = __webpack_require__(606);

var _spacing2 = _interopRequireDefault(_spacing);

var _getMuiTheme = __webpack_require__(602);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copied from https://github.com/dhis2/maintenance-app/blob/master/src/App/app.theme.js - TODO: Add to d2-ui?
var theme = {
    spacing: _spacing2.default,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: _colors.blue500,
        primary2Color: _colors.blue800,
        primary3Color: _colors.blue100,
        accent1Color: _colors.blue800,
        textColor: _colors.darkBlack,
        alternateTextColor: _colors.white,
        canvasColor: _colors.white,
        borderColor: _colors.grey400,
        disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3)
    }
};

var muiTheme = (0, _getMuiTheme2.default)(theme, {
    tabs: {
        backgroundColor: '#fff',
        selectedTextColor: _colors.blue800,
        textColor: _colors.grey500
    }
});

exports.default = muiTheme;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _build = __webpack_require__(527);

var _build2 = _interopRequireDefault(_build);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Makes the Leaflet map instance available in all child components
var MapProvider = function (_Component) {
    _inherits(MapProvider, _Component);

    _createClass(MapProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                map: this.map
            };
        }
    }]);

    function MapProvider(props, context) {
        _classCallCheck(this, MapProvider);

        // Create map div
        var _this = _possibleConstructorReturn(this, (MapProvider.__proto__ || Object.getPrototypeOf(MapProvider)).call(this, props, context));

        var div = document.createElement('div');
        div.style.width = '100%';
        div.style.height = '100%';

        _this.map = (0, _build2.default)(div);
        // console.log('this.map', this.map.addControl);
        return _this;
    }

    _createClass(MapProvider, [{
        key: 'render',
        value: function render() {
            return _react.Children.only(this.props.children);
        }
    }]);

    return MapProvider;
}(_react.Component);

MapProvider.propTypes = {
    children: _propTypes2.default.element.isRequired
};

MapProvider.childContextTypes = {
    map: _propTypes2.default.object.isRequired
};

exports.default = MapProvider;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _home = __webpack_require__(937);

var _home2 = _interopRequireDefault(_home);

var _layout = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    header: {
        position: 'relative',
        boxSizing: 'border-box',
        height: 48,
        borderBottom: '1px solid #ddd'
    },
    logo: {
        boxSizing: 'border-box',
        position: 'absolute',
        width: _layout.LAYERS_PANEL_WIDTH + 1,
        height: '100%',
        padding: '4px 20px'
    },
    svg: {
        width: 74
    },
    title: {
        position: 'absolute',
        left: _layout.LAYERS_PANEL_WIDTH + 1,
        right: 0,
        height: '100%',
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '48px',
        marginTop: 2,
        marginLeft: 16
    },
    noFavorite: {
        color: '#aaa',
        fontStyle: 'italic'
    },
    star: {
        verticalAlign: 'middle',
        marginTop: -5,
        marginRight: 8,
        fill: '#bbb'
    },
    homeBtn: {
        position: 'absolute',
        right: 0
    },
    homeIcon: {
        fill: '#777'
    }
};

var AppHeader = exports.AppHeader = function AppHeader(_ref) {
    var name = _ref.name;
    return _react2.default.createElement(
        'div',
        { style: styles.header },
        _react2.default.createElement(
            'div',
            { style: styles.logo },
            _react2.default.createElement(
                'svg',
                {
                    style: styles.svg,
                    viewBox: '0 0 400 233.33',
                    xmlns: 'http://www.w3.org/2000/svg',
                    display: 'block'
                },
                _react2.default.createElement(
                    'g',
                    { fillRule: 'evenodd' },
                    _react2.default.createElement('path', {
                        d: 'M61.709 67.458c.063 17.337.047 16.968 1.017 23.417.276 1.833-.062 2.02-1.127.625-6.259-8.209-19.501-12.133-32.611-9.666-17.62 3.316-27.441 20.003-25.814 43.861C4.7 148.07 16.634 160.558 36.5 160.568c10.941.006 19.555-3.722 24.899-10.776.971-1.282.784-1.649 3.328 6.541l.905 2.917 7.101.043 7.1.044V51.333H61.65l.059 16.125M106 105.333v54h18.153l.056-22.041c.063-24.6.019-23.626 1.286-28.51 2.345-9.045 7.93-13.383 18.168-14.115 9.292-.664 15.048 2.384 17.344 9.185 1.12 3.319 1.052 1.488 1.114 29.856l.056 25.625h18.156v-26.125c-.001-16.914-.063-26.8-.176-28.041-1.245-13.637-8.659-21.381-22.519-23.521-14.009-2.164-27.238 1.954-32.853 10.225-.437.643-.627.788-1.038.791l-.502.005.288-2.875c.51-5.081.631-9.744.633-24.25l.001-14.209H106v54m106.756-52.159c-5.24.825-7.909 3.861-7.92 9.008-.012 5.962 3.896 9.194 10.816 8.944 6.153-.223 9.417-3.364 9.396-9.043-.024-6.379-5.08-10.045-12.292-8.909M272 81.27c-18.419 1.587-28.234 9.783-27.02 22.565.965 10.166 6.582 15.116 24.52 21.608 17.105 6.191 21.293 9.634 19.342 15.903-2.618 8.412-22.26 8.962-41.804 1.17-.941-.376-1.785-.683-1.875-.683-.104 0-.163 2.569-.163 7.081v7.082l.625.269c12.045 5.19 34.308 5.897 46.165 1.467 10.373-3.875 15.693-11.417 15.154-21.482-.577-10.787-5.85-15.511-25.111-22.502-14.97-5.434-18.232-7.437-19.016-11.676-1.618-8.751 13.789-10.841 32.85-4.455 2.062.69 3.846 1.266 3.963 1.278.181.018 6.128-12.202 5.996-12.321-.024-.021-1.055-.416-2.293-.878-5.44-2.031-10.812-3.322-17.166-4.125-1.983-.251-12.225-.469-14.167-.301m-66.167 39.48v38.417H224V82.333h-18.167v38.417M45.968 94.939c12.003 1.708 16.858 10.072 16.481 28.394-.333 16.204-5.504 22.834-18.612 23.866-14.23 1.121-21.727-7.193-22.121-24.532-.46-20.223 8.114-30.025 24.252-27.728',
                        fill: '#194f90'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M355.25 56.447c-11.836.604-24.275 5.368-32.993 12.636l-.6.5 4.35 4.834c2.393 2.658 4.6 5.087 4.905 5.397l.554.563 2.642-1.753c8.936-5.932 14.971-8.012 23.309-8.032 13.145-.032 19.638 7.968 16.502 20.331-2.215 8.732-6.372 13.368-37.544 41.872l-15.208 13.906v12.466h75.666v-14.5h-26.512c-22.702 0-26.504-.034-26.458-.235.044-.193 14.177-12.744 20.637-18.327 19.554-16.899 26.547-26.394 28.101-38.156 2.618-19.815-12.727-32.757-37.351-31.502',
                        fill: '#4dc6ff'
                    })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { style: _extends({}, styles.title, !name ? styles.noFavorite : {}) },
            name ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_SvgIcon2.default, { icon: 'Star', style: styles.star }),
                name
            ) : _i18next2.default.t('No favorite selected'),
            _react2.default.createElement(
                _IconButton2.default,
                {
                    onClick: function onClick() {
                        return window.location.href = '../dhis-web-commons-about/redirect.action';
                    },
                    style: styles.homeBtn,
                    iconStyle: styles.homeIcon
                },
                _react2.default.createElement(_home2.default, null)
            )
        )
    );
};

AppHeader.propTypes = {
    name: _propTypes2.default.string
};

AppHeader.defaultProps = {
    name: ''
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        name: state.map ? state.map.name : null
    };
})(AppHeader);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(617);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Tooltip = __webpack_require__(892);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _childUtils = __webpack_require__(618);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      boxSizing: 'border-box',
      overflow: 'visible',
      transition: _transitions2.default.easeOut(),
      padding: baseTheme.spacing.iconSize / 2,
      width: baseTheme.spacing.iconSize * 2,
      height: baseTheme.spacing.iconSize * 2,
      fontSize: 0
    },
    tooltip: {
      boxSizing: 'border-box'
    },
    disabled: {
      color: baseTheme.palette.disabledColor,
      fill: baseTheme.palette.disabledColor,
      cursor: 'default'
    }
  };
}

var IconButton = function (_Component) {
  (0, _inherits3.default)(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      // Not to be confonded with the touch property.
      // This state is to determined if it's a mobile device.
      touch: false,
      tooltipShown: false
    }, _this.handleBlur = function (event) {
      _this.hideTooltip();
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      _this.showTooltip();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.button.isKeyboardFocused()) {
        _this.hideTooltip();
      }
      _this.setState({ hovered: false });
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseOut = function (event) {
      if (_this.props.disabled) _this.hideTooltip();
      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
    }, _this.handleMouseEnter = function (event) {
      _this.showTooltip();

      // Cancel hover styles for touch devices
      if (!_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onKeyboardFocus = _this$props.onKeyboardFocus;

      if (isKeyboardFocused && !disabled) {
        _this.showTooltip();
        if (onFocus) {
          onFocus(event);
        }
      } else {
        _this.hideTooltip();
        if (onBlur) {
          onBlur(event);
        }
      }

      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      if (onKeyboardFocus) {
        onKeyboardFocus(event, isKeyboardFocused);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hovered: false });
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus() {
      this.button.setKeyboardFocus();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      if (this.props.tooltip) {
        this.setState({ tooltipShown: true });
      }
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      if (this.props.tooltip) this.setState({ tooltipShown: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          hoveredStyle = _props.hoveredStyle,
          disableTouchRipple = _props.disableTouchRipple,
          children = _props.children,
          iconClassName = _props.iconClassName,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipPositionProp = _props.tooltipPosition,
          tooltipStyles = _props.tooltipStyles,
          touch = _props.touch,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);

      var fonticon = void 0;

      var styles = getStyles(this.props, this.context);
      var tooltipPosition = tooltipPositionProp.split('-');

      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});

      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
        label: tooltip,
        show: this.state.tooltipShown,
        touch: touch,
        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
        verticalPosition: tooltipPosition[0],
        horizontalPosition: tooltipPosition[1]
      }) : null;

      if (iconClassName) {
        var iconHoverColor = iconStyle.iconHoverColor,
            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);


        fonticon = _react2.default.createElement(
          _FontIcon2.default,
          {
            className: iconClassName,
            hoverColor: disabled ? null : iconHoverColor,
            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
            color: this.context.muiTheme.baseTheme.palette.textColor
          },
          children
        );
      }

      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({
          ref: function ref(_ref2) {
            return _this2.button = _ref2;
          }
        }, other, {
          centerRipple: true,
          disabled: disabled,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          disableTouchRipple: disableTouchRipple,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onMouseOut: this.handleMouseOut,
          onKeyboardFocus: this.handleKeyboardFocus
        }),
        tooltipElement,
        fonticon,
        (0, _childUtils.extendChildren)(children, {
          style: childrenStyle
        })
      );
    }
  }]);
  return IconButton;
}(_react.Component);

IconButton.muiName = 'IconButton';
IconButton.defaultProps = {
  disabled: false,
  disableTouchRipple: false,
  iconStyle: {},
  tooltipPosition: 'bottom-center',
  touch: false
};
IconButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconButton.propTypes =  false ? {
  /**
   * Can be used to pass a `FontIcon` element as the icon for the button.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the element will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when the component is hovered.
   */
  hoveredStyle: _propTypes2.default.object,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the icon element.
   * Note: you can specify iconHoverColor as a String inside this object.
   */
  iconStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} keyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseOut: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to supply to the element's tooltip.
   */
  tooltip: _propTypes2.default.node,
  /**
   * The vertical and horizontal positions, respectively, of the element's tooltip.
   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
   * "bottom-left", and "top-left".
   */
  tooltipPosition: _propTypes4.default.cornersAndCenter,
  /**
   * Override the inline-styles of the tooltip element.
   */
  tooltipStyles: _propTypes2.default.object,
  /**
   * If true, increase the tooltip element's size. Useful for increasing tooltip
   * readability on mobile devices.
   */
  touch: _propTypes2.default.bool
} : {};
exports.default = IconButton;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(884);
module.exports = __webpack_require__(44).Object.assign;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(104);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(885) });


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(237);
var gOPS = __webpack_require__(522);
var pIE = __webpack_require__(264);
var toObject = __webpack_require__(235);
var IObject = __webpack_require__(599);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(157)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(267);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__(889);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),
/* 887 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var color = props.color,
      hoverColor = props.hoverColor;
  var baseTheme = context.muiTheme.baseTheme;

  var offColor = color || baseTheme.palette.textColor;
  var onColor = hoverColor || offColor;

  return {
    root: {
      color: state.hovered ? onColor : offColor,
      position: 'relative',
      fontSize: baseTheme.spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: _transitions2.default.easeOut()
    }
  };
}

var FontIcon = function (_Component) {
  (0, _inherits3.default)(FontIcon, _Component);

  function FontIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FontIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FontIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hoverColor = _props.hoverColor,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
      }));
    }
  }]);
  return FontIcon;
}(_react.Component);

FontIcon.muiName = 'FontIcon';
FontIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
FontIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FontIcon.propTypes =  false ? {
  /**
   * This is the font color of the font icon. If not specified,
   * this component will default to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FontIcon;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var verticalPosition = props.verticalPosition;
  var horizontalPosition = props.horizontalPosition;
  var touchMarginOffset = props.touch ? 10 : 0;
  var touchOffsetTop = props.touch ? -20 : -10;
  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      zIndex = _context$muiTheme.zIndex,
      tooltip = _context$muiTheme.tooltip,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'absolute',
      fontFamily: baseTheme.fontFamily,
      fontSize: '10px',
      lineHeight: '22px',
      padding: '0 8px',
      zIndex: zIndex.tooltip,
      color: tooltip.color,
      overflow: 'hidden',
      top: -10000,
      borderRadius: borderRadius,
      userSelect: 'none',
      opacity: 0,
      right: horizontalPosition === 'left' ? 12 : null,
      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    label: {
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    ripple: {
      position: 'absolute',
      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
      top: verticalPosition === 'bottom' ? 0 : '100%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    },
    rootWhenShown: {
      top: verticalPosition === 'top' ? touchOffsetTop : 36,
      opacity: tooltip.opacity,
      transform: 'translate(0px, ' + offset + 'px)',
      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    rootWhenTouched: {
      fontSize: '14px',
      lineHeight: '32px',
      padding: '0 16px'
    },
    rippleWhenShown: {
      backgroundColor: tooltip.rippleBackgroundColor,
      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    }
  };

  return styles;
}

var Tooltip = function (_Component) {
  (0, _inherits3.default)(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      offsetWidth: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRippleSize();
      this.setTooltipPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setTooltipPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setRippleSize();
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var ripple = this.refs.ripple;
      var tooltip = this.refs.tooltip;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);

      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.props.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    }
  }, {
    key: 'setTooltipPosition',
    value: function setTooltipPosition() {
      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          horizontalPosition = _props.horizontalPosition,
          label = _props.label,
          show = _props.show,
          touch = _props.touch,
          verticalPosition = _props.verticalPosition,
          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: 'tooltip',
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
        }),
        _react2.default.createElement('div', {
          ref: 'ripple',
          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          label
        )
      );
    }
  }]);
  return Tooltip;
}(_react.Component);

Tooltip.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tooltip.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
  label: _propTypes2.default.node.isRequired,
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  touch: _propTypes2.default.bool,
  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};
exports.default = Tooltip;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAdd = function ContentAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
  );
};
ContentAdd = (0, _pure2.default)(ContentAdd);
ContentAdd.displayName = 'ContentAdd';
ContentAdd.muiName = 'SvgIcon';

exports.default = ContentAdd;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(619);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(620);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function (_Component) {
  (0, _inherits3.default)(SvgIcon, _Component);

  function SvgIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          hoverColor = _props.hoverColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          style = _props.style,
          viewBox = _props.viewBox,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
      var _context$muiTheme = this.context.muiTheme,
          svgIcon = _context$muiTheme.svgIcon,
          prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);
  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};
exports.default = SvgIcon;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationApps = function NavigationApps(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
  );
};
NavigationApps = (0, _pure2.default)(NavigationApps);
NavigationApps.displayName = 'NavigationApps';
NavigationApps.muiName = 'SvgIcon';

exports.default = NavigationApps;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDownward = function NavigationArrowDownward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
  );
};
NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
NavigationArrowDownward.displayName = 'NavigationArrowDownward';
NavigationArrowDownward.muiName = 'SvgIcon';

exports.default = NavigationArrowDownward;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
  );
};

NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
NavigationArrowDropRight.muiName = 'SvgIcon';

exports.default = NavigationArrowDropRight;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowUpward = function NavigationArrowUpward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
  );
};
NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
NavigationArrowUpward.displayName = 'NavigationArrowUpward';
NavigationArrowUpward.muiName = 'SvgIcon';

exports.default = NavigationArrowUpward;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationBusiness = function CommunicationBusiness(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
  );
};
CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
CommunicationBusiness.displayName = 'CommunicationBusiness';
CommunicationBusiness.muiName = 'SvgIcon';

exports.default = CommunicationBusiness;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCancel = function NavigationCancel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
  );
};
NavigationCancel = (0, _pure2.default)(NavigationCancel);
NavigationCancel.displayName = 'NavigationCancel';
NavigationCancel.muiName = 'SvgIcon';

exports.default = NavigationCancel;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentClear = function ContentClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
ContentClear = (0, _pure2.default)(ContentClear);
ContentClear.displayName = 'ContentClear';
ContentClear.muiName = 'SvgIcon';

exports.default = ContentClear;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationClose = function NavigationClose(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
NavigationClose = (0, _pure2.default)(NavigationClose);
NavigationClose.displayName = 'NavigationClose';
NavigationClose.muiName = 'SvgIcon';

exports.default = NavigationClose;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCreate = function ContentCreate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
ContentCreate = (0, _pure2.default)(ContentCreate);
ContentCreate.displayName = 'ContentCreate';
ContentCreate.muiName = 'SvgIcon';

exports.default = ContentCreate;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropFree = function ImageCropFree(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
  );
};
ImageCropFree = (0, _pure2.default)(ImageCropFree);
ImageCropFree.displayName = 'ImageCropFree';
ImageCropFree.muiName = 'SvgIcon';

exports.default = ImageCropFree;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDelete = function ActionDelete(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDelete = (0, _pure2.default)(ActionDelete);
ActionDelete.displayName = 'ActionDelete';
ActionDelete.muiName = 'SvgIcon';

exports.default = ActionDelete;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDescription = function ActionDescription(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
  );
};
ActionDescription = (0, _pure2.default)(ActionDescription);
ActionDescription.displayName = 'ActionDescription';
ActionDescription.muiName = 'SvgIcon';

exports.default = ActionDescription;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDone = function ActionDone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
  );
};
ActionDone = (0, _pure2.default)(ActionDone);
ActionDone.displayName = 'ActionDone';
ActionDone.muiName = 'SvgIcon';

exports.default = ActionDone;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorDragHandle = function EditorDragHandle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
  );
};
EditorDragHandle = (0, _pure2.default)(EditorDragHandle);
EditorDragHandle.displayName = 'EditorDragHandle';
EditorDragHandle.muiName = 'SvgIcon';

exports.default = EditorDragHandle;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationEmail = function CommunicationEmail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
CommunicationEmail.displayName = 'CommunicationEmail';
CommunicationEmail.muiName = 'SvgIcon';

exports.default = CommunicationEmail;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExtension = function ActionExtension(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
  );
};
ActionExtension = (0, _pure2.default)(ActionExtension);
ActionExtension.displayName = 'ActionExtension';
ActionExtension.muiName = 'SvgIcon';

exports.default = ActionExtension;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFontDownload = function ContentFontDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
  );
};
ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
ContentFontDownload.displayName = 'ContentFontDownload';
ContentFontDownload.muiName = 'SvgIcon';

exports.default = ContentFontDownload;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroup = function SocialGroup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
  );
};
SocialGroup = (0, _pure2.default)(SocialGroup);
SocialGroup.displayName = 'SocialGroup';
SocialGroup.muiName = 'SvgIcon';

exports.default = SocialGroup;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageGridOn = function ImageGridOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
  );
};
ImageGridOn = (0, _pure2.default)(ImageGridOn);
ImageGridOn.displayName = 'ImageGridOn';
ImageGridOn.muiName = 'SvgIcon';

exports.default = ImageGridOn;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInfoOutline = function ActionInfoOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
  );
};
ActionInfoOutline = (0, _pure2.default)(ActionInfoOutline);
ActionInfoOutline.displayName = 'ActionInfoOutline';
ActionInfoOutline.muiName = 'SvgIcon';

exports.default = ActionInfoOutline;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertChart = function EditorInsertChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
  );
};
EditorInsertChart = (0, _pure2.default)(EditorInsertChart);
EditorInsertChart.displayName = 'EditorInsertChart';
EditorInsertChart.muiName = 'SvgIcon';

exports.default = EditorInsertChart;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionList = function ActionList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
  );
};
ActionList = (0, _pure2.default)(ActionList);
ActionList.displayName = 'ActionList';
ActionList.muiName = 'SvgIcon';

exports.default = ActionList;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLaunch = function ActionLaunch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
  );
};
ActionLaunch = (0, _pure2.default)(ActionLaunch);
ActionLaunch.displayName = 'ActionLaunch';
ActionLaunch.muiName = 'SvgIcon';

exports.default = ActionLaunch;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationMessage = function CommunicationMessage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
CommunicationMessage.displayName = 'CommunicationMessage';
CommunicationMessage.muiName = 'SvgIcon';

exports.default = CommunicationMessage;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreVert = function NavigationMoreVert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
NavigationMoreVert.displayName = 'NavigationMoreVert';
NavigationMoreVert.muiName = 'SvgIcon';

exports.default = NavigationMoreVert;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvNotInterested = function AvNotInterested(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
  );
};
AvNotInterested = (0, _pure2.default)(AvNotInterested);
AvNotInterested.displayName = 'AvNotInterested';
AvNotInterested.muiName = 'SvgIcon';

exports.default = AvNotInterested;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPerson = function SocialPerson(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
  );
};
SocialPerson = (0, _pure2.default)(SocialPerson);
SocialPerson.displayName = 'SocialPerson';
SocialPerson.muiName = 'SvgIcon';

exports.default = SocialPerson;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPublic = function SocialPublic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
  );
};
SocialPublic = (0, _pure2.default)(SocialPublic);
SocialPublic.displayName = 'SocialPublic';
SocialPublic.muiName = 'SvgIcon';

exports.default = SocialPublic;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReply = function ContentReply(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
  );
};
ContentReply = (0, _pure2.default)(ContentReply);
ContentReply.displayName = 'ContentReply';
ContentReply.muiName = 'SvgIcon';

exports.default = ContentReply;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRoom = function ActionRoom(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
ActionRoom = (0, _pure2.default)(ActionRoom);
ActionRoom.displayName = 'ActionRoom';
ActionRoom.muiName = 'SvgIcon';

exports.default = ActionRoom;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSearch = function ActionSearch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
  );
};
ActionSearch = (0, _pure2.default)(ActionSearch);
ActionSearch.displayName = 'ActionSearch';
ActionSearch.muiName = 'SvgIcon';

exports.default = ActionSearch;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorShowChart = function EditorShowChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
  );
};
EditorShowChart = (0, _pure2.default)(EditorShowChart);
EditorShowChart.displayName = 'EditorShowChart';
EditorShowChart.muiName = 'SvgIcon';

exports.default = EditorShowChart;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStar = function ToggleStar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
  );
};
ToggleStar = (0, _pure2.default)(ToggleStar);
ToggleStar.displayName = 'ToggleStar';
ToggleStar.muiName = 'SvgIcon';

exports.default = ToggleStar;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStarBorder = function ToggleStarBorder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
  );
};
ToggleStarBorder = (0, _pure2.default)(ToggleStarBorder);
ToggleStarBorder.displayName = 'ToggleStarBorder';
ToggleStarBorder.muiName = 'SvgIcon';

exports.default = ToggleStarBorder;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThumbUp = function ActionThumbUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
  );
};
ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
ActionThumbUp.displayName = 'ActionThumbUp';
ActionThumbUp.muiName = 'SvgIcon';

exports.default = ActionThumbUp;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewList = function ActionViewList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
  );
};
ActionViewList = (0, _pure2.default)(ActionViewList);
ActionViewList.displayName = 'ActionViewList';
ActionViewList.muiName = 'SvgIcon';

exports.default = ActionViewList;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVisibility = function ActionVisibility(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ActionVisibility = (0, _pure2.default)(ActionVisibility);
ActionVisibility.displayName = 'ActionVisibility';
ActionVisibility.muiName = 'SvgIcon';

exports.default = ActionVisibility;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVisibilityOff = function ActionVisibilityOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
  );
};
ActionVisibilityOff = (0, _pure2.default)(ActionVisibilityOff);
ActionVisibilityOff.displayName = 'ActionVisibilityOff';
ActionVisibilityOff.muiName = 'SvgIcon';

exports.default = ActionVisibilityOff;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentDissatisfied = function SocialSentimentDissatisfied(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' })
  );
};
SocialSentimentDissatisfied = (0, _pure2.default)(SocialSentimentDissatisfied);
SocialSentimentDissatisfied.displayName = 'SocialSentimentDissatisfied';
SocialSentimentDissatisfied.muiName = 'SvgIcon';

exports.default = SocialSentimentDissatisfied;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHome = function ActionHome(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
  );
};
ActionHome = (0, _pure2.default)(ActionHome);
ActionHome.displayName = 'ActionHome';
ActionHome.muiName = 'SvgIcon';

exports.default = ActionHome;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppMenu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Toolbar = __webpack_require__(623);

var _FlatButton = __webpack_require__(162);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _AddLayer = __webpack_require__(945);

var _AddLayer2 = _interopRequireDefault(_AddLayer);

var _FavoritesMenu = __webpack_require__(956);

var _FavoritesMenu2 = _interopRequireDefault(_FavoritesMenu);

var _about = __webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Button from 'd2-ui/lib/button/Button';
var styles = {
    toolbar: {
        position: 'absolute',
        width: '100%',
        height: 40,
        backgroundColor: '#f3f3f3',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.227451)',
        zIndex: 1200
    },
    button: {
        color: '#333',
        height: 40,
        margin: 0,
        padding: '4px 16px 0 16px',
        minWidth: 50
    }
}; // TODO: Support buttons with without uppercase in d2-ui
var AppMenu = exports.AppMenu = function AppMenu(_ref) {
    var openAboutDialog = _ref.openAboutDialog;
    return _react2.default.createElement(
        _Toolbar.Toolbar,
        { style: styles.toolbar, className: 'dhis-gis-menu' },
        _react2.default.createElement(
            _Toolbar.ToolbarGroup,
            { firstChild: true },
            _react2.default.createElement(_AddLayer2.default, null),
            _react2.default.createElement(_FavoritesMenu2.default, null)
        ),
        _react2.default.createElement(
            _Toolbar.ToolbarGroup,
            { lastChild: true },
            _react2.default.createElement(
                _FlatButton2.default,
                { onClick: openAboutDialog, style: styles.button },
                _i18next2.default.t('About')
            )
        )
    );
};

AppMenu.propTypes = {
    openAboutDialog: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(null, { openAboutDialog: _about.openAboutDialog })(AppMenu);

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var noGutter = props.noGutter;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      backgroundColor: toolbar.backgroundColor,
      height: toolbar.height,
      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
}

var Toolbar = function (_Component) {
  (0, _inherits3.default)(Toolbar, _Component);

  function Toolbar() {
    (0, _classCallCheck3.default)(this, Toolbar);
    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Toolbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          noGutter = _props.noGutter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children
      );
    }
  }]);
  return Toolbar;
}(_react.Component);

Toolbar.defaultProps = {
  noGutter: false
};
Toolbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Toolbar.propTypes =  false ? {
  /**
   * Can be a `ToolbarGroup` to render a group of related items.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Do not apply `desktopGutter` to the `Toolbar`.
   */
  noGutter: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Toolbar;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var firstChild = props.firstChild,
      lastChild = props.lastChild;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      toolbar = _context$muiTheme.toolbar;


  var marginHorizontal = baseTheme.spacing.desktopGutter;
  var marginVertical = (toolbar.height - button.height) / 2;

  var styles = {
    root: {
      position: 'relative',
      marginLeft: firstChild ? -marginHorizontal : undefined,
      marginRight: lastChild ? -marginHorizontal : undefined,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    dropDownMenu: {
      root: {
        color: toolbar.color, // removes hover color change, we want to keep it
        marginRight: baseTheme.spacing.desktopGutter,
        flex: 1,
        whiteSpace: 'nowrap'
      },
      controlBg: {
        backgroundColor: toolbar.menuHoverColor,
        borderRadius: 0
      },
      underline: {
        display: 'none'
      }
    },
    button: {
      margin: marginVertical + 'px ' + marginHorizontal + 'px',
      position: 'relative'
    },
    icon: {
      root: {
        cursor: 'pointer',
        lineHeight: toolbar.height + 'px',
        paddingLeft: baseTheme.spacing.desktopGutter
      }
    },
    span: {
      color: toolbar.iconColor,
      lineHeight: toolbar.height + 'px'
    }
  };

  return styles;
}

var ToolbarGroup = function (_Component) {
  (0, _inherits3.default)(ToolbarGroup, _Component);

  function ToolbarGroup() {
    (0, _classCallCheck3.default)(this, ToolbarGroup);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarGroup, [{
    key: 'handleMouseLeaveFontIcon',
    value: function handleMouseLeaveFontIcon(style) {
      return function (event) {
        event.target.style.zIndex = 'auto';
        event.target.style.color = style.root.color;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          firstChild = _props.firstChild,
          lastChild = _props.lastChild,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        if (!currentChild) {
          return null;
        }
        if (!currentChild.type) {
          return currentChild;
        }
        switch (currentChild.type.muiName) {
          case 'DropDownMenu':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
              underlineStyle: styles.dropDownMenu.underline
            });
          case 'RaisedButton':
          case 'FlatButton':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
            });
          case 'FontIcon':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
            });
          case 'ToolbarSeparator':
          case 'ToolbarTitle':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
            });
          default:
            return currentChild;
        }
      }, this);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        newChildren
      );
    }
  }]);
  return ToolbarGroup;
}(_react.Component);

ToolbarGroup.defaultProps = {
  firstChild: false,
  lastChild: false
};
ToolbarGroup.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarGroup.propTypes =  false ? {
  /**
   * Can be any node or number of nodes.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
   * to prevent setting the left gap.
   */
  firstChild: _propTypes2.default.bool,
  /**
   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
   * to prevent setting the right gap.
   */
  lastChild: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarGroup;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      backgroundColor: toolbar.separatorColor,
      display: 'block',
      height: baseTheme.spacing.desktopGutterMore,
      marginLeft: baseTheme.spacing.desktopGutter,
      width: 1
    }
  };
}

var ToolbarSeparator = function (_Component) {
  (0, _inherits3.default)(ToolbarSeparator, _Component);

  function ToolbarSeparator() {
    (0, _classCallCheck3.default)(this, ToolbarSeparator);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarSeparator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
    }
  }]);
  return ToolbarSeparator;
}(_react.Component);

ToolbarSeparator.muiName = 'ToolbarSeparator';
ToolbarSeparator.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarSeparator.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarSeparator;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      paddingRight: baseTheme.spacing.desktopGutterLess,
      lineHeight: toolbar.height + 'px',
      fontSize: toolbar.titleFontSize,
      fontFamily: baseTheme.fontFamily,
      position: 'relative',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  };
}

var ToolbarTitle = function (_Component) {
  (0, _inherits3.default)(ToolbarTitle, _Component);

  function ToolbarTitle() {
    (0, _classCallCheck3.default)(this, ToolbarTitle);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          text = _props.text,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
        }, other),
        text
      );
    }
  }]);
  return ToolbarTitle;
}(_react.Component);

ToolbarTitle.muiName = 'ToolbarTitle';
ToolbarTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarTitle.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to be displayed.
   */
  text: _propTypes2.default.node
} : {};
exports.default = ToolbarTitle;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(147);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__(944);

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  (0, _inherits3.default)(FlatButton, _Component);

  function FlatButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          children = _props.children,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          hoverColor = _props.hoverColor,
          icon = _props.icon,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          primary = _props.primary,
          rippleColor = _props.rippleColor,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
      var _context$muiTheme = this.context.muiTheme,
          borderRadius = _context$muiTheme.borderRadius,
          _context$muiTheme$but = _context$muiTheme.button,
          buttonHeight = _context$muiTheme$but.height,
          buttonMinWidth = _context$muiTheme$but.minWidth,
          buttonTextTransform = _context$muiTheme$but.textTransform,
          _context$muiTheme$fla = _context$muiTheme.flatButton,
          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
          buttonColor = _context$muiTheme$fla.color,
          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
          fontSize = _context$muiTheme$fla.fontSize,
          fontWeight = _context$muiTheme$fla.fontWeight,
          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
          textColor = _context$muiTheme$fla.textColor,
          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: fullWidth ? '100%' : buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: borderRadius,
        userSelect: 'none',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        var iconStyles = (0, _simpleAssign2.default)({
          verticalAlign: 'middle',
          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
          marginRight: label && labelPosition === 'before' ? 12 : 0
        }, icon.props.style);
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: iconStyles,
          key: 'iconCloned'
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          focusRippleColor: buttonRippleColor,
          focusRippleOpacity: 0.3,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          touchRippleColor: buttonRippleColor,
          touchRippleOpacity: 0.3
        }),
        enhancedButtonChildren
      );
    }
  }]);
  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButton.propTypes =  false ? {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The element to use as the container for the FlatButton. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * FlatButton in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * Use this property to display an icon.
   */
  icon: _propTypes2.default.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _propTypes2.default.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _propTypes2.default.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FlatButton;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  (0, _inherits3.default)(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    (0, _classCallCheck3.default)(this, FlatButtonLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        label
      );
    }
  }]);
  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButtonLabel.propTypes =  false ? {
  label: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = FlatButtonLabel;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddLayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _FlatButton = __webpack_require__(162);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _addCircleOutline = __webpack_require__(946);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _AddLayerPopover = __webpack_require__(947);

var _AddLayerPopover2 = _interopRequireDefault(_AddLayerPopover);

var _layers = __webpack_require__(101);

var _layout = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: Support buttons with without uppercase in d2-ui


var styles = {
    button: {
        color: '#333',
        height: 40,
        margin: 0,
        padding: '4px 16px 0 16px',
        minWidth: 50
    },
    addLayer: {
        position: 'relative',
        boxSizing: 'border-box',
        width: _layout.LAYERS_PANEL_WIDTH + 1,
        borderRight: '1px solid #ddd',
        textAlign: 'left',
        paddingLeft: 48
    },
    addCircle: {
        position: 'absolute',
        top: 8,
        left: 18,
        fill: '#333'
    },
    dropDown: {
        position: 'absolute',
        top: 8,
        right: 8,
        fill: '#333'
    }
};

var AddLayer = exports.AddLayer = function (_Component) {
    _inherits(AddLayer, _Component);

    function AddLayer(props) {
        _classCallCheck(this, AddLayer);

        var _this = _possibleConstructorReturn(this, (AddLayer.__proto__ || Object.getPrototypeOf(AddLayer)).call(this, props));

        _this.handleClick = function (event) {
            event.preventDefault(); // This prevents ghost click.
            _this.setState({
                anchorEl: event.currentTarget
            });
            _this.props.openLayersDialog();
        };

        _this.state = {};
        return _this;
    }

    _createClass(AddLayer, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return [_react2.default.createElement(
                _FlatButton2.default,
                {
                    key: 'button',
                    onClick: function onClick(event) {
                        return _this2.handleClick(event);
                    },
                    style: _extends({}, styles.button, styles.addLayer)
                },
                _react2.default.createElement(_addCircleOutline2.default, { style: styles.addCircle }),
                ' ',
                _i18next2.default.t('Add layer')
            ), _react2.default.createElement(_AddLayerPopover2.default, { key: 'popover', anchorEl: this.state.anchorEl })];
        }
    }]);

    return AddLayer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, { openLayersDialog: _layers.openLayersDialog })(AddLayer);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
ContentAddCircleOutline.muiName = 'SvgIcon';

exports.default = ContentAddCircleOutline;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _Popover = __webpack_require__(268);

var _Popover2 = _interopRequireDefault(_Popover);

var _LayerList = __webpack_require__(952);

var _LayerList2 = _interopRequireDefault(_LayerList);

var _layers = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddLayerPopover = function AddLayerPopover(_ref) {
    var anchorEl = _ref.anchorEl,
        layersDialogOpen = _ref.layersDialogOpen,
        layers = _ref.layers,
        onRequestClose = _ref.onRequestClose,
        onLayerSelect = _ref.onLayerSelect;
    return _react2.default.createElement(
        _Popover2.default,
        {
            anchorEl: anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' },
            onRequestClose: onRequestClose,
            open: layersDialogOpen
        },
        _react2.default.createElement(_LayerList2.default, { layers: layers, onLayerSelect: onLayerSelect })
    );
};

AddLayerPopover.propTypes = {
    layersDialogOpen: _propTypes2.default.bool,
    layers: _propTypes2.default.array,
    onRequestClose: _propTypes2.default.func.isRequired,
    onLayerSelect: _propTypes2.default.func.isRequired
};

AddLayerPopover.defaultProps = {
    layersDialogOpen: false,
    layers: []
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        layers: state.layers,
        layersDialogOpen: state.ui.layersDialogOpen
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onRequestClose: function onRequestClose() {
            return dispatch((0, _layers.closeLayersDialog)());
        },
        onLayerSelect: function onLayerSelect(layer) {
            if (layer.type === 'external') {
                dispatch((0, _layers.addLayer)(_extends({}, layer, { isLoaded: true })));
            } else {
                dispatch((0, _layers.editLayer)(_extends({}, layer)));
            }

            dispatch((0, _layers.closeLayersDialog)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddLayerPopover);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = undefined;

var _defineProperty = __webpack_require__(511);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineProperty(o, p, attr) {
  return (0, _defineProperty2.default)(o, p, attr);
}

// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;

// IE8+ Support
var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;

// Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
var passiveOption = exports.passiveOption = function () {
  var cache = null;

  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (e) {} // eslint-disable-line no-empty

    cache = supportsPassiveOption;

    return supportsPassiveOption;
  }();
}();

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var rounded = props.rounded,
      circle = props.circle,
      transitionEnabled = props.transitionEnabled,
      zDepth = props.zDepth;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      paper = _context$muiTheme.paper,
      borderRadius = _context$muiTheme.borderRadius;


  return {
    root: {
      color: paper.color,
      backgroundColor: paper.backgroundColor,
      transition: transitionEnabled && _transitions2.default.easeOut(),
      boxSizing: 'border-box',
      fontFamily: baseTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
    }
  };
}

var Paper = function (_Component) {
  (0, _inherits3.default)(Paper, _Component);

  function Paper() {
    (0, _classCallCheck3.default)(this, Paper);
    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Paper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          circle = _props.circle,
          rounded = _props.rounded,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return Paper;
}(_react.Component);

Paper.defaultProps = {
  circle: false,
  rounded: true,
  transitionEnabled: true,
  zDepth: 1
};
Paper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Paper.propTypes =  false ? {
  /**
   * Children passed into the paper element.
   */
  children: _propTypes2.default.node,
  /**
   * Set to true to generate a circular paper container.
   */
  circle: _propTypes2.default.bool,
  /**
   * By default, the paper container will have a border radius.
   * Set this to false to generate a container with sharp corners.
   */
  rounded: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Set to false to disable CSS transitions for the paper element.
   */
  transitionEnabled: _propTypes2.default.bool,
  /**
   * This number represents the zDepth of the paper shadow.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Paper;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
      maxHeight: '100%'
    },
    horizontal: {
      maxHeight: '100%',
      overflowY: 'auto',
      transform: open ? 'scaleX(1)' : 'scaleX(0)',
      opacity: open ? 1 : 0,
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
    },
    vertical: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
    }
  };
}

var PopoverAnimationDefault = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationDefault, _Component);

  function PopoverAnimationDefault() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationDefault, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.horizontal) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.vertical) },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopoverAnimationDefault;
}(_react.Component);

PopoverAnimationDefault.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationDefault.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationDefault.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationDefault;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Layer = __webpack_require__(953);

var _Layer2 = _interopRequireDefault(_Layer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerList = function LayerList(_ref) {
    var layers = _ref.layers,
        onLayerSelect = _ref.onLayerSelect;
    return _react2.default.createElement(
        'div',
        { className: 'LayerList' },
        layers.map(function (layer, index) {
            return _react2.default.createElement(_Layer2.default, {
                key: 'layer-' + index,
                onClick: onLayerSelect,
                layer: layer
            });
        })
    );
};

LayerList.propTypes = {
    layers: _propTypes2.default.array.isRequired,
    onLayerSelect: _propTypes2.default.func.isRequired
};

exports.default = LayerList;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layer = function Layer(_ref) {
    var layer = _ref.layer,
        _onClick = _ref.onClick;
    var img = layer.img,
        type = layer.type,
        name = layer.name;


    return _react2.default.createElement(
        'div',
        { className: 'Layer', onClick: function onClick() {
                return _onClick(layer);
            } },
        img ? _react2.default.createElement('img', { src: img, className: 'Layer-image' }) : _react2.default.createElement(
            'div',
            { className: 'Layer-no-image' },
            'External layer'
        ),
        _react2.default.createElement(
            'div',
            { className: 'Layer-name' },
            name || type
        )
    );
};

Layer.propTypes = {
    layer: _propTypes2.default.object.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Layer;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(955);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./Layer.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./Layer.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".LayerList {\n    padding: 16px 0 0 16px;\n    overflow-y: auto;\n    max-width: 680px;\n    max-height: calc(100vh - 150px);\n}\n\n.Layer {\n    float: left;\n    width: 120px;\n    margin-right: 16px;\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 160px;\n}\n\n.Layer-image {\n    box-sizing: border-box;\n    border: 1px solid #555;\n    width: 120px;\n    height: 120px;\n}\n\n.Layer-no-image {\n    box-sizing: border-box;\n    border: 1px solid #555;\n    width: 120px;\n    height: 120px;\n    line-height: 120px;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    margin-bottom: 4px;\n}\n\n.Layer-name {\n    font-size: 14px;\n    color: #333;\n    padding-bottom: 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _FlatButton = __webpack_require__(162);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _Popover = __webpack_require__(268);

var _Popover2 = _interopRequireDefault(_Popover);

var _Menu = __webpack_require__(625);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(164);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _FavoritesDialog = __webpack_require__(965);

var _FavoritesDialog2 = _interopRequireDefault(_FavoritesDialog);

var _SaveNewFavoriteDialog = __webpack_require__(967);

var _SaveNewFavoriteDialog2 = _interopRequireDefault(_SaveNewFavoriteDialog);

var _InterpretationDialog = __webpack_require__(979);

var _InterpretationDialog2 = _interopRequireDefault(_InterpretationDialog);

var _LinksDialog = __webpack_require__(980);

var _LinksDialog2 = _interopRequireDefault(_LinksDialog);

var _map = __webpack_require__(154);

var _dataTable = __webpack_require__(271);

var _favorites = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: Support buttons with without uppercase in d2-ui


var styles = {
    button: {
        color: '#333',
        height: 40,
        margin: 0,
        padding: '4px 16px 0 16px',
        minWidth: 50
    },
    popover: {
        marginLeft: 10
    }
};

var FavoritesMenu = function (_Component) {
    _inherits(FavoritesMenu, _Component);

    function FavoritesMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FavoritesMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FavoritesMenu.__proto__ || Object.getPrototypeOf(FavoritesMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showInterpretationDialog: false,
            showLinksDialog: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FavoritesMenu, [{
        key: 'openMenu',
        value: function openMenu(evt) {
            this.setState({ anchorEl: evt.currentTarget });
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            this.setState({ anchorEl: null });
        }
    }, {
        key: 'onNewMapClick',
        value: function onNewMapClick() {
            this.closeMenu();
            this.props.closeDataTable();
            this.props.newMap();
        }
    }, {
        key: 'onLoadClick',
        value: function onLoadClick() {
            this.closeMenu();
            this.props.openFavoritesDialog();
        }
    }, {
        key: 'onSaveClick',
        value: function onSaveClick() {
            this.closeMenu();
            this.props.saveFavorite();
        }
    }, {
        key: 'onSaveNewClick',
        value: function onSaveNewClick() {
            this.closeMenu();
            this.props.openSaveNewFavoriteDialog();
        }
    }, {
        key: 'onWriteInterpretationClick',
        value: function onWriteInterpretationClick() {
            this.closeMenu();
            this.setState({ showInterpretationDialog: true });
        }
    }, {
        key: 'onGetLinkClick',
        value: function onGetLinkClick() {
            this.closeMenu();
            this.setState({ showLinksDialog: true });
        }
    }, {
        key: 'onDialogClose',
        value: function onDialogClose() {
            this.setState({
                showInterpretationDialog: false,
                showLinksDialog: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                mapId = _props.mapId,
                saveFavoriteInterpretation = _props.saveFavoriteInterpretation;
            var _state = this.state,
                anchorEl = _state.anchorEl,
                showInterpretationDialog = _state.showInterpretationDialog,
                showLinksDialog = _state.showLinksDialog;


            return [React.createElement(
                _FlatButton2.default,
                {
                    key: 'favorites-btn',
                    onClick: function onClick(evt) {
                        return _this2.openMenu(evt);
                    },
                    style: styles.button
                },
                _i18next2.default.t('Favorites')
            ), React.createElement(
                _Popover2.default,
                {
                    key: 'favorites-menu',
                    open: Boolean(anchorEl),
                    anchorEl: anchorEl,
                    onRequestClose: function onRequestClose(evt) {
                        return _this2.closeMenu();
                    },
                    style: styles.popover
                },
                React.createElement(
                    _Menu2.default,
                    null,
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('New'),
                        onClick: function onClick() {
                            return _this2.onNewMapClick();
                        }
                    }),
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('Open'),
                        onClick: function onClick() {
                            return _this2.onLoadClick();
                        }
                    }),
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('Save'),
                        onClick: function onClick() {
                            return _this2.onSaveClick();
                        },
                        disabled: mapId === undefined
                    }),
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('Save as'),
                        onClick: function onClick() {
                            return _this2.onSaveNewClick();
                        }
                    }),
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('Write interpretation'),
                        onClick: function onClick() {
                            return _this2.onWriteInterpretationClick();
                        },
                        disabled: mapId === undefined
                    }),
                    React.createElement(_MenuItem2.default, {
                        primaryText: _i18next2.default.t('Get link'),
                        onClick: function onClick() {
                            return _this2.onGetLinkClick();
                        },
                        disabled: mapId === undefined
                    })
                )
            ), React.createElement(_FavoritesDialog2.default, { key: 'favorite-load' }), React.createElement(_SaveNewFavoriteDialog2.default, { key: 'favorite-save' }), showInterpretationDialog && React.createElement(_InterpretationDialog2.default, {
                key: 'interpretation',
                favoriteId: mapId,
                onSave: function onSave(id, interpretation) {
                    saveFavoriteInterpretation(id, interpretation);
                    _this2.onDialogClose();
                },
                onClose: function onClose() {
                    return _this2.onDialogClose();
                }
            }), showLinksDialog && React.createElement(_LinksDialog2.default, {
                key: 'links',
                favoriteId: mapId,
                onClose: function onClose() {
                    return _this2.onDialogClose();
                }
            })];
        }
    }]);

    return FavoritesMenu;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        mapId: state.map.id,
        favoritesDialogOpen: state.favorite.dialogOpen
    };
}, {
    newMap: _map.newMap,
    saveFavorite: _favorites.saveFavorite,
    openFavoritesDialog: _favorites.openFavoritesDialog,
    openSaveNewFavoriteDialog: _favorites.openSaveNewFavoriteDialog,
    saveFavoriteInterpretation: _favorites.saveFavoriteInterpretation,
    closeDataTable: _dataTable.closeDataTable
})(FavoritesMenu);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Subheader = __webpack_require__(958);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheader = function Subheader(props, context) {
  var children = props.children,
      inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      prepareStyles = _context$muiTheme.prepareStyles,
      subheader = _context$muiTheme.subheader;


  var styles = {
    root: {
      boxSizing: 'border-box',
      color: subheader.color,
      fontSize: 14,
      fontWeight: subheader.fontWeight,
      lineHeight: '48px',
      paddingLeft: inset ? 72 : 16,
      width: '100%'
    }
  };

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    children
  );
};

Subheader.muiName = 'Subheader';

Subheader.propTypes =  false ? {
  /**
   * Node that will be placed inside the `Subheader`.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the `Subheader` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Subheader.defaultProps = {
  inset: false
};

Subheader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Subheader;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotKeyHolder = undefined;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotKeyHolder = exports.HotKeyHolder = function () {
  function HotKeyHolder() {
    var _this = this;

    (0, _classCallCheck3.default)(this, HotKeyHolder);

    this.clear = function () {
      _this.timerId = null;
      _this.lastKeys = null;
    };
  }

  (0, _createClass3.default)(HotKeyHolder, [{
    key: 'append',
    value: function append(key) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(this.clear, 500);
      return this.lastKeys = (this.lastKeys || '') + key;
    }
  }]);
  return HotKeyHolder;
}();

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCheck = function NavigationCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
  );
};
NavigationCheck = (0, _pure2.default)(NavigationCheck);
NavigationCheck.displayName = 'NavigationCheck';
NavigationCheck.muiName = 'SvgIcon';

exports.default = NavigationCheck;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(147);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _expandLess = __webpack_require__(962);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(963);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _NestedList = __webpack_require__(964);

var _NestedList2 = _interopRequireDefault(_NestedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
      insetChildren = props.insetChildren,
      leftAvatar = props.leftAvatar,
      leftCheckbox = props.leftCheckbox,
      leftIcon = props.leftIcon,
      nestedItems = props.nestedItems,
      nestedLevel = props.nestedLevel,
      rightAvatar = props.rightAvatar,
      rightIcon = props.rightIcon,
      rightIconButton = props.rightIconButton,
      rightToggle = props.rightToggle,
      secondaryText = props.secondaryText,
      secondaryTextLines = props.secondaryTextLines;
  var muiTheme = context.muiTheme;
  var listItem = muiTheme.listItem;


  var textColor = muiTheme.baseTheme.palette.textColor;
  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
  var twoLine = secondaryText && secondaryTextLines === 1;
  var threeLine = secondaryText && secondaryTextLines > 1;

  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;

  var styles = {
    root: {
      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
      color: textColor,
      display: 'block',
      fontSize: 16,
      lineHeight: '16px',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },

    // This inner div is needed so that ripples will span the entire container
    innerDiv: {
      marginLeft: nestedLevel * listItem.nestedLevelDepth,
      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
      paddingBottom: singleAvatar ? 20 : 16,
      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
      position: 'relative'
    },

    icons: {
      height: 24,
      width: 24,
      display: 'block',
      position: 'absolute',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      margin: 12
    },

    leftIcon: {
      left: 4
    },

    rightIcon: {
      right: 4
    },

    avatars: {
      position: 'absolute',
      top: singleAvatar ? 8 : 16
    },

    label: {
      cursor: 'pointer'
    },

    leftAvatar: {
      left: 16
    },

    rightAvatar: {
      right: 16
    },

    leftCheckbox: {
      position: 'absolute',
      display: 'block',
      width: 24,
      top: twoLine ? 24 : singleAvatar ? 16 : 12,
      left: 16
    },

    primaryText: {},

    rightIconButton: {
      position: 'absolute',
      display: 'block',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      right: 4
    },

    rightToggle: {
      position: 'absolute',
      display: 'block',
      width: 54,
      top: twoLine ? 25 : singleAvatar ? 17 : 13,
      right: 8
    },

    secondaryText: {
      fontSize: 14,
      lineHeight: threeLine ? '18px' : '16px',
      height: threeLine ? 36 : 16,
      margin: 0,
      marginTop: 4,
      color: listItem.secondaryTextColor,

      // needed for 2 and 3 line ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: threeLine ? null : 'nowrap',
      display: threeLine ? '-webkit-box' : null,
      WebkitLineClamp: threeLine ? 2 : null,
      WebkitBoxOrient: threeLine ? 'vertical' : null
    }
  };

  return styles;
}

var ListItem = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      open: false,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (_this.props.primaryTogglesNestedList) {
        _this.handleNestedListToggle(event);
      }
    }, _this.handleNestedListToggle = function (event) {
      if (_this.props.leftCheckbox) {
        event.preventDefault();
      }
      event.stopPropagation();

      if (_this.props.open === null) {
        _this.setState({ open: !_this.state.open }, function () {
          _this.props.onNestedListToggle(_this);
        });
      } else {
        // Exposing `this` in the callback is quite a bad API.
        // I'm doing a one level deep clone to expose a fake state.open.
        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
          state: {
            open: !_this.state.open
          }
        }));
      }
    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
      if (isKeyboardFocused) {
        _this.setState({
          isKeyboardFocused: false,
          rightIconButtonKeyboardFocused: isKeyboardFocused
        });
      }

      var iconButton = _this.props.rightIconButton;

      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleRightIconButtonMouseLeave = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: false });
      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
    }, _this.handleRightIconButtonMouseEnter = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: true });
      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
    }, _this.handleRightIconButtonMouseUp = function (event) {
      var iconButton = _this.props.rightIconButton;
      event.stopPropagation();
      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
    }, _this.handleRightIconButtonClick = function (event) {
      var iconButton = _this.props.rightIconButton;

      // Stop the event from bubbling up to the list-item
      event.stopPropagation();
      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _this.handleTouchEnd = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchEnd(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.open !== null) this.setState({ open: nextProps.open });
      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }

    // This method is needed by the `MenuItem` component.

  }, {
    key: 'applyFocusState',
    value: function applyFocusState(focusState) {
      if (this.button) {
        var buttonEl = _reactDom2.default.findDOMNode(this.button);

        switch (focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            this.button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  }, {
    key: 'createDisabledElement',
    value: function createDisabledElement(styles, contentChildren, additionalProps) {
      var _props = this.props,
          innerDivStyle = _props.innerDivStyle,
          style = _props.style;


      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createLabelElement',
    value: function createLabelElement(styles, contentChildren, additionalProps) {
      var _props2 = this.props,
          innerDivStyle = _props2.innerDivStyle,
          style = _props2.style;


      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

      return _react2.default.createElement(
        'label',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createTextElement',
    value: function createTextElement(styles, data, key) {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      if (_react2.default.isValidElement(data)) {
        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
        if (typeof data.type === 'string') {
          // if element is a native dom node
          style = prepareStyles(style);
        }
        return _react2.default.cloneElement(data, {
          key: key,
          style: style
        });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: prepareStyles(styles) },
        data
      );
    }
  }, {
    key: 'pushElement',
    value: function pushElement(children, element, baseStyles, additionalProps) {
      if (element) {
        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
          key: children.length,
          style: styles
        }, additionalProps)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          hoverColor = _props3.hoverColor,
          initiallyOpen = _props3.initiallyOpen,
          innerDivStyle = _props3.innerDivStyle,
          insetChildren = _props3.insetChildren,
          leftAvatar = _props3.leftAvatar,
          leftCheckbox = _props3.leftCheckbox,
          leftIcon = _props3.leftIcon,
          nestedItems = _props3.nestedItems,
          nestedLevel = _props3.nestedLevel,
          nestedListStyle = _props3.nestedListStyle,
          onKeyboardFocus = _props3.onKeyboardFocus,
          isKeyboardFocused = _props3.isKeyboardFocused,
          onMouseEnter = _props3.onMouseEnter,
          onMouseLeave = _props3.onMouseLeave,
          onNestedListToggle = _props3.onNestedListToggle,
          onTouchStart = _props3.onTouchStart,
          onClick = _props3.onClick,
          rightAvatar = _props3.rightAvatar,
          rightIcon = _props3.rightIcon,
          rightIconButton = _props3.rightIconButton,
          rightToggle = _props3.rightToggle,
          primaryText = _props3.primaryText,
          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
          secondaryText = _props3.secondaryText,
          secondaryTextLines = _props3.secondaryTextLines,
          style = _props3.style,
          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var contentChildren = [children];

      if (leftIcon) {
        var additionalProps = {
          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
        };
        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
      }

      if (rightIcon) {
        var _additionalProps = {
          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
        };
        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
      }

      if (leftAvatar) {
        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
      }

      if (rightAvatar) {
        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
      }

      if (leftCheckbox) {
        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
      }

      // RightIconButtonElement
      var hasNestListItems = nestedItems.length;
      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

      if (rightIconButton || needsNestedIndicator) {
        var rightIconButtonElement = rightIconButton;
        var rightIconButtonHandlers = {
          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
          onMouseEnter: this.handleRightIconButtonMouseEnter,
          onMouseLeave: this.handleRightIconButtonMouseLeave,
          onClick: this.handleRightIconButtonClick,
          onMouseDown: this.handleRightIconButtonMouseUp,
          onMouseUp: this.handleRightIconButtonMouseUp
        };

        // Create a nested list indicator icon if we don't have an icon on the right
        if (needsNestedIndicator) {
          rightIconButtonElement = this.state.open ? _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandLess2.default, null)
          ) : _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandMore2.default, null)
          );
          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
        }

        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
      }

      if (rightToggle) {
        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
      }

      if (primaryText) {
        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
        contentChildren.push(primaryTextElement);
      }

      if (secondaryText) {
        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
        contentChildren.push(secondaryTextElement);
      }

      var nestedList = nestedItems.length ? _react2.default.createElement(
        _NestedList2.default,
        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
        nestedItems
      ) : undefined;

      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);

      return _react2.default.createElement(
        'div',
        null,
        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({
            containerElement: containerElement
          }, other, {
            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
            onKeyboardFocus: this.handleKeyboardFocus,
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onClick: this.handleClick,
            disabled: disabled,
            ref: function ref(node) {
              return _this2.button = node;
            },
            style: (0, _simpleAssign2.default)({}, styles.root, style)
          }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
            contentChildren
          )
        ),
        nestedList
      );
    }
  }]);
  return ListItem;
}(_react.Component);

ListItem.muiName = 'ListItem';
ListItem.defaultProps = {
  autoGenerateNestedIndicator: true,
  containerElement: 'span',
  disableKeyboardFocus: false,
  disabled: false,
  initiallyOpen: false,
  insetChildren: false,
  nestedItems: [],
  nestedLevel: 0,
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onNestedListToggle: function onNestedListToggle() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {},
  open: null,
  primaryTogglesNestedList: false,
  secondaryTextLines: 1
};
ListItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ListItem.propTypes =  false ? {
  /**
   * If true, generate a nested-list-indicator icon when nested list
   * items are detected. Note that an indicator will not be created
   * if a `rightIcon` or `rightIconButton` has been provided to
   * the element.
   */
  autoGenerateNestedIndicator: _propTypes2.default.bool,
  /**
   * Children passed into the `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * The element to use as the container for the ListItem. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * ListItem in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element will not be able to be focused by the keyboard.
   */
  disableKeyboardFocus: _propTypes2.default.bool,
  /**
   * If true, the element will not be clickable
   * and will not display hover effects.
   * This is automatically disabled if either `leftCheckbox`
   * or `rightToggle` is set.
   */
  disabled: _propTypes2.default.bool,
  /**
  * Override the hover background color.
  */
  hoverColor: _propTypes2.default.string,
  /**
   * If true, the nested `ListItem`s are initially displayed.
   */
  initiallyOpen: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner div element.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * Use to control if the list item should render as keyboard focused.  If
   * undefined (default), this will be automatically managed.  If provided,
   * it will change the components style.  Note that this will not change the
   * actual focus - and should only be used when you want to simulate
   * keyboard focus (eg. in a rich text input autocomplete).
   */
  isKeyboardFocused: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the left side.
   */
  leftAvatar: _propTypes2.default.element,
  /**
   * This is the `Checkbox` element to be displayed on the left side.
   */
  leftCheckbox: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * An array of `ListItem`s to nest underneath the current `ListItem`.
   */
  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Controls how deep a `ListItem` appears.
   * This property is automatically managed, so modify at your own risk.
   */
  nestedLevel: _propTypes2.default.number,
  /**
   * Override the inline-styles of the nested items' `NestedList`.
   */
  nestedListStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the list item is clicked.
   *
   * @param {object} event Click event targeting the list item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` toggles its nested list.
   *
   * @param {object} listItem The `ListItem`.
   */
  onNestedListToggle: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Control toggle state of nested list.
   */
  open: _propTypes2.default.bool,
  /**
   * This is the block element that contains the primary text.
   * If a string is passed in, a div tag will be rendered.
   */
  primaryText: _propTypes2.default.node,
  /**
   * If true, clicking or tapping the primary text of the `ListItem`
   * toggles the nested list.
   */
  primaryTogglesNestedList: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the right side.
   */
  rightAvatar: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * This is the `IconButton` to be displayed on the right side.
   * Hovering over this button will remove the `ListItem` hover.
   * Also, clicking on this button will not trigger a
   * ripple on the `ListItem`; the event will be stopped and prevented
   * from bubbling up to cause a `ListItem` click.
   */
  rightIconButton: _propTypes2.default.element,
  /**
   * This is the `Toggle` element to display on the right side.
   */
  rightToggle: _propTypes2.default.element,
  /**
   * This is the block element that contains the secondary text.
   * If a string is passed in, a div tag will be rendered.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Can be 1 or 2. This is the number of secondary
   * text lines before ellipsis will show.
   */
  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ListItem;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandLess = function NavigationExpandLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
  );
};
NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
NavigationExpandLess.displayName = 'NavigationExpandLess';
NavigationExpandLess.muiName = 'SvgIcon';

exports.default = NavigationExpandLess;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandMore = function NavigationExpandMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
  );
};
NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
NavigationExpandMore.displayName = 'NavigationExpandMore';
NavigationExpandMore.muiName = 'SvgIcon';

exports.default = NavigationExpandMore;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(627);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedList = function NestedList(props) {
  var children = props.children,
      open = props.open,
      nestedLevel = props.nestedLevel,
      style = props.style;


  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    _List2.default,
    { style: style },
    _react.Children.map(children, function (child) {
      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
        nestedLevel: nestedLevel + 1
      }) : child;
    })
  );
};

NestedList.propTypes =  false ? {
  children: _propTypes2.default.node,
  nestedLevel: _propTypes2.default.number.isRequired,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = NestedList;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(14);

var _d2UiFavorites = __webpack_require__(966);

var _d2UiFavorites2 = _interopRequireDefault(_d2UiFavorites);

var _favorites = __webpack_require__(270);

var _dataTable = __webpack_require__(271);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoritesDialog = function FavoritesDialog(_ref, context) {
    var dialogOpen = _ref.dialogOpen,
        onFavoriteSelect = _ref.onFavoriteSelect,
        closeFavoritesDialog = _ref.closeFavoritesDialog;
    return React.createElement(_d2UiFavorites2.default, {
        type: 'map',
        open: dialogOpen,
        onRequestClose: closeFavoritesDialog,
        onFavoriteSelect: onFavoriteSelect,
        d2: context.d2
    });
};

FavoritesDialog.contextTypes = {
    d2: _propTypes2.default.object // .isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeFavoritesDialog: function closeFavoritesDialog() {
            return dispatch((0, _favorites.closeFavoritesDialog)());
        },
        onFavoriteSelect: function onFavoriteSelect(id) {
            dispatch((0, _dataTable.closeDataTable)());
            dispatch((0, _favorites.closeFavoritesDialog)());
            dispatch((0, _favorites.loadFavorite)(id));
        }
    };
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dialogOpen: state.favorite.dialogOpen
    };
}, mapDispatchToProps)(FavoritesDialog);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FavoritesDialog=t(require("react")):e.FavoritesDialog=t(e.React)}("undefined"!=typeof self?self:this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=172)}([function(t,n){t.exports=e},function(e,t,n){e.exports=n(175)()},function(e,t,n){"use strict";t.__esModule=!0;var r=n(108),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){return ee||(ee=(0,W.default)())}Object.defineProperty(t,"__esModule",{value:!0}),t.sheetsManager=void 0;var i=n(31),a=r(i),u=n(2),s=r(u),l=n(8),c=r(l),f=n(7),d=r(f),p=n(9),h=r(p),y=n(10),v=r(y),m=n(11),b=r(m),g=n(3),_=r(g),w=n(235),x=r(w),O=n(251),S=r(O),T=n(0),E=r(T),C=n(1),k=r(C),P=n(12),M=(r(P),n(44)),j=r(M),N=n(129),I=(r(N),n(40)),A=(r(I),n(254)),R=r(A),F=n(131),D=n(130),L=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(D),z=n(137),V=r(z),U=n(88),W=r(U),H=n(91),B=r(H),K=n(140),q=r(K),G=n(298),Y=r(G),X=(0,F.create)((0,V.default)()),$=(0,q.default)(),Q=S.default,J=t.sheetsManager=new x.default,Z={},ee=void 0,te=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return function(n){var r=t.withTheme,i=void 0!==r&&r,u=t.flip,l=void 0===u?null:u,f=t.name,p=(0,_.default)(t,["withTheme","flip","name"]),y=(0,Y.default)(e),m=y.themingEnabled||i||"string"==typeof f;Q+=1,y.options.index=Q;var g=function(e){function t(e,n){(0,d.default)(this,t);var r=(0,v.default)(this,(t.__proto__||(0,c.default)(t)).call(this,e,n));r.state={},r.disableStylesGeneration=!1,r.jss=null,r.sheetOptions=null,r.sheetsManager=J,r.stylesCreatorSaved=null,r.theme=null,r.unsubscribeId=null,r.jss=r.context[L.jss]||X;var i=r.context.muiThemeProviderOptions;return i&&(i.sheetsManager&&(r.sheetsManager=i.sheetsManager),r.disableStylesGeneration=i.disableStylesGeneration),r.stylesCreatorSaved=y,r.sheetOptions=(0,s.default)({generateClassName:$},r.context[L.sheetOptions]),r.theme=m?B.default.initial(n)||o():Z,r}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){this.attach(this.theme)}},{key:"componentDidMount",value:function(){var e=this;m&&(this.unsubscribeId=B.default.subscribe(this.context,function(t){var n=e.theme;e.theme=t,e.attach(e.theme),e.setState({},function(){e.detach(n)})}))}},{key:"componentWillReceiveProps",value:function(){this.stylesCreatorSaved,0}},{key:"componentWillUnmount",value:function(){this.detach(this.theme),null!==this.unsubscribeId&&B.default.unsubscribe(this.context,this.unsubscribeId)}},{key:"attach",value:function(e){if(!this.disableStylesGeneration){var t=this.stylesCreatorSaved,n=this.sheetsManager.get(t);n||(n=new x.default,this.sheetsManager.set(t,n));var r=n.get(e);if(r||(r={refs:0,sheet:null},n.set(e,r)),0===r.refs){var o=t.create(e,f),i=f,a=this.jss.createStyleSheet(o,(0,s.default)({meta:i,classNamePrefix:i,flip:"boolean"==typeof l?l:"rtl"===e.direction,link:!1},this.sheetOptions,t.options,{name:f},p));r.sheet=a,a.attach();var u=this.context[L.sheetsRegistry];u&&u.add(a)}r.refs+=1}}},{key:"detach",value:function(e){if(!this.disableStylesGeneration){var t=this.stylesCreatorSaved,n=this.sheetsManager.get(t),r=n.get(e);if(r.refs-=1,0===r.refs){n.delete(e),this.jss.removeStyleSheet(r.sheet);var o=this.context[L.sheetsRegistry];o&&o.remove(r.sheet)}}}},{key:"render",value:function(){var e=this.props,t=e.classes,r=e.innerRef,o=(0,_.default)(e,["classes","innerRef"]),u=void 0,l={};if(!this.disableStylesGeneration){var c=this.sheetsManager.get(this.stylesCreatorSaved),f=c.get(this.theme);l=f.sheet.classes}u=t?(0,s.default)({},l,(0,a.default)(t).reduce(function(e,n){return t[n]&&(e[n]=l[n]+" "+t[n]),e},{})):l;var d={};return i&&(d.theme=this.theme),E.default.createElement(n,(0,s.default)({classes:u},d,o,{ref:r}))}}]),t}(E.default.Component);return g.propTypes={},g.contextTypes=(0,s.default)({muiThemeProviderOptions:k.default.object},R.default,m?B.default.contextTypes:{}),(0,j.default)(g,n),g}};t.default=te},function(e,t,n){var r,o;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var a in r)i.call(r,a)&&r[a]&&e.push(a)}}return e.join(" ")}var i={}.hasOwnProperty;void 0!==e&&e.exports?e.exports=n:(r=[],void 0!==(o=function(){return n}.apply(t,r))&&(e.exports=o))}()},function(e,t,n){"use strict";t.__esModule=!0;var r=n(78),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t,n){return t in e?(0,o.default)(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t,n){e.exports={default:n(211),__esModule:!0}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(78),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()},function(e,t,n){"use strict";t.__esModule=!0;var r=n(48),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,o.default)(t))&&"function"!=typeof t?e:t}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(228),i=r(o),a=n(232),u=r(a),s=n(48),l=r(s);t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,l.default)(t)));e.prototype=(0,u.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(i.default?(0,i.default)(e,t):e.__proto__=t)}},function(e,t,n){"use strict";var r=function(){};e.exports=r},function(e,t){var n=e.exports={version:"2.5.3"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(19),o=n(13),i=n(27),a=n(25),u=function(e,t,n){var s,l,c,f=e&u.F,d=e&u.G,p=e&u.S,h=e&u.P,y=e&u.B,v=e&u.W,m=d?o:o[t]||(o[t]={}),b=m.prototype,g=d?r:p?r[t]:(r[t]||{}).prototype;d&&(n=t);for(s in n)(l=!f&&g&&void 0!==g[s])&&s in m||(c=l?g[s]:n[s],m[s]=d&&"function"!=typeof g[s]?n[s]:y&&l?i(c,r):v&&g[s]==c?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(c):h&&"function"==typeof c?i(Function.call,c):c,h&&((m.virtual||(m.virtual={}))[s]=c,e&u.R&&b&&!b[s]&&a(b,s,c)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t,n){var r=n(75)("wks"),o=n(46),i=n(19).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){var r=n(28),o=n(110),i=n(69),a=Object.defineProperty;t.f=n(20)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){"use strict";function r(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r)}catch(e){console.error(e)}}r(),e.exports=n(300)},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){e.exports=!n(29)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return e.charAt(0).toUpperCase()+e.slice(1)}function i(e,t){return(0,d.default)(t).every(function(n){return e.hasOwnProperty(n)&&e[n]===t[n]})}function a(e,t){for(var n=void 0===t?"undefined":(0,c.default)(t),r=0;r<e.length;r+=1){if("function"===n&&!0==!!t(e[r],r,e))return r;if("object"===n&&i(e[r],t))return r;if(-1!==["string","number","boolean"].indexOf(n))return e.indexOf(t)}return-1}function u(e,t){var n=a(e,t);return n>-1?e[n]:void 0}function s(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.filter(function(e){return null!=e}).reduce(function(e,t){return function(){for(var n=arguments.length,r=Array(n),o=0;o<n;o++)r[o]=arguments[o];e.apply(this,r),t.apply(this,r)}},function(){})}Object.defineProperty(t,"__esModule",{value:!0});var l=n(48),c=r(l),f=n(31),d=r(f);t.capitalize=o,t.contains=i,t.findIndex=a,t.find=u,t.createChainedFunction=s;var p=n(12);r(p)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){"use strict";function r(e){return e&&e.ownerDocument||document}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(375);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){var r=n(17),o=n(37);e.exports=n(20)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(372),i=r(o),a=n(374),u=r(a),s=n(161),l=(r(s),n(40)),c=(r(l),function(e){var t=(0,i.default)(function(e,t){return!(0,u.default)(e,t)});return t(e)});t.default=c},function(e,t,n){var r=n(109);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var r=n(22);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){e.exports={default:n(209),__esModule:!0}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(174),o=n(100),i=n(180);n.d(t,"Provider",function(){return r.b}),n.d(t,"createProvider",function(){return r.a}),n.d(t,"connectAdvanced",function(){return o.a}),n.d(t,"connect",function(){return i.a})},function(e,t,n){var r=n(70),o=n(72);e.exports=function(e){return r(o(e))}},function(e,t,n){var r=n(72);e.exports=function(e){return Object(r(e))}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(12),l=r(s),c=n(85),f=r(c),d=n(52),p=r(d),h=function(){function e(t,n,r){o(this,e),this.type="style",this.isProcessed=!1;var i=r.sheet,a=r.Renderer,u=r.selector;this.key=t,this.options=r,this.style=n,u&&(this.selectorText=u),this.renderer=i?i.renderer:new a}return u(e,[{key:"prop",value:function(e,t){if(void 0===t)return this.style[e];if(this.style[e]===t)return this;t=this.options.jss.plugins.onChangeValue(t,e,this);var n=null==t||!1===t,r=e in this.style;if(n&&!r)return this;var o=n&&r;if(o?delete this.style[e]:this.style[e]=t,this.renderable)return o?this.renderer.removeProperty(this.renderable,e):this.renderer.setProperty(this.renderable,e,t),this;var i=this.options.sheet;return i&&i.attached&&(0,l.default)(!1,'Rule is not linked. Missing sheet option "link: true".'),this}},{key:"applyTo",value:function(e){var t=this.toJSON();for(var n in t)this.renderer.setProperty(e,n,t[n]);return this}},{key:"toJSON",value:function(){var e={};for(var t in this.style){var n=this.style[t];"object"!==(void 0===n?"undefined":a(n))?e[t]=n:Array.isArray(n)&&(e[t]=(0,p.default)(n))}return e}},{key:"toString",value:function(e){var t=this.options.sheet,n=!!t&&t.options.link,r=n?i({},e,{allowEmpty:!0}):e;return(0,f.default)(this.selector,this.style,r)}},{key:"selector",set:function(e){if(e!==this.selectorText&&(this.selectorText=e,this.renderable)){if(!this.renderer.setSelector(this.renderable,e)&&this.renderable){var t=this.renderer.replaceRule(this.renderable,this);t&&(this.renderable=t)}}},get:function(){return this.selectorText}}]),e}();t.default=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.changePage=t.setRowsPerPage=t.setPage=t.fetchData=t.sortData=t.filterData=t.searchData=t.setCreatedByValue=t.setTotalRecords=t.setSearchValue=t.setSortColumn=t.setSortOrder=t.setData=t.setFavoriteType=t.toggleShareDialog=t.setD2=t.renameFavorite=t.toggleRenameDialog=t.deleteFavorite=t.toggleDeleteDialog=t.selectFavorite=t.setActionsMenuAnchorEl=t.toggleActionsMenu=t.toggleLoading=void 0;var r=n(168),o=n(391),i=function(e){return e&&e.__esModule?e:{default:e}}(o),a=t.toggleLoading=function(){return{type:r.actionTypes.TOGGLE_LOADING}},u=(t.toggleActionsMenu=function(){return{type:r.actionTypes.TOGGLE_ACTIONS_MENU}},t.setActionsMenuAnchorEl=function(e){return{type:r.actionTypes.SET_ACTIONS_MENU_ANCHOR_EL,payload:e}},t.selectFavorite=function(e){return{type:r.actionTypes.SET_SELECTED_FAVORITE,payload:e}},t.toggleDeleteDialog=function(){return{type:r.actionTypes.TOGGLE_DELETE_DIALOG}}),s=(t.deleteFavorite=function(e){return function(e,t){var n=t(),r=n.actions.select.favoriteModel;r&&r.delete().then(function(){e(u()),e(y())}).catch(function(e){return i.default.error("favorites: delete error",e)})}},t.toggleRenameDialog=function(){return{type:r.actionTypes.TOGGLE_RENAME_DIALOG}}),l=(t.renameFavorite=function(e){return function(t,n){var r=n(),o=r.actions.select.favoriteModel,a=e.newName,u=e.newDescription,l=void 0;o&&(console.log("hello"),l=r.d2.Api.getApi(),r.d2.models[r.filtering.type].get(o.id).then(function(e){e.name=a,e.description=u,e.validate().then(function(n){if(!0===n.status){var r={description:u};a&&(r.name=a),r.name&&l.request("PATCH",e.href,JSON.stringify(r)).then(function(e){t(s()),t(y())}).catch(function(e){i.default.error("favorites: rename error",e),t(s())})}})}).catch(function(e){i.default.error("favorites: favorite ("+o.id+") not found ("+e+")")}))}},t.setD2=function(e){return{type:r.actionTypes.SET_D2,payload:e}},t.toggleShareDialog=function(){return{type:r.actionTypes.TOGGLE_SHARE_DIALOG}},t.setFavoriteType=function(e){return{type:r.actionTypes.SET_FAVORITE_TYPE,payload:e}},t.setData=function(e){return{type:r.actionTypes.SET_DATA,payload:e}}),c=t.setSortOrder=function(e){return{type:r.actionTypes.SET_SORT_ORDER,payload:e}},f=t.setSortColumn=function(e){return{type:r.actionTypes.SET_SORT_COLUMN,payload:e}},d=t.setSearchValue=function(e){return{type:r.actionTypes.SET_SEARCH_VALUE,payload:e}},p=t.setTotalRecords=function(e){return{type:r.actionTypes.SET_TOTAL_RECORDS,payload:e}},h=t.setCreatedByValue=function(e){return{type:r.actionTypes.SET_CREATEDBY_VALUE,payload:e}},y=(t.searchData=function(e){var t=e.target.value;return function(e,n){e(d(t)),e(y())}},t.filterData=function(e){var t=e.target.value;return function(e,n){e(h(t)),e(y())}},t.sortData=function(e,t){return function(e,n){var r=n(),o="desc";r.sorting.column!==t?o=r.sorting.order:"desc"===r.sorting.order&&(o="asc");var i="desc"===o?r.data.records.sort(function(e,n){return n[t]<e[t]?-1:1}):r.data.records.sort(function(e,n){return e[t]<n[t]?-1:1});e(c(o)),e(f(t)),e(l(i))}},t.fetchData=function(){return function(e,t){var n=t();e(a());var r=n.d2.models[n.filtering.type];if(n.filtering.createdByValue){var o=n.d2.currentUser.id;switch(n.filtering.createdByValue){case"byme":r=r.filter().on("user.id").equals(o);break;case"byothers":r=r.filter().on("user.id").notEqual(o)}}n.filtering.searchValue&&(r=r.filter().on("displayName").ilike(n.filtering.searchValue)),r.list({fields:"id,displayName,title,displayDescription,created,lastUpdated,user,access,href",order:"name:asc",pageSize:n.pagination.rowsPerPage,page:n.pagination.page+1}).then(function(t){e(p(t.pager.total)),e(l(t.toArray())),e(a())}).catch(function(e){return i.default.error("favorites: fetch error",e)})}}),v=t.setPage=function(e){return{type:r.actionTypes.SET_PAGE,payload:e}};t.setRowsPerPage=function(e){return{type:r.actionTypes.SET_ROWS_PER_PAGE,payload:e.target.value}},t.changePage=function(e,t){return function(e,n){e(v(t)),e(y())}}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(112),o=n(76);e.exports=Object.keys||function(e){return r(e,o)}},function(e,t){e.exports={}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(129),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(e,t){return t+"("+(0,o.default)(e)+")"};t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(53),s=r(u),l=n(134),c=r(l),f=n(35),d=r(f),p=n(259),h=r(p),y=function(){function e(t){o(this,e),this.map={},this.raw={},this.index=[],this.options=t,this.classes=t.classes}return a(e,[{key:"add",value:function(e,t,n){var r=this.options,o=r.parent,a=r.sheet,u=r.jss,l=r.Renderer,c=r.generateClassName;n=i({classes:this.classes,parent:o,sheet:a,jss:u,Renderer:l,generateClassName:c},n),!n.selector&&this.classes[e]&&(n.selector="."+(0,h.default)(this.classes[e])),this.raw[e]=t;var f=(0,s.default)(e,t,n),p=void 0;!n.selector&&f instanceof d.default&&(p=c(f,a),f.selector="."+(0,h.default)(p)),this.register(f,p);var y=void 0===n.index?this.index.length:n.index;return this.index.splice(y,0,f),f}},{key:"get",value:function(e){return this.map[e]}},{key:"remove",value:function(e){this.unregister(e),this.index.splice(this.indexOf(e),1)}},{key:"indexOf",value:function(e){return this.index.indexOf(e)}},{key:"process",value:function(){var e=this.options.jss.plugins;this.index.slice(0).forEach(e.onProcessRule,e)}},{key:"register",value:function(e,t){this.map[e.key]=e,e instanceof d.default&&(this.map[e.selector]=e,t&&(this.classes[e.key]=t))}},{key:"unregister",value:function(e){delete this.map[e.key],e instanceof d.default&&(delete this.map[e.selector],delete this.classes[e.key])}},{key:"update",value:function(e,t){var n=this.options,r=n.jss.plugins,o=n.sheet;if("string"==typeof e)return void r.onUpdate(t,this.get(e),o);for(var i=0;i<this.index.length;i++)r.onUpdate(e,this.index[i],o)}},{key:"link",value:function(e){for(var t=this.options.sheet.renderer.getUnescapedKeysMap(this.index),n=0;n<e.length;n++){var r=e[n],o=this.options.sheet.renderer.getKey(r);t[o]&&(o=t[o]);var i=this.map[o];i&&(0,c.default)(i,r)}}},{key:"toString",value:function(e){for(var t="",n=this.options.sheet,r=!!n&&n.options.link,o=0;o<this.index.length;o++){var i=this.index[o],a=i.toString(e);(a||r)&&(t&&(t+="\n"),t+=a)}return t}}]),e}();t.default=y},function(e,t){t=e.exports=function(e){if(e&&"object"==typeof e){var t=e.which||e.keyCode||e.charCode;t&&(e=t)}if("number"==typeof e)return i[e];var o=String(e),a=n[o.toLowerCase()];if(a)return a;var a=r[o.toLowerCase()];return a||(1===o.length?o.charCodeAt(0):void 0)};var n=t.code=t.codes={backspace:8,tab:9,enter:13,shift:16,ctrl:17,alt:18,"pause/break":19,"caps lock":20,esc:27,space:32,"page up":33,"page down":34,end:35,home:36,left:37,up:38,right:39,down:40,insert:45,delete:46,command:91,"left command":91,"right command":93,"numpad *":106,"numpad +":107,"numpad -":109,"numpad .":110,"numpad /":111,"num lock":144,"scroll lock":145,"my computer":182,"my calculator":183,";":186,"=":187,",":188,"-":189,".":190,"/":191,"`":192,"[":219,"\\":220,"]":221,"'":222},r=t.aliases={windows:91,"⇧":16,"⌥":18,"⌃":17,"⌘":91,ctl:17,control:17,option:18,pause:19,break:19,caps:20,return:13,escape:27,spc:32,pgup:33,pgdn:34,ins:45,del:46,cmd:91};/*!
 * Programatically add the following
 */
for(o=97;o<123;o++)n[String.fromCharCode(o)]=o-32;for(var o=48;o<58;o++)n[o-48]=o;for(o=1;o<13;o++)n["f"+o]=o+111;for(o=0;o<10;o++)n["numpad "+o]=o+96;var i=t.names=t.title={};for(o in n)i[n[o]]=o;for(var a in r)n[a]=r[a]},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(342);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){!function(t,n){e.exports=n()}(0,function(){"use strict";var e={childContextTypes:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},t={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},n=Object.defineProperty,r=Object.getOwnPropertyNames,o=Object.getOwnPropertySymbols,i=Object.getOwnPropertyDescriptor,a=Object.getPrototypeOf,u=a&&a(Object);return function s(l,c,f){if("string"!=typeof c){if(u){var d=a(c);d&&d!==u&&s(l,d,f)}var p=r(c);o&&(p=p.concat(o(c)));for(var h=0;h<p.length;++h){var y=p[h];if(!(e[y]||t[y]||f&&f[y])){var v=i(c,y);try{n(l,y,v)}catch(e){}}}return l}return l}})},function(e,t,n){var r=n(73),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(213),i=r(o),a=n(221),u=r(a),s="function"==typeof u.default&&"symbol"==typeof i.default?function(e){return typeof e}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":typeof e};t.default="function"==typeof u.default&&"symbol"===s(i.default)?function(e){return void 0===e?"undefined":s(e)}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":void 0===e?"undefined":s(e)}},function(e,t,n){var r=n(28),o=n(217),i=n(76),a=n(74)("IE_PROTO"),u=function(){},s=function(){var e,t=n(111)("iframe"),r=i.length;for(t.style.display="none",n(218).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),s=e.F;r--;)delete s.prototype[i[r]];return s()};e.exports=Object.create||function(e,t){var n;return null!==e?(u.prototype=r(e),n=new u,u.prototype=null,n[a]=e):n=s(),void 0===t?n:o(n,t)}},function(e,t,n){var r=n(17).f,o=n(30),i=n(15)("toStringTag");e.exports=function(e,t,n){e&&!o(e=n?e:e.prototype,i)&&r(e,i,{configurable:!0,value:t})}},function(e,t,n){var r=n(27),o=n(124),i=n(125),a=n(28),u=n(45),s=n(126),l={},c={},t=e.exports=function(e,t,n,f,d){var p,h,y,v,m=d?function(){return e}:s(e),b=r(n,f,t?2:1),g=0;if("function"!=typeof m)throw TypeError(e+" is not iterable!");if(i(m)){for(p=u(e.length);p>g;g++)if((v=t?b(a(h=e[g])[0],h[1]):b(e[g]))===l||v===c)return v}else for(y=m.call(e);!(h=y.next()).done;)if((v=o(y,b,h.value,t))===l||v===c)return v};t.BREAK=l,t.RETURN=c},function(e,t,n){"use strict";function r(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!Array.isArray(e))return e;var n="";if(Array.isArray(e[0]))for(var r=0;r<e.length&&"!important"!==e[r];r++)n&&(n+=", "),n+=o(e[r]," ");else n=o(e,", ");return t||"!important"!==e[e.length-1]||(n+=" !important"),n}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=function(e,t){for(var n="",r=0;r<e.length&&"!important"!==e[r];r++)n&&(n+=t),n+=e[r];return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"unnamed",t=arguments[1],n=arguments[2],r=n.jss,o=(0,c.default)(t),i=r.plugins.onCreateRule(e,o,n);return i||("@"===e[0]&&(0,a.default)(!1,"[JSS] Unknown at-rule %s",e),new s.default(e,o,n))}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(12),a=r(i),u=n(35),s=r(u),l=n(258),c=r(l)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"isBrowser",function(){return o});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o="object"===("undefined"==typeof window?"undefined":r(window))&&"object"===("undefined"==typeof document?"undefined":r(document))&&9===document.nodeType;t.default=o},function(e,t,n){"use strict";function r(e){return!!e&&"object"==typeof e}function o(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||i(e)}function i(e){return e.$$typeof===p}function a(e){return Array.isArray(e)?[]:{}}function u(e,t){return t&&!1===t.clone||!f(e)?e:c(a(e),e,t)}function s(e,t,n){return e.concat(t).map(function(e){return u(e,n)})}function l(e,t,n){var r={};return f(e)&&Object.keys(e).forEach(function(t){r[t]=u(e[t],n)}),Object.keys(t).forEach(function(o){f(t[o])&&e[o]?r[o]=c(e[o],t[o],n):r[o]=u(t[o],n)}),r}function c(e,t,n){var r=Array.isArray(t),o=Array.isArray(e),i=n||{arrayMerge:s};if(r===o)return r?(i.arrayMerge||s)(e,t,n):l(e,t,n);return u(t,n)}Object.defineProperty(t,"__esModule",{value:!0});var f=function(e){return r(e)&&!o(e)},d="function"==typeof Symbol&&Symbol.for,p=d?Symbol.for("react.element"):60103;c.all=function(e,t){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce(function(e,n){return c(e,n,t)},{})};var h=c;t.default=h},function(e,t,n){"use strict";function r(e,t){if(t)do{if(t===e)return!0}while(t=t.parentNode);return!1}Object.defineProperty(t,"__esModule",{value:!0});var o=n(57),i=function(e){return e&&e.__esModule?e:{default:e}}(o);t.default=function(){return i.default?function(e,t){return e.contains?e.contains(t):e.compareDocumentPosition?e===t||!!(16&e.compareDocumentPosition(t)):r(e,t)}:r}(),e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=!("undefined"==typeof window||!window.document||!window.document.createElement),e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){return E||(E=(0,O.default)())}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),a=r(i),u=n(8),s=r(u),l=n(7),c=r(l),f=n(9),d=r(f),p=n(10),h=r(p),y=n(11),v=r(y),m=n(0),b=r(m),g=n(44),_=r(g),w=n(40),x=(r(w),n(88)),O=r(x),S=n(91),T=r(S),E=void 0,C=function(){return function(e){var t=function(t){function n(e,t){(0,c.default)(this,n);var r=(0,h.default)(this,(n.__proto__||(0,s.default)(n)).call(this,e,t));return r.state={},r.unsubscribeId=null,r.state={theme:T.default.initial(t)||o()},r}return(0,v.default)(n,t),(0,d.default)(n,[{key:"componentDidMount",value:function(){var e=this;this.unsubscribeId=T.default.subscribe(this.context,function(t){e.setState({theme:t})})}},{key:"componentWillUnmount",value:function(){null!==this.unsubscribeId&&T.default.unsubscribe(this.context,this.unsubscribeId)}},{key:"render",value:function(){return b.default.createElement(e,(0,a.default)({theme:this.state.theme},this.props))}}]),n}(b.default.Component);return t.contextTypes=T.default.contextTypes,(0,_.default)(t,e),t}};t.default=C},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(328);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(329);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return s.default.Children.map(e,function(e){return s.default.isValidElement(e)&&s.default.cloneElement(e,{className:(0,c.default)(e.props.className,t)})})}function i(e,t){return s.default.isValidElement(e)&&-1!==t.indexOf(e.type.muiName)}function a(e,t){return-1!==t.indexOf(e.muiName)}Object.defineProperty(t,"__esModule",{value:!0}),t.cloneChildrenWithClassName=o,t.isMuiElement=i,t.isMuiComponent=a;var u=n(0),s=r(u),l=n(5),c=r(l)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return(0,C.default)({},R,e)}function i(e,t,n){var r=[e,t];return r.push(A.passiveOption?n:n.capture),r}function a(e,t,n,r){e.addEventListener.apply(e,i(t,n,r))}function u(e,t,n,r){e.removeEventListener.apply(e,i(t,n,r))}function s(e,t){var n=(e.children,e.target,(0,T.default)(e,["children","target"]));(0,O.default)(n).forEach(function(e){if("on"===e.substring(0,2)){var r=n[e],i=void 0===r?"undefined":(0,w.default)(r),a="object"===i,u="function"===i;if(a||u){var s="capture"===e.substr(-7).toLowerCase(),l=e.substring(2).toLowerCase();l=s?l.substring(0,l.length-7):l,a?t(l,r.handler,r.options):t(l,r,o({capture:s}))}}})}function l(e,t){return{handler:e,options:o(t)}}Object.defineProperty(t,"__esModule",{value:!0});var c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(48),w=r(_),x=n(31),O=r(x),S=n(3),T=r(S),E=n(108),C=r(E);t.withOptions=l;var k=n(0),P=r(k),M=n(1),j=(r(M),n(92)),N=r(j),I=n(12),A=(r(I),n(347)),R={capture:!1,passive:!1},F=function(e){function t(){return(0,p.default)(this,t),(0,m.default)(this,(t.__proto__||(0,f.default)(t)).apply(this,arguments))}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentDidMount",value:function(){this.addListeners()}},{key:"shouldComponentUpdate",value:function(e){return!(0,N.default)(this.props,e)}},{key:"componentWillUpdate",value:function(){this.removeListeners()}},{key:"componentDidUpdate",value:function(){this.addListeners()}},{key:"componentWillUnmount",value:function(){this.removeListeners()}},{key:"addListeners",value:function(){this.applyListeners(a)}},{key:"removeListeners",value:function(){this.applyListeners(u)}},{key:"applyListeners",value:function(e){var t=this.props.target;if(t){var n=t;"string"==typeof t&&(n=window[t]),s(this.props,e.bind(null,n))}}},{key:"render",value:function(){return this.props.children||null}}]),t}(P.default.Component);F.propTypes={},t.default=F},function(e,t,n){function r(e,t,n){function r(t){var n=b,r=g;return b=g=void 0,S=t,w=e.apply(r,n)}function c(e){return S=e,x=setTimeout(p,t),T?r(e):w}function f(e){var n=e-O,r=e-S,o=t-n;return E?l(o,_-r):o}function d(e){var n=e-O,r=e-S;return void 0===O||n>=t||n<0||E&&r>=_}function p(){var e=i();if(d(e))return h(e);x=setTimeout(p,f(e))}function h(e){return x=void 0,C&&b?r(e):(b=g=void 0,w)}function y(){void 0!==x&&clearTimeout(x),S=0,b=O=g=x=void 0}function v(){return void 0===x?w:h(i())}function m(){var e=i(),n=d(e);if(b=arguments,g=this,O=e,n){if(void 0===x)return c(O);if(E)return x=setTimeout(p,t),r(O)}return void 0===x&&(x=setTimeout(p,t)),w}var b,g,_,w,x,O,S=0,T=!1,E=!1,C=!0;if("function"!=typeof e)throw new TypeError(u);return t=a(t)||0,o(n)&&(T=!!n.leading,E="maxWait"in n,_=E?s(a(n.maxWait)||0,t):_,C="trailing"in n?!!n.trailing:C),m.cancel=y,m.flush=v,m}var o=n(152),i=n(348),a=n(350),u="Expected a function",s=Math.max,l=Math.min;e.exports=r},function(e,t,n){"use strict";function r(e){return function(){return e}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";function r(e){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(e);try{throw new Error(e)}catch(e){}}t.a=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(101),o=n(193),i=n(194),a=n(195),u=n(105);n(104);n.d(t,"createStore",function(){return r.b}),n.d(t,"combineReducers",function(){return o.a}),n.d(t,"bindActionCreators",function(){return i.a}),n.d(t,"applyMiddleware",function(){return a.a}),n.d(t,"compose",function(){return u.a})},function(e,t,n){"use strict";function r(e){if(!Object(a.a)(e)||Object(o.a)(e)!=u)return!1;var t=Object(i.a)(e);if(null===t)return!0;var n=f.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&c.call(n)==d}var o=n(183),i=n(188),a=n(190),u="[object Object]",s=Function.prototype,l=Object.prototype,c=s.toString,f=l.hasOwnProperty,d=c.call(Object);t.a=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(201);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(327);Object.defineProperty(t,"DialogActions",{enumerable:!0,get:function(){return r(i).default}});var a=n(341);Object.defineProperty(t,"DialogTitle",{enumerable:!0,get:function(){return r(a).default}});var u=n(343);Object.defineProperty(t,"DialogContent",{enumerable:!0,get:function(){return r(u).default}});var s=n(344);Object.defineProperty(t,"DialogContentText",{enumerable:!0,get:function(){return r(s).default}});var l=n(345);Object.defineProperty(t,"withMobileDialog",{enumerable:!0,get:function(){return r(l).default}})},function(e,t,n){var r=n(22);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var r=n(71);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(75)("keys"),o=n(46);e.exports=function(e){return r[e]||(r[e]=o(e))}},function(e,t,n){var r=n(19),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){e.exports={default:n(207),__esModule:!0}},function(e,t,n){"use strict";var r=n(215)(!0);n(80)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){"use strict";var r=n(81),o=n(14),i=n(115),a=n(25),u=n(30),s=n(39),l=n(216),c=n(50),f=n(114),d=n(15)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,y,v,m,b){l(n,t,y);var g,_,w,x=function(e){if(!p&&e in E)return E[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},O=t+" Iterator",S="values"==v,T=!1,E=e.prototype,C=E[d]||E["@@iterator"]||v&&E[v],k=!p&&C||x(v),P=v?S?x("entries"):k:void 0,M="Array"==t?E.entries||C:C;if(M&&(w=f(M.call(new e)))!==Object.prototype&&w.next&&(c(w,O,!0),r||u(w,d)||a(w,d,h)),S&&C&&"values"!==C.name&&(T=!0,k=function(){return C.call(this)}),r&&!b||!p&&!T&&E[d]||a(E,d,k),s[t]=k,s[O]=h,v)if(g={values:S?k:x("values"),keys:m?k:x("keys"),entries:P},b)for(_ in g)_ in E||i(E,_,g[_]);else o(o.P+o.F*(p||T),t,g);return g}},function(e,t){e.exports=!0},function(e,t,n){t.f=n(15)},function(e,t,n){var r=n(46)("meta"),o=n(22),i=n(30),a=n(17).f,u=0,s=Object.isExtensible||function(){return!0},l=!n(29)(function(){return s(Object.preventExtensions({}))}),c=function(e){a(e,r,{value:{i:"O"+ ++u,w:{}}})},f=function(e,t){if(!o(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!i(e,r)){if(!s(e))return"F";if(!t)return"E";c(e)}return e[r].i},d=function(e,t){if(!i(e,r)){if(!s(e))return!0;if(!t)return!1;c(e)}return e[r].w},p=function(e){return l&&h.NEED&&s(e)&&!i(e,r)&&c(e),e},h=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(e,t,n){var r=n(19),o=n(13),i=n(81),a=n(82),u=n(17).f;e.exports=function(e){var t=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||u(t,e,{value:a.f(e)})}},function(e,t,n){"use strict";function r(e,t){for(var n="",r=0;r<t;r++)n+="  ";return n+e}function o(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o="";if(!t)return o;var i=n.indent,u=void 0===i?0:i,s=t.fallbacks;if(u++,s)if(Array.isArray(s))for(var l=0;l<s.length;l++){var c=s[l];for(var f in c){var d=c[f];null!=d&&(o+="\n"+r(f+": "+(0,a.default)(d)+";",u))}}else for(var p in s){var h=s[p];null!=h&&(o+="\n"+r(p+": "+(0,a.default)(h)+";",u))}for(var y in t){var v=t[y];null!=v&&"fallbacks"!==y&&(o+="\n"+r(y+": "+(0,a.default)(v)+";",u))}return o||n.allowEmpty?(u--,o=r(e+" {"+o+"\n",u)+r("}",u)):o}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(52),a=function(e){return e&&e.__esModule?e:{default:e}}(i)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(132),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=new o.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(54),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i="",a="";if(o.default){var u={Moz:"-moz-",ms:"-ms-",O:"-o-",Webkit:"-webkit-"},s=document.createElement("p").style;for(var l in u)if(l+"Transform"in s){i=l,a=u[l];break}}t.default={js:i,css:a}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.palette,n=void 0===t?{}:t,r=e.breakpoints,o=void 0===r?{}:r,i=e.mixins,u=void 0===i?{}:i,l=e.typography,f=void 0===l?{}:l,d=e.shadows,h=(0,s.default)(e,["palette","breakpoints","mixins","typography","shadows"]),v=(0,m.default)(n),b=(0,y.default)(o),_=(0,a.default)({direction:"ltr",palette:v,typography:(0,p.default)(v,f),mixins:(0,g.default)(b,C.default,u),breakpoints:b,shadows:d||w.default},(0,c.default)({transitions:O.default,spacing:C.default,zIndex:T.default},h));return _}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),a=r(i),u=n(3),s=r(u),l=n(55),c=r(l),f=n(12),d=(r(f),n(285)),p=r(d),h=n(138),y=r(h),v=n(286),m=r(v),b=n(291),g=r(b),_=n(292),w=r(_),x=n(90),O=r(x),S=n(296),T=r(S),E=n(297),C=r(E);t.default=o},function(e,t,n){"use strict";function r(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;return e<t?t:e>n?n:e}function o(e){e=e.substr(1);var t=new RegExp(".{1,"+e.length/3+"}","g"),n=e.match(t);return n&&1===n[0].length&&(n=n.map(function(e){return e+e})),n?"rgb("+n.map(function(e){return parseInt(e,16)}).join(", ")+")":""}function i(e){if("#"===e.charAt(0))return i(o(e));var t=e.indexOf("("),n=e.substring(0,t),r=e.substring(t+1,e.length-1).split(",");return r=r.map(function(e){return parseFloat(e)}),{type:n,values:r}}function a(e){var t=e.type,n=e.values;return t.indexOf("rgb")>-1&&(n=n.map(function(e,t){return t<3?parseInt(e,10):e})),t.indexOf("hsl")>-1&&(n[1]=n[1]+"%",n[2]=n[2]+"%"),e.type+"("+n.join(", ")+")"}function u(e,t){var n=s(e),r=s(t);return(Math.max(n,r)+.05)/(Math.min(n,r)+.05)}function s(e){var t=i(e);if(t.type.indexOf("rgb")>-1){var n=t.values.map(function(e){return e/=255,e<=.03928?e/12.92:Math.pow((e+.055)/1.055,2.4)});return Number((.2126*n[0]+.7152*n[1]+.0722*n[2]).toFixed(3))}if(t.type.indexOf("hsl")>-1)return t.values[2]/100;throw new Error("Material-UI: unsupported `"+e+"` color.")}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.15;return s(e)>.5?f(e,t):d(e,t)}function c(e,t){return e?(e=i(e),t=r(t),"rgb"!==e.type&&"hsl"!==e.type||(e.type+="a"),e.values[3]=t,a(e)):e}function f(e,t){if(!e)return e;if(e=i(e),t=r(t),e.type.indexOf("hsl")>-1)e.values[2]*=1-t;else if(e.type.indexOf("rgb")>-1)for(var n=0;n<3;n+=1)e.values[n]*=1-t;return a(e)}function d(e,t){if(!e)return e;if(e=i(e),t=r(t),e.type.indexOf("hsl")>-1)e.values[2]+=(100-e.values[2])*t;else if(e.type.indexOf("rgb")>-1)for(var n=0;n<3;n+=1)e.values[n]+=(255-e.values[n])*t;return a(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.convertHexToRGB=o,t.decomposeColor=i,t.recomposeColor=a,t.getContrastRatio=u,t.getLuminance=s,t.emphasize=l,t.fade=c,t.darken=f,t.lighten=d;var p=n(12);!function(e){e&&e.__esModule}(p)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.isNumber=t.isString=t.formatMs=t.duration=t.easing=void 0;var o=n(31),i=(r(o),n(3)),a=r(i),u=n(293),s=r(u),l=n(12),c=(r(l),t.easing={easeInOut:"cubic-bezier(0.4, 0, 0.2, 1)",easeOut:"cubic-bezier(0.0, 0, 0.2, 1)",easeIn:"cubic-bezier(0.4, 0, 1, 1)",sharp:"cubic-bezier(0.4, 0, 0.6, 1)"}),f=t.duration={shortest:150,shorter:200,short:250,standard:300,complex:375,enteringScreen:225,leavingScreen:195},d=t.formatMs=function(e){return Math.round(e)+"ms"};t.isString=function(e){return"string"==typeof e},t.isNumber=function(e){return!(0,s.default)(parseFloat(e))};t.default={easing:c,duration:f,create:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["all"],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.duration,r=void 0===n?f.standard:n,o=t.easing,i=void 0===o?c.easeInOut:o,u=t.delay,s=void 0===u?0:u;(0,a.default)(t,["duration","easing","delay"]);return(Array.isArray(e)?e:[e]).map(function(e){return e+" "+("string"==typeof r?r:d(r))+" "+i+" "+("string"==typeof s?s:d(s))}).join(",")},getAutoHeightDuration:function(e){if(!e)return 0;var t=e/36;return Math.round(10*(4+15*Math.pow(t,.25)+t/5))}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.CHANNEL=void 0;var o=n(6),i=r(o),a=n(1),u=r(a),s=t.CHANNEL="__THEMING__",l={contextTypes:(0,i.default)({},s,u.default.object),initial:function(e){return e[s]?e[s].getState():null},subscribe:function(e,t){return e[s]?e[s].subscribe(t):null},unsubscribe:function(e,t){e[s]&&e[s].unsubscribe(t)}};t.default=l},function(e,t,n){"use strict";function r(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!==e&&t!==t}function o(e,t){if(r(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),o=Object.keys(t);if(n.length!==o.length)return!1;for(var a=0;a<n.length;a++)if(!i.call(t,n[a])||!r(e[n[a]],t[n[a]]))return!1;return!0}var i=Object.prototype.hasOwnProperty;e.exports=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return(0,c.default)({},e,(0,a.default)({},f,function(n){var r=(0,s.default)(n).filter(function(t){return!e.hasOwnProperty(t)});return r.length>0?new TypeError(t+": unknown props found: "+r.join(", ")+". Please remove the unknown properties."):null}))}Object.defineProperty(t,"__esModule",{value:!0}),t.specialProperty=void 0;var i=n(6),a=r(i),u=n(31),s=r(u),l=n(2),c=r(l);t.default=o;var f=t.specialProperty="exact-prop: ​"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(){}t.__esModule=!0,t.EXITING=t.ENTERED=t.ENTERING=t.EXITED=t.UNMOUNTED=void 0;var l=n(1),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(l),f=n(0),d=r(f),p=n(18),h=r(p),y=(n(325),t.UNMOUNTED="unmounted"),v=t.EXITED="exited",m=t.ENTERING="entering",b=t.ENTERED="entered",g=t.EXITING="exiting",_=function(e){function t(n,r){i(this,t);var o=a(this,e.call(this,n,r)),u=r.transitionGroup,s=u&&!u.isMounting?n.enter:n.appear,l=void 0;return o.nextStatus=null,n.in?s?(l=v,o.nextStatus=m):l=b:l=n.unmountOnExit||n.mountOnEnter?y:v,o.state={status:l},o.nextCallback=null,o}return u(t,e),t.prototype.getChildContext=function(){return{transitionGroup:null}},t.prototype.componentDidMount=function(){this.updateStatus(!0)},t.prototype.componentWillReceiveProps=function(e){var t=this.pendingState||this.state,n=t.status;e.in?(n===y&&this.setState({status:v}),n!==m&&n!==b&&(this.nextStatus=m)):n!==m&&n!==b||(this.nextStatus=g)},t.prototype.componentDidUpdate=function(){this.updateStatus()},t.prototype.componentWillUnmount=function(){this.cancelNextCallback()},t.prototype.getTimeouts=function(){var e=this.props.timeout,t=void 0,n=void 0,r=void 0;return t=n=r=e,null!=e&&"number"!=typeof e&&(t=e.exit,n=e.enter,r=e.appear),{exit:t,enter:n,appear:r}},t.prototype.updateStatus=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.nextStatus;if(null!==t){this.nextStatus=null,this.cancelNextCallback();var n=h.default.findDOMNode(this);t===m?this.performEnter(n,e):this.performExit(n)}else this.props.unmountOnExit&&this.state.status===v&&this.setState({status:y})},t.prototype.performEnter=function(e,t){var n=this,r=this.props.enter,o=this.context.transitionGroup?this.context.transitionGroup.isMounting:t,i=this.getTimeouts();if(!t&&!r)return void this.safeSetState({status:b},function(){n.props.onEntered(e)});this.props.onEnter(e,o),this.safeSetState({status:m},function(){n.props.onEntering(e,o),n.onTransitionEnd(e,i.enter,function(){n.safeSetState({status:b},function(){n.props.onEntered(e,o)})})})},t.prototype.performExit=function(e){var t=this,n=this.props.exit,r=this.getTimeouts();if(!n)return void this.safeSetState({status:v},function(){t.props.onExited(e)});this.props.onExit(e),this.safeSetState({status:g},function(){t.props.onExiting(e),t.onTransitionEnd(e,r.exit,function(){t.safeSetState({status:v},function(){t.props.onExited(e)})})})},t.prototype.cancelNextCallback=function(){null!==this.nextCallback&&(this.nextCallback.cancel(),this.nextCallback=null)},t.prototype.safeSetState=function(e,t){var n=this;this.pendingState=e,t=this.setNextCallback(t),this.setState(e,function(){n.pendingState=null,t()})},t.prototype.setNextCallback=function(e){var t=this,n=!0;return this.nextCallback=function(r){n&&(n=!1,t.nextCallback=null,e(r))},this.nextCallback.cancel=function(){n=!1},this.nextCallback},t.prototype.onTransitionEnd=function(e,t,n){this.setNextCallback(n),e?(this.props.addEndListener&&this.props.addEndListener(e,this.nextCallback),null!=t&&setTimeout(this.nextCallback,t)):setTimeout(this.nextCallback,0)},t.prototype.render=function(){var e=this.state.status;if(e===y)return null;var t=this.props,n=t.children,r=o(t,["children"]);if(delete r.in,delete r.mountOnEnter,delete r.unmountOnExit,delete r.appear,delete r.enter,delete r.exit,delete r.timeout,delete r.addEndListener,delete r.onEnter,delete r.onEntering,delete r.onEntered,delete r.onExit,delete r.onExiting,delete r.onExited,"function"==typeof n)return n(e,r);var i=d.default.Children.only(n);return d.default.cloneElement(i,r)},t}(d.default.Component);_.contextTypes={transitionGroup:c.object},_.childContextTypes={transitionGroup:function(){}},_.propTypes={},_.defaultProps={in:!1,mountOnEnter:!1,unmountOnExit:!1,appear:!1,enter:!0,exit:!0,onEnter:s,onEntering:s,onEntered:s,onExit:s,onExiting:s,onExited:s},_.UNMOUNTED=0,_.EXITED=1,_.ENTERING=2,_.ENTERED=3,_.EXITING=4,t.default=_},function(e,t,n){"use strict";t.__esModule=!0;var r=n(332),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,o.default)(e)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(155);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(156);Object.defineProperty(t,"MenuList",{enumerable:!0,get:function(){return r(i).default}});var a=n(369);Object.defineProperty(t,"MenuItem",{enumerable:!0,get:function(){return r(a).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return null!=e&&!(Array.isArray(e)&&0===e.length)}function i(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return e&&(o(e.value)&&""!==e.value||t&&o(e.defaultValue)&&""!==e.defaultValue)}function a(e){return e.startAdornment}function u(e,t){var n=e.disabled,r=e.error,o=e.margin;return t&&t.muiFormControl&&(void 0===n&&(n=t.muiFormControl.disabled),void 0===r&&(r=t.muiFormControl.error),void 0===o&&(o=t.muiFormControl.margin)),{disabled:n,error:r,margin:o}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var s=n(2),l=r(s),c=n(6),f=r(c),d=n(3),p=r(d),h=n(8),y=r(h),v=n(7),m=r(v),b=n(9),g=r(b),_=n(10),w=r(_),x=n(11),O=r(x);t.hasValue=o,t.isDirty=i,t.isAdornedStart=a;var S=n(0),T=r(S),E=n(1),C=r(E),k=n(5),P=r(k),M=n(4),j=r(M),N=n(376),I=r(N),A=t.styles=function(e){var t="light"===e.palette.type,n={color:"currentColor",opacity:t?.42:.5,transition:e.transitions.create("opacity",{duration:e.transitions.duration.shorter})},r={opacity:0},o={opacity:t?.42:.5},i=t?"rgba(0, 0, 0, 0.42)":"rgba(255, 255, 255, 0.7)";return{root:{display:"inline-flex",position:"relative",fontFamily:e.typography.fontFamily,color:t?"rgba(0, 0, 0, 0.87)":e.palette.common.white,fontSize:e.typography.pxToRem(16)},formControl:{"label + &":{marginTop:2*e.spacing.unit}},inkbar:{"&:after":{backgroundColor:e.palette.primary[t?"dark":"light"],left:0,bottom:0,content:'""',height:2,position:"absolute",right:0,transform:"scaleX(0)",transition:e.transitions.create("transform",{duration:e.transitions.duration.shorter,easing:e.transitions.easing.easeOut}),pointerEvents:"none"},"&$focused:after":{transform:"scaleX(1)"}},error:{"&:after":{backgroundColor:e.palette.error.main,transform:"scaleX(1)"}},focused:{},disabled:{color:e.palette.text.disabled},underline:{"&:before":{backgroundColor:i,left:0,bottom:0,content:'""',height:1,position:"absolute",right:0,transition:e.transitions.create("background-color",{duration:e.transitions.duration.shorter}),pointerEvents:"none"},"&:hover:not($disabled):before":{backgroundColor:e.palette.text.primary,height:2},"&$disabled:before":{background:"transparent",backgroundImage:"linear-gradient(to right, "+i+" 33%, transparent 0%)",backgroundPosition:"left top",backgroundRepeat:"repeat-x",backgroundSize:"5px 1px"}},multiline:{padding:e.spacing.unit-2+"px 0 "+(e.spacing.unit-1)+"px"},fullWidth:{width:"100%"},input:{font:"inherit",color:"currentColor",padding:e.spacing.unit-2+"px 0 "+(e.spacing.unit-1)+"px",border:0,boxSizing:"content-box",verticalAlign:"middle",background:"none",margin:0,WebkitTapHighlightColor:"transparent",display:"block",minWidth:0,width:"100%","&::-webkit-input-placeholder":n,"&::-moz-placeholder":n,"&:-ms-input-placeholder":n,"&::-ms-input-placeholder":n,"&:focus":{outline:0},"&:invalid":{boxShadow:"none"},"&::-webkit-search-decoration":{"-webkit-appearance":"none"},"label[data-shrink=false] + $formControl &":{"&::-webkit-input-placeholder":r,"&::-moz-placeholder":r,"&:-ms-input-placeholder":r,"&::-ms-input-placeholder":r,"&:focus::-webkit-input-placeholder":o,"&:focus::-moz-placeholder":o,"&:focus:-ms-input-placeholder":o,"&:focus::-ms-input-placeholder":o}},inputDense:{paddingTop:e.spacing.unit/2-1},inputDisabled:{opacity:1},inputType:{height:"1.1875em"},inputMultiline:{resize:"none",padding:0},inputSearch:{"-moz-appearance":"textfield","-webkit-appearance":"textfield"}}},R=function(e){function t(){var e,n,r,o;(0,m.default)(this,t);for(var i=arguments.length,a=Array(i),s=0;s<i;s++)a[s]=arguments[s];return n=r=(0,w.default)(this,(e=t.__proto__||(0,y.default)(t)).call.apply(e,[this].concat(a))),r.state={focused:!1},r.input=null,r.handleFocus=function(e){if(u(r.props,r.context).disabled)return void e.stopPropagation();r.setState({focused:!0}),r.props.onFocus&&r.props.onFocus(e)},r.handleBlur=function(e){r.setState({focused:!1}),r.props.onBlur&&r.props.onBlur(e)},r.handleChange=function(e){r.isControlled||r.checkDirty(r.input),r.props.onChange&&r.props.onChange(e)},r.handleRefInput=function(e){r.input=e,r.props.inputRef?r.props.inputRef(e):r.props.inputProps&&r.props.inputProps.ref&&r.props.inputProps.ref(e)},o=n,(0,w.default)(r,o)}return(0,O.default)(t,e),(0,g.default)(t,[{key:"getChildContext",value:function(){return{muiFormControl:null}}},{key:"componentWillMount",value:function(){this.isControlled=null!=this.props.value,this.isControlled&&this.checkDirty(this.props)}},{key:"componentDidMount",value:function(){this.isControlled||this.checkDirty(this.input)}},{key:"componentWillReceiveProps",value:function(e,t){!u(this.props,this.context).disabled&&u(e,t).disabled&&this.setState({focused:!1})}},{key:"componentWillUpdate",value:function(e,t,n){if(this.isControlled&&this.checkDirty(e),!u(this.props,this.context).disabled&&u(e,n).disabled){var r=this.context.muiFormControl;r&&r.onBlur&&r.onBlur()}}},{key:"checkDirty",value:function(e){var t=this.context.muiFormControl;if(i(e))return t&&t.onDirty&&t.onDirty(),void(this.props.onDirty&&this.props.onDirty());t&&t.onClean&&t.onClean(),this.props.onClean&&this.props.onClean()}},{key:"render",value:function(){var e,t,n=this.props,r=n.autoComplete,o=n.autoFocus,i=n.classes,a=n.className,s=n.defaultValue,c=(n.disabled,n.disableUnderline),d=n.endAdornment,h=(n.error,n.fullWidth),y=n.id,v=n.inputComponent,m=n.inputProps;m=void 0===m?{}:m;var b=m.className,g=(0,p.default)(m,["className"]),_=(n.inputRef,n.margin,n.multiline),w=n.name,x=(n.onBlur,n.onChange,n.onClean,n.onDirty,n.onFocus,n.onKeyDown),O=n.onKeyUp,S=n.placeholder,E=n.readOnly,C=n.rows,k=n.rowsMax,M=n.startAdornment,j=n.type,N=n.value,A=(0,p.default)(n,["autoComplete","autoFocus","classes","className","defaultValue","disabled","disableUnderline","endAdornment","error","fullWidth","id","inputComponent","inputProps","inputRef","margin","multiline","name","onBlur","onChange","onClean","onDirty","onFocus","onKeyDown","onKeyUp","placeholder","readOnly","rows","rowsMax","startAdornment","type","value"]),R=this.context.muiFormControl,F=u(this.props,this.context),D=F.disabled,L=F.error,z=F.margin,V=(0,P.default)(i.root,(e={},(0,f.default)(e,i.disabled,D),(0,f.default)(e,i.error,L),(0,f.default)(e,i.fullWidth,h),(0,f.default)(e,i.focused,this.state.focused),(0,f.default)(e,i.formControl,R),(0,f.default)(e,i.inkbar,!c),(0,f.default)(e,i.multiline,_),(0,f.default)(e,i.underline,!c),e),a),U=(0,P.default)(i.input,(t={},(0,f.default)(t,i.inputDisabled,D),(0,f.default)(t,i.inputType,"text"!==j),(0,f.default)(t,i.inputMultiline,_),(0,f.default)(t,i.inputSearch,"search"===j),(0,f.default)(t,i.inputDense,"dense"===z),t),b),W=R&&!0===R.required,H="input",B=(0,l.default)({},g,{ref:this.handleRefInput});return v?(H=v,B=(0,l.default)({inputRef:this.handleRefInput},B,{ref:null})):_&&(C&&!k?H="textarea":(B=(0,l.default)({rowsMax:k,textareaRef:this.handleRefInput},B,{ref:null}),H=I.default)),T.default.createElement("div",(0,l.default)({onBlur:this.handleBlur,onFocus:this.handleFocus,className:V},A),M,T.default.createElement(H,(0,l.default)({autoComplete:r,autoFocus:o,className:U,onChange:this.handleChange,onKeyUp:O,onKeyDown:x,disabled:D,required:!!W||void 0,value:N,id:y,name:w,defaultValue:s,placeholder:S,type:j,readOnly:E,rows:C,"aria-required":W,"aria-invalid":L},B)),d)}}]),t}(T.default.Component);R.propTypes={},R.muiName="Input",R.defaultProps={disableUnderline:!1,fullWidth:!1,multiline:!1,type:"text"},R.contextTypes={muiFormControl:C.default.object},R.childContextTypes={muiFormControl:C.default.object},t.default=(0,j.default)(A,{name:"MuiInput"})(R)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(97);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(377);Object.defineProperty(t,"InputAdornment",{enumerable:!0,get:function(){return r(i).default}});var a=n(378);Object.defineProperty(t,"InputLabel",{enumerable:!0,get:function(){return r(a).default}})},function(e,t,n){"use strict";n.d(t,"b",function(){return i}),n.d(t,"a",function(){return a});var r=n(1),o=n.n(r),i=o.a.shape({trySubscribe:o.a.func.isRequired,tryUnsubscribe:o.a.func.isRequired,notifyNestedSubs:o.a.func.isRequired,isSubscribed:o.a.func.isRequired}),a=o.a.shape({subscribe:o.a.func.isRequired,dispatch:o.a.func.isRequired,getState:o.a.func.isRequired})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function u(){}function s(e,t){var n={run:function(r){try{var o=e(t.getState(),r);(o!==n.props||n.error)&&(n.shouldComponentUpdate=!0,n.props=o,n.error=null)}catch(e){n.shouldComponentUpdate=!0,n.error=e}}};return n}function l(e){var t,n,l=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},c=l.getDisplayName,d=void 0===c?function(e){return"ConnectAdvanced("+e+")"}:c,_=l.methodName,w=void 0===_?"connectAdvanced":_,x=l.renderCountProp,O=void 0===x?void 0:x,S=l.shouldHandleStateChanges,T=void 0===S||S,E=l.storeKey,C=void 0===E?"store":E,k=l.withRef,P=void 0!==k&&k,M=a(l,["getDisplayName","methodName","renderCountProp","shouldHandleStateChanges","storeKey","withRef"]),j=C+"Subscription",N=b++,I=(t={},t[C]=v.a,t[j]=v.b,t),A=(n={},n[j]=v.b,n);return function(t){p()("function"==typeof t,"You must pass a component to the function returned by "+w+". Instead received "+JSON.stringify(t));var n=t.displayName||t.name||"Component",a=d(n),l=m({},M,{getDisplayName:d,methodName:w,renderCountProp:O,shouldHandleStateChanges:T,storeKey:C,withRef:P,displayName:a,wrappedComponentName:n,WrappedComponent:t}),c=function(n){function c(e,t){r(this,c);var i=o(this,n.call(this,e,t));return i.version=N,i.state={},i.renderCount=0,i.store=e[C]||t[C],i.propsMode=Boolean(e[C]),i.setWrappedInstance=i.setWrappedInstance.bind(i),p()(i.store,'Could not find "'+C+'" in either the context or props of "'+a+'". Either wrap the root component in a <Provider>, or explicitly pass "'+C+'" as a prop to "'+a+'".'),i.initSelector(),i.initSubscription(),i}return i(c,n),c.prototype.getChildContext=function(){var e,t=this.propsMode?null:this.subscription;return e={},e[j]=t||this.context[j],e},c.prototype.componentDidMount=function(){T&&(this.subscription.trySubscribe(),this.selector.run(this.props),this.selector.shouldComponentUpdate&&this.forceUpdate())},c.prototype.componentWillReceiveProps=function(e){this.selector.run(e)},c.prototype.shouldComponentUpdate=function(){return this.selector.shouldComponentUpdate},c.prototype.componentWillUnmount=function(){this.subscription&&this.subscription.tryUnsubscribe(),this.subscription=null,this.notifyNestedSubs=u,this.store=null,this.selector.run=u,this.selector.shouldComponentUpdate=!1},c.prototype.getWrappedInstance=function(){return p()(P,"To access the wrapped instance, you need to specify { withRef: true } in the options argument of the "+w+"() call."),this.wrappedInstance},c.prototype.setWrappedInstance=function(e){this.wrappedInstance=e},c.prototype.initSelector=function(){var t=e(this.store.dispatch,l);this.selector=s(t,this.store),this.selector.run(this.props)},c.prototype.initSubscription=function(){if(T){var e=(this.propsMode?this.props:this.context)[j];this.subscription=new y.a(this.store,e,this.onStateChange.bind(this)),this.notifyNestedSubs=this.subscription.notifyNestedSubs.bind(this.subscription)}},c.prototype.onStateChange=function(){this.selector.run(this.props),this.selector.shouldComponentUpdate?(this.componentDidUpdate=this.notifyNestedSubsOnComponentDidUpdate,this.setState(g)):this.notifyNestedSubs()},c.prototype.notifyNestedSubsOnComponentDidUpdate=function(){this.componentDidUpdate=void 0,this.notifyNestedSubs()},c.prototype.isSubscribed=function(){return Boolean(this.subscription)&&this.subscription.isSubscribed()},c.prototype.addExtraProps=function(e){if(!(P||O||this.propsMode&&this.subscription))return e;var t=m({},e);return P&&(t.ref=this.setWrappedInstance),O&&(t[O]=this.renderCount++),this.propsMode&&this.subscription&&(t[j]=this.subscription),t},c.prototype.render=function(){var e=this.selector;if(e.shouldComponentUpdate=!1,e.error)throw e.error;return Object(h.createElement)(t,this.addExtraProps(e.props))},c}(h.Component);return c.WrappedComponent=t,c.displayName=a,c.childContextTypes=A,c.contextTypes=I,c.propTypes=I,f()(c,t)}}t.a=l;var c=n(44),f=n.n(c),d=n(178),p=n.n(d),h=n(0),y=(n.n(h),n(179)),v=n(99),m=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},b=0,g={}},function(e,t,n){"use strict";function r(e,t,n){function u(){m===v&&(m=v.slice())}function s(){return y}function l(e){if("function"!=typeof e)throw new Error("Expected listener to be a function.");var t=!0;return u(),m.push(e),function(){if(t){t=!1,u();var n=m.indexOf(e);m.splice(n,1)}}}function c(e){if(!Object(o.a)(e))throw new Error("Actions must be plain objects. Use custom middleware for async actions.");if(void 0===e.type)throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');if(b)throw new Error("Reducers may not dispatch actions.");try{b=!0,y=h(y,e)}finally{b=!1}for(var t=v=m,n=0;n<t.length;n++){(0,t[n])()}return e}function f(e){if("function"!=typeof e)throw new Error("Expected the nextReducer to be a function.");h=e,c({type:a.INIT})}function d(){var e,t=l;return e={subscribe:function(e){function n(){e.next&&e.next(s())}if("object"!=typeof e)throw new TypeError("Expected the observer to be an object.");return n(),{unsubscribe:t(n)}}},e[i.default]=function(){return this},e}var p;if("function"==typeof t&&void 0===n&&(n=t,t=void 0),void 0!==n){if("function"!=typeof n)throw new Error("Expected the enhancer to be a function.");return n(r)(e,t)}if("function"!=typeof e)throw new Error("Expected the reducer to be a function.");var h=e,y=t,v=[],m=v,b=!1;return c({type:a.INIT}),p={dispatch:c,subscribe:l,getState:s,replaceReducer:f},p[i.default]=d,p}n.d(t,"a",function(){return a}),t.b=r;var o=n(67),i=n(103),a={INIT:"@@redux/INIT"}},function(e,t,n){"use strict";var r=n(184),o=r.a.Symbol;t.a=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e,r){var o,i=n(192);o="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==e?e:r;var a=Object(i.a)(o);t.default=a}.call(t,n(16),n(191)(e))},function(e,t,n){"use strict"},function(e,t,n){"use strict";function r(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return 0===t.length?function(e){return e}:1===t.length?t[0]:t.reduce(function(e,t){return function(){return e(t.apply(void 0,arguments))}})}t.a=r},function(e,t,n){"use strict";function r(e){return function(t,n){function r(){return o}var o=e(t,n);return r.dependsOnOwnProps=!1,r}}function o(e){return null!==e.dependsOnOwnProps&&void 0!==e.dependsOnOwnProps?Boolean(e.dependsOnOwnProps):1!==e.length}function i(e,t){return function(t,n){var r=(n.displayName,function(e,t){return r.dependsOnOwnProps?r.mapToProps(e,t):r.mapToProps(e)});return r.dependsOnOwnProps=!0,r.mapToProps=function(t,n){r.mapToProps=e,r.dependsOnOwnProps=o(e);var i=r(t,n);return"function"==typeof i&&(r.mapToProps=i,r.dependsOnOwnProps=o(i),i=r(t,n)),i},r}}t.a=r,t.b=i;n(107)},function(e,t,n){"use strict";n(67),n(65)},function(e,t,n){e.exports={default:n(202),__esModule:!0}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){e.exports=!n(20)&&!n(29)(function(){return 7!=Object.defineProperty(n(111)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(22),o=n(19).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(30),o=n(33),i=n(205)(!1),a=n(74)("IE_PROTO");e.exports=function(e,t){var n,u=o(e),s=0,l=[];for(n in u)n!=a&&r(u,n)&&l.push(n);for(;t.length>s;)r(u,n=t[s++])&&(~i(l,n)||l.push(n));return l}},function(e,t,n){var r=n(14),o=n(13),i=n(29);e.exports=function(e,t){var n=(o.Object||{})[e]||Object[e],a={};a[e]=t(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(e,t,n){var r=n(30),o=n(34),i=n(74)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=o(e),r(e,i)?e[i]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){e.exports=n(25)},function(e,t,n){n(219);for(var r=n(19),o=n(25),i=n(39),a=n(15)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<u.length;s++){var l=u[s],c=r[l],f=c&&c.prototype;f&&!f[a]&&o(f,a,l),i[l]=i.Array}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){var r=n(71);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(112),o=n(76).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o)}},function(e,t,n){var r=n(47),o=n(37),i=n(33),a=n(69),u=n(30),s=n(110),l=Object.getOwnPropertyDescriptor;t.f=n(20)?l:function(e,t){if(e=i(e),t=a(t,!0),s)try{return l(e,t)}catch(e){}if(u(e,t))return o(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){var r=n(25);e.exports=function(e,t,n){for(var o in t)n&&e[o]?e[o]=t[o]:r(e,o,t[o]);return e}},function(e,t){e.exports=function(e,t,n,r){if(!(e instanceof t)||void 0!==r&&r in e)throw TypeError(n+": incorrect invocation!");return e}},function(e,t,n){var r=n(28);e.exports=function(e,t,n,o){try{return o?t(r(n)[0],n[1]):t(n)}catch(t){var i=e.return;throw void 0!==i&&r(i.call(e)),t}}},function(e,t,n){var r=n(39),o=n(15)("iterator"),i=Array.prototype;e.exports=function(e){return void 0!==e&&(r.Array===e||i[o]===e)}},function(e,t,n){var r=n(127),o=n(15)("iterator"),i=n(39);e.exports=n(13).getIteratorMethod=function(e){if(void 0!=e)return e[o]||e["@@iterator"]||i[r(e)]}},function(e,t,n){var r=n(71),o=n(15)("toStringTag"),i="Arguments"==r(function(){return arguments}()),a=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,u;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=a(t=Object(e),o))?n:i?r(t):"Object"==(u=r(t))&&"function"==typeof t.callee?"Arguments":u}},function(e,t,n){var r=n(22);e.exports=function(e,t){if(!r(e)||e._t!==t)throw TypeError("Incompatible receiver, "+t+" required!");return e}},function(e,t,n){"use strict";t.__esModule=!0;var r=function(e){if("string"==typeof e)return e;if(e)return e.displayName||e.name||"Component"};t.default=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.jss="64a55d578f856d258dc345b094a2a2b3",t.sheetsRegistry="d4bd0baacbc52bbd48bbb9eb24344ecd",t.managers="b768b78919504fba9de2c03545c5cd3a",t.sheetOptions="6fc570d6bd61383819d0f9e7407c452d"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.create=t.createGenerateClassName=t.sheets=t.RuleList=t.SheetsManager=t.SheetsRegistry=t.toCssValue=t.getDynamicStyles=void 0;var o=n(256);Object.defineProperty(t,"getDynamicStyles",{enumerable:!0,get:function(){return r(o).default}});var i=n(52);Object.defineProperty(t,"toCssValue",{enumerable:!0,get:function(){return r(i).default}});var a=n(132);Object.defineProperty(t,"SheetsRegistry",{enumerable:!0,get:function(){return r(a).default}});var u=n(257);Object.defineProperty(t,"SheetsManager",{enumerable:!0,get:function(){return r(u).default}});var s=n(41);Object.defineProperty(t,"RuleList",{enumerable:!0,get:function(){return r(s).default}});var l=n(86);Object.defineProperty(t,"sheets",{enumerable:!0,get:function(){return r(l).default}});var c=n(135);Object.defineProperty(t,"createGenerateClassName",{enumerable:!0,get:function(){return r(c).default}});var f=n(261),d=r(f),p=t.create=function(e){return new d.default(e)};t.default=p()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=function(){function e(){r(this,e),this.registry=[]}return o(e,[{key:"add",value:function(e){var t=this.registry,n=e.options.index;if(-1===t.indexOf(e)){if(0===t.length||n>=this.index)return void t.push(e);for(var r=0;r<t.length;r++)if(t[r].options.index>n)return void t.splice(r,0,e)}}},{key:"reset",value:function(){this.registry=[]}},{key:"remove",value:function(e){var t=this.registry.indexOf(e);this.registry.splice(t,1)}},{key:"toString",value:function(e){return this.registry.filter(function(e){return e.attached}).map(function(t){return t.toString(e)}).join("\n")}},{key:"index",get:function(){return 0===this.registry.length?0:this.registry[this.registry.length-1].options.index}}]),e}();t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(103),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){return e&&e[o.default]&&e===e[o.default]()}},function(e,t,n){"use strict";function r(e,t){e.renderable=t,e.rules&&t.cssRules&&e.rules.link(t.cssRules)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(12),i=r(o),a=n(136),u=(r(a),n(260)),s=r(u);t.default=function(){var e=0;return function(t,n){(e+=1)>1e10&&(0,i.default)(!1,"[JSS] You might have a memory leak. Rule counter is at %s.",e);var r="c",o="";return n&&(r=n.options.classNamePrefix||"c",null!=n.options.jss.id&&(o+=n.options.jss.id)),""+r+s.default+o+e}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(134),s=r(u),l=n(41),c=r(l),f=function(){function e(t,n){o(this,e),this.attached=!1,this.deployed=!1,this.linked=!1,this.classes={},this.options=i({},n,{sheet:this,parent:this,classes:this.classes}),this.renderer=new n.Renderer(this),this.rules=new c.default(this.options);for(var r in t)this.rules.add(r,t[r]);this.rules.process()}return a(e,[{key:"attach",value:function(){return this.attached?this:(this.deployed||this.deploy(),this.renderer.attach(),!this.linked&&this.options.link&&this.link(),this.attached=!0,this)}},{key:"detach",value:function(){return this.attached?(this.renderer.detach(),this.attached=!1,this):this}},{key:"addRule",value:function(e,t,n){var r=this.queue;this.attached&&!r&&(this.queue=[]);var o=this.rules.add(e,t,n);return this.options.jss.plugins.onProcessRule(o),this.attached?this.deployed?(r?r.push(o):(this.insertRule(o),this.queue&&(this.queue.forEach(this.insertRule,this),this.queue=void 0)),o):o:(this.deployed=!1,o)}},{key:"insertRule",value:function(e){var t=this.renderer.insertRule(e);t&&this.options.link&&(0,s.default)(e,t)}},{key:"addRules",value:function(e,t){var n=[];for(var r in e)n.push(this.addRule(r,e[r],t));return n}},{key:"getRule",value:function(e){return this.rules.get(e)}},{key:"deleteRule",value:function(e){var t=this.rules.get(e);return!!t&&(this.rules.remove(t),!this.attached||!t.renderable||this.renderer.deleteRule(t.renderable))}},{key:"indexOf",value:function(e){return this.rules.indexOf(e)}},{key:"deploy",value:function(){return this.renderer.deploy(),this.deployed=!0,this}},{key:"link",value:function(){var e=this.renderer.getRules();return e&&this.rules.link(e),this.linked=!0,this}},{key:"update",value:function(e,t){return this.rules.update(e,t),this}},{key:"toString",value:function(e){return this.rules.toString(e)}}]),e}();t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){return{plugins:[(0,a.default)(),(0,s.default)(),(0,c.default)(),(0,d.default)(),(0,h.default)(),(0,v.default)()]}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(273),a=r(i),u=n(274),s=r(u),l=n(275),c=r(l),f=n(277),d=r(f),p=n(279),h=r(p),y=n(284),v=r(y);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){return"@media (min-width:"+("number"==typeof c[e]?c[e]:e)+d+")"}function n(e){var n=l.indexOf(e)+1,r=c[l[n]];return n===l.length?t("xs"):"@media (max-width:"+(("number"==typeof r&&n>0?r:e)-h/100)+d+")"}function r(e,n){var r=l.indexOf(n)+1;return r===l.length?t(e):"@media (min-width:"+c[e]+d+") and (max-width:"+(c[l[r]]-h/100)+d+")"}function o(e){return r(e,e)}function i(e){return c[e]}var u=e.values,c=void 0===u?{xs:0,sm:600,md:960,lg:1280,xl:1920}:u,f=e.unit,d=void 0===f?"px":f,p=e.step,h=void 0===p?5:p,y=(0,s.default)(e,["values","unit","step"]);return(0,a.default)({keys:l,values:c,up:t,down:n,between:r,only:o,width:i},y)}Object.defineProperty(t,"__esModule",{value:!0}),t.keys=void 0;var i=n(2),a=r(i),u=n(3),s=r(u);t.default=o;var l=t.keys=["xs","sm","md","lg","xl"]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={black:"#000",white:"#fff"};t.default=r},function(e,t,n){"use strict";function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dangerouslyUseGlobalCSS,n=void 0!==t&&t,r=e.productionPrefix,o=void 0===r?"jss":r,a=/([[\].#*$><+~=|^:(),"'`\s])/g,u=0;return"undefined"!=typeof window&&"jss"===o&&(i+=1)>2&&console.error(["Material-UI: we have detected more than needed creation of the class name generator.","You should only use one class name generator on the client side.","If you do otherwise, you take the risk to have conflicting class names in production."].join("\n")),function(e,t){if(u+=1,n){if(t&&t.options.classNamePrefix){var r=t.options.classNamePrefix;if(r=r.replace(a,"-"),r.match(/^Mui/))return r+"-"+e.key}return""+o+u}return""+o+u}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(12),i=(function(e){e&&e.__esModule}(o),0)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(299);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(147);Object.defineProperty(t,"Backdrop",{enumerable:!0,get:function(){return r(i).default}});var a=n(144);Object.defineProperty(t,"ModalManager",{enumerable:!0,get:function(){return r(a).default}})},function(e,t,n){"use strict";function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:(0,i.default)();try{return e.activeElement}catch(e){}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(23),i=function(e){return e&&e.__esModule?e:{default:e}}(o);e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(8),i=r(o),a=n(7),u=r(a),s=n(9),l=r(s),c=n(10),f=r(c),d=n(11),p=r(d),h=n(0),y=r(h),v=n(1),m=(r(v),function(e){function t(){return(0,u.default)(this,t),(0,f.default)(this,(t.__proto__||(0,i.default)(t)).apply(this,arguments))}return(0,p.default)(t,e),(0,l.default)(t,[{key:"render",value:function(){return this.props.children}}]),t}(y.default.Component));m.propTypes={},t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=-1;return e.some(function(e,r){return!!t(e)&&(n=r,!0)}),n}function i(e,t){return o(e,function(e){return-1!==e.modals.indexOf(t)})}function a(e){return parseInt((0,h.default)(e,"paddingRight")||0,10)}function u(e,t){var n={overflow:"hidden"};if(e.style={overflow:t.style.overflow,paddingRight:t.style.paddingRight},e.overflowing){var r=(0,v.default)();n.paddingRight=a(t)+r+"px";for(var o=document.querySelectorAll(".mui-fixed"),i=0;i<o.length;i+=1){var u=a(o[i]);e.prevPaddings.push(u),o[i].style.paddingRight=u+r+"px"}}(0,d.default)(n).forEach(function(e){t.style[e]=n[e]})}function s(e,t){(0,d.default)(e.style).forEach(function(n){t.style[n]=e.style[n]});for(var n=document.querySelectorAll(".mui-fixed"),r=0;r<n.length;r+=1)n[r].style.paddingRight=e.prevPaddings[r]+"px"}Object.defineProperty(t,"__esModule",{value:!0});var l=n(7),c=r(l),f=n(31),d=r(f),p=n(314),h=r(p),y=n(146),v=r(y),m=n(322),b=r(m),g=n(324),_=function e(){var t=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.hideSiblingNodes,o=void 0===r||r,a=n.handleContainerOverflow,l=void 0===a||a;(0,c.default)(this,e),this.add=function(e,n){var r=t.modals.indexOf(e),o=t.containers.indexOf(n);if(-1!==r)return r;if(r=t.modals.length,t.modals.push(e),t.hideSiblingNodes&&(0,g.hideSiblings)(n,e.mountNode),-1!==o)return t.data[o].modals.push(e),r;var i={modals:[e],overflowing:(0,b.default)(n),prevPaddings:[]};return t.handleContainerOverflow&&u(i,n),t.containers.push(n),t.data.push(i),r},this.remove=function(e){var n=t.modals.indexOf(e);if(-1===n)return n;var r=i(t.data,e),o=t.data[r],a=t.containers[r];return o.modals.splice(o.modals.indexOf(e),1),t.modals.splice(n,1),0===o.modals.length?(t.handleContainerOverflow&&s(o,a),t.hideSiblingNodes&&(0,g.showSiblings)(a,e.mountNode),t.containers.splice(r,1),t.data.splice(r,1)):t.hideSiblingNodes&&(0,g.ariaHidden)(!1,o.modals[o.modals.length-1].mountNode),n},this.isTopModal=function(e){return!!t.modals.length&&t.modals[t.modals.length-1]===e},this.hideSiblingNodes=o,this.handleContainerOverflow=l,this.modals=[],this.containers=[],this.data=[]};t.default=_},function(e,t,n){"use strict";function r(e){return(0,i.default)(e.replace(a,"ms-"))}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(315),i=function(e){return e&&e.__esModule?e:{default:e}}(o),a=/^-ms-/;e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){if((!i&&0!==i||e)&&o.default){var t=document.createElement("div");t.style.position="absolute",t.style.top="-9999px",t.style.width="50px",t.style.height="50px",t.style.overflow="scroll",document.body.appendChild(t),i=t.offsetWidth-t.clientWidth,document.body.removeChild(t)}return i};var r=n(57),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=void 0;e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.classes,n=e.invisible,r=e.open,o=e.transitionDuration,i=(0,c.default)(e,["classes","invisible","open","transitionDuration"]),u=(0,y.default)(t.root,(0,s.default)({},t.invisible,n));return d.default.createElement(g.default,(0,a.default)({appear:!0,in:r,timeout:o},i),d.default.createElement("div",{className:u,"aria-hidden":"true"}))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(148),g=r(b),_=t.styles={root:{zIndex:-1,width:"100%",height:"100%",position:"fixed",top:0,left:0,WebkitTapHighlightColor:"transparent",willChange:"opacity",backgroundColor:"rgba(0, 0, 0, 0.5)"},invisible:{backgroundColor:"transparent"}};o.propTypes={},o.defaultProps={invisible:!1},t.default=(0,m.default)(_,{name:"MuiBackdrop"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(94)),x=r(w),O=n(90),S=n(58),T=r(S),E=n(149),C={entering:{opacity:1},entered:{opacity:1}},k=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.handleEnter=function(e){var t=r.props.theme;(0,E.reflow)(e);var n=(0,E.getTransitionProps)(r.props,{mode:"enter"}),o=n.duration,i=n.delay;e.style.transition=t.transitions.create("opacity",{duration:o,delay:i}),e.style.webkitTransition=t.transitions.create("opacity",{duration:o,delay:i}),r.props.onEnter&&r.props.onEnter(e)},r.handleExit=function(e){var t=r.props.theme,n=(0,E.getTransitionProps)(r.props,{mode:"exit"}),o=n.duration,i=n.delay;e.style.transition=t.transitions.create("opacity",{duration:o,delay:i}),e.style.webkitTransition=t.transitions.create("opacity",{duration:o,delay:i}),r.props.onExit&&r.props.onExit(e)},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"render",value:function(){var e=this.props,t=e.children,n=(e.onEnter,e.onExit,e.style),r=(e.theme,(0,u.default)(e,["children","onEnter","onExit","style","theme"])),o=(0,i.default)({},n,g.default.isValidElement(t)?t.props.style:{});return g.default.createElement(x.default,(0,i.default)({appear:!0,onEnter:this.handleEnter,onExit:this.handleExit},r),function(e,n){return g.default.cloneElement(t,(0,i.default)({style:(0,i.default)({opacity:0},C[e],o)},n))})}}]),t}(g.default.Component);k.propTypes={},k.defaultProps={timeout:{enter:O.duration.enteringScreen,exit:O.duration.leavingScreen}},t.default=(0,T.default)()(k)},function(e,t,n){"use strict";function r(e,t){var n=e.timeout,r=e.style,o=void 0===r?{}:r;return{duration:o.transitionDuration||"number"==typeof n?n:n[t.mode],delay:o.transitionDelay}}Object.defineProperty(t,"__esModule",{value:!0}),t.getTransitionProps=r;t.reflow=function(e){return e.scrollTop}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(326);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){var t=(0,i.default)(e);return t&&t.defaultView||t.parentWindow}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(23),i=function(e){return e&&e.__esModule?e:{default:e}}(o);e.exports=t.default},function(e,t){function n(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=n},function(e,t,n){var r=n(349),o="object"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function("return this")();e.exports=i},function(e,t,n){var r=n(153),o=r.Symbol;e.exports=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(18)),x=n(146),O=r(x),S=n(4),T=r(S),E=n(360),C=r(E),k=n(156),P=r(k),M={vertical:"top",horizontal:"right"},j={vertical:"top",horizontal:"left"},N=t.styles={paper:{maxHeight:"calc(100vh - 96px)",WebkitOverflowScrolling:"touch"}},I=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.getContentAnchorEl=function(){return r.menuList&&r.menuList.selectedItem?(0,w.findDOMNode)(r.menuList.selectedItem):(0,w.findDOMNode)(r.menuList).firstChild},r.menuList=void 0,r.focus=function(){if(r.menuList&&r.menuList.selectedItem)return void(0,w.findDOMNode)(r.menuList.selectedItem).focus();var e=(0,w.findDOMNode)(r.menuList);e&&e.firstChild&&e.firstChild.focus()},r.handleEnter=function(e){var t=r.props.theme,n=(0,w.findDOMNode)(r.menuList);if(r.focus(),n&&e.clientHeight<n.clientHeight&&!n.style.width){var o=(0,O.default)()+"px";n.style["rtl"===t.direction?"paddingLeft":"paddingRight"]=o,n.style.width="calc(100% + "+o+")"}r.props.onEnter&&r.props.onEnter(e)},r.handleListKeyDown=function(e,t){"tab"===t&&(e.preventDefault(),r.props.onClose&&r.props.onClose(e))},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentDidMount",value:function(){this.props.open&&this.focus()}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,r=t.classes,o=t.MenuListProps,a=(t.onEnter,t.PaperProps),s=void 0===a?{}:a,l=t.PopoverClasses,c=t.theme,f=(0,u.default)(t,["children","classes","MenuListProps","onEnter","PaperProps","PopoverClasses","theme"]);return g.default.createElement(C.default,(0,i.default)({getContentAnchorEl:this.getContentAnchorEl,classes:l,onEnter:this.handleEnter,anchorOrigin:"rtl"===c.direction?M:j,transformOrigin:"rtl"===c.direction?M:j,PaperProps:(0,i.default)({},s,{classes:(0,i.default)({},s.classes,{root:r.paper})})},f),g.default.createElement(P.default,(0,i.default)({role:"menu",onKeyDown:this.handleListKeyDown},o,{ref:function(t){e.menuList=t}}),n))}}]),t}(g.default.Component);I.propTypes={},I.defaultProps={transitionDuration:"auto"},t.default=(0,T.default)(N,{name:"MuiMenu",withTheme:!0})(I)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),i=r(o),a=n(3),u=r(a),s=n(95),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=(r(x),n(18)),S=n(42),T=r(S),E=n(56),C=r(E),k=n(142),P=r(k),M=n(23),j=r(M),N=n(157),I=r(N),A=function(e){function t(){var e,n,r,o;(0,p.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,m.default)(this,(e=t.__proto__||(0,f.default)(t)).call.apply(e,[this].concat(a))),r.state={currentTabIndex:void 0},r.list=void 0,r.selectedItem=void 0,r.blurTimer=void 0,r.handleBlur=function(e){r.blurTimer=setTimeout(function(){if(r.list){var e=(0,O.findDOMNode)(r.list),t=(0,P.default)((0,j.default)(e));(0,C.default)(e,t)||r.resetTabIndex()}},30),r.props.onBlur&&r.props.onBlur(e)},r.handleKeyDown=function(e){var t=(0,O.findDOMNode)(r.list),n=(0,T.default)(e),o=(0,P.default)((0,j.default)(t));"up"!==n&&"down"!==n||o&&(!o||(0,C.default)(t,o))?"down"===n?(e.preventDefault(),o.nextElementSibling&&o.nextElementSibling.focus()):"up"===n&&(e.preventDefault(),o.previousElementSibling&&o.previousElementSibling.focus()):r.selectedItem?(0,O.findDOMNode)(r.selectedItem).focus():t.firstChild.focus(),r.props.onKeyDown&&r.props.onKeyDown(e,n)},r.handleItemFocus=function(e){var t=(0,O.findDOMNode)(r.list);if(t)for(var n=0;n<t.children.length;n+=1)if(t.children[n]===e.currentTarget){r.setTabIndex(n);break}},o=n,(0,m.default)(r,o)}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentDidMount",value:function(){this.resetTabIndex()}},{key:"componentWillUnmount",value:function(){clearTimeout(this.blurTimer)}},{key:"setTabIndex",value:function(e){this.setState({currentTabIndex:e})}},{key:"focus",value:function(){var e=this.state.currentTabIndex,t=(0,O.findDOMNode)(this.list);t&&t.children&&t.firstChild&&(e&&e>=0?t.children[e].focus():t.firstChild.focus())}},{key:"resetTabIndex",value:function(){var e=(0,O.findDOMNode)(this.list),t=(0,P.default)((0,j.default)(e)),n=[].concat((0,l.default)(e.children)),r=n.indexOf(t);return-1!==r?this.setTabIndex(r):this.selectedItem?this.setTabIndex(n.indexOf((0,O.findDOMNode)(this.selectedItem))):this.setTabIndex(0)}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,r=t.className,o=(t.onBlur,t.onKeyDown,(0,u.default)(t,["children","className","onBlur","onKeyDown"]));return w.default.createElement(I.default,(0,i.default)({role:"menu",ref:function(t){e.list=t},className:r,onKeyDown:this.handleKeyDown,onBlur:this.handleBlur},o),w.default.Children.map(n,function(t,n){return w.default.isValidElement(t)?w.default.cloneElement(t,{tabIndex:n===e.state.currentTabIndex?0:-1,ref:t.props.selected?function(t){e.selectedItem=t}:void 0,onFocus:e.handleItemFocus}):null}))}}]),t}(w.default.Component);A.propTypes={},t.default=A},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(363);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(158);Object.defineProperty(t,"ListItem",{enumerable:!0,get:function(){return r(i).default}});var a=n(364);Object.defineProperty(t,"ListItemAvatar",{enumerable:!0,get:function(){return r(a).default}});var u=n(365);Object.defineProperty(t,"ListItemText",{enumerable:!0,get:function(){return r(u).default}});var s=n(366);Object.defineProperty(t,"ListItemIcon",{enumerable:!0,get:function(){return r(s).default}});var l=n(367);Object.defineProperty(t,"ListItemSecondaryAction",{enumerable:!0,get:function(){return r(l).default}});var c=n(368);Object.defineProperty(t,"ListSubheader",{enumerable:!0,get:function(){return r(c).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(6),u=r(a),s=n(3),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=r(x),S=n(5),T=r(S),E=n(4),C=r(E),k=n(60),P=r(k),M=n(61),j=t.styles=function(e){return{root:{display:"flex",justifyContent:"flex-start",alignItems:"center",position:"relative",textDecoration:"none",width:"100%",boxSizing:"border-box",textAlign:"left"},container:{position:"relative"},keyboardFocused:{backgroundColor:e.palette.action.hover},default:{paddingTop:12,paddingBottom:12},dense:{paddingTop:e.spacing.unit,paddingBottom:e.spacing.unit},disabled:{opacity:.5},divider:{borderBottom:"1px solid "+e.palette.divider,backgroundClip:"padding-box"},gutters:{paddingLeft:2*e.spacing.unit,paddingRight:2*e.spacing.unit},button:{transition:e.transitions.create("background-color",{duration:e.transitions.duration.shortest}),"&:hover":{textDecoration:"none",backgroundColor:e.palette.action.hover,"@media (hover: none)":{backgroundColor:"transparent"}}},secondaryAction:{paddingRight:4*e.spacing.unit}}},N=function(e){function t(){return(0,p.default)(this,t),(0,m.default)(this,(t.__proto__||(0,f.default)(t)).apply(this,arguments))}return(0,g.default)(t,e),(0,y.default)(t,[{key:"getChildContext",value:function(){return{dense:this.props.dense||this.context.dense||!1}}},{key:"render",value:function(){var e,t=this.props,n=t.button,r=t.children,o=t.classes,a=t.className,s=t.component,c=t.ContainerComponent,f=t.ContainerProps,d=t.dense,p=t.disabled,h=t.disableGutters,y=t.divider,v=(0,l.default)(t,["button","children","classes","className","component","ContainerComponent","ContainerProps","dense","disabled","disableGutters","divider"]),m=d||this.context.dense||!1,b=w.default.Children.toArray(r),g=b.some(function(e){return(0,M.isMuiElement)(e,["ListItemAvatar"])}),_=b.length&&(0,M.isMuiElement)(b[b.length-1],["ListItemSecondaryAction"]),x=(0,T.default)(o.root,m||g?o.dense:o.default,(e={},(0,u.default)(e,o.gutters,!h),(0,u.default)(e,o.divider,y),(0,u.default)(e,o.disabled,p),(0,u.default)(e,o.button,n),(0,u.default)(e,o.secondaryAction,_),e),a),O=(0,i.default)({className:x,disabled:p},v),S=s||"li";return n&&(O.component=s||"div",O.keyboardFocusedClassName=o.keyboardFocused,S=P.default),_?(S=S===P.default||s?S:"div",w.default.createElement(c,(0,i.default)({className:o.container},f),w.default.createElement(S,O,b),b.pop())):w.default.createElement(S,O,b)}}]),t}(w.default.Component);N.propTypes={},N.defaultProps={button:!1,ContainerComponent:"li",dense:!1,disabled:!1,disableGutters:!1,divider:!1},N.contextTypes={dense:O.default.bool},N.childContextTypes={dense:O.default.bool},t.default=(0,C.default)(j,{name:"MuiListItem"})(N)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(160);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.autoWidth,n=e.children,r=e.classes,o=e.displayEmpty,i=e.input,u=e.inputProps,l=e.MenuProps,f=e.multiple,d=e.native,h=e.onClose,y=e.onOpen,v=e.open,m=e.renderValue,b=(0,s.default)(e,["autoWidth","children","classes","displayEmpty","input","inputProps","MenuProps","multiple","native","onClose","onOpen","open","renderValue"]);return c.default.cloneElement(i,(0,a.default)({inputComponent:p.default},b,{inputProps:(0,a.default)({},u,i?i.props.inputProps:{},{autoWidth:t,children:n,classes:r,displayEmpty:o,MenuProps:l,multiple:f,native:d,onClose:h,onOpen:y,open:v,renderValue:m})}))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(370)),p=r(d),h=n(4),y=r(h),v=n(98),m=r(v),b=t.styles=function(e){return{root:{position:"relative",width:"100%"},select:{"-moz-appearance":"none","-webkit-appearance":"none",userSelect:"none",paddingRight:4*e.spacing.unit,width:"calc(100% - "+4*e.spacing.unit+"px)",minWidth:2*e.spacing.unit,cursor:"pointer","&:focus":{background:"light"===e.palette.type?"rgba(0, 0, 0, 0.05)":"rgba(255, 255, 255, 0.05)",borderRadius:0},"&:-moz-focusring":{color:"transparent",textShadow:"0 0 0 #000"},"&::-ms-expand":{display:"none"}},selectMenu:{width:"auto",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden",minHeight:"1.1875em",lineHeight:"1.1875em"},disabled:{cursor:"default"},icon:{position:"absolute",right:0,top:"calc(50% - 12px)",color:e.palette.action.active,"pointer-events":"none"}}};o.propTypes={},o.defaultProps={autoWidth:!1,displayEmpty:!1,input:c.default.createElement(m.default,null),multiple:!1,native:!1},o.muiName="Select",t.default=(0,y.default)(b,{name:"MuiSelect"})(o)},function(e,t,n){"use strict";t.__esModule=!0;var r=n(373),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(e){return(0,o.default)("displayName",e)};t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(379);Object.defineProperty(t,"FormGroup",{enumerable:!0,get:function(){return r(o).default}});var i=n(380);Object.defineProperty(t,"FormLabel",{enumerable:!0,get:function(){return r(i).default}});var a=n(163);Object.defineProperty(t,"FormControl",{enumerable:!0,get:function(){return r(a).default}});var u=n(164);Object.defineProperty(t,"FormHelperText",{enumerable:!0,get:function(){return r(u).default}});var s=n(381);Object.defineProperty(t,"FormControlLabel",{enumerable:!0,get:function(){return r(s).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(6),u=r(a),s=n(3),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=r(x),S=n(5),T=r(S),E=n(4),C=r(E),k=n(97),P=n(21),M=n(61),j=t.styles=function(e){return{root:{display:"inline-flex",flexDirection:"column",position:"relative",minWidth:0,padding:0,margin:0,border:0},marginNormal:{marginTop:2*e.spacing.unit,marginBottom:e.spacing.unit},marginDense:{marginTop:e.spacing.unit,marginBottom:e.spacing.unit/2},fullWidth:{width:"100%"}}},N=function(e){function t(e,n){(0,p.default)(this,t);var r=(0,m.default)(this,(t.__proto__||(0,f.default)(t)).call(this,e,n));r.state={adornedStart:!1,dirty:!1,focused:!1},r.handleFocus=function(e){r.props.onFocus&&r.props.onFocus(e),r.setState(function(e){return e.focused?null:{focused:!0}})},r.handleBlur=function(e){r.props.onBlur&&e&&r.props.onBlur(e),r.setState(function(e){return e.focused?{focused:!1}:null})},r.handleDirty=function(){r.state.dirty||r.setState({dirty:!0})},r.handleClean=function(){r.state.dirty&&r.setState({dirty:!1})};var o=r.props.children;return o&&w.default.Children.forEach(o,function(e){(0,M.isMuiElement)(e,["Input","Select"])&&(0,k.isDirty)(e.props,!0)&&(r.state.dirty=!0),(0,M.isMuiElement)(e,["Input"])&&(0,k.isAdornedStart)(e.props)&&(r.state.adornedStart=!0)}),r}return(0,g.default)(t,e),(0,y.default)(t,[{key:"getChildContext",value:function(){var e=this.props,t=e.disabled,n=e.error,r=e.required,o=e.margin,i=this.state;return{muiFormControl:{adornedStart:i.adornedStart,dirty:i.dirty,disabled:t,error:n,focused:i.focused,margin:o,required:r,onDirty:this.handleDirty,onClean:this.handleClean,onFocus:this.handleFocus,onBlur:this.handleBlur}}}},{key:"render",value:function(){var e,t=this.props,n=t.classes,r=t.className,o=t.component,a=(t.disabled,t.error,t.fullWidth),s=t.margin,c=(t.required,(0,l.default)(t,["classes","className","component","disabled","error","fullWidth","margin","required"]));return w.default.createElement(o,(0,i.default)({className:(0,T.default)(n.root,(e={},(0,u.default)(e,n["margin"+(0,P.capitalize)(s)],"none"!==s),(0,u.default)(e,n.fullWidth,a),e),r)},c,{onFocus:this.handleFocus,onBlur:this.handleBlur}))}}]),t}(w.default.Component);N.propTypes={},N.defaultProps={component:"div",disabled:!1,error:!1,fullWidth:!1,margin:"none",required:!1},N.childContextTypes={muiFormControl:O.default.object},t.default=(0,C.default)(j,{name:"MuiFormControl"})(N)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.classes,o=e.className,i=e.disabled,u=e.error,l=e.margin,f=e.component,p=(0,c.default)(e,["classes","className","disabled","error","margin","component"]),h=t.muiFormControl,y=i,m=u,b=l;h&&(void 0===y&&(y=h.disabled),void 0===m&&(m=h.error),void 0===b&&(b=h.margin));var g=(0,v.default)(r.root,(n={},(0,s.default)(n,r.disabled,y),(0,s.default)(n,r.error,m),(0,s.default)(n,r.dense,"dense"===b),n),o);return d.default.createElement(f,(0,a.default)({className:g},p))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=t.styles=function(e){return{root:{color:e.palette.text.secondary,fontFamily:e.typography.fontFamily,fontSize:e.typography.pxToRem(12),textAlign:"left",marginTop:e.spacing.unit,lineHeight:"1em",minHeight:"1em",margin:0},dense:{marginTop:e.spacing.unit/2},error:{color:e.palette.error.main},disabled:{color:e.palette.text.disabled}}};o.propTypes={},o.defaultProps={component:"p"},o.contextTypes={muiFormControl:h.default.object},t.default=(0,b.default)(g,{name:"MuiFormHelperText"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(382);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(383);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(384);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.actionTypes=void 0;var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},o=n(66),i=t.actionTypes={SET_D2:"SET_D2",SET_FAVORITE_TYPE:"SET_FAVORITE_TYPE",SET_ACTIONS_MENU_ANCHOR_EL:"SET_ACTIONS_MENU_ANCHOR_EL",SET_SORT_ORDER:"SET_SORT_ORDER",SET_SORT_COLUMN:"SET_SORT_COLUMN",SET_DATA:"SET_DATA",SET_SEARCH_VALUE:"SET_SEARCH_VALUE",SET_FILTER_VALUE:"SET_FILTER_VALUE",SET_CREATEDBY_VALUE:"SET_CREATEDBY_VALUE",SET_PAGE:"SET_PAGE",SET_ROWS_PER_PAGE:"SET_ROWS_PER_PAGE",SET_TOTAL_RECORDS:"SET_TOTAL_RECORDS",SET_SELECTED_FAVORITE:"SET_SELECTED_FAVORITE",TOGGLE_LOADING:"TOGGLE_LOADING",TOGGLE_DELETE_DIALOG:"TOGGLE_DELETE_DIALOG",TOGGLE_RENAME_DIALOG:"TOGGLE_RENAME_DIALOG",TOGGLE_SHARE_DIALOG:"TOGGLE_SHARE_DIALOG",TOGGLE_ACTIONS_MENU:"TOGGLE_ACTIONS_MENU"},a={d2:null,isLoading:!1,actions:{menuIsOpen:!1,menuAnchorEl:null,remove:{dialogIsOpen:!1},rename:{dialogIsOpen:!1},share:{dialogIsOpen:!1},select:{favoriteModel:null}},data:{records:[],totalRecords:0,filtering:{type:"chart",searchValue:"",createdByValue:"all"},sorting:{order:"asc",column:"displayName"},pagination:{page:0,rowsPerPage:10}}},u=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.isLoading;switch(arguments[1].type){case i.TOGGLE_LOADING:return!e;default:return e}},s=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.d2,t=arguments[1];switch(t.type){case i.SET_D2:return t.payload;default:return e}},l=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.actions,t=arguments[1];switch(t.type){case i.TOGGLE_ACTIONS_MENU:return r({},e,{menuIsOpen:!e.menuIsOpen});case i.SET_ACTIONS_MENU_ANCHOR_EL:return r({},e,{menuAnchorEl:t.payload});case i.TOGGLE_SHARE_DIALOG:return r({},e,{share:r({},e.share,{dialogIsOpen:!e.share.dialogIsOpen})});case i.TOGGLE_DELETE_DIALOG:return r({},e,{remove:r({},e.remove,{dialogIsOpen:!e.remove.dialogIsOpen})});case i.TOGGLE_RENAME_DIALOG:return r({},e,{rename:r({},e.rename,{dialogIsOpen:!e.rename.dialogIsOpen})});case i.SET_SELECTED_FAVORITE:return r({},e,{select:{favoriteModel:t.payload}});default:return e}},c=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.data.sorting,t=arguments[1];switch(t.type){case i.SET_SORT_ORDER:return r({},e,{order:t.payload});case i.SET_SORT_COLUMN:return r({},e,{column:t.payload});default:return e}},f=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.data,t=arguments[1];switch(t.type){case i.SET_DATA:return r({},e,{records:t.payload});case i.SET_TOTAL_RECORDS:return r({},e,{totalRecords:t.payload});default:return e}},d=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.data.pagination,t=arguments[1];switch(t.type){case i.SET_PAGE:return r({},e,{page:t.payload});case i.SET_ROWS_PER_PAGE:return r({},e,{rowsPerPage:t.payload});default:return e}},p=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.data.filtering,t=arguments[1];switch(t.type){case i.SET_FAVORITE_TYPE:return r({},e,{type:t.payload});case i.SET_CREATEDBY_VALUE:return r({},e,{createdByValue:t.payload});case i.SET_SEARCH_VALUE:return r({},e,{searchValue:t.payload});default:return e}};t.default=(0,o.combineReducers)({loading:u,actions:l,pagination:d,sorting:c,data:f,filtering:p,d2:s})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(393);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.children,o=e.classes,i=e.className,u=e.component,l=e.sortDirection,f=e.numeric,p=e.padding,h=e.scope,y=e.variant,m=(0,c.default)(e,["children","classes","className","component","sortDirection","numeric","padding","scope","variant"]),b=t.table,_=void 0;_=u||(b&&b.head?"th":"td");var w=h;!w&&b&&b.head&&(w="col");var x=(0,v.default)(o.root,(n={},(0,s.default)(n,o.numeric,f),(0,s.default)(n,o["padding"+(0,g.capitalize)(p)],"none"!==p&&"default"!==p),(0,s.default)(n,o.paddingDefault,"none"!==p),(0,s.default)(n,o.typeHead,y?"head"===y:b&&b.head),(0,s.default)(n,o.typeBody,y?"body"===y:b&&b.body),(0,s.default)(n,o.typeFooter,y?"footer"===y:b&&b.footer),n),i),O=null;return l&&(O="asc"===l?"ascending":"descending"),d.default.createElement(_,(0,a.default)({className:x,"aria-sort":O,scope:w},m),r)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=n(21),_=n(89),w=t.styles=function(e){return{root:{borderBottom:"1px solid\n    "+("light"===e.palette.type?(0,_.lighten)((0,_.fade)(e.palette.divider,1),.88):(0,_.darken)((0,_.fade)(e.palette.divider,1),.8)),textAlign:"left"},numeric:{textAlign:"right",flexDirection:"row-reverse"},typeHead:{color:e.palette.text.secondary,fontSize:e.typography.pxToRem(12),fontWeight:e.typography.fontWeightMedium,position:"relative"},typeBody:{fontSize:e.typography.pxToRem(13),color:e.palette.text.primary},typeFooter:{borderBottom:0,color:e.palette.text.secondary,fontSize:e.typography.pxToRem(12)},paddingDefault:{padding:e.spacing.unit/2+"px "+7*e.spacing.unit+"px "+e.spacing.unit/2+"px "+3*e.spacing.unit+"px","&:last-child":{paddingRight:3*e.spacing.unit}},paddingDense:{paddingRight:3*e.spacing.unit},paddingCheckbox:{padding:"0 12px"}}};o.propTypes={},o.defaultProps={numeric:!1,padding:"default"},o.contextTypes={table:h.default.object.isRequired},t.default=(0,b.default)(w,{name:"MuiTableCell"})(o)},function(e,t,n){"use strict";(function(e){function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=e.__MUI_SvgIcon__||l.default,f=i.default.createElement("path",{d:"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"}),d=function(e){return i.default.createElement(c,e,f)};d=(0,u.default)(d),d.muiName="SvgIcon",t.default=d}).call(t,n(16))},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(173),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),l=r(s),c=n(32),f=n(200),d=r(f),p=n(1),h=r(p),y=n(413),v=r(y),m=n(36),b=(0,v.default)(),g=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return e.type&&b.dispatch((0,m.setFavoriteType)(e.type)),e.d2?b.dispatch((0,m.setD2)(e.d2)):console.error("no d2"),n}return a(t,e),u(t,[{key:"getChildContext",value:function(){return{d2:this.props.d2}}},{key:"render",value:function(){var e=this.props,t=e.open,n=e.type,r=e.onFavoriteSelect,o=e.onRequestClose;return l.default.createElement(c.Provider,{store:b},l.default.createElement(d.default,{open:t,type:n,onFavoriteSelect:r,onRequestClose:o}))}}]),t}(s.Component);g.childContextTypes={d2:h.default.object.isRequired},t.default=g},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"store",n=arguments[1],a=n||t+"Subscription",s=function(e){function n(i,a){r(this,n);var u=o(this,e.call(this,i,a));return u[t]=i.store,u}return i(n,e),n.prototype.getChildContext=function(){var e;return e={},e[t]=this[t],e[a]=null,e},n.prototype.render=function(){return u.Children.only(this.props.children)},n}(u.Component);return s.propTypes={store:c.a.isRequired,children:l.a.element.isRequired},s.childContextTypes=(e={},e[t]=c.a.isRequired,e[a]=c.b,e),s}t.a=a;var u=n(0),s=(n.n(u),n(1)),l=n.n(s),c=n(99);n(65);t.b=a()},function(e,t,n){"use strict";var r=n(64),o=n(176),i=n(177);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";function r(e,t,n,r,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,i,a,u,s],f=0;l=new Error(t.replace(/%s/g,function(){return c[f++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";var r=function(e,t,n,r,o,i,a,u){if(!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,o,i,a,u],c=0;s=new Error(t.replace(/%s/g,function(){return l[c++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}};e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){var e=[],t=[];return{clear:function(){t=i,e=i},notify:function(){for(var n=e=t,r=0;r<n.length;r++)n[r]()},get:function(){return t},subscribe:function(n){var r=!0;return t===e&&(t=e.slice()),t.push(n),function(){r&&e!==i&&(r=!1,t===e&&(t=e.slice()),t.splice(t.indexOf(n),1))}}}}n.d(t,"a",function(){return u});var i=null,a={notify:function(){}},u=function(){function e(t,n,o){r(this,e),this.store=t,this.parentSub=n,this.onStateChange=o,this.unsubscribe=null,this.listeners=a}return e.prototype.addNestedSub=function(e){return this.trySubscribe(),this.listeners.subscribe(e)},e.prototype.notifyNestedSubs=function(){this.listeners.notify()},e.prototype.isSubscribed=function(){return Boolean(this.unsubscribe)},e.prototype.trySubscribe=function(){this.unsubscribe||(this.unsubscribe=this.parentSub?this.parentSub.addNestedSub(this.onStateChange):this.store.subscribe(this.onStateChange),this.listeners=o())},e.prototype.tryUnsubscribe=function(){this.unsubscribe&&(this.unsubscribe(),this.unsubscribe=null,this.listeners.clear(),this.listeners=a)},e}()},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t,n){for(var r=t.length-1;r>=0;r--){var o=t[r](e);if(o)return o}return function(t,r){throw new Error("Invalid value of type "+typeof e+" for "+n+" argument when connecting component "+r.wrappedComponentName+".")}}function i(e,t){return e===t}var a=n(100),u=n(181),s=n(182),l=n(196),c=n(197),f=n(198),d=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.a=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.connectHOC,n=void 0===t?a.a:t,p=e.mapStateToPropsFactories,h=void 0===p?l.a:p,y=e.mapDispatchToPropsFactories,v=void 0===y?s.a:y,m=e.mergePropsFactories,b=void 0===m?c.a:m,g=e.selectorFactory,_=void 0===g?f.a:g;return function(e,t,a){var s=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},l=s.pure,c=void 0===l||l,f=s.areStatesEqual,p=void 0===f?i:f,y=s.areOwnPropsEqual,m=void 0===y?u.a:y,g=s.areStatePropsEqual,w=void 0===g?u.a:g,x=s.areMergedPropsEqual,O=void 0===x?u.a:x,S=r(s,["pure","areStatesEqual","areOwnPropsEqual","areStatePropsEqual","areMergedPropsEqual"]),T=o(e,h,"mapStateToProps"),E=o(t,v,"mapDispatchToProps"),C=o(a,b,"mergeProps");return n(_,d({methodName:"connect",getDisplayName:function(e){return"Connect("+e+")"},shouldHandleStateChanges:Boolean(e),initMapStateToProps:T,initMapDispatchToProps:E,initMergeProps:C,pure:c,areStatesEqual:p,areOwnPropsEqual:m,areStatePropsEqual:w,areMergedPropsEqual:O},S))}}()},function(e,t,n){"use strict";function r(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!==e&&t!==t}function o(e,t){if(r(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),o=Object.keys(t);if(n.length!==o.length)return!1;for(var a=0;a<n.length;a++)if(!i.call(t,n[a])||!r(e[n[a]],t[n[a]]))return!1;return!0}t.a=o;var i=Object.prototype.hasOwnProperty},function(e,t,n){"use strict";function r(e){return"function"==typeof e?Object(u.b)(e,"mapDispatchToProps"):void 0}function o(e){return e?void 0:Object(u.a)(function(e){return{dispatch:e}})}function i(e){return e&&"object"==typeof e?Object(u.a)(function(t){return Object(a.bindActionCreators)(e,t)}):void 0}var a=n(66),u=n(106);t.a=[r,o,i]},function(e,t,n){"use strict";function r(e){return null==e?void 0===e?s:u:l&&l in Object(e)?Object(i.a)(e):Object(a.a)(e)}var o=n(102),i=n(186),a=n(187),u="[object Null]",s="[object Undefined]",l=o.a?o.a.toStringTag:void 0;t.a=r},function(e,t,n){"use strict";var r=n(185),o="object"==typeof self&&self&&self.Object===Object&&self,i=r.a||o||Function("return this")();t.a=i},function(e,t,n){"use strict";(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.a=n}).call(t,n(16))},function(e,t,n){"use strict";function r(e){var t=a.call(e,s),n=e[s];try{e[s]=void 0;var r=!0}catch(e){}var o=u.call(e);return r&&(t?e[s]=n:delete e[s]),o}var o=n(102),i=Object.prototype,a=i.hasOwnProperty,u=i.toString,s=o.a?o.a.toStringTag:void 0;t.a=r},function(e,t,n){"use strict";function r(e){return i.call(e)}var o=Object.prototype,i=o.toString;t.a=r},function(e,t,n){"use strict";var r=n(189),o=Object(r.a)(Object.getPrototypeOf,Object);t.a=o},function(e,t,n){"use strict";function r(e,t){return function(n){return e(t(n))}}t.a=r},function(e,t,n){"use strict";function r(e){return null!=e&&"object"==typeof e}t.a=r},function(e,t){e.exports=function(e){if(!e.webpackPolyfill){var t=Object.create(e);t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),Object.defineProperty(t,"exports",{enumerable:!0}),t.webpackPolyfill=1}return t}},function(e,t,n){"use strict";function r(e){var t,n=e.Symbol;return"function"==typeof n?n.observable?t=n.observable:(t=n("observable"),n.observable=t):t="@@observable",t}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=t&&t.type;return"Given action "+(n&&'"'+n.toString()+'"'||"an action")+', reducer "'+e+'" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.'}function o(e){Object.keys(e).forEach(function(t){var n=e[t];if(void 0===n(void 0,{type:a.a.INIT}))throw new Error('Reducer "'+t+"\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");if(void 0===n(void 0,{type:"@@redux/PROBE_UNKNOWN_ACTION_"+Math.random().toString(36).substring(7).split("").join(".")}))throw new Error('Reducer "'+t+"\" returned undefined when probed with a random type. Don't try to handle "+a.a.INIT+' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.')})}function i(e){for(var t=Object.keys(e),n={},i=0;i<t.length;i++){var a=t[i];"function"==typeof e[a]&&(n[a]=e[a])}var u=Object.keys(n),s=void 0;try{o(n)}catch(e){s=e}return function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments[1];if(s)throw s;for(var o=!1,i={},a=0;a<u.length;a++){var l=u[a],c=n[l],f=e[l],d=c(f,t);if(void 0===d){var p=r(l,t);throw new Error(p)}i[l]=d,o=o||d!==f}return o?i:e}}t.a=i;var a=n(101);n(67),n(104)},function(e,t,n){"use strict";function r(e,t){return function(){return t(e.apply(void 0,arguments))}}function o(e,t){if("function"==typeof e)return r(e,t);if("object"!=typeof e||null===e)throw new Error("bindActionCreators expected an object or a function, instead received "+(null===e?"null":typeof e)+'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');for(var n=Object.keys(e),o={},i=0;i<n.length;i++){var a=n[i],u=e[a];"function"==typeof u&&(o[a]=r(u,t))}return o}t.a=o},function(e,t,n){"use strict";function r(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(e){return function(n,r,a){var u=e(n,r,a),s=u.dispatch,l=[],c={getState:u.getState,dispatch:function(e){return s(e)}};return l=t.map(function(e){return e(c)}),s=o.a.apply(void 0,l)(u.dispatch),i({},u,{dispatch:s})}}}t.a=r;var o=n(105),i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){"use strict";function r(e){return"function"==typeof e?Object(i.b)(e,"mapStateToProps"):void 0}function o(e){return e?void 0:Object(i.a)(function(){return{}})}var i=n(106);t.a=[r,o]},function(e,t,n){"use strict";function r(e,t,n){return u({},n,e,t)}function o(e){return function(t,n){var r=(n.displayName,n.pure),o=n.areMergedPropsEqual,i=!1,a=void 0;return function(t,n,u){var s=e(t,n,u);return i?r&&o(s,a)||(a=s):(i=!0,a=s),a}}}function i(e){return"function"==typeof e?o(e):void 0}function a(e){return e?void 0:function(){return r}}var u=(n(107),Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e});t.a=[i,a]},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t,n,r){return function(o,i){return n(e(o,i),t(r,i),i)}}function i(e,t,n,r,o){function i(o,i){return h=o,y=i,v=e(h,y),m=t(r,y),b=n(v,m,y),p=!0,b}function a(){return v=e(h,y),t.dependsOnOwnProps&&(m=t(r,y)),b=n(v,m,y)}function u(){return e.dependsOnOwnProps&&(v=e(h,y)),t.dependsOnOwnProps&&(m=t(r,y)),b=n(v,m,y)}function s(){var t=e(h,y),r=!d(t,v);return v=t,r&&(b=n(v,m,y)),b}function l(e,t){var n=!f(t,y),r=!c(e,h);return h=e,y=t,n&&r?a():n?u():r?s():b}var c=o.areStatesEqual,f=o.areOwnPropsEqual,d=o.areStatePropsEqual,p=!1,h=void 0,y=void 0,v=void 0,m=void 0,b=void 0;return function(e,t){return p?l(e,t):i(e,t)}}function a(e,t){var n=t.initMapStateToProps,a=t.initMapDispatchToProps,u=t.initMergeProps,s=r(t,["initMapStateToProps","initMapDispatchToProps","initMergeProps"]),l=n(e,s),c=a(e,s),f=u(e,s);return(s.pure?i:o)(l,c,f,e,s)}t.a=a;n(199)},function(e,t,n){"use strict";n(65)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),l=r(s),c=n(32),f=n(68),d=r(f),p=n(59),h=r(p),y=n(356),v=r(y),m=n(392),b=r(m),g=n(36),_=function(e){function t(){return o(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),u(t,[{key:"componentWillReceiveProps",value:function(e){e.open&&!e.dataIsLoaded&&this.props.fetchData()}},{key:"render",value:function(){var e=this.props,t=e.open,n=e.onRequestClose,r=e.onFavoriteSelect,o=function(e){r(e),n()};return l.default.createElement(d.default,{open:t,onClose:n,disableEnforceFocus:!0,maxWidth:"md"},l.default.createElement(f.DialogTitle,null,"Favorites"),l.default.createElement(f.DialogContent,null,l.default.createElement(v.default,null),l.default.createElement(b.default,{onFavoriteSelect:o})),l.default.createElement(f.DialogActions,null,l.default.createElement(h.default,{onClick:n},"Close")))}}]),t}(s.Component),w=function(e){return{dataIsLoaded:e.data.totalRecords>0}},x={fetchData:g.fetchData};t.default=(0,c.connect)(w,x)(_)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.children,r=e.classes,o=e.className,i=e.fullScreen,u=e.fullWidth,l=e.disableBackdropClick,f=e.disableEscapeKeyDown,p=e.maxWidth,h=e.onBackdropClick,v=e.onClose,m=e.onEnter,g=e.onEntered,w=e.onEntering,x=e.onEscapeKeyDown,O=e.onExit,S=e.onExited,E=e.onExiting,C=e.open,k=e.PaperProps,P=e.transition,M=e.transitionDuration,j=(0,c.default)(e,["children","classes","className","fullScreen","fullWidth","disableBackdropClick","disableEscapeKeyDown","maxWidth","onBackdropClick","onClose","onEnter","onEntered","onEntering","onEscapeKeyDown","onExit","onExited","onExiting","open","PaperProps","transition","transitionDuration"]);return d.default.createElement(_.default,(0,a.default)({className:(0,y.default)(r.root,o),BackdropProps:{transitionDuration:M},disableBackdropClick:l,disableEscapeKeyDown:f,onBackdropClick:h,onEscapeKeyDown:x,onClose:v,open:C,role:"dialog"},j),d.default.createElement(P,{appear:!0,in:C,timeout:M,onEnter:m,onEntering:w,onEntered:g,onExit:O,onExiting:E,onExited:S},d.default.createElement(T.default,(0,a.default)({elevation:24,className:(0,y.default)(r.paper,(t={},(0,s.default)(t,r["paperWidth"+(p?(0,b.capitalize)(p):"")],p),(0,s.default)(t,r.fullScreen,i),(0,s.default)(t,r.fullWidth,u),t))},k),n)))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(21),g=n(141),_=r(g),w=n(148),x=r(w),O=n(90),S=n(150),T=r(S),E=t.styles=function(e){return{root:{justifyContent:"center",alignItems:"center"},paper:{display:"flex",margin:4*e.spacing.unit,flexDirection:"column",flex:"0 1 auto",position:"relative",maxHeight:"90vh",overflowY:"auto","&:focus":{outline:"none"}},paperWidthXs:{maxWidth:Math.max(e.breakpoints.values.xs,360)},paperWidthSm:{maxWidth:e.breakpoints.values.sm},paperWidthMd:{maxWidth:e.breakpoints.values.md},fullWidth:{width:"100%"},fullScreen:{margin:0,width:"100%",maxWidth:"100%",height:"100%",maxHeight:"100%",borderRadius:0}}};o.propTypes={},o.defaultProps={fullScreen:!1,fullWidth:!1,disableBackdropClick:!1,disableEscapeKeyDown:!1,maxWidth:"sm",transition:x.default,transitionDuration:{enter:O.duration.enteringScreen,exit:O.duration.leavingScreen}},t.default=(0,m.default)(E,{name:"MuiDialog"})(o)},function(e,t,n){n(203),e.exports=n(13).Object.assign},function(e,t,n){var r=n(14);r(r.S+r.F,"Object",{assign:n(204)})},function(e,t,n){"use strict";var r=n(38),o=n(77),i=n(47),a=n(34),u=n(70),s=Object.assign;e.exports=!s||n(29)(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e}),7!=s({},e)[n]||Object.keys(s({},t)).join("")!=r})?function(e,t){for(var n=a(e),s=arguments.length,l=1,c=o.f,f=i.f;s>l;)for(var d,p=u(arguments[l++]),h=c?r(p).concat(c(p)):r(p),y=h.length,v=0;y>v;)f.call(p,d=h[v++])&&(n[d]=p[d]);return n}:s},function(e,t,n){var r=n(33),o=n(45),i=n(206);e.exports=function(e){return function(t,n,a){var u,s=r(t),l=o(s.length),c=i(a,l);if(e&&n!=n){for(;l>c;)if((u=s[c++])!=u)return!0}else for(;l>c;c++)if((e||c in s)&&s[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(73),o=Math.max,i=Math.min;e.exports=function(e,t){return e=r(e),e<0?o(e+t,0):i(e,t)}},function(e,t,n){n(208);var r=n(13).Object;e.exports=function(e,t,n){return r.defineProperty(e,t,n)}},function(e,t,n){var r=n(14);r(r.S+r.F*!n(20),"Object",{defineProperty:n(17).f})},function(e,t,n){n(210),e.exports=n(13).Object.keys},function(e,t,n){var r=n(34),o=n(38);n(113)("keys",function(){return function(e){return o(r(e))}})},function(e,t,n){n(212),e.exports=n(13).Object.getPrototypeOf},function(e,t,n){var r=n(34),o=n(114);n(113)("getPrototypeOf",function(){return function(e){return o(r(e))}})},function(e,t,n){e.exports={default:n(214),__esModule:!0}},function(e,t,n){n(79),n(116),e.exports=n(82).f("iterator")},function(e,t,n){var r=n(73),o=n(72);e.exports=function(e){return function(t,n){var i,a,u=String(o(t)),s=r(n),l=u.length;return s<0||s>=l?e?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===l||(a=u.charCodeAt(s+1))<56320||a>57343?e?u.charAt(s):i:e?u.slice(s,s+2):a-56320+(i-55296<<10)+65536)}}},function(e,t,n){"use strict";var r=n(49),o=n(37),i=n(50),a={};n(25)(a,n(15)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:o(1,n)}),i(e,t+" Iterator")}},function(e,t,n){var r=n(17),o=n(28),i=n(38);e.exports=n(20)?Object.defineProperties:function(e,t){o(e);for(var n,a=i(t),u=a.length,s=0;u>s;)r.f(e,n=a[s++],t[n]);return e}},function(e,t,n){var r=n(19).document;e.exports=r&&r.documentElement},function(e,t,n){"use strict";var r=n(220),o=n(117),i=n(39),a=n(33);e.exports=n(80)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,o(1)):"keys"==t?o(0,n):"values"==t?o(0,e[n]):o(0,[n,e[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t,n){e.exports={default:n(222),__esModule:!0}},function(e,t,n){n(223),n(121),n(226),n(227),e.exports=n(13).Symbol},function(e,t,n){"use strict";var r=n(19),o=n(30),i=n(20),a=n(14),u=n(115),s=n(83).KEY,l=n(29),c=n(75),f=n(50),d=n(46),p=n(15),h=n(82),y=n(84),v=n(224),m=n(118),b=n(28),g=n(22),_=n(33),w=n(69),x=n(37),O=n(49),S=n(225),T=n(120),E=n(17),C=n(38),k=T.f,P=E.f,M=S.f,j=r.Symbol,N=r.JSON,I=N&&N.stringify,A=p("_hidden"),R=p("toPrimitive"),F={}.propertyIsEnumerable,D=c("symbol-registry"),L=c("symbols"),z=c("op-symbols"),V=Object.prototype,U="function"==typeof j,W=r.QObject,H=!W||!W.prototype||!W.prototype.findChild,B=i&&l(function(){return 7!=O(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=k(V,t);r&&delete V[t],P(e,t,n),r&&e!==V&&P(V,t,r)}:P,K=function(e){var t=L[e]=O(j.prototype);return t._k=e,t},q=U&&"symbol"==typeof j.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof j},G=function(e,t,n){return e===V&&G(z,t,n),b(e),t=w(t,!0),b(n),o(L,t)?(n.enumerable?(o(e,A)&&e[A][t]&&(e[A][t]=!1),n=O(n,{enumerable:x(0,!1)})):(o(e,A)||P(e,A,x(1,{})),e[A][t]=!0),B(e,t,n)):P(e,t,n)},Y=function(e,t){b(e);for(var n,r=v(t=_(t)),o=0,i=r.length;i>o;)G(e,n=r[o++],t[n]);return e},X=function(e,t){return void 0===t?O(e):Y(O(e),t)},$=function(e){var t=F.call(this,e=w(e,!0));return!(this===V&&o(L,e)&&!o(z,e))&&(!(t||!o(this,e)||!o(L,e)||o(this,A)&&this[A][e])||t)},Q=function(e,t){if(e=_(e),t=w(t,!0),e!==V||!o(L,t)||o(z,t)){var n=k(e,t);return!n||!o(L,t)||o(e,A)&&e[A][t]||(n.enumerable=!0),n}},J=function(e){for(var t,n=M(_(e)),r=[],i=0;n.length>i;)o(L,t=n[i++])||t==A||t==s||r.push(t);return r},Z=function(e){for(var t,n=e===V,r=M(n?z:_(e)),i=[],a=0;r.length>a;)!o(L,t=r[a++])||n&&!o(V,t)||i.push(L[t]);return i};U||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===V&&t.call(z,n),o(this,A)&&o(this[A],e)&&(this[A][e]=!1),B(this,e,x(1,n))};return i&&H&&B(V,e,{configurable:!0,set:t}),K(e)},u(j.prototype,"toString",function(){return this._k}),T.f=Q,E.f=G,n(119).f=S.f=J,n(47).f=$,n(77).f=Z,i&&!n(81)&&u(V,"propertyIsEnumerable",$,!0),h.f=function(e){return K(p(e))}),a(a.G+a.W+a.F*!U,{Symbol:j});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ne=C(p.store),re=0;ne.length>re;)y(ne[re++]);a(a.S+a.F*!U,"Symbol",{for:function(e){return o(D,e+="")?D[e]:D[e]=j(e)},keyFor:function(e){if(!q(e))throw TypeError(e+" is not a symbol!");for(var t in D)if(D[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),a(a.S+a.F*!U,"Object",{create:X,defineProperty:G,defineProperties:Y,getOwnPropertyDescriptor:Q,getOwnPropertyNames:J,getOwnPropertySymbols:Z}),N&&a(a.S+a.F*(!U||l(function(){var e=j();return"[null]"!=I([e])||"{}"!=I({a:e})||"{}"!=I(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=t=r[1],(g(t)||void 0!==e)&&!q(e))return m(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!q(t))return t}),r[1]=t,I.apply(N,r)}}),j.prototype[R]||n(25)(j.prototype,R,j.prototype.valueOf),f(j,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(38),o=n(77),i=n(47);e.exports=function(e){var t=r(e),n=o.f;if(n)for(var a,u=n(e),s=i.f,l=0;u.length>l;)s.call(e,a=u[l++])&&t.push(a);return t}},function(e,t,n){var r=n(33),o=n(119).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(e){try{return o(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==i.call(e)?u(e):o(r(e))}},function(e,t,n){n(84)("asyncIterator")},function(e,t,n){n(84)("observable")},function(e,t,n){e.exports={default:n(229),__esModule:!0}},function(e,t,n){n(230),e.exports=n(13).Object.setPrototypeOf},function(e,t,n){var r=n(14);r(r.S,"Object",{setPrototypeOf:n(231).set})},function(e,t,n){var r=n(22),o=n(28),i=function(e,t){if(o(e),!r(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n(27)(Function.call,n(120).f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return i(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:i}},function(e,t,n){e.exports={default:n(233),__esModule:!0}},function(e,t,n){n(234);var r=n(13).Object;e.exports=function(e,t){return r.create(e,t)}},function(e,t,n){var r=n(14);r(r.S,"Object",{create:n(49)})},function(e,t,n){e.exports={default:n(236),__esModule:!0}},function(e,t,n){n(121),n(79),n(116),n(237),n(244),n(247),n(249),e.exports=n(13).Map},function(e,t,n){"use strict";var r=n(238),o=n(128);e.exports=n(240)("Map",function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{get:function(e){var t=r.getEntry(o(this,"Map"),e);return t&&t.v},set:function(e,t){return r.def(o(this,"Map"),0===e?0:e,t)}},r,!0)},function(e,t,n){"use strict";var r=n(17).f,o=n(49),i=n(122),a=n(27),u=n(123),s=n(51),l=n(80),c=n(117),f=n(239),d=n(20),p=n(83).fastKey,h=n(128),y=d?"_s":"size",v=function(e,t){var n,r=p(t);if("F"!==r)return e._i[r];for(n=e._f;n;n=n.n)if(n.k==t)return n};e.exports={getConstructor:function(e,t,n,l){var c=e(function(e,r){u(e,c,t,"_i"),e._t=t,e._i=o(null),e._f=void 0,e._l=void 0,e[y]=0,void 0!=r&&s(r,n,e[l],e)});return i(c.prototype,{clear:function(){for(var e=h(this,t),n=e._i,r=e._f;r;r=r.n)r.r=!0,r.p&&(r.p=r.p.n=void 0),delete n[r.i];e._f=e._l=void 0,e[y]=0},delete:function(e){var n=h(this,t),r=v(n,e);if(r){var o=r.n,i=r.p;delete n._i[r.i],r.r=!0,i&&(i.n=o),o&&(o.p=i),n._f==r&&(n._f=o),n._l==r&&(n._l=i),n[y]--}return!!r},forEach:function(e){h(this,t);for(var n,r=a(e,arguments.length>1?arguments[1]:void 0,3);n=n?n.n:this._f;)for(r(n.v,n.k,this);n&&n.r;)n=n.p},has:function(e){return!!v(h(this,t),e)}}),d&&r(c.prototype,"size",{get:function(){return h(this,t)[y]}}),c},def:function(e,t,n){var r,o,i=v(e,t);return i?i.v=n:(e._l=i={i:o=p(t,!0),k:t,v:n,p:r=e._l,n:void 0,r:!1},e._f||(e._f=i),r&&(r.n=i),e[y]++,"F"!==o&&(e._i[o]=i)),e},getEntry:v,setStrong:function(e,t,n){l(e,t,function(e,n){this._t=h(e,t),this._k=n,this._l=void 0},function(){for(var e=this,t=e._k,n=e._l;n&&n.r;)n=n.p;return e._t&&(e._l=n=n?n.n:e._t._f)?"keys"==t?c(0,n.k):"values"==t?c(0,n.v):c(0,[n.k,n.v]):(e._t=void 0,c(1))},n?"entries":"values",!n,!0),f(t)}}},function(e,t,n){"use strict";var r=n(19),o=n(13),i=n(17),a=n(20),u=n(15)("species");e.exports=function(e){var t="function"==typeof o[e]?o[e]:r[e];a&&t&&!t[u]&&i.f(t,u,{configurable:!0,get:function(){return this}})}},function(e,t,n){"use strict";var r=n(19),o=n(14),i=n(83),a=n(29),u=n(25),s=n(122),l=n(51),c=n(123),f=n(22),d=n(50),p=n(17).f,h=n(241)(0),y=n(20);e.exports=function(e,t,n,v,m,b){var g=r[e],_=g,w=m?"set":"add",x=_&&_.prototype,O={};return y&&"function"==typeof _&&(b||x.forEach&&!a(function(){(new _).entries().next()}))?(_=t(function(t,n){c(t,_,e,"_c"),t._c=new g,void 0!=n&&l(n,m,t[w],t)}),h("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","),function(e){var t="add"==e||"set"==e;e in x&&(!b||"clear"!=e)&&u(_.prototype,e,function(n,r){if(c(this,_,e),!t&&b&&!f(n))return"get"==e&&void 0;var o=this._c[e](0===n?0:n,r);return t?this:o})}),b||p(_.prototype,"size",{get:function(){return this._c.size}})):(_=v.getConstructor(t,e,m,w),s(_.prototype,n),i.NEED=!0),d(_,e),O[e]=_,o(o.G+o.W+o.F,O),b||v.setStrong(_,e,m),_}},function(e,t,n){var r=n(27),o=n(70),i=n(34),a=n(45),u=n(242);e.exports=function(e,t){var n=1==e,s=2==e,l=3==e,c=4==e,f=6==e,d=5==e||f,p=t||u;return function(t,u,h){for(var y,v,m=i(t),b=o(m),g=r(u,h,3),_=a(b.length),w=0,x=n?p(t,_):s?p(t,0):void 0;_>w;w++)if((d||w in b)&&(y=b[w],v=g(y,w,m),e))if(n)x[w]=v;else if(v)switch(e){case 3:return!0;case 5:return y;case 6:return w;case 2:x.push(y)}else if(c)return!1;return f?-1:l||c?c:x}}},function(e,t,n){var r=n(243);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(22),o=n(118),i=n(15)("species");e.exports=function(e){var t;return o(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(14);r(r.P+r.R,"Map",{toJSON:n(245)("Map")})},function(e,t,n){var r=n(127),o=n(246);e.exports=function(e){return function(){if(r(this)!=e)throw TypeError(e+"#toJSON isn't generic");return o(this)}}},function(e,t,n){var r=n(51);e.exports=function(e,t){var n=[];return r(e,!1,n.push,n,t),n}},function(e,t,n){n(248)("Map")},function(e,t,n){"use strict";var r=n(14);e.exports=function(e){r(r.S,e,{of:function(){for(var e=arguments.length,t=new Array(e);e--;)t[e]=arguments[e];return new this(t)}})}},function(e,t,n){n(250)("Map")},function(e,t,n){"use strict";var r=n(14),o=n(109),i=n(27),a=n(51);e.exports=function(e){r(r.S,e,{from:function(e){var t,n,r,u,s=arguments[1];return o(this),t=void 0!==s,t&&o(s),void 0==e?new this:(n=[],t?(r=0,u=i(s,arguments[2],2),a(e,!1,function(e){n.push(u(e,r++))})):a(e,!1,n.push,n),new this(n))}})}},function(e,t,n){e.exports={default:n(252),__esModule:!0}},function(e,t,n){n(253),e.exports=-9007199254740991},function(e,t,n){var r=n(14);r(r.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0});var o,i=n(1),a=n(130),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(a),s=n(255),l=function(e){return e&&e.__esModule?e:{default:e}}(s);t.default=(o={},r(o,u.jss,l.default.jss),r(o,u.sheetOptions,i.object),r(o,u.sheetsRegistry,l.default.registry),r(o,u.managers,i.object),o)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1);t.default={jss:(0,r.shape)({options:(0,r.shape)({createGenerateClassName:r.func.isRequired}).isRequired,createStyleSheet:r.func.isRequired,removeStyleSheet:r.func.isRequired}),registry:(0,r.shape)({add:r.func.isRequired,toString:r.func.isRequired})}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=function(e){function t(e){var n=null;for(var o in e){var i=e[o],a=void 0===i?"undefined":r(i);if("function"===a)n||(n={}),n[o]=i;else if("object"===a&&null!==i&&!Array.isArray(i)){var u=t(i);u&&(n||(n={}),n[o]=u)}}return n}return t(e)}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(12),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=function(){function e(){r(this,e),this.sheets=[],this.refs=[],this.keys=[]}return o(e,[{key:"get",value:function(e){var t=this.keys.indexOf(e);return this.sheets[t]}},{key:"add",value:function(e,t){var n=this.sheets,r=this.refs,o=this.keys,i=n.indexOf(t);return-1!==i?i:(n.push(t),r.push(0),o.push(e),n.length-1)}},{key:"manage",value:function(e){var t=this.keys.indexOf(e),n=this.sheets[t];return 0===this.refs[t]&&n.attach(),this.refs[t]++,this.keys[t]||this.keys.splice(t,0,e),n}},{key:"unmanage",value:function(e){var t=this.keys.indexOf(e);if(-1===t)return void(0,a.default)(!1,"SheetsManager: can't find sheet to unmanage");this.refs[t]>0&&0===--this.refs[t]&&this.sheets[t].detach()}},{key:"size",get:function(){return this.keys.length}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){if(null==e)return e;var t=void 0===e?"undefined":o(e);if("string"===t||"number"===t||"function"===t)return e;if(u(e))return e.map(r);if((0,a.default)(e))return e;var n={};for(var i in e){var s=e[i];"object"!==(void 0===s?"undefined":o(s))?n[i]=s:n[i]=r(s)}return n}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=r;var i=n(133),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=Array.isArray},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});e.CSS;t.default=function(e){return e}}).call(t,n(16))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var n="2f1acc6c3a606b082e5eef5e54414ffb";null==e[n]&&(e[n]=0),t.default=e[n]++}).call(t,n(16))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(54),l=r(s),c=n(136),f=r(c),d=n(262),p=r(d),h=n(263),y=r(h),v=n(269),m=r(v),b=n(270),g=r(b),_=n(86),w=r(_),x=n(35),O=r(x),S=n(135),T=r(S),E=n(53),C=r(E),k=n(271),P=r(k),M=n(272),j=r(M),N=y.default.concat([m.default,g.default]),I=0,A=function(){function e(t){o(this,e),this.id=I++,this.version="9.8.0",this.plugins=new p.default,this.options={createGenerateClassName:T.default,Renderer:l.default?P.default:j.default,plugins:[]},this.generateClassName=(0,T.default)(),this.use.apply(this,N),this.setup(t)}return u(e,[{key:"setup",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e.createGenerateClassName&&(this.options.createGenerateClassName=e.createGenerateClassName,this.generateClassName=e.createGenerateClassName()),null!=e.insertionPoint&&(this.options.insertionPoint=e.insertionPoint),(e.virtual||e.Renderer)&&(this.options.Renderer=e.Renderer||(e.virtual?j.default:P.default)),e.plugins&&this.use.apply(this,e.plugins),this}},{key:"createStyleSheet",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.index;"number"!=typeof n&&(n=0===w.default.index?0:w.default.index+1);var r=new f.default(e,a({},t,{jss:this,generateClassName:t.generateClassName||this.generateClassName,insertionPoint:this.options.insertionPoint,Renderer:this.options.Renderer,index:n}));return this.plugins.onProcessSheet(r),r}},{key:"removeStyleSheet",value:function(e){return e.detach(),w.default.remove(e),this}},{key:"createRule",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};"object"===(void 0===e?"undefined":i(e))&&(n=t,t=e,e=void 0);var r=n;r.jss=this,r.Renderer=this.options.Renderer,r.generateClassName||(r.generateClassName=this.generateClassName),r.classes||(r.classes={});var o=(0,C.default)(e,t,r);return!r.selector&&o instanceof O.default&&(o.selector="."+r.generateClassName(o)),this.plugins.onProcessRule(o),o}},{key:"use",value:function(){for(var e=this,t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];return n.forEach(function(t){-1===e.options.plugins.indexOf(t)&&(e.options.plugins.push(t),e.plugins.use(t))}),this}}]),e}();t.default=A},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(12),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=function(){function e(){r(this,e),this.hooks={onCreateRule:[],onProcessRule:[],onProcessStyle:[],onProcessSheet:[],onChangeValue:[],onUpdate:[]}}return o(e,[{key:"onCreateRule",value:function(e,t,n){for(var r=0;r<this.hooks.onCreateRule.length;r++){var o=this.hooks.onCreateRule[r](e,t,n);if(o)return o}return null}},{key:"onProcessRule",value:function(e){if(!e.isProcessed){for(var t=e.options.sheet,n=0;n<this.hooks.onProcessRule.length;n++)this.hooks.onProcessRule[n](e,t);e.style&&this.onProcessStyle(e.style,e,t),e.isProcessed=!0}}},{key:"onProcessStyle",value:function(e,t,n){for(var r=e,o=0;o<this.hooks.onProcessStyle.length;o++)r=this.hooks.onProcessStyle[o](r,t,n),t.style=r}},{key:"onProcessSheet",value:function(e){for(var t=0;t<this.hooks.onProcessSheet.length;t++)this.hooks.onProcessSheet[t](e)}},{key:"onUpdate",value:function(e,t,n){for(var r=0;r<this.hooks.onUpdate.length;r++)this.hooks.onUpdate[r](e,t,n)}},{key:"onChangeValue",value:function(e,t,n){for(var r=e,o=0;o<this.hooks.onChangeValue.length;o++)r=this.hooks.onChangeValue[o](r,t,n);return r}},{key:"use",value:function(e){for(var t in e)this.hooks[t]?this.hooks[t].push(e[t]):(0,a.default)(!1,'[JSS] Unknown hook "%s".',t)}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(264),i=r(o),a=n(265),u=r(a),s=n(266),l=r(s),c=n(267),f=r(c),d=n(268),p=r(d),h={"@charset":i.default,"@import":i.default,"@namespace":i.default,"@keyframes":u.default,"@media":l.default,"@supports":l.default,"@font-face":f.default,"@viewport":p.default,"@-ms-viewport":p.default};t.default=Object.keys(h).map(function(e){var t=new RegExp("^"+e);return{onCreateRule:function(n,r,o){return t.test(n)?new h[e](n,r,o):null}}})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=function(){function e(t,n,o){r(this,e),this.type="simple",this.isProcessed=!1,this.key=t,this.value=n,this.options=o}return o(e,[{key:"toString",value:function(e){if(Array.isArray(this.value)){for(var t="",n=0;n<this.value.length;n++)t+=this.key+" "+this.value[n]+";",this.value[n+1]&&(t+="\n");return t}return this.key+" "+this.value+";"}}]),e}();t.default=i},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(41),u=function(e){return e&&e.__esModule?e:{default:e}}(a),s=function(){function e(t,n,i){r(this,e),this.type="keyframes",this.isProcessed=!1,this.key=t,this.options=i,this.rules=new u.default(o({},i,{parent:this}));for(var a in n)this.rules.add(a,n[a],o({},this.options,{parent:this,selector:a}));this.rules.process()}return i(e,[{key:"toString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{indent:1},t=this.rules.toString(e);return t&&(t+="\n"),this.key+" {\n"+t+"}"}}]),e}();t.default=s},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(41),u=function(e){return e&&e.__esModule?e:{default:e}}(a),s=function(){function e(t,n,i){r(this,e),this.type="conditional",this.isProcessed=!1,this.key=t,this.options=i,this.rules=new u.default(o({},i,{parent:this}));for(var a in n)this.rules.add(a,n[a]);this.rules.process()}return i(e,[{key:"getRule",value:function(e){return this.rules.get(e)}},{key:"indexOf",value:function(e){return this.rules.indexOf(e)}},{key:"addRule",value:function(e,t,n){var r=this.rules.add(e,t,n);return this.options.jss.plugins.onProcessRule(r),r}},{key:"toString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{indent:1},t=this.rules.toString(e);return t?this.key+" {\n"+t+"\n}":""}}]),e}();t.default=s},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(85),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=function(){function e(t,n,o){r(this,e),this.type="font-face",this.isProcessed=!1,this.key=t,this.style=n,this.options=o}return o(e,[{key:"toString",value:function(e){if(Array.isArray(this.style)){for(var t="",n=0;n<this.style.length;n++)t+=(0,a.default)(this.key,this.style[n]),this.style[n+1]&&(t+="\n");return t}return(0,a.default)(this.key,this.style,e)}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(85),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=function(){function e(t,n,o){r(this,e),this.type="viewport",this.isProcessed=!1,this.key=t,this.style=n,this.options=o}return o(e,[{key:"toString",value:function(e){return(0,a.default)(this.key,this.style,e)}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(35),i=r(o),a=n(53),u=r(a),s=n(133),l=r(s);t.default={onCreateRule:function(e,t,n){if(!(0,l.default)(t))return null;var r=t,o=(0,u.default)(e,{},n);return r.subscribe(function(e){for(var t in e)o.prop(t,e[t])}),o},onProcessRule:function(e){if(e instanceof i.default){var t=e,n=t.style;for(var r in n){(function(e){var r=n[e];if(!(0,l.default)(r))return"continue";delete n[e],r.subscribe({next:function(n){t.prop(e,n)}})})(r)}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(41),i=r(o),a=n(35),u=r(a),s=n(53),l=r(s),c=Date.now(),f="fnValues"+c,d="fnStyle"+ ++c;t.default={onCreateRule:function(e,t,n){if("function"!=typeof t)return null;var r=(0,l.default)(e,{},n);return r[d]=t,r},onProcessStyle:function(e,t){var n={};for(var r in e){var o=e[r];"function"==typeof o&&(delete e[r],n[r]=o)}return t=t,t[f]=n,e},onUpdate:function(e,t){if(t.rules instanceof i.default)return void t.rules.update(e);if(t instanceof u.default){if(t=t,t[f])for(var n in t[f])t.prop(n,t[f][n](e));t=t;var r=t[d];if(r){var o=r(e);for(var a in o)t.prop(a,o[a])}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){try{return e.style.getPropertyValue(t)}catch(e){return""}}function a(e,t,n){try{var r=n;if(Array.isArray(n)&&(r=(0,x.default)(n,!0),"!important"===n[n.length-1]))return e.style.setProperty(t,r,"important"),!0;e.style.setProperty(t,r)}catch(e){return!1}return!0}function u(e,t){try{e.style.removeProperty(t)}catch(e){(0,v.default)(!1,'[JSS] DOMException "%s" was thrown. Tried to remove property "%s".',e.message,t)}}function s(e,t){return e.selectorText=t,e.selectorText===t}function l(e,t){for(var n=0;n<e.length;n++){var r=e[n];if(r.attached&&r.options.index>t.index&&r.options.insertionPoint===t.insertionPoint)return r}return null}function c(e,t){for(var n=e.length-1;n>=0;n--){var r=e[n];if(r.attached&&r.options.insertionPoint===t.insertionPoint)return r}return null}function f(e){for(var t=E(),n=0;n<t.childNodes.length;n++){var r=t.childNodes[n];if(8===r.nodeType&&r.nodeValue.trim()===e)return r}return null}function d(e){var t=b.default.registry;if(t.length>0){var n=l(t,e);if(n)return n.renderer.element;if(n=c(t,e))return n.renderer.element.nextElementSibling}var r=e.insertionPoint;if(r&&"string"==typeof r){var o=f(r);if(o)return o.nextSibling;(0,v.default)("jss"===r,'[JSS] Insertion point "%s" not found.',r)}return null}function p(e,t){var n=t.insertionPoint,r=d(t);if(r){var o=r.parentNode;return void(o&&o.insertBefore(e,r))}if(n&&"number"==typeof n.nodeType){var i=n,a=i.parentNode;return void(a?a.insertBefore(e,i.nextSibling):(0,v.default)(!1,"[JSS] Insertion point is not in the DOM."))}E().insertBefore(e,r)}Object.defineProperty(t,"__esModule",{value:!0});var h=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),y=n(12),v=r(y),m=n(86),b=r(m),g=n(35),_=r(g),w=n(52),x=r(w),O=function(e){var t=void 0;return function(){return t||(t=e()),t}},S={STYLE_RULE:1,KEYFRAMES_RULE:7},T=function(){var e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e.substr(t,e.indexOf("{")-1)};return function(t){if(t.type===S.STYLE_RULE)return t.selectorText;if(t.type===S.KEYFRAMES_RULE){var n=t.name;if(n)return"@keyframes "+n;var r=t.cssText;return"@"+e(r,r.indexOf("keyframes"))}return e(t.cssText)}}(),E=O(function(){return document.head||document.getElementsByTagName("head")[0]}),C=function(){var e=void 0,t=!1;return function(n){var r={};e||(e=document.createElement("style"));for(var o=0;o<n.length;o++){var i=n[o];if(i instanceof _.default){var a=i.selector;if(a&&-1!==a.indexOf("\\")){t||(E().appendChild(e),t=!0),e.textContent=a+" {}";var u=e,s=u.sheet;if(s){var l=s.cssRules;l&&(r[l[0].selectorText]=i.key)}}}}return t&&(E().removeChild(e),t=!1),r}}(),k=O(function(){var e=document.querySelector('meta[property="csp-nonce"]');return e?e.getAttribute("content"):null}),P=function(){function e(t){o(this,e),this.getPropertyValue=i,this.setProperty=a,this.removeProperty=u,this.setSelector=s,this.getKey=T,this.getUnescapedKeysMap=C,this.hasInsertedRules=!1,t&&b.default.add(t),this.sheet=t;var n=this.sheet?this.sheet.options:{},r=n.media,l=n.meta,c=n.element;this.element=c||document.createElement("style"),this.element.type="text/css",this.element.setAttribute("data-jss",""),r&&this.element.setAttribute("media",r),l&&this.element.setAttribute("data-meta",l);var f=k();f&&this.element.setAttribute("nonce",f)}return h(e,[{key:"attach",value:function(){!this.element.parentNode&&this.sheet&&(this.hasInsertedRules&&(this.deploy(),this.hasInsertedRules=!1),p(this.element,this.sheet.options))}},{key:"detach",value:function(){this.element.parentNode.removeChild(this.element)}},{key:"deploy",value:function(){this.sheet&&(this.element.textContent="\n"+this.sheet.toString()+"\n")}},{key:"insertRule",value:function(e,t){var n=this.element.sheet,r=n.cssRules,o=e.toString();if(t||(t=r.length),!o)return!1;try{n.insertRule(o,t)}catch(t){return(0,v.default)(!1,"[JSS] Can not insert an unsupported rule \n\r%s",e),!1}return this.hasInsertedRules=!0,r[t]}},{key:"deleteRule",value:function(e){var t=this.element.sheet,n=this.indexOf(e);return-1!==n&&(t.deleteRule(n),!0)}},{key:"indexOf",value:function(e){for(var t=this.element.sheet.cssRules,n=0;n<t.length;n++)if(e===t[n])return n;return-1}},{key:"replaceRule",value:function(e,t){var n=this.indexOf(e),r=this.insertRule(t,n);return this.element.sheet.deleteRule(n),r}},{key:"getRules",value:function(){return this.element.sheet.cssRules}}]),e}();t.default=P},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=function(){function e(){r(this,e)}return o(e,[{key:"setProperty",value:function(){return!0}},{key:"getPropertyValue",value:function(){return""}},{key:"removeProperty",value:function(){}},{key:"setSelector",value:function(){return!0}},{key:"getKey",value:function(){return""}},{key:"attach",value:function(){}},{key:"detach",value:function(){}},{key:"deploy",value:function(){}},{key:"insertRule",value:function(){return!1}},{key:"deleteRule",value:function(){return!0}},{key:"replaceRule",value:function(){return!1}},{key:"getRules",value:function(){}},{key:"indexOf",value:function(){return-1}}]),e}();t.default=i},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var n=e.split(y),r="",o=0;o<n.length;o++)r+=t+" "+n[o].trim(),n[o+1]&&(r+=", ");return r}function i(e){var t=e.options,n=e.style,r=n[f];if(r){for(var i in r)t.sheet.addRule(i,r[i],s({},t,{selector:o(i,e.selector)}));delete n[f]}}function a(e){var t=e.options,n=e.style;for(var r in n)if(r.substr(0,f.length)===f){var i=o(r.substr(f.length),e.selector);t.sheet.addRule(i,n[r],s({},t,{selector:i})),delete n[r]}}function u(){function e(e,t,n){if(e===f)return new p(e,t,n);if("@"===e[0]&&e.substr(0,d.length)===d)return new h(e,t,n);var r=n.parent;return r&&("global"!==r.type&&"global"!==r.options.parent.type||(n.global=!0)),n.global&&(n.selector=e),null}function t(e){"style"===e.type&&(i(e),a(e))}return{onCreateRule:e,onProcessRule:t}}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.default=u;var c=n(131),f="@global",d="@global ",p=function(){function e(t,n,o){r(this,e),this.type="global",this.key=t,this.options=o,this.rules=new c.RuleList(s({},o,{parent:this}));for(var i in n)this.rules.add(i,n[i],{selector:i});this.rules.process()}return l(e,[{key:"getRule",value:function(e){return this.rules.get(e)}},{key:"addRule",value:function(e,t,n){var r=this.rules.add(e,t,n);return this.options.jss.plugins.onProcessRule(r),r}},{key:"indexOf",value:function(e){return this.rules.indexOf(e)}},{key:"toString",value:function(){return this.rules.toString()}}]),e}(),h=function(){function e(t,n,o){r(this,e),this.name=t,this.options=o;var i=t.substr(d.length);this.rule=o.jss.createRule(i,n,s({},o,{parent:this,selector:i}))}return l(e,[{key:"toString",value:function(e){return this.rule.toString(e)}}]),e}(),y=/\s*,\s*/g},function(e,t,n){"use strict";function r(){function e(e){return function(t,n){var r=e.getRule(n);return r?r.selector:((0,a.default)(!1,"[JSS] Could not find the referenced rule %s in %s.",n,e.options.meta||e),n)}}function t(e,t){for(var n=t.split(u),r=e.split(u),o="",a=0;a<n.length;a++)for(var l=n[a],c=0;c<r.length;c++){var f=r[c];o&&(o+=", "),o+=i(f)?f.replace(s,l):l+" "+f}return o}function n(e,t,n){if(n)return o({},n,{index:n.index+1});var r=e.options.nestingLevel;return r=void 0===r?1:r+1,o({},e.options,{nestingLevel:r,index:t.indexOf(e)+1})}function r(r,a){if("style"!==a.type)return r;var u=a.options.parent,s=void 0,c=void 0;for(var f in r){var d=i(f),p="@"===f[0];if(d||p){if(s=n(a,u,s),d){var h=t(f,a.selector);c||(c=e(u)),h=h.replace(l,c),u.addRule(h,r[f],o({},s,{selector:h}))}else p&&u.addRule(f,null,s).addRule(a.key,r[f],{selector:a.selector});delete r[f]}}return r}var i=function(e){return-1!==e.indexOf("&")};return{onProcessStyle:r}}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=r;var i=n(12),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=/\s*,\s*/g,s=/&/g,l=/\$([\w-]+)/g},function(e,t,n){"use strict";function r(e){var t={};for(var n in e)t[(0,a.default)(n)]=e[n];return e.fallbacks&&(Array.isArray(e.fallbacks)?t.fallbacks=e.fallbacks.map(r):t.fallbacks=r(e.fallbacks)),t}function o(){function e(e){if(Array.isArray(e)){for(var t=0;t<e.length;t++)e[t]=r(e[t]);return e}return r(e)}function t(e,t,n){var r=(0,a.default)(t);return t===r?e:(n.prop(r,e),null)}return{onProcessStyle:e,onChangeValue:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(276),a=function(e){return e&&e.__esModule?e:{default:e}}(i)},function(e,t,n){"use strict";function r(e){return e in a?a[e]:a[e]=e.replace(o,"-$&").toLowerCase().replace(i,"-ms-")}var o=/[A-Z]/g,i=/^ms-/,a={};e.exports=r},function(e,t,n){"use strict";function r(e){var t=/(-[a-z])/g,n=function(e){return e[1].toUpperCase()},r={};for(var o in e)r[o]=e[o],r[o.replace(t,n)]=e[o];return r}function o(e,t,n){if(!t)return t;var r=t,i=void 0===t?"undefined":a(t);switch("object"===i&&Array.isArray(t)&&(i="array"),i){case"object":if("fallbacks"===e){for(var u in t)t[u]=o(u,t[u],n);break}for(var s in t)t[s]=o(e+"-"+s,t[s],n);break;case"array":for(var c=0;c<t.length;c++)t[c]=o(e,t[c],n);break;case"number":0!==t&&(r=t+(n[e]||l[e]||""))}return r}function i(){function e(e,t){if("style"!==t.type)return e;for(var n in e)e[n]=o(n,e[n],i);return e}function t(e,t){return o(t,e,i)}var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},i=r(n);return{onProcessStyle:e,onChangeValue:t}}Object.defineProperty(t,"__esModule",{value:!0});var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=i;var u=n(278),s=function(e){return e&&e.__esModule?e:{default:e}}(u),l=r(s.default)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={"animation-delay":"ms","animation-duration":"ms","background-position":"px","background-position-x":"px","background-position-y":"px","background-size":"px",border:"px","border-bottom":"px","border-bottom-left-radius":"px","border-bottom-right-radius":"px","border-bottom-width":"px","border-left":"px","border-left-width":"px","border-radius":"px","border-right":"px","border-right-width":"px","border-spacing":"px","border-top":"px","border-top-left-radius":"px","border-top-right-radius":"px","border-top-width":"px","border-width":"px","border-after-width":"px","border-before-width":"px","border-end-width":"px","border-horizontal-spacing":"px","border-start-width":"px","border-vertical-spacing":"px",bottom:"px","box-shadow":"px","column-gap":"px","column-rule":"px","column-rule-width":"px","column-width":"px","flex-basis":"px","font-size":"px","font-size-delta":"px",height:"px",left:"px","letter-spacing":"px","logical-height":"px","logical-width":"px",margin:"px","margin-after":"px","margin-before":"px","margin-bottom":"px","margin-left":"px","margin-right":"px","margin-top":"px","max-height":"px","max-width":"px","margin-end":"px","margin-start":"px","mask-position-x":"px","mask-position-y":"px","mask-size":"px","max-logical-height":"px","max-logical-width":"px","min-height":"px","min-width":"px","min-logical-height":"px","min-logical-width":"px",motion:"px","motion-offset":"px",outline:"px","outline-offset":"px","outline-width":"px",padding:"px","padding-bottom":"px","padding-left":"px","padding-right":"px","padding-top":"px","padding-after":"px","padding-before":"px","padding-end":"px","padding-start":"px","perspective-origin-x":"%","perspective-origin-y":"%",perspective:"px",right:"px","shape-margin":"px",size:"px","text-indent":"px","text-stroke":"px","text-stroke-width":"px",top:"px","transform-origin":"%","transform-origin-x":"%","transform-origin-y":"%","transform-origin-z":"%","transition-delay":"ms","transition-duration":"ms","vertical-align":"px",width:"px","word-spacing":"px","box-shadow-x":"px","box-shadow-y":"px","box-shadow-blur":"px","box-shadow-spread":"px","font-line-height":"px","text-shadow-x":"px","text-shadow-y":"px","text-shadow-blur":"px"}},function(e,t,n){"use strict";function r(){function e(e){"keyframes"===e.type&&(e.key="@"+i.prefix.css+e.key.substr(1))}function t(e,t){if("style"!==t.type)return e;for(var n in e){var r=e[n],o=!1,a=i.supportedProperty(n);a&&a!==n&&(o=!0);var u=!1,s=i.supportedValue(a,r);s&&s!==r&&(u=!0),(o||u)&&(o&&delete e[n],e[a||n]=s||r)}return e}function n(e,t){return i.supportedValue(t,e)}return{onProcessRule:e,onProcessStyle:t,onChangeValue:n}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(280),i=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.supportedValue=t.supportedProperty=t.prefix=void 0;var o=n(87),i=r(o),a=n(281),u=r(a),s=n(283),l=r(s);t.default={prefix:i.default,supportedProperty:u.default,supportedValue:l.default},/**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */
t.prefix=i.default,t.supportedProperty=u.default,t.supportedValue=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return f?null!=d[e]?d[e]:((0,c.default)(e)in f.style?d[e]=e:s.default.js+(0,c.default)("-"+e)in f.style?d[e]=s.default.css+e:d[e]=!1,d[e]):e}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(54),a=r(i),u=n(87),s=r(u),l=n(282),c=r(l),f=void 0,d={};if(a.default){f=document.createElement("p");var p=window.getComputedStyle(document.documentElement,"");for(var h in p)isNaN(h)||(d[p[h]]=p[h])}},function(e,t,n){"use strict";function r(e){return e.replace(i,o)}function o(e,t){return t?t.toUpperCase():""}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=/[-\s]+(.)?/g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!c)return t;if("string"!=typeof t||!isNaN(parseInt(t,10)))return t;var n=e+t;if(null!=l[n])return l[n];try{c.style[e]=t}catch(e){return l[n]=!1,!1}return""!==c.style[e]?l[n]=t:(t=s.default.css+t,"-ms-flex"===t&&(t="-ms-flexbox"),c.style[e]=t,""!==c.style[e]&&(l[n]=t)),l[n]||(l[n]=!1),c.style[e]="",l[n]}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(54),a=r(i),u=n(87),s=r(u),l={},c=void 0;a.default&&(c=document.createElement("p"))},function(e,t,n){"use strict";function r(){function e(e,t){return e.length-t.length}function t(t,n){if("style"!==n.type)return t;var r={},o=Object.keys(t).sort(e);for(var i in o)r[o[i]]=t[o[i]];return r}return{onProcessStyle:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return Math.round(1e5*e)/1e5}function i(e,t){function n(e){return e/b+"rem"}var r="function"==typeof t?t(e):t,i=r.fontFamily,a=void 0===i?'"Roboto", "Helvetica", "Arial", sans-serif':i,s=r.fontSize,c=void 0===s?14:s,f=r.fontWeightLight,d=void 0===f?300:f,p=r.fontWeightRegular,h=void 0===p?400:p,y=r.fontWeightMedium,v=void 0===y?500:y,m=r.htmlFontSize,b=void 0===m?16:m,g=(0,u.default)(r,["fontFamily","fontSize","fontWeightLight","fontWeightRegular","fontWeightMedium","htmlFontSize"]);return(0,l.default)({pxToRem:n,round:o,fontFamily:a,fontSize:c,fontWeightLight:d,fontWeightRegular:h,fontWeightMedium:v,display4:{fontSize:n(112),fontWeight:d,fontFamily:a,letterSpacing:"-.04em",lineHeight:o(128/112)+"em",marginLeft:"-.06em",color:e.text.secondary},display3:{fontSize:n(56),fontWeight:h,fontFamily:a,letterSpacing:"-.02em",lineHeight:o(73/56)+"em",marginLeft:"-.04em",color:e.text.secondary},display2:{fontSize:n(45),fontWeight:h,fontFamily:a,lineHeight:o(48/45)+"em",marginLeft:"-.04em",color:e.text.secondary},display1:{fontSize:n(34),fontWeight:h,fontFamily:a,lineHeight:o(41/34)+"em",marginLeft:"-.04em",color:e.text.secondary},headline:{fontSize:n(24),fontWeight:h,fontFamily:a,lineHeight:o(32.5/24)+"em",color:e.text.primary},title:{fontSize:n(21),fontWeight:v,fontFamily:a,lineHeight:o(24.5/21)+"em",color:e.text.primary},subheading:{fontSize:n(16),fontWeight:h,fontFamily:a,lineHeight:o(1.5)+"em",color:e.text.primary},body2:{fontSize:n(14),fontWeight:v,fontFamily:a,lineHeight:o(24/14)+"em",color:e.text.primary},body1:{fontSize:n(14),fontWeight:h,fontFamily:a,lineHeight:o(20.5/14)+"em",color:e.text.primary},caption:{fontSize:n(12),fontWeight:h,fontFamily:a,lineHeight:o(1.375)+"em",color:e.text.secondary},button:{fontSize:n(c),textTransform:"uppercase",fontWeight:v,fontFamily:a}},g,{clone:!1})}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),u=r(a);t.default=i;var s=n(55),l=r(s)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n,r){e[t]||(e.hasOwnProperty(n)?e[t]=e[n]:"light"===t?e.light=(0,O.lighten)(e.main,r):"dark"===t&&(e.dark=(0,O.darken)(e.main,1.5*r)))}function i(e){function t(e){var t=(0,O.getContrastRatio)(e,T.text.primary)>=g?T.text.primary:S.text.primary;return t}function n(e,n,r,i){!e.main&&e[n]&&(e.main=e[n]),o(e,"light",r,E),o(e,"dark",i,E),e.contrastText||(e.contrastText=t(e.main))}var r=e.primary,i=void 0===r?{light:h.default[300],main:h.default[500],dark:h.default[700]}:r,a=e.secondary,s=void 0===a?{light:v.default.A200,main:v.default.A400,dark:v.default.A700}:a,c=e.error,f=void 0===c?{light:_.default[300],main:_.default[500],dark:_.default[700]}:c,p=e.type,y=void 0===p?"light":p,m=e.contrastThreshold,g=void 0===m?3:m,w=e.tonalOffset,E=void 0===w?.2:w,C=(0,l.default)(e,["primary","secondary","error","type","contrastThreshold","tonalOffset"]);n(i,500,300,700),n(s,"A400","A200","A700"),n(f,500,300,700);var k={dark:T,light:S};return(0,d.default)((0,u.default)({common:x.default,type:y,primary:i,secondary:s,error:f,grey:b.default,contrastThreshold:g,getContrastText:t,tonalOffset:E},k[y]),C,{clone:!1})}Object.defineProperty(t,"__esModule",{value:!0}),t.dark=t.light=void 0;var a=n(2),u=r(a),s=n(3),l=r(s);t.default=i;var c=n(12),f=(r(c),n(55)),d=r(f),p=n(287),h=r(p),y=n(288),v=r(y),m=n(289),b=r(m),g=n(290),_=r(g),w=n(139),x=r(w),O=n(89),S=t.light={text:{primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)",hint:"rgba(0, 0, 0, 0.38)"},divider:"rgba(0, 0, 0, 0.12)",background:{paper:x.default.white,default:b.default[50]},action:{active:"rgba(0, 0, 0, 0.54)",hover:"rgba(0, 0, 0, 0.08)",selected:"rgba(0, 0, 0, 0.14)",disabled:"rgba(0, 0, 0, 0.26)",disabledBackground:"rgba(0, 0, 0, 0.12)"}},T=t.dark={text:{primary:x.default.white,secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(255, 255, 255, 0.5)",hint:"rgba(255, 255, 255, 0.5)",icon:"rgba(255, 255, 255, 0.5)"},divider:"rgba(255, 255, 255, 0.12)",background:{paper:b.default[800],default:"#303030"},action:{active:x.default.white,hover:"rgba(255, 255, 255, 0.1)",selected:"rgba(255, 255, 255, 0.2)",disabled:"rgba(255, 255, 255, 0.3)",disabledBackground:"rgba(255, 255, 255, 0.12)"}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",A100:"#8c9eff",A200:"#536dfe",A400:"#3d5afe",A700:"#304ffe"};t.default=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",A100:"#ff80ab",A200:"#ff4081",A400:"#f50057",A700:"#c51162"};t.default=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121",A100:"#d5d5d5",A200:"#aaaaaa",A400:"#303030",A700:"#616161"};t.default=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",A100:"#ff8a80",A200:"#ff5252",A400:"#ff1744",A700:"#d50000"};t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r;return(0,s.default)({gutters:function(n){return(0,s.default)({paddingLeft:2*t.unit,paddingRight:2*t.unit},n,(0,a.default)({},e.up("sm"),(0,s.default)({paddingLeft:3*t.unit,paddingRight:3*t.unit},n[e.up("sm")])))},toolbar:(r={minHeight:56},(0,a.default)(r,e.up("xs")+" and (orientation: landscape)",{minHeight:48}),(0,a.default)(r,e.up("sm"),{minHeight:64}),r)},n)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),a=r(i),u=n(2),s=r(u);t.default=o},function(e,t,n){"use strict";function r(){return[(arguments.length<=0?void 0:arguments[0])+"px "+(arguments.length<=1?void 0:arguments[1])+"px "+(arguments.length<=2?void 0:arguments[2])+"px "+(arguments.length<=3?void 0:arguments[3])+"px rgba(0, 0, 0, "+o+")",(arguments.length<=4?void 0:arguments[4])+"px "+(arguments.length<=5?void 0:arguments[5])+"px "+(arguments.length<=6?void 0:arguments[6])+"px "+(arguments.length<=7?void 0:arguments[7])+"px rgba(0, 0, 0, "+i+")",(arguments.length<=8?void 0:arguments[8])+"px "+(arguments.length<=9?void 0:arguments[9])+"px "+(arguments.length<=10?void 0:arguments[10])+"px "+(arguments.length<=11?void 0:arguments[11])+"px rgba(0, 0, 0, "+a+")"].join(",")}Object.defineProperty(t,"__esModule",{value:!0});var o=.2,i=.14,a=.12,u=["none",r(0,1,3,0,0,1,1,0,0,2,1,-1),r(0,1,5,0,0,2,2,0,0,3,1,-2),r(0,1,8,0,0,3,4,0,0,3,3,-2),r(0,2,4,-1,0,4,5,0,0,1,10,0),r(0,3,5,-1,0,5,8,0,0,1,14,0),r(0,3,5,-1,0,6,10,0,0,1,18,0),r(0,4,5,-2,0,7,10,1,0,2,16,1),r(0,5,5,-3,0,8,10,1,0,3,14,2),r(0,5,6,-3,0,9,12,1,0,3,16,2),r(0,6,6,-3,0,10,14,1,0,4,18,3),r(0,6,7,-4,0,11,15,1,0,4,20,3),r(0,7,8,-4,0,12,17,2,0,5,22,4),r(0,7,8,-4,0,13,19,2,0,5,24,4),r(0,7,9,-4,0,14,21,2,0,5,26,4),r(0,8,9,-5,0,15,22,2,0,6,28,5),r(0,8,10,-5,0,16,24,2,0,6,30,5),r(0,8,11,-5,0,17,26,2,0,6,32,5),r(0,9,11,-5,0,18,28,2,0,7,34,6),r(0,9,12,-6,0,19,29,2,0,7,36,6),r(0,10,13,-6,0,20,31,3,0,8,38,7),r(0,10,13,-6,0,21,33,3,0,8,40,7),r(0,10,14,-6,0,22,35,3,0,8,42,7),r(0,11,14,-7,0,23,36,3,0,9,44,8),r(0,11,15,-7,0,24,38,3,0,9,46,8)];t.default=u},function(e,t,n){e.exports={default:n(294),__esModule:!0}},function(e,t,n){n(295),e.exports=n(13).Number.isNaN},function(e,t,n){var r=n(14);r(r.S,"Number",{isNaN:function(e){return e!=e}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={mobileStepper:1e3,appBar:1100,drawer:1200,modal:1300,snackbar:1400,tooltip:1500};t.default=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={unit:8}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(t,r){var o=n?e(t):e;if(!t.overrides||!r||!t.overrides[r])return o;var i=t.overrides[r],u=(0,s.default)({},o);return(0,a.default)(i).forEach(function(e){u[e]=(0,f.default)(u[e],i[e])}),u}var n="function"==typeof e;return{create:t,options:{},themingEnabled:n}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(31),a=r(i),u=n(2),s=r(u),l=n(12),c=(r(l),n(55)),f=r(c);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e="function"==typeof e?e():e,E.default.findDOMNode(e)||t}function i(e){return(0,V.default)(E.default.findDOMNode(e))}function a(e){return!!e.children&&e.children.props.hasOwnProperty("in")}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var u=n(2),s=r(u),l=n(6),c=r(l),f=n(3),d=r(f),p=n(8),h=r(p),y=n(7),v=r(y),m=n(9),b=r(m),g=n(10),_=r(g),w=n(11),x=r(w),O=n(0),S=r(O),T=n(18),E=r(T),C=n(1),k=(r(C),n(5)),P=r(k),M=n(12),j=(r(M),n(42)),N=r(j),I=n(142),A=r(I),R=n(56),F=r(R),D=n(57),L=r(D),z=n(23),V=r(z),U=n(143),W=r(U),H=n(310),B=r(H),K=n(313),q=r(K),G=n(21),Y=n(4),X=r(Y),$=n(144),Q=r($),J=n(147),Z=r(J),ee=t.styles=function(e){return{root:{display:"flex",width:"100%",height:"100%",position:"fixed",zIndex:e.zIndex.modal,top:0,left:0},hidden:{visibility:"hidden"}}},te=function(e){function t(e,n){(0,v.default)(this,t);var r=(0,_.default)(this,(t.__proto__||(0,h.default)(t)).call(this,e,n));return r.dialog=null,r.mounted=!1,r.mountNode=null,r.handleRendered=function(){r.autoFocus(),r.props.onRendered&&r.props.onRendered()},r.handleOpen=function(){var e=i(r),t=o(r.props.container,e.body);r.props.manager.add(r,t),r.onDocumentKeydownListener=(0,q.default)(e,"keydown",r.handleDocumentKeyDown),r.onFocusinListener=(0,q.default)(document,"focus",r.enforceFocus,!0)},r.handleClose=function(){r.props.manager.remove(r),r.onDocumentKeydownListener.remove(),r.onFocusinListener.remove(),r.restoreLastFocus()},r.handleExited=function(){r.setState({exited:!0}),r.handleClose()},r.handleBackdropClick=function(e){e.target===e.currentTarget&&(r.props.onBackdropClick&&r.props.onBackdropClick(e),!r.props.disableBackdropClick&&r.props.onClose&&r.props.onClose(e,"backdropClick"))},r.handleDocumentKeyDown=function(e){r.isTopModal()&&"esc"===(0,N.default)(e)&&(r.props.onEscapeKeyDown&&r.props.onEscapeKeyDown(e),!r.props.disableEscapeKeyDown&&r.props.onClose&&r.props.onClose(e,"escapeKeyDown"))},r.checkForFocus=function(){L.default&&(r.lastFocus=(0,A.default)())},r.enforceFocus=function(){if(!r.props.disableEnforceFocus&&r.mounted&&r.isTopModal()){var e=r.getDialogElement(),t=(0,A.default)(i(r));e&&!(0,F.default)(e,t)&&e.focus()}},r.state={exited:!r.props.open},r}return(0,x.default)(t,e),(0,b.default)(t,[{key:"componentDidMount",value:function(){this.mounted=!0,this.props.open&&this.handleOpen()}},{key:"componentWillReceiveProps",value:function(e){e.open?this.setState({exited:!1}):a(e)||this.setState({exited:!0})}},{key:"componentWillUpdate",value:function(e){!this.props.open&&e.open&&this.checkForFocus()}},{key:"componentDidUpdate",value:function(e){!e.open||this.props.open||a(this.props)?!e.open&&this.props.open&&this.handleOpen():this.handleClose()}},{key:"componentWillUnmount",value:function(){this.mounted=!1,(this.props.open||a(this.props)&&!this.state.exited)&&this.handleClose()}},{key:"getDialogElement",value:function(){return E.default.findDOMNode(this.dialog)}},{key:"autoFocus",value:function(){if(!this.props.disableAutoFocus){var e=this.getDialogElement(),t=(0,A.default)(i(this));e&&!(0,F.default)(e,t)&&(this.lastFocus=t,e.hasAttribute("tabIndex")||e.setAttribute("tabIndex",-1),e.focus())}}},{key:"restoreLastFocus",value:function(){this.props.disableRestoreFocus||this.lastFocus&&(this.lastFocus.focus(),this.lastFocus=null)}},{key:"isTopModal",value:function(){return this.props.manager.isTopModal(this)}},{key:"render",value:function(){var e=this,t=this.props,n=t.BackdropComponent,r=t.BackdropProps,o=t.children,i=t.classes,u=t.className,l=t.container,f=(t.disableAutoFocus,t.disableBackdropClick,t.disableEnforceFocus,t.disableEscapeKeyDown,t.disableRestoreFocus,t.hideBackdrop),p=t.keepMounted,h=(t.onBackdropClick,t.onClose,t.onEscapeKeyDown,t.onRendered,t.open),y=(t.manager,(0,d.default)(t,["BackdropComponent","BackdropProps","children","classes","className","container","disableAutoFocus","disableBackdropClick","disableEnforceFocus","disableEscapeKeyDown","disableRestoreFocus","hideBackdrop","keepMounted","onBackdropClick","onClose","onEscapeKeyDown","onRendered","open","manager"])),v=this.state.exited,m=a(this.props),b={};return p||h||m&&!v?(m&&(b.onExited=(0,G.createChainedFunction)(this.handleExited,o.props.onExited)),void 0===o.props.role&&(b.role=o.props.role||"document"),void 0===o.props.tabIndex&&(b.tabIndex=o.props.tabIndex||"-1"),S.default.createElement(B.default,{ref:function(t){e.mountNode=t?t.getMountNode():t},container:l,onRendered:this.handleRendered},S.default.createElement("div",(0,s.default)({className:(0,P.default)(i.root,u,(0,c.default)({},i.hidden,v))},y),f?null:S.default.createElement(n,(0,s.default)({open:h,onClick:this.handleBackdropClick},r)),S.default.createElement(W.default,{ref:function(t){e.dialog=t}},S.default.cloneElement(o,b))))):null}}]),t}(S.default.Component);te.propTypes={},te.defaultProps={disableAutoFocus:!1,disableBackdropClick:!1,disableEnforceFocus:!1,disableEscapeKeyDown:!1,disableRestoreFocus:!1,hideBackdrop:!1,keepMounted:!1,manager:new Q.default,BackdropComponent:Z.default},t.default=(0,X.default)(ee,{flip:!1,name:"MuiModal"})(te)},function(e,t,n){"use strict";function r(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);throw t=Error(n+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."),t.name="Invariant Violation",t.framesToPop=1,t}function o(e,t){return(e&t)===t}function i(e,t){if(Pn.hasOwnProperty(e)||2<e.length&&("o"===e[0]||"O"===e[0])&&("n"===e[1]||"N"===e[1]))return!1;if(null===t)return!0;switch(typeof t){case"boolean":return Pn.hasOwnProperty(e)?e=!0:(t=a(e))?e=t.hasBooleanValue||t.hasStringBooleanValue||t.hasOverloadedBooleanValue:(e=e.toLowerCase().slice(0,5),e="data-"===e||"aria-"===e),e;case"undefined":case"number":case"string":case"object":return!0;default:return!1}}function a(e){return jn.hasOwnProperty(e)?jn[e]:null}function u(e){return e[1].toUpperCase()}function s(e,t,n,r,o,i,a,u,s){Bn._hasCaughtError=!1,Bn._caughtError=null;var l=Array.prototype.slice.call(arguments,3);try{t.apply(n,l)}catch(e){Bn._caughtError=e,Bn._hasCaughtError=!0}}function l(){if(Bn._hasRethrowError){var e=Bn._rethrowError;throw Bn._rethrowError=null,Bn._hasRethrowError=!1,e}}function c(){if(Kn)for(var e in qn){var t=qn[e],n=Kn.indexOf(e);if(-1<n||r("96",e),!Gn[n]){t.extractEvents||r("97",e),Gn[n]=t,n=t.eventTypes;for(var o in n){var i=void 0,a=n[o],u=t,s=o;Yn.hasOwnProperty(s)&&r("99",s),Yn[s]=a;var l=a.phasedRegistrationNames;if(l){for(i in l)l.hasOwnProperty(i)&&f(l[i],u,s);i=!0}else a.registrationName?(f(a.registrationName,u,s),i=!0):i=!1;i||r("98",o,e)}}}}function f(e,t,n){Xn[e]&&r("100",e),Xn[e]=t,$n[e]=t.eventTypes[n].dependencies}function d(e){Kn&&r("101"),Kn=Array.prototype.slice.call(e),c()}function p(e){var t,n=!1;for(t in e)if(e.hasOwnProperty(t)){var o=e[t];qn.hasOwnProperty(t)&&qn[t]===o||(qn[t]&&r("102",t),qn[t]=o,n=!0)}n&&c()}function h(e,t,n,r){t=e.type||"unknown-event",e.currentTarget=er(r),Bn.invokeGuardedCallbackAndCatchFirstError(t,n,void 0,e),e.currentTarget=null}function y(e,t){return null==t&&r("30"),null==e?t:Array.isArray(e)?Array.isArray(t)?(e.push.apply(e,t),e):(e.push(t),e):Array.isArray(t)?[e].concat(t):[e,t]}function v(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)}function m(e,t){if(e){var n=e._dispatchListeners,r=e._dispatchInstances;if(Array.isArray(n))for(var o=0;o<n.length&&!e.isPropagationStopped();o++)h(e,t,n[o],r[o]);else n&&h(e,t,n,r);e._dispatchListeners=null,e._dispatchInstances=null,e.isPersistent()||e.constructor.release(e)}}function b(e){return m(e,!0)}function g(e){return m(e,!1)}function _(e,t){var n=e.stateNode;if(!n)return null;var o=Jn(n);if(!o)return null;n=o[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":(o=!o.disabled)||(e=e.type,o=!("button"===e||"input"===e||"select"===e||"textarea"===e)),e=!o;break e;default:e=!1}return e?null:(n&&"function"!=typeof n&&r("231",t,typeof n),n)}function w(e,t,n,r){for(var o,i=0;i<Gn.length;i++){var a=Gn[i];a&&(a=a.extractEvents(e,t,n,r))&&(o=y(o,a))}return o}function x(e){e&&(tr=y(tr,e))}function O(e){var t=tr;tr=null,t&&(e?v(t,b):v(t,g),tr&&r("95"),Bn.rethrowCaughtError())}function S(e){if(e[ir])return e[ir];for(var t=[];!e[ir];){if(t.push(e),!e.parentNode)return null;e=e.parentNode}var n=void 0,r=e[ir];if(5===r.tag||6===r.tag)return r;for(;e&&(r=e[ir]);e=t.pop())n=r;return n}function T(e){if(5===e.tag||6===e.tag)return e.stateNode;r("33")}function E(e){return e[ar]||null}function C(e){do{e=e.return}while(e&&5!==e.tag);return e||null}function k(e,t,n){for(var r=[];e;)r.push(e),e=C(e);for(e=r.length;0<e--;)t(r[e],"captured",n);for(e=0;e<r.length;e++)t(r[e],"bubbled",n)}function P(e,t,n){(t=_(e,n.dispatchConfig.phasedRegistrationNames[t]))&&(n._dispatchListeners=y(n._dispatchListeners,t),n._dispatchInstances=y(n._dispatchInstances,e))}function M(e){e&&e.dispatchConfig.phasedRegistrationNames&&k(e._targetInst,P,e)}function j(e){if(e&&e.dispatchConfig.phasedRegistrationNames){var t=e._targetInst;t=t?C(t):null,k(t,P,e)}}function N(e,t,n){e&&n&&n.dispatchConfig.registrationName&&(t=_(e,n.dispatchConfig.registrationName))&&(n._dispatchListeners=y(n._dispatchListeners,t),n._dispatchInstances=y(n._dispatchInstances,e))}function I(e){e&&e.dispatchConfig.registrationName&&N(e._targetInst,null,e)}function A(e){v(e,M)}function R(e,t,n,r){if(n&&r)e:{for(var o=n,i=r,a=0,u=o;u;u=C(u))a++;u=0;for(var s=i;s;s=C(s))u++;for(;0<a-u;)o=C(o),a--;for(;0<u-a;)i=C(i),u--;for(;a--;){if(o===i||o===i.alternate)break e;o=C(o),i=C(i)}o=null}else o=null;for(i=o,o=[];n&&n!==i&&(null===(a=n.alternate)||a!==i);)o.push(n),n=C(n);for(n=[];r&&r!==i&&(null===(a=r.alternate)||a!==i);)n.push(r),r=C(r);for(r=0;r<o.length;r++)N(o[r],"bubbled",e);for(e=n.length;0<e--;)N(n[e],"captured",t)}function F(){return!lr&&_n.canUseDOM&&(lr="textContent"in document.documentElement?"textContent":"innerText"),lr}function D(){if(cr._fallbackText)return cr._fallbackText;var e,t,n=cr._startText,r=n.length,o=L(),i=o.length;for(e=0;e<r&&n[e]===o[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===o[i-t];t++);return cr._fallbackText=o.slice(e,1<t?1-t:void 0),cr._fallbackText}function L(){return"value"in cr._root?cr._root.value:cr._root[F()]}function z(e,t,n,r){this.dispatchConfig=e,this._targetInst=t,this.nativeEvent=n,e=this.constructor.Interface;for(var o in e)e.hasOwnProperty(o)&&((t=e[o])?this[o]=t(n):"target"===o?this.target=r:this[o]=n[o]);return this.isDefaultPrevented=(null!=n.defaultPrevented?n.defaultPrevented:!1===n.returnValue)?xn.thatReturnsTrue:xn.thatReturnsFalse,this.isPropagationStopped=xn.thatReturnsFalse,this}function V(e,t,n,r){if(this.eventPool.length){var o=this.eventPool.pop();return this.call(o,e,t,n,r),o}return new this(e,t,n,r)}function U(e){e instanceof this||r("223"),e.destructor(),10>this.eventPool.length&&this.eventPool.push(e)}function W(e){e.eventPool=[],e.getPooled=V,e.release=U}function H(e,t,n,r){return z.call(this,e,t,n,r)}function B(e,t,n,r){return z.call(this,e,t,n,r)}function K(e,t){switch(e){case"topKeyUp":return-1!==pr.indexOf(t.keyCode);case"topKeyDown":return 229!==t.keyCode;case"topKeyPress":case"topMouseDown":case"topBlur":return!0;default:return!1}}function q(e){return e=e.detail,"object"==typeof e&&"data"in e?e.data:null}function G(e,t){switch(e){case"topCompositionEnd":return q(t);case"topKeyPress":return 32!==t.which?null:(Or=!0,wr);case"topTextInput":return e=t.data,e===wr&&Or?null:e;default:return null}}function Y(e,t){if(Sr)return"topCompositionEnd"===e||!hr&&K(e,t)?(e=D(),cr._root=null,cr._startText=null,cr._fallbackText=null,Sr=!1,e):null;switch(e){case"topPaste":return null;case"topKeyPress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"topCompositionEnd":return _r?null:t.data;default:return null}}function X(e){if(e=Zn(e)){Er&&"function"==typeof Er.restoreControlledState||r("194");var t=Jn(e.stateNode);Er.restoreControlledState(e.stateNode,e.type,t)}}function $(e){Cr?kr?kr.push(e):kr=[e]:Cr=e}function Q(){if(Cr){var e=Cr,t=kr;if(kr=Cr=null,X(e),t)for(e=0;e<t.length;e++)X(t[e])}}function J(e,t){return e(t)}function Z(e,t){if(jr)return J(e,t);jr=!0;try{return J(e,t)}finally{jr=!1,Q()}}function ee(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!Nr[e.type]:"textarea"===t}function te(e){return e=e.target||e.srcElement||window,e.correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}function ne(e,t){if(!_n.canUseDOM||t&&!("addEventListener"in document))return!1;t="on"+e;var n=t in document;return n||(n=document.createElement("div"),n.setAttribute(t,"return;"),n="function"==typeof n[t]),!n&&br&&"wheel"===e&&(n=document.implementation.hasFeature("Events.wheel","3.0")),n}function re(e){var t=e.type;return(e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function oe(e){var t=re(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),r=""+e[t];if(!e.hasOwnProperty(t)&&"function"==typeof n.get&&"function"==typeof n.set)return Object.defineProperty(e,t,{enumerable:n.enumerable,configurable:!0,get:function(){return n.get.call(this)},set:function(e){r=""+e,n.set.call(this,e)}}),{getValue:function(){return r},setValue:function(e){r=""+e},stopTracking:function(){e._valueTracker=null,delete e[t]}}}function ie(e){e._valueTracker||(e._valueTracker=oe(e))}function ae(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var n=t.getValue(),r="";return e&&(r=re(e)?e.checked?"true":"false":e.value),(e=r)!==n&&(t.setValue(e),!0)}function ue(e,t,n){return e=z.getPooled(Ir.change,e,t,n),e.type="change",$(n),A(e),e}function se(e){x(e),O(!1)}function le(e){if(ae(T(e)))return e}function ce(e,t){if("topChange"===e)return t}function fe(){Ar&&(Ar.detachEvent("onpropertychange",de),Rr=Ar=null)}function de(e){"value"===e.propertyName&&le(Rr)&&(e=ue(Rr,e,te(e)),Z(se,e))}function pe(e,t,n){"topFocus"===e?(fe(),Ar=t,Rr=n,Ar.attachEvent("onpropertychange",de)):"topBlur"===e&&fe()}function he(e){if("topSelectionChange"===e||"topKeyUp"===e||"topKeyDown"===e)return le(Rr)}function ye(e,t){if("topClick"===e)return le(t)}function ve(e,t){if("topInput"===e||"topChange"===e)return le(t)}function me(e,t,n,r){return z.call(this,e,t,n,r)}function be(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=Lr[e])&&!!t[e]}function ge(){return be}function _e(e,t,n,r){return z.call(this,e,t,n,r)}function we(e){return e=e.type,"string"==typeof e?e:"function"==typeof e?e.displayName||e.name:null}function xe(e){var t=e;if(e.alternate)for(;t.return;)t=t.return;else{if(0!=(2&t.effectTag))return 1;for(;t.return;)if(t=t.return,0!=(2&t.effectTag))return 1}return 3===t.tag?2:3}function Oe(e){return!!(e=e._reactInternalFiber)&&2===xe(e)}function Se(e){2!==xe(e)&&r("188")}function Te(e){var t=e.alternate;if(!t)return t=xe(e),3===t&&r("188"),1===t?null:e;for(var n=e,o=t;;){var i=n.return,a=i?i.alternate:null;if(!i||!a)break;if(i.child===a.child){for(var u=i.child;u;){if(u===n)return Se(i),e;if(u===o)return Se(i),t;u=u.sibling}r("188")}if(n.return!==o.return)n=i,o=a;else{u=!1;for(var s=i.child;s;){if(s===n){u=!0,n=i,o=a;break}if(s===o){u=!0,o=i,n=a;break}s=s.sibling}if(!u){for(s=a.child;s;){if(s===n){u=!0,n=a,o=i;break}if(s===o){u=!0,o=a,n=i;break}s=s.sibling}u||r("189")}}n.alternate!==o&&r("190")}return 3!==n.tag&&r("188"),n.stateNode.current===n?e:t}function Ee(e){if(!(e=Te(e)))return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}function Ce(e){if(!(e=Te(e)))return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child&&4!==t.tag)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}function ke(e){var t=e.targetInst;do{if(!t){e.ancestors.push(t);break}var n;for(n=t;n.return;)n=n.return;if(!(n=3!==n.tag?null:n.stateNode.containerInfo))break;e.ancestors.push(t),t=S(n)}while(t);for(n=0;n<e.ancestors.length;n++)t=e.ancestors[n],Br(e.topLevelType,t,e.nativeEvent,te(e.nativeEvent))}function Pe(e){Hr=!!e}function Me(e,t,n){return n?On.listen(n,t,Ne.bind(null,e)):null}function je(e,t,n){return n?On.capture(n,t,Ne.bind(null,e)):null}function Ne(e,t){if(Hr){var n=te(t);if(n=S(n),null===n||"number"!=typeof n.tag||2===xe(n)||(n=null),Wr.length){var r=Wr.pop();r.topLevelType=e,r.nativeEvent=t,r.targetInst=n,e=r}else e={topLevelType:e,nativeEvent:t,targetInst:n,ancestors:[]};try{Z(ke,e)}finally{e.topLevelType=null,e.nativeEvent=null,e.targetInst=null,e.ancestors.length=0,10>Wr.length&&Wr.push(e)}}}function Ie(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n["ms"+e]="MS"+t,n["O"+e]="o"+t.toLowerCase(),n}function Ae(e){if(Gr[e])return Gr[e];if(!qr[e])return e;var t,n=qr[e];for(t in n)if(n.hasOwnProperty(t)&&t in Yr)return Gr[e]=n[t];return""}function Re(e){return Object.prototype.hasOwnProperty.call(e,Jr)||(e[Jr]=Qr++,$r[e[Jr]]={}),$r[e[Jr]]}function Fe(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function De(e,t){var n=Fe(e);e=0;for(var r;n;){if(3===n.nodeType){if(r=e+n.textContent.length,e<=t&&r>=t)return{node:n,offset:t-e};e=r}e:{for(;n;){if(n.nextSibling){n=n.nextSibling;break e}n=n.parentNode}n=void 0}n=Fe(n)}}function Le(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&"text"===e.type||"textarea"===t||"true"===e.contentEditable)}function ze(e,t){if(oo||null==to||to!==Sn())return null;var n=to;return"selectionStart"in n&&Le(n)?n={start:n.selectionStart,end:n.selectionEnd}:window.getSelection?(n=window.getSelection(),n={anchorNode:n.anchorNode,anchorOffset:n.anchorOffset,focusNode:n.focusNode,focusOffset:n.focusOffset}):n=void 0,ro&&Tn(ro,n)?null:(ro=n,e=z.getPooled(eo.select,no,e,t),e.type="select",e.target=to,A(e),e)}function Ve(e,t,n,r){return z.call(this,e,t,n,r)}function Ue(e,t,n,r){return z.call(this,e,t,n,r)}function We(e,t,n,r){return z.call(this,e,t,n,r)}function He(e){var t=e.keyCode;return"charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,32<=e||13===e?e:0}function Be(e,t,n,r){return z.call(this,e,t,n,r)}function Ke(e,t,n,r){return z.call(this,e,t,n,r)}function qe(e,t,n,r){return z.call(this,e,t,n,r)}function Ge(e,t,n,r){return z.call(this,e,t,n,r)}function Ye(e,t,n,r){return z.call(this,e,t,n,r)}function Xe(e){0>po||(e.current=fo[po],fo[po]=null,po--)}function $e(e,t){po++,fo[po]=e.current,e.current=t}function Qe(e){return Ze(e)?vo:ho.current}function Je(e,t){var n=e.type.contextTypes;if(!n)return kn;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var o,i={};for(o in n)i[o]=t[o];return r&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=i),i}function Ze(e){return 2===e.tag&&null!=e.type.childContextTypes}function et(e){Ze(e)&&(Xe(yo,e),Xe(ho,e))}function tt(e,t,n){null!=ho.cursor&&r("168"),$e(ho,t,e),$e(yo,n,e)}function nt(e,t){var n=e.stateNode,o=e.type.childContextTypes;if("function"!=typeof n.getChildContext)return t;n=n.getChildContext();for(var i in n)i in o||r("108",we(e)||"Unknown",i);return wn({},t,n)}function rt(e){if(!Ze(e))return!1;var t=e.stateNode;return t=t&&t.__reactInternalMemoizedMergedChildContext||kn,vo=ho.current,$e(ho,t,e),$e(yo,yo.current,e),!0}function ot(e,t){var n=e.stateNode;if(n||r("169"),t){var o=nt(e,vo);n.__reactInternalMemoizedMergedChildContext=o,Xe(yo,e),Xe(ho,e),$e(ho,o,e)}else Xe(yo,e);$e(yo,t,e)}function it(e,t,n){this.tag=e,this.key=t,this.stateNode=this.type=null,this.sibling=this.child=this.return=null,this.index=0,this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null,this.internalContextTag=n,this.effectTag=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.expirationTime=0,this.alternate=null}function at(e,t,n){var r=e.alternate;return null===r?(r=new it(e.tag,e.key,e.internalContextTag),r.type=e.type,r.stateNode=e.stateNode,r.alternate=e,e.alternate=r):(r.effectTag=0,r.nextEffect=null,r.firstEffect=null,r.lastEffect=null),r.expirationTime=n,r.pendingProps=t,r.child=e.child,r.memoizedProps=e.memoizedProps,r.memoizedState=e.memoizedState,r.updateQueue=e.updateQueue,r.sibling=e.sibling,r.index=e.index,r.ref=e.ref,r}function ut(e,t,n){var o=void 0,i=e.type,a=e.key;return"function"==typeof i?(o=i.prototype&&i.prototype.isReactComponent?new it(2,a,t):new it(0,a,t),o.type=i,o.pendingProps=e.props):"string"==typeof i?(o=new it(5,a,t),o.type=i,o.pendingProps=e.props):"object"==typeof i&&null!==i&&"number"==typeof i.tag?(o=i,o.pendingProps=e.props):r("130",null==i?i:typeof i,""),o.expirationTime=n,o}function st(e,t,n,r){return t=new it(10,r,t),t.pendingProps=e,t.expirationTime=n,t}function lt(e,t,n){return t=new it(6,null,t),t.pendingProps=e,t.expirationTime=n,t}function ct(e,t,n){return t=new it(7,e.key,t),t.type=e.handler,t.pendingProps=e,t.expirationTime=n,t}function ft(e,t,n){return e=new it(9,null,t),e.expirationTime=n,e}function dt(e,t,n){return t=new it(4,e.key,t),t.pendingProps=e.children||[],t.expirationTime=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function pt(e){return function(t){try{return e(t)}catch(e){}}}function ht(e){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var t=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(t.isDisabled||!t.supportsFiber)return!0;try{var n=t.inject(e);mo=pt(function(e){return t.onCommitFiberRoot(n,e)}),bo=pt(function(e){return t.onCommitFiberUnmount(n,e)})}catch(e){}return!0}function yt(e){"function"==typeof mo&&mo(e)}function vt(e){"function"==typeof bo&&bo(e)}function mt(e){return{baseState:e,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function bt(e,t){null===e.last?e.first=e.last=t:(e.last.next=t,e.last=t),(0===e.expirationTime||e.expirationTime>t.expirationTime)&&(e.expirationTime=t.expirationTime)}function gt(e,t){var n=e.alternate,r=e.updateQueue;null===r&&(r=e.updateQueue=mt(null)),null!==n?null===(e=n.updateQueue)&&(e=n.updateQueue=mt(null)):e=null,e=e!==r?e:null,null===e?bt(r,t):null===r.last||null===e.last?(bt(r,t),bt(e,t)):(bt(r,t),e.last=t)}function _t(e,t,n,r){return e=e.partialState,"function"==typeof e?e.call(t,n,r):e}function wt(e,t,n,r,o,i){null!==e&&e.updateQueue===n&&(n=t.updateQueue={baseState:n.baseState,expirationTime:n.expirationTime,first:n.first,last:n.last,isInitialized:n.isInitialized,callbackList:null,hasForceUpdate:!1}),n.expirationTime=0,n.isInitialized?e=n.baseState:(e=n.baseState=t.memoizedState,n.isInitialized=!0);for(var a=!0,u=n.first,s=!1;null!==u;){var l=u.expirationTime;if(l>i){var c=n.expirationTime;(0===c||c>l)&&(n.expirationTime=l),s||(s=!0,n.baseState=e)}else s||(n.first=u.next,null===n.first&&(n.last=null)),u.isReplace?(e=_t(u,r,e,o),a=!0):(l=_t(u,r,e,o))&&(e=a?wn({},e,l):wn(e,l),a=!1),u.isForced&&(n.hasForceUpdate=!0),null!==u.callback&&(l=n.callbackList,null===l&&(l=n.callbackList=[]),l.push(u));u=u.next}return null!==n.callbackList?t.effectTag|=32:null!==n.first||n.hasForceUpdate||(t.updateQueue=null),s||(n.baseState=e),e}function xt(e,t){var n=e.callbackList;if(null!==n)for(e.callbackList=null,e=0;e<n.length;e++){var o=n[e],i=o.callback;o.callback=null,"function"!=typeof i&&r("191",i),i.call(t)}}function Ot(e,t,n,o){function i(e,t){t.updater=a,e.stateNode=t,t._reactInternalFiber=e}var a={isMounted:Oe,enqueueSetState:function(n,r,o){n=n._reactInternalFiber,o=void 0===o?null:o;var i=t(n);gt(n,{expirationTime:i,partialState:r,callback:o,isReplace:!1,isForced:!1,nextCallback:null,next:null}),e(n,i)},enqueueReplaceState:function(n,r,o){n=n._reactInternalFiber,o=void 0===o?null:o;var i=t(n);gt(n,{expirationTime:i,partialState:r,callback:o,isReplace:!0,isForced:!1,nextCallback:null,next:null}),e(n,i)},enqueueForceUpdate:function(n,r){n=n._reactInternalFiber,r=void 0===r?null:r;var o=t(n);gt(n,{expirationTime:o,partialState:null,callback:r,isReplace:!1,isForced:!0,nextCallback:null,next:null}),e(n,o)}};return{adoptClassInstance:i,constructClassInstance:function(e,t){var n=e.type,r=Qe(e),o=2===e.tag&&null!=e.type.contextTypes,a=o?Je(e,r):kn;return t=new n(t,a),i(e,t),o&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=r,e.__reactInternalMemoizedMaskedChildContext=a),t},mountClassInstance:function(e,t){var n=e.alternate,o=e.stateNode,i=o.state||null,u=e.pendingProps;u||r("158");var s=Qe(e);o.props=u,o.state=e.memoizedState=i,o.refs=kn,o.context=Je(e,s),null!=e.type&&null!=e.type.prototype&&!0===e.type.prototype.unstable_isAsyncReactComponent&&(e.internalContextTag|=1),"function"==typeof o.componentWillMount&&(i=o.state,o.componentWillMount(),i!==o.state&&a.enqueueReplaceState(o,o.state,null),null!==(i=e.updateQueue)&&(o.state=wt(n,e,i,o,u,t))),"function"==typeof o.componentDidMount&&(e.effectTag|=4)},updateClassInstance:function(e,t,i){var u=t.stateNode;u.props=t.memoizedProps,u.state=t.memoizedState;var s=t.memoizedProps,l=t.pendingProps;l||null==(l=s)&&r("159");var c=u.context,f=Qe(t);if(f=Je(t,f),"function"!=typeof u.componentWillReceiveProps||s===l&&c===f||(c=u.state,u.componentWillReceiveProps(l,f),u.state!==c&&a.enqueueReplaceState(u,u.state,null)),c=t.memoizedState,i=null!==t.updateQueue?wt(e,t,t.updateQueue,u,l,i):c,!(s!==l||c!==i||yo.current||null!==t.updateQueue&&t.updateQueue.hasForceUpdate))return"function"!=typeof u.componentDidUpdate||s===e.memoizedProps&&c===e.memoizedState||(t.effectTag|=4),!1;var d=l;if(null===s||null!==t.updateQueue&&t.updateQueue.hasForceUpdate)d=!0;else{var p=t.stateNode,h=t.type;d="function"==typeof p.shouldComponentUpdate?p.shouldComponentUpdate(d,i,f):!h.prototype||!h.prototype.isPureReactComponent||(!Tn(s,d)||!Tn(c,i))}return d?("function"==typeof u.componentWillUpdate&&u.componentWillUpdate(l,i,f),"function"==typeof u.componentDidUpdate&&(t.effectTag|=4)):("function"!=typeof u.componentDidUpdate||s===e.memoizedProps&&c===e.memoizedState||(t.effectTag|=4),n(t,l),o(t,i)),u.props=l,u.state=i,u.context=f,d}}}function St(e){return null===e||void 0===e?null:(e=To&&e[To]||e["@@iterator"],"function"==typeof e?e:null)}function Tt(e,t){var n=t.ref;if(null!==n&&"function"!=typeof n){if(t._owner){t=t._owner;var o=void 0;t&&(2!==t.tag&&r("110"),o=t.stateNode),o||r("147",n);var i=""+n;return null!==e&&null!==e.ref&&e.ref._stringRef===i?e.ref:(e=function(e){var t=o.refs===kn?o.refs={}:o.refs;null===e?delete t[i]:t[i]=e},e._stringRef=i,e)}"string"!=typeof n&&r("148"),t._owner||r("149",n)}return n}function Et(e,t){"textarea"!==e.type&&r("31","[object Object]"===Object.prototype.toString.call(t)?"object with keys {"+Object.keys(t).join(", ")+"}":t,"")}function Ct(e){function t(t,n){if(e){var r=t.lastEffect;null!==r?(r.nextEffect=n,t.lastEffect=n):t.firstEffect=t.lastEffect=n,n.nextEffect=null,n.effectTag=8}}function n(n,r){if(!e)return null;for(;null!==r;)t(n,r),r=r.sibling;return null}function o(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function i(e,t,n){return e=at(e,t,n),e.index=0,e.sibling=null,e}function a(t,n,r){return t.index=r,e?null!==(r=t.alternate)?(r=r.index,r<n?(t.effectTag=2,n):r):(t.effectTag=2,n):n}function u(t){return e&&null===t.alternate&&(t.effectTag=2),t}function s(e,t,n,r){return null===t||6!==t.tag?(t=lt(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function l(e,t,n,r){return null!==t&&t.type===n.type?(r=i(t,n.props,r),r.ref=Tt(t,n),r.return=e,r):(r=ut(n,e.internalContextTag,r),r.ref=Tt(t,n),r.return=e,r)}function c(e,t,n,r){return null===t||7!==t.tag?(t=ct(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function f(e,t,n,r){return null===t||9!==t.tag?(t=ft(n,e.internalContextTag,r),t.type=n.value,t.return=e,t):(t=i(t,null,r),t.type=n.value,t.return=e,t)}function d(e,t,n,r){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?(t=dt(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n.children||[],r),t.return=e,t)}function p(e,t,n,r,o){return null===t||10!==t.tag?(t=st(n,e.internalContextTag,r,o),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function h(e,t,n){if("string"==typeof t||"number"==typeof t)return t=lt(""+t,e.internalContextTag,n),t.return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case _o:return t.type===So?(t=st(t.props.children,e.internalContextTag,n,t.key),t.return=e,t):(n=ut(t,e.internalContextTag,n),n.ref=Tt(null,t),n.return=e,n);case wo:return t=ct(t,e.internalContextTag,n),t.return=e,t;case xo:return n=ft(t,e.internalContextTag,n),n.type=t.value,n.return=e,n;case Oo:return t=dt(t,e.internalContextTag,n),t.return=e,t}if(Eo(t)||St(t))return t=st(t,e.internalContextTag,n,null),t.return=e,t;Et(e,t)}return null}function y(e,t,n,r){var o=null!==t?t.key:null;if("string"==typeof n||"number"==typeof n)return null!==o?null:s(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case _o:return n.key===o?n.type===So?p(e,t,n.props.children,r,o):l(e,t,n,r):null;case wo:return n.key===o?c(e,t,n,r):null;case xo:return null===o?f(e,t,n,r):null;case Oo:return n.key===o?d(e,t,n,r):null}if(Eo(n)||St(n))return null!==o?null:p(e,t,n,r,null);Et(e,n)}return null}function v(e,t,n,r,o){if("string"==typeof r||"number"==typeof r)return e=e.get(n)||null,s(t,e,""+r,o);if("object"==typeof r&&null!==r){switch(r.$$typeof){case _o:return e=e.get(null===r.key?n:r.key)||null,r.type===So?p(t,e,r.props.children,o,r.key):l(t,e,r,o);case wo:return e=e.get(null===r.key?n:r.key)||null,c(t,e,r,o);case xo:return e=e.get(n)||null,f(t,e,r,o);case Oo:return e=e.get(null===r.key?n:r.key)||null,d(t,e,r,o)}if(Eo(r)||St(r))return e=e.get(n)||null,p(t,e,r,o,null);Et(t,r)}return null}function m(r,i,u,s){for(var l=null,c=null,f=i,d=i=0,p=null;null!==f&&d<u.length;d++){f.index>d?(p=f,f=null):p=f.sibling;var m=y(r,f,u[d],s);if(null===m){null===f&&(f=p);break}e&&f&&null===m.alternate&&t(r,f),i=a(m,i,d),null===c?l=m:c.sibling=m,c=m,f=p}if(d===u.length)return n(r,f),l;if(null===f){for(;d<u.length;d++)(f=h(r,u[d],s))&&(i=a(f,i,d),null===c?l=f:c.sibling=f,c=f);return l}for(f=o(r,f);d<u.length;d++)(p=v(f,r,d,u[d],s))&&(e&&null!==p.alternate&&f.delete(null===p.key?d:p.key),i=a(p,i,d),null===c?l=p:c.sibling=p,c=p);return e&&f.forEach(function(e){return t(r,e)}),l}function b(i,u,s,l){var c=St(s);"function"!=typeof c&&r("150"),null==(s=c.call(s))&&r("151");for(var f=c=null,d=u,p=u=0,m=null,b=s.next();null!==d&&!b.done;p++,b=s.next()){d.index>p?(m=d,d=null):m=d.sibling;var g=y(i,d,b.value,l);if(null===g){d||(d=m);break}e&&d&&null===g.alternate&&t(i,d),u=a(g,u,p),null===f?c=g:f.sibling=g,f=g,d=m}if(b.done)return n(i,d),c;if(null===d){for(;!b.done;p++,b=s.next())null!==(b=h(i,b.value,l))&&(u=a(b,u,p),null===f?c=b:f.sibling=b,f=b);return c}for(d=o(i,d);!b.done;p++,b=s.next())null!==(b=v(d,i,p,b.value,l))&&(e&&null!==b.alternate&&d.delete(null===b.key?p:b.key),u=a(b,u,p),null===f?c=b:f.sibling=b,f=b);return e&&d.forEach(function(e){return t(i,e)}),c}return function(e,o,a,s){"object"==typeof a&&null!==a&&a.type===So&&null===a.key&&(a=a.props.children);var l="object"==typeof a&&null!==a;if(l)switch(a.$$typeof){case _o:e:{var c=a.key;for(l=o;null!==l;){if(l.key===c){if(10===l.tag?a.type===So:l.type===a.type){n(e,l.sibling),o=i(l,a.type===So?a.props.children:a.props,s),o.ref=Tt(l,a),o.return=e,e=o;break e}n(e,l);break}t(e,l),l=l.sibling}a.type===So?(o=st(a.props.children,e.internalContextTag,s,a.key),o.return=e,e=o):(s=ut(a,e.internalContextTag,s),s.ref=Tt(o,a),s.return=e,e=s)}return u(e);case wo:e:{for(l=a.key;null!==o;){if(o.key===l){if(7===o.tag){n(e,o.sibling),o=i(o,a,s),o.return=e,e=o;break e}n(e,o);break}t(e,o),o=o.sibling}o=ct(a,e.internalContextTag,s),o.return=e,e=o}return u(e);case xo:e:{if(null!==o){if(9===o.tag){n(e,o.sibling),o=i(o,null,s),o.type=a.value,o.return=e,e=o;break e}n(e,o)}o=ft(a,e.internalContextTag,s),o.type=a.value,o.return=e,e=o}return u(e);case Oo:e:{for(l=a.key;null!==o;){if(o.key===l){if(4===o.tag&&o.stateNode.containerInfo===a.containerInfo&&o.stateNode.implementation===a.implementation){n(e,o.sibling),o=i(o,a.children||[],s),o.return=e,e=o;break e}n(e,o);break}t(e,o),o=o.sibling}o=dt(a,e.internalContextTag,s),o.return=e,e=o}return u(e)}if("string"==typeof a||"number"==typeof a)return a=""+a,null!==o&&6===o.tag?(n(e,o.sibling),o=i(o,a,s)):(n(e,o),o=lt(a,e.internalContextTag,s)),o.return=e,e=o,u(e);if(Eo(a))return m(e,o,a,s);if(St(a))return b(e,o,a,s);if(l&&Et(e,a),void 0===a)switch(e.tag){case 2:case 1:s=e.type,r("152",s.displayName||s.name||"Component")}return n(e,o)}}function kt(e,t,n,o,i){function a(e,t,n){var r=t.expirationTime;t.child=null===e?ko(t,null,n,r):Co(t,e.child,n,r)}function u(e,t){var n=t.ref;null===n||e&&e.ref===n||(t.effectTag|=128)}function s(e,t,n,r){if(u(e,t),!n)return r&&ot(t,!1),c(e,t);n=t.stateNode,Ur.current=t;var o=n.render();return t.effectTag|=1,a(e,t,o),t.memoizedState=n.state,t.memoizedProps=n.props,r&&ot(t,!0),t.child}function l(e){var t=e.stateNode;t.pendingContext?tt(e,t.pendingContext,t.pendingContext!==t.context):t.context&&tt(e,t.context,!1),v(e,t.containerInfo)}function c(e,t){if(null!==e&&t.child!==e.child&&r("153"),null!==t.child){e=t.child;var n=at(e,e.pendingProps,e.expirationTime);for(t.child=n,n.return=t;null!==e.sibling;)e=e.sibling,n=n.sibling=at(e,e.pendingProps,e.expirationTime),n.return=t;n.sibling=null}return t.child}function f(e,t){switch(t.tag){case 3:l(t);break;case 2:rt(t);break;case 4:v(t,t.stateNode.containerInfo)}return null}var d=e.shouldSetTextContent,p=e.useSyncScheduling,h=e.shouldDeprioritizeSubtree,y=t.pushHostContext,v=t.pushHostContainer,m=n.enterHydrationState,b=n.resetHydrationState,g=n.tryToClaimNextHydratableInstance;e=Ot(o,i,function(e,t){e.memoizedProps=t},function(e,t){e.memoizedState=t});var _=e.adoptClassInstance,w=e.constructClassInstance,x=e.mountClassInstance,O=e.updateClassInstance;return{beginWork:function(e,t,n){if(0===t.expirationTime||t.expirationTime>n)return f(e,t);switch(t.tag){case 0:null!==e&&r("155");var o=t.type,i=t.pendingProps,S=Qe(t);return S=Je(t,S),o=o(i,S),t.effectTag|=1,"object"==typeof o&&null!==o&&"function"==typeof o.render?(t.tag=2,i=rt(t),_(t,o),x(t,n),t=s(e,t,!0,i)):(t.tag=1,a(e,t,o),t.memoizedProps=i,t=t.child),t;case 1:e:{if(i=t.type,n=t.pendingProps,o=t.memoizedProps,yo.current)null===n&&(n=o);else if(null===n||o===n){t=c(e,t);break e}o=Qe(t),o=Je(t,o),i=i(n,o),t.effectTag|=1,a(e,t,i),t.memoizedProps=n,t=t.child}return t;case 2:return i=rt(t),o=void 0,null===e?t.stateNode?r("153"):(w(t,t.pendingProps),x(t,n),o=!0):o=O(e,t,n),s(e,t,o,i);case 3:return l(t),i=t.updateQueue,null!==i?(o=t.memoizedState,i=wt(e,t,i,null,null,n),o===i?(b(),t=c(e,t)):(o=i.element,S=t.stateNode,(null===e||null===e.child)&&S.hydrate&&m(t)?(t.effectTag|=2,t.child=ko(t,null,o,n)):(b(),a(e,t,o)),t.memoizedState=i,t=t.child)):(b(),t=c(e,t)),t;case 5:y(t),null===e&&g(t),i=t.type;var T=t.memoizedProps;return o=t.pendingProps,null===o&&null===(o=T)&&r("154"),S=null!==e?e.memoizedProps:null,yo.current||null!==o&&T!==o?(T=o.children,d(i,o)?T=null:S&&d(i,S)&&(t.effectTag|=16),u(e,t),2147483647!==n&&!p&&h(i,o)?(t.expirationTime=2147483647,t=null):(a(e,t,T),t.memoizedProps=o,t=t.child)):t=c(e,t),t;case 6:return null===e&&g(t),e=t.pendingProps,null===e&&(e=t.memoizedProps),t.memoizedProps=e,null;case 8:t.tag=7;case 7:return i=t.pendingProps,yo.current?null===i&&null===(i=e&&e.memoizedProps)&&r("154"):null!==i&&t.memoizedProps!==i||(i=t.memoizedProps),o=i.children,t.stateNode=null===e?ko(t,t.stateNode,o,n):Co(t,t.stateNode,o,n),t.memoizedProps=i,t.stateNode;case 9:return null;case 4:e:{if(v(t,t.stateNode.containerInfo),i=t.pendingProps,yo.current)null===i&&null==(i=e&&e.memoizedProps)&&r("154");else if(null===i||t.memoizedProps===i){t=c(e,t);break e}null===e?t.child=Co(t,null,i,n):a(e,t,i),t.memoizedProps=i,t=t.child}return t;case 10:e:{if(n=t.pendingProps,yo.current)null===n&&(n=t.memoizedProps);else if(null===n||t.memoizedProps===n){t=c(e,t);break e}a(e,t,n),t.memoizedProps=n,t=t.child}return t;default:r("156")}},beginFailedWork:function(e,t,n){switch(t.tag){case 2:rt(t);break;case 3:l(t);break;default:r("157")}return t.effectTag|=64,null===e?t.child=null:t.child!==e.child&&(t.child=e.child),0===t.expirationTime||t.expirationTime>n?f(e,t):(t.firstEffect=null,t.lastEffect=null,t.child=null===e?ko(t,null,null,n):Co(t,e.child,null,n),2===t.tag&&(e=t.stateNode,t.memoizedProps=e.props,t.memoizedState=e.state),t.child)}}}function Pt(e,t,n){function o(e){e.effectTag|=4}var i=e.createInstance,a=e.createTextInstance,u=e.appendInitialChild,s=e.finalizeInitialChildren,l=e.prepareUpdate,c=e.persistence,f=t.getRootHostContainer,d=t.popHostContext,p=t.getHostContext,h=t.popHostContainer,y=n.prepareToHydrateHostInstance,v=n.prepareToHydrateHostTextInstance,m=n.popHydrationState,b=void 0,g=void 0,_=void 0;return e.mutation?(b=function(){},g=function(e,t,n){(t.updateQueue=n)&&o(t)},_=function(e,t,n,r){n!==r&&o(t)}):r(c?"235":"236"),{completeWork:function(e,t,n){var c=t.pendingProps;switch(null===c?c=t.memoizedProps:2147483647===t.expirationTime&&2147483647!==n||(t.pendingProps=null),t.tag){case 1:return null;case 2:return et(t),null;case 3:return h(t),Xe(yo,t),Xe(ho,t),c=t.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==e&&null!==e.child||(m(t),t.effectTag&=-3),b(t),null;case 5:d(t),n=f();var w=t.type;if(null!==e&&null!=t.stateNode){var x=e.memoizedProps,O=t.stateNode,S=p();O=l(O,w,x,c,n,S),g(e,t,O,w,x,c,n),e.ref!==t.ref&&(t.effectTag|=128)}else{if(!c)return null===t.stateNode&&r("166"),null;if(e=p(),m(t))y(t,n,e)&&o(t);else{e=i(w,c,n,e,t);e:for(x=t.child;null!==x;){if(5===x.tag||6===x.tag)u(e,x.stateNode);else if(4!==x.tag&&null!==x.child){x.child.return=x,x=x.child;continue}if(x===t)break;for(;null===x.sibling;){if(null===x.return||x.return===t)break e;x=x.return}x.sibling.return=x.return,x=x.sibling}s(e,w,c,n)&&o(t),t.stateNode=e}null!==t.ref&&(t.effectTag|=128)}return null;case 6:if(e&&null!=t.stateNode)_(e,t,e.memoizedProps,c);else{if("string"!=typeof c)return null===t.stateNode&&r("166"),null;e=f(),n=p(),m(t)?v(t)&&o(t):t.stateNode=a(c,e,n,t)}return null;case 7:(c=t.memoizedProps)||r("165"),t.tag=8,w=[];e:for((x=t.stateNode)&&(x.return=t);null!==x;){if(5===x.tag||6===x.tag||4===x.tag)r("247");else if(9===x.tag)w.push(x.type);else if(null!==x.child){x.child.return=x,x=x.child;continue}for(;null===x.sibling;){if(null===x.return||x.return===t)break e;x=x.return}x.sibling.return=x.return,x=x.sibling}return x=c.handler,c=x(c.props,w),t.child=Co(t,null!==e?e.child:null,c,n),t.child;case 8:return t.tag=7,null;case 9:case 10:return null;case 4:return h(t),b(t),null;case 0:r("167");default:r("156")}}}}function Mt(e,t){function n(e){var n=e.ref;if(null!==n)try{n(null)}catch(n){t(e,n)}}function o(e){switch("function"==typeof vt&&vt(e),e.tag){case 2:n(e);var r=e.stateNode;if("function"==typeof r.componentWillUnmount)try{r.props=e.memoizedProps,r.state=e.memoizedState,r.componentWillUnmount()}catch(n){t(e,n)}break;case 5:n(e);break;case 7:i(e.stateNode);break;case 4:l&&u(e)}}function i(e){for(var t=e;;)if(o(t),null===t.child||l&&4===t.tag){if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return;t=t.return}t.sibling.return=t.return,t=t.sibling}else t.child.return=t,t=t.child}function a(e){return 5===e.tag||3===e.tag||4===e.tag}function u(e){for(var t=e,n=!1,a=void 0,u=void 0;;){if(!n){n=t.return;e:for(;;){switch(null===n&&r("160"),n.tag){case 5:a=n.stateNode,u=!1;break e;case 3:case 4:a=n.stateNode.containerInfo,u=!0;break e}n=n.return}n=!0}if(5===t.tag||6===t.tag)i(t),u?g(a,t.stateNode):b(a,t.stateNode);else if(4===t.tag?a=t.stateNode.containerInfo:o(t),null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return;t=t.return,4===t.tag&&(n=!1)}t.sibling.return=t.return,t=t.sibling}}var s=e.getPublicInstance,l=e.mutation;e=e.persistence,l||r(e?"235":"236");var c=l.commitMount,f=l.commitUpdate,d=l.resetTextContent,p=l.commitTextUpdate,h=l.appendChild,y=l.appendChildToContainer,v=l.insertBefore,m=l.insertInContainerBefore,b=l.removeChild,g=l.removeChildFromContainer;return{commitResetTextContent:function(e){d(e.stateNode)},commitPlacement:function(e){e:{for(var t=e.return;null!==t;){if(a(t)){var n=t;break e}t=t.return}r("160"),n=void 0}var o=t=void 0;switch(n.tag){case 5:t=n.stateNode,o=!1;break;case 3:case 4:t=n.stateNode.containerInfo,o=!0;break;default:r("161")}16&n.effectTag&&(d(t),n.effectTag&=-17);e:t:for(n=e;;){for(;null===n.sibling;){if(null===n.return||a(n.return)){n=null;break e}n=n.return}for(n.sibling.return=n.return,n=n.sibling;5!==n.tag&&6!==n.tag;){if(2&n.effectTag)continue t;if(null===n.child||4===n.tag)continue t;n.child.return=n,n=n.child}if(!(2&n.effectTag)){n=n.stateNode;break e}}for(var i=e;;){if(5===i.tag||6===i.tag)n?o?m(t,i.stateNode,n):v(t,i.stateNode,n):o?y(t,i.stateNode):h(t,i.stateNode);else if(4!==i.tag&&null!==i.child){i.child.return=i,i=i.child;continue}if(i===e)break;for(;null===i.sibling;){if(null===i.return||i.return===e)return;i=i.return}i.sibling.return=i.return,i=i.sibling}},commitDeletion:function(e){u(e),e.return=null,e.child=null,e.alternate&&(e.alternate.child=null,e.alternate.return=null)},commitWork:function(e,t){switch(t.tag){case 2:break;case 5:var n=t.stateNode;if(null!=n){var o=t.memoizedProps;e=null!==e?e.memoizedProps:o;var i=t.type,a=t.updateQueue;t.updateQueue=null,null!==a&&f(n,a,i,e,o,t)}break;case 6:null===t.stateNode&&r("162"),n=t.memoizedProps,p(t.stateNode,null!==e?e.memoizedProps:n,n);break;case 3:break;default:r("163")}},commitLifeCycles:function(e,t){switch(t.tag){case 2:var n=t.stateNode;if(4&t.effectTag)if(null===e)n.props=t.memoizedProps,n.state=t.memoizedState,n.componentDidMount();else{var o=e.memoizedProps;e=e.memoizedState,n.props=t.memoizedProps,n.state=t.memoizedState,n.componentDidUpdate(o,e)}t=t.updateQueue,null!==t&&xt(t,n);break;case 3:n=t.updateQueue,null!==n&&xt(n,null!==t.child?t.child.stateNode:null);break;case 5:n=t.stateNode,null===e&&4&t.effectTag&&c(n,t.type,t.memoizedProps,t);break;case 6:case 4:break;default:r("163")}},commitAttachRef:function(e){var t=e.ref;if(null!==t){var n=e.stateNode;switch(e.tag){case 5:t(s(n));break;default:t(n)}}},commitDetachRef:function(e){null!==(e=e.ref)&&e(null)}}}function jt(e){function t(e){return e===Po&&r("174"),e}var n=e.getChildHostContext,o=e.getRootHostContext,i={current:Po},a={current:Po},u={current:Po};return{getHostContext:function(){return t(i.current)},getRootHostContainer:function(){return t(u.current)},popHostContainer:function(e){Xe(i,e),Xe(a,e),Xe(u,e)},popHostContext:function(e){a.current===e&&(Xe(i,e),Xe(a,e))},pushHostContainer:function(e,t){$e(u,t,e),t=o(t),$e(a,e,e),$e(i,t,e)},pushHostContext:function(e){var r=t(u.current),o=t(i.current);r=n(o,e.type,r),o!==r&&($e(a,e,e),$e(i,r,e))},resetHostContainer:function(){i.current=Po,u.current=Po}}}function Nt(e){function t(e,t){var n=new it(5,null,0);n.type="DELETED",n.stateNode=t,n.return=e,n.effectTag=8,null!==e.lastEffect?(e.lastEffect.nextEffect=n,e.lastEffect=n):e.firstEffect=e.lastEffect=n}function n(e,t){switch(e.tag){case 5:return null!==(t=a(t,e.type,e.pendingProps))&&(e.stateNode=t,!0);case 6:return null!==(t=u(t,e.pendingProps))&&(e.stateNode=t,!0);default:return!1}}function o(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag;)e=e.return;d=e}var i=e.shouldSetTextContent;if(!(e=e.hydration))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){r("175")},prepareToHydrateHostTextInstance:function(){r("176")},popHydrationState:function(){return!1}};var a=e.canHydrateInstance,u=e.canHydrateTextInstance,s=e.getNextHydratableSibling,l=e.getFirstHydratableChild,c=e.hydrateInstance,f=e.hydrateTextInstance,d=null,p=null,h=!1;return{enterHydrationState:function(e){return p=l(e.stateNode.containerInfo),d=e,h=!0},resetHydrationState:function(){p=d=null,h=!1},tryToClaimNextHydratableInstance:function(e){if(h){var r=p;if(r){if(!n(e,r)){if(!(r=s(r))||!n(e,r))return e.effectTag|=2,h=!1,void(d=e);t(d,p)}d=e,p=l(r)}else e.effectTag|=2,h=!1,d=e}},prepareToHydrateHostInstance:function(e,t,n){return t=c(e.stateNode,e.type,e.memoizedProps,t,n,e),e.updateQueue=t,null!==t},prepareToHydrateHostTextInstance:function(e){return f(e.stateNode,e.memoizedProps,e)},popHydrationState:function(e){if(e!==d)return!1;if(!h)return o(e),h=!0,!1;var n=e.type;if(5!==e.tag||"head"!==n&&"body"!==n&&!i(n,e.memoizedProps))for(n=p;n;)t(e,n),n=s(n);return o(e),p=d?s(e.stateNode):null,!0}}}function It(e){function t(e){ie=X=!0;var t=e.stateNode;if(t.current===e&&r("177"),t.isReadyForCommit=!1,Ur.current=null,1<e.effectTag)if(null!==e.lastEffect){e.lastEffect.nextEffect=e;var n=e.firstEffect}else n=e;else n=e.firstEffect;for(B(),Z=n;null!==Z;){var o=!1,i=void 0;try{for(;null!==Z;){var a=Z.effectTag;if(16&a&&I(Z),128&a){var u=Z.alternate;null!==u&&z(u)}switch(-242&a){case 2:A(Z),Z.effectTag&=-3;break;case 6:A(Z),Z.effectTag&=-3,F(Z.alternate,Z);break;case 4:F(Z.alternate,Z);break;case 8:ae=!0,R(Z),ae=!1}Z=Z.nextEffect}}catch(e){o=!0,i=e}o&&(null===Z&&r("178"),s(Z,i),null!==Z&&(Z=Z.nextEffect))}for(K(),t.current=e,Z=n;null!==Z;){n=!1,o=void 0;try{for(;null!==Z;){var l=Z.effectTag;if(36&l&&D(Z.alternate,Z),128&l&&L(Z),64&l)switch(i=Z,a=void 0,null!==ee&&(a=ee.get(i),ee.delete(i),null==a&&null!==i.alternate&&(i=i.alternate,a=ee.get(i),ee.delete(i))),null==a&&r("184"),i.tag){case 2:i.stateNode.componentDidCatch(a.error,{componentStack:a.componentStack});break;case 3:null===re&&(re=a.error);break;default:r("157")}var c=Z.nextEffect;Z.nextEffect=null,Z=c}}catch(e){n=!0,o=e}n&&(null===Z&&r("178"),s(Z,o),null!==Z&&(Z=Z.nextEffect))}return X=ie=!1,"function"==typeof yt&&yt(e.stateNode),ne&&(ne.forEach(y),ne=null),null!==re&&(e=re,re=null,O(e)),t=t.current.expirationTime,0===t&&(te=ee=null),t}function n(e){for(;;){var t=N(e.alternate,e,J),n=e.return,r=e.sibling,o=e;if(2147483647===J||2147483647!==o.expirationTime){if(2!==o.tag&&3!==o.tag)var i=0;else i=o.updateQueue,i=null===i?0:i.expirationTime;for(var a=o.child;null!==a;)0!==a.expirationTime&&(0===i||i>a.expirationTime)&&(i=a.expirationTime),a=a.sibling;o.expirationTime=i}if(null!==t)return t;if(null!==n&&(null===n.firstEffect&&(n.firstEffect=e.firstEffect),null!==e.lastEffect&&(null!==n.lastEffect&&(n.lastEffect.nextEffect=e.firstEffect),n.lastEffect=e.lastEffect),1<e.effectTag&&(null!==n.lastEffect?n.lastEffect.nextEffect=e:n.firstEffect=e,n.lastEffect=e)),null!==r)return r;if(null===n){e.stateNode.isReadyForCommit=!0;break}e=n}return null}function o(e){var t=M(e.alternate,e,J);return null===t&&(t=n(e)),Ur.current=null,t}function i(e){var t=j(e.alternate,e,J);return null===t&&(t=n(e)),Ur.current=null,t}function a(e){if(null!==ee){if(!(0===J||J>e))if(J<=G)for(;null!==$;)$=l($)?i($):o($);else for(;null!==$&&!x();)$=l($)?i($):o($)}else if(!(0===J||J>e))if(J<=G)for(;null!==$;)$=o($);else for(;null!==$&&!x();)$=o($)}function u(e,t){if(X&&r("243"),X=!0,e.isReadyForCommit=!1,e!==Q||t!==J||null===$){for(;-1<po;)fo[po]=null,po--;vo=kn,ho.current=kn,yo.current=!1,k(),Q=e,J=t,$=at(Q.current,null,t)}var n=!1,o=null;try{a(t)}catch(e){n=!0,o=e}for(;n;){if(oe){re=o;break}var u=$;if(null===u)oe=!0;else{var l=s(u,o);if(null===l&&r("183"),!oe){try{for(n=l,o=t,l=n;null!==u;){switch(u.tag){case 2:et(u);break;case 5:C(u);break;case 3:E(u);break;case 4:E(u)}if(u===l||u.alternate===l)break;u=u.return}$=i(n),a(o)}catch(e){n=!0,o=e;continue}break}}}return t=re,oe=X=!1,re=null,null!==t&&O(t),e.isReadyForCommit?e.current.alternate:null}function s(e,t){var n=Ur.current=null,r=!1,o=!1,i=null;if(3===e.tag)n=e,c(e)&&(oe=!0);else for(var a=e.return;null!==a&&null===n;){if(2===a.tag?"function"==typeof a.stateNode.componentDidCatch&&(r=!0,i=we(a),n=a,o=!0):3===a.tag&&(n=a),c(a)){if(ae||null!==ne&&(ne.has(a)||null!==a.alternate&&ne.has(a.alternate)))return null;n=null,o=!1}a=a.return}if(null!==n){null===te&&(te=new Set),te.add(n);var u="";a=e;do{e:switch(a.tag){case 0:case 1:case 2:case 5:var s=a._debugOwner,l=a._debugSource,f=we(a),d=null;s&&(d=we(s)),s=l,f="\n    in "+(f||"Unknown")+(s?" (at "+s.fileName.replace(/^.*[\\\/]/,"")+":"+s.lineNumber+")":d?" (created by "+d+")":"");break e;default:f=""}u+=f,a=a.return}while(a);a=u,e=we(e),null===ee&&(ee=new Map),t={componentName:e,componentStack:a,error:t,errorBoundary:r?n.stateNode:null,errorBoundaryFound:r,errorBoundaryName:i,willRetry:o},ee.set(n,t);try{var p=t.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(e){e&&e.suppressReactErrorLogging||console.error(e)}return ie?(null===ne&&(ne=new Set),ne.add(n)):y(n),n}return null===re&&(re=t),null}function l(e){return null!==ee&&(ee.has(e)||null!==e.alternate&&ee.has(e.alternate))}function c(e){return null!==te&&(te.has(e)||null!==e.alternate&&te.has(e.alternate))}function f(){return 20*(1+((v()+100)/20|0))}function d(e){return 0!==Y?Y:X?ie?1:J:!H||1&e.internalContextTag?f():1}function p(e,t){return h(e,t,!1)}function h(e,t){for(;null!==e;){if((0===e.expirationTime||e.expirationTime>t)&&(e.expirationTime=t),null!==e.alternate&&(0===e.alternate.expirationTime||e.alternate.expirationTime>t)&&(e.alternate.expirationTime=t),null===e.return){if(3!==e.tag)break;var n=e.stateNode;!X&&n===Q&&t<J&&($=Q=null,J=0);var o=n,i=t;if(xe>_e&&r("185"),null===o.nextScheduledRoot)o.remainingExpirationTime=i,null===se?(ue=se=o,o.nextScheduledRoot=o):(se=se.nextScheduledRoot=o,se.nextScheduledRoot=ue);else{var a=o.remainingExpirationTime;(0===a||i<a)&&(o.remainingExpirationTime=i)}fe||(be?ge&&(de=o,pe=1,w(de,pe)):1===i?_(1,null):m(i)),!X&&n===Q&&t<J&&($=Q=null,J=0)}e=e.return}}function y(e){h(e,1,!0)}function v(){return G=2+((V()-q)/10|0)}function m(e){if(0!==le){if(e>le)return;W(ce)}var t=V()-q;le=e,ce=U(g,{timeout:10*(e-2)-t})}function b(){var e=0,t=null;if(null!==se)for(var n=se,o=ue;null!==o;){var i=o.remainingExpirationTime;if(0===i){if((null===n||null===se)&&r("244"),o===o.nextScheduledRoot){ue=se=o.nextScheduledRoot=null;break}if(o===ue)ue=i=o.nextScheduledRoot,se.nextScheduledRoot=i,o.nextScheduledRoot=null;else{if(o===se){se=n,se.nextScheduledRoot=ue,o.nextScheduledRoot=null;break}n.nextScheduledRoot=o.nextScheduledRoot,o.nextScheduledRoot=null}o=n.nextScheduledRoot}else{if((0===e||i<e)&&(e=i,t=o),o===se)break;n=o,o=o.nextScheduledRoot}}n=de,null!==n&&n===t?xe++:xe=0,de=t,pe=e}function g(e){_(0,e)}function _(e,t){for(me=t,b();null!==de&&0!==pe&&(0===e||pe<=e)&&!he;)w(de,pe),b();if(null!==me&&(le=0,ce=-1),0!==pe&&m(pe),me=null,he=!1,xe=0,ye)throw e=ve,ve=null,ye=!1,e}function w(e,n){if(fe&&r("245"),fe=!0,n<=v()){var o=e.finishedWork;null!==o?(e.finishedWork=null,e.remainingExpirationTime=t(o)):(e.finishedWork=null,null!==(o=u(e,n))&&(e.remainingExpirationTime=t(o)))}else o=e.finishedWork,null!==o?(e.finishedWork=null,e.remainingExpirationTime=t(o)):(e.finishedWork=null,null!==(o=u(e,n))&&(x()?e.finishedWork=o:e.remainingExpirationTime=t(o)));fe=!1}function x(){return!(null===me||me.timeRemaining()>Oe)&&(he=!0)}function O(e){null===de&&r("246"),de.remainingExpirationTime=0,ye||(ye=!0,ve=e)}var S=jt(e),T=Nt(e),E=S.popHostContainer,C=S.popHostContext,k=S.resetHostContainer,P=kt(e,S,T,p,d),M=P.beginWork,j=P.beginFailedWork,N=Pt(e,S,T).completeWork;S=Mt(e,s);var I=S.commitResetTextContent,A=S.commitPlacement,R=S.commitDeletion,F=S.commitWork,D=S.commitLifeCycles,L=S.commitAttachRef,z=S.commitDetachRef,V=e.now,U=e.scheduleDeferredCallback,W=e.cancelDeferredCallback,H=e.useSyncScheduling,B=e.prepareForCommit,K=e.resetAfterCommit,q=V(),G=2,Y=0,X=!1,$=null,Q=null,J=0,Z=null,ee=null,te=null,ne=null,re=null,oe=!1,ie=!1,ae=!1,ue=null,se=null,le=0,ce=-1,fe=!1,de=null,pe=0,he=!1,ye=!1,ve=null,me=null,be=!1,ge=!1,_e=1e3,xe=0,Oe=1;return{computeAsyncExpiration:f,computeExpirationForFiber:d,scheduleWork:p,batchedUpdates:function(e,t){var n=be;be=!0;try{return e(t)}finally{(be=n)||fe||_(1,null)}},unbatchedUpdates:function(e){if(be&&!ge){ge=!0;try{return e()}finally{ge=!1}}return e()},flushSync:function(e){var t=be;be=!0;try{e:{var n=Y;Y=1;try{var o=e();break e}finally{Y=n}o=void 0}return o}finally{be=t,fe&&r("187"),_(1,null)}},deferredUpdates:function(e){var t=Y;Y=f();try{return e()}finally{Y=t}}}}function At(e){function t(e){return e=Ee(e),null===e?null:e.stateNode}var n=e.getPublicInstance;e=It(e);var o=e.computeAsyncExpiration,i=e.computeExpirationForFiber,a=e.scheduleWork;return{createContainer:function(e,t){var n=new it(3,null,0);return e={current:n,containerInfo:e,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:t,nextScheduledRoot:null},n.stateNode=e},updateContainer:function(e,t,n,u){var s=t.current;if(n){n=n._reactInternalFiber;var l;e:{for(2===xe(n)&&2===n.tag||r("170"),l=n;3!==l.tag;){if(Ze(l)){l=l.stateNode.__reactInternalMemoizedMergedChildContext;break e}(l=l.return)||r("171")}l=l.stateNode.context}n=Ze(n)?nt(n,l):l}else n=kn;null===t.context?t.context=n:t.pendingContext=n,t=u,t=void 0===t?null:t,u=null!=e&&null!=e.type&&null!=e.type.prototype&&!0===e.type.prototype.unstable_isAsyncReactComponent?o():i(s),gt(s,{expirationTime:u,partialState:{element:e},callback:t,isReplace:!1,isForced:!1,nextCallback:null,next:null}),a(s,u)},batchedUpdates:e.batchedUpdates,unbatchedUpdates:e.unbatchedUpdates,deferredUpdates:e.deferredUpdates,flushSync:e.flushSync,getPublicRootInstance:function(e){if(e=e.current,!e.child)return null;switch(e.child.tag){case 5:return n(e.child.stateNode);default:return e.child.stateNode}},findHostInstance:t,findHostInstanceWithNoPortals:function(e){return e=Ce(e),null===e?null:e.stateNode},injectIntoDevTools:function(e){var n=e.findFiberByHostInstance;return ht(wn({},e,{findHostInstanceByFiber:function(e){return t(e)},findFiberByHostInstance:function(e){return n?n(e):null}}))}}}function Rt(e,t,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Oo,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}function Ft(e){return!!Xo.hasOwnProperty(e)||!Yo.hasOwnProperty(e)&&(Go.test(e)?Xo[e]=!0:(Yo[e]=!0,!1))}function Dt(e,t,n){var r=a(t);if(r&&i(t,n)){var o=r.mutationMethod;o?o(e,n):null==n||r.hasBooleanValue&&!n||r.hasNumericValue&&isNaN(n)||r.hasPositiveNumericValue&&1>n||r.hasOverloadedBooleanValue&&!1===n?zt(e,t):r.mustUseProperty?e[r.propertyName]=n:(t=r.attributeName,(o=r.attributeNamespace)?e.setAttributeNS(o,t,""+n):r.hasBooleanValue||r.hasOverloadedBooleanValue&&!0===n?e.setAttribute(t,""):e.setAttribute(t,""+n))}else Lt(e,t,i(t,n)?n:null)}function Lt(e,t,n){Ft(t)&&(null==n?e.removeAttribute(t):e.setAttribute(t,""+n))}function zt(e,t){var n=a(t);n?(t=n.mutationMethod)?t(e,void 0):n.mustUseProperty?e[n.propertyName]=!n.hasBooleanValue&&"":e.removeAttribute(n.attributeName):e.removeAttribute(t)}function Vt(e,t){var n=t.value,r=t.checked;return wn({type:void 0,step:void 0,min:void 0,max:void 0},t,{defaultChecked:void 0,defaultValue:void 0,value:null!=n?n:e._wrapperState.initialValue,checked:null!=r?r:e._wrapperState.initialChecked})}function Ut(e,t){var n=t.defaultValue;e._wrapperState={initialChecked:null!=t.checked?t.checked:t.defaultChecked,initialValue:null!=t.value?t.value:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value}}function Wt(e,t){null!=(t=t.checked)&&Dt(e,"checked",t)}function Ht(e,t){Wt(e,t);var n=t.value;null!=n?0===n&&""===e.value?e.value="0":"number"===t.type?(t=parseFloat(e.value)||0,(n!=t||n==t&&e.value!=n)&&(e.value=""+n)):e.value!==""+n&&(e.value=""+n):(null==t.value&&null!=t.defaultValue&&e.defaultValue!==""+t.defaultValue&&(e.defaultValue=""+t.defaultValue),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked))}function Bt(e,t){switch(t.type){case"submit":case"reset":break;case"color":case"date":case"datetime":case"datetime-local":case"month":case"time":case"week":e.value="",e.value=e.defaultValue;break;default:e.value=e.value}t=e.name,""!==t&&(e.name=""),e.defaultChecked=!e.defaultChecked,e.defaultChecked=!e.defaultChecked,""!==t&&(e.name=t)}function Kt(e){var t="";return gn.Children.forEach(e,function(e){null==e||"string"!=typeof e&&"number"!=typeof e||(t+=e)}),t}function qt(e,t){return e=wn({children:void 0},t),(t=Kt(t.children))&&(e.children=t),e}function Gt(e,t,n,r){if(e=e.options,t){t={};for(var o=0;o<n.length;o++)t["$"+n[o]]=!0;for(n=0;n<e.length;n++)o=t.hasOwnProperty("$"+e[n].value),e[n].selected!==o&&(e[n].selected=o),o&&r&&(e[n].defaultSelected=!0)}else{for(n=""+n,t=null,o=0;o<e.length;o++){if(e[o].value===n)return e[o].selected=!0,void(r&&(e[o].defaultSelected=!0));null!==t||e[o].disabled||(t=e[o])}null!==t&&(t.selected=!0)}}function Yt(e,t){var n=t.value;e._wrapperState={initialValue:null!=n?n:t.defaultValue,wasMultiple:!!t.multiple}}function Xt(e,t){return null!=t.dangerouslySetInnerHTML&&r("91"),wn({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function $t(e,t){var n=t.value;null==n&&(n=t.defaultValue,t=t.children,null!=t&&(null!=n&&r("92"),Array.isArray(t)&&(1>=t.length||r("93"),t=t[0]),n=""+t),null==n&&(n="")),e._wrapperState={initialValue:""+n}}function Qt(e,t){var n=t.value;null!=n&&(n=""+n,n!==e.value&&(e.value=n),null==t.defaultValue&&(e.defaultValue=n)),null!=t.defaultValue&&(e.defaultValue=t.defaultValue)}function Jt(e){var t=e.textContent;t===e._wrapperState.initialValue&&(e.value=t)}function Zt(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function en(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?Zt(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}function tn(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t}function nn(e,t){e=e.style;for(var n in t)if(t.hasOwnProperty(n)){var r=0===n.indexOf("--"),o=n,i=t[n];o=null==i||"boolean"==typeof i||""===i?"":r||"number"!=typeof i||0===i||Zo.hasOwnProperty(o)&&Zo[o]?(""+i).trim():i+"px","float"===n&&(n="cssFloat"),r?e.setProperty(n,o):e[n]=o}}function rn(e,t,n){t&&(ti[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML)&&r("137",e,n()),null!=t.dangerouslySetInnerHTML&&(null!=t.children&&r("60"),"object"==typeof t.dangerouslySetInnerHTML&&"__html"in t.dangerouslySetInnerHTML||r("61")),null!=t.style&&"object"!=typeof t.style&&r("62",n()))}function on(e,t){if(-1===e.indexOf("-"))return"string"==typeof t.is;switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}function an(e,t){e=9===e.nodeType||11===e.nodeType?e:e.ownerDocument;var n=Re(e);t=$n[t];for(var r=0;r<t.length;r++){var o=t[r];n.hasOwnProperty(o)&&n[o]||("topScroll"===o?je("topScroll","scroll",e):"topFocus"===o||"topBlur"===o?(je("topFocus","focus",e),je("topBlur","blur",e),n.topBlur=!0,n.topFocus=!0):"topCancel"===o?(ne("cancel",!0)&&je("topCancel","cancel",e),n.topCancel=!0):"topClose"===o?(ne("close",!0)&&je("topClose","close",e),n.topClose=!0):Xr.hasOwnProperty(o)&&Me(o,Xr[o],e),n[o]=!0)}}function un(e,t,n,r){return n=9===n.nodeType?n:n.ownerDocument,r===ni&&(r=Zt(e)),r===ni?"script"===e?(e=n.createElement("div"),e.innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):e="string"==typeof t.is?n.createElement(e,{is:t.is}):n.createElement(e):e=n.createElementNS(r,e),e}function sn(e,t){return(9===t.nodeType?t:t.ownerDocument).createTextNode(e)}function ln(e,t,n,r){var o=on(t,n);switch(t){case"iframe":case"object":Me("topLoad","load",e);var i=n;break;case"video":case"audio":for(i in oi)oi.hasOwnProperty(i)&&Me(i,oi[i],e);i=n;break;case"source":Me("topError","error",e),i=n;break;case"img":case"image":Me("topError","error",e),Me("topLoad","load",e),i=n;break;case"form":Me("topReset","reset",e),Me("topSubmit","submit",e),i=n;break;case"details":Me("topToggle","toggle",e),i=n;break;case"input":Ut(e,n),i=Vt(e,n),Me("topInvalid","invalid",e),an(r,"onChange");break;case"option":i=qt(e,n);break;case"select":Yt(e,n),i=wn({},n,{value:void 0}),Me("topInvalid","invalid",e),an(r,"onChange");break;case"textarea":$t(e,n),i=Xt(e,n),Me("topInvalid","invalid",e),an(r,"onChange");break;default:i=n}rn(t,i,ri);var a,u=i;for(a in u)if(u.hasOwnProperty(a)){var s=u[a];"style"===a?nn(e,s,ri):"dangerouslySetInnerHTML"===a?null!=(s=s?s.__html:void 0)&&Jo(e,s):"children"===a?"string"==typeof s?("textarea"!==t||""!==s)&&tn(e,s):"number"==typeof s&&tn(e,""+s):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(Xn.hasOwnProperty(a)?null!=s&&an(r,a):o?Lt(e,a,s):null!=s&&Dt(e,a,s))}switch(t){case"input":ie(e),Bt(e,n);break;case"textarea":ie(e),Jt(e,n);break;case"option":null!=n.value&&e.setAttribute("value",n.value);break;case"select":e.multiple=!!n.multiple,t=n.value,null!=t?Gt(e,!!n.multiple,t,!1):null!=n.defaultValue&&Gt(e,!!n.multiple,n.defaultValue,!0);break;default:"function"==typeof i.onClick&&(e.onclick=xn)}}function cn(e,t,n,r,o){var i=null;switch(t){case"input":n=Vt(e,n),r=Vt(e,r),i=[];break;case"option":n=qt(e,n),r=qt(e,r),i=[];break;case"select":n=wn({},n,{value:void 0}),r=wn({},r,{value:void 0}),i=[];break;case"textarea":n=Xt(e,n),r=Xt(e,r),i=[];break;default:"function"!=typeof n.onClick&&"function"==typeof r.onClick&&(e.onclick=xn)}rn(t,r,ri);var a,u;e=null;for(a in n)if(!r.hasOwnProperty(a)&&n.hasOwnProperty(a)&&null!=n[a])if("style"===a)for(u in t=n[a])t.hasOwnProperty(u)&&(e||(e={}),e[u]="");else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(Xn.hasOwnProperty(a)?i||(i=[]):(i=i||[]).push(a,null));for(a in r){var s=r[a];if(t=null!=n?n[a]:void 0,r.hasOwnProperty(a)&&s!==t&&(null!=s||null!=t))if("style"===a)if(t){for(u in t)!t.hasOwnProperty(u)||s&&s.hasOwnProperty(u)||(e||(e={}),e[u]="");for(u in s)s.hasOwnProperty(u)&&t[u]!==s[u]&&(e||(e={}),e[u]=s[u])}else e||(i||(i=[]),i.push(a,e)),e=s;else"dangerouslySetInnerHTML"===a?(s=s?s.__html:void 0,t=t?t.__html:void 0,null!=s&&t!==s&&(i=i||[]).push(a,""+s)):"children"===a?t===s||"string"!=typeof s&&"number"!=typeof s||(i=i||[]).push(a,""+s):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(Xn.hasOwnProperty(a)?(null!=s&&an(o,a),i||t===s||(i=[])):(i=i||[]).push(a,s))}return e&&(i=i||[]).push("style",e),i}function fn(e,t,n,r,o){"input"===n&&"radio"===o.type&&null!=o.name&&Wt(e,o),on(n,r),r=on(n,o);for(var i=0;i<t.length;i+=2){var a=t[i],u=t[i+1];"style"===a?nn(e,u,ri):"dangerouslySetInnerHTML"===a?Jo(e,u):"children"===a?tn(e,u):r?null!=u?Lt(e,a,u):e.removeAttribute(a):null!=u?Dt(e,a,u):zt(e,a)}switch(n){case"input":Ht(e,o);break;case"textarea":Qt(e,o);break;case"select":e._wrapperState.initialValue=void 0,t=e._wrapperState.wasMultiple,e._wrapperState.wasMultiple=!!o.multiple,n=o.value,null!=n?Gt(e,!!o.multiple,n,!1):t!==!!o.multiple&&(null!=o.defaultValue?Gt(e,!!o.multiple,o.defaultValue,!0):Gt(e,!!o.multiple,o.multiple?[]:"",!1))}}function dn(e,t,n,r,o){switch(t){case"iframe":case"object":Me("topLoad","load",e);break;case"video":case"audio":for(var i in oi)oi.hasOwnProperty(i)&&Me(i,oi[i],e);break;case"source":Me("topError","error",e);break;case"img":case"image":Me("topError","error",e),Me("topLoad","load",e);break;case"form":Me("topReset","reset",e),Me("topSubmit","submit",e);break;case"details":Me("topToggle","toggle",e);break;case"input":Ut(e,n),Me("topInvalid","invalid",e),an(o,"onChange");break;case"select":Yt(e,n),Me("topInvalid","invalid",e),an(o,"onChange");break;case"textarea":$t(e,n),Me("topInvalid","invalid",e),an(o,"onChange")}rn(t,n,ri),r=null;for(var a in n)n.hasOwnProperty(a)&&(i=n[a],"children"===a?"string"==typeof i?e.textContent!==i&&(r=["children",i]):"number"==typeof i&&e.textContent!==""+i&&(r=["children",""+i]):Xn.hasOwnProperty(a)&&null!=i&&an(o,a));switch(t){case"input":ie(e),Bt(e,n);break;case"textarea":ie(e),Jt(e,n);break;case"select":case"option":break;default:"function"==typeof n.onClick&&(e.onclick=xn)}return r}function pn(e,t){return e.nodeValue!==t}function hn(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function yn(e){return!(!(e=e?9===e.nodeType?e.documentElement:e.firstChild:null)||1!==e.nodeType||!e.hasAttribute("data-reactroot"))}function vn(e,t,n,o,i){hn(n)||r("200");var a=n._reactRootContainer;if(a)si.updateContainer(t,a,e,i);else{if(!(o=o||yn(n)))for(a=void 0;a=n.lastChild;)n.removeChild(a);var u=si.createContainer(n,o);a=n._reactRootContainer=u,si.unbatchedUpdates(function(){si.updateContainer(t,u,e,i)})}return si.getPublicRootInstance(a)}function mn(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;return hn(t)||r("200"),Rt(e,t,null,n)}function bn(e,t){this._reactRootContainer=si.createContainer(e,t)}/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gn=n(0),_n=n(301),wn=n(302),xn=n(64),On=n(303),Sn=n(304),Tn=n(92),En=n(305),Cn=n(308),kn=n(309);gn||r("227");var Pn={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0},Mn={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(e){var t=Mn,n=e.Properties||{},i=e.DOMAttributeNamespaces||{},a=e.DOMAttributeNames||{};e=e.DOMMutationMethods||{};for(var u in n){jn.hasOwnProperty(u)&&r("48",u);var s=u.toLowerCase(),l=n[u];s={attributeName:s,attributeNamespace:null,propertyName:u,mutationMethod:null,mustUseProperty:o(l,t.MUST_USE_PROPERTY),hasBooleanValue:o(l,t.HAS_BOOLEAN_VALUE),hasNumericValue:o(l,t.HAS_NUMERIC_VALUE),hasPositiveNumericValue:o(l,t.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:o(l,t.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:o(l,t.HAS_STRING_BOOLEAN_VALUE)},1>=s.hasBooleanValue+s.hasNumericValue+s.hasOverloadedBooleanValue||r("50",u),a.hasOwnProperty(u)&&(s.attributeName=a[u]),i.hasOwnProperty(u)&&(s.attributeNamespace=i[u]),e.hasOwnProperty(u)&&(s.mutationMethod=e[u]),jn[u]=s}}},jn={},Nn=Mn,In=Nn.MUST_USE_PROPERTY,An=Nn.HAS_BOOLEAN_VALUE,Rn=Nn.HAS_NUMERIC_VALUE,Fn=Nn.HAS_POSITIVE_NUMERIC_VALUE,Dn=Nn.HAS_OVERLOADED_BOOLEAN_VALUE,Ln=Nn.HAS_STRING_BOOLEAN_VALUE,zn={Properties:{allowFullScreen:An,async:An,autoFocus:An,autoPlay:An,capture:Dn,checked:In|An,cols:Fn,contentEditable:Ln,controls:An,default:An,defer:An,disabled:An,download:Dn,draggable:Ln,formNoValidate:An,hidden:An,loop:An,multiple:In|An,muted:In|An,noValidate:An,open:An,playsInline:An,readOnly:An,required:An,reversed:An,rows:Fn,rowSpan:Rn,scoped:An,seamless:An,selected:In|An,size:Fn,start:Rn,span:Fn,spellCheck:Ln,style:0,tabIndex:0,itemScope:An,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ln},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(e,t){if(null==t)return e.removeAttribute("value");"number"!==e.type||!1===e.hasAttribute("value")?e.setAttribute("value",""+t):e.validity&&!e.validity.badInput&&e.ownerDocument.activeElement!==e&&e.setAttribute("value",""+t)}}},Vn=Nn.HAS_STRING_BOOLEAN_VALUE,Un={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Wn={Properties:{autoReverse:Vn,externalResourcesRequired:Vn,preserveAlpha:Vn},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:Un.xlink,xlinkArcrole:Un.xlink,xlinkHref:Un.xlink,xlinkRole:Un.xlink,xlinkShow:Un.xlink,xlinkTitle:Un.xlink,xlinkType:Un.xlink,xmlBase:Un.xml,xmlLang:Un.xml,xmlSpace:Un.xml}},Hn=/[\-\:]([a-z])/g;"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(e){var t=e.replace(Hn,u);Wn.Properties[t]=0,Wn.DOMAttributeNames[t]=e}),Nn.injectDOMPropertyConfig(zn),Nn.injectDOMPropertyConfig(Wn);var Bn={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(e){"function"!=typeof e.invokeGuardedCallback&&r("197"),s=e.invokeGuardedCallback}},invokeGuardedCallback:function(e,t,n,r,o,i,a,u,l){s.apply(Bn,arguments)},invokeGuardedCallbackAndCatchFirstError:function(e,t,n,r,o,i,a,u,s){if(Bn.invokeGuardedCallback.apply(this,arguments),Bn.hasCaughtError()){var l=Bn.clearCaughtError();Bn._hasRethrowError||(Bn._hasRethrowError=!0,Bn._rethrowError=l)}},rethrowCaughtError:function(){return l.apply(Bn,arguments)},hasCaughtError:function(){return Bn._hasCaughtError},clearCaughtError:function(){if(Bn._hasCaughtError){var e=Bn._caughtError;return Bn._caughtError=null,Bn._hasCaughtError=!1,e}r("198")}},Kn=null,qn={},Gn=[],Yn={},Xn={},$n={},Qn=Object.freeze({plugins:Gn,eventNameDispatchConfigs:Yn,registrationNameModules:Xn,registrationNameDependencies:$n,possibleRegistrationNames:null,injectEventPluginOrder:d,injectEventPluginsByName:p}),Jn=null,Zn=null,er=null,tr=null,nr={injectEventPluginOrder:d,injectEventPluginsByName:p},rr=Object.freeze({injection:nr,getListener:_,extractEvents:w,enqueueEvents:x,processEventQueue:O}),or=Math.random().toString(36).slice(2),ir="__reactInternalInstance$"+or,ar="__reactEventHandlers$"+or,ur=Object.freeze({precacheFiberNode:function(e,t){t[ir]=e},getClosestInstanceFromNode:S,getInstanceFromNode:function(e){return e=e[ir],!e||5!==e.tag&&6!==e.tag?null:e},getNodeFromInstance:T,getFiberCurrentPropsFromNode:E,updateFiberProps:function(e,t){e[ar]=t}}),sr=Object.freeze({accumulateTwoPhaseDispatches:A,accumulateTwoPhaseDispatchesSkipTarget:function(e){v(e,j)},accumulateEnterLeaveDispatches:R,accumulateDirectDispatches:function(e){v(e,I)}}),lr=null,cr={_root:null,_startText:null,_fallbackText:null},fr="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),dr={type:null,target:null,currentTarget:xn.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};wn(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=xn.thatReturnsTrue)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=xn.thatReturnsTrue)},persist:function(){this.isPersistent=xn.thatReturnsTrue},isPersistent:xn.thatReturnsFalse,destructor:function(){var e,t=this.constructor.Interface;for(e in t)this[e]=null;for(t=0;t<fr.length;t++)this[fr[t]]=null}}),z.Interface=dr,z.augmentClass=function(e,t){function n(){}n.prototype=this.prototype;var r=new n;wn(r,e.prototype),e.prototype=r,e.prototype.constructor=e,e.Interface=wn({},this.Interface,t),e.augmentClass=this.augmentClass,W(e)},W(z),z.augmentClass(H,{data:null}),z.augmentClass(B,{data:null});var pr=[9,13,27,32],hr=_n.canUseDOM&&"CompositionEvent"in window,yr=null;_n.canUseDOM&&"documentMode"in document&&(yr=document.documentMode);var vr;if(vr=_n.canUseDOM&&"TextEvent"in window&&!yr){var mr=window.opera;vr=!("object"==typeof mr&&"function"==typeof mr.version&&12>=parseInt(mr.version(),10))}var br,gr=vr,_r=_n.canUseDOM&&(!hr||yr&&8<yr&&11>=yr),wr=String.fromCharCode(32),xr={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Or=!1,Sr=!1,Tr={eventTypes:xr,extractEvents:function(e,t,n,r){var o;if(hr)e:{switch(e){case"topCompositionStart":var i=xr.compositionStart;break e;case"topCompositionEnd":i=xr.compositionEnd;break e;case"topCompositionUpdate":i=xr.compositionUpdate;break e}i=void 0}else Sr?K(e,n)&&(i=xr.compositionEnd):"topKeyDown"===e&&229===n.keyCode&&(i=xr.compositionStart);return i?(_r&&(Sr||i!==xr.compositionStart?i===xr.compositionEnd&&Sr&&(o=D()):(cr._root=r,cr._startText=L(),Sr=!0)),i=H.getPooled(i,t,n,r),o?i.data=o:null!==(o=q(n))&&(i.data=o),A(i),o=i):o=null,(e=gr?G(e,n):Y(e,n))?(t=B.getPooled(xr.beforeInput,t,n,r),t.data=e,A(t)):t=null,[o,t]}},Er=null,Cr=null,kr=null,Pr={injectFiberControlledHostComponent:function(e){Er=e}},Mr=Object.freeze({injection:Pr,enqueueStateRestore:$,restoreStateIfNeeded:Q}),jr=!1,Nr={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};_n.canUseDOM&&(br=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));var Ir={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}},Ar=null,Rr=null,Fr=!1;_n.canUseDOM&&(Fr=ne("input")&&(!document.documentMode||9<document.documentMode));var Dr={eventTypes:Ir,_isInputEventSupported:Fr,extractEvents:function(e,t,n,r){var o=t?T(t):window,i=o.nodeName&&o.nodeName.toLowerCase();if("select"===i||"input"===i&&"file"===o.type)var a=ce;else if(ee(o))if(Fr)a=ve;else{a=he;var u=pe}else!(i=o.nodeName)||"input"!==i.toLowerCase()||"checkbox"!==o.type&&"radio"!==o.type||(a=ye);if(a&&(a=a(e,t)))return ue(a,n,r);u&&u(e,o,t),"topBlur"===e&&null!=t&&(e=t._wrapperState||o._wrapperState)&&e.controlled&&"number"===o.type&&(e=""+o.value,o.getAttribute("value")!==e&&o.setAttribute("value",e))}};z.augmentClass(me,{view:null,detail:null});var Lr={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};me.augmentClass(_e,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ge,button:null,buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)}});var zr={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Vr={eventTypes:zr,extractEvents:function(e,t,n,r){if("topMouseOver"===e&&(n.relatedTarget||n.fromElement)||"topMouseOut"!==e&&"topMouseOver"!==e)return null;var o=r.window===r?r:(o=r.ownerDocument)?o.defaultView||o.parentWindow:window;if("topMouseOut"===e?(e=t,t=(t=n.relatedTarget||n.toElement)?S(t):null):e=null,e===t)return null;var i=null==e?o:T(e);o=null==t?o:T(t);var a=_e.getPooled(zr.mouseLeave,e,n,r);return a.type="mouseleave",a.target=i,a.relatedTarget=o,n=_e.getPooled(zr.mouseEnter,t,n,r),n.type="mouseenter",n.target=o,n.relatedTarget=i,R(a,n,e,t),[a,n]}},Ur=gn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,Wr=[],Hr=!0,Br=void 0,Kr=Object.freeze({get _enabled(){return Hr},get _handleTopLevel(){return Br},setHandleTopLevel:function(e){Br=e},setEnabled:Pe,isEnabled:function(){return Hr},trapBubbledEvent:Me,trapCapturedEvent:je,dispatchEvent:Ne}),qr={animationend:Ie("Animation","AnimationEnd"),animationiteration:Ie("Animation","AnimationIteration"),animationstart:Ie("Animation","AnimationStart"),transitionend:Ie("Transition","TransitionEnd")},Gr={},Yr={};_n.canUseDOM&&(Yr=document.createElement("div").style,"AnimationEvent"in window||(delete qr.animationend.animation,delete qr.animationiteration.animation,delete qr.animationstart.animation),"TransitionEvent"in window||delete qr.transitionend.transition);var Xr={topAbort:"abort",topAnimationEnd:Ae("animationend")||"animationend",topAnimationIteration:Ae("animationiteration")||"animationiteration",topAnimationStart:Ae("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",topTouchStart:"touchstart",topTransitionEnd:Ae("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},$r={},Qr=0,Jr="_reactListenersID"+(""+Math.random()).slice(2),Zr=_n.canUseDOM&&"documentMode"in document&&11>=document.documentMode,eo={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},to=null,no=null,ro=null,oo=!1,io={eventTypes:eo,extractEvents:function(e,t,n,r){var o,i=r.window===r?r.document:9===r.nodeType?r:r.ownerDocument;if(!(o=!i)){e:{i=Re(i),o=$n.onSelect;for(var a=0;a<o.length;a++){var u=o[a];if(!i.hasOwnProperty(u)||!i[u]){i=!1;break e}}i=!0}o=!i}if(o)return null;switch(i=t?T(t):window,e){case"topFocus":(ee(i)||"true"===i.contentEditable)&&(to=i,no=t,ro=null);break;case"topBlur":ro=no=to=null;break;case"topMouseDown":oo=!0;break;case"topContextMenu":case"topMouseUp":return oo=!1,ze(n,r);case"topSelectionChange":if(Zr)break;case"topKeyDown":case"topKeyUp":return ze(n,r)}return null}};z.augmentClass(Ve,{animationName:null,elapsedTime:null,pseudoElement:null}),z.augmentClass(Ue,{clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),me.augmentClass(We,{relatedTarget:null});var ao={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},uo={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};me.augmentClass(Be,{key:function(e){if(e.key){var t=ao[e.key]||e.key;if("Unidentified"!==t)return t}return"keypress"===e.type?(e=He(e),13===e?"Enter":String.fromCharCode(e)):"keydown"===e.type||"keyup"===e.type?uo[e.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ge,charCode:function(e){return"keypress"===e.type?He(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?He(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),_e.augmentClass(Ke,{dataTransfer:null}),me.augmentClass(qe,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ge}),z.augmentClass(Ge,{propertyName:null,elapsedTime:null,pseudoElement:null}),_e.augmentClass(Ye,{deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null});var so={},lo={};"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(e){var t=e[0].toUpperCase()+e.slice(1),n="on"+t;t="top"+t,n={phasedRegistrationNames:{bubbled:n,captured:n+"Capture"},dependencies:[t]},so[e]=n,lo[t]=n});var co={eventTypes:so,extractEvents:function(e,t,n,r){var o=lo[e];if(!o)return null;switch(e){case"topKeyPress":if(0===He(n))return null;case"topKeyDown":case"topKeyUp":e=Be;break;case"topBlur":case"topFocus":e=We;break;case"topClick":if(2===n.button)return null;case"topDoubleClick":case"topMouseDown":case"topMouseMove":case"topMouseUp":case"topMouseOut":case"topMouseOver":case"topContextMenu":e=_e;break;case"topDrag":case"topDragEnd":case"topDragEnter":case"topDragExit":case"topDragLeave":case"topDragOver":case"topDragStart":case"topDrop":e=Ke;break;case"topTouchCancel":case"topTouchEnd":case"topTouchMove":case"topTouchStart":e=qe;break;case"topAnimationEnd":case"topAnimationIteration":case"topAnimationStart":e=Ve;break;case"topTransitionEnd":e=Ge;break;case"topScroll":e=me;break;case"topWheel":e=Ye;break;case"topCopy":case"topCut":case"topPaste":e=Ue;break;default:e=z}return t=e.getPooled(o,t,n,r),A(t),t}};Br=function(e,t,n,r){e=w(e,t,n,r),x(e),O(!1)},nr.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")),Jn=ur.getFiberCurrentPropsFromNode,Zn=ur.getInstanceFromNode,er=ur.getNodeFromInstance,nr.injectEventPluginsByName({SimpleEventPlugin:co,EnterLeaveEventPlugin:Vr,ChangeEventPlugin:Dr,SelectEventPlugin:io,BeforeInputEventPlugin:Tr});var fo=[],po=-1;new Set;var ho={current:kn},yo={current:!1},vo=kn,mo=null,bo=null,go="function"==typeof Symbol&&Symbol.for,_o=go?Symbol.for("react.element"):60103,wo=go?Symbol.for("react.call"):60104,xo=go?Symbol.for("react.return"):60105,Oo=go?Symbol.for("react.portal"):60106,So=go?Symbol.for("react.fragment"):60107,To="function"==typeof Symbol&&Symbol.iterator,Eo=Array.isArray,Co=Ct(!0),ko=Ct(!1),Po={},Mo=Object.freeze({default:At}),jo=Mo&&At||Mo,No=jo.default?jo.default:jo,Io="object"==typeof performance&&"function"==typeof performance.now,Ao=void 0;Ao=Io?function(){return performance.now()}:function(){return Date.now()};var Ro=void 0,Fo=void 0;if(_n.canUseDOM)if("function"!=typeof requestIdleCallback||"function"!=typeof cancelIdleCallback){var Do,Lo=null,zo=!1,Vo=-1,Uo=!1,Wo=0,Ho=33,Bo=33;Do=Io?{didTimeout:!1,timeRemaining:function(){var e=Wo-performance.now();return 0<e?e:0}}:{didTimeout:!1,timeRemaining:function(){var e=Wo-Date.now();return 0<e?e:0}};var Ko="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(e){if(e.source===window&&e.data===Ko){if(zo=!1,e=Ao(),0>=Wo-e){if(!(-1!==Vo&&Vo<=e))return void(Uo||(Uo=!0,requestAnimationFrame(qo)));Do.didTimeout=!0}else Do.didTimeout=!1;Vo=-1,e=Lo,Lo=null,null!==e&&e(Do)}},!1);var qo=function(e){Uo=!1;var t=e-Wo+Bo;t<Bo&&Ho<Bo?(8>t&&(t=8),Bo=t<Ho?Ho:t):Ho=t,Wo=e+Bo,zo||(zo=!0,window.postMessage(Ko,"*"))};Ro=function(e,t){return Lo=e,null!=t&&"number"==typeof t.timeout&&(Vo=Ao()+t.timeout),Uo||(Uo=!0,requestAnimationFrame(qo)),0},Fo=function(){Lo=null,zo=!1,Vo=-1}}else Ro=window.requestIdleCallback,Fo=window.cancelIdleCallback;else Ro=function(e){return setTimeout(function(){e({timeRemaining:function(){return 1/0}})})},Fo=function(e){clearTimeout(e)};var Go=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Yo={},Xo={},$o={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},Qo=void 0,Jo=function(e){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(t,n,r,o){MSApp.execUnsafeLocalFunction(function(){return e(t,n)})}:e}(function(e,t){if(e.namespaceURI!==$o.svg||"innerHTML"in e)e.innerHTML=t;else{for(Qo=Qo||document.createElement("div"),Qo.innerHTML="<svg>"+t+"</svg>",t=Qo.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}}),Zo={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ei=["Webkit","ms","Moz","O"];Object.keys(Zo).forEach(function(e){ei.forEach(function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),Zo[t]=Zo[e]})});var ti=wn({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0}),ni=$o.html,ri=xn.thatReturns(""),oi={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ii=Object.freeze({createElement:un,createTextNode:sn,setInitialProperties:ln,diffProperties:cn,updateProperties:fn,diffHydratedProperties:dn,diffHydratedText:pn,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(e,t,n){switch(t){case"input":if(Ht(e,n),t=n.name,"radio"===n.type&&null!=t){for(n=e;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<n.length;t++){var o=n[t];if(o!==e&&o.form===e.form){var i=E(o);i||r("90"),ae(o),Ht(o,i)}}}break;case"textarea":Qt(e,n);break;case"select":null!=(t=n.value)&&Gt(e,!!n.multiple,t,!1)}}});Pr.injectFiberControlledHostComponent(ii);var ai=null,ui=null,si=No({getRootHostContext:function(e){var t=e.nodeType;switch(t){case 9:case 11:e=(e=e.documentElement)?e.namespaceURI:en(null,"");break;default:t=8===t?e.parentNode:e,e=t.namespaceURI||null,t=t.tagName,e=en(e,t)}return e},getChildHostContext:function(e,t){return en(e,t)},getPublicInstance:function(e){return e},prepareForCommit:function(){ai=Hr;var e=Sn();if(Le(e)){if("selectionStart"in e)var t={start:e.selectionStart,end:e.selectionEnd};else e:{var n=window.getSelection&&window.getSelection();if(n&&0!==n.rangeCount){t=n.anchorNode;var r=n.anchorOffset,o=n.focusNode;n=n.focusOffset;try{t.nodeType,o.nodeType}catch(e){t=null;break e}var i=0,a=-1,u=-1,s=0,l=0,c=e,f=null;t:for(;;){for(var d;c!==t||0!==r&&3!==c.nodeType||(a=i+r),c!==o||0!==n&&3!==c.nodeType||(u=i+n),3===c.nodeType&&(i+=c.nodeValue.length),null!==(d=c.firstChild);)f=c,c=d;for(;;){if(c===e)break t;if(f===t&&++s===r&&(a=i),f===o&&++l===n&&(u=i),null!==(d=c.nextSibling))break;c=f,f=c.parentNode}c=d}t=-1===a||-1===u?null:{start:a,end:u}}else t=null}t=t||{start:0,end:0}}else t=null;ui={focusedElem:e,selectionRange:t},Pe(!1)},resetAfterCommit:function(){var e=ui,t=Sn(),n=e.focusedElem,r=e.selectionRange;if(t!==n&&En(document.documentElement,n)){if(Le(n))if(t=r.start,e=r.end,void 0===e&&(e=t),"selectionStart"in n)n.selectionStart=t,n.selectionEnd=Math.min(e,n.value.length);else if(window.getSelection){t=window.getSelection();var o=n[F()].length;e=Math.min(r.start,o),r=void 0===r.end?e:Math.min(r.end,o),!t.extend&&e>r&&(o=r,r=e,e=o),o=De(n,e);var i=De(n,r);if(o&&i&&(1!==t.rangeCount||t.anchorNode!==o.node||t.anchorOffset!==o.offset||t.focusNode!==i.node||t.focusOffset!==i.offset)){var a=document.createRange();a.setStart(o.node,o.offset),t.removeAllRanges(),e>r?(t.addRange(a),t.extend(i.node,i.offset)):(a.setEnd(i.node,i.offset),t.addRange(a))}}for(t=[],e=n;e=e.parentNode;)1===e.nodeType&&t.push({element:e,left:e.scrollLeft,top:e.scrollTop});for(Cn(n),n=0;n<t.length;n++)e=t[n],e.element.scrollLeft=e.left,e.element.scrollTop=e.top}ui=null,Pe(ai),ai=null},createInstance:function(e,t,n,r,o){return e=un(e,t,n,r),e[ir]=o,e[ar]=t,e},appendInitialChild:function(e,t){e.appendChild(t)},finalizeInitialChildren:function(e,t,n,r){ln(e,t,n,r);e:{switch(t){case"button":case"input":case"select":case"textarea":e=!!n.autoFocus;break e}e=!1}return e},prepareUpdate:function(e,t,n,r,o){return cn(e,t,n,r,o)},shouldSetTextContent:function(e,t){return"textarea"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&"string"==typeof t.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(e,t){return!!t.hidden},createTextInstance:function(e,t,n,r){return e=sn(e,t),e[ir]=r,e},now:Ao,mutation:{commitMount:function(e){e.focus()},commitUpdate:function(e,t,n,r,o){e[ar]=o,fn(e,t,n,r,o)},resetTextContent:function(e){e.textContent=""},commitTextUpdate:function(e,t,n){e.nodeValue=n},appendChild:function(e,t){e.appendChild(t)},appendChildToContainer:function(e,t){8===e.nodeType?e.parentNode.insertBefore(t,e):e.appendChild(t)},insertBefore:function(e,t,n){e.insertBefore(t,n)},insertInContainerBefore:function(e,t,n){8===e.nodeType?e.parentNode.insertBefore(t,n):e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},removeChildFromContainer:function(e,t){8===e.nodeType?e.parentNode.removeChild(t):e.removeChild(t)}},hydration:{canHydrateInstance:function(e,t){return 1!==e.nodeType||t.toLowerCase()!==e.nodeName.toLowerCase()?null:e},canHydrateTextInstance:function(e,t){return""===t||3!==e.nodeType?null:e},getNextHydratableSibling:function(e){for(e=e.nextSibling;e&&1!==e.nodeType&&3!==e.nodeType;)e=e.nextSibling;return e},getFirstHydratableChild:function(e){for(e=e.firstChild;e&&1!==e.nodeType&&3!==e.nodeType;)e=e.nextSibling;return e},hydrateInstance:function(e,t,n,r,o,i){return e[ir]=i,e[ar]=n,dn(e,t,n,o,r)},hydrateTextInstance:function(e,t,n){return e[ir]=n,pn(e,t)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:Ro,cancelDeferredCallback:Fo,useSyncScheduling:!0});J=si.batchedUpdates,bn.prototype.render=function(e,t){si.updateContainer(e,this._reactRootContainer,null,t)},bn.prototype.unmount=function(e){si.updateContainer(null,this._reactRootContainer,null,e)};var li={createPortal:mn,findDOMNode:function(e){if(null==e)return null;if(1===e.nodeType)return e;var t=e._reactInternalFiber;if(t)return si.findHostInstance(t);"function"==typeof e.render?r("188"):r("213",Object.keys(e))},hydrate:function(e,t,n){return vn(null,e,t,!0,n)},render:function(e,t,n){return vn(null,e,t,!1,n)},unstable_renderSubtreeIntoContainer:function(e,t,n,o){return(null==e||void 0===e._reactInternalFiber)&&r("38"),vn(e,t,n,!1,o)},unmountComponentAtNode:function(e){return hn(e)||r("40"),!!e._reactRootContainer&&(si.unbatchedUpdates(function(){vn(null,null,e,!1,function(){e._reactRootContainer=null})}),!0)},unstable_createPortal:mn,unstable_batchedUpdates:Z,unstable_deferredUpdates:si.deferredUpdates,flushSync:si.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:rr,EventPluginRegistry:Qn,EventPropagators:sr,ReactControlledComponent:Mr,ReactDOMComponentTree:ur,ReactDOMEventListener:Kr}};si.injectIntoDevTools({findFiberByHostInstance:S,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var ci=Object.freeze({default:li}),fi=ci&&li||ci;e.exports=fi.default?fi.default:fi},function(e,t,n){"use strict";var r=!("undefined"==typeof window||!window.document||!window.document.createElement),o={canUseDOM:r,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:r&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:r&&!!window.screen,isInWorker:!r};e.exports=o},function(e,t,n){"use strict";function r(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var n,u,s=r(e),l=1;l<arguments.length;l++){n=Object(arguments[l]);for(var c in n)i.call(n,c)&&(s[c]=n[c]);if(o){u=o(n);for(var f=0;f<u.length;f++)a.call(n,u[f])&&(s[u[f]]=n[u[f]])}}return s}},function(e,t,n){"use strict";var r=n(64),o={listen:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!1),{remove:function(){e.removeEventListener(t,n,!1)}}):e.attachEvent?(e.attachEvent("on"+t,n),{remove:function(){e.detachEvent("on"+t,n)}}):void 0},capture:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!0),{remove:function(){e.removeEventListener(t,n,!0)}}):{remove:r}},registerDefault:function(){}};e.exports=o},function(e,t,n){"use strict";function r(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}e.exports=r},function(e,t,n){"use strict";function r(e,t){return!(!e||!t)&&(e===t||!o(e)&&(o(t)?r(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}var o=n(306);e.exports=r},function(e,t,n){"use strict";function r(e){return o(e)&&3==e.nodeType}var o=n(307);e.exports=r},function(e,t,n){"use strict";function r(e){var t=e?e.ownerDocument||e:document,n=t.defaultView||window;return!(!e||!("function"==typeof n.Node?e instanceof n.Node:"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName))}e.exports=r},function(e,t,n){"use strict";function r(e){try{e.focus()}catch(e){}}e.exports=r},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(18),i=r(o),a=n(311),u=r(a),s=n(312),l=r(s);t.default=i.default.createPortal?u.default:l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e="function"==typeof e?e():e,g.default.findDOMNode(e)||t}function i(e){return(0,x.default)(g.default.findDOMNode(e))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(8),u=r(a),s=n(7),l=r(s),c=n(9),f=r(c),d=n(10),p=r(d),h=n(11),y=r(h),v=n(0),m=r(v),b=n(18),g=r(b),_=n(1),w=(r(_),n(23)),x=r(w),O=n(93),S=(r(O),function(e){function t(){var e,n,r,o;(0,l.default)(this,t);for(var i=arguments.length,a=Array(i),s=0;s<i;s++)a[s]=arguments[s];return n=r=(0,p.default)(this,(e=t.__proto__||(0,u.default)(t)).call.apply(e,[this].concat(a))),r.getMountNode=function(){return r.mountNode},o=n,(0,p.default)(r,o)}return(0,y.default)(t,e),(0,f.default)(t,[{key:"componentDidMount",value:function(){this.setContainer(this.props.container),this.forceUpdate(this.props.onRendered)}},{key:"componentWillReceiveProps",value:function(e){e.container!==this.props.container&&this.setContainer(e.container)}},{key:"componentWillUnmount",value:function(){this.mountNode=null}},{key:"setContainer",value:function(e){this.mountNode=o(e,i(this).body)}},{key:"render",value:function(){var e=this.props.children;return this.mountNode?g.default.createPortal(e,this.mountNode):null}}]),t}(m.default.Component));S.propTypes={},S.propTypes={},t.default=S},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e="function"==typeof e?e():e,g.default.findDOMNode(e)||t}function i(e){return(0,x.default)(g.default.findDOMNode(e))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(8),u=r(a),s=n(7),l=r(s),c=n(9),f=r(c),d=n(10),p=r(d),h=n(11),y=r(h),v=n(0),m=r(v),b=n(18),g=r(b),_=n(1),w=(r(_),n(23)),x=r(w),O=n(93),S=(r(O),function(e){function t(){var e,n,r,a;(0,l.default)(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=(0,p.default)(this,(e=t.__proto__||(0,u.default)(t)).call.apply(e,[this].concat(c))),r.getMountNode=function(){return r.mountNode},r.mountOverlayTarget=function(){r.overlayTarget||(r.overlayTarget=document.createElement("div"),r.mountNode=o(r.props.container,i(r).body),r.mountNode.appendChild(r.overlayTarget))},r.unmountOverlayTarget=function(){r.overlayTarget&&(r.mountNode.removeChild(r.overlayTarget),r.overlayTarget=null),r.mountNode=null},r.unrenderOverlay=function(){r.overlayTarget&&(g.default.unmountComponentAtNode(r.overlayTarget),r.overlayInstance=null)},r.renderOverlay=function(){var e=r.props.children;r.mountOverlayTarget();var t=!r.overlayInstance;r.overlayInstance=g.default.unstable_renderSubtreeIntoContainer(r,e,r.overlayTarget,function(){t&&r.props.onRendered&&r.props.onRendered()})},a=n,(0,p.default)(r,a)}return(0,y.default)(t,e),(0,f.default)(t,[{key:"componentDidMount",value:function(){this.mounted=!0,this.renderOverlay()}},{key:"componentWillReceiveProps",value:function(e){this.overlayTarget&&e.container!==this.props.container&&(this.mountNode.removeChild(this.overlayTarget),this.mountNode=o(e.container,i(this).body),this.mountNode.appendChild(this.overlayTarget))}},{key:"componentDidUpdate",value:function(){this.renderOverlay()}},{key:"componentWillUnmount",value:function(){this.mounted=!1,this.unrenderOverlay(),this.unmountOverlayTarget()}},{key:"render",value:function(){return null}}]),t}(m.default.Component));S.propTypes={},S.propTypes={},t.default=S},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n,r){return e.addEventListener(t,n,r),{remove:function(){e.removeEventListener(t,n,r)}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r="",o="",i=t;if("string"==typeof t){if(void 0===n)return e.style[(0,a.default)(t)]||(0,c.default)(e).getPropertyValue((0,s.default)(t));(i={})[t]=n}Object.keys(i).forEach(function(t){var n=i[t];n||0===n?(0,y.default)(t)?o+=t+"("+n+") ":r+=(0,s.default)(t)+": "+n+";":(0,d.default)(e,(0,s.default)(t))}),o&&(r+=p.transform+": "+o+";"),e.style.cssText+=";"+r}Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var i=n(145),a=r(i),u=n(316),s=r(u),l=n(318),c=r(l),f=n(319),d=r(f),p=n(320),h=n(321),y=r(h);e.exports=t.default},function(e,t,n){"use strict";function r(e){return e.replace(o,function(e,t){return t.toUpperCase()})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=/-(.)/g;e.exports=t.default},function(e,t,n){"use strict";function r(e){return(0,i.default)(e).replace(a,"-ms-")}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(317),i=function(e){return e&&e.__esModule?e:{default:e}}(o),a=/^ms-/;e.exports=t.default},function(e,t,n){"use strict";function r(e){return e.replace(o,"-$1").toLowerCase()}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=/([A-Z])/g;e.exports=t.default},function(e,t,n){"use strict";function r(e){if(!e)throw new TypeError("No Element passed to `getComputedStyle()`");var t=e.ownerDocument;return"defaultView"in t?t.defaultView.opener?e.ownerDocument.defaultView.getComputedStyle(e,null):window.getComputedStyle(e,null):{getPropertyValue:function(t){var n=e.style;"float"==(t=(0,i.default)(t))&&(t="styleFloat");var r=e.currentStyle[t]||null;if(null==r&&n&&n[t]&&(r=n[t]),u.test(r)&&!a.test(t)){var o=n.left,s=e.runtimeStyle,l=s&&s.left;l&&(s.left=e.currentStyle.left),n.left="fontSize"===t?"1em":r,r=n.pixelLeft+"px",n.left=o,l&&(s.left=l)}return r}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(145),i=function(e){return e&&e.__esModule?e:{default:e}}(o),a=/^(top|right|bottom|left)$/,u=/^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;e.exports=t.default},function(e,t,n){"use strict";function r(e,t){return"removeProperty"in e.style?e.style.removeProperty(t):e.style.removeAttribute(t)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.animationEnd=t.animationDelay=t.animationTiming=t.animationDuration=t.animationName=t.transitionEnd=t.transitionDuration=t.transitionDelay=t.transitionTiming=t.transitionProperty=t.transform=void 0;var r=n(57),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i="transform",a=void 0,u=void 0,s=void 0,l=void 0,c=void 0,f=void 0,d=void 0,p=void 0,h=void 0,y=void 0,v=void 0;if(o.default){var m=function(){for(var e=document.createElement("div").style,t={O:function(e){return"o"+e.toLowerCase()},Moz:function(e){return e.toLowerCase()},Webkit:function(e){return"webkit"+e},ms:function(e){return"MS"+e}},n=Object.keys(t),r=void 0,o=void 0,i="",a=0;a<n.length;a++){var u=n[a];if(u+"TransitionProperty"in e){i="-"+u.toLowerCase(),r=t[u]("TransitionEnd"),o=t[u]("AnimationEnd");break}}return!r&&"transitionProperty"in e&&(r="transitionend"),!o&&"animationName"in e&&(o="animationend"),e=null,{animationEnd:o,transitionEnd:r,prefix:i}}();a=m.prefix,t.transitionEnd=u=m.transitionEnd,t.animationEnd=s=m.animationEnd,t.transform=i=a+"-"+i,t.transitionProperty=l=a+"-transition-property",t.transitionDuration=c=a+"-transition-duration",t.transitionDelay=d=a+"-transition-delay",t.transitionTiming=f=a+"-transition-timing-function",t.animationName=p=a+"-animation-name",t.animationDuration=h=a+"-animation-duration",t.animationTiming=y=a+"-animation-delay",t.animationDelay=v=a+"-animation-timing-function"}t.transform=i,t.transitionProperty=l,t.transitionTiming=f,t.transitionDelay=d,t.transitionDuration=c,t.transitionEnd=u,t.animationName=p,t.animationDuration=h,t.animationTiming=y,t.animationDelay=v,t.animationEnd=s,t.default={transform:i,end:u,property:l,timing:f,delay:d,duration:c}},function(e,t,n){"use strict";function r(e){return!(!e||!o.test(e))}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=/^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return e&&"body"===e.tagName.toLowerCase()}function i(e){var t=(0,l.default)(e),n=(0,u.default)(t);if(!n&&!o(e))return e.scrollHeight>e.clientHeight;var r=window.getComputedStyle(t.body),i=parseInt(r.getPropertyValue("margin-left"),10),a=parseInt(r.getPropertyValue("margin-right"),10);return i+t.body.clientWidth+a<n.innerWidth}Object.defineProperty(t,"__esModule",{value:!0}),t.isBody=o,t.default=i;var a=n(323),u=r(a),s=n(23),l=r(s)},function(e,t,n){"use strict";function r(e){return e===e.window?e:9===e.nodeType&&(e.defaultView||e.parentWindow)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){return 1===e.nodeType&&-1===s.indexOf(e.tagName.toLowerCase())}function o(e,t,n){t=[].concat(t),[].forEach.call(e.children,function(e){-1===t.indexOf(e)&&r(e)&&n(e)})}function i(e,t){t&&(e?t.setAttribute("aria-hidden","true"):t.removeAttribute("aria-hidden"))}function a(e,t){o(e,t,function(e){return i(!0,e)})}function u(e,t){o(e,t,function(e){return i(!1,e)})}Object.defineProperty(t,"__esModule",{value:!0}),t.ariaHidden=i,t.hideSiblings=a,t.showSiblings=u;var s=["template","script","style"]},function(e,t,n){"use strict";function r(e){var t="transition"+e+"Timeout",n="transition"+e;return function(e){if(e[n]){if(null==e[t])return new Error(t+" wasn't supplied to CSSTransitionGroup: this can cause unreliable animations and won't be supported in a future version of React. See https://fb.me/react-animation-transition-group-timeout for more information.");if("number"!=typeof e[t])return new Error(t+" must be a number (in milliseconds)")}return null}}t.__esModule=!0,t.classNamesShape=t.timeoutsShape=void 0,t.transitionTimeout=r;var o=n(1),i=function(e){return e&&e.__esModule?e:{default:e}}(o);t.timeoutsShape=i.default.oneOfType([i.default.number,i.default.shape({enter:i.default.number,exit:i.default.number}).isRequired]),t.classNamesShape=i.default.oneOfType([i.default.string,i.default.shape({enter:i.default.string,exit:i.default.string,active:i.default.string}),i.default.shape({enter:i.default.string,enterActive:i.default.string,exit:i.default.string,exitActive:i.default.string})])},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.classes,n=e.className,r=e.component,o=e.square,i=e.elevation,u=(0,s.default)(e,["classes","className","component","square","elevation"]),l=(0,y.default)(t.root,t["shadow"+i],(0,a.default)({},t.rounded,!o),n);return d.default.createElement(r,(0,c.default)({className:l},u))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(6),a=r(i),u=n(3),s=r(u),l=n(2),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(12),m=(r(v),n(4)),b=r(m),g=t.styles=function(e){var t={};return e.shadows.forEach(function(e,n){t["shadow"+n]={boxShadow:e}}),(0,c.default)({root:{backgroundColor:e.palette.background.paper},rounded:{borderRadius:2}},t)};o.propTypes={},o.defaultProps={component:"div",elevation:2,square:!1},t.default=(0,b.default)(g,{name:"MuiPaper"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=(0,s.default)(e,["children","classes","className"]);return c.default.createElement("div",(0,a.default)({className:(0,p.default)(n.root,r)},o),c.default.Children.map(t,function(e){return c.default.isValidElement(e)?c.default.createElement("div",{className:n.action},c.default.cloneElement(e,{className:(0,p.default)(n.button,e.props.className)})):null}))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h);n(59);var v=t.styles=function(e){return{root:{display:"flex",justifyContent:"flex-end",alignItems:"center",margin:e.spacing.unit+"px "+e.spacing.unit/2+"px",flex:"0 0 auto"},action:{margin:"0 "+e.spacing.unit/2+"px"},button:{minWidth:64}}};o.propTypes={},t.default=(0,y.default)(v,{name:"MuiDialogActions"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.children,r=e.classes,o=e.className,i=e.color,u=e.disabled,l=e.disableFocusRipple,f=e.fullWidth,p=e.mini,h=e.size,v=e.variant,m=(0,s.default)(e,["children","classes","className","color","disabled","disableFocusRipple","fullWidth","mini","size","variant"]),b="fab"===v,g="raised"===v,O=!g&&!b,S=(0,y.default)(r.root,(t={},(0,a.default)(t,r.raised,g||b),(0,a.default)(t,r.fab,b),(0,a.default)(t,r.mini,b&&p),(0,a.default)(t,r.colorInherit,"inherit"===i),(0,a.default)(t,r.flatPrimary,O&&"primary"===i),(0,a.default)(t,r.flatSecondary,O&&"secondary"===i),(0,a.default)(t,r.raisedPrimary,!O&&"primary"===i),(0,a.default)(t,r.raisedSecondary,!O&&"secondary"===i),(0,a.default)(t,r["size"+(0,w.capitalize)(h)],"medium"!==h),(0,a.default)(t,r.disabled,u),(0,a.default)(t,r.fullWidth,f),t),o),T=n;return b&&(T=d.default.Children.map(T,function(e){return(0,x.isMuiElement)(e,["Icon","SvgIcon"])?d.default.cloneElement(e,{fontSize:!0}):e})),d.default.createElement(_.default,(0,c.default)({className:S,disabled:u,focusRipple:!l,keyboardFocusedClassName:r.keyboardFocused},m),d.default.createElement("span",{className:r.label},T))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(6),a=r(i),u=n(3),s=r(u),l=n(2),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(89),g=n(60),_=r(g),w=n(21),x=n(61),O=t.styles=function(e){return{root:(0,c.default)({},e.typography.button,{lineHeight:"1.4em",boxSizing:"border-box",minWidth:11*e.spacing.unit,minHeight:36,padding:e.spacing.unit+"px "+2*e.spacing.unit+"px",borderRadius:2,color:e.palette.text.primary,transition:e.transitions.create(["background-color","box-shadow"],{duration:e.transitions.duration.short}),"&:hover":{textDecoration:"none",backgroundColor:(0,b.fade)(e.palette.text.primary,.12),"@media (hover: none)":{backgroundColor:"transparent"},"&$disabled":{backgroundColor:"transparent"}}}),label:{width:"100%",display:"inherit",alignItems:"inherit",justifyContent:"inherit"},flatPrimary:{color:e.palette.primary.main,"&:hover":{backgroundColor:(0,b.fade)(e.palette.primary.main,.12),"@media (hover: none)":{backgroundColor:"transparent"}}},flatSecondary:{color:e.palette.secondary.main,"&:hover":{backgroundColor:(0,b.fade)(e.palette.secondary.main,.12),"@media (hover: none)":{backgroundColor:"transparent"}}},colorInherit:{color:"inherit"},raised:{color:e.palette.getContrastText(e.palette.grey[300]),backgroundColor:e.palette.grey[300],boxShadow:e.shadows[2],"&$keyboardFocused":{boxShadow:e.shadows[6]},"&:active":{boxShadow:e.shadows[8]},"&$disabled":{boxShadow:e.shadows[0],backgroundColor:e.palette.action.disabledBackground},"&:hover":{backgroundColor:e.palette.grey.A100,"@media (hover: none)":{backgroundColor:e.palette.grey[300]},"&$disabled":{backgroundColor:e.palette.action.disabledBackground}}},keyboardFocused:{},raisedPrimary:{color:e.palette.primary.contrastText,backgroundColor:e.palette.primary.main,"&:hover":{backgroundColor:e.palette.primary.dark,"@media (hover: none)":{backgroundColor:e.palette.primary.main}}},raisedSecondary:{color:e.palette.secondary.contrastText,backgroundColor:e.palette.secondary.main,"&:hover":{backgroundColor:e.palette.secondary.dark,"@media (hover: none)":{backgroundColor:e.palette.secondary.main}}},disabled:{color:e.palette.action.disabled},fab:{borderRadius:"50%",padding:0,minWidth:0,width:56,fontSize:24,height:56,boxShadow:e.shadows[6],"&:active":{boxShadow:e.shadows[12]}},mini:{width:40,height:40},sizeSmall:{padding:e.spacing.unit-1+"px "+e.spacing.unit+"px",minWidth:8*e.spacing.unit,minHeight:32,fontSize:e.typography.pxToRem(e.typography.fontSize-1)},sizeLarge:{padding:e.spacing.unit+"px "+3*e.spacing.unit+"px",minWidth:14*e.spacing.unit,minHeight:40,fontSize:e.typography.pxToRem(e.typography.fontSize+1)},fullWidth:{width:"100%"}}};o.propTypes={},o.defaultProps={color:"default",disabled:!1,disableFocusRipple:!1,disableRipple:!1,fullWidth:!1,mini:!1,size:"medium",type:"button",variant:"flat"},t.default=(0,m.default)(O,{name:"MuiButton"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(6),u=r(a),s=n(3),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=(r(x),n(18)),S=n(5),T=r(S),E=n(42),C=r(E),k=n(151),P=r(k),M=n(4),j=r(M),N=n(330),I=n(331),A=r(I),R=n(340),F=r(R),D=t.styles={root:{display:"inline-flex",alignItems:"center",justifyContent:"center",position:"relative",WebkitTapHighlightColor:"transparent",backgroundColor:"transparent",outline:"none",border:0,margin:0,borderRadius:0,padding:0,cursor:"pointer",userSelect:"none",verticalAlign:"middle","-moz-appearance":"none","-webkit-appearance":"none",textDecoration:"none",color:"inherit","&::-moz-focus-inner":{borderStyle:"none"}},disabled:{pointerEvents:"none",cursor:"default"}},L=["a"],z=function(e){function t(){var e,n,r,o;(0,p.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,m.default)(this,(e=t.__proto__||(0,f.default)(t)).call.apply(e,[this].concat(a))),r.state={keyboardFocused:!1},r.onKeyboardFocusHandler=function(e){r.keyDown=!1,r.setState({keyboardFocused:!0}),r.props.onKeyboardFocus&&r.props.onKeyboardFocus(e)},r.onRippleRef=function(e){r.ripple=e},r.ripple=null,r.keyDown=!1,r.button=null,r.keyboardFocusTimeout=null,r.keyboardFocusCheckTime=50,r.keyboardFocusMaxCheckTimes=5,r.handleKeyDown=function(e){var t=r.props,n=t.component,o=t.focusRipple,i=t.onKeyDown,a=t.onClick,u=(0,C.default)(e);o&&!r.keyDown&&r.state.keyboardFocused&&r.ripple&&"space"===u&&(r.keyDown=!0,e.persist(),r.ripple.stop(e,function(){r.ripple.start(e)})),i&&i(e),e.target===r.button&&a&&n&&"a"!==n&&"button"!==n&&("space"===u||"enter"===u)&&(e.preventDefault(),a(e))},r.handleKeyUp=function(e){r.props.focusRipple&&"space"===(0,C.default)(e)&&r.ripple&&r.state.keyboardFocused&&(r.keyDown=!1,e.persist(),r.ripple.stop(e,function(){return r.ripple.pulsate(e)})),r.props.onKeyUp&&r.props.onKeyUp(e)},r.handleMouseDown=(0,F.default)(r,"MouseDown","start",function(){clearTimeout(r.keyboardFocusTimeout),(0,N.focusKeyPressed)(!1),r.state.keyboardFocused&&r.setState({keyboardFocused:!1})}),r.handleMouseUp=(0,F.default)(r,"MouseUp","stop"),r.handleMouseLeave=(0,F.default)(r,"MouseLeave","stop",function(e){r.state.keyboardFocused&&e.preventDefault()}),r.handleTouchStart=(0,F.default)(r,"TouchStart","start"),r.handleTouchEnd=(0,F.default)(r,"TouchEnd","stop"),r.handleTouchMove=(0,F.default)(r,"TouchEnd","stop"),r.handleBlur=(0,F.default)(r,"Blur","stop",function(){clearTimeout(r.keyboardFocusTimeout),(0,N.focusKeyPressed)(!1),r.setState({keyboardFocused:!1})}),r.handleFocus=function(e){r.props.disabled||(r.button||(r.button=e.currentTarget),e.persist(),(0,N.detectKeyboardFocus)(r,r.button,function(){r.onKeyboardFocusHandler(e)}),r.props.onFocus&&r.props.onFocus(e))},o=n,(0,m.default)(r,o)}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentDidMount",value:function(){this.button=(0,O.findDOMNode)(this),(0,N.listenForFocusKeys)((0,P.default)(this.button))}},{key:"componentWillReceiveProps",value:function(e){!this.props.disabled&&e.disabled&&this.state.keyboardFocused&&this.setState({keyboardFocused:!1})}},{key:"componentWillUpdate",value:function(e,t){this.props.focusRipple&&t.keyboardFocused&&!this.state.keyboardFocused&&!this.props.disableRipple&&this.ripple.pulsate()}},{key:"componentWillUnmount",value:function(){this.button=null,clearTimeout(this.keyboardFocusTimeout)}},{key:"render",value:function(){var e,t=this.props,n=t.buttonRef,r=t.centerRipple,o=t.children,a=t.classes,s=t.className,c=t.component,f=t.disabled,d=t.disableRipple,p=(t.focusRipple,t.keyboardFocusedClassName),h=(t.onBlur,t.onFocus,t.onKeyboardFocus,t.onKeyDown,t.onKeyUp,t.onMouseDown,t.onMouseLeave,t.onMouseUp,t.onTouchEnd,t.onTouchMove,t.onTouchStart,t.tabIndex),y=t.type,v=(0,l.default)(t,["buttonRef","centerRipple","children","classes","className","component","disabled","disableRipple","focusRipple","keyboardFocusedClassName","onBlur","onFocus","onKeyboardFocus","onKeyDown","onKeyUp","onMouseDown","onMouseLeave","onMouseUp","onTouchEnd","onTouchMove","onTouchStart","tabIndex","type"]),m=(0,T.default)(a.root,(e={},(0,u.default)(e,a.disabled,f),(0,u.default)(e,p||"",this.state.keyboardFocused),e),s),b={},g=c;return g||(g=v.href?"a":"button"),"button"===g?(b.type=y||"button",b.disabled=f):-1===L.indexOf(g)&&(b.role="button"),w.default.createElement(g,(0,i.default)({onBlur:this.handleBlur,onFocus:this.handleFocus,onKeyDown:this.handleKeyDown,onKeyUp:this.handleKeyUp,onMouseDown:this.handleMouseDown,onMouseLeave:this.handleMouseLeave,onMouseUp:this.handleMouseUp,onTouchEnd:this.handleTouchEnd,onTouchMove:this.handleTouchMove,onTouchStart:this.handleTouchStart,tabIndex:f?-1:h,className:m,ref:n},b,v),o,d||f?null:w.default.createElement(A.default,{innerRef:this.onRippleRef,center:r}))}}]),t}(w.default.Component);z.propTypes={},z.defaultProps={centerRipple:!1,disableRipple:!1,focusRipple:!1,tabIndex:0,type:"button"},t.default=(0,j.default)(D,{name:"MuiButtonBase"})(z)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return void 0!==e&&(y.focusKeyPressed=Boolean(e)),y.focusKeyPressed}function i(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;e.keyboardFocusTimeout=setTimeout(function(){var a=(0,h.default)(t);o()&&(a.activeElement===t||(0,d.default)(t,a.activeElement))?n():r<e.keyboardFocusMaxCheckTimes&&i(e,t,n,r+1)},e.keyboardFocusCheckTime)}function a(e){return-1!==v.indexOf((0,l.default)(e))}function u(e){e.addEventListener("keyup",m)}Object.defineProperty(t,"__esModule",{value:!0}),t.focusKeyPressed=o,t.detectKeyboardFocus=i,t.listenForFocusKeys=u;var s=n(42),l=r(s),c=n(12),f=(r(c),n(56)),d=r(f),p=n(23),h=r(p),y={focusKeyPressed:!1},v=["tab","enter","space","esc","up","down","left","right"],m=function(e){a(e)&&(y.focusKeyPressed=!0)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=t.DELAY_RIPPLE=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(95),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=(r(x),n(18)),S=r(O),T=n(337),E=r(T),C=n(5),k=r(C),P=n(4),M=r(P),j=n(339),N=r(j),I=550,A=t.DELAY_RIPPLE=80,R=t.styles=function(e){return{root:{display:"block",position:"absolute",overflow:"hidden",borderRadius:"inherit",width:"100%",height:"100%",left:0,top:0,pointerEvents:"none",zIndex:0},wrapper:{opacity:1},wrapperLeaving:{opacity:0,animation:"mui-ripple-exit "+I+"ms "+e.transitions.easing.easeInOut},wrapperPulsating:{position:"absolute",left:0,top:0,display:"block",width:"100%",height:"100%",animation:"mui-ripple-pulsate 2500ms "+e.transitions.easing.easeInOut+" 200ms infinite"},"@keyframes mui-ripple-enter":{"0%":{transform:"scale(0)"},"100%":{transform:"scale(1)"}},"@keyframes mui-ripple-exit":{"0%":{opacity:1},"100%":{opacity:0}},"@keyframes mui-ripple-pulsate":{"0%":{transform:"scale(1)"},"50%":{transform:"scale(0.92)"},"100%":{transform:"scale(1)"}},ripple:{width:50,height:50,left:0,top:0,opacity:0,position:"absolute",borderRadius:"50%",background:"currentColor"},rippleVisible:{opacity:.3,transform:"scale(1)",animation:"mui-ripple-enter "+I+"ms "+e.transitions.easing.easeInOut},rippleFast:{animationDuration:"200ms"}}},F=function(e){function t(){var e,n,r,o;(0,p.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,m.default)(this,(e=t.__proto__||(0,f.default)(t)).call.apply(e,[this].concat(a))),r.state={nextKey:0,ripples:[]},r.ignoringMouseDown=!1,r.startTimer=null,r.startTimerCommit=null,r.pulsate=function(){r.start({},{pulsate:!0})},r.start=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments[2],o=t.pulsate,i=void 0!==o&&o,a=t.center,u=void 0===a?r.props.center||t.pulsate:a,s=t.fakeElement,l=void 0!==s&&s;if("mousedown"===e.type&&r.ignoringMouseDown)return void(r.ignoringMouseDown=!1);"touchstart"===e.type&&(r.ignoringMouseDown=!0);var c=l?null:S.default.findDOMNode(r),f=c?c.getBoundingClientRect():{width:0,height:0,left:0,top:0},d=void 0,p=void 0,h=void 0;if(u||0===e.clientX&&0===e.clientY||!e.clientX&&!e.touches)d=Math.round(f.width/2),p=Math.round(f.height/2);else{var y=e.clientX?e.clientX:e.touches[0].clientX,v=e.clientY?e.clientY:e.touches[0].clientY;d=Math.round(y-f.left),p=Math.round(v-f.top)}if(u)(h=Math.sqrt((2*Math.pow(f.width,2)+Math.pow(f.height,2))/3))%2==0&&(h+=1);else{var m=2*Math.max(Math.abs((c?c.clientWidth:0)-d),d)+2,b=2*Math.max(Math.abs((c?c.clientHeight:0)-p),p)+2;h=Math.sqrt(Math.pow(m,2)+Math.pow(b,2))}e.touches?(r.startTimerCommit=function(){r.startCommit({pulsate:i,rippleX:d,rippleY:p,rippleSize:h,cb:n})},r.startTimer=setTimeout(function(){r.startTimerCommit(),r.startTimerCommit=null},A)):r.startCommit({pulsate:i,rippleX:d,rippleY:p,rippleSize:h,cb:n})},r.startCommit=function(e){var t=e.pulsate,n=e.rippleX,o=e.rippleY,i=e.rippleSize,a=e.cb,u=r.state.ripples;u=[].concat((0,l.default)(u),[w.default.createElement(N.default,{key:r.state.nextKey,classes:r.props.classes,timeout:{exit:I,enter:I},pulsate:t,rippleX:n,rippleY:o,rippleSize:i})]),r.setState({nextKey:r.state.nextKey+1,ripples:u},a)},r.stop=function(e,t){clearTimeout(r.startTimer);var n=r.state.ripples;if("touchend"===e.type&&r.startTimerCommit)return e.persist(),r.startTimerCommit(),r.startTimerCommit=null,void(r.startTimer=setTimeout(function(){r.stop(e,t)},0));r.startTimerCommit=null,n&&n.length&&r.setState({ripples:n.slice(1)},t)},o=n,(0,m.default)(r,o)}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentWillUnmount",value:function(){clearTimeout(this.startTimer)}},{key:"render",value:function(){var e=this.props,t=(e.center,e.classes),n=e.className,r=(0,u.default)(e,["center","classes","className"]);return w.default.createElement(E.default,(0,i.default)({component:"span",enter:!0,exit:!0,className:(0,k.default)(t.root,n)},r),this.state.ripples)}}]),t}(w.default.Component);F.propTypes={},F.defaultProps={center:!1},t.default=(0,M.default)(R,{flip:!1,name:"MuiTouchRipple"})(F)},function(e,t,n){e.exports={default:n(333),__esModule:!0}},function(e,t,n){n(79),n(334),e.exports=n(13).Array.from},function(e,t,n){"use strict";var r=n(27),o=n(14),i=n(34),a=n(124),u=n(125),s=n(45),l=n(335),c=n(126);o(o.S+o.F*!n(336)(function(e){Array.from(e)}),"Array",{from:function(e){var t,n,o,f,d=i(e),p="function"==typeof this?this:Array,h=arguments.length,y=h>1?arguments[1]:void 0,v=void 0!==y,m=0,b=c(d);if(v&&(y=r(y,h>2?arguments[2]:void 0,2)),void 0==b||p==Array&&u(b))for(t=s(d.length),n=new p(t);t>m;m++)l(n,m,v?y(d[m],m):d[m]);else for(f=b.call(d),n=new p;!(o=f.next()).done;m++)l(n,m,v?a(f,y,[o.value,m],!0):o.value);return n.length=m,n}})},function(e,t,n){"use strict";var r=n(17),o=n(37);e.exports=function(e,t,n){t in e?r.f(e,t,o(0,n)):e[t]=n}},function(e,t,n){var r=n(15)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},e(i)}catch(e){}return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=n(1),c=r(l),f=n(0),d=r(f),p=n(338),h=Object.values||function(e){return Object.keys(e).map(function(t){return e[t]})},y=(c.default.any,c.default.node,c.default.bool,c.default.bool,c.default.bool,c.default.func,{component:"div",childFactory:function(e){return e}}),v=function(e){function t(n,r){i(this,t);var o=a(this,e.call(this,n,r));return o.handleExited=function(e,t,n){var r=(0,p.getChildMapping)(o.props.children);e in r||(n&&n(t),o.setState(function(t){var n=s({},t.children);return delete n[e],{children:n}}))},o.state={children:(0,p.getChildMapping)(n.children,function(e){var t=function(t){o.handleExited(e.key,t,e.props.onExited)};return(0,f.cloneElement)(e,{onExited:t,in:!0,appear:o.getProp(e,"appear"),enter:o.getProp(e,"enter"),exit:o.getProp(e,"exit")})})},o}return u(t,e),t.prototype.getChildContext=function(){return{transitionGroup:{isMounting:!this.appeared}}},t.prototype.getProp=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.props;return null!=n[t]?n[t]:e.props[t]},t.prototype.componentDidMount=function(){this.appeared=!0},t.prototype.componentWillReceiveProps=function(e){var t=this,n=this.state.children,r=(0,p.getChildMapping)(e.children),o=(0,p.mergeChildMappings)(n,r);Object.keys(o).forEach(function(i){var a=o[i];if((0,f.isValidElement)(a)){var u=function(e){t.handleExited(a.key,e,a.props.onExited)},s=i in n,l=i in r,c=n[i],d=(0,f.isValidElement)(c)&&!c.props.in;!l||s&&!d?l||!s||d?l&&s&&(0,f.isValidElement)(c)&&(o[i]=(0,f.cloneElement)(a,{onExited:u,in:c.props.in,exit:t.getProp(a,"exit",e),enter:t.getProp(a,"enter",e)})):o[i]=(0,f.cloneElement)(a,{in:!1}):o[i]=(0,f.cloneElement)(a,{onExited:u,in:!0,exit:t.getProp(a,"exit",e),enter:t.getProp(a,"enter",e)})}}),this.setState({children:o})},t.prototype.render=function(){var e=this.props,t=e.component,n=e.childFactory,r=o(e,["component","childFactory"]),i=this.state.children;return delete r.appear,delete r.enter,delete r.exit,d.default.createElement(t,r,h(i).map(n))},t}(d.default.Component);v.childContextTypes={transitionGroup:c.default.object.isRequired},v.propTypes={},v.defaultProps=y,t.default=v,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){var n=function(e){return t&&(0,i.isValidElement)(e)?t(e):e},r=Object.create(null);return e&&i.Children.map(e,function(e){return e}).forEach(function(e){r[e.key]=n(e)}),r}function o(e,t){function n(n){return n in t?t[n]:e[n]}e=e||{},t=t||{};var r=Object.create(null),o=[];for(var i in e)i in t?o.length&&(r[i]=o,o=[]):o.push(i);var a=void 0,u={};for(var s in t){if(r[s])for(a=0;a<r[s].length;a++){var l=r[s][a];u[r[s][a]]=n(l)}u[s]=n(s)}for(a=0;a<o.length;a++)u[o[a]]=n(o[a]);return u}t.__esModule=!0,t.getChildMapping=r,t.mergeChildMappings=o;var i=n(0)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),i=r(o),a=n(6),u=r(a),s=n(3),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=(r(x),n(5)),S=r(O),T=n(94),E=r(T),C=function(e){function t(){var e,n,r,o;(0,p.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,m.default)(this,(e=t.__proto__||(0,f.default)(t)).call.apply(e,[this].concat(a))),r.state={rippleVisible:!1,rippleLeaving:!1},r.handleEnter=function(){r.setState({rippleVisible:!0})},r.handleExit=function(){r.setState({rippleLeaving:!0})},o=n,(0,m.default)(r,o)}return(0,g.default)(t,e),(0,y.default)(t,[{key:"render",value:function(){var e,t,n=this.props,r=n.classes,o=n.className,a=n.pulsate,s=n.rippleX,c=n.rippleY,f=n.rippleSize,d=(0,l.default)(n,["classes","className","pulsate","rippleX","rippleY","rippleSize"]),p=this.state,h=p.rippleVisible,y=p.rippleLeaving,v=(0,S.default)(r.wrapper,(e={},(0,u.default)(e,r.wrapperLeaving,y),(0,u.default)(e,r.wrapperPulsating,a),e),o),m=(0,S.default)(r.ripple,(t={},(0,u.default)(t,r.rippleVisible,h),(0,u.default)(t,r.rippleFast,a),t)),b={width:f,height:f,top:-f/2+c,left:-f/2+s};return w.default.createElement(E.default,(0,i.default)({onEnter:this.handleEnter,onExit:this.handleExit},d),w.default.createElement("span",{className:v},w.default.createElement("span",{className:m,style:b})))}}]),t}(w.default.Component);C.propTypes={},C.defaultProps={pulsate:!1},t.default=C},function(e,t,n){"use strict";function r(e,t,n,r){return function(o){return r&&r.call(e,o),!o.defaultPrevented&&(e.ripple&&e.ripple[n](o),e.props&&"function"==typeof e.props["on"+t]&&e.props["on"+t](o),!0)}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=e.disableTypography,i=(0,s.default)(e,["children","classes","className","disableTypography"]);return c.default.createElement("div",(0,a.default)({className:(0,p.default)(n.root,r)},i),o?t:c.default.createElement(m.default,{variant:"title"},t))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h),v=n(43),m=r(v),b=t.styles=function(e){return{root:{margin:0,padding:3*e.spacing.unit+"px "+3*e.spacing.unit+"px       20px "+3*e.spacing.unit+"px",flex:"0 0 auto"}}};o.propTypes={},o.defaultProps={disableTypography:!1},t.default=(0,y.default)(b,{name:"MuiDialogTitle"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.align,r=e.classes,o=e.className,i=e.component,u=e.color,l=e.gutterBottom,f=e.headlineMapping,p=e.noWrap,h=e.paragraph,v=e.variant,m=(0,c.default)(e,["align","classes","className","component","color","gutterBottom","headlineMapping","noWrap","paragraph","variant"]),g=(0,y.default)(r.root,r[v],(t={},(0,s.default)(t,r["color"+(0,b.capitalize)(u)],"default"!==u),(0,s.default)(t,r.noWrap,p),(0,s.default)(t,r.gutterBottom,l),(0,s.default)(t,r.paragraph,h),(0,s.default)(t,r["align"+(0,b.capitalize)(n)],"inherit"!==n),t),o),_=i||(h?"p":f[v])||"span";return d.default.createElement(_,(0,a.default)({className:g},m))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(21),g=t.styles=function(e){return{root:{display:"block",margin:0},display4:e.typography.display4,display3:e.typography.display3,display2:e.typography.display2,display1:e.typography.display1,headline:e.typography.headline,title:e.typography.title,subheading:e.typography.subheading,body2:e.typography.body2,body1:e.typography.body1,caption:e.typography.caption,button:e.typography.button,alignLeft:{textAlign:"left"},alignCenter:{textAlign:"center"},alignRight:{textAlign:"right"},alignJustify:{textAlign:"justify"},noWrap:{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},gutterBottom:{marginBottom:"0.35em"},paragraph:{marginBottom:2*e.spacing.unit},colorInherit:{color:"inherit"},colorPrimary:{color:e.palette.primary.main},colorSecondary:{color:e.palette.secondary.main},colorTextSecondary:{color:e.palette.text.secondary},colorError:{color:e.palette.error.main}}};o.propTypes={},o.defaultProps={align:"inherit",color:"default",gutterBottom:!1,headlineMapping:{display4:"h1",display3:"h1",display2:"h1",display1:"h1",headline:"h1",title:"h2",subheading:"h3",body2:"aside",body1:"p"},noWrap:!1,paragraph:!1,variant:"body1"},t.default=(0,m.default)(g,{name:"MuiTypography"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.classes,n=e.children,r=e.className,o=(0,s.default)(e,["classes","children","className"]);return c.default.createElement("div",(0,a.default)({className:(0,p.default)(t.root,r)},o),n)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h),v=t.styles=function(e){var t=3*e.spacing.unit;return{root:{flex:"1 1 auto",overflowY:"auto",padding:"0 "+t+"px "+t+"px "+t+"px","&:first-child":{paddingTop:t}}}};o.propTypes={},t.default=(0,y.default)(v,{name:"MuiDialogContent"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=(0,a.default)(e,["children","classes","className"]);return c.default.createElement("p",(0,s.default)({className:(0,p.default)(n.root,r)},o),t)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(3),a=r(i),u=n(2),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h),v=t.styles=function(e){return{root:(0,s.default)({},e.typography.subheading,{color:e.palette.text.secondary,margin:0})}};o.propTypes={},t.default=(0,y.default)(v,{name:"MuiDialogContentText"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),i=r(o),a=n(0),u=r(a),s=n(1),l=(r(s),n(346)),c=r(l),f=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return function(t){function n(e){return u.default.createElement(t,(0,i.default)({fullScreen:(0,l.isWidthDown)(o,e.width)},e))}var r=e.breakpoint,o=void 0===r?"sm":r;return n.propTypes={},(0,c.default)()(n)}};t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.isWidthDown=t.isWidthUp=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(62)),x=r(w),O=n(63),S=r(O),T=n(40),E=(r(T),n(44)),C=r(E),k=n(58),P=r(k),M=n(138),j=(t.isWidthUp=function(e,t){return arguments.length>2&&void 0!==arguments[2]&&!arguments[2]?M.keys.indexOf(e)<M.keys.indexOf(t):M.keys.indexOf(e)<=M.keys.indexOf(t)},t.isWidthDown=function(e,t){return arguments.length>2&&void 0!==arguments[2]&&!arguments[2]?M.keys.indexOf(t)<M.keys.indexOf(e):M.keys.indexOf(t)<=M.keys.indexOf(e)},function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return function(t){var n=e.resizeInterval,r=void 0===n?166:n,o=e.withTheme,a=void 0!==o&&o,s=function(e){function n(){var e,t,o,i;(0,f.default)(this,n);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return t=o=(0,y.default)(this,(e=n.__proto__||(0,l.default)(n)).call.apply(e,[this].concat(u))),o.state={width:void 0},o.handleResize=(0,S.default)(function(){o.updateWidth(window.innerWidth)},r),i=t,(0,y.default)(o,i)}return(0,m.default)(n,e),(0,p.default)(n,[{key:"componentDidMount",value:function(){this.updateWidth(window.innerWidth)}},{key:"componentWillUnmount",value:function(){this.handleResize.cancel()}},{key:"updateWidth",value:function(e){for(var t=this.props.theme.breakpoints,n=null,r=1;null===n&&r<M.keys.length;){var o=M.keys[r];if(e<t.values[o]){n=M.keys[r-1];break}r+=1}(n=n||"xl")!==this.state.width&&this.setState({width:n})}},{key:"render",value:function(){var e=this.props,n=e.initialWidth,r=e.theme,o=e.width,s=(0,u.default)(e,["initialWidth","theme","width"]),l=(0,i.default)({width:o||this.state.width||n},s),c={};return a&&(c.theme=r),void 0===l.width?null:g.default.createElement(x.default,{target:"window",onResize:this.handleResize},g.default.createElement(t,(0,i.default)({},c,l)))}}]),n}(g.default.Component);return s.propTypes={},(0,C.default)(s,t),(0,P.default)()(s)}});t.default=j},function(e,t,n){"use strict";function r(e,t,n){return(0,i.default)(e,t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.passiveOption=void 0;var o=n(78),i=function(e){return e&&e.__esModule?e:{default:e}}(o);t.passiveOption=function(){var e=null;return function(){if(null!==e)return e;var t=!1;try{window.addEventListener("test",null,r({},"passive",{get:function(){t=!0}}))}catch(e){}return e=t,t}()}();t.default={}},function(e,t,n){var r=n(153),o=function(){return r.Date.now()};e.exports=o},function(e,t,n){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.exports=n}).call(t,n(16))},function(e,t,n){function r(e){if("number"==typeof e)return e;if(i(e))return a;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(u,"");var n=l.test(e);return n||c.test(e)?f(e.slice(2),n?2:8):s.test(e)?a:+e}var o=n(152),i=n(351),a=NaN,u=/^\s+|\s+$/g,s=/^[-+]0x[0-9a-f]+$/i,l=/^0b[01]+$/i,c=/^0o[0-7]+$/i,f=parseInt;e.exports=r},function(e,t,n){function r(e){return"symbol"==typeof e||i(e)&&o(e)==a}var o=n(352),i=n(355),a="[object Symbol]";e.exports=r},function(e,t,n){function r(e){return null==e?void 0===e?s:u:l&&l in Object(e)?i(e):a(e)}var o=n(154),i=n(353),a=n(354),u="[object Null]",s="[object Undefined]",l=o?o.toStringTag:void 0;e.exports=r},function(e,t,n){function r(e){var t=a.call(e,s),n=e[s];try{e[s]=void 0;var r=!0}catch(e){}var o=u.call(e);return r&&(t?e[s]=n:delete e[s]),o}var o=n(154),i=Object.prototype,a=i.hasOwnProperty,u=i.toString,s=o?o.toStringTag:void 0;e.exports=r},function(e,t){function n(e){return o.call(e)}var r=Object.prototype,o=r.toString;e.exports=n},function(e,t){function n(e){return null!=e&&"object"==typeof e}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(32),u=n(357),s=n(96),l=n(159),c=r(l),f=n(165),d=r(f),p=n(166),h=r(p),y=n(167),v=r(y),m=n(36),b=function(e){return{search:{flex:"0 0 auto"},spacer:{flex:"1 1 100%"}}},g=function(e){var t=e.classes,n=e.createdByValue,r=e.searchValue,o=e.searchData,a=e.filterData;return i.default.createElement(h.default,null,i.default.createElement(d.default,{type:"search",label:"Search by name",className:t.search,value:r,onChange:o}),i.default.createElement("div",{className:t.spacer}),i.default.createElement(v.default,{title:"Filter list"},i.default.createElement(c.default,{disableUnderline:!0,value:n,onChange:a},i.default.createElement(s.MenuItem,{value:"all"},"Show all"),i.default.createElement(s.MenuItem,{value:"byme"},"Created by me"),i.default.createElement(s.MenuItem,{value:"byothers"},"Created by others"))))};g=(0,u.withStyles)(b)(g);var _=function(e){return{createdByValue:e.filtering.createdByValue,searchValue:e.filtering.searchValue}},w={searchData:m.searchData,filterData:m.filterData};t.default=(0,a.connect)(_,w)(g)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(140);Object.defineProperty(t,"createGenerateClassName",{enumerable:!0,get:function(){return r(o).default}});var i=n(88);Object.defineProperty(t,"createMuiTheme",{enumerable:!0,get:function(){return r(i).default}});var a=n(137);Object.defineProperty(t,"jssPreset",{enumerable:!0,get:function(){return r(a).default}});var u=n(358);Object.defineProperty(t,"MuiThemeProvider",{enumerable:!0,get:function(){return r(u).default}});var s=n(4);Object.defineProperty(t,"withStyles",{enumerable:!0,get:function(){return r(s).default}});var l=n(58);Object.defineProperty(t,"withTheme",{enumerable:!0,get:function(){return r(l).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),i=r(o),a=n(6),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=r(_),x=n(12),O=(r(x),n(359)),S=r(O),T=n(91),E=r(T),C=n(93),k=(r(C),function(e){function t(e,n){(0,f.default)(this,t);var r=(0,y.default)(this,(t.__proto__||(0,l.default)(t)).call(this,e,n));return r.broadcast=(0,S.default)(),r.unsubscribeId=null,r.outerTheme=null,r.outerTheme=E.default.initial(n),r.broadcast.setState(r.mergeOuterLocalTheme(r.props.theme)),r}return(0,m.default)(t,e),(0,p.default)(t,[{key:"getChildContext",value:function(){var e,t=this.props,n=t.sheetsManager,r=t.disableStylesGeneration,o=this.context.muiThemeProviderOptions||{};return void 0!==n&&(o.sheetsManager=n),void 0!==r&&(o.disableStylesGeneration=r),e={},(0,u.default)(e,T.CHANNEL,this.broadcast),(0,u.default)(e,"muiThemeProviderOptions",o),e}},{key:"componentDidMount",value:function(){var e=this;this.unsubscribeId=E.default.subscribe(this.context,function(t){e.outerTheme=t,e.broadcast.setState(e.mergeOuterLocalTheme(e.props.theme))})}},{key:"componentWillReceiveProps",value:function(e){this.props.theme!==e.theme&&this.broadcast.setState(this.mergeOuterLocalTheme(e.theme))}},{key:"componentWillUnmount",value:function(){null!==this.unsubscribeId&&E.default.unsubscribe(this.context,this.unsubscribeId)}},{key:"mergeOuterLocalTheme",value:function(e){return"function"==typeof e?e(this.outerTheme):this.outerTheme?(0,i.default)({},this.outerTheme,e):e}},{key:"render",value:function(){return this.props.children}}]),t}(g.default.Component));k.propTypes={},k.propTypes={},k.childContextTypes=(0,i.default)({},E.default.contextTypes,{muiThemeProviderOptions:w.default.object}),k.contextTypes=(0,i.default)({},E.default.contextTypes,{muiThemeProviderOptions:w.default.object}),t.default=k},function(e,t,n){"use strict";function r(e){function t(){return u}function n(e){u=e;for(var t=Object.keys(i),n=0,r=t.length;n<r;n++)i[t[n]]&&i[t[n]](e)}function r(e){if("function"!=typeof e)throw new Error("listener must be a function.");var t=a;return i[t]=e,a+=1,t}function o(e){i[e]=void 0}var i={},a=1,u=e;return{getState:t,setState:n,subscribe:r,unsubscribe:o}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(361);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=0;return"number"==typeof t?n=t:"center"===t?n=e.height/2:"bottom"===t&&(n=e.height),n}function i(e,t){var n=0;return"number"==typeof t?n=t:"center"===t?n=e.width/2:"right"===t&&(n=e.width),n}function a(e){return[e.horizontal,e.vertical].map(function(e){return"number"==typeof e?e+"px":e}).join(" ")}function u(e,t){for(var n=t,r=0;n&&n!==e;)n=n.parentNode,r+=n.scrollTop;return r}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var s=n(2),l=r(s),c=n(3),f=r(c),d=n(8),p=r(d),h=n(7),y=r(h),v=n(9),m=r(v),b=n(10),g=r(b),_=n(11),w=r(_),x=n(0),O=r(x),S=n(1),T=(r(S),n(18)),E=r(T),C=n(12),k=(r(C),n(56)),P=r(k),M=n(23),j=r(M),N=n(151),I=r(N),A=n(63),R=r(A),F=n(62),D=r(F),L=n(4),z=r(L),V=n(141),U=r(V),W=n(362),H=r(W),B=n(150),K=r(B),q=t.styles={paper:{position:"absolute",overflowY:"auto",overflowX:"hidden",minWidth:16,minHeight:16,maxWidth:"calc(100vw - 32px)",maxHeight:"calc(100vh - 32px)","&:focus":{outline:"none"}}},G=function(e){function t(){var e,n,r,u;(0,y.default)(this,t);for(var s=arguments.length,l=Array(s),c=0;c<s;c++)l[c]=arguments[c];return n=r=(0,g.default)(this,(e=t.__proto__||(0,p.default)(t)).call.apply(e,[this].concat(l))),r.componentWillUnmount=function(){r.handleResize.cancel()},r.setPositioningStyles=function(e){if(e&&e.style){var t=r.getPositioningStyle(e);e.style.top=t.top,e.style.left=t.left,e.style.transformOrigin=t.transformOrigin}},r.getPositioningStyle=function(e){var t=r.props,n=t.anchorEl,o=t.marginThreshold,i=r.getContentAnchorOffset(e),u=r.getAnchorOffset(i),s={width:e.clientWidth,height:e.clientHeight},l=r.getTransformOrigin(s,i),c=u.top-l.vertical,f=u.left-l.horizontal,d=c+s.height,p=f+s.width,h=(0,I.default)(n),y=h.innerHeight-o,v=h.innerWidth-o;if(c<o){var m=c-o;c-=m,l.vertical+=m}else if(d>y){var b=d-y;c-=b,l.vertical+=b}if(f<o){var g=f-o;f-=g,l.horizontal+=g}else if(p>v){var _=p-v;f-=_,l.horizontal+=_}return{top:c+"px",left:f+"px",transformOrigin:a(l)}},r.transitionEl=void 0,r.handleGetOffsetTop=o,r.handleGetOffsetLeft=i,r.handleEnter=function(e){r.props.onEnter&&r.props.onEnter(e),r.setPositioningStyles(e)},r.handleResize=(0,R.default)(function(){var e=E.default.findDOMNode(r.transitionEl);r.setPositioningStyles(e)},166),u=n,(0,g.default)(r,u)}return(0,w.default)(t,e),(0,m.default)(t,[{key:"componentDidMount",value:function(){this.props.action&&this.props.action({updatePosition:this.handleResize})}},{key:"getAnchorOffset",value:function(e){var t=this.props,n=t.anchorEl,r=t.anchorOrigin,o=t.anchorReference,i=t.anchorPosition;if("anchorPosition"===o)return i;var a=n||document.body,u=a.getBoundingClientRect(),s=0===e?r.vertical:"center";return{top:u.top+this.handleGetOffsetTop(u,s),left:u.left+this.handleGetOffsetLeft(u,r.horizontal)}}},{key:"getContentAnchorOffset",value:function(e){var t=this.props,n=t.getContentAnchorEl,r=t.anchorReference,o=0;if(n&&"anchorEl"===r){var i=n(e);if(i&&(0,P.default)(e,i)){var a=u(e,i);o=i.offsetTop+i.clientHeight/2-a||0}}return o}},{key:"getTransformOrigin",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.props.transformOrigin;return{vertical:this.handleGetOffsetTop(e,n.vertical)+t,horizontal:this.handleGetOffsetLeft(e,n.horizontal)}}},{key:"render",value:function(){var e=this,t=this.props,n=t.anchorEl,r=(t.anchorOrigin,t.anchorPosition,t.anchorReference,t.children),o=t.classes,i=t.container,a=t.elevation,u=(t.getContentAnchorEl,t.marginThreshold,t.onEnter,t.onEntered),s=t.onEntering,c=t.onExit,d=t.onExited,p=t.onExiting,h=t.open,y=t.PaperProps,v=t.role,m=(t.transformOrigin,t.transition),b=t.transitionDuration,g=(t.action,(0,f.default)(t,["anchorEl","anchorOrigin","anchorPosition","anchorReference","children","classes","container","elevation","getContentAnchorEl","marginThreshold","onEnter","onEntered","onEntering","onExit","onExited","onExiting","open","PaperProps","role","transformOrigin","transition","transitionDuration","action"])),_=i||(n?(0,j.default)(n).body:void 0),w={};return m===H.default&&(w.timeout=b),O.default.createElement(U.default,(0,l.default)({container:_,open:h,BackdropProps:{invisible:!0}},g),O.default.createElement(m,(0,l.default)({appear:!0,in:h,onEnter:this.handleEnter,onEntered:u,onEntering:s,onExit:c,onExited:d,onExiting:p,role:v,ref:function(t){e.transitionEl=t}},w),O.default.createElement(K.default,(0,l.default)({className:o.paper,elevation:a},y),O.default.createElement(D.default,{target:"window",onResize:this.handleResize}),r)))}}]),t}(O.default.Component);G.propTypes={},G.defaultProps={anchorReference:"anchorEl",anchorOrigin:{vertical:"top",horizontal:"left"},elevation:8,marginThreshold:16,transformOrigin:{vertical:"top",horizontal:"left"},transition:H.default,transitionDuration:"auto"},t.default=(0,z.default)(q,{name:"MuiPopover"})(G)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return"scale("+e+", "+Math.pow(e,2)+")"}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),a=r(i),u=n(3),s=r(u),l=n(8),c=r(l),f=n(7),d=r(f),p=n(9),h=r(p),y=n(10),v=r(y),m=n(11),b=r(m),g=n(0),_=r(g),w=n(1),x=(r(w),n(94)),O=r(x),S=n(58),T=r(S),E=n(149),C={entering:{opacity:1,transform:o(1)},entered:{opacity:1,transform:o(1)}},k=function(e){function t(){var e,n,r,i;(0,d.default)(this,t);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(u))),r.autoTimeout=void 0,r.timer=null,r.handleEnter=function(e){var t=r.props,n=t.theme,o=t.timeout;(0,E.reflow)(e);var i=(0,E.getTransitionProps)(r.props,{mode:"enter"}),a=i.duration,u=i.delay,s=0;"auto"===o?(s=n.transitions.getAutoHeightDuration(e.clientHeight),r.autoTimeout=s):s=a,e.style.transition=[n.transitions.create("opacity",{duration:s,delay:u}),n.transitions.create("transform",{duration:.666*s,delay:u})].join(","),r.props.onEnter&&r.props.onEnter(e)},r.handleExit=function(e){var t=r.props,n=t.theme,i=t.timeout,a=0,u=(0,E.getTransitionProps)(r.props,{mode:"exit"}),s=u.duration,l=u.delay;"auto"===i?(a=n.transitions.getAutoHeightDuration(e.clientHeight),r.autoTimeout=a):a=s,e.style.transition=[n.transitions.create("opacity",{duration:a,delay:l}),n.transitions.create("transform",{duration:.666*a,delay:l||.333*a})].join(","),e.style.opacity="0",e.style.transform=o(.75),r.props.onExit&&r.props.onExit(e)},r.addEndListener=function(e,t){"auto"===r.props.timeout&&(r.timer=setTimeout(t,r.autoTimeout||0))},i=n,(0,v.default)(r,i)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillUnmount",value:function(){clearTimeout(this.timer)}},{key:"render",value:function(){var e=this.props,t=e.children,n=(e.onEnter,e.onExit,e.style),r=(e.theme,e.timeout),i=(0,s.default)(e,["children","onEnter","onExit","style","theme","timeout"]),u=(0,a.default)({},n,_.default.isValidElement(t)?t.props.style:{});return _.default.createElement(O.default,(0,a.default)({appear:!0,onEnter:this.handleEnter,onExit:this.handleExit,addEndListener:this.addEndListener,timeout:"auto"===r?null:r},i),function(e,n){return _.default.cloneElement(t,(0,a.default)({style:(0,a.default)({opacity:0,transform:o(.75)},C[e],u)},n))})}}]),t}(_.default.Component);k.propTypes={},k.defaultProps={timeout:"auto"},t.default=(0,T.default)()(k)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(6),u=r(a),s=n(3),l=r(s),c=n(8),f=r(c),d=n(7),p=r(d),h=n(9),y=r(h),v=n(10),m=r(v),b=n(11),g=r(b),_=n(0),w=r(_),x=n(1),O=r(x),S=n(5),T=r(S),E=n(4),C=r(E),k=t.styles=function(e){return{root:{flex:"1 1 auto",listStyle:"none",margin:0,padding:0,position:"relative"},padding:{paddingTop:e.spacing.unit,paddingBottom:e.spacing.unit},dense:{paddingTop:e.spacing.unit/2,paddingBottom:e.spacing.unit/2},subheader:{paddingTop:0}}},P=function(e){function t(){return(0,p.default)(this,t),(0,m.default)(this,(t.__proto__||(0,f.default)(t)).apply(this,arguments))}return(0,g.default)(t,e),(0,y.default)(t,[{key:"getChildContext",value:function(){return{dense:this.props.dense}}},{key:"render",value:function(){var e,t=this.props,n=t.children,r=t.classes,o=t.className,a=t.component,s=t.dense,c=t.disablePadding,f=t.subheader,d=(0,l.default)(t,["children","classes","className","component","dense","disablePadding","subheader"]),p=(0,T.default)(r.root,(e={},(0,u.default)(e,r.dense,s&&!c),(0,u.default)(e,r.padding,!c),(0,u.default)(e,r.subheader,f),e),o);return w.default.createElement(a,(0,i.default)({className:p},d),f,n)}}]),t}(w.default.Component);P.propTypes={},P.defaultProps={component:"ul",dense:!1,disablePadding:!1},P.childContextTypes={dense:O.default.bool},t.default=(0,C.default)(k,{name:"MuiList"})(P)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.children,r=e.classes,o=e.className,i=(0,c.default)(e,["children","classes","className"]);return void 0===t.dense?e.children:d.default.cloneElement(n,(0,s.default)({className:(0,v.default)((0,a.default)({},r.root,t.dense),o,n.props.className),childrenClassName:(0,v.default)((0,a.default)({},r.icon,t.dense),n.props.childrenClassName)},i))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(6),a=r(i),u=n(2),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(12),b=(r(m),n(4)),g=r(b),_=t.styles=function(e){return{root:{width:36,height:36,fontSize:e.typography.pxToRem(18),marginRight:4},icon:{width:20,height:20,fontSize:e.typography.pxToRem(20)}}};o.propTypes={},o.contextTypes={dense:h.default.bool},o.muiName="ListItemAvatar",t.default=(0,g.default)(_,{name:"MuiListItemAvatar"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.classes,o=e.className,i=e.disableTypography,u=e.inset,l=e.primary,f=e.secondary,p=(0,c.default)(e,["classes","className","disableTypography","inset","primary","secondary"]),h=t.dense,y=(0,v.default)(r.root,(n={},(0,s.default)(n,r.dense,h),(0,s.default)(n,r.inset,u),n),o);return d.default.createElement("div",(0,a.default)({className:y},p),l&&(i?l:d.default.createElement(_.default,{variant:"subheading",className:(0,v.default)(r.primary,(0,s.default)({},r.textDense,h))},l)),f&&(i?f:d.default.createElement(_.default,{variant:"body1",className:(0,v.default)(r.secondary,(0,s.default)({},r.textDense,h)),color:"textSecondary"},f)))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=n(43),_=r(g),w=t.styles=function(e){return{root:{flex:"1 1 auto",minWidth:0,padding:"0 16px","&:first-child":{paddingLeft:0}},inset:{"&:first-child":{paddingLeft:7*e.spacing.unit}},dense:{fontSize:e.typography.pxToRem(13)},primary:{"&$textDense":{fontSize:"inherit"}},secondary:{"&$textDense":{fontSize:"inherit"}},textDense:{}}};o.propTypes={},o.defaultProps={disableTypography:!1,inset:!1,primary:!1,secondary:!1},o.contextTypes={dense:h.default.bool},t.default=(0,b.default)(w,{name:"MuiListItemText"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=(0,s.default)(e,["children","classes","className"]);return c.default.cloneElement(t,(0,a.default)({className:(0,p.default)(n.root,r,t.props.className)},o))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h),v=t.styles=function(e){return{root:{height:24,marginRight:2*e.spacing.unit,width:24,color:e.palette.action.active,flexShrink:0}}};o.propTypes={},t.default=(0,y.default)(v,{name:"MuiListItemIcon"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=(0,s.default)(e,["children","classes","className"]);return c.default.createElement("div",(0,a.default)({className:(0,p.default)(n.root,r)},o),t)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(1),d=(r(f),n(5)),p=r(d),h=n(4),y=r(h),v=t.styles=function(e){return{root:{position:"absolute",right:4,top:"50%",marginTop:3*-e.spacing.unit}}};o.propTypes={},o.muiName="ListItemSecondaryAction",t.default=(0,y.default)(v,{name:"MuiListItemSecondaryAction"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.classes,r=e.className,o=e.color,i=e.component,u=e.disableSticky,l=e.inset,f=(0,c.default)(e,["classes","className","color","component","disableSticky","inset"]),p=(0,y.default)(n.root,(t={},(0,s.default)(t,n["color"+(0,b.capitalize)(o)],"default"!==o),(0,s.default)(t,n.inset,l),(0,s.default)(t,n.sticky,!u),t),r);return d.default.createElement(i,(0,a.default)({className:p},f))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(21),g=t.styles=function(e){return{root:{boxSizing:"border-box",lineHeight:"48px",listStyle:"none",paddingLeft:2*e.spacing.unit,paddingRight:2*e.spacing.unit,color:e.palette.text.secondary,fontFamily:e.typography.fontFamily,fontWeight:e.typography.fontWeightMedium,fontSize:e.typography.pxToRem(e.typography.fontSize)},colorPrimary:{color:e.palette.primary.main},colorInherit:{color:"inherit"},inset:{paddingLeft:9*e.spacing.unit},sticky:{position:"sticky",top:0,zIndex:1,backgroundColor:"inherit"}}};o.propTypes={},o.defaultProps={color:"default",component:"li",disableSticky:!1,inset:!1},o.muiName="ListSubheader",t.default=(0,m.default)(g,{name:"MuiListSubheader"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.classes,n=e.className,r=e.component,o=e.selected,i=e.role,u=(0,s.default)(e,["classes","className","component","selected","role"]),l=(0,y.default)(t.root,(0,a.default)({},t.selected,o),n);return d.default.createElement(g.default,(0,c.default)({button:!0,role:i,tabIndex:-1,className:l,component:r},u))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(6),a=r(i),u=n(3),s=r(u),l=n(2),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(158),g=r(b),_=t.styles=function(e){return{root:(0,c.default)({},e.typography.subheading,{height:3*e.spacing.unit,boxSizing:"content-box",width:"auto",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap","&$selected":{backgroundColor:e.palette.action.selected}}),selected:{}}};o.propTypes={},o.defaultProps={component:"li",role:"menuitem",selected:!1},t.default=(0,m.default)(_,{name:"MuiMenuItem"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(6),i=r(o),a=n(3),u=r(a),s=n(2),l=r(s),c=n(95),f=r(c),d=n(8),p=r(d),h=n(7),y=r(h),v=n(9),m=r(v),b=n(10),g=r(b),_=n(11),w=r(_),x=n(0),O=r(x),S=n(1),T=(r(S),n(5)),E=r(T),C=n(42),k=r(C),P=n(12),M=(r(P),n(371)),j=r(M),N=n(155),I=r(N),A=n(97),R=function(e){function t(){var e,n,r,o;(0,y.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,g.default)(this,(e=t.__proto__||(0,p.default)(t)).call.apply(e,[this].concat(a))),r.state={open:!1},r.ignoreNextBlur=!1,r.displayNode=null,r.isControlled=void 0!==r.props.open,r.update=r.isControlled?function(e){var t=e.event;e.open?r.props.onOpen(t):r.props.onClose(t)}:function(e){var t=e.open;return r.setState({open:t})},r.handleClick=function(e){r.ignoreNextBlur=!0,r.update({open:!0,event:e})},r.handleClose=function(e){r.update({open:!1,event:e})},r.handleItemClick=function(e){return function(t){r.props.multiple||r.update({open:!1,event:t});var n=r.props,o=n.onChange,i=n.name;if(o){var a=void 0,u=void 0;if(t.target&&(u=t.target),r.props.multiple){a=Array.isArray(r.props.value)?[].concat((0,f.default)(r.props.value)):[];var s=a.indexOf(e.props.value);-1===s?a.push(e.props.value):a.splice(s,1)}else a=e.props.value;t.persist(),t.target=(0,l.default)({},u,{value:a,name:i}),o(t,e)}}},r.handleBlur=function(e){if(!0===r.ignoreNextBlur)return e.stopPropagation(),void(r.ignoreNextBlur=!1);r.props.onBlur&&r.props.onBlur(e)},r.handleKeyDown=function(e){r.props.readOnly||["space","up","down"].includes((0,k.default)(e))&&(e.preventDefault(),r.ignoreNextBlur=!0,r.update({open:!0,event:e}))},r.handleSelectRef=function(e){r.props.inputRef&&r.props.inputRef({node:e,value:r.props.value})},o=n,(0,g.default)(r,o)}return(0,w.default)(t,e),(0,m.default)(t,[{key:"componentDidMount",value:function(){this.isControlled&&this.props.open&&(this.displayNode.focus(),this.forceUpdate())}},{key:"render",value:function(){var e=this,t=this.props,n=t.autoWidth,r=t.children,o=t.classes,a=t.className,s=t.disabled,c=t.displayEmpty,f=t.inputRef,d=t.MenuProps,p=void 0===d?{}:d,h=t.multiple,y=t.name,v=t.native,m=t.onBlur,b=t.onChange,g=(t.onClose,t.onFocus),_=(t.onOpen,t.open),w=t.readOnly,x=t.renderValue,S=t.value,T=(0,u.default)(t,["autoWidth","children","classes","className","disabled","displayEmpty","inputRef","MenuProps","multiple","name","native","onBlur","onChange","onClose","onFocus","onOpen","open","readOnly","renderValue","value"]),C=this.isControlled&&this.displayNode?_:this.state.open;if(v)return O.default.createElement("div",{className:o.root},O.default.createElement("select",(0,l.default)({className:(0,E.default)(o.select,(0,i.default)({},o.disabled,s),a),name:y,disabled:s,onBlur:m,onChange:b,onFocus:g,value:S,readOnly:w,ref:f},T),r),O.default.createElement(j.default,{className:o.icon}));if(void 0===S)throw new Error("Material-UI: the `value` property is required when using the `Select` component with `native=false`.");var k=void 0,P="",M=[],N=!1;((0,A.isDirty)(this.props)||c)&&(x?k=x(S):N=!0);var R=O.default.Children.map(r,function(t){if(!O.default.isValidElement(t))return null;var n=void 0;if(h){if(!Array.isArray(S))throw new Error("Material-UI: the `value` property must be an array when using the `Select` component with `multiple`.");n=-1!==S.indexOf(t.props.value),n&&N&&M.push(t.props.children)}else(n=S===t.props.value)&&N&&(P=t.props.children);return O.default.cloneElement(t,{role:"option",selected:n,onClick:e.handleItemClick(t)})});N&&(k=h?M.join(", "):P);var F=this.displayNode&&!n?this.displayNode.clientWidth:void 0;return O.default.createElement("div",{className:o.root},O.default.createElement("div",{className:(0,E.default)(o.select,o.selectMenu,(0,i.default)({},o.disabled,s),a),ref:function(t){e.displayNode=t},"aria-pressed":C?"true":"false",tabIndex:s?null:0,role:"button","aria-owns":C?"menu-"+(y||""):null,"aria-haspopup":"true",onKeyDown:this.handleKeyDown,onBlur:this.handleBlur,onClick:s||w?null:this.handleClick,onFocus:g},k),O.default.createElement("input",(0,l.default)({value:Array.isArray(S)?S.join(","):S,name:y,readOnly:w,ref:this.handleSelectRef},T,{type:"hidden"})),O.default.createElement(j.default,{className:o.icon}),O.default.createElement(I.default,(0,l.default)({id:"menu-"+(y||""),anchorEl:this.displayNode,open:C,onClose:this.handleClose},p,{MenuListProps:(0,l.default)({role:"listbox"},p.MenuListProps),PaperProps:(0,l.default)({},p.PaperProps,{style:(0,l.default)({minWidth:F},null!=p.PaperProps?p.PaperProps.style:null)})}),R))}}]),t}(O.default.Component);R.propTypes={},t.default=R},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=i.default.createElement("path",{d:"M7 10l5 5 5-5z"}),f=function(e){return i.default.createElement(l.default,e,c)};f=(0,u.default)(f),f.muiName="SvgIcon",t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),s=n(161),l=(r(s),n(40)),c=(r(l),function(e){return function(t){var n=(0,u.createFactory)(t),r=function(t){function r(){return o(this,r),i(this,t.apply(this,arguments))}return a(r,t),r.prototype.shouldComponentUpdate=function(t){return e(this.props,t)},r.prototype.render=function(){return n(this.props)},r}(u.Component);return r}});t.default=c},function(e,t,n){"use strict";t.__esModule=!0;var r=function(e,t){return function(n){return n[e]=t,n}};t.default=r},function(e,t,n){"use strict";t.__esModule=!0;var r=n(92),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.children,r=e.classes,o=e.className,i=e.color,u=e.fontSize,l=e.nativeColor,f=e.titleAccess,p=e.viewBox,h=(0,c.default)(e,["children","classes","className","color","fontSize","nativeColor","titleAccess","viewBox"]),v=(0,y.default)(r.root,(t={},(0,s.default)(t,r["color"+(0,b.capitalize)(i)],"inherit"!==i),(0,s.default)(t,r.fontSize,u),t),o);return d.default.createElement("svg",(0,a.default)({className:v,focusable:"false",viewBox:p,color:l,"aria-hidden":f?"false":"true"},h),f?d.default.createElement("title",null,f):null,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(21),g=t.styles=function(e){return{root:{display:"inline-block",fill:"currentColor",height:24,width:24,userSelect:"none",flexShrink:0,transition:e.transitions.create("fill",{duration:e.transitions.duration.shorter})},colorPrimary:{color:e.palette.primary.main},colorSecondary:{color:e.palette.secondary.main},colorAction:{color:e.palette.action.active},colorDisabled:{color:e.palette.action.disabled},colorError:{color:e.palette.error.main},fontSize:{width:"1em",height:"1em"}}};o.propTypes={},o.defaultProps={color:"inherit",fontSize:!1,viewBox:"0 0 24 24"},o.muiName="SvgIcon",t.default=(0,m.default)(g,{name:"MuiSvgIcon"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(5)),x=r(w),O=n(63),S=r(O),T=n(62),E=r(T),C=n(4),k=r(C),P=t.styles={root:{position:"relative",width:"100%"},textarea:{width:"100%",height:"100%",resize:"none",font:"inherit",padding:0,cursor:"inherit",boxSizing:"border-box",lineHeight:"inherit",border:"none",outline:"none",background:"transparent"},shadow:{resize:"none",overflow:"hidden",visibility:"hidden",position:"absolute",height:"auto",whiteSpace:"pre-wrap"}},M=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.state={height:null},r.shadow=null,r.singlelineShadow=null,r.input=null,r.value=null,r.handleResize=(0,S.default)(function(e){r.syncHeightWithShadow(e)},166),r.handleRefInput=function(e){r.input=e,r.props.textareaRef&&r.props.textareaRef(e)},r.handleRefSinglelineShadow=function(e){r.singlelineShadow=e},r.handleRefShadow=function(e){r.shadow=e},r.handleChange=function(e){r.value=e.target.value,void 0===r.props.value&&r.shadow&&(r.shadow.value=r.value,r.syncHeightWithShadow(e)),r.props.onChange&&r.props.onChange(e)},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentWillMount",value:function(){this.value=this.props.value||this.props.defaultValue||"",this.setState({height:19*Number(this.props.rows)})}},{key:"componentDidMount",value:function(){this.syncHeightWithShadow(null)}},{key:"componentWillReceiveProps",value:function(e){e.value===this.props.value&&Number(e.rowsMax)===Number(this.props.rowsMax)||this.syncHeightWithShadow(null,e)}},{key:"componentWillUnmount",value:function(){this.handleResize.cancel()}},{key:"syncHeightWithShadow",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.props;if(this.shadow&&this.singlelineShadow){void 0!==this.props.value&&(this.shadow.value=null==t.value?"":String(t.value));var n=this.singlelineShadow.scrollHeight,r=this.shadow.scrollHeight;if(void 0===r)return;Number(t.rowsMax)>=Number(t.rows)&&(r=Math.min(Number(t.rowsMax)*n,r)),r=Math.max(r,n),this.state.height!==r&&this.setState({height:r})}}},{key:"render",value:function(){var e=this.props,t=e.classes,n=e.className,r=e.defaultValue,o=(e.onChange,e.rows),a=(e.rowsMax,e.textareaRef,e.value),s=(0,u.default)(e,["classes","className","defaultValue","onChange","rows","rowsMax","textareaRef","value"]);return g.default.createElement("div",{className:t.root,style:{height:this.state.height}},g.default.createElement(E.default,{target:"window",onResize:this.handleResize}),g.default.createElement("textarea",{ref:this.handleRefSinglelineShadow,className:(0,x.default)(t.shadow,t.textarea),tabIndex:-1,rows:"1",readOnly:!0,"aria-hidden":"true",value:""}),g.default.createElement("textarea",{ref:this.handleRefShadow,className:(0,x.default)(t.shadow,t.textarea),tabIndex:-1,rows:o,"aria-hidden":"true",readOnly:!0,defaultValue:r,value:a}),g.default.createElement("textarea",(0,i.default)({rows:o,className:(0,x.default)(t.textarea,n),defaultValue:r,value:a,onChange:this.handleChange,ref:this.handleRefInput},s)))}}]),t}(g.default.Component);M.propTypes={},M.defaultProps={rows:1},t.default=(0,k.default)(P,{name:"MuiTextarea"})(M)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.children,r=e.component,o=e.classes,i=e.className,u=e.disableTypography,l=e.position,f=(0,c.default)(e,["children","component","classes","className","disableTypography","position"]);return d.default.createElement(r,(0,a.default)({className:(0,y.default)(o.root,(t={},(0,s.default)(t,o.positionStart,"start"===l),(0,s.default)(t,o.positionEnd,"end"===l),t),i)},f),"string"!=typeof n||u?n:d.default.createElement(m.default,{color:"textSecondary"},n))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(43),m=r(v),b=n(4),g=r(b),_=t.styles=function(e){return{root:{display:"flex",maxHeight:"2em",alignItems:"center"},positionStart:{marginRight:e.spacing.unit},positionEnd:{marginLeft:e.spacing.unit}}};o.propTypes={},o.defaultProps={component:"div",disableTypography:!1},t.default=(0,g.default)(_,{name:"MuiInputAdornment"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.children,o=e.classes,i=e.className,u=e.disableAnimation,l=e.disabled,f=e.FormControlClasses,p=e.margin,h=e.shrink,y=(0,c.default)(e,["children","classes","className","disableAnimation","disabled","FormControlClasses","margin","shrink"]),m=t.muiFormControl,b=h;void 0===b&&m&&(b=m.dirty||m.focused||m.adornedStart);var _=p;void 0===_&&m&&(_=m.margin);var w=(0,v.default)(o.root,(n={},(0,s.default)(n,o.formControl,m),(0,s.default)(n,o.animated,!u),(0,s.default)(n,o.shrink,b),(0,s.default)(n,o.disabled,l),(0,s.default)(n,o.labelDense,"dense"===_),n),i);return d.default.createElement(g.FormLabel,(0,a.default)({"data-shrink":b,className:w,classes:f},y),r)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=n(162),_=t.styles=function(e){return{root:{transformOrigin:"top left"},formControl:{position:"absolute",left:0,top:0,transform:"translate(0, "+3*e.spacing.unit+"px) scale(1)"},labelDense:{transform:"translate(0, "+(2.5*e.spacing.unit+1)+"px) scale(1)"},shrink:{transform:"translate(0, 1.5px) scale(0.75)",transformOrigin:"top left"},animated:{transition:e.transitions.create("transform",{duration:e.transitions.duration.shorter,easing:e.transitions.easing.easeOut})},disabled:{color:e.palette.text.disabled}}};o.propTypes={},o.defaultProps={disabled:!1,disableAnimation:!1},o.contextTypes={muiFormControl:h.default.object},t.default=(0,b.default)(_,{name:"MuiInputLabel"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.classes,n=e.className,r=e.children,o=e.row,i=(0,c.default)(e,["classes","className","children","row"]),u=(0,y.default)(t.root,(0,s.default)({},t.row,o),n);return d.default.createElement("div",(0,a.default)({className:u},i),r)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=t.styles={root:{display:"flex",flexDirection:"column",flexWrap:"wrap"},row:{flexDirection:"row"}};o.propTypes={},o.defaultProps={row:!1},t.default=(0,m.default)(b,{name:"MuiFormGroup"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.children,o=e.classes,i=e.className,u=e.component,l=e.disabled,f=e.error,p=e.focused,h=e.required,y=(0,c.default)(e,["children","classes","className","component","disabled","error","focused","required"]),m=t.muiFormControl,b=h,g=p,_=l,w=f;m&&(void 0===b&&(b=m.required),void 0===g&&(g=m.focused),void 0===_&&(_=m.disabled),void 0===w&&(w=m.error));var x=(0,v.default)(o.root,(n={},(0,s.default)(n,o.focused,g),(0,s.default)(n,o.disabled,_),(0,s.default)(n,o.error,w),n),i),O=(0,v.default)((0,s.default)({},o.error,w));return d.default.createElement(u,(0,a.default)({className:x},y),r,b&&d.default.createElement("span",{className:O}," *"))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=t.styles=function(e){return{root:{fontFamily:e.typography.fontFamily,color:e.palette.text.secondary,fontSize:e.typography.pxToRem(16),lineHeight:1,padding:0},focused:{color:e.palette.primary["light"===e.palette.type?"dark":"light"]},error:{color:e.palette.error.main},disabled:{color:e.palette.text.disabled}}};o.propTypes={},o.defaultProps={component:"label"},o.contextTypes={muiFormControl:h.default.object},t.default=(0,b.default)(g,{name:"MuiFormLabel"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.checked,r=e.classes,o=e.className,i=e.control,u=e.disabled,l=e.inputRef,f=e.label,p=e.name,h=e.onChange,y=e.value,m=(0,c.default)(e,["checked","classes","className","control","disabled","inputRef","label","name","onChange","value"]),b=t.muiFormControl,g=u;void 0!==i.props.disabled&&void 0===g&&(g=i.props.disabled),b&&void 0===g&&(g=b.disabled);var w=(0,v.default)(r.root,(0,s.default)({},r.disabled,g),o);return d.default.createElement("label",(0,a.default)({className:w},m),d.default.cloneElement(i,{disabled:g,checked:void 0===i.props.checked?n:i.props.checked,name:i.props.name||p,onChange:i.props.onChange||h,value:i.props.value||y,inputRef:i.props.inputRef||l}),d.default.createElement(_.default,{component:"span",className:r.label},f))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=n(43),_=r(g),w=t.styles=function(e){return{root:{display:"inline-flex",alignItems:"center",cursor:"pointer",verticalAlign:"middle",WebkitTapHighlightColor:"transparent",marginLeft:-14,marginRight:2*e.spacing.unit},disabled:{color:e.palette.text.disabled,cursor:"default"},label:{}}};o.propTypes={},o.contextTypes={muiFormControl:h.default.object},t.default=(0,b.default)(w,{name:"MuiFormControlLabel"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.autoComplete,n=e.autoFocus,r=e.children,o=e.className,i=e.defaultValue,u=e.disabled,l=e.error,f=e.FormHelperTextProps,d=e.fullWidth,y=e.helperText,m=e.helperTextClassName,g=e.id,w=e.InputLabelProps,x=e.inputProps,O=e.InputProps,S=e.inputRef,T=e.label,E=e.labelClassName,C=e.multiline,k=e.name,P=e.onChange,M=e.placeholder,j=e.required,N=e.rows,I=e.rowsMax,A=e.select,R=e.SelectProps,F=e.type,D=e.value,L=(0,s.default)(e,["autoComplete","autoFocus","children","className","defaultValue","disabled","error","FormHelperTextProps","fullWidth","helperText","helperTextClassName","id","InputLabelProps","inputProps","InputProps","inputRef","label","labelClassName","multiline","name","onChange","placeholder","required","rows","rowsMax","select","SelectProps","type","value"]),z=y&&g?g+"-helper-text":void 0,V=c.default.createElement(h.default,(0,a.default)({autoComplete:t,autoFocus:n,defaultValue:i,disabled:u,fullWidth:d,multiline:C,name:k,rows:N,rowsMax:I,type:F,value:D,id:g,inputRef:S,onChange:P,placeholder:M,inputProps:x},O));return c.default.createElement(v.default,(0,a.default)({"aria-describedby":z,className:o,error:l,fullWidth:d,required:j},L),T&&c.default.createElement(p.InputLabel,(0,a.default)({htmlFor:g,className:E},w),T),A?c.default.createElement(_.default,(0,a.default)({value:D,input:V},R),r):V,y&&c.default.createElement(b.default,(0,a.default)({className:m,id:z},f),y))}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),a=r(i),u=n(3),s=r(u),l=n(0),c=r(l),f=n(12),d=(r(f),n(1)),p=(r(d),n(98)),h=r(p),y=n(163),v=r(y),m=n(164),b=r(m),g=n(160),_=r(g);o.propTypes={},o.defaultProps={required:!1,select:!1},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.children,n=e.classes,r=e.className,o=e.disableGutters,i=(0,s.default)(e,["children","classes","className","disableGutters"]),u=(0,y.default)(n.root,(0,a.default)({},n.gutters,!o),r);return d.default.createElement("div",(0,c.default)({className:u},i),t)}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(6),a=r(i),u=n(3),s=r(u),l=n(2),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=t.styles=function(e){return{root:(0,c.default)({position:"relative",display:"flex",alignItems:"center"},e.mixins.toolbar),gutters:e.mixins.gutters({})}};o.propTypes={},o.defaultProps={disableGutters:!1},t.default=(0,m.default)(b,{name:"MuiToolbar"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){switch(e){case"bottom-end":return"bottom-start";case"bottom-start":return"bottom-end";case"top-end":return"top-start";case"top-start":return"top-end";default:return e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(3),s=r(u),l=n(8),c=r(l),f=n(7),d=r(f),p=n(9),h=r(p),y=n(10),v=r(y),m=n(11),b=r(m),g=n(6),_=r(g),w=n(0),x=r(w),O=n(1),S=(r(O),n(18)),T=n(62),E=r(T),C=n(63),k=r(C),P=n(12),M=(r(P),n(5)),j=r(M),N=n(385),I=n(21),A=n(143),R=r(A),F=n(139),D=r(F),L=n(4),z=r(L),V=t.styles=function(e){return{root:{display:"inline",flexDirection:"inherit"},popper:{zIndex:e.zIndex.tooltip},popperClose:{pointerEvents:"none"},tooltip:(0,_.default)({backgroundColor:e.palette.grey[700],borderRadius:2,color:D.default.white,fontFamily:e.typography.fontFamily,opacity:0,transform:"scale(0)",transition:e.transitions.create(["opacity","transform"],{duration:e.transitions.duration.shortest}),minHeight:0,padding:e.spacing.unit,fontSize:e.typography.pxToRem(14),lineHeight:e.typography.round(16/14)+"em"},e.breakpoints.up("sm"),{padding:e.spacing.unit/2+"px "+e.spacing.unit+"px",fontSize:e.typography.pxToRem(10),lineHeight:e.typography.round(1.4)+"em"}),tooltipLeft:(0,_.default)({transformOrigin:"right center",margin:"0 "+3*e.spacing.unit+"px"},e.breakpoints.up("sm"),{margin:"0 14px"}),tooltipRight:(0,_.default)({transformOrigin:"left center",margin:"0 "+3*e.spacing.unit+"px"},e.breakpoints.up("sm"),{margin:"0 14px"}),tooltipTop:(0,_.default)({transformOrigin:"center bottom",margin:3*e.spacing.unit+"px 0"},e.breakpoints.up("sm"),{margin:"14px 0"}),tooltipBottom:(0,_.default)({transformOrigin:"center top",margin:3*e.spacing.unit+"px 0"},e.breakpoints.up("sm"),{margin:"14px 0"}),tooltipOpen:{opacity:.9,transform:"scale(1)"}}},U=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={},r.enterTimer=null,r.leaveTimer=null,r.touchTimer=null,r.isControlled=null,r.popper=null,r.children=null,r.ignoreNonTouchEvents=!1,r.handleResize=(0,k.default)(function(){r.popper&&r.popper._popper.scheduleUpdate()},166),r.handleRequestOpen=function(e){var t=r.props.children,n=t.props;"focus"===e.type&&n.onFocus&&n.onFocus(e),"mouseover"===e.type&&n.onMouseOver&&n.onMouseOver(e),r.ignoreNonTouchEvents&&"touchstart"!==e.type||(clearTimeout(r.leaveTimer),r.props.enterDelay>0?r.leaveTimer=setTimeout(function(){r.requestOpen(e)},r.props.enterDelay):r.requestOpen(e))},r.requestOpen=function(e){r.isControlled||r.setState({open:!0}),r.props.onOpen&&r.props.onOpen(e,!0)},r.handleClose=function(e){var t=r.props.children,n=t.props;"blur"===e.type&&n.onBlur&&n.onBlur(e),"mouseleave"===e.type&&n.onMouseLeave&&n.onMouseLeave(e),clearTimeout(r.leaveTimer),r.props.leaveDelay?r.leaveTimer=setTimeout(function(){r.requestClose(e)},r.props.leaveDelay):r.requestClose(e)},r.requestClose=function(e){r.ignoreNonTouchEvents=!1,r.isControlled||r.setState({open:!1}),r.props.onClose&&r.props.onClose(e,!1)},r.handleTouchStart=function(e){r.ignoreNonTouchEvents=!0;var t=r.props.children,n=t.props;n.onTouchStart&&n.onTouchStart(e),clearTimeout(r.touchTimer),e.persist(),r.touchTimer=setTimeout(function(){r.handleRequestOpen(e)},1e3)},r.handleTouchEnd=function(e){var t=r.props.children,n=t.props;n.onTouchEnd&&n.onTouchEnd(e),clearTimeout(r.touchTimer),clearTimeout(r.leaveTimer),e.persist(),r.leaveTimer=setTimeout(function(){r.requestClose(e)},1500+r.props.leaveDelay)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){var e=this.props;this.isControlled=null!=e.open,this.isControlled||this.setState({open:!1})}},{key:"componentDidMount",value:function(){}},{key:"componentWillUnmount",value:function(){clearTimeout(this.enterTimer),clearTimeout(this.leaveTimer),this.handleResize.cancel()}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,r=t.classes,i=t.className,u=t.disableTriggerFocus,l=t.disableTriggerHover,c=t.disableTriggerTouch,f=(t.enterDelay,t.id),d=(t.leaveDelay,t.onClose,t.onOpen,t.open),p=t.placement,h=t.PopperProps;h=void 0===h?{}:h;var y=h.PopperClassName,v=(0,s.default)(h,["PopperClassName"]),m=t.theme,b=t.title,g=(0,s.default)(t,["children","classes","className","disableTriggerFocus","disableTriggerHover","disableTriggerTouch","enterDelay","id","leaveDelay","onClose","onOpen","open","placement","PopperProps","theme","title"]),w="rtl"===m.direction?o(p):p,O=this.isControlled?d:this.state.open,T={};return""===b&&(O=!1),T["aria-describedby"]=f,c||(T.onTouchStart=this.handleTouchStart,T.onTouchEnd=this.handleTouchEnd),l||(T.onMouseOver=this.handleRequestOpen,T.onMouseLeave=this.handleClose),u||(T.onFocus=this.handleRequestOpen,T.onBlur=this.handleClose),x.default.createElement(E.default,{target:"window",onResize:this.handleResize},x.default.createElement(N.Manager,(0,a.default)({className:(0,j.default)(r.root,i)},g),x.default.createElement(N.Target,null,function(t){var r=t.targetProps;return x.default.createElement(R.default,{ref:function(t){e.children=(0,S.findDOMNode)(t),r.ref(e.children)}},x.default.cloneElement(n,T))}),x.default.createElement(N.Popper,(0,a.default)({placement:w,eventsEnabled:O,className:(0,j.default)(r.popper,(0,_.default)({},r.popperClose,!O),y)},v,{ref:function(t){e.popper=t}}),function(e){var t=e.popperProps,n=e.restProps,o=t["data-placement"]||w;return x.default.createElement("div",(0,a.default)({},t,n,{style:(0,a.default)({},t.style,{top:t.style.top||0,left:t.style.left||0},n.style)}),x.default.createElement("div",{id:f,role:"tooltip","aria-hidden":!O,className:(0,j.default)(r.tooltip,(0,_.default)({},r.tooltipOpen,O),r["tooltip"+(0,I.capitalize)(o.split("-")[0])])},b))})))}}]),t}(x.default.Component);U.propTypes={},U.defaultProps={disableTriggerFocus:!1,disableTriggerHover:!1,disableTriggerTouch:!1,enterDelay:0,leaveDelay:0,placement:"bottom"},t.default=(0,z.default)(V,{name:"MuiTooltip",withTheme:!0})(U)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(386);Object.defineProperty(t,"Manager",{enumerable:!0,get:function(){return r(o).default}});var i=n(387);Object.defineProperty(t,"Target",{enumerable:!0,get:function(){return r(i).default}});var a=n(388);Object.defineProperty(t,"Popper",{enumerable:!0,get:function(){return r(a).default}});var u=n(390);Object.defineProperty(t,"Arrow",{enumerable:!0,get:function(){return r(u).default}})},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),l=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(l),f=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,s=Array(u),l=0;l<u;l++)s[l]=arguments[l];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},a=n,i(r,a)}return a(t,e),u(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,o=r(e,["tag","children"]);return!1!==t?(0,s.createElement)(t,o,n):n}}]),t}(s.Component);f.childContextTypes={popperManager:c.default.object.isRequired},f.propTypes={tag:c.default.oneOfType([c.default.string,c.default.bool]),children:c.default.oneOfType([c.default.node,c.default.func])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),a=n(1),u=function(e){return e&&e.__esModule?e:{default:e}}(a),s=function(e,t){var n=e.component,a=void 0===n?"div":n,u=e.innerRef,s=e.children,l=r(e,["component","innerRef","children"]),c=t.popperManager,f=function(e){c.setTargetNode(e),"function"==typeof u&&u(e)};if("function"==typeof s){return s({targetProps:{ref:f},restProps:l})}var d=o({},l);return"string"==typeof a?d.ref=f:d.innerRef=f,(0,i.createElement)(a,d,s)};s.contextTypes={popperManager:u.default.object.isRequired},s.propTypes={component:u.default.oneOfType([u.default.node,u.default.func]),innerRef:u.default.func,children:u.default.oneOfType([u.default.node,u.default.func])},t.default=s},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=n(1),d=r(f),p=n(389),h=r(p),y=function(e){function t(){var e,n,r,o;i(this,t);for(var u=arguments.length,l=Array(u),c=0;c<u;c++)l[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._getOffsets=function(e){return Object.keys(e.offsets).map(function(t){return e.offsets[t]})},r._isDataDirty=function(e){return!r.state.data||JSON.stringify(r._getOffsets(r.state.data))!==JSON.stringify(r._getOffsets(e))},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return r._isDataDirty(e)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;return r._popper&&e?s({position:e.offsets.popper.position},e.styles):{position:"absolute",pointerEvents:"none",opacity:0}},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getPopperHide=function(){return r.state.data&&r.state.data.hide?"":void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow;return{top:e.top,left:e.left}}return{}},r._handlePopperRef=function(e){r._popperNode=e,e?r._createPopper():r._destroyPopper(),r.props.innerRef&&r.props.innerRef(e)},r._scheduleUpdate=function(){r._popper&&r._popper.scheduleUpdate()},o=n,a(r,o)}return u(t,e),l(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||(this._destroyPopper(),this._createPopper()),e.children!==this.props.children&&this._scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_createPopper",value:function(){var e=this,t=this.props,n=t.placement,r=t.eventsEnabled,o=s({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(o.arrow={element:this._arrowNode}),this._popper=new h.default(this._getTargetNode(),this._popperNode,{placement:n,eventsEnabled:r,modifiers:o}),setTimeout(function(){return e._scheduleUpdate()})}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this.props,t=e.component,n=(e.innerRef,e.placement,e.eventsEnabled,e.modifiers,e.children),r=o(e,["component","innerRef","placement","eventsEnabled","modifiers","children"]),i=this._getPopperStyle(),a=this._getPopperPlacement(),u=this._getPopperHide();if("function"==typeof n){return n({popperProps:{ref:this._handlePopperRef,style:i,"data-placement":a,"data-x-out-of-boundaries":u},restProps:r,scheduleUpdate:this._scheduleUpdate})}var l=s({},r,{style:s({},r.style,i),"data-placement":a,"data-x-out-of-boundaries":u});return"string"==typeof t?l.ref=this._handlePopperRef:l.innerRef=this._handlePopperRef,(0,c.createElement)(t,l,n)}}]),t}(c.Component);y.contextTypes={popperManager:d.default.object.isRequired},y.childContextTypes={popper:d.default.object.isRequired},y.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(h.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},y.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=y},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e){function n(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then(function(){t=!1,e()}))}}function r(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},le))}}function o(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function i(e,t){if(1!==e.nodeType)return[];var n=getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function u(e){if(!e)return document.body;switch(e.nodeName){case"HTML":case"BODY":return e.ownerDocument.body;case"#document":return e.body}var t=i(e),n=t.overflow,r=t.overflowX;return/(auto|scroll)/.test(n+t.overflowY+r)?e:u(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?-1!==["TD","TABLE"].indexOf(t.nodeName)&&"static"===i(t,"position")?s(t):t:e?e.ownerDocument.documentElement:document.documentElement}function l(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function c(e){return null!==e.parentNode?c(e.parentNode):e}function f(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,i=document.createRange();i.setStart(r,0),i.setEnd(o,0);var a=i.commonAncestorContainer;if(e!==a&&t!==a||r.contains(o))return l(a)?a:s(a);var u=c(e);return u.host?f(u.host,t):f(e,c(t).host)}function d(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=e.ownerDocument.documentElement;return(e.ownerDocument.scrollingElement||o)[n]}return e[n]}function p(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=d(t,"top"),o=d(t,"left"),i=n?-1:1;return e.top+=r*i,e.bottom+=r*i,e.left+=o*i,e.right+=o*i,e}function h(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return parseFloat(e["border"+n+"Width"],10)+parseFloat(e["border"+r+"Width"],10)}function y(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],he()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function v(){var e=document.body,t=document.documentElement,n=he()&&getComputedStyle(t);return{height:y("Height",e,t,n),width:y("Width",e,t,n)}}function m(e){return be({},e,{right:e.left+e.width,bottom:e.top+e.height})}function b(e){var t={};if(he())try{t=e.getBoundingClientRect();var n=d(e,"top"),r=d(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var o={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},a="HTML"===e.nodeName?v():{},u=a.width||e.clientWidth||o.right-o.left,s=a.height||e.clientHeight||o.bottom-o.top,l=e.offsetWidth-u,c=e.offsetHeight-s;if(l||c){var f=i(e);l-=h(f,"x"),c-=h(f,"y"),o.width-=l,o.height-=c}return m(o)}function g(e,t){var n=he(),r="HTML"===t.nodeName,o=b(e),a=b(t),s=u(e),l=i(t),c=parseFloat(l.borderTopWidth,10),f=parseFloat(l.borderLeftWidth,10),d=m({top:o.top-a.top-c,left:o.left-a.left-f,width:o.width,height:o.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=parseFloat(l.marginTop,10),y=parseFloat(l.marginLeft,10);d.top-=c-h,d.bottom-=c-h,d.left-=f-y,d.right-=f-y,d.marginTop=h,d.marginLeft=y}return(n?t.contains(s):t===s&&"BODY"!==s.nodeName)&&(d=p(d,t)),d}function _(e){var t=e.ownerDocument.documentElement,n=g(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),i=d(t),a=d(t,"left");return m({top:i-n.top+n.marginTop,left:a-n.left+n.marginLeft,width:r,height:o})}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===i(e,"position")||w(a(e)))}function x(e,t,n,r){var o={top:0,left:0},i=f(e,t);if("viewport"===r)o=_(i);else{var s=void 0;"scrollParent"===r?(s=u(a(t)),"BODY"===s.nodeName&&(s=e.ownerDocument.documentElement)):s="window"===r?e.ownerDocument.documentElement:r;var l=g(s,i);if("HTML"!==s.nodeName||w(i))o=l;else{var c=v(),d=c.height,p=c.width;o.top+=l.top-l.marginTop,o.bottom=d+l.top,o.left+=l.left-l.marginLeft,o.right=p+l.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function O(e){return e.width*e.height}function S(e,t,n,r,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf("auto"))return e;var a=x(n,r,i,o),u={top:{width:a.width,height:t.top-a.top},right:{width:a.right-t.right,height:a.height},bottom:{width:a.width,height:a.bottom-t.bottom},left:{width:t.left-a.left,height:a.height}},s=Object.keys(u).map(function(e){return be({key:e},u[e],{area:O(u[e])})}).sort(function(e,t){return t.area-e.area}),l=s.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),c=l.length>0?l[0].key:s[0].key,f=e.split("-")[1];return c+(f?"-"+f:"")}function T(e,t,n){return g(n,f(t,n))}function E(e){var t=getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight);return{width:e.offsetWidth+r,height:e.offsetHeight+n}}function C(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function k(e,t,n){n=n.split("-")[0];var r=E(e),o={width:r.width,height:r.height},i=-1!==["right","left"].indexOf(n),a=i?"top":"left",u=i?"left":"top",s=i?"height":"width",l=i?"width":"height";return o[a]=t[a]+t[s]/2-r[s]/2,o[u]=n===u?t[u]-r[l]:t[C(u)],o}function P(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function M(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=P(e,function(e){return e[t]===n});return e.indexOf(r)}function j(e,t,n){return(void 0===n?e:e.slice(0,M(e,"name",n))).forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&o(n)&&(t.offsets.popper=m(t.offsets.popper),t.offsets.reference=m(t.offsets.reference),t=n(t,e))}),t}function N(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=T(this.state,this.popper,this.reference),e.placement=S(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=k(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=j(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function I(e,t){return e.some(function(e){var n=e.name;return e.enabled&&n===t})}function A(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],i=o?""+o+n:e;if(void 0!==document.body.style[i])return i}return null}function R(){return this.state.isDestroyed=!0,I(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[A("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function F(e){var t=e.ownerDocument;return t?t.defaultView:window}function D(e,t,n,r){var o="BODY"===e.nodeName,i=o?e.ownerDocument.defaultView:e;i.addEventListener(t,n,{passive:!0}),o||D(u(i.parentNode),t,n,r),r.push(i)}function L(e,t,n,r){n.updateBound=r,F(e).addEventListener("resize",n.updateBound,{passive:!0});var o=u(e);return D(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function z(){this.state.eventsEnabled||(this.state=L(this.reference,this.options,this.state,this.scheduleUpdate))}function V(e,t){return F(e).removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function U(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=V(this.reference,this.state))}function W(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function H(e,t){Object.keys(t).forEach(function(n){var r="";-1!==["width","height","top","right","bottom","left"].indexOf(n)&&W(t[n])&&(r="px"),e.style[n]=t[n]+r})}function B(e,t){Object.keys(t).forEach(function(n){!1!==t[n]?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function K(e){return H(e.instance.popper,e.styles),B(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&H(e.arrowElement,e.arrowStyles),e}function q(e,t,n,r,o){var i=T(o,t,e),a=S(n.placement,i,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",a),H(t,{position:"absolute"}),n}function G(e,t){var n=t.x,r=t.y,o=e.offsets.popper,i=P(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==i&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var a=void 0!==i?i:t.gpuAcceleration,u=s(e.instance.popper),l=b(u),c={position:o.position},f={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},d="bottom"===n?"top":"bottom",p="right"===r?"left":"right",h=A("transform"),y=void 0,v=void 0;if(v="bottom"===d?-l.height+f.bottom:f.top,y="right"===p?-l.width+f.right:f.left,a&&h)c[h]="translate3d("+y+"px, "+v+"px, 0)",c[d]=0,c[p]=0,c.willChange="transform";else{var m="bottom"===d?-1:1,g="right"===p?-1:1;c[d]=v*m,c[p]=y*g,c.willChange=d+", "+p}var _={"x-placement":e.placement};return e.attributes=be({},_,e.attributes),e.styles=be({},c,e.styles),e.arrowStyles=be({},e.offsets.arrow,e.arrowStyles),e}function Y(e,t,n){var r=P(e,function(e){return e.name===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var i="`"+t+"`",a="`"+n+"`";console.warn(a+" modifier is required by "+i+" modifier in order to work, be sure to include it before "+i+"!")}return o}function X(e,t){var n;if(!Y(e.instance.modifiers,"arrow","keepTogether"))return e;var r=t.element;if("string"==typeof r){if(!(r=e.instance.popper.querySelector(r)))return e}else if(!e.instance.popper.contains(r))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var o=e.placement.split("-")[0],a=e.offsets,u=a.popper,s=a.reference,l=-1!==["left","right"].indexOf(o),c=l?"height":"width",f=l?"Top":"Left",d=f.toLowerCase(),p=l?"left":"top",h=l?"bottom":"right",y=E(r)[c];s[h]-y<u[d]&&(e.offsets.popper[d]-=u[d]-(s[h]-y)),s[d]+y>u[h]&&(e.offsets.popper[d]+=s[d]+y-u[h]),e.offsets.popper=m(e.offsets.popper);var v=s[d]+s[c]/2-y/2,b=i(e.instance.popper),g=parseFloat(b["margin"+f],10),_=parseFloat(b["border"+f+"Width"],10),w=v-e.offsets.popper[d]-g-_;return w=Math.max(Math.min(u[c]-y,w),0),e.arrowElement=r,e.offsets.arrow=(n={},me(n,d,Math.round(w)),me(n,p,""),n),e}function $(e){return"end"===e?"start":"start"===e?"end":e}function Q(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=_e.indexOf(e),r=_e.slice(n+1).concat(_e.slice(0,n));return t?r.reverse():r}function J(e,t){if(I(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=x(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=C(r),i=e.placement.split("-")[1]||"",a=[];switch(t.behavior){case we.FLIP:a=[r,o];break;case we.CLOCKWISE:a=Q(r);break;case we.COUNTERCLOCKWISE:a=Q(r,!0);break;default:a=t.behavior}return a.forEach(function(u,s){if(r!==u||a.length===s+1)return e;r=e.placement.split("-")[0],o=C(r);var l=e.offsets.popper,c=e.offsets.reference,f=Math.floor,d="left"===r&&f(l.right)>f(c.left)||"right"===r&&f(l.left)<f(c.right)||"top"===r&&f(l.bottom)>f(c.top)||"bottom"===r&&f(l.top)<f(c.bottom),p=f(l.left)<f(n.left),h=f(l.right)>f(n.right),y=f(l.top)<f(n.top),v=f(l.bottom)>f(n.bottom),m="left"===r&&p||"right"===r&&h||"top"===r&&y||"bottom"===r&&v,b=-1!==["top","bottom"].indexOf(r),g=!!t.flipVariations&&(b&&"start"===i&&p||b&&"end"===i&&h||!b&&"start"===i&&y||!b&&"end"===i&&v);(d||m||g)&&(e.flipped=!0,(d||m)&&(r=a[s+1]),g&&(i=$(i)),e.placement=r+(i?"-"+i:""),e.offsets.popper=be({},e.offsets.popper,k(e.instance.popper,e.offsets.reference,e.placement)),e=j(e.instance.modifiers,e,"flip"))}),e}function Z(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],i=Math.floor,a=-1!==["top","bottom"].indexOf(o),u=a?"right":"bottom",s=a?"left":"top",l=a?"width":"height";return n[u]<i(r[s])&&(e.offsets.popper[s]=i(r[s])-n[l]),n[s]>i(r[u])&&(e.offsets.popper[s]=i(r[u])),e}function ee(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),i=+o[1],a=o[2];if(!i)return e;if(0===a.indexOf("%")){var u=void 0;switch(a){case"%p":u=n;break;case"%":case"%r":default:u=r}return m(u)[t]/100*i}if("vh"===a||"vw"===a){return("vh"===a?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0))/100*i}return i}function te(e,t,n,r){var o=[0,0],i=-1!==["right","left"].indexOf(r),a=e.split(/(\+|\-)/).map(function(e){return e.trim()}),u=a.indexOf(P(a,function(e){return-1!==e.search(/,|\s/)}));a[u]&&-1===a[u].indexOf(",")&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var s=/\s*,\s*|\s+/,l=-1!==u?[a.slice(0,u).concat([a[u].split(s)[0]]),[a[u].split(s)[1]].concat(a.slice(u+1))]:[a];return l=l.map(function(e,r){var o=(1===r?!i:i)?"height":"width",a=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&-1!==["+","-"].indexOf(t)?(e[e.length-1]=t,a=!0,e):a?(e[e.length-1]+=t,a=!1,e):e.concat(t)},[]).map(function(e){return ee(e,o,t,n)})}),l.forEach(function(e,t){e.forEach(function(n,r){W(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function ne(e,t){var n=t.offset,r=e.placement,o=e.offsets,i=o.popper,a=o.reference,u=r.split("-")[0],s=void 0;return s=W(+n)?[+n,0]:te(n,i,a,u),"left"===u?(i.top+=s[0],i.left-=s[1]):"right"===u?(i.top+=s[0],i.left+=s[1]):"top"===u?(i.left+=s[0],i.top-=s[1]):"bottom"===u&&(i.left+=s[0],i.top+=s[1]),e.popper=i,e}function re(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=x(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,i=e.offsets.popper,a={primary:function(e){var n=i[e];return i[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(i[e],r[e])),me({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=i[n];return i[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(i[n],r[e]-("right"===e?i.width:i.height))),me({},n,o)}};return o.forEach(function(e){var t=-1!==["left","top"].indexOf(e)?"primary":"secondary";i=be({},i,a[t](e))}),e.offsets.popper=i,e}function oe(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,i=o.reference,a=o.popper,u=-1!==["bottom","top"].indexOf(n),s=u?"left":"top",l=u?"width":"height",c={start:me({},s,i[s]),end:me({},s,i[s]+i[l]-a[l])};e.offsets.popper=be({},a,c[r])}return e}function ie(e){if(!Y(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=P(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(!0===e.hide)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(!1===e.hide)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function ae(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,i=r.reference,a=-1!==["left","right"].indexOf(n),u=-1===["top","left"].indexOf(n);return o[a?"left":"top"]=i[n]-(u?o[a?"width":"height"]:0),e.placement=C(t),e.offsets.popper=m(o),e}for(var ue="undefined"!=typeof window&&"undefined"!=typeof document,se=["Edge","Trident","Firefox"],le=0,ce=0;ce<se.length;ce+=1)if(ue&&navigator.userAgent.indexOf(se[ce])>=0){le=1;break}var fe=ue&&window.Promise,de=fe?n:r,pe=void 0,he=function(){return void 0===pe&&(pe=-1!==navigator.appVersion.indexOf("MSIE 10")),pe},ye=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},ve=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),me=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],_e=ge.slice(3),we={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},xe={shift:{order:100,enabled:!0,fn:oe},offset:{order:200,enabled:!0,fn:ne,offset:0},preventOverflow:{order:300,enabled:!0,fn:re,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Z},arrow:{order:500,enabled:!0,fn:X,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:J,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:ae},hide:{order:800,enabled:!0,fn:ie},computeStyle:{order:850,enabled:!0,fn:G,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:K,onLoad:q,gpuAcceleration:void 0}},Oe={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:xe},Se=function(){function e(t,n){var r=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};ye(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(r.update)},this.update=de(this.update.bind(this)),this.options=be({},e.Defaults,i),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t&&t.jquery?t[0]:t,this.popper=n&&n.jquery?n[0]:n,this.options.modifiers={},Object.keys(be({},e.Defaults.modifiers,i.modifiers)).forEach(function(t){r.options.modifiers[t]=be({},e.Defaults.modifiers[t]||{},i.modifiers?i.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return be({name:e},r.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&o(e.onLoad)&&e.onLoad(r.reference,r.popper,r.options,e,r.state)}),this.update();var a=this.options.eventsEnabled;a&&this.enableEventListeners(),this.state.eventsEnabled=a}return ve(e,[{key:"update",value:function(){return N.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return z.call(this)}},{key:"disableEventListeners",value:function(){return U.call(this)}}]),e}();Se.Utils=("undefined"!=typeof window?window:e).PopperUtils,Se.placements=ge,Se.Defaults=Oe,t.default=Se}.call(t,n(16))},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),a=n(1),u=function(e){return e&&e.__esModule?e:{default:e}}(a),s=function(e,t){var n=e.component,a=void 0===n?"span":n,u=e.innerRef,s=e.children,l=r(e,["component","innerRef","children"]),c=t.popper,f=function(e){c.setArrowNode(e),"function"==typeof u&&u(e)},d=c.getArrowStyle();if("function"==typeof s){return s({arrowProps:{ref:f,style:d},restProps:l})}var p=o({},l,{style:o({},d,l.style)});return"string"==typeof a?p.ref=f:p.innerRef=f,(0,i.createElement)(a,p,s)};s.contextTypes={popper:u.default.object.isRequired},s.propTypes={component:u.default.oneOfType([u.default.node,u.default.func]),innerRef:u.default.func,children:u.default.oneOfType([u.default.node,u.default.func])},t.default=s},function(e,t,n){var r,o;!function(i,a){"use strict";r=a,void 0!==(o="function"==typeof r?r.call(t,n,t,e):r)&&(e.exports=o)}(0,function(){"use strict";function e(e,t){var n=e[t];if("function"==typeof n.bind)return n.bind(e);try{return Function.prototype.bind.call(n,e)}catch(t){return function(){return Function.prototype.apply.apply(n,[e,arguments])}}}function t(t){return"debug"===t&&(t="log"),typeof console!==u&&(void 0!==console[t]?e(console,t):void 0!==console.log?e(console,"log"):a)}function n(e,t){for(var n=0;n<s.length;n++){var r=s[n];this[r]=n<e?a:this.methodFactory(r,e,t)}this.log=this.debug}function r(e,t,r){return function(){typeof console!==u&&(n.call(this,t,r),this[e].apply(this,arguments))}}function o(e,n,o){return t(e)||r.apply(this,arguments)}function i(e,t,r){function i(e){var t=(s[e]||"silent").toUpperCase();if(typeof window!==u){try{return void(window.localStorage[f]=t)}catch(e){}try{window.document.cookie=encodeURIComponent(f)+"="+t+";"}catch(e){}}}function a(){var e;if(typeof window!==u){try{e=window.localStorage[f]}catch(e){}if(typeof e===u)try{var t=window.document.cookie,n=t.indexOf(encodeURIComponent(f)+"=");-1!==n&&(e=/^([^;]+)/.exec(t.slice(n))[1])}catch(e){}return void 0===c.levels[e]&&(e=void 0),e}}var l,c=this,f="loglevel";e&&(f+=":"+e),c.name=e,c.levels={TRACE:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,SILENT:5},c.methodFactory=r||o,c.getLevel=function(){return l},c.setLevel=function(t,r){if("string"==typeof t&&void 0!==c.levels[t.toUpperCase()]&&(t=c.levels[t.toUpperCase()]),!("number"==typeof t&&t>=0&&t<=c.levels.SILENT))throw"log.setLevel() called with invalid level: "+t;if(l=t,!1!==r&&i(t),n.call(c,t,e),typeof console===u&&t<c.levels.SILENT)return"No console available for logging"},c.setDefaultLevel=function(e){a()||c.setLevel(e,!1)},c.enableAll=function(e){c.setLevel(c.levels.TRACE,e)},c.disableAll=function(e){c.setLevel(c.levels.SILENT,e)};var d=a();null==d&&(d=null==t?"WARN":t),c.setLevel(d,!1)}var a=function(){},u="undefined",s=["trace","debug","info","warn","error"],l=new i,c={};l.getLogger=function(e){if("string"!=typeof e||""===e)throw new TypeError("You must supply a name when creating a logger.");var t=c[e];return t||(t=c[e]=new i(e,l.getLevel(),l.methodFactory)),t};var f=typeof window!==u?window.log:void 0;return l.noConflict=function(){return typeof window!==u&&window.log===l&&(window.log=f),l},l.getLoggers=function(){return c},l})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(32),u=n(169),s=r(u),l=n(394),c=r(l),f=n(167),d=r(f),p=n(171),h=r(p),y=n(406),v=r(y),m=n(36),b=function(e){var t=e.date,n=new Date(t),r=n.getFullYear()+"-"+("0"+n.getMonth()+1).slice(-2)+"-"+("0"+n.getDate()).slice(-2);return i.default.createElement("time",{dateTime:n.toISOString()},r)},g=function(e){var t=e.order,n=e.column,r=e.sortData,o=[{id:"displayName",label:"Name"},{id:"created",label:"Created"},{id:"lastUpdated",label:"Last updated"}],a=function(e){return function(t){r(t,e)}};return i.default.createElement(l.TableHead,null,i.default.createElement(l.TableRow,null,o.map(function(e){return i.default.createElement(l.TableCell,{key:e.id},i.default.createElement(l.TableSortLabel,{active:n===e.id,direction:t,onClick:a(e.id)},e.label))}),i.default.createElement(l.TableCell,null)))},_=function(e){var t=e.data,n=e.rowsPerPage,r=e.totalRecords,o=e.page,a=e.changePage,u=e.order,f=e.column,p=e.sortData,y=e.toggleActionsMenu,m=e.setActionsMenuAnchorEl,_=e.selectFavorite,w=e.onFavoriteSelect,x=function(e){return function(t){_(e),m(t.currentTarget),y()}},O=function(e){return function(t){w(e)}};return i.default.createElement("div",null,i.default.createElement(c.default,null,i.default.createElement(g,{order:u,column:f,sortData:p}),i.default.createElement(l.TableBody,null,t.map(function(e){return i.default.createElement(l.TableRow,{hover:!0,key:e.id},i.default.createElement(l.TableCell,{padding:"dense",onClick:O(e.id),style:{width:"60%",cursor:"pointer"}},e.displayName),i.default.createElement(l.TableCell,{padding:"dense"},i.default.createElement(b,{date:e.created})),i.default.createElement(l.TableCell,{padding:"dense"},i.default.createElement(b,{date:e.lastUpdated})),i.default.createElement(l.TableCell,{padding:"dense"},e.access.update&&e.access.manage&&e.access.delete?i.default.createElement(d.default,{title:"Actions",placement:"bottom"},i.default.createElement(s.default,{onClick:x(e)},i.default.createElement(h.default,null))):i.default.createElement(s.default,{disabled:!0},i.default.createElement(h.default,{color:"disabled"}))))})),i.default.createElement(l.TableFooter,null,i.default.createElement(l.TableRow,null,i.default.createElement(l.TablePagination,{count:r,rowsPerPage:n,page:o,onChangePage:a,rowsPerPageOptions:[]})))),i.default.createElement(v.default,null))},w=function(e,t){return{order:e.sorting.order,column:e.sorting.column,page:e.pagination.page,rowsPerPage:e.pagination.rowsPerPage,totalRecords:e.data.totalRecords,data:e.data.records}},x={setRowsPerPage:m.setRowsPerPage,changePage:m.changePage,sortData:m.sortData,toggleActionsMenu:m.toggleActionsMenu,setActionsMenuAnchorEl:m.setActionsMenuAnchorEl,selectFavorite:m.selectFavorite};t.default=(0,a.connect)(w,x)(_)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t,n=e.children,r=e.classes,o=e.className,i=e.color,u=e.disabled,l=(0,c.default)(e,["children","classes","className","color","disabled"]);return d.default.createElement(g.default,(0,a.default)({className:(0,y.default)(r.root,(t={},(0,s.default)(t,r["color"+(0,_.capitalize)(i)],"default"!==i),(0,s.default)(t,r.disabled,u),t),o),centerRipple:!0,focusRipple:!0,disabled:u},l),d.default.createElement("span",{className:r.label},d.default.Children.map(n,function(e){return(0,w.isMuiElement)(e,["Icon","SvgIcon"])?d.default.cloneElement(e,{fontSize:!0}):e})))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(4),m=r(v),b=n(60),g=r(b),_=n(21),w=n(61);n(24);var x=t.styles=function(e){return{root:{textAlign:"center",flex:"0 0 auto",fontSize:e.typography.pxToRem(24),width:6*e.spacing.unit,height:6*e.spacing.unit,padding:0,borderRadius:"50%",color:e.palette.action.active,transition:e.transitions.create("background-color",{duration:e.transitions.duration.shortest})},colorInherit:{color:"inherit"},colorPrimary:{color:e.palette.primary.main},colorSecondary:{color:e.palette.secondary.main},disabled:{color:e.palette.action.disabled},label:{width:"100%",display:"flex",alignItems:"inherit",justifyContent:"inherit"}}};o.propTypes={},o.defaultProps={color:"default",disabled:!1,disableRipple:!1},t.default=(0,m.default)(x,{name:"MuiIconButton"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(395);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(396);Object.defineProperty(t,"TableBody",{enumerable:!0,get:function(){return r(i).default}});var a=n(170);Object.defineProperty(t,"TableCell",{enumerable:!0,get:function(){return r(a).default}});var u=n(397);Object.defineProperty(t,"TableFooter",{enumerable:!0,get:function(){return r(u).default}});var s=n(398);Object.defineProperty(t,"TableHead",{enumerable:!0,get:function(){return r(s).default}});var l=n(399);Object.defineProperty(t,"TablePagination",{enumerable:!0,get:function(){return r(l).default}});var c=n(403);Object.defineProperty(t,"TableRow",{enumerable:!0,get:function(){return r(c).default}});var f=n(404);Object.defineProperty(t,"TableSortLabel",{enumerable:!0,get:function(){return r(f).default}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=r(_),x=n(5),O=r(x),S=n(4),T=r(S),E=t.styles=function(e){return{root:{fontFamily:e.typography.fontFamily,width:"100%",borderCollapse:"collapse",borderSpacing:0,overflow:"hidden"}}},C=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"getChildContext",value:function(){return{table:{}}}},{key:"render",value:function(){var e=this.props,t=e.classes,n=e.className,r=e.component,o=(0,u.default)(e,["classes","className","component"]);return g.default.createElement(r,(0,i.default)({className:(0,O.default)(t.root,n)},o))}}]),t}(g.default.Component);C.propTypes={},C.defaultProps={component:"table"},C.childContextTypes={table:w.default.object},t.default=(0,T.default)(E,{name:"MuiTable"})(C)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(3),i=r(o),a=n(8),u=r(a),s=n(7),l=r(s),c=n(9),f=r(c),d=n(10),p=r(d),h=n(11),y=r(h),v=n(0),m=r(v),b=n(1),g=r(b),_=function(e){function t(){return(0,l.default)(this,t),(0,p.default)(this,(t.__proto__||(0,u.default)(t)).apply(this,arguments))}return(0,y.default)(t,e),(0,f.default)(t,[{key:"getChildContext",value:function(){return{table:{body:!0}}}},{key:"render",value:function(){var e=this.props,t=e.component,n=(0,i.default)(e,["component"]);return m.default.createElement(t,n)}}]),t}(m.default.Component);_.propTypes={},_.defaultProps={component:"tbody"},_.childContextTypes={table:g.default.object},t.default=_},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(3),i=r(o),a=n(8),u=r(a),s=n(7),l=r(s),c=n(9),f=r(c),d=n(10),p=r(d),h=n(11),y=r(h),v=n(0),m=r(v),b=n(1),g=r(b),_=function(e){function t(){return(0,l.default)(this,t),(0,p.default)(this,(t.__proto__||(0,u.default)(t)).apply(this,arguments))}return(0,y.default)(t,e),(0,f.default)(t,[{key:"getChildContext",value:function(){return{table:{footer:!0}}}},{key:"render",value:function(){var e=this.props,t=e.component,n=(0,i.default)(e,["component"]);return m.default.createElement(t,n)}}]),t}(m.default.Component);_.propTypes={},_.defaultProps={component:"tfoot"},_.childContextTypes={table:g.default.object},t.default=_},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(3),i=r(o),a=n(8),u=r(a),s=n(7),l=r(s),c=n(9),f=r(c),d=n(10),p=r(d),h=n(11),y=r(h),v=n(0),m=r(v),b=n(1),g=r(b),_=function(e){function t(){return(0,l.default)(this,t),(0,p.default)(this,(t.__proto__||(0,u.default)(t)).apply(this,arguments))}return(0,y.default)(t,e),(0,f.default)(t,[{key:"getChildContext",value:function(){return{table:{head:!0}}}},{key:"render",value:function(){var e=this.props,t=e.component,n=(0,i.default)(e,["component"]);return m.default.createElement(t,n)}}]),t}(m.default.Component);_.propTypes={},_.defaultProps={component:"thead"},_.childContextTypes={table:g.default.object},t.default=_},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(4)),x=r(w),O=n(98),S=r(O),T=n(96),E=n(159),C=r(E),k=n(170),P=r(k),M=n(166),j=r(M),N=n(43),I=r(N),A=n(400),R=r(A),F=t.styles=function(e){return{root:{"&:last-child":{padding:0}},toolbar:{height:56,minHeight:56,paddingRight:2},spacer:{flex:"1 1 100%"},caption:{flexShrink:0},input:{fontSize:"inherit",flexShrink:0},selectRoot:{marginRight:4*e.spacing.unit,marginLeft:e.spacing.unit,color:e.palette.text.secondary},select:{paddingLeft:e.spacing.unit,paddingRight:2*e.spacing.unit},selectIcon:{top:1},actions:{flexShrink:0,color:e.palette.text.secondary,marginLeft:2.5*e.spacing.unit}}},D=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentWillReceiveProps",value:function(e){var t=e.count,n=e.onChangePage,r=e.rowsPerPage,o=Math.max(0,Math.ceil(t/r)-1);this.props.page>o&&n(null,o)}},{key:"render",value:function(){var e=this.props,t=e.Actions,n=e.backIconButtonProps,r=e.classes,o=e.colSpan,a=e.component,s=e.count,l=e.labelDisplayedRows,c=e.labelRowsPerPage,f=e.nextIconButtonProps,d=e.onChangePage,p=e.onChangeRowsPerPage,h=e.page,y=e.rowsPerPage,v=e.rowsPerPageOptions,m=(0,u.default)(e,["Actions","backIconButtonProps","classes","colSpan","component","count","labelDisplayedRows","labelRowsPerPage","nextIconButtonProps","onChangePage","onChangeRowsPerPage","page","rowsPerPage","rowsPerPageOptions"]),b=void 0;return a!==P.default&&"td"!==a||(b=o||1e3),g.default.createElement(a,(0,i.default)({className:r.root,colSpan:b},m),g.default.createElement(j.default,{className:r.toolbar},g.default.createElement("div",{className:r.spacer}),v.length>1&&g.default.createElement(I.default,{variant:"caption",className:r.caption},c),v.length>1&&g.default.createElement(C.default,{classes:{root:r.selectRoot,select:r.select,icon:r.selectIcon},input:g.default.createElement(S.default,{classes:{root:r.input},disableUnderline:!0}),value:y,onChange:p},v.map(function(e){return g.default.createElement(T.MenuItem,{key:e,value:e},e)})),g.default.createElement(I.default,{variant:"caption",className:r.caption},l({from:0===s?0:h*y+1,to:Math.min(s,(h+1)*y),count:s,page:h})),g.default.createElement(t,{backIconButtonProps:n,count:s,nextIconButtonProps:f,onChangePage:d,page:h,rowsPerPage:y})))}}]),t}(g.default.Component);D.propTypes={},D.defaultProps={Actions:R.default,component:P.default,labelDisplayedRows:function(e){return e.from+"-"+e.to+" of "+e.count},labelRowsPerPage:"Rows per page:",rowsPerPageOptions:[5,10,25]},t.default=(0,x.default)(F,{name:"MuiTablePagination"})(D)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var o=n(2),i=r(o),a=n(3),u=r(a),s=n(8),l=r(s),c=n(7),f=r(c),d=n(9),p=r(d),h=n(10),y=r(h),v=n(11),m=r(v),b=n(0),g=r(b),_=n(1),w=(r(_),n(401)),x=r(w),O=n(402),S=r(O),T=n(4),E=r(T),C=n(169),k=r(C),P=t.styles=function(e){return{root:{flexShrink:0,color:e.palette.text.secondary,marginLeft:2.5*e.spacing.unit}}},M=g.default.createElement(S.default,null),j=g.default.createElement(x.default,null),N=g.default.createElement(x.default,null),I=g.default.createElement(S.default,null),A=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.handleBackButtonClick=function(e){r.props.onChangePage(e,r.props.page-1)},r.handleNextButtonClick=function(e){r.props.onChangePage(e,r.props.page+1)},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"render",value:function(){var e=this.props,t=e.backIconButtonProps,n=e.classes,r=e.count,o=e.nextIconButtonProps,a=(e.onChangePage,e.page),s=e.rowsPerPage,l=e.theme,c=(0,u.default)(e,["backIconButtonProps","classes","count","nextIconButtonProps","onChangePage","page","rowsPerPage","theme"]);return g.default.createElement("div",(0,i.default)({className:n.root},c),g.default.createElement(k.default,(0,i.default)({onClick:this.handleBackButtonClick,disabled:0===a},t),"rtl"===l.direction?M:j),g.default.createElement(k.default,(0,i.default)({onClick:this.handleNextButtonClick,disabled:a>=Math.ceil(r/s)-1},o),"rtl"===l.direction?N:I))}}]),t}(g.default.Component);A.propTypes={},t.default=(0,E.default)(P,{name:"MuiTablePaginationActions",withTheme:!0})(A)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=i.default.createElement("path",{d:"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"}),f=function(e){return i.default.createElement(l.default,e,c)};f=(0,u.default)(f),f.muiName="SvgIcon",t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=i.default.createElement("path",{d:"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}),f=function(e){return i.default.createElement(l.default,e,c)};f=(0,u.default)(f),f.muiName="SvgIcon",t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n,r=e.classes,o=e.className,i=e.component,u=e.hover,l=e.selected,f=(0,c.default)(e,["classes","className","component","hover","selected"]),p=t.table,h=(0,v.default)(r.root,(n={},(0,s.default)(n,r.typeHead,p&&p.head),(0,s.default)(n,r.typeFooter,p&&p.footer),(0,s.default)(n,r.hover,p&&u),(0,s.default)(n,r.selected,p&&l),n),o);return d.default.createElement(i,(0,a.default)({className:h},f))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=r(p),y=n(5),v=r(y),m=n(4),b=r(m),g=t.styles=function(e){return{root:{color:"inherit",display:"table-row",height:48,"&:focus":{outline:"none"},verticalAlign:"middle"},typeHead:{height:56},typeFooter:{height:56},selected:{backgroundColor:"light"===e.palette.type?"rgba(0, 0, 0, 0.04)":"rgba(255, 255, 255, 0.08)"},hover:{"&:hover":{backgroundColor:"light"===e.palette.type?"rgba(0, 0, 0, 0.07)":"rgba(255, 255, 255, 0.14)"}}}};o.propTypes={},o.defaultProps={component:"tr",hover:!1,selected:!1},o.contextTypes={table:h.default.object},t.default=(0,b.default)(g,{name:"MuiTableRow"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.active,n=e.classes,r=e.className,o=e.children,i=e.direction,u=(0,c.default)(e,["active","classes","className","children","direction"]),l=(0,y.default)(n.root,(0,s.default)({},n.active,t),r),f=(0,y.default)(n.icon,(0,s.default)({},n[i],!!i));return d.default.createElement(w.default,(0,a.default)({className:l,component:"span",disableRipple:!0},u),o,d.default.createElement(m.default,{className:f}))}Object.defineProperty(t,"__esModule",{value:!0}),t.styles=void 0;var i=n(2),a=r(i),u=n(6),s=r(u),l=n(3),c=r(l),f=n(0),d=r(f),p=n(1),h=(r(p),n(5)),y=r(h),v=n(405),m=r(v),b=n(4),g=r(b),_=n(60),w=r(_),x=t.styles=function(e){return{root:{cursor:"pointer",display:"inline-flex",justifyContent:"flex-start",flexDirection:"inherit",alignItems:"center","&:hover":{color:e.palette.text.primary},"&:focus":{color:e.palette.text.primary}},active:{color:e.palette.text.primary,"& $icon":{opacity:1}},icon:{height:16,marginRight:4,marginLeft:4,opacity:0,transition:e.transitions.create(["opacity","transform"],{duration:e.transitions.duration.shorter}),userSelect:"none",width:16},desc:{transform:"rotate(0deg)"},asc:{transform:"rotate(180deg)"}}};o.propTypes={},o.defaultProps={active:!1,direction:"desc"},t.default=(0,g.default)(x,{name:"MuiTableSortLabel"})(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=i.default.createElement("path",{d:"M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"}),f=function(e){return i.default.createElement(l.default,e,c)};f=(0,u.default)(f),f.muiName="SvgIcon",t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(32),u=n(1),s=r(u),l=n(96),c=r(l),f=n(157),d=n(407),p=r(d),h=n(408),y=r(h),v=n(409),m=r(v),b=n(410),g=r(b),_=n(171),w=(r(_),n(411)),x=r(w),O=n(412),S=r(O),T=n(36),E=function(e,t){var n=e.open,r=e.anchorEl,o=e.toggleActionsMenu,a=e.toggleDeleteDialog,u=e.deleteDialogIsOpen,s=e.toggleShareDialog,d=e.toggleRenameDialog,h=e.shareDialogIsOpen,v=e.deleteFavorite,b=e.selectedFavoriteModel,_=function(){o(),a()},w=function(){o(),d()},O=function(){o(),s()};return i.default.createElement("div",null,i.default.createElement(c.default,{open:n,onClose:o,anchorEl:r},i.default.createElement(l.MenuItem,{onClick:w,disabled:b&&!b.access.update},i.default.createElement(f.ListItemIcon,null,i.default.createElement(g.default,null)),i.default.createElement(f.ListItemText,{primary:"Rename"})),i.default.createElement(l.MenuItem,{onClick:O,disabled:b&&!b.access.manage},i.default.createElement(f.ListItemIcon,null,i.default.createElement(x.default,null)),i.default.createElement(f.ListItemText,{primary:"Share"})),i.default.createElement(l.MenuItem,{onClick:_,disabled:b&&!b.access.delete},i.default.createElement(f.ListItemIcon,null,i.default.createElement(S.default,null)),i.default.createElement(f.ListItemText,{primary:"Delete"}))),i.default.createElement(y.default,null),b?i.default.createElement(m.default,{open:h,id:b.id,type:b.modelDefinition.name,onRequestClose:s,d2:t.d2}):null,i.default.createElement(p.default,{open:u,onRequestClose:a,onRequestDelete:v}))};E.contextTypes={d2:s.default.object.isRequired},t.default=(0,a.connect)(function(e){return{open:e.actions.menuIsOpen,anchorEl:e.actions.menuAnchorEl,deleteDialogIsOpen:e.actions.remove.dialogIsOpen,shareDialogIsOpen:e.actions.share.dialogIsOpen,selectedFavoriteModel:e.actions.select.favoriteModel}},{toggleActionsMenu:T.toggleActionsMenu,toggleRenameDialog:T.toggleRenameDialog,toggleDeleteDialog:T.toggleDeleteDialog,toggleShareDialog:T.toggleShareDialog,deleteFavorite:T.deleteFavorite})(E)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(68),u=r(a),s=n(59),l=r(s),c=function(e){var t=e.open,n=e.onRequestClose,r=e.onRequestDelete;return i.default.createElement(u.default,{open:t,onClose:n,maxWidth:"xs"},i.default.createElement(a.DialogTitle,null,"Delete favorite"),i.default.createElement(a.DialogContent,null,"This favorite will be deleted. Continue?"),i.default.createElement(a.DialogActions,null,i.default.createElement(l.default,{onClick:n,color:"primary"},"Cancel"),i.default.createElement(l.default,{onClick:r,color:"primary"},"Delete")))};t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(32),d=n(68),p=r(d),h=n(59),y=r(h),v=n(165),m=r(v),b=n(162),g=n(36),_=function(e){function t(e){i(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleSubmit=function(e){e.preventDefault(),n.props.renameFavorite(n.state)},n.handleChange=function(e){return function(t){t.preventDefault(),n.setState(o({},e,t.target.value))}},n.state={newName:"",newDescription:""},n}return u(t,e),s(t,[{key:"componentWillReceiveProps",value:function(e){!0===e.open&&this.setState({newName:e.favoriteModel.displayName||"",newDescription:e.favoriteModel.displayDescription||""})}},{key:"render",value:function(){var e=this.props,t=e.open,n=e.toggleRenameDialog;e.renameFavorite;return c.default.createElement(p.default,{open:t,onClose:n,maxWidth:"md"},c.default.createElement("form",{onSubmit:this.handleSubmit},c.default.createElement(d.DialogTitle,null,"Rename favorite"),c.default.createElement(d.DialogContent,null,c.default.createElement(b.FormControl,{fullWidth:!0},c.default.createElement(m.default,{label:"Name",value:this.state.newName,required:!0,margin:"normal",onChange:this.handleChange("newName")})),c.default.createElement(b.FormControl,{fullWidth:!0},c.default.createElement(m.default,{label:"Description",value:this.state.newDescription,margin:"normal",multiline:!0,rowsMax:4,onChange:this.handleChange("newDescription")}))),c.default.createElement(d.DialogActions,null,c.default.createElement(y.default,{onClick:n,color:"primary"},"Cancel"),c.default.createElement(y.default,{type:"submit",onClick:this.handleSubmit,color:"primary"},"Rename"))))}}]),t}(c.default.Component);t.default=(0,f.connect)(function(e){return{open:e.actions.rename.dialogIsOpen,favoriteModel:e.actions.select.favoriteModel}},{renameFavorite:g.renameFavorite,toggleRenameDialog:g.toggleRenameDialog})(_)},function(e,t,n){!function(t,r){e.exports=r(n(0))}("undefined"!=typeof self&&self,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=252)}([function(e,t,n){"use strict";var r=n(22),o=n(340),i=n(69),a=n(99),u=function(){function e(e){this._isScalar=!1,e&&(this._subscribe=e)}return e.prototype.lift=function(t){var n=new e;return n.source=this,n.operator=t,n},e.prototype.subscribe=function(e,t,n){var r=this.operator,i=o.toSubscriber(e,t,n);if(r?r.call(i,this.source):i.add(this.source||!i.syncErrorThrowable?this._subscribe(i):this._trySubscribe(i)),i.syncErrorThrowable&&(i.syncErrorThrowable=!1,i.syncErrorThrown))throw i.syncErrorValue;return i},e.prototype._trySubscribe=function(e){try{return this._subscribe(e)}catch(t){e.syncErrorThrown=!0,e.syncErrorValue=t,e.error(t)}},e.prototype.forEach=function(e,t){var n=this;if(t||(r.root.Rx&&r.root.Rx.config&&r.root.Rx.config.Promise?t=r.root.Rx.config.Promise:r.root.Promise&&(t=r.root.Promise)),!t)throw new Error("no Promise impl found");return new t(function(t,r){var o;o=n.subscribe(function(t){if(o)try{e(t)}catch(e){r(e),o.unsubscribe()}else e(t)},r,t)})},e.prototype._subscribe=function(e){return this.source.subscribe(e)},e.prototype[i.observable]=function(){return this},e.prototype.pipe=function(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return 0===e.length?this:a.pipeFromArray(e)(this)},e.prototype.toPromise=function(e){var t=this;if(e||(r.root.Rx&&r.root.Rx.config&&r.root.Rx.config.Promise?e=r.root.Rx.config.Promise:r.root.Promise&&(e=r.root.Promise)),!e)throw new Error("no Promise impl found");return new e(function(e,n){var r;t.subscribe(function(e){return r=e},function(e){return n(e)},function(){return e(r)})})},e.create=function(t){return new e(t)},e}();t.Observable=u},function(t,n){t.exports=e},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(67),i=n(18),a=n(145),u=n(68),s=function(e){function t(n,r,o){switch(e.call(this),this.syncErrorValue=null,this.syncErrorThrown=!1,this.syncErrorThrowable=!1,this.isStopped=!1,arguments.length){case 0:this.destination=a.empty;break;case 1:if(!n){this.destination=a.empty;break}if("object"==typeof n){n instanceof t?(this.syncErrorThrowable=n.syncErrorThrowable,this.destination=n,this.destination.add(this)):(this.syncErrorThrowable=!0,this.destination=new l(this,n));break}default:this.syncErrorThrowable=!0,this.destination=new l(this,n,r,o)}}return r(t,e),t.prototype[u.rxSubscriber]=function(){return this},t.create=function(e,n,r){var o=new t(e,n,r);return o.syncErrorThrowable=!1,o},t.prototype.next=function(e){this.isStopped||this._next(e)},t.prototype.error=function(e){this.isStopped||(this.isStopped=!0,this._error(e))},t.prototype.complete=function(){this.isStopped||(this.isStopped=!0,this._complete())},t.prototype.unsubscribe=function(){this.closed||(this.isStopped=!0,e.prototype.unsubscribe.call(this))},t.prototype._next=function(e){this.destination.next(e)},t.prototype._error=function(e){this.destination.error(e),this.unsubscribe()},t.prototype._complete=function(){this.destination.complete(),this.unsubscribe()},t.prototype._unsubscribeAndRecycle=function(){var e=this,t=e._parent,n=e._parents;return this._parent=null,this._parents=null,this.unsubscribe(),this.closed=!1,this.isStopped=!1,this._parent=t,this._parents=n,this},t}(i.Subscription);t.Subscriber=s;var l=function(e){function t(t,n,r,i){e.call(this),this._parentSubscriber=t;var u,s=this;o.isFunction(n)?u=n:n&&(u=n.next,r=n.error,i=n.complete,n!==a.empty&&(s=Object.create(n),o.isFunction(s.unsubscribe)&&this.add(s.unsubscribe.bind(s)),s.unsubscribe=this.unsubscribe.bind(this))),this._context=s,this._next=u,this._error=r,this._complete=i}return r(t,e),t.prototype.next=function(e){if(!this.isStopped&&this._next){var t=this._parentSubscriber;t.syncErrorThrowable?this.__tryOrSetError(t,this._next,e)&&this.unsubscribe():this.__tryOrUnsub(this._next,e)}},t.prototype.error=function(e){if(!this.isStopped){var t=this._parentSubscriber;if(this._error)t.syncErrorThrowable?(this.__tryOrSetError(t,this._error,e),this.unsubscribe()):(this.__tryOrUnsub(this._error,e),this.unsubscribe());else{if(!t.syncErrorThrowable)throw this.unsubscribe(),e;t.syncErrorValue=e,t.syncErrorThrown=!0,this.unsubscribe()}}},t.prototype.complete=function(){var e=this;if(!this.isStopped){var t=this._parentSubscriber;if(this._complete){var n=function(){return e._complete.call(e._context)};t.syncErrorThrowable?(this.__tryOrSetError(t,n),this.unsubscribe()):(this.__tryOrUnsub(n),this.unsubscribe())}else this.unsubscribe()}},t.prototype.__tryOrUnsub=function(e,t){try{e.call(this._context,t)}catch(e){throw this.unsubscribe(),e}},t.prototype.__tryOrSetError=function(e,t,n){try{t.call(this._context,n)}catch(t){return e.syncErrorValue=t,e.syncErrorThrown=!0,!0}return!1},t.prototype._unsubscribe=function(){var e=this._parentSubscriber;this._context=null,this._parentSubscriber=null,e.unsubscribe()},t}(s)},function(e,t,n){e.exports=n(292)()},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(651),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(648),i=r(o),a=n(36),u=r(a),s=n(248),l=(r(s),n(249)),c=(r(l),function(e){return(0,i.default)(function(e,t){return!(0,u.default)(e,t)})(e)});t.default=c},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(2),i=function(e){function t(){e.apply(this,arguments)}return r(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.destination.next(t)},t.prototype.notifyError=function(e,t){this.destination.error(e)},t.prototype.notifyComplete=function(e){this.destination.complete()},t}(o.Subscriber);t.OuterSubscriber=i},function(e,t,n){"use strict";function r(e,t,n,r){var d=new c.InnerSubscriber(e,n,r);if(d.closed)return null;if(t instanceof s.Observable)return t._isScalar?(d.next(t.value),d.complete(),null):(d.syncErrorThrowable=!0,t.subscribe(d));if(i.isArrayLike(t)){for(var p=0,h=t.length;p<h&&!d.closed;p++)d.next(t[p]);d.closed||d.complete()}else{if(a.isPromise(t))return t.then(function(e){d.closed||(d.next(e),d.complete())},function(e){return d.error(e)}).then(null,function(e){o.root.setTimeout(function(){throw e})}),d;if(t&&"function"==typeof t[l.iterator])for(var y=t[l.iterator]();;){var v=y.next();if(v.done){d.complete();break}if(d.next(v.value),d.closed)break}else if(t&&"function"==typeof t[f.observable]){var m=t[f.observable]();if("function"==typeof m.subscribe)return m.subscribe(new c.InnerSubscriber(e,n,r));d.error(new TypeError("Provided object does not correctly implement Symbol.observable"))}else{var b=u.isObject(t)?"an invalid object":"'"+t+"'",g="You provided "+b+" where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";d.error(new TypeError(g))}}return null}var o=n(22),i=n(147),a=n(148),u=n(143),s=n(0),l=n(48),c=n(349),f=n(69);t.subscribeToResult=r},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(128),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()},function(e,t){e.exports=function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){e.exports={default:n(261),__esModule:!0}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(60),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,o.default)(t))&&"function"!=typeof t?e:t}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(285),i=r(o),a=n(289),u=r(a),s=n(60),l=r(s);t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,l.default)(t)));e.prototype=(0,u.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(i.default?(0,i.default)(e,t):e.__proto__=t)}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(120),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}},function(e,t,n){"use strict";var r=n(53),o=n(54);t.async=new o.AsyncScheduler(r.AsyncAction)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={easeOutFunction:"cubic-bezier(0.23, 1, 0.32, 1)",easeInOutFunction:"cubic-bezier(0.445, 0.05, 0.55, 0.95)",easeOut:function(e,t,n,r){if(r=r||this.easeOutFunction,t&&"[object Array]"===Object.prototype.toString.call(t)){for(var o="",i=0;i<t.length;i++)o&&(o+=","),o+=this.create(e,t[i],n,r);return o}return this.create(e,t,n,r)},create:function(e,t,n,r){return e=e||"450ms",t=t||"all",n=n||"0ms",r=r||"linear",t+" "+e+" "+r+" "+n}}},function(e,t,n){"use strict";function r(e){return e.reduce(function(e,t){return e.concat(t instanceof l.UnsubscriptionError?t.errors:t)},[])}var o=n(27),i=n(143),a=n(67),u=n(21),s=n(20),l=n(144),c=function(){function e(e){this.closed=!1,this._parent=null,this._parents=null,this._subscriptions=null,e&&(this._unsubscribe=e)}return e.prototype.unsubscribe=function(){var e,t=!1;if(!this.closed){var n=this,c=n._parent,f=n._parents,d=n._unsubscribe,p=n._subscriptions;this.closed=!0,this._parent=null,this._parents=null,this._subscriptions=null;for(var h=-1,y=f?f.length:0;c;)c.remove(this),c=++h<y&&f[h]||null;if(a.isFunction(d)){var v=u.tryCatch(d).call(this);v===s.errorObject&&(t=!0,e=e||(s.errorObject.e instanceof l.UnsubscriptionError?r(s.errorObject.e.errors):[s.errorObject.e]))}if(o.isArray(p))for(h=-1,y=p.length;++h<y;){var m=p[h];if(i.isObject(m)){var v=u.tryCatch(m.unsubscribe).call(m);if(v===s.errorObject){t=!0,e=e||[];var b=s.errorObject.e;b instanceof l.UnsubscriptionError?e=e.concat(r(b.errors)):e.push(b)}}}if(t)throw new l.UnsubscriptionError(e)}},e.prototype.add=function(t){if(!t||t===e.EMPTY)return e.EMPTY;if(t===this)return this;var n=t;switch(typeof t){case"function":n=new e(t);case"object":if(n.closed||"function"!=typeof n.unsubscribe)return n;if(this.closed)return n.unsubscribe(),n;if("function"!=typeof n._addParent){var r=n;n=new e,n._subscriptions=[r]}break;default:throw new Error("unrecognized teardown "+t+" added to Subscription.")}return(this._subscriptions||(this._subscriptions=[])).push(n),n._addParent(this),n},e.prototype.remove=function(e){var t=this._subscriptions;if(t){var n=t.indexOf(e);-1!==n&&t.splice(n,1)}},e.prototype._addParent=function(e){var t=this,n=t._parent,r=t._parents;n&&n!==e?r?-1===r.indexOf(e)&&r.push(e):this._parents=[e]:this._parent=e},e.EMPTY=function(e){return e.closed=!0,e}(new e),e}();t.Subscription=c},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(2),a=n(18),u=n(70),s=n(146),l=n(68),c=function(e){function t(t){e.call(this,t),this.destination=t}return r(t,e),t}(i.Subscriber);t.SubjectSubscriber=c;var f=function(e){function t(){e.call(this),this.observers=[],this.closed=!1,this.isStopped=!1,this.hasError=!1,this.thrownError=null}return r(t,e),t.prototype[l.rxSubscriber]=function(){return new c(this)},t.prototype.lift=function(e){var t=new d(this,this);return t.operator=e,t},t.prototype.next=function(e){if(this.closed)throw new u.ObjectUnsubscribedError;if(!this.isStopped)for(var t=this.observers,n=t.length,r=t.slice(),o=0;o<n;o++)r[o].next(e)},t.prototype.error=function(e){if(this.closed)throw new u.ObjectUnsubscribedError;this.hasError=!0,this.thrownError=e,this.isStopped=!0;for(var t=this.observers,n=t.length,r=t.slice(),o=0;o<n;o++)r[o].error(e);this.observers.length=0},t.prototype.complete=function(){if(this.closed)throw new u.ObjectUnsubscribedError;this.isStopped=!0;for(var e=this.observers,t=e.length,n=e.slice(),r=0;r<t;r++)n[r].complete();this.observers.length=0},t.prototype.unsubscribe=function(){this.isStopped=!0,this.closed=!0,this.observers=null},t.prototype._trySubscribe=function(t){if(this.closed)throw new u.ObjectUnsubscribedError;return e.prototype._trySubscribe.call(this,t)},t.prototype._subscribe=function(e){if(this.closed)throw new u.ObjectUnsubscribedError;return this.hasError?(e.error(this.thrownError),a.Subscription.EMPTY):this.isStopped?(e.complete(),a.Subscription.EMPTY):(this.observers.push(e),new s.SubjectSubscription(this,e))},t.prototype.asObservable=function(){var e=new o.Observable;return e.source=this,e},t.create=function(e,t){return new d(e,t)},t}(o.Observable);t.Subject=f;var d=function(e){function t(t,n){e.call(this),this.destination=t,this.source=n}return r(t,e),t.prototype.next=function(e){var t=this.destination;t&&t.next&&t.next(e)},t.prototype.error=function(e){var t=this.destination;t&&t.error&&this.destination.error(e)},t.prototype.complete=function(){var e=this.destination;e&&e.complete&&this.destination.complete()},t.prototype._subscribe=function(e){return this.source?this.source.subscribe(e):a.Subscription.EMPTY},t}(f);t.AnonymousSubject=d},function(e,t,n){"use strict";t.errorObject={e:{}}},function(e,t,n){"use strict";function r(){try{return i.apply(this,arguments)}catch(e){return a.errorObject.e=e,a.errorObject}}function o(e){return i=e,r}var i,a=n(20);t.tryCatch=o},function(e,t,n){"use strict";(function(e){var n="undefined"!=typeof window&&window,r="undefined"!=typeof self&&"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope&&self,o=void 0!==e&&e,i=n||o||r;t.root=i,function(){if(!i)throw new Error("RxJS could not find any global context (window, self, global)")}()}).call(t,n(47))},function(e,t,n){"use strict";function r(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r)}catch(e){console.error(e)}}r(),e.exports=n(295)},function(e,t){var n=e.exports={version:"2.5.3"};"number"==typeof __e&&(__e=n)},function(e,t,n){"use strict";function r(e){return e&&"function"==typeof e.schedule}t.isScheduler=r},function(e,t,n){var r=n(87)("wks"),o=n(58),i=n(29).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){"use strict";t.isArray=Array.isArray||function(e){return e&&"number"==typeof e.length}},function(e,t,n){var r=n(29),o=n(24),i=n(81),a=n(38),u=function(e,t,n){var s,l,c,f=e&u.F,d=e&u.G,p=e&u.S,h=e&u.P,y=e&u.B,v=e&u.W,m=d?o:o[t]||(o[t]={}),b=m.prototype,g=d?r:p?r[t]:(r[t]||{}).prototype;d&&(n=t);for(s in n)(l=!f&&g&&void 0!==g[s])&&s in m||(c=l?g[s]:n[s],m[s]=d&&"function"!=typeof g[s]?n[s]:y&&l?i(c,r):v&&g[s]==c?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(c):h&&"function"==typeof c?i(Function.call,c):c,h&&((m.virtual||(m.virtual={}))[s]=c,e&u.R&&b&&!b[s]&&a(b,s,c)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){var r=n(39),o=n(121),i=n(82),a=Object.defineProperty;t.f=n(34)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o.default.oneOf(["left","middle","right"]),a=o.default.oneOf(["top","center","bottom"]);t.default={corners:o.default.oneOf(["bottom-left","bottom-right","top-left","top-right"]),horizontal:i,vertical:a,origin:o.default.shape({horizontal:i,vertical:a}),cornersAndCenter:o.default.oneOf(["bottom-center","bottom-left","bottom-right","top-center","top-left","top-right"]),stringOrNumber:o.default.oneOfType([o.default.string,o.default.number]),zDepth:o.default.oneOf([0,1,2,3,4,5])}},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(101),a=n(33),u=n(25),s=function(e){function t(t,n){e.call(this),this.array=t,this.scheduler=n,n||1!==t.length||(this._isScalar=!0,this.value=t[0])}return r(t,e),t.create=function(e,n){return new t(e,n)},t.of=function(){for(var e=[],n=0;n<arguments.length;n++)e[n-0]=arguments[n];var r=e[e.length-1];u.isScheduler(r)?e.pop():r=null;var o=e.length;return o>1?new t(e,r):1===o?new i.ScalarObservable(e[0],r):new a.EmptyObservable(r)},t.dispatch=function(e){var t=e.array,n=e.index,r=e.count,o=e.subscriber;if(n>=r)return void o.complete();o.next(t[n]),o.closed||(e.index=n+1,this.schedule(e))},t.prototype._subscribe=function(e){var n=this.array,r=n.length,o=this.scheduler;if(o)return o.schedule(t.dispatch,0,{array:n,index:0,count:r,subscriber:e});for(var i=0;i<r&&!e.closed;i++)e.next(n[i]);e.complete()},t}(o.Observable);t.ArrayObservable=s},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=function(e){function t(t){e.call(this),this.scheduler=t}return r(t,e),t.create=function(e){return new t(e)},t.dispatch=function(e){e.subscriber.complete()},t.prototype._subscribe=function(e){var n=this.scheduler;if(n)return n.schedule(t.dispatch,0,{subscriber:e});e.complete()},t}(o.Observable);t.EmptyObservable=i},function(e,t,n){e.exports=!n(41)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(61),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e,t){return function(n){var r;if(r="function"==typeof e?e:function(){return e},"function"==typeof t)return n.lift(new i(r,t));var a=Object.create(n,o.connectableObservableDescriptor);return a.source=n,a.subjectFactory=r,a}}var o=n(195);t.multicast=r;var i=function(){function e(e,t){this.subjectFactory=e,this.selector=t}return e.prototype.call=function(e,t){var n=this.selector,r=this.subjectFactory(),o=n(r).subscribe(e);return o.add(t.subscribe(r)),o},e}();t.MulticastOperator=i},function(e,t,n){var r=n(30),o=n(43);e.exports=n(34)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(40);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t,n){var r=n(124),o=n(84);e.exports=function(e){return r(o(e))}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(123),o=n(88);e.exports=Object.keys||function(e){return r(e,o)}},function(e,t,n){var r=n(84);e.exports=function(e){return Object(r(e))}},function(e,t){e.exports={}},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";function r(e){var t=e.Symbol;if("function"==typeof t)return t.iterator||(t.iterator=t("iterator polyfill")),t.iterator;var n=e.Set;if(n&&"function"==typeof(new n)["@@iterator"])return"@@iterator";var r=e.Map;if(r)for(var o=Object.getOwnPropertyNames(r.prototype),i=0;i<o.length;++i){var a=o[i];if("entries"!==a&&"size"!==a&&r.prototype[a]===r.prototype.entries)return a}return"@@iterator"}var o=n(22);t.symbolIteratorPonyfill=r,t.iterator=r(o.root),t.$$iterator=t.iterator},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return 1===e.length||2===e.length&&o.isScheduler(e[1])?a.from(e[0]):u.concatAll()(i.of.apply(void 0,e))}var o=n(25),i=n(149),a=n(150),u=n(102);t.concat=r},function(e,t,n){"use strict";var r=n(0),o=function(){function e(e,t,n){this.kind=e,this.value=t,this.error=n,this.hasValue="N"===e}return e.prototype.observe=function(e){switch(this.kind){case"N":return e.next&&e.next(this.value);case"E":return e.error&&e.error(this.error);case"C":return e.complete&&e.complete()}},e.prototype.do=function(e,t,n){switch(this.kind){case"N":return e&&e(this.value);case"E":return t&&t(this.error);case"C":return n&&n()}},e.prototype.accept=function(e,t,n){return e&&"function"==typeof e.next?this.observe(e):this.do(e,t,n)},e.prototype.toObservable=function(){switch(this.kind){case"N":return r.Observable.of(this.value);case"E":return r.Observable.throw(this.error);case"C":return r.Observable.empty()}throw new Error("unexpected notification kind value")},e.createNext=function(t){return void 0!==t?new e("N",t):e.undefinedValueNotification},e.createError=function(t){return new e("E",void 0,t)},e.createComplete=function(){return e.completeNotification},e.completeNotification=new e("C"),e.undefinedValueNotification=new e("N",void 0),e}();t.Notification=o},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),function(r){return"number"==typeof t&&(n=t,t=null),r.lift(new u(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(7),a=n(6);t.mergeMap=r;var u=function(){function e(e,t,n){void 0===n&&(n=Number.POSITIVE_INFINITY),this.project=e,this.resultSelector=t,this.concurrent=n}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.project,this.resultSelector,this.concurrent))},e}();t.MergeMapOperator=u;var s=function(e){function t(t,n,r,o){void 0===o&&(o=Number.POSITIVE_INFINITY),e.call(this,t),this.project=n,this.resultSelector=r,this.concurrent=o,this.hasCompleted=!1,this.buffer=[],this.active=0,this.index=0}return o(t,e),t.prototype._next=function(e){this.active<this.concurrent?this._tryNext(e):this.buffer.push(e)},t.prototype._tryNext=function(e){var t,n=this.index++;try{t=this.project(e,n)}catch(e){return void this.destination.error(e)}this.active++,this._innerSub(t,e,n)},t.prototype._innerSub=function(e,t,n){this.add(i.subscribeToResult(this,e,t,n))},t.prototype._complete=function(){this.hasCompleted=!0,0===this.active&&0===this.buffer.length&&this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){this.resultSelector?this._notifyResultSelector(e,t,n,r):this.destination.next(t)},t.prototype._notifyResultSelector=function(e,t,n,r){var o;try{o=this.resultSelector(e,t,n,r)}catch(e){return void this.destination.error(e)}this.destination.next(o)},t.prototype.notifyComplete=function(e){var t=this.buffer;this.remove(e),this.active--,t.length>0?this._next(t.shift()):0===this.active&&this.hasCompleted&&this.destination.complete()},t}(a.OuterSubscriber);t.MergeMapSubscriber=s},function(e,t,n){"use strict";function r(e){return!o.isArray(e)&&e-parseFloat(e)+1>=0}var o=n(27);t.isNumeric=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(22),i=n(379),a=function(e){function t(t,n){e.call(this,t,n),this.scheduler=t,this.work=n,this.pending=!1}return r(t,e),t.prototype.schedule=function(e,t){if(void 0===t&&(t=0),this.closed)return this;this.state=e,this.pending=!0;var n=this.id,r=this.scheduler;return null!=n&&(this.id=this.recycleAsyncId(r,n,t)),this.delay=t,this.id=this.id||this.requestAsyncId(r,this.id,t),this},t.prototype.requestAsyncId=function(e,t,n){return void 0===n&&(n=0),o.root.setInterval(e.flush.bind(e,this),n)},t.prototype.recycleAsyncId=function(e,t,n){return void 0===n&&(n=0),null!==n&&this.delay===n&&!1===this.pending?t:o.root.clearInterval(t)&&void 0||void 0},t.prototype.execute=function(e,t){if(this.closed)return new Error("executing a cancelled action");this.pending=!1;var n=this._execute(e,t);if(n)return n;!1===this.pending&&null!=this.id&&(this.id=this.recycleAsyncId(this.scheduler,this.id,null))},t.prototype._execute=function(e,t){var n=!1,r=void 0;try{this.work(e)}catch(e){n=!0,r=!!e&&e||new Error(e)}if(n)return this.unsubscribe(),r},t.prototype._unsubscribe=function(){var e=this.id,t=this.scheduler,n=t.actions,r=n.indexOf(this);this.work=null,this.state=null,this.pending=!1,this.scheduler=null,-1!==r&&n.splice(r,1),null!=e&&(this.id=this.recycleAsyncId(t,e,null)),this.delay=null},t}(i.Action);t.AsyncAction=a},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(380),i=function(e){function t(){e.apply(this,arguments),this.actions=[],this.active=!1,this.scheduled=void 0}return r(t,e),t.prototype.flush=function(e){var t=this.actions;if(this.active)return void t.push(e);var n;this.active=!0;do{if(n=e.execute(e.state,e.delay))break}while(e=t.shift());if(this.active=!1,n){for(;e=t.shift();)e.unsubscribe();throw n}},t}(o.Scheduler);t.AsyncScheduler=i},function(e,t,n){"use strict";function r(e,t){return function(n){if("function"!=typeof e)throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");return n.lift(new a(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.map=r;var a=function(){function e(e,t){this.project=e,this.thisArg=t}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.project,this.thisArg))},e}();t.MapOperator=a;var u=function(e){function t(t,n,r){e.call(this,t),this.project=n,this.count=0,this.thisArg=r||this}return o(t,e),t.prototype._next=function(e){var t;try{t=this.project.call(this.thisArg,e,this.count++)}catch(e){return void this.destination.error(e)}this.destination.next(t)},t}(i.Subscriber)},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=function(e){function t(){var t=e.call(this,"argument out of range");this.name=t.name="ArgumentOutOfRangeError",this.stack=t.stack,this.message=t.message}return r(t,e),t}(Error);t.ArgumentOutOfRangeError=o},function(e,t,n){"use strict";function r(e,t){return arguments.length>=2?function(n){return u.pipe(o.scan(e,t),i.takeLast(1),a.defaultIfEmpty(t))(n)}:function(t){return u.pipe(o.scan(function(t,n,r){return e(t,n,r+1)}),i.takeLast(1))(t)}}var o=n(111),i=n(112),a=n(106),u=n(99);t.reduce=r},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(265),i=r(o),a=n(275),u=r(a),s="function"==typeof u.default&&"symbol"==typeof i.default?function(e){return typeof e}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":typeof e};t.default="function"==typeof u.default&&"symbol"===s(i.default)?function(e){return void 0===e?"undefined":s(e)}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":void 0===e?"undefined":s(e)}},function(e,t,n){"use strict";function r(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!==e&&t!==t}function o(e,t){if(r(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),o=Object.keys(t);if(n.length!==o.length)return!1;for(var a=0;a<n.length;a++)if(!i.call(t,n[a])||!r(e[n[a]],t[n[a]]))return!1;return!0}var i=Object.prototype.hasOwnProperty;e.exports=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return(0,C.default)({},R,e)}function i(e,t,n){var r=[e,t];return r.push(A.passiveOption?n:n.capture),r}function a(e,t,n,r){e.addEventListener.apply(e,i(t,n,r))}function u(e,t,n,r){e.removeEventListener.apply(e,i(t,n,r))}function s(e,t){var n=(e.children,e.target,(0,T.default)(e,["children","target"]));(0,O.default)(n).forEach(function(e){if("on"===e.substring(0,2)){var r=n[e],i=void 0===r?"undefined":(0,w.default)(r),a="object"===i,u="function"===i;if(a||u){var s="capture"===e.substr(-7).toLowerCase(),l=e.substring(2).toLowerCase();l=s?l.substring(0,l.length-7):l,a?t(l,r.handler,r.options):t(l,r,o({capture:s}))}}})}function l(e,t){return{handler:e,options:o(t)}}Object.defineProperty(t,"__esModule",{value:!0});var c=n(11),f=r(c),d=n(8),p=r(d),h=n(9),y=r(h),v=n(12),m=r(v),b=n(13),g=r(b),_=n(60),w=r(_),x=n(305),O=r(x),S=n(15),T=r(S),E=n(120),C=r(E);t.withOptions=l;var k=n(1),P=r(k),M=n(3),j=(r(M),n(61)),N=r(j),I=n(63),A=(r(I),n(308)),R={capture:!1,passive:!1},F=function(e){function t(){return(0,p.default)(this,t),(0,m.default)(this,(t.__proto__||(0,f.default)(t)).apply(this,arguments))}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentDidMount",value:function(){this.addListeners()}},{key:"shouldComponentUpdate",value:function(e){return!(0,N.default)(this.props,e)}},{key:"componentWillUpdate",value:function(){this.removeListeners()}},{key:"componentDidUpdate",value:function(){this.addListeners()}},{key:"componentWillUnmount",value:function(){this.removeListeners()}},{key:"addListeners",value:function(){this.applyListeners(a)}},{key:"removeListeners",value:function(){this.applyListeners(u)}},{key:"applyListeners",value:function(e){var t=this.props.target;if(t){var n=t;"string"==typeof t&&(n=window[t]),s(this.props,e.bind(null,n))}}},{key:"render",value:function(){return this.props.children||null}}]),t}(P.default.Component);F.propTypes={},t.default=F},function(e,t,n){"use strict";var r=function(){};e.exports=r},function(e,t){t=e.exports=function(e){if(e&&"object"==typeof e){var t=e.which||e.keyCode||e.charCode;t&&(e=t)}if("number"==typeof e)return i[e];var o=String(e),a=n[o.toLowerCase()];if(a)return a;var a=r[o.toLowerCase()];return a||(1===o.length?o.charCodeAt(0):void 0)};var n=t.code=t.codes={backspace:8,tab:9,enter:13,shift:16,ctrl:17,alt:18,"pause/break":19,"caps lock":20,esc:27,space:32,"page up":33,"page down":34,end:35,home:36,left:37,up:38,right:39,down:40,insert:45,delete:46,command:91,"left command":91,"right command":93,"numpad *":106,"numpad +":107,"numpad -":109,"numpad .":110,"numpad /":111,"num lock":144,"scroll lock":145,"my computer":182,"my calculator":183,";":186,"=":187,",":188,"-":189,".":190,"/":191,"`":192,"[":219,"\\":220,"]":221,"'":222},r=t.aliases={windows:91,"⇧":16,"⌥":18,"⌃":17,"⌘":91,ctl:17,control:17,option:18,pause:19,break:19,caps:20,return:13,escape:27,spc:32,pgup:33,pgdn:34,ins:45,del:46,cmd:91};/*!
 * Programatically add the following
 */
for(o=97;o<123;o++)n[String.fromCharCode(o)]=o-32;for(var o=48;o<58;o++)n[o-48]=o;for(o=1;o<13;o++)n["f"+o]=o+111;for(o=0;o<10;o++)n["numpad "+o]=o+96;var i=t.names=t.title={};for(o in n)i[n[o]]=o;for(var a in r)n[a]=r[a]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(311),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={set:function(e,t,n){e[t]=n}}},function(e,t,n){"use strict";function r(e){return"function"==typeof e}t.isFunction=r},function(e,t,n){"use strict";var r=n(22),o=r.root.Symbol;t.rxSubscriber="function"==typeof o&&"function"==typeof o.for?o.for("rxSubscriber"):"@@rxSubscriber",t.$$rxSubscriber=t.rxSubscriber},function(e,t,n){"use strict";function r(e){var t,n=e.Symbol;return"function"==typeof n?n.observable?t=n.observable:(t=n("observable"),n.observable=t):t="@@observable",t}var o=n(22);t.getSymbolObservable=r,t.observable=r(o.root),t.$$observable=t.observable},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=function(e){function t(){var t=e.call(this,"object unsubscribed");this.name=t.name="ObjectUnsubscribedError",this.stack=t.stack,this.message=t.message}return r(t,e),t}(Error);t.ObjectUnsubscribedError=o},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(18),a=function(e){function t(){e.apply(this,arguments),this.value=null,this.hasNext=!1,this.hasCompleted=!1}return r(t,e),t.prototype._subscribe=function(t){return this.hasError?(t.error(this.thrownError),i.Subscription.EMPTY):this.hasCompleted&&this.hasNext?(t.next(this.value),t.complete(),i.Subscription.EMPTY):e.prototype._subscribe.call(this,t)},t.prototype.next=function(e){this.hasCompleted||(this.value=e,this.hasNext=!0)},t.prototype.error=function(t){this.hasCompleted||e.prototype.error.call(this,t)},t.prototype.complete=function(){this.hasCompleted=!0,this.hasNext&&e.prototype.next.call(this,this.value),e.prototype.complete.call(this)},t}(o.Subject);t.AsyncSubject=a},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=null;return"function"==typeof e[e.length-1]&&(n=e.pop()),1===e.length&&a.isArray(e[0])&&(e=e[0].slice()),function(t){return t.lift.call(new i.ArrayObservable([t].concat(e)),new c(n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(32),a=n(27),u=n(6),s=n(7),l={};t.combineLatest=r;var c=function(){function e(e){this.project=e}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.project))},e}();t.CombineLatestOperator=c;var f=function(e){function t(t,n){e.call(this,t),this.project=n,this.active=0,this.values=[],this.observables=[]}return o(t,e),t.prototype._next=function(e){this.values.push(l),this.observables.push(e)},t.prototype._complete=function(){var e=this.observables,t=e.length;if(0===t)this.destination.complete();else{this.active=t,this.toRespond=t;for(var n=0;n<t;n++){var r=e[n];this.add(s.subscribeToResult(this,r,r,n))}}},t.prototype.notifyComplete=function(e){0==(this.active-=1)&&this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){var i=this.values,a=i[n],u=this.toRespond?a===l?--this.toRespond:this.toRespond:0;i[n]=t,0===u&&(this.project?this._tryProject(i):this.destination.next(i.slice()))},t.prototype._tryProject=function(e){var t;try{t=this.project.apply(this,e)}catch(e){return void this.destination.error(e)}this.destination.next(t)},t}(u.OuterSubscriber);t.CombineLatestSubscriber=f},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(50);t.observeOn=r;var u=function(){function e(e,t){void 0===t&&(t=0),this.scheduler=e,this.delay=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.scheduler,this.delay))},e}();t.ObserveOnOperator=u;var s=function(e){function t(t,n,r){void 0===r&&(r=0),e.call(this,t),this.scheduler=n,this.delay=r}return o(t,e),t.dispatch=function(e){var t=e.notification,n=e.destination;t.observe(n),this.unsubscribe()},t.prototype.scheduleMessage=function(e){this.add(this.scheduler.schedule(t.dispatch,this.delay,new l(e,this.destination)))},t.prototype._next=function(e){this.scheduleMessage(a.Notification.createNext(e))},t.prototype._error=function(e){this.scheduleMessage(a.Notification.createError(e))},t.prototype._complete=function(){this.scheduleMessage(a.Notification.createComplete())},t}(i.Subscriber);t.ObserveOnSubscriber=s;var l=function(){function e(e,t){this.notification=e,this.destination=t}return e}();t.ObserveOnMessage=l},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=Number.POSITIVE_INFINITY),o.mergeMap(i.identity,null,e)}var o=n(51),i=n(153);t.mergeAll=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=Number.POSITIVE_INFINITY,r=null,s=e[e.length-1];return a.isScheduler(s)?(r=e.pop(),e.length>1&&"number"==typeof e[e.length-1]&&(n=e.pop())):"number"==typeof s&&(n=e.pop()),null===r&&1===e.length&&e[0]instanceof o.Observable?e[0]:u.mergeAll(n)(new i.ArrayObservable(e,r))}var o=n(0),i=n(32),a=n(25),u=n(74);t.merge=r},function(e,t,n){"use strict";function r(e){return e instanceof Date&&!isNaN(+e)}t.isDate=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){return t.lift.call(o.apply(void 0,[t].concat(e)))}}function o(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=e[e.length-1];return"function"==typeof n&&e.pop(),new a.ArrayObservable(e).lift(new d(n))}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(32),u=n(27),s=n(2),l=n(6),c=n(7),f=n(48);t.zip=r,t.zipStatic=o;var d=function(){function e(e){this.project=e}return e.prototype.call=function(e,t){return t.subscribe(new p(e,this.project))},e}();t.ZipOperator=d;var p=function(e){function t(t,n,r){void 0===r&&(r=Object.create(null)),e.call(this,t),this.iterators=[],this.active=0,this.project="function"==typeof n?n:null,this.values=r}return i(t,e),t.prototype._next=function(e){var t=this.iterators;u.isArray(e)?t.push(new y(e)):"function"==typeof e[f.iterator]?t.push(new h(e[f.iterator]())):t.push(new v(this.destination,this,e))},t.prototype._complete=function(){var e=this.iterators,t=e.length;if(0===t)return void this.destination.complete();this.active=t;for(var n=0;n<t;n++){var r=e[n];r.stillUnsubscribed?this.add(r.subscribe(r,n)):this.active--}},t.prototype.notifyInactive=function(){0==--this.active&&this.destination.complete()},t.prototype.checkIterators=function(){for(var e=this.iterators,t=e.length,n=this.destination,r=0;r<t;r++){var o=e[r];if("function"==typeof o.hasValue&&!o.hasValue())return}for(var i=!1,a=[],r=0;r<t;r++){var o=e[r],u=o.next();if(o.hasCompleted()&&(i=!0),u.done)return void n.complete();a.push(u.value)}this.project?this._tryProject(a):n.next(a),i&&n.complete()},t.prototype._tryProject=function(e){var t;try{t=this.project.apply(this,e)}catch(e){return void this.destination.error(e)}this.destination.next(t)},t}(s.Subscriber);t.ZipSubscriber=p;var h=function(){function e(e){this.iterator=e,this.nextResult=e.next()}return e.prototype.hasValue=function(){return!0},e.prototype.next=function(){var e=this.nextResult;return this.nextResult=this.iterator.next(),e},e.prototype.hasCompleted=function(){var e=this.nextResult;return e&&e.done},e}(),y=function(){function e(e){this.array=e,this.index=0,this.length=0,this.length=e.length}return e.prototype[f.iterator]=function(){return this},e.prototype.next=function(e){var t=this.index++,n=this.array;return t<this.length?{value:n[t],done:!1}:{value:null,done:!0}},e.prototype.hasValue=function(){return this.array.length>this.index},e.prototype.hasCompleted=function(){return this.array.length===this.index},e}(),v=function(e){function t(t,n,r){e.call(this,t),this.parent=n,this.observable=r,this.stillUnsubscribed=!0,this.buffer=[],this.isComplete=!1}return i(t,e),t.prototype[f.iterator]=function(){return this},t.prototype.next=function(){var e=this.buffer;return 0===e.length&&this.isComplete?{value:null,done:!0}:{value:e.shift(),done:!1}},t.prototype.hasValue=function(){return this.buffer.length>0},t.prototype.hasCompleted=function(){return 0===this.buffer.length&&this.isComplete},t.prototype.notifyComplete=function(){this.buffer.length>0?(this.isComplete=!0,this.parent.notifyInactive()):this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){this.buffer.push(t),this.parent.checkIterators()},t.prototype.subscribe=function(e,t){return c.subscribeToResult(this,this.observable,this,t)},t}(l.OuterSubscriber)},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(156),a=n(18),u=n(73),s=n(70),l=n(146),c=function(e){function t(t,n,r){void 0===t&&(t=Number.POSITIVE_INFINITY),void 0===n&&(n=Number.POSITIVE_INFINITY),e.call(this),this.scheduler=r,this._events=[],this._bufferSize=t<1?1:t,this._windowTime=n<1?1:n}return r(t,e),t.prototype.next=function(t){var n=this._getNow();this._events.push(new f(n,t)),this._trimBufferThenGetEvents(),e.prototype.next.call(this,t)},t.prototype._subscribe=function(e){var t,n=this._trimBufferThenGetEvents(),r=this.scheduler;if(this.closed)throw new s.ObjectUnsubscribedError;this.hasError?t=a.Subscription.EMPTY:this.isStopped?t=a.Subscription.EMPTY:(this.observers.push(e),t=new l.SubjectSubscription(this,e)),r&&e.add(e=new u.ObserveOnSubscriber(e,r));for(var o=n.length,i=0;i<o&&!e.closed;i++)e.next(n[i].value);return this.hasError?e.error(this.thrownError):this.isStopped&&e.complete(),t},t.prototype._getNow=function(){return(this.scheduler||i.queue).now()},t.prototype._trimBufferThenGetEvents=function(){for(var e=this._getNow(),t=this._bufferSize,n=this._windowTime,r=this._events,o=r.length,i=0;i<o&&!(e-r[i].time<n);)i++;return o>t&&(i=Math.max(i,o-t)),i>0&&r.splice(0,i),r},t}(o.Subject);t.ReplaySubject=c;var f=function(){function e(e,t){this.time=e,this.value=t}return e}()},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=function(e){function t(){var t=e.call(this,"no elements in sequence");this.name=t.name="EmptyError",this.stack=t.stack,this.message=t.message}return r(t,e),t}(Error);t.EmptyError=o},function(e,t,n){"use strict";function r(e,n){return void 0===n&&(n=t.defaultThrottleConfig),function(t){return t.lift(new u(e,n.leading,n.trailing))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.defaultThrottleConfig={leading:!0,trailing:!1},t.throttle=r;var u=function(){function e(e,t,n){this.durationSelector=e,this.leading=t,this.trailing=n}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.durationSelector,this.leading,this.trailing))},e}(),s=function(e){function t(t,n,r,o){e.call(this,t),this.destination=t,this.durationSelector=n,this._leading=r,this._trailing=o,this._hasTrailingValue=!1}return o(t,e),t.prototype._next=function(e){if(this.throttled)this._trailing&&(this._hasTrailingValue=!0,this._trailingValue=e);else{var t=this.tryDurationSelector(e);t&&this.add(this.throttled=a.subscribeToResult(this,t)),this._leading&&(this.destination.next(e),this._trailing&&(this._hasTrailingValue=!0,this._trailingValue=e))}},t.prototype.tryDurationSelector=function(e){try{return this.durationSelector(e)}catch(e){return this.destination.error(e),null}},t.prototype._unsubscribe=function(){var e=this,t=e.throttled;e._trailingValue,e._hasTrailingValue,e._trailing,this._trailingValue=null,this._hasTrailingValue=!1,t&&(this.remove(t),this.throttled=null,t.unsubscribe())},t.prototype._sendTrailing=function(){var e=this,t=e.destination,n=e.throttled,r=e._trailing,o=e._trailingValue,i=e._hasTrailingValue;n&&r&&i&&(t.next(o),this._trailingValue=null,this._hasTrailingValue=!1)},t.prototype.notifyNext=function(e,t,n,r,o){this._sendTrailing(),this._unsubscribe()},t.prototype.notifyComplete=function(){this._sendTrailing(),this._unsubscribe()},t}(i.OuterSubscriber)},function(e,t,n){var r=n(257);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var r=n(40);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(87)("keys"),o=n(58);e.exports=function(e){return r[e]||(r[e]=o(e))}},function(e,t,n){var r=n(29),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t){e.exports=!0},function(e,t,n){var r=n(39),o=n(269),i=n(88),a=n(86)("IE_PROTO"),u=function(){},s=function(){var e,t=n(122)("iframe"),r=i.length;for(t.style.display="none",n(270).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),s=e.F;r--;)delete s.prototype[i[r]];return s()};e.exports=Object.create||function(e,t){var n;return null!==e?(u.prototype=r(e),n=new u,u.prototype=null,n[a]=e):n=s(),void 0===t?n:o(n,t)}},function(e,t,n){var r=n(30).f,o=n(35),i=n(26)("toStringTag");e.exports=function(e,t,n){e&&!o(e=n?e:e.prototype,i)&&r(e,i,{configurable:!0,value:t})}},function(e,t,n){t.f=n(26)},function(e,t,n){var r=n(29),o=n(24),i=n(90),a=n(93),u=n(30).f;e.exports=function(e){var t=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||u(t,e,{value:a.f(e)})}},function(e,t,n){"use strict";function r(e){return function(){return e}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=n(312),l=r(s),c=n(1),f=r(c),d=n(3),p=r(d),h=n(63),y=(r(h),n(313)),v=(p.default.any,p.default.func,p.default.node,{component:"span",childFactory:function(e){return e}}),m=function(e){function t(n,r){o(this,t);var a=i(this,e.call(this,n,r));return a.performAppear=function(e,t){a.currentlyTransitioningKeys[e]=!0,t.componentWillAppear?t.componentWillAppear(a._handleDoneAppearing.bind(a,e,t)):a._handleDoneAppearing(e,t)},a._handleDoneAppearing=function(e,t){t.componentDidAppear&&t.componentDidAppear(),delete a.currentlyTransitioningKeys[e];var n=(0,y.getChildMapping)(a.props.children);n&&n.hasOwnProperty(e)||a.performLeave(e,t)},a.performEnter=function(e,t){a.currentlyTransitioningKeys[e]=!0,t.componentWillEnter?t.componentWillEnter(a._handleDoneEntering.bind(a,e,t)):a._handleDoneEntering(e,t)},a._handleDoneEntering=function(e,t){t.componentDidEnter&&t.componentDidEnter(),delete a.currentlyTransitioningKeys[e];var n=(0,y.getChildMapping)(a.props.children);n&&n.hasOwnProperty(e)||a.performLeave(e,t)},a.performLeave=function(e,t){a.currentlyTransitioningKeys[e]=!0,t.componentWillLeave?t.componentWillLeave(a._handleDoneLeaving.bind(a,e,t)):a._handleDoneLeaving(e,t)},a._handleDoneLeaving=function(e,t){t.componentDidLeave&&t.componentDidLeave(),delete a.currentlyTransitioningKeys[e];var n=(0,y.getChildMapping)(a.props.children);n&&n.hasOwnProperty(e)?a.keysToEnter.push(e):a.setState(function(t){var n=u({},t.children);return delete n[e],{children:n}})},a.childRefs=Object.create(null),a.state={children:(0,y.getChildMapping)(n.children)},a}return a(t,e),t.prototype.componentWillMount=function(){this.currentlyTransitioningKeys={},this.keysToEnter=[],this.keysToLeave=[]},t.prototype.componentDidMount=function(){var e=this.state.children;for(var t in e)e[t]&&this.performAppear(t,this.childRefs[t])},t.prototype.componentWillReceiveProps=function(e){var t=(0,y.getChildMapping)(e.children),n=this.state.children;this.setState({children:(0,y.mergeChildMappings)(n,t)});for(var r in t){var o=n&&n.hasOwnProperty(r);!t[r]||o||this.currentlyTransitioningKeys[r]||this.keysToEnter.push(r)}for(var i in n){var a=t&&t.hasOwnProperty(i);!n[i]||a||this.currentlyTransitioningKeys[i]||this.keysToLeave.push(i)}},t.prototype.componentDidUpdate=function(){var e=this,t=this.keysToEnter;this.keysToEnter=[],t.forEach(function(t){return e.performEnter(t,e.childRefs[t])});var n=this.keysToLeave;this.keysToLeave=[],n.forEach(function(t){return e.performLeave(t,e.childRefs[t])})},t.prototype.render=function(){var e=this,t=[];for(var n in this.state.children)!function(n){var r=e.state.children[n];if(r){var o="string"!=typeof r.ref,i=e.props.childFactory(r),a=function(t){e.childRefs[n]=t};i===r&&o&&(a=(0,l.default)(r.ref,a)),t.push(f.default.cloneElement(i,{key:n,ref:a}))}}(n);var r=u({},this.props);return delete r.transitionLeave,delete r.transitionName,delete r.transitionAppear,delete r.transitionEnter,delete r.childFactory,delete r.transitionLeaveTimeout,delete r.transitionEnterTimeout,delete r.transitionAppearTimeout,delete r.component,f.default.createElement(this.props.component,r,t)},t}(f.default.Component);m.displayName="TransitionGroup",m.propTypes={},m.defaultProps=v,t.default=m,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){if(!A){var e=document.createElement("style");e.innerHTML="\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ",document.body.appendChild(e),A=!0}}function i(){R||(C.default.on(window,"keydown",function(e){F="tab"===(0,P.default)(e)}),R=!0)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(14),u=r(a),s=n(15),l=r(s),c=n(11),f=r(c),d=n(8),p=r(d),h=n(9),y=r(h),v=n(12),m=r(v),b=n(13),g=r(b),_=n(10),w=r(_),x=n(1),O=r(x),S=n(3),T=r(S),E=n(138),C=r(E),k=n(64),P=r(k),M=n(314),j=r(M),N=n(317),I=r(N),A=!1,R=!1,F=!1,D=function(e){function t(){var e,n,r,o;(0,p.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,m.default)(this,(e=t.__proto__||(0,f.default)(t)).call.apply(e,[this].concat(a))),r.state={isKeyboardFocused:!1},r.handleKeyDown=function(e){r.props.disabled||r.props.disableKeyboardFocus||("enter"===(0,P.default)(e)&&r.state.isKeyboardFocused&&r.handleTouchTap(e),"esc"===(0,P.default)(e)&&r.state.isKeyboardFocused&&r.removeKeyboardFocus(e)),r.props.onKeyDown(e)},r.handleKeyUp=function(e){r.props.disabled||r.props.disableKeyboardFocus||"space"===(0,P.default)(e)&&r.state.isKeyboardFocused&&r.handleTouchTap(e),r.props.onKeyUp(e)},r.handleBlur=function(e){r.cancelFocusTimeout(),r.removeKeyboardFocus(e),r.props.onBlur(e)},r.handleFocus=function(e){e&&e.persist(),r.props.disabled||r.props.disableKeyboardFocus||(r.focusTimeout=setTimeout(function(){F&&(r.setKeyboardFocus(e),F=!1)},150),r.props.onFocus(e))},r.handleTouchTap=function(e){r.cancelFocusTimeout(),r.props.disabled||(F=!1,r.removeKeyboardFocus(e),r.props.onClick(e))},o=n,(0,m.default)(r,o)}return(0,g.default)(t,e),(0,y.default)(t,[{key:"componentWillMount",value:function(){var e=this.props,t=e.disabled,n=e.disableKeyboardFocus,r=e.keyboardFocused;t||!r||n||this.setState({isKeyboardFocused:!0})}},{key:"componentDidMount",value:function(){o(),i(),this.state.isKeyboardFocused&&(this.button.focus(),this.props.onKeyboardFocus(null,!0))}},{key:"componentWillReceiveProps",value:function(e){(e.disabled||e.disableKeyboardFocus)&&this.state.isKeyboardFocused&&(this.setState({isKeyboardFocused:!1}),e.onKeyboardFocus&&e.onKeyboardFocus(null,!1))}},{key:"componentWillUnmount",value:function(){this.focusTimeout&&clearTimeout(this.focusTimeout)}},{key:"isKeyboardFocused",value:function(){return this.state.isKeyboardFocused}},{key:"removeKeyboardFocus",value:function(e){this.state.isKeyboardFocused&&(this.setState({isKeyboardFocused:!1}),this.props.onKeyboardFocus(e,!1))}},{key:"setKeyboardFocus",value:function(e){this.state.isKeyboardFocused||(this.setState({isKeyboardFocused:!0}),this.props.onKeyboardFocus(e,!0))}},{key:"cancelFocusTimeout",value:function(){this.focusTimeout&&(clearTimeout(this.focusTimeout),this.focusTimeout=null)}},{key:"createButtonChildren",value:function(){var e=this.props,t=e.centerRipple,n=e.children,r=e.disabled,o=e.disableFocusRipple,i=e.disableKeyboardFocus,a=e.disableTouchRipple,u=e.focusRippleColor,s=e.focusRippleOpacity,l=e.touchRippleColor,c=e.touchRippleOpacity,f=this.state.isKeyboardFocused,d=!f||r||o||i?void 0:O.default.createElement(j.default,{color:u,opacity:s,show:f,style:{overflow:"hidden"},key:"focusRipple"}),p=r||a?void 0:O.default.createElement(I.default,{centerRipple:t,color:l,opacity:c,key:"touchRipple"},n);return[d,p,p?void 0:n]}},{key:"render",value:function(){var e=this,t=this.props,n=(t.centerRipple,t.children),r=t.containerElement,o=t.disabled,i=(t.disableFocusRipple,t.disableKeyboardFocus),a=(t.disableTouchRipple,t.focusRippleColor,t.focusRippleOpacity,t.href),s=(t.keyboardFocused,t.touchRippleColor,t.touchRippleOpacity,t.onBlur,t.onClick,t.onFocus,t.onKeyUp,t.onKeyDown,t.onKeyboardFocus,t.style),c=t.tabIndex,f=t.type,d=(0,l.default)(t,["centerRipple","children","containerElement","disabled","disableFocusRipple","disableKeyboardFocus","disableTouchRipple","focusRippleColor","focusRippleOpacity","href","keyboardFocused","touchRippleColor","touchRippleOpacity","onBlur","onClick","onFocus","onKeyUp","onKeyDown","onKeyboardFocus","style","tabIndex","type"]),p=this.context.muiTheme,h=p.prepareStyles,y=p.enhancedButton,v=(0,w.default)({border:10,boxSizing:"border-box",display:"inline-block",fontFamily:this.context.muiTheme.baseTheme.fontFamily,WebkitTapHighlightColor:y.tapHighlightColor,cursor:o?"default":"pointer",textDecoration:"none",margin:0,padding:0,outline:"none",fontSize:"inherit",fontWeight:"inherit",position:"relative",verticalAlign:a?"middle":null},s);if(v.backgroundColor||v.background||(v.background="none"),o&&a)return O.default.createElement("span",(0,u.default)({},d,{style:v}),n);var m=(0,u.default)({},d,{style:h(v),ref:function(t){return e.button=t},disabled:o,onBlur:this.handleBlur,onFocus:this.handleFocus,onKeyUp:this.handleKeyUp,onKeyDown:this.handleKeyDown,onClick:this.handleTouchTap,tabIndex:o||i?-1:c});a&&(m.href=a);var b=this.createButtonChildren();return O.default.isValidElement(r)?O.default.cloneElement(r,m,b):(a||"button"!==r||(m.type=f),O.default.createElement(a?"a":r,m,b))}}]),t}(x.Component);D.defaultProps={containerElement:"button",onBlur:function(){},onClick:function(){},onFocus:function(){},onKeyDown:function(){},onKeyUp:function(){},onKeyboardFocus:function(){},tabIndex:0,type:"button"},D.contextTypes={muiTheme:T.default.object.isRequired},D.propTypes={},t.default=D},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(335),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o(e)}function o(e){return e?1===e.length?e[0]:function(t){return e.reduce(function(e,t){return t(e)},t)}:i.noop}var i=n(100);t.pipe=r,t.pipeFromArray=o},function(e,t,n){"use strict";function r(){}t.noop=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=function(e){function t(t,n){e.call(this),this.value=t,this.scheduler=n,this._isScalar=!0,n&&(this._isScalar=!1)}return r(t,e),t.create=function(e,n){return new t(e,n)},t.dispatch=function(e){var t=e.done,n=e.value,r=e.subscriber;if(t)return void r.complete();r.next(n),r.closed||(e.done=!0,this.schedule(e))},t.prototype._subscribe=function(e){var n=this.value,r=this.scheduler;if(r)return r.schedule(t.dispatch,0,{done:!1,value:n,subscriber:e});e.next(n),e.closed||e.complete()},t}(o.Observable);t.ScalarObservable=i},function(e,t,n){"use strict";function r(){return o.mergeAll(1)}var o=n(74);t.concatAll=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];if(1===e.length){if(!i.isArray(e[0]))return e[0];e=e[0]}return new a.ArrayObservable(e).lift(new l)}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(27),a=n(32),u=n(6),s=n(7);t.race=r;var l=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new c(e))},e}();t.RaceOperator=l;var c=function(e){function t(t){e.call(this,t),this.hasFirst=!1,this.observables=[],this.subscriptions=[]}return o(t,e),t.prototype._next=function(e){this.observables.push(e)},t.prototype._complete=function(){var e=this.observables,t=e.length;if(0===t)this.destination.complete();else{for(var n=0;n<t&&!this.hasFirst;n++){var r=e[n],o=s.subscribeToResult(this,r,r,n);this.subscriptions&&this.subscriptions.push(o),this.add(o)}this.observables=null}},t.prototype.notifyNext=function(e,t,n,r,o){if(!this.hasFirst){this.hasFirst=!0;for(var i=0;i<this.subscriptions.length;i++)if(i!==n){var a=this.subscriptions[i];a.unsubscribe(),this.remove(a)}this.subscriptions=null}this.destination.next(t)},t}(u.OuterSubscriber);t.RaceSubscriber=c},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return 1===e.length&&u.isArray(e[0])&&(e=e[0]),function(t){return t.lift(new c(e))}}function o(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=null;return 1===e.length&&u.isArray(e[0])&&(e=e[0]),n=e.shift(),new a.FromObservable(n,null).lift(new c(e))}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(151),u=n(27),s=n(6),l=n(7);t.onErrorResumeNext=r,t.onErrorResumeNextStatic=o;var c=function(){function e(e){this.nextSources=e}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.nextSources))},e}(),f=function(e){function t(t,n){e.call(this,t),this.destination=t,this.nextSources=n}return i(t,e),t.prototype.notifyError=function(e,t){this.subscribeToNextSource()},t.prototype.notifyComplete=function(e){this.subscribeToNextSource()},t.prototype._error=function(e){this.subscribeToNextSource()},t.prototype._complete=function(){this.subscribeToNextSource()},t.prototype.subscribeToNextSource=function(){var e=this.nextSources.shift();e?this.add(l.subscribeToResult(this,e)):this.destination.complete()},t}(s.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return o.mergeMap(e,t,1)}var o=n(51);t.concatMap=r},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=null),function(t){return t.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.defaultIfEmpty=r;var a=function(){function e(e){this.defaultValue=e}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.defaultValue))},e}(),u=function(e){function t(t,n){e.call(this,t),this.defaultValue=n,this.isEmpty=!0}return o(t,e),t.prototype._next=function(e){this.isEmpty=!1,this.destination.next(e)},t.prototype._complete=function(){this.isEmpty&&this.destination.next(this.defaultValue),this.destination.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new s(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(21),u=n(20);t.distinctUntilChanged=r;var s=function(){function e(e,t){this.compare=e,this.keySelector=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.compare,this.keySelector))},e}(),l=function(e){function t(t,n,r){e.call(this,t),this.keySelector=r,this.hasKey=!1,"function"==typeof n&&(this.compare=n)}return o(t,e),t.prototype.compare=function(e,t){return e===t},t.prototype._next=function(e){var t=this.keySelector,n=e;if(t&&(n=a.tryCatch(this.keySelector)(e))===u.errorObject)return this.destination.error(u.errorObject.e);var r=!1;if(this.hasKey){if((r=a.tryCatch(this.compare)(this.key,n))===u.errorObject)return this.destination.error(u.errorObject.e)}else this.hasKey=!0;!1===Boolean(r)&&(this.key=n,this.destination.next(e))},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new a(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.filter=r;var a=function(){function e(e,t){this.predicate=e,this.thisArg=t}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate,this.thisArg))},e}(),u=function(e){function t(t,n,r){e.call(this,t),this.predicate=n,this.thisArg=r,this.count=0}return o(t,e),t.prototype._next=function(e){var t;try{t=this.predicate.call(this.thisArg,e,this.count++)}catch(e){return void this.destination.error(e)}t&&this.destination.next(e)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){if("function"!=typeof e)throw new TypeError("predicate is not a function");return function(n){return n.lift(new a(e,n,!1,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.find=r;var a=function(){function e(e,t,n,r){this.predicate=e,this.source=t,this.yieldIndex=n,this.thisArg=r}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate,this.source,this.yieldIndex,this.thisArg))},e}();t.FindValueOperator=a;var u=function(e){function t(t,n,r,o,i){e.call(this,t),this.predicate=n,this.source=r,this.yieldIndex=o,this.thisArg=i,this.index=0}return o(t,e),t.prototype.notifyComplete=function(e){var t=this.destination;t.next(e),t.complete()},t.prototype._next=function(e){var t=this,n=t.predicate,r=t.thisArg,o=this.index++;try{n.call(r||this,e,o,this.source)&&this.notifyComplete(this.yieldIndex?o:e)}catch(e){this.destination.error(e)}},t.prototype._complete=function(){this.notifyComplete(this.yieldIndex?-1:void 0)},t}(i.Subscriber);t.FindValueSubscriber=u},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new l(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(21),a=n(20),u=n(6),s=n(7);t.audit=r;var l=function(){function e(e){this.durationSelector=e}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.durationSelector))},e}(),c=function(e){function t(t,n){e.call(this,t),this.durationSelector=n,this.hasValue=!1}return o(t,e),t.prototype._next=function(e){if(this.value=e,this.hasValue=!0,!this.throttled){var t=i.tryCatch(this.durationSelector)(e);if(t===a.errorObject)this.destination.error(a.errorObject.e);else{var n=s.subscribeToResult(this,t);n.closed?this.clearThrottle():this.add(this.throttled=n)}}},t.prototype.clearThrottle=function(){var e=this,t=e.value,n=e.hasValue,r=e.throttled;r&&(this.remove(r),this.throttled=null,r.unsubscribe()),n&&(this.value=null,this.hasValue=!1,this.destination.next(t))},t.prototype.notifyNext=function(e,t,n,r){this.clearThrottle()},t.prototype.notifyComplete=function(){this.clearThrottle()},t}(u.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){var n=!1;return arguments.length>=2&&(n=!0),function(r){return r.lift(new a(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.scan=r;var a=function(){function e(e,t,n){void 0===n&&(n=!1),this.accumulator=e,this.seed=t,this.hasSeed=n}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.accumulator,this.seed,this.hasSeed))},e}(),u=function(e){function t(t,n,r,o){e.call(this,t),this.accumulator=n,this._seed=r,this.hasSeed=o,this.index=0}return o(t,e),Object.defineProperty(t.prototype,"seed",{get:function(){return this._seed},set:function(e){this.hasSeed=!0,this._seed=e},enumerable:!0,configurable:!0}),t.prototype._next=function(e){if(this.hasSeed)return this._tryNext(e);this.seed=e,this.destination.next(e)},t.prototype._tryNext=function(e){var t,n=this.index++;try{t=this.accumulator(this.seed,e,n)}catch(e){this.destination.error(e)}this.seed=t,this.destination.next(t)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return 0===e?new u.EmptyObservable:t.lift(new s(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(56),u=n(33);t.takeLast=r;var s=function(){function e(e){if(this.total=e,this.total<0)throw new a.ArgumentOutOfRangeError}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.total))},e}(),l=function(e){function t(t,n){e.call(this,t),this.total=n,this.ring=new Array,this.count=0}return o(t,e),t.prototype._next=function(e){var t=this.ring,n=this.total,r=this.count++;t.length<n?t.push(e):t[r%n]=e},t.prototype._complete=function(){var e=this.destination,t=this.count;if(t>0)for(var n=this.count>=this.total?this.total:this.count,r=this.ring,o=0;o<n;o++){var i=t++%n;e.next(r[i])}e.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.refCount=r;var a=function(){function e(e){this.connectable=e}return e.prototype.call=function(e,t){var n=this.connectable;n._refCount++;var r=new u(e,n),o=t.subscribe(r);return r.closed||(r.connection=n.connect()),o},e}(),u=function(e){function t(t,n){e.call(this,t),this.connectable=n}return o(t,e),t.prototype._unsubscribe=function(){var e=this.connectable;if(!e)return void(this.connection=null);this.connectable=null;var t=e._refCount;if(t<=0)return void(this.connection=null);if(e._refCount=t-1,t>1)return void(this.connection=null);var n=this.connection,r=e._connection;this.connection=null,!r||n&&r!==n||r.unsubscribe()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.switchMap=r;var u=function(){function e(e,t){this.project=e,this.resultSelector=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.project,this.resultSelector))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.project=n,this.resultSelector=r,this.index=0}return o(t,e),t.prototype._next=function(e){var t,n=this.index++;try{t=this.project(e,n)}catch(e){return void this.destination.error(e)}this._innerSub(t,e,n)},t.prototype._innerSub=function(e,t,n){var r=this.innerSubscription;r&&r.unsubscribe(),this.add(this.innerSubscription=a.subscribeToResult(this,e,t,n))},t.prototype._complete=function(){var t=this.innerSubscription;t&&!t.closed||e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){this.innerSubscription=null},t.prototype.notifyComplete=function(t){this.remove(t),this.innerSubscription=null,this.isStopped&&e.prototype._complete.call(this)},t.prototype.notifyNext=function(e,t,n,r,o){this.resultSelector?this._tryNotifyNext(e,t,n,r):this.destination.next(t)},t.prototype._tryNotifyNext=function(e,t,n,r){var o;try{o=this.resultSelector(e,t,n,r)}catch(e){return void this.destination.error(e)}this.destination.next(o)},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=o.async),i.map(function(t){return new a(t,e.now())})}var o=n(16),i=n(55);t.timestamp=r;var a=function(){function e(e,t){this.value=e,this.timestamp=t}return e}();t.Timestamp=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(644),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(23),T=r(S),E=n(62),C=r(E),k=n(134),P=r(k),M=n(31),j=(r(M),n(65)),N=r(j),I=n(645),A=r(I),R=n(646),F=r(R),D={root:{display:"none"}},L=function(e){function t(e,n){(0,f.default)(this,t);var r=(0,y.default)(this,(t.__proto__||(0,l.default)(t)).call(this,e,n));return r.timeout=null,r.renderLayer=function(){var e=r.props,t=e.animated,n=e.animation,o=(e.anchorEl,e.anchorOrigin,e.autoCloseWhenOffScreen,e.canAutoPosition,e.children),a=(e.onRequestClose,e.style),s=e.targetOrigin,l=(e.useLayerForClickAway,e.scrollableContainer,(0,u.default)(e,["animated","animation","anchorEl","anchorOrigin","autoCloseWhenOffScreen","canAutoPosition","children","onRequestClose","style","targetOrigin","useLayerForClickAway","scrollableContainer"])),c=a;if(!t)return c={position:"fixed",zIndex:r.context.muiTheme.zIndex.popover},r.state.open?w.default.createElement(N.default,(0,i.default)({style:(0,g.default)(c,a)},l),o):null;var f=n||F.default;return w.default.createElement(f,(0,i.default)({targetOrigin:s,style:c},l,{open:r.state.open&&!r.state.closing}),o)},r.componentClickAway=function(){r.requestClose("clickAway")},r.setPlacement=function(e){if(r.state.open&&r.popoverRefs.layer.getLayer()){var t=r.popoverRefs.layer.getLayer().children[0];if(t){var n=r.props,o=n.targetOrigin,i=n.anchorOrigin,a=r.props.anchorEl||r.anchorEl,u=r.getAnchorPosition(a),s=r.getTargetPosition(t),l={top:u[i.vertical]-s[o.vertical],left:u[i.horizontal]-s[o.horizontal]};e&&r.props.autoCloseWhenOffScreen&&r.autoCloseWhenOffScreen(u),r.props.canAutoPosition&&(s=r.getTargetPosition(t),l=r.applyAutoPositionIfNeeded(u,s,o,i,l)),t.style.top=l.top+"px",t.style.left=l.left+"px",t.style.maxHeight=window.innerHeight+"px"}}},r.handleResize=(0,A.default)(r.setPlacement,100),r.handleScroll=(0,A.default)(r.setPlacement.bind(r,!0),50),r.popoverRefs={},r.state={open:e.open,closing:!1},r}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentDidMount",value:function(){this.placementTimeout=setTimeout(this.setPlacement)}},{key:"componentWillReceiveProps",value:function(e){var t=this;if(e.open!==this.props.open)if(e.open)clearTimeout(this.timeout),this.timeout=null,this.anchorEl=e.anchorEl||this.props.anchorEl,this.setState({open:!0,closing:!1});else if(e.animated){if(null!==this.timeout)return;this.setState({closing:!0}),this.timeout=setTimeout(function(){t.setState({open:!1},function(){t.timeout=null})},500)}else this.setState({open:!1})}},{key:"componentDidUpdate",value:function(){clearTimeout(this.placementTimeout),this.placementTimeout=setTimeout(this.setPlacement)}},{key:"componentWillUnmount",value:function(){this.handleResize.cancel(),this.handleScroll.cancel(),this.placementTimeout&&(clearTimeout(this.placementTimeout),this.placementTimeout=null),this.timeout&&(clearTimeout(this.timeout),this.timeout=null)}},{key:"requestClose",value:function(e){this.props.onRequestClose&&this.props.onRequestClose(e)}},{key:"getAnchorPosition",value:function(e){e||(e=T.default.findDOMNode(this));var t=e.getBoundingClientRect(),n={top:t.top,left:t.left,width:e.offsetWidth,height:e.offsetHeight};return n.right=t.right||n.left+n.width,n.bottom=t.bottom||n.top+n.height,n.middle=n.left+(n.right-n.left)/2,n.center=n.top+(n.bottom-n.top)/2,n}},{key:"getTargetPosition",value:function(e){return{top:0,center:e.offsetHeight/2,bottom:e.offsetHeight,left:0,middle:e.offsetWidth/2,right:e.offsetWidth}}},{key:"autoCloseWhenOffScreen",value:function(e){(e.top<0||e.top>window.innerHeight||e.left<0||e.left>window.innerWidth)&&this.requestClose("offScreen")}},{key:"getOverlapMode",value:function(e,t,n){return[e,t].indexOf(n)>=0?"auto":e===t?"inclusive":"exclusive"}},{key:"getPositions",value:function(e,t){var n=(0,i.default)({},e),r=(0,i.default)({},t),o={x:["left","right"].filter(function(e){return e!==r.horizontal}),y:["top","bottom"].filter(function(e){return e!==r.vertical})},a={x:this.getOverlapMode(n.horizontal,r.horizontal,"middle"),y:this.getOverlapMode(n.vertical,r.vertical,"center")};return o.x.splice("auto"===a.x?0:1,0,"middle"),o.y.splice("auto"===a.y?0:1,0,"center"),"auto"!==a.y&&(n.vertical="top"===n.vertical?"bottom":"top","inclusive"===a.y&&(r.vertical=r.vertical)),"auto"!==a.x&&(n.horizontal="left"===n.horizontal?"right":"left","inclusive"===a.y&&(r.horizontal=r.horizontal)),{positions:o,anchorPos:n}}},{key:"applyAutoPositionIfNeeded",value:function(e,t,n,r,o){var i=this.getPositions(r,n),a=i.positions,u=i.anchorPos;if(o.top<0||o.top+t.bottom>window.innerHeight){var s=e[u.vertical]-t[a.y[0]];s+t.bottom<=window.innerHeight?o.top=Math.max(0,s):(s=e[u.vertical]-t[a.y[1]])+t.bottom<=window.innerHeight&&(o.top=Math.max(0,s))}if(o.left<0||o.left+t.right>window.innerWidth){var l=e[u.horizontal]-t[a.x[0]];l+t.right<=window.innerWidth?o.left=Math.max(0,l):(l=e[u.horizontal]-t[a.x[1]])+t.right<=window.innerWidth&&(o.left=Math.max(0,l))}return o}},{key:"render",value:function(){var e=this;return w.default.createElement("div",{style:D.root},w.default.createElement(C.default,{target:this.props.scrollableContainer,onScroll:this.handleScroll,onResize:this.handleResize}),w.default.createElement(P.default,{ref:function(t){return e.popoverRefs.layer=t},open:this.state.open,componentClickAway:this.componentClickAway,useLayerForClickAway:this.props.useLayerForClickAway,render:this.renderLayer}))}}]),t}(_.Component);L.defaultProps={anchorOrigin:{vertical:"bottom",horizontal:"left"},animated:!0,autoCloseWhenOffScreen:!0,canAutoPosition:!0,onRequestClose:function(){},open:!1,scrollableContainer:"window",style:{overflowY:"auto"},targetOrigin:{vertical:"top",horizontal:"left"},useLayerForClickAway:!0,zDepth:1},L.contextTypes={muiTheme:O.default.object.isRequired},L.propTypes={},t.default=L},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(653),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),o=n.n(r),i=n(3),a=n.n(i),u=n(663),s=n.n(u),l=n(664),c=n.n(l),f=n(665),d=n.n(f),p=n(666),h=n.n(p),y=n(667),v=n.n(y),m=n(668),b=n.n(m),g=n(669),_=n.n(g),w=n(670),x=n.n(w),O=n(671),S=n.n(O),T=n(672),E=n.n(T),C=n(673),k=n.n(C),P=n(674),M=n.n(P),j=n(675),N=n.n(j),I=n(676),A=n.n(I),R=n(677),F=n.n(R),D=n(678),L=n.n(D),z=n(679),V=n.n(z),U=n(680),W=n.n(U),H=n(681),B=n.n(H),K=n(682),q=n.n(K),G=n(683),Y=n.n(G),X=n(684),$=n.n(X),Q=n(685),J=n.n(Q),Z=n(686),ee=n.n(Z),te=n(687),ne=n.n(te),re=n(688),oe=n.n(re),ie=n(689),ae=n.n(ie),ue=n(690),se=n.n(ue),le=n(691),ce=n.n(le),fe=n(692),de=n.n(fe),pe=n(693),he=n.n(pe),ye=n(694),ve=n.n(ye),me=n(695),be=n.n(me),ge=n(696),_e=n.n(ge),we=n(697),xe=n.n(we),Oe=n(698),Se=n.n(Oe),Te=n(699),Ee=n.n(Te),Ce=n(700),ke=n.n(Ce),Pe=n(701),Me=n.n(Pe),je=n(702),Ne=n.n(je),Ie=n(703),Ae=n.n(Ie),Re=n(704),Fe=n.n(Re),De=n(4),Le=n.n(De),ze=n(705),Ve=(n.n(ze),Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}),Ue={Add:s.a,Apps:c.a,ArrowDownward:d.a,ArrowDropRight:h.a,ArrowUpward:v.a,Business:b.a,Cancel:_.a,ChevronLeft:x.a,ChevronRight:S.a,Clear:E.a,Close:k.a,Create:M.a,CropFree:N.a,Delete:A.a,Description:F.a,Done:L.a,DragHandle:V.a,Email:W.a,Extension:B.a,FontDownload:q.a,GridOn:$.a,Group:Y.a,InfoOutline:J.a,InsertChart:ee.a,List:ne.a,Launch:oe.a,Message:ae.a,MoreVert:se.a,NotInterested:ce.a,Person:de.a,Public:he.a,Reply:ve.a,Room:be.a,Search:_e.a,ShowChart:xe.a,Star:Se.a,StarBorder:Ee.a,ThumbUp:ke.a,ViewList:Me.a,Visibility:Ne.a,VisibilityOff:Ae.a},We=function(e){var t=e.icon,n=e.children,r=e.className,i=e.disabled,a=e.style,u=null;return u=n&&!Ue[t]?Le.a:Ue[t]||Fe.a,o.a.createElement(u,{className:r,style:Ve({},a,{fill:a.fill||(i?ze.grey200:ze.grey600)})},n)};We.propTypes={icon:a.a.string,children:a.a.node,className:a.a.string,disabled:a.a.bool,style:a.a.object},We.defaultProps={icon:"",children:null,className:"",disabled:!1,style:{}},t.default=We},function(e,t,n){e.exports={default:n(255),__esModule:!0}},function(e,t,n){e.exports=!n(34)&&!n(41)(function(){return 7!=Object.defineProperty(n(122)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(40),o=n(29).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(35),o=n(42),i=n(259)(!1),a=n(86)("IE_PROTO");e.exports=function(e,t){var n,u=o(e),s=0,l=[];for(n in u)n!=a&&r(u,n)&&l.push(n);for(;t.length>s;)r(u,n=t[s++])&&(~i(l,n)||l.push(n));return l}},function(e,t,n){var r=n(83);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(85),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){var r=n(35),o=n(45),i=n(86)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=o(e),r(e,i)?e[i]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){var r=n(28),o=n(24),i=n(41);e.exports=function(e,t){var n=(o.Object||{})[e]||Object[e],a={};a[e]=t(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(e,t,n){e.exports={default:n(263),__esModule:!0}},function(e,t,n){"use strict";var r=n(267)(!0);n(130)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){"use strict";var r=n(90),o=n(28),i=n(131),a=n(38),u=n(35),s=n(46),l=n(268),c=n(92),f=n(126),d=n(26)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,y,v,m,b){l(n,t,y);var g,_,w,x=function(e){if(!p&&e in E)return E[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},O=t+" Iterator",S="values"==v,T=!1,E=e.prototype,C=E[d]||E["@@iterator"]||v&&E[v],k=!p&&C||x(v),P=v?S?x("entries"):k:void 0,M="Array"==t?E.entries||C:C;if(M&&(w=f(M.call(new e)))!==Object.prototype&&w.next&&(c(w,O,!0),r||u(w,d)||a(w,d,h)),S&&C&&"values"!==C.name&&(T=!0,k=function(){return C.call(this)}),r&&!b||!p&&!T&&E[d]||a(E,d,k),s[t]=k,s[O]=h,v)if(g={values:S?k:x("values"),keys:m?k:x("keys"),entries:P},b)for(_ in g)_ in E||i(E,_,g[_]);else o(o.P+o.F*(p||T),t,g);return g}},function(e,t,n){e.exports=n(38)},function(e,t,n){var r=n(123),o=n(88).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o)}},function(e,t,n){var r=n(59),o=n(43),i=n(42),a=n(82),u=n(35),s=n(121),l=Object.getOwnPropertyDescriptor;t.f=n(34)?l:function(e,t){if(e=i(e),t=a(t,!0),s)try{return l(e,t)}catch(e){}if(u(e,t))return o(!r.f.call(e,t),e[t])}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(8),u=r(a),s=n(9),l=r(s),c=n(12),f=r(c),d=n(13),p=r(d),h=n(1),y=n(3),v=r(y),m=n(23),b=n(135),g=r(b),_=function(e){function t(){var e,n,r,o;(0,u.default)(this,t);for(var a=arguments.length,s=Array(a),l=0;l<a;l++)s[l]=arguments[l];return n=r=(0,f.default)(this,(e=t.__proto__||(0,i.default)(t)).call.apply(e,[this].concat(s))),r.onClickAway=function(e){if(!e.defaultPrevented&&r.props.componentClickAway&&r.props.open){var t=r.layer;(e.target!==t&&e.target===window||document.documentElement.contains(e.target)&&!g.default.isDescendant(t,e.target))&&r.props.componentClickAway(e)}},o=n,(0,f.default)(r,o)}return(0,p.default)(t,e),(0,l.default)(t,[{key:"componentDidMount",value:function(){this.renderLayer()}},{key:"componentDidUpdate",value:function(){this.renderLayer()}},{key:"componentWillUnmount",value:function(){this.unrenderLayer()}},{key:"getLayer",value:function(){return this.layer}},{key:"unrenderLayer",value:function(){this.layer&&(this.props.useLayerForClickAway?(this.layer.style.position="relative",this.layer.removeEventListener("touchstart",this.onClickAway),this.layer.removeEventListener("click",this.onClickAway)):(window.removeEventListener("touchstart",this.onClickAway),window.removeEventListener("click",this.onClickAway)),(0,m.unmountComponentAtNode)(this.layer),document.body.removeChild(this.layer),this.layer=null)}},{key:"renderLayer",value:function(){var e=this,t=this.props,n=t.open,r=t.render;if(n){this.layer||(this.layer=document.createElement("div"),document.body.appendChild(this.layer),this.props.useLayerForClickAway?(this.layer.addEventListener("touchstart",this.onClickAway),this.layer.addEventListener("click",this.onClickAway),this.layer.style.position="fixed",this.layer.style.top=0,this.layer.style.bottom=0,this.layer.style.left=0,this.layer.style.right=0,this.layer.style.zIndex=this.context.muiTheme.zIndex.layer):setTimeout(function(){window.addEventListener("touchstart",e.onClickAway),window.addEventListener("click",e.onClickAway)},0));var o=r();this.layerElement=(0,m.unstable_renderSubtreeIntoContainer)(this,o,this.layer)}else this.unrenderLayer()}},{key:"render",value:function(){return null}}]),t}(h.Component);_.defaultProps={useLayerForClickAway:!0},_.contextTypes={muiTheme:v.default.object.isRequired},_.propTypes={},t.default=_},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={isDescendant:function(e,t){for(var n=t.parentNode;null!==n;){if(n===e)return!0;n=n.parentNode}return!1},offset:function(e){var t=e.getBoundingClientRect();return{top:t.top+document.body.scrollTop,left:t.left+document.body.scrollLeft}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(17),T=r(S),E=n(137),C=n(97),k=r(C),P=n(328),M=r(P),j=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.state={hovered:!1,isKeyboardFocused:!1,touch:!1},r.handleKeyboardFocus=function(e,t){r.setState({isKeyboardFocused:t}),r.props.onKeyboardFocus(e,t)},r.handleMouseEnter=function(e){r.state.touch||r.setState({hovered:!0}),r.props.onMouseEnter(e)},r.handleMouseLeave=function(e){r.setState({hovered:!1}),r.props.onMouseLeave(e)},r.handleTouchStart=function(e){r.setState({touch:!0}),r.props.onTouchStart(e)},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentWillReceiveProps",value:function(e){e.disabled&&this.setState({hovered:!1})}},{key:"render",value:function(){var e=this.props,t=e.backgroundColor,n=e.children,r=e.disabled,o=e.fullWidth,a=e.hoverColor,s=e.icon,l=e.label,c=e.labelStyle,f=e.labelPosition,d=e.primary,p=e.rippleColor,h=e.secondary,y=e.style,v=(0,u.default)(e,["backgroundColor","children","disabled","fullWidth","hoverColor","icon","label","labelStyle","labelPosition","primary","rippleColor","secondary","style"]),m=this.context.muiTheme,b=m.borderRadius,_=m.button,x=_.height,O=_.minWidth,S=_.textTransform,C=m.flatButton,P=C.buttonFilterColor,j=C.color,N=C.disabledTextColor,I=C.fontSize,A=C.fontWeight,R=C.primaryTextColor,F=C.secondaryTextColor,D=C.textColor,L=C.textTransform,z=void 0===L?S||"uppercase":L,V=r?N:d?R:h?F:D,U=(0,E.fade)(P,.2),W=P,H=a||U,B=p||W,K=t||j,q=(this.state.hovered||this.state.isKeyboardFocused)&&!r,G=(0,g.default)({},{height:x,lineHeight:x+"px",minWidth:o?"100%":O,color:V,transition:T.default.easeOut(),borderRadius:b,userSelect:"none",overflow:"hidden",backgroundColor:q?H:K,padding:0,margin:0,textAlign:"center"},y),Y=void 0,X={};if(s){var $=(0,g.default)({verticalAlign:"middle",marginLeft:l&&"before"!==f?12:0,marginRight:l&&"before"===f?12:0},s.props.style);Y=w.default.cloneElement(s,{color:s.props.color||G.color,style:$,key:"iconCloned"}),"before"===f?X.paddingRight=8:X.paddingLeft=8}var Q=(0,g.default)({letterSpacing:0,textTransform:z,fontWeight:A,fontSize:I},X,c),J=l?w.default.createElement(M.default,{key:"labelElement",label:l,style:Q}):void 0,Z="before"===f?[J,Y,n]:[n,Y,J];return w.default.createElement(k.default,(0,i.default)({},v,{disabled:r,focusRippleColor:B,focusRippleOpacity:.3,onKeyboardFocus:this.handleKeyboardFocus,onMouseLeave:this.handleMouseLeave,onMouseEnter:this.handleMouseEnter,onTouchStart:this.handleTouchStart,style:G,touchRippleColor:B,touchRippleOpacity:.3}),Z)}}]),t}(_.Component);j.muiName="FlatButton",j.defaultProps={disabled:!1,fullWidth:!1,labelStyle:{},labelPosition:"after",onKeyboardFocus:function(){},onMouseEnter:function(){},onMouseLeave:function(){},onTouchStart:function(){},primary:!1,secondary:!1},j.contextTypes={muiTheme:O.default.object.isRequired},j.propTypes={},t.default=j},function(e,t,n){"use strict";function r(e,t,n){return e<t?t:e>n?n:e}function o(e){var t=e.type,n=e.values;if(t.indexOf("rgb")>-1)for(var r=0;r<3;r++)n[r]=parseInt(n[r]);var o=void 0;return o=t.indexOf("hsl")>-1?e.type+"("+n[0]+", "+n[1]+"%, "+n[2]+"%":e.type+"("+n[0]+", "+n[1]+", "+n[2],4===n.length?o+=", "+e.values[3]+")":o+=")",o}function i(e){if(4===e.length){for(var t="#",n=1;n<e.length;n++)t+=e.charAt(n)+e.charAt(n);e=t}var r={r:parseInt(e.substr(1,2),16),g:parseInt(e.substr(3,2),16),b:parseInt(e.substr(5,2),16)};return"rgb("+r.r+", "+r.g+", "+r.b+")"}function a(e){if("#"===e.charAt(0))return a(i(e));var t=e.indexOf("("),n=e.substring(0,t),r=e.substring(t+1,e.length-1).split(",");return r=r.map(function(e){return parseFloat(e)}),{type:n,values:r}}function u(e,t){var n=s(e),r=s(t),o=(Math.max(n,r)+.05)/(Math.min(n,r)+.05);return Number(o.toFixed(2))}function s(e){if(e=a(e),e.type.indexOf("rgb")>-1){var t=e.values.map(function(e){return e/=255,e<=.03928?e/12.92:Math.pow((e+.055)/1.055,2.4)});return Number((.2126*t[0]+.7152*t[1]+.0722*t[2]).toFixed(3))}if(e.type.indexOf("hsl")>-1)return e.values[2]/100}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.15;return s(e)>.5?f(e,t):d(e,t)}function c(e,t){return e=a(e),t=r(t,0,1),"rgb"!==e.type&&"hsl"!==e.type||(e.type+="a"),e.values[3]=t,o(e)}function f(e,t){if(e=a(e),t=r(t,0,1),e.type.indexOf("hsl")>-1)e.values[2]*=1-t;else if(e.type.indexOf("rgb")>-1)for(var n=0;n<3;n++)e.values[n]*=1-t;return o(e)}function d(e,t){if(e=a(e),t=r(t,0,1),e.type.indexOf("hsl")>-1)e.values[2]+=(100-e.values[2])*t;else if(e.type.indexOf("rgb")>-1)for(var n=0;n<3;n++)e.values[n]+=(255-e.values[n])*t;return o(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.convertColorToString=o,t.convertHexToRGB=i,t.decomposeColor=a,t.getContrastRatio=u,t.getLuminance=s,t.emphasize=l,t.fade=c,t.darken=f,t.lighten=d;var p=n(63);!function(e){e&&e.__esModule}(p)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={once:function(e,t,n){for(var r=t?t.split(" "):[],o=function e(t){return t.target.removeEventListener(t.type,e),n(t)},i=r.length-1;i>=0;i--)this.on(e,r[i],o)},on:function(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,function(){n.call(e)})},off:function(e,t,n){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)},isKeyboard:function(e){return-1!==["keydown","keypress","keyup"].indexOf(e.type)}}},function(e,t,n){e.exports={default:n(319),__esModule:!0}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(139),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){return Array.isArray(e)?e:(0,o.default)(e)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(8),u=r(a),s=n(9),l=r(s),c=n(12),f=r(c),d=n(13),p=r(d),h=n(1),y=n(3),v=(r(y),n(23)),m=r(v),b=n(138),g=r(b),_=function e(t,n){return null!==n&&(t===n||e(t,n.parentNode))},w=["mouseup","touchend"],x=function(e){return w.forEach(function(t){return g.default.on(document,t,e)})},O=function(e){return w.forEach(function(t){return g.default.off(document,t,e)})},S=function(e){function t(){var e,n,r,o;(0,u.default)(this,t);for(var a=arguments.length,s=Array(a),l=0;l<a;l++)s[l]=arguments[l];return n=r=(0,f.default)(this,(e=t.__proto__||(0,i.default)(t)).call.apply(e,[this].concat(s))),r.handleClickAway=function(e){if(!e.defaultPrevented&&r.isCurrentlyMounted){var t=m.default.findDOMNode(r);document.documentElement.contains(e.target)&&!_(t,e.target)&&r.props.onClickAway(e)}},o=n,(0,f.default)(r,o)}return(0,p.default)(t,e),(0,l.default)(t,[{key:"componentDidMount",value:function(){this.isCurrentlyMounted=!0,this.props.onClickAway&&x(this.handleClickAway)}},{key:"componentDidUpdate",value:function(e){e.onClickAway!==this.props.onClickAway&&(O(this.handleClickAway),this.props.onClickAway&&x(this.handleClickAway))}},{key:"componentWillUnmount",value:function(){this.isCurrentlyMounted=!1,O(this.handleClickAway)}},{key:"render",value:function(){return this.props.children}}]),t}(h.Component);S.propTypes={},t.default=S},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(336),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return null!=e&&"object"==typeof e}t.isObject=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=function(e){function t(t){e.call(this),this.errors=t;var n=Error.call(this,t?t.length+" errors occurred during unsubscription:\n  "+t.map(function(e,t){return t+1+") "+e.toString()}).join("\n  "):"");this.name=n.name="UnsubscriptionError",this.stack=n.stack,this.message=n.message}return r(t,e),t}(Error);t.UnsubscriptionError=o},function(e,t,n){"use strict";t.empty={closed:!0,next:function(e){},error:function(e){throw e},complete:function(){}}},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(18),i=function(e){function t(t,n){e.call(this),this.subject=t,this.subscriber=n,this.closed=!1}return r(t,e),t.prototype.unsubscribe=function(){if(!this.closed){this.closed=!0;var e=this.subject,t=e.observers;if(this.subject=null,t&&0!==t.length&&!e.isStopped&&!e.closed){var n=t.indexOf(this.subscriber);-1!==n&&t.splice(n,1)}}},t}(o.Subscription);t.SubjectSubscription=i},function(e,t,n){"use strict";t.isArrayLike=function(e){return e&&"number"==typeof e.length}},function(e,t,n){"use strict";function r(e){return e&&"function"!=typeof e.subscribe&&"function"==typeof e.then}t.isPromise=r},function(e,t,n){"use strict";var r=n(32);t.of=r.ArrayObservable.of},function(e,t,n){"use strict";var r=n(151);t.from=r.FromObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(27),i=n(147),a=n(148),u=n(152),s=n(351),l=n(32),c=n(352),f=n(48),d=n(0),p=n(73),h=n(69),y=function(e){function t(t,n){e.call(this,null),this.ish=t,this.scheduler=n}return r(t,e),t.create=function(e,n){if(null!=e){if("function"==typeof e[h.observable])return e instanceof d.Observable&&!n?e:new t(e,n);if(o.isArray(e))return new l.ArrayObservable(e,n);if(a.isPromise(e))return new u.PromiseObservable(e,n);if("function"==typeof e[f.iterator]||"string"==typeof e)return new s.IteratorObservable(e,n);if(i.isArrayLike(e))return new c.ArrayLikeObservable(e,n)}throw new TypeError((null!==e&&typeof e||e)+" is not observable")},t.prototype._subscribe=function(e){var t=this.ish,n=this.scheduler;return null==n?t[h.observable]().subscribe(e):t[h.observable]().subscribe(new p.ObserveOnSubscriber(e,n,0))},t}(d.Observable);t.FromObservable=y},function(e,t,n){"use strict";function r(e){var t=e.value,n=e.subscriber;n.closed||(n.next(t),n.complete())}function o(e){var t=e.err,n=e.subscriber;n.closed||n.error(t)}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(22),u=n(0),s=function(e){function t(t,n){e.call(this),this.promise=t,this.scheduler=n}return i(t,e),t.create=function(e,n){return new t(e,n)},t.prototype._subscribe=function(e){var t=this,n=this.promise,i=this.scheduler;if(null==i)this._isScalar?e.closed||(e.next(this.value),e.complete()):n.then(function(n){t.value=n,t._isScalar=!0,e.closed||(e.next(n),e.complete())},function(t){e.closed||e.error(t)}).then(null,function(e){a.root.setTimeout(function(){throw e})});else if(this._isScalar){if(!e.closed)return i.schedule(r,0,{value:this.value,subscriber:e})}else n.then(function(n){t.value=n,t._isScalar=!0,e.closed||e.add(i.schedule(r,0,{value:n,subscriber:e}))},function(t){e.closed||e.add(i.schedule(o,0,{err:t,subscriber:e}))}).then(null,function(e){a.root.setTimeout(function(){throw e})})},t}(u.Observable);t.PromiseObservable=s},function(e,t,n){"use strict";function r(e){return e}t.identity=r},function(e,t,n){"use strict";var r=n(402);t.timer=r.TimerObservable.create},function(e,t,n){"use strict";function r(){if(p.root.XMLHttpRequest)return new p.root.XMLHttpRequest;if(p.root.XDomainRequest)return new p.root.XDomainRequest;throw new Error("CORS is not supported by your browser")}function o(){if(p.root.XMLHttpRequest)return new p.root.XMLHttpRequest;var e=void 0;try{for(var t=["Msxml2.XMLHTTP","Microsoft.XMLHTTP","Msxml2.XMLHTTP.4.0"],n=0;n<3;n++)try{if(e=t[n],new p.root.ActiveXObject(e))break}catch(e){}return new p.root.ActiveXObject(e)}catch(e){throw new Error("XMLHttpRequest is not supported by your browser")}}function i(e,t){return void 0===t&&(t=null),new _({method:"GET",url:e,headers:t})}function a(e,t,n){return new _({method:"POST",url:e,body:t,headers:n})}function u(e,t){return new _({method:"DELETE",url:e,headers:t})}function s(e,t,n){return new _({method:"PUT",url:e,body:t,headers:n})}function l(e,t,n){return new _({method:"PATCH",url:e,body:t,headers:n})}function c(e,t){return g(new _({method:"GET",url:e,responseType:"json",headers:t}))}function f(e,t){switch(e){case"json":return"response"in t?t.responseType?t.response:JSON.parse(t.response||t.responseText||"null"):JSON.parse(t.responseText||"null");case"xml":return t.responseXML;case"text":default:return"response"in t?t.response:t.responseText}}var d=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},p=n(22),h=n(21),y=n(20),v=n(0),m=n(2),b=n(55);t.ajaxGet=i,t.ajaxPost=a,t.ajaxDelete=u,t.ajaxPut=s,t.ajaxPatch=l;var g=b.map(function(e,t){return e.response});t.ajaxGetJSON=c;var _=function(e){function t(t){e.call(this);var n={async:!0,createXHR:function(){return this.crossDomain?r.call(this):o()},crossDomain:!1,withCredentials:!1,headers:{},method:"GET",responseType:"json",timeout:0};if("string"==typeof t)n.url=t;else for(var i in t)t.hasOwnProperty(i)&&(n[i]=t[i]);this.request=n}return d(t,e),t.prototype._subscribe=function(e){return new w(e,this.request)},t.create=function(){var e=function(e){return new t(e)};return e.get=i,e.post=a,e.delete=u,e.put=s,e.patch=l,e.getJSON=c,e}(),t}(v.Observable);t.AjaxObservable=_;var w=function(e){function t(t,n){e.call(this,t),this.request=n,this.done=!1;var r=n.headers=n.headers||{};n.crossDomain||r["X-Requested-With"]||(r["X-Requested-With"]="XMLHttpRequest"),"Content-Type"in r||p.root.FormData&&n.body instanceof p.root.FormData||void 0===n.body||(r["Content-Type"]="application/x-www-form-urlencoded; charset=UTF-8"),n.body=this.serializeBody(n.body,n.headers["Content-Type"]),this.send()}return d(t,e),t.prototype.next=function(e){this.done=!0;var t=this,n=t.xhr,r=t.request,o=t.destination,i=new x(e,n,r);o.next(i)},t.prototype.send=function(){var e=this,t=e.request,n=e.request,r=n.user,o=n.method,i=n.url,a=n.async,u=n.password,s=n.headers,l=n.body,c=t.createXHR,f=h.tryCatch(c).call(t);if(f===y.errorObject)this.error(y.errorObject.e);else{if(this.xhr=f,this.setupEvents(f,t),(r?h.tryCatch(f.open).call(f,o,i,a,r,u):h.tryCatch(f.open).call(f,o,i,a))===y.errorObject)return this.error(y.errorObject.e),null;if(a&&(f.timeout=t.timeout,f.responseType=t.responseType),"withCredentials"in f&&(f.withCredentials=!!t.withCredentials),this.setHeaders(f,s),(l?h.tryCatch(f.send).call(f,l):h.tryCatch(f.send).call(f))===y.errorObject)return this.error(y.errorObject.e),null}return f},t.prototype.serializeBody=function(e,t){if(!e||"string"==typeof e)return e;if(p.root.FormData&&e instanceof p.root.FormData)return e;if(t){var n=t.indexOf(";");-1!==n&&(t=t.substring(0,n))}switch(t){case"application/x-www-form-urlencoded":return Object.keys(e).map(function(t){return encodeURI(t)+"="+encodeURI(e[t])}).join("&");case"application/json":return JSON.stringify(e);default:return e}},t.prototype.setHeaders=function(e,t){for(var n in t)t.hasOwnProperty(n)&&e.setRequestHeader(n,t[n])},t.prototype.setupEvents=function(e,t){function n(e){var t=n,r=t.subscriber,o=t.progressSubscriber,i=t.request;o&&o.error(e),r.error(new S(this,i))}function r(e){var t=r,n=t.subscriber,o=t.progressSubscriber,i=t.request;if(4===this.readyState){var a=1223===this.status?204:this.status,u="text"===this.responseType?this.response||this.responseText:this.response;0===a&&(a=u?200:0),200<=a&&a<300?(o&&o.complete(),n.next(e),n.complete()):(o&&o.error(e),n.error(new O("ajax error "+a,this,i)))}}var o=t.progressSubscriber;if(e.ontimeout=n,n.request=t,n.subscriber=this,n.progressSubscriber=o,e.upload&&"withCredentials"in e){if(o){var i;i=function(e){i.progressSubscriber.next(e)},p.root.XDomainRequest?e.onprogress=i:e.upload.onprogress=i,i.progressSubscriber=o}var a;a=function(e){var t=a,n=t.progressSubscriber,r=t.subscriber,o=t.request;n&&n.error(e),r.error(new O("ajax error",this,o))},e.onerror=a,a.request=t,a.subscriber=this,a.progressSubscriber=o}e.onreadystatechange=r,r.subscriber=this,r.progressSubscriber=o,r.request=t},t.prototype.unsubscribe=function(){var t=this,n=t.done,r=t.xhr;!n&&r&&4!==r.readyState&&"function"==typeof r.abort&&r.abort(),e.prototype.unsubscribe.call(this)},t}(m.Subscriber);t.AjaxSubscriber=w;var x=function(){function e(e,t,n){this.originalEvent=e,this.xhr=t,this.request=n,this.status=t.status,this.responseType=t.responseType||n.responseType,this.response=f(this.responseType,t)}return e}();t.AjaxResponse=x;var O=function(e){function t(t,n,r){e.call(this,t),this.message=t,this.xhr=n,this.request=r,this.status=n.status,this.responseType=n.responseType||r.responseType,this.response=f(this.responseType,n)}return d(t,e),t}(Error);t.AjaxError=O;var S=function(e){function t(t,n){e.call(this,"ajax timeout",t,n)}return d(t,e),t}(O);t.AjaxTimeoutError=S},function(e,t,n){"use strict";var r=n(410),o=n(411);t.queue=new o.QueueScheduler(r.QueueAction)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.buffer=r;var u=function(){function e(e){this.closingNotifier=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.closingNotifier))},e}(),s=function(e){function t(t,n){e.call(this,t),this.buffer=[],this.add(a.subscribeToResult(this,n))}return o(t,e),t.prototype._next=function(e){this.buffer.push(e)},t.prototype.notifyNext=function(e,t,n,r,o){var i=this.buffer;this.buffer=[],this.destination.next(i)},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=null),function(n){return n.lift(new a(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.bufferCount=r;var a=function(){function e(e,t){this.bufferSize=e,this.startBufferEvery=t,this.subscriberClass=t&&e!==t?s:u}return e.prototype.call=function(e,t){return t.subscribe(new this.subscriberClass(e,this.bufferSize,this.startBufferEvery))},e}(),u=function(e){function t(t,n){e.call(this,t),this.bufferSize=n,this.buffer=[]}return o(t,e),t.prototype._next=function(e){var t=this.buffer;t.push(e),t.length==this.bufferSize&&(this.destination.next(t),this.buffer=[])},t.prototype._complete=function(){var t=this.buffer;t.length>0&&this.destination.next(t),e.prototype._complete.call(this)},t}(i.Subscriber),s=function(e){function t(t,n,r){e.call(this,t),this.bufferSize=n,this.startBufferEvery=r,this.buffers=[],this.count=0}return o(t,e),t.prototype._next=function(e){var t=this,n=t.bufferSize,r=t.startBufferEvery,o=t.buffers,i=t.count;this.count++,i%r==0&&o.push([]);for(var a=o.length;a--;){var u=o[a];u.push(e),u.length===n&&(o.splice(a,1),this.destination.next(u))}},t.prototype._complete=function(){for(var t=this,n=t.buffers,r=t.destination;n.length>0;){var o=n.shift();o.length>0&&r.next(o)}e.prototype._complete.call(this)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){var t=arguments.length,n=s.async;c.isScheduler(arguments[arguments.length-1])&&(n=arguments[arguments.length-1],t--);var r=null;t>=2&&(r=arguments[1]);var o=Number.POSITIVE_INFINITY;return t>=3&&(o=arguments[2]),function(t){return t.lift(new f(e,r,o,n))}}function o(e){var t=e.subscriber,n=e.context;n&&t.closeContext(n),t.closed||(e.context=t.openContext(),e.context.closeAction=this.schedule(e,e.bufferTimeSpan))}function i(e){var t=e.bufferCreationInterval,n=e.bufferTimeSpan,r=e.subscriber,o=e.scheduler,i=r.openContext(),u=this;r.closed||(r.add(i.closeAction=o.schedule(a,n,{subscriber:r,context:i})),u.schedule(e,t))}function a(e){var t=e.subscriber,n=e.context;t.closeContext(n)}var u=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},s=n(16),l=n(2),c=n(25);t.bufferTime=r;var f=function(){function e(e,t,n,r){this.bufferTimeSpan=e,this.bufferCreationInterval=t,this.maxBufferSize=n,this.scheduler=r}return e.prototype.call=function(e,t){return t.subscribe(new p(e,this.bufferTimeSpan,this.bufferCreationInterval,this.maxBufferSize,this.scheduler))},e}(),d=function(){function e(){this.buffer=[]}return e}(),p=function(e){function t(t,n,r,u,s){e.call(this,t),this.bufferTimeSpan=n,this.bufferCreationInterval=r,this.maxBufferSize=u,this.scheduler=s,this.contexts=[];var l=this.openContext();if(this.timespanOnly=null==r||r<0,this.timespanOnly){var c={subscriber:this,context:l,bufferTimeSpan:n};this.add(l.closeAction=s.schedule(o,n,c))}else{var f={subscriber:this,context:l},d={bufferTimeSpan:n,bufferCreationInterval:r,subscriber:this,scheduler:s};this.add(l.closeAction=s.schedule(a,n,f)),this.add(s.schedule(i,r,d))}}return u(t,e),t.prototype._next=function(e){for(var t,n=this.contexts,r=n.length,o=0;o<r;o++){var i=n[o],a=i.buffer;a.push(e),a.length==this.maxBufferSize&&(t=i)}t&&this.onBufferFull(t)},t.prototype._error=function(t){this.contexts.length=0,e.prototype._error.call(this,t)},t.prototype._complete=function(){for(var t=this,n=t.contexts,r=t.destination;n.length>0;){var o=n.shift();r.next(o.buffer)}e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){this.contexts=null},t.prototype.onBufferFull=function(e){this.closeContext(e);var t=e.closeAction;if(t.unsubscribe(),this.remove(t),!this.closed&&this.timespanOnly){e=this.openContext();var n=this.bufferTimeSpan,r={subscriber:this,context:e,bufferTimeSpan:n};this.add(e.closeAction=this.scheduler.schedule(o,n,r))}},t.prototype.openContext=function(){var e=new d;return this.contexts.push(e),e},t.prototype.closeContext=function(e){this.destination.next(e.buffer);var t=this.contexts;(t?t.indexOf(e):-1)>=0&&t.splice(t.indexOf(e),1)},t}(l.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new s(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(18),a=n(7),u=n(6);t.bufferToggle=r;var s=function(){function e(e,t){this.openings=e,this.closingSelector=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.openings,this.closingSelector))},e}(),l=function(e){function t(t,n,r){e.call(this,t),this.openings=n,this.closingSelector=r,this.contexts=[],this.add(a.subscribeToResult(this,n))}return o(t,e),t.prototype._next=function(e){for(var t=this.contexts,n=t.length,r=0;r<n;r++)t[r].buffer.push(e)},t.prototype._error=function(t){for(var n=this.contexts;n.length>0;){var r=n.shift();r.subscription.unsubscribe(),r.buffer=null,r.subscription=null}this.contexts=null,e.prototype._error.call(this,t)},t.prototype._complete=function(){for(var t=this.contexts;t.length>0;){var n=t.shift();this.destination.next(n.buffer),n.subscription.unsubscribe(),n.buffer=null,n.subscription=null}this.contexts=null,e.prototype._complete.call(this)},t.prototype.notifyNext=function(e,t,n,r,o){e?this.closeBuffer(e):this.openBuffer(t)},t.prototype.notifyComplete=function(e){this.closeBuffer(e.context)},t.prototype.openBuffer=function(e){try{var t=this.closingSelector,n=t.call(this,e);n&&this.trySubscribe(n)}catch(e){this._error(e)}},t.prototype.closeBuffer=function(e){var t=this.contexts;if(t&&e){var n=e.buffer,r=e.subscription;this.destination.next(n),t.splice(t.indexOf(e),1),this.remove(r),r.unsubscribe()}},t.prototype.trySubscribe=function(e){var t=this.contexts,n=[],r=new i.Subscription,o={buffer:n,subscription:r};t.push(o);var u=a.subscribeToResult(this,e,o);!u||u.closed?this.closeBuffer(o):(u.context=o,this.add(u),r.add(u))},t}(u.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new c(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(18),a=n(21),u=n(20),s=n(6),l=n(7);t.bufferWhen=r;var c=function(){function e(e){this.closingSelector=e}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.closingSelector))},e}(),f=function(e){function t(t,n){e.call(this,t),this.closingSelector=n,this.subscribing=!1,this.openBuffer()}return o(t,e),t.prototype._next=function(e){this.buffer.push(e)},t.prototype._complete=function(){var t=this.buffer;t&&this.destination.next(t),e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){this.buffer=null,this.subscribing=!1},t.prototype.notifyNext=function(e,t,n,r,o){this.openBuffer()},t.prototype.notifyComplete=function(){this.subscribing?this.complete():this.openBuffer()},t.prototype.openBuffer=function(){var e=this.closingSubscription;e&&(this.remove(e),e.unsubscribe());var t=this.buffer;this.buffer&&this.destination.next(t),this.buffer=[];var n=a.tryCatch(this.closingSelector)();n===u.errorObject?this.error(u.errorObject.e):(e=new i.Subscription,this.closingSubscription=e,this.add(e),this.subscribing=!0,e.add(l.subscribeToResult(this,n)),this.subscribing=!1)},t}(s.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){var n=new u(e),r=t.lift(n);return n.caught=r}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.catchError=r;var u=function(){function e(e){this.selector=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.selector,this.caught))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.selector=n,this.caught=r}return o(t,e),t.prototype.error=function(t){if(!this.isStopped){var n=void 0;try{n=this.selector(t,this.caught)}catch(t){return void e.prototype.error.call(this,t)}this._unsubscribeAndRecycle(),this.add(a.subscribeToResult(this,n))}},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new o.CombineLatestOperator(e))}}var o=n(72);t.combineAll=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){return t.lift.call(o.concat.apply(void 0,[t].concat(e)))}}var o=n(49),i=n(49);t.concatStatic=i.concat,t.concat=r},function(e,t,n){"use strict";function r(e,t){return o.concatMap(function(){return e},t)}var o=n(105);t.concatMapTo=r},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new a(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.count=r;var a=function(){function e(e,t){this.predicate=e,this.source=t}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate,this.source))},e}(),u=function(e){function t(t,n,r){e.call(this,t),this.predicate=n,this.source=r,this.count=0,this.index=0}return o(t,e),t.prototype._next=function(e){this.predicate?this._tryPredicate(e):this.count++},t.prototype._tryPredicate=function(e){var t;try{t=this.predicate(e,this.index++,this.source)}catch(e){return void this.destination.error(e)}t&&this.count++},t.prototype._complete=function(){this.destination.next(this.count),this.destination.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new a)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.dematerialize=r;var a=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new u(e))},e}(),u=function(e){function t(t){e.call(this,t)}return o(t,e),t.prototype._next=function(e){e.observe(this.destination)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.debounce=r;var u=function(){function e(e){this.durationSelector=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.durationSelector))},e}(),s=function(e){function t(t,n){e.call(this,t),this.durationSelector=n,this.hasValue=!1,this.durationSubscription=null}return o(t,e),t.prototype._next=function(e){try{var t=this.durationSelector.call(this,e);t&&this._tryNext(e,t)}catch(e){this.destination.error(e)}},t.prototype._complete=function(){this.emitValue(),this.destination.complete()},t.prototype._tryNext=function(e,t){var n=this.durationSubscription;this.value=e,this.hasValue=!0,n&&(n.unsubscribe(),this.remove(n)),n=a.subscribeToResult(this,t),n.closed||this.add(this.durationSubscription=n)},t.prototype.notifyNext=function(e,t,n,r,o){this.emitValue()},t.prototype.notifyComplete=function(){this.emitValue()},t.prototype.emitValue=function(){if(this.hasValue){var t=this.value,n=this.durationSubscription;n&&(this.durationSubscription=null,n.unsubscribe(),this.remove(n)),this.value=null,this.hasValue=!1,e.prototype._next.call(this,t)}},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=u.async),function(n){return n.lift(new s(e,t))}}function o(e){e.debouncedNext()}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(2),u=n(16);t.debounceTime=r;var s=function(){function e(e,t){this.dueTime=e,this.scheduler=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.dueTime,this.scheduler))},e}(),l=function(e){function t(t,n,r){e.call(this,t),this.dueTime=n,this.scheduler=r,this.debouncedSubscription=null,this.lastValue=null,this.hasValue=!1}return i(t,e),t.prototype._next=function(e){this.clearDebounce(),this.lastValue=e,this.hasValue=!0,this.add(this.debouncedSubscription=this.scheduler.schedule(o,this.dueTime,this))},t.prototype._complete=function(){this.debouncedNext(),this.destination.complete()},t.prototype.debouncedNext=function(){this.clearDebounce(),this.hasValue&&(this.destination.next(this.lastValue),this.lastValue=null,this.hasValue=!1)},t.prototype.clearDebounce=function(){var e=this.debouncedSubscription;null!==e&&(this.remove(e),e.unsubscribe(),this.debouncedSubscription=null)},t}(a.Subscriber)},function(e,t,n){"use strict";function r(e,t){void 0===t&&(t=i.async);var n=a.isDate(e),r=n?+e-t.now():Math.abs(e);return function(e){return e.lift(new l(r,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(16),a=n(76),u=n(2),s=n(50);t.delay=r;var l=function(){function e(e,t){this.delay=e,this.scheduler=t}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.delay,this.scheduler))},e}(),c=function(e){function t(t,n,r){e.call(this,t),this.delay=n,this.scheduler=r,this.queue=[],this.active=!1,this.errored=!1}return o(t,e),t.dispatch=function(e){for(var t=e.source,n=t.queue,r=e.scheduler,o=e.destination;n.length>0&&n[0].time-r.now()<=0;)n.shift().notification.observe(o);if(n.length>0){var i=Math.max(0,n[0].time-r.now());this.schedule(e,i)}else t.active=!1},t.prototype._schedule=function(e){this.active=!0,this.add(e.schedule(t.dispatch,this.delay,{source:this,destination:this.destination,scheduler:e}))},t.prototype.scheduleNotification=function(e){if(!0!==this.errored){var t=this.scheduler,n=new f(t.now()+this.delay,e);this.queue.push(n),!1===this.active&&this._schedule(t)}},t.prototype._next=function(e){this.scheduleNotification(s.Notification.createNext(e))},t.prototype._error=function(e){this.errored=!0,this.queue=[],this.destination.error(e)},t.prototype._complete=function(){this.scheduleNotification(s.Notification.createComplete())},t}(u.Subscriber),f=function(){function e(e,t){this.time=e,this.notification=t}return e}()},function(e,t,n){"use strict";function r(e,t){return t?function(n){return new f(n,t).lift(new l(e))}:function(t){return t.lift(new l(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(0),u=n(6),s=n(7);t.delayWhen=r;var l=function(){function e(e){this.delayDurationSelector=e}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.delayDurationSelector))},e}(),c=function(e){function t(t,n){e.call(this,t),this.delayDurationSelector=n,this.completed=!1,this.delayNotifierSubscriptions=[],this.values=[]}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.destination.next(e),this.removeSubscription(o),this.tryComplete()},t.prototype.notifyError=function(e,t){this._error(e)},t.prototype.notifyComplete=function(e){var t=this.removeSubscription(e);t&&this.destination.next(t),this.tryComplete()},t.prototype._next=function(e){try{var t=this.delayDurationSelector(e);t&&this.tryDelay(t,e)}catch(e){this.destination.error(e)}},t.prototype._complete=function(){this.completed=!0,this.tryComplete()},t.prototype.removeSubscription=function(e){e.unsubscribe();var t=this.delayNotifierSubscriptions.indexOf(e),n=null;return-1!==t&&(n=this.values[t],this.delayNotifierSubscriptions.splice(t,1),this.values.splice(t,1)),n},t.prototype.tryDelay=function(e,t){var n=s.subscribeToResult(this,e,t);n&&!n.closed&&(this.add(n),this.delayNotifierSubscriptions.push(n)),this.values.push(t)},t.prototype.tryComplete=function(){this.completed&&0===this.delayNotifierSubscriptions.length&&this.destination.complete()},t}(u.OuterSubscriber),f=function(e){function t(t,n){e.call(this),this.source=t,this.subscriptionDelay=n}return o(t,e),t.prototype._subscribe=function(e){this.subscriptionDelay.subscribe(new d(e,this.source))},t}(a.Observable),d=function(e){function t(t,n){e.call(this),this.parent=t,this.source=n,this.sourceSubscribed=!1}return o(t,e),t.prototype._next=function(e){this.subscribeToSource()},t.prototype._error=function(e){this.unsubscribe(),this.parent.error(e)},t.prototype._complete=function(){this.subscribeToSource()},t.prototype.subscribeToSource=function(){this.sourceSubscribed||(this.sourceSubscribed=!0,this.unsubscribe(),this.source.subscribe(this.parent))},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new s(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7),u=n(453);t.distinct=r;var s=function(){function e(e,t){this.keySelector=e,this.flushes=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.keySelector,this.flushes))},e}(),l=function(e){function t(t,n,r){e.call(this,t),this.keySelector=n,this.values=new u.Set,r&&this.add(a.subscribeToResult(this,r))}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.values.clear()},t.prototype.notifyError=function(e,t){this._error(e)},t.prototype._next=function(e){this.keySelector?this._useKeySelector(e):this._finalizeNext(e,e)},t.prototype._useKeySelector=function(e){var t,n=this.destination;try{t=this.keySelector(e)}catch(e){return void n.error(e)}this._finalizeNext(t,e)},t.prototype._finalizeNext=function(e,t){var n=this.values;n.has(e)||(n.add(e),this.destination.next(t))},t}(i.OuterSubscriber);t.DistinctSubscriber=l},function(e,t,n){"use strict";function r(e,t){return o.distinctUntilChanged(function(n,r){return t?t(n[e],r[e]):n[e]===r[e]})}var o=n(107);t.distinctUntilKeyChanged=r},function(e,t,n){"use strict";function r(e,t,n){return function(r){return r.lift(new a(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.tap=r;var a=function(){function e(e,t,n){this.nextOrObserver=e,this.error=t,this.complete=n}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.nextOrObserver,this.error,this.complete))},e}(),u=function(e){function t(t,n,r,o){e.call(this,t);var a=new i.Subscriber(n,r,o);a.syncErrorThrowable=!0,this.add(a),this.safeSubscriber=a}return o(t,e),t.prototype._next=function(e){var t=this.safeSubscriber;t.next(e),t.syncErrorThrown?this.destination.error(t.syncErrorValue):this.destination.next(e)},t.prototype._error=function(e){var t=this.safeSubscriber;t.error(e),t.syncErrorThrown?this.destination.error(t.syncErrorValue):this.destination.error(e)},t.prototype._complete=function(){var e=this.safeSubscriber;e.complete(),e.syncErrorThrown?this.destination.error(e.syncErrorValue):this.destination.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new u)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.exhaust=r;var u=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new s(e))},e}(),s=function(e){function t(t){e.call(this,t),this.hasCompleted=!1,this.hasSubscription=!1}return o(t,e),t.prototype._next=function(e){this.hasSubscription||(this.hasSubscription=!0,this.add(a.subscribeToResult(this,e)))},t.prototype._complete=function(){this.hasCompleted=!0,this.hasSubscription||this.destination.complete()},t.prototype.notifyComplete=function(e){this.remove(e),this.hasSubscription=!1,this.hasCompleted&&this.destination.complete()},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.exhaustMap=r;var u=function(){function e(e,t){this.project=e,this.resultSelector=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.project,this.resultSelector))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.project=n,this.resultSelector=r,this.hasSubscription=!1,this.hasCompleted=!1,this.index=0}return o(t,e),t.prototype._next=function(e){this.hasSubscription||this.tryNext(e)},t.prototype.tryNext=function(e){var t=this.index++,n=this.destination;try{var r=this.project(e,t);this.hasSubscription=!0,this.add(a.subscribeToResult(this,r,e,t))}catch(e){n.error(e)}},t.prototype._complete=function(){this.hasCompleted=!0,this.hasSubscription||this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){var i=this,a=i.resultSelector,u=i.destination;a?this.trySelectResult(e,t,n,r):u.next(t)},t.prototype.trySelectResult=function(e,t,n,r){var o=this,i=o.resultSelector,a=o.destination;try{var u=i(e,t,n,r);a.next(u)}catch(e){a.error(e)}},t.prototype.notifyError=function(e){this.destination.error(e)},t.prototype.notifyComplete=function(e){this.remove(e),this.hasSubscription=!1,this.hasCompleted&&this.destination.complete()},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t,n){return void 0===t&&(t=Number.POSITIVE_INFINITY),void 0===n&&(n=void 0),t=(t||0)<1?Number.POSITIVE_INFINITY:t,function(r){return r.lift(new l(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(21),a=n(20),u=n(6),s=n(7);t.expand=r;var l=function(){function e(e,t,n){this.project=e,this.concurrent=t,this.scheduler=n}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.project,this.concurrent,this.scheduler))},e}();t.ExpandOperator=l;var c=function(e){function t(t,n,r,o){e.call(this,t),this.project=n,this.concurrent=r,this.scheduler=o,this.index=0,this.active=0,this.hasCompleted=!1,r<Number.POSITIVE_INFINITY&&(this.buffer=[])}return o(t,e),t.dispatch=function(e){var t=e.subscriber,n=e.result,r=e.value,o=e.index;t.subscribeToProjection(n,r,o)},t.prototype._next=function(e){var n=this.destination;if(n.closed)return void this._complete();var r=this.index++;if(this.active<this.concurrent){n.next(e);var o=i.tryCatch(this.project)(e,r);if(o===a.errorObject)n.error(a.errorObject.e);else if(this.scheduler){var u={subscriber:this,result:o,value:e,index:r};this.add(this.scheduler.schedule(t.dispatch,0,u))}else this.subscribeToProjection(o,e,r)}else this.buffer.push(e)},t.prototype.subscribeToProjection=function(e,t,n){this.active++,this.add(s.subscribeToResult(this,e,t,n))},t.prototype._complete=function(){this.hasCompleted=!0,this.hasCompleted&&0===this.active&&this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){this._next(t)},t.prototype.notifyComplete=function(e){var t=this.buffer;this.remove(e),this.active--,t&&t.length>0&&this._next(t.shift()),this.hasCompleted&&0===this.active&&this.destination.complete()},t}(u.OuterSubscriber);t.ExpandSubscriber=c},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(56);t.elementAt=r;var u=function(){function e(e,t){if(this.index=e,this.defaultValue=t,e<0)throw new a.ArgumentOutOfRangeError}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.index,this.defaultValue))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.index=n,this.defaultValue=r}return o(t,e),t.prototype._next=function(e){0==this.index--&&(this.destination.next(e),this.destination.complete())},t.prototype._complete=function(){var e=this.destination;this.index>=0&&(void 0!==this.defaultValue?e.next(this.defaultValue):e.error(new a.ArgumentOutOfRangeError)),e.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(18);t.finalize=r;var u=function(){function e(e){this.callback=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.callback))},e}(),s=function(e){function t(t,n){e.call(this,t),this.add(new a.Subscription(n))}return o(t,e),t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new o.FindValueOperator(e,n,!0,t))}}var o=n(109);t.findIndex=r},function(e,t,n){"use strict";function r(e,t,n){return function(r){return r.lift(new u(e,t,n,r))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(79);t.first=r;var u=function(){function e(e,t,n,r){this.predicate=e,this.resultSelector=t,this.defaultValue=n,this.source=r}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.predicate,this.resultSelector,this.defaultValue,this.source))},e}(),s=function(e){function t(t,n,r,o,i){e.call(this,t),this.predicate=n,this.resultSelector=r,this.defaultValue=o,this.source=i,this.index=0,this.hasCompleted=!1,this._emitted=!1}return o(t,e),t.prototype._next=function(e){var t=this.index++;this.predicate?this._tryPredicate(e,t):this._emit(e,t)},t.prototype._tryPredicate=function(e,t){var n;try{n=this.predicate(e,t,this.source)}catch(e){return void this.destination.error(e)}n&&this._emit(e,t)},t.prototype._emit=function(e,t){if(this.resultSelector)return void this._tryResultSelector(e,t);this._emitFinal(e)},t.prototype._tryResultSelector=function(e,t){var n;try{n=this.resultSelector(e,t)}catch(e){return void this.destination.error(e)}this._emitFinal(n)},t.prototype._emitFinal=function(e){var t=this.destination;this._emitted||(this._emitted=!0,t.next(e),t.complete(),this.hasCompleted=!0)},t.prototype._complete=function(){var e=this.destination;this.hasCompleted||void 0===this.defaultValue?this.hasCompleted||e.error(new a.EmptyError):(e.next(this.defaultValue),e.complete())},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t,n,r){return function(o){return o.lift(new f(e,t,n,r))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(18),u=n(0),s=n(19),l=n(480),c=n(482);t.groupBy=r;var f=function(){function e(e,t,n,r){this.keySelector=e,this.elementSelector=t,this.durationSelector=n,this.subjectSelector=r}return e.prototype.call=function(e,t){return t.subscribe(new d(e,this.keySelector,this.elementSelector,this.durationSelector,this.subjectSelector))},e}(),d=function(e){function t(t,n,r,o,i){e.call(this,t),this.keySelector=n,this.elementSelector=r,this.durationSelector=o,this.subjectSelector=i,this.groups=null,this.attemptedToUnsubscribe=!1,this.count=0}return o(t,e),t.prototype._next=function(e){var t;try{t=this.keySelector(e)}catch(e){return void this.error(e)}this._group(e,t)},t.prototype._group=function(e,t){var n=this.groups;n||(n=this.groups="string"==typeof t?new c.FastMap:new l.Map);var r,o=n.get(t);if(this.elementSelector)try{r=this.elementSelector(e)}catch(e){this.error(e)}else r=e;if(!o){o=this.subjectSelector?this.subjectSelector():new s.Subject,n.set(t,o);var i=new h(t,o,this);if(this.destination.next(i),this.durationSelector){var a=void 0;try{a=this.durationSelector(new h(t,o))}catch(e){return void this.error(e)}this.add(a.subscribe(new p(t,o,this)))}}o.closed||o.next(r)},t.prototype._error=function(e){var t=this.groups;t&&(t.forEach(function(t,n){t.error(e)}),t.clear()),this.destination.error(e)},t.prototype._complete=function(){var e=this.groups;e&&(e.forEach(function(e,t){e.complete()}),e.clear()),this.destination.complete()},t.prototype.removeGroup=function(e){this.groups.delete(e)},t.prototype.unsubscribe=function(){this.closed||(this.attemptedToUnsubscribe=!0,0===this.count&&e.prototype.unsubscribe.call(this))},t}(i.Subscriber),p=function(e){function t(t,n,r){e.call(this,n),this.key=t,this.group=n,this.parent=r}return o(t,e),t.prototype._next=function(e){this.complete()},t.prototype._unsubscribe=function(){var e=this,t=e.parent,n=e.key;this.key=this.parent=null,t&&t.removeGroup(n)},t}(i.Subscriber),h=function(e){function t(t,n,r){e.call(this),this.key=t,this.groupSubject=n,this.refCountSubscription=r}return o(t,e),t.prototype._subscribe=function(e){var t=new a.Subscription,n=this,r=n.refCountSubscription,o=n.groupSubject;return r&&!r.closed&&t.add(new y(r)),t.add(o.subscribe(e)),t},t}(u.Observable);t.GroupedObservable=h;var y=function(e){function t(t){e.call(this),this.parent=t,t.count++}return o(t,e),t.prototype.unsubscribe=function(){var t=this.parent;t.closed||this.closed||(e.prototype.unsubscribe.call(this),t.count-=1,0===t.count&&t.attemptedToUnsubscribe&&t.unsubscribe())},t}(a.Subscription)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new u)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(100);t.ignoreElements=r;var u=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new s(e))},e}(),s=function(e){function t(){e.apply(this,arguments)}return o(t,e),t.prototype._next=function(e){a.noop()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new a)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.isEmpty=r;var a=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new u(e))},e}(),u=function(e){function t(t){e.call(this,t)}return o(t,e),t.prototype.notifyComplete=function(e){var t=this.destination;t.next(e),t.complete()},t.prototype._next=function(e){this.notifyComplete(!1)},t.prototype._complete=function(){this.notifyComplete(!0)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.audit(function(){return a.timer(e,t)})}var o=n(16),i=n(110),a=n(154);t.auditTime=r},function(e,t,n){"use strict";function r(e,t,n){return function(r){return r.lift(new u(e,t,n,r))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(79);t.last=r;var u=function(){function e(e,t,n,r){this.predicate=e,this.resultSelector=t,this.defaultValue=n,this.source=r}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.predicate,this.resultSelector,this.defaultValue,this.source))},e}(),s=function(e){function t(t,n,r,o,i){e.call(this,t),this.predicate=n,this.resultSelector=r,this.defaultValue=o,this.source=i,this.hasValue=!1,this.index=0,void 0!==o&&(this.lastValue=o,this.hasValue=!0)}return o(t,e),t.prototype._next=function(e){var t=this.index++;if(this.predicate)this._tryPredicate(e,t);else{if(this.resultSelector)return void this._tryResultSelector(e,t);this.lastValue=e,this.hasValue=!0}},t.prototype._tryPredicate=function(e,t){var n;try{n=this.predicate(e,t,this.source)}catch(e){return void this.destination.error(e)}if(n){if(this.resultSelector)return void this._tryResultSelector(e,t);this.lastValue=e,this.hasValue=!0}},t.prototype._tryResultSelector=function(e,t){var n;try{n=this.resultSelector(e,t)}catch(e){return void this.destination.error(e)}this.lastValue=n,this.hasValue=!0},t.prototype._complete=function(){var e=this.destination;this.hasValue?(e.next(this.lastValue),e.complete()):e.error(new a.EmptyError)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new a(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.every=r;var a=function(){function e(e,t,n){this.predicate=e,this.thisArg=t,this.source=n}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate,this.thisArg,this.source))},e}(),u=function(e){function t(t,n,r,o){e.call(this,t),this.predicate=n,this.thisArg=r,this.source=o,this.index=0,this.thisArg=r||this}return o(t,e),t.prototype.notifyComplete=function(e){this.destination.next(e),this.destination.complete()},t.prototype._next=function(e){var t=!1;try{t=this.predicate.call(this.thisArg,e,this.index++,this.source)}catch(e){return void this.destination.error(e)}t||this.notifyComplete(!1)},t.prototype._complete=function(){this.notifyComplete(!0)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.mapTo=r;var a=function(){function e(e){this.value=e}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.value))},e}(),u=function(e){function t(t,n){e.call(this,t),this.value=n}return o(t,e),t.prototype._next=function(e){this.destination.next(this.value)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new u)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(50);t.materialize=r;var u=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new s(e))},e}(),s=function(e){function t(t){e.call(this,t)}return o(t,e),t.prototype._next=function(e){this.destination.next(a.Notification.createNext(e))},t.prototype._error=function(e){var t=this.destination;t.next(a.Notification.createError(e)),t.complete()},t.prototype._complete=function(){var e=this.destination;e.next(a.Notification.createComplete()),e.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){var t="function"==typeof e?function(t,n){return e(t,n)>0?t:n}:function(e,t){return e>t?e:t};return o.reduce(t)}var o=n(57);t.max=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){return t.lift.call(o.merge.apply(void 0,[t].concat(e)))}}var o=n(75),i=n(75);t.mergeStatic=i.merge,t.merge=r},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),"number"==typeof t&&(n=t,t=null),function(r){return r.lift(new u(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.mergeMapTo=r;var u=function(){function e(e,t,n){void 0===n&&(n=Number.POSITIVE_INFINITY),this.ish=e,this.resultSelector=t,this.concurrent=n}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.ish,this.resultSelector,this.concurrent))},e}();t.MergeMapToOperator=u;var s=function(e){function t(t,n,r,o){void 0===o&&(o=Number.POSITIVE_INFINITY),e.call(this,t),this.ish=n,this.resultSelector=r,this.concurrent=o,this.hasCompleted=!1,this.buffer=[],this.active=0,this.index=0}return o(t,e),t.prototype._next=function(e){if(this.active<this.concurrent){var t=this.resultSelector,n=this.index++,r=this.ish,o=this.destination;this.active++,this._innerSub(r,o,t,e,n)}else this.buffer.push(e)},t.prototype._innerSub=function(e,t,n,r,o){this.add(a.subscribeToResult(this,e,r,o))},t.prototype._complete=function(){this.hasCompleted=!0,0===this.active&&0===this.buffer.length&&this.destination.complete()},t.prototype.notifyNext=function(e,t,n,r,o){var i=this,a=i.resultSelector,u=i.destination;a?this.trySelectResult(e,t,n,r):u.next(t)},t.prototype.trySelectResult=function(e,t,n,r){var o,i=this,a=i.resultSelector,u=i.destination;try{o=a(e,t,n,r)}catch(e){return void u.error(e)}u.next(o)},t.prototype.notifyError=function(e){this.destination.error(e)},t.prototype.notifyComplete=function(e){var t=this.buffer;this.remove(e),this.active--,t.length>0?this._next(t.shift()):0===this.active&&this.hasCompleted&&this.destination.complete()},t}(i.OuterSubscriber);t.MergeMapToSubscriber=s},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),function(r){return r.lift(new l(e,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(21),a=n(20),u=n(7),s=n(6);t.mergeScan=r;var l=function(){function e(e,t,n){this.accumulator=e,this.seed=t,this.concurrent=n}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.accumulator,this.seed,this.concurrent))},e}();t.MergeScanOperator=l;var c=function(e){function t(t,n,r,o){e.call(this,t),this.accumulator=n,this.acc=r,this.concurrent=o,this.hasValue=!1,this.hasCompleted=!1,this.buffer=[],this.active=0,this.index=0}return o(t,e),t.prototype._next=function(e){if(this.active<this.concurrent){var t=this.index++,n=i.tryCatch(this.accumulator)(this.acc,e),r=this.destination;n===a.errorObject?r.error(a.errorObject.e):(this.active++,this._innerSub(n,e,t))}else this.buffer.push(e)},t.prototype._innerSub=function(e,t,n){this.add(u.subscribeToResult(this,e,t,n))},t.prototype._complete=function(){this.hasCompleted=!0,0===this.active&&0===this.buffer.length&&(!1===this.hasValue&&this.destination.next(this.acc),this.destination.complete())},t.prototype.notifyNext=function(e,t,n,r,o){var i=this.destination;this.acc=t,this.hasValue=!0,i.next(t)},t.prototype.notifyComplete=function(e){var t=this.buffer;this.remove(e),this.active--,t.length>0?this._next(t.shift()):0===this.active&&this.hasCompleted&&(!1===this.hasValue&&this.destination.next(this.acc),this.destination.complete())},t}(s.OuterSubscriber);t.MergeScanSubscriber=c},function(e,t,n){"use strict";function r(e){var t="function"==typeof e?function(t,n){return e(t,n)<0?t:n}:function(e,t){return e<t?e:t};return o.reduce(t)}var o=n(57);t.min=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(0),a=n(2),u=n(18),s=n(113),l=function(e){function t(t,n){e.call(this),this.source=t,this.subjectFactory=n,this._refCount=0,this._isComplete=!1}return r(t,e),t.prototype._subscribe=function(e){return this.getSubject().subscribe(e)},t.prototype.getSubject=function(){var e=this._subject;return e&&!e.isStopped||(this._subject=this.subjectFactory()),this._subject},t.prototype.connect=function(){var e=this._connection;return e||(this._isComplete=!1,e=this._connection=new u.Subscription,e.add(this.source.subscribe(new f(this.getSubject(),this))),e.closed?(this._connection=null,e=u.Subscription.EMPTY):this._connection=e),e},t.prototype.refCount=function(){return s.refCount()(this)},t}(i.Observable);t.ConnectableObservable=l;var c=l.prototype;t.connectableObservableDescriptor={operator:{value:null},_refCount:{value:0,writable:!0},_subject:{value:null,writable:!0},_connection:{value:null,writable:!0},_subscribe:{value:c._subscribe},_isComplete:{value:c._isComplete,writable:!0},getSubject:{value:c.getSubject},connect:{value:c.connect},refCount:{value:c.refCount}};var f=function(e){function t(t,n){e.call(this,t),this.connectable=n}return r(t,e),t.prototype._error=function(t){this._unsubscribe(),e.prototype._error.call(this,t)},t.prototype._complete=function(){this.connectable._isComplete=!0,this._unsubscribe(),e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){var e=this.connectable;if(e){this.connectable=null;var t=e._connection;e._refCount=0,e._subject=null,e._connection=null,t&&t.unsubscribe()}},t}(o.SubjectSubscriber),d=(function(){function e(e){this.connectable=e}e.prototype.call=function(e,t){var n=this.connectable;n._refCount++;var r=new d(e,n),o=t.subscribe(r);return r.closed||(r.connection=n.connect()),o}}(),function(e){function t(t,n){e.call(this,t),this.connectable=n}return r(t,e),t.prototype._unsubscribe=function(){var e=this.connectable;if(!e)return void(this.connection=null);this.connectable=null;var t=e._refCount;if(t<=0)return void(this.connection=null);if(e._refCount=t-1,t>1)return void(this.connection=null);var n=this.connection,r=e._connection;this.connection=null,!r||n&&r!==n||r.unsubscribe()},t}(a.Subscriber))},function(e,t,n){"use strict";function r(){return function(e){return e.lift(new a)}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.pairwise=r;var a=function(){function e(){}return e.prototype.call=function(e,t){return t.subscribe(new u(e))},e}(),u=function(e){function t(t){e.call(this,t),this.hasPrev=!1}return o(t,e),t.prototype._next=function(e){this.hasPrev?this.destination.next([this.prev,e]):this.hasPrev=!0,this.prev=e},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return[i.filter(e,t)(n),i.filter(o.not(e,t))(n)]}}var o=n(527),i=n(108);t.partition=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=e.length;if(0===n)throw new Error("list of properties cannot be empty.");return function(t){return i.map(o(e,n))(t)}}function o(e,t){return function(n){for(var r=n,o=0;o<t;o++){var i=r[e[o]];if(void 0===i)return;r=i}return r}}var i=n(55);t.pluck=r},function(e,t,n){"use strict";function r(e){return e?i.multicast(function(){return new o.Subject},e):i.multicast(new o.Subject)}var o=n(19),i=n(37);t.publish=r},function(e,t,n){"use strict";function r(e){return function(t){return i.multicast(new o.BehaviorSubject(e))(t)}}var o=n(201),i=n(37);t.publishBehavior=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(70),a=function(e){function t(t){e.call(this),this._value=t}return r(t,e),Object.defineProperty(t.prototype,"value",{get:function(){return this.getValue()},enumerable:!0,configurable:!0}),t.prototype._subscribe=function(t){var n=e.prototype._subscribe.call(this,t);return n&&!n.closed&&t.next(this._value),n},t.prototype.getValue=function(){if(this.hasError)throw this.thrownError;if(this.closed)throw new i.ObjectUnsubscribedError;return this._value},t.prototype.next=function(t){e.prototype.next.call(this,this._value=t)},t}(o.Subject);t.BehaviorSubject=a},function(e,t,n){"use strict";function r(e,t,n,r){n&&"function"!=typeof n&&(r=n);var a="function"==typeof n?n:void 0,u=new o.ReplaySubject(e,t,r);return function(e){return i.multicast(function(){return u},a)(e)}}var o=n(78),i=n(37);t.publishReplay=r},function(e,t,n){"use strict";function r(){return function(e){return i.multicast(new o.AsyncSubject)(e)}}var o=n(71),i=n(37);t.publishLast=r},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){return 1===e.length&&o.isArray(e[0])&&(e=e[0]),t.lift.call(i.race.apply(void 0,[t].concat(e)))}}var o=n(27),i=n(103);t.race=r},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=-1),function(t){return 0===e?new a.EmptyObservable:e<0?t.lift(new u(-1,t)):t.lift(new u(e-1,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(33);t.repeat=r;var u=function(){function e(e,t){this.count=e,this.source=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.count,this.source))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.count=n,this.source=r}return o(t,e),t.prototype.complete=function(){if(!this.isStopped){var t=this,n=t.source,r=t.count;if(0===r)return e.prototype.complete.call(this);r>-1&&(this.count=r-1),n.subscribe(this._unsubscribeAndRecycle())}},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new c(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(19),a=n(21),u=n(20),s=n(6),l=n(7);t.repeatWhen=r;var c=function(){function e(e){this.notifier=e}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.notifier,t))},e}(),f=function(e){function t(t,n,r){e.call(this,t),this.notifier=n,this.source=r,this.sourceIsBeingSubscribedTo=!0}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.sourceIsBeingSubscribedTo=!0,this.source.subscribe(this)},t.prototype.notifyComplete=function(t){if(!1===this.sourceIsBeingSubscribedTo)return e.prototype.complete.call(this)},t.prototype.complete=function(){if(this.sourceIsBeingSubscribedTo=!1,!this.isStopped){if(this.retries){if(this.retriesSubscription.closed)return e.prototype.complete.call(this)}else this.subscribeToRetries();this._unsubscribeAndRecycle(),this.notifications.next()}},t.prototype._unsubscribe=function(){var e=this,t=e.notifications,n=e.retriesSubscription;t&&(t.unsubscribe(),this.notifications=null),n&&(n.unsubscribe(),this.retriesSubscription=null),this.retries=null},t.prototype._unsubscribeAndRecycle=function(){var t=this,n=t.notifications,r=t.retries,o=t.retriesSubscription;return this.notifications=null,this.retries=null,this.retriesSubscription=null,e.prototype._unsubscribeAndRecycle.call(this),this.notifications=n,this.retries=r,this.retriesSubscription=o,this},t.prototype.subscribeToRetries=function(){this.notifications=new i.Subject;var t=a.tryCatch(this.notifier)(this.notifications);if(t===u.errorObject)return e.prototype.complete.call(this);this.retries=t,this.retriesSubscription=l.subscribeToResult(this,t)},t}(s.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=-1),function(t){return t.lift(new a(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.retry=r;var a=function(){function e(e,t){this.count=e,this.source=t}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.count,this.source))},e}(),u=function(e){function t(t,n,r){e.call(this,t),this.count=n,this.source=r}return o(t,e),t.prototype.error=function(t){if(!this.isStopped){var n=this,r=n.source,o=n.count;if(0===o)return e.prototype.error.call(this,t);o>-1&&(this.count=o-1),r.subscribe(this._unsubscribeAndRecycle())}},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new c(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(19),a=n(21),u=n(20),s=n(6),l=n(7);t.retryWhen=r;var c=function(){function e(e,t){this.notifier=e,this.source=t}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.notifier,this.source))},e}(),f=function(e){function t(t,n,r){e.call(this,t),this.notifier=n,this.source=r}return o(t,e),t.prototype.error=function(t){if(!this.isStopped){var n=this.errors,r=this.retries,o=this.retriesSubscription;if(r)this.errors=null,this.retriesSubscription=null;else{if(n=new i.Subject,(r=a.tryCatch(this.notifier)(n))===u.errorObject)return e.prototype.error.call(this,u.errorObject.e);o=l.subscribeToResult(this,r)}this._unsubscribeAndRecycle(),this.errors=n,this.retries=r,this.retriesSubscription=o,n.next(t)}},t.prototype._unsubscribe=function(){var e=this,t=e.errors,n=e.retriesSubscription;t&&(t.unsubscribe(),this.errors=null),n&&(n.unsubscribe(),this.retriesSubscription=null),this.retries=null},t.prototype.notifyNext=function(e,t,n,r,o){var i=this,a=i.errors,u=i.retries,s=i.retriesSubscription;this.errors=null,this.retries=null,this.retriesSubscription=null,this._unsubscribeAndRecycle(),this.errors=a,this.retries=u,this.retriesSubscription=s,this.source.subscribe(this)},t}(s.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.sample=r;var u=function(){function e(e){this.notifier=e}return e.prototype.call=function(e,t){var n=new s(e),r=t.subscribe(n);return r.add(a.subscribeToResult(n,this.notifier)),r},e}(),s=function(e){function t(){e.apply(this,arguments),this.hasValue=!1}return o(t,e),t.prototype._next=function(e){this.value=e,this.hasValue=!0},t.prototype.notifyNext=function(e,t,n,r,o){this.emitValue()},t.prototype.notifyComplete=function(){this.emitValue()},t.prototype.emitValue=function(){this.hasValue&&(this.hasValue=!1,this.destination.next(this.value))},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=u.async),function(n){return n.lift(new s(e,t))}}function o(e){var t=e.subscriber,n=e.period;t.notifyNext(),this.schedule(e,n)}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(2),u=n(16);t.sampleTime=r;var s=function(){function e(e,t){this.period=e,this.scheduler=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.period,this.scheduler))},e}(),l=function(e){function t(t,n,r){e.call(this,t),this.period=n,this.scheduler=r,this.hasValue=!1,this.add(r.schedule(o,n,{subscriber:this,period:n}))}return i(t,e),t.prototype._next=function(e){this.lastValue=e,this.hasValue=!0},t.prototype.notifyNext=function(){this.hasValue&&(this.hasValue=!1,this.destination.next(this.lastValue))},t}(a.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new s(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(21),u=n(20);t.sequenceEqual=r;var s=function(){function e(e,t){this.compareTo=e,this.comparor=t}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.compareTo,this.comparor))},e}();t.SequenceEqualOperator=s;var l=function(e){function t(t,n,r){e.call(this,t),this.compareTo=n,this.comparor=r,this._a=[],this._b=[],this._oneComplete=!1,this.add(n.subscribe(new c(t,this)))}return o(t,e),t.prototype._next=function(e){this._oneComplete&&0===this._b.length?this.emit(!1):(this._a.push(e),this.checkValues())},t.prototype._complete=function(){this._oneComplete?this.emit(0===this._a.length&&0===this._b.length):this._oneComplete=!0},t.prototype.checkValues=function(){for(var e=this,t=e._a,n=e._b,r=e.comparor;t.length>0&&n.length>0;){var o=t.shift(),i=n.shift(),s=!1;r?(s=a.tryCatch(r)(o,i))===u.errorObject&&this.destination.error(u.errorObject.e):s=o===i,s||this.emit(!1)}},t.prototype.emit=function(e){var t=this.destination;t.next(e),t.complete()},t.prototype.nextB=function(e){this._oneComplete&&0===this._a.length?this.emit(!1):(this._b.push(e),this.checkValues())},t}(i.Subscriber);t.SequenceEqualSubscriber=l;var c=function(e){function t(t,n){e.call(this,t),this.parent=n}return o(t,e),t.prototype._next=function(e){this.parent.nextB(e)},t.prototype._error=function(e){this.parent.error(e)},t.prototype._complete=function(){this.parent._complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){return new u.Subject}function o(){return function(e){return a.refCount()(i.multicast(r)(e))}}var i=n(37),a=n(113),u=n(19);t.share=o},function(e,t,n){"use strict";function r(e,t,n){return function(r){return r.lift(o(e,t,n))}}function o(e,t,n){var r,o,a=0,u=!1,s=!1;return function(l){a++,r&&!u||(u=!1,r=new i.ReplaySubject(e,t,n),o=l.subscribe({next:function(e){r.next(e)},error:function(e){u=!0,r.error(e)},complete:function(){s=!0,r.complete()}}));var c=r.subscribe(this);return function(){a--,c.unsubscribe(),o&&0===a&&s&&o.unsubscribe()}}}var i=n(78);t.shareReplay=r},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(79);t.single=r;var u=function(){function e(e,t){this.predicate=e,this.source=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.predicate,this.source))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.predicate=n,this.source=r,this.seenValue=!1,this.index=0}return o(t,e),t.prototype.applySingleValue=function(e){this.seenValue?this.destination.error("Sequence contains more than one element"):(this.seenValue=!0,this.singleValue=e)},t.prototype._next=function(e){var t=this.index++;this.predicate?this.tryNext(e,t):this.applySingleValue(e)},t.prototype.tryNext=function(e,t){try{this.predicate(e,t,this.source)&&this.applySingleValue(e)}catch(e){this.destination.error(e)}},t.prototype._complete=function(){var e=this.destination;this.index>0?(e.next(this.seenValue?this.singleValue:void 0),e.complete()):e.error(new a.EmptyError)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.skip=r;var a=function(){function e(e){this.total=e}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.total))},e}(),u=function(e){function t(t,n){e.call(this,t),this.total=n,this.count=0}return o(t,e),t.prototype._next=function(e){++this.count>this.total&&this.destination.next(e)},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(56);t.skipLast=r;var u=function(){function e(e){if(this._skipCount=e,this._skipCount<0)throw new a.ArgumentOutOfRangeError}return e.prototype.call=function(e,t){return 0===this._skipCount?t.subscribe(new i.Subscriber(e)):t.subscribe(new s(e,this._skipCount))},e}(),s=function(e){function t(t,n){e.call(this,t),this._skipCount=n,this._count=0,this._ring=new Array(n)}return o(t,e),t.prototype._next=function(e){var t=this._skipCount,n=this._count++;if(n<t)this._ring[n]=e;else{var r=n%t,o=this._ring,i=o[r];o[r]=e,this.destination.next(i)}},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.skipUntil=r;var u=function(){function e(e){this.notifier=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.notifier))},e}(),s=function(e){function t(t,n){e.call(this,t),this.hasValue=!1,this.isInnerStopped=!1,this.add(a.subscribeToResult(this,n))}return o(t,e),t.prototype._next=function(t){this.hasValue&&e.prototype._next.call(this,t)},t.prototype._complete=function(){this.isInnerStopped?e.prototype._complete.call(this):this.unsubscribe()},t.prototype.notifyNext=function(e,t,n,r,o){this.hasValue=!0},t.prototype.notifyComplete=function(){this.isInnerStopped=!0,this.isStopped&&e.prototype._complete.call(this)},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.skipWhile=r;var a=function(){function e(e){this.predicate=e}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate))},e}(),u=function(e){function t(t,n){e.call(this,t),this.predicate=n,this.skipping=!0,this.index=0}return o(t,e),t.prototype._next=function(e){var t=this.destination;this.skipping&&this.tryCallPredicate(e),this.skipping||t.next(e)},t.prototype.tryCallPredicate=function(e){try{var t=this.predicate(e,this.index++);this.skipping=Boolean(t)}catch(e){this.destination.error(e)}},t}(i.Subscriber)},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){var n=e[e.length-1];s.isScheduler(n)?e.pop():n=null;var r=e.length;return 1===r?u.concat(new i.ScalarObservable(e[0],n),t):r>1?u.concat(new o.ArrayObservable(e,n),t):u.concat(new a.EmptyObservable(n),t)}}var o=n(32),i=n(101),a=n(33),u=n(49),s=n(25);t.startWith=r},function(e,t,n){"use strict";var r=n(578),o=n(582);t.asap=new o.AsapScheduler(r.AsapAction)},function(e,t,n){(function(e){function r(e,t){this._id=e,this._clearFn=t}var o=Function.prototype.apply;t.setTimeout=function(){return new r(o.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(o.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(580),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(t,n(47))},function(e,t,n){"use strict";function r(){return o.switchMap(i.identity)}var o=n(114),i=n(153);t.switchAll=r},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.switchMapTo=r;var u=function(){function e(e,t){this.observable=e,this.resultSelector=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.observable,this.resultSelector))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.inner=n,this.resultSelector=r,this.index=0}return o(t,e),t.prototype._next=function(e){var t=this.innerSubscription;t&&t.unsubscribe(),this.add(this.innerSubscription=a.subscribeToResult(this,this.inner,e,this.index++))},t.prototype._complete=function(){var t=this.innerSubscription;t&&!t.closed||e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){this.innerSubscription=null},t.prototype.notifyComplete=function(t){this.remove(t),this.innerSubscription=null,this.isStopped&&e.prototype._complete.call(this)},t.prototype.notifyNext=function(e,t,n,r,o){var i=this,a=i.resultSelector,u=i.destination;a?this.tryResultSelector(e,t,n,r):u.next(t)},t.prototype.tryResultSelector=function(e,t,n,r){var o,i=this,a=i.resultSelector,u=i.destination;try{o=a(e,t,n,r)}catch(e){return void u.error(e)}u.next(o)},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return 0===e?new u.EmptyObservable:t.lift(new s(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(56),u=n(33);t.take=r;var s=function(){function e(e){if(this.total=e,this.total<0)throw new a.ArgumentOutOfRangeError}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.total))},e}(),l=function(e){function t(t,n){e.call(this,t),this.total=n,this.count=0}return o(t,e),t.prototype._next=function(e){var t=this.total,n=++this.count;n<=t&&(this.destination.next(e),n===t&&(this.destination.complete(),this.unsubscribe()))},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new u(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.takeUntil=r;var u=function(){function e(e){this.notifier=e}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.notifier))},e}(),s=function(e){function t(t,n){e.call(this,t),this.notifier=n,this.add(a.subscribeToResult(this,n))}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.complete()},t.prototype.notifyComplete=function(){},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new a(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2);t.takeWhile=r;var a=function(){function e(e){this.predicate=e}return e.prototype.call=function(e,t){return t.subscribe(new u(e,this.predicate))},e}(),u=function(e){function t(t,n){e.call(this,t),this.predicate=n,this.index=0}return o(t,e),t.prototype._next=function(e){var t,n=this.destination;try{t=this.predicate(e,this.index++)}catch(e){return void n.error(e)}this.nextOrComplete(e,t)},t.prototype.nextOrComplete=function(e,t){var n=this.destination;Boolean(t)?n.next(e):n.complete()},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t,n){return void 0===t&&(t=u.async),void 0===n&&(n=s.defaultThrottleConfig),function(r){return r.lift(new l(e,t,n.leading,n.trailing))}}function o(e){e.subscriber.clearThrottle()}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(2),u=n(16),s=n(80);t.throttleTime=r;var l=function(){function e(e,t,n,r){this.duration=e,this.scheduler=t,this.leading=n,this.trailing=r}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.duration,this.scheduler,this.leading,this.trailing))},e}(),c=function(e){function t(t,n,r,o,i){e.call(this,t),this.duration=n,this.scheduler=r,this.leading=o,this.trailing=i,this._hasTrailingValue=!1,this._trailingValue=null}return i(t,e),t.prototype._next=function(e){this.throttled?this.trailing&&(this._trailingValue=e,this._hasTrailingValue=!0):(this.add(this.throttled=this.scheduler.schedule(o,this.duration,{subscriber:this})),this.leading&&this.destination.next(e))},t.prototype.clearThrottle=function(){var e=this.throttled;e&&(this.trailing&&this._hasTrailingValue&&(this.destination.next(this._trailingValue),this._trailingValue=null,this._hasTrailingValue=!1),e.unsubscribe(),this.remove(e),this.throttled=null)},t}(a.Subscriber)},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=o.async),i.timeInterval(e)(this)}var o=n(16),i=n(229);t.TimeInterval=i.TimeInterval,t.timeInterval=r},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=a.async),function(t){return t.lift(new s(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(16);t.timeInterval=r;var u=function(){function e(e,t){this.value=e,this.interval=t}return e}();t.TimeInterval=u;var s=function(){function e(e){this.scheduler=e}return e.prototype.call=function(e,t){return t.subscribe(new l(e,this.scheduler))},e}(),l=function(e){function t(t,n){e.call(this,t),this.scheduler=n,this.lastTime=0,this.lastTime=n.now()}return o(t,e),t.prototype._next=function(e){var t=this.scheduler.now(),n=t-this.lastTime;this.lastTime=t,this.destination.next(new u(e,n))},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e,t){void 0===t&&(t=i.async);var n=a.isDate(e),r=n?+e-t.now():Math.abs(e);return function(e){return e.lift(new l(r,n,t,new s.TimeoutError))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(16),a=n(76),u=n(2),s=n(231);t.timeout=r;var l=function(){function e(e,t,n,r){this.waitFor=e,this.absoluteTimeout=t,this.scheduler=n,this.errorInstance=r}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.absoluteTimeout,this.waitFor,this.scheduler,this.errorInstance))},e}(),c=function(e){function t(t,n,r,o,i){e.call(this,t),this.absoluteTimeout=n,this.waitFor=r,this.scheduler=o,this.errorInstance=i,this.action=null,this.scheduleTimeout()}return o(t,e),t.dispatchTimeout=function(e){e.error(e.errorInstance)},t.prototype.scheduleTimeout=function(){var e=this.action;e?this.action=e.schedule(this,this.waitFor):this.add(this.action=this.scheduler.schedule(t.dispatchTimeout,this.waitFor,this))},t.prototype._next=function(t){this.absoluteTimeout||this.scheduleTimeout(),e.prototype._next.call(this,t)},t.prototype._unsubscribe=function(){this.action=null,this.scheduler=null,this.errorInstance=null},t}(u.Subscriber)},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=function(e){function t(){var t=e.call(this,"Timeout has occurred");this.name=t.name="TimeoutError",this.stack=t.stack,this.message=t.message}return r(t,e),t}(Error);t.TimeoutError=o},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=i.async),function(r){var o=a.isDate(e),i=o?+e-n.now():Math.abs(e);return r.lift(new l(i,o,t,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(16),a=n(76),u=n(6),s=n(7);t.timeoutWith=r;var l=function(){function e(e,t,n,r){this.waitFor=e,this.absoluteTimeout=t,this.withObservable=n,this.scheduler=r}return e.prototype.call=function(e,t){return t.subscribe(new c(e,this.absoluteTimeout,this.waitFor,this.withObservable,this.scheduler))},e}(),c=function(e){function t(t,n,r,o,i){e.call(this,t),this.absoluteTimeout=n,this.waitFor=r,this.withObservable=o,this.scheduler=i,this.action=null,this.scheduleTimeout()}return o(t,e),t.dispatchTimeout=function(e){var t=e.withObservable;e._unsubscribeAndRecycle(),e.add(s.subscribeToResult(e,t))},t.prototype.scheduleTimeout=function(){var e=this.action;e?this.action=e.schedule(this,this.waitFor):this.add(this.action=this.scheduler.schedule(t.dispatchTimeout,this.waitFor,this))},t.prototype._next=function(t){this.absoluteTimeout||this.scheduleTimeout(),e.prototype._next.call(this,t)},t.prototype._unsubscribe=function(){this.action=null,this.scheduler=null,this.withObservable=null},t}(u.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t,n){return e.push(t),e}function o(){return i.reduce(r,[])}var i=n(57);t.toArray=o},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new s(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(19),a=n(6),u=n(7);t.window=r;var s=function(){function e(e){this.windowBoundaries=e}return e.prototype.call=function(e,t){var n=new l(e),r=t.subscribe(n);return r.closed||n.add(u.subscribeToResult(n,this.windowBoundaries)),r},e}(),l=function(e){function t(t){e.call(this,t),this.window=new i.Subject,t.next(this.window)}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.openWindow()},t.prototype.notifyError=function(e,t){this._error(e)},t.prototype.notifyComplete=function(e){this._complete()},t.prototype._next=function(e){this.window.next(e)},t.prototype._error=function(e){this.window.error(e),this.destination.error(e)},t.prototype._complete=function(){this.window.complete(),this.destination.complete()},t.prototype._unsubscribe=function(){this.window=null},t.prototype.openWindow=function(){var e=this.window;e&&e.complete();var t=this.destination,n=this.window=new i.Subject;t.next(n)},t}(a.OuterSubscriber)},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),function(n){return n.lift(new u(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(2),a=n(19);t.windowCount=r;var u=function(){function e(e,t){this.windowSize=e,this.startWindowEvery=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.windowSize,this.startWindowEvery))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.destination=t,this.windowSize=n,this.startWindowEvery=r,this.windows=[new a.Subject],this.count=0,t.next(this.windows[0])}return o(t,e),t.prototype._next=function(e){for(var t=this.startWindowEvery>0?this.startWindowEvery:this.windowSize,n=this.destination,r=this.windowSize,o=this.windows,i=o.length,u=0;u<i&&!this.closed;u++)o[u].next(e);var s=this.count-r+1;if(s>=0&&s%t==0&&!this.closed&&o.shift().complete(),++this.count%t==0&&!this.closed){var l=new a.Subject;o.push(l),n.next(l)}},t.prototype._error=function(e){var t=this.windows;if(t)for(;t.length>0&&!this.closed;)t.shift().error(e);this.destination.error(e)},t.prototype._complete=function(){var e=this.windows;if(e)for(;e.length>0&&!this.closed;)e.shift().complete();this.destination.complete()},t.prototype._unsubscribe=function(){this.count=0,this.windows=null},t}(i.Subscriber)},function(e,t,n){"use strict";function r(e){var t=l.async,n=null,r=Number.POSITIVE_INFINITY;return d.isScheduler(arguments[3])&&(t=arguments[3]),d.isScheduler(arguments[2])?t=arguments[2]:f.isNumeric(arguments[2])&&(r=arguments[2]),d.isScheduler(arguments[1])?t=arguments[1]:f.isNumeric(arguments[1])&&(n=arguments[1]),function(o){return o.lift(new p(e,n,r,t))}}function o(e){var t=e.subscriber,n=e.windowTimeSpan,r=e.window;r&&t.closeWindow(r),e.window=t.openWindow(),this.schedule(e,n)}function i(e){var t=e.windowTimeSpan,n=e.subscriber,r=e.scheduler,o=e.windowCreationInterval,i=n.openWindow(),u=this,s={action:u,subscription:null},l={subscriber:n,window:i,context:s};s.subscription=r.schedule(a,t,l),u.add(s.subscription),u.schedule(e,o)}function a(e){var t=e.subscriber,n=e.window,r=e.context;r&&r.action&&r.subscription&&r.action.remove(r.subscription),t.closeWindow(n)}var u=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},s=n(19),l=n(16),c=n(2),f=n(52),d=n(25);t.windowTime=r;var p=function(){function e(e,t,n,r){this.windowTimeSpan=e,this.windowCreationInterval=t,this.maxWindowSize=n,this.scheduler=r}return e.prototype.call=function(e,t){return t.subscribe(new y(e,this.windowTimeSpan,this.windowCreationInterval,this.maxWindowSize,this.scheduler))},e}(),h=function(e){function t(){e.apply(this,arguments),this._numberOfNextedValues=0}return u(t,e),t.prototype.next=function(t){this._numberOfNextedValues++,e.prototype.next.call(this,t)},Object.defineProperty(t.prototype,"numberOfNextedValues",{get:function(){return this._numberOfNextedValues},enumerable:!0,configurable:!0}),t}(s.Subject),y=function(e){function t(t,n,r,u,s){e.call(this,t),this.destination=t,this.windowTimeSpan=n,this.windowCreationInterval=r,this.maxWindowSize=u,this.scheduler=s,this.windows=[];var l=this.openWindow();if(null!==r&&r>=0){var c={subscriber:this,window:l,context:null},f={windowTimeSpan:n,windowCreationInterval:r,subscriber:this,scheduler:s};this.add(s.schedule(a,n,c)),this.add(s.schedule(i,r,f))}else{var d={subscriber:this,window:l,windowTimeSpan:n};this.add(s.schedule(o,n,d))}}return u(t,e),t.prototype._next=function(e){for(var t=this.windows,n=t.length,r=0;r<n;r++){var o=t[r];o.closed||(o.next(e),o.numberOfNextedValues>=this.maxWindowSize&&this.closeWindow(o))}},t.prototype._error=function(e){for(var t=this.windows;t.length>0;)t.shift().error(e);this.destination.error(e)},t.prototype._complete=function(){for(var e=this.windows;e.length>0;){var t=e.shift();t.closed||t.complete()}this.destination.complete()},t.prototype.openWindow=function(){var e=new h;return this.windows.push(e),this.destination.next(e),e},t.prototype.closeWindow=function(e){e.complete();var t=this.windows;t.splice(t.indexOf(e),1)},t}(c.Subscriber)},function(e,t,n){"use strict";function r(e,t){return function(n){return n.lift(new f(e,t))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(19),a=n(18),u=n(21),s=n(20),l=n(6),c=n(7);t.windowToggle=r;var f=function(){function e(e,t){this.openings=e,this.closingSelector=t}return e.prototype.call=function(e,t){return t.subscribe(new d(e,this.openings,this.closingSelector))},e}(),d=function(e){function t(t,n,r){e.call(this,t),this.openings=n,this.closingSelector=r,this.contexts=[],this.add(this.openSubscription=c.subscribeToResult(this,n,n))}return o(t,e),t.prototype._next=function(e){var t=this.contexts;if(t)for(var n=t.length,r=0;r<n;r++)t[r].window.next(e)},t.prototype._error=function(t){var n=this.contexts;if(this.contexts=null,n)for(var r=n.length,o=-1;++o<r;){var i=n[o];i.window.error(t),i.subscription.unsubscribe()}e.prototype._error.call(this,t)},t.prototype._complete=function(){var t=this.contexts;if(this.contexts=null,t)for(var n=t.length,r=-1;++r<n;){var o=t[r];o.window.complete(),o.subscription.unsubscribe()}e.prototype._complete.call(this)},t.prototype._unsubscribe=function(){var e=this.contexts;if(this.contexts=null,e)for(var t=e.length,n=-1;++n<t;){var r=e[n];r.window.unsubscribe(),r.subscription.unsubscribe()}},t.prototype.notifyNext=function(e,t,n,r,o){if(e===this.openings){var l=this.closingSelector,f=u.tryCatch(l)(t);if(f===s.errorObject)return this.error(s.errorObject.e);var d=new i.Subject,p=new a.Subscription,h={window:d,subscription:p};this.contexts.push(h);var y=c.subscribeToResult(this,f,h);y.closed?this.closeWindow(this.contexts.length-1):(y.context=h,p.add(y)),this.destination.next(d)}else this.closeWindow(this.contexts.indexOf(e))},t.prototype.notifyError=function(e){this.error(e)},t.prototype.notifyComplete=function(e){e!==this.openSubscription&&this.closeWindow(this.contexts.indexOf(e.context))},t.prototype.closeWindow=function(e){if(-1!==e){var t=this.contexts,n=t[e],r=n.window,o=n.subscription;t.splice(e,1),r.complete(),o.unsubscribe()}},t}(l.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new c(e))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(19),a=n(21),u=n(20),s=n(6),l=n(7);t.windowWhen=r;var c=function(){function e(e){this.closingSelector=e}return e.prototype.call=function(e,t){return t.subscribe(new f(e,this.closingSelector))},e}(),f=function(e){function t(t,n){e.call(this,t),this.destination=t,this.closingSelector=n,this.openWindow()}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.openWindow(o)},t.prototype.notifyError=function(e,t){this._error(e)},t.prototype.notifyComplete=function(e){this.openWindow(e)},t.prototype._next=function(e){this.window.next(e)},t.prototype._error=function(e){this.window.error(e),this.destination.error(e),this.unsubscribeClosingNotification()},t.prototype._complete=function(){this.window.complete(),this.destination.complete(),this.unsubscribeClosingNotification()},t.prototype.unsubscribeClosingNotification=function(){this.closingNotification&&this.closingNotification.unsubscribe()},t.prototype.openWindow=function(e){void 0===e&&(e=null),e&&(this.remove(e),e.unsubscribe());var t=this.window;t&&t.complete();var n=this.window=new i.Subject;this.destination.next(n);var r=a.tryCatch(this.closingSelector)();if(r===u.errorObject){var o=u.errorObject.e;this.destination.error(o),this.window.error(o)}else this.add(this.closingNotification=l.subscribeToResult(this,r))},t}(s.OuterSubscriber)},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return function(t){var n;"function"==typeof e[e.length-1]&&(n=e.pop());var r=e;return t.lift(new u(r,n))}}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(6),a=n(7);t.withLatestFrom=r;var u=function(){function e(e,t){this.observables=e,this.project=t}return e.prototype.call=function(e,t){return t.subscribe(new s(e,this.observables,this.project))},e}(),s=function(e){function t(t,n,r){e.call(this,t),this.observables=n,this.project=r,this.toRespond=[];var o=n.length;this.values=new Array(o);for(var i=0;i<o;i++)this.toRespond.push(i);for(var i=0;i<o;i++){var u=n[i];this.add(a.subscribeToResult(this,u,u,i))}}return o(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.values[n]=t;var i=this.toRespond;if(i.length>0){var a=i.indexOf(n);-1!==a&&i.splice(a,1)}},t.prototype.notifyComplete=function(){},t.prototype._next=function(e){if(0===this.toRespond.length){var t=[e].concat(this.values);this.project?this._tryProject(t):this.destination.next(t)}},t.prototype._tryProject=function(e){var t;try{t=this.project.apply(this,e)}catch(e){return void this.destination.error(e)}this.destination.next(t)},t}(i.OuterSubscriber)},function(e,t,n){"use strict";function r(e){return function(t){return t.lift(new o.ZipOperator(e))}}var o=n(77);t.zipAll=r},function(e,t,n){"use strict";var r=n(242),o=function(){function e(){this.subscriptions=[]}return e.prototype.logSubscribedFrame=function(){return this.subscriptions.push(new r.SubscriptionLog(this.scheduler.now())),this.subscriptions.length-1},e.prototype.logUnsubscribedFrame=function(e){var t=this.subscriptions,n=t[e];t[e]=new r.SubscriptionLog(n.subscribedFrame,this.scheduler.now())},e}();t.SubscriptionLoggable=o},function(e,t,n){"use strict";var r=function(){function e(e,t){void 0===t&&(t=Number.POSITIVE_INFINITY),this.subscribedFrame=e,this.unsubscribedFrame=t}return e}();t.SubscriptionLog=r},function(e,t,n){"use strict";function r(e,t){for(var n=0,r=t.length;n<r;n++)for(var o=t[n],i=Object.getOwnPropertyNames(o.prototype),a=0,u=i.length;a<u;a++){var s=i[a];e.prototype[s]=o.prototype[s]}}t.applyMixins=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(53),i=n(54),a=function(e){function t(t,n){var r=this;void 0===t&&(t=u),void 0===n&&(n=Number.POSITIVE_INFINITY),e.call(this,t,function(){return r.frame}),this.maxFrames=n,this.frame=0,this.index=-1}return r(t,e),t.prototype.flush=function(){for(var e,t,n=this,r=n.actions,o=n.maxFrames;(t=r.shift())&&(this.frame=t.delay)<=o&&!(e=t.execute(t.state,t.delay)););if(e){for(;t=r.shift();)t.unsubscribe();throw e}},t.frameTimeFactor=10,t}(i.AsyncScheduler);t.VirtualTimeScheduler=a;var u=function(e){function t(t,n,r){void 0===r&&(r=t.index+=1),e.call(this,t,n),this.scheduler=t,this.work=n,this.index=r,this.active=!0,this.index=t.index=r}return r(t,e),t.prototype.schedule=function(n,r){if(void 0===r&&(r=0),!this.id)return e.prototype.schedule.call(this,n,r);this.active=!1;var o=new t(this.scheduler,this.work);return this.add(o),o.schedule(n,r)},t.prototype.requestAsyncId=function(e,n,r){void 0===r&&(r=0),this.delay=e.frame+r;var o=e.actions;return o.push(this),o.sort(t.sortActions),!0},t.prototype.recycleAsyncId=function(e,t,n){void 0===n&&(n=0)},t.prototype._execute=function(t,n){if(!0===this.active)return e.prototype._execute.call(this,t,n)},t.sortActions=function(e,t){return e.delay===t.delay?e.index===t.index?0:e.index>t.index?1:-1:e.delay>t.delay?1:-1},t}(o.AsyncAction);t.VirtualAction=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.MenuItem=t.Menu=void 0;var o=n(246),i=r(o),a=n(116),u=r(a);t.Menu=i.default,t.MenuItem=u.default,t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.desktop,r=e.maxHeight,o=e.width,i=t.muiTheme;return{root:{zIndex:i.zIndex.menu,maxHeight:r,overflowY:r?"auto":null},divider:{marginTop:7,marginBottom:8},list:{display:"table-cell",paddingBottom:n?16:8,paddingTop:n?16:8,userSelect:"none",width:o},selectedMenuItem:{color:i.menuItem.selectedTextColor}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(140),c=r(l),f=n(11),d=r(f),p=n(8),h=r(p),y=n(9),v=r(y),m=n(12),b=r(m),g=n(13),_=r(g),w=n(10),x=r(w),O=n(1),S=r(O),T=n(3),E=r(T),C=n(23),k=r(C),P=n(36),M=r(P),j=n(141),N=r(j),I=n(64),A=r(I),R=n(31),F=(r(R),n(247)),D=r(F),L=n(643),z=function(e){function t(e,n){(0,h.default)(this,t);var r=(0,b.default)(this,(t.__proto__||(0,d.default)(t)).call(this,e,n));V.call(r);var o=r.getFilteredChildren(e.children),i=r.getLastSelectedIndex(e,o),a=e.disableAutoFocus?-1:i>=0?i:0;return-1!==a&&e.onMenuItemFocusChange&&e.onMenuItemFocusChange(null,a),r.state={focusIndex:a,isKeyboardFocused:e.initiallyKeyboardFocused,keyWidth:e.desktop?64:56},r.hotKeyHolder=new L.HotKeyHolder,r}return(0,_.default)(t,e),(0,v.default)(t,[{key:"componentDidMount",value:function(){this.props.autoWidth&&this.setWidth(),this.setScollPosition()}},{key:"componentWillReceiveProps",value:function(e){var t=void 0,n=this.getFilteredChildren(e.children);t=!0!==this.props.multiple?this.getLastSelectedIndex(e,n):this.state.focusIndex;var r=e.disableAutoFocus?-1:t>=0?t:0;r!==this.state.focusIndex&&this.props.onMenuItemFocusChange&&this.props.onMenuItemFocusChange(null,r),this.setState({focusIndex:r,keyWidth:e.desktop?64:56})}},{key:"shouldComponentUpdate",value:function(e,t,n){return!(0,M.default)(this.props,e)||!(0,M.default)(this.state,t)||!(0,M.default)(this.context,n)}},{key:"componentDidUpdate",value:function(){this.props.autoWidth&&this.setWidth()}},{key:"getValueLink",value:function(e){return e.valueLink||{value:e.value,requestChange:e.onChange}}},{key:"setKeyboardFocused",value:function(e){this.setState({isKeyboardFocused:e})}},{key:"getFilteredChildren",value:function(e){var t=[];return S.default.Children.forEach(e,function(e){e&&t.push(e)}),t}},{key:"cloneMenuItem",value:function(e,t,n,r){var o=this,i=e.props.disabled,a={};i||this.isChildSelected(e,this.props)&&(0,x.default)(a,n.selectedMenuItem,this.props.selectedMenuItemStyle);var u=(0,x.default)({},e.props.style,this.props.menuItemStyle,a),s={desktop:this.props.desktop,style:u};if(!i){var l=t===this.state.focusIndex,c="none";l&&(c=this.state.isKeyboardFocused?"keyboard-focused":"focused"),(0,x.default)(s,{focusState:c,onClick:function(t){o.handleMenuItemTouchTap(t,e,r),e.props.onClick&&e.props.onClick(t)},ref:l?"focusedMenuItem":null})}return S.default.cloneElement(e,s)}},{key:"decrementKeyboardFocusIndex",value:function(e){var t=this.state.focusIndex;t--,t<0&&(t=0),this.setFocusIndex(e,t,!0)}},{key:"getMenuItemCount",value:function(e){var t=0;return e.forEach(function(e){var n=e.type&&"Divider"===e.type.muiName,r=e.props.disabled;n||r||t++}),t}},{key:"getLastSelectedIndex",value:function(e,t){var n=this,r=-1,o=0;return t.forEach(function(t){var i=t.type&&"Divider"===t.type.muiName;n.isChildSelected(t,e)&&(r=o),i||o++}),r}},{key:"setFocusIndexStartsWith",value:function(e,t){var n=-1;return S.default.Children.forEach(this.props.children,function(e,r){if(!(n>=0)){var o=e.props.primaryText;"string"==typeof o&&o.substr(0,t.length).toLowerCase()===t.toLowerCase()&&(n=r)}}),n>=0&&(this.setFocusIndex(e,n,!0),!0)}},{key:"handleMenuItemTouchTap",value:function(e,t,n){var r=this.props.children,o=this.props.multiple,i=this.getValueLink(this.props),a=i.value,u=t.props.value,s=S.default.isValidElement(r)?0:r.indexOf(t);if(this.setFocusIndex(e,s,!1),o){a=a||[];var l=a.indexOf(u),f=a,d=(0,c.default)(f),p=d.slice(0);-1===l?p.push(u):p.splice(l,1),i.requestChange(e,p)}else o||u===a||i.requestChange(e,u);this.props.onItemTouchTap(e,t,n)}},{key:"incrementKeyboardFocusIndex",value:function(e,t){var n=this.state.focusIndex,r=this.getMenuItemCount(t)-1;n++,n>r&&(n=r),this.setFocusIndex(e,n,!0)}},{key:"isChildSelected",value:function(e,t){var n=this.getValueLink(t).value,r=e.props.value;return t.multiple?n&&n.length&&-1!==n.indexOf(r):e.props.hasOwnProperty("value")&&n===r}},{key:"setFocusIndex",value:function(e,t,n){this.props.onMenuItemFocusChange&&this.props.onMenuItemFocusChange(e,t),this.setState({focusIndex:t,isKeyboardFocused:n})}},{key:"setScollPosition",value:function(){var e=this.props.desktop,t=this.refs.focusedMenuItem,n=e?32:48;if(t){var r=k.default.findDOMNode(t).offsetTop,o=r-n;o<n&&(o=0),k.default.findDOMNode(this.refs.scrollContainer).scrollTop=o}}},{key:"cancelScrollEvent",value:function(e){return e.stopPropagation(),e.preventDefault(),!1}},{key:"setWidth",value:function(){var e=k.default.findDOMNode(this),t=k.default.findDOMNode(this.refs.list),n=e.offsetWidth,r=this.state.keyWidth,o=1.5*r,i=n/r,a=void 0;i=i<=1.5?1.5:Math.ceil(i),a=i*r,a<o&&(a=o),e.style.width=a+"px",t.style.width=a+"px"}},{key:"render",value:function(){var e=this,t=this.props,n=(t.autoWidth,t.children),r=(t.desktop,t.disableAutoFocus,t.initiallyKeyboardFocused,t.listStyle),i=(t.maxHeight,t.multiple,t.onItemTouchTap,t.onEscKeyDown,t.onMenuItemFocusChange,t.selectedMenuItemStyle,t.menuItemStyle,t.style),u=(t.value,t.valueLink,t.width,(0,s.default)(t,["autoWidth","children","desktop","disableAutoFocus","initiallyKeyboardFocused","listStyle","maxHeight","multiple","onItemTouchTap","onEscKeyDown","onMenuItemFocusChange","selectedMenuItemStyle","menuItemStyle","style","value","valueLink","width"])),l=this.context.muiTheme.prepareStyles,c=o(this.props,this.context),f=(0,x.default)(c.root,i),d=(0,x.default)(c.list,r),p=this.getFilteredChildren(n),h=0,y=S.default.Children.map(p,function(t,n){var r=t.props.disabled,o=t.type?t.type.muiName:"",i=t;switch(o){case"MenuItem":i=e.cloneMenuItem(t,h,c,n);break;case"Divider":i=S.default.cloneElement(t,{style:(0,x.default)({},c.divider,t.props.style)})}return"MenuItem"!==o||r||h++,i});return S.default.createElement(N.default,{onClickAway:this.handleClickAway},S.default.createElement("div",{onKeyDown:this.handleKeyDown,onWheel:this.handleOnWheel,style:l(f),ref:"scrollContainer",role:"presentation"},S.default.createElement(D.default,(0,a.default)({},u,{ref:"list",style:d,role:"menu"}),y)))}}]),t}(O.Component);z.defaultProps={autoWidth:!0,desktop:!1,disableAutoFocus:!1,initiallyKeyboardFocused:!1,maxHeight:null,multiple:!1,onChange:function(){},onEscKeyDown:function(){},onItemTouchTap:function(){},onKeyDown:function(){}},z.contextTypes={muiTheme:E.default.object.isRequired};var V=function(){var e=this;this.handleClickAway=function(t){if(!t.defaultPrevented){var n=e.state.focusIndex;if(!(n<0)){var r=e.getFilteredChildren(e.props.children),o=r[n];o.props.menuItems&&o.props.menuItems.length>0||e.setFocusIndex(t,-1,!1)}}},this.handleKeyDown=function(t){var n=e.getFilteredChildren(e.props.children),r=(0,A.default)(t);switch(r){case"down":t.preventDefault(),e.incrementKeyboardFocusIndex(t,n);break;case"esc":e.props.onEscKeyDown(t);break;case"tab":t.preventDefault(),t.shiftKey?e.decrementKeyboardFocusIndex(t):e.incrementKeyboardFocusIndex(t,n);break;case"up":t.preventDefault(),e.decrementKeyboardFocusIndex(t);break;default:if(r&&1===r.length){var o=e.hotKeyHolder.append(r);e.setFocusIndexStartsWith(t,o)&&t.preventDefault()}}e.props.onKeyDown(t)},this.handleOnWheel=function(t){var n=e.refs.scrollContainer;if(!(n.scrollHeight<=n.clientHeight)){var r=n.scrollTop,o=n.scrollHeight,i=n.clientHeight,a=t.deltaY,u=a>0;return u&&a>o-i-r?(n.scrollTop=o,e.cancelScrollEvent(t)):!u&&-a>r?(n.scrollTop=0,e.cancelScrollEvent(t)):void 0}}};z.propTypes={},t.default=z},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(142),T=r(S),E=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"render",value:function(){var e=this.props,t=e.children,n=e.style,r=(0,u.default)(e,["children","style"]),o=this.context.muiTheme.prepareStyles,a=!1,s=_.Children.toArray(t)[0];(0,_.isValidElement)(s)&&s.type===T.default&&(a=!0);var l={root:{padding:(a?0:8)+"px 0px 8px 0px"}};return w.default.createElement("div",(0,i.default)({},r,{style:o((0,g.default)(l.root,n))}),t)}}]),t}(_.Component);E.contextTypes={muiTheme:O.default.object.isRequired},E.propTypes={},t.default=E},function(e,t,n){"use strict";t.__esModule=!0;var r=n(649),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(e){return(0,o.default)("displayName",e)};t.default=i},function(e,t,n){"use strict";t.__esModule=!0;var r=n(650),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(e,t){return t+"("+(0,o.default)(e)+")"};t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.cachedAccessTypeToString=function(e,t){return e?t?"rw------":"r-------":"--------"},t.transformAccessObject=function(e,t){return{id:e.id,name:e.name,displayName:e.displayName,type:t,canView:e.access&&e.access.includes("r"),canEdit:e.access&&e.access.includes("rw")}},t.accessStringToObject=function(e){if(!e)return{data:{canView:!1,canEdit:!1},meta:{canView:!1,canEdit:!1}};var t=e.substring(0,2),n=e.substring(2,4);return{meta:{canView:t.includes("r"),canEdit:t.includes("rw")},data:{canView:n.includes("r"),canEdit:n.includes("rw")}}},t.accessObjectToString=function(e){var t=function(e){var t=e.canEdit,n=e.canView;return t?"rw":n?"r-":"--"},n="";return n+=t(e.meta),n+=t(e.data),n+="----"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=n(3),l=r(s),c=n(1),f=r(c),d=n(118),p=r(d),h=n(98),y=r(h),v=n(661),m=r(v),b=n(245),g=r(b),_=n(119),w=r(_),x=n(706),O=r(x),S={optionHeader:{paddingLeft:16,paddingTop:16,fontWeight:"400",color:"gray"}},T=function(e){return e.canEdit?"Create":e.canView?"Visibility":"NotInterested"},E=function(e){function t(e,n){o(this,t);var r=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={open:!1},r.onOptionClick=function(e,t){var n=u({},r.props.access,t.props.value);r.props.onChange(n)},r.openMenu=function(e){e.preventDefault(),r.setState({open:!0,anchor:e.currentTarget})},r.closeMenu=function(){r.setState({open:!1})},r.translate=function(e){return r.context.d2.i18n.getTranslation(e)},r.render=function(){var e=r.props.access,t=e.data,n=e.meta,o=r.props.accessOptions,i=o.data,a=o.meta;return f.default.createElement("div",null,f.default.createElement(p.default,{onClick:r.openMenu,disabled:r.props.disabled},f.default.createElement(w.default,{icon:T(n)})),f.default.createElement(m.default,{open:r.state.open,anchorEl:r.state.anchor,onRequestClose:r.closeMenu},f.default.createElement(C,{text:r.translate("metadata")}),f.default.createElement(g.default,{onItemTouchTap:r.onOptionClick},f.default.createElement(O.default,{disabled:!a.canEdit,value:{meta:{canView:!0,canEdit:!0}},primaryText:r.translate("can_edit_and_view"),isSelected:n.canEdit}),f.default.createElement(O.default,{disabled:!a.canView,value:{meta:{canView:!0,canEdit:!1}},primaryText:r.translate("can_view_only"),isSelected:!n.canEdit&&n.canView}),f.default.createElement(O.default,{disabled:!a.noAccess,value:{meta:{canView:!1,canEdit:!1}},primaryText:r.translate("no_access"),isSelected:!n.canEdit&&!n.canView})),f.default.createElement(y.default,null),i&&f.default.createElement("div",null,f.default.createElement(C,{text:r.translate("data")}),f.default.createElement(g.default,{onItemTouchTap:r.onOptionClick},f.default.createElement(O.default,{disabled:!i.canEdit,value:{data:{canView:!0,canEdit:!0}},primaryText:r.translate("can_capture_data"),isSelected:t.canEdit}),f.default.createElement(O.default,{disabled:!i.canView,value:{data:{canView:!0,canEdit:!1}},primaryText:r.translate("can_view_data"),isSelected:!t.canEdit&&t.canView}),f.default.createElement(O.default,{disabled:!i.noAccess,value:{data:{canView:!1,canEdit:!1}},primaryText:r.translate("no_access"),isSelected:!t.canEdit&&!t.canView})))))},n.d2.i18n.addStrings(["can_edit_and_view","can_capture_data","can_view_data","can_view_only","no_access"]),r}return a(t,e),t}(c.Component);E.propTypes={access:l.default.object.isRequired,accessOptions:l.default.object.isRequired,onChange:l.default.func.isRequired,disabled:l.default.bool},E.defaultProps={disabled:!1},E.contextTypes={d2:l.default.object.isRequired};var C=function(e){var t=e.text;return f.default.createElement("div",{style:S.optionHeader},t.toUpperCase())};C.propTypes={text:l.default.string.isRequired},t.default=E},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(253),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(254),c=r(l),f=n(136),d=r(f),p=n(329),h=r(p),y=n(3),v=r(y),m=n(1),b=r(m),g=n(334),_=r(g),w=n(715),x=r(w),O={loadingMask:{position:"relative"}},S={api:null,sharedObject:null,errorMessage:""},T=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state=u({},S,{dataShareableTypes:[]}),n.onSearchRequest=function(e){return n.state.api.get("sharing/search",{key:e}).then(function(e){return e})},n.onSharingChanged=function(e,t){var r={meta:n.state.sharedObject.meta,object:u({},n.state.sharedObject.object,e)};n.postChanges(r,t)},n.createPropsChecker=function(e){return function(t){return e[t]!==n.props[t]}},n.postChanges=function(e,t){var r="sharing?type="+n.props.type+"&id="+n.props.id;return n.state.api.post(r,e).then(function(r){var o=r.httpStatus,i=r.message;return"OK"===o&&n.setState({sharedObject:e},function(){t&&t()}),i}).catch(function(e){var t=e.message;n.setState({errorMessage:t})})},n.resetState=function(){n.setState(S)},n.loadDataSharingSettings=function(){n.props.d2.Api.getApi().get("schemas",{fields:["name","dataShareable"]}).then(function(e){var t=e.schemas.filter(function(e){return e.dataShareable}).map(function(e){return e.name});n.setState({dataShareableTypes:t})})},n.loadObjectFromApi=function(){var e=n.props.d2.Api.getApi(),t=n.props,r=t.type,o=t.id;e.get("sharing",{type:r,id:o}).then(function(t){n.setState({api:e,sharedObject:t})}).catch(function(e){n.setState({errorMessage:e.message})})},n.closeSharingDialog=function(){n.props.onRequestClose(n.state.sharedObject.object)},e.d2?e.d2.i18n.addStrings(["share","close","no_manage_access"]):console.error("no d2"),n}return a(t,e),s(t,[{key:"getChildContext",value:function(){return{d2:this.props.d2}}},{key:"componentDidMount",value:function(){this.loadDataSharingSettings(),this.props.open&&this.props.type&&this.props.id&&this.loadObjectFromApi()}},{key:"componentWillReceiveProps",value:function(e){var t=this.createPropsChecker(e);(t("id")||t("type"))&&(this.resetState(),e.open&&this.loadObjectFromApi()),!this.props.open&&e.open&&this.loadObjectFromApi()}},{key:"render",value:function(){var e=-1!==this.state.dataShareableTypes.indexOf(this.props.type),t=""!==this.state.errorMessage,n=!this.state.sharedObject&&this.props.open&&!t,r=[b.default.createElement(d.default,{label:this.props.d2.i18n.getTranslation("close"),onClick:this.closeSharingDialog})];return b.default.createElement("div",null,b.default.createElement(h.default,{open:t,message:this.state.errorMessage,autoHideDuration:3e3}),n&&b.default.createElement(x.default,{style:O.loadingMask,size:1}),this.state.sharedObject&&b.default.createElement(c.default,u({autoDetectWindowHeight:!0,autoScrollBodyContent:!0,open:this.props.open,title:this.props.d2.i18n.getTranslation("share"),actions:r,onRequestClose:this.closeSharingDialog},this.props),b.default.createElement(_.default,{sharedObject:this.state.sharedObject,dataShareable:e,onChange:this.onSharingChanged,onSearch:this.onSearchRequest})))}}]),t}(b.default.Component);T.childContextTypes={d2:v.default.object},T.propTypes={open:v.default.bool.isRequired,onRequestClose:v.default.func.isRequired,type:v.default.string.isRequired,id:v.default.string.isRequired,d2:v.default.object.isRequired},t.default=T},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.autoScrollBodyContent,r=e.open,o=t.muiTheme,i=o.baseTheme,a=i.spacing,u=i.palette,s=o.dialog,l=o.zIndex,c=a.desktopGutter,f="1px solid "+u.borderColor;return{root:{position:"fixed",boxSizing:"border-box",WebkitTapHighlightColor:"rgba(0,0,0,0)",zIndex:l.dialog,top:0,left:r?0:-1e4,width:"100%",height:"100%",transition:r?N.default.easeOut("0ms","left","0ms"):N.default.easeOut("0ms","left","450ms")},content:{boxSizing:"border-box",WebkitTapHighlightColor:"rgba(0,0,0,0)",transition:N.default.easeOut(),position:"relative",width:"75%",maxWidth:12*a.desktopKeylineIncrement,margin:"0 auto",zIndex:l.dialog},actionsContainer:{boxSizing:"border-box",WebkitTapHighlightColor:"rgba(0,0,0,0)",padding:8,width:"100%",textAlign:"right",marginTop:n?-1:0},overlay:{zIndex:l.dialogOverlay},title:{margin:0,padding:c+"px "+c+"px 20px "+c+"px",color:u.textColor,fontSize:s.titleFontSize,lineHeight:"32px",fontWeight:400,marginBottom:n?-1:0},body:{fontSize:s.bodyFontSize,color:s.bodyColor,padding:(e.title?0:c)+"px "+c+"px "+c+"px",boxSizing:"border-box",overflowY:n?"auto":"hidden",borderTop:n?f:"none",borderBottom:n?f:"none"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(23),E=r(T),C=n(62),k=r(C),P=n(64),M=r(P),j=n(17),N=r(j),I=n(309),A=r(I),R=n(134),F=r(R),D=n(65),L=r(D),z=n(96),V=r(z),U=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={style:{}},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillUnmount",value:function(){clearTimeout(this.enterTimeout),clearTimeout(this.leaveTimeout)}},{key:"componentWillEnter",value:function(e){this.componentWillAppear(e)}},{key:"componentWillAppear",value:function(e){var t=this.context.muiTheme.baseTheme.spacing;this.setState({style:{opacity:1,transform:"translate(0, "+t.desktopKeylineIncrement+"px)"}}),this.enterTimeout=setTimeout(e,450)}},{key:"componentWillLeave",value:function(e){this.setState({style:{opacity:0,transform:"translate(0, 0)"}}),this.leaveTimeout=setTimeout(e,450)}},{key:"render",value:function(){var e=this.props,t=e.style,n=e.children,r=(0,s.default)(e,["style","children"]),o=this.context.muiTheme.prepareStyles;return x.default.createElement("div",(0,a.default)({},r,{style:o((0,_.default)({},this.state.style,t))}),n)}}]),t}(w.Component);U.contextTypes={muiTheme:S.default.object.isRequired},U.propTypes={};var W=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.handleTouchTapOverlay=function(){r.requestClose(!1)},r.handleKeyUp=function(e){"esc"===(0,M.default)(e)&&r.requestClose(!1)},r.handleResize=function(){r.positionDialog()},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentDidMount",value:function(){this.positionDialog()}},{key:"componentDidUpdate",value:function(){this.positionDialog()}},{key:"positionDialog",value:function(){var e=this.props,t=e.actions,n=e.autoDetectWindowHeight,r=e.autoScrollBodyContent,i=e.bodyStyle,a=e.open,u=e.repositionOnUpdate,s=e.title;if(a){var l=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,c=E.default.findDOMNode(this),f=E.default.findDOMNode(this.refs.dialogWindow),d=E.default.findDOMNode(this.refs.dialogContent);f.style.height="",d.style.height="";var p=f.offsetHeight,h=(l-p)/2-64;if(h<16&&(h=16),!u&&c.style.paddingTop||(c.style.paddingTop=h+"px"),n||r){var y=o(this.props,this.context);y.body=(0,_.default)(y.body,i);var v=l-128;s&&(v-=d.previousSibling.offsetHeight),x.default.Children.count(t)&&(v-=d.nextSibling.offsetHeight),d.style.maxHeight=v+"px",v>p&&(d.style.borderBottom="none",d.style.borderTop="none")}}}},{key:"requestClose",value:function(e){!e&&this.props.modal||this.props.onRequestClose&&this.props.onRequestClose(!!e)}},{key:"render",value:function(){var e=this.props,t=e.actions,n=e.actionsContainerClassName,r=e.actionsContainerStyle,i=e.bodyClassName,u=e.bodyStyle,s=e.children,l=e.className,c=e.contentClassName,f=e.contentStyle,d=e.overlayClassName,p=e.overlayStyle,h=e.open,y=e.paperClassName,v=e.paperProps,m=e.style,b=e.titleClassName,g=e.titleStyle,w=e.title,O=this.context.muiTheme.prepareStyles,S=o(this.props,this.context);S.root=(0,_.default)(S.root,m),S.content=(0,_.default)(S.content,f),S.body=(0,_.default)(S.body,u),S.actionsContainer=(0,_.default)(S.actionsContainer,r),S.overlay=(0,_.default)(S.overlay,p),S.title=(0,_.default)(S.title,g);var T=x.default.Children.count(t)>0&&x.default.createElement("div",{className:n,style:O(S.actionsContainer)},x.default.Children.toArray(t)),E=w;return x.default.isValidElement(w)?E=x.default.cloneElement(w,{className:w.props.className||b,style:O((0,_.default)(S.title,w.props.style))}):"string"==typeof w&&(E=x.default.createElement("h3",{className:b,style:O(S.title)},w)),x.default.createElement("div",{className:l,style:O(S.root)},h&&x.default.createElement(k.default,{target:"window",onKeyUp:this.handleKeyUp,onResize:this.handleResize}),x.default.createElement(V.default,{component:"div",ref:"dialogWindow",transitionAppear:!0,transitionAppearTimeout:450,transitionEnter:!0,transitionEnterTimeout:450},h&&x.default.createElement(U,{className:c,style:S.content},x.default.createElement(L.default,(0,a.default)({className:y,zDepth:4},v),E,x.default.createElement("div",{ref:"dialogContent",className:i,style:O(S.body)},s),T))),x.default.createElement(A.default,{show:h,className:d,style:S.overlay,onClick:this.handleTouchTapOverlay}))}}]),t}(w.Component);W.contextTypes={muiTheme:S.default.object.isRequired},W.propTypes={};var H=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.renderLayer=function(){return x.default.createElement(W,r.props)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"render",value:function(){return x.default.createElement(F.default,{render:this.renderLayer,open:!0,useLayerForClickAway:!1})}}]),t}(w.Component);H.contextTypes={muiTheme:S.default.object.isRequired},H.defaultProps={autoDetectWindowHeight:!0,autoScrollBodyContent:!1,modal:!1,repositionOnUpdate:!0},H.propTypes={},t.default=H},function(e,t,n){n(256),e.exports=n(24).Object.assign},function(e,t,n){var r=n(28);r(r.S+r.F,"Object",{assign:n(258)})},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(44),o=n(89),i=n(59),a=n(45),u=n(124),s=Object.assign;e.exports=!s||n(41)(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e}),7!=s({},e)[n]||Object.keys(s({},t)).join("")!=r})?function(e,t){for(var n=a(e),s=arguments.length,l=1,c=o.f,f=i.f;s>l;)for(var d,p=u(arguments[l++]),h=c?r(p).concat(c(p)):r(p),y=h.length,v=0;y>v;)f.call(p,d=h[v++])&&(n[d]=p[d]);return n}:s},function(e,t,n){var r=n(42),o=n(125),i=n(260);e.exports=function(e){return function(t,n,a){var u,s=r(t),l=o(s.length),c=i(a,l);if(e&&n!=n){for(;l>c;)if((u=s[c++])!=u)return!0}else for(;l>c;c++)if((e||c in s)&&s[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(85),o=Math.max,i=Math.min;e.exports=function(e,t){return e=r(e),e<0?o(e+t,0):i(e,t)}},function(e,t,n){n(262),e.exports=n(24).Object.getPrototypeOf},function(e,t,n){var r=n(45),o=n(126);n(127)("getPrototypeOf",function(){return function(e){return o(r(e))}})},function(e,t,n){n(264);var r=n(24).Object;e.exports=function(e,t,n){return r.defineProperty(e,t,n)}},function(e,t,n){var r=n(28);r(r.S+r.F*!n(34),"Object",{defineProperty:n(30).f})},function(e,t,n){e.exports={default:n(266),__esModule:!0}},function(e,t,n){n(129),n(271),e.exports=n(93).f("iterator")},function(e,t,n){var r=n(85),o=n(84);e.exports=function(e){return function(t,n){var i,a,u=String(o(t)),s=r(n),l=u.length;return s<0||s>=l?e?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===l||(a=u.charCodeAt(s+1))<56320||a>57343?e?u.charAt(s):i:e?u.slice(s,s+2):a-56320+(i-55296<<10)+65536)}}},function(e,t,n){"use strict";var r=n(91),o=n(43),i=n(92),a={};n(38)(a,n(26)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:o(1,n)}),i(e,t+" Iterator")}},function(e,t,n){var r=n(30),o=n(39),i=n(44);e.exports=n(34)?Object.defineProperties:function(e,t){o(e);for(var n,a=i(t),u=a.length,s=0;u>s;)r.f(e,n=a[s++],t[n]);return e}},function(e,t,n){var r=n(29).document;e.exports=r&&r.documentElement},function(e,t,n){n(272);for(var r=n(29),o=n(38),i=n(46),a=n(26)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<u.length;s++){var l=u[s],c=r[l],f=c&&c.prototype;f&&!f[a]&&o(f,a,l),i[l]=i.Array}},function(e,t,n){"use strict";var r=n(273),o=n(274),i=n(46),a=n(42);e.exports=n(130)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,o(1)):"keys"==t?o(0,n):"values"==t?o(0,e[n]):o(0,[n,e[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(276),__esModule:!0}},function(e,t,n){n(277),n(282),n(283),n(284),e.exports=n(24).Symbol},function(e,t,n){"use strict";var r=n(29),o=n(35),i=n(34),a=n(28),u=n(131),s=n(278).KEY,l=n(41),c=n(87),f=n(92),d=n(58),p=n(26),h=n(93),y=n(94),v=n(279),m=n(280),b=n(39),g=n(40),_=n(42),w=n(82),x=n(43),O=n(91),S=n(281),T=n(133),E=n(30),C=n(44),k=T.f,P=E.f,M=S.f,j=r.Symbol,N=r.JSON,I=N&&N.stringify,A=p("_hidden"),R=p("toPrimitive"),F={}.propertyIsEnumerable,D=c("symbol-registry"),L=c("symbols"),z=c("op-symbols"),V=Object.prototype,U="function"==typeof j,W=r.QObject,H=!W||!W.prototype||!W.prototype.findChild,B=i&&l(function(){return 7!=O(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=k(V,t);r&&delete V[t],P(e,t,n),r&&e!==V&&P(V,t,r)}:P,K=function(e){var t=L[e]=O(j.prototype);return t._k=e,t},q=U&&"symbol"==typeof j.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof j},G=function(e,t,n){return e===V&&G(z,t,n),b(e),t=w(t,!0),b(n),o(L,t)?(n.enumerable?(o(e,A)&&e[A][t]&&(e[A][t]=!1),n=O(n,{enumerable:x(0,!1)})):(o(e,A)||P(e,A,x(1,{})),e[A][t]=!0),B(e,t,n)):P(e,t,n)},Y=function(e,t){b(e);for(var n,r=v(t=_(t)),o=0,i=r.length;i>o;)G(e,n=r[o++],t[n]);return e},X=function(e,t){return void 0===t?O(e):Y(O(e),t)},$=function(e){var t=F.call(this,e=w(e,!0));return!(this===V&&o(L,e)&&!o(z,e))&&(!(t||!o(this,e)||!o(L,e)||o(this,A)&&this[A][e])||t)},Q=function(e,t){if(e=_(e),t=w(t,!0),e!==V||!o(L,t)||o(z,t)){var n=k(e,t);return!n||!o(L,t)||o(e,A)&&e[A][t]||(n.enumerable=!0),n}},J=function(e){for(var t,n=M(_(e)),r=[],i=0;n.length>i;)o(L,t=n[i++])||t==A||t==s||r.push(t);return r},Z=function(e){for(var t,n=e===V,r=M(n?z:_(e)),i=[],a=0;r.length>a;)!o(L,t=r[a++])||n&&!o(V,t)||i.push(L[t]);return i};U||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===V&&t.call(z,n),o(this,A)&&o(this[A],e)&&(this[A][e]=!1),B(this,e,x(1,n))};return i&&H&&B(V,e,{configurable:!0,set:t}),K(e)},u(j.prototype,"toString",function(){return this._k}),T.f=Q,E.f=G,n(132).f=S.f=J,n(59).f=$,n(89).f=Z,i&&!n(90)&&u(V,"propertyIsEnumerable",$,!0),h.f=function(e){return K(p(e))}),a(a.G+a.W+a.F*!U,{Symbol:j});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ne=C(p.store),re=0;ne.length>re;)y(ne[re++]);a(a.S+a.F*!U,"Symbol",{for:function(e){return o(D,e+="")?D[e]:D[e]=j(e)},keyFor:function(e){if(!q(e))throw TypeError(e+" is not a symbol!");for(var t in D)if(D[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),a(a.S+a.F*!U,"Object",{create:X,defineProperty:G,defineProperties:Y,getOwnPropertyDescriptor:Q,getOwnPropertyNames:J,getOwnPropertySymbols:Z}),N&&a(a.S+a.F*(!U||l(function(){var e=j();return"[null]"!=I([e])||"{}"!=I({a:e})||"{}"!=I(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=t=r[1],(g(t)||void 0!==e)&&!q(e))return m(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!q(t))return t}),r[1]=t,I.apply(N,r)}}),j.prototype[R]||n(38)(j.prototype,R,j.prototype.valueOf),f(j,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(58)("meta"),o=n(40),i=n(35),a=n(30).f,u=0,s=Object.isExtensible||function(){return!0},l=!n(41)(function(){return s(Object.preventExtensions({}))}),c=function(e){a(e,r,{value:{i:"O"+ ++u,w:{}}})},f=function(e,t){if(!o(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!i(e,r)){if(!s(e))return"F";if(!t)return"E";c(e)}return e[r].i},d=function(e,t){if(!i(e,r)){if(!s(e))return!0;if(!t)return!1;c(e)}return e[r].w},p=function(e){return l&&h.NEED&&s(e)&&!i(e,r)&&c(e),e},h=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(e,t,n){var r=n(44),o=n(89),i=n(59);e.exports=function(e){var t=r(e),n=o.f;if(n)for(var a,u=n(e),s=i.f,l=0;u.length>l;)s.call(e,a=u[l++])&&t.push(a);return t}},function(e,t,n){var r=n(83);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(42),o=n(132).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(e){try{return o(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==i.call(e)?u(e):o(r(e))}},function(e,t){},function(e,t,n){n(94)("asyncIterator")},function(e,t,n){n(94)("observable")},function(e,t,n){e.exports={default:n(286),__esModule:!0}},function(e,t,n){n(287),e.exports=n(24).Object.setPrototypeOf},function(e,t,n){var r=n(28);r(r.S,"Object",{setPrototypeOf:n(288).set})},function(e,t,n){var r=n(40),o=n(39),i=function(e,t){if(o(e),!r(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n(81)(Function.call,n(133).f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return i(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:i}},function(e,t,n){e.exports={default:n(290),__esModule:!0}},function(e,t,n){n(291);var r=n(24).Object;e.exports=function(e,t){return r.create(e,t)}},function(e,t,n){var r=n(28);r(r.S,"Object",{create:n(91)})},function(e,t,n){"use strict";var r=n(95),o=n(293),i=n(294);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";function r(e,t,n,r,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,i,a,u,s],f=0;l=new Error(t.replace(/%s/g,function(){return c[f++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function r(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);throw t=Error(n+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."),t.name="Invariant Violation",t.framesToPop=1,t}function o(e,t){return(e&t)===t}function i(e,t){if(Pn.hasOwnProperty(e)||2<e.length&&("o"===e[0]||"O"===e[0])&&("n"===e[1]||"N"===e[1]))return!1;if(null===t)return!0;switch(typeof t){case"boolean":return Pn.hasOwnProperty(e)?e=!0:(t=a(e))?e=t.hasBooleanValue||t.hasStringBooleanValue||t.hasOverloadedBooleanValue:(e=e.toLowerCase().slice(0,5),e="data-"===e||"aria-"===e),e;case"undefined":case"number":case"string":case"object":return!0;default:return!1}}function a(e){return jn.hasOwnProperty(e)?jn[e]:null}function u(e){return e[1].toUpperCase()}function s(e,t,n,r,o,i,a,u,s){Bn._hasCaughtError=!1,Bn._caughtError=null;var l=Array.prototype.slice.call(arguments,3);try{t.apply(n,l)}catch(e){Bn._caughtError=e,Bn._hasCaughtError=!0}}function l(){if(Bn._hasRethrowError){var e=Bn._rethrowError;throw Bn._rethrowError=null,Bn._hasRethrowError=!1,e}}function c(){if(Kn)for(var e in qn){var t=qn[e],n=Kn.indexOf(e);if(-1<n||r("96",e),!Gn[n]){t.extractEvents||r("97",e),Gn[n]=t,n=t.eventTypes;for(var o in n){var i=void 0,a=n[o],u=t,s=o;Yn.hasOwnProperty(s)&&r("99",s),Yn[s]=a;var l=a.phasedRegistrationNames;if(l){for(i in l)l.hasOwnProperty(i)&&f(l[i],u,s);i=!0}else a.registrationName?(f(a.registrationName,u,s),i=!0):i=!1;i||r("98",o,e)}}}}function f(e,t,n){Xn[e]&&r("100",e),Xn[e]=t,$n[e]=t.eventTypes[n].dependencies}function d(e){Kn&&r("101"),Kn=Array.prototype.slice.call(e),c()}function p(e){var t,n=!1;for(t in e)if(e.hasOwnProperty(t)){var o=e[t];qn.hasOwnProperty(t)&&qn[t]===o||(qn[t]&&r("102",t),qn[t]=o,n=!0)}n&&c()}function h(e,t,n,r){t=e.type||"unknown-event",e.currentTarget=er(r),Bn.invokeGuardedCallbackAndCatchFirstError(t,n,void 0,e),e.currentTarget=null}function y(e,t){return null==t&&r("30"),null==e?t:Array.isArray(e)?Array.isArray(t)?(e.push.apply(e,t),e):(e.push(t),e):Array.isArray(t)?[e].concat(t):[e,t]}function v(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)}function m(e,t){if(e){var n=e._dispatchListeners,r=e._dispatchInstances;if(Array.isArray(n))for(var o=0;o<n.length&&!e.isPropagationStopped();o++)h(e,t,n[o],r[o]);else n&&h(e,t,n,r);e._dispatchListeners=null,e._dispatchInstances=null,e.isPersistent()||e.constructor.release(e)}}function b(e){return m(e,!0)}function g(e){return m(e,!1)}function _(e,t){var n=e.stateNode;if(!n)return null;var o=Jn(n);if(!o)return null;n=o[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":(o=!o.disabled)||(e=e.type,o=!("button"===e||"input"===e||"select"===e||"textarea"===e)),e=!o;break e;default:e=!1}return e?null:(n&&"function"!=typeof n&&r("231",t,typeof n),n)}function w(e,t,n,r){for(var o,i=0;i<Gn.length;i++){var a=Gn[i];a&&(a=a.extractEvents(e,t,n,r))&&(o=y(o,a))}return o}function x(e){e&&(tr=y(tr,e))}function O(e){var t=tr;tr=null,t&&(e?v(t,b):v(t,g),tr&&r("95"),Bn.rethrowCaughtError())}function S(e){if(e[ir])return e[ir];for(var t=[];!e[ir];){if(t.push(e),!e.parentNode)return null;e=e.parentNode}var n=void 0,r=e[ir];if(5===r.tag||6===r.tag)return r;for(;e&&(r=e[ir]);e=t.pop())n=r;return n}function T(e){if(5===e.tag||6===e.tag)return e.stateNode;r("33")}function E(e){return e[ar]||null}function C(e){do{e=e.return}while(e&&5!==e.tag);return e||null}function k(e,t,n){for(var r=[];e;)r.push(e),e=C(e);for(e=r.length;0<e--;)t(r[e],"captured",n);for(e=0;e<r.length;e++)t(r[e],"bubbled",n)}function P(e,t,n){(t=_(e,n.dispatchConfig.phasedRegistrationNames[t]))&&(n._dispatchListeners=y(n._dispatchListeners,t),n._dispatchInstances=y(n._dispatchInstances,e))}function M(e){e&&e.dispatchConfig.phasedRegistrationNames&&k(e._targetInst,P,e)}function j(e){if(e&&e.dispatchConfig.phasedRegistrationNames){var t=e._targetInst;t=t?C(t):null,k(t,P,e)}}function N(e,t,n){e&&n&&n.dispatchConfig.registrationName&&(t=_(e,n.dispatchConfig.registrationName))&&(n._dispatchListeners=y(n._dispatchListeners,t),n._dispatchInstances=y(n._dispatchInstances,e))}function I(e){e&&e.dispatchConfig.registrationName&&N(e._targetInst,null,e)}function A(e){v(e,M)}function R(e,t,n,r){if(n&&r)e:{for(var o=n,i=r,a=0,u=o;u;u=C(u))a++;u=0;for(var s=i;s;s=C(s))u++;for(;0<a-u;)o=C(o),a--;for(;0<u-a;)i=C(i),u--;for(;a--;){if(o===i||o===i.alternate)break e;o=C(o),i=C(i)}o=null}else o=null;for(i=o,o=[];n&&n!==i&&(null===(a=n.alternate)||a!==i);)o.push(n),n=C(n);for(n=[];r&&r!==i&&(null===(a=r.alternate)||a!==i);)n.push(r),r=C(r);for(r=0;r<o.length;r++)N(o[r],"bubbled",e);for(e=n.length;0<e--;)N(n[e],"captured",t)}function F(){return!lr&&_n.canUseDOM&&(lr="textContent"in document.documentElement?"textContent":"innerText"),lr}function D(){if(cr._fallbackText)return cr._fallbackText;var e,t,n=cr._startText,r=n.length,o=L(),i=o.length;for(e=0;e<r&&n[e]===o[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===o[i-t];t++);return cr._fallbackText=o.slice(e,1<t?1-t:void 0),cr._fallbackText}function L(){return"value"in cr._root?cr._root.value:cr._root[F()]}function z(e,t,n,r){this.dispatchConfig=e,this._targetInst=t,this.nativeEvent=n,e=this.constructor.Interface;for(var o in e)e.hasOwnProperty(o)&&((t=e[o])?this[o]=t(n):"target"===o?this.target=r:this[o]=n[o]);return this.isDefaultPrevented=(null!=n.defaultPrevented?n.defaultPrevented:!1===n.returnValue)?xn.thatReturnsTrue:xn.thatReturnsFalse,this.isPropagationStopped=xn.thatReturnsFalse,this}function V(e,t,n,r){if(this.eventPool.length){var o=this.eventPool.pop();return this.call(o,e,t,n,r),o}return new this(e,t,n,r)}function U(e){e instanceof this||r("223"),e.destructor(),10>this.eventPool.length&&this.eventPool.push(e)}function W(e){e.eventPool=[],e.getPooled=V,e.release=U}function H(e,t,n,r){return z.call(this,e,t,n,r)}function B(e,t,n,r){return z.call(this,e,t,n,r)}function K(e,t){switch(e){case"topKeyUp":return-1!==pr.indexOf(t.keyCode);case"topKeyDown":return 229!==t.keyCode;case"topKeyPress":case"topMouseDown":case"topBlur":return!0;default:return!1}}function q(e){return e=e.detail,"object"==typeof e&&"data"in e?e.data:null}function G(e,t){switch(e){case"topCompositionEnd":return q(t);case"topKeyPress":return 32!==t.which?null:(Or=!0,wr);case"topTextInput":return e=t.data,e===wr&&Or?null:e;default:return null}}function Y(e,t){if(Sr)return"topCompositionEnd"===e||!hr&&K(e,t)?(e=D(),cr._root=null,cr._startText=null,cr._fallbackText=null,Sr=!1,e):null;switch(e){case"topPaste":return null;case"topKeyPress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"topCompositionEnd":return _r?null:t.data;default:return null}}function X(e){if(e=Zn(e)){Er&&"function"==typeof Er.restoreControlledState||r("194");var t=Jn(e.stateNode);Er.restoreControlledState(e.stateNode,e.type,t)}}function $(e){Cr?kr?kr.push(e):kr=[e]:Cr=e}function Q(){if(Cr){var e=Cr,t=kr;if(kr=Cr=null,X(e),t)for(e=0;e<t.length;e++)X(t[e])}}function J(e,t){return e(t)}function Z(e,t){if(jr)return J(e,t);jr=!0;try{return J(e,t)}finally{jr=!1,Q()}}function ee(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!Nr[e.type]:"textarea"===t}function te(e){return e=e.target||e.srcElement||window,e.correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}function ne(e,t){if(!_n.canUseDOM||t&&!("addEventListener"in document))return!1;t="on"+e;var n=t in document;return n||(n=document.createElement("div"),n.setAttribute(t,"return;"),n="function"==typeof n[t]),!n&&br&&"wheel"===e&&(n=document.implementation.hasFeature("Events.wheel","3.0")),n}function re(e){var t=e.type;return(e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function oe(e){var t=re(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),r=""+e[t];if(!e.hasOwnProperty(t)&&"function"==typeof n.get&&"function"==typeof n.set)return Object.defineProperty(e,t,{enumerable:n.enumerable,configurable:!0,get:function(){return n.get.call(this)},set:function(e){r=""+e,n.set.call(this,e)}}),{getValue:function(){return r},setValue:function(e){r=""+e},stopTracking:function(){e._valueTracker=null,delete e[t]}}}function ie(e){e._valueTracker||(e._valueTracker=oe(e))}function ae(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var n=t.getValue(),r="";return e&&(r=re(e)?e.checked?"true":"false":e.value),(e=r)!==n&&(t.setValue(e),!0)}function ue(e,t,n){return e=z.getPooled(Ir.change,e,t,n),e.type="change",$(n),A(e),e}function se(e){x(e),O(!1)}function le(e){if(ae(T(e)))return e}function ce(e,t){if("topChange"===e)return t}function fe(){Ar&&(Ar.detachEvent("onpropertychange",de),Rr=Ar=null)}function de(e){"value"===e.propertyName&&le(Rr)&&(e=ue(Rr,e,te(e)),Z(se,e))}function pe(e,t,n){"topFocus"===e?(fe(),Ar=t,Rr=n,Ar.attachEvent("onpropertychange",de)):"topBlur"===e&&fe()}function he(e){if("topSelectionChange"===e||"topKeyUp"===e||"topKeyDown"===e)return le(Rr)}function ye(e,t){if("topClick"===e)return le(t)}function ve(e,t){if("topInput"===e||"topChange"===e)return le(t)}function me(e,t,n,r){return z.call(this,e,t,n,r)}function be(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=Lr[e])&&!!t[e]}function ge(){return be}function _e(e,t,n,r){return z.call(this,e,t,n,r)}function we(e){return e=e.type,"string"==typeof e?e:"function"==typeof e?e.displayName||e.name:null}function xe(e){var t=e;if(e.alternate)for(;t.return;)t=t.return;else{if(0!=(2&t.effectTag))return 1;for(;t.return;)if(t=t.return,0!=(2&t.effectTag))return 1}return 3===t.tag?2:3}function Oe(e){return!!(e=e._reactInternalFiber)&&2===xe(e)}function Se(e){2!==xe(e)&&r("188")}function Te(e){var t=e.alternate;if(!t)return t=xe(e),3===t&&r("188"),1===t?null:e;for(var n=e,o=t;;){var i=n.return,a=i?i.alternate:null;if(!i||!a)break;if(i.child===a.child){for(var u=i.child;u;){if(u===n)return Se(i),e;if(u===o)return Se(i),t;u=u.sibling}r("188")}if(n.return!==o.return)n=i,o=a;else{u=!1;for(var s=i.child;s;){if(s===n){u=!0,n=i,o=a;break}if(s===o){u=!0,o=i,n=a;break}s=s.sibling}if(!u){for(s=a.child;s;){if(s===n){u=!0,n=a,o=i;break}if(s===o){u=!0,o=a,n=i;break}s=s.sibling}u||r("189")}}n.alternate!==o&&r("190")}return 3!==n.tag&&r("188"),n.stateNode.current===n?e:t}function Ee(e){if(!(e=Te(e)))return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}function Ce(e){if(!(e=Te(e)))return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child&&4!==t.tag)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}function ke(e){var t=e.targetInst;do{if(!t){e.ancestors.push(t);break}var n;for(n=t;n.return;)n=n.return;if(!(n=3!==n.tag?null:n.stateNode.containerInfo))break;e.ancestors.push(t),t=S(n)}while(t);for(n=0;n<e.ancestors.length;n++)t=e.ancestors[n],Br(e.topLevelType,t,e.nativeEvent,te(e.nativeEvent))}function Pe(e){Hr=!!e}function Me(e,t,n){return n?On.listen(n,t,Ne.bind(null,e)):null}function je(e,t,n){return n?On.capture(n,t,Ne.bind(null,e)):null}function Ne(e,t){if(Hr){var n=te(t);if(n=S(n),null===n||"number"!=typeof n.tag||2===xe(n)||(n=null),Wr.length){var r=Wr.pop();r.topLevelType=e,r.nativeEvent=t,r.targetInst=n,e=r}else e={topLevelType:e,nativeEvent:t,targetInst:n,ancestors:[]};try{Z(ke,e)}finally{e.topLevelType=null,e.nativeEvent=null,e.targetInst=null,e.ancestors.length=0,10>Wr.length&&Wr.push(e)}}}function Ie(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n["ms"+e]="MS"+t,n["O"+e]="o"+t.toLowerCase(),n}function Ae(e){if(Gr[e])return Gr[e];if(!qr[e])return e;var t,n=qr[e];for(t in n)if(n.hasOwnProperty(t)&&t in Yr)return Gr[e]=n[t];return""}function Re(e){return Object.prototype.hasOwnProperty.call(e,Jr)||(e[Jr]=Qr++,$r[e[Jr]]={}),$r[e[Jr]]}function Fe(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function De(e,t){var n=Fe(e);e=0;for(var r;n;){if(3===n.nodeType){if(r=e+n.textContent.length,e<=t&&r>=t)return{node:n,offset:t-e};e=r}e:{for(;n;){if(n.nextSibling){n=n.nextSibling;break e}n=n.parentNode}n=void 0}n=Fe(n)}}function Le(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&"text"===e.type||"textarea"===t||"true"===e.contentEditable)}function ze(e,t){if(oo||null==to||to!==Sn())return null;var n=to;return"selectionStart"in n&&Le(n)?n={start:n.selectionStart,end:n.selectionEnd}:window.getSelection?(n=window.getSelection(),n={anchorNode:n.anchorNode,anchorOffset:n.anchorOffset,focusNode:n.focusNode,focusOffset:n.focusOffset}):n=void 0,ro&&Tn(ro,n)?null:(ro=n,e=z.getPooled(eo.select,no,e,t),e.type="select",e.target=to,A(e),e)}function Ve(e,t,n,r){return z.call(this,e,t,n,r)}function Ue(e,t,n,r){return z.call(this,e,t,n,r)}function We(e,t,n,r){return z.call(this,e,t,n,r)}function He(e){var t=e.keyCode;return"charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,32<=e||13===e?e:0}function Be(e,t,n,r){return z.call(this,e,t,n,r)}function Ke(e,t,n,r){return z.call(this,e,t,n,r)}function qe(e,t,n,r){return z.call(this,e,t,n,r)}function Ge(e,t,n,r){return z.call(this,e,t,n,r)}function Ye(e,t,n,r){return z.call(this,e,t,n,r)}function Xe(e){0>po||(e.current=fo[po],fo[po]=null,po--)}function $e(e,t){po++,fo[po]=e.current,e.current=t}function Qe(e){return Ze(e)?vo:ho.current}function Je(e,t){var n=e.type.contextTypes;if(!n)return kn;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var o,i={};for(o in n)i[o]=t[o];return r&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=i),i}function Ze(e){return 2===e.tag&&null!=e.type.childContextTypes}function et(e){Ze(e)&&(Xe(yo,e),Xe(ho,e))}function tt(e,t,n){null!=ho.cursor&&r("168"),$e(ho,t,e),$e(yo,n,e)}function nt(e,t){var n=e.stateNode,o=e.type.childContextTypes;if("function"!=typeof n.getChildContext)return t;n=n.getChildContext();for(var i in n)i in o||r("108",we(e)||"Unknown",i);return wn({},t,n)}function rt(e){if(!Ze(e))return!1;var t=e.stateNode;return t=t&&t.__reactInternalMemoizedMergedChildContext||kn,vo=ho.current,$e(ho,t,e),$e(yo,yo.current,e),!0}function ot(e,t){var n=e.stateNode;if(n||r("169"),t){var o=nt(e,vo);n.__reactInternalMemoizedMergedChildContext=o,Xe(yo,e),Xe(ho,e),$e(ho,o,e)}else Xe(yo,e);$e(yo,t,e)}function it(e,t,n){this.tag=e,this.key=t,this.stateNode=this.type=null,this.sibling=this.child=this.return=null,this.index=0,this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null,this.internalContextTag=n,this.effectTag=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.expirationTime=0,this.alternate=null}function at(e,t,n){var r=e.alternate;return null===r?(r=new it(e.tag,e.key,e.internalContextTag),r.type=e.type,r.stateNode=e.stateNode,r.alternate=e,e.alternate=r):(r.effectTag=0,r.nextEffect=null,r.firstEffect=null,r.lastEffect=null),r.expirationTime=n,r.pendingProps=t,r.child=e.child,r.memoizedProps=e.memoizedProps,r.memoizedState=e.memoizedState,r.updateQueue=e.updateQueue,r.sibling=e.sibling,r.index=e.index,r.ref=e.ref,r}function ut(e,t,n){var o=void 0,i=e.type,a=e.key;return"function"==typeof i?(o=i.prototype&&i.prototype.isReactComponent?new it(2,a,t):new it(0,a,t),o.type=i,o.pendingProps=e.props):"string"==typeof i?(o=new it(5,a,t),o.type=i,o.pendingProps=e.props):"object"==typeof i&&null!==i&&"number"==typeof i.tag?(o=i,o.pendingProps=e.props):r("130",null==i?i:typeof i,""),o.expirationTime=n,o}function st(e,t,n,r){return t=new it(10,r,t),t.pendingProps=e,t.expirationTime=n,t}function lt(e,t,n){return t=new it(6,null,t),t.pendingProps=e,t.expirationTime=n,t}function ct(e,t,n){return t=new it(7,e.key,t),t.type=e.handler,t.pendingProps=e,t.expirationTime=n,t}function ft(e,t,n){return e=new it(9,null,t),e.expirationTime=n,e}function dt(e,t,n){return t=new it(4,e.key,t),t.pendingProps=e.children||[],t.expirationTime=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function pt(e){return function(t){try{return e(t)}catch(e){}}}function ht(e){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var t=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(t.isDisabled||!t.supportsFiber)return!0;try{var n=t.inject(e);mo=pt(function(e){return t.onCommitFiberRoot(n,e)}),bo=pt(function(e){return t.onCommitFiberUnmount(n,e)})}catch(e){}return!0}function yt(e){"function"==typeof mo&&mo(e)}function vt(e){"function"==typeof bo&&bo(e)}function mt(e){return{baseState:e,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function bt(e,t){null===e.last?e.first=e.last=t:(e.last.next=t,e.last=t),(0===e.expirationTime||e.expirationTime>t.expirationTime)&&(e.expirationTime=t.expirationTime)}function gt(e,t){var n=e.alternate,r=e.updateQueue;null===r&&(r=e.updateQueue=mt(null)),null!==n?null===(e=n.updateQueue)&&(e=n.updateQueue=mt(null)):e=null,e=e!==r?e:null,null===e?bt(r,t):null===r.last||null===e.last?(bt(r,t),bt(e,t)):(bt(r,t),e.last=t)}function _t(e,t,n,r){return e=e.partialState,"function"==typeof e?e.call(t,n,r):e}function wt(e,t,n,r,o,i){null!==e&&e.updateQueue===n&&(n=t.updateQueue={baseState:n.baseState,expirationTime:n.expirationTime,first:n.first,last:n.last,isInitialized:n.isInitialized,callbackList:null,hasForceUpdate:!1}),n.expirationTime=0,n.isInitialized?e=n.baseState:(e=n.baseState=t.memoizedState,n.isInitialized=!0);for(var a=!0,u=n.first,s=!1;null!==u;){var l=u.expirationTime;if(l>i){var c=n.expirationTime;(0===c||c>l)&&(n.expirationTime=l),s||(s=!0,n.baseState=e)}else s||(n.first=u.next,null===n.first&&(n.last=null)),u.isReplace?(e=_t(u,r,e,o),a=!0):(l=_t(u,r,e,o))&&(e=a?wn({},e,l):wn(e,l),a=!1),u.isForced&&(n.hasForceUpdate=!0),null!==u.callback&&(l=n.callbackList,null===l&&(l=n.callbackList=[]),l.push(u));u=u.next}return null!==n.callbackList?t.effectTag|=32:null!==n.first||n.hasForceUpdate||(t.updateQueue=null),s||(n.baseState=e),e}function xt(e,t){var n=e.callbackList;if(null!==n)for(e.callbackList=null,e=0;e<n.length;e++){var o=n[e],i=o.callback;o.callback=null,"function"!=typeof i&&r("191",i),i.call(t)}}function Ot(e,t,n,o){function i(e,t){t.updater=a,e.stateNode=t,t._reactInternalFiber=e}var a={isMounted:Oe,enqueueSetState:function(n,r,o){n=n._reactInternalFiber,o=void 0===o?null:o;var i=t(n);gt(n,{expirationTime:i,partialState:r,callback:o,isReplace:!1,isForced:!1,nextCallback:null,next:null}),e(n,i)},enqueueReplaceState:function(n,r,o){n=n._reactInternalFiber,o=void 0===o?null:o;var i=t(n);gt(n,{expirationTime:i,partialState:r,callback:o,isReplace:!0,isForced:!1,nextCallback:null,next:null}),e(n,i)},enqueueForceUpdate:function(n,r){n=n._reactInternalFiber,r=void 0===r?null:r;var o=t(n);gt(n,{expirationTime:o,partialState:null,callback:r,isReplace:!1,isForced:!0,nextCallback:null,next:null}),e(n,o)}};return{adoptClassInstance:i,constructClassInstance:function(e,t){var n=e.type,r=Qe(e),o=2===e.tag&&null!=e.type.contextTypes,a=o?Je(e,r):kn;return t=new n(t,a),i(e,t),o&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=r,e.__reactInternalMemoizedMaskedChildContext=a),t},mountClassInstance:function(e,t){var n=e.alternate,o=e.stateNode,i=o.state||null,u=e.pendingProps;u||r("158");var s=Qe(e);o.props=u,o.state=e.memoizedState=i,o.refs=kn,o.context=Je(e,s),null!=e.type&&null!=e.type.prototype&&!0===e.type.prototype.unstable_isAsyncReactComponent&&(e.internalContextTag|=1),"function"==typeof o.componentWillMount&&(i=o.state,o.componentWillMount(),i!==o.state&&a.enqueueReplaceState(o,o.state,null),null!==(i=e.updateQueue)&&(o.state=wt(n,e,i,o,u,t))),"function"==typeof o.componentDidMount&&(e.effectTag|=4)},updateClassInstance:function(e,t,i){var u=t.stateNode;u.props=t.memoizedProps,u.state=t.memoizedState;var s=t.memoizedProps,l=t.pendingProps;l||null==(l=s)&&r("159");var c=u.context,f=Qe(t);if(f=Je(t,f),"function"!=typeof u.componentWillReceiveProps||s===l&&c===f||(c=u.state,u.componentWillReceiveProps(l,f),u.state!==c&&a.enqueueReplaceState(u,u.state,null)),c=t.memoizedState,i=null!==t.updateQueue?wt(e,t,t.updateQueue,u,l,i):c,!(s!==l||c!==i||yo.current||null!==t.updateQueue&&t.updateQueue.hasForceUpdate))return"function"!=typeof u.componentDidUpdate||s===e.memoizedProps&&c===e.memoizedState||(t.effectTag|=4),!1;var d=l;if(null===s||null!==t.updateQueue&&t.updateQueue.hasForceUpdate)d=!0;else{var p=t.stateNode,h=t.type;d="function"==typeof p.shouldComponentUpdate?p.shouldComponentUpdate(d,i,f):!(h.prototype&&h.prototype.isPureReactComponent&&Tn(s,d)&&Tn(c,i))}return d?("function"==typeof u.componentWillUpdate&&u.componentWillUpdate(l,i,f),"function"==typeof u.componentDidUpdate&&(t.effectTag|=4)):("function"!=typeof u.componentDidUpdate||s===e.memoizedProps&&c===e.memoizedState||(t.effectTag|=4),n(t,l),o(t,i)),u.props=l,u.state=i,u.context=f,d}}}function St(e){return null===e||void 0===e?null:(e=To&&e[To]||e["@@iterator"],"function"==typeof e?e:null)}function Tt(e,t){var n=t.ref;if(null!==n&&"function"!=typeof n){if(t._owner){t=t._owner;var o=void 0;t&&(2!==t.tag&&r("110"),o=t.stateNode),o||r("147",n);var i=""+n;return null!==e&&null!==e.ref&&e.ref._stringRef===i?e.ref:(e=function(e){var t=o.refs===kn?o.refs={}:o.refs;null===e?delete t[i]:t[i]=e},e._stringRef=i,e)}"string"!=typeof n&&r("148"),t._owner||r("149",n)}return n}function Et(e,t){"textarea"!==e.type&&r("31","[object Object]"===Object.prototype.toString.call(t)?"object with keys {"+Object.keys(t).join(", ")+"}":t,"")}function Ct(e){function t(t,n){if(e){var r=t.lastEffect;null!==r?(r.nextEffect=n,t.lastEffect=n):t.firstEffect=t.lastEffect=n,n.nextEffect=null,n.effectTag=8}}function n(n,r){if(!e)return null;for(;null!==r;)t(n,r),r=r.sibling;return null}function o(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function i(e,t,n){return e=at(e,t,n),e.index=0,e.sibling=null,e}function a(t,n,r){return t.index=r,e?null!==(r=t.alternate)?(r=r.index,r<n?(t.effectTag=2,n):r):(t.effectTag=2,n):n}function u(t){return e&&null===t.alternate&&(t.effectTag=2),t}function s(e,t,n,r){return null===t||6!==t.tag?(t=lt(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function l(e,t,n,r){return null!==t&&t.type===n.type?(r=i(t,n.props,r),r.ref=Tt(t,n),r.return=e,r):(r=ut(n,e.internalContextTag,r),r.ref=Tt(t,n),r.return=e,r)}function c(e,t,n,r){return null===t||7!==t.tag?(t=ct(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function f(e,t,n,r){return null===t||9!==t.tag?(t=ft(n,e.internalContextTag,r),t.type=n.value,t.return=e,t):(t=i(t,null,r),t.type=n.value,t.return=e,t)}function d(e,t,n,r){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?(t=dt(n,e.internalContextTag,r),t.return=e,t):(t=i(t,n.children||[],r),t.return=e,t)}function p(e,t,n,r,o){return null===t||10!==t.tag?(t=st(n,e.internalContextTag,r,o),t.return=e,t):(t=i(t,n,r),t.return=e,t)}function h(e,t,n){if("string"==typeof t||"number"==typeof t)return t=lt(""+t,e.internalContextTag,n),t.return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case _o:return t.type===So?(t=st(t.props.children,e.internalContextTag,n,t.key),t.return=e,t):(n=ut(t,e.internalContextTag,n),n.ref=Tt(null,t),n.return=e,n);case wo:return t=ct(t,e.internalContextTag,n),t.return=e,t;case xo:return n=ft(t,e.internalContextTag,n),n.type=t.value,n.return=e,n;case Oo:return t=dt(t,e.internalContextTag,n),t.return=e,t}if(Eo(t)||St(t))return t=st(t,e.internalContextTag,n,null),t.return=e,t;Et(e,t)}return null}function y(e,t,n,r){var o=null!==t?t.key:null;if("string"==typeof n||"number"==typeof n)return null!==o?null:s(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case _o:return n.key===o?n.type===So?p(e,t,n.props.children,r,o):l(e,t,n,r):null;case wo:return n.key===o?c(e,t,n,r):null;case xo:return null===o?f(e,t,n,r):null;case Oo:return n.key===o?d(e,t,n,r):null}if(Eo(n)||St(n))return null!==o?null:p(e,t,n,r,null);Et(e,n)}return null}function v(e,t,n,r,o){if("string"==typeof r||"number"==typeof r)return e=e.get(n)||null,s(t,e,""+r,o);if("object"==typeof r&&null!==r){switch(r.$$typeof){case _o:return e=e.get(null===r.key?n:r.key)||null,r.type===So?p(t,e,r.props.children,o,r.key):l(t,e,r,o);case wo:return e=e.get(null===r.key?n:r.key)||null,c(t,e,r,o);case xo:return e=e.get(n)||null,f(t,e,r,o);case Oo:return e=e.get(null===r.key?n:r.key)||null,d(t,e,r,o)}if(Eo(r)||St(r))return e=e.get(n)||null,p(t,e,r,o,null);Et(t,r)}return null}function m(r,i,u,s){for(var l=null,c=null,f=i,d=i=0,p=null;null!==f&&d<u.length;d++){f.index>d?(p=f,f=null):p=f.sibling;var m=y(r,f,u[d],s);if(null===m){null===f&&(f=p);break}e&&f&&null===m.alternate&&t(r,f),i=a(m,i,d),null===c?l=m:c.sibling=m,c=m,f=p}if(d===u.length)return n(r,f),l;if(null===f){for(;d<u.length;d++)(f=h(r,u[d],s))&&(i=a(f,i,d),null===c?l=f:c.sibling=f,c=f);return l}for(f=o(r,f);d<u.length;d++)(p=v(f,r,d,u[d],s))&&(e&&null!==p.alternate&&f.delete(null===p.key?d:p.key),i=a(p,i,d),null===c?l=p:c.sibling=p,c=p);return e&&f.forEach(function(e){return t(r,e)}),l}function b(i,u,s,l){var c=St(s);"function"!=typeof c&&r("150"),null==(s=c.call(s))&&r("151");for(var f=c=null,d=u,p=u=0,m=null,b=s.next();null!==d&&!b.done;p++,b=s.next()){d.index>p?(m=d,d=null):m=d.sibling;var g=y(i,d,b.value,l);if(null===g){d||(d=m);break}e&&d&&null===g.alternate&&t(i,d),u=a(g,u,p),null===f?c=g:f.sibling=g,f=g,d=m}if(b.done)return n(i,d),c;if(null===d){for(;!b.done;p++,b=s.next())null!==(b=h(i,b.value,l))&&(u=a(b,u,p),null===f?c=b:f.sibling=b,f=b);return c}for(d=o(i,d);!b.done;p++,b=s.next())null!==(b=v(d,i,p,b.value,l))&&(e&&null!==b.alternate&&d.delete(null===b.key?p:b.key),u=a(b,u,p),null===f?c=b:f.sibling=b,f=b);return e&&d.forEach(function(e){return t(i,e)}),c}return function(e,o,a,s){"object"==typeof a&&null!==a&&a.type===So&&null===a.key&&(a=a.props.children);var l="object"==typeof a&&null!==a;if(l)switch(a.$$typeof){case _o:e:{var c=a.key;for(l=o;null!==l;){if(l.key===c){if(10===l.tag?a.type===So:l.type===a.type){n(e,l.sibling),o=i(l,a.type===So?a.props.children:a.props,s),o.ref=Tt(l,a),o.return=e,e=o;break e}n(e,l);break}t(e,l),l=l.sibling}a.type===So?(o=st(a.props.children,e.internalContextTag,s,a.key),o.return=e,e=o):(s=ut(a,e.internalContextTag,s),s.ref=Tt(o,a),s.return=e,e=s)}return u(e);case wo:e:{for(l=a.key;null!==o;){if(o.key===l){if(7===o.tag){n(e,o.sibling),o=i(o,a,s),o.return=e,e=o;break e}n(e,o);break}t(e,o),o=o.sibling}o=ct(a,e.internalContextTag,s),o.return=e,e=o}return u(e);case xo:e:{if(null!==o){if(9===o.tag){n(e,o.sibling),o=i(o,null,s),o.type=a.value,o.return=e,e=o;break e}n(e,o)}o=ft(a,e.internalContextTag,s),o.type=a.value,o.return=e,e=o}return u(e);case Oo:e:{for(l=a.key;null!==o;){if(o.key===l){if(4===o.tag&&o.stateNode.containerInfo===a.containerInfo&&o.stateNode.implementation===a.implementation){n(e,o.sibling),o=i(o,a.children||[],s),o.return=e,e=o;break e}n(e,o);break}t(e,o),o=o.sibling}o=dt(a,e.internalContextTag,s),o.return=e,e=o}return u(e)}if("string"==typeof a||"number"==typeof a)return a=""+a,null!==o&&6===o.tag?(n(e,o.sibling),o=i(o,a,s)):(n(e,o),o=lt(a,e.internalContextTag,s)),o.return=e,e=o,u(e);if(Eo(a))return m(e,o,a,s);if(St(a))return b(e,o,a,s);if(l&&Et(e,a),void 0===a)switch(e.tag){case 2:case 1:s=e.type,r("152",s.displayName||s.name||"Component")}return n(e,o)}}function kt(e,t,n,o,i){function a(e,t,n){var r=t.expirationTime;t.child=null===e?ko(t,null,n,r):Co(t,e.child,n,r)}function u(e,t){var n=t.ref;null===n||e&&e.ref===n||(t.effectTag|=128)}function s(e,t,n,r){if(u(e,t),!n)return r&&ot(t,!1),c(e,t);n=t.stateNode,Ur.current=t;var o=n.render();return t.effectTag|=1,a(e,t,o),t.memoizedState=n.state,t.memoizedProps=n.props,r&&ot(t,!0),t.child}function l(e){var t=e.stateNode;t.pendingContext?tt(e,t.pendingContext,t.pendingContext!==t.context):t.context&&tt(e,t.context,!1),v(e,t.containerInfo)}function c(e,t){if(null!==e&&t.child!==e.child&&r("153"),null!==t.child){e=t.child;var n=at(e,e.pendingProps,e.expirationTime);for(t.child=n,n.return=t;null!==e.sibling;)e=e.sibling,n=n.sibling=at(e,e.pendingProps,e.expirationTime),n.return=t;n.sibling=null}return t.child}function f(e,t){switch(t.tag){case 3:l(t);break;case 2:rt(t);break;case 4:v(t,t.stateNode.containerInfo)}return null}var d=e.shouldSetTextContent,p=e.useSyncScheduling,h=e.shouldDeprioritizeSubtree,y=t.pushHostContext,v=t.pushHostContainer,m=n.enterHydrationState,b=n.resetHydrationState,g=n.tryToClaimNextHydratableInstance;e=Ot(o,i,function(e,t){e.memoizedProps=t},function(e,t){e.memoizedState=t});var _=e.adoptClassInstance,w=e.constructClassInstance,x=e.mountClassInstance,O=e.updateClassInstance;return{beginWork:function(e,t,n){if(0===t.expirationTime||t.expirationTime>n)return f(e,t);switch(t.tag){case 0:null!==e&&r("155");var o=t.type,i=t.pendingProps,S=Qe(t);return S=Je(t,S),o=o(i,S),t.effectTag|=1,"object"==typeof o&&null!==o&&"function"==typeof o.render?(t.tag=2,i=rt(t),_(t,o),x(t,n),t=s(e,t,!0,i)):(t.tag=1,a(e,t,o),t.memoizedProps=i,t=t.child),t;case 1:e:{if(i=t.type,n=t.pendingProps,o=t.memoizedProps,yo.current)null===n&&(n=o);else if(null===n||o===n){t=c(e,t);break e}o=Qe(t),o=Je(t,o),i=i(n,o),t.effectTag|=1,a(e,t,i),t.memoizedProps=n,t=t.child}return t;case 2:return i=rt(t),o=void 0,null===e?t.stateNode?r("153"):(w(t,t.pendingProps),x(t,n),o=!0):o=O(e,t,n),s(e,t,o,i);case 3:return l(t),i=t.updateQueue,null!==i?(o=t.memoizedState,i=wt(e,t,i,null,null,n),o===i?(b(),t=c(e,t)):(o=i.element,S=t.stateNode,(null===e||null===e.child)&&S.hydrate&&m(t)?(t.effectTag|=2,t.child=ko(t,null,o,n)):(b(),a(e,t,o)),t.memoizedState=i,t=t.child)):(b(),t=c(e,t)),t;case 5:y(t),null===e&&g(t),i=t.type;var T=t.memoizedProps;return o=t.pendingProps,null===o&&null===(o=T)&&r("154"),S=null!==e?e.memoizedProps:null,yo.current||null!==o&&T!==o?(T=o.children,d(i,o)?T=null:S&&d(i,S)&&(t.effectTag|=16),u(e,t),2147483647!==n&&!p&&h(i,o)?(t.expirationTime=2147483647,t=null):(a(e,t,T),t.memoizedProps=o,t=t.child)):t=c(e,t),t;case 6:return null===e&&g(t),e=t.pendingProps,null===e&&(e=t.memoizedProps),t.memoizedProps=e,null;case 8:t.tag=7;case 7:return i=t.pendingProps,yo.current?null===i&&null===(i=e&&e.memoizedProps)&&r("154"):null!==i&&t.memoizedProps!==i||(i=t.memoizedProps),o=i.children,t.stateNode=null===e?ko(t,t.stateNode,o,n):Co(t,t.stateNode,o,n),t.memoizedProps=i,t.stateNode;case 9:return null;case 4:e:{if(v(t,t.stateNode.containerInfo),i=t.pendingProps,yo.current)null===i&&null==(i=e&&e.memoizedProps)&&r("154");else if(null===i||t.memoizedProps===i){t=c(e,t);break e}null===e?t.child=Co(t,null,i,n):a(e,t,i),t.memoizedProps=i,t=t.child}return t;case 10:e:{if(n=t.pendingProps,yo.current)null===n&&(n=t.memoizedProps);else if(null===n||t.memoizedProps===n){t=c(e,t);break e}a(e,t,n),t.memoizedProps=n,t=t.child}return t;default:r("156")}},beginFailedWork:function(e,t,n){switch(t.tag){case 2:rt(t);break;case 3:l(t);break;default:r("157")}return t.effectTag|=64,null===e?t.child=null:t.child!==e.child&&(t.child=e.child),0===t.expirationTime||t.expirationTime>n?f(e,t):(t.firstEffect=null,t.lastEffect=null,t.child=null===e?ko(t,null,null,n):Co(t,e.child,null,n),2===t.tag&&(e=t.stateNode,t.memoizedProps=e.props,t.memoizedState=e.state),t.child)}}}function Pt(e,t,n){function o(e){e.effectTag|=4}var i=e.createInstance,a=e.createTextInstance,u=e.appendInitialChild,s=e.finalizeInitialChildren,l=e.prepareUpdate,c=e.persistence,f=t.getRootHostContainer,d=t.popHostContext,p=t.getHostContext,h=t.popHostContainer,y=n.prepareToHydrateHostInstance,v=n.prepareToHydrateHostTextInstance,m=n.popHydrationState,b=void 0,g=void 0,_=void 0;return e.mutation?(b=function(){},g=function(e,t,n){(t.updateQueue=n)&&o(t)},_=function(e,t,n,r){n!==r&&o(t)}):r(c?"235":"236"),{completeWork:function(e,t,n){var c=t.pendingProps;switch(null===c?c=t.memoizedProps:2147483647===t.expirationTime&&2147483647!==n||(t.pendingProps=null),t.tag){case 1:return null;case 2:return et(t),null;case 3:return h(t),Xe(yo,t),Xe(ho,t),c=t.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==e&&null!==e.child||(m(t),t.effectTag&=-3),b(t),null;case 5:d(t),n=f();var w=t.type;if(null!==e&&null!=t.stateNode){var x=e.memoizedProps,O=t.stateNode,S=p();O=l(O,w,x,c,n,S),g(e,t,O,w,x,c,n),e.ref!==t.ref&&(t.effectTag|=128)}else{if(!c)return null===t.stateNode&&r("166"),null;if(e=p(),m(t))y(t,n,e)&&o(t);else{e=i(w,c,n,e,t);e:for(x=t.child;null!==x;){if(5===x.tag||6===x.tag)u(e,x.stateNode);else if(4!==x.tag&&null!==x.child){x.child.return=x,x=x.child;continue}if(x===t)break;for(;null===x.sibling;){if(null===x.return||x.return===t)break e;x=x.return}x.sibling.return=x.return,x=x.sibling}s(e,w,c,n)&&o(t),t.stateNode=e}null!==t.ref&&(t.effectTag|=128)}return null;case 6:if(e&&null!=t.stateNode)_(e,t,e.memoizedProps,c);else{if("string"!=typeof c)return null===t.stateNode&&r("166"),null;e=f(),n=p(),m(t)?v(t)&&o(t):t.stateNode=a(c,e,n,t)}return null;case 7:(c=t.memoizedProps)||r("165"),t.tag=8,w=[];e:for((x=t.stateNode)&&(x.return=t);null!==x;){if(5===x.tag||6===x.tag||4===x.tag)r("247");else if(9===x.tag)w.push(x.type);else if(null!==x.child){x.child.return=x,x=x.child;continue}for(;null===x.sibling;){if(null===x.return||x.return===t)break e;x=x.return}x.sibling.return=x.return,x=x.sibling}return x=c.handler,c=x(c.props,w),t.child=Co(t,null!==e?e.child:null,c,n),t.child;case 8:return t.tag=7,null;case 9:case 10:return null;case 4:return h(t),b(t),null;case 0:r("167");default:r("156")}}}}function Mt(e,t){function n(e){var n=e.ref;if(null!==n)try{n(null)}catch(n){t(e,n)}}function o(e){switch("function"==typeof vt&&vt(e),e.tag){case 2:n(e);var r=e.stateNode;if("function"==typeof r.componentWillUnmount)try{r.props=e.memoizedProps,r.state=e.memoizedState,r.componentWillUnmount()}catch(n){t(e,n)}break;case 5:n(e);break;case 7:i(e.stateNode);break;case 4:l&&u(e)}}function i(e){for(var t=e;;)if(o(t),null===t.child||l&&4===t.tag){if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return;t=t.return}t.sibling.return=t.return,t=t.sibling}else t.child.return=t,t=t.child}function a(e){return 5===e.tag||3===e.tag||4===e.tag}function u(e){for(var t=e,n=!1,a=void 0,u=void 0;;){if(!n){n=t.return;e:for(;;){switch(null===n&&r("160"),n.tag){case 5:a=n.stateNode,u=!1;break e;case 3:case 4:a=n.stateNode.containerInfo,u=!0;break e}n=n.return}n=!0}if(5===t.tag||6===t.tag)i(t),u?g(a,t.stateNode):b(a,t.stateNode);else if(4===t.tag?a=t.stateNode.containerInfo:o(t),null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return;t=t.return,4===t.tag&&(n=!1)}t.sibling.return=t.return,t=t.sibling}}var s=e.getPublicInstance,l=e.mutation;e=e.persistence,l||r(e?"235":"236");var c=l.commitMount,f=l.commitUpdate,d=l.resetTextContent,p=l.commitTextUpdate,h=l.appendChild,y=l.appendChildToContainer,v=l.insertBefore,m=l.insertInContainerBefore,b=l.removeChild,g=l.removeChildFromContainer;return{commitResetTextContent:function(e){d(e.stateNode)},commitPlacement:function(e){e:{for(var t=e.return;null!==t;){if(a(t)){var n=t;break e}t=t.return}r("160"),n=void 0}var o=t=void 0;switch(n.tag){case 5:t=n.stateNode,o=!1;break;case 3:case 4:t=n.stateNode.containerInfo,o=!0;break;default:r("161")}16&n.effectTag&&(d(t),n.effectTag&=-17);e:t:for(n=e;;){for(;null===n.sibling;){if(null===n.return||a(n.return)){n=null;break e}n=n.return}for(n.sibling.return=n.return,n=n.sibling;5!==n.tag&&6!==n.tag;){if(2&n.effectTag)continue t;if(null===n.child||4===n.tag)continue t;n.child.return=n,n=n.child}if(!(2&n.effectTag)){n=n.stateNode;break e}}for(var i=e;;){if(5===i.tag||6===i.tag)n?o?m(t,i.stateNode,n):v(t,i.stateNode,n):o?y(t,i.stateNode):h(t,i.stateNode);else if(4!==i.tag&&null!==i.child){i.child.return=i,i=i.child;continue}if(i===e)break;for(;null===i.sibling;){if(null===i.return||i.return===e)return;i=i.return}i.sibling.return=i.return,i=i.sibling}},commitDeletion:function(e){u(e),e.return=null,e.child=null,e.alternate&&(e.alternate.child=null,e.alternate.return=null)},commitWork:function(e,t){switch(t.tag){case 2:break;case 5:var n=t.stateNode;if(null!=n){var o=t.memoizedProps;e=null!==e?e.memoizedProps:o;var i=t.type,a=t.updateQueue;t.updateQueue=null,null!==a&&f(n,a,i,e,o,t)}break;case 6:null===t.stateNode&&r("162"),n=t.memoizedProps,p(t.stateNode,null!==e?e.memoizedProps:n,n);break;case 3:break;default:r("163")}},commitLifeCycles:function(e,t){switch(t.tag){case 2:var n=t.stateNode;if(4&t.effectTag)if(null===e)n.props=t.memoizedProps,n.state=t.memoizedState,n.componentDidMount();else{var o=e.memoizedProps;e=e.memoizedState,n.props=t.memoizedProps,n.state=t.memoizedState,n.componentDidUpdate(o,e)}null!==(t=t.updateQueue)&&xt(t,n);break;case 3:null!==(n=t.updateQueue)&&xt(n,null!==t.child?t.child.stateNode:null);break;case 5:n=t.stateNode,null===e&&4&t.effectTag&&c(n,t.type,t.memoizedProps,t);break;case 6:case 4:break;default:r("163")}},commitAttachRef:function(e){var t=e.ref;if(null!==t){var n=e.stateNode;switch(e.tag){case 5:t(s(n));break;default:t(n)}}},commitDetachRef:function(e){null!==(e=e.ref)&&e(null)}}}function jt(e){function t(e){return e===Po&&r("174"),e}var n=e.getChildHostContext,o=e.getRootHostContext,i={current:Po},a={current:Po},u={current:Po};return{getHostContext:function(){return t(i.current)},getRootHostContainer:function(){return t(u.current)},popHostContainer:function(e){Xe(i,e),Xe(a,e),Xe(u,e)},popHostContext:function(e){a.current===e&&(Xe(i,e),Xe(a,e))},pushHostContainer:function(e,t){$e(u,t,e),t=o(t),$e(a,e,e),$e(i,t,e)},pushHostContext:function(e){var r=t(u.current),o=t(i.current);r=n(o,e.type,r),o!==r&&($e(a,e,e),$e(i,r,e))},resetHostContainer:function(){i.current=Po,u.current=Po}}}function Nt(e){function t(e,t){var n=new it(5,null,0);n.type="DELETED",n.stateNode=t,n.return=e,n.effectTag=8,null!==e.lastEffect?(e.lastEffect.nextEffect=n,e.lastEffect=n):e.firstEffect=e.lastEffect=n}function n(e,t){switch(e.tag){case 5:return null!==(t=a(t,e.type,e.pendingProps))&&(e.stateNode=t,!0);case 6:return null!==(t=u(t,e.pendingProps))&&(e.stateNode=t,!0);default:return!1}}function o(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag;)e=e.return;d=e}var i=e.shouldSetTextContent;if(!(e=e.hydration))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){r("175")},prepareToHydrateHostTextInstance:function(){r("176")},popHydrationState:function(){return!1}};var a=e.canHydrateInstance,u=e.canHydrateTextInstance,s=e.getNextHydratableSibling,l=e.getFirstHydratableChild,c=e.hydrateInstance,f=e.hydrateTextInstance,d=null,p=null,h=!1;return{enterHydrationState:function(e){return p=l(e.stateNode.containerInfo),d=e,h=!0},resetHydrationState:function(){p=d=null,h=!1},tryToClaimNextHydratableInstance:function(e){if(h){var r=p;if(r){if(!n(e,r)){if(!(r=s(r))||!n(e,r))return e.effectTag|=2,h=!1,void(d=e);t(d,p)}d=e,p=l(r)}else e.effectTag|=2,h=!1,d=e}},prepareToHydrateHostInstance:function(e,t,n){return t=c(e.stateNode,e.type,e.memoizedProps,t,n,e),e.updateQueue=t,null!==t},prepareToHydrateHostTextInstance:function(e){return f(e.stateNode,e.memoizedProps,e)},popHydrationState:function(e){if(e!==d)return!1;if(!h)return o(e),h=!0,!1;var n=e.type;if(5!==e.tag||"head"!==n&&"body"!==n&&!i(n,e.memoizedProps))for(n=p;n;)t(e,n),n=s(n);return o(e),p=d?s(e.stateNode):null,!0}}}function It(e){function t(e){ie=X=!0;var t=e.stateNode;if(t.current===e&&r("177"),t.isReadyForCommit=!1,Ur.current=null,1<e.effectTag)if(null!==e.lastEffect){e.lastEffect.nextEffect=e;var n=e.firstEffect}else n=e;else n=e.firstEffect;for(B(),Z=n;null!==Z;){var o=!1,i=void 0;try{for(;null!==Z;){var a=Z.effectTag;if(16&a&&I(Z),128&a){var u=Z.alternate;null!==u&&z(u)}switch(-242&a){case 2:A(Z),Z.effectTag&=-3;break;case 6:A(Z),Z.effectTag&=-3,F(Z.alternate,Z);break;case 4:F(Z.alternate,Z);break;case 8:ae=!0,R(Z),ae=!1}Z=Z.nextEffect}}catch(e){o=!0,i=e}o&&(null===Z&&r("178"),s(Z,i),null!==Z&&(Z=Z.nextEffect))}for(K(),t.current=e,Z=n;null!==Z;){n=!1,o=void 0;try{for(;null!==Z;){var l=Z.effectTag;if(36&l&&D(Z.alternate,Z),128&l&&L(Z),64&l)switch(i=Z,a=void 0,null!==ee&&(a=ee.get(i),ee.delete(i),null==a&&null!==i.alternate&&(i=i.alternate,a=ee.get(i),ee.delete(i))),null==a&&r("184"),i.tag){case 2:i.stateNode.componentDidCatch(a.error,{componentStack:a.componentStack});break;case 3:null===re&&(re=a.error);break;default:r("157")}var c=Z.nextEffect;Z.nextEffect=null,Z=c}}catch(e){n=!0,o=e}n&&(null===Z&&r("178"),s(Z,o),null!==Z&&(Z=Z.nextEffect))}return X=ie=!1,"function"==typeof yt&&yt(e.stateNode),ne&&(ne.forEach(y),ne=null),null!==re&&(e=re,re=null,O(e)),t=t.current.expirationTime,0===t&&(te=ee=null),t}function n(e){for(;;){var t=N(e.alternate,e,J),n=e.return,r=e.sibling,o=e;if(2147483647===J||2147483647!==o.expirationTime){if(2!==o.tag&&3!==o.tag)var i=0;else i=o.updateQueue,i=null===i?0:i.expirationTime;for(var a=o.child;null!==a;)0!==a.expirationTime&&(0===i||i>a.expirationTime)&&(i=a.expirationTime),a=a.sibling;o.expirationTime=i}if(null!==t)return t;if(null!==n&&(null===n.firstEffect&&(n.firstEffect=e.firstEffect),null!==e.lastEffect&&(null!==n.lastEffect&&(n.lastEffect.nextEffect=e.firstEffect),n.lastEffect=e.lastEffect),1<e.effectTag&&(null!==n.lastEffect?n.lastEffect.nextEffect=e:n.firstEffect=e,n.lastEffect=e)),null!==r)return r;if(null===n){e.stateNode.isReadyForCommit=!0;break}e=n}return null}function o(e){var t=M(e.alternate,e,J);return null===t&&(t=n(e)),Ur.current=null,t}function i(e){var t=j(e.alternate,e,J);return null===t&&(t=n(e)),Ur.current=null,t}function a(e){if(null!==ee){if(!(0===J||J>e))if(J<=G)for(;null!==$;)$=l($)?i($):o($);else for(;null!==$&&!x();)$=l($)?i($):o($)}else if(!(0===J||J>e))if(J<=G)for(;null!==$;)$=o($);else for(;null!==$&&!x();)$=o($)}function u(e,t){if(X&&r("243"),X=!0,e.isReadyForCommit=!1,e!==Q||t!==J||null===$){for(;-1<po;)fo[po]=null,po--;vo=kn,ho.current=kn,yo.current=!1,k(),Q=e,J=t,$=at(Q.current,null,t)}var n=!1,o=null;try{a(t)}catch(e){n=!0,o=e}for(;n;){if(oe){re=o;break}var u=$;if(null===u)oe=!0;else{var l=s(u,o);if(null===l&&r("183"),!oe){try{for(n=l,o=t,l=n;null!==u;){switch(u.tag){case 2:et(u);break;case 5:C(u);break;case 3:E(u);break;case 4:E(u)}if(u===l||u.alternate===l)break;u=u.return}$=i(n),a(o)}catch(e){n=!0,o=e;continue}break}}}return t=re,oe=X=!1,re=null,null!==t&&O(t),e.isReadyForCommit?e.current.alternate:null}function s(e,t){var n=Ur.current=null,r=!1,o=!1,i=null;if(3===e.tag)n=e,c(e)&&(oe=!0);else for(var a=e.return;null!==a&&null===n;){if(2===a.tag?"function"==typeof a.stateNode.componentDidCatch&&(r=!0,i=we(a),n=a,o=!0):3===a.tag&&(n=a),c(a)){if(ae||null!==ne&&(ne.has(a)||null!==a.alternate&&ne.has(a.alternate)))return null;n=null,o=!1}a=a.return}if(null!==n){null===te&&(te=new Set),te.add(n);var u="";a=e;do{e:switch(a.tag){case 0:case 1:case 2:case 5:var s=a._debugOwner,l=a._debugSource,f=we(a),d=null;s&&(d=we(s)),s=l,f="\n    in "+(f||"Unknown")+(s?" (at "+s.fileName.replace(/^.*[\\\/]/,"")+":"+s.lineNumber+")":d?" (created by "+d+")":"");break e;default:f=""}u+=f,a=a.return}while(a);a=u,e=we(e),null===ee&&(ee=new Map),t={componentName:e,componentStack:a,error:t,errorBoundary:r?n.stateNode:null,errorBoundaryFound:r,errorBoundaryName:i,willRetry:o},ee.set(n,t);try{var p=t.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(e){e&&e.suppressReactErrorLogging||console.error(e)}return ie?(null===ne&&(ne=new Set),ne.add(n)):y(n),n}return null===re&&(re=t),null}function l(e){return null!==ee&&(ee.has(e)||null!==e.alternate&&ee.has(e.alternate))}function c(e){return null!==te&&(te.has(e)||null!==e.alternate&&te.has(e.alternate))}function f(){return 20*(1+((v()+100)/20|0))}function d(e){return 0!==Y?Y:X?ie?1:J:!H||1&e.internalContextTag?f():1}function p(e,t){return h(e,t,!1)}function h(e,t){for(;null!==e;){if((0===e.expirationTime||e.expirationTime>t)&&(e.expirationTime=t),null!==e.alternate&&(0===e.alternate.expirationTime||e.alternate.expirationTime>t)&&(e.alternate.expirationTime=t),null===e.return){if(3!==e.tag)break;var n=e.stateNode;!X&&n===Q&&t<J&&($=Q=null,J=0);var o=n,i=t;if(xe>_e&&r("185"),null===o.nextScheduledRoot)o.remainingExpirationTime=i,null===se?(ue=se=o,o.nextScheduledRoot=o):(se=se.nextScheduledRoot=o,se.nextScheduledRoot=ue);else{var a=o.remainingExpirationTime;(0===a||i<a)&&(o.remainingExpirationTime=i)}fe||(be?ge&&(de=o,pe=1,w(de,pe)):1===i?_(1,null):m(i)),!X&&n===Q&&t<J&&($=Q=null,J=0)}e=e.return}}function y(e){h(e,1,!0)}function v(){return G=2+((V()-q)/10|0)}function m(e){if(0!==le){if(e>le)return;W(ce)}var t=V()-q;le=e,ce=U(g,{timeout:10*(e-2)-t})}function b(){var e=0,t=null;if(null!==se)for(var n=se,o=ue;null!==o;){var i=o.remainingExpirationTime;if(0===i){if((null===n||null===se)&&r("244"),o===o.nextScheduledRoot){ue=se=o.nextScheduledRoot=null;break}if(o===ue)ue=i=o.nextScheduledRoot,se.nextScheduledRoot=i,o.nextScheduledRoot=null;else{if(o===se){se=n,se.nextScheduledRoot=ue,o.nextScheduledRoot=null;break}n.nextScheduledRoot=o.nextScheduledRoot,o.nextScheduledRoot=null}o=n.nextScheduledRoot}else{if((0===e||i<e)&&(e=i,t=o),o===se)break;n=o,o=o.nextScheduledRoot}}n=de,null!==n&&n===t?xe++:xe=0,de=t,pe=e}function g(e){_(0,e)}function _(e,t){for(me=t,b();null!==de&&0!==pe&&(0===e||pe<=e)&&!he;)w(de,pe),b();if(null!==me&&(le=0,ce=-1),0!==pe&&m(pe),me=null,he=!1,xe=0,ye)throw e=ve,ve=null,ye=!1,e}function w(e,n){if(fe&&r("245"),fe=!0,n<=v()){var o=e.finishedWork;null!==o?(e.finishedWork=null,e.remainingExpirationTime=t(o)):(e.finishedWork=null,null!==(o=u(e,n))&&(e.remainingExpirationTime=t(o)))}else o=e.finishedWork,null!==o?(e.finishedWork=null,e.remainingExpirationTime=t(o)):(e.finishedWork=null,null!==(o=u(e,n))&&(x()?e.finishedWork=o:e.remainingExpirationTime=t(o)));fe=!1}function x(){return!(null===me||me.timeRemaining()>Oe)&&(he=!0)}function O(e){null===de&&r("246"),de.remainingExpirationTime=0,ye||(ye=!0,ve=e)}var S=jt(e),T=Nt(e),E=S.popHostContainer,C=S.popHostContext,k=S.resetHostContainer,P=kt(e,S,T,p,d),M=P.beginWork,j=P.beginFailedWork,N=Pt(e,S,T).completeWork;S=Mt(e,s);var I=S.commitResetTextContent,A=S.commitPlacement,R=S.commitDeletion,F=S.commitWork,D=S.commitLifeCycles,L=S.commitAttachRef,z=S.commitDetachRef,V=e.now,U=e.scheduleDeferredCallback,W=e.cancelDeferredCallback,H=e.useSyncScheduling,B=e.prepareForCommit,K=e.resetAfterCommit,q=V(),G=2,Y=0,X=!1,$=null,Q=null,J=0,Z=null,ee=null,te=null,ne=null,re=null,oe=!1,ie=!1,ae=!1,ue=null,se=null,le=0,ce=-1,fe=!1,de=null,pe=0,he=!1,ye=!1,ve=null,me=null,be=!1,ge=!1,_e=1e3,xe=0,Oe=1;return{computeAsyncExpiration:f,computeExpirationForFiber:d,scheduleWork:p,batchedUpdates:function(e,t){var n=be;be=!0;try{return e(t)}finally{(be=n)||fe||_(1,null)}},unbatchedUpdates:function(e){if(be&&!ge){ge=!0;try{return e()}finally{ge=!1}}return e()},flushSync:function(e){var t=be;be=!0;try{e:{var n=Y;Y=1;try{var o=e();break e}finally{Y=n}o=void 0}return o}finally{be=t,fe&&r("187"),_(1,null)}},deferredUpdates:function(e){var t=Y;Y=f();try{return e()}finally{Y=t}}}}function At(e){function t(e){return e=Ee(e),null===e?null:e.stateNode}var n=e.getPublicInstance;e=It(e);var o=e.computeAsyncExpiration,i=e.computeExpirationForFiber,a=e.scheduleWork;return{createContainer:function(e,t){var n=new it(3,null,0);return e={current:n,containerInfo:e,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:t,nextScheduledRoot:null},n.stateNode=e},updateContainer:function(e,t,n,u){var s=t.current;if(n){n=n._reactInternalFiber;var l;e:{for(2===xe(n)&&2===n.tag||r("170"),l=n;3!==l.tag;){if(Ze(l)){l=l.stateNode.__reactInternalMemoizedMergedChildContext;break e}(l=l.return)||r("171")}l=l.stateNode.context}n=Ze(n)?nt(n,l):l}else n=kn;null===t.context?t.context=n:t.pendingContext=n,t=u,t=void 0===t?null:t,u=null!=e&&null!=e.type&&null!=e.type.prototype&&!0===e.type.prototype.unstable_isAsyncReactComponent?o():i(s),gt(s,{expirationTime:u,partialState:{element:e},callback:t,isReplace:!1,isForced:!1,nextCallback:null,next:null}),a(s,u)},batchedUpdates:e.batchedUpdates,unbatchedUpdates:e.unbatchedUpdates,deferredUpdates:e.deferredUpdates,flushSync:e.flushSync,getPublicRootInstance:function(e){if(e=e.current,!e.child)return null;switch(e.child.tag){case 5:return n(e.child.stateNode);default:return e.child.stateNode}},findHostInstance:t,findHostInstanceWithNoPortals:function(e){return e=Ce(e),null===e?null:e.stateNode},injectIntoDevTools:function(e){var n=e.findFiberByHostInstance;return ht(wn({},e,{findHostInstanceByFiber:function(e){return t(e)},findFiberByHostInstance:function(e){return n?n(e):null}}))}}}function Rt(e,t,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Oo,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}function Ft(e){return!!Xo.hasOwnProperty(e)||!Yo.hasOwnProperty(e)&&(Go.test(e)?Xo[e]=!0:(Yo[e]=!0,!1))}function Dt(e,t,n){var r=a(t);if(r&&i(t,n)){var o=r.mutationMethod;o?o(e,n):null==n||r.hasBooleanValue&&!n||r.hasNumericValue&&isNaN(n)||r.hasPositiveNumericValue&&1>n||r.hasOverloadedBooleanValue&&!1===n?zt(e,t):r.mustUseProperty?e[r.propertyName]=n:(t=r.attributeName,(o=r.attributeNamespace)?e.setAttributeNS(o,t,""+n):r.hasBooleanValue||r.hasOverloadedBooleanValue&&!0===n?e.setAttribute(t,""):e.setAttribute(t,""+n))}else Lt(e,t,i(t,n)?n:null)}function Lt(e,t,n){Ft(t)&&(null==n?e.removeAttribute(t):e.setAttribute(t,""+n))}function zt(e,t){var n=a(t);n?(t=n.mutationMethod)?t(e,void 0):n.mustUseProperty?e[n.propertyName]=!n.hasBooleanValue&&"":e.removeAttribute(n.attributeName):e.removeAttribute(t)}function Vt(e,t){var n=t.value,r=t.checked;return wn({type:void 0,step:void 0,min:void 0,max:void 0},t,{defaultChecked:void 0,defaultValue:void 0,value:null!=n?n:e._wrapperState.initialValue,checked:null!=r?r:e._wrapperState.initialChecked})}function Ut(e,t){var n=t.defaultValue;e._wrapperState={initialChecked:null!=t.checked?t.checked:t.defaultChecked,initialValue:null!=t.value?t.value:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value}}function Wt(e,t){null!=(t=t.checked)&&Dt(e,"checked",t)}function Ht(e,t){Wt(e,t);var n=t.value;null!=n?0===n&&""===e.value?e.value="0":"number"===t.type?(t=parseFloat(e.value)||0,(n!=t||n==t&&e.value!=n)&&(e.value=""+n)):e.value!==""+n&&(e.value=""+n):(null==t.value&&null!=t.defaultValue&&e.defaultValue!==""+t.defaultValue&&(e.defaultValue=""+t.defaultValue),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked))}function Bt(e,t){switch(t.type){case"submit":case"reset":break;case"color":case"date":case"datetime":case"datetime-local":case"month":case"time":case"week":e.value="",e.value=e.defaultValue;break;default:e.value=e.value}t=e.name,""!==t&&(e.name=""),e.defaultChecked=!e.defaultChecked,e.defaultChecked=!e.defaultChecked,""!==t&&(e.name=t)}function Kt(e){var t="";return gn.Children.forEach(e,function(e){null==e||"string"!=typeof e&&"number"!=typeof e||(t+=e)}),t}function qt(e,t){return e=wn({children:void 0},t),(t=Kt(t.children))&&(e.children=t),e}function Gt(e,t,n,r){if(e=e.options,t){t={};for(var o=0;o<n.length;o++)t["$"+n[o]]=!0;for(n=0;n<e.length;n++)o=t.hasOwnProperty("$"+e[n].value),e[n].selected!==o&&(e[n].selected=o),o&&r&&(e[n].defaultSelected=!0)}else{for(n=""+n,t=null,o=0;o<e.length;o++){if(e[o].value===n)return e[o].selected=!0,void(r&&(e[o].defaultSelected=!0));null!==t||e[o].disabled||(t=e[o])}null!==t&&(t.selected=!0)}}function Yt(e,t){var n=t.value;e._wrapperState={initialValue:null!=n?n:t.defaultValue,wasMultiple:!!t.multiple}}function Xt(e,t){return null!=t.dangerouslySetInnerHTML&&r("91"),wn({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function $t(e,t){var n=t.value;null==n&&(n=t.defaultValue,t=t.children,null!=t&&(null!=n&&r("92"),Array.isArray(t)&&(1>=t.length||r("93"),t=t[0]),n=""+t),null==n&&(n="")),e._wrapperState={initialValue:""+n}}function Qt(e,t){var n=t.value;null!=n&&(n=""+n,n!==e.value&&(e.value=n),null==t.defaultValue&&(e.defaultValue=n)),null!=t.defaultValue&&(e.defaultValue=t.defaultValue)}function Jt(e){var t=e.textContent;t===e._wrapperState.initialValue&&(e.value=t)}function Zt(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function en(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?Zt(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}function tn(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t}function nn(e,t){e=e.style;for(var n in t)if(t.hasOwnProperty(n)){var r=0===n.indexOf("--"),o=n,i=t[n];o=null==i||"boolean"==typeof i||""===i?"":r||"number"!=typeof i||0===i||Zo.hasOwnProperty(o)&&Zo[o]?(""+i).trim():i+"px","float"===n&&(n="cssFloat"),r?e.setProperty(n,o):e[n]=o}}function rn(e,t,n){t&&(ti[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML)&&r("137",e,n()),null!=t.dangerouslySetInnerHTML&&(null!=t.children&&r("60"),"object"==typeof t.dangerouslySetInnerHTML&&"__html"in t.dangerouslySetInnerHTML||r("61")),null!=t.style&&"object"!=typeof t.style&&r("62",n()))}function on(e,t){if(-1===e.indexOf("-"))return"string"==typeof t.is;switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}function an(e,t){e=9===e.nodeType||11===e.nodeType?e:e.ownerDocument;var n=Re(e);t=$n[t];for(var r=0;r<t.length;r++){var o=t[r];n.hasOwnProperty(o)&&n[o]||("topScroll"===o?je("topScroll","scroll",e):"topFocus"===o||"topBlur"===o?(je("topFocus","focus",e),je("topBlur","blur",e),n.topBlur=!0,n.topFocus=!0):"topCancel"===o?(ne("cancel",!0)&&je("topCancel","cancel",e),n.topCancel=!0):"topClose"===o?(ne("close",!0)&&je("topClose","close",e),n.topClose=!0):Xr.hasOwnProperty(o)&&Me(o,Xr[o],e),n[o]=!0)}}function un(e,t,n,r){return n=9===n.nodeType?n:n.ownerDocument,r===ni&&(r=Zt(e)),r===ni?"script"===e?(e=n.createElement("div"),e.innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):e="string"==typeof t.is?n.createElement(e,{is:t.is}):n.createElement(e):e=n.createElementNS(r,e),e}function sn(e,t){return(9===t.nodeType?t:t.ownerDocument).createTextNode(e)}function ln(e,t,n,r){var o=on(t,n);switch(t){case"iframe":case"object":Me("topLoad","load",e);var i=n;break;case"video":case"audio":for(i in oi)oi.hasOwnProperty(i)&&Me(i,oi[i],e);i=n;break;case"source":Me("topError","error",e),i=n;break;case"img":case"image":Me("topError","error",e),Me("topLoad","load",e),i=n;break;case"form":Me("topReset","reset",e),Me("topSubmit","submit",e),i=n;break;case"details":Me("topToggle","toggle",e),i=n;break;case"input":Ut(e,n),i=Vt(e,n),Me("topInvalid","invalid",e),an(r,"onChange");break;case"option":i=qt(e,n);break;case"select":Yt(e,n),i=wn({},n,{value:void 0}),Me("topInvalid","invalid",e),an(r,"onChange");break;case"textarea":$t(e,n),i=Xt(e,n),Me("topInvalid","invalid",e),an(r,"onChange");break;default:i=n}rn(t,i,ri);var a,u=i;for(a in u)if(u.hasOwnProperty(a)){var s=u[a];"style"===a?nn(e,s,ri):"dangerouslySetInnerHTML"===a?null!=(s=s?s.__html:void 0)&&Jo(e,s):"children"===a?"string"==typeof s?("textarea"!==t||""!==s)&&tn(e,s):"number"==typeof s&&tn(e,""+s):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(Xn.hasOwnProperty(a)?null!=s&&an(r,a):o?Lt(e,a,s):null!=s&&Dt(e,a,s))}switch(t){case"input":ie(e),Bt(e,n);break;case"textarea":ie(e),Jt(e,n);break;case"option":null!=n.value&&e.setAttribute("value",n.value);break;case"select":e.multiple=!!n.multiple,t=n.value,null!=t?Gt(e,!!n.multiple,t,!1):null!=n.defaultValue&&Gt(e,!!n.multiple,n.defaultValue,!0);break;default:"function"==typeof i.onClick&&(e.onclick=xn)}}function cn(e,t,n,r,o){var i=null;switch(t){case"input":n=Vt(e,n),r=Vt(e,r),i=[];break;case"option":n=qt(e,n),r=qt(e,r),i=[];break;case"select":n=wn({},n,{value:void 0}),r=wn({},r,{value:void 0}),i=[];break;case"textarea":n=Xt(e,n),r=Xt(e,r),i=[];break;default:"function"!=typeof n.onClick&&"function"==typeof r.onClick&&(e.onclick=xn)}rn(t,r,ri);var a,u;e=null;for(a in n)if(!r.hasOwnProperty(a)&&n.hasOwnProperty(a)&&null!=n[a])if("style"===a)for(u in t=n[a])t.hasOwnProperty(u)&&(e||(e={}),e[u]="");else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(Xn.hasOwnProperty(a)?i||(i=[]):(i=i||[]).push(a,null));for(a in r){var s=r[a];if(t=null!=n?n[a]:void 0,r.hasOwnProperty(a)&&s!==t&&(null!=s||null!=t))if("style"===a)if(t){for(u in t)!t.hasOwnProperty(u)||s&&s.hasOwnProperty(u)||(e||(e={}),e[u]="");for(u in s)s.hasOwnProperty(u)&&t[u]!==s[u]&&(e||(e={}),e[u]=s[u])}else e||(i||(i=[]),i.push(a,e)),e=s;else"dangerouslySetInnerHTML"===a?(s=s?s.__html:void 0,t=t?t.__html:void 0,null!=s&&t!==s&&(i=i||[]).push(a,""+s)):"children"===a?t===s||"string"!=typeof s&&"number"!=typeof s||(i=i||[]).push(a,""+s):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(Xn.hasOwnProperty(a)?(null!=s&&an(o,a),i||t===s||(i=[])):(i=i||[]).push(a,s))}return e&&(i=i||[]).push("style",e),i}function fn(e,t,n,r,o){"input"===n&&"radio"===o.type&&null!=o.name&&Wt(e,o),on(n,r),r=on(n,o);for(var i=0;i<t.length;i+=2){var a=t[i],u=t[i+1];"style"===a?nn(e,u,ri):"dangerouslySetInnerHTML"===a?Jo(e,u):"children"===a?tn(e,u):r?null!=u?Lt(e,a,u):e.removeAttribute(a):null!=u?Dt(e,a,u):zt(e,a)}switch(n){case"input":Ht(e,o);break;case"textarea":Qt(e,o);break;case"select":e._wrapperState.initialValue=void 0,t=e._wrapperState.wasMultiple,e._wrapperState.wasMultiple=!!o.multiple,n=o.value,null!=n?Gt(e,!!o.multiple,n,!1):t!==!!o.multiple&&(null!=o.defaultValue?Gt(e,!!o.multiple,o.defaultValue,!0):Gt(e,!!o.multiple,o.multiple?[]:"",!1))}}function dn(e,t,n,r,o){switch(t){case"iframe":case"object":Me("topLoad","load",e);break;case"video":case"audio":for(var i in oi)oi.hasOwnProperty(i)&&Me(i,oi[i],e);break;case"source":Me("topError","error",e);break;case"img":case"image":Me("topError","error",e),Me("topLoad","load",e);break;case"form":Me("topReset","reset",e),Me("topSubmit","submit",e);break;case"details":Me("topToggle","toggle",e);break;case"input":Ut(e,n),Me("topInvalid","invalid",e),an(o,"onChange");break;case"select":Yt(e,n),Me("topInvalid","invalid",e),an(o,"onChange");break;case"textarea":$t(e,n),Me("topInvalid","invalid",e),an(o,"onChange")}rn(t,n,ri),r=null;for(var a in n)n.hasOwnProperty(a)&&(i=n[a],"children"===a?"string"==typeof i?e.textContent!==i&&(r=["children",i]):"number"==typeof i&&e.textContent!==""+i&&(r=["children",""+i]):Xn.hasOwnProperty(a)&&null!=i&&an(o,a));switch(t){case"input":ie(e),Bt(e,n);break;case"textarea":ie(e),Jt(e,n);break;case"select":case"option":break;default:"function"==typeof n.onClick&&(e.onclick=xn)}return r}function pn(e,t){return e.nodeValue!==t}function hn(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function yn(e){return!(!(e=e?9===e.nodeType?e.documentElement:e.firstChild:null)||1!==e.nodeType||!e.hasAttribute("data-reactroot"))}function vn(e,t,n,o,i){hn(n)||r("200");var a=n._reactRootContainer;if(a)si.updateContainer(t,a,e,i);else{if(!(o=o||yn(n)))for(a=void 0;a=n.lastChild;)n.removeChild(a);var u=si.createContainer(n,o);a=n._reactRootContainer=u,si.unbatchedUpdates(function(){si.updateContainer(t,u,e,i)})}return si.getPublicRootInstance(a)}function mn(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;return hn(t)||r("200"),Rt(e,t,null,n)}function bn(e,t){this._reactRootContainer=si.createContainer(e,t)}/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gn=n(1),_n=n(296),wn=n(297),xn=n(95),On=n(298),Sn=n(299),Tn=n(61),En=n(300),Cn=n(303),kn=n(304);gn||r("227");var Pn={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0},Mn={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(e){var t=Mn,n=e.Properties||{},i=e.DOMAttributeNamespaces||{},a=e.DOMAttributeNames||{};e=e.DOMMutationMethods||{};for(var u in n){jn.hasOwnProperty(u)&&r("48",u);var s=u.toLowerCase(),l=n[u];s={attributeName:s,attributeNamespace:null,propertyName:u,mutationMethod:null,mustUseProperty:o(l,t.MUST_USE_PROPERTY),hasBooleanValue:o(l,t.HAS_BOOLEAN_VALUE),hasNumericValue:o(l,t.HAS_NUMERIC_VALUE),hasPositiveNumericValue:o(l,t.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:o(l,t.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:o(l,t.HAS_STRING_BOOLEAN_VALUE)},1>=s.hasBooleanValue+s.hasNumericValue+s.hasOverloadedBooleanValue||r("50",u),a.hasOwnProperty(u)&&(s.attributeName=a[u]),i.hasOwnProperty(u)&&(s.attributeNamespace=i[u]),e.hasOwnProperty(u)&&(s.mutationMethod=e[u]),jn[u]=s}}},jn={},Nn=Mn,In=Nn.MUST_USE_PROPERTY,An=Nn.HAS_BOOLEAN_VALUE,Rn=Nn.HAS_NUMERIC_VALUE,Fn=Nn.HAS_POSITIVE_NUMERIC_VALUE,Dn=Nn.HAS_OVERLOADED_BOOLEAN_VALUE,Ln=Nn.HAS_STRING_BOOLEAN_VALUE,zn={Properties:{allowFullScreen:An,async:An,autoFocus:An,autoPlay:An,capture:Dn,checked:In|An,cols:Fn,contentEditable:Ln,controls:An,default:An,defer:An,disabled:An,download:Dn,draggable:Ln,formNoValidate:An,hidden:An,loop:An,multiple:In|An,muted:In|An,noValidate:An,open:An,playsInline:An,readOnly:An,required:An,reversed:An,rows:Fn,rowSpan:Rn,scoped:An,seamless:An,selected:In|An,size:Fn,start:Rn,span:Fn,spellCheck:Ln,style:0,tabIndex:0,itemScope:An,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ln},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(e,t){if(null==t)return e.removeAttribute("value");"number"!==e.type||!1===e.hasAttribute("value")?e.setAttribute("value",""+t):e.validity&&!e.validity.badInput&&e.ownerDocument.activeElement!==e&&e.setAttribute("value",""+t)}}},Vn=Nn.HAS_STRING_BOOLEAN_VALUE,Un={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Wn={Properties:{autoReverse:Vn,externalResourcesRequired:Vn,preserveAlpha:Vn},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:Un.xlink,xlinkArcrole:Un.xlink,xlinkHref:Un.xlink,xlinkRole:Un.xlink,xlinkShow:Un.xlink,xlinkTitle:Un.xlink,xlinkType:Un.xlink,xmlBase:Un.xml,xmlLang:Un.xml,xmlSpace:Un.xml}},Hn=/[\-\:]([a-z])/g;"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(e){var t=e.replace(Hn,u);Wn.Properties[t]=0,Wn.DOMAttributeNames[t]=e}),Nn.injectDOMPropertyConfig(zn),Nn.injectDOMPropertyConfig(Wn);var Bn={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(e){"function"!=typeof e.invokeGuardedCallback&&r("197"),s=e.invokeGuardedCallback}},invokeGuardedCallback:function(e,t,n,r,o,i,a,u,l){s.apply(Bn,arguments)},invokeGuardedCallbackAndCatchFirstError:function(e,t,n,r,o,i,a,u,s){if(Bn.invokeGuardedCallback.apply(this,arguments),Bn.hasCaughtError()){var l=Bn.clearCaughtError();Bn._hasRethrowError||(Bn._hasRethrowError=!0,Bn._rethrowError=l)}},rethrowCaughtError:function(){return l.apply(Bn,arguments)},hasCaughtError:function(){return Bn._hasCaughtError},clearCaughtError:function(){if(Bn._hasCaughtError){var e=Bn._caughtError;return Bn._caughtError=null,Bn._hasCaughtError=!1,e}r("198")}},Kn=null,qn={},Gn=[],Yn={},Xn={},$n={},Qn=Object.freeze({plugins:Gn,eventNameDispatchConfigs:Yn,registrationNameModules:Xn,registrationNameDependencies:$n,possibleRegistrationNames:null,injectEventPluginOrder:d,injectEventPluginsByName:p}),Jn=null,Zn=null,er=null,tr=null,nr={injectEventPluginOrder:d,injectEventPluginsByName:p},rr=Object.freeze({injection:nr,getListener:_,extractEvents:w,enqueueEvents:x,processEventQueue:O}),or=Math.random().toString(36).slice(2),ir="__reactInternalInstance$"+or,ar="__reactEventHandlers$"+or,ur=Object.freeze({precacheFiberNode:function(e,t){t[ir]=e},getClosestInstanceFromNode:S,getInstanceFromNode:function(e){return e=e[ir],!e||5!==e.tag&&6!==e.tag?null:e},getNodeFromInstance:T,getFiberCurrentPropsFromNode:E,updateFiberProps:function(e,t){e[ar]=t}}),sr=Object.freeze({accumulateTwoPhaseDispatches:A,accumulateTwoPhaseDispatchesSkipTarget:function(e){v(e,j)},accumulateEnterLeaveDispatches:R,accumulateDirectDispatches:function(e){v(e,I)}}),lr=null,cr={_root:null,_startText:null,_fallbackText:null},fr="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),dr={type:null,target:null,currentTarget:xn.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};wn(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=xn.thatReturnsTrue)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=xn.thatReturnsTrue)},persist:function(){this.isPersistent=xn.thatReturnsTrue},isPersistent:xn.thatReturnsFalse,destructor:function(){var e,t=this.constructor.Interface;for(e in t)this[e]=null;for(t=0;t<fr.length;t++)this[fr[t]]=null}}),z.Interface=dr,z.augmentClass=function(e,t){function n(){}n.prototype=this.prototype;var r=new n;wn(r,e.prototype),e.prototype=r,e.prototype.constructor=e,e.Interface=wn({},this.Interface,t),e.augmentClass=this.augmentClass,W(e)},W(z),z.augmentClass(H,{data:null}),z.augmentClass(B,{data:null});var pr=[9,13,27,32],hr=_n.canUseDOM&&"CompositionEvent"in window,yr=null;_n.canUseDOM&&"documentMode"in document&&(yr=document.documentMode);var vr;if(vr=_n.canUseDOM&&"TextEvent"in window&&!yr){var mr=window.opera;vr=!("object"==typeof mr&&"function"==typeof mr.version&&12>=parseInt(mr.version(),10))}var br,gr=vr,_r=_n.canUseDOM&&(!hr||yr&&8<yr&&11>=yr),wr=String.fromCharCode(32),xr={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Or=!1,Sr=!1,Tr={eventTypes:xr,extractEvents:function(e,t,n,r){var o;if(hr)e:{switch(e){case"topCompositionStart":var i=xr.compositionStart;break e;case"topCompositionEnd":i=xr.compositionEnd;break e;case"topCompositionUpdate":i=xr.compositionUpdate;break e}i=void 0}else Sr?K(e,n)&&(i=xr.compositionEnd):"topKeyDown"===e&&229===n.keyCode&&(i=xr.compositionStart);return i?(_r&&(Sr||i!==xr.compositionStart?i===xr.compositionEnd&&Sr&&(o=D()):(cr._root=r,cr._startText=L(),Sr=!0)),i=H.getPooled(i,t,n,r),o?i.data=o:null!==(o=q(n))&&(i.data=o),A(i),o=i):o=null,(e=gr?G(e,n):Y(e,n))?(t=B.getPooled(xr.beforeInput,t,n,r),t.data=e,A(t)):t=null,[o,t]}},Er=null,Cr=null,kr=null,Pr={injectFiberControlledHostComponent:function(e){Er=e}},Mr=Object.freeze({injection:Pr,enqueueStateRestore:$,restoreStateIfNeeded:Q}),jr=!1,Nr={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};_n.canUseDOM&&(br=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));var Ir={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}},Ar=null,Rr=null,Fr=!1;_n.canUseDOM&&(Fr=ne("input")&&(!document.documentMode||9<document.documentMode));var Dr={eventTypes:Ir,_isInputEventSupported:Fr,extractEvents:function(e,t,n,r){var o=t?T(t):window,i=o.nodeName&&o.nodeName.toLowerCase();if("select"===i||"input"===i&&"file"===o.type)var a=ce;else if(ee(o))if(Fr)a=ve;else{a=he;var u=pe}else!(i=o.nodeName)||"input"!==i.toLowerCase()||"checkbox"!==o.type&&"radio"!==o.type||(a=ye);if(a&&(a=a(e,t)))return ue(a,n,r);u&&u(e,o,t),"topBlur"===e&&null!=t&&(e=t._wrapperState||o._wrapperState)&&e.controlled&&"number"===o.type&&(e=""+o.value,o.getAttribute("value")!==e&&o.setAttribute("value",e))}};z.augmentClass(me,{view:null,detail:null});var Lr={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};me.augmentClass(_e,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ge,button:null,buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)}});var zr={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Vr={eventTypes:zr,extractEvents:function(e,t,n,r){if("topMouseOver"===e&&(n.relatedTarget||n.fromElement)||"topMouseOut"!==e&&"topMouseOver"!==e)return null;var o=r.window===r?r:(o=r.ownerDocument)?o.defaultView||o.parentWindow:window;if("topMouseOut"===e?(e=t,t=(t=n.relatedTarget||n.toElement)?S(t):null):e=null,e===t)return null;var i=null==e?o:T(e);o=null==t?o:T(t);var a=_e.getPooled(zr.mouseLeave,e,n,r);return a.type="mouseleave",a.target=i,a.relatedTarget=o,n=_e.getPooled(zr.mouseEnter,t,n,r),n.type="mouseenter",n.target=o,n.relatedTarget=i,R(a,n,e,t),[a,n]}},Ur=gn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,Wr=[],Hr=!0,Br=void 0,Kr=Object.freeze({get _enabled(){return Hr},get _handleTopLevel(){return Br},setHandleTopLevel:function(e){Br=e},setEnabled:Pe,isEnabled:function(){return Hr},trapBubbledEvent:Me,trapCapturedEvent:je,dispatchEvent:Ne}),qr={animationend:Ie("Animation","AnimationEnd"),animationiteration:Ie("Animation","AnimationIteration"),animationstart:Ie("Animation","AnimationStart"),transitionend:Ie("Transition","TransitionEnd")},Gr={},Yr={};_n.canUseDOM&&(Yr=document.createElement("div").style,"AnimationEvent"in window||(delete qr.animationend.animation,delete qr.animationiteration.animation,delete qr.animationstart.animation),"TransitionEvent"in window||delete qr.transitionend.transition);var Xr={topAbort:"abort",topAnimationEnd:Ae("animationend")||"animationend",topAnimationIteration:Ae("animationiteration")||"animationiteration",topAnimationStart:Ae("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",topTouchStart:"touchstart",topTransitionEnd:Ae("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},$r={},Qr=0,Jr="_reactListenersID"+(""+Math.random()).slice(2),Zr=_n.canUseDOM&&"documentMode"in document&&11>=document.documentMode,eo={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},to=null,no=null,ro=null,oo=!1,io={eventTypes:eo,extractEvents:function(e,t,n,r){var o,i=r.window===r?r.document:9===r.nodeType?r:r.ownerDocument;if(!(o=!i)){e:{i=Re(i),o=$n.onSelect;for(var a=0;a<o.length;a++){var u=o[a];if(!i.hasOwnProperty(u)||!i[u]){i=!1;break e}}i=!0}o=!i}if(o)return null;switch(i=t?T(t):window,e){case"topFocus":(ee(i)||"true"===i.contentEditable)&&(to=i,no=t,ro=null);break;case"topBlur":ro=no=to=null;break;case"topMouseDown":oo=!0;break;case"topContextMenu":case"topMouseUp":return oo=!1,ze(n,r);case"topSelectionChange":if(Zr)break;case"topKeyDown":case"topKeyUp":return ze(n,r)}return null}};z.augmentClass(Ve,{animationName:null,elapsedTime:null,pseudoElement:null}),z.augmentClass(Ue,{clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),me.augmentClass(We,{relatedTarget:null});var ao={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},uo={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};me.augmentClass(Be,{key:function(e){if(e.key){var t=ao[e.key]||e.key;if("Unidentified"!==t)return t}return"keypress"===e.type?(e=He(e),13===e?"Enter":String.fromCharCode(e)):"keydown"===e.type||"keyup"===e.type?uo[e.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ge,charCode:function(e){return"keypress"===e.type?He(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?He(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),_e.augmentClass(Ke,{dataTransfer:null}),me.augmentClass(qe,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ge}),z.augmentClass(Ge,{propertyName:null,elapsedTime:null,pseudoElement:null}),_e.augmentClass(Ye,{deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null});var so={},lo={};"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(e){var t=e[0].toUpperCase()+e.slice(1),n="on"+t;t="top"+t,n={phasedRegistrationNames:{bubbled:n,captured:n+"Capture"},dependencies:[t]},so[e]=n,lo[t]=n});var co={eventTypes:so,extractEvents:function(e,t,n,r){var o=lo[e];if(!o)return null;switch(e){case"topKeyPress":if(0===He(n))return null;case"topKeyDown":case"topKeyUp":e=Be;break;case"topBlur":case"topFocus":e=We;break;case"topClick":if(2===n.button)return null;case"topDoubleClick":case"topMouseDown":case"topMouseMove":case"topMouseUp":case"topMouseOut":case"topMouseOver":case"topContextMenu":e=_e;break;case"topDrag":case"topDragEnd":case"topDragEnter":case"topDragExit":case"topDragLeave":case"topDragOver":case"topDragStart":case"topDrop":e=Ke;break;case"topTouchCancel":case"topTouchEnd":case"topTouchMove":case"topTouchStart":e=qe;break;case"topAnimationEnd":case"topAnimationIteration":case"topAnimationStart":e=Ve;break;case"topTransitionEnd":e=Ge;break;case"topScroll":e=me;break;case"topWheel":e=Ye;break;case"topCopy":case"topCut":case"topPaste":e=Ue;break;default:e=z}return t=e.getPooled(o,t,n,r),A(t),t}};Br=function(e,t,n,r){e=w(e,t,n,r),x(e),O(!1)},nr.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")),Jn=ur.getFiberCurrentPropsFromNode,Zn=ur.getInstanceFromNode,er=ur.getNodeFromInstance,nr.injectEventPluginsByName({SimpleEventPlugin:co,EnterLeaveEventPlugin:Vr,ChangeEventPlugin:Dr,SelectEventPlugin:io,BeforeInputEventPlugin:Tr});var fo=[],po=-1;new Set;var ho={current:kn},yo={current:!1},vo=kn,mo=null,bo=null,go="function"==typeof Symbol&&Symbol.for,_o=go?Symbol.for("react.element"):60103,wo=go?Symbol.for("react.call"):60104,xo=go?Symbol.for("react.return"):60105,Oo=go?Symbol.for("react.portal"):60106,So=go?Symbol.for("react.fragment"):60107,To="function"==typeof Symbol&&Symbol.iterator,Eo=Array.isArray,Co=Ct(!0),ko=Ct(!1),Po={},Mo=Object.freeze({default:At}),jo=Mo&&At||Mo,No=jo.default?jo.default:jo,Io="object"==typeof performance&&"function"==typeof performance.now,Ao=void 0;Ao=Io?function(){return performance.now()}:function(){return Date.now()};var Ro=void 0,Fo=void 0;if(_n.canUseDOM)if("function"!=typeof requestIdleCallback||"function"!=typeof cancelIdleCallback){var Do,Lo=null,zo=!1,Vo=-1,Uo=!1,Wo=0,Ho=33,Bo=33;Do=Io?{didTimeout:!1,timeRemaining:function(){var e=Wo-performance.now();return 0<e?e:0}}:{didTimeout:!1,timeRemaining:function(){var e=Wo-Date.now();return 0<e?e:0}};var Ko="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(e){if(e.source===window&&e.data===Ko){if(zo=!1,e=Ao(),0>=Wo-e){if(!(-1!==Vo&&Vo<=e))return void(Uo||(Uo=!0,requestAnimationFrame(qo)));Do.didTimeout=!0}else Do.didTimeout=!1;Vo=-1,e=Lo,Lo=null,null!==e&&e(Do)}},!1);var qo=function(e){Uo=!1;var t=e-Wo+Bo;t<Bo&&Ho<Bo?(8>t&&(t=8),Bo=t<Ho?Ho:t):Ho=t,Wo=e+Bo,zo||(zo=!0,window.postMessage(Ko,"*"))};Ro=function(e,t){return Lo=e,null!=t&&"number"==typeof t.timeout&&(Vo=Ao()+t.timeout),Uo||(Uo=!0,requestAnimationFrame(qo)),0},Fo=function(){Lo=null,zo=!1,Vo=-1}}else Ro=window.requestIdleCallback,Fo=window.cancelIdleCallback;else Ro=function(e){return setTimeout(function(){e({timeRemaining:function(){return 1/0}})})},Fo=function(e){clearTimeout(e)};var Go=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Yo={},Xo={},$o={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},Qo=void 0,Jo=function(e){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(t,n,r,o){MSApp.execUnsafeLocalFunction(function(){return e(t,n)})}:e}(function(e,t){if(e.namespaceURI!==$o.svg||"innerHTML"in e)e.innerHTML=t;else{for(Qo=Qo||document.createElement("div"),Qo.innerHTML="<svg>"+t+"</svg>",t=Qo.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}}),Zo={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ei=["Webkit","ms","Moz","O"];Object.keys(Zo).forEach(function(e){ei.forEach(function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),Zo[t]=Zo[e]})});var ti=wn({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0}),ni=$o.html,ri=xn.thatReturns(""),oi={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ii=Object.freeze({createElement:un,createTextNode:sn,setInitialProperties:ln,diffProperties:cn,updateProperties:fn,diffHydratedProperties:dn,diffHydratedText:pn,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(e,t,n){switch(t){case"input":if(Ht(e,n),t=n.name,"radio"===n.type&&null!=t){for(n=e;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<n.length;t++){var o=n[t];if(o!==e&&o.form===e.form){var i=E(o);i||r("90"),ae(o),Ht(o,i)}}}break;case"textarea":Qt(e,n);break;case"select":null!=(t=n.value)&&Gt(e,!!n.multiple,t,!1)}}});Pr.injectFiberControlledHostComponent(ii);var ai=null,ui=null,si=No({getRootHostContext:function(e){var t=e.nodeType;switch(t){case 9:case 11:e=(e=e.documentElement)?e.namespaceURI:en(null,"");break;default:t=8===t?e.parentNode:e,e=t.namespaceURI||null,t=t.tagName,e=en(e,t)}return e},getChildHostContext:function(e,t){return en(e,t)},getPublicInstance:function(e){return e},prepareForCommit:function(){ai=Hr;var e=Sn();if(Le(e)){if("selectionStart"in e)var t={start:e.selectionStart,end:e.selectionEnd};else e:{var n=window.getSelection&&window.getSelection();if(n&&0!==n.rangeCount){t=n.anchorNode;var r=n.anchorOffset,o=n.focusNode;n=n.focusOffset;try{t.nodeType,o.nodeType}catch(e){t=null;break e}var i=0,a=-1,u=-1,s=0,l=0,c=e,f=null;t:for(;;){for(var d;c!==t||0!==r&&3!==c.nodeType||(a=i+r),c!==o||0!==n&&3!==c.nodeType||(u=i+n),3===c.nodeType&&(i+=c.nodeValue.length),null!==(d=c.firstChild);)f=c,c=d;for(;;){if(c===e)break t;if(f===t&&++s===r&&(a=i),f===o&&++l===n&&(u=i),null!==(d=c.nextSibling))break;c=f,f=c.parentNode}c=d}t=-1===a||-1===u?null:{start:a,end:u}}else t=null}t=t||{start:0,end:0}}else t=null;ui={focusedElem:e,selectionRange:t},Pe(!1)},resetAfterCommit:function(){var e=ui,t=Sn(),n=e.focusedElem,r=e.selectionRange;if(t!==n&&En(document.documentElement,n)){if(Le(n))if(t=r.start,e=r.end,void 0===e&&(e=t),"selectionStart"in n)n.selectionStart=t,n.selectionEnd=Math.min(e,n.value.length);else if(window.getSelection){t=window.getSelection();var o=n[F()].length;e=Math.min(r.start,o),r=void 0===r.end?e:Math.min(r.end,o),!t.extend&&e>r&&(o=r,r=e,e=o),o=De(n,e);var i=De(n,r);if(o&&i&&(1!==t.rangeCount||t.anchorNode!==o.node||t.anchorOffset!==o.offset||t.focusNode!==i.node||t.focusOffset!==i.offset)){var a=document.createRange();a.setStart(o.node,o.offset),t.removeAllRanges(),e>r?(t.addRange(a),t.extend(i.node,i.offset)):(a.setEnd(i.node,i.offset),t.addRange(a))}}for(t=[],e=n;e=e.parentNode;)1===e.nodeType&&t.push({element:e,left:e.scrollLeft,top:e.scrollTop});for(Cn(n),n=0;n<t.length;n++)e=t[n],e.element.scrollLeft=e.left,e.element.scrollTop=e.top}ui=null,Pe(ai),ai=null},createInstance:function(e,t,n,r,o){return e=un(e,t,n,r),e[ir]=o,e[ar]=t,e},appendInitialChild:function(e,t){e.appendChild(t)},finalizeInitialChildren:function(e,t,n,r){ln(e,t,n,r);e:{switch(t){case"button":case"input":case"select":case"textarea":e=!!n.autoFocus;break e}e=!1}return e},prepareUpdate:function(e,t,n,r,o){return cn(e,t,n,r,o)},shouldSetTextContent:function(e,t){return"textarea"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&"string"==typeof t.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(e,t){return!!t.hidden},createTextInstance:function(e,t,n,r){return e=sn(e,t),e[ir]=r,e},now:Ao,mutation:{commitMount:function(e){e.focus()},commitUpdate:function(e,t,n,r,o){e[ar]=o,fn(e,t,n,r,o)},resetTextContent:function(e){e.textContent=""},commitTextUpdate:function(e,t,n){e.nodeValue=n},appendChild:function(e,t){e.appendChild(t)},appendChildToContainer:function(e,t){8===e.nodeType?e.parentNode.insertBefore(t,e):e.appendChild(t)},insertBefore:function(e,t,n){e.insertBefore(t,n)},insertInContainerBefore:function(e,t,n){8===e.nodeType?e.parentNode.insertBefore(t,n):e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},removeChildFromContainer:function(e,t){8===e.nodeType?e.parentNode.removeChild(t):e.removeChild(t)}},hydration:{canHydrateInstance:function(e,t){return 1!==e.nodeType||t.toLowerCase()!==e.nodeName.toLowerCase()?null:e},canHydrateTextInstance:function(e,t){return""===t||3!==e.nodeType?null:e},getNextHydratableSibling:function(e){for(e=e.nextSibling;e&&1!==e.nodeType&&3!==e.nodeType;)e=e.nextSibling;return e},getFirstHydratableChild:function(e){for(e=e.firstChild;e&&1!==e.nodeType&&3!==e.nodeType;)e=e.nextSibling;return e},hydrateInstance:function(e,t,n,r,o,i){return e[ir]=i,e[ar]=n,dn(e,t,n,o,r)},hydrateTextInstance:function(e,t,n){return e[ir]=n,pn(e,t)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:Ro,cancelDeferredCallback:Fo,useSyncScheduling:!0});J=si.batchedUpdates,bn.prototype.render=function(e,t){si.updateContainer(e,this._reactRootContainer,null,t)},bn.prototype.unmount=function(e){si.updateContainer(null,this._reactRootContainer,null,e)};var li={createPortal:mn,findDOMNode:function(e){if(null==e)return null;if(1===e.nodeType)return e;var t=e._reactInternalFiber;if(t)return si.findHostInstance(t);"function"==typeof e.render?r("188"):r("213",Object.keys(e))},hydrate:function(e,t,n){return vn(null,e,t,!0,n)},render:function(e,t,n){return vn(null,e,t,!1,n)},unstable_renderSubtreeIntoContainer:function(e,t,n,o){return(null==e||void 0===e._reactInternalFiber)&&r("38"),vn(e,t,n,!1,o)},unmountComponentAtNode:function(e){return hn(e)||r("40"),!!e._reactRootContainer&&(si.unbatchedUpdates(function(){vn(null,null,e,!1,function(){e._reactRootContainer=null})}),!0)},unstable_createPortal:mn,unstable_batchedUpdates:Z,unstable_deferredUpdates:si.deferredUpdates,flushSync:si.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:rr,EventPluginRegistry:Qn,EventPropagators:sr,ReactControlledComponent:Mr,ReactDOMComponentTree:ur,ReactDOMEventListener:Kr}};si.injectIntoDevTools({findFiberByHostInstance:S,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var ci=Object.freeze({default:li}),fi=ci&&li||ci;e.exports=fi.default?fi.default:fi},function(e,t,n){"use strict";var r=!("undefined"==typeof window||!window.document||!window.document.createElement),o={canUseDOM:r,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:r&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:r&&!!window.screen,isInWorker:!r};e.exports=o},function(e,t,n){"use strict";function r(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var n,u,s=r(e),l=1;l<arguments.length;l++){n=Object(arguments[l]);for(var c in n)i.call(n,c)&&(s[c]=n[c]);if(o){u=o(n);for(var f=0;f<u.length;f++)a.call(n,u[f])&&(s[u[f]]=n[u[f]])}}return s}},function(e,t,n){"use strict";var r=n(95),o={listen:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!1),{remove:function(){e.removeEventListener(t,n,!1)}}):e.attachEvent?(e.attachEvent("on"+t,n),{remove:function(){e.detachEvent("on"+t,n)}}):void 0},capture:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!0),{remove:function(){e.removeEventListener(t,n,!0)}}):{remove:r}},registerDefault:function(){}};e.exports=o},function(e,t,n){"use strict";function r(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}e.exports=r},function(e,t,n){"use strict";function r(e,t){return!(!e||!t)&&(e===t||!o(e)&&(o(t)?r(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}var o=n(301);e.exports=r},function(e,t,n){"use strict";function r(e){return o(e)&&3==e.nodeType}var o=n(302);e.exports=r},function(e,t,n){"use strict";function r(e){var t=e?e.ownerDocument||e:document,n=t.defaultView||window;return!(!e||!("function"==typeof n.Node?e instanceof n.Node:"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName))}e.exports=r},function(e,t,n){"use strict";function r(e){try{e.focus()}catch(e){}}e.exports=r},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t,n){e.exports={default:n(306),__esModule:!0}},function(e,t,n){n(307),e.exports=n(24).Object.keys},function(e,t,n){var r=n(45),o=n(44);n(127)("keys",function(){return function(e){return o(r(e))}})},function(e,t,n){"use strict";function r(e,t,n){return(0,i.default)(e,t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.passiveOption=void 0;var o=n(128),i=function(e){return e&&e.__esModule?e:{default:e}}(o);t.passiveOption=function(){var e=null;return function(){if(null!==e)return e;var t=!1;try{window.addEventListener("test",null,r({},"passive",{get:function(){t=!0}}))}catch(e){}return e=t,t}()}(),t.default={}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=t.muiTheme.overlay,r={root:{position:"fixed",height:"100%",width:"100%",top:0,left:"-100%",opacity:0,backgroundColor:n.backgroundColor,WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",willChange:"opacity",transform:"translateZ(0)",transition:e.transitionEnabled&&E.default.easeOut("0ms","left","400ms")+", "+E.default.easeOut("400ms","opacity")}};return e.show&&(0,_.default)(r.root,{left:0,opacity:1,transition:E.default.easeOut("0ms","left")+", "+E.default.easeOut("400ms","opacity")}),r}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(17),E=r(T),C=n(310),k=r(C),P=function(e){function t(){return(0,d.default)(this,t),(0,v.default)(this,(t.__proto__||(0,c.default)(t)).apply(this,arguments))}return(0,b.default)(t,e),(0,h.default)(t,[{key:"setOpacity",value:function(e){this.refs.overlay.style.opacity=e}},{key:"render",value:function(){var e=this.props,t=e.autoLockScrolling,n=e.show,r=e.style,i=(e.transitionEnabled,(0,s.default)(e,["autoLockScrolling","show","style","transitionEnabled"])),u=this.context.muiTheme.prepareStyles,l=o(this.props,this.context);return x.default.createElement("div",(0,a.default)({},i,{ref:"overlay",style:u((0,_.default)(l.root,r))}),t&&x.default.createElement(k.default,{lock:n}))}}]),t}(w.Component);P.defaultProps={autoLockScrolling:!0,style:{},transitionEnabled:!0},P.contextTypes={muiTheme:S.default.object.isRequired},P.propTypes={},t.default=P},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(8),u=r(a),s=n(9),l=r(s),c=n(12),f=r(c),d=n(13),p=r(d),h=n(1),y=n(3),v=(r(y),null),m=0,b=function(e){function t(){var e,n,r,o;(0,u.default)(this,t);for(var a=arguments.length,s=Array(a),l=0;l<a;l++)s[l]=arguments[l];return n=r=(0,f.default)(this,(e=t.__proto__||(0,i.default)(t)).call.apply(e,[this].concat(s))),r.locked=!1,o=n,(0,f.default)(r,o)}return(0,p.default)(t,e),(0,l.default)(t,[{key:"componentDidMount",value:function(){!0===this.props.lock&&this.preventScrolling()}},{key:"componentWillReceiveProps",value:function(e){this.props.lock!==e.lock&&(e.lock?this.preventScrolling():this.allowScrolling())}},{key:"componentWillUnmount",value:function(){this.allowScrolling()}},{key:"preventScrolling",value:function(){if(!0!==this.locked&&(m+=1,this.locked=!0,1===m)){var e=document.getElementsByTagName("body")[0];v=e.style.overflow,e.style.overflow="hidden"}}},{key:"allowScrolling",value:function(){!0===this.locked&&(m-=1,this.locked=!1),0===m&&null!==v&&(document.getElementsByTagName("body")[0].style.overflow=v||"",v=null)}},{key:"render",value:function(){return null}}]),t}(h.Component);b.propTypes={},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.rounded,r=e.circle,o=e.transitionEnabled,i=e.zDepth,a=t.muiTheme,u=a.baseTheme,s=a.paper,l=a.borderRadius;return{root:{color:s.color,backgroundColor:s.backgroundColor,transition:o&&C.default.easeOut(),boxSizing:"border-box",fontFamily:u.fontFamily,WebkitTapHighlightColor:"rgba(0,0,0,0)",boxShadow:s.zDepthShadows[i-1],borderRadius:r?"50%":n?l:"0px"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(31),E=(r(T),n(17)),C=r(E),k=function(e){function t(){return(0,d.default)(this,t),(0,v.default)(this,(t.__proto__||(0,c.default)(t)).apply(this,arguments))}return(0,b.default)(t,e),(0,h.default)(t,[{key:"render",value:function(){var e=this.props,t=e.children,n=(e.circle,e.rounded,e.style),r=(e.transitionEnabled,e.zDepth,(0,s.default)(e,["children","circle","rounded","style","transitionEnabled","zDepth"])),i=this.context.muiTheme.prepareStyles,u=o(this.props,this.context);return x.default.createElement("div",(0,a.default)({},r,{style:i((0,_.default)(u.root,n))}),t)}}]),t}(w.Component);k.defaultProps={circle:!1,rounded:!0,transitionEnabled:!0,zDepth:1},k.contextTypes={muiTheme:S.default.object.isRequired},k.propTypes={},t.default=k},function(e,t){e.exports=function(){for(var e=arguments.length,t=[],n=0;n<e;n++)t[n]=arguments[n];if(t=t.filter(function(e){return null!=e}),0!==t.length)return 1===t.length?t[0]:t.reduce(function(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}})}},function(e,t,n){"use strict";function r(e){if(!e)return e;var t={};return i.Children.map(e,function(e){return e}).forEach(function(e){t[e.key]=e}),t}function o(e,t){function n(n){return t.hasOwnProperty(n)?t[n]:e[n]}e=e||{},t=t||{};var r={},o=[];for(var i in e)t.hasOwnProperty(i)?o.length&&(r[i]=o,o=[]):o.push(i);var a=void 0,u={};for(var s in t){if(r.hasOwnProperty(s))for(a=0;a<r[s].length;a++){var l=r[s][a];u[r[s][a]]=n(l)}u[s]=n(s)}for(a=0;a<o.length;a++)u[o[a]]=n(o[a]);return u}t.__esModule=!0,t.getChildMapping=r,t.mergeChildMappings=o;var i=n(1)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(8),u=r(a),s=n(9),l=r(s),c=n(12),f=r(c),d=n(13),p=r(d),h=n(10),y=r(h),v=n(1),m=r(v),b=n(3),g=r(b),_=n(23),w=r(_),x=n(36),O=r(x),S=n(66),T=r(S),E=n(17),C=r(E),k=n(315),P=r(k),M=750,j=function(e){function t(){var e,n,r,o;(0,u.default)(this,t);for(var a=arguments.length,s=Array(a),l=0;l<a;l++)s[l]=arguments[l];return n=r=(0,f.default)(this,(e=t.__proto__||(0,i.default)(t)).call.apply(e,[this].concat(s))),r.pulsate=function(){var e=w.default.findDOMNode(r.refs.innerCircle);if(e){var t=e.style.transform||"scale(1)",n="scale(1)"===t?"scale(0.85)":"scale(1)";T.default.set(e.style,"transform",n),r.timeout=setTimeout(r.pulsate,M)}},o=n,(0,f.default)(r,o)}return(0,p.default)(t,e),(0,l.default)(t,[{key:"componentDidMount",value:function(){this.props.show&&(this.setRippleSize(),this.pulsate())}},{key:"shouldComponentUpdate",value:function(e,t){return!(0,O.default)(this.props,e)||!(0,O.default)(this.state,t)}},{key:"componentDidUpdate",value:function(){this.props.show?(this.setRippleSize(),this.pulsate()):this.timeout&&clearTimeout(this.timeout)}},{key:"componentWillUnmount",value:function(){clearTimeout(this.timeout)}},{key:"getRippleElement",value:function(e){var t=e.color,n=e.innerStyle,r=e.opacity,o=this.context.muiTheme,i=o.prepareStyles,a=o.ripple,u=(0,y.default)({position:"absolute",height:"100%",width:"100%",borderRadius:"50%",opacity:r||.16,backgroundColor:t||a.color,transition:C.default.easeOut(M+"ms","transform",null,C.default.easeInOutFunction)},n);return m.default.createElement("div",{ref:"innerCircle",style:i((0,y.default)({},u))})}},{key:"setRippleSize",value:function(){var e=w.default.findDOMNode(this.refs.innerCircle),t=e.offsetHeight,n=e.offsetWidth,r=Math.max(t,n),o=0;-1!==e.style.top.indexOf("px",e.style.top.length-2)&&(o=parseInt(e.style.top)),e.style.height=r+"px",e.style.top=t/2-r/2+o+"px"}},{key:"render",value:function(){var e=this.props,t=e.show,n=e.style,r=(0,y.default)({height:"100%",width:"100%",position:"absolute",top:0,left:0},n),o=t?this.getRippleElement(this.props):null;return m.default.createElement(P.default,{maxScale:.85,style:r},o)}}]),t}(v.Component);j.contextTypes={muiTheme:g.default.object.isRequired},j.propTypes={},t.default=j},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(96),T=r(S),E=n(316),C=r(E),k=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"render",value:function(){var e=this.props,t=e.children,n=e.childStyle,r=e.enterDelay,o=e.maxScale,a=e.minScale,s=e.style,l=(0,u.default)(e,["children","childStyle","enterDelay","maxScale","minScale","style"]),c=this.context.muiTheme.prepareStyles,f=(0,g.default)({},{position:"relative",height:"100%"},s),d=w.default.Children.map(t,function(e){return w.default.createElement(C.default,{key:e.key,enterDelay:r,maxScale:o,minScale:a,style:n},e)});return w.default.createElement(T.default,(0,i.default)({},l,{style:c(f),component:"div"}),d)}}]),t}(_.Component);k.defaultProps={enterDelay:0},k.contextTypes={muiTheme:O.default.object.isRequired},k.propTypes={},t.default=k},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(23),T=r(S),E=n(66),C=r(E),k=n(17),P=r(k),M=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"componentWillUnmount",value:function(){clearTimeout(this.enterTimer),clearTimeout(this.leaveTimer)}},{key:"componentWillAppear",value:function(e){this.initializeAnimation(e)}},{key:"componentWillEnter",value:function(e){this.initializeAnimation(e)}},{key:"componentDidAppear",value:function(){this.animate()}},{key:"componentDidEnter",value:function(){this.animate()}},{key:"componentWillLeave",value:function(e){var t=T.default.findDOMNode(this).style;t.opacity="0",C.default.set(t,"transform","scale("+this.props.minScale+")"),this.leaveTimer=setTimeout(e,450)}},{key:"animate",value:function(){var e=T.default.findDOMNode(this).style;e.opacity="1",C.default.set(e,"transform","scale("+this.props.maxScale+")")}},{key:"initializeAnimation",value:function(e){var t=T.default.findDOMNode(this).style;t.opacity="0",C.default.set(t,"transform","scale(0)"),this.enterTimer=setTimeout(e,this.props.enterDelay)}},{key:"render",value:function(){var e=this.props,t=e.children,n=(e.enterDelay,e.maxScale,e.minScale,e.style),r=(0,u.default)(e,["children","enterDelay","maxScale","minScale","style"]),o=this.context.muiTheme.prepareStyles,a=(0,g.default)({},{position:"absolute",height:"100%",width:"100%",top:0,left:0,transition:P.default.easeOut(null,["transform","opacity"])},n);return w.default.createElement("div",(0,i.default)({},r,{style:o(a)}),t)}}]),t}(_.Component);M.defaultProps={enterDelay:0,maxScale:1,minScale:0},M.contextTypes={muiTheme:O.default.object.isRequired},M.propTypes={},t.default=M},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(318),i=r(o),a=n(11),u=r(a),s=n(8),l=r(s),c=n(9),f=r(c),d=n(12),p=r(d),h=n(13),y=r(h),v=n(140),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(23),T=r(S),E=n(96),C=r(E),k=n(135),P=r(k),M=n(327),j=r(M),N=function(e){return(0,m.default)(e).slice(1)},I=function(e){function t(e,n){(0,l.default)(this,t);var r=(0,p.default)(this,(t.__proto__||(0,u.default)(t)).call(this,e,n));return r.handleMouseDown=function(e){0===e.button&&r.start(e,!1)},r.handleMouseUp=function(){r.end()},r.handleMouseLeave=function(){r.end()},r.handleTouchStart=function(e){e.stopPropagation(),r.props.abortOnScroll&&e.touches&&(r.startListeningForScrollAbort(e),r.startTime=Date.now()),r.start(e,!0)},r.handleTouchEnd=function(){r.end()},r.handleTouchMove=function(e){if(Math.abs(Date.now()-r.startTime)>300)return void r.stopListeningForScrollAbort();var t=Math.abs(e.touches[0].clientY-r.firstTouchY),n=Math.abs(e.touches[0].clientX-r.firstTouchX);if(t>6||n>6){var o=r.state.ripples,a=o[0],u=w.default.cloneElement(a,{aborted:!0});o=N(o),o=[].concat((0,i.default)(o),[u]),r.setState({ripples:o},function(){r.end()})}},r.ignoreNextMouseDown=!1,r.state={hasRipples:!1,nextKey:0,ripples:[]},r}return(0,y.default)(t,e),(0,f.default)(t,[{key:"start",value:function(e,t){var n=this.context.muiTheme.ripple;if(this.ignoreNextMouseDown&&!t)return void(this.ignoreNextMouseDown=!1);var r=this.state.ripples;r=[].concat((0,i.default)(r),[w.default.createElement(j.default,{key:this.state.nextKey,style:this.props.centerRipple?{}:this.getRippleStyle(e),color:this.props.color||n.color,opacity:this.props.opacity,touchGenerated:t})]),this.ignoreNextMouseDown=t,this.setState({hasRipples:!0,nextKey:this.state.nextKey+1,ripples:r})}},{key:"end",value:function(){var e=this.state.ripples;this.setState({ripples:N(e)}),this.props.abortOnScroll&&this.stopListeningForScrollAbort()}},{key:"startListeningForScrollAbort",value:function(e){this.firstTouchY=e.touches[0].clientY,this.firstTouchX=e.touches[0].clientX,document.body.addEventListener("touchmove",this.handleTouchMove)}},{key:"stopListeningForScrollAbort",value:function(){document.body.removeEventListener("touchmove",this.handleTouchMove)}},{key:"getRippleStyle",value:function(e){var t=T.default.findDOMNode(this),n=t.offsetHeight,r=t.offsetWidth,o=P.default.offset(t),i=e.touches&&e.touches.length,a=i?e.touches[0].pageX:e.pageX,u=i?e.touches[0].pageY:e.pageY,s=a-o.left,l=u-o.top,c=this.calcDiag(s,l),f=this.calcDiag(r-s,l),d=this.calcDiag(r-s,n-l),p=this.calcDiag(s,n-l),h=Math.max(c,f,d,p),y=2*h;return{directionInvariant:!0,height:y,width:y,top:l-h,left:s-h}}},{key:"calcDiag",value:function(e,t){return Math.sqrt(e*e+t*t)}},{key:"render",value:function(){var e=this.props,t=e.children,n=e.style,r=this.state,o=r.hasRipples,i=r.ripples,a=this.context.muiTheme.prepareStyles,u=void 0;if(o){var s=(0,g.default)({height:"100%",width:"100%",position:"absolute",top:0,left:0,overflow:"hidden",pointerEvents:"none",zIndex:1},n);u=w.default.createElement(C.default,{style:a(s)},i)}return w.default.createElement("div",{onMouseUp:this.handleMouseUp,onMouseDown:this.handleMouseDown,onMouseLeave:this.handleMouseLeave,onTouchStart:this.handleTouchStart,onTouchEnd:this.handleTouchEnd},u,t)}}]),t}(_.Component);I.defaultProps={abortOnScroll:!0},I.contextTypes={muiTheme:O.default.object.isRequired},I.propTypes={},t.default=I},function(e,t,n){"use strict";t.__esModule=!0;var r=n(139),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,o.default)(e)}},function(e,t,n){n(129),n(320),e.exports=n(24).Array.from},function(e,t,n){"use strict";var r=n(81),o=n(28),i=n(45),a=n(321),u=n(322),s=n(125),l=n(323),c=n(324);o(o.S+o.F*!n(326)(function(e){Array.from(e)}),"Array",{from:function(e){var t,n,o,f,d=i(e),p="function"==typeof this?this:Array,h=arguments.length,y=h>1?arguments[1]:void 0,v=void 0!==y,m=0,b=c(d);if(v&&(y=r(y,h>2?arguments[2]:void 0,2)),void 0==b||p==Array&&u(b))for(t=s(d.length),n=new p(t);t>m;m++)l(n,m,v?y(d[m],m):d[m]);else for(f=b.call(d),n=new p;!(o=f.next()).done;m++)l(n,m,v?a(f,y,[o.value,m],!0):o.value);return n.length=m,n}})},function(e,t,n){var r=n(39);e.exports=function(e,t,n,o){try{return o?t(r(n)[0],n[1]):t(n)}catch(t){var i=e.return;throw void 0!==i&&r(i.call(e)),t}}},function(e,t,n){var r=n(46),o=n(26)("iterator"),i=Array.prototype;e.exports=function(e){return void 0!==e&&(r.Array===e||i[o]===e)}},function(e,t,n){"use strict";var r=n(30),o=n(43);e.exports=function(e,t,n){t in e?r.f(e,t,o(0,n)):e[t]=n}},function(e,t,n){var r=n(325),o=n(26)("iterator"),i=n(46);e.exports=n(24).getIteratorMethod=function(e){if(void 0!=e)return e[o]||e["@@iterator"]||i[r(e)]}},function(e,t,n){var r=n(83),o=n(26)("toStringTag"),i="Arguments"==r(function(){return arguments}()),a=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,u;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=a(t=Object(e),o))?n:i?r(t):"Object"==(u=r(t))&&"function"==typeof t.callee?"Arguments":u}},function(e,t,n){var r=n(26)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},e(i)}catch(e){}return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(23),T=r(S),E=n(36),C=r(E),k=n(66),P=r(k),M=n(17),j=r(M),N=function(e){function t(){return(0,f.default)(this,t),(0,y.default)(this,(t.__proto__||(0,l.default)(t)).apply(this,arguments))}return(0,m.default)(t,e),(0,p.default)(t,[{key:"shouldComponentUpdate",value:function(e){return!(0,C.default)(this.props,e)}},{key:"componentWillUnmount",value:function(){clearTimeout(this.enterTimer),clearTimeout(this.leaveTimer)}},{key:"componentWillAppear",value:function(e){this.initializeAnimation(e)}},{key:"componentWillEnter",value:function(e){this.initializeAnimation(e)}},{key:"componentDidAppear",value:function(){this.animate()}},{key:"componentDidEnter",value:function(){this.animate()}},{key:"componentWillLeave",value:function(e){T.default.findDOMNode(this).style.opacity=0;var t=this.props.aborted?0:2e3;this.enterTimer=setTimeout(e,t)}},{key:"animate",value:function(){var e=T.default.findDOMNode(this).style,t=j.default.easeOut("2s","opacity")+", "+j.default.easeOut("1s","transform");P.default.set(e,"transition",t),P.default.set(e,"transform","scale(1)")}},{key:"initializeAnimation",value:function(e){var t=T.default.findDOMNode(this).style;t.opacity=this.props.opacity,P.default.set(t,"transform","scale(0)"),this.leaveTimer=setTimeout(e,0)}},{key:"render",value:function(){var e=this.props,t=(e.aborted,e.color),n=(e.opacity,e.style),r=(e.touchGenerated,(0,u.default)(e,["aborted","color","opacity","style","touchGenerated"])),o=this.context.muiTheme.prepareStyles,a=(0,g.default)({position:"absolute",top:0,left:0,height:"100%",width:"100%",borderRadius:"50%",backgroundColor:t},n);return w.default.createElement("div",(0,i.default)({},r,{style:o(a)}))}}]),t}(_.Component);N.defaultProps={opacity:.1,aborted:!1},N.contextTypes={muiTheme:O.default.object.isRequired},N.propTypes={},t.default=N},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=t.muiTheme.baseTheme;return{root:{position:"relative",paddingLeft:n.spacing.desktopGutterLess,paddingRight:n.spacing.desktopGutterLess,verticalAlign:"middle"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(11),a=r(i),u=n(8),s=r(u),l=n(9),c=r(l),f=n(12),d=r(f),p=n(13),h=r(p),y=n(10),v=r(y),m=n(1),b=r(m),g=n(3),_=r(g),w=function(e){function t(){return(0,s.default)(this,t),(0,d.default)(this,(t.__proto__||(0,a.default)(t)).apply(this,arguments))}return(0,h.default)(t,e),(0,c.default)(t,[{key:"render",value:function(){var e=this.props,t=e.label,n=e.style,r=this.context.muiTheme.prepareStyles,i=o(this.props,this.context);return b.default.createElement("span",{style:r((0,v.default)(i.root,n))},t)}}]),t}(m.Component);w.contextTypes={muiTheme:_.default.object.isRequired},w.propTypes={},t.default=w},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(330),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=t.muiTheme,o=r.baseTheme.spacing.desktopSubheaderHeight,i=r.zIndex,a=n.open;return{root:{position:"fixed",left:"50%",display:"flex",bottom:0,zIndex:i.snackbar,visibility:a?"visible":"hidden",transform:a?"translate(-50%, 0)":"translate(-50%, "+o+"px)",transition:E.default.easeOut("400ms","transform")+", "+E.default.easeOut("400ms","visibility")}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(17),E=r(T),C=n(141),k=r(C),P=n(331),M=r(P),j=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.componentClickAway=function(){r.timerTransitionId||(null!==r.props.open&&r.props.onRequestClose?r.props.onRequestClose("clickaway"):r.setState({open:!1}))},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){this.setState({open:this.props.open,message:this.props.message,action:this.props.action})}},{key:"componentDidMount",value:function(){this.state.open&&(this.setAutoHideTimer(),this.setTransitionTimer())}},{key:"componentWillReceiveProps",value:function(e){var t=this;if(this.props.open&&e.open&&(e.message!==this.props.message||e.action!==this.props.action))this.setState({open:!1}),clearTimeout(this.timerOneAtTheTimeId),this.timerOneAtTheTimeId=setTimeout(function(){t.setState({message:e.message,action:e.action,open:!0})},400);else{var n=e.open;this.setState({open:null!==n?n:this.state.open,message:e.message,action:e.action})}}},{key:"componentDidUpdate",value:function(e,t){t.open!==this.state.open&&(this.state.open?(this.setAutoHideTimer(),this.setTransitionTimer()):clearTimeout(this.timerAutoHideId))}},{key:"componentWillUnmount",value:function(){clearTimeout(this.timerAutoHideId),clearTimeout(this.timerTransitionId),clearTimeout(this.timerOneAtTheTimeId)}},{key:"setAutoHideTimer",value:function(){var e=this,t=this.props.autoHideDuration;t>0&&(clearTimeout(this.timerAutoHideId),this.timerAutoHideId=setTimeout(function(){null!==e.props.open&&e.props.onRequestClose?e.props.onRequestClose("timeout"):e.setState({open:!1})},t))}},{key:"setTransitionTimer",value:function(){var e=this;this.timerTransitionId=setTimeout(function(){e.timerTransitionId=void 0},400)}},{key:"render",value:function(){var e=this.props,t=(e.autoHideDuration,e.contentStyle),n=e.bodyStyle,r=(e.message,e.onRequestClose,e.onActionTouchTap),i=e.style,u=(0,s.default)(e,["autoHideDuration","contentStyle","bodyStyle","message","onRequestClose","onActionTouchTap","style"]),l=this.state,c=l.action,f=l.message,d=l.open,p=this.context.muiTheme.prepareStyles,h=o(this.props,this.context,this.state);return x.default.createElement(k.default,{onClickAway:d?this.componentClickAway:null},x.default.createElement("div",(0,a.default)({},u,{style:p((0,_.default)(h.root,i))}),x.default.createElement(M.default,{action:c,contentStyle:t,message:f,open:d,onActionTouchTap:r,style:n})))}}]),t}(w.Component);j.contextTypes={muiTheme:S.default.object.isRequired},j.propTypes={},t.default=j},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=e.open,r=e.width,o=t.muiTheme,i=o.baseTheme,a=i.spacing,u=a.desktopGutter,s=a.desktopSubheaderHeight,l=i.fontFamily,c=o.snackbar,f=c.backgroundColor,d=c.textColor,p=c.actionColor,h=o.borderRadius,y=r===m.SMALL;return{root:{fontFamily:l,backgroundColor:f,padding:"0 "+u+"px",height:s,lineHeight:s+"px",borderRadius:y?0:h,maxWidth:y?"inherit":568,minWidth:y?"inherit":288,width:y?"calc(100vw - "+2*u+"px)":"auto",flexGrow:y?1:0},content:{fontSize:14,color:d,opacity:n?1:0,transition:n?v.default.easeOut("500ms","opacity","100ms"):v.default.easeOut("400ms","opacity")},action:{color:p,float:"right",marginTop:6,marginRight:-16,marginLeft:u,backgroundColor:"transparent"}}}Object.defineProperty(t,"__esModule",{value:!0}),t.SnackbarBody=void 0;var i=n(14),a=r(i),u=n(15),s=r(u),l=n(10),c=r(l),f=n(1),d=r(f),p=n(3),h=r(p),y=n(17),v=r(y),m=n(332),b=r(m),g=n(333),_=r(g),w=function(e,t){var n=e.action,r=e.contentStyle,i=e.message,u=(e.open,e.onActionTouchTap),l=e.style,f=(0,s.default)(e,["action","contentStyle","message","open","onActionTouchTap","style"]),p=t.muiTheme.prepareStyles,h=o(e,t),y=n&&d.default.createElement(_.default,{style:h.action,label:n,onClick:u});return d.default.createElement("div",(0,a.default)({},f,{style:p((0,c.default)(h.root,l))}),d.default.createElement("div",{style:p((0,c.default)(h.content,r))},d.default.createElement("span",null,i),y))};t.SnackbarBody=w,w.propTypes={},w.contextTypes={muiTheme:h.default.object.isRequired},t.default=(0,b.default)()(w)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.largeWidth,n=void 0===t?992:t,r=e.mediumWidth,o=void 0===r?768:r,i=e.resizeInterval,u=void 0===i?166:i;return function(e){return function(t){function r(){var e,t,n,o;(0,c.default)(this,r);for(var i=arguments.length,a=Array(i),l=0;l<i;l++)a[l]=arguments[l];return t=n=(0,h.default)(this,(e=r.__proto__||(0,s.default)(r)).call.apply(e,[this].concat(a))),n.state={width:null},n.handleResize=function(){clearTimeout(n.deferTimer),n.deferTimer=setTimeout(function(){n.updateWidth()},u)},o=t,(0,h.default)(n,o)}return(0,v.default)(r,t),(0,d.default)(r,[{key:"componentDidMount",value:function(){this.updateWidth()}},{key:"componentWillUnmount",value:function(){clearTimeout(this.deferTimer)}},{key:"updateWidth",value:function(){var e=window.innerWidth,t=void 0;(t=e>=n?O:e>=o?x:w)!==this.state.width&&this.setState({width:t})}},{key:"render",value:function(){var t=this.state.width;return null===t?null:b.default.createElement(_.default,{target:"window",onResize:this.handleResize},b.default.createElement(e,(0,a.default)({width:t},this.props)))}}]),r}(m.Component)}}Object.defineProperty(t,"__esModule",{value:!0}),t.LARGE=t.MEDIUM=t.SMALL=void 0;var i=n(14),a=r(i),u=n(11),s=r(u),l=n(8),c=r(l),f=n(9),d=r(f),p=n(12),h=r(p),y=n(13),v=r(y);t.default=o;var m=n(1),b=r(m),g=n(62),_=r(g),w=t.SMALL=1,x=t.MEDIUM=2,O=t.LARGE=3},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(136),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(3),f=r(c),d=n(1),p=r(d),h=n(98),y=r(h),v=n(142),m=r(v),b=n(337),g=r(b),_=n(338),w=r(_),x=n(707),O=r(x),S=n(708),T={createdBy:{color:"#818181"},titleBodySpace:{paddingTop:30},rules:{height:"240px",overflowY:"scroll"}},E=function(e){function t(e,n){i(this,t);var r=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.onAccessRuleChange=function(e){return function(t){var n=function(n){return n.id===e?s({},n,{access:t}):n},o=(r.props.sharedObject.object.userAccesses||[]).map(n),i=(r.props.sharedObject.object.userGroupAccesses||[]).map(n);r.props.onChange({userAccesses:o,userGroupAccesses:i})}},r.onAccessRemove=function(e){return function(){var t=function(t){return t.id!==e},n=(r.props.sharedObject.object.userAccesses||[]).filter(t),o=(r.props.sharedObject.object.userGroupAccesses||[]).filter(t);r.props.onChange({userAccesses:n,userGroupAccesses:o})}},r.onPublicAccessChange=function(e){r.props.onChange({publicAccess:e})},r.onExternalAccessChange=function(e){r.props.onChange({externalAccess:e})},r.setAccessListRef=function(e){r.accessListRef=e},r.accessListRef=null,r.addUserAccess=function(e){var t=r.props.sharedObject.object.userAccesses||[];r.props.onChange({userAccesses:[].concat(o(t),[e])},r.scrollAccessListToBottom())},r.addUserGroupAccess=function(e){var t=r.props.sharedObject.object.userGroupAccesses||[];r.props.onChange({userGroupAccesses:[].concat(o(t),[e])},r.scrollAccessListToBottom())},r.scrollAccessListToBottom=function(){r.accessListRef.scrollTop=r.accessListRef.scrollHeight},n.d2.i18n.addStrings(["who_has_access"]),r}return u(t,e),l(t,[{key:"render",value:function(){var e=this,t=this.props.sharedObject.object,n=t.user,r=t.displayName,o=t.userAccesses,i=t.userGroupAccesses,a=t.publicAccess,u=t.externalAccess,s=this.props.sharedObject.meta,l=s.allowPublicAccess,c=s.allowExternalAccess,f=(o||[]).map(function(e){return e.id}).concat((i||[]).map(function(e){return e.id}));return p.default.createElement("div",null,p.default.createElement(g.default,{text:r,level:2}),p.default.createElement(O.default,{author:n}),p.default.createElement("div",{style:T.titleBodySpace}),p.default.createElement(m.default,null,this.context.d2.i18n.getTranslation("who_has_access")),p.default.createElement(y.default,null),p.default.createElement("div",{style:T.rules,ref:this.setAccessListRef},p.default.createElement(S.PublicAccess,{access:a,disabled:!l,dataShareable:this.props.dataShareable,onChange:this.onPublicAccessChange}),p.default.createElement(y.default,null),p.default.createElement(S.ExternalAccess,{access:u,disabled:!c,onChange:this.onExternalAccessChange}),p.default.createElement(y.default,null),o&&o.map(function(t){return p.default.createElement("div",{key:t.id},p.default.createElement(S.GroupAccess,{groupName:t.displayName,groupType:"user",access:t.access,dataShareable:e.props.dataShareable,onRemove:e.onAccessRemove(t.id),onChange:e.onAccessRuleChange(t.id)}),p.default.createElement(y.default,null))}),i&&i.map(function(t){return p.default.createElement("div",{key:t.id},p.default.createElement(S.GroupAccess,{access:t.access,groupName:t.displayName,groupType:"userGroup",dataShareable:e.props.dataShareable,onRemove:e.onAccessRemove(t.id),onChange:e.onAccessRuleChange(t.id)}),p.default.createElement(y.default,null))})),p.default.createElement(w.default,{onSearch:this.props.onSearch,addUserAccess:this.addUserAccess,addUserGroupAccess:this.addUserGroupAccess,dataShareable:this.props.dataShareable,currentAccessIds:f}))}}]),t}(p.default.Component);E.propTypes={sharedObject:f.default.object.isRequired,dataShareable:f.default.bool.isRequired,onChange:f.default.func.isRequired,onSearch:f.default.func.isRequired},E.contextTypes={d2:f.default.object.isRequired},t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(10),l=r(s),c=n(1),f=r(c),d=n(3),p=r(d),h=function(e,t){var n=e.inset,r=e.style,o=(0,u.default)(e,["inset","style"]),a=t.muiTheme,s=a.baseTheme,c=a.prepareStyles,d={root:{margin:0,marginTop:-1,marginLeft:n?72:0,height:1,border:"none",backgroundColor:s.palette.borderColor}};return f.default.createElement("hr",(0,i.default)({},o,{style:c((0,l.default)(d.root,r))}))};h.muiName="Divider",h.propTypes={},h.defaultProps={inset:!1},h.contextTypes={muiTheme:p.default.object.isRequired},t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(10),l=r(s),c=n(1),f=r(c),d=n(3),p=r(d),h=function(e,t){var n=e.children,r=e.inset,o=e.style,a=(0,u.default)(e,["children","inset","style"]),s=t.muiTheme,c=s.prepareStyles,d=s.subheader,p={root:{boxSizing:"border-box",color:d.color,fontSize:14,fontWeight:d.fontWeight,lineHeight:"48px",paddingLeft:r?72:16,width:"100%"}};return f.default.createElement("div",(0,i.default)({},a,{style:c((0,l.default)(p.root,o))}),n)};h.muiName="Subheader",h.propTypes={},h.defaultProps={inset:!1},h.contextTypes={muiTheme:p.default.object.isRequired},t.default=h},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e){var t=e.level,n=e.text,o=e.style,i=e.children,u=r(e,["level","text","style","children"]),s={type:t<=6?"h"+t:"span"},c=l({fontSize:24,fontWeight:300,color:"rgba(0, 0, 0, 0.87)",padding:"16px 0 5px 0",margin:0},o);return a.a.createElement(s.type,l({},u,{style:c}),i||n)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(1),a=n.n(i),u=n(3),s=n.n(u),l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};o.propTypes={level:s.a.oneOf([1,2,3,4,5,6]),text:s.a.string},o.defaultProps={level:1},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=r(l),f=n(3),d=r(f),p=n(339),h=n(635),y=r(h),v=n(250),m=n(251),b=r(m),g={container:{fontWeight:"400",padding:16,backgroundColor:"#F5F5F5",display:"flex",flexDirection:"column",justifyContent:"center"},innerContainer:{display:"flex",flexDirection:"row",flex:1},title:{color:"#818181",paddingBottom:8},searchBox:{backgroundColor:"white",boxShadow:"2px 2px 2px #cccccc",padding:"0px 16px",marginRight:"16px"}},_=function(e){function t(e,n){o(this,t);var r=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={defaultAccess:{meta:{canView:!0,canEdit:!0},data:{canView:!1,canEdit:!1}},searchResult:[],searchText:""},r.onResultClick=function(e,t){r.inputStream.next("");var n=r.state.searchResult[t],o=n.type;delete n.type,"userAccess"===o?r.props.addUserAccess(u({},n,{access:(0,v.accessObjectToString)(r.state.defaultAccess)})):r.props.addUserGroupAccess(u({},n,{access:(0,v.accessObjectToString)(r.state.defaultAccess)})),r.clearSearchText()},r.inputStream=new p.Subject,r.hasNoCurrentAccess=function(e){return-1===r.props.currentAccessIds.indexOf(e.id)},r.fetchSearchResult=function(e){""===e?r.handleSearchResult([]):r.props.onSearch(e).then(function(e){var t=e.users,n=e.userGroups,o=function(e){return function(t){return u({},t,{type:e})}},i=t.map(o("userAccess")).filter(r.hasNoCurrentAccess).concat(n.map(o("userGroupAccess")).filter(r.hasNoCurrentAccess));r.handleSearchResult(i)})},r.handleSearchResult=function(e){r.setState({searchResult:e})},r.handleUpdateInput=function(e){r.inputStream.next(e),r.setState({searchText:e})},r.accessOptionsChanged=function(e){r.setState({defaultAccess:e})},r.clearSearchText=function(){r.setState({searchText:""})},r.noFilter=function(){return!0},n.d2.i18n.addStrings(["add_users_and_user_groups","enter_names"]),r}return a(t,e),s(t,[{key:"componentWillMount",value:function(){var e=this;this.inputStream.debounce(function(){return p.Observable.timer(300)}).subscribe(function(t){e.fetchSearchResult(t)})}},{key:"render",value:function(){return c.default.createElement("div",{style:g.container},c.default.createElement("div",{style:g.title},this.context.d2.i18n.getTranslation("add_users_and_user_groups")),c.default.createElement("div",{style:g.innerContainer},c.default.createElement(y.default,{fullWidth:!0,openOnFocus:!0,filter:this.noFilter,dataSource:this.state.searchResult,dataSourceConfig:{text:"displayName",value:"id"},hintText:this.context.d2.i18n.getTranslation("enter_names"),onNewRequest:this.onResultClick,onUpdateInput:this.handleUpdateInput,style:g.searchBox,searchText:this.state.searchText,underlineShow:!1}),c.default.createElement(b.default,{access:this.state.defaultAccess,accessOptions:{meta:{canView:!0,canEdit:!0,noAccess:!1},data:this.props.dataShareable&&{canView:!0,canEdit:!0,noAccess:!0}},onChange:this.accessOptionsChanged})))}}]),t}(l.Component);_.propTypes={onSearch:d.default.func.isRequired,addUserAccess:d.default.func.isRequired,dataShareable:d.default.bool.isRequired,addUserGroupAccess:d.default.func.isRequired,currentAccessIds:d.default.array.isRequired},_.contextTypes={d2:d.default.object.isRequired},t.default=_},function(e,t,n){"use strict";var r=n(19);t.Subject=r.Subject,t.AnonymousSubject=r.AnonymousSubject;var o=n(0);t.Observable=o.Observable,n(341),n(344),n(347),n(350),n(353),n(356),n(358),n(361),n(362),n(365),n(368),n(370),n(373),n(376),n(381),n(382),n(383),n(386),n(387),n(389),n(392),n(395),n(398),n(401),n(403),n(405),n(407),n(413),n(415),n(417),n(419),n(421),n(423),n(425),n(427),n(429),n(431),n(433),n(435),n(437),n(439),n(441),n(443),n(445),n(447),n(449),n(451),n(454),n(456),n(458),n(460),n(462),n(464),n(466),n(468),n(470),n(472),n(474),n(476),n(478),n(483),n(485),n(487),n(489),n(491),n(493),n(495),n(497),n(499),n(501),n(503),n(505),n(507),n(509),n(511),n(513),n(515),n(517),n(519),n(521),n(523),n(525),n(528),n(530),n(532),n(534),n(536),n(538),n(540),n(542),n(544),n(546),n(548),n(550),n(552),n(554),n(556),n(558),n(560),n(562),n(564),n(566),n(568),n(570),n(572),n(574),n(583),n(585),n(587),n(589),n(591),n(593),n(595),n(597),n(599),n(601),n(602),n(604),n(606),n(608),n(610),n(611),n(613),n(615),n(617),n(619),n(621),n(623),n(625);var i=n(18);t.Subscription=i.Subscription;var a=n(2);t.Subscriber=a.Subscriber;var u=n(71);t.AsyncSubject=u.AsyncSubject;var s=n(78);t.ReplaySubject=s.ReplaySubject;var l=n(201);t.BehaviorSubject=l.BehaviorSubject;var c=n(195);t.ConnectableObservable=c.ConnectableObservable;var f=n(50);t.Notification=f.Notification;var d=n(79);t.EmptyError=d.EmptyError;var p=n(56);t.ArgumentOutOfRangeError=p.ArgumentOutOfRangeError;var h=n(70);t.ObjectUnsubscribedError=h.ObjectUnsubscribedError;var y=n(231);t.TimeoutError=y.TimeoutError;var v=n(144);t.UnsubscriptionError=v.UnsubscriptionError;var m=n(228);t.TimeInterval=m.TimeInterval;var b=n(115);t.Timestamp=b.Timestamp;var g=n(627);t.TestScheduler=g.TestScheduler;var _=n(244);t.VirtualTimeScheduler=_.VirtualTimeScheduler;var w=n(155);t.AjaxResponse=w.AjaxResponse,t.AjaxError=w.AjaxError,t.AjaxTimeoutError=w.AjaxTimeoutError;var x=n(99);t.pipe=x.pipe;var O=n(220),S=n(16),T=n(156),E=n(630),C=n(68),k=n(48),P=n(69),M=n(634);t.operators=M;var j={asap:O.asap,queue:T.queue,animationFrame:E.animationFrame,async:S.async};t.Scheduler=j;var N={rxSubscriber:C.rxSubscriber,observable:P.observable,iterator:k.iterator};t.Symbol=N},function(e,t,n){"use strict";function r(e,t,n){if(e){if(e instanceof o.Subscriber)return e;if(e[i.rxSubscriber])return e[i.rxSubscriber]()}return e||t||n?new o.Subscriber(e,t,n):new o.Subscriber(a.empty)}var o=n(2),i=n(68),a=n(145);t.toSubscriber=r},function(e,t,n){"use strict";var r=n(0),o=n(342);r.Observable.bindCallback=o.bindCallback},function(e,t,n){"use strict";var r=n(343);t.bindCallback=r.BoundCallbackObservable.create},function(e,t,n){"use strict";function r(e){var t=e.value,n=e.subject;n.next(t),n.complete()}function o(e){var t=e.err;e.subject.error(t)}var i=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},a=n(0),u=n(21),s=n(20),l=n(71),c=function(e){function t(t,n,r,o,i){e.call(this),this.callbackFunc=t,this.selector=n,this.args=r,this.context=o,this.scheduler=i}return i(t,e),t.create=function(e,n,r){return void 0===n&&(n=void 0),function(){for(var o=[],i=0;i<arguments.length;i++)o[i-0]=arguments[i];return new t(e,n,o,this,r)}},t.prototype._subscribe=function(e){var n=this.callbackFunc,r=this.args,o=this.scheduler,i=this.subject;if(o)return o.schedule(t.dispatch,0,{source:this,subscriber:e,context:this.context});if(!i){i=this.subject=new l.AsyncSubject;var a=function e(){for(var t=[],n=0;n<arguments.length;n++)t[n-0]=arguments[n];var r=e.source,o=r.selector,i=r.subject;if(o){var a=u.tryCatch(o).apply(this,t);a===s.errorObject?i.error(s.errorObject.e):(i.next(a),i.complete())}else i.next(t.length<=1?t[0]:t),i.complete()};a.source=this,u.tryCatch(n).apply(this.context,r.concat(a))===s.errorObject&&i.error(s.errorObject.e)}return i.subscribe(e)},t.dispatch=function(e){var t=this,n=e.source,i=e.subscriber,a=e.context,c=n.callbackFunc,f=n.args,d=n.scheduler,p=n.subject;if(!p){p=n.subject=new l.AsyncSubject;var h=function e(){for(var n=[],i=0;i<arguments.length;i++)n[i-0]=arguments[i];var a=e.source,l=a.selector,c=a.subject;if(l){var f=u.tryCatch(l).apply(this,n);f===s.errorObject?t.add(d.schedule(o,0,{err:s.errorObject.e,subject:c})):t.add(d.schedule(r,0,{value:f,subject:c}))}else{var p=n.length<=1?n[0]:n;t.add(d.schedule(r,0,{value:p,subject:c}))}};h.source=n,u.tryCatch(c).apply(a,f.concat(h))===s.errorObject&&p.error(s.errorObject.e)}t.add(p.subscribe(i))},t}(a.Observable);t.BoundCallbackObservable=c},function(e,t,n){"use strict";var r=n(0),o=n(345);r.Observable.bindNodeCallback=o.bindNodeCallback},function(e,t,n){"use strict";var r=n(346);t.bindNodeCallback=r.BoundNodeCallbackObservable.create},function(e,t,n){"use strict";function r(e){var t=this,n=e.source,r=e.subscriber,a=e.context,u=n,f=u.callbackFunc,d=u.args,p=u.scheduler,h=n.subject;if(!h){h=n.subject=new c.AsyncSubject;var y=function e(){for(var n=[],r=0;r<arguments.length;r++)n[r-0]=arguments[r];var a=e.source,u=a.selector,c=a.subject,f=n.shift();if(f)t.add(p.schedule(i,0,{err:f,subject:c}));else if(u){var d=s.tryCatch(u).apply(this,n);d===l.errorObject?t.add(p.schedule(i,0,{err:l.errorObject.e,subject:c})):t.add(p.schedule(o,0,{value:d,subject:c}))}else{var h=n.length<=1?n[0]:n;t.add(p.schedule(o,0,{value:h,subject:c}))}};y.source=n,s.tryCatch(f).apply(a,d.concat(y))===l.errorObject&&t.add(p.schedule(i,0,{err:l.errorObject.e,subject:h}))}t.add(h.subscribe(r))}function o(e){var t=e.value,n=e.subject;n.next(t),n.complete()}function i(e){var t=e.err;e.subject.error(t)}var a=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},u=n(0),s=n(21),l=n(20),c=n(71),f=function(e){function t(t,n,r,o,i){e.call(this),this.callbackFunc=t,this.selector=n,this.args=r,this.context=o,this.scheduler=i}return a(t,e),t.create=function(e,n,r){return void 0===n&&(n=void 0),function(){for(var o=[],i=0;i<arguments.length;i++)o[i-0]=arguments[i];return new t(e,n,o,this,r)}},t.prototype._subscribe=function(e){var t=this.callbackFunc,n=this.args,o=this.scheduler,i=this.subject;if(o)return o.schedule(r,0,{source:this,subscriber:e,context:this.context});if(!i){i=this.subject=new c.AsyncSubject;var a=function e(){for(var t=[],n=0;n<arguments.length;n++)t[n-0]=arguments[n];var r=e.source,o=r.selector,i=r.subject,a=t.shift();if(a)i.error(a);else if(o){var u=s.tryCatch(o).apply(this,t);u===l.errorObject?i.error(l.errorObject.e):(i.next(u),i.complete())}else i.next(t.length<=1?t[0]:t),i.complete()};a.source=this,s.tryCatch(t).apply(this.context,n.concat(a))===l.errorObject&&i.error(l.errorObject.e)}return i.subscribe(e)},t}(u.Observable);t.BoundNodeCallbackObservable=f},function(e,t,n){"use strict";var r=n(0),o=n(348);r.Observable.combineLatest=o.combineLatest},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];var n=null,r=null;return o.isScheduler(e[e.length-1])&&(r=e.pop()),"function"==typeof e[e.length-1]&&(n=e.pop()),1===e.length&&i.isArray(e[0])&&(e=e[0]),new a.ArrayObservable(e,r).lift(new u.CombineLatestOperator(n))}var o=n(25),i=n(27),a=n(32),u=n(72);t.combineLatest=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(2),i=function(e){function t(t,n,r){e.call(this),this.parent=t,this.outerValue=n,this.outerIndex=r,this.index=0}return r(t,e),t.prototype._next=function(e){this.parent.notifyNext(this.outerValue,e,this.outerIndex,this.index++,this)},t.prototype._error=function(e){this.parent.notifyError(e,this),this.unsubscribe()},t.prototype._complete=function(){this.parent.notifyComplete(this),this.unsubscribe()},t}(o.Subscriber);t.InnerSubscriber=i},function(e,t,n){"use strict";var r=n(0),o=n(49);r.Observable.concat=o.concat},function(e,t,n){"use strict";function r(e){var t=e[c.iterator];if(!t&&"string"==typeof e)return new d(e);if(!t&&void 0!==e.length)return new p(e);if(!t)throw new TypeError("object is not iterable");return e[c.iterator]()}function o(e){var t=+e.length;return isNaN(t)?0:0!==t&&i(t)?(t=a(t)*Math.floor(Math.abs(t)),t<=0?0:t>h?h:t):t}function i(e){return"number"==typeof e&&s.root.isFinite(e)}function a(e){var t=+e;return 0===t?t:isNaN(t)?t:t<0?-1:1}var u=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},s=n(22),l=n(0),c=n(48),f=function(e){function t(t,n){if(e.call(this),this.scheduler=n,null==t)throw new Error("iterator cannot be null.");this.iterator=r(t)}return u(t,e),t.create=function(e,n){return new t(e,n)},t.dispatch=function(e){var t=e.index,n=e.hasError,r=e.iterator,o=e.subscriber;if(n)return void o.error(e.error);var i=r.next();return i.done?void o.complete():(o.next(i.value),e.index=t+1,o.closed?void("function"==typeof r.return&&r.return()):void this.schedule(e))},t.prototype._subscribe=function(e){var n=this,r=n.iterator,o=n.scheduler;if(o)return o.schedule(t.dispatch,0,{index:0,iterator:r,subscriber:e});for(;;){var i=r.next();if(i.done){e.complete();break}if(e.next(i.value),e.closed){"function"==typeof r.return&&r.return();break}}},t}(l.Observable);t.IteratorObservable=f;var d=function(){function e(e,t,n){void 0===t&&(t=0),void 0===n&&(n=e.length),this.str=e,this.idx=t,this.len=n}return e.prototype[c.iterator]=function(){return this},e.prototype.next=function(){return this.idx<this.len?{done:!1,value:this.str.charAt(this.idx++)}:{done:!0,value:void 0}},e}(),p=function(){function e(e,t,n){void 0===t&&(t=0),void 0===n&&(n=o(e)),this.arr=e,this.idx=t,this.len=n}return e.prototype[c.iterator]=function(){return this},e.prototype.next=function(){return this.idx<this.len?{done:!1,value:this.arr[this.idx++]}:{done:!0,value:void 0}},e}(),h=Math.pow(2,53)-1},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(101),a=n(33),u=function(e){function t(t,n){e.call(this),this.arrayLike=t,this.scheduler=n,n||1!==t.length||(this._isScalar=!0,this.value=t[0])}return r(t,e),t.create=function(e,n){var r=e.length;return 0===r?new a.EmptyObservable:1===r?new i.ScalarObservable(e[0],n):new t(e,n)},t.dispatch=function(e){var t=e.arrayLike,n=e.index,r=e.length,o=e.subscriber;if(!o.closed){if(n>=r)return void o.complete();o.next(t[n]),e.index=n+1,this.schedule(e)}},t.prototype._subscribe=function(e){var n=this,r=n.arrayLike,o=n.scheduler,i=r.length;if(o)return o.schedule(t.dispatch,0,{arrayLike:r,index:0,length:i,subscriber:e});for(var a=0;a<i&&!e.closed;a++)e.next(r[a]);e.complete()},t}(o.Observable);t.ArrayLikeObservable=u},function(e,t,n){"use strict";var r=n(0),o=n(354);r.Observable.defer=o.defer},function(e,t,n){"use strict";var r=n(355);t.defer=r.DeferObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(7),a=n(6),u=function(e){function t(t){e.call(this),this.observableFactory=t}return r(t,e),t.create=function(e){return new t(e)},t.prototype._subscribe=function(e){return new s(e,this.observableFactory)},t}(o.Observable);t.DeferObservable=u;var s=function(e){function t(t,n){e.call(this,t),this.factory=n,this.tryDefer()}return r(t,e),t.prototype.tryDefer=function(){try{this._callFactory()}catch(e){this._error(e)}},t.prototype._callFactory=function(){var e=this.factory();e&&this.add(i.subscribeToResult(this,e))},t}(a.OuterSubscriber)},function(e,t,n){"use strict";var r=n(0),o=n(357);r.Observable.empty=o.empty},function(e,t,n){"use strict";var r=n(33);t.empty=r.EmptyObservable.create},function(e,t,n){"use strict";var r=n(0),o=n(359);r.Observable.forkJoin=o.forkJoin},function(e,t,n){"use strict";var r=n(360);t.forkJoin=r.ForkJoinObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(33),a=n(27),u=n(7),s=n(6),l=function(e){function t(t,n){e.call(this),this.sources=t,this.resultSelector=n}return r(t,e),t.create=function(){for(var e=[],n=0;n<arguments.length;n++)e[n-0]=arguments[n];if(null===e||0===arguments.length)return new i.EmptyObservable;var r=null;return"function"==typeof e[e.length-1]&&(r=e.pop()),1===e.length&&a.isArray(e[0])&&(e=e[0]),0===e.length?new i.EmptyObservable:new t(e,r)},t.prototype._subscribe=function(e){return new c(e,this.sources,this.resultSelector)},t}(o.Observable);t.ForkJoinObservable=l;var c=function(e){function t(t,n,r){e.call(this,t),this.sources=n,this.resultSelector=r,this.completed=0,this.haveValues=0;var o=n.length;this.total=o,this.values=new Array(o);for(var i=0;i<o;i++){var a=n[i],s=u.subscribeToResult(this,a,null,i);s&&(s.outerIndex=i,this.add(s))}}return r(t,e),t.prototype.notifyNext=function(e,t,n,r,o){this.values[n]=t,o._hasValue||(o._hasValue=!0,this.haveValues++)},t.prototype.notifyComplete=function(e){var t=this.destination,n=this,r=n.haveValues,o=n.resultSelector,i=n.values,a=i.length;if(!e._hasValue)return void t.complete();if(++this.completed===a){if(r===a){var u=o?o.apply(this,i):i;t.next(u)}t.complete()}},t}(s.OuterSubscriber)},function(e,t,n){"use strict";var r=n(0),o=n(150);r.Observable.from=o.from},function(e,t,n){"use strict";var r=n(0),o=n(363);r.Observable.fromEvent=o.fromEvent},function(e,t,n){"use strict";var r=n(364);t.fromEvent=r.FromEventObservable.create},function(e,t,n){"use strict";function r(e){return!!e&&"function"==typeof e.addListener&&"function"==typeof e.removeListener}function o(e){return!!e&&"function"==typeof e.on&&"function"==typeof e.off}function i(e){return!!e&&"[object NodeList]"===h.call(e)}function a(e){return!!e&&"[object HTMLCollection]"===h.call(e)}function u(e){return!!e&&"function"==typeof e.addEventListener&&"function"==typeof e.removeEventListener}var s=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},l=n(0),c=n(21),f=n(67),d=n(20),p=n(18),h=Object.prototype.toString,y=function(e){function t(t,n,r,o){e.call(this),this.sourceObj=t,this.eventName=n,this.selector=r,this.options=o}return s(t,e),t.create=function(e,n,r,o){return f.isFunction(r)&&(o=r,r=void 0),new t(e,n,o,r)},t.setupSubscription=function(e,n,s,l,c){var f;if(i(e)||a(e))for(var d=0,h=e.length;d<h;d++)t.setupSubscription(e[d],n,s,l,c);else if(u(e)){var y=e;e.addEventListener(n,s,c),f=function(){return y.removeEventListener(n,s)}}else if(o(e)){var v=e;e.on(n,s),f=function(){return v.off(n,s)}}else{if(!r(e))throw new TypeError("Invalid event target");var m=e;e.addListener(n,s),f=function(){return m.removeListener(n,s)}}l.add(new p.Subscription(f))},t.prototype._subscribe=function(e){var n=this.sourceObj,r=this.eventName,o=this.options,i=this.selector,a=i?function(){for(var t=[],n=0;n<arguments.length;n++)t[n-0]=arguments[n];var r=c.tryCatch(i).apply(void 0,t);r===d.errorObject?e.error(d.errorObject.e):e.next(r)}:function(t){return e.next(t)};t.setupSubscription(n,r,a,e,o)},t}(l.Observable);t.FromEventObservable=y},function(e,t,n){"use strict";var r=n(0),o=n(366);r.Observable.fromEventPattern=o.fromEventPattern},function(e,t,n){"use strict";var r=n(367);t.fromEventPattern=r.FromEventPatternObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(67),i=n(0),a=n(18),u=function(e){function t(t,n,r){e.call(this),this.addHandler=t,this.removeHandler=n,this.selector=r}return r(t,e),t.create=function(e,n,r){return new t(e,n,r)},t.prototype._subscribe=function(e){var t=this,n=this.removeHandler,r=this.selector?function(){for(var n=[],r=0;r<arguments.length;r++)n[r-0]=arguments[r];t._callSelector(e,n)}:function(t){e.next(t)},i=this._callAddHandler(r,e);o.isFunction(n)&&e.add(new a.Subscription(function(){n(r,i)}))},t.prototype._callSelector=function(e,t){try{var n=this.selector.apply(this,t);e.next(n)}catch(t){e.error(t)}},t.prototype._callAddHandler=function(e,t){try{return this.addHandler(e)||null}catch(e){t.error(e)}},t}(i.Observable);t.FromEventPatternObservable=u},function(e,t,n){"use strict";var r=n(0),o=n(369);r.Observable.fromPromise=o.fromPromise},function(e,t,n){"use strict";var r=n(152);t.fromPromise=r.PromiseObservable.create},function(e,t,n){"use strict";var r=n(0),o=n(371);r.Observable.generate=o.generate},function(e,t,n){"use strict";var r=n(372);t.generate=r.GenerateObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(25),a=function(e){return e},u=function(e){function t(t,n,r,o,i){e.call(this),this.initialState=t,this.condition=n,this.iterate=r,this.resultSelector=o,this.scheduler=i}return r(t,e),t.create=function(e,n,r,o,u){return 1==arguments.length?new t(e.initialState,e.condition,e.iterate,e.resultSelector||a,e.scheduler):void 0===o||i.isScheduler(o)?new t(e,n,r,a,o):new t(e,n,r,o,u)},t.prototype._subscribe=function(e){var n=this.initialState;if(this.scheduler)return this.scheduler.schedule(t.dispatch,0,{subscriber:e,iterate:this.iterate,condition:this.condition,resultSelector:this.resultSelector,state:n});for(var r=this,o=r.condition,i=r.resultSelector,a=r.iterate;;){if(o){var u=void 0;try{u=o(n)}catch(t){return void e.error(t)}if(!u){e.complete();break}}var s=void 0;try{s=i(n)}catch(t){return void e.error(t)}if(e.next(s),e.closed)break;try{n=a(n)}catch(t){return void e.error(t)}}},t.dispatch=function(e){var t=e.subscriber,n=e.condition;if(!t.closed){if(e.needIterate)try{e.state=e.iterate(e.state)}catch(e){return void t.error(e)}else e.needIterate=!0;if(n){var r=void 0;try{r=n(e.state)}catch(e){return void t.error(e)}if(!r)return void t.complete();if(t.closed)return}var o;try{o=e.resultSelector(e.state)}catch(e){return void t.error(e)}if(!t.closed&&(t.next(o),!t.closed))return this.schedule(e)}},t}(o.Observable);t.GenerateObservable=u},function(e,t,n){"use strict";var r=n(0),o=n(374);r.Observable.if=o._if},function(e,t,n){"use strict";var r=n(375);t._if=r.IfObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(7),a=n(6),u=function(e){function t(t,n,r){e.call(this),this.condition=t,this.thenSource=n,this.elseSource=r}return r(t,e),t.create=function(e,n,r){return new t(e,n,r)},t.prototype._subscribe=function(e){var t=this,n=t.condition,r=t.thenSource,o=t.elseSource;return new s(e,n,r,o)},t}(o.Observable);t.IfObservable=u;var s=function(e){function t(t,n,r,o){e.call(this,t),this.condition=n,this.thenSource=r,this.elseSource=o,this.tryIf()}return r(t,e),t.prototype.tryIf=function(){var e,t=this,n=t.condition,r=t.thenSource,o=t.elseSource;try{e=n();var a=e?r:o;a?this.add(i.subscribeToResult(this,a)):this._complete()}catch(e){this._error(e)}},t}(a.OuterSubscriber)},function(e,t,n){"use strict";var r=n(0),o=n(377);r.Observable.interval=o.interval},function(e,t,n){"use strict";var r=n(378);t.interval=r.IntervalObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(52),i=n(0),a=n(16),u=function(e){function t(t,n){void 0===t&&(t=0),void 0===n&&(n=a.async),e.call(this),this.period=t,this.scheduler=n,(!o.isNumeric(t)||t<0)&&(this.period=0),n&&"function"==typeof n.schedule||(this.scheduler=a.async)}return r(t,e),t.create=function(e,n){return void 0===e&&(e=0),void 0===n&&(n=a.async),new t(e,n)},t.dispatch=function(e){var t=e.index,n=e.subscriber,r=e.period;n.next(t),n.closed||(e.index+=1,this.schedule(e,r))},t.prototype._subscribe=function(e){var n=this.period,r=this.scheduler;e.add(r.schedule(t.dispatch,n,{index:0,subscriber:e,period:n}))},t}(i.Observable);t.IntervalObservable=u},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(18),i=function(e){function t(t,n){e.call(this)}return r(t,e),t.prototype.schedule=function(e,t){return void 0===t&&(t=0),this},t}(o.Subscription);t.Action=i},function(e,t,n){"use strict";var r=function(){function e(t,n){void 0===n&&(n=e.now),this.SchedulerAction=t,this.now=n}return e.prototype.schedule=function(e,t,n){return void 0===t&&(t=0),new this.SchedulerAction(this,e).schedule(n,t)},e.now=Date.now?Date.now:function(){return+new Date},e}();t.Scheduler=r},function(e,t,n){"use strict";var r=n(0),o=n(75);r.Observable.merge=o.merge},function(e,t,n){"use strict";var r=n(0),o=n(103);r.Observable.race=o.race},function(e,t,n){"use strict";var r=n(0),o=n(384);r.Observable.never=o.never},function(e,t,n){"use strict";var r=n(385);t.never=r.NeverObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(100),a=function(e){function t(){e.call(this)}return r(t,e),t.create=function(){return new t},t.prototype._subscribe=function(e){i.noop()},t}(o.Observable);t.NeverObservable=a},function(e,t,n){"use strict";var r=n(0),o=n(149);r.Observable.of=o.of},function(e,t,n){"use strict";var r=n(0),o=n(388);r.Observable.onErrorResumeNext=o.onErrorResumeNext},function(e,t,n){"use strict";var r=n(104);t.onErrorResumeNext=r.onErrorResumeNextStatic},function(e,t,n){"use strict";var r=n(0),o=n(390);r.Observable.pairs=o.pairs},function(e,t,n){"use strict";var r=n(391);t.pairs=r.PairsObservable.create},function(e,t,n){"use strict";function r(e){var t=e.obj,n=e.keys,r=e.length,o=e.index,i=e.subscriber;if(o===r)return void i.complete();var a=n[o];i.next([a,t[a]]),e.index=o+1,this.schedule(e)}var o=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},i=n(0),a=function(e){function t(t,n){e.call(this),this.obj=t,this.scheduler=n,this.keys=Object.keys(t)}return o(t,e),t.create=function(e,n){return new t(e,n)},t.prototype._subscribe=function(e){var t=this,n=t.keys,o=t.scheduler,i=n.length;if(o)return o.schedule(r,0,{obj:this.obj,keys:n,length:i,index:0,subscriber:e});for(var a=0;a<i;a++){var u=n[a];e.next([u,this.obj[u]])}e.complete()},t}(i.Observable);t.PairsObservable=a},function(e,t,n){"use strict";var r=n(0),o=n(393);r.Observable.range=o.range},function(e,t,n){"use strict";var r=n(394);t.range=r.RangeObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=function(e){function t(t,n,r){e.call(this),this.start=t,this._count=n,this.scheduler=r}return r(t,e),t.create=function(e,n,r){return void 0===e&&(e=0),void 0===n&&(n=0),new t(e,n,r)},t.dispatch=function(e){var t=e.start,n=e.index,r=e.count,o=e.subscriber;if(n>=r)return void o.complete();o.next(t),o.closed||(e.index=n+1,e.start=t+1,this.schedule(e))},t.prototype._subscribe=function(e){var n=0,r=this.start,o=this._count,i=this.scheduler;if(i)return i.schedule(t.dispatch,0,{index:n,count:o,start:r,subscriber:e});for(;;){if(n++>=o){e.complete();break}if(e.next(r++),e.closed)break}},t}(o.Observable);t.RangeObservable=i},function(e,t,n){"use strict";var r=n(0),o=n(396);r.Observable.using=o.using},function(e,t,n){"use strict";var r=n(397);t.using=r.UsingObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(7),a=n(6),u=function(e){function t(t,n){e.call(this),this.resourceFactory=t,this.observableFactory=n}return r(t,e),t.create=function(e,n){return new t(e,n)},t.prototype._subscribe=function(e){var t,n=this,r=n.resourceFactory,o=n.observableFactory;try{return t=r(),new s(e,t,o)}catch(t){e.error(t)}},t}(o.Observable);t.UsingObservable=u;var s=function(e){function t(t,n,r){e.call(this,t),this.resource=n,this.observableFactory=r,t.add(n),this.tryUse()}return r(t,e),t.prototype.tryUse=function(){try{var e=this.observableFactory.call(this,this.resource);e&&this.add(i.subscribeToResult(this,e))}catch(e){this._error(e)}},t}(a.OuterSubscriber)},function(e,t,n){"use strict";var r=n(0),o=n(399);r.Observable.throw=o._throw},function(e,t,n){"use strict";var r=n(400);t._throw=r.ErrorObservable.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=function(e){function t(t,n){e.call(this),this.error=t,this.scheduler=n}return r(t,e),t.create=function(e,n){return new t(e,n)},t.dispatch=function(e){var t=e.error;e.subscriber.error(t)},t.prototype._subscribe=function(e){var n=this.error,r=this.scheduler;if(e.syncErrorThrowable=!0,r)return r.schedule(t.dispatch,0,{error:n,subscriber:e});e.error(n)},t}(o.Observable);t.ErrorObservable=i},function(e,t,n){"use strict";var r=n(0),o=n(154);r.Observable.timer=o.timer},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(52),i=n(0),a=n(16),u=n(25),s=n(76),l=function(e){function t(t,n,r){void 0===t&&(t=0),e.call(this),this.period=-1,this.dueTime=0,o.isNumeric(n)?this.period=Number(n)<1&&1||Number(n):u.isScheduler(n)&&(r=n),u.isScheduler(r)||(r=a.async),this.scheduler=r,this.dueTime=s.isDate(t)?+t-this.scheduler.now():t}return r(t,e),t.create=function(e,n,r){return void 0===e&&(e=0),new t(e,n,r)},t.dispatch=function(e){var t=e.index,n=e.period,r=e.subscriber,o=this;if(r.next(t),!r.closed){if(-1===n)return r.complete();e.index=t+1,o.schedule(e,n)}},t.prototype._subscribe=function(e){var n=this,r=n.period,o=n.dueTime;return n.scheduler.schedule(t.dispatch,o,{index:0,period:r,subscriber:e})},t}(i.Observable);t.TimerObservable=l},function(e,t,n){"use strict";var r=n(0),o=n(404);r.Observable.zip=o.zip},function(e,t,n){"use strict";var r=n(77);t.zip=r.zipStatic},function(e,t,n){"use strict";var r=n(0),o=n(406);r.Observable.ajax=o.ajax},function(e,t,n){"use strict";var r=n(155);t.ajax=r.AjaxObservable.create},function(e,t,n){"use strict";var r=n(0),o=n(408);r.Observable.webSocket=o.webSocket},function(e,t,n){"use strict";var r=n(409);t.webSocket=r.WebSocketSubject.create},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(2),a=n(0),u=n(18),s=n(22),l=n(78),c=n(21),f=n(20),d=n(412),p=function(e){function t(t,n){if(t instanceof a.Observable)e.call(this,n,t);else{if(e.call(this),this.WebSocketCtor=s.root.WebSocket,this._output=new o.Subject,"string"==typeof t?this.url=t:d.assign(this,t),!this.WebSocketCtor)throw new Error("no WebSocket constructor can be found");this.destination=new l.ReplaySubject}}return r(t,e),t.prototype.resultSelector=function(e){return JSON.parse(e.data)},t.create=function(e){return new t(e)},t.prototype.lift=function(e){var n=new t(this,this.destination);return n.operator=e,n},t.prototype._resetState=function(){this.socket=null,this.source||(this.destination=new l.ReplaySubject),this._output=new o.Subject},t.prototype.multiplex=function(e,t,n){var r=this;return new a.Observable(function(o){var i=c.tryCatch(e)();i===f.errorObject?o.error(f.errorObject.e):r.next(i);var a=r.subscribe(function(e){var t=c.tryCatch(n)(e);t===f.errorObject?o.error(f.errorObject.e):t&&o.next(e)},function(e){return o.error(e)},function(){return o.complete()});return function(){var e=c.tryCatch(t)();e===f.errorObject?o.error(f.errorObject.e):r.next(e),a.unsubscribe()}})},t.prototype._connectSocket=function(){var e=this,t=this.WebSocketCtor,n=this._output,r=null;try{r=this.protocol?new t(this.url,this.protocol):new t(this.url),this.socket=r,this.binaryType&&(this.socket.binaryType=this.binaryType)}catch(e){return void n.error(e)}var o=new u.Subscription(function(){e.socket=null,r&&1===r.readyState&&r.close()});r.onopen=function(t){var a=e.openObserver;a&&a.next(t);var u=e.destination;e.destination=i.Subscriber.create(function(e){return 1===r.readyState&&r.send(e)},function(t){var o=e.closingObserver;o&&o.next(void 0),t&&t.code?r.close(t.code,t.reason):n.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }")),e._resetState()},function(){var t=e.closingObserver;t&&t.next(void 0),r.close(),e._resetState()}),u&&u instanceof l.ReplaySubject&&o.add(u.subscribe(e.destination))},r.onerror=function(t){e._resetState(),n.error(t)},r.onclose=function(t){e._resetState();var r=e.closeObserver;r&&r.next(t),t.wasClean?n.complete():n.error(t)},r.onmessage=function(t){var r=c.tryCatch(e.resultSelector)(t);r===f.errorObject?n.error(f.errorObject.e):n.next(r)}},t.prototype._subscribe=function(e){var t=this,n=this.source;if(n)return n.subscribe(e);this.socket||this._connectSocket();var r=new u.Subscription;return r.add(this._output.subscribe(e)),r.add(function(){var e=t.socket;0===t._output.observers.length&&(e&&1===e.readyState&&e.close(),t._resetState())}),r},t.prototype.unsubscribe=function(){var t=this,n=t.source,r=t.socket;r&&1===r.readyState&&(r.close(),this._resetState()),e.prototype.unsubscribe.call(this),n||(this.destination=new l.ReplaySubject)},t}(o.AnonymousSubject);t.WebSocketSubject=p},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(53),i=function(e){function t(t,n){e.call(this,t,n),this.scheduler=t,this.work=n}return r(t,e),t.prototype.schedule=function(t,n){return void 0===n&&(n=0),n>0?e.prototype.schedule.call(this,t,n):(this.delay=n,this.state=t,this.scheduler.flush(this),this)},t.prototype.execute=function(t,n){return n>0||this.closed?e.prototype.execute.call(this,t,n):this._execute(t,n)},t.prototype.requestAsyncId=function(t,n,r){return void 0===r&&(r=0),null!==r&&r>0||null===r&&this.delay>0?e.prototype.requestAsyncId.call(this,t,n,r):t.flush(this)},t}(o.AsyncAction);t.QueueAction=i},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(54),i=function(e){function t(){e.apply(this,arguments)}return r(t,e),t}(o.AsyncScheduler);t.QueueScheduler=i},function(e,t,n){"use strict";function r(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var r=t.length,o=0;o<r;o++){var i=t[o];for(var a in i)i.hasOwnProperty(a)&&(e[a]=i[a])}return e}function o(e){return e.Object.assign||r}var i=n(22);t.assignImpl=r,t.getAssign=o,t.assign=o(i.root)},function(e,t,n){"use strict";var r=n(0),o=n(414);r.Observable.prototype.buffer=o.buffer},function(e,t,n){"use strict";function r(e){return o.buffer(e)(this)}var o=n(157);t.buffer=r},function(e,t,n){"use strict";var r=n(0),o=n(416);r.Observable.prototype.bufferCount=o.bufferCount},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=null),o.bufferCount(e,t)(this)}var o=n(158);t.bufferCount=r},function(e,t,n){"use strict";var r=n(0),o=n(418);r.Observable.prototype.bufferTime=o.bufferTime},function(e,t,n){"use strict";function r(e){var t=arguments.length,n=o.async;i.isScheduler(arguments[arguments.length-1])&&(n=arguments[arguments.length-1],t--);var r=null;t>=2&&(r=arguments[1]);var u=Number.POSITIVE_INFINITY;return t>=3&&(u=arguments[2]),a.bufferTime(e,r,u,n)(this)}var o=n(16),i=n(25),a=n(159);t.bufferTime=r},function(e,t,n){"use strict";var r=n(0),o=n(420);r.Observable.prototype.bufferToggle=o.bufferToggle},function(e,t,n){"use strict";function r(e,t){return o.bufferToggle(e,t)(this)}var o=n(160);t.bufferToggle=r},function(e,t,n){"use strict";var r=n(0),o=n(422);r.Observable.prototype.bufferWhen=o.bufferWhen},function(e,t,n){"use strict";function r(e){return o.bufferWhen(e)(this)}var o=n(161);t.bufferWhen=r},function(e,t,n){"use strict";var r=n(0),o=n(424);r.Observable.prototype.catch=o._catch,r.Observable.prototype._catch=o._catch},function(e,t,n){"use strict";function r(e){return o.catchError(e)(this)}var o=n(162);t._catch=r},function(e,t,n){"use strict";var r=n(0),o=n(426);r.Observable.prototype.combineAll=o.combineAll},function(e,t,n){"use strict";function r(e){return o.combineAll(e)(this)}var o=n(163);t.combineAll=r},function(e,t,n){"use strict";var r=n(0),o=n(428);r.Observable.prototype.combineLatest=o.combineLatest},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.combineLatest.apply(void 0,e)(this)}var o=n(72);t.combineLatest=r},function(e,t,n){"use strict";var r=n(0),o=n(430);r.Observable.prototype.concat=o.concat},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.concat.apply(void 0,e)(this)}var o=n(164),i=n(49);t.concatStatic=i.concat,t.concat=r},function(e,t,n){"use strict";var r=n(0),o=n(432);r.Observable.prototype.concatAll=o.concatAll},function(e,t,n){"use strict";function r(){return o.concatAll()(this)}var o=n(102);t.concatAll=r},function(e,t,n){"use strict";var r=n(0),o=n(434);r.Observable.prototype.concatMap=o.concatMap},function(e,t,n){"use strict";function r(e,t){return o.concatMap(e,t)(this)}var o=n(105);t.concatMap=r},function(e,t,n){"use strict";var r=n(0),o=n(436);r.Observable.prototype.concatMapTo=o.concatMapTo},function(e,t,n){"use strict";function r(e,t){return o.concatMapTo(e,t)(this)}var o=n(165);t.concatMapTo=r},function(e,t,n){"use strict";var r=n(0),o=n(438);r.Observable.prototype.count=o.count},function(e,t,n){"use strict";function r(e){return o.count(e)(this)}var o=n(166);t.count=r},function(e,t,n){"use strict";var r=n(0),o=n(440);r.Observable.prototype.dematerialize=o.dematerialize},function(e,t,n){"use strict";function r(){return o.dematerialize()(this)}var o=n(167);t.dematerialize=r},function(e,t,n){"use strict";var r=n(0),o=n(442);r.Observable.prototype.debounce=o.debounce},function(e,t,n){"use strict";function r(e){return o.debounce(e)(this)}var o=n(168);t.debounce=r},function(e,t,n){"use strict";var r=n(0),o=n(444);r.Observable.prototype.debounceTime=o.debounceTime},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.debounceTime(e,t)(this)}var o=n(16),i=n(169);t.debounceTime=r},function(e,t,n){"use strict";var r=n(0),o=n(446);r.Observable.prototype.defaultIfEmpty=o.defaultIfEmpty},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=null),o.defaultIfEmpty(e)(this)}var o=n(106);t.defaultIfEmpty=r},function(e,t,n){"use strict";var r=n(0),o=n(448);r.Observable.prototype.delay=o.delay},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.delay(e,t)(this)}var o=n(16),i=n(170);t.delay=r},function(e,t,n){"use strict";var r=n(0),o=n(450);r.Observable.prototype.delayWhen=o.delayWhen},function(e,t,n){"use strict";function r(e,t){return o.delayWhen(e,t)(this)}var o=n(171);t.delayWhen=r},function(e,t,n){"use strict";var r=n(0),o=n(452);r.Observable.prototype.distinct=o.distinct},function(e,t,n){"use strict";function r(e,t){return o.distinct(e,t)(this)}var o=n(172);t.distinct=r},function(e,t,n){"use strict";function r(){return function(){function e(){this._values=[]}return e.prototype.add=function(e){this.has(e)||this._values.push(e)},e.prototype.has=function(e){return-1!==this._values.indexOf(e)},Object.defineProperty(e.prototype,"size",{get:function(){return this._values.length},enumerable:!0,configurable:!0}),e.prototype.clear=function(){this._values.length=0},e}()}var o=n(22);t.minimalSetImpl=r,t.Set=o.root.Set||r()},function(e,t,n){"use strict";var r=n(0),o=n(455);r.Observable.prototype.distinctUntilChanged=o.distinctUntilChanged},function(e,t,n){"use strict";function r(e,t){return o.distinctUntilChanged(e,t)(this)}var o=n(107);t.distinctUntilChanged=r},function(e,t,n){"use strict";var r=n(0),o=n(457);r.Observable.prototype.distinctUntilKeyChanged=o.distinctUntilKeyChanged},function(e,t,n){"use strict";function r(e,t){return o.distinctUntilKeyChanged(e,t)(this)}var o=n(173);t.distinctUntilKeyChanged=r},function(e,t,n){"use strict";var r=n(0),o=n(459);r.Observable.prototype.do=o._do,r.Observable.prototype._do=o._do},function(e,t,n){"use strict";function r(e,t,n){return o.tap(e,t,n)(this)}var o=n(174);t._do=r},function(e,t,n){"use strict";var r=n(0),o=n(461);r.Observable.prototype.exhaust=o.exhaust},function(e,t,n){"use strict";function r(){return o.exhaust()(this)}var o=n(175);t.exhaust=r},function(e,t,n){"use strict";var r=n(0),o=n(463);r.Observable.prototype.exhaustMap=o.exhaustMap},function(e,t,n){"use strict";function r(e,t){return o.exhaustMap(e,t)(this)}var o=n(176);t.exhaustMap=r},function(e,t,n){"use strict";var r=n(0),o=n(465);r.Observable.prototype.expand=o.expand},function(e,t,n){"use strict";function r(e,t,n){return void 0===t&&(t=Number.POSITIVE_INFINITY),void 0===n&&(n=void 0),t=(t||0)<1?Number.POSITIVE_INFINITY:t,o.expand(e,t,n)(this)}var o=n(177);t.expand=r},function(e,t,n){"use strict";var r=n(0),o=n(467);r.Observable.prototype.elementAt=o.elementAt},function(e,t,n){"use strict";function r(e,t){return o.elementAt(e,t)(this)}var o=n(178);t.elementAt=r},function(e,t,n){"use strict";var r=n(0),o=n(469);r.Observable.prototype.filter=o.filter},function(e,t,n){"use strict";function r(e,t){return o.filter(e,t)(this)}var o=n(108);t.filter=r},function(e,t,n){"use strict";var r=n(0),o=n(471);r.Observable.prototype.finally=o._finally,r.Observable.prototype._finally=o._finally},function(e,t,n){"use strict";function r(e){return o.finalize(e)(this)}var o=n(179);t._finally=r},function(e,t,n){"use strict";var r=n(0),o=n(473);r.Observable.prototype.find=o.find},function(e,t,n){"use strict";function r(e,t){return o.find(e,t)(this)}var o=n(109);t.find=r},function(e,t,n){"use strict";var r=n(0),o=n(475);r.Observable.prototype.findIndex=o.findIndex},function(e,t,n){"use strict";function r(e,t){return o.findIndex(e,t)(this)}var o=n(180);t.findIndex=r},function(e,t,n){"use strict";var r=n(0),o=n(477);r.Observable.prototype.first=o.first},function(e,t,n){"use strict";function r(e,t,n){return o.first(e,t,n)(this)}var o=n(181);t.first=r},function(e,t,n){"use strict";var r=n(0),o=n(479);r.Observable.prototype.groupBy=o.groupBy},function(e,t,n){"use strict";function r(e,t,n,r){return o.groupBy(e,t,n,r)(this)}var o=n(182);t.GroupedObservable=o.GroupedObservable,t.groupBy=r},function(e,t,n){"use strict";var r=n(22),o=n(481);t.Map=r.root.Map||function(){return o.MapPolyfill}()},function(e,t,n){"use strict";var r=function(){function e(){this.size=0,this._values=[],this._keys=[]}return e.prototype.get=function(e){var t=this._keys.indexOf(e);return-1===t?void 0:this._values[t]},e.prototype.set=function(e,t){var n=this._keys.indexOf(e);return-1===n?(this._keys.push(e),this._values.push(t),this.size++):this._values[n]=t,this},e.prototype.delete=function(e){var t=this._keys.indexOf(e);return-1!==t&&(this._values.splice(t,1),this._keys.splice(t,1),this.size--,!0)},e.prototype.clear=function(){this._keys.length=0,this._values.length=0,this.size=0},e.prototype.forEach=function(e,t){for(var n=0;n<this.size;n++)e.call(t,this._values[n],this._keys[n])},e}();t.MapPolyfill=r},function(e,t,n){"use strict";var r=function(){function e(){this.values={}}return e.prototype.delete=function(e){return this.values[e]=null,!0},e.prototype.set=function(e,t){return this.values[e]=t,this},e.prototype.get=function(e){return this.values[e]},e.prototype.forEach=function(e,t){var n=this.values;for(var r in n)n.hasOwnProperty(r)&&null!==n[r]&&e.call(t,n[r],r)},e.prototype.clear=function(){this.values={}},e}();t.FastMap=r},function(e,t,n){"use strict";var r=n(0),o=n(484);r.Observable.prototype.ignoreElements=o.ignoreElements},function(e,t,n){"use strict";function r(){return o.ignoreElements()(this)}var o=n(183);t.ignoreElements=r},function(e,t,n){"use strict";var r=n(0),o=n(486);r.Observable.prototype.isEmpty=o.isEmpty},function(e,t,n){"use strict";function r(){return o.isEmpty()(this)}var o=n(184);t.isEmpty=r},function(e,t,n){"use strict";var r=n(0),o=n(488);r.Observable.prototype.audit=o.audit},function(e,t,n){"use strict";function r(e){return o.audit(e)(this)}var o=n(110);t.audit=r},function(e,t,n){"use strict";var r=n(0),o=n(490);r.Observable.prototype.auditTime=o.auditTime},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.auditTime(e,t)(this)}var o=n(16),i=n(185);t.auditTime=r},function(e,t,n){"use strict";var r=n(0),o=n(492);r.Observable.prototype.last=o.last},function(e,t,n){"use strict";function r(e,t,n){return o.last(e,t,n)(this)}var o=n(186);t.last=r},function(e,t,n){"use strict";var r=n(0),o=n(494);r.Observable.prototype.let=o.letProto,r.Observable.prototype.letBind=o.letProto},function(e,t,n){"use strict";function r(e){return e(this)}t.letProto=r},function(e,t,n){"use strict";var r=n(0),o=n(496);r.Observable.prototype.every=o.every},function(e,t,n){"use strict";function r(e,t){return o.every(e,t)(this)}var o=n(187);t.every=r},function(e,t,n){"use strict";var r=n(0),o=n(498);r.Observable.prototype.map=o.map},function(e,t,n){"use strict";function r(e,t){return o.map(e,t)(this)}var o=n(55);t.map=r},function(e,t,n){"use strict";var r=n(0),o=n(500);r.Observable.prototype.mapTo=o.mapTo},function(e,t,n){"use strict";function r(e){return o.mapTo(e)(this)}var o=n(188);t.mapTo=r},function(e,t,n){"use strict";var r=n(0),o=n(502);r.Observable.prototype.materialize=o.materialize},function(e,t,n){"use strict";function r(){return o.materialize()(this)}var o=n(189);t.materialize=r},function(e,t,n){"use strict";var r=n(0),o=n(504);r.Observable.prototype.max=o.max},function(e,t,n){"use strict";function r(e){return o.max(e)(this)}var o=n(190);t.max=r},function(e,t,n){"use strict";var r=n(0),o=n(506);r.Observable.prototype.merge=o.merge},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.merge.apply(void 0,e)(this)}var o=n(191),i=n(75);t.mergeStatic=i.merge,t.merge=r},function(e,t,n){"use strict";var r=n(0),o=n(508);r.Observable.prototype.mergeAll=o.mergeAll},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=Number.POSITIVE_INFINITY),o.mergeAll(e)(this)}var o=n(74);t.mergeAll=r},function(e,t,n){"use strict";var r=n(0),o=n(510);r.Observable.prototype.mergeMap=o.mergeMap,r.Observable.prototype.flatMap=o.mergeMap},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),o.mergeMap(e,t,n)(this)}var o=n(51);t.mergeMap=r},function(e,t,n){"use strict";var r=n(0),o=n(512);r.Observable.prototype.flatMapTo=o.mergeMapTo,r.Observable.prototype.mergeMapTo=o.mergeMapTo},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),o.mergeMapTo(e,t,n)(this)}var o=n(192);t.mergeMapTo=r},function(e,t,n){"use strict";var r=n(0),o=n(514);r.Observable.prototype.mergeScan=o.mergeScan},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=Number.POSITIVE_INFINITY),o.mergeScan(e,t,n)(this)}var o=n(193);t.mergeScan=r},function(e,t,n){"use strict";var r=n(0),o=n(516);r.Observable.prototype.min=o.min},function(e,t,n){"use strict";function r(e){return o.min(e)(this)}var o=n(194);t.min=r},function(e,t,n){"use strict";var r=n(0),o=n(518);r.Observable.prototype.multicast=o.multicast},function(e,t,n){"use strict";function r(e,t){return o.multicast(e,t)(this)}var o=n(37);t.multicast=r},function(e,t,n){"use strict";var r=n(0),o=n(520);r.Observable.prototype.observeOn=o.observeOn},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),o.observeOn(e,t)(this)}var o=n(73);t.observeOn=r},function(e,t,n){"use strict";var r=n(0),o=n(522);r.Observable.prototype.onErrorResumeNext=o.onErrorResumeNext},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.onErrorResumeNext.apply(void 0,e)(this)}var o=n(104);t.onErrorResumeNext=r},function(e,t,n){"use strict";var r=n(0),o=n(524);r.Observable.prototype.pairwise=o.pairwise},function(e,t,n){"use strict";function r(){return o.pairwise()(this)}var o=n(196);t.pairwise=r},function(e,t,n){"use strict";var r=n(0),o=n(526);r.Observable.prototype.partition=o.partition},function(e,t,n){"use strict";function r(e,t){return o.partition(e,t)(this)}var o=n(197);t.partition=r},function(e,t,n){"use strict";function r(e,t){function n(){return!n.pred.apply(n.thisArg,arguments)}return n.pred=e,n.thisArg=t,n}t.not=r},function(e,t,n){"use strict";var r=n(0),o=n(529);r.Observable.prototype.pluck=o.pluck},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.pluck.apply(void 0,e)(this)}var o=n(198);t.pluck=r},function(e,t,n){"use strict";var r=n(0),o=n(531);r.Observable.prototype.publish=o.publish},function(e,t,n){"use strict";function r(e){return o.publish(e)(this)}var o=n(199);t.publish=r},function(e,t,n){"use strict";var r=n(0),o=n(533);r.Observable.prototype.publishBehavior=o.publishBehavior},function(e,t,n){"use strict";function r(e){return o.publishBehavior(e)(this)}var o=n(200);t.publishBehavior=r},function(e,t,n){"use strict";var r=n(0),o=n(535);r.Observable.prototype.publishReplay=o.publishReplay},function(e,t,n){"use strict";function r(e,t,n,r){return o.publishReplay(e,t,n,r)(this)}var o=n(202);t.publishReplay=r},function(e,t,n){"use strict";var r=n(0),o=n(537);r.Observable.prototype.publishLast=o.publishLast},function(e,t,n){"use strict";function r(){return o.publishLast()(this)}var o=n(203);t.publishLast=r},function(e,t,n){"use strict";var r=n(0),o=n(539);r.Observable.prototype.race=o.race},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.race.apply(void 0,e)(this)}var o=n(204),i=n(103);t.raceStatic=i.race,t.race=r},function(e,t,n){"use strict";var r=n(0),o=n(541);r.Observable.prototype.reduce=o.reduce},function(e,t,n){"use strict";function r(e,t){return arguments.length>=2?o.reduce(e,t)(this):o.reduce(e)(this)}var o=n(57);t.reduce=r},function(e,t,n){"use strict";var r=n(0),o=n(543);r.Observable.prototype.repeat=o.repeat},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=-1),o.repeat(e)(this)}var o=n(205);t.repeat=r},function(e,t,n){"use strict";var r=n(0),o=n(545);r.Observable.prototype.repeatWhen=o.repeatWhen},function(e,t,n){"use strict";function r(e){return o.repeatWhen(e)(this)}var o=n(206);t.repeatWhen=r},function(e,t,n){"use strict";var r=n(0),o=n(547);r.Observable.prototype.retry=o.retry},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=-1),o.retry(e)(this)}var o=n(207);t.retry=r},function(e,t,n){"use strict";var r=n(0),o=n(549);r.Observable.prototype.retryWhen=o.retryWhen},function(e,t,n){"use strict";function r(e){return o.retryWhen(e)(this)}var o=n(208);t.retryWhen=r},function(e,t,n){"use strict";var r=n(0),o=n(551);r.Observable.prototype.sample=o.sample},function(e,t,n){"use strict";function r(e){return o.sample(e)(this)}var o=n(209);t.sample=r},function(e,t,n){"use strict";var r=n(0),o=n(553);r.Observable.prototype.sampleTime=o.sampleTime},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.sampleTime(e,t)(this)}var o=n(16),i=n(210);t.sampleTime=r},function(e,t,n){"use strict";var r=n(0),o=n(555);r.Observable.prototype.scan=o.scan},function(e,t,n){"use strict";function r(e,t){return arguments.length>=2?o.scan(e,t)(this):o.scan(e)(this)}var o=n(111);t.scan=r},function(e,t,n){"use strict";var r=n(0),o=n(557);r.Observable.prototype.sequenceEqual=o.sequenceEqual},function(e,t,n){"use strict";function r(e,t){return o.sequenceEqual(e,t)(this)}var o=n(211);t.sequenceEqual=r},function(e,t,n){"use strict";var r=n(0),o=n(559);r.Observable.prototype.share=o.share},function(e,t,n){"use strict";function r(){return o.share()(this)}var o=n(212);t.share=r},function(e,t,n){"use strict";var r=n(0),o=n(561);r.Observable.prototype.shareReplay=o.shareReplay},function(e,t,n){"use strict";function r(e,t,n){return o.shareReplay(e,t,n)(this)}var o=n(213);t.shareReplay=r},function(e,t,n){"use strict";var r=n(0),o=n(563);r.Observable.prototype.single=o.single},function(e,t,n){"use strict";function r(e){return o.single(e)(this)}var o=n(214);t.single=r},function(e,t,n){"use strict";var r=n(0),o=n(565);r.Observable.prototype.skip=o.skip},function(e,t,n){"use strict";function r(e){return o.skip(e)(this)}var o=n(215);t.skip=r},function(e,t,n){"use strict";var r=n(0),o=n(567);r.Observable.prototype.skipLast=o.skipLast},function(e,t,n){"use strict";function r(e){return o.skipLast(e)(this)}var o=n(216);t.skipLast=r},function(e,t,n){"use strict";var r=n(0),o=n(569);r.Observable.prototype.skipUntil=o.skipUntil},function(e,t,n){"use strict";function r(e){return o.skipUntil(e)(this)}var o=n(217);t.skipUntil=r},function(e,t,n){"use strict";var r=n(0),o=n(571);r.Observable.prototype.skipWhile=o.skipWhile},function(e,t,n){"use strict";function r(e){return o.skipWhile(e)(this)}var o=n(218);t.skipWhile=r},function(e,t,n){"use strict";var r=n(0),o=n(573);r.Observable.prototype.startWith=o.startWith},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.startWith.apply(void 0,e)(this)}var o=n(219);t.startWith=r},function(e,t,n){"use strict";var r=n(0),o=n(575);r.Observable.prototype.subscribeOn=o.subscribeOn},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),o.subscribeOn(e,t)(this)}var o=n(576);t.subscribeOn=r},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),function(n){return n.lift(new i(e,t))}}var o=n(577);t.subscribeOn=r;var i=function(){function e(e,t){this.scheduler=e,this.delay=t}return e.prototype.call=function(e,t){return new o.SubscribeOnObservable(t,this.delay,this.scheduler).subscribe(e)},e}()},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(220),a=n(52),u=function(e){function t(t,n,r){void 0===n&&(n=0),void 0===r&&(r=i.asap),e.call(this),this.source=t,this.delayTime=n,this.scheduler=r,(!a.isNumeric(n)||n<0)&&(this.delayTime=0),r&&"function"==typeof r.schedule||(this.scheduler=i.asap)}return r(t,e),t.create=function(e,n,r){return void 0===n&&(n=0),void 0===r&&(r=i.asap),new t(e,n,r)},t.dispatch=function(e){var t=e.source,n=e.subscriber;return this.add(t.subscribe(n))},t.prototype._subscribe=function(e){var n=this.delayTime,r=this.source;return this.scheduler.schedule(t.dispatch,n,{source:r,subscriber:e})},t}(o.Observable);t.SubscribeOnObservable=u},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(579),i=n(53),a=function(e){function t(t,n){e.call(this,t,n),this.scheduler=t,this.work=n}return r(t,e),t.prototype.requestAsyncId=function(t,n,r){return void 0===r&&(r=0),null!==r&&r>0?e.prototype.requestAsyncId.call(this,t,n,r):(t.actions.push(this),t.scheduled||(t.scheduled=o.Immediate.setImmediate(t.flush.bind(t,null))))},t.prototype.recycleAsyncId=function(t,n,r){if(void 0===r&&(r=0),null!==r&&r>0||null===r&&this.delay>0)return e.prototype.recycleAsyncId.call(this,t,n,r);0===t.actions.length&&(o.Immediate.clearImmediate(n),t.scheduled=void 0)},t}(i.AsyncAction);t.AsapAction=a},function(e,t,n){"use strict";(function(e,r){var o=n(22),i=function(){function e(e){if(this.root=e,e.setImmediate&&"function"==typeof e.setImmediate)this.setImmediate=e.setImmediate.bind(e),this.clearImmediate=e.clearImmediate.bind(e);else{this.nextHandle=1,this.tasksByHandle={},this.currentlyRunningATask=!1,this.canUseProcessNextTick()?this.setImmediate=this.createProcessNextTickSetImmediate():this.canUsePostMessage()?this.setImmediate=this.createPostMessageSetImmediate():this.canUseMessageChannel()?this.setImmediate=this.createMessageChannelSetImmediate():this.canUseReadyStateChange()?this.setImmediate=this.createReadyStateChangeSetImmediate():this.setImmediate=this.createSetTimeoutSetImmediate();var t=function e(t){delete e.instance.tasksByHandle[t]};t.instance=this,this.clearImmediate=t}}return e.prototype.identify=function(e){return this.root.Object.prototype.toString.call(e)},e.prototype.canUseProcessNextTick=function(){return"[object process]"===this.identify(this.root.process)},e.prototype.canUseMessageChannel=function(){return Boolean(this.root.MessageChannel)},e.prototype.canUseReadyStateChange=function(){var e=this.root.document;return Boolean(e&&"onreadystatechange"in e.createElement("script"))},e.prototype.canUsePostMessage=function(){var e=this.root;if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}return!1},e.prototype.partiallyApplied=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var r=function e(){var t=e,n=t.handler,r=t.args;"function"==typeof n?n.apply(void 0,r):new Function(""+n)()};return r.handler=e,r.args=t,r},e.prototype.addFromSetImmediateArguments=function(e){return this.tasksByHandle[this.nextHandle]=this.partiallyApplied.apply(void 0,e),this.nextHandle++},e.prototype.createProcessNextTickSetImmediate=function(){var e=function e(){var t=e.instance,n=t.addFromSetImmediateArguments(arguments);return t.root.process.nextTick(t.partiallyApplied(t.runIfPresent,n)),n};return e.instance=this,e},e.prototype.createPostMessageSetImmediate=function(){var e=this.root,t="setImmediate$"+e.Math.random()+"$",n=function n(r){var o=n.instance;r.source===e&&"string"==typeof r.data&&0===r.data.indexOf(t)&&o.runIfPresent(+r.data.slice(t.length))};n.instance=this,e.addEventListener("message",n,!1);var r=function e(){var t=e,n=t.messagePrefix,r=t.instance,o=r.addFromSetImmediateArguments(arguments);return r.root.postMessage(n+o,"*"),o};return r.instance=this,r.messagePrefix=t,r},e.prototype.runIfPresent=function(e){if(this.currentlyRunningATask)this.root.setTimeout(this.partiallyApplied(this.runIfPresent,e),0);else{var t=this.tasksByHandle[e];if(t){this.currentlyRunningATask=!0;try{t()}finally{this.clearImmediate(e),this.currentlyRunningATask=!1}}}},e.prototype.createMessageChannelSetImmediate=function(){var e=this,t=new this.root.MessageChannel;t.port1.onmessage=function(t){var n=t.data;e.runIfPresent(n)};var n=function e(){var t=e,n=t.channel,r=t.instance,o=r.addFromSetImmediateArguments(arguments);return n.port2.postMessage(o),o};return n.channel=t,n.instance=this,n},e.prototype.createReadyStateChangeSetImmediate=function(){var e=function e(){var t=e.instance,n=t.root,r=n.document,o=r.documentElement,i=t.addFromSetImmediateArguments(arguments),a=r.createElement("script");return a.onreadystatechange=function(){t.runIfPresent(i),a.onreadystatechange=null,o.removeChild(a),a=null},o.appendChild(a),i};return e.instance=this,e},e.prototype.createSetTimeoutSetImmediate=function(){var e=function e(){var t=e.instance,n=t.addFromSetImmediateArguments(arguments);return t.root.setTimeout(t.partiallyApplied(t.runIfPresent,n),0),n};return e.instance=this,e},e}();t.ImmediateDefinition=i,t.Immediate=new i(o.root)}).call(t,n(221).clearImmediate,n(221).setImmediate)},function(e,t,n){(function(e,t){!function(e,n){"use strict";function r(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var r={callback:e,args:t};return l[s]=r,u(s),s++}function o(e){delete l[e]}function i(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}function a(e){if(c)setTimeout(a,0,e);else{var t=l[e];if(t){c=!0;try{i(t)}finally{o(e),c=!1}}}}if(!e.setImmediate){var u,s=1,l={},c=!1,f=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?function(){u=function(e){t.nextTick(function(){a(e)})}}():function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&a(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),u=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){a(e.data)},u=function(t){e.port2.postMessage(t)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var e=f.documentElement;u=function(t){var n=f.createElement("script");n.onreadystatechange=function(){a(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){u=function(e){setTimeout(a,0,e)}}(),d.setImmediate=r,d.clearImmediate=o}}("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(47),n(581))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(c===setTimeout)return setTimeout(e,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(e,0);try{return c(e,0)}catch(t){try{return c.call(null,e,0)}catch(t){return c.call(this,e,0)}}}function i(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function a(){y&&p&&(y=!1,p.length?h=p.concat(h):v=-1,h.length&&u())}function u(){if(!y){var e=o(a);y=!0;for(var t=h.length;t;){for(p=h,h=[];++v<t;)p&&p[v].run();v=-1,t=h.length}p=null,y=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function l(){}var c,f,d=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(e){c=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var p,h=[],y=!1,v=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||y||o(u)},s.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(54),i=function(e){function t(){e.apply(this,arguments)}return r(t,e),t.prototype.flush=function(e){this.active=!0,this.scheduled=void 0;var t,n=this.actions,r=-1,o=n.length;e=e||n.shift();do{if(t=e.execute(e.state,e.delay))break}while(++r<o&&(e=n.shift()));if(this.active=!1,t){for(;++r<o&&(e=n.shift());)e.unsubscribe();throw t}},t}(o.AsyncScheduler);t.AsapScheduler=i},function(e,t,n){"use strict";var r=n(0),o=n(584);r.Observable.prototype.switch=o._switch,r.Observable.prototype._switch=o._switch},function(e,t,n){"use strict";function r(){return o.switchAll()(this)}var o=n(222);t._switch=r},function(e,t,n){"use strict";var r=n(0),o=n(586);r.Observable.prototype.switchMap=o.switchMap},function(e,t,n){"use strict";function r(e,t){return o.switchMap(e,t)(this)}var o=n(114);t.switchMap=r},function(e,t,n){"use strict";var r=n(0),o=n(588);r.Observable.prototype.switchMapTo=o.switchMapTo},function(e,t,n){"use strict";function r(e,t){return o.switchMapTo(e,t)(this)}var o=n(223);t.switchMapTo=r},function(e,t,n){"use strict";var r=n(0),o=n(590);r.Observable.prototype.take=o.take},function(e,t,n){"use strict";function r(e){return o.take(e)(this)}var o=n(224);t.take=r},function(e,t,n){"use strict";var r=n(0),o=n(592);r.Observable.prototype.takeLast=o.takeLast},function(e,t,n){"use strict";function r(e){return o.takeLast(e)(this)}var o=n(112);t.takeLast=r},function(e,t,n){"use strict";var r=n(0),o=n(594);r.Observable.prototype.takeUntil=o.takeUntil},function(e,t,n){"use strict";function r(e){return o.takeUntil(e)(this)}var o=n(225);t.takeUntil=r},function(e,t,n){"use strict";var r=n(0),o=n(596);r.Observable.prototype.takeWhile=o.takeWhile},function(e,t,n){"use strict";function r(e){return o.takeWhile(e)(this)}var o=n(226);t.takeWhile=r},function(e,t,n){"use strict";var r=n(0),o=n(598);r.Observable.prototype.throttle=o.throttle},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.defaultThrottleConfig),o.throttle(e,t)(this)}var o=n(80);t.throttle=r},function(e,t,n){"use strict";var r=n(0),o=n(600);r.Observable.prototype.throttleTime=o.throttleTime},function(e,t,n){"use strict";function r(e,t,n){return void 0===t&&(t=o.async),void 0===n&&(n=i.defaultThrottleConfig),a.throttleTime(e,t,n)(this)}var o=n(16),i=n(80),a=n(227);t.throttleTime=r},function(e,t,n){"use strict";var r=n(0),o=n(228);r.Observable.prototype.timeInterval=o.timeInterval},function(e,t,n){"use strict";var r=n(0),o=n(603);r.Observable.prototype.timeout=o.timeout},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=o.async),i.timeout(e,t)(this)}var o=n(16),i=n(230);t.timeout=r},function(e,t,n){"use strict";var r=n(0),o=n(605);r.Observable.prototype.timeoutWith=o.timeoutWith},function(e,t,n){"use strict";function r(e,t,n){return void 0===n&&(n=o.async),i.timeoutWith(e,t,n)(this)}var o=n(16),i=n(232);t.timeoutWith=r},function(e,t,n){"use strict";var r=n(0),o=n(607);r.Observable.prototype.timestamp=o.timestamp},function(e,t,n){"use strict";function r(e){return void 0===e&&(e=o.async),i.timestamp(e)(this)}var o=n(16),i=n(115);t.timestamp=r},function(e,t,n){"use strict";var r=n(0),o=n(609);r.Observable.prototype.toArray=o.toArray},function(e,t,n){"use strict";function r(){return o.toArray()(this)}var o=n(233);t.toArray=r},function(e,t){},function(e,t,n){"use strict";var r=n(0),o=n(612);r.Observable.prototype.window=o.window},function(e,t,n){"use strict";function r(e){return o.window(e)(this)}var o=n(234);t.window=r},function(e,t,n){"use strict";var r=n(0),o=n(614);r.Observable.prototype.windowCount=o.windowCount},function(e,t,n){"use strict";function r(e,t){return void 0===t&&(t=0),o.windowCount(e,t)(this)}var o=n(235);t.windowCount=r},function(e,t,n){"use strict";var r=n(0),o=n(616);r.Observable.prototype.windowTime=o.windowTime},function(e,t,n){"use strict";function r(e){var t=o.async,n=null,r=Number.POSITIVE_INFINITY;return a.isScheduler(arguments[3])&&(t=arguments[3]),a.isScheduler(arguments[2])?t=arguments[2]:i.isNumeric(arguments[2])&&(r=arguments[2]),a.isScheduler(arguments[1])?t=arguments[1]:i.isNumeric(arguments[1])&&(n=arguments[1]),u.windowTime(e,n,r,t)(this)}var o=n(16),i=n(52),a=n(25),u=n(236);t.windowTime=r},function(e,t,n){"use strict";var r=n(0),o=n(618);r.Observable.prototype.windowToggle=o.windowToggle},function(e,t,n){"use strict";function r(e,t){return o.windowToggle(e,t)(this)}var o=n(237);t.windowToggle=r},function(e,t,n){"use strict";var r=n(0),o=n(620);r.Observable.prototype.windowWhen=o.windowWhen},function(e,t,n){"use strict";function r(e){return o.windowWhen(e)(this)}var o=n(238);t.windowWhen=r},function(e,t,n){"use strict";var r=n(0),o=n(622);r.Observable.prototype.withLatestFrom=o.withLatestFrom},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.withLatestFrom.apply(void 0,e)(this)}var o=n(239);t.withLatestFrom=r},function(e,t,n){"use strict";var r=n(0),o=n(624);r.Observable.prototype.zip=o.zipProto},function(e,t,n){"use strict";function r(){for(var e=[],t=0;t<arguments.length;t++)e[t-0]=arguments[t];return o.zip.apply(void 0,e)(this)}var o=n(77);t.zipProto=r},function(e,t,n){"use strict";var r=n(0),o=n(626);r.Observable.prototype.zipAll=o.zipAll},function(e,t,n){"use strict";function r(e){return o.zipAll(e)(this)}var o=n(240);t.zipAll=r},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(50),a=n(628),u=n(629),s=n(242),l=n(244),c=750,f=function(e){function t(t){e.call(this,l.VirtualAction,c),this.assertDeepEqual=t,this.hotObservables=[],this.coldObservables=[],this.flushTests=[]}return r(t,e),t.prototype.createTime=function(e){var n=e.indexOf("|");if(-1===n)throw new Error('marble diagram for time should have a completion marker "|"');return n*t.frameTimeFactor},t.prototype.createColdObservable=function(e,n,r){if(-1!==e.indexOf("^"))throw new Error('cold observable cannot have subscription offset "^"');if(-1!==e.indexOf("!"))throw new Error('cold observable cannot have unsubscription marker "!"');var o=t.parseMarbles(e,n,r),i=new a.ColdObservable(o,this);return this.coldObservables.push(i),i},t.prototype.createHotObservable=function(e,n,r){if(-1!==e.indexOf("!"))throw new Error('hot observable cannot have unsubscription marker "!"');var o=t.parseMarbles(e,n,r),i=new u.HotObservable(o,this);return this.hotObservables.push(i),i},t.prototype.materializeInnerObservable=function(e,t){var n=this,r=[];return e.subscribe(function(e){r.push({frame:n.frame-t,notification:i.Notification.createNext(e)})},function(e){r.push({frame:n.frame-t,notification:i.Notification.createError(e)})},function(){r.push({frame:n.frame-t,notification:i.Notification.createComplete()})}),r},t.prototype.expectObservable=function(e,n){var r=this;void 0===n&&(n=null);var a,u=[],s={actual:u,ready:!1},l=t.parseMarblesAsSubscriptions(n).unsubscribedFrame;return this.schedule(function(){a=e.subscribe(function(e){var t=e;e instanceof o.Observable&&(t=r.materializeInnerObservable(t,r.frame)),u.push({frame:r.frame,notification:i.Notification.createNext(t)})},function(e){u.push({frame:r.frame,notification:i.Notification.createError(e)})},function(){u.push({frame:r.frame,notification:i.Notification.createComplete()})})},0),l!==Number.POSITIVE_INFINITY&&this.schedule(function(){return a.unsubscribe()},l),this.flushTests.push(s),{toBe:function(e,n,r){s.ready=!0,s.expected=t.parseMarbles(e,n,r,!0)}}},t.prototype.expectSubscriptions=function(e){var n={actual:e,ready:!1};return this.flushTests.push(n),{toBe:function(e){var r="string"==typeof e?[e]:e;n.ready=!0,n.expected=r.map(function(e){return t.parseMarblesAsSubscriptions(e)})}}},t.prototype.flush=function(){for(var t=this.hotObservables;t.length>0;)t.shift().setup();e.prototype.flush.call(this);for(var n=this.flushTests.filter(function(e){return e.ready});n.length>0;){var r=n.shift();this.assertDeepEqual(r.actual,r.expected)}},t.parseMarblesAsSubscriptions=function(e){if("string"!=typeof e)return new s.SubscriptionLog(Number.POSITIVE_INFINITY);for(var t=e.length,n=-1,r=Number.POSITIVE_INFINITY,o=Number.POSITIVE_INFINITY,i=0;i<t;i++){var a=i*this.frameTimeFactor,u=e[i];switch(u){case"-":case" ":break;case"(":n=a;break;case")":n=-1;break;case"^":if(r!==Number.POSITIVE_INFINITY)throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");r=n>-1?n:a;break;case"!":if(o!==Number.POSITIVE_INFINITY)throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");o=n>-1?n:a;break;default:throw new Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '"+u+"'.")}}return o<0?new s.SubscriptionLog(r):new s.SubscriptionLog(r,o)},t.parseMarbles=function(e,t,n,r){if(void 0===r&&(r=!1),-1!==e.indexOf("!"))throw new Error('conventional marble diagrams cannot have the unsubscription marker "!"');for(var o=e.length,u=[],s=e.indexOf("^"),l=-1===s?0:s*-this.frameTimeFactor,c="object"!=typeof t?function(e){return e}:function(e){return r&&t[e]instanceof a.ColdObservable?t[e].messages:t[e]},f=-1,d=0;d<o;d++){var p=d*this.frameTimeFactor+l,h=void 0,y=e[d];switch(y){case"-":case" ":break;case"(":f=p;break;case")":f=-1;break;case"|":h=i.Notification.createComplete();break;case"^":break;case"#":h=i.Notification.createError(n||"error");break;default:h=i.Notification.createNext(c(y))}h&&u.push({frame:f>-1?f:p,notification:h})}return u},t}(l.VirtualTimeScheduler);t.TestScheduler=f},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(0),i=n(18),a=n(241),u=n(243),s=function(e){function t(t,n){e.call(this,function(e){var t=this,n=t.logSubscribedFrame();return e.add(new i.Subscription(function(){t.logUnsubscribedFrame(n)})),t.scheduleMessages(e),e}),this.messages=t,this.subscriptions=[],this.scheduler=n}return r(t,e),t.prototype.scheduleMessages=function(e){for(var t=this.messages.length,n=0;n<t;n++){var r=this.messages[n];e.add(this.scheduler.schedule(function(e){var t=e.message,n=e.subscriber;t.notification.observe(n)},r.frame,{message:r,subscriber:e}))}},t}(o.Observable);t.ColdObservable=s,u.applyMixins(s,[a.SubscriptionLoggable])},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(19),i=n(18),a=n(241),u=n(243),s=function(e){function t(t,n){e.call(this),this.messages=t,this.subscriptions=[],this.scheduler=n}return r(t,e),t.prototype._subscribe=function(t){var n=this,r=n.logSubscribedFrame();return t.add(new i.Subscription(function(){n.logUnsubscribedFrame(r)})),e.prototype._subscribe.call(this,t)},t.prototype.setup=function(){for(var e=this,t=e.messages.length,n=0;n<t;n++)!function(){var t=e.messages[n];e.scheduler.schedule(function(){t.notification.observe(e)},t.frame)}()},t}(o.Subject);t.HotObservable=s,u.applyMixins(s,[a.SubscriptionLoggable])},function(e,t,n){"use strict";var r=n(631),o=n(633);t.animationFrame=new o.AnimationFrameScheduler(r.AnimationFrameAction)},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(53),i=n(632),a=function(e){function t(t,n){e.call(this,t,n),this.scheduler=t,this.work=n}return r(t,e),t.prototype.requestAsyncId=function(t,n,r){return void 0===r&&(r=0),null!==r&&r>0?e.prototype.requestAsyncId.call(this,t,n,r):(t.actions.push(this),t.scheduled||(t.scheduled=i.AnimationFrame.requestAnimationFrame(t.flush.bind(t,null))))},t.prototype.recycleAsyncId=function(t,n,r){if(void 0===r&&(r=0),null!==r&&r>0||null===r&&this.delay>0)return e.prototype.recycleAsyncId.call(this,t,n,r);0===t.actions.length&&(i.AnimationFrame.cancelAnimationFrame(n),t.scheduled=void 0)},t}(o.AsyncAction);t.AnimationFrameAction=a},function(e,t,n){"use strict";var r=n(22),o=function(){function e(e){e.requestAnimationFrame?(this.cancelAnimationFrame=e.cancelAnimationFrame.bind(e),this.requestAnimationFrame=e.requestAnimationFrame.bind(e)):e.mozRequestAnimationFrame?(this.cancelAnimationFrame=e.mozCancelAnimationFrame.bind(e),this.requestAnimationFrame=e.mozRequestAnimationFrame.bind(e)):e.webkitRequestAnimationFrame?(this.cancelAnimationFrame=e.webkitCancelAnimationFrame.bind(e),this.requestAnimationFrame=e.webkitRequestAnimationFrame.bind(e)):e.msRequestAnimationFrame?(this.cancelAnimationFrame=e.msCancelAnimationFrame.bind(e),this.requestAnimationFrame=e.msRequestAnimationFrame.bind(e)):e.oRequestAnimationFrame?(this.cancelAnimationFrame=e.oCancelAnimationFrame.bind(e),this.requestAnimationFrame=e.oRequestAnimationFrame.bind(e)):(this.cancelAnimationFrame=e.clearTimeout.bind(e),this.requestAnimationFrame=function(t){return e.setTimeout(t,1e3/60)})}return e}();t.RequestAnimationFrameDefinition=o,t.AnimationFrame=new o(r.root)},function(e,t,n){"use strict";var r=this&&this.__extends||function(e,t){function n(){this.constructor=e}for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)},o=n(54),i=function(e){function t(){e.apply(this,arguments)}return r(t,e),t.prototype.flush=function(e){this.active=!0,this.scheduled=void 0;var t,n=this.actions,r=-1,o=n.length;e=e||n.shift();do{if(t=e.execute(e.state,e.delay))break}while(++r<o&&(e=n.shift()));if(this.active=!1,t){for(;++r<o&&(e=n.shift());)e.unsubscribe();throw t}},t}(o.AsyncScheduler);t.AnimationFrameScheduler=i},function(e,t,n){"use strict";var r=n(110);t.audit=r.audit;var o=n(185);t.auditTime=o.auditTime;var i=n(157);t.buffer=i.buffer;var a=n(158);t.bufferCount=a.bufferCount;var u=n(159);t.bufferTime=u.bufferTime;var s=n(160);t.bufferToggle=s.bufferToggle;var l=n(161);t.bufferWhen=l.bufferWhen;var c=n(162);t.catchError=c.catchError;var f=n(163);t.combineAll=f.combineAll;var d=n(72);t.combineLatest=d.combineLatest;var p=n(164);t.concat=p.concat;var h=n(102);t.concatAll=h.concatAll;var y=n(105);t.concatMap=y.concatMap;var v=n(165);t.concatMapTo=v.concatMapTo;var m=n(166);t.count=m.count;var b=n(168);t.debounce=b.debounce;var g=n(169);t.debounceTime=g.debounceTime;var _=n(106);t.defaultIfEmpty=_.defaultIfEmpty;var w=n(170);t.delay=w.delay;var x=n(171);t.delayWhen=x.delayWhen;var O=n(167);t.dematerialize=O.dematerialize;var S=n(172);t.distinct=S.distinct;var T=n(107);t.distinctUntilChanged=T.distinctUntilChanged;var E=n(173);t.distinctUntilKeyChanged=E.distinctUntilKeyChanged;var C=n(178);t.elementAt=C.elementAt;var k=n(187);t.every=k.every;var P=n(175);t.exhaust=P.exhaust;var M=n(176);t.exhaustMap=M.exhaustMap;var j=n(177);t.expand=j.expand;var N=n(108);t.filter=N.filter;var I=n(179);t.finalize=I.finalize;var A=n(109);t.find=A.find;var R=n(180);t.findIndex=R.findIndex;var F=n(181);t.first=F.first;var D=n(182);t.groupBy=D.groupBy;var L=n(183);t.ignoreElements=L.ignoreElements;var z=n(184);t.isEmpty=z.isEmpty;var V=n(186);t.last=V.last;var U=n(55);t.map=U.map;var W=n(188);t.mapTo=W.mapTo;var H=n(189);t.materialize=H.materialize;var B=n(190);t.max=B.max;var K=n(191);t.merge=K.merge;var q=n(74);t.mergeAll=q.mergeAll;var G=n(51);t.mergeMap=G.mergeMap;var Y=n(51);t.flatMap=Y.mergeMap;var X=n(192);t.mergeMapTo=X.mergeMapTo;var $=n(193);t.mergeScan=$.mergeScan;var Q=n(194);t.min=Q.min;var J=n(37);t.multicast=J.multicast;var Z=n(73);t.observeOn=Z.observeOn;var ee=n(104);t.onErrorResumeNext=ee.onErrorResumeNext;var te=n(196);t.pairwise=te.pairwise;var ne=n(197);t.partition=ne.partition;var re=n(198);t.pluck=re.pluck;var oe=n(199);t.publish=oe.publish;var ie=n(200);t.publishBehavior=ie.publishBehavior;var ae=n(203);t.publishLast=ae.publishLast;var ue=n(202);t.publishReplay=ue.publishReplay;var se=n(204);t.race=se.race;var le=n(57);t.reduce=le.reduce;var ce=n(205);t.repeat=ce.repeat;var fe=n(206);t.repeatWhen=fe.repeatWhen;var de=n(207);t.retry=de.retry;var pe=n(208);t.retryWhen=pe.retryWhen;var he=n(113);t.refCount=he.refCount;var ye=n(209);t.sample=ye.sample;var ve=n(210);t.sampleTime=ve.sampleTime;var me=n(111);t.scan=me.scan;var be=n(211);t.sequenceEqual=be.sequenceEqual;var ge=n(212);t.share=ge.share;var _e=n(213);t.shareReplay=_e.shareReplay;var we=n(214);t.single=we.single;var xe=n(215);t.skip=xe.skip;var Oe=n(216);t.skipLast=Oe.skipLast;var Se=n(217);t.skipUntil=Se.skipUntil;var Te=n(218);t.skipWhile=Te.skipWhile;var Ee=n(219);t.startWith=Ee.startWith;var Ce=n(222);t.switchAll=Ce.switchAll;var ke=n(114);t.switchMap=ke.switchMap;var Pe=n(223);t.switchMapTo=Pe.switchMapTo;var Me=n(224);t.take=Me.take;var je=n(112);t.takeLast=je.takeLast;var Ne=n(225);t.takeUntil=Ne.takeUntil;var Ie=n(226);t.takeWhile=Ie.takeWhile;var Ae=n(174);t.tap=Ae.tap;var Re=n(80);t.throttle=Re.throttle;var Fe=n(227);t.throttleTime=Fe.throttleTime;var De=n(229);t.timeInterval=De.timeInterval;var Le=n(230);t.timeout=Le.timeout;var ze=n(232);t.timeoutWith=ze.timeoutWith;var Ve=n(115);t.timestamp=Ve.timestamp;var Ue=n(233);t.toArray=Ue.toArray;var We=n(234);t.window=We.window;var He=n(235);t.windowCount=He.windowCount;var Be=n(236);t.windowTime=Be.windowTime;var Ke=n(237);t.windowToggle=Ke.windowToggle;var qe=n(238);t.windowWhen=qe.windowWhen;var Ge=n(239);t.withLatestFrom=Ge.withLatestFrom;var Ye=n(77);t.zip=Ye.zip;var Xe=n(240);t.zipAll=Xe.zipAll},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(636),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=n.anchorEl,o=e.fullWidth,i={root:{display:"inline-block",position:"relative",width:o?"100%":256},menu:{width:"100%"},list:{display:"block",width:o?"100%":256},innerDiv:{overflow:"hidden"}};return r&&o&&(i.popover={width:r.clientWidth}),i}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(60),s=r(u),l=n(15),c=r(l),f=n(11),d=r(f),p=n(8),h=r(p),y=n(9),v=r(y),m=n(12),b=r(m),g=n(13),_=r(g),w=n(10),x=r(w),O=n(1),S=r(O),T=n(3),E=r(T),C=n(23),k=r(C),P=n(64),M=r(P),j=n(637),N=r(j),I=n(245),A=r(I),R=n(116),F=r(R),D=n(98),L=r(D),z=n(117),V=r(z),U=n(31),W=(r(U),function(e){function t(){var e,n,r,o;(0,h.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,b.default)(this,(e=t.__proto__||(0,d.default)(t)).call.apply(e,[this].concat(a))),r.state={anchorEl:null,focusTextField:!0,open:!1,searchText:void 0},r.handleRequestClose=function(){r.state.focusTextField||r.close()},r.handleMouseDown=function(e){e.preventDefault()},r.handleItemTouchTap=function(e,t){var n=r.props.dataSource,o=parseInt(t.key,10),i=n[o],a=r.chosenRequestText(i),u=function(){return r.props.onUpdateInput(a,r.props.dataSource,{source:"click"})};r.timerTouchTapCloseId=function(){return setTimeout(function(){r.timerTouchTapCloseId=null,r.close(),r.props.onNewRequest(i,o)},r.props.menuCloseDelay)},void 0!==r.props.searchText?(u(),r.timerTouchTapCloseId()):r.setState({searchText:a},function(){u(),r.timerTouchTapCloseId()})},r.chosenRequestText=function(e){return"string"==typeof e?e:e[r.props.dataSourceConfig.text]},r.handleEscKeyDown=function(){r.close()},r.handleKeyDown=function(e){switch(r.props.onKeyDown&&r.props.onKeyDown(e),(0,M.default)(e)){case"enter":r.close();var t=r.state.searchText;""!==t&&r.props.onNewRequest(t,-1);break;case"esc":r.close();break;case"down":e.preventDefault(),r.setState({open:!0,focusTextField:!1,anchorEl:k.default.findDOMNode(r.refs.searchTextField)})}},r.handleChange=function(e){var t=e.target.value;if(t!==r.state.searchText){var n={open:!0,anchorEl:k.default.findDOMNode(r.refs.searchTextField)};void 0===r.props.searchText&&(n.searchText=t),r.setState(n),r.props.onUpdateInput(t,r.props.dataSource,{source:"change"})}},r.handleBlur=function(e){r.state.focusTextField&&null===r.timerTouchTapCloseId&&(r.timerBlurClose=setTimeout(function(){r.close()},0)),r.props.onBlur&&r.props.onBlur(e)},r.handleFocus=function(e){!r.state.open&&r.props.openOnFocus&&r.setState({open:!0,anchorEl:k.default.findDOMNode(r.refs.searchTextField)}),r.setState({focusTextField:!0}),r.props.onFocus&&r.props.onFocus(e)},o=n,(0,b.default)(r,o)}return(0,_.default)(t,e),(0,v.default)(t,[{key:"componentWillMount",value:function(){this.requestsList=[],this.setState({open:this.props.open,searchText:this.props.searchText||""}),this.timerTouchTapCloseId=null}},{key:"componentWillReceiveProps",value:function(e){this.props.searchText!==e.searchText&&this.setState({searchText:e.searchText}),this.props.open!==e.open&&this.setState({open:e.open,anchorEl:k.default.findDOMNode(this.refs.searchTextField)})}},{key:"componentWillUnmount",value:function(){clearTimeout(this.timerTouchTapCloseId),clearTimeout(this.timerBlurClose)}},{key:"close",value:function(){this.setState({open:!1,anchorEl:null}),this.props.onClose&&this.props.onClose()}},{key:"blur",value:function(){this.refs.searchTextField.blur()}},{key:"focus",value:function(){this.refs.searchTextField.focus()}},{key:"render",value:function(){var e=this,t=this.props,n=t.anchorOrigin,r=t.animated,i=t.animation,u=t.dataSource,l=(t.dataSourceConfig,t.disableFocusRipple),f=t.errorStyle,d=t.floatingLabelText,p=t.filter,h=t.fullWidth,y=t.style,v=t.hintText,m=t.maxSearchResults,b=(t.menuCloseDelay,t.textFieldStyle),g=t.menuStyle,_=t.menuProps,w=t.listStyle,O=t.targetOrigin,T=(t.onBlur,t.onClose,t.onFocus,t.onKeyDown,t.onNewRequest,t.onUpdateInput,t.openOnFocus,t.popoverProps),E=(t.searchText,(0,c.default)(t,["anchorOrigin","animated","animation","dataSource","dataSourceConfig","disableFocusRipple","errorStyle","floatingLabelText","filter","fullWidth","style","hintText","maxSearchResults","menuCloseDelay","textFieldStyle","menuStyle","menuProps","listStyle","targetOrigin","onBlur","onClose","onFocus","onKeyDown","onNewRequest","onUpdateInput","openOnFocus","popoverProps","searchText"])),C=T||{},k=C.style,P=(0,c.default)(C,["style"]),M=this.state,j=M.open,I=M.anchorEl,R=M.searchText,D=M.focusTextField,z=this.context.muiTheme.prepareStyles,U=o(this.props,this.context,this.state),W=[];u.every(function(t,n){switch(void 0===t?"undefined":(0,s.default)(t)){case"string":p(R,t,t)&&W.push({text:t,value:S.default.createElement(F.default,{innerDivStyle:U.innerDiv,value:t,primaryText:t,disableFocusRipple:l,key:n})});break;case"object":if(t&&"string"==typeof t[e.props.dataSourceConfig.text]){var r=t[e.props.dataSourceConfig.text];if(!e.props.filter(R,r,t))break;var o=t[e.props.dataSourceConfig.value];!o.type||o.type.muiName!==F.default.muiName&&o.type.muiName!==L.default.muiName?W.push({text:r,value:S.default.createElement(F.default,{innerDivStyle:U.innerDiv,primaryText:r,disableFocusRipple:l,key:n})}):W.push({text:r,value:S.default.cloneElement(o,{key:n,disableFocusRipple:l})})}}return!(m&&m>0&&W.length===m)}),this.requestsList=W;var H=j&&W.length>0&&S.default.createElement(A.default,(0,a.default)({ref:"menu",autoWidth:!1,disableAutoFocus:D,onEscKeyDown:this.handleEscKeyDown,initiallyKeyboardFocused:!0,onItemTouchTap:this.handleItemTouchTap,onMouseDown:this.handleMouseDown,style:(0,x.default)(U.menu,g),listStyle:(0,x.default)(U.list,w)},_),W.map(function(e){return e.value}));return S.default.createElement("div",{style:z((0,x.default)(U.root,y))},S.default.createElement(N.default,(0,a.default)({ref:"searchTextField",autoComplete:"off",onBlur:this.handleBlur,onFocus:this.handleFocus,onKeyDown:this.handleKeyDown,floatingLabelText:d,hintText:v,fullWidth:h,multiLine:!1,errorStyle:f,style:b},E,{value:R,onChange:this.handleChange})),S.default.createElement(V.default,(0,a.default)({style:(0,x.default)({},U.popover,k),canAutoPosition:!1,anchorOrigin:n,targetOrigin:O,open:j,anchorEl:I,useLayerForClickAway:!1,onRequestClose:this.handleRequestClose,animated:r,animation:i},P),H))}}]),t}(O.Component));W.defaultProps={anchorOrigin:{vertical:"bottom",horizontal:"left"},animated:!0,dataSourceConfig:{text:"text",value:"value"},disableFocusRipple:!0,filter:function(e,t){return""!==e&&-1!==t.indexOf(e)},fullWidth:!1,open:!1,openOnFocus:!1,onUpdateInput:function(){},onNewRequest:function(){},menuCloseDelay:300,targetOrigin:{vertical:"top",horizontal:"left"}},W.contextTypes={muiTheme:E.default.object.isRequired},W.propTypes={},W.levenshteinDistance=function(e,t){for(var n=[],r=void 0,o=void 0,i=0;i<=t.length;i++)for(var a=0;a<=e.length;a++)o=i&&a?e.charAt(a-1)===t.charAt(i-1)?r:Math.min(n[a],n[a-1],r)+1:i+a,r=n[a],n[a]=o;return n.pop()},W.noFilter=function(){return!0},W.defaultFilter=W.caseSensitiveFilter=function(e,t){return""!==e&&-1!==t.indexOf(e)},W.caseInsensitiveFilter=function(e,t){return-1!==t.toLowerCase().indexOf(e.toLowerCase())},W.levenshteinDistanceFilter=function(e){if(void 0===e)return W.levenshteinDistance;if("number"!=typeof e)throw"Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!";return function(t,n){return W.levenshteinDistance(t,n)<e}},W.fuzzyFilter=function(e,t){var n=t.toLowerCase();e=e.toLowerCase();for(var r=0,o=0;o<t.length;o++)n[o]===e[r]&&(r+=1);return r===e.length},W.Item=F.default,W.Divider=L.default,t.default=W},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(638),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){return""!==e&&void 0!==e&&null!==e&&!(Array.isArray(e)&&0===e.length)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(23),E=r(T),C=n(36),k=r(C),P=n(17),M=r(P),j=n(639),N=r(j),I=n(640),A=r(I),R=n(641),F=r(R),D=n(642),L=r(D),z=n(63),V=(r(z),function(e,t,n){var r=t.muiTheme,o=r.baseTheme,i=r.textField,a=i.floatingLabelColor,u=i.focusColor,s=i.textColor,l=i.disabledTextColor,c=i.backgroundColor,f=i.errorColor,d={root:{fontSize:16,lineHeight:"24px",width:e.fullWidth?"100%":256,height:24*(e.rows-1)+(e.floatingLabelText?72:48),display:"inline-block",position:"relative",backgroundColor:c,fontFamily:o.fontFamily,transition:M.default.easeOut("200ms","height"),cursor:e.disabled?"not-allowed":"auto"},error:{position:"relative",bottom:2,fontSize:12,lineHeight:"12px",color:f,transition:M.default.easeOut()},floatingLabel:{color:e.disabled?l:a,pointerEvents:"none"},input:{padding:0,position:"relative",width:"100%",border:"none",outline:"none",backgroundColor:"rgba(0,0,0,0)",color:e.disabled?l:s,cursor:"inherit",font:"inherit",WebkitOpacity:1,WebkitTapHighlightColor:"rgba(0,0,0,0)"},inputNative:{appearance:"textfield"}};return d.textarea=(0,_.default)({},d.input,{marginTop:e.floatingLabelText?36:12,marginBottom:e.floatingLabelText?-36:-12,boxSizing:"border-box",font:"inherit"}),d.input.height="100%",n.isFocused&&(d.floatingLabel.color=u),e.floatingLabelText&&(d.input.boxSizing="border-box",e.multiLine||(d.input.marginTop=14),n.errorText&&(d.error.bottom=e.multiLine?3:d.error.fontSize+3)),n.errorText&&n.isFocused&&(d.floatingLabel.color=d.error.color),d}),U=function(e){function t(){var e,n,r,i;(0,d.default)(this,t);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(u))),r.state={isFocused:!1,errorText:void 0,hasValue:!1},r.handleInputBlur=function(e){r.setState({isFocused:!1}),r.props.onBlur&&r.props.onBlur(e)},r.handleInputChange=function(e){r.props.hasOwnProperty("value")||r.setState({hasValue:o(e.target.value)}),r.props.onChange&&r.props.onChange(e,e.target.value)},r.handleInputFocus=function(e){r.props.disabled||(r.setState({isFocused:!0}),r.props.onFocus&&r.props.onFocus(e))},r.handleHeightChange=function(e,t){var n=t+24;r.props.floatingLabelText&&(n+=24),E.default.findDOMNode(r).style.height=n+"px"},i=n,(0,v.default)(r,i)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){var e=this.props,t=e.children,n=e.name,r=e.hintText,i=e.floatingLabelText,a=(e.id,t?t.props:this.props);this.setState({errorText:this.props.errorText,hasValue:o(a.value)||o(a.defaultValue)});var u=n+"-"+r+"-"+i+"-"+Math.floor(65535*Math.random());this.uniqueId=u.replace(/[^A-Za-z0-9-]/gi,"")}},{key:"componentWillReceiveProps",value:function(e){if(e.disabled&&!this.props.disabled&&this.setState({isFocused:!1}),e.errorText!==this.props.errorText&&this.setState({errorText:e.errorText}),e.children&&e.children.props&&(e=e.children.props),e.hasOwnProperty("value")){var t=o(e.value);this.setState({hasValue:t})}}},{key:"shouldComponentUpdate",value:function(e,t,n){return!(0,k.default)(this.props,e)||!(0,k.default)(this.state,t)||!(0,k.default)(this.context,n)}},{key:"blur",value:function(){this.input&&this.getInputNode().blur()}},{key:"focus",value:function(){this.input&&this.getInputNode().focus()}},{key:"select",value:function(){this.input&&this.getInputNode().select()}},{key:"getValue",value:function(){return this.input?this.getInputNode().value:void 0}},{key:"getInputNode",value:function(){return this.props.children||this.props.multiLine?this.input.getInputNode():E.default.findDOMNode(this.input)}},{key:"_isControlled",value:function(){return this.props.hasOwnProperty("value")}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,r=t.className,o=t.disabled,i=t.errorStyle,u=(t.errorText,t.floatingLabelFixed),l=t.floatingLabelFocusStyle,c=t.floatingLabelShrinkStyle,f=t.floatingLabelStyle,d=t.floatingLabelText,p=(t.fullWidth,t.hintText),h=t.hintStyle,y=t.id,v=t.inputStyle,m=t.multiLine,b=(t.onBlur,t.onChange,t.onFocus,t.style),g=t.type,w=t.underlineDisabledStyle,O=t.underlineFocusStyle,S=t.underlineShow,T=t.underlineStyle,E=t.rows,C=t.rowsMax,k=t.textareaStyle,P=(0,s.default)(t,["children","className","disabled","errorStyle","errorText","floatingLabelFixed","floatingLabelFocusStyle","floatingLabelShrinkStyle","floatingLabelStyle","floatingLabelText","fullWidth","hintText","hintStyle","id","inputStyle","multiLine","onBlur","onChange","onFocus","style","type","underlineDisabledStyle","underlineFocusStyle","underlineShow","underlineStyle","rows","rowsMax","textareaStyle"]),M=this.context.muiTheme.prepareStyles,j=V(this.props,this.context,this.state),I=y||this.uniqueId,R=this.state.errorText&&x.default.createElement("div",{style:M((0,_.default)(j.error,i))},this.state.errorText),D=d&&x.default.createElement(F.default,{muiTheme:this.context.muiTheme,style:(0,_.default)(j.floatingLabel,f,this.state.isFocused?l:null),shrinkStyle:c,htmlFor:I,shrink:this.state.hasValue||this.state.isFocused||u,disabled:o},d),z={id:I,ref:function(t){return e.input=t},disabled:this.props.disabled,onBlur:this.handleInputBlur,onChange:this.handleInputChange,onFocus:this.handleInputFocus},U=(0,_.default)(j.input,v),W=void 0;W=n?x.default.cloneElement(n,(0,a.default)({},z,n.props,{style:(0,_.default)(U,n.props.style)})):m?x.default.createElement(N.default,(0,a.default)({style:U,textareaStyle:(0,_.default)(j.textarea,j.inputNative,k),rows:E,rowsMax:C,hintText:p},P,z,{onHeightChange:this.handleHeightChange})):x.default.createElement("input",(0,a.default)({type:g,style:M((0,_.default)(j.inputNative,U))},P,z));var H={};return n&&(H=P),x.default.createElement("div",(0,a.default)({},H,{className:r,style:M((0,_.default)(j.root,b))}),D,p?x.default.createElement(A.default,{muiTheme:this.context.muiTheme,show:!(this.state.hasValue||d&&!this.state.isFocused)||!this.state.hasValue&&d&&u&&!this.state.isFocused,style:h,text:p}):null,W,S?x.default.createElement(L.default,{disabled:o,disabledStyle:w,error:!!this.state.errorText,errorStyle:i,focus:this.state.isFocused,focusStyle:O,muiTheme:this.context.muiTheme,style:T}):null,R)}}]),t}(w.Component);U.defaultProps={disabled:!1,floatingLabelFixed:!1,multiLine:!1,fullWidth:!1,type:"text",underlineShow:!0,rows:1},U.contextTypes={muiTheme:S.default.object.isRequired},U.propTypes={},t.default=U},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return{root:{position:"relative"},textarea:{height:n.height,width:"100%",resize:"none",font:"inherit",padding:0,cursor:"inherit"},shadow:{resize:"none",overflow:"hidden",visibility:"hidden",position:"absolute",height:"auto"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(62),E=r(T),C=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={height:null},r.handleResize=function(e){r.syncHeightWithShadow(r.props.value,e)},r.handleChange=function(e){r.props.hasOwnProperty("value")||r.syncHeightWithShadow(e.target.value),r.props.hasOwnProperty("valueLink")&&r.props.valueLink.requestChange(e.target.value),r.props.onChange&&r.props.onChange(e)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){this.setState({height:24*this.props.rows})}},{key:"componentDidMount",value:function(){this.syncHeightWithShadow(this.props.value)}},{key:"componentWillReceiveProps",value:function(e){e.value===this.props.value&&e.rowsMax===this.props.rowsMax||this.syncHeightWithShadow(e.value,null,e)}},{key:"getInputNode",value:function(){return this.refs.input}},{key:"setValue",value:function(e){this.getInputNode().value=e,this.syncHeightWithShadow(e)}},{key:"syncHeightWithShadow",value:function(e,t,n){var r=this.refs.shadow,o=!this.props.hintText||""!==e&&void 0!==e&&null!==e?e:this.props.hintText;void 0!==o&&(r.value=o);var i=r.scrollHeight;if(void 0!==i&&(n=n||this.props,n.rowsMax>=n.rows&&(i=Math.min(24*n.rowsMax,i)),i=Math.max(i,24),this.state.height!==i)){var a=this.refs.input,u=a.selectionStart;this.setState({height:i},function(){a.setSelectionRange(u,u)}),n.onHeightChange&&n.onHeightChange(t,i)}}},{key:"render",value:function(){var e=this.props,t=(e.onChange,e.onHeightChange,e.rows,e.rowsMax,e.shadowStyle),n=e.style,r=(e.hintText,e.textareaStyle),i=e.valueLink,u=(0,s.default)(e,["onChange","onHeightChange","rows","rowsMax","shadowStyle","style","hintText","textareaStyle","valueLink"]),l=this.context.muiTheme.prepareStyles,c=o(this.props,this.context,this.state),f=(0,_.default)(c.root,n),d=(0,_.default)(c.textarea,r),p=(0,_.default)({},d,c.shadow,t),h={};return this.props.hasOwnProperty("valueLink")&&(u.value=i.value,h.valueLink=i),x.default.createElement("div",{style:l(f)},x.default.createElement(E.default,{target:"window",onResize:this.handleResize}),x.default.createElement("textarea",(0,a.default)({ref:"shadow",style:l(p),tabIndex:"-1",rows:this.props.rows,defaultValue:this.props.defaultValue,readOnly:!0,value:this.props.value},h)),x.default.createElement("textarea",(0,a.default)({},u,{ref:"input",rows:this.props.rows,style:l(d),onChange:this.handleChange})))}}]),t}(w.Component);C.defaultProps={rows:1},C.contextTypes={muiTheme:S.default.object.isRequired},C.propTypes={},t.default=C},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.muiTheme.textField.hintColor;return{root:{position:"absolute",opacity:e.show?1:0,color:t,transition:f.default.easeOut(),bottom:12}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(10),a=r(i),u=n(1),s=r(u),l=n(3),c=(r(l),n(17)),f=r(c),d=function(e){var t=e.muiTheme.prepareStyles,n=e.style,r=e.text,i=o(e);return s.default.createElement("div",{style:t((0,a.default)(i.root,n))},r)};d.propTypes={},d.defaultProps={show:!0},t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={position:"absolute",lineHeight:"22px",top:38,transition:f.default.easeOut(),zIndex:1,transform:"scale(1) translate(0, 0)",transformOrigin:"left top",pointerEvents:"auto",userSelect:"none"},n=e.shrink?(0,a.default)({transform:"scale(0.75) translate(0, -28px)",pointerEvents:"none"},e.shrinkStyle):null;return{root:(0,a.default)(t,e.style,n)}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(10),a=r(i),u=n(1),s=r(u),l=n(3),c=(r(l),n(17)),f=r(c),d=function(e){var t=e.muiTheme,n=e.className,r=e.children,i=e.htmlFor,a=e.onClick,u=t.prepareStyles,l=o(e);return s.default.createElement("label",{className:n,style:u(l.root),htmlFor:i,onClick:a},r)};d.propTypes={},d.defaultProps={disabled:!1,shrink:!1},t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(10),i=r(o),a=n(1),u=r(a),s=n(3),l=r(s),c=n(17),f=r(c),d=(l.default.bool,l.default.object,l.default.bool,l.default.object,l.default.bool,l.default.object,l.default.object.isRequired,l.default.object,{disabled:!1,disabledStyle:{},error:!1,errorStyle:{},focus:!1,focusStyle:{},style:{}}),p=function(e){var t=e.disabled,n=e.disabledStyle,r=e.error,o=e.errorStyle,a=e.focus,s=e.focusStyle,l=e.muiTheme,c=e.style,d=o.color,p=l.prepareStyles,h=l.textField,y=h.borderColor,v=h.disabledTextColor,m=h.errorColor,b=h.focusColor,g={root:{borderTop:"none",borderLeft:"none",borderRight:"none",borderBottomStyle:"solid",borderBottomWidth:1,borderColor:y,bottom:8,boxSizing:"content-box",margin:0,position:"absolute",width:"100%"},disabled:{borderBottomStyle:"dotted",borderBottomWidth:2,borderColor:v},focus:{borderBottomStyle:"solid",borderBottomWidth:2,borderColor:b,transform:"scaleX(0)",transition:f.default.easeOut()},error:{borderColor:d||m,transform:"scaleX(1)"}},_=(0,i.default)({},g.root,c),w=(0,i.default)({},_,g.focus,s);return t&&(_=(0,i.default)({},_,g.disabled,n)),a&&(w=(0,i.default)({},w,{transform:"scaleX(1)"})),r&&(w=(0,i.default)({},w,g.error)),u.default.createElement("div",null,u.default.createElement("hr",{"aria-hidden":"true",style:p(_)}),u.default.createElement("hr",{"aria-hidden":"true",style:p(w)}))};p.propTypes={},p.defaultProps=d,t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.HotKeyHolder=void 0;var o=n(8),i=r(o),a=n(9),u=r(a);t.HotKeyHolder=function(){function e(){var t=this;(0,i.default)(this,e),this.clear=function(){t.timerId=null,t.lastKeys=null}}return(0,u.default)(e,[{key:"append",value:function(e){return clearTimeout(this.timerId),this.timerId=setTimeout(this.clear,500),this.lastKeys=(this.lastKeys||"")+e}}]),e}()},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=t.muiTheme.baseTheme.palette.disabledColor,r=t.muiTheme.baseTheme.palette.textColor,o=e.desktop?64:72,i=e.desktop?24:16;return{root:{color:e.disabled?n:r,cursor:e.disabled?"default":"pointer",minHeight:e.desktop?"32px":"48px",lineHeight:e.desktop?"32px":"48px",fontSize:e.desktop?15:16,whiteSpace:"nowrap"},innerDivStyle:{paddingLeft:e.leftIcon||e.insetChildren||e.checked?o:i,paddingRight:e.rightIcon?o:i,paddingBottom:0,paddingTop:0},secondaryText:{float:"right"},leftIconDesktop:{margin:0,left:24,top:4},rightIconDesktop:{margin:0,right:24,top:4,fill:t.muiTheme.menuItem.rightIconDesktopFill}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(23),E=r(T),C=n(36),k=r(C),P=n(117),M=r(P),j=n(647),N=r(j),I=n(652),A=r(I),R=n(246),F=r(R),D=n(31),L=(r(D),{position:"relative"}),z=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={open:!1},r.cloneMenuItem=function(e){return x.default.cloneElement(e,{onClick:function(t){e.props.menuItems||r.handleRequestClose(),e.props.onClick&&e.props.onClick(t)}})},r.handleTouchTap=function(e){e.preventDefault(),r.setState({open:!0,anchorEl:E.default.findDOMNode(r)}),r.props.onClick&&r.props.onClick(e)},r.handleRequestClose=function(){r.setState({open:!1,anchorEl:null})},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentDidMount",value:function(){this.applyFocusState()}},{key:"componentWillReceiveProps",value:function(e){this.state.open&&"none"===e.focusState&&this.handleRequestClose()}},{key:"shouldComponentUpdate",value:function(e,t,n){return!(0,k.default)(this.props,e)||!(0,k.default)(this.state,t)||!(0,k.default)(this.context,n)}},{key:"componentDidUpdate",value:function(){this.applyFocusState()}},{key:"componentWillUnmount",value:function(){this.state.open&&this.setState({open:!1})}},{key:"applyFocusState",value:function(){this.refs.listItem.applyFocusState(this.props.focusState)}},{key:"render",value:function(){var e=this.props,t=e.checked,n=e.children,r=e.desktop,i=e.disabled,u=(e.focusState,e.innerDivStyle),l=e.insetChildren,c=e.leftIcon,f=e.menuItems,d=e.rightIcon,p=e.secondaryText,h=e.style,y=e.animation,v=e.anchorOrigin,m=e.targetOrigin,b=(e.value,(0,s.default)(e,["checked","children","desktop","disabled","focusState","innerDivStyle","insetChildren","leftIcon","menuItems","rightIcon","secondaryText","style","animation","anchorOrigin","targetOrigin","value"])),g=this.context.muiTheme.prepareStyles,w=o(this.props,this.context),O=(0,_.default)(w.root,h),S=(0,_.default)(w.innerDivStyle,u),T=c||(t?x.default.createElement(N.default,null):null);if(T){var E=r?(0,_.default)(w.leftIconDesktop,T.props.style):T.props.style;T=x.default.cloneElement(T,{style:E})}var C=void 0;if(d){var k=r?(0,_.default)(w.rightIconDesktop,d.props.style):d.props.style;C=x.default.cloneElement(d,{style:k})}var P=void 0;if(p){var j=x.default.isValidElement(p),I=j?(0,_.default)(w.secondaryText,p.props.style):null;P=j?x.default.cloneElement(p,{style:I}):x.default.createElement("div",{style:g(w.secondaryText)},p)}var R=void 0;return f&&(R=x.default.createElement(M.default,{animation:y,anchorOrigin:v,anchorEl:this.state.anchorEl,open:this.state.open,targetOrigin:m,useLayerForClickAway:!1,onRequestClose:this.handleRequestClose},x.default.createElement(F.default,{desktop:r,disabled:i,style:L},x.default.Children.map(f,this.cloneMenuItem))),b.onClick=this.handleTouchTap),x.default.createElement(A.default,(0,a.default)({},b,{disabled:i,hoverColor:this.context.muiTheme.menuItem.hoverColor,innerDivStyle:S,insetChildren:l,leftIcon:T,ref:"listItem",rightIcon:C,role:"menuitem",style:O}),n,P,R)}}]),t}(w.Component);z.muiName="MenuItem",z.defaultProps={anchorOrigin:{horizontal:"right",vertical:"top"},checked:!1,desktop:!1,disabled:!1,focusState:"none",insetChildren:!1,targetOrigin:{horizontal:"left",vertical:"top"}},z.contextTypes={muiTheme:S.default.object.isRequired},z.propTypes={},t.default=z},function(e,t,n){(function(t){function n(e,t,n){function r(t){var n=y,r=v;return y=v=void 0,S=t,b=e.apply(r,n)}function i(e){return S=e,g=setTimeout(c,t),T?r(e):b}function a(e){var n=e-_,r=e-S,o=t-n;return E?x(o,m-r):o}function l(e){var n=e-_,r=e-S;return void 0===_||n>=t||n<0||E&&r>=m}function c(){var e=O();if(l(e))return f(e);g=setTimeout(c,a(e))}function f(e){return g=void 0,C&&y?r(e):(y=v=void 0,b)}function d(){void 0!==g&&clearTimeout(g),S=0,y=_=v=g=void 0}function p(){return void 0===g?b:f(O())}function h(){var e=O(),n=l(e);if(y=arguments,v=this,_=e,n){if(void 0===g)return i(_);if(E)return g=setTimeout(c,t),r(_)}return void 0===g&&(g=setTimeout(c,t)),b}var y,v,m,b,g,_,S=0,T=!1,E=!1,C=!0;if("function"!=typeof e)throw new TypeError(s);return t=u(t)||0,o(n)&&(T=!!n.leading,E="maxWait"in n,m=E?w(u(n.maxWait)||0,t):m,C="trailing"in n?!!n.trailing:C),h.cancel=d,h.flush=p,h}function r(e,t,r){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(s);return o(r)&&(i="leading"in r?!!r.leading:i,a="trailing"in r?!!r.trailing:a),n(e,t,{leading:i,maxWait:t,trailing:a})}function o(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==typeof e}function a(e){return"symbol"==typeof e||i(e)&&_.call(e)==c}function u(e){if("number"==typeof e)return e;if(a(e))return l;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(f,"");var n=p.test(e);return n||h.test(e)?y(e.slice(2),n?2:8):d.test(e)?l:+e}var s="Expected a function",l=NaN,c="[object Symbol]",f=/^\s+|\s+$/g,d=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,h=/^0o[0-7]+$/i,y=parseInt,v="object"==typeof t&&t&&t.Object===Object&&t,m="object"==typeof self&&self&&self.Object===Object&&self,b=v||m||Function("return this")(),g=Object.prototype,_=g.toString,w=Math.max,x=Math.min,O=function(){return b.Date.now()};e.exports=r}).call(t,n(47))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=e.targetOrigin,o=n.open,i=t.muiTheme,a=r.horizontal.replace("middle","vertical");return{root:{position:"fixed",zIndex:i.zIndex.popover,opacity:o?1:0,transform:o?"scale(1, 1)":"scale(0, 0)",transformOrigin:a+" "+r.vertical,transition:b.default.easeOut("250ms",["transform","opacity"]),maxHeight:"100%"},horizontal:{maxHeight:"100%",overflowY:"auto",transform:o?"scaleX(1)":"scaleX(0)",opacity:o?1:0,transformOrigin:a+" "+r.vertical,transition:b.default.easeOut("250ms",["transform","opacity"])},vertical:{opacity:o?1:0,transform:o?"scaleY(1)":"scaleY(0)",transformOrigin:a+" "+r.vertical,transition:b.default.easeOut("500ms",["transform","opacity"])}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(11),a=r(i),u=n(8),s=r(u),l=n(9),c=r(l),f=n(12),d=r(f),p=n(13),h=r(p),y=n(10),v=r(y),m=n(17),b=r(m),g=n(1),_=r(g),w=n(3),x=r(w),O=n(31),S=(r(O),n(65)),T=r(S),E=function(e){function t(){var e,n,r,o;(0,s.default)(this,t);for(var i=arguments.length,u=Array(i),l=0;l<i;l++)u[l]=arguments[l];return n=r=(0,d.default)(this,(e=t.__proto__||(0,a.default)(t)).call.apply(e,[this].concat(u))),r.state={open:!1},o=n,(0,d.default)(r,o)}return(0,h.default)(t,e),(0,c.default)(t,[{key:"componentDidMount",value:function(){this.setState({open:!0})}},{key:"componentWillReceiveProps",value:function(e){this.setState({open:e.open})}},{key:"render",value:function(){var e=this.props,t=e.className,n=e.style,r=e.zDepth,i=this.context.muiTheme.prepareStyles,a=o(this.props,this.context,this.state);return _.default.createElement(T.default,{style:(0,v.default)(a.root,n),zDepth:r,className:t},_.default.createElement("div",{style:i(a.horizontal)},_.default.createElement("div",{style:i(a.vertical)},this.props.children)))}}]),t}(g.Component);E.defaultProps={style:{},zDepth:1},E.contextTypes={muiTheme:x.default.object.isRequired},E.propTypes={},t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"}))};c=(0,u.default)(c),c.displayName="NavigationCheck",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(1),s=n(248),l=(r(s),n(249)),c=(r(l),function(e){return function(t){var n=(0,u.createFactory)(t);return function(t){function r(){return o(this,r),i(this,t.apply(this,arguments))}return a(r,t),r.prototype.shouldComponentUpdate=function(t){return e(this.props,t)},r.prototype.render=function(){return n(this.props)},r}(u.Component)}});t.default=c},function(e,t,n){"use strict";t.__esModule=!0;var r=function(e,t){return function(n){return n[e]=t,n}};t.default=r},function(e,t,n){"use strict";t.__esModule=!0;var r=function(e){return"string"==typeof e?e:e?e.displayName||e.name||"Component":void 0};t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(14),i=r(o),a=n(15),u=r(a),s=n(11),l=r(s),c=n(8),f=r(c),d=n(9),p=r(d),h=n(12),y=r(h),v=n(13),m=r(v),b=n(10),g=r(b),_=n(1),w=r(_),x=n(3),O=r(x),S=n(17),T=r(S),E=function(e){function t(){var e,n,r,o;(0,f.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,y.default)(this,(e=t.__proto__||(0,l.default)(t)).call.apply(e,[this].concat(a))),r.state={hovered:!1},r.handleMouseLeave=function(e){r.setState({hovered:!1}),r.props.onMouseLeave(e)},r.handleMouseEnter=function(e){r.setState({hovered:!0}),r.props.onMouseEnter(e)},o=n,(0,y.default)(r,o)}return(0,m.default)(t,e),(0,p.default)(t,[{key:"render",value:function(){var e=this.props,t=e.children,n=e.color,r=e.hoverColor,o=(e.onMouseEnter,e.onMouseLeave,e.style),a=e.viewBox,s=(0,u.default)(e,["children","color","hoverColor","onMouseEnter","onMouseLeave","style","viewBox"]),l=this.context.muiTheme,c=l.svgIcon,f=l.prepareStyles,d=n||"currentColor",p=r||d,h=(0,g.default)({display:"inline-block",color:c.color,fill:this.state.hovered?p:d,height:24,width:24,userSelect:"none",transition:T.default.easeOut()},o);return w.default.createElement("svg",(0,i.default)({},s,{onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,style:f(h),viewBox:a}),t)}}]),t}(_.Component);E.muiName="SvgIcon",E.defaultProps={onMouseEnter:function(){},onMouseLeave:function(){},viewBox:"0 0 24 24"},E.contextTypes={muiTheme:O.default.object.isRequired},E.propTypes={},t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=e.autoGenerateNestedIndicator,o=e.insetChildren,i=e.leftAvatar,a=e.leftCheckbox,u=e.leftIcon,s=e.nestedItems,l=e.nestedLevel,c=e.rightAvatar,f=e.rightIcon,d=e.rightIconButton,p=e.rightToggle,h=e.secondaryText,y=e.secondaryTextLines,v=t.muiTheme,m=v.listItem,b=v.baseTheme.palette.textColor,g=e.hoverColor||(0,P.fade)(b,.1),_=!h&&(i||c),w=!h&&!(i||c),x=h&&1===y,O=h&&y>1;return{root:{backgroundColor:!(void 0!==e.isKeyboardFocused?e:n).isKeyboardFocused&&!n.hovered||n.rightIconButtonHovered||n.rightIconButtonKeyboardFocused?null:g,color:b,display:"block",fontSize:16,lineHeight:"16px",position:"relative",transition:j.default.easeOut()},innerDiv:{marginLeft:l*m.nestedLevelDepth,paddingLeft:u||i||a||o?72:16,paddingRight:f||c||d||s.length&&r?56:p?72:16,paddingBottom:_?20:16,paddingTop:w||O?16:20,position:"relative"},icons:{height:24,width:24,display:"block",position:"absolute",top:x?12:_?4:0,margin:12},leftIcon:{left:4},rightIcon:{right:4},avatars:{position:"absolute",top:_?8:16},label:{cursor:"pointer"},leftAvatar:{left:16},rightAvatar:{right:16},leftCheckbox:{position:"absolute",display:"block",width:24,top:x?24:_?16:12,left:16},primaryText:{},rightIconButton:{position:"absolute",display:"block",top:x?12:_?4:0,right:4},rightToggle:{position:"absolute",display:"block",width:54,top:x?25:_?17:13,right:8},secondaryText:{fontSize:14,lineHeight:O?"18px":"16px",height:O?36:16,margin:0,marginTop:4,color:m.secondaryTextColor,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:O?null:"nowrap",display:O?"-webkit-box":null,WebkitLineClamp:O?2:null,WebkitBoxOrient:O?"vertical":null}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(15),a=r(i),u=n(14),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(23),E=r(T),C=n(36),k=r(C),P=n(137),M=n(17),j=r(M),N=n(97),I=r(N),A=n(118),R=r(A),F=n(658),D=r(F),L=n(659),z=r(L),V=n(660),U=r(V),W=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={hovered:!1,isKeyboardFocused:!1,open:!1,rightIconButtonHovered:!1,rightIconButtonKeyboardFocused:!1,touch:!1},r.handleKeyboardFocus=function(e,t){r.setState({isKeyboardFocused:t}),r.props.onKeyboardFocus(e,t)},r.handleMouseEnter=function(e){r.state.touch||r.setState({hovered:!0}),r.props.onMouseEnter(e)},r.handleMouseLeave=function(e){r.setState({hovered:!1}),r.props.onMouseLeave(e)},r.handleTouchTap=function(e){r.props.onClick&&r.props.onClick(e),r.props.primaryTogglesNestedList&&r.handleNestedListToggle(e)},r.handleNestedListToggle=function(e){r.props.leftCheckbox&&e.preventDefault(),e.stopPropagation(),null===r.props.open?r.setState({open:!r.state.open},function(){r.props.onNestedListToggle(r)}):r.props.onNestedListToggle((0,s.default)({},r,{state:{open:!r.state.open}}))},r.handleRightIconButtonKeyboardFocus=function(e,t){t&&r.setState({isKeyboardFocused:!1,rightIconButtonKeyboardFocused:t});var n=r.props.rightIconButton;n&&n.props.onKeyboardFocus&&n.props.onKeyboardFocus(e,t)},r.handleRightIconButtonMouseLeave=function(e){var t=r.props.rightIconButton;r.setState({rightIconButtonHovered:!1}),t&&t.props.onMouseLeave&&t.props.onMouseLeave(e)},r.handleRightIconButtonMouseEnter=function(e){var t=r.props.rightIconButton;r.setState({rightIconButtonHovered:!0}),t&&t.props.onMouseEnter&&t.props.onMouseEnter(e)},r.handleRightIconButtonMouseUp=function(e){var t=r.props.rightIconButton;e.stopPropagation(),t&&t.props.onMouseUp&&t.props.onMouseUp(e)},r.handleRightIconButtonTouchTap=function(e){var t=r.props.rightIconButton;e.stopPropagation(),t&&t.props.onClick&&t.props.onClick(e)},r.handleTouchStart=function(e){r.setState({touch:!0}),r.props.onTouchStart(e)},r.handleTouchEnd=function(e){r.setState({touch:!0}),r.props.onTouchEnd(e)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillMount",value:function(){this.setState({open:null===this.props.open?!0===this.props.initiallyOpen:this.props.open})}},{key:"componentWillReceiveProps",value:function(e){null!==e.open&&this.setState({open:e.open}),e.disabled&&this.state.hovered&&this.setState({hovered:!1})}},{key:"shouldComponentUpdate",value:function(e,t,n){return!(0,k.default)(this.props,e)||!(0,k.default)(this.state,t)||!(0,k.default)(this.context,n)}},{key:"applyFocusState",value:function(e){if(this.button){var t=E.default.findDOMNode(this.button);switch(e){case"none":t.blur();break;case"focused":t.focus();break;case"keyboard-focused":this.button.setKeyboardFocus(),t.focus()}}}},{key:"createDisabledElement",value:function(e,t,n){var r=this.props,o=r.innerDivStyle,i=r.style,a=(0,_.default)({},e.root,e.innerDiv,o,i);return x.default.createElement("div",(0,s.default)({},n,{style:this.context.muiTheme.prepareStyles(a)}),t)}},{key:"createLabelElement",value:function(e,t,n){var r=this.props,o=r.innerDivStyle,i=r.style,a=(0,_.default)({},e.root,e.innerDiv,o,e.label,i);return x.default.createElement("label",(0,s.default)({},n,{style:this.context.muiTheme.prepareStyles(a)}),t)}},{key:"createTextElement",value:function(e,t,n){var r=this.context.muiTheme.prepareStyles;if(x.default.isValidElement(t)){var o=(0,_.default)({},e,t.props.style);return"string"==typeof t.type&&(o=r(o)),x.default.cloneElement(t,{key:n,style:o})}return x.default.createElement("div",{key:n,style:r(e)},t)}},{key:"pushElement",value:function(e,t,n,r){if(t){var o=(0,_.default)({},n,t.props.style);e.push(x.default.cloneElement(t,(0,s.default)({key:e.length,style:o},r)))}}},{key:"render",value:function(){var e=this,t=this.props,n=t.autoGenerateNestedIndicator,r=t.children,i=t.containerElement,u=t.disabled,l=t.disableKeyboardFocus,c=(t.hoverColor,t.initiallyOpen,t.innerDivStyle),f=(t.insetChildren,t.leftAvatar),d=t.leftCheckbox,p=t.leftIcon,h=t.nestedItems,y=t.nestedLevel,v=t.nestedListStyle,m=(t.onKeyboardFocus,t.isKeyboardFocused,t.onMouseEnter,t.onMouseLeave,t.onNestedListToggle,t.onTouchStart,t.onClick,t.rightAvatar),b=t.rightIcon,g=t.rightIconButton,w=t.rightToggle,O=t.primaryText,S=t.primaryTogglesNestedList,T=t.secondaryText,E=(t.secondaryTextLines,t.style),C=(0,a.default)(t,["autoGenerateNestedIndicator","children","containerElement","disabled","disableKeyboardFocus","hoverColor","initiallyOpen","innerDivStyle","insetChildren","leftAvatar","leftCheckbox","leftIcon","nestedItems","nestedLevel","nestedListStyle","onKeyboardFocus","isKeyboardFocused","onMouseEnter","onMouseLeave","onNestedListToggle","onTouchStart","onClick","rightAvatar","rightIcon","rightIconButton","rightToggle","primaryText","primaryTogglesNestedList","secondaryText","secondaryTextLines","style"]),k=this.context.muiTheme.prepareStyles,P=o(this.props,this.context,this.state),M=[r];if(p){var j={color:p.props.color||this.context.muiTheme.listItem.leftIconColor};this.pushElement(M,p,(0,_.default)({},P.icons,P.leftIcon),j)}if(b){var N={color:b.props.color||this.context.muiTheme.listItem.rightIconColor};this.pushElement(M,b,(0,_.default)({},P.icons,P.rightIcon),N)}f&&this.pushElement(M,f,(0,_.default)({},P.avatars,P.leftAvatar)),m&&this.pushElement(M,m,(0,_.default)({},P.avatars,P.rightAvatar)),d&&this.pushElement(M,d,(0,_.default)({},P.leftCheckbox));var A=h.length,F=m||b||g||w,L=A&&n&&!F;if(g||L){var V=g,W={onKeyboardFocus:this.handleRightIconButtonKeyboardFocus,onMouseEnter:this.handleRightIconButtonMouseEnter,onMouseLeave:this.handleRightIconButtonMouseLeave,onClick:this.handleRightIconButtonTouchTap,onMouseDown:this.handleRightIconButtonMouseUp,onMouseUp:this.handleRightIconButtonMouseUp};L&&(V=this.state.open?x.default.createElement(R.default,null,x.default.createElement(D.default,null)):x.default.createElement(R.default,null,x.default.createElement(z.default,null)),W.onClick=this.handleNestedListToggle),this.pushElement(M,V,(0,_.default)({},P.rightIconButton),W)}if(w&&this.pushElement(M,w,(0,_.default)({},P.rightToggle)),O){var H=this.createTextElement(P.primaryText,O,"primaryText");M.push(H)}if(T){var B=this.createTextElement(P.secondaryText,T,"secondaryText");M.push(B)}var K=h.length?x.default.createElement(U.default,{nestedLevel:y,open:this.state.open,style:v},h):void 0,q=!S&&(d||w);return x.default.createElement("div",null,q?this.createLabelElement(P,M,C):u?this.createDisabledElement(P,M,C):x.default.createElement(I.default,(0,s.default)({containerElement:i},C,{disableKeyboardFocus:l||this.state.rightIconButtonKeyboardFocused,onKeyboardFocus:this.handleKeyboardFocus,onMouseLeave:this.handleMouseLeave,onMouseEnter:this.handleMouseEnter,onTouchStart:this.handleTouchStart,onTouchEnd:this.handleTouchEnd,onClick:this.handleTouchTap,disabled:u,ref:function(t){return e.button=t},style:(0,_.default)({},P.root,E)}),x.default.createElement("div",{style:k((0,_.default)(P.innerDiv,c))},M)),K)}}]),t}(w.Component);W.muiName="ListItem",W.defaultProps={autoGenerateNestedIndicator:!0,containerElement:"span",disableKeyboardFocus:!1,disabled:!1,initiallyOpen:!1,insetChildren:!1,nestedItems:[],nestedLevel:0,onKeyboardFocus:function(){},onMouseEnter:function(){},onMouseLeave:function(){},onNestedListToggle:function(){},onTouchEnd:function(){},onTouchStart:function(){},open:null,primaryTogglesNestedList:!1,secondaryTextLines:1},W.contextTypes={muiTheme:S.default.object.isRequired},W.propTypes={},t.default=W},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n=t.muiTheme.baseTheme;return{root:{boxSizing:"border-box",overflow:"visible",transition:E.default.easeOut(),padding:n.spacing.iconSize/2,width:2*n.spacing.iconSize,height:2*n.spacing.iconSize,fontSize:0},tooltip:{boxSizing:"border-box"},disabled:{color:n.palette.disabledColor,fill:n.palette.disabledColor,cursor:"default"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(17),E=r(T),C=n(31),k=(r(C),n(97)),P=r(k),M=n(654),j=r(M),N=n(656),I=r(N),A=n(657),R=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={hovered:!1,isKeyboardFocused:!1,touch:!1,tooltipShown:!1},r.handleBlur=function(e){r.hideTooltip(),r.props.onBlur&&r.props.onBlur(e)},r.handleFocus=function(e){r.showTooltip(),r.props.onFocus&&r.props.onFocus(e)},r.handleMouseLeave=function(e){r.button.isKeyboardFocused()||r.hideTooltip(),r.setState({hovered:!1}),r.props.onMouseLeave&&r.props.onMouseLeave(e)},r.handleMouseOut=function(e){r.props.disabled&&r.hideTooltip(),r.props.onMouseOut&&r.props.onMouseOut(e)},r.handleMouseEnter=function(e){r.showTooltip(),r.state.touch||r.setState({hovered:!0}),r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.handleTouchStart=function(e){r.setState({touch:!0}),r.props.onTouchStart&&r.props.onTouchStart(e)},r.handleKeyboardFocus=function(e,t){var n=r.props,o=n.disabled,i=n.onFocus,a=n.onBlur,u=n.onKeyboardFocus;t&&!o?(r.showTooltip(),i&&i(e)):(r.hideTooltip(),a&&a(e)),r.setState({isKeyboardFocused:t}),u&&u(e,t)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentWillReceiveProps",value:function(e){e.disabled&&this.setState({hovered:!1})}},{key:"setKeyboardFocus",value:function(){this.button.setKeyboardFocus()}},{key:"showTooltip",value:function(){this.props.tooltip&&this.setState({tooltipShown:!0})}},{key:"hideTooltip",value:function(){this.props.tooltip&&this.setState({tooltipShown:!1})}},{key:"render",value:function(){var e=this,t=this.props,n=t.disabled,r=t.hoveredStyle,i=t.disableTouchRipple,u=t.children,l=t.iconClassName,c=t.style,f=t.tooltip,d=t.tooltipPosition,p=t.tooltipStyles,h=t.touch,y=t.iconStyle,v=(0,s.default)(t,["disabled","hoveredStyle","disableTouchRipple","children","iconClassName","style","tooltip","tooltipPosition","tooltipStyles","touch","iconStyle"]),m=void 0,b=o(this.props,this.context),g=d.split("-"),w=(this.state.hovered||this.state.isKeyboardFocused)&&!n,O=(0,_.default)(b.root,c,w?r:{}),S=f?x.default.createElement(I.default,{label:f,show:this.state.tooltipShown,touch:h,style:(0,_.default)(b.tooltip,p),verticalPosition:g[0],horizontalPosition:g[1]}):null;if(l){var T=y.iconHoverColor,E=(0,s.default)(y,["iconHoverColor"]);m=x.default.createElement(j.default,{className:l,hoverColor:n?null:T,style:(0,_.default)({},n&&b.disabled,E),color:this.context.muiTheme.baseTheme.palette.textColor},u)}var C=n?(0,_.default)({},y,b.disabled):y;return x.default.createElement(P.default,(0,a.default)({ref:function(t){return e.button=t}},v,{centerRipple:!0,disabled:n,onTouchStart:this.handleTouchStart,style:O,disableTouchRipple:i,onBlur:this.handleBlur,onFocus:this.handleFocus,onMouseLeave:this.handleMouseLeave,onMouseEnter:this.handleMouseEnter,onMouseOut:this.handleMouseOut,onKeyboardFocus:this.handleKeyboardFocus}),S,m,(0,A.extendChildren)(u,{style:C}))}}]),t}(w.Component);R.muiName="IconButton",R.defaultProps={disabled:!1,disableTouchRipple:!1,iconStyle:{},tooltipPosition:"bottom-center",touch:!1},R.contextTypes={muiTheme:S.default.object.isRequired},R.propTypes={},t.default=R},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(655),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=e.color,o=e.hoverColor,i=t.muiTheme.baseTheme,a=r||i.palette.textColor,u=o||a;return{root:{color:n.hovered?u:a,position:"relative",fontSize:i.spacing.iconSize,display:"inline-block",userSelect:"none",transition:E.default.easeOut()}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(17),E=r(T),C=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={hovered:!1},r.handleMouseLeave=function(e){void 0!==r.props.hoverColor&&r.setState({hovered:!1}),r.props.onMouseLeave&&r.props.onMouseLeave(e)},r.handleMouseEnter=function(e){void 0!==r.props.hoverColor&&r.setState({hovered:!0}),r.props.onMouseEnter&&r.props.onMouseEnter(e)},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"render",value:function(){var e=this.props,t=(e.hoverColor,e.onMouseLeave,e.onMouseEnter,e.style),n=(0,s.default)(e,["hoverColor","onMouseLeave","onMouseEnter","style"]),r=this.context.muiTheme.prepareStyles,i=o(this.props,this.context,this.state);return x.default.createElement("span",(0,a.default)({},n,{onMouseLeave:this.handleMouseLeave,onMouseEnter:this.handleMouseEnter,style:r((0,_.default)(i.root,t))}))}}]),t}(w.Component);C.muiName="FontIcon",C.defaultProps={onMouseEnter:function(){},onMouseLeave:function(){}},C.contextTypes={muiTheme:S.default.object.isRequired},C.propTypes={},t.default=C},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=e.verticalPosition,o=e.horizontalPosition,i=e.touch?10:0,a=e.touch?-20:-10,u="bottom"===r?14+i:-14-i,s=t.muiTheme,l=s.baseTheme,c=s.zIndex,f=s.tooltip,d=s.borderRadius;return{root:{position:"absolute",fontFamily:l.fontFamily,fontSize:"10px",lineHeight:"22px",padding:"0 8px",zIndex:c.tooltip,color:f.color,overflow:"hidden",top:-1e4,borderRadius:d,userSelect:"none",opacity:0,right:"left"===o?12:null,left:"center"===o?(n.offsetWidth-48)/2*-1:"right"===o?12:null,transition:E.default.easeOut("0ms","top","450ms")+", "+E.default.easeOut("450ms","transform","0ms")+", "+E.default.easeOut("450ms","opacity","0ms")},label:{position:"relative",whiteSpace:"nowrap"},ripple:{position:"absolute",left:"center"===o?"50%":"left"===o?"100%":"0%",top:"bottom"===r?0:"100%",transform:"translate(-50%, -50%)",borderRadius:"50%",backgroundColor:"transparent",transition:E.default.easeOut("0ms","width","450ms")+", "+E.default.easeOut("0ms","height","450ms")+", "+E.default.easeOut("450ms","backgroundColor","0ms")},rootWhenShown:{top:"top"===r?a:36,opacity:f.opacity,transform:"translate(0px, "+u+"px)",transition:E.default.easeOut("0ms","top","0ms")+", "+E.default.easeOut("450ms","transform","0ms")+", "+E.default.easeOut("450ms","opacity","0ms")},rootWhenTouched:{fontSize:"14px",lineHeight:"32px",padding:"0 16px"},rippleWhenShown:{backgroundColor:f.rippleBackgroundColor,transition:E.default.easeOut("450ms","width","0ms")+", "+E.default.easeOut("450ms","height","0ms")+", "+E.default.easeOut("450ms","backgroundColor","0ms")}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(14),a=r(i),u=n(15),s=r(u),l=n(11),c=r(l),f=n(8),d=r(f),p=n(9),h=r(p),y=n(12),v=r(y),m=n(13),b=r(m),g=n(10),_=r(g),w=n(1),x=r(w),O=n(3),S=r(O),T=n(17),E=r(T),C=function(e){function t(){var e,n,r,o;(0,d.default)(this,t);for(var i=arguments.length,a=Array(i),u=0;u<i;u++)a[u]=arguments[u];return n=r=(0,v.default)(this,(e=t.__proto__||(0,c.default)(t)).call.apply(e,[this].concat(a))),r.state={offsetWidth:null},o=n,(0,v.default)(r,o)}return(0,b.default)(t,e),(0,h.default)(t,[{key:"componentDidMount",value:function(){this.setRippleSize(),this.setTooltipPosition()}},{key:"componentWillReceiveProps",value:function(){this.setTooltipPosition()}},{key:"componentDidUpdate",value:function(){this.setRippleSize()}},{key:"setRippleSize",value:function(){var e=this.refs.ripple,t=this.refs.tooltip,n=parseInt(t.offsetWidth,10)/("center"===this.props.horizontalPosition?2:1),r=parseInt(t.offsetHeight,10),o=Math.ceil(2*Math.sqrt(Math.pow(r,2)+Math.pow(n,2)));this.props.show?(e.style.height=o+"px",e.style.width=o+"px"):(e.style.width="0px",e.style.height="0px")}},{key:"setTooltipPosition",value:function(){this.setState({offsetWidth:this.refs.tooltip.offsetWidth})}},{key:"render",value:function(){var e=this.props,t=(e.horizontalPosition,e.label),n=(e.show,e.touch,e.verticalPosition,(0,s.default)(e,["horizontalPosition","label","show","touch","verticalPosition"])),r=this.context.muiTheme.prepareStyles,i=o(this.props,this.context,this.state);return x.default.createElement("div",(0,a.default)({},n,{ref:"tooltip",style:r((0,_.default)(i.root,this.props.show&&i.rootWhenShown,this.props.touch&&i.rootWhenTouched,this.props.style))}),x.default.createElement("div",{ref:"ripple",style:r((0,_.default)(i.ripple,this.props.show&&i.rippleWhenShown))}),x.default.createElement("span",{style:r(i.label)},t))}}]),t}(w.Component);C.contextTypes={muiTheme:S.default.object.isRequired},C.propTypes={},t.default=C},function(e,t,n){"use strict";function r(e,t,n){return i.default.Children.map(e,function(e){if(!i.default.isValidElement(e))return e;var r="function"==typeof t?t(e):t,o="function"==typeof n?n(e):n||e.props.children;return i.default.cloneElement(e,r,o)})}Object.defineProperty(t,"__esModule",{value:!0}),t.extendChildren=r;var o=n(1),i=function(e){return e&&e.__esModule?e:{default:e}}(o)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"}))};c=(0,u.default)(c),c.displayName="NavigationExpandLess",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}))};c=(0,u.default)(c),c.displayName="NavigationExpandMore",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(3),u=(r(a),n(247)),s=r(u),l=function(e){var t=e.children,n=e.open,r=e.nestedLevel,a=e.style;return n?i.default.createElement(s.default,{style:a},o.Children.map(t,function(e){return(0,o.isValidElement)(e)?(0,o.cloneElement)(e,{nestedLevel:r+1}):e})):null};l.propTypes={},t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.PopoverAnimationVertical=t.Popover=void 0;var o=n(117),i=r(o),a=n(662),u=r(a);t.Popover=i.default,t.PopoverAnimationVertical=u.default,t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=e.targetOrigin,o=n.open,i=t.muiTheme,a=r.horizontal.replace("middle","center");return{root:{position:"fixed",zIndex:i.zIndex.popover,opacity:o?1:0,transform:o?"scaleY(1)":"scaleY(0)",transformOrigin:a+" "+r.vertical,transition:S.default.easeOut("450ms",["transform","opacity"]),maxHeight:"100%"}}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(11),a=r(i),u=n(8),s=r(u),l=n(9),c=r(l),f=n(12),d=r(f),p=n(13),h=r(p),y=n(10),v=r(y),m=n(1),b=r(m),g=n(3),_=r(g),w=n(65),x=r(w),O=n(17),S=r(O),T=n(31),E=(r(T),function(e){function t(){var e,n,r,o;(0,s.default)(this,t);for(var i=arguments.length,u=Array(i),l=0;l<i;l++)u[l]=arguments[l];return n=r=(0,d.default)(this,(e=t.__proto__||(0,a.default)(t)).call.apply(e,[this].concat(u))),r.state={open:!1},o=n,(0,d.default)(r,o)}return(0,h.default)(t,e),(0,c.default)(t,[{key:"componentDidMount",value:function(){this.setState({open:!0})}},{key:"componentWillReceiveProps",value:function(e){this.setState({open:e.open})}},{key:"render",value:function(){var e=this.props,t=e.className,n=e.style,r=e.zDepth,i=o(this.props,this.context,this.state);return b.default.createElement(x.default,{style:(0,v.default)(i.root,n),zDepth:r,className:t},this.props.children)}}]),t}(m.Component));E.defaultProps={style:{},zDepth:1},E.contextTypes={muiTheme:_.default.object.isRequired},E.propTypes={},t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}))};c=(0,u.default)(c),c.displayName="ContentAdd",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"}))};c=(0,u.default)(c),c.displayName="NavigationApps",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"}))};c=(0,u.default)(c),c.displayName="NavigationArrowDownward",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M9.5,7l5,5l-5,5V7z"}))};c=(0,u.default)(c),c.displayName="NavigationArrowDropRight",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"}))};c=(0,u.default)(c),c.displayName="NavigationArrowUpward",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"}))};c=(0,u.default)(c),c.displayName="CommunicationBusiness",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"}))};c=(0,u.default)(c),c.displayName="NavigationCancel",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}))};c=(0,u.default)(c),c.displayName="NavigationChevronLeft",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}))};c=(0,u.default)(c),c.displayName="NavigationChevronRight",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}))};c=(0,u.default)(c),c.displayName="ContentClear",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}))};c=(0,u.default)(c),c.displayName="NavigationClose",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"}))};c=(0,u.default)(c),c.displayName="ContentCreate",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"}))};c=(0,u.default)(c),c.displayName="ImageCropFree",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"}))};c=(0,u.default)(c),c.displayName="ActionDelete",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"}))};c=(0,u.default)(c),c.displayName="ActionDescription",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"}))};c=(0,u.default)(c),c.displayName="ActionDone",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20 9H4v2h16V9zM4 15h16v-2H4v2z"}))};c=(0,u.default)(c),c.displayName="EditorDragHandle",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"}))};c=(0,u.default)(c),c.displayName="CommunicationEmail",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"}))};c=(0,u.default)(c),c.displayName="ActionExtension",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"}))};c=(0,u.default)(c),c.displayName="ContentFontDownload",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"}))};c=(0,u.default)(c),c.displayName="SocialGroup",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"}))};c=(0,u.default)(c),c.displayName="ImageGridOn",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"}))};c=(0,u.default)(c),c.displayName="ActionInfoOutline",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"}))};c=(0,u.default)(c),c.displayName="EditorInsertChart",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"}))};c=(0,u.default)(c),c.displayName="ActionList",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"}))};c=(0,u.default)(c),c.displayName="ActionLaunch",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"}))};c=(0,u.default)(c),c.displayName="CommunicationMessage",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"}))};c=(0,u.default)(c),c.displayName="NavigationMoreVert",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"}))};c=(0,u.default)(c),c.displayName="AvNotInterested",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"}))};c=(0,u.default)(c),c.displayName="SocialPerson",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"}))};c=(0,u.default)(c),c.displayName="SocialPublic",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"}))};c=(0,u.default)(c),c.displayName="ContentReply",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"}))};c=(0,u.default)(c),c.displayName="ActionRoom",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"}))};c=(0,u.default)(c),c.displayName="ActionSearch",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"}))};c=(0,u.default)(c),c.displayName="EditorShowChart",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"}))};c=(0,u.default)(c),c.displayName="ToggleStar",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"}))};c=(0,u.default)(c),c.displayName="ToggleStarBorder",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"}))};c=(0,u.default)(c),c.displayName="ActionThumbUp",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"}))};c=(0,u.default)(c),c.displayName="ActionViewList",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"}))};c=(0,u.default)(c),c.displayName="ActionVisibility",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("path",{d:"M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"}))};c=(0,u.default)(c),c.displayName="ActionVisibilityOff",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),a=n(5),u=r(a),s=n(4),l=r(s),c=function(e){return i.default.createElement(l.default,e,i.default.createElement("circle",{cx:"15.5",cy:"9.5",r:"1.5"}),i.default.createElement("circle",{cx:"8.5",cy:"9.5",r:"1.5"}),i.default.createElement("path",{d:"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"}))};c=(0,u.default)(c),c.displayName="SocialSentimentDissatisfied",c.muiName="SvgIcon",t.default=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.red50="#ffebee",t.red100="#ffcdd2",t.red200="#ef9a9a",t.red300="#e57373",t.red400="#ef5350",t.red500="#f44336",t.red600="#e53935",t.red700="#d32f2f",t.red800="#c62828",t.red900="#b71c1c",t.redA100="#ff8a80",t.redA200="#ff5252",t.redA400="#ff1744",t.redA700="#d50000",t.pink50="#fce4ec",t.pink100="#f8bbd0",t.pink200="#f48fb1",t.pink300="#f06292",t.pink400="#ec407a",t.pink500="#e91e63",t.pink600="#d81b60",t.pink700="#c2185b",t.pink800="#ad1457",t.pink900="#880e4f",t.pinkA100="#ff80ab",t.pinkA200="#ff4081",t.pinkA400="#f50057",t.pinkA700="#c51162",t.purple50="#f3e5f5",t.purple100="#e1bee7",t.purple200="#ce93d8",t.purple300="#ba68c8",t.purple400="#ab47bc",t.purple500="#9c27b0",t.purple600="#8e24aa",t.purple700="#7b1fa2",t.purple800="#6a1b9a",t.purple900="#4a148c",t.purpleA100="#ea80fc",t.purpleA200="#e040fb",t.purpleA400="#d500f9",t.purpleA700="#aa00ff",t.deepPurple50="#ede7f6",t.deepPurple100="#d1c4e9",t.deepPurple200="#b39ddb",t.deepPurple300="#9575cd",t.deepPurple400="#7e57c2",t.deepPurple500="#673ab7",t.deepPurple600="#5e35b1",t.deepPurple700="#512da8",t.deepPurple800="#4527a0",t.deepPurple900="#311b92",t.deepPurpleA100="#b388ff",t.deepPurpleA200="#7c4dff",t.deepPurpleA400="#651fff",t.deepPurpleA700="#6200ea",t.indigo50="#e8eaf6",t.indigo100="#c5cae9",t.indigo200="#9fa8da",t.indigo300="#7986cb",t.indigo400="#5c6bc0",t.indigo500="#3f51b5",t.indigo600="#3949ab",t.indigo700="#303f9f",t.indigo800="#283593",t.indigo900="#1a237e",t.indigoA100="#8c9eff",t.indigoA200="#536dfe",t.indigoA400="#3d5afe",t.indigoA700="#304ffe",t.blue50="#e3f2fd",t.blue100="#bbdefb",t.blue200="#90caf9",t.blue300="#64b5f6",t.blue400="#42a5f5",t.blue500="#2196f3",t.blue600="#1e88e5",t.blue700="#1976d2",t.blue800="#1565c0",t.blue900="#0d47a1",t.blueA100="#82b1ff",t.blueA200="#448aff",t.blueA400="#2979ff",t.blueA700="#2962ff",t.lightBlue50="#e1f5fe",t.lightBlue100="#b3e5fc",t.lightBlue200="#81d4fa",t.lightBlue300="#4fc3f7",t.lightBlue400="#29b6f6",t.lightBlue500="#03a9f4",t.lightBlue600="#039be5",t.lightBlue700="#0288d1",t.lightBlue800="#0277bd",t.lightBlue900="#01579b",t.lightBlueA100="#80d8ff",t.lightBlueA200="#40c4ff",t.lightBlueA400="#00b0ff",t.lightBlueA700="#0091ea",t.cyan50="#e0f7fa",t.cyan100="#b2ebf2",t.cyan200="#80deea",t.cyan300="#4dd0e1",t.cyan400="#26c6da",t.cyan500="#00bcd4",t.cyan600="#00acc1",t.cyan700="#0097a7",t.cyan800="#00838f",t.cyan900="#006064",t.cyanA100="#84ffff",t.cyanA200="#18ffff",t.cyanA400="#00e5ff",t.cyanA700="#00b8d4",t.teal50="#e0f2f1",t.teal100="#b2dfdb",t.teal200="#80cbc4",t.teal300="#4db6ac",t.teal400="#26a69a",t.teal500="#009688",t.teal600="#00897b",t.teal700="#00796b",t.teal800="#00695c",t.teal900="#004d40",t.tealA100="#a7ffeb",t.tealA200="#64ffda",t.tealA400="#1de9b6",t.tealA700="#00bfa5",t.green50="#e8f5e9",t.green100="#c8e6c9",t.green200="#a5d6a7",t.green300="#81c784",t.green400="#66bb6a",t.green500="#4caf50",t.green600="#43a047",t.green700="#388e3c",t.green800="#2e7d32",t.green900="#1b5e20",t.greenA100="#b9f6ca",t.greenA200="#69f0ae",t.greenA400="#00e676",t.greenA700="#00c853",t.lightGreen50="#f1f8e9",t.lightGreen100="#dcedc8",t.lightGreen200="#c5e1a5",t.lightGreen300="#aed581",t.lightGreen400="#9ccc65",t.lightGreen500="#8bc34a",t.lightGreen600="#7cb342",t.lightGreen700="#689f38",t.lightGreen800="#558b2f",t.lightGreen900="#33691e",t.lightGreenA100="#ccff90",t.lightGreenA200="#b2ff59",t.lightGreenA400="#76ff03",t.lightGreenA700="#64dd17",t.lime50="#f9fbe7",t.lime100="#f0f4c3",t.lime200="#e6ee9c",t.lime300="#dce775",t.lime400="#d4e157",t.lime500="#cddc39",t.lime600="#c0ca33",t.lime700="#afb42b",t.lime800="#9e9d24",t.lime900="#827717",t.limeA100="#f4ff81",t.limeA200="#eeff41",t.limeA400="#c6ff00",t.limeA700="#aeea00",t.yellow50="#fffde7",t.yellow100="#fff9c4",t.yellow200="#fff59d",t.yellow300="#fff176",t.yellow400="#ffee58",t.yellow500="#ffeb3b",t.yellow600="#fdd835",t.yellow700="#fbc02d",t.yellow800="#f9a825",t.yellow900="#f57f17",t.yellowA100="#ffff8d",t.yellowA200="#ffff00",t.yellowA400="#ffea00",t.yellowA700="#ffd600",t.amber50="#fff8e1",t.amber100="#ffecb3",t.amber200="#ffe082",t.amber300="#ffd54f",t.amber400="#ffca28",t.amber500="#ffc107",t.amber600="#ffb300",t.amber700="#ffa000",t.amber800="#ff8f00",t.amber900="#ff6f00",t.amberA100="#ffe57f",t.amberA200="#ffd740",t.amberA400="#ffc400",t.amberA700="#ffab00",t.orange50="#fff3e0",t.orange100="#ffe0b2",t.orange200="#ffcc80",t.orange300="#ffb74d",t.orange400="#ffa726",t.orange500="#ff9800",t.orange600="#fb8c00",t.orange700="#f57c00",t.orange800="#ef6c00",t.orange900="#e65100",t.orangeA100="#ffd180",t.orangeA200="#ffab40",t.orangeA400="#ff9100",t.orangeA700="#ff6d00",t.deepOrange50="#fbe9e7",t.deepOrange100="#ffccbc",t.deepOrange200="#ffab91",t.deepOrange300="#ff8a65",t.deepOrange400="#ff7043",t.deepOrange500="#ff5722",t.deepOrange600="#f4511e",t.deepOrange700="#e64a19",t.deepOrange800="#d84315",t.deepOrange900="#bf360c",t.deepOrangeA100="#ff9e80",t.deepOrangeA200="#ff6e40",t.deepOrangeA400="#ff3d00",t.deepOrangeA700="#dd2c00",t.brown50="#efebe9",t.brown100="#d7ccc8",t.brown200="#bcaaa4",t.brown300="#a1887f",t.brown400="#8d6e63",t.brown500="#795548",t.brown600="#6d4c41",t.brown700="#5d4037",t.brown800="#4e342e",t.brown900="#3e2723",t.blueGrey50="#eceff1",t.blueGrey100="#cfd8dc",t.blueGrey200="#b0bec5",t.blueGrey300="#90a4ae",t.blueGrey400="#78909c",t.blueGrey500="#607d8b",t.blueGrey600="#546e7a",t.blueGrey700="#455a64",t.blueGrey800="#37474f",t.blueGrey900="#263238",t.grey50="#fafafa",t.grey100="#f5f5f5",t.grey200="#eeeeee",t.grey300="#e0e0e0",t.grey400="#bdbdbd",t.grey500="#9e9e9e",t.grey600="#757575",t.grey700="#616161",t.grey800="#424242",t.grey900="#212121",t.black="#000000",t.white="#ffffff",t.transparent="rgba(0, 0, 0, 0)",t.fullBlack="rgba(0, 0, 0, 1)",t.darkBlack="rgba(0, 0, 0, 0.87)",t.lightBlack="rgba(0, 0, 0, 0.54)",t.minBlack="rgba(0, 0, 0, 0.26)",t.faintBlack="rgba(0, 0, 0, 0.12)",t.fullWhite="rgba(255, 255, 255, 1)",t.darkWhite="rgba(255, 255, 255, 0.87)",t.lightWhite="rgba(255, 255, 255, 0.54)"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(3),s=r(u),l=n(1),c=r(l),f=n(119),d=r(f),p=n(116),h=r(p),y=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,s=Array(u),l=0;l<u;l++)s[l]=arguments[l];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r.ref=null,r.render=function(){return r.props.disabled?null:c.default.createElement(h.default,{insetChildren:!0,leftIcon:r.props.isSelected?c.default.createElement(d.default,{icon:"Done"}):void 0,primaryText:r.props.primaryText,value:r.props.value,disabled:r.props.disabled,onClick:r.props.onClick,focusState:r.props.focusState})},a=n,i(r,a)}return a(t,e),t}(l.Component);y.propTypes={disabled:s.default.bool.isRequired,isSelected:s.default.bool.isRequired,primaryText:s.default.string.isRequired,value:s.default.object.isRequired,onClick:s.default.func,focusState:s.default.string},y.defaultProps={onClick:void 0,focusState:"none"},y.muiName="MenuItem",t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(3),i=r(o),a=n(1),u=r(a),s=function(e,t){var n=e.author;t.d2.i18n.addStrings(["created_by","no_author"]);var r=n?t.d2.i18n.getTranslation("created_by")+": "+n.name:t.d2.i18n.getTranslation("no_author");return u.default.createElement("div",null,r)};s.propTypes={author:i.default.object.isRequired},s.contextTypes={d2:i.default.object.isRequired},t.default=s},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.PublicAccess=t.ExternalAccess=t.GroupAccess=t.Access=void 0;var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(3),a=r(i),u=n(1),s=r(u),l=n(709),c=n(118),f=r(c),d=n(119),p=r(d),h=n(251),y=r(h),v=n(250),m={accessView:{fontWeight:"400",display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center",padding:"4px 8px"},accessDescription:{display:"flex",flexDirection:"column",flex:1,paddingLeft:16}},b={d2:a.default.object.isRequired},g=function(e){switch(e){case"user":return"Person";case"userGroup":return"Group";case"external":return"Public";case"public":return"Business";default:return"Person"}},_=function(e){return o({},e,{access:(0,v.accessStringToObject)(e.access),onChange:function(t){e.onChange((0,v.accessObjectToString)(t))}})},w=t.Access=function(e){var t=e.access,n=e.accessType,r=e.accessOptions,o=e.primaryText,i=e.secondaryText,a=e.onChange,u=e.onRemove,l=e.disabled;return s.default.createElement("div",{style:m.accessView},s.default.createElement(p.default,{icon:g(n)}),s.default.createElement("div",{style:m.accessDescription},s.default.createElement("div",null,o),s.default.createElement("div",{style:{color:"#818181",paddingTop:4}},i||" ")),s.default.createElement(y.default,{access:t,accessOptions:r,onChange:a,disabled:l}),s.default.createElement(f.default,{disabled:!u,iconStyle:{color:"#bbbbbb"},onClick:u||function(){}},s.default.createElement(p.default,{icon:"Clear"})))};w.contextTypes=b,w.propTypes={access:a.default.object.isRequired,accessType:a.default.string.isRequired,accessOptions:a.default.object.isRequired,primaryText:a.default.string.isRequired,onChange:a.default.func.isRequired,disabled:a.default.bool,secondaryText:a.default.string,onRemove:a.default.func},w.defaultProps={secondaryText:void 0,onRemove:void 0,disabled:!1};var x=(t.GroupAccess=(0,l.compose)((0,l.mapProps)(_),(0,l.withProps)(function(e){return{accessType:e.groupType,primaryText:e.groupName,accessOptions:{meta:{canView:!0,canEdit:!0,noAccess:!1},data:e.dataShareable&&{canView:!0,canEdit:!0,noAccess:!0}}}}))(w),t.ExternalAccess=(0,l.compose)((0,l.getContext)(b),(0,l.withProps)(function(e){return e.d2.i18n.addStrings(["public_access","external_access","anyone_can_view_without_a_login","anyone_can_find_view_and_edit","anyone_can_find_and_view","no_access"]),{accessType:"external",primaryText:e.d2.i18n.getTranslation("external_access"),secondaryText:e.access?e.d2.i18n.getTranslation("anyone_can_view_without_a_login"):e.d2.i18n.getTranslation("no_access"),access:{meta:{canEdit:!1,canView:e.access},data:{canEdit:!1,canView:!1}},onChange:function(t){e.onChange(t.meta.canView)},accessOptions:{meta:{canView:!0,canEdit:!1,noAccess:!0}}}}))(w),function(e){var t=e.canView;return e.canEdit?"anyone_can_find_view_and_edit":t?"anyone_can_find_and_view":"no_access"});t.PublicAccess=(0,l.compose)((0,l.mapProps)(_),(0,l.getContext)(b),(0,l.withProps)(function(e){return e.d2.i18n.addStrings(["public_access","external_access","anyone_can_view_without_a_login","anyone_can_find_view_and_edit","anyone_can_find_and_view","no_access"]),{accessType:"public",primaryText:e.d2.i18n.getTranslation("public_access"),secondaryText:e.d2.i18n.getTranslation(x(e.access.meta)),accessOptions:{meta:{canView:!0,canEdit:!0,noAccess:!0},data:e.dataShareable&&{canView:!0,canEdit:!0,noAccess:!0}}}}))(w)},function(e,t,n){"use strict";function r(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return 0===t.length?function(e){return e}:1===t.length?t[0]:t.reduce(function(e,t){return function(){return e(t.apply(void 0,arguments))}})}Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"mapProps",function(){return v}),n.d(t,"withProps",function(){return x}),n.d(t,"withPropsOnChange",function(){return S}),n.d(t,"withHandlers",function(){return E}),n.d(t,"defaultProps",function(){return C}),n.d(t,"renameProp",function(){return P}),n.d(t,"renameProps",function(){return N}),n.d(t,"flattenProp",function(){return I}),n.d(t,"withState",function(){return A}),n.d(t,"withStateHandlers",function(){return R}),n.d(t,"withReducer",function(){return F}),n.d(t,"branch",function(){return L}),n.d(t,"renderComponent",function(){return z}),n.d(t,"renderNothing",function(){return U}),n.d(t,"shouldUpdate",function(){return W}),n.d(t,"pure",function(){return H}),n.d(t,"onlyUpdateForKeys",function(){return B}),n.d(t,"onlyUpdateForPropTypes",function(){return K}),n.d(t,"withContext",function(){return q}),n.d(t,"getContext",function(){return G}),n.d(t,"lifecycle",function(){return Y}),n.d(t,"toClass",function(){return $}),n.d(t,"setStatic",function(){return d}),n.d(t,"setPropTypes",function(){return Q}),n.d(t,"setDisplayName",function(){return p}),n.d(t,"compose",function(){return r}),n.d(t,"getDisplayName",function(){return h}),n.d(t,"wrapDisplayName",function(){return y}),n.d(t,"isClassComponent",function(){return X}),n.d(t,"createSink",function(){return J}),n.d(t,"componentFromProp",function(){return Z}),n.d(t,"nest",function(){return ee}),n.d(t,"hoistStatics",function(){return te}),n.d(t,"componentFromStream",function(){return ae}),n.d(t,"componentFromStreamWithConfig",function(){return ie}),n.d(t,"mapPropsStream",function(){return le}),n.d(t,"mapPropsStreamWithConfig",function(){return se}),n.d(t,"createEventHandler",function(){return fe}),n.d(t,"createEventHandlerWithConfig",function(){return ce}),n.d(t,"setObservableConfig",function(){return re});var o=n(1),i=n.n(o),a=n(61),u=n.n(a),s=n(710),l=n.n(s),c=n(711),f=(n.n(c),n(712));n.d(t,"shallowEqual",function(){return u.a});var d=function(e,t){return function(n){return n[e]=t,n}},p=function(e){return d("displayName",e)},h=function(e){return"string"==typeof e?e:e?e.displayName||e.name||"Component":void 0},y=function(e,t){return t+"("+h(e)+")"},v=function(e){return function(t){var n=Object(o.createFactory)(t);return function(t){return n(e(t))}}},m=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},b=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},g=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},_=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n},w=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},x=function(e){return v(function(t){return b({},t,"function"==typeof e?e(t):e)})},O=function(e,t){for(var n={},r=0;r<t.length;r++){var o=t[r];e.hasOwnProperty(o)&&(n[o]=e[o])}return n},S=function(e,t){return function(n){var r=Object(o.createFactory)(n),i="function"==typeof e?e:function(t,n){return!u()(O(t,e),O(n,e))};return function(e){function n(){var r,o,i;m(this,n);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return r=o=w(this,e.call.apply(e,[this].concat(u))),o.computedProps=t(o.props),i=r,w(o,i)}return g(n,e),n.prototype.componentWillReceiveProps=function(e){i(this.props,e)&&(this.computedProps=t(e))},n.prototype.render=function(){return r(b({},this.props,this.computedProps))},n}(o.Component)}},T=function(e,t){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]=t(e[r],r));return n},E=function(e){return function(t){var n=Object(o.createFactory)(t),r=function(){var t=this;this.cachedHandlers={},this.handlers=T("function"==typeof e?e(this.props):e,function(e,n){return function(){var r=t.cachedHandlers[n];if(r)return r.apply(void 0,arguments);var o=e(t.props);return t.cachedHandlers[n]=o,o.apply(void 0,arguments)}})};return function(e){function t(){var n,o,i;m(this,t);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return n=o=w(this,e.call.apply(e,[this].concat(u))),r.call(o),i=n,w(o,i)}return g(t,e),t.prototype.componentWillReceiveProps=function(){this.cachedHandlers={}},t.prototype.render=function(){return n(b({},this.props,this.handlers))},t}(o.Component)}},C=function(e){return function(t){var n=Object(o.createFactory)(t),r=function(e){return n(e)};return r.defaultProps=e,r}},k=function(e,t){for(var n=_(e,[]),r=0;r<t.length;r++){var o=t[r];n.hasOwnProperty(o)&&delete n[o]}return n},P=function(e,t){return v(function(n){var r;return b({},k(n,[e]),(r={},r[t]=n[e],r))})},M=Object.keys,j=function(e,t){return M(e).reduce(function(n,r){var o=e[r];return n[t(o,r)]=o,n},{})},N=function(e){return v(function(t){return b({},k(t,M(e)),j(O(t,M(e)),function(t,n){return e[n]}))})},I=function(e){return function(t){var n=Object(o.createFactory)(t);return function(t){return n(b({},t,t[e]))}}},A=function(e,t,n){return function(r){var i=Object(o.createFactory)(r);return function(r){function o(){var e,t,i;m(this,o);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return e=t=w(this,r.call.apply(r,[this].concat(u))),t.state={stateValue:"function"==typeof n?n(t.props):n},t.updateStateValue=function(e,n){return t.setState(function(t){var n=t.stateValue;return{stateValue:"function"==typeof e?e(n):e}},n)},i=e,w(t,i)}return g(o,r),o.prototype.render=function(){var n;return i(b({},this.props,(n={},n[e]=this.state.stateValue,n[t]=this.updateStateValue,n)))},o}(o.Component)}},R=function(e,t){return function(n){var r=Object(o.createFactory)(n),i=function(){var n=this;this.state="function"==typeof e?e(this.props):e,this.stateUpdaters=T(t,function(e){return function(t){for(var r=arguments.length,o=Array(r>1?r-1:0),i=1;i<r;i++)o[i-1]=arguments[i];t&&"function"==typeof t.persist&&t.persist(),n.setState(function(n,r){return e(n,r).apply(void 0,[t].concat(o))})}})};return function(e){function t(){var n,r,o;m(this,t);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return n=r=w(this,e.call.apply(e,[this].concat(u))),i.call(r),o=n,w(r,o)}return g(t,e),t.prototype.shouldComponentUpdate=function(e,t){var n=e!==this.props,r=!u()(t,this.state);return n||r},t.prototype.render=function(){return r(b({},this.props,this.state,this.stateUpdaters))},t}(o.Component)}},F=function(e,t,n,r){return function(i){var a=Object(o.createFactory)(i);return function(o){function i(){var e,t,r;m(this,i);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return e=t=w(this,o.call.apply(o,[this].concat(u))),t.state={stateValue:t.initializeStateValue()},t.dispatch=function(e){return t.setState(function(t){var r=t.stateValue;return{stateValue:n(r,e)}})},r=e,w(t,r)}return g(i,o),i.prototype.initializeStateValue=function(){return void 0!==r?"function"==typeof r?r(this.props):r:n(void 0,{type:"@@recompose/INIT"})},i.prototype.render=function(){var n;return a(b({},this.props,(n={},n[e]=this.state.stateValue,n[t]=this.dispatch,n)))},i}(o.Component)}},D=function(e){return e},L=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:D;return function(r){var i=void 0,a=void 0;return function(u){return e(u)?(i=i||Object(o.createFactory)(t(r)))(u):(a=a||Object(o.createFactory)(n(r)))(u)}}},z=function(e){return function(t){var n=Object(o.createFactory)(e);return function(e){return n(e)}}},V=function(e){function t(){return m(this,t),w(this,e.apply(this,arguments))}return g(t,e),t.prototype.render=function(){return null},t}(o.Component),U=function(e){return V},W=function(e){return function(t){var n=Object(o.createFactory)(t);return function(t){function r(){return m(this,r),w(this,t.apply(this,arguments))}return g(r,t),r.prototype.shouldComponentUpdate=function(t){return e(this.props,t)},r.prototype.render=function(){return n(this.props)},r}(o.Component)}},H=function(e){return W(function(e,t){return!u()(e,t)})(e)},B=function(e){return W(function(t,n){return!u()(O(n,e),O(t,e))})},K=function(e){var t=e.propTypes,n=Object.keys(t||{});return B(n)(e)},q=function(e,t){return function(n){var r=Object(o.createFactory)(n),i=function(e){function n(){var r,o,i;m(this,n);for(var a=arguments.length,u=Array(a),s=0;s<a;s++)u[s]=arguments[s];return r=o=w(this,e.call.apply(e,[this].concat(u))),o.getChildContext=function(){return t(o.props)},i=r,w(o,i)}return g(n,e),n.prototype.render=function(){return r(this.props)},n}(o.Component);return i.childContextTypes=e,i}},G=function(e){return function(t){var n=Object(o.createFactory)(t),r=function(e,t){return n(b({},e,t))};return r.contextTypes=e,r}},Y=function(e){return function(t){var n=Object(o.createFactory)(t),r=function(e){function t(){return m(this,t),w(this,e.apply(this,arguments))}return g(t,e),t.prototype.render=function(){return n(b({},this.props,this.state))},t}(o.Component);return Object.keys(e).forEach(function(t){return r.prototype[t]=e[t]}),r}},X=function(e){return Boolean(e&&e.prototype&&"function"==typeof e.prototype.render)},$=function(e){if(X(e))return e;var t=function(t){function n(){return m(this,n),w(this,t.apply(this,arguments))}return g(n,t),n.prototype.render=function(){return"string"==typeof e?i.a.createElement(e,this.props):e(this.props,this.context)},n}(o.Component);return t.displayName=h(e),t.propTypes=e.propTypes,t.contextTypes=e.contextTypes,t.defaultProps=e.defaultProps,t},Q=function(e){return d("propTypes",e)},J=function(e){return function(t){function n(){return m(this,n),w(this,t.apply(this,arguments))}return g(n,t),n.prototype.componentWillMount=function(){e(this.props)},n.prototype.componentWillReceiveProps=function(t){e(t)},n.prototype.render=function(){return null},n}(o.Component)},Z=function(e){var t=function(t){return Object(o.createElement)(t[e],k(t,[e]))};return t.displayName="componentFromProp("+e+")",t},ee=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];var r=t.map(o.createFactory);return function(e){var t=_(e,[]),n=e.children;return r.reduceRight(function(e,n){return n(t,e)},n)}},te=function(e){return function(t){var n=e(t);return l()(n,t),n}},ne={fromESObservable:null,toESObservable:null},re=function(e){ne=e},oe={fromESObservable:function(e){return"function"==typeof ne.fromESObservable?ne.fromESObservable(e):e},toESObservable:function(e){return"function"==typeof ne.toESObservable?ne.toESObservable(e):e}},ie=function(e){return function(t){return function(n){function r(){var o,i,a,u;m(this,r);for(var s=arguments.length,l=Array(s),d=0;d<s;d++)l[d]=arguments[d];return i=a=w(this,n.call.apply(n,[this].concat(l))),a.state={vdom:null},a.propsEmitter=Object(c.createChangeEmitter)(),a.props$=e.fromESObservable((o={subscribe:function(e){return{unsubscribe:a.propsEmitter.listen(function(t){t?e.next(t):e.complete()})}}},o[f.a]=function(){return this},o)),a.vdom$=e.toESObservable(t(a.props$)),u=i,w(a,u)}return g(r,n),r.prototype.componentWillMount=function(){var e=this;this.subscription=this.vdom$.subscribe({next:function(t){e.setState({vdom:t})}}),this.propsEmitter.emit(this.props)},r.prototype.componentWillReceiveProps=function(e){this.propsEmitter.emit(e)},r.prototype.shouldComponentUpdate=function(e,t){return t.vdom!==this.state.vdom},r.prototype.componentWillUnmount=function(){this.propsEmitter.emit(),this.subscription.unsubscribe()},r.prototype.render=function(){return this.state.vdom},r}(o.Component)}},ae=function(e){return ie(oe)(e)},ue=function(e){return e},se=function(e){var t=ie({fromESObservable:ue,toESObservable:ue});return function(n){return function(r){var i=Object(o.createFactory)(r),a=e.fromESObservable,u=e.toESObservable;return t(function(e){var t;return t={subscribe:function(t){var r=u(n(a(e))).subscribe({next:function(e){return t.next(i(e))}});return{unsubscribe:function(){return r.unsubscribe()}}}},t[f.a]=function(){return this},t})}}},le=function(e){return se(oe)(e)},ce=function(e){return function(){var t,n=Object(c.createChangeEmitter)(),r=e.fromESObservable((t={subscribe:function(e){return{unsubscribe:n.listen(function(t){return e.next(t)})}}},t[f.a]=function(){return this},t));return{handler:n.emit,stream:r}}},fe=ce(oe)},function(e,t,n){!function(t,n){e.exports=function(){"use strict";var e={childContextTypes:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},t={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},n=Object.defineProperty,r=Object.getOwnPropertyNames,o=Object.getOwnPropertySymbols,i=Object.getOwnPropertyDescriptor,a=Object.getPrototypeOf,u=a&&a(Object);return function s(l,c,f){if("string"!=typeof c){if(u){var d=a(c);d&&d!==u&&s(l,d,f)}var p=r(c);o&&(p=p.concat(o(c)));for(var h=0;h<p.length;++h){var y=p[h];if(!(e[y]||t[y]||f&&f[y])){var v=i(c,y);try{n(l,y,v)}catch(e){}}}return l}return l}}()}()},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.createChangeEmitter=function(){function e(){o===r&&(o=r.slice())}function t(t){if("function"!=typeof t)throw new Error("Expected listener to be a function.");var n=!0;return e(),o.push(t),function(){if(n){n=!1,e();var r=o.indexOf(t);o.splice(r,1)}}}function n(){r=o;for(var e=r,t=0;t<e.length;t++)e[t].apply(e,arguments)}var r=[],o=r;return{listen:t,emit:n}}},function(e,t,n){"use strict";(function(e,r){var o,i=n(714);o="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==e?e:r;var a=Object(i.a)(o);t.a=a}).call(t,n(47),n(713)(e))},function(e,t){e.exports=function(e){if(!e.webpackPolyfill){var t=Object.create(e);t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),Object.defineProperty(t,"exports",{enumerable:!0}),t.webpackPolyfill=1}return t}},function(e,t,n){"use strict";function r(e){var t,n=e.Symbol;return"function"==typeof n?n.observable?t=n.observable:(t=n("observable"),n.observable=t):t="@@observable",t}t.a=r},function(e,t,n){"use strict";function r(e){var t=e.style,n=void 0===t?{}:t,r=e.large,o=void 0!==r&&r,i=e.small,a=void 0!==i&&i;return u.a.createElement("div",{style:Object.assign({},l,n)},u.a.createElement(s.a,{large:o,small:a}))}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var o=n(3),i=n.n(o),a=n(1),u=n.n(a),s=n(716),l={left:"45%",position:"fixed",top:"45%"};r.propTypes={style:i.a.object,large:i.a.bool,small:i.a.bool}},function(e,t,n){"use strict";function r(e,t){return e?{size:119,margin:10.5}:t?{size:29.75,margin:2.625}:{size:59.5,margin:5.25}}function o(e){var t=e.large,n=void 0!==t&&t,o=e.small,i=void 0!==o&&o,a=e.style,u=r(n,i);return s.a.createElement(c.a,{mode:"indeterminate",size:u.size,style:Object.assign({margin:u.margin},a)})}t.a=o;var i=n(3),a=n.n(i),u=n(1),s=n.n(u),l=n(717),c=n.n(l);o.propTypes={large:a.a.bool,small:a.a.bool}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return Math.min(Math.max(t,e),n)/(n-t)}function i(e,t){return e*Math.PI*(t.size-t.thickness)}function a(e,t){var n=e.max,r=e.min,a=e.size,u=e.value,s=t.muiTheme.baseTheme.palette,l={root:{position:"relative",display:"inline-block",width:a,height:a},wrapper:{width:a,height:a,display:"inline-block",transition:M.default.create("transform","20s",null,"linear"),transitionTimingFunction:"linear"},svg:{width:a,height:a,position:"relative"},path:{stroke:e.color||s.primary1Color,strokeLinecap:"round",transition:M.default.create("all","1.5s",null,"ease-in-out")}};if("determinate"===e.mode){var c=o(u,r,n);l.path.transition=M.default.create("all","0.3s",null,"linear"),l.path.strokeDasharray=i(c,e)+", "+i(1,e)}return l}Object.defineProperty(t,"__esModule",{value:!0});var u=n(14),s=r(u),l=n(15),c=r(l),f=n(11),d=r(f),p=n(8),h=r(p),y=n(9),v=r(y),m=n(12),b=r(m),g=n(13),_=r(g),w=n(10),x=r(w),O=n(1),S=r(O),T=n(3),E=r(T),C=n(66),k=r(C),P=n(17),M=r(P),j=function(e){function t(){return(0,h.default)(this,t),(0,b.default)(this,(t.__proto__||(0,d.default)(t)).apply(this,arguments))}return(0,_.default)(t,e),(0,v.default)(t,[{key:"componentDidMount",value:function(){this.scalePath(this.refs.path),this.rotateWrapper(this.refs.wrapper)}},{key:"componentWillUnmount",value:function(){clearTimeout(this.scalePathTimer),clearTimeout(this.rotateWrapperTimer)}},{key:"scalePath",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;"indeterminate"===this.props.mode&&(n%=3,0===n?(e.style.strokeDasharray=i(0,this.props)+", "+i(1,this.props),e.style.strokeDashoffset=0,e.style.transitionDuration="0ms"):1===n?(e.style.strokeDasharray=i(.7,this.props)+", "+i(1,this.props),e.style.strokeDashoffset=i(-.3,this.props),e.style.transitionDuration="750ms"):(e.style.strokeDasharray=i(.7,this.props)+", "+i(1,this.props),e.style.strokeDashoffset=i(-1,this.props),e.style.transitionDuration="850ms"),this.scalePathTimer=setTimeout(function(){return t.scalePath(e,n+1)},n?750:250))}},{key:"rotateWrapper",value:function(e){var t=this;"indeterminate"===this.props.mode&&(k.default.set(e.style,"transform","rotate(0deg)"),k.default.set(e.style,"transitionDuration","0ms"),setTimeout(function(){k.default.set(e.style,"transform","rotate(1800deg)"),k.default.set(e.style,"transitionDuration","10s"),k.default.set(e.style,"transitionTimingFunction","linear")},50),this.rotateWrapperTimer=setTimeout(function(){return t.rotateWrapper(e)},10050))}},{key:"render",value:function(){var e=this.props,t=e.style,n=e.innerStyle,r=e.size,o=e.thickness,i=(0,c.default)(e,["style","innerStyle","size","thickness"]),u=this.context.muiTheme.prepareStyles,l=a(this.props,this.context);return S.default.createElement("div",(0,s.default)({},i,{style:u((0,x.default)(l.root,t))}),S.default.createElement("div",{ref:"wrapper",style:u((0,x.default)(l.wrapper,n))},S.default.createElement("svg",{viewBox:"0 0 "+r+" "+r,style:u(l.svg)},S.default.createElement("circle",{ref:"path",style:u(l.path),cx:r/2,cy:r/2,r:(r-o)/2,fill:"none",strokeWidth:o,strokeMiterlimit:"20"}))))}}]),t}(O.Component);j.defaultProps={mode:"indeterminate",value:0,min:0,max:100,size:40,thickness:3.5},j.contextTypes={muiTheme:E.default.object.isRequired},j.propTypes={},t.default=j}])})},function(e,t,n){"use strict";(function(e){function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=e.__MUI_SvgIcon__||l.default,f=i.default.createElement("path",{d:"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"}),d=function(e){return i.default.createElement(c,e,f)};d=(0,u.default)(d),d.muiName="SvgIcon",t.default=d}).call(t,n(16))},function(e,t,n){"use strict";(function(e){function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=e.__MUI_SvgIcon__||l.default,f=i.default.createElement("path",{d:"M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"}),d=function(e){return i.default.createElement(c,e,f)};d=(0,u.default)(d),d.muiName="SvgIcon",t.default=d}).call(t,n(16))},function(e,t,n){"use strict";(function(e){function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(0),i=r(o),a=n(26),u=r(a),s=n(24),l=r(s),c=e.__MUI_SvgIcon__||l.default,f=i.default.createElement("path",{d:"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"}),d=function(e){return i.default.createElement(c,e,f)};d=(0,u.default)(d),d.muiName="SvgIcon",t.default=d}).call(t,n(16))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(66),i=(n(414),n(415)),a=r(i),u=n(168),s=r(u),l=function(){var e=[a.default],t=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||o.compose;return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__,(0,o.createStore)(s.default,t(o.applyMiddleware.apply(void 0,e)))};t.default=l},function(e,t,n){(function(e){!function(e,n){n(t)}(0,function(t){"use strict";function n(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function o(e,t,n){o.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:n,enumerable:!0})}function i(e,t){i.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function a(e,t){a.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function u(e,t,n){u.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:n,enumerable:!0})}function s(e,t,n){var r=e.slice((n||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,r),e}function l(e){var t=void 0===e?"undefined":M(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function c(e,t,n,r,f,d,p){f=f||[],p=p||[];var h=f.slice(0);if(void 0!==d){if(r){if("function"==typeof r&&r(h,d))return;if("object"===(void 0===r?"undefined":M(r))){if(r.prefilter&&r.prefilter(h,d))return;if(r.normalize){var y=r.normalize(h,d,e,t);y&&(e=y[0],t=y[1])}}}h.push(d)}"regexp"===l(e)&&"regexp"===l(t)&&(e=e.toString(),t=t.toString());var v=void 0===e?"undefined":M(e),m=void 0===t?"undefined":M(t),b="undefined"!==v||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),g="undefined"!==m||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&g)n(new i(h,t));else if(!g&&b)n(new a(h,e));else if(l(e)!==l(t))n(new o(h,e,t));else if("date"===l(e)&&e-t!=0)n(new o(h,e,t));else if("object"===v&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&n(new o(h,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var _;for(e.length,_=0;_<e.length;_++)_>=t.length?n(new u(h,_,new a(void 0,e[_]))):c(e[_],t[_],n,r,h,_,p);for(;_<t.length;)n(new u(h,_,new i(void 0,t[_++])))}else{var w=Object.keys(e),x=Object.keys(t);w.forEach(function(o,i){var a=x.indexOf(o);a>=0?(c(e[o],t[o],n,r,h,o,p),x=s(x,a)):c(e[o],void 0,n,r,h,o,p)}),x.forEach(function(e){c(void 0,t[e],n,r,h,e,p)})}p.length=p.length-1}else e!==t&&("number"===v&&isNaN(e)&&isNaN(t)||n(new o(h,e,t)))}function f(e,t,n,r){return r=r||[],c(e,t,function(e){e&&r.push(e)},n),r.length?r:void 0}function d(e,t,n){if(n.path&&n.path.length){var r,o=e[t],i=n.path.length-1;for(r=0;r<i;r++)o=o[n.path[r]];switch(n.kind){case"A":d(o[n.path[r]],n.index,n.item);break;case"D":delete o[n.path[r]];break;case"E":case"N":o[n.path[r]]=n.rhs}}else switch(n.kind){case"A":d(e[t],n.index,n.item);break;case"D":e=s(e,t);break;case"E":case"N":e[t]=n.rhs}return e}function p(e,t,n){if(e&&t&&n&&n.kind){for(var r=e,o=-1,i=n.path?n.path.length-1:0;++o<i;)void 0===r[n.path[o]]&&(r[n.path[o]]="number"==typeof n.path[o]?[]:{}),r=r[n.path[o]];switch(n.kind){case"A":d(n.path?r[n.path[o]]:r,n.index,n.item);break;case"D":delete r[n.path[o]];break;case"E":case"N":r[n.path[o]]=n.rhs}}}function h(e,t,n){if(n.path&&n.path.length){var r,o=e[t],i=n.path.length-1;for(r=0;r<i;r++)o=o[n.path[r]];switch(n.kind){case"A":h(o[n.path[r]],n.index,n.item);break;case"D":case"E":o[n.path[r]]=n.lhs;break;case"N":delete o[n.path[r]]}}else switch(n.kind){case"A":h(e[t],n.index,n.item);break;case"D":case"E":e[t]=n.lhs;break;case"N":e=s(e,t)}return e}function y(e,t,n){if(e&&t&&n&&n.kind){var r,o,i=e;for(o=n.path.length-1,r=0;r<o;r++)void 0===i[n.path[r]]&&(i[n.path[r]]={}),i=i[n.path[r]];switch(n.kind){case"A":h(i[n.path[r]],n.index,n.item);break;case"D":case"E":i[n.path[r]]=n.lhs;break;case"N":delete i[n.path[r]]}}}function v(e,t,n){if(e&&t){c(e,t,function(r){n&&!n(e,t,r)||p(e,t,r)})}}function m(e){return"color: "+I[e].color+"; font-weight: bold"}function b(e){var t=e.kind,n=e.path,r=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[n.join("."),r,"→",o];case"N":return[n.join("."),o];case"D":return[n.join(".")];case"A":return[n.join(".")+"["+i+"]",a];default:return[]}}function g(e,t,n,r){var o=f(e,t);try{r?n.groupCollapsed("diff"):n.group("diff")}catch(e){n.log("diff")}o?o.forEach(function(e){var t=e.kind,r=b(e);n.log.apply(n,["%c "+I[t].text,m(t)].concat(j(r)))}):n.log("—— no diff ——");try{n.groupEnd()}catch(e){n.log("—— diff end —— ")}}function _(e,t,n,r){switch(void 0===e?"undefined":M(e)){case"object":return"function"==typeof e[r]?e[r].apply(e,j(n)):e[r];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,n=e.duration;return function(e,r,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+r),n&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var n=t.logger,r=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,u=t.colors,s=t.level,l=t.diff,c=void 0===t.titleFormatter;e.forEach(function(o,f){var d=o.started,p=o.startedTime,h=o.action,y=o.prevState,v=o.error,m=o.took,b=o.nextState,w=e[f+1];w&&(b=w.prevState,m=w.started-d);var x=r(h),O="function"==typeof a?a(function(){return b},h,o):a,S=k(p),T=u.title?"color: "+u.title(x)+";":"",E=["color: gray; font-weight: lighter;"];E.push(T),t.timestamp&&E.push("color: gray; font-weight: lighter;"),t.duration&&E.push("color: gray; font-weight: lighter;");var C=i(x,S,m);try{O?u.title&&c?n.groupCollapsed.apply(n,["%c "+C].concat(E)):n.groupCollapsed(C):u.title&&c?n.group.apply(n,["%c "+C].concat(E)):n.group(C)}catch(e){n.log(C)}var P=_(s,x,[y],"prevState"),M=_(s,x,[x],"action"),j=_(s,x,[v,y],"error"),N=_(s,x,[b],"nextState");if(P)if(u.prevState){var I="color: "+u.prevState(y)+"; font-weight: bold";n[P]("%c prev state",I,y)}else n[P]("prev state",y);if(M)if(u.action){var A="color: "+u.action(x)+"; font-weight: bold";n[M]("%c action    ",A,x)}else n[M]("action    ",x);if(v&&j)if(u.error){var R="color: "+u.error(v,y)+"; font-weight: bold;";n[j]("%c error     ",R,v)}else n[j]("error     ",v);if(N)if(u.nextState){var F="color: "+u.nextState(b)+"; font-weight: bold";n[N]("%c next state",F,b)}else n[N]("next state",b);l&&g(y,b,n,O);try{n.groupEnd()}catch(e){n.log("—— log end ——")}})}function O(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},A,e),n=t.logger,r=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,u=t.diffPredicate;if(void 0===n)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var s=[];return function(e){var n=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(n,l))return e(l);var c={};s.push(c),c.started=P.now(),c.startedTime=new Date,c.prevState=r(n()),c.action=l;var f=void 0;if(a)try{f=e(l)}catch(e){c.error=o(e)}else f=e(l);c.took=P.now()-c.started,c.nextState=r(n());var d=t.diff&&"function"==typeof u?u(n,l):t.diff;if(x(s,Object.assign({},t,{diff:d})),s.length=0,c.error)throw c.error;return f}}}}var S,T,E=function(e,t){return new Array(t+1).join(e)},C=function(e,t){return E("0",t-e.toString().length)+e},k=function(e){return C(e.getHours(),2)+":"+C(e.getMinutes(),2)+":"+C(e.getSeconds(),2)+"."+C(e.getMilliseconds(),3)},P="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,M="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},j=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)},N=[];S="object"===(void 0===e?"undefined":M(e))&&e?e:"undefined"!=typeof window?window:{},T=S.DeepDiff,T&&N.push(function(){void 0!==T&&S.DeepDiff===f&&(S.DeepDiff=T,T=void 0)}),n(o,r),n(i,r),n(a,r),n(u,r),Object.defineProperties(f,{diff:{value:f,enumerable:!0},observableDiff:{value:c,enumerable:!0},applyDiff:{value:v,enumerable:!0},applyChange:{value:p,enumerable:!0},revertChange:{value:y,enumerable:!0},isConflict:{value:function(){return void 0!==T},enumerable:!0},noConflict:{value:function(){return N&&(N.forEach(function(e){e()}),N=null),f},enumerable:!0}});var I={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},A={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},R=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,n=e.getState;return"function"==typeof t||"function"==typeof n?O()({dispatch:t,getState:n}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};t.defaults=A,t.createLogger=O,t.logger=R,t.default=R,Object.defineProperty(t,"__esModule",{value:!0})})}).call(t,n(16))},function(e,t,n){"use strict";function r(e){return function(t){var n=t.dispatch,r=t.getState;return function(t){return function(o){return"function"==typeof o?o(n,r,e):t(o)}}}}t.__esModule=!0;var o=r();o.withExtraArgument=r,t.default=o}])});

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _map = __webpack_require__(154);

var _favorites = __webpack_require__(270);

var _favorites2 = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    content: {
        width: 305
    },
    title: {
        paddingBottom: 10
    },
    body: {
        padding: '0 24px 10px',
        lineHeight: '26px'
    }
};

var SaveNewFavoriteDialog = function (_Component) {
    _inherits(SaveNewFavoriteDialog, _Component);

    function SaveNewFavoriteDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SaveNewFavoriteDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SaveNewFavoriteDialog.__proto__ || Object.getPrototypeOf(SaveNewFavoriteDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            name: ''
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SaveNewFavoriteDialog, [{
        key: 'validateName',
        value: function validateName(name) {
            // TODO: Set error text if name is empty
            this.saveFavorite(name);
        }
    }, {
        key: 'saveFavorite',
        value: function saveFavorite(name) {
            var config = _extends({}, (0, _favorites2.cleanMapConfig)(this.props.config), {
                name: name
            });

            delete config.id;

            if (config.mapViews) {
                config.mapViews.forEach(function (view) {
                    return delete view.id;
                });
            }

            this.props.setMapName(name);
            this.props.saveNewFavorite(config);
            this.props.closeSaveNewFavoriteDialog();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                response = _props.response,
                hasLayers = _props.hasLayers,
                saveNewDialogOpen = _props.saveNewDialogOpen,
                closeSaveNewFavoriteDialog = _props.closeSaveNewFavoriteDialog; // TODO: config included only for testing

            var name = this.state.name;


            if (!saveNewDialogOpen) {
                return null;
            }

            return _react2.default.createElement(
                _Dialog2.default,
                {
                    title: _i18next2.default.t('Save as new favorite'),
                    contentStyle: styles.content,
                    titleStyle: styles.title,
                    bodyStyle: styles.body,
                    actions: [_react2.default.createElement(
                        _Button2.default,
                        {
                            color: 'primary',
                            onClick: closeSaveNewFavoriteDialog
                        },
                        'Close'
                    ), hasLayers && !response ? _react2.default.createElement(
                        _Button2.default,
                        {
                            color: 'primary',
                            onClick: function onClick() {
                                return _this2.validateName(name);
                            },
                            disabled: name.length === 0
                        },
                        'Save'
                    ) : null],
                    open: saveNewDialogOpen,
                    onRequestClose: closeSaveNewFavoriteDialog
                },
                response && response.status === 'OK' ? _react2.default.createElement(
                    'div',
                    null,
                    _i18next2.default.t('Your map was saved successfully.')
                ) : null,
                response && response.status !== 'OK' ? _react2.default.createElement(
                    'div',
                    null,
                    _i18next2.default.t('An error occurred'),
                    ' ',
                    '(response.httpStatusCode): ',
                    response.message
                ) : null,
                hasLayers && !response ? _react2.default.createElement(_TextField2.default, {
                    label: _i18next2.default.t('Favorite name'),
                    value: name,
                    onChange: function onChange(name) {
                        return _this2.setState({ name: name });
                    }
                }) : null,
                !hasLayers && !response ? _react2.default.createElement(
                    'div',
                    null,
                    _i18next2.default.t('Your map is empty, please add a layer before you save a favorite.')
                ) : null
            );
        }
    }]);

    return SaveNewFavoriteDialog;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        saveNewDialogOpen: state.favorite.saveNewDialogOpen,
        hasLayers: Boolean(state.map.mapViews.length),
        config: state.map,
        response: state.favorite.response
    };
}, { setMapName: _map.setMapName, saveNewFavorite: _favorites.saveNewFavorite, closeSaveNewFavoriteDialog: _favorites.closeSaveNewFavoriteDialog })(SaveNewFavoriteDialog);

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(628);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _RenderToLayer = __webpack_require__(624);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _TransitionGroup = __webpack_require__(267);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransitionItem = function (_Component) {
  (0, _inherits3.default)(TransitionItem, _Component);

  function TransitionItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransitionItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      style: {}
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransitionItem, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimeout);
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.componentWillAppear(callback);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      var spacing = this.context.muiTheme.baseTheme.spacing;

      this.setState({
        style: {
          opacity: 1,
          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
        }
      });

      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this.setState({
        style: {
          opacity: 0,
          transform: 'translate(0, 0)'
        }
      });

      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          children = _props.children,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
        children
      );
    }
  }]);
  return TransitionItem;
}(_react.Component);

TransitionItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TransitionItem.propTypes =  false ? {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};


function getStyles(props, context) {
  var autoScrollBodyContent = props.autoScrollBodyContent,
      open = props.open;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      spacing = _context$muiTheme$bas.spacing,
      palette = _context$muiTheme$bas.palette,
      dialog = _context$muiTheme.dialog,
      zIndex = _context$muiTheme.zIndex;


  var gutter = spacing.desktopGutter;
  var borderScroll = '1px solid ' + palette.borderColor;

  return {
    root: {
      position: 'fixed',
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      zIndex: zIndex.dialog,
      top: 0,
      left: open ? 0 : -10000,
      width: '100%',
      height: '100%',
      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
    },
    content: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      transition: _transitions2.default.easeOut(),
      position: 'relative',
      width: '75%',
      maxWidth: spacing.desktopKeylineIncrement * 12,
      margin: '0 auto',
      zIndex: zIndex.dialog
    },
    actionsContainer: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      padding: 8,
      width: '100%',
      textAlign: 'right',
      marginTop: autoScrollBodyContent ? -1 : 0
    },
    overlay: {
      zIndex: zIndex.dialogOverlay
    },
    title: {
      margin: 0,
      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
      color: palette.textColor,
      fontSize: dialog.titleFontSize,
      lineHeight: '32px',
      fontWeight: 400,
      marginBottom: autoScrollBodyContent ? -1 : 0
    },
    body: {
      fontSize: dialog.bodyFontSize,
      color: dialog.bodyColor,
      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
      boxSizing: 'border-box',
      overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
      borderTop: autoScrollBodyContent ? borderScroll : 'none',
      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
    }
  };
}

var DialogInline = function (_Component2) {
  (0, _inherits3.default)(DialogInline, _Component2);

  function DialogInline() {
    var _ref2;

    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DialogInline);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleClickOverlay = function () {
      _this2.requestClose(false);
    }, _this2.handleKeyUp = function (event) {
      if ((0, _keycode2.default)(event) === 'esc') {
        _this2.requestClose(false);
      }
    }, _this2.handleResize = function () {
      _this2.positionDialog();
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(DialogInline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.positionDialog();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.positionDialog();
    }
  }, {
    key: 'positionDialog',
    value: function positionDialog() {
      var _props2 = this.props,
          actions = _props2.actions,
          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
          autoScrollBodyContent = _props2.autoScrollBodyContent,
          bodyStyle = _props2.bodyStyle,
          open = _props2.open,
          repositionOnUpdate = _props2.repositionOnUpdate,
          title = _props2.title;


      if (!open) {
        return;
      }

      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var container = _reactDom2.default.findDOMNode(this);
      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
      var minPaddingTop = 16;

      // Reset the height in case the window was resized.
      dialogWindow.style.height = '';
      dialogContent.style.height = '';

      var dialogWindowHeight = dialogWindow.offsetHeight;
      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;

      // Vertically center the dialog window, but make sure it doesn't
      // transition to that position.
      if (repositionOnUpdate || !container.style.paddingTop) {
        container.style.paddingTop = paddingTop + 'px';
      }

      // Force a height if the dialog is taller than clientHeight
      if (autoDetectWindowHeight || autoScrollBodyContent) {
        var styles = getStyles(this.props, this.context);
        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
        var maxDialogContentHeight = clientHeight - 2 * 64;

        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;

        if (_react2.default.Children.count(actions)) {
          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
        }

        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
        if (maxDialogContentHeight > dialogWindowHeight) {
          dialogContent.style.borderBottom = 'none';
          dialogContent.style.borderTop = 'none';
        }
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(buttonClicked) {
      if (!buttonClicked && this.props.modal) {
        return;
      }

      if (this.props.onRequestClose) {
        this.props.onRequestClose(!!buttonClicked);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          actions = _props3.actions,
          actionsContainerClassName = _props3.actionsContainerClassName,
          actionsContainerStyle = _props3.actionsContainerStyle,
          bodyClassName = _props3.bodyClassName,
          bodyStyle = _props3.bodyStyle,
          children = _props3.children,
          className = _props3.className,
          contentClassName = _props3.contentClassName,
          contentStyle = _props3.contentStyle,
          overlayClassName = _props3.overlayClassName,
          overlayStyle = _props3.overlayStyle,
          open = _props3.open,
          paperClassName = _props3.paperClassName,
          paperProps = _props3.paperProps,
          style = _props3.style,
          titleClassName = _props3.titleClassName,
          titleStyle = _props3.titleStyle,
          title = _props3.title;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      styles.root = (0, _simpleAssign2.default)(styles.root, style);
      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);

      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
        'div',
        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
        _react2.default.Children.toArray(actions)
      );

      var titleElement = title;
      if (_react2.default.isValidElement(title)) {
        titleElement = _react2.default.cloneElement(title, {
          className: title.props.className || titleClassName,
          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
        });
      } else if (typeof title === 'string') {
        titleElement = _react2.default.createElement(
          'h3',
          { className: titleClassName, style: prepareStyles(styles.title) },
          title
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className, style: prepareStyles(styles.root) },
        open && _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyUp: this.handleKeyUp,
          onResize: this.handleResize
        }),
        _react2.default.createElement(
          _TransitionGroup2.default,
          {
            component: 'div',
            ref: 'dialogWindow',
            transitionAppear: true,
            transitionAppearTimeout: 450,
            transitionEnter: true,
            transitionEnterTimeout: 450
          },
          open && _react2.default.createElement(
            TransitionItem,
            {
              className: contentClassName,
              style: styles.content
            },
            _react2.default.createElement(
              _Paper2.default,
              (0, _extends3.default)({ className: paperClassName, zDepth: 4 }, paperProps),
              titleElement,
              _react2.default.createElement(
                'div',
                {
                  ref: 'dialogContent',
                  className: bodyClassName,
                  style: prepareStyles(styles.body)
                },
                children
              ),
              actionsContainer
            )
          )
        ),
        _react2.default.createElement(_Overlay2.default, {
          show: open,
          className: overlayClassName,
          style: styles.overlay,
          onClick: this.handleClickOverlay
        })
      );
    }
  }]);
  return DialogInline;
}(_react.Component);

DialogInline.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DialogInline.propTypes =  false ? {
  actions: _propTypes2.default.node,
  actionsContainerClassName: _propTypes2.default.string,
  actionsContainerStyle: _propTypes2.default.object,
  autoDetectWindowHeight: _propTypes2.default.bool,
  autoScrollBodyContent: _propTypes2.default.bool,
  bodyClassName: _propTypes2.default.string,
  bodyStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  contentStyle: _propTypes2.default.object,
  modal: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  overlayClassName: _propTypes2.default.string,
  overlayStyle: _propTypes2.default.object,
  paperClassName: _propTypes2.default.string,
  paperProps: _propTypes2.default.object,
  repositionOnUpdate: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  title: _propTypes2.default.node,
  titleClassName: _propTypes2.default.string,
  titleStyle: _propTypes2.default.object
} : {};

var Dialog = function (_Component3) {
  (0, _inherits3.default)(Dialog, _Component3);

  function Dialog() {
    var _ref3;

    var _temp3, _this3, _ret3;

    (0, _classCallCheck3.default)(this, Dialog);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
      return _react2.default.createElement(DialogInline, _this3.props);
    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
  }

  (0, _createClass3.default)(Dialog, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
    }
  }]);
  return Dialog;
}(_react.Component);

Dialog.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Dialog.defaultProps = {
  autoDetectWindowHeight: true,
  autoScrollBodyContent: false,
  modal: false,
  repositionOnUpdate: true
};
Dialog.propTypes =  false ? {
  /**
   * Action buttons to display below the Dialog content (`children`).
   * This property accepts either a React element, or an array of React elements.
   */
  actions: _propTypes2.default.node,
  /**
   * The `className` to add to the actions container's root element.
   */
  actionsContainerClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the actions container's root element.
   */
  actionsContainerStyle: _propTypes2.default.object,
  /**
   * If set to true, the height of the `Dialog` will be auto detected. A max height
   * will be enforced so that the content does not extend beyond the viewport.
   */
  autoDetectWindowHeight: _propTypes2.default.bool,
  /**
   * If set to true, the body content of the `Dialog` will be scrollable.
   */
  autoScrollBodyContent: _propTypes2.default.bool,
  /**
   * The `className` to add to the content's root element under the title.
   */
  bodyClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the content's root element under the title.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The contents of the `Dialog`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The `className` to add to the content container.
   */
  contentClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the content container.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * Force the user to use one of the actions in the `Dialog`.
   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
   */
  modal: _propTypes2.default.bool,
  /**
   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
   *
   * @param {bool} buttonClicked Determines whether a button click triggered this request.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the Dialog is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * The CSS class name of the `Paper` element.
   */
  paperClassName: _propTypes2.default.string,
  /**
   * Properties applied to the `Paper` element.
   */
  paperProps: _propTypes2.default.object,
  /**
   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
   */
  repositionOnUpdate: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
   */
  title: _propTypes2.default.node,
  /**
   * The `className` to add to the title's root container element.
   */
  titleClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the title's root container element.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = Dialog;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalBodyOverflow = null;
var lockingCounter = 0;

var AutoLockScrolling = function (_Component) {
  (0, _inherits3.default)(AutoLockScrolling, _Component);

  function AutoLockScrolling() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AutoLockScrolling);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AutoLockScrolling, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.lock === true) {
        this.preventScrolling();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.lock !== nextProps.lock) {
        if (nextProps.lock) {
          this.preventScrolling();
        } else {
          this.allowScrolling();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.allowScrolling();
    }

    // force to only lock/unlock once

  }, {
    key: 'preventScrolling',
    value: function preventScrolling() {
      if (this.locked === true) {
        return;
      }

      lockingCounter = lockingCounter + 1;
      this.locked = true;

      // only lock the first time the component is mounted.
      if (lockingCounter === 1) {
        var body = document.getElementsByTagName('body')[0];
        originalBodyOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'allowScrolling',
    value: function allowScrolling() {
      if (this.locked === true) {
        lockingCounter = lockingCounter - 1;
        this.locked = false;
      }

      if (lockingCounter === 0 && originalBodyOverflow !== null) {
        var body = document.getElementsByTagName('body')[0];
        body.style.overflow = originalBodyOverflow || '';
        originalBodyOverflow = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return AutoLockScrolling;
}(_react.Component);

AutoLockScrolling.propTypes =  false ? {
  lock: _propTypes2.default.bool.isRequired
} : {};
exports.default = AutoLockScrolling;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RaisedButton = __webpack_require__(971);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RaisedButton2.default;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(147);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      raisedButton = _context$muiTheme.raisedButton,
      borderRadius = _context$muiTheme.borderRadius;
  var disabled = props.disabled,
      disabledBackgroundColor = props.disabledBackgroundColor,
      disabledLabelColor = props.disabledLabelColor,
      fullWidth = props.fullWidth,
      icon = props.icon,
      label = props.label,
      labelPosition = props.labelPosition,
      primary = props.primary,
      secondary = props.secondary,
      style = props.style;


  var amount = primary || secondary ? 0.4 : 0.08;

  var backgroundColor = raisedButton.color;
  var labelColor = raisedButton.textColor;

  if (disabled) {
    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
  } else if (primary) {
    backgroundColor = raisedButton.primaryColor;
    labelColor = raisedButton.primaryTextColor;
  } else if (secondary) {
    backgroundColor = raisedButton.secondaryColor;
    labelColor = raisedButton.secondaryTextColor;
  } else {
    if (props.backgroundColor) {
      backgroundColor = props.backgroundColor;
    }
    if (props.labelColor) {
      labelColor = props.labelColor;
    }
  }

  var buttonHeight = style && style.height || button.height;

  return {
    root: {
      display: 'inline-block',
      transition: _transitions2.default.easeOut(),
      minWidth: fullWidth ? '100%' : button.minWidth
    },
    button: {
      height: buttonHeight,
      lineHeight: buttonHeight + 'px',
      width: '100%',
      padding: 0,
      borderRadius: borderRadius,
      transition: _transitions2.default.easeOut(),
      backgroundColor: backgroundColor,
      // That's the default value for a button but not a link
      textAlign: 'center'
    },
    label: {
      position: 'relative',
      opacity: 1,
      fontSize: raisedButton.fontSize,
      letterSpacing: 0,
      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
      fontWeight: raisedButton.fontWeight,
      margin: 0,
      userSelect: 'none',
      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      color: labelColor
    },
    icon: {
      verticalAlign: 'middle',
      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
      marginRight: label && labelPosition === 'before' ? 12 : 0
    },
    overlay: {
      height: buttonHeight,
      borderRadius: borderRadius,
      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    ripple: {
      color: labelColor,
      opacity: !(primary || secondary) ? 0.1 : 0.16
    }
  };
}

var RaisedButton = function (_Component) {
  (0, _inherits3.default)(RaisedButton, _Component);

  function RaisedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RaisedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      keyboardFocused: false,
      touched: false,
      initialZDepth: 0,
      zDepth: 0
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({
          zDepth: _this.state.initialZDepth + 1
        });
      }
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
    }, _this.handleMouseUp = function (event) {
      _this.setState({
        zDepth: _this.state.initialZDepth
      });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.state.keyboardFocused) {
        _this.setState({
          zDepth: _this.state.initialZDepth,
          hovered: false
        });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.keyboardFocused && !_this.state.touched) {
        _this.setState({
          hovered: true
        });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth + 1
      });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth
      });

      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;

      _this.setState({
        zDepth: zDepth,
        keyboardFocused: keyboardFocused
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RaisedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var zDepth = this.props.disabled ? 0 : 1;
      this.setState({
        zDepth: zDepth,
        initialZDepth: zDepth
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var zDepth = nextProps.disabled ? 0 : 1;
      var nextState = {
        zDepth: zDepth,
        initialZDepth: zDepth
      };

      if (nextProps.disabled) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          buttonStyle = _props.buttonStyle,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          disabledBackgroundColor = _props.disabledBackgroundColor,
          disabledLabelColor = _props.disabledLabelColor,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          label = _props.label,
          labelColor = _props.labelColor,
          labelPosition = _props.labelPosition,
          labelStyle = _props.labelStyle,
          overlayStyle = _props.overlayStyle,
          primary = _props.primary,
          rippleStyle = _props.rippleStyle,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);

      var buttonEventHandlers = disabled ? {} : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      var labelElement = label && _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
        label
      );

      var iconCloned = icon && (0, _react.cloneElement)(icon, {
        color: icon.props.color || styles.label.color,
        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
        key: 'iconCloned'
      });

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: this.state.zDepth
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
            focusRippleColor: mergedRippleStyles.color,
            touchRippleColor: mergedRippleStyles.color,
            focusRippleOpacity: mergedRippleStyles.opacity,
            touchRippleOpacity: mergedRippleStyles.opacity
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
            },
            enhancedButtonChildren
          )
        )
      );
    }
  }]);
  return RaisedButton;
}(_react.Component);

RaisedButton.muiName = 'RaisedButton';
RaisedButton.defaultProps = {
  disabled: false,
  labelPosition: 'after',
  fullWidth: false,
  primary: false,
  secondary: false
};
RaisedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RaisedButton.propTypes =  false ? {
  /**
   * Override the default background color for the button,
   * but not the default disabled background color
   * (use `disabledBackgroundColor` for this).
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The content of the button.
   * If a label is provided via the `label` prop, the text within the label
   * will be displayed in addition to the content provided here.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
    * The element to use as the container for the RaisedButton. Either a string to
    * use a DOM element or a ReactElement. This is useful for wrapping the
    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
    * that it passes all of its given props through to the underlying DOM
    * element and renders its children prop for proper integration.
    */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the default background color for the button
   * when it is disabled.
   */
  disabledBackgroundColor: _propTypes2.default.string,
  /**
   * The color of the button's label when the button is disabled.
   */
  disabledLabelColor: _propTypes2.default.string,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * An icon to be displayed within the button.
   */
  icon: _propTypes2.default.node,
  /**
   * The label to be displayed within the button.
   * If content is provided via the `children` prop, that content will be
   * displayed in addition to the label provided here.
   */
  label: validateLabel,
  /**
   * The color of the button's label.
   */
  labelColor: _propTypes2.default.string,
  /**
   * The position of the button's label relative to the button's `children`.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline style of the button overlay.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's primary color.
   */
  primary: _propTypes2.default.bool,
  /**
   * Override the inline style of the ripple element.
   */
  rippleStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's secondary color.
   * If both `secondary` and `primary` are true, the button will use
   * the theme's primary color.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = RaisedButton;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FloatingActionButton = __webpack_require__(973);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FloatingActionButton2.default;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(147);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(617);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _childUtils = __webpack_require__(618);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var floatingActionButton = context.muiTheme.floatingActionButton;


  var backgroundColor = props.backgroundColor || floatingActionButton.color;
  var iconColor = floatingActionButton.iconColor;

  if (props.disabled) {
    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
    iconColor = floatingActionButton.disabledTextColor;
  } else if (props.secondary) {
    backgroundColor = floatingActionButton.secondaryColor;
    iconColor = floatingActionButton.secondaryIconColor;
  }

  return {
    root: {
      transition: _transitions2.default.easeOut(),
      display: 'inline-block',
      backgroundColor: 'transparent'
    },
    container: {
      backgroundColor: backgroundColor,
      transition: _transitions2.default.easeOut(),
      height: floatingActionButton.buttonSize,
      width: floatingActionButton.buttonSize,
      padding: 0,
      overflow: 'hidden',
      borderRadius: '50%',
      textAlign: 'center',
      verticalAlign: 'bottom'
    },
    containerWhenMini: {
      height: floatingActionButton.miniSize,
      width: floatingActionButton.miniSize
    },
    overlay: {
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    overlayWhenHovered: {
      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
    },
    icon: {
      height: floatingActionButton.buttonSize,
      lineHeight: floatingActionButton.buttonSize + 'px',
      fill: iconColor,
      color: iconColor
    },
    iconWhenMini: {
      height: floatingActionButton.miniSize,
      lineHeight: floatingActionButton.miniSize + 'px'
    }
  };
}

var FloatingActionButton = function (_Component) {
  (0, _inherits3.default)(FloatingActionButton, _Component);

  function FloatingActionButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FloatingActionButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      touch: false,
      zDepth: undefined
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({ zDepth: _this.props.zDepth + 1 });
      }
      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
    }, _this.handleMouseUp = function (event) {
      _this.setState({ zDepth: _this.props.zDepth });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.refs.container.isKeyboardFocused()) {
        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touch: true,
        zDepth: _this.props.zDepth + 1
      });
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        touch: true,
        zDepth: _this.props.zDepth
      });
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (keyboardFocused && !_this.props.disabled) {
        _this.setState({ zDepth: _this.props.zDepth + 1 });
        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
      } else if (!_this.state.hovered) {
        _this.setState({ zDepth: _this.props.zDepth });
        _this.refs.overlay.style.backgroundColor = 'transparent';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FloatingActionButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        zDepth: this.props.disabled ? 0 : this.props.zDepth
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextState = {};

      if (nextProps.disabled !== this.props.disabled) {
        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
      }
      if (nextProps.disabled) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          className = _props.className,
          childrenProp = _props.children,
          disabled = _props.disabled,
          disabledColor = _props.disabledColor,
          mini = _props.mini,
          secondary = _props.secondary,
          iconStyle = _props.iconStyle,
          iconClassName = _props.iconClassName,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (iconClassName) {
        iconElement = _react2.default.createElement(_FontIcon2.default, {
          className: iconClassName,
          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
        });
      }

      var children = void 0;

      if (childrenProp) {
        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
          return {
            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
          };
        });
      }

      var buttonEventHandlers = disabled ? null : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          zDepth: this.state.zDepth,
          circle: true
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
            focusRippleColor: styles.icon.color,
            touchRippleColor: styles.icon.color
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
            },
            iconElement,
            children
          )
        )
      );
    }
  }]);
  return FloatingActionButton;
}(_react.Component);

FloatingActionButton.defaultProps = {
  disabled: false,
  mini: false,
  secondary: false,
  zDepth: 2
};
FloatingActionButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FloatingActionButton.propTypes =  false ? {
  /**
   * This value will override the default background color for the button.
   * However it will not override the default disabled background color.
   * This has to be set separately using the disabledColor attribute.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what displayed inside the floating action button; for example, a SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * This value will override the default background color for the button when it is disabled.
   */
  disabledColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The icon within the FloatingActionButton is a FontIcon component.
   * This property is the classname of the icon to be displayed inside the button.
   * An alternative to adding an iconClassName would be to manually insert a
   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * This is the equivalent to iconClassName except that it is used for
   * overriding the inline-styles of the FontIcon component.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * If true, the button will be a small floating action button.
   */
  mini: _propTypes2.default.bool,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, the button will use the secondary button colors.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The zDepth of the underlying `Paper` component.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = FloatingActionButton;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(148);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedTextarea = __webpack_require__(975);

var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);

var _TextFieldHint = __webpack_require__(976);

var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);

var _TextFieldLabel = __webpack_require__(977);

var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);

var _TextFieldUnderline = __webpack_require__(978);

var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      _context$muiTheme$tex = _context$muiTheme.textField,
      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
      focusColor = _context$muiTheme$tex.focusColor,
      textColor = _context$muiTheme$tex.textColor,
      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
      backgroundColor = _context$muiTheme$tex.backgroundColor,
      errorColor = _context$muiTheme$tex.errorColor;


  var styles = {
    root: {
      fontSize: 16,
      lineHeight: '24px',
      width: props.fullWidth ? '100%' : 256,
      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
      display: 'inline-block',
      position: 'relative',
      backgroundColor: backgroundColor,
      fontFamily: baseTheme.fontFamily,
      transition: _transitions2.default.easeOut('200ms', 'height'),
      cursor: props.disabled ? 'not-allowed' : 'auto'
    },
    error: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: errorColor,
      transition: _transitions2.default.easeOut()
    },
    floatingLabel: {
      color: props.disabled ? disabledTextColor : floatingLabelColor,
      pointerEvents: 'none'
    },
    input: {
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      color: props.disabled ? disabledTextColor : textColor,
      cursor: 'inherit',
      font: 'inherit',
      WebkitOpacity: 1,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
    },
    inputNative: {
      appearance: 'textfield' // Improve type search style.
    }
  };

  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
    marginTop: props.floatingLabelText ? 36 : 12,
    marginBottom: props.floatingLabelText ? -36 : -12,
    boxSizing: 'border-box',
    font: 'inherit'
  });

  // Do not assign a height to the textarea as he handles it on his own.
  styles.input.height = '100%';

  if (state.isFocused) {
    styles.floatingLabel.color = focusColor;
  }

  if (props.floatingLabelText) {
    styles.input.boxSizing = 'border-box';

    if (!props.multiLine) {
      styles.input.marginTop = 14;
    }

    if (state.errorText) {
      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
    }
  }

  if (state.errorText) {
    if (state.isFocused) {
      styles.floatingLabel.color = styles.error.color;
    }
  }

  return styles;
};

/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}

var TextField = function (_Component) {
  (0, _inherits3.default)(TextField, _Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false,
      errorText: undefined,
      hasValue: false
    }, _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleInputChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.setState({ hasValue: isValid(event.target.value) });
      }
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _this.handleInputFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({ isFocused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleHeightChange = function (event, height) {
      var newHeight = height + 24;
      if (_this.props.floatingLabelText) {
        newHeight += 24;
      }
      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextField, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          hintText = _props.hintText,
          floatingLabelText = _props.floatingLabelText,
          id = _props.id;


      var propsLeaf = children ? children.props : this.props;

      this.setState({
        errorText: this.props.errorText,
        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
      });

       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;

      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled && !this.props.disabled) {
        this.setState({
          isFocused: false
        });
      }

      if (nextProps.errorText !== this.props.errorText) {
        this.setState({
          errorText: nextProps.errorText
        });
      }

      if (nextProps.children && nextProps.children.props) {
        nextProps = nextProps.children.props;
      }

      if (nextProps.hasOwnProperty('value')) {
        var hasValue = isValid(nextProps.value);

        this.setState({
          hasValue: hasValue
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'blur',
    value: function blur() {
      if (this.input) {
        this.getInputNode().blur();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.input) {
        this.getInputNode().focus();
      }
    }
  }, {
    key: 'select',
    value: function select() {
      if (this.input) {
        this.getInputNode().select();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input ? this.getInputNode().value : undefined;
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
    }
  }, {
    key: '_isControlled',
    value: function _isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          errorStyle = _props2.errorStyle,
          errorText = _props2.errorText,
          floatingLabelFixed = _props2.floatingLabelFixed,
          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
          floatingLabelStyle = _props2.floatingLabelStyle,
          floatingLabelText = _props2.floatingLabelText,
          fullWidth = _props2.fullWidth,
          hintText = _props2.hintText,
          hintStyle = _props2.hintStyle,
          id = _props2.id,
          inputStyle = _props2.inputStyle,
          multiLine = _props2.multiLine,
          onBlur = _props2.onBlur,
          onChange = _props2.onChange,
          onFocus = _props2.onFocus,
          style = _props2.style,
          type = _props2.type,
          underlineDisabledStyle = _props2.underlineDisabledStyle,
          underlineFocusStyle = _props2.underlineFocusStyle,
          underlineShow = _props2.underlineShow,
          underlineStyle = _props2.underlineStyle,
          rows = _props2.rows,
          rowsMax = _props2.rowsMax,
          textareaStyle = _props2.textareaStyle,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var inputId = id || this.uniqueId;

      var errorTextElement = this.state.errorText && _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
        this.state.errorText
      );

      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
        _TextFieldLabel2.default,
        {
          muiTheme: this.context.muiTheme,
          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
          shrinkStyle: floatingLabelShrinkStyle,
          htmlFor: inputId,
          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
          disabled: disabled
        },
        floatingLabelText
      );

      var inputProps = {
        id: inputId,
        ref: function ref(elem) {
          return _this2.input = elem;
        },
        disabled: this.props.disabled,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus
      };

      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);

      var inputElement = void 0;
      if (children) {
        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
        }));
      } else {
        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
          style: childStyleMerged,
          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
          rows: rows,
          rowsMax: rowsMax,
          hintText: hintText
        }, other, inputProps, {
          onHeightChange: this.handleHeightChange
        })) : _react2.default.createElement('input', (0, _extends3.default)({
          type: type,
          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
        }, other, inputProps));
      }

      var rootProps = {};

      if (children) {
        rootProps = other;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rootProps, {
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }),
        floatingLabelTextElement,
        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
          muiTheme: this.context.muiTheme,
          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
          style: hintStyle,
          text: hintText
        }) : null,
        inputElement,
        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
          disabled: disabled,
          disabledStyle: underlineDisabledStyle,
          error: !!this.state.errorText,
          errorStyle: errorStyle,
          focus: this.state.isFocused,
          focusStyle: underlineFocusStyle,
          muiTheme: this.context.muiTheme,
          style: underlineStyle
        }) : null,
        errorTextElement
      );
    }
  }]);
  return TextField;
}(_react.Component);

TextField.defaultProps = {
  disabled: false,
  floatingLabelFixed: false,
  multiLine: false,
  fullWidth: false,
  type: 'text',
  underlineShow: true,
  rows: 1
};
TextField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TextField.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The text string to use for the default value.
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Disables the text field if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The style object to use to override error styles.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when there is no value.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * The style object to use to override floating label styles when focused.
   */
  floatingLabelFocusStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles when shrunk.
   */
  floatingLabelShrinkStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content to use for the floating label element.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the field receives the property width 100%.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's hint text element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the inline-styles of the TextField's input element.
   * When multiLine is false: define the style of the input element.
   * When multiLine is true: define the style of the container of the textarea.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * If true, a textarea element will be rendered.
   * The textarea also grows and shrinks according to the number of lines.
   */
  multiLine: _propTypes2.default.bool,
  /**
   * Name applied to the input.
   */
  name: _propTypes2.default.string,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired when the textfield's value changes.
   *
   * @param {object} event Change event targeting the text field.
   * @param {string} newValue The new value of the text field.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Number of rows to display when multiLine option is set to true.
   */
  rows: _propTypes2.default.number,
  /**
   * Maximum number of rows to display when
   * multiLine option is set to true.
   */
  rowsMax: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's textarea element.
   * The TextField use either a textarea or an input,
   * this property has effects only when multiLine is true.
   */
  textareaStyle: _propTypes2.default.object,
  /**
   * Specifies the type of input to display
   * such as "password" or "text".
   */
  type: _propTypes2.default.string,
  /**
   * Override the inline-styles of the
   * TextField's underline element when disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's
   * underline element when focussed.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * If true, shows the underline for the text field.
   */
  underlineShow: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * The value of the text field.
   */
  value: _propTypes2.default.any
} : {};
exports.default = TextField;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowsHeight = 24;

function getStyles(props, context, state) {
  return {
    root: {
      position: 'relative' // because the shadow has position: 'absolute'
    },
    textarea: {
      height: state.height,
      width: '100%',
      resize: 'none',
      font: 'inherit',
      padding: 0,
      cursor: 'inherit'
    },
    shadow: {
      resize: 'none',
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      height: 'auto'
    }
  };
}

var EnhancedTextarea = function (_Component) {
  (0, _inherits3.default)(EnhancedTextarea, _Component);

  function EnhancedTextarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedTextarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.handleResize = function (event) {
      _this.syncHeightWithShadow(_this.props.value, event);
    }, _this.handleChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.syncHeightWithShadow(event.target.value);
      }

      if (_this.props.hasOwnProperty('valueLink')) {
        _this.props.valueLink.requestChange(event.target.value);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedTextarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        height: this.props.rows * rowsHeight
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow(this.props.value);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
        this.syncHeightWithShadow(nextProps.value, null, nextProps);
      }
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.refs.input;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getInputNode().value = value;
      this.syncHeightWithShadow(value);
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(newValue, event, props) {
      var shadow = this.refs.shadow;
      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;

      if (displayText !== undefined) {
        shadow.value = displayText;
      }

      var newHeight = shadow.scrollHeight;

      // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013
      if (newHeight === undefined) return;

      props = props || this.props;

      if (props.rowsMax >= props.rows) {
        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
      }

      newHeight = Math.max(newHeight, rowsHeight);

      if (this.state.height !== newHeight) {
        var input = this.refs.input;
        var cursorPosition = input.selectionStart;
        this.setState({
          height: newHeight
        }, function () {
          input.setSelectionRange(cursorPosition, cursorPosition);
        });

        if (props.onHeightChange) {
          props.onHeightChange(event, newHeight);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          onHeightChange = _props.onHeightChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          shadowStyle = _props.shadowStyle,
          style = _props.style,
          hintText = _props.hintText,
          textareaStyle = _props.textareaStyle,
          valueLink = _props.valueLink,
          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
      var props = {};

      if (this.props.hasOwnProperty('valueLink')) {
        other.value = valueLink.value;
        props.valueLink = valueLink;
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(rootStyles) },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          ref: 'shadow',
          style: prepareStyles(shadowStyles),
          tabIndex: '-1',
          rows: this.props.rows,
          defaultValue: this.props.defaultValue,
          readOnly: true,
          value: this.props.value
        }, props)),
        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
          ref: 'input',
          rows: this.props.rows,
          style: prepareStyles(textareaStyles),
          onChange: this.handleChange
        }))
      );
    }
  }]);
  return EnhancedTextarea;
}(_react.Component);

EnhancedTextarea.defaultProps = {
  rows: 1
};
EnhancedTextarea.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedTextarea.propTypes =  false ? {
  defaultValue: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  hintText: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  onHeightChange: _propTypes2.default.func,
  rows: _propTypes2.default.number,
  rowsMax: _propTypes2.default.number,
  shadowStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  textareaStyle: _propTypes2.default.object,
  value: _propTypes2.default.string,
  valueLink: _propTypes2.default.object
} : {};
exports.default = EnhancedTextarea;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var hintColor = props.muiTheme.textField.hintColor,
      show = props.show;


  return {
    root: {
      position: 'absolute',
      opacity: show ? 1 : 0,
      color: hintColor,
      transition: _transitions2.default.easeOut(),
      bottom: 12
    }
  };
}

var TextFieldHint = function TextFieldHint(props) {
  var prepareStyles = props.muiTheme.prepareStyles,
      style = props.style,
      text = props.text;


  var styles = getStyles(props);

  return _react2.default.createElement(
    'div',
    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
    text
  );
};

TextFieldHint.propTypes =  false ? {
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * True if the hint text should be visible.
   */
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The hint text displayed.
   */
  text: _propTypes2.default.node
} : {};

TextFieldHint.defaultProps = {
  show: true
};

exports.default = TextFieldHint;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var defaultStyles = {
    position: 'absolute',
    lineHeight: '22px',
    top: 38,
    transition: _transitions2.default.easeOut(),
    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
    transform: 'scale(1) translate(0, 0)',
    transformOrigin: 'left top',
    pointerEvents: 'auto',
    userSelect: 'none'
  };

  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
    transform: 'scale(0.75) translate(0, -28px)',
    pointerEvents: 'none'
  }, props.shrinkStyle) : null;

  return {
    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
  };
}

var TextFieldLabel = function TextFieldLabel(props) {
  var muiTheme = props.muiTheme,
      className = props.className,
      children = props.children,
      htmlFor = props.htmlFor,
      onClick = props.onClick;
  var prepareStyles = muiTheme.prepareStyles;

  var styles = getStyles(props);

  return _react2.default.createElement(
    'label',
    {
      className: className,
      style: prepareStyles(styles.root),
      htmlFor: htmlFor,
      onClick: onClick
    },
    children
  );
};

TextFieldLabel.propTypes =  false ? {
  /**
   * The label contents.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the label if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The id of the target element that this label should refer to.
   */
  htmlFor: _propTypes2.default.string,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Callback function for when the label is selected via a click.
   *
   * @param {object} event Click event targeting the text field label.
   */
  onClick: _propTypes2.default.func,
  /**
   * True if the floating label should shrink.
   */
  shrink: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when shrunk.
   */
  shrinkStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

TextFieldLabel.defaultProps = {
  disabled: false,
  shrink: false
};

exports.default = TextFieldLabel;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * True if the parent `TextField` is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is disabled.
   */
  disabledStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` has an error.
   */
  error: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` has an error.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` is focused.
   */
  focus: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is focused.
   */
  focusStyle: _propTypes2.default.object,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
};

var defaultProps = {
  disabled: false,
  disabledStyle: {},
  error: false,
  errorStyle: {},
  focus: false,
  focusStyle: {},
  style: {}
};

var TextFieldUnderline = function TextFieldUnderline(props) {
  var disabled = props.disabled,
      disabledStyle = props.disabledStyle,
      error = props.error,
      errorStyle = props.errorStyle,
      focus = props.focus,
      focusStyle = props.focusStyle,
      muiTheme = props.muiTheme,
      style = props.style;
  var errorStyleColor = errorStyle.color;
  var prepareStyles = muiTheme.prepareStyles,
      _muiTheme$textField = muiTheme.textField,
      borderColor = _muiTheme$textField.borderColor,
      disabledTextColor = _muiTheme$textField.disabledTextColor,
      errorColor = _muiTheme$textField.errorColor,
      focusColor = _muiTheme$textField.focusColor;


  var styles = {
    root: {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderColor: borderColor,
      bottom: 8,
      boxSizing: 'content-box',
      margin: 0,
      position: 'absolute',
      width: '100%'
    },
    disabled: {
      borderBottomStyle: 'dotted',
      borderBottomWidth: 2,
      borderColor: disabledTextColor
    },
    focus: {
      borderBottomStyle: 'solid',
      borderBottomWidth: 2,
      borderColor: focusColor,
      transform: 'scaleX(0)',
      transition: _transitions2.default.easeOut()
    },
    error: {
      borderColor: errorStyleColor ? errorStyleColor : errorColor,
      transform: 'scaleX(1)'
    }
  };

  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);

  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
  );
};

TextFieldUnderline.propTypes =  false ? propTypes : {};
TextFieldUnderline.defaultProps = defaultProps;

exports.default = TextFieldUnderline;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _TextField = __webpack_require__(273);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    dialog: {
        maxWidth: 600
    },
    textfield: {
        width: '100%'
    }
};

var InterpretationDialog = function (_Component) {
    _inherits(InterpretationDialog, _Component);

    function InterpretationDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, InterpretationDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InterpretationDialog.__proto__ || Object.getPrototypeOf(InterpretationDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            value: ''
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InterpretationDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                favoriteId = _props.favoriteId,
                onSave = _props.onSave,
                onClose = _props.onClose;
            var value = this.state.value;


            return _react2.default.createElement(
                _Dialog2.default,
                {
                    title: _i18next2.default.t('Write interpretation'),
                    open: true,
                    onRequestClose: onClose,
                    actions: [_react2.default.createElement(
                        _Button2.default,
                        { color: 'primary', onClick: onClose },
                        _i18next2.default.t('Cancel')
                    ), _react2.default.createElement(
                        _Button2.default,
                        {
                            color: 'primary',
                            disabled: value ? false : true,
                            onClick: function onClick() {
                                return onSave(favoriteId, value);
                            }
                        },
                        _i18next2.default.t('Save')
                    )],
                    contentStyle: styles.dialog
                },
                _react2.default.createElement(_TextField2.default, {
                    name: 'interpretation',
                    value: value,
                    multiLine: true,
                    rows: 4,
                    onChange: function onChange(evt, value) {
                        return _this2.setState({ value: value });
                    },
                    style: styles.textfield
                })
            );
        }
    }]);

    return InterpretationDialog;
}(_react.Component);

exports.default = InterpretationDialog;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _d = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    dialog: {
        maxWidth: 600,
        fontSize: 12
    },
    heading: {
        fontWeight: 'normal',
        color: '#111',
        fontSize: 14,
        marginTop: 0,
        marginBottom: 5
    },
    link: {
        display: 'block',
        fontSize: 14,
        marginBottom: 20
    }
};

var LinkDialog = function LinkDialog(_ref, _ref2) {
    var favoriteId = _ref.favoriteId,
        onClose = _ref.onClose;
    var d2 = _ref2.d2;

    var contextPath = d2.system.systemInfo.contextPath;
    var appUrl = contextPath + '/dhis-web-maps/?id=' + favoriteId;
    var apiUrl = _d.config.baseUrl + '/maps/' + favoriteId + '/data';

    return _react2.default.createElement(
        _Dialog2.default,
        {
            title: _i18next2.default.t('Favorite link'),
            open: true,
            onRequestClose: onClose,
            actions: _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                _i18next2.default.t('Close')
            ),
            contentStyle: styles.dialog
        },
        _react2.default.createElement(
            'h3',
            { style: styles.heading },
            _i18next2.default.t('Open in this app')
        ),
        _react2.default.createElement(
            'a',
            { href: appUrl, target: '_blank', style: styles.link },
            appUrl
        ),
        _react2.default.createElement(
            'h3',
            { style: styles.heading },
            _i18next2.default.t('Open in Web API (limited support)')
        ),
        _react2.default.createElement(
            'a',
            { href: apiUrl, target: '_blank', style: styles.link },
            apiUrl
        )
    );
};

LinkDialog.contextTypes = {
    d2: _propTypes2.default.object.isRequired
};

exports.default = LinkDialog;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _Drawer = __webpack_require__(982);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _reactSortableHoc = __webpack_require__(448);

var _BasemapCard = __webpack_require__(984);

var _BasemapCard2 = _interopRequireDefault(_BasemapCard);

var _LayerCard = __webpack_require__(1006);

var _LayerCard2 = _interopRequireDefault(_LayerCard);

var _layers = __webpack_require__(101);

var _layout = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SortableLayer = (0, _reactSortableHoc.SortableElement)(_LayerCard2.default);

// Draggable layers - last layer on top
var SortableLayersList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
    var layers = _ref.layers;
    return _react2.default.createElement(
        'div',
        { style: { zIndex: 3000 } },
        layers.map(function (layer, index) {
            return _react2.default.createElement(SortableLayer, { key: layer.id, index: index, layer: layer });
        })
    );
});

var style = {
    position: 'absolute',
    top: _layout.HEADER_HEIGHT,
    height: 'auto',
    bottom: 0,
    backgroundColor: '#fafafa',
    boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.227451)',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1190
};

var LayersPanel = function LayersPanel(_ref2) {
    var layersPanelOpen = _ref2.layersPanelOpen,
        basemap = _ref2.basemap,
        basemaps = _ref2.basemaps,
        layers = _ref2.layers,
        sortLayers = _ref2.sortLayers;
    return _react2.default.createElement(
        _Drawer2.default,
        {
            open: layersPanelOpen,
            containerStyle: style,
            width: _layout.LAYERS_PANEL_WIDTH
        },
        _react2.default.createElement(SortableLayersList, {
            layers: layers,
            onSortEnd: sortLayers,
            useDragHandle: true
        }),
        _react2.default.createElement(_BasemapCard2.default, _extends({}, basemap, { basemaps: basemaps }))
    );
};

LayersPanel.propTypes = {
    layersPanelOpen: _propTypes2.default.bool.isRequired,
    basemap: _propTypes2.default.object.isRequired,
    basemaps: _propTypes2.default.array.isRequired,
    layers: _propTypes2.default.array.isRequired,
    sortLayers: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        basemap: _extends({}, state.basemaps.filter(function (b) {
            return b.id === state.map.basemap.id;
        })[0], state.map.basemap),
        layers: [].concat(_toConsumableArray(state.map.mapViews)).reverse(),
        basemaps: state.basemaps,
        layersPanelOpen: state.ui.layersPanelOpen
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { sortLayers: _layers.sortLayers })(LayersPanel);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Drawer = __webpack_require__(983);

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Drawer2.default;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(628);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openNavEventHandler = null;

var Drawer = function (_Component) {
  (0, _inherits3.default)(Drawer, _Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOverlay = function (event) {
      event.preventDefault();
      _this.close('clickaway');
    }, _this.handleKeyUp = function (event) {
      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
        _this.close('escape');
      }
    }, _this.onBodyTouchStart = function (event) {
      var swipeAreaWidth = _this.props.swipeAreaWidth;

      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var touchStartY = event.touches[0].pageY;

      // Open only if swiping from far left (or right) while closed
      if (swipeAreaWidth !== null && !_this.state.open) {
        if (_this.props.openSecondary) {
          // If openSecondary is true calculate from the far right
          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
        } else {
          // If openSecondary is false calculate from the far left
          if (touchStartX > swipeAreaWidth) return;
        }
      }

      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
        return;
      }

      _this.maybeSwiping = true;
      _this.touchStartX = touchStartX;
      _this.touchStartY = touchStartY;

      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
    }, _this.onBodyTouchMove = function (event) {
      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = event.touches[0].pageY;

      if (_this.state.swiping) {
        event.preventDefault();
        _this.setPosition(_this.getTranslateX(currentX));
      } else if (_this.maybeSwiping) {
        var dXAbs = Math.abs(currentX - _this.touchStartX);
        var dYAbs = Math.abs(currentY - _this.touchStartY);
        // If the user has moved his thumb ten pixels in either direction,
        // we can safely make an assumption about whether he was intending
        // to swipe or scroll.
        var threshold = 10;

        if (dXAbs > threshold && dYAbs <= threshold) {
          _this.swipeStartX = currentX;
          _this.setState({
            swiping: _this.state.open ? 'closing' : 'opening'
          });
          _this.setPosition(_this.getTranslateX(currentX));
        } else if (dXAbs <= threshold && dYAbs > threshold) {
          _this.onBodyTouchEnd();
        }
      }
    }, _this.onBodyTouchEnd = function (event) {
      if (_this.state.swiping) {
        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();

        _this.maybeSwiping = false;
        var swiping = _this.state.swiping;
        _this.setState({
          swiping: null
        });

        // We have to open or close after setting swiping to null,
        // because only then CSS transition is enabled.
        if (translateRatio > 0.5) {
          if (swiping === 'opening') {
            _this.setPosition(_this.getMaxTranslateX());
          } else {
            _this.close('swipe');
          }
        } else {
          if (swiping === 'opening') {
            _this.open('swipe');
          } else {
            _this.setPosition(0);
          }
        }
      } else {
        _this.maybeSwiping = false;
      }

      _this.removeBodyTouchListeners();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.maybeSwiping = false;
      this.touchStartX = null;
      this.touchStartY = null;
      this.swipeStartX = null;

      this.setState({
        open: this.props.open !== null ? this.props.open : this.props.docked,
        swiping: null
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If controlled then the open prop takes precedence.
      if (nextProps.open !== null) {
        this.setState({
          open: nextProps.open
        });
        // Otherwise, if docked is changed, change the open state for when uncontrolled.
      } else if (this.props.docked !== nextProps.docked) {
        this.setState({
          open: nextProps.docked
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disableSwipeHandling();
      this.removeBodyTouchListeners();
    }
  }, {
    key: 'getStyles',
    value: function getStyles() {
      var muiTheme = this.context.muiTheme;
      var theme = muiTheme.drawer;

      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());

      var styles = {
        root: {
          height: '100%',
          width: this.getTranslatedWidth() || theme.width,
          position: 'fixed',
          zIndex: muiTheme.zIndex.drawer,
          left: 0,
          top: 0,
          transform: 'translate(' + x + 'px, 0)',
          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
          backgroundColor: theme.color,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
        },
        overlay: {
          zIndex: muiTheme.zIndex.drawerOverlay,
          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
        },
        rootWhenOpenRight: {
          left: 'auto',
          right: 0
        }
      };

      return styles;
    }
  }, {
    key: 'shouldShow',
    value: function shouldShow() {
      return this.state.open || !!this.state.swiping; // component is swiping
    }
  }, {
    key: 'close',
    value: function close(reason) {
      if (this.props.open === null) this.setState({ open: false });
      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
      return this;
    }
  }, {
    key: 'open',
    value: function open(reason) {
      if (this.props.open === null) this.setState({ open: true });
      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
      return this;
    }
  }, {
    key: 'getTranslatedWidth',
    value: function getTranslatedWidth() {
      if (typeof this.props.width === 'string') {
        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
          throw new Error('Not a valid percentage format.');
        }
        var width = parseFloat(this.props.width) / 100.0;
        // We are doing our best on the Server to render a consistent UI, hence the
        // default value of 10000
        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
      } else {
        return this.props.width;
      }
    }
  }, {
    key: 'getMaxTranslateX',
    value: function getMaxTranslateX() {
      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
      return width + 10;
    }
  }, {
    key: 'getTranslateMultiplier',
    value: function getTranslateMultiplier() {
      return this.props.openSecondary ? 1 : -1;
    }
  }, {
    key: 'enableSwipeHandling',
    value: function enableSwipeHandling() {
      if (!this.props.docked) {
        document.body.addEventListener('touchstart', this.onBodyTouchStart);
        if (!openNavEventHandler) {
          openNavEventHandler = this.onBodyTouchStart;
        }
      } else {
        this.disableSwipeHandling();
      }
    }
  }, {
    key: 'disableSwipeHandling',
    value: function disableSwipeHandling() {
      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
      if (openNavEventHandler === this.onBodyTouchStart) {
        openNavEventHandler = null;
      }
    }
  }, {
    key: 'removeBodyTouchListeners',
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
    }
  }, {
    key: 'setPosition',
    value: function setPosition(translateX) {
      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
    }
  }, {
    key: 'getTranslateX',
    value: function getTranslateX(currentX) {
      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          containerClassName = _props.containerClassName,
          containerStyle = _props.containerStyle,
          docked = _props.docked,
          openSecondary = _props.openSecondary,
          overlayClassName = _props.overlayClassName,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = this.getStyles();

      var overlay = void 0;
      if (!docked) {
        overlay = _react2.default.createElement(_Overlay2.default, {
          ref: 'overlay',
          show: this.shouldShow(),
          className: overlayClassName,
          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
          transitionEnabled: !this.state.swiping,
          onClick: this.handleClickOverlay
        });
      }

      return _react2.default.createElement(
        'div',
        {
          className: className,
          style: style
        },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
        overlay,
        _react2.default.createElement(
          _Paper2.default,
          {
            ref: 'clickAwayableElement',
            zDepth: zDepth,
            rounded: false,
            transitionEnabled: !this.state.swiping,
            className: containerClassName,
            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
          },
          children
        )
      );
    }
  }]);
  return Drawer;
}(_react.Component);

Drawer.defaultProps = {
  disableSwipeToOpen: false,
  docked: true,
  open: null,
  openSecondary: false,
  swipeAreaWidth: 30,
  width: null,
  zDepth: 2
};
Drawer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Drawer.propTypes =  false ? {
  /**
   * The contents of the `Drawer`
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The CSS class name of the container element.
   */
  containerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, swiping sideways when the `Drawer` is closed will not open it.
   */
  disableSwipeToOpen: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
   * clicking on a menu item will not close the `Drawer`.
   */
  docked: _propTypes2.default.bool,
  /**
   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
   *
   * @param {boolean} open If true, the `Drawer` was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
   * 'escape' (on escape key press), and 'swipe' for close requests.
   */
  onRequestChange: _propTypes2.default.func,
  /**
   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
   * into a controlled component.
   */
  open: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` is positioned to open from the opposite side.
   */
  openSecondary: _propTypes2.default.bool,
  /**
   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The width of the left most (or right most) area in pixels where the `Drawer` can be
   * swiped open from. Setting this to `null` spans that area to the entire page
   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
   * swipeable `Tabs`: use at your own risk).
   */
  swipeAreaWidth: _propTypes2.default.number,
  /**
   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
   * half of the window or `100%` and so on. Defaults to using the values from theme.
   */
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * The zDepth of the `Drawer`.
   */
  zDepth: _propTypes4.default.zDepth

} : {};
exports.default = Drawer;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _Card = __webpack_require__(630);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _colors = __webpack_require__(106);

var _BasemapList = __webpack_require__(995);

var _BasemapList2 = _interopRequireDefault(_BasemapList);

var _OpacitySlider = __webpack_require__(632);

var _OpacitySlider2 = _interopRequireDefault(_OpacitySlider);

var _basemap = __webpack_require__(586);

__webpack_require__(1004);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    container: {
        paddingBottom: 0
    },
    headerText: {
        position: 'relative',
        width: 210,
        top: '50%',
        transform: 'translateY(-50%)',
        paddingRight: 0
    },
    visibility: {
        width: 56,
        height: 56,
        padding: 8,
        position: 'absolute',
        right: 32,
        top: 0
    },
    body: {
        padding: 0
    }
};

// Basemap card shown in left layers panel
var BasemapCard = function BasemapCard(props) {
    var name = props.name,
        subtitle = props.subtitle,
        opacity = props.opacity,
        isExpanded = props.isExpanded,
        isVisible = props.isVisible,
        toggleBasemapExpand = props.toggleBasemapExpand,
        toggleBasemapVisibility = props.toggleBasemapVisibility,
        changeBasemapOpacity = props.changeBasemapOpacity;


    return _react2.default.createElement(
        _Card.Card,
        {
            className: 'BasemapCard',
            containerStyle: styles.container,
            expanded: isExpanded,
            onExpandChange: toggleBasemapExpand
        },
        _react2.default.createElement(
            _Card.CardHeader,
            {
                className: 'BasemapCard-header',
                title: name,
                subtitle: subtitle,
                showExpandableButton: true,
                textStyle: styles.headerText
            },
            _react2.default.createElement(
                _IconButton2.default,
                {
                    style: styles.visibility,
                    onClick: toggleBasemapVisibility,
                    tooltip: 'Toggle visibility'
                },
                _react2.default.createElement(_SvgIcon2.default, {
                    icon: isVisible ? 'Visibility' : 'VisibilityOff',
                    color: _colors.grey600
                })
            )
        ),
        _react2.default.createElement(
            _Card.CardText,
            { expandable: true, style: styles.body },
            _react2.default.createElement(_BasemapList2.default, props),
            _react2.default.createElement(
                'div',
                { className: 'BasemapCard-toolbar' },
                _react2.default.createElement(_OpacitySlider2.default, {
                    opacity: opacity,
                    onChange: function onChange(opacity) {
                        return changeBasemapOpacity(opacity);
                    }
                })
            )
        )
    );
};

BasemapCard.propTypes = {
    opacity: _propTypes2.default.number,
    isVisible: _propTypes2.default.bool,
    isExpanded: _propTypes2.default.bool,
    toggleBasemapExpand: _propTypes2.default.func,
    toggleBasemapVisibility: _propTypes2.default.func,
    changeBasemapOpacity: _propTypes2.default.func
};

BasemapCard.defaultProps = {
    opacity: 1,
    isVisible: true,
    isExpanded: true
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        basemap: state.map.basemap, // Selected basemap
        basemaps: state.basemaps // All basemaps
    };
}, {
    changeBasemapOpacity: _basemap.changeBasemapOpacity,
    toggleBasemapExpand: _basemap.toggleBasemapExpand,
    toggleBasemapVisibility: _basemap.toggleBasemapVisibility,
    selectBasemap: _basemap.selectBasemap
})(BasemapCard);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _CardExpandable = __webpack_require__(631);

var _CardExpandable2 = _interopRequireDefault(_CardExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function (_Component) {
  (0, _inherits3.default)(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: null
    }, _this.handleExpanding = function (event) {
      event.preventDefault();
      var newExpandedState = !_this.state.expanded;
      // no automatic state update when the component is controlled
      if (_this.props.expanded === null) {
        _this.setState({ expanded: newExpandedState });
      }
      if (_this.props.onExpandChange) {
        _this.props.onExpandChange(newExpandedState);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Card, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          containerStyle = _props.containerStyle,
          children = _props.children,
          expandable = _props.expandable,
          expandedProp = _props.expanded,
          initiallyExpanded = _props.initiallyExpanded,
          onExpandChange = _props.onExpandChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);


      var lastElement = void 0;
      var expanded = this.state.expanded;
      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        var doClone = false;
        var newChild = undefined;
        var newProps = {};
        var element = currentChild;
        if (!currentChild || !currentChild.props) {
          return null;
        }
        if (expanded === false && currentChild.props.expandable === true) return;
        if (currentChild.props.actAsExpander === true) {
          doClone = true;
          newProps.onClick = _this2.handleExpanding;
          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
        }
        if (currentChild.props.showExpandableButton === true) {
          doClone = true;
          newChild = _react2.default.createElement(_CardExpandable2.default, {
            closeIcon: currentChild.props.closeIcon,
            expanded: expanded,
            onExpanding: _this2.handleExpanding,
            openIcon: currentChild.props.openIcon,
            iconStyle: currentChild.props.iconStyle
          });
        }
        if (doClone) {
          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
        }
        lastElement = element;
        return element;
      }, this);

      // If the last element is text or a title we should add
      // 8px padding to the bottom of the card
      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');

      var mergedStyles = (0, _simpleAssign2.default)({
        zIndex: 1
      }, style);
      var containerMergedStyles = (0, _simpleAssign2.default)({
        paddingBottom: addBottomPadding ? 8 : 0
      }, containerStyle);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, { style: mergedStyles }),
        _react2.default.createElement(
          'div',
          { style: containerMergedStyles },
          newChildren
        )
      );
    }
  }]);
  return Card;
}(_react.Component);

Card.defaultProps = {
  expandable: false,
  expanded: null,
  initiallyExpanded: false
};
Card.propTypes =  false ? {
  /**
   * Can be used to render elements inside the Card.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, this card component is expandable. Can be set on any child of the `Card` component.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Whether this card is expanded.
   * If `true` or `false` the component is controlled.
   * if `null` the component is uncontrolled.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Whether this card is initially expanded.
   */
  initiallyExpanded: _propTypes2.default.bool,
  /**
   * Callback function fired when the `expandable` state of the card has changed.
   *
   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
   */
  onExpandChange: _propTypes2.default.func,
  /**
   * If true, this card component will include a button to expand the card. `CardTitle`,
   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
   * of `Card` can implements `showExpandableButton` or forwards the property to a child
   * component supporting it.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Card;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
  );
};
HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
HardwareKeyboardArrowUp.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
  );
};
HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
HardwareKeyboardArrowDown.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Avatar = __webpack_require__(989);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      fontWeight: card.fontWeight,
      boxSizing: 'border-box',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    text: {
      display: 'inline-block',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      paddingRight: '90px'
    },
    avatar: {
      marginRight: 16
    },
    title: {
      color: props.titleColor || card.titleColor,
      display: 'block',
      fontSize: 15
    },
    subtitle: {
      color: props.subtitleColor || card.subtitleColor,
      display: 'block',
      fontSize: 14
    }
  };
}

var CardHeader = function (_Component) {
  (0, _inherits3.default)(CardHeader, _Component);

  function CardHeader() {
    (0, _classCallCheck3.default)(this, CardHeader);
    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          avatarProp = _props.avatar,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          openIcon = _props.openIcon,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          textStyle = _props.textStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var avatar = avatarProp;

      if ((0, _react.isValidElement)(avatarProp)) {
        avatar = _react2.default.cloneElement(avatar, {
          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
        });
      } else if (avatar !== null) {
        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        avatar,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
            title
          ),
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
            subtitle
          )
        ),
        children
      );
    }
  }]);
  return CardHeader;
}(_react.Component);

CardHeader.muiName = 'CardHeader';
CardHeader.defaultProps = {
  avatar: null
};
CardHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardHeader.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
   * If `avatar` is an `Avatar` or other element, it will be rendered.
   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
   */
  avatar: _propTypes2.default.node,
  /**
   * Can be used to render elements inside the Card Header.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the iconStyle of the Icon Button.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
   */
  openIcon: _propTypes2.default.node,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in Card Header.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the text.
   */
  textStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in Card Header.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardHeader;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = __webpack_require__(990);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var backgroundColor = props.backgroundColor,
      color = props.color,
      size = props.size;
  var avatar = context.muiTheme.avatar;


  var styles = {
    root: {
      color: color || avatar.color,
      backgroundColor: backgroundColor || avatar.backgroundColor,
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size / 2,
      borderRadius: '50%',
      height: size,
      width: size
    },
    icon: {
      color: color || avatar.color,
      width: size * 0.6,
      height: size * 0.6,
      fontSize: size * 0.6,
      margin: size * 0.2
    }
  };

  return styles;
}

var Avatar = function (_Component) {
  (0, _inherits3.default)(Avatar, _Component);

  function Avatar() {
    (0, _classCallCheck3.default)(this, Avatar);
    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          icon = _props.icon,
          src = _props.src,
          style = _props.style,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      if (src) {
        return _react2.default.createElement('img', (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other, {
          src: src,
          className: className
        }));
      } else {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, {
            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
            className: className
          }),
          icon && _react2.default.cloneElement(icon, {
            color: styles.icon.color,
            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
          }),
          this.props.children
        );
      }
    }
  }]);
  return Avatar;
}(_react.Component);

Avatar.muiName = 'Avatar';
Avatar.defaultProps = {
  size: 40
};
Avatar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Avatar.propTypes =  false ? {
  /**
   * The backgroundColor of the avatar. Does not apply to image avatars.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root `div` or `img` element.
   */
  className: _propTypes2.default.string,
  /**
   * The icon or letter's color.
   */
  color: _propTypes2.default.string,
  /**
   * This is the SvgIcon or FontIcon to be used inside the avatar.
   */
  icon: _propTypes2.default.element,
  /**
   * This is the size of the avatar in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
   */
  src: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Avatar;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      position: 'relative'
    },
    title: {
      fontSize: 24,
      color: props.titleColor || card.titleColor,
      display: 'block',
      lineHeight: '36px'
    },
    subtitle: {
      fontSize: 14,
      color: props.subtitleColor || card.subtitleColor,
      display: 'block'
    }
  };
}

var CardTitle = function (_Component) {
  (0, _inherits3.default)(CardTitle, _Component);

  function CardTitle() {
    (0, _classCallCheck3.default)(this, CardTitle);
    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedTitleStyle) },
          title
        ),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedSubtitleStyle) },
          subtitle
        ),
        children
      );
    }
  }]);
  return CardTitle;
}(_react.Component);

CardTitle.muiName = 'CardTitle';
CardTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardTitle.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Title.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in the Card Title.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in the Card Title.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardTitle;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardMedia = context.muiTheme.cardMedia;


  return {
    root: {
      position: 'relative'
    },
    overlayContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    overlay: {
      height: '100%',
      position: 'relative'
    },
    overlayContent: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      paddingTop: 8,
      background: cardMedia.overlayContentBackground
    },
    media: {},
    mediaChild: {
      verticalAlign: 'top',
      maxWidth: '100%',
      minWidth: '100%',
      width: '100%'
    }
  };
}

var CardMedia = function (_Component) {
  (0, _inherits3.default)(CardMedia, _Component);

  function CardMedia() {
    (0, _classCallCheck3.default)(this, CardMedia);
    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          mediaStyle = _props.mediaStyle,
          overlay = _props.overlay,
          overlayContainerStyle = _props.overlayContainerStyle,
          overlayContentStyle = _props.overlayContentStyle,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      var titleColor = this.context.muiTheme.cardMedia.titleColor;
      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
      var color = this.context.muiTheme.cardMedia.color;

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (!child) {
          return child;
        }

        return _react2.default.cloneElement(child, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
        });
      });

      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
        var childMuiName = child && child.type ? child.type.muiName : null;

        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
          return _react2.default.cloneElement(child, {
            titleColor: titleColor,
            subtitleColor: subtitleColor
          });
        } else if (childMuiName === 'CardText') {
          return _react2.default.cloneElement(child, {
            color: color
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedMediaStyle) },
          styledChildren
        ),
        overlay ? _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedOverlayContainerStyle) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(extendedOverlayStyle) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles(extendedOverlayContentStyle) },
              overlayChildren
            )
          )
        ) : ''
      );
    }
  }]);
  return CardMedia;
}(_react.Component);

CardMedia.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardMedia.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Media.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the Card Media.
   */
  mediaStyle: _propTypes2.default.object,
  /**
   * Can be used to render overlay element in Card Media.
   */
  overlay: _propTypes2.default.node,
  /**
   * Override the inline-styles of the overlay container.
   */
  overlayContainerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay content.
   */
  overlayContentStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay element.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardMedia;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardText = context.muiTheme.cardText;


  return {
    root: {
      padding: 16,
      fontSize: 14,
      color: props.color || cardText.textColor
    }
  };
}

var CardText = function (_Component) {
  (0, _inherits3.default)(CardText, _Component);

  function CardText() {
    (0, _classCallCheck3.default)(this, CardText);
    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          color = _props.color,
          expandable = _props.expandable,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        children
      );
    }
  }]);
  return CardText;
}(_react.Component);

CardText.muiName = 'CardText';
CardText.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardText.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Text.
   */
  children: _propTypes2.default.node,
  /**
   * Override the CardText color.
   */
  color: _propTypes2.default.string,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardText;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      padding: 8,
      position: 'relative'
    },
    action: {
      marginRight: 8
    }
  };
}

var CardActions = function (_Component) {
  (0, _inherits3.default)(CardActions, _Component);

  function CardActions() {
    (0, _classCallCheck3.default)(this, CardActions);
    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        styledChildren
      );
    }
  }]);
  return CardActions;
}(_react.Component);

CardActions.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardActions.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Action.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardActions;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Basemap = __webpack_require__(996);

var _Basemap2 = _interopRequireDefault(_Basemap);

__webpack_require__(999);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasemapList = function BasemapList(_ref) {
    var id = _ref.id,
        basemaps = _ref.basemaps,
        selectBasemap = _ref.selectBasemap;
    return _react2.default.createElement(
        'div',
        { className: 'BasemapList' },
        basemaps.map(function (basemap, index) {
            return _react2.default.createElement(_Basemap2.default, _extends({
                key: 'basemap-' + index,
                onClick: selectBasemap,
                isSelected: basemap.id === id
            }, basemap));
        })
    );
};

BasemapList.propTypes = {
    id: _propTypes2.default.string.isRequired,
    basemaps: _propTypes2.default.array.isRequired,
    selectBasemap: _propTypes2.default.func.isRequired
};

exports.default = BasemapList;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(997);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Basemap = function Basemap(_ref) {
    var id = _ref.id,
        img = _ref.img,
        name = _ref.name,
        isSelected = _ref.isSelected,
        _onClick = _ref.onClick;

    var borderStyle = {
        outline: isSelected ? '3px solid orange' : '1px solid #999'
    };

    return _react2.default.createElement(
        'div',
        { className: 'Basemap', title: name, onClick: function onClick() {
                return _onClick(id);
            } },
        _react2.default.createElement(
            'div',
            { className: 'Basemap-image-container', style: borderStyle },
            img ? _react2.default.createElement('img', { src: img, className: 'Basemap-image' }) : _react2.default.createElement(
                'div',
                { className: 'Basemap-no-image' },
                'External basemap'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'Basemap-name' },
            name
        )
    );
};

Basemap.propTypes = {
    id: _propTypes2.default.string.isRequired,
    img: _propTypes2.default.string,
    title: _propTypes2.default.string.isRequired,
    isSelected: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

Basemap.defaultProps = {
    title: ''
};

exports.default = Basemap;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(998);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./Basemap.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./Basemap.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".Basemap {\n    float: left;\n    width: 120px;\n    margin-left: 12px;\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 90px;\n}\n\n.Basemap-image-container {\n    position: relative;\n    height: 56px;\n    width: 100%;\n    margin-top: 4px;\n    overflow: hidden;\n}\n\n.Basemap-image {\n    position: absolute;\n    clip: rect(64px, 256px, 192px, 0);\n    width: 100%;\n    top: -64px;\n}\n\n.Basemap-no-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    line-height: 56px;\n}\n\n.Basemap-name {\n    font-size: 12px;\n    color: #333;\n    padding-top: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1000);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./BasemapList.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./BasemapList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".BasemapList {\n    max-height: 270px;\n    overflow-y: auto;\n    overflow-y: overlay;\n    margin-left: 7px;\n}\n\n\n\n", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Slider = __webpack_require__(1002);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Slider2.default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(1003);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(528);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Verifies min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if min >= max otherwise null.
 */
var minMaxPropType = function minMaxPropType(props, propName, componentName) {
  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
  if (error !== null) {
    return error;
  }

  if (props.min >= props.max) {
    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
    return new Error(errorMsg);
  }
};

/**
 * Verifies value is within the min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
 */
var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
  if (error !== null) {
    return error;
  }

  var value = props[propName];
  if (value < props.min || props.max < value) {
    return new Error(propName + ' should be within the range specified by min and max');
  }
};

var crossAxisProperty = {
  x: 'height',
  'x-reverse': 'height',
  y: 'width',
  'y-reverse': 'width'
};

var crossAxisOffsetProperty = {
  x: 'top',
  'x-reverse': 'top',
  y: 'left',
  'y-reverse': 'left'
};

var mainAxisProperty = {
  x: 'width',
  'x-reverse': 'width',
  y: 'height',
  'y-reverse': 'height'
};

var mainAxisMarginFromEnd = {
  x: 'marginRight',
  'x-reverse': 'marginLeft',
  y: 'marginTop',
  'y-reverse': 'marginBottom'
};

var mainAxisMarginFromStart = {
  x: 'marginLeft',
  'x-reverse': 'marginRight',
  y: 'marginBottom',
  'y-reverse': 'marginTop'
};

var mainAxisOffsetProperty = {
  x: 'left',
  'x-reverse': 'right',
  y: 'bottom',
  'y-reverse': 'top'
};

var mainAxisClientProperty = {
  x: 'clientWidth',
  'x-reverse': 'clientWidth',
  y: 'clientHeight',
  'y-reverse': 'clientHeight'
};

var mainAxisClientOffsetProperty = {
  x: 'clientX',
  'x-reverse': 'clientX',
  y: 'clientY',
  'y-reverse': 'clientY'
};

var reverseMainAxisOffsetProperty = {
  x: 'right',
  'x-reverse': 'left',
  y: 'top',
  'y-reverse': 'bottom'
};

var isMouseControlInverted = function isMouseControlInverted(axis) {
  return axis === 'x-reverse' || axis === 'y';
};

var calculateAxis = function calculateAxis(axis, isRtl) {
  if (isRtl) {
    switch (axis) {
      case 'x':
        return 'x-reverse';
      case 'x-reverse':
        return 'x';
    }
  }
  return axis;
};

function getPercent(value, min, max) {
  var percent = (value - min) / (max - min);
  if (isNaN(percent)) {
    percent = 0;
  }

  return percent;
}

var getStyles = function getStyles(props, context, state) {
  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;

  var axis = props.axis,
      disabled = props.disabled,
      max = props.max,
      min = props.min;
  var _context$muiTheme = context.muiTheme,
      isRtl = _context$muiTheme.isRtl,
      _context$muiTheme$sli = _context$muiTheme.slider,
      handleColorZero = _context$muiTheme$sli.handleColorZero,
      handleFillColor = _context$muiTheme$sli.handleFillColor,
      handleSize = _context$muiTheme$sli.handleSize,
      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
      trackSize = _context$muiTheme$sli.trackSize,
      trackColor = _context$muiTheme$sli.trackColor,
      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
      rippleColor = _context$muiTheme$sli.rippleColor,
      selectionColor = _context$muiTheme$sli.selectionColor;


  var fillGutter = handleSize / 2;
  var disabledGutter = trackSize + handleSizeDisabled / 2;
  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
  var percent = getPercent(state.value, min, max);
  var calculatedAxis = calculateAxis(axis, isRtl);

  var styles = {
    slider: (_slider = {
      touchCallout: 'none',
      userSelect: 'none',
      cursor: 'default'
    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[calculatedAxis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
    track: (_track = {
      position: 'absolute'
    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[calculatedAxis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[calculatedAxis], trackSize), _track),
    filledAndRemaining: (_filledAndRemaining = {
      directionInvariant: true,
      position: 'absolute'
    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
    handle: (_handle = {
      directionInvariant: true,
      boxSizing: 'border-box',
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'inherit'
    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[calculatedAxis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
      x: trackSize / 2 + 'px 0 0 0',
      'x-reverse': trackSize / 2 + 'px 0 0 0',
      y: '0 0 0 ' + trackSize / 2 + 'px',
      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
      x: 'translate(-50%, -50%)',
      'x-reverse': 'translate(50%, -50%)',
      y: 'translate(-50%, 50%)',
      'y-reverse': 'translate(-50%, -50%)'
    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
    handleWhenDisabled: {
      boxSizing: 'content-box',
      cursor: 'not-allowed',
      backgroundColor: trackColor,
      width: handleSizeDisabled,
      height: handleSizeDisabled,
      border: 'none'
    },
    handleWhenPercentZero: {
      border: trackSize + 'px solid ' + handleColorZero,
      backgroundColor: handleFillColor,
      boxShadow: 'none'
    },
    handleWhenPercentZeroAndDisabled: {
      cursor: 'not-allowed',
      width: handleSizeDisabled,
      height: handleSizeDisabled
    },
    handleWhenPercentZeroAndFocused: {
      border: trackSize + 'px solid ' + trackColorSelected
    },
    handleWhenActive: {
      width: handleSizeActive,
      height: handleSizeActive
    },
    ripple: {
      height: handleSize,
      width: handleSize,
      overflow: 'visible'
    },
    rippleWhenPercentZero: {
      top: -trackSize,
      left: -trackSize
    },
    rippleInner: {
      height: '300%',
      width: '300%',
      top: -handleSize,
      left: -handleSize
    },
    rippleColor: {
      fill: percent === 0 ? handleColorZero : rippleColor
    }
  };
  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[calculatedAxis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[calculatedAxis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));

  return styles;
};

var Slider = function (_Component) {
  (0, _inherits3.default)(Slider, _Component);

  function Slider() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Slider);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: false,
      dragging: false,
      focused: false,
      hovered: false,
      value: 0
    }, _this.track = null, _this.handle = null, _this.resolveValue = function (value, min, max) {
      if (value > max) {
        return max;
      }

      if (value < min) {
        return min;
      }

      return value;
    }, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          axis = _this$props.axis,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step;
      var isRtl = _this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);

      var action = void 0;

      switch ((0, _keycode2.default)(event)) {
        case 'page down':
        case 'down':
          if (calculatedAxis === 'y-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'left':
          if (calculatedAxis === 'x-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'page up':
        case 'up':
          if (calculatedAxis === 'y-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'right':
          if (calculatedAxis === 'x-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'home':
          action = 'min';
          break;
        case 'end':
          action = 'max';
          break;
      }

      if (action) {
        var newValue = void 0;

        // Cancel scroll
        event.preventDefault();

        switch (action) {
          case 'decrease':
            newValue = _this.state.value - step;
            break;
          case 'increase':
            newValue = _this.state.value + step;
            break;
          case 'min':
            newValue = min;
            break;
          case 'max':
            newValue = max;
            break;
        }

        // We need to use toFixed() because of float point errors.
        // For example, 0.01 + 0.06 = 0.06999999999999999
        newValue = _this.resolveValue(parseFloat(newValue.toFixed(5)), min, max);

        if (_this.state.value !== newValue) {
          _this.setState({
            value: newValue
          });

          if (_this.props.onChange) {
            _this.props.onChange(event, newValue);
          }
        }
      }
    }, _this.handleDragMouseMove = function (event) {
      _this.onDragUpdate(event, 'mouse');
    }, _this.handleTouchMove = function (event) {
      _this.onDragUpdate(event, 'touch');
    }, _this.handleMouseEnd = function (event) {
      document.removeEventListener('mousemove', _this.handleDragMouseMove);
      document.removeEventListener('mouseup', _this.handleMouseEnd);

      _this.onDragStop(event);
    }, _this.handleTouchEnd = function (event) {
      document.removeEventListener('touchmove', _this.handleTouchMove);
      document.removeEventListener('touchup', _this.handleTouchEnd);
      document.removeEventListener('touchend', _this.handleTouchEnd);
      document.removeEventListener('touchcancel', _this.handleTouchEnd);

      _this.onDragStop(event);
    }, _this.handleTouchStart = function (event) {
      var _this$props2 = _this.props,
          axis = _this$props2.axis,
          disabled = _this$props2.disabled;
      var isRtl = _this.context.muiTheme.isRtl;


      if (disabled) {
        return;
      }

      var calculatedAxis = calculateAxis(axis, isRtl);

      var position = void 0;
      if (isMouseControlInverted(calculatedAxis)) {
        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]];
      } else {
        position = event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
      }
      _this.setValueFromPosition(event, position);

      document.addEventListener('touchmove', _this.handleTouchMove);
      document.addEventListener('touchup', _this.handleTouchEnd);
      document.addEventListener('touchend', _this.handleTouchEnd);
      document.addEventListener('touchcancel', _this.handleTouchEnd);

      _this.onDragStart(event);

      // Cancel scroll and context menu
      event.preventDefault();
    }, _this.handleFocus = function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function (event) {
      _this.setState({
        focused: false,
        active: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleMouseDown = function (event) {
      var _this$props3 = _this.props,
          axis = _this$props3.axis,
          disabled = _this$props3.disabled;
      var isRtl = _this.context.muiTheme.isRtl;


      if (disabled) {
        return;
      }

      var calculatedAxis = calculateAxis(axis, isRtl);

      var position = void 0;
      if (isMouseControlInverted(calculatedAxis)) {
        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[calculatedAxis]];
      } else {
        position = event[mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
      }
      _this.setValueFromPosition(event, position);

      document.addEventListener('mousemove', _this.handleDragMouseMove);
      document.addEventListener('mouseup', _this.handleMouseEnd);

      // Cancel text selection
      event.preventDefault();

      // Set focus manually since we called preventDefault()
      _this.handle.focus();

      _this.onDragStart(event);
    }, _this.handleMouseUp = function () {
      if (!_this.props.disabled) {
        _this.setState({
          active: false
        });
      }
    }, _this.handleMouseEnter = function () {
      _this.setState({
        hovered: true
      });
    }, _this.handleMouseLeave = function () {
      _this.setState({
        hovered: false
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Slider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          min = _props.min,
          max = _props.max;
      var value = this.props.value;


      if (value === undefined) {
        value = defaultValue !== undefined ? defaultValue : min;
      }

      this.setState({
        value: this.resolveValue(value, min, max)
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined && !this.state.dragging) {
        var _nextProps$min = nextProps.min,
            min = _nextProps$min === undefined ? this.props.min : _nextProps$min,
            _nextProps$max = nextProps.max,
            max = _nextProps$max === undefined ? this.props.max : _nextProps$max;


        this.setState({
          value: this.resolveValue(nextProps.value, min, max)
        });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;

      return this.state.value;
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;

      this.setState({
        value: this.props.min
      });
    }
  }, {
    key: 'getTrackOffset',
    value: function getTrackOffset() {
      var axis = this.props.axis;
      var isRtl = this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);

      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[calculatedAxis]];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(event) {
      this.setState({
        dragging: true,
        active: true
      });

      if (this.props.onDragStart) {
        this.props.onDragStart(event);
      }
    }
  }, {
    key: 'onDragUpdate',
    value: function onDragUpdate(event, type) {
      var _this2 = this;

      var _props2 = this.props,
          axis = _props2.axis,
          disabled = _props2.disabled;
      var isRtl = this.context.muiTheme.isRtl;


      if (this.dragRunning) {
        return;
      }
      this.dragRunning = true;

      requestAnimationFrame(function () {
        _this2.dragRunning = false;

        var calculatedAxis = calculateAxis(axis, isRtl);
        var source = type === 'touch' ? event.touches[0] : event;

        var position = void 0;
        if (isMouseControlInverted(calculatedAxis)) {
          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[calculatedAxis]];
        } else {
          position = source[mainAxisClientOffsetProperty[calculatedAxis]] - _this2.getTrackOffset();
        }

        if (!disabled) {
          _this2.setValueFromPosition(event, position);
        }
      });
    }
  }, {
    key: 'onDragStop',
    value: function onDragStop(event) {
      this.setState({
        dragging: false,
        active: false
      });

      if (this.props.onDragStop) {
        this.props.onDragStop(event);
      }
    }
  }, {
    key: 'setValueFromPosition',
    value: function setValueFromPosition(event, position) {
      var _props3 = this.props,
          axis = _props3.axis,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;
      var isRtl = this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);
      var positionMax = this.track[mainAxisClientProperty[calculatedAxis]];

      var value = void 0;

      if (position <= 0) {
        value = min;
      } else if (position >= positionMax) {
        value = max;
      } else {
        value = position / positionMax * (max - min);
        value = Math.round(value / step) * step + min;
        value = parseFloat(value.toFixed(5));
      }

      value = this.resolveValue(value, min, max);

      if (this.state.value !== value) {
        this.setState({
          value: value
        });

        if (this.props.onChange) {
          this.props.onChange(event, value);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          axis = _props4.axis,
          disabled = _props4.disabled,
          disableFocusRipple = _props4.disableFocusRipple,
          max = _props4.max,
          min = _props4.min,
          name = _props4.name,
          onBlur = _props4.onBlur,
          onChange = _props4.onChange,
          onDragStart = _props4.onDragStart,
          onDragStop = _props4.onDragStop,
          onFocus = _props4.onFocus,
          required = _props4.required,
          sliderStyle = _props4.sliderStyle,
          step = _props4.step,
          style = _props4.style,
          propValue = _props4.value,
          other = (0, _objectWithoutProperties3.default)(_props4, ['axis', 'disabled', 'disableFocusRipple', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style', 'value']);
      var _state = this.state,
          active = _state.active,
          focused = _state.focused,
          hovered = _state.hovered,
          value = _state.value;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var percent = getPercent(value, min, max);

      var handleStyles = {};
      if (percent === 0) {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
      } else {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
      }

      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMouseDown: this.handleMouseDown,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseUp: this.handleMouseUp,
            onTouchStart: this.handleTouchStart,
            onKeyDown: !disabled ? this.handleKeyDown : undefined
          },
          _react2.default.createElement(
            'div',
            { ref: function ref(node) {
                return _this3.track = node;
              }, style: prepareStyles(styles.track) },
            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
            _react2.default.createElement(
              'div',
              {
                ref: function ref(node) {
                  return _this3.handle = node;
                },
                style: prepareStyles(handleStyles),
                tabIndex: 0
              },
              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
                style: rippleStyle,
                innerStyle: styles.rippleInner,
                show: (hovered || focused) && !active,
                color: styles.rippleColor.fill
              })
            )
          )
        ),
        _react2.default.createElement('input', {
          type: 'hidden',
          name: name,
          value: value,
          required: required,
          min: min,
          max: max,
          step: step
        })
      );
    }
  }]);
  return Slider;
}(_react.Component);

Slider.defaultProps = {
  axis: 'x',
  disabled: false,
  disableFocusRipple: false,
  max: 1,
  min: 0,
  required: true,
  step: 0.01,
  style: {}
};
Slider.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Slider.propTypes =  false ? {
  /**
   * The axis on which the slider will slide.
   */
  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * The default value of the slider.
   */
  defaultValue: valueInRangePropType,
  /**
   * Disables focus ripple if set to true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * If true, the slider will not be interactable.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The maximum value the slider can slide to on
   * a scale from 0 to 1 inclusive. Cannot be equal to min.
   */
  max: minMaxPropType,
  /**
   * The minimum value the slider can slide to on a scale
   * from 0 to 1 inclusive. Cannot be equal to max.
   */
  min: minMaxPropType,
  /**
   * The name of the slider. Behaves like the name attribute
   * of an input element.
   */
  name: _propTypes2.default.string,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event KeyDown event targeting the slider.
   * @param {number} newValue The new value of the slider.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slider has begun to move.
   *
   * @param {object} event MouseDown or TouchStart event targeting the slider.
   */
  onDragStart: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slide has stopped moving.
   *
   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
   */
  onDragStop: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Whether or not the slider is required in a form.
   */
  required: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner slider element.
   */
  sliderStyle: _propTypes2.default.object,
  /**
   * The granularity the slider can step through values.
   */
  step: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The value of the slider.
   */
  value: valueInRangePropType
} : {};
exports.default = Slider;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(511);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1005);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./BasemapCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./BasemapCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".BasemapCard {\n    clear: both;\n    z-index: 1010;\n    margin: 8px 4px 8px 4px;\n}\n\n.BasemapCard-header {\n    height: 56px;\n    padding-left: 14px;\n    padding-right: 8px;\n    margin-right: -8px;\n    font-size: 10px;\n}\n\n.BasemapCard-header span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n.BasemapCard-toolbar {\n    background-color: #eee;\n    height: 32px;\n    padding-left: 7px;\n}", ""]);

// exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Card = __webpack_require__(630);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _colors = __webpack_require__(106);

var _SortableHandle = __webpack_require__(1007);

var _SortableHandle2 = _interopRequireDefault(_SortableHandle);

var _LayerToolbar = __webpack_require__(1008);

var _LayerToolbar2 = _interopRequireDefault(_LayerToolbar);

var _Legend = __webpack_require__(1016);

var _Legend2 = _interopRequireDefault(_Legend);

var _layers = __webpack_require__(101);

var _message = __webpack_require__(498);

var _dataTable = __webpack_require__(271);

__webpack_require__(1018);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    container: {
        paddingBottom: 0
    },
    headerText: {
        position: 'relative',
        width: 195,
        top: '50%',
        left: 16,
        transform: 'translateY(-50%)',
        paddingRight: 0
    },
    visibility: {
        width: 56,
        height: 56,
        padding: 8,
        position: 'absolute',
        right: 32,
        top: 0
    },
    body: {
        padding: 0
    }
};

var LayerCard = function LayerCard(props) {
    var layer = props.layer,
        editLayer = props.editLayer,
        removeLayer = props.removeLayer,
        changeLayerOpacity = props.changeLayerOpacity,
        toggleLayerExpand = props.toggleLayerExpand,
        toggleLayerVisibility = props.toggleLayerVisibility,
        toggleDataTable = props.toggleDataTable,
        setMessage = props.setMessage;
    var id = layer.id,
        name = layer.name,
        legend = layer.legend,
        isExpanded = layer.isExpanded,
        isVisible = layer.isVisible;


    return _react2.default.createElement(
        _Card.Card,
        {
            className: 'LayerCard',
            containerStyle: styles.container,
            expanded: isExpanded,
            onExpandChange: function onExpandChange() {
                return toggleLayerExpand(id);
            }
        },
        _react2.default.createElement(
            _Card.CardHeader,
            {
                className: 'LayerCard-header',
                title: name,
                subtitle: legend && legend.period ? legend.period : null,
                showExpandableButton: true,
                textStyle: styles.headerText
            },
            _react2.default.createElement(_SortableHandle2.default, { color: _colors.grey600 }),
            _react2.default.createElement(
                _IconButton2.default,
                {
                    style: styles.visibility,
                    onClick: function onClick() {
                        return toggleLayerVisibility(id);
                    },
                    tooltip: _i18next2.default.t('Toggle visibility')
                },
                _react2.default.createElement(_SvgIcon2.default, {
                    icon: isVisible ? 'Visibility' : 'VisibilityOff',
                    color: _colors.grey600
                })
            )
        ),
        _react2.default.createElement(
            _Card.CardText,
            { expandable: true, style: styles.body },
            legend && _react2.default.createElement(_Legend2.default, legend),
            _react2.default.createElement(_LayerToolbar2.default, {
                layer: layer,
                onEdit: function onEdit() {
                    return editLayer(layer);
                },
                toggleDataTable: toggleDataTable,
                onOpacityChange: changeLayerOpacity,
                onRemove: function onRemove() {
                    removeLayer(id);
                    setMessage(name + ' ' + _i18next2.default.t('deleted') + '.');
                }
            })
        )
    );
};

LayerCard.propTypes = {
    layer: _propTypes2.default.object,
    editLayer: _propTypes2.default.func.isRequired,
    removeLayer: _propTypes2.default.func.isRequired,
    changeLayerOpacity: _propTypes2.default.func.isRequired,
    toggleLayerExpand: _propTypes2.default.func.isRequired,
    toggleLayerVisibility: _propTypes2.default.func.isRequired,
    toggleDataTable: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
    editLayer: _layers.editLayer,
    removeLayer: _layers.removeLayer,
    changeLayerOpacity: _layers.changeLayerOpacity,
    toggleLayerExpand: _layers.toggleLayerExpand,
    toggleLayerVisibility: _layers.toggleLayerVisibility,
    toggleDataTable: _dataTable.toggleDataTable,
    setMessage: _message.setMessage
})(LayerCard);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSortableHoc = __webpack_require__(448);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    width: 24,
    height: 24,
    position: 'absolute',
    left: 6,
    top: 16,
    cursor: 'ns-resize'
};

var Handle = function Handle(_ref) {
    var color = _ref.color;
    return _react2.default.createElement(
        'svg',
        { style: styles, viewBox: '0 0 24 24' },
        _react2.default.createElement('path', {
            fill: color,
            d: 'M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z'
        })
    );
};

Handle.propTypes = {
    color: _propTypes2.default.string
};

Handle.defaultProps = {
    color: '#757575'
};

exports.default = (0, _reactSortableHoc.SortableHandle)(Handle);

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Toolbar = __webpack_require__(623);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _IconMenu = __webpack_require__(1009);

var _IconMenu2 = _interopRequireDefault(_IconMenu);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _OpacitySlider = __webpack_require__(632);

var _OpacitySlider2 = _interopRequireDefault(_OpacitySlider);

var _DownloadMenu = __webpack_require__(1011);

var _DownloadMenu2 = _interopRequireDefault(_DownloadMenu);

var _OpenAsMenu = __webpack_require__(1015);

var _OpenAsMenu2 = _interopRequireDefault(_OpenAsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    toolbar: {
        backgroundColor: '#eee',
        height: 32,
        padding: '0 8px'
    },
    button: {
        float: 'left',
        padding: 4,
        width: 32,
        height: 32
    },
    moreButton: {
        float: 'right',
        padding: 4,
        width: 32,
        height: 32,
        marginRight: -7,
        marginLeft: -5
    },
    menuList: {
        paddingTop: 0,
        paddingBottom: 0
    }
};

var OverlayToolbar = function OverlayToolbar(_ref) {
    var layer = _ref.layer,
        onEdit = _ref.onEdit,
        onRemove = _ref.onRemove,
        toggleDataTable = _ref.toggleDataTable,
        onOpacityChange = _ref.onOpacityChange;
    return _react2.default.createElement(
        _Toolbar.Toolbar,
        { style: styles.toolbar },
        _react2.default.createElement(
            _Toolbar.ToolbarGroup,
            null,
            onEdit && layer.type !== 'external' && _react2.default.createElement(
                _IconButton2.default,
                {
                    onClick: function onClick() {
                        return onEdit(layer);
                    },
                    tooltip: 'Edit',
                    tooltipPosition: 'top-center',
                    style: styles.button
                },
                _react2.default.createElement(_SvgIcon2.default, { icon: 'Create' })
            ),
            (layer.layer === 'thematic' || layer.layer === 'boundary' || layer.layer === 'facility') && _react2.default.createElement(
                _IconButton2.default,
                {
                    onClick: function onClick() {
                        return toggleDataTable(layer.id);
                    },
                    tooltip: 'Data table',
                    tooltipPosition: 'top-center',
                    style: styles.button
                },
                _react2.default.createElement(_SvgIcon2.default, { icon: 'ViewList' })
            ),
            _react2.default.createElement(_OpacitySlider2.default, _extends({}, layer, {
                onChange: function onChange(opacity) {
                    return onOpacityChange(layer.id, opacity);
                }
            }))
        ),
        _react2.default.createElement(
            _Toolbar.ToolbarGroup,
            null,
            onRemove && _react2.default.createElement(
                _IconButton2.default,
                {
                    onClick: onRemove,
                    tooltip: 'Delete',
                    tooltipPosition: 'top-center',
                    style: styles.button
                },
                _react2.default.createElement(_SvgIcon2.default, { icon: 'Delete' })
            ),
            true === false && //    TODO
            _react2.default.createElement(
                _IconMenu2.default,
                {
                    iconButtonElement: _react2.default.createElement(
                        _IconButton2.default,
                        {
                            tooltip: 'More',
                            tooltipPosition: 'top-center',
                            style: styles.moreButton
                        },
                        _react2.default.createElement(_SvgIcon2.default, { icon: 'MoreVert' })
                    ),
                    listStyle: styles.menuList
                },
                _react2.default.createElement(_OpenAsMenu2.default, layer),
                _react2.default.createElement(_DownloadMenu2.default, layer)
            )
        )
    );
};

OverlayToolbar.propTypes = {
    layer: _propTypes2.default.object,
    onEdit: _propTypes2.default.func,
    onRemove: _propTypes2.default.func,
    onDataTableShow: _propTypes2.default.func,
    onOpacityChange: _propTypes2.default.func
};

exports.default = OverlayToolbar;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.IconMenu = undefined;

var _IconMenu2 = __webpack_require__(1010);

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

var _MenuItem2 = __webpack_require__(531);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IconMenu = _IconMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _IconMenu3.default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(266);

var _events2 = _interopRequireDefault(_events);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Menu = __webpack_require__(269);

var _Menu2 = _interopRequireDefault(_Menu);

var _Popover = __webpack_require__(163);

var _Popover2 = _interopRequireDefault(_Popover);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconMenu = function (_Component) {
  (0, _inherits3.default)(IconMenu, _Component);

  function IconMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      menuInitiallyKeyboardFocused: false,
      open: false
    }, _this.handleItemClick = function (event, child) {
      if (_this.props.clickCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
        var isKeyboard = _events2.default.isKeyboard(event);
        _this.timerCloseId = setTimeout(function () {
          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
        }, _this.props.clickCloseDelay);
      }

      _this.props.onItemClick(event, child);
    }, _this.handleRequestClose = function (reason) {
      _this.close(reason);
    }, _this.handleEscKeyDownMenu = function (event) {
      _this.close('escape', event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open != null) {
        this.setState({
          open: nextProps.open,
          anchorEl: this.refs.iconMenuContainer
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerCloseId);
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.state.open;
    }
  }, {
    key: 'close',
    value: function close(reason, isKeyboard) {
      var _this2 = this;

      if (!this.state.open) {
        return;
      }

      if (this.props.open !== null) {
        this.props.onRequestChange(false, reason);
      } else {
        this.setState({ open: false }, function () {
          // Set focus on the icon button when the menu close
          if (isKeyboard) {
            var iconButton = _this2.refs.iconButton;
            _reactDom2.default.findDOMNode(iconButton).focus();
            iconButton.setKeyboardFocus();
          }
        });
      }
    }
  }, {
    key: 'open',
    value: function open(reason, event) {
      if (this.props.open !== null) {
        this.props.onRequestChange(true, reason);

        return this.setState({
          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
          anchorEl: event.currentTarget
        });
      }

      this.setState({
        open: true,
        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
        anchorEl: event.currentTarget
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          anchorOrigin = _props.anchorOrigin,
          className = _props.className,
          animated = _props.animated,
          animation = _props.animation,
          iconButtonElement = _props.iconButtonElement,
          iconStyle = _props.iconStyle,
          onItemClick = _props.onItemClick,
          onKeyboardFocus = _props.onKeyboardFocus,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          onMouseUp = _props.onMouseUp,
          onRequestChange = _props.onRequestChange,
          onClick = _props.onClick,
          listStyle = _props.listStyle,
          menuStyle = _props.menuStyle,
          style = _props.style,
          targetOrigin = _props.targetOrigin,
          clickCloseDelay = _props.clickCloseDelay,
          useLayerForClickAway = _props.useLayerForClickAway,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemClick', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onClick', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'clickCloseDelay', 'useLayerForClickAway']);
      var prepareStyles = this.context.muiTheme.prepareStyles;
      var _state = this.state,
          open = _state.open,
          anchorEl = _state.anchorEl;


      var styles = {
        root: {
          display: 'inline-block',
          position: 'relative'
        },
        menu: {
          position: 'relative'
        }
      };

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);

       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;

      var iconButtonProps = {
        onKeyboardFocus: onKeyboardFocus,
        onClick: function onClick(event) {
          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
          if (iconButtonElement.props.onClick) {
            iconButtonElement.props.onClick(event);
          }
        },
        ref: 'iconButton'
      };
      if (iconStyle || iconButtonElement.props.iconStyle) {
        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
      }
      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);

      var menu = _react2.default.createElement(
        _Menu2.default,
        (0, _extends3.default)({}, other, {
          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
          onEscKeyDown: this.handleEscKeyDownMenu,
          onItemClick: this.handleItemClick,
          style: mergedMenuStyles,
          listStyle: listStyle
        }),
        this.props.children
      );

      return _react2.default.createElement(
        'div',
        {
          ref: 'iconMenuContainer',
          className: className,
          onMouseDown: onMouseDown,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          onMouseUp: onMouseUp,
          onClick: onClick,
          style: prepareStyles(mergedRootStyles)
        },
        iconButton,
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            open: open,
            anchorEl: anchorEl,
            childContextTypes: this.constructor.childContextTypes,
            useLayerForClickAway: useLayerForClickAway,
            onRequestClose: this.handleRequestClose,
            animated: animated,
            animation: animation,
            context: this.context
          },
          menu
        )
      );
    }
  }]);
  return IconMenu;
}(_react.Component);

IconMenu.muiName = 'IconMenu';
IconMenu.defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  animated: true,
  multiple: false,
  open: null,
  onItemClick: function onItemClick() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseDown: function onMouseDown() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseUp: function onMouseUp() {},
  onRequestChange: function onRequestChange() {},
  onClick: function onClick() {},
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  clickCloseDelay: 200,
  useLayerForClickAway: false
};
IconMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconMenu.propTypes =  false ? {
  /**
   * This is the point on the icon where the menu
   * `targetOrigin` will attach.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * Should be used to pass `MenuItem` components.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Sets the delay in milliseconds before closing the
   * menu when an item is clicked.
   * If set to 0 then the auto close functionality
   * will be disabled.
   */
  clickCloseDelay: _propTypes2.default.number,
  /**
   * This is the `IconButton` to render. This button will open the menu.
   */
  iconButtonElement: _propTypes2.default.element.isRequired,
  /**
   * Override the inline-styles of the underlying icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the menu element.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, the value can an be array and allow the menu to be a multi-select.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when the `IconButton` element is clicked.
   *
   * @param {object} event Click event targeting the `IconButton` element.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected with a click.
   *
   * @param {object} event Click event targeting the selected menu item element.
   * @param {object} child The selected element.
   */
  onItemClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /**
   * Callback function fired when the `open` state of the menu is requested to be changed.
   *
   * @param {boolean} open If true, the menu was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
   * for close requests.
   */
  onRequestChange: _propTypes2.default.func,
  /**
   * If true, the `IconMenu` is opened.
   */
  open: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the menu which will stick to the menu
   * origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying elements.
   */
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = IconMenu;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MenuItem = __webpack_require__(164);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _fileSaver = __webpack_require__(1012);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _sld = __webpack_require__(1014);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    icon: {
        margin: 4
    },
    menuItem: {
        lineHeight: '32px',
        minHeight: 32,
        fontSize: 14
    }
};

// TODO: Use layer name rather than id as file name
// https://github.com/eligrey/FileSaver.js
var downloadGeoJson = function downloadGeoJson(_ref) {
    var id = _ref.id,
        data = _ref.data;

    var geojson = {
        type: 'FeatureCollection',
        features: data
    };

    var blob = new Blob([JSON.stringify(geojson)], {
        type: 'application/json;charset=utf-8'
    });

    _fileSaver2.default.saveAs(blob, id + '.geojson');
};

var downloadStyle = function downloadStyle(id) {
    var sld = (0, _sld.createSld)(); // TODO: Make generic
    var blob = new Blob([sld], { type: 'application/xml;charset=utf-8' });

    _fileSaver2.default.saveAs(blob, id + '.sld');
};

var DownloadMenu = function DownloadMenu(_ref2) {
    var id = _ref2.id,
        data = _ref2.data;
    return _react2.default.createElement(_MenuItem2.default, {
        primaryText: 'Download ...',
        rightIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'ArrowDropRight', style: styles.icon }),
        menuItems: [_react2.default.createElement(_MenuItem2.default, {
            primaryText: 'Organisation units (GeoJSON)',
            onClick: function onClick() {
                return downloadGeoJson(id, data);
            },
            style: styles.menuItem
        }), _react2.default.createElement(_MenuItem2.default, {
            primaryText: 'Style (SLD)',
            onClick: function onClick() {
                return downloadStyle(id);
            },
            style: styles.menuItem
        })],
        style: styles.menuItem
    });
};

DownloadMenu.propTypes = {
    id: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.array
};

exports.default = DownloadMenu;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(610) !== null) && (__webpack_require__(1013) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createSld = exports.createSld = function createSld() {
  var bounds = [0, 40, 60, 70, 80, 90, 120, 990];
  var colors = ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026', '#CCCCCC'];

  var sld = '<?xml version="1.0" encoding="UTF-8"?>\n                <StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="1.1.0" xmlns:xlink="http://www.w3.org/1999/xlink" xsi:schemaLocation="http://www.opengis.net/sld http://schemas.opengis.net/sld/1.1.0/StyledLayerDescriptor.xsd" xmlns:se="http://www.opengis.net/se">\n                  <NamedLayer>\n                    <se:Name>JzqNgIsKF4N</se:Name>\n                    <UserStyle>\n                      <se:Name>JzqNgIsKF4N</se:Name>\n                      <se:FeatureTypeStyle>';

  for (var i = 0; i < colors.length; i++) {
    var color = colors[i];
    var start = bounds[i];
    var stop = bounds[i + 1];

    var stopFilter = 'PropertyIsLessThan';

    if (i === colors.length - 1) {
      // If last
      var _stopFilter = 'PropertyIsLessThanOrEqualTo';
    }

    sld += '<se:Rule>\n                  <se:Name>' + start + ' - ' + stop + '</se:Name>\n                  <se:Description>\n                    <se:Title>' + start + ' - ' + stop + '</se:Title>\n                  </se:Description>\n                  <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">\n                    <ogc:And>\n                      <ogc:PropertyIsGreaterThanOrEqualTo>\n                        <ogc:PropertyName>value</ogc:PropertyName>\n                        <ogc:Literal>' + start + '</ogc:Literal>\n                      </ogc:PropertyIsGreaterThanOrEqualTo>\n                      <ogc:' + stopFilter + '>\n                        <ogc:PropertyName>value</ogc:PropertyName>\n                        <ogc:Literal>' + stop + '</ogc:Literal>\n                      </ogc:' + stopFilter + '>\n                    </ogc:And>\n                  </ogc:Filter>\n                  <se:PolygonSymbolizer>\n                    <se:Fill>\n                      <se:SvgParameter name="fill">' + color + '</se:SvgParameter>\n                    </se:Fill>\n                    <se:Stroke>\n                      <se:SvgParameter name="stroke">#000000</se:SvgParameter>\n                      <se:SvgParameter name="stroke-width">0.2</se:SvgParameter>\n                      <se:SvgParameter name="stroke-linejoin">bevel</se:SvgParameter>\n                    </se:Stroke>\n                  </se:PolygonSymbolizer>\n                </se:Rule>';
  }

  sld += '</se:FeatureTypeStyle>\n              </UserStyle>\n              </NamedLayer>\n              </StyledLayerDescriptor>';

  return sld;

  /*
  const blob = new Blob([sld], {type: 'application/xml;charset=utf-8'});
   FileSaver.saveAs(blob, layer.id + '.sld');
  */
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MenuItem = __webpack_require__(164);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    icon: {
        margin: 4
    },
    menuItem: {
        lineHeight: '32px',
        minHeight: 32,
        fontSize: 14
    }
};

var OpenAsMenu = function OpenAsMenu(_ref) {
    var id = _ref.id;
    return _react2.default.createElement(_MenuItem2.default, {
        primaryText: 'Open as ...',
        rightIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'ArrowDropRight', style: styles.icon }),
        menuItems: [_react2.default.createElement(_MenuItem2.default, { primaryText: 'Pivot', style: styles.menuItem }), _react2.default.createElement(_MenuItem2.default, { primaryText: 'Chart', style: styles.menuItem })],
        style: styles.menuItem
    });
};

OpenAsMenu.propTypes = {
    id: _propTypes2.default.string.isRequired
};

exports.default = OpenAsMenu;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _LegendItem = __webpack_require__(633);

var _LegendItem2 = _interopRequireDefault(_LegendItem);

__webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legend = function Legend(_ref) {
    var description = _ref.description,
        period = _ref.period,
        filters = _ref.filters,
        unit = _ref.unit,
        items = _ref.items,
        source = _ref.source,
        sourceUrl = _ref.sourceUrl,
        attribution = _ref.attribution;
    return _react2.default.createElement(
        'dl',
        { className: 'Legend' },
        description && _react2.default.createElement(
            'div',
            { className: 'Legend-description' },
            description
        ),
        filters && _react2.default.createElement(
            'div',
            { className: 'Legend-filters' },
            _i18next2.default.t('Filters'),
            ': ',
            filters.join(', ')
        ),
        unit && items && _react2.default.createElement(
            'div',
            { className: 'Legend-unit' },
            unit
        ),
        items && _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
                'tbody',
                null,
                items.map(function (item, index) {
                    return _react2.default.createElement(_LegendItem2.default, _extends({}, item, { key: 'item-' + index }));
                })
            )
        ),
        source && _react2.default.createElement(
            'div',
            { className: 'Legend-source' },
            'Source:\xA0',
            sourceUrl ? _react2.default.createElement(
                'a',
                { href: sourceUrl },
                source
            ) : _react2.default.createElement(
                'span',
                null,
                source
            )
        )
    );
};

Legend.propTypes = {
    description: _propTypes2.default.string,
    unit: _propTypes2.default.string,
    items: _propTypes2.default.array,
    source: _propTypes2.default.string,
    sourceUrl: _propTypes2.default.string
};

exports.default = Legend;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".Legend {\n    padding: 0 16px 16px 32px;\n    margin: 0;\n}\n\n.Legend-description {\n    padding-bottom: 12px;\n}\n\n.Legend-period {\n    padding-bottom: 12px;\n}\n\n.Legend-filters {\n    padding-bottom: 12px;\n}\n\n.Legend-unit {\n    margin-left: 32px;\n    line-height: 24px;\n}\n\n.Legend-source {\n    padding-top: 16px;\n    font-size: 12px;\n}\n\n.Legend table {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n.Legend table tr {\n    height: 24px;\n}\n\n.Legend table th {\n    min-width: 24px;\n    height: 24px;\n    padding: 0;\n    vertical-align: middle;\n}\n\n.Legend table th span {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.Legend table td {\n    padding-left: 10px;\n    white-space: nowrap;\n}", ""]);

// exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1019);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!./LayerCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!./LayerCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".LayerCard {\n    clear: both;\n    z-index: 2000!important;\n    margin: 8px 4px 8px 4px;\n}\n\n.LayerCard-header {\n    height: 56px;\n    padding-left: 14px;\n    padding-right: 8px;\n    margin-right: -8px;\n    font-size: 10px;\n}\n\n.LayerCard-header span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}", ""]);

// exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _colors = __webpack_require__(106);

var _ui = __webpack_require__(635);

var _layout = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
    position: 'absolute',
    top: _layout.HEADER_HEIGHT + 15,
    left: _layout.LAYERS_PANEL_WIDTH,
    width: 24,
    height: 40,
    padding: 0,
    background: '#fff',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    boxShadow: '3px 1px 5px -1px rgba(0, 0, 0, 0.2)',
    zIndex: 1100
};

// This expand/collapse toggle is separate from LayersPanel to avoid overflow issue
var LayersToggle = function LayersToggle(_ref) {
    var isOpen = _ref.isOpen,
        openLayersPanel = _ref.openLayersPanel,
        closeLayersPanel = _ref.closeLayersPanel;
    return isOpen ? _react2.default.createElement(
        _IconButton2.default,
        {
            onClick: closeLayersPanel,
            style: style,
            disableTouchRipple: true
        },
        _react2.default.createElement(_SvgIcon2.default, { icon: 'ChevronLeft', color: _colors.grey800 })
    ) : _react2.default.createElement(
        _IconButton2.default,
        {
            onClick: openLayersPanel,
            style: _extends({}, style, { left: 0 }),
            disableTouchRipple: true
        },
        _react2.default.createElement(_SvgIcon2.default, { icon: 'ChevronRight', color: _colors.grey800 })
    );
};

LayersToggle.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    openLayersPanel: _propTypes2.default.func.isRequired,
    closeLayersPanel: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        isOpen: state.ui.layersPanelOpen
    };
}, { openLayersPanel: _ui.openLayersPanel, closeLayersPanel: _ui.closeLayersPanel })(LayersToggle);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _isNumeric = __webpack_require__(274);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _Layer = __webpack_require__(45);

var _Layer2 = _interopRequireDefault(_Layer);

var _EventLayer = __webpack_require__(532);

var _EventLayer2 = _interopRequireDefault(_EventLayer);

var _FacilityLayer = __webpack_require__(533);

var _FacilityLayer2 = _interopRequireDefault(_FacilityLayer);

var _ThematicLayer = __webpack_require__(534);

var _ThematicLayer2 = _interopRequireDefault(_ThematicLayer);

var _BoundaryLayer = __webpack_require__(535);

var _BoundaryLayer2 = _interopRequireDefault(_BoundaryLayer);

var _EarthEngineLayer = __webpack_require__(536);

var _EarthEngineLayer2 = _interopRequireDefault(_EarthEngineLayer);

var _ExternalLayer = __webpack_require__(537);

var _ExternalLayer2 = _interopRequireDefault(_ExternalLayer);

var _map = __webpack_require__(154);

var _layout = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var layerType = {
    event: _EventLayer2.default,
    facility: _FacilityLayer2.default,
    thematic: _ThematicLayer2.default,
    boundary: _BoundaryLayer2.default,
    earthEngine: _EarthEngineLayer2.default,
    external: _ExternalLayer2.default
};

var Map = function (_Component) {
    _inherits(Map, _Component);

    function Map() {
        _classCallCheck(this, Map);

        return _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).apply(this, arguments));
    }

    _createClass(Map, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.context.map.on('contextmenu', this.onRightClick, this);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                bounds = _props.bounds,
                latitude = _props.latitude,
                longitude = _props.longitude,
                zoom = _props.zoom;

            var map = this.context.map;

            this.node.appendChild(map.getContainer()); // Append map container to DOM

            // Add zoom control
            map.addControl({
                type: 'zoom',
                position: 'topright'
            });

            // Add fit bounds control
            map.addControl({
                type: 'fitBounds',
                position: 'topright'
            });

            // Add scale control
            map.addControl({
                type: 'scale',
                imperial: false
            });

            // Add place search control (OSM Nominatim)
            map.addControl({
                type: 'search'
            });

            // Add measurement control
            map.addControl({
                type: 'measure'
            });

            if (Array.isArray(bounds)) {
                map.fitBounds(bounds);
            } else if ((0, _isNumeric2.default)(latitude) && (0, _isNumeric2.default)(longitude) && (0, _isNumeric2.default)(zoom)) {
                map.setView([latitude, longitude], zoom);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var coordinatePopup = this.props.coordinatePopup;


            if (coordinatePopup) {
                this.showCoordinate(coordinatePopup);
            }

            this.context.map.invalidateSize();
        }

        // Remove map

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.context.map.remove();
        }
    }, {
        key: 'showCoordinate',
        value: function showCoordinate(coord) {
            L.popup().setLatLng([coord[1], coord[0]]).setContent('Longitude: ' + coord[0].toFixed(6) + '<br />Latitude: ' + coord[1].toFixed(6)).on('remove', this.props.closeCoordinatePopup).openOn(this.context.map);
        }
    }, {
        key: 'onRightClick',
        value: function onRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng.lng, latlng.lat]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                basemap = _props2.basemap,
                basemaps = _props2.basemaps,
                mapViews = _props2.mapViews,
                layersPanelOpen = _props2.layersPanelOpen,
                dataTableOpen = _props2.dataTableOpen,
                dataTableHeight = _props2.dataTableHeight,
                openContextMenu = _props2.openContextMenu;


            var basemapConfig = _extends({}, basemaps.filter(function (b) {
                return b.id === basemap.id;
            })[0], basemap);

            var layers = [].concat(_toConsumableArray(mapViews)).reverse();

            var style = {
                position: 'absolute',
                top: _layout.HEADER_HEIGHT,
                left: layersPanelOpen ? _layout.LAYERS_PANEL_WIDTH : 0,
                bottom: dataTableOpen ? dataTableHeight : 0,
                right: 0
            };

            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        return _this2.node = node;
                    }, style: style },
                layers.filter(function (layer) {
                    return layer.isLoaded;
                }).map(function (config, index) {
                    var Overlay = layerType[config.layer] || _Layer2.default;

                    return _react2.default.createElement(Overlay, _extends({
                        key: config.id,
                        index: index,
                        openContextMenu: openContextMenu
                    }, config));
                }),
                _react2.default.createElement(_Layer2.default, _extends({ key: 'basemap' }, basemapConfig))
            );
        }
    }]);

    return Map;
}(_react.Component);

Map.contextTypes = {
    map: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state.map, {
        basemaps: state.basemaps,
        layersPanelOpen: state.ui.layersPanelOpen,
        dataTableOpen: state.dataTable,
        dataTableHeight: state.ui.dataTableHeight
    });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    openContextMenu: _map.openContextMenu,
    closeCoordinatePopup: _map.closeCoordinatePopup
})(Map);

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _ResizeHandle = __webpack_require__(1023);

var _ResizeHandle2 = _interopRequireDefault(_ResizeHandle);

var _DataTable = __webpack_require__(1026);

var _DataTable2 = _interopRequireDefault(_DataTable);

var _layout = __webpack_require__(161);

var _dataTable = __webpack_require__(271);

__webpack_require__(1100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    closeIcon: {
        width: 16,
        height: 16
    }
};

// Container for DataTable

var BottomPanel = function (_Component) {
    _inherits(BottomPanel, _Component);

    function BottomPanel() {
        _classCallCheck(this, BottomPanel);

        return _possibleConstructorReturn(this, (BottomPanel.__proto__ || Object.getPrototypeOf(BottomPanel)).apply(this, arguments));
    }

    _createClass(BottomPanel, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                layersPanelOpen = _props.layersPanelOpen,
                dataTableOpen = _props.dataTableOpen,
                dataTableHeight = _props.dataTableHeight,
                width = _props.width,
                height = _props.height,
                resizeDataTable = _props.resizeDataTable,
                closeDataTable = _props.closeDataTable;


            if (dataTableOpen) {
                var maxHeight = height - _layout.HEADER_HEIGHT - 20;
                var tableHeight = dataTableHeight < maxHeight ? dataTableHeight : maxHeight;
                var tableWidth = width - (layersPanelOpen ? _layout.LAYERS_PANEL_WIDTH : 0);

                var style = {
                    left: layersPanelOpen ? _layout.LAYERS_PANEL_WIDTH : 0,
                    height: tableHeight
                };

                return _react2.default.createElement(
                    'div',
                    {
                        ref: function ref(node) {
                            return _this2.node = node;
                        },
                        className: 'BottomPanel',
                        style: style
                    },
                    _react2.default.createElement(
                        'span',
                        { onClick: closeDataTable },
                        _react2.default.createElement(_SvgIcon2.default, {
                            icon: 'Cancel',
                            className: 'BottomPanel-close',
                            style: styles.closeIcon
                        })
                    ),
                    _react2.default.createElement(_ResizeHandle2.default, {
                        maxHeight: maxHeight,
                        onResize: function onResize(height) {
                            return _this2.onResize(height);
                        },
                        onResizeEnd: function onResizeEnd(height) {
                            return resizeDataTable(height);
                        }
                    }),
                    _react2.default.createElement(_DataTable2.default, { width: tableWidth, height: tableHeight })
                );
            }

            return null;
        }

        // Called from resize handle

    }, {
        key: 'onResize',
        value: function onResize(height) {
            this.node.style.height = height + 'px';
        }
    }]);

    return BottomPanel;
}(_react.Component);

BottomPanel.propTypes = {
    layersPanelOpen: _propTypes2.default.bool.isRequired,
    dataTableOpen: _propTypes2.default.bool.isRequired,
    dataTableHeight: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    resizeDataTable: _propTypes2.default.func.isRequired,
    closeDataTable: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dataTableOpen: state.dataTable ? true : false,
        dataTableHeight: state.ui.dataTableHeight,
        layersPanelOpen: state.ui.layersPanelOpen,
        width: state.ui.width,
        height: state.ui.height
    };
}, { closeDataTable: _dataTable.closeDataTable, resizeDataTable: _dataTable.resizeDataTable })(BottomPanel);

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

__webpack_require__(1024);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResizeHandle = function ResizeHandle(_ref) {
    var onResize = _ref.onResize,
        onResizeEnd = _ref.onResizeEnd,
        minHeight = _ref.minHeight,
        maxHeight = _ref.maxHeight;

    var dragHeight = 0;

    var _onDragStart = function _onDragStart(evt) {
        // Set the drag ghost image to a transparent 1x1px
        // https://stackoverflow.com/questions/7680285/how-do-you-turn-off-setdragimage
        var img = document.createElement('img');
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        evt.dataTransfer.setDragImage(img, 0, 0);

        evt.dataTransfer.setData('text/plain', 'node'); // Required to initialize dragging in Firefox

        // https://stackoverflow.com/questions/23992091/drag-and-drop-directive-no-e-clientx-or-e-clienty-on-drag-event-in-firefox
        document.ondragover = onDrag;
    };

    var onDrag = function onDrag(evt) {
        var height = getHeight(evt || window.event);

        if (height && onResize) {
            onResize(height);
            dragHeight = height;
        }
    };

    var _onDragEnd = function _onDragEnd(evt) {
        var height = getHeight(evt);

        if (height && onResizeEnd) {
            onResizeEnd(height);
        }
    };

    var getHeight = function getHeight(evt) {
        if (evt.pageY) {
            var height = window.innerHeight - evt.pageY;
            dragHeight = height < minHeight ? minHeight : height > maxHeight ? maxHeight : height;
        }

        return dragHeight;
    };

    return _react2.default.createElement(
        'div',
        {
            className: 'ResizeHandle',
            draggable: true,
            onDragStart: function onDragStart(evt) {
                return _onDragStart(evt);
            }
            // onDrag={(evt) => onDrag(evt)}
            , onDragEnd: function onDragEnd(evt) {
                return _onDragEnd(evt);
            }
        },
        _react2.default.createElement(_SvgIcon2.default, { icon: 'DragHandle' })
    );
};

ResizeHandle.propTypes = {
    onResize: _propTypes2.default.func,
    onResizeEnd: _propTypes2.default.func,
    minHeight: _propTypes2.default.number.isRequired,
    maxHeight: _propTypes2.default.number.isRequired
};

ResizeHandle.defaultProps = {
    minHeight: 50,
    maxHeight: 500
};

exports.default = ResizeHandle;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1025);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./ResizeHandle.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./ResizeHandle.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".ResizeHandle {\n    position: absolute;\n    left: 50%;\n    top: -8px;\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);\n    border-radius: 2;\n    width: 40px;\n    height: 12px;\n    background: #fff;\n    z-index: 1500;\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.ResizeHandle:hover,\n.ResizeHandle:active {\n    transform: scale(1.03);\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.ResizeHandle:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n }\n\n.ResizeHandle svg {\n    margin-left: 8px;\n    margin-top: -6px;\n}\n", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactVirtualized = __webpack_require__(636);

var _mapValues = __webpack_require__(1076);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _ColumnHeader = __webpack_require__(1078);

var _ColumnHeader2 = _interopRequireDefault(_ColumnHeader);

var _ColorCell = __webpack_require__(1092);

var _ColorCell2 = _interopRequireDefault(_ColorCell);

var _orgUnits = __webpack_require__(93);

var _dataFilters = __webpack_require__(542);

var _filter = __webpack_require__(112);

__webpack_require__(1097);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Using react component to keep sorting state, which is only used within the data table.
var DataTable = function (_Component) {
    _inherits(DataTable, _Component);

    function DataTable(props, context) {
        _classCallCheck(this, DataTable);

        // Default sort
        var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props, context));

        var sortBy = 'index';
        var sortDirection = 'ASC';

        _this.state = {
            sortBy: sortBy,
            sortDirection: sortDirection,
            data: _this.sort(props.data, sortBy, sortDirection)
        };
        return _this;
    }

    _createClass(DataTable, [{
        key: 'onSort',
        value: function onSort(sortBy, sortDirection) {
            var data = this.state.data;

            this.setState({
                sortBy: sortBy,
                sortDirection: sortDirection,
                data: this.sort(data, sortBy, sortDirection)
            });
        }

        // TODO: Make sure sorting works across different locales - use lib method

    }, {
        key: 'sort',
        value: function sort(data, sortBy, sortDirection) {
            return data.sort(function (a, b) {
                a = a[sortBy];
                b = b[sortBy];

                if (typeof a === 'number') {
                    return sortDirection === 'ASC' ? a - b : b - a;
                }

                if (a !== undefined) {
                    return sortDirection === 'ASC' ? a.localeCompare(b) : b.localeCompare(a);
                }

                return 0;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                width = _props.width,
                height = _props.height,
                data = _props.data,
                layerType = _props.layerType;

            var fields = (0, _mapValues2.default)(function () {
                return true;
            }, data[0]);
            var _state = this.state,
                sortBy = _state.sortBy,
                sortDirection = _state.sortDirection;

            var sortedData = this.sort(data, sortBy, sortDirection);
            var isFacility = layerType === 'facility';
            var isThematic = layerType === 'thematic';
            var isBoundary = layerType === 'boundary';

            return _react2.default.createElement(
                _reactVirtualized.Table,
                {
                    className: 'DataTable',
                    width: width,
                    height: height,
                    headerHeight: 48,
                    rowHeight: 32,
                    rowCount: sortedData.length,
                    rowGetter: function rowGetter(_ref) {
                        var index = _ref.index;
                        return sortedData[index];
                    },
                    sort: function sort(_ref2) {
                        var sortBy = _ref2.sortBy,
                            sortDirection = _ref2.sortDirection;
                        return _this2.onSort(sortBy, sortDirection);
                    },
                    sortBy: sortBy,
                    sortDirection: sortDirection,
                    useDynamicRowHeight: false,
                    hideIndexRow: false
                },
                _react2.default.createElement(_reactVirtualized.Column, {
                    cellDataGetter: function cellDataGetter(_ref3) {
                        var columnData = _ref3.columnData,
                            dataKey = _ref3.dataKey,
                            rowData = _ref3.rowData;
                        return rowData.index;
                    },
                    dataKey: 'index',
                    label: 'Index',
                    width: 72,
                    className: 'right'
                    // headerRenderer={props => <ColumnHeader type='number' {...props}  />}
                }),
                _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'name',
                    label: 'Name',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                isThematic && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'value',
                    label: 'Value',
                    width: 72,
                    className: 'right',
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'number' }, props));
                    }
                }),
                isThematic && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'legend',
                    label: 'Legend',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                isThematic && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'range',
                    label: 'Range',
                    width: 72,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                (isThematic || isBoundary) && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'level',
                    label: 'Level',
                    width: 72,
                    className: 'right',
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'number' }, props));
                    }
                }),
                (isThematic || isBoundary) && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'parentName',
                    label: 'Parent',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'id',
                    label: 'ID',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'type',
                    label: 'Type',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    }
                }),
                isThematic && _react2.default.createElement(_reactVirtualized.Column, {
                    dataKey: 'color',
                    label: 'Color',
                    width: 100,
                    headerRenderer: function headerRenderer(props) {
                        return _react2.default.createElement(_ColumnHeader2.default, _extends({ type: 'string' }, props));
                    },
                    cellRenderer: _ColorCell2.default
                })
            );
        }
    }]);

    return DataTable;
}(_react.Component);

DataTable.propTypes = {
    data: _propTypes2.default.array.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired
};
DataTable.defaultProps = {
    data: []
};


var mapStateToProps = function mapStateToProps(state) {
    var overlay = state.dataTable ? state.map.mapViews.filter(function (layer) {
        return layer.id === state.dataTable;
    })[0] : null;

    if (overlay) {
        var data = (0, _filter.filterData)(overlay.data.map(function (d, i) {
            return _extends({}, d.properties, {
                index: i
            });
        }), overlay.dataFilters);

        return {
            layerType: overlay.layer,
            data: data
        };
    }

    return null;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    selectOrgUnit: _orgUnits.selectOrgUnit,
    unselectOrgUnit: _orgUnits.unselectOrgUnit,
    setDataFilter: _dataFilters.setDataFilter,
    clearDataFilter: _dataFilters.clearDataFilter
})(DataTable);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(637);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });






/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(1).any;

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(538);
var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(1).any;



/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(1).any;

var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var babelPluginFlowReactPropTypes_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: require("prop-types").number.isRequired,
  scrollToRow: require("prop-types").number.isRequired
};
if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_ScrollIndices", {
  value: babelPluginFlowReactPropTypes_proptype_ScrollIndices,
  configurable: true
});

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(642);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CellMeasurerCache_js__ = __webpack_require__(645);









/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: typeof CellMeasurerCache === 'function' ? require('prop-types').instanceOf(CellMeasurerCache).isRequired : require('prop-types').any.isRequired,
  children: require('prop-types').oneOfType([require('prop-types').func, require('prop-types').node]).isRequired,
  columnIndex: require('prop-types').number,
  index: require('prop-types').number,
  parent: require('prop-types').shape({
    invalidateCellSizeAfterRender: require('prop-types').func,
    recomputeGridSize: require('prop-types').func
  }).isRequired,
  rowIndex: require('prop-types').number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(1039);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collection__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(1044);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var babelPluginFlowReactPropTypes_proptype_SizeInfo = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_SizeInfo || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_ScrollPosition = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_ScrollPosition || __webpack_require__(1).any;

var Collection = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createCallbackMemoizer__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dom_helpers_util_scrollbarSize__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_dom_helpers_util_scrollbarSize__);












// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _PureComponent);

  function CollectionView(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call(this, props, context));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };

    _this._calculateSizeAndPositionDataOnNextUpdate = false;

    // Invokes callbacks only when their values have changed.
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createCallbackMemoizer__["a" /* default */])(false);

    // Bind functions to instance so they don't lose context when passed around.
    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_10_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var cellLayoutManager = this.props.cellLayoutManager;


      cellLayoutManager.calculateSizeAndPositionData();

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()
      this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_10_dom_helpers_util_scrollbarSize___default()();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state2 = this.state,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;


      if (nextProps.cellCount === 0 && (scrollLeft !== 0 || scrollTop !== 0)) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        this._setScrollPosition({
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        });
      }

      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        nextProps.cellLayoutManager.calculateSizeAndPositionData();
      }

      if (this._calculateSizeAndPositionDataOnNextUpdate) {
        this._calculateSizeAndPositionDataOnNextUpdate = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state3 = this.state,
          isScrolling = _state3.isScrolling,
          scrollLeft = _state3.scrollLeft,
          scrollTop = _state3.scrollTop;

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnSectionRenderedHelper',
    value: function _invokeOnSectionRenderedHelper() {
      var _props4 = this.props,
          cellLayoutManager = _props4.cellLayoutManager,
          onSectionRendered = _props4.onSectionRendered;


      this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _props5 = _this3.props,
              height = _props5.height,
              onScroll = _props5.onScroll,
              width = _props5.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollingContainerRef',
    value: function _setScrollingContainerRef(ref) {
      this._scrollingContainer = ref;
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_updateScrollPositionForScrollToCell',
    value: function _updateScrollPositionForScrollToCell() {
      var _props6 = this.props,
          cellLayoutManager = _props6.cellLayoutManager,
          height = _props6.height,
          scrollToAlignment = _props6.scrollToAlignment,
          scrollToCell = _props6.scrollToCell,
          width = _props6.width;
      var _state4 = this.state,
          scrollLeft = _state4.scrollLeft,
          scrollTop = _state4.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          this._setScrollPosition(scrollPosition);
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _props7 = this.props,
          cellLayoutManager = _props7.cellLayoutManager,
          height = _props7.height,
          isScrollingChange = _props7.isScrollingChange,
          width = _props7.width;

      var scrollbarSize = this._scrollbarSize;

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!this.state.isScrolling) {
          isScrollingChange(true);
        }

        this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
/* harmony default export */ __webpack_exports__["a"] = (CollectionView);
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(1042);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(1043);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */


var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_Index = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_Index || __webpack_require__(1).any;

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo || __webpack_require__(1).any; /** @rlow */


var babelPluginFlowReactPropTypes_proptype_Index = __webpack_require__(166).babelPluginFlowReactPropTypes_proptype_Index || __webpack_require__(1).any;

var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(1046);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(1048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(539);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
      startIndex = _ref2.startIndex,
      stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded,
      minimumBatchSize = _ref3.minimumBatchSize,
      rowCount = _ref3.rowCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(646);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });






/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1051), __esModule: true };

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1052);
var $Object = __webpack_require__(44).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(146);
var $getOwnPropertyDescriptor = __webpack_require__(523).f;

__webpack_require__(508)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Masonry__["default"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["default"]);


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCellPositioner;
var babelPluginFlowReactPropTypes_proptype_Positioner = __webpack_require__(541).babelPluginFlowReactPropTypes_proptype_Positioner || __webpack_require__(1).any;

var babelPluginFlowReactPropTypes_proptype_CellMeasurerCache = __webpack_require__(541).babelPluginFlowReactPropTypes_proptype_CellMeasurerCache || __webpack_require__(1).any;

function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(1063);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1057);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1060);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1058), __esModule: true };

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(519);
__webpack_require__(263);
module.exports = __webpack_require__(1059);


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(605);
var ITERATOR = __webpack_require__(69)('iterator');
var Iterators = __webpack_require__(158);
module.exports = __webpack_require__(44).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1061), __esModule: true };

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(519);
__webpack_require__(263);
module.exports = __webpack_require__(1062);


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(144);
var get = __webpack_require__(604);
module.exports = __webpack_require__(44).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(1064);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(1066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CellMeasurerCacheDecorator__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(49);












var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _this.state = {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    };

    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;

    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onScrollbarPresenceChange = _this._onScrollbarPresenceChange.bind(_this);
    _this._onScrollLeft = _this._onScrollLeft.bind(_this);
    _this._onScrollTop = _this._onScrollTop.bind(_this);
    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(null, this.props, null, this.state);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props3 = this.props,
          deferredMeasurementCache = _props3.deferredMeasurementCache,
          fixedColumnCount = _props3.fixedColumnCount,
          fixedRowCount = _props3.fixedRowCount;


      this._maybeCalculateCachedStyles(null, this.props, null, this.state);

      if (deferredMeasurementCache) {
        this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_9__CellMeasurerCacheDecorator__["a" /* default */]({
          cellMeasurerCache: deferredMeasurementCache,
          columnIndexOffset: 0,
          rowIndexOffset: fixedRowCount
        }) : deferredMeasurementCache;

        this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_9__CellMeasurerCacheDecorator__["a" /* default */]({
          cellMeasurerCache: deferredMeasurementCache,
          columnIndexOffset: fixedColumnCount,
          rowIndexOffset: fixedRowCount
        }) : deferredMeasurementCache;

        this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_9__CellMeasurerCacheDecorator__["a" /* default */]({
          cellMeasurerCache: deferredMeasurementCache,
          columnIndexOffset: fixedColumnCount,
          rowIndexOffset: 0
        }) : deferredMeasurementCache;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextState) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight;


      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
        this._topGridHeight = null;
      }

      if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null && nextProps.scrollLeft >= 0) {
          newState.scrollLeft = nextProps.scrollLeft;
        }

        if (nextProps.scrollTop != null && nextProps.scrollTop >= 0) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this.setState(newState);
      }

      this._maybeCalculateCachedStyles(this.props, nextProps, this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          onScroll = _props5.onScroll,
          onSectionRendered = _props5.onSectionRendered,
          onScrollbarPresenceChange = _props5.onScrollbarPresenceChange,
          scrollLeftProp = _props5.scrollLeft,
          scrollToColumn = _props5.scrollToColumn,
          scrollTopProp = _props5.scrollTop,
          scrollToRow = _props5.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props5, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_bottomLeftGridRef',
    value: function _bottomLeftGridRef(ref) {
      this._bottomLeftGrid = ref;
    }
  }, {
    key: '_bottomRightGridRef',
    value: function _bottomRightGridRef(ref) {
      this._bottomRightGrid = ref;
    }
  }, {
    key: '_cellRendererBottomLeftGrid',
    value: function _cellRendererBottomLeftGrid(_ref3) {
      var rowIndex = _ref3.rowIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

      var _props6 = this.props,
          cellRenderer = _props6.cellRenderer,
          fixedRowCount = _props6.fixedRowCount,
          rowCount = _props6.rowCount;


      if (rowIndex === rowCount - fixedRowCount) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
          key: rest.key,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          parent: this,
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    }
  }, {
    key: '_cellRendererBottomRightGrid',
    value: function _cellRendererBottomRightGrid(_ref4) {
      var columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

      var _props7 = this.props,
          cellRenderer = _props7.cellRenderer,
          fixedColumnCount = _props7.fixedColumnCount,
          fixedRowCount = _props7.fixedRowCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: this,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  }, {
    key: '_cellRendererTopRightGrid',
    value: function _cellRendererTopRightGrid(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

      var _props8 = this.props,
          cellRenderer = _props8.cellRenderer,
          columnCount = _props8.columnCount,
          fixedColumnCount = _props8.fixedColumnCount;


      if (columnIndex === columnCount - fixedColumnCount) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
          key: rest.key,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: this
        }));
      }
    }
  }, {
    key: '_columnWidthRightGrid',
    value: function _columnWidthRightGrid(_ref6) {
      var index = _ref6.index;
      var _props9 = this.props,
          columnCount = _props9.columnCount,
          fixedColumnCount = _props9.fixedColumnCount,
          columnWidth = _props9.columnWidth;
      var _state2 = this.state,
          scrollbarSize = _state2.scrollbarSize,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar;

      // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(prevProps, props) {
      var columnWidth = props.columnWidth,
          enableFixedColumnScroll = props.enableFixedColumnScroll,
          enableFixedRowScroll = props.enableFixedRowScroll,
          height = props.height,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight,
          style = props.style,
          styleBottomLeftGrid = props.styleBottomLeftGrid,
          styleBottomRightGrid = props.styleBottomRightGrid,
          styleTopLeftGrid = props.styleTopLeftGrid,
          styleTopRightGrid = props.styleTopRightGrid,
          width = props.width;


      var firstRender = !prevProps;
      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;

      if (firstRender || sizeChange || style !== prevProps.style) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (firstRender || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      var onScroll = this.props.onScroll;
      if (onScroll) {
        onScroll(scrollInfo);
      }
    }
  }, {
    key: '_onScrollbarPresenceChange',
    value: function _onScrollbarPresenceChange(_ref7) {
      var horizontal = _ref7.horizontal,
          size = _ref7.size,
          vertical = _ref7.vertical;
      var _state3 = this.state,
          showHorizontalScrollbar = _state3.showHorizontalScrollbar,
          showVerticalScrollbar = _state3.showVerticalScrollbar;


      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    }
  }, {
    key: '_onScrollLeft',
    value: function _onScrollLeft(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: this.state.scrollTop
      });
    }
  }, {
    key: '_onScrollTop',
    value: function _onScrollTop(scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: this.state.scrollLeft
      });
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollTop = props.scrollTop;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: this._getBottomGridHeight(props),
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        scrollTop: scrollTop,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft;
      var showHorizontalScrollbar = this.state.showHorizontalScrollbar;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: this._getTopGridHeight(props),
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: this._topRightGridStyle,
        tabIndex: null,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_rowHeightBottomGrid',
    value: function _rowHeightBottomGrid(_ref8) {
      var index = _ref8.index;
      var _props10 = this.props,
          fixedRowCount = _props10.fixedRowCount,
          rowCount = _props10.rowCount,
          rowHeight = _props10.rowHeight;
      var _state4 = this.state,
          scrollbarSize = _state4.scrollbarSize,
          showVerticalScrollbar = _state4.showVerticalScrollbar;

      // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
    }
  }, {
    key: '_topLeftGridRef',
    value: function _topLeftGridRef(ref) {
      this._topLeftGrid = ref;
    }
  }, {
    key: '_topRightGridRef',
    value: function _topRightGridRef(ref) {
      this._topRightGrid = ref;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {}
};
/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);
MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired
} : {};

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(644);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(1069);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(1072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createMultiSort__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__SortDirection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__SortIndicator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMultiSort;


function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      sortBy.length = 0;
      sortBy.push(dataKey);

      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(275);







var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(49).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(1).any;












/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rowStyleObject, {
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          })
        }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        {
          'aria-describedby': id,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, rowStyleObject, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      });

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        var scrollbarWidth = offsetWidth - clientWidth;

        this.setState({ scrollbarWidth: scrollbarWidth });
      }
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["accessibilityOverscanIndicesGetter"],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a"]; });
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(654);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["requestAnimationTimeout"])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('mapValues', __webpack_require__(1077));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(150),
    baseForOwn = __webpack_require__(218),
    baseIteratee = __webpack_require__(38);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FilterInput = __webpack_require__(1079);

var _FilterInput2 = _interopRequireDefault(_FilterInput);

var _FilterMultiSelect = __webpack_require__(1082);

var _FilterMultiSelect2 = _interopRequireDefault(_FilterMultiSelect);

__webpack_require__(1090);

var _reactVirtualized = __webpack_require__(636);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Replacement for https://github.com/bvaughn/react-virtualized/blob/master/source/Table/defaultHeaderRenderer.js

var ColumnHeader = function ColumnHeader(_ref) {
    var dataKey = _ref.dataKey,
        label = _ref.label,
        type = _ref.type,
        sortBy = _ref.sortBy,
        sortDirection = _ref.sortDirection;
    return _react2.default.createElement(
        'div',
        { className: 'ColumnHeader' },
        _react2.default.createElement(
            'span',
            { className: 'ColumnHeader-label', title: label },
            label
        ),
        sortBy === dataKey ? _react2.default.createElement(_reactVirtualized.SortIndicator, { sortDirection: sortDirection }) : null,
        type === 'multiselect' ? _react2.default.createElement(_FilterMultiSelect2.default, { dataKey: dataKey }) : _react2.default.createElement(_FilterInput2.default, { type: type, dataKey: dataKey })
    );
};

ColumnHeader.propTypes = {
    dataKey: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    sortBy: _propTypes2.default.string.isRequired,
    sortDirection: _propTypes2.default.string.isRequired
};

exports.default = ColumnHeader;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _dataFilters = __webpack_require__(542);

__webpack_require__(1080);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://adazzle.github.io/react-data-grid/examples.html#/custom-filters
// https://github.com/adazzle/react-data-grid/tree/master/packages/react-data-grid-addons/src/cells/headerCells/filters
var FilterInput = function FilterInput(_ref) {
    var layerId = _ref.layerId,
        type = _ref.type,
        dataKey = _ref.dataKey,
        filters = _ref.filters,
        setDataFilter = _ref.setDataFilter,
        clearDataFilter = _ref.clearDataFilter;

    var filterValue = filters[dataKey] || '';

    // https://stackoverflow.com/questions/36683770/react-how-to-get-the-value-of-an-input-field
    var onChange = function onChange(evt) {
        var value = evt.target.value;

        if (value !== '') {
            setDataFilter(layerId, dataKey, value);
        } else {
            clearDataFilter(layerId, dataKey, value);
        }
    };

    return _react2.default.createElement('input', {
        className: 'FilterInput',
        placeholder: type === 'number' ? '2,>3&<8' : 'Search' // TODO: Support more field types
        , value: filterValue,
        onClick: function onClick(evt) {
            return evt.stopPropagation();
        },
        onChange: onChange
    });
};

FilterInput.propTypes = {
    layerId: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    dataKey: _propTypes2.default.string.isRequired,
    filters: _propTypes2.default.object.isRequired,
    setDataFilter: _propTypes2.default.func.isRequired,
    clearDataFilter: _propTypes2.default.func.isRequired
};

// Avoid needing to pass filter and actions to every input field
var mapStateToProps = function mapStateToProps(state) {
    var overlay = state.dataTable ? state.map.mapViews.filter(function (layer) {
        return layer.id === state.dataTable;
    })[0] : null;

    if (overlay) {
        return {
            layerId: overlay.id,
            filters: overlay.dataFilters || {}
        };
    }

    return null;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { setDataFilter: _dataFilters.setDataFilter, clearDataFilter: _dataFilters.clearDataFilter })(FilterInput);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1081);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./FilterInput.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./FilterInput.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".FilterInput {\n    position: absolute;\n    left: 0;\n    top: 22px;\n    box-sizing: border-box;\n    width: 100%;\n    height: 24px;\n    font-weight: normal;\n    padding-left: 5px;\n}\n\n.FilterInput::placeholder {\n    color: #ddd;\n}", ""]);

// exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(655);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _MenuItem = __webpack_require__(164);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _dataFilters = __webpack_require__(542);

__webpack_require__(1088);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var names = ['Low', 'Medium', 'Medium Pl.', 'High', 'High Plus', 'Great', 'Invalid'];

var styles = {
    root: {
        width: '100%',
        height: 24,
        background: '#fff'
    },
    underline: {
        display: 'none'
    },
    hint: {
        textTransform: 'none',
        color: '#ddd',
        fontSize: 12,
        fontWeight: 'normal',
        bottom: -1,
        left: 5
    },
    label: {
        top: -1,
        left: 5,
        height: 24,
        width: 120,
        lineHeight: '24px',
        textTransform: 'none',
        fontWeight: 'normal',
        fontSize: 12
    },
    icon: {
        width: 24,
        height: 24,
        right: 45,
        marginTop: -6
    },
    menu: {
        width: 140
    },
    list: {
        paddingTop: 4,
        paddingBottom: 4
    },
    menuItem: {
        fontSize: 12,
        lineHeight: '24px',
        minHeight: 24
    }
};

// http://www.material-ui.com/#/components/select-field

var FilterMultiSelect = function (_Component) {
    _inherits(FilterMultiSelect, _Component);

    function FilterMultiSelect(props) {
        _classCallCheck(this, FilterMultiSelect);

        var _this = _possibleConstructorReturn(this, (FilterMultiSelect.__proto__ || Object.getPrototypeOf(FilterMultiSelect)).call(this, props));

        _this.handleChange = function (event, index, values) {
            return _this.setState({ values: values });
        };

        _this.state = {
            values: []
        };
        return _this;
    }

    _createClass(FilterMultiSelect, [{
        key: 'menuItems',
        value: function menuItems(values) {
            return names.map(function (name) {
                return _react2.default.createElement(_MenuItem2.default, {
                    className: 'FilterMultiSelect-item',
                    key: name,
                    insetChildren: true,
                    checked: values && values.indexOf(name) > -1,
                    value: name,
                    primaryText: name
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var values = this.state.values;


            return _react2.default.createElement(
                _SelectField2.default,
                {
                    hintText: 'Select',
                    value: values,
                    onChange: this.handleChange,
                    className: 'FilterMultiSelect',
                    style: styles.root,
                    hintStyle: styles.hint,
                    underlineStyle: styles.underline,
                    labelStyle: styles.label,
                    iconStyle: styles.icon,
                    menuStyle: styles.menu,
                    menuItemStyle: styles.menuItem,
                    listStyle: styles.list,
                    multiple: true,
                    onClick: function onClick(evt) {
                        return evt.stopPropagation();
                    }
                },
                this.menuItems(values)
            );
        }
    }]);

    return FilterMultiSelect;
}(_react.Component);

// Avoid needing to pass filter and actions to every input field


var mapStateToProps = function mapStateToProps(state) {
    var overlay = state.dataTable ? state.map.overlays.filter(function (layer) {
        return layer.id === state.dataTable;
    })[0] : null;

    if (overlay) {
        return {
            layerId: overlay.id,
            filters: overlay.dataFilters
        };
    }

    return null;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { setDataFilter: _dataFilters.setDataFilter, clearDataFilter: _dataFilters.clearDataFilter })(FilterMultiSelect);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(273);

var _TextField2 = _interopRequireDefault(_TextField);

var _DropDownMenu = __webpack_require__(1084);

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  return {
    label: {
      paddingLeft: 0,
      top: props.floatingLabelText ? 6 : -4
    },
    icon: {
      right: 0,
      top: props.floatingLabelText ? 8 : 0
    },
    hideDropDownUnderline: {
      borderTop: 'none'
    },
    dropDownMenu: {
      display: 'block'
    }
  };
}

var SelectField = function (_Component) {
  (0, _inherits3.default)(SelectField, _Component);

  function SelectField() {
    (0, _classCallCheck3.default)(this, SelectField);
    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          style = _props.style,
          labelStyle = _props.labelStyle,
          iconStyle = _props.iconStyle,
          id = _props.id,
          underlineDisabledStyle = _props.underlineDisabledStyle,
          underlineFocusStyle = _props.underlineFocusStyle,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          underlineStyle = _props.underlineStyle,
          dropDownMenuProps = _props.dropDownMenuProps,
          errorStyle = _props.errorStyle,
          disabled = _props.disabled,
          floatingLabelFixed = _props.floatingLabelFixed,
          floatingLabelText = _props.floatingLabelText,
          floatingLabelStyle = _props.floatingLabelStyle,
          hintStyle = _props.hintStyle,
          hintText = _props.hintText,
          fullWidth = _props.fullWidth,
          errorText = _props.errorText,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyle = _props.menuStyle,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          selectionRenderer = _props.selectionRenderer,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);


      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _TextField2.default,
        (0, _extends3.default)({}, other, {
          style: style,
          disabled: disabled,
          floatingLabelFixed: floatingLabelFixed,
          floatingLabelText: floatingLabelText,
          floatingLabelStyle: floatingLabelStyle,
          hintStyle: hintStyle,
          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
          fullWidth: fullWidth,
          errorText: errorText,
          underlineStyle: underlineStyle,
          errorStyle: errorStyle,
          onFocus: onFocus,
          onBlur: onBlur,
          id: id,
          underlineDisabledStyle: underlineDisabledStyle,
          underlineFocusStyle: underlineFocusStyle
        }),
        _react2.default.createElement(
          _DropDownMenu2.default,
          (0, _extends3.default)({
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
            menuItemStyle: menuItemStyle,
            selectedMenuItemStyle: selectedMenuItemStyle,
            underlineStyle: styles.hideDropDownUnderline,
            listStyle: listStyle,
            autoWidth: autoWidth,
            value: value,
            onChange: onChange,
            maxHeight: maxHeight,
            multiple: multiple,
            selectionRenderer: selectionRenderer
          }, dropDownMenuProps),
          children
        )
      );
    }
  }]);
  return SelectField;
}(_react.Component);

SelectField.defaultProps = {
  autoWidth: false,
  disabled: false,
  fullWidth: false,
  multiple: false
};
SelectField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SelectField.propTypes =  false ? {
  /**
   * If true, the width will automatically be set according to the
   * items inside the menu.
   * To control the width in CSS instead, leave this prop set to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem` elements to populate the select field with.
   * If the menu items have a `label` prop, that value will
   * represent the selected menu item in the rendered select field.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the select field will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Object that can handle and override any property of component DropDownMenu.
   */
  dropDownMenuProps: _propTypes2.default.object,
  /**
   * Override the inline-styles of the error element.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when no value is selected.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the floating label.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content of the floating label.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the select field will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the hint element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the label style when the select field is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * Override the default max-height of the underlying `DropDownMenu` element.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `DropDownMenu` element.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event Click event targeting the menu item
   * that was selected.
   * @param {number} key The index of the selected menu item, or undefined
   * if `multiple` is true.
   * @param {any} payload If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Customize the rendering of the selected item.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select
   * field is disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select field
   * is focused.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = SelectField;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.DropDownMenu = undefined;

var _DropDownMenu2 = __webpack_require__(1085);

var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);

var _MenuItem2 = __webpack_require__(531);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownMenu = _DropDownMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _DropDownMenu3.default;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _arrowDropDown = __webpack_require__(656);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Menu = __webpack_require__(269);

var _Menu2 = _interopRequireDefault(_Menu);

var _ClearFix = __webpack_require__(1086);

var _ClearFix2 = _interopRequireDefault(_ClearFix);

var _Popover = __webpack_require__(163);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(529);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _events = __webpack_require__(266);

var _events2 = _interopRequireDefault(_events);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _propTypes3 = __webpack_require__(70);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var disabled = props.disabled;

  var spacing = context.muiTheme.baseTheme.spacing;
  var palette = context.muiTheme.baseTheme.palette;
  var accentColor = context.muiTheme.dropDownMenu.accentColor;
  return {
    control: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: '100%',
      position: 'relative',
      width: '100%'
    },
    icon: {
      fill: accentColor,
      position: 'absolute',
      right: spacing.desktopGutterLess,
      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
    },
    iconChildren: {
      fill: 'inherit'
    },
    label: {
      color: disabled ? palette.disabledColor : palette.textColor,
      height: spacing.desktopToolbarHeight + 'px',
      lineHeight: spacing.desktopToolbarHeight + 'px',
      overflow: 'hidden',
      opacity: 1,
      position: 'relative',
      paddingLeft: spacing.desktopGutter,
      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
      textOverflow: 'ellipsis',
      top: 0,
      whiteSpace: 'nowrap'
    },
    labelWhenOpen: {
      opacity: 0,
      top: spacing.desktopToolbarHeight / 8
    },
    root: {
      display: 'inline-block',
      fontSize: spacing.desktopDropDownMenuFontSize,
      height: spacing.desktopSubheaderHeight,
      fontFamily: context.muiTheme.baseTheme.fontFamily,
      outline: 'none',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },
    rootWhenOpen: {
      opacity: 1
    },
    underline: {
      borderTop: 'solid 1px ' + accentColor,
      bottom: 1,
      left: 0,
      margin: '-1px ' + spacing.desktopGutter + 'px',
      right: 0,
      position: 'absolute'
    }
  };
}

var DropDownMenu = function (_Component) {
  (0, _inherits3.default)(DropDownMenu, _Component);

  function DropDownMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropDownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleClickControl = function (event) {
      event.preventDefault();
      if (!_this.props.disabled) {
        _this.setState({
          open: !_this.state.open,
          anchorEl: _this.rootNode
        });
      }
    }, _this.handleRequestCloseMenu = function () {
      _this.close(false);
    }, _this.handleEscKeyDownMenu = function () {
      _this.close(true);
    }, _this.handleKeyDown = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'up':
        case 'down':
        case 'space':
        case 'enter':
          event.preventDefault();
          _this.setState({
            open: true,
            anchorEl: _this.rootNode
          });
          break;
      }
    }, _this.handleItemClick = function (event, child, index) {
      if (_this.props.multiple) {
        if (!_this.state.open) {
          _this.setState({ open: true });
        }
      } else {
        event.persist();
        _this.setState({
          open: false
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(event, index, child.props.value);
          }

          _this.close(_events2.default.isKeyboard(event));
        });
      }
    }, _this.handleChange = function (event, value) {
      if (_this.props.multiple && _this.props.onChange) {
        _this.props.onChange(event, undefined, value);
      }
    }, _this.close = function (isKeyboard) {
      _this.setState({
        open: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }

        if (isKeyboard) {
          var dropArrow = _this.arrowNode;
          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
          dropNode.focus();
          dropArrow.setKeyboardFocus(true);
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.


  (0, _createClass3.default)(DropDownMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (this.props.openImmediately) {
        // TODO: Temporary fix to make openImmediately work with popover.
        /* eslint-disable react/no-did-mount-set-state */
        setTimeout(function () {
          return _this2.setState({
            open: true,
            anchorEl: _this2.rootNode
          });
        }, 0);
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
    }
  }, {
    key: 'getInputNode',


    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    value: function getInputNode() {
      var _this3 = this;

      var rootNode = this.rootNode;

      rootNode.focus = function () {
        if (!_this3.props.disabled) {
          _this3.setState({
            open: !_this3.state.open,
            anchorEl: _this3.rootNode
          });
        }
      };

      return rootNode;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = this.rootNode;
      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
        el.style.width = 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          animated = _props.animated,
          animation = _props.animation,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyleProp = _props.menuStyle,
          selectionRenderer = _props.selectionRenderer,
          onClose = _props.onClose,
          openImmediately = _props.openImmediately,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          style = _props.style,
          underlineStyle = _props.underlineStyle,
          value = _props.value,
          iconButton = _props.iconButton,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
      var _state = this.state,
          anchorEl = _state.anchorEl,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var displayValue = '';
      if (!multiple) {
        _react2.default.Children.forEach(children, function (child) {
          if (child && value === child.props.value) {
            if (selectionRenderer) {
              displayValue = selectionRenderer(value, child);
            } else {
              // This will need to be improved (in case primaryText is a node)
              displayValue = child.props.label || child.props.primaryText;
            }
          }
        });
      } else {
        var values = [];
        var selectionRendererChildren = [];
        _react2.default.Children.forEach(children, function (child) {
          if (child && value && value.indexOf(child.props.value) > -1) {
            if (selectionRenderer) {
              values.push(child.props.value);
              selectionRendererChildren.push(child);
            } else {
              values.push(child.props.label || child.props.primaryText);
            }
          }
        });

        displayValue = [];
        if (selectionRenderer) {
          displayValue = selectionRenderer(values, selectionRendererChildren);
        } else {
          displayValue = values.join(', ');
        }
      }

      var menuStyle = void 0;
      if (anchorEl && !autoWidth) {
        menuStyle = (0, _simpleAssign2.default)({
          width: anchorEl.clientWidth
        }, menuStyleProp);
      } else {
        menuStyle = menuStyleProp;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
        }),
        _react2.default.createElement(
          _ClearFix2.default,
          { style: styles.control, onClick: this.handleClickControl },
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
            displayValue
          ),
          _react2.default.createElement(
            _IconButton2.default,
            {
              disabled: disabled,
              onKeyDown: this.handleKeyDown,
              ref: function ref(node) {
                _this4.arrowNode = node;
              },
              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
              iconStyle: styles.iconChildren
            },
            iconButton
          ),
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            anchorEl: anchorEl,
            animation: animation || _PopoverAnimationVertical2.default,
            open: open,
            animated: animated,
            onRequestClose: this.handleRequestCloseMenu
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              multiple: multiple,
              maxHeight: maxHeight,
              desktop: true,
              value: value,
              onEscKeyDown: this.handleEscKeyDownMenu,
              style: menuStyle,
              listStyle: listStyle,
              onItemClick: this.handleItemClick,
              onChange: this.handleChange,
              menuItemStyle: menuItemStyle,
              selectedMenuItemStyle: selectedMenuItemStyle,
              autoWidth: autoWidth,
              width: !autoWidth && menuStyle ? menuStyle.width : null
            },
            children
          )
        )
      );
    }
  }]);
  return DropDownMenu;
}(_react.Component);

DropDownMenu.muiName = 'DropDownMenu';
DropDownMenu.defaultProps = {
  animated: true,
  autoWidth: true,
  disabled: false,
  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
  openImmediately: false,
  maxHeight: 500,
  multiple: false,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
DropDownMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DropDownMenu.propTypes =  false ? {
  /**
   * This is the point on the anchor that the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * The width will automatically be set according to the items inside the menu.
   * To control this width in css instead, set this prop to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
   * prop `label` that value will be used to render the representation of that
   * item within the field.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the menu.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides default `SvgIcon` dropdown arrow component.
   */
  iconButton: _propTypes2.default.node,
  /**
   * Overrides the styles of icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of label when the `DropDownMenu` is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * The style object to use to override underlying list style.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the `Menu` when it is displayed.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {object} event Click event targeting the menu item that was clicked.
   * @param {number} key The index of the clicked menu item in the `children` collection.
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is closed.
   */
  onClose: _propTypes2.default.func,
  /**
   * Set to true to have the `DropDownMenu` automatically open on mount.
   */
  openImmediately: _propTypes2.default.bool,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * Overrides the inline-styles of the underline.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = DropDownMenu;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BeforeAfterWrapper = __webpack_require__(1087);

var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  before: {
    content: "' '",
    display: 'table'
  },
  after: {
    content: "' '",
    clear: 'both',
    display: 'table'
  }
};

var ClearFix = function ClearFix(_ref) {
  var style = _ref.style,
      children = _ref.children,
      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
  return _react2.default.createElement(
    _BeforeAfterWrapper2.default,
    (0, _extends3.default)({}, other, {
      beforeStyle: styles.before,
      afterStyle: styles.after,
      style: style
    }),
    children
  );
};

ClearFix.muiName = 'ClearFix';

ClearFix.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = ClearFix;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var styles = {
  box: {
    boxSizing: 'border-box'
  }
};

var BeforeAfterWrapper = function (_Component) {
  (0, _inherits3.default)(BeforeAfterWrapper, _Component);

  function BeforeAfterWrapper() {
    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(BeforeAfterWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          beforeStyle = _props.beforeStyle,
          afterStyle = _props.afterStyle,
          beforeElementType = _props.beforeElementType,
          afterElementType = _props.afterElementType,
          elementType = _props.elementType,
          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var beforeElement = void 0;
      var afterElement = void 0;

      if (beforeStyle) {
        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
          key: '::before'
        });
      }

      if (afterStyle) {
        afterElement = _react2.default.createElement(this.props.afterElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
          key: '::after'
        });
      }

      var children = [beforeElement, this.props.children, afterElement];

      var props = other;
      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));

      return _react2.default.createElement(this.props.elementType, props, children);
    }
  }]);
  return BeforeAfterWrapper;
}(_react.Component);

BeforeAfterWrapper.defaultProps = {
  beforeElementType: 'div',
  afterElementType: 'div',
  elementType: 'div'
};
BeforeAfterWrapper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
BeforeAfterWrapper.propTypes =  false ? {
  afterElementType: _propTypes2.default.string,
  afterStyle: _propTypes2.default.object,
  beforeElementType: _propTypes2.default.string,
  beforeStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  elementType: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = BeforeAfterWrapper;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1089);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./FilterMultiSelect.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./FilterMultiSelect.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".FilterMultiSelect {\n    top: 22px;\n    height: 24px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n}\n\n.FilterMultiSelect-item > div > div {\n    padding-left: 32px!important;\n    padding-right: 8px!important;\n}\n\n.FilterMultiSelect-item svg {\n    left: 5px!important;\n    top: 0!important;\n}\n\n", ""]);

// exports


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1091);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./ColumnHeader.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./ColumnHeader.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".ColumnHeader {\n    position: relative;\n}\n\n.ColumnHeader-label {\n    display: inline-block;\n    position: absolute;\n    top: 7px;\n    left: 0;\n    right: 15px;\n    user-select: none;\n    overflow: hidden;\n}\n\n.ColumnHeader svg {\n    position: absolute;\n    top: 5px;\n    right: 0;\n}", ""]);

// exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d3Color = __webpack_require__(657);

__webpack_require__(1095);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorCell = function ColorCell(_ref) {
    var cellData = _ref.cellData;

    var style = {
        backgroundColor: cellData,
        color: (0, _d3Color.hcl)(cellData).l < 70 ? '#fff' : '#000'
    };

    return _react2.default.createElement(
        'div',
        { className: 'ColorCell', style: style },
        cellData.toLowerCase()
    );
};

ColorCell.propTypes = {
    cellData: _propTypes2.default.string.isRequired
};

exports.default = ColorCell;

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(658);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(658);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1096);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./ColorCell.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./ColorCell.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".ColorCell {\n    height: 32px;\n    line-height: 32px;\n    text-align: center;\n}", ""]);

// exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1098);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./DataTable.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./DataTable.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports
exports.i(__webpack_require__(1099), "");

// module
exports.push([module.i, ".DataTable {\n    font-size: 11px;\n    font-family: Roboto, sans-serif;\n    overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerRow {\n    position: relative;\n    background-color: #eee;\n    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 2px;\n    z-index: 10;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n    display: inline-block;\n    position: absolute;\n    top: 7px;\n    left: 10px;\n    right: 15px;\n    user-select: none;\n    overflow: hidden;\n}\n\n.ReactVirtualized__Table__sortableHeaderIcon {\n    position: absolute;\n    top: 5px;\n    right: 0;\n}\n\n.ReactVirtualized__Table__headerColumn {\n    height: 48px;\n    margin-bottom: 2px;\n    position: relative;\n}\n\n.ReactVirtualized__Table__row {\n    position: relative;\n    border-bottom: 1px solid #e0e0e0;\n    cursor: pointer;\n    z-index: 9;\n}\n\n.ReactVirtualized__Table__row:hover {\n    background-color: #fafafa;\n}\n\n.ReactVirtualized__Table__rowColumn.right {\n    text-align: right;\n}\n", ""]);

// exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, "/* Collection default theme */\n\n.ReactVirtualized__Collection {\n}\n\n.ReactVirtualized__Collection__innerScrollContainer {\n}\n\n/* Grid default theme */\n\n.ReactVirtualized__Grid {\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n}\n\n/* Table default theme */\n\n.ReactVirtualized__Table {\n}\n\n.ReactVirtualized__Table__Grid {\n}\n\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 24px;\n          flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n\n.ReactVirtualized__List {\n}", ""]);

// exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1101);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./BottomPanel.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./BottomPanel.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".BottomPanel {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 1040;\n    background: #fff;\n    box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n}\n\n.BottomPanel-close {\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    z-index: 100;\n    cursor: pointer;\n}", ""]);

// exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _EventDialog = __webpack_require__(1103);

var _EventDialog2 = _interopRequireDefault(_EventDialog);

var _FacilityDialog = __webpack_require__(1182);

var _FacilityDialog2 = _interopRequireDefault(_FacilityDialog);

var _ThematicDialog = __webpack_require__(1186);

var _ThematicDialog2 = _interopRequireDefault(_ThematicDialog);

var _BoundaryDialog = __webpack_require__(1218);

var _BoundaryDialog2 = _interopRequireDefault(_BoundaryDialog);

var _EarthEngineDialog = __webpack_require__(1219);

var _EarthEngineDialog2 = _interopRequireDefault(_EarthEngineDialog);

var _layers = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var layerType = {
    event: _EventDialog2.default,
    facility: _FacilityDialog2.default,
    thematic: _ThematicDialog2.default,
    boundary: _BoundaryDialog2.default,
    earthEngine: _EarthEngineDialog2.default
};

var layerName = {
    event: 'event',
    facility: 'facility',
    thematic: 'thematic',
    boundary: 'boundary',
    earthEngine: 'Earth Engine'
};

var styles = {
    content: {
        minWidth: 400,
        maxWidth: 600
    },
    title: {
        padding: '16px 24px 0',
        fontSize: 16,
        fontWeight: 'bold'
    },
    body: {
        padding: '0 24px',
        minHeight: 300
    }
};

var LayerEdit = function (_Component) {
    _inherits(LayerEdit, _Component);

    function LayerEdit() {
        _classCallCheck(this, LayerEdit);

        return _possibleConstructorReturn(this, (LayerEdit.__proto__ || Object.getPrototypeOf(LayerEdit)).apply(this, arguments));
    }

    _createClass(LayerEdit, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                layer = _props.layer,
                loadLayer = _props.loadLayer;


            if (layer && layer.layer === 'external') {
                // External layers has no edit widget
                loadLayer(_extends({}, layer));
            }
        }
    }, {
        key: 'loadLayer',
        value: function loadLayer() {
            var _props2 = this.props,
                layer = _props2.layer,
                loadLayer = _props2.loadLayer;


            if (this.layerContainer.getWrappedInstance().validate()) {
                // TODO: Better pattern?
                loadLayer(layer);

                this.closeDialog();
            }
        }
    }, {
        key: 'closeDialog',
        value: function closeDialog() {
            this.props.cancelLayer();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                layer = _props3.layer,
                cancelLayer = _props3.cancelLayer;


            if (!layer) {
                return null;
            }

            var type = layer.layer;
            var name = layerName[type];
            var LayerDialog = layerType[type];

            if (!LayerDialog) {
                return null;
            }

            var title = _i18next2.default.t(layer.id ? 'Edit ' + name + ' layer' : 'Add new ' + name + ' layer');

            return _react2.default.createElement(
                _Dialog2.default,
                {
                    title: title,
                    contentStyle: styles.content,
                    bodyStyle: styles.body,
                    titleStyle: styles.title,
                    open: true,
                    actions: [_react2.default.createElement(
                        _Button2.default,
                        {
                            color: 'primary',
                            onClick: function onClick() {
                                return cancelLayer();
                            },
                            selector: 'cancel'
                        },
                        _i18next2.default.t('Cancel')
                    ), _react2.default.createElement(
                        _Button2.default,
                        {
                            color: 'primary',
                            onClick: function onClick() {
                                return _this2.loadLayer();
                            },
                            selector: 'update'
                        },
                        _i18next2.default.t(layer.id ? _i18next2.default.t('Update layer') : _i18next2.default.t('Add layer'))
                    )]
                },
                _react2.default.createElement(LayerDialog, _extends({}, layer, {
                    ref: function ref(container) {
                        return _this2.layerContainer = container;
                    }
                }))
            );
        }
    }]);

    return LayerEdit;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        layer: state.layerEdit
    };
}, { loadLayer: _layers.loadLayer, cancelLayer: _layers.cancelLayer })(LayerEdit);

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Tabs = __webpack_require__(240);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _ProgramSelect = __webpack_require__(659);

var _ProgramSelect2 = _interopRequireDefault(_ProgramSelect);

var _ProgramStageSelect = __webpack_require__(1109);

var _ProgramStageSelect2 = _interopRequireDefault(_ProgramStageSelect);

var _RelativePeriodSelect = __webpack_require__(661);

var _RelativePeriodSelect2 = _interopRequireDefault(_RelativePeriodSelect);

var _DatePicker = __webpack_require__(662);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _FilterGroup = __webpack_require__(1122);

var _FilterGroup2 = _interopRequireDefault(_FilterGroup);

var _ImageSelect = __webpack_require__(1129);

var _ImageSelect2 = _interopRequireDefault(_ImageSelect);

var _DataItemSelect = __webpack_require__(663);

var _DataItemSelect2 = _interopRequireDefault(_DataItemSelect);

var _DataItemStyle = __webpack_require__(1132);

var _DataItemStyle2 = _interopRequireDefault(_DataItemStyle);

var _CoordinateField = __webpack_require__(1169);

var _CoordinateField2 = _interopRequireDefault(_CoordinateField);

var _ColorPicker = __webpack_require__(546);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _OrgUnitTree = __webpack_require__(276);

var _OrgUnitTree2 = _interopRequireDefault(_OrgUnitTree);

var _UserOrgUnitsSelect = __webpack_require__(277);

var _UserOrgUnitsSelect2 = _interopRequireDefault(_UserOrgUnitsSelect);

var _SelectedOrgUnits = __webpack_require__(1181);

var _SelectedOrgUnits2 = _interopRequireDefault(_SelectedOrgUnits);

var _layers = __webpack_require__(68);

var _LayerDialogStyles = __webpack_require__(242);

var _layerEdit = __webpack_require__(60);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _extends({}, _LayerDialogStyles.layerDialogStyles, {
    colorLabel: {
        color: 'rgba(0, 0, 0, 0.3)',
        fontSize: 12,
        paddingBottom: 6,
        marginTop: -2
    },
    image: {
        width: '50%',
        float: 'left',
        boxSizing: 'border-box',
        padding: '12px 12px 0 3px'
    }
});

var EventDialog = exports.EventDialog = function (_Component) {
    _inherits(EventDialog, _Component);

    function EventDialog(props, context) {
        _classCallCheck(this, EventDialog);

        var _this = _possibleConstructorReturn(this, (EventDialog.__proto__ || Object.getPrototypeOf(EventDialog)).call(this, props, context));

        _this.state = {
            tab: 'data'
        };
        return _this;
    }

    _createClass(EventDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                filters = _props.filters,
                startDate = _props.startDate,
                endDate = _props.endDate,
                setStartDate = _props.setStartDate,
                setEndDate = _props.setEndDate;

            var period = (0, _analytics.getPeriodFromFilters)(filters);

            if (!period && !startDate && !endDate) {
                // Set default period (last year)
                setStartDate(_layers.EVENT_START_DATE);
                setEndDate(_layers.EVENT_END_DATE);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                classes = _props2.classes,
                _props2$columns = _props2.columns,
                columns = _props2$columns === undefined ? [] : _props2$columns,
                colorScale = _props2.colorScale,
                endDate = _props2.endDate,
                eventClustering = _props2.eventClustering,
                eventCoordinateField = _props2.eventCoordinateField,
                eventPointColor = _props2.eventPointColor,
                eventPointRadius = _props2.eventPointRadius,
                _props2$filters = _props2.filters,
                filters = _props2$filters === undefined ? [] : _props2$filters,
                method = _props2.method,
                program = _props2.program,
                programStage = _props2.programStage,
                _props2$rows = _props2.rows,
                rows = _props2$rows === undefined ? [] : _props2$rows,
                startDate = _props2.startDate,
                styleDataItem = _props2.styleDataItem;
            var _props3 = this.props,
                setProgram = _props3.setProgram,
                setProgramStage = _props3.setProgramStage,
                setStyleDataItem = _props3.setStyleDataItem,
                setEventCoordinateField = _props3.setEventCoordinateField,
                setEventClustering = _props3.setEventClustering,
                setEventPointColor = _props3.setEventPointColor,
                setEventPointRadius = _props3.setEventPointRadius,
                setUserOrgUnits = _props3.setUserOrgUnits,
                toggleOrganisationUnit = _props3.toggleOrganisationUnit,
                setPeriod = _props3.setPeriod,
                setStartDate = _props3.setStartDate,
                setEndDate = _props3.setEndDate;
            var _state = this.state,
                tab = _state.tab,
                programError = _state.programError,
                programStageError = _state.programStageError,
                orgUnitsError = _state.orgUnitsError;


            var period = (0, _analytics.getPeriodFromFilters)(filters) || {
                id: 'START_END_DATES'
            };
            var selectedUserOrgUnits = (0, _analytics.getUserOrgUnitsFromRows)(rows);
            var allowStyleByDataItem = false; // TODO: Remove check

            return _react2.default.createElement(
                _Tabs.Tabs,
                {
                    style: styles.tabs,
                    tabItemContainerStyle: styles.tabBar,
                    value: tab,
                    onChange: function onChange(tab) {
                        return _this2.setState({ tab: tab });
                    }
                },
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'data', label: _i18next2.default.t('data') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_ProgramSelect2.default, {
                            program: program,
                            onChange: setProgram,
                            style: styles.select,
                            errorText: programError
                        }),
                        _react2.default.createElement(_ProgramStageSelect2.default, {
                            program: program,
                            programStage: programStage,
                            onChange: setProgramStage,
                            style: styles.select,
                            errorText: programStageError
                        }),
                        _react2.default.createElement(_CoordinateField2.default, {
                            program: program,
                            programStage: programStage,
                            value: eventCoordinateField,
                            onChange: setEventCoordinateField,
                            style: styles.select
                        })
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'period', label: _i18next2.default.t('period') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_RelativePeriodSelect2.default, {
                            period: period,
                            startEndDates: true,
                            onChange: setPeriod,
                            style: styles.select
                        }),
                        period.id === 'START_END_DATES' && [_react2.default.createElement(_DatePicker2.default, {
                            key: 'startdate',
                            label: _i18next2.default.t('Start date'),
                            value: startDate,
                            'default': _layers.EVENT_START_DATE,
                            onChange: setStartDate,
                            style: styles.select
                        }), _react2.default.createElement(_DatePicker2.default, {
                            key: 'enddate',
                            label: _i18next2.default.t('End date'),
                            value: endDate,
                            'default': _layers.EVENT_END_DATE,
                            onChange: setEndDate,
                            style: styles.select
                        })]
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'filter', label: _i18next2.default.t('Filter') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(_FilterGroup2.default, {
                            program: program,
                            programStage: programStage,
                            filters: columns.filter(function (c) {
                                return c.filter !== undefined;
                            })
                        })
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'orgunits', label: _i18next2.default.t('Org units') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexRowFlow },
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitTree2.default, {
                                selected: (0, _analytics.getOrgUnitNodesFromRows)(rows),
                                onClick: toggleOrganisationUnit,
                                disabled: selectedUserOrgUnits.length ? true : false,
                                selectRootAsDefault: (0, _analytics.getOrgUnitsFromRows)(rows).length === 0
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_UserOrgUnitsSelect2.default, {
                                selected: selectedUserOrgUnits,
                                onChange: setUserOrgUnits
                            }),
                            _react2.default.createElement(_SelectedOrgUnits2.default, {
                                rows: rows,
                                units: _i18next2.default.t('Events'),
                                error: orgUnitsError
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'style', label: _i18next2.default.t('Style') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(
                            'div',
                            { style: styles.select },
                            _react2.default.createElement(_ImageSelect2.default, {
                                id: 'cluster',
                                img: 'images/cluster.png',
                                title: _i18next2.default.t('Group events'),
                                onClick: function onClick() {
                                    return setEventClustering(true);
                                },
                                isSelected: eventClustering,
                                style: styles.image
                            }),
                            _react2.default.createElement(_ImageSelect2.default, {
                                id: 'nocluster',
                                img: 'images/nocluster.png',
                                title: _i18next2.default.t('View all events'),
                                onClick: function onClick() {
                                    return setEventClustering(false);
                                },
                                isSelected: !eventClustering,
                                style: styles.image
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: { marginLeft: 3 } },
                            _react2.default.createElement(
                                'div',
                                {
                                    style: {
                                        marginTop: 20,
                                        marginRight: 20,
                                        float: 'left'
                                    }
                                },
                                _react2.default.createElement(
                                    'div',
                                    { style: styles.colorLabel },
                                    _i18next2.default.t('Color')
                                ),
                                _react2.default.createElement(_ColorPicker2.default, {
                                    color: eventPointColor || _layers.EVENT_COLOR,
                                    onChange: setEventPointColor,
                                    style: { width: 64, height: 32 }
                                })
                            ),
                            _react2.default.createElement(_TextField2.default, {
                                type: 'number',
                                label: _i18next2.default.t('Radius'),
                                value: eventPointRadius || _layers.EVENT_RADIUS,
                                onChange: setEventPointRadius,
                                style: { float: 'left', maxWidth: 100 }
                            })
                        ),
                        allowStyleByDataItem && [
                        // TODO: Remove check
                        _react2.default.createElement(_DataItemSelect2.default, {
                            label: _i18next2.default.t('Style by data item'),
                            program: program,
                            programStage: programStage,
                            allowNone: true,
                            value: styleDataItem ? styleDataItem.id : null,
                            onChange: setStyleDataItem,
                            style: styles.select
                        }), _react2.default.createElement(_DataItemStyle2.default, _extends({
                            method: method,
                            classes: classes,
                            colorScale: colorScale,
                            style: styles.select
                        }, styleDataItem))]
                    )
                )
            );
        }

        // TODO: Add to parent class?

    }, {
        key: 'setErrorState',
        value: function setErrorState(key, message, tab) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, key, message), _defineProperty(_setState, 'tab', tab), _setState));

            return false;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _props4 = this.props,
                program = _props4.program,
                programStage = _props4.programStage,
                rows = _props4.rows;


            if (!program) {
                return this.setErrorState('programError', _i18next2.default.t('Program is required'), 'data');
            }

            if (!programStage) {
                return this.setErrorState('programStageError', _i18next2.default.t('Program stage is required'), 'data');
            }

            if (!(0, _analytics.getOrgUnitsFromRows)(rows).length) {
                return this.setErrorState('orgUnitsError', _i18next2.default.t('No organisation units are selected.'), 'orgunits');
            }

            return true;
        }
    }]);

    return EventDialog;
}(_react.Component);

EventDialog.propTypes = {
    classes: _propTypes2.default.number,
    columns: _propTypes2.default.array
};
exports.default = (0, _reactRedux.connect)(null, {
    setProgram: _layerEdit.setProgram,
    setProgramStage: _layerEdit.setProgramStage,
    setStyleDataItem: _layerEdit.setStyleDataItem,
    setEventCoordinateField: _layerEdit.setEventCoordinateField,
    setEventClustering: _layerEdit.setEventClustering,
    setEventPointColor: _layerEdit.setEventPointColor,
    setEventPointRadius: _layerEdit.setEventPointRadius,
    setUserOrgUnits: _layerEdit.setUserOrgUnits,
    toggleOrganisationUnit: _layerEdit.toggleOrganisationUnit,
    setPeriod: _layerEdit.setPeriod,
    setStartDate: _layerEdit.setStartDate,
    setEndDate: _layerEdit.setEndDate
}, null, {
    withRef: true
})(EventDialog);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    root: {
      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
      fontWeight: 500,
      fontSize: 14,
      width: props.width,
      textTransform: 'uppercase',
      padding: 0
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: props.label && props.icon ? 72 : 48
    }
  };
}

var Tab = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.value, event, _this);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          index = _props.index,
          onActive = _props.onActive,
          onClick = _props.onClick,
          selected = _props.selected,
          label = _props.label,
          buttonStyle = _props.buttonStyle,
          style = _props.style,
          value = _props.value,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);


      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (icon && _react2.default.isValidElement(icon)) {
        iconElement = _react2.default.cloneElement(icon, {
          style: {
            fontSize: 24,
            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
            marginBottom: label ? 5 : 0
          }
        });
      }

      var rippleOpacity = 0.3;
      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style),
          focusRippleColor: rippleColor,
          touchRippleColor: rippleColor,
          focusRippleOpacity: rippleOpacity,
          touchRippleOpacity: rippleOpacity,
          onClick: this.handleClick
        }),
        _react2.default.createElement(
          'div',
          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
          iconElement,
          label
        )
      );
    }
  }]);
  return Tab;
}(_react.Component);

Tab.muiName = 'Tab';
Tab.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tab.propTypes =  false ? {
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  index: _propTypes2.default.any,
  /**
   * Sets the text value of the tab item to the string specified.
   */
  label: _propTypes2.default.node,
  /**
   * Fired when the active tab changes by touch or tap.
   * Use this event to specify any functionality when an active tab changes.
   * For example - we are using this to route to home when the third tab becomes active.
   * This function will always recieve the active tab as it\'s first argument.
   */
  onActive: _propTypes2.default.func,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   * Defines if the current tab is selected or not.
   * The Tabs component is responsible for setting this property.
   */
  selected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If value prop passed to Tabs component, this value prop is also required.
   * It assigns a value to the tab so that it can be selected by the Tabs.
   */
  value: _propTypes2.default.any,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  width: _propTypes2.default.string
} : {};
exports.default = Tab;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

var _TabTemplate = __webpack_require__(1106);

var _TabTemplate2 = _interopRequireDefault(_TabTemplate);

var _InkBar = __webpack_require__(1107);

var _InkBar2 = _interopRequireDefault(_InkBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    tabItemContainer: {
      width: '100%',
      backgroundColor: tabs.backgroundColor,
      whiteSpace: 'nowrap',
      display: 'flex'
    }
  };
}

var Tabs = function (_Component) {
  (0, _inherits3.default)(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabClick = function (value, event, tab) {
      var valueLink = _this.getValueLink(_this.props);
      var index = tab.props.index;

      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
        valueLink.requestChange(value, event, tab);
      }

      _this.setState({ selectedIndex: index });

      if (tab.props.onActive) {
        tab.props.onActive(tab);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var valueLink = this.getValueLink(this.props);
      var initialIndex = this.props.initialSelectedIndex;

      this.setState({
        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps, nextContext) {
      var valueLink = this.getValueLink(newProps);
      var newState = {
        muiTheme: nextContext.muiTheme || this.context.muiTheme
      };

      if (valueLink.value !== undefined) {
        newState.selectedIndex = this.getSelectedIndex(newProps);
      }

      this.setState(newState);
    }
  }, {
    key: 'getTabs',
    value: function getTabs() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var tabs = [];

      _react.Children.forEach(props.children, function (tab) {
        if ((0, _react.isValidElement)(tab)) {
          tabs.push(tab);
        }
      });

      return tabs;
    }
  }, {
    key: 'getTabCount',
    value: function getTabCount() {
      return this.getTabs().length;
    }

    // Do not use outside of this component, it will be removed once valueLink is deprecated

  }, {
    key: 'getValueLink',
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'getSelectedIndex',
    value: function getSelectedIndex(props) {
      var valueLink = this.getValueLink(props);
      var selectedIndex = -1;

      this.getTabs(props).forEach(function (tab, index) {
        if (valueLink.value === tab.props.value) {
          selectedIndex = index;
        }
      });

      return selectedIndex;
    }
  }, {
    key: 'getSelected',
    value: function getSelected(tab, index) {
      var valueLink = this.getValueLink(this.props);
      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contentContainerClassName = _props.contentContainerClassName,
          contentContainerStyle = _props.contentContainerStyle,
          initialSelectedIndex = _props.initialSelectedIndex,
          inkBarStyle = _props.inkBarStyle,
          onChange = _props.onChange,
          style = _props.style,
          tabItemContainerStyle = _props.tabItemContainerStyle,
          tabTemplate = _props.tabTemplate,
          tabTemplateStyle = _props.tabTemplateStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var valueLink = this.getValueLink(this.props);
      var tabValue = valueLink.value;
      var tabContent = [];
      var width = 100 / this.getTabCount();

      var tabs = this.getTabs().map(function (tab, index) {
         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;

         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;

        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
          key: index,
          selected: _this2.getSelected(tab, index),
          style: tabTemplateStyle
        }, tab.props.children) : undefined);

        return (0, _react.cloneElement)(tab, {
          key: index,
          index: index,
          selected: _this2.getSelected(tab, index),
          width: width + '%',
          onClick: _this2.handleTabClick
        });
      });

      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;

      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
        left: width * realSelectedIndex + '%',
        width: width + '%',
        style: inkBarStyle
      }) : null;

      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
          tabs
        ),
        _react2.default.createElement(
          'div',
          { style: { width: inkBarContainerWidth } },
          inkBar
        ),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
            className: contentContainerClassName
          },
          tabContent
        )
      );
    }
  }]);
  return Tabs;
}(_react.Component);

Tabs.defaultProps = {
  initialSelectedIndex: 0,
  onChange: function onChange() {}
};
Tabs.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tabs.propTypes =  false ? {
  /**
   * Should be used to pass `Tab` components.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The css class name of the content's container.
   */
  contentContainerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content's container.
   */
  contentContainerStyle: _propTypes2.default.object,
  /**
   * Specify initial visible tab index.
   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
   * `initialSelectedIndex` will revert back to default.
   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
   */
  initialSelectedIndex: _propTypes2.default.number,
  /**
   * Override the inline-styles of the InkBar.
   */
  inkBarStyle: _propTypes2.default.object,
  /**
   * Called when the selected value change.
   */
  onChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the tab-labels container.
   */
  tabItemContainerStyle: _propTypes2.default.object,
  /**
   * Override the default tab template used to wrap the content of each tab element.
   */
  tabTemplate: _propTypes2.default.func,
  /**
   * Override the inline-styles of the tab template.
   */
  tabTemplateStyle: _propTypes2.default.object,
  /**
   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
   */
  value: _propTypes2.default.any
} : {};
exports.default = Tabs;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  width: '100%',
  position: 'relative',
  textAlign: 'initial'
};

var TabTemplate = function TabTemplate(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      style = _ref.style;

  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
  if (!selected) {
    templateStyle.height = 0;
    templateStyle.overflow = 'hidden';
  }

  return _react2.default.createElement(
    'div',
    { style: templateStyle },
    children
  );
};

TabTemplate.propTypes =  false ? {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};

exports.default = TabTemplate;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      inkBar = _context$muiTheme.inkBar,
      isRtl = _context$muiTheme.isRtl;


  return {
    root: {
      left: props.left,
      width: props.width,
      bottom: 0,
      display: 'block',
      backgroundColor: props.color || inkBar.backgroundColor,
      height: 2,
      marginTop: -2,
      position: 'relative',
      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
    }
  };
}

var InkBar = function (_Component) {
  (0, _inherits3.default)(InkBar, _Component);

  function InkBar() {
    (0, _classCallCheck3.default)(this, InkBar);
    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(InkBar, [{
    key: 'render',
    value: function render() {
      var style = this.props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
    }
  }]);
  return InkBar;
}(_react.Component);

InkBar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
InkBar.propTypes =  false ? {
  color: _propTypes2.default.string,
  left: _propTypes2.default.string.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  width: _propTypes2.default.string.isRequired
} : {};
exports.default = InkBar;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return clampedValue / (max - min);
}

function getArcLength(fraction, props) {
  return fraction * Math.PI * (props.size - props.thickness);
}

function getStyles(props, context) {
  var max = props.max,
      min = props.min,
      size = props.size,
      value = props.value;
  var palette = context.muiTheme.baseTheme.palette;


  var styles = {
    root: {
      position: 'relative',
      display: 'inline-block',
      width: size,
      height: size
    },
    wrapper: {
      width: size,
      height: size,
      display: 'inline-block',
      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
      transitionTimingFunction: 'linear'
    },
    svg: {
      width: size,
      height: size,
      position: 'relative'
    },
    path: {
      stroke: props.color || palette.primary1Color,
      strokeLinecap: 'round',
      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
    }
  };

  if (props.mode === 'determinate') {
    var relVal = getRelativeValue(value, min, max);
    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
  }

  return styles;
}

var CircularProgress = function (_Component) {
  (0, _inherits3.default)(CircularProgress, _Component);

  function CircularProgress() {
    (0, _classCallCheck3.default)(this, CircularProgress);
    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircularProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path) {
      var _this2 = this;

      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.props.mode !== 'indeterminate') return;

      step %= 3;

      if (step === 0) {
        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = 0;
        path.style.transitionDuration = '0ms';
      } else if (step === 1) {
        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
        path.style.transitionDuration = '750ms';
      } else {
        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = getArcLength(-1, this.props);
        path.style.transitionDuration = '850ms';
      }

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, step + 1);
      }, step ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          innerStyle = _props.innerStyle,
          size = _props.size,
          thickness = _props.thickness,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
          _react2.default.createElement(
            'svg',
            {
              viewBox: '0 0 ' + size + ' ' + size,
              style: prepareStyles(styles.svg)
            },
            _react2.default.createElement('circle', {
              ref: 'path',
              style: prepareStyles(styles.path),
              cx: size / 2,
              cy: size / 2,
              r: (size - thickness) / 2,
              fill: 'none',
              strokeWidth: thickness,
              strokeMiterlimit: '20'
            })
          )
        )
      );
    }
  }]);
  return CircularProgress;
}(_react.Component);

CircularProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100,
  size: 40,
  thickness: 3.5
};
CircularProgress.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircularProgress.propTypes =  false ? {
  /**
   * Override the progress's color.
   */
  color: _propTypes2.default.string,
  /**
   * Style for inner wrapper div.
   */
  innerStyle: _propTypes2.default.object,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes2.default.number,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * The diameter of the progress in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Stroke width in pixels.
   */
  thickness: _propTypes2.default.number,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes2.default.number
} : {};
exports.default = CircularProgress;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgramStageSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _programs = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgramStageSelect = exports.ProgramStageSelect = function (_Component) {
    _inherits(ProgramStageSelect, _Component);

    function ProgramStageSelect() {
        _classCallCheck(this, ProgramStageSelect);

        return _possibleConstructorReturn(this, (ProgramStageSelect.__proto__ || Object.getPrototypeOf(ProgramStageSelect)).apply(this, arguments));
    }

    _createClass(ProgramStageSelect, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                program = _props.program,
                programStage = _props.programStage,
                programStages = _props.programStages,
                loadProgramStages = _props.loadProgramStages,
                onChange = _props.onChange;


            if (program) {
                var stages = programStages[program.id];

                // Load program stages when program is selected
                if (!stages) {
                    loadProgramStages(program.id);
                }

                // Select first program stage if only one
                if (program && !programStage && stages && stages.length === 1) {
                    onChange(stages[0]);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                program = _props2.program,
                programStage = _props2.programStage,
                programStages = _props2.programStages,
                onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;


            if (!program) {
                return null;
            }

            var items = programStages[program.id];

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Stage'),
                loading: items ? false : true,
                items: items,
                value: programStage ? programStage.id : null,
                onChange: onChange,
                style: style,
                errorText: !programStage && errorText ? errorText : null
            });
        }
    }]);

    return ProgramStageSelect;
}(_react.Component);

ProgramStageSelect.propTypes = {
    program: _propTypes2.default.object,
    programStage: _propTypes2.default.object,
    programStages: _propTypes2.default.object,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programStages: state.programStages
    };
}, { loadProgramStages: _programs.loadProgramStages })(ProgramStageSelect);

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DatePicker = __webpack_require__(1111);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DatePicker2.default;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateUtils = __webpack_require__(241);

var _DatePickerDialog = __webpack_require__(1112);

var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);

var _TextField = __webpack_require__(273);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = function (_Component) {
  (0, _inherits3.default)(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      date: undefined
    }, _this.handleAccept = function (date) {
      if (!_this.isControlled()) {
        _this.setState({
          date: date
        });
      }
      if (_this.props.onChange) {
        _this.props.onChange(null, date);
      }
    }, _this.handleFocus = function (event) {
      event.target.blur();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (!_this.props.disabled) {
        setTimeout(function () {
          _this.openDialog();
        }, 0);
      }
    }, _this.formatDate = function (date) {
      if (_this.props.locale) {
        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
        return new DateTimeFormat(_this.props.locale, {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        }).format(date);
      } else {
        return (0, _dateUtils.formatIso)(date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DatePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlled()) {
        var newDate = this.getControlledDate(nextProps);
        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
          this.setState({
            date: newDate
          });
        }
      }
    }
  }, {
    key: 'getDate',
    value: function getDate() {
      return this.state.date;
    }

    /**
     * Open the date-picker dialog programmatically from a parent.
     */

  }, {
    key: 'openDialog',
    value: function openDialog() {
      /**
       * if the date is not selected then set it to new date
       * (get the current system date while doing so)
       * else set it to the currently selected date
       */
      if (this.state.date !== undefined) {
        this.setState({
          dialogDate: this.getDate()
        }, this.refs.dialogWindow.show);
      } else {
        this.setState({
          dialogDate: new Date()
        }, this.refs.dialogWindow.show);
      }
    }

    /**
     * Alias for `openDialog()` for an api consistent with TextField.
     */

  }, {
    key: 'focus',
    value: function focus() {
      this.openDialog();
    }
  }, {
    key: 'isControlled',
    value: function isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'getControlledDate',
    value: function getControlledDate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (props.value instanceof Date) {
        return props.value;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          autoOk = _props.autoOk,
          cancelLabel = _props.cancelLabel,
          className = _props.className,
          container = _props.container,
          defaultDate = _props.defaultDate,
          dialogContainerStyle = _props.dialogContainerStyle,
          disableYearSelection = _props.disableYearSelection,
          firstDayOfWeek = _props.firstDayOfWeek,
          formatDateProp = _props.formatDate,
          locale = _props.locale,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          mode = _props.mode,
          okLabel = _props.okLabel,
          onDismiss = _props.onDismiss,
          onFocus = _props.onFocus,
          onShow = _props.onShow,
          onClick = _props.onClick,
          openToYearSelection = _props.openToYearSelection,
          shouldDisableDate = _props.shouldDisableDate,
          hideCalendarDate = _props.hideCalendarDate,
          style = _props.style,
          textFieldStyle = _props.textFieldStyle,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onClick', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var formatDate = formatDateProp || this.formatDate;

      return _react2.default.createElement(
        'div',
        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
          onFocus: this.handleFocus,
          onClick: this.handleClick,
          ref: 'input',
          style: textFieldStyle,
          value: this.state.date ? formatDate(this.state.date) : ''
        })),
        _react2.default.createElement(_DatePickerDialog2.default, {
          DateTimeFormat: DateTimeFormat,
          autoOk: autoOk,
          cancelLabel: cancelLabel,
          container: container,
          containerStyle: dialogContainerStyle,
          disableYearSelection: disableYearSelection,
          firstDayOfWeek: firstDayOfWeek,
          initialDate: this.state.dialogDate,
          locale: locale,
          maxDate: maxDate,
          minDate: minDate,
          mode: mode,
          okLabel: okLabel,
          onAccept: this.handleAccept,
          onShow: onShow,
          onDismiss: onDismiss,
          ref: 'dialogWindow',
          shouldDisableDate: shouldDisableDate,
          hideCalendarDate: hideCalendarDate,
          openToYearSelection: openToYearSelection,
          utils: utils
        })
      );
    }
  }]);
  return DatePicker;
}(_react.Component);

DatePicker.defaultProps = {
  autoOk: false,
  container: 'dialog',
  disabled: false,
  disableYearSelection: false,
  firstDayOfWeek: 1,
  hideCalendarDate: false,
  style: {},
  openToYearSelection: false
};
DatePicker.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DatePicker.propTypes =  false ? {
  /**
   * Constructor for date formatting for the specified `locale`.
   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
   *
   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
   */
  DateTimeFormat: _propTypes2.default.func,
  /**
   * If true, automatically accept and close the picker on select a date.
   */
  autoOk: _propTypes2.default.bool,
  /**
   * Override the default text of the 'Cancel' button.
   */
  cancelLabel: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Used to control how the Date Picker will be displayed when the input field is focused.
   * `dialog` (default) displays the DatePicker as a dialog with a modal.
   * `inline` displays the DatePicker below the input field (similar to auto complete).
   */
  container: _propTypes2.default.oneOf(['dialog', 'inline']),
  /**
   * This is the initial date value of the component.
   * If either `value` or `valueLink` is provided they will override this
   * prop with `value` taking precedence.
   */
  defaultDate: _propTypes2.default.object,
  /**
   * Override the inline-styles of DatePickerDialog's Container element.
   */
  dialogContainerStyle: _propTypes2.default.object,
  /**
   * Disables the year selection in the date picker.
   */
  disableYearSelection: _propTypes2.default.bool,
  /**
   * Disables the DatePicker.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used to change the first day of week. It varies from
   * Saturday to Monday between different locales.
   * The allowed range is 0 (Sunday) to 6 (Saturday).
   * The default is `1`, Monday, as per ISO 8601.
   */
  firstDayOfWeek: _propTypes2.default.number,
  /**
   * This function is called to format the date displayed in the input field, and should return a string.
   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
   *
   * @param {object} date Date object to be formatted.
   * @returns {any} The formatted date.
   */
  formatDate: _propTypes2.default.func,
  /**
   * Hide date display
   */
  hideCalendarDate: _propTypes2.default.bool,
  /**
   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
   * must provide a `DateTimeFormat` that supports the chosen `locale`.
   */
  locale: _propTypes2.default.string,
  /**
   * The ending of a range of valid dates. The range includes the endDate.
   * The default value is current date + 100 years.
   */
  maxDate: _propTypes2.default.object,
  /**
   * The beginning of a range of valid dates. The range includes the startDate.
   * The default value is current date - 100 years.
   */
  minDate: _propTypes2.default.object,
  /**
   * Tells the component to display the picker in portrait or landscape mode.
   */
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  /**
   * Override the default text of the 'OK' button.
   */
  okLabel: _propTypes2.default.node,
  /**
   * Callback function that is fired when the date value changes.
   *
   * @param {null} null Since there is no particular event associated with the change,
   * the first argument will always be null.
   * @param {object} date The new date.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when a click event occurs on the Date Picker's `TextField`.
   *
   * @param {object} event Click event targeting the `TextField`.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's dialog is dismissed.
   */
  onDismiss: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's `TextField` gains focus.
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's dialog is shown.
   */
  onShow: _propTypes2.default.func,
  /**
   * If true sets the datepicker to open to year selection first.
   */
  openToYearSelection: _propTypes2.default.bool,
  /**
   * Callback function used to determine if a day's entry should be disabled on the calendar.
   *
   * @param {object} day Date object of a day.
   * @returns {boolean} Indicates whether the day should be disabled.
   */
  shouldDisableDate: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of DatePicker's TextField element.
   */
  textFieldStyle: _propTypes2.default.object,
  /**
   * This object should contain methods needed to build the calendar system.
   *
   * Useful for building a custom calendar system. Refer to the
   * [source code](https://github.com/callemall/material-ui/blob/master/src/DatePicker/dateUtils.js)
   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
   * for more information.
   */
  utils: _propTypes2.default.object,
  /**
   * Sets the date for the Date Picker programmatically.
   */
  value: _propTypes2.default.object
} : {};
exports.default = DatePicker;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _Calendar = __webpack_require__(1113);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Popover = __webpack_require__(163);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(529);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _dateUtils = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerDialog = function (_Component) {
  (0, _inherits3.default)(DatePickerDialog, _Component);

  function DatePickerDialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePickerDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.show = function () {
      if (_this.props.onShow && !_this.state.open) {
        _this.props.onShow();
      }

      _this.setState({
        open: true
      });
    }, _this.dismiss = function () {
      if (_this.props.onDismiss && _this.state.open) {
        _this.props.onDismiss();
      }

      _this.setState({
        open: false
      });
    }, _this.handleClickDay = function () {
      if (_this.props.autoOk) {
        setTimeout(_this.handleClickOk, 300);
      }
    }, _this.handleClickCancel = function () {
      _this.dismiss();
    }, _this.handleRequestClose = function () {
      _this.dismiss();
    }, _this.handleClickOk = function () {
      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
      }

      _this.setState({
        open: false
      });
    }, _this.handleWindowKeyUp = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'enter':
          _this.handleClickOk();
          break;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DatePickerDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          autoOk = _props.autoOk,
          cancelLabel = _props.cancelLabel,
          container = _props.container,
          containerStyle = _props.containerStyle,
          disableYearSelection = _props.disableYearSelection,
          initialDate = _props.initialDate,
          firstDayOfWeek = _props.firstDayOfWeek,
          locale = _props.locale,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          mode = _props.mode,
          okLabel = _props.okLabel,
          onAccept = _props.onAccept,
          onDismiss = _props.onDismiss,
          onShow = _props.onShow,
          openToYearSelection = _props.openToYearSelection,
          shouldDisableDate = _props.shouldDisableDate,
          hideCalendarDate = _props.hideCalendarDate,
          style = _props.style,
          animation = _props.animation,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
      var open = this.state.open;


      var styles = {
        dialogContent: {
          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
        },
        dialogBodyContent: {
          padding: 0,
          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
        }
      };

      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { ref: 'root' }),
        _react2.default.createElement(
          Container,
          {
            anchorEl: this.refs.root // For Popover
            , animation: animation || _PopoverAnimationVertical2.default // For Popover
            , bodyStyle: styles.dialogBodyContent,
            contentStyle: styles.dialogContent,
            ref: 'dialog',
            repositionOnUpdate: true,
            open: open,
            onRequestClose: this.handleRequestClose,
            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
          },
          _react2.default.createElement(_reactEventListener2.default, {
            target: 'window',
            onKeyUp: this.handleWindowKeyUp
          }),
          _react2.default.createElement(_Calendar2.default, {
            autoOk: autoOk,
            DateTimeFormat: DateTimeFormat,
            cancelLabel: cancelLabel,
            disableYearSelection: disableYearSelection,
            firstDayOfWeek: firstDayOfWeek,
            initialDate: initialDate,
            locale: locale,
            onClickDay: this.handleClickDay,
            maxDate: maxDate,
            minDate: minDate,
            mode: mode,
            open: open,
            ref: 'calendar',
            onClickCancel: this.handleClickCancel,
            onClickOk: this.handleClickOk,
            okLabel: okLabel,
            openToYearSelection: openToYearSelection,
            shouldDisableDate: shouldDisableDate,
            hideCalendarDate: hideCalendarDate,
            utils: utils
          })
        )
      );
    }
  }]);
  return DatePickerDialog;
}(_react.Component);

DatePickerDialog.defaultProps = {
  DateTimeFormat: _dateUtils.dateTimeFormat,
  cancelLabel: 'Cancel',
  container: 'dialog',
  locale: 'en-US',
  okLabel: 'OK',
  openToYearSelection: false
};
DatePickerDialog.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DatePickerDialog.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func,
  animation: _propTypes2.default.func,
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  container: _propTypes2.default.oneOf(['dialog', 'inline']),
  containerStyle: _propTypes2.default.object,
  disableYearSelection: _propTypes2.default.bool,
  firstDayOfWeek: _propTypes2.default.number,
  hideCalendarDate: _propTypes2.default.bool,
  initialDate: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  okLabel: _propTypes2.default.node,
  onAccept: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func,
  onShow: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  openToYearSelection: _propTypes2.default.bool,
  shouldDisableDate: _propTypes2.default.func,
  style: _propTypes2.default.object,
  utils: _propTypes2.default.object
} : {};
exports.default = DatePickerDialog;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = __webpack_require__(524);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(94);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _CalendarActionButtons = __webpack_require__(1114);

var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);

var _CalendarMonth = __webpack_require__(1115);

var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

var _CalendarYear = __webpack_require__(1117);

var _CalendarYear2 = _interopRequireDefault(_CalendarYear);

var _CalendarToolbar = __webpack_require__(1119);

var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);

var _DateDisplay = __webpack_require__(1121);

var _DateDisplay2 = _interopRequireDefault(_DateDisplay);

var _SlideIn = __webpack_require__(545);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

var _dateUtils = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));

var Calendar = function (_Component) {
  (0, _inherits3.default)(Calendar, _Component);

  function Calendar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayDate: undefined,
      displayMonthDay: undefined,
      selectedDate: undefined,
      transitionDirection: 'left',
      transitionEnter: true
    }, _this.calendarRefs = {}, _this.handleClickDay = function (event, date) {
      _this.setSelectedDate(date);
      if (_this.props.onClickDay) _this.props.onClickDay(event, date);
    }, _this.handleMonthChange = function (months) {
      var nextDirection = _this.context.muiTheme.isRtl ? 'right' : 'left';
      var prevDirection = _this.context.muiTheme.isRtl ? 'left' : 'right';
      var direction = months >= 0 ? nextDirection : prevDirection;
      _this.setState({
        transitionDirection: direction,
        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
      });
    }, _this.handleClickYear = function (event, year) {
      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
      _this.handleClickDateDisplayMonthDay();
    }, _this.handleClickDateDisplayMonthDay = function () {
      _this.setState({
        displayMonthDay: true
      });
    }, _this.handleClickDateDisplayYear = function () {
      _this.setState({
        displayMonthDay: false
      });
    }, _this.handleWindowKeyDown = function (event) {
      if (_this.props.open) {
        var nextArrow = _this.context.muiTheme.isRtl ? 'left' : 'right';
        var prevArrow = _this.context.muiTheme.isRtl ? 'right' : 'left';
        switch ((0, _keycode2.default)(event)) {
          case 'up':
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(-1);
            } else {
              _this.addSelectedDays(-7);
            }
            break;

          case 'down':
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(1);
            } else {
              _this.addSelectedDays(7);
            }
            break;

          case nextArrow:
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(1);
            } else {
              _this.addSelectedDays(1);
            }
            break;

          case prevArrow:
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(-1);
            } else {
              _this.addSelectedDays(-1);
            }
            break;
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
        selectedDate: this.props.initialDate,
        displayMonthDay: !this.props.openToYearSelection
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.initialDate !== this.props.initialDate) {
        var date = nextProps.initialDate || new Date();
        this.setState({
          displayDate: this.props.utils.getFirstDayOfMonth(date),
          selectedDate: date
        });
      }
    }
  }, {
    key: 'getMinDate',
    value: function getMinDate() {
      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
    }
  }, {
    key: 'getMaxDate',
    value: function getMaxDate() {
      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
    }
  }, {
    key: 'getSelectedDate',
    value: function getSelectedDate() {
      return this.state.selectedDate;
    }
  }, {
    key: 'isSelectedDateDisabled',
    value: function isSelectedDateDisabled() {
      if (!this.state.displayMonthDay) {
        return false;
      }

      if (this.calendarRefs.calendar) {
        return this.calendarRefs.calendar.isSelectedDateDisabled();
      } else {
        return false;
      }
    }
  }, {
    key: 'addSelectedDays',
    value: function addSelectedDays(days) {
      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
    }
  }, {
    key: 'addSelectedMonths',
    value: function addSelectedMonths(months) {
      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
    }
  }, {
    key: 'addSelectedYears',
    value: function addSelectedYears(years) {
      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
    }
  }, {
    key: 'setDisplayDate',
    value: function setDisplayDate(date, newSelectedDate) {
      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);

      if (newDisplayDate !== this.state.displayDate) {
        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
        var direction = newDisplayDate > this.state.displayDate ? nextDirection : prevDirection;
        this.setState({
          displayDate: newDisplayDate,
          transitionDirection: direction,
          selectedDate: newSelectedDate || this.state.selectedDate
        });
      }
    }
  }, {
    key: 'setSelectedDate',
    value: function setSelectedDate(date) {
      var adjustedDate = date;
      var minDate = this.getMinDate();
      var maxDate = this.getMaxDate();
      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
        adjustedDate = minDate;
      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
        adjustedDate = maxDate;
      }

      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
      if (newDisplayDate !== this.state.displayDate) {
        this.setDisplayDate(newDisplayDate, adjustedDate);
      } else {
        this.setState({
          selectedDate: adjustedDate
        });
      }
    }
  }, {
    key: 'getToolbarInteractions',
    value: function getToolbarInteractions() {
      return {
        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
      };
    }
  }, {
    key: 'yearSelector',
    value: function yearSelector() {
      if (!this.props.disableYearSelection) {
        return _react2.default.createElement(_CalendarYear2.default, {
          key: 'years',
          DateTimeFormat: this.props.DateTimeFormat,
          locale: this.props.locale,
          onClickYear: this.handleClickYear,
          selectedDate: this.state.selectedDate,
          minDate: this.getMinDate(),
          maxDate: this.getMaxDate(),
          utils: this.props.utils
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var prepareStyles = this.context.muiTheme.prepareStyles;
      var hideCalendarDate = this.props.hideCalendarDate;

      var toolbarInteractions = this.getToolbarInteractions();
      var isLandscape = this.props.mode === 'landscape';
      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;


      var styles = {
        root: {
          color: calendarTextColor,
          userSelect: 'none',
          width: !hideCalendarDate && isLandscape ? 479 : 310
        },
        calendar: {
          display: 'flex',
          flexDirection: 'column'
        },
        calendarContainer: {
          display: 'flex',
          alignContent: 'space-between',
          justifyContent: 'space-between',
          flexDirection: 'column',
          fontSize: 12,
          fontWeight: 400,
          padding: '0px 8px',
          transition: _transitions2.default.easeOut()
        },
        yearContainer: {
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          height: 272,
          marginTop: 10,
          overflow: 'hidden',
          width: 310
        },
        weekTitle: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontWeight: '500',
          height: 20,
          lineHeight: '15px',
          opacity: '0.5',
          textAlign: 'center'
        },
        weekTitleDay: {
          width: 42
        },
        transitionSlide: {
          height: 214
        }
      };

      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);

      var _props = this.props,
          cancelLabel = _props.cancelLabel,
          DateTimeFormat = _props.DateTimeFormat,
          firstDayOfWeek = _props.firstDayOfWeek,
          locale = _props.locale,
          okLabel = _props.okLabel,
          onClickCancel = _props.onClickCancel,
          onClickOk = _props.onClickOk,
          utils = _props.utils;


      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleWindowKeyDown
        }),
        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
          DateTimeFormat: DateTimeFormat,
          disableYearSelection: this.props.disableYearSelection,
          onClickMonthDay: this.handleClickDateDisplayMonthDay,
          onClickYear: this.handleClickDateDisplayYear,
          locale: locale,
          monthDaySelected: this.state.displayMonthDay,
          mode: this.props.mode,
          selectedDate: this.state.selectedDate
        }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.calendar) },
          this.state.displayMonthDay && _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.calendarContainer) },
            _react2.default.createElement(_CalendarToolbar2.default, {
              DateTimeFormat: DateTimeFormat,
              locale: locale,
              displayDate: this.state.displayDate,
              onMonthChange: this.handleMonthChange,
              prevMonth: toolbarInteractions.prevMonth,
              nextMonth: toolbarInteractions.nextMonth
            }),
            _react2.default.createElement(
              'div',
              { style: prepareStyles(styles.weekTitle) },
              daysArray.map(function (event, i) {
                return _react2.default.createElement(
                  'span',
                  { key: i, style: weekTitleDayStyle },
                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
                );
              })
            ),
            _react2.default.createElement(
              _SlideIn2.default,
              { direction: this.state.transitionDirection, style: styles.transitionSlide },
              _react2.default.createElement(_CalendarMonth2.default, {
                DateTimeFormat: DateTimeFormat,
                locale: locale,
                displayDate: this.state.displayDate,
                firstDayOfWeek: this.props.firstDayOfWeek,
                key: this.state.displayDate.toDateString(),
                minDate: this.getMinDate(),
                maxDate: this.getMaxDate(),
                onClickDay: this.handleClickDay,
                ref: function ref(_ref2) {
                  return _this2.calendarRefs.calendar = _ref2;
                },
                selectedDate: this.state.selectedDate,
                shouldDisableDate: this.props.shouldDisableDate,
                utils: utils
              })
            )
          ),
          !this.state.displayMonthDay && _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.yearContainer) },
            this.yearSelector()
          ),
          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
            autoOk: this.props.autoOk,
            cancelLabel: cancelLabel,
            okLabel: okLabel,
            onClickCancel: onClickCancel,
            onClickOk: onClickOk
          })
        )
      );
    }
  }]);
  return Calendar;
}(_react.Component);

Calendar.defaultProps = {
  DateTimeFormat: _dateUtils.dateTimeFormat,
  disableYearSelection: false,
  initialDate: new Date(),
  locale: 'en-US',
  utils: _dateUtils.defaultUtils
};
Calendar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Calendar.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  disableYearSelection: _propTypes2.default.bool,
  firstDayOfWeek: _propTypes2.default.number,
  hideCalendarDate: _propTypes2.default.bool,
  initialDate: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  okLabel: _propTypes2.default.node,
  onClickCancel: _propTypes2.default.func,
  onClickDay: _propTypes2.default.func,
  onClickOk: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  openToYearSelection: _propTypes2.default.bool,
  shouldDisableDate: _propTypes2.default.func,
  utils: _propTypes2.default.object
} : {};
exports.default = Calendar;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatButton = __webpack_require__(162);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarActionButton = function (_Component) {
  (0, _inherits3.default)(CalendarActionButton, _Component);

  function CalendarActionButton() {
    (0, _classCallCheck3.default)(this, CalendarActionButton);
    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CalendarActionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelLabel = _props.cancelLabel,
          okLabel = _props.okLabel;


      var styles = {
        root: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          margin: 0,
          maxHeight: 48,
          padding: 0
        },
        flatButtons: {
          fontsize: 14,
          margin: '4px 8px 8px 0px',
          maxHeight: 36,
          minWidth: 64,
          padding: 0
        }
      };

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(_FlatButton2.default, {
          label: cancelLabel,
          onClick: this.props.onClickCancel,
          primary: true,
          style: styles.flatButtons
        }),
        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
          label: okLabel,
          onClick: this.props.onClickOk,
          primary: true,
          style: styles.flatButtons
        })
      );
    }
  }]);
  return CalendarActionButton;
}(_react.Component);

CalendarActionButton.propTypes =  false ? {
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  okLabel: _propTypes2.default.node,
  onClickCancel: _propTypes2.default.func,
  onClickOk: _propTypes2.default.func
} : {};
exports.default = CalendarActionButton;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateUtils = __webpack_require__(241);

var _DayButton = __webpack_require__(1116);

var _DayButton2 = _interopRequireDefault(_DayButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    fontWeight: 400,
    height: 228,
    lineHeight: 2,
    position: 'relative',
    textAlign: 'center',
    MozPaddingStart: 0
  },
  week: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    height: 34,
    marginBottom: 2
  }
};

var CalendarMonth = function (_Component) {
  (0, _inherits3.default)(CalendarMonth, _Component);

  function CalendarMonth() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarMonth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickDay = function (event, date) {
      if (_this.props.onClickDay) {
        _this.props.onClickDay(event, date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarMonth, [{
    key: 'isSelectedDateDisabled',
    value: function isSelectedDateDisabled() {
      return this.selectedDateDisabled;
    }
  }, {
    key: 'shouldDisableDate',
    value: function shouldDisableDate(day) {
      if (day === null) return false;
      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);

      return disabled;
    }
  }, {
    key: 'getWeekElements',
    value: function getWeekElements() {
      var _this2 = this;

      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);

      return weekArray.map(function (week, i) {
        return _react2.default.createElement(
          'div',
          { key: i, style: styles.week },
          _this2.getDayElements(week, i)
        );
      }, this);
    }
  }, {
    key: 'getDayElements',
    value: function getDayElements(week, i) {
      var _this3 = this;

      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          selectedDate = _props.selectedDate;


      return week.map(function (day, j) {
        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
        var disabled = _this3.shouldDisableDate(day);
        var selected = !disabled && isSameDate;

        if (isSameDate) {
          _this3.selectedDateDisabled = disabled;
        }

        return _react2.default.createElement(_DayButton2.default, {
          DateTimeFormat: DateTimeFormat,
          locale: locale,
          date: day,
          disabled: disabled,
          key: 'db' + (i + j),
          onClick: _this3.handleClickDay,
          selected: selected
        });
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: styles.root },
        this.getWeekElements()
      );
    }
  }]);
  return CalendarMonth;
}(_react.Component);

CalendarMonth.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  autoOk: _propTypes2.default.bool,
  displayDate: _propTypes2.default.object.isRequired,
  firstDayOfWeek: _propTypes2.default.number,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  onClickDay: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  shouldDisableDate: _propTypes2.default.func,
  utils: _propTypes2.default.object.isRequired
} : {};
exports.default = CalendarMonth;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _dateUtils = __webpack_require__(241);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var date = props.date,
      disabled = props.disabled,
      selected = props.selected;
  var hover = state.hover;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      datePicker = _context$muiTheme.datePicker;


  var labelColor = baseTheme.palette.textColor;
  var buttonStateOpacity = 0;
  var buttonStateTransform = 'scale(0)';

  if (hover || selected) {
    labelColor = datePicker.selectTextColor;
    buttonStateOpacity = selected ? 1 : 0.6;
    buttonStateTransform = 'scale(1)';
  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
    labelColor = datePicker.color;
  }

  return {
    root: {
      boxSizing: 'border-box',
      fontWeight: '400',
      opacity: disabled && '0.4',
      padding: '4px 0px',
      position: 'relative',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      width: 42
    },
    label: {
      color: labelColor,
      fontWeight: '400',
      position: 'relative'
    },
    buttonState: {
      backgroundColor: datePicker.selectColor,
      borderRadius: '50%',
      height: 34,
      left: 4,
      opacity: buttonStateOpacity,
      position: 'absolute',
      top: 0,
      transform: buttonStateTransform,
      transition: _transitions2.default.easeOut(),
      width: 34
    }
  };
}

var DayButton = function (_Component) {
  (0, _inherits3.default)(DayButton, _Component);

  function DayButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DayButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.handleMouseEnter = function () {
      if (!_this.props.disabled) {
        _this.setState({ hover: true });
      }
    }, _this.handleMouseLeave = function () {
      if (!_this.props.disabled) {
        _this.setState({ hover: false });
      }
    }, _this.handleClick = function (event) {
      if (!_this.props.disabled && _this.props.onClick) {
        _this.props.onClick(event, _this.props.date);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DayButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          date = _props.date,
          disabled = _props.disabled,
          locale = _props.locale,
          onClick = _props.onClick,
          selected = _props.selected,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onClick', 'selected']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return date ? _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          disableFocusRipple: true,
          disableTouchRipple: true,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleClick,
          style: styles.root
        }),
        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          new DateTimeFormat(locale, {
            day: 'numeric'
          }).format(date)
        )
      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
    }
  }]);
  return DayButton;
}(_react.Component);

DayButton.defaultProps = {
  selected: false,
  disabled: false
};
DayButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DayButton.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  date: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  selected: _propTypes2.default.bool
} : {};
exports.default = DayButton;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _YearButton = __webpack_require__(1118);

var _YearButton2 = _interopRequireDefault(_YearButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarYear = function (_Component) {
  (0, _inherits3.default)(CalendarYear, _Component);

  function CalendarYear() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarYear);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickYear = function (event, year) {
      if (_this.props.onClickYear) {
        _this.props.onClickYear(event, year);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarYear, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToSelectedYear();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToSelectedYear();
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          selectedDate = _props.selectedDate,
          utils = _props.utils;


      var minYear = utils.getYear(minDate);
      var maxYear = utils.getYear(maxDate);
      var years = [];

      for (var year = minYear; year <= maxYear; year++) {
        var selected = utils.getYear(selectedDate) === year;
        var selectedProps = {};
        if (selected) {
          selectedProps.ref = 'selectedYearButton';
        }

        var yearFormated = new DateTimeFormat(locale, {
          year: 'numeric'
        }).format(utils.setYear(selectedDate, year));

        var yearButton = _react2.default.createElement(
          _YearButton2.default,
          (0, _extends3.default)({
            key: 'yb' + year,
            onClick: this.handleClickYear,
            selected: selected,
            year: year,
            utils: utils
          }, selectedProps),
          yearFormated
        );

        years.push(yearButton);
      }

      return years;
    }
  }, {
    key: 'scrollToSelectedYear',
    value: function scrollToSelectedYear() {
      if (this.refs.selectedYearButton === undefined) {
        return;
      }

      var container = _reactDom2.default.findDOMNode(this);
      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);

      var containerHeight = container.clientHeight;
      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;

      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
      container.scrollTop = scrollYOffset;
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;


      var styles = {
        root: {
          backgroundColor: calendarYearBackgroundColor,
          height: 'inherit',
          lineHeight: '35px',
          overflowX: 'hidden',
          overflowY: 'scroll',
          position: 'relative'
        },
        child: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '100%'
        }
      };

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.child) },
          this.getYears()
        )
      );
    }
  }]);
  return CalendarYear;
}(_react.Component);

CalendarYear.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CalendarYear.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object.isRequired,
  minDate: _propTypes2.default.object.isRequired,
  onClickYear: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  utils: _propTypes2.default.object.isRequired,
  wordings: _propTypes2.default.object
} : {};
exports.default = CalendarYear;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(107);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var selected = props.selected,
      year = props.year,
      utils = props.utils;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      datePicker = _context$muiTheme.datePicker;
  var hover = state.hover;


  return {
    root: {
      boxSizing: 'border-box',
      color: year === utils.getYear(new Date()) && datePicker.color,
      display: 'block',
      fontSize: 14,
      margin: '0 auto',
      position: 'relative',
      textAlign: 'center',
      lineHeight: 'inherit',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated)
    },
    label: {
      alignSelf: 'center',
      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
      fontSize: selected ? 26 : 17,
      fontWeight: hover ? 450 : selected ? 500 : 400,
      position: 'relative',
      top: -1
    }
  };
}

var YearButton = function (_Component) {
  (0, _inherits3.default)(YearButton, _Component);

  function YearButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, YearButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.year);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(YearButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          selected = _props.selected,
          year = _props.year,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'selected', 'year', 'utils']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disableFocusRipple: true,
          disableTouchRipple: true,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleClick,
          style: styles.root
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          children
        )
      );
    }
  }]);
  return YearButton;
}(_react.Component);

YearButton.defaultProps = {
  selected: false
};
YearButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
YearButton.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  utils: _propTypes2.default.object.isRequired,
  year: _propTypes2.default.number.isRequired
} : {};
exports.default = YearButton;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _chevronLeft = __webpack_require__(621);

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = __webpack_require__(622);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _SlideIn = __webpack_require__(545);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'inherit',
    height: 48
  },
  titleDiv: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    width: '100%'
  },
  titleText: {
    height: 'inherit',
    paddingTop: 12
  }
};

var CalendarToolbar = function (_Component) {
  (0, _inherits3.default)(CalendarToolbar, _Component);

  function CalendarToolbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarToolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      transitionDirection: 'up'
    }, _this.handleClickPrevMonth = function () {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(-1);
      }
    }, _this.handleClickNextMonth = function () {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(1);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarToolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.displayDate !== this.props.displayDate) {
        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
        var direction = nextProps.displayDate > this.props.displayDate ? nextDirection : prevDirection;
        this.setState({
          transitionDirection: direction
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          displayDate = _props.displayDate;


      var dateTimeFormatted = new DateTimeFormat(locale, {
        month: 'long',
        year: 'numeric'
      }).format(displayDate);

      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: !this.props.prevMonth,
            onClick: this.handleClickPrevMonth
          },
          prevButtonIcon
        ),
        _react2.default.createElement(
          _SlideIn2.default,
          {
            direction: this.state.transitionDirection,
            style: styles.titleDiv
          },
          _react2.default.createElement(
            'div',
            { key: dateTimeFormatted, style: styles.titleText },
            dateTimeFormatted
          )
        ),
        _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: !this.props.nextMonth,
            onClick: this.handleClickNextMonth
          },
          nextButtonIcon
        )
      );
    }
  }]);
  return CalendarToolbar;
}(_react.Component);

CalendarToolbar.defaultProps = {
  nextMonth: true,
  prevMonth: true
};
CalendarToolbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CalendarToolbar.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  displayDate: _propTypes2.default.object.isRequired,
  locale: _propTypes2.default.string.isRequired,
  nextMonth: _propTypes2.default.bool,
  onMonthChange: _propTypes2.default.func,
  prevMonth: _propTypes2.default.bool
} : {};
exports.default = CalendarToolbar;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(160);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideInChild = function (_Component) {
  (0, _inherits3.default)(SlideInChild, _Component);

  function SlideInChild() {
    (0, _classCallCheck3.default)(this, SlideInChild);
    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(SlideInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      var direction = this.props.getLeaveDirection();
      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          getLeaveDirection = _props.getLeaveDirection,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return SlideInChild;
}(_react.Component);

SlideInChild.defaultProps = {
  enterDelay: 0
};
SlideInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SlideInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  direction: _propTypes2.default.string,
  enterDelay: _propTypes2.default.number,
  // This callback is needed bacause the direction could change when leaving the DOM
  getLeaveDirection: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
} : {};
exports.default = SlideInChild;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _SlideIn = __webpack_require__(545);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var datePicker = context.muiTheme.datePicker;
  var selectedYear = state.selectedYear;

  var isLandscape = props.mode === 'landscape';

  var styles = {
    root: {
      width: isLandscape ? 165 : '100%',
      height: isLandscape ? 330 : 'auto',
      float: isLandscape ? 'left' : 'none',
      fontWeight: 700,
      display: 'inline-block',
      backgroundColor: datePicker.headerColor,
      borderTopLeftRadius: 2,
      borderTopRightRadius: isLandscape ? 0 : 2,
      borderBottomLeftRadius: isLandscape ? 2 : 0,
      color: datePicker.textColor,
      padding: 20,
      boxSizing: 'border-box'
    },
    monthDay: {
      display: 'block',
      fontSize: 36,
      lineHeight: '36px',
      height: props.mode === 'landscape' ? '100%' : 38,
      opacity: selectedYear ? 0.7 : 1,
      transition: _transitions2.default.easeOut(),
      width: '100%',
      fontWeight: '500'
    },
    monthDayTitle: {
      cursor: !selectedYear ? 'default' : 'pointer',
      width: '100%',
      display: 'block'
    },
    year: {
      margin: 0,
      fontSize: 16,
      fontWeight: '500',
      lineHeight: '16px',
      height: 16,
      opacity: selectedYear ? 1 : 0.7,
      transition: _transitions2.default.easeOut(),
      marginBottom: 10
    },
    yearTitle: {
      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
    }
  };

  return styles;
}

var DateDisplay = function (_Component) {
  (0, _inherits3.default)(DateDisplay, _Component);

  function DateDisplay() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DateDisplay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedYear: false,
      transitionDirection: 'up'
    }, _this.handleClickMonthDay = function () {
      if (_this.props.onClickMonthDay && _this.state.selectedYear) {
        _this.props.onClickMonthDay();
      }

      _this.setState({ selectedYear: false });
    }, _this.handleClickYear = function () {
      if (_this.props.onClickYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
        _this.props.onClickYear();
      }

      if (!_this.props.disableYearSelection) {
        _this.setState({ selectedYear: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DateDisplay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.monthDaySelected) {
        this.setState({ selectedYear: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedDate !== this.props.selectedDate) {
        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
        this.setState({
          transitionDirection: direction
        });
      }

      if (nextProps.monthDaySelected !== undefined) {
        this.setState({
          selectedYear: !nextProps.monthDaySelected
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          disableYearSelection = _props.disableYearSelection,
          locale = _props.locale,
          mode = _props.mode,
          monthDaySelected = _props.monthDaySelected,
          onClickMonthDay = _props.onClickMonthDay,
          onClickYear = _props.onClickYear,
          selectedDate = _props.selectedDate,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onClickMonthDay', 'onClickYear', 'selectedDate', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var year = new DateTimeFormat(locale, {
        year: 'numeric'
      }).format(selectedDate);

      var dateTime = new DateTimeFormat(locale, {
        month: 'short',
        weekday: 'short',
        day: '2-digit'
      }).format(selectedDate);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
        _react2.default.createElement(
          _SlideIn2.default,
          { style: styles.year, direction: this.state.transitionDirection },
          _react2.default.createElement(
            'div',
            { key: year, style: styles.yearTitle, onClick: this.handleClickYear },
            year
          )
        ),
        _react2.default.createElement(
          _SlideIn2.default,
          { style: styles.monthDay, direction: this.state.transitionDirection },
          _react2.default.createElement(
            'div',
            {
              key: dateTime,
              onClick: this.handleClickMonthDay,
              style: styles.monthDayTitle
            },
            dateTime
          )
        )
      );
    }
  }]);
  return DateDisplay;
}(_react.Component);

DateDisplay.defaultProps = {
  disableYearSelection: false,
  monthDaySelected: true
};
DateDisplay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DateDisplay.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  disableYearSelection: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  monthDaySelected: _propTypes2.default.bool,
  onClickMonthDay: _propTypes2.default.func,
  onClickYear: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object
} : {};
exports.default = DateDisplay;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _FilterRow = __webpack_require__(1123);

var _FilterRow2 = _interopRequireDefault(_FilterRow);

var _analytics = __webpack_require__(32);

var _layerEdit = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    container: {
        width: '100%',
        height: 300,
        padding: 12,
        overflowY: 'auto'
    },
    button: {
        marginTop: 8
    },
    note: {
        padding: 12
    }
};

var FilterGroup = function (_Component) {
    _inherits(FilterGroup, _Component);

    function FilterGroup() {
        _classCallCheck(this, FilterGroup);

        return _possibleConstructorReturn(this, (FilterGroup.__proto__ || Object.getPrototypeOf(FilterGroup)).apply(this, arguments));
    }

    _createClass(FilterGroup, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$filters = _props.filters,
                filters = _props$filters === undefined ? [] : _props$filters,
                dataItems = _props.dataItems,
                program = _props.program,
                programStage = _props.programStage,
                addFilter = _props.addFilter,
                removeFilter = _props.removeFilter,
                changeFilter = _props.changeFilter;


            if (!programStage) {
                return _react2.default.createElement(
                    'div',
                    { style: styles.note },
                    _i18next2.default.t('Filtering is available after selecting a program stage.')
                );
            }

            return _react2.default.createElement(
                'div',
                { style: styles.container },
                filters.map(function (item, index) {
                    return _react2.default.createElement(_FilterRow2.default, _extends({
                        key: index,
                        index: index,
                        dataItems: dataItems,
                        program: program,
                        programStage: programStage,
                        onChange: changeFilter,
                        onRemove: removeFilter
                    }, item));
                }),
                _react2.default.createElement(
                    _Button2.default,
                    {
                        raised: true,
                        color: 'accent',
                        onClick: function onClick() {
                            return addFilter();
                        },
                        style: styles.button
                    },
                    _i18next2.default.t('Add filter')
                )
            );
        }
    }]);

    return FilterGroup;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state, _ref) {
    var program = _ref.program,
        programStage = _ref.programStage;
    return {
        dataItems: program && programStage ? (0, _analytics.combineDataItems)(state.programTrackedEntityAttributes[program.id], state.programStageDataElements[programStage.id], ['FILE_RESOURCE', 'ORGANISATION_UNIT', 'COORDINATE'] // Exclude these value types
        ) : []
    };
}, { addFilter: _layerEdit.addFilter, removeFilter: _layerEdit.removeFilter, changeFilter: _layerEdit.changeFilter })(FilterGroup);

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DataItemSelect = __webpack_require__(663);

var _DataItemSelect2 = _interopRequireDefault(_DataItemSelect);

var _FilterSelect = __webpack_require__(1124);

var _FilterSelect2 = _interopRequireDefault(_FilterSelect);

var _IconButton = __webpack_require__(55);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://react.rocks/example/react-redux-test

var styles = {
    container: {
        height: 64,
        marginBottom: 8,
        padding: '0 56px 0 8px',
        background: '#f4f4f4',
        position: 'relative',
        clear: 'both'
    },
    select: {
        top: -8,
        marginRight: 24,
        float: 'left',
        width: 'calc((100% - 48px) / 8 * 3)'
    },
    removeBtn: {
        position: 'absolute',
        top: 8,
        right: 8
    }
};

var FilterRow = function (_Component) {
    _inherits(FilterRow, _Component);

    function FilterRow() {
        _classCallCheck(this, FilterRow);

        return _possibleConstructorReturn(this, (FilterRow.__proto__ || Object.getPrototypeOf(FilterRow)).apply(this, arguments));
    }

    _createClass(FilterRow, [{
        key: 'onChange',
        value: function onChange(dimension, filter) {
            var _props = this.props,
                index = _props.index,
                dataItems = _props.dataItems,
                onChange = _props.onChange;

            var name = dataItems.filter(function (d) {
                return d.id === dimension;
            })[0].name;

            if (dimension !== this.props.dimension) {
                // New dimension
                onChange(index, {
                    dimension: dimension,
                    name: name,
                    filter: null
                });
            } else {
                onChange(index, {
                    dimension: dimension,
                    name: name,
                    filter: filter
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                index = _props2.index,
                dimension = _props2.dimension,
                filter = _props2.filter,
                dataItems = _props2.dataItems,
                program = _props2.program,
                programStage = _props2.programStage,
                onRemove = _props2.onRemove;

            var dataItem = void 0;

            if (dataItems && dimension) {
                dataItem = dataItems.filter(function (d) {
                    return d.id === dimension;
                })[0];
            }

            return _react2.default.createElement(
                'div',
                { style: styles.container },
                _react2.default.createElement(_DataItemSelect2.default, {
                    items: dataItems,
                    value: dimension || null,
                    program: program,
                    programStage: programStage,
                    onChange: function onChange(dataItem) {
                        return _this2.onChange(dataItem.id, filter);
                    },
                    style: styles.select
                }),
                dimension ? _react2.default.createElement(_FilterSelect2.default, _extends({}, dataItem, {
                    filter: filter,
                    onChange: function onChange(filter) {
                        return _this2.onChange(dimension, filter);
                    }
                })) : null,
                _react2.default.createElement(
                    _IconButton2.default,
                    {
                        tooltip: 'Remove filter',
                        style: styles.removeBtn,
                        onClick: function onClick() {
                            return onRemove(index);
                        }
                    },
                    _react2.default.createElement(_SvgIcon2.default, { icon: 'Close' })
                )
            );
        }
    }]);

    return FilterRow;
}(_react.Component);

exports.default = FilterRow;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _Checkbox = __webpack_require__(664);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _OptionSetSelect = __webpack_require__(1128);

var _OptionSetSelect2 = _interopRequireDefault(_OptionSetSelect);

var _DatePicker = __webpack_require__(662);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _optionSets = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    operator: {
        float: 'left',
        top: -8,
        marginRight: 24,
        width: 'calc((100% - 48px) / 8 * 2)'
    },
    textField: {
        float: 'left',
        top: -8,
        width: 'calc((100% - 48px) / 8 * 3)'
    },
    checkbox: {
        float: 'left',
        marginTop: 26,
        marginLeft: -4,
        width: 'calc((100% - 48px) / 8 * 5)'
    },
    dateField: {
        width: 'calc((100% - 48px) / 8 * 3)',
        top: -8
    }
};

// https://react.rocks/example/react-redux-test
// https://docs.dhis2.org/master/en/developer/html/webapi_metadata_object_filter.html

/* Value Types: https://play.dhis2.org/demo/api/schemas/dataElement
- TEXT
- LONG_TEXT
- LETTER
- PHONE_NUMBER
- EMAIL
- BOOLEAN
- TRUE_ONLY
- DATE
- DATETIME
- TIME
- NUMBER
- UNIT_INTERVAL
- PERCENTAGE
- INTEGER
- INTEGER_POSITIVE
- INTEGER_NEGATIVE
- INTEGER_ZERO_OR_POSITIVE
- TRACKER_ASSOCIATE
- USERNAME
- FILE_RESOURCE
- COORDINATE
- ORGANISATION_UNIT
- AGE
- URL
*/

var FilterSelect = function FilterSelect(_ref) {
    var valueType = _ref.valueType,
        filter = _ref.filter,
        optionSet = _ref.optionSet,
        optionSets = _ref.optionSets,
        loadOptionSet = _ref.loadOptionSet,
        _onChange = _ref.onChange;

    var operators = void 0;
    var operator = void 0;
    var value = void 0;

    if (['NUMBER', 'INTEGER', 'INTEGER_POSITIVE', 'DATE'].includes(valueType)) {
        operators = [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }];
    } else if (optionSet) {
        operators = [{ id: 'IN', name: _i18next2.default.t('one of') }, { id: '!IN', name: _i18next2.default.t('not one of') }];
    } else if (['TEXT', 'LONG_TEXT'].includes(valueType)) {
        operators = [{ id: 'LIKE', name: _i18next2.default.t('contains') }, { id: '!LIKE', name: _i18next2.default.t("doesn't contains") }, { id: 'EQ', name: _i18next2.default.t('is') }, { id: '!EQ', name: _i18next2.default.t('is not') }];
    }

    if (optionSet && !optionSets[optionSet.id]) {
        loadOptionSet(optionSet.id);
    }

    if (filter) {
        var splitFilter = filter.split(':');
        operator = splitFilter[0];
        value = splitFilter[1];
    } else if (operators) {
        operator = operators[0].id;
    }

    // console.log('valueType', valueType, value);

    return [operators ? _react2.default.createElement(_SelectField2.default, {
        key: 'operator',
        label: _i18next2.default.t('Operator'),
        items: operators,
        value: operator,
        onChange: function onChange(newOperator) {
            return _onChange(newOperator.id + ':' + (value ? value : ''));
        },
        style: styles.operator
    }) : null, optionSet && optionSets[optionSet.id] ? _react2.default.createElement(_OptionSetSelect2.default, {
        key: 'optionset',
        options: optionSets[optionSet.id].options,
        value: value ? value.split(';') : null,
        onChange: function onChange(newValue) {
            return _onChange(operator + ':' + newValue.join(';'));
        },
        style: styles.textField
    }) : null, ['NUMBER', 'INTEGER', 'INTEGER_POSITIVE'].includes(valueType) ? _react2.default.createElement(_TextField2.default, {
        key: 'number',
        label: _i18next2.default.t('Value'),
        type: 'number',
        value: value !== undefined ? value : '',
        onChange: function onChange(newValue) {
            return _onChange(operator + ':' + newValue);
        },
        style: styles.textField
    }) : null, ['TEXT', 'LONG_TEXT'].includes(valueType) && !optionSet ? _react2.default.createElement(_TextField2.default, {
        key: 'text',
        label: _i18next2.default.t('Value'),
        value: value || '',
        onChange: function onChange(newValue) {
            return _onChange(operator + ':' + newValue);
        },
        style: styles.textField
    }) : null, valueType === 'BOOLEAN' ? _react2.default.createElement(_Checkbox2.default, {
        key: 'checkbox',
        label: _i18next2.default.t('Yes'),
        checked: value == 1 ? true : false,
        onCheck: function onCheck(event, isChecked) {
            return _onChange(isChecked ? 'IN:1' : 'IN:0');
        },
        style: styles.checkbox
    }) : null, valueType === 'DATE' ? _react2.default.createElement(_DatePicker2.default, {
        key: 'date',
        label: _i18next2.default.t('Date'),
        value: value,
        onChange: function onChange(date) {
            return _onChange(operator + ':' + date);
        },
        style: styles.datePicker,
        textFieldStyle: styles.dateField
    }) : null];
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        optionSets: state.optionSets
    };
}, { loadOptionSet: _optionSets.loadOptionSet })(FilterSelect);

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedSwitch = __webpack_require__(665);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _checkBoxOutlineBlank = __webpack_require__(1126);

var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);

var _checkBox = __webpack_require__(1127);

var _checkBox2 = _interopRequireDefault(_checkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var checkbox = context.muiTheme.checkbox;

  var checkboxSize = 24;

  return {
    icon: {
      height: checkboxSize,
      width: checkboxSize
    },
    check: {
      position: 'absolute',
      opacity: 0,
      transform: 'scale(0)',
      transitionOrigin: '50% 50%',
      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
      fill: checkbox.checkedColor
    },
    checkWhenSwitched: {
      opacity: 1,
      transform: 'scale(1)',
      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
    },
    checkWhenDisabled: {
      fill: checkbox.disabledColor
    },
    box: {
      position: 'absolute',
      opacity: 1,
      fill: checkbox.boxColor,
      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
    },
    boxWhenSwitched: {
      opacity: 0,
      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
      fill: checkbox.checkedColor
    },
    boxWhenDisabled: {
      fill: props.checked ? 'transparent' : checkbox.disabledColor
    },
    label: {
      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
    }
  };
}

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switched: false
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({
        switched: newSwitched
      });
    }, _this.handleCheck = function (event, isInputChecked) {
      if (_this.props.onCheck) {
        _this.props.onCheck(event, isInputChecked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          checked = _props.checked,
          defaultChecked = _props.defaultChecked,
          valueLink = _props.valueLink;


      if (checked || defaultChecked || valueLink && valueLink.value) {
        this.setState({
          switched: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.checked !== nextProps.checked) {
        this.setState({
          switched: nextProps.checked
        });
      }
    }
  }, {
    key: 'isChecked',
    value: function isChecked() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setChecked',
    value: function setChecked(newCheckedValue) {
      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          iconStyle = _props2.iconStyle,
          onCheck = _props2.onCheck,
          checkedIcon = _props2.checkedIcon,
          uncheckedIcon = _props2.uncheckedIcon,
          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);

      var styles = getStyles(this.props, this.context);
      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);

      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
      }) : _react2.default.createElement(_checkBox2.default, {
        style: checkStyles
      });

      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
        style: boxStyles
      });

      var checkboxElement = _react2.default.createElement(
        'div',
        null,
        unCheckedElement,
        checkedElement
      );

      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);

      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switched: this.state.switched,
        switchElement: checkboxElement,
        rippleColor: rippleColor,
        iconStyle: mergedIconStyle,
        onSwitch: this.handleCheck,
        labelStyle: labelStyle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.defaultProps = {
  labelPosition: 'right',
  disabled: false
};
Checkbox.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Checkbox.propTypes =  false ? {
  /**
   * Checkbox is checked if true.
   */
  checked: _propTypes2.default.bool,
  /**
   * The SvgIcon to use for the checked state.
   * This is useful to create icon toggles.
   */
  checkedIcon: _propTypes2.default.element,
  /**
   * The default state of our checkbox component.
   * **Warning:** This cannot be used in conjunction with `checked`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * Disabled if true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * Where the label will be placed next to the checkbox.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Checkbox element label.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function that is fired when the checkbox is checked.
   *
   * @param {object} event `change` event targeting the underlying checkbox `input`.
   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
   */
  onCheck: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The SvgIcon to use for the unchecked state.
   * This is useful to create icon toggles.
   */
  uncheckedIcon: _propTypes2.default.element,
  /**
   * ValueLink for when using controlled checkbox.
   */
  valueLink: _propTypes2.default.object
} : {};
exports.default = Checkbox;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBox = function ToggleCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
ToggleCheckBox.displayName = 'ToggleCheckBox';
ToggleCheckBox.muiName = 'SvgIcon';

exports.default = ToggleCheckBox;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionSetSelect = function OptionSetSelect(_ref) {
    var options = _ref.options,
        value = _ref.value,
        _onChange = _ref.onChange,
        style = _ref.style;

    // TODO: Temporarily fix until we have a searchable SelectField handling hundreds of options
    if (options.length > 100) {
        options = options.slice(0, 100);
    }

    return _react2.default.createElement(_SelectField2.default, {
        label: 'Options' // TODO: i18n
        , items: options.map(function (option) {
            return {
                id: option.code,
                name: option.name
            };
        }),
        value: value,
        multiple: true,
        onChange: function onChange(values) {
            return _onChange(values);
        },
        style: style
    });
};

exports.default = OptionSetSelect;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(1130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSelect = function ImageSelect(_ref) {
    var id = _ref.id,
        img = _ref.img,
        title = _ref.title,
        isSelected = _ref.isSelected,
        _onClick = _ref.onClick,
        style = _ref.style;

    var borderStyle = {
        outline: isSelected ? '3px solid orange' : '1px solid #999'
    };

    return _react2.default.createElement(
        'div',
        {
            className: 'ImageSelect',
            title: title,
            onClick: function onClick() {
                return _onClick(id);
            },
            style: style
        },
        _react2.default.createElement(
            'div',
            { className: 'ImageSelect-image-container', style: borderStyle },
            img ? _react2.default.createElement('img', { src: img, className: 'ImageSelect-image' }) : _react2.default.createElement('div', { className: 'ImageSelect-no-image' })
        ),
        title ? _react2.default.createElement(
            'div',
            { className: 'ImageSelect-title' },
            title
        ) : null
    );
};

ImageSelect.propTypes = {
    id: _propTypes2.default.string.isRequired,
    img: _propTypes2.default.string,
    title: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = ImageSelect;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1131);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./ImageSelect.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./ImageSelect.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, "/*\n.ImageSelect {\n    float: left;\n     width: calc(50% - 24px);\n    margin: 12px;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n*/\n\n\n.ImageSelect-image-container {\n    position: relative;\n    /* height: 120px; */\n    /* width: 100%; */\n    margin-top: 4px;\n    overflow: hidden;\n}\n\n\n.ImageSelect-image {\n    width: 100%;\n    display: block;\n}\n\n/*\n.ImageSelect-image {\n    position: absolute;\n    clip: rect(64px, 256px, 192px, 0);\n    width: 100%;\n    top: -64px;\n}\n*/\n\n.ImageSelect-no-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    line-height: 56px;\n}\n\n.ImageSelect-title {\n    font-size: 12px;\n    color: #333;\n    padding-top: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BooleanStyle = __webpack_require__(1133);

var _BooleanStyle2 = _interopRequireDefault(_BooleanStyle);

var _OptionSetStyle = __webpack_require__(1134);

var _OptionSetStyle2 = _interopRequireDefault(_OptionSetStyle);

var _Classification = __webpack_require__(669);

var _Classification2 = _interopRequireDefault(_Classification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataElementStyle = function DataElementStyle(_ref) {
    var method = _ref.method,
        classes = _ref.classes,
        colorScale = _ref.colorScale,
        id = _ref.id,
        valueType = _ref.valueType,
        name = _ref.name,
        optionSet = _ref.optionSet,
        style = _ref.style;
    return _react2.default.createElement(
        'div',
        { style: style },
        valueType === 'INTEGER' ? _react2.default.createElement(_Classification2.default, {
            method: method,
            classes: classes,
            colorScale: colorScale,
            style: { width: '100%' }
        }) : null,
        valueType === 'BOOLEAN' ? _react2.default.createElement(_BooleanStyle2.default, null) : null,
        optionSet ? _react2.default.createElement(_OptionSetStyle2.default, optionSet) : null
    );
};

exports.default = DataElementStyle;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = ['#a6cee3', '#1f78b4']; // From ColorBrewer

var BooleanStyle = function BooleanStyle(props) {
    return _react2.default.createElement(
        'div',
        null,
        'BooleanStyle'
    );
};

exports.default = BooleanStyle;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _CircularProgress = __webpack_require__(660);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _OptionStyle = __webpack_require__(1135);

var _OptionStyle2 = _interopRequireDefault(_OptionStyle);

var _optionSets = __webpack_require__(260);

var _layerEdit = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// From ColorBrewer
var colors = ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'];

var style = {
    marginTop: 20
};

var OptionSetStyle = function (_Component) {
    _inherits(OptionSetStyle, _Component);

    function OptionSetStyle() {
        _classCallCheck(this, OptionSetStyle);

        return _possibleConstructorReturn(this, (OptionSetStyle.__proto__ || Object.getPrototypeOf(OptionSetStyle)).apply(this, arguments));
    }

    _createClass(OptionSetStyle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.options) {
                this.setOptions();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.options) {
                this.setOptions();
            }
        }
    }, {
        key: 'setOptions',
        value: function setOptions() {
            var _props = this.props,
                id = _props.id,
                optionSets = _props.optionSets,
                loadOptionSet = _props.loadOptionSet,
                setStyleOptions = _props.setStyleOptions;


            if (!optionSets[id]) {
                loadOptionSet(id);
            } else {
                var byName = {}; // TODO: Use by code when API support it
                optionSets[id].options.forEach(function (option, index) {
                    return byName[option.name] = colors[index] || '#ffffff';
                });
                setStyleOptions(byName);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var options = this.props.options;


            return _react2.default.createElement(
                'div',
                { style: style },
                options ? Object.keys(options).map(function (name) {
                    return _react2.default.createElement(_OptionStyle2.default, {
                        key: name,
                        name: name,
                        color: options[name]
                    });
                }) : _react2.default.createElement(_CircularProgress2.default, null)
            );
        }
    }]);

    return OptionSetStyle;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        optionSets: state.optionSets
    };
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        optionSets: state.optionSets
    };
}, { loadOptionSet: _optionSets.loadOptionSet, setStyleOptions: _layerEdit.setStyleOptions })(OptionSetStyle);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ColorPicker = __webpack_require__(546);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    color: {
        width: 32,
        height: 32,
        marginRight: 8
    },
    label: {
        display: 'inline-block',
        height: 24,
        lineHeight: '32px',
        verticalAlign: 'top'
    }
};

var OptionStyle = function OptionStyle(_ref) {
    var id = _ref.id,
        name = _ref.name,
        color = _ref.color,
        _onChange = _ref.onChange;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ColorPicker2.default, {
            color: color,
            onChange: function onChange(newColor) {
                return _onChange(id, newColor);
            },
            style: styles.color
        }),
        _react2.default.createElement(
            'span',
            { style: styles.label },
            name
        )
    );
};

exports.default = OptionStyle;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(548);

var _ChromeFields = __webpack_require__(1161);

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = __webpack_require__(1162);

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = __webpack_require__(1163);

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        width: '225px',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  disableAlpha: _propTypes2.default.bool
};

Chrome.defaultProps = {
  disableAlpha: false
};

exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(253);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(547);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(135);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(1138);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseIteratee = __webpack_require__(38),
    baseMap = __webpack_require__(246),
    isArray = __webpack_require__(21);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(547);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(1140);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(127);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(547);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(1146);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(667);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden'
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (props.hsl.a !== a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (props.a !== _a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
  var checkboard = render(c1, c2, size, serverCanvas);

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      if (_this.props.label) {
        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
      } else {
        _this.props.onChange && _this.props.onChange(e.target.value, e);
      }

      _this.setState({ value: e.target.value });
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var stringValue = String(e.target.value);
      var isPercentage = stringValue.indexOf('%') > -1;
      var number = Number(stringValue.replace(/%/g, ''));
      if (!isNaN(number)) {
        var amount = _this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number + amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number + amount + '%' });
          } else {
            _this.setState({ value: number + amount });
          }
        }

        // Down
        if (e.keyCode === 40) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number - amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number - amount + '%' });
          } else {
            _this.setState({ value: number - amount });
          }
        }
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = this.input;
      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(1150);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = hue.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%'
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (props.hsl.h !== h) {
      return {
        h: h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (props.hsl.h !== _h) {
      return {
        h: _h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2
};

exports.default = Raised;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(1153);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(1154);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e, skip) {
      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(429),
    isObject = __webpack_require__(26);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();

  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  } else if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left * 100 / containerWidth;
  var bright = -(top * 100 / containerHeight) + 100;

  return {
    h: props.hsl.h,
    s: saturation,
    v: bright,
    a: props.hsl.a,
    source: 'rgb'
  };
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(429);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(668);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
      }
    }, {
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1157);


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(96),
    baseEach = __webpack_require__(247),
    castFunction = __webpack_require__(666),
    isArray = __webpack_require__(21);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(1160);

var _ = __webpack_require__(548);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_.Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onFocus: _this.handleFocus, onBlur: _this.handleBlur },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Focus;
  }(_react2.default.Component);
};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(668);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(548);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChromeFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      view: ''
    }, _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    }, _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: data.s && data.s || _this.props.hsl.s,
          l: data.l && data.l || _this.props.hsl.l,
          source: 'hsl'
        }, e);
      }
    }, _this.showHighlight = function (e) {
      e.target.style.background = '#eee';
    }, _this.hideHighlight = function (e) {
      e.target.style.background = 'transparent';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChromeFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
        this.setState({ view: 'hex' });
      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(
              'svg',
              {
                style: styles.svg,
                viewBox: '0 0 24 24',
                onMouseOver: this.showHighlight,
                onMouseEnter: this.showHighlight,
                onMouseOut: this.hideHighlight
              },
              _react2.default.createElement('path', {
                ref: function ref(iconUp) {
                  return _this2.iconUp = iconUp;
                },
                fill: '#333',
                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
              }),
              _react2.default.createElement('path', {
                ref: function ref(iconDown) {
                  return _this2.iconDown = iconDown;
                },
                fill: '#333',
                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
              })
            )
          )
        )
      );
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

exports.default = ChromeFields;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(71);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('range', __webpack_require__(1165));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1166);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1167),
    isIterateeCall = __webpack_require__(249),
    toFinite = __webpack_require__(243);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColorScale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorbrewer__ = __webpack_require__(257);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Returns one color scale based on a code and number of classes
function ColorScale(_ref) {
    var scale = _ref.scale,
        classes = _ref.classes,
        style = _ref.style,
        _onClick = _ref.onClick;

    var colors = __WEBPACK_IMPORTED_MODULE_1__colorbrewer__["default"][scale][classes];

    var styles = {
        scale: _extends({
            marginRight: 30,
            paddingLeft: 0,
            height: 36,
            cursor: 'pointer',
            boxShadow: '0 1px 6px rgba(0,0,0,0.12),0 1px 4px rgba(0,0,0,0.12)',
            display: 'inline-block'
        }, style)
    };

    var items = colors.map(function (color, index) {
        var styles = {
            marginLeft: 0,
            display: 'inline-block',
            backgroundColor: color,
            width: 36,
            height: '100%'
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index, style: styles });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: styles.scale, onClick: function onClick(event) {
                return _onClick(event, scale);
            } },
        items
    );
}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CoordinateField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _programs = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoordinateField = exports.CoordinateField = function (_Component) {
    _inherits(CoordinateField, _Component);

    function CoordinateField() {
        _classCallCheck(this, CoordinateField);

        return _possibleConstructorReturn(this, (CoordinateField.__proto__ || Object.getPrototypeOf(CoordinateField)).apply(this, arguments));
    }

    _createClass(CoordinateField, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                program = _props.program,
                programStage = _props.programStage,
                programAttributes = _props.programAttributes,
                dataElements = _props.dataElements,
                loadProgramTrackedEntityAttributes = _props.loadProgramTrackedEntityAttributes,
                loadProgramStageDataElements = _props.loadProgramStageDataElements;


            if (program && !programAttributes[program.id]) {
                loadProgramTrackedEntityAttributes(program.id);
            }

            if (programStage && !dataElements[programStage.id]) {
                loadProgramStageDataElements(programStage.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                value = _props2.value,
                program = _props2.program,
                programStage = _props2.programStage,
                programAttributes = _props2.programAttributes,
                dataElements = _props2.dataElements,
                _onChange = _props2.onChange,
                style = _props2.style;

            var fields = [{ id: 'event', name: _i18next2.default.t('Event location') }];

            if (program && programStage) {
                fields = fields.concat([].concat(_toConsumableArray(programAttributes[program.id] || []), _toConsumableArray(dataElements[programStage.id] || [])).filter(function (field) {
                    return field.valueType === 'COORDINATE';
                }));
            }

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Coordinate field'),
                items: fields,
                value: value || 'event',
                onChange: function onChange(field) {
                    return _onChange(field.id);
                },
                style: style
            });
        }
    }]);

    return CoordinateField;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programAttributes: state.programTrackedEntityAttributes,
        dataElements: state.programStageDataElements
    };
}, { loadProgramTrackedEntityAttributes: _programs.loadProgramTrackedEntityAttributes, loadProgramStageDataElements: _programs.loadProgramStageDataElements })(CoordinateField);

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(1171);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(97);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d2_lib_model_Model__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d2_lib_model_Model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d2_lib_model_Model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d2_lib_model_ModelCollection__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d2_lib_model_ModelCollection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_d2_lib_model_ModelCollection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tree_view_TreeView_component__ = __webpack_require__(1175);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var styles = {
    progress: {
        position: 'absolute',
        display: 'inline-block',
        width: '100%',
        left: -8
    },
    progressBar: {
        height: 2,
        backgroundColor: 'transparent'
    },
    spacer: {
        position: 'relative',
        display: 'inline-block',
        width: '1.2rem',
        height: '1rem'
    },
    label: {
        display: 'inline-block',
        outline: 'none'
    },
    ouContainer: {
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRightWidth: 0,
        borderRadius: '3px 0 0 3px',
        background: 'transparent',
        paddingLeft: 2,
        outline: 'none'
    },
    currentOuContainer: {
        background: 'rgba(0,0,0,0.05)',
        borderColor: 'rgba(0,0,0,0.1)'
    },
    memberCount: {
        fontSize: '0.75rem',
        marginLeft: 4
    }
};

var OrgUnitTree = function (_React$Component) {
    _inherits(OrgUnitTree, _React$Component);

    function OrgUnitTree(props) {
        _classCallCheck(this, OrgUnitTree);

        var _this = _possibleConstructorReturn(this, (OrgUnitTree.__proto__ || Object.getPrototypeOf(OrgUnitTree)).call(this, props));

        _this.state = {
            children: props.root.children === false || Array.isArray(props.root.children) && props.root.children.length === 0 ? [] : undefined,
            loading: false
        };
        if (props.root.children instanceof __WEBPACK_IMPORTED_MODULE_4_d2_lib_model_ModelCollection___default.a && !props.root.children.hasUnloadedData) {
            _this.state.children = props.root.children.toArray()
            // Sort here since the API returns nested children in random order
            .sort(function (a, b) {
                return a.displayName.localeCompare(b.displayName);
            });
        }

        _this.loadChildren = _this.loadChildren.bind(_this);
        _this.handleSelectClick = _this.handleSelectClick.bind(_this);
        return _this;
    }

    _createClass(OrgUnitTree, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.initiallyExpanded.some(function (ou) {
                return ou.includes('/' + _this2.props.root.id);
            })) {
                this.loadChildren();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.initiallyExpanded.some(function (ou) {
                return ou.includes('/' + newProps.root.id);
            }) || newProps.idsThatShouldBeReloaded.includes(newProps.root.id)) {
                this.loadChildren();
            }
        }
    }, {
        key: 'setChildState',
        value: function setChildState(children) {
            if (this.props.onChildrenLoaded) {
                this.props.onChildrenLoaded(children);
            }
            this.setState({
                children: children.toArray().sort(function (a, b) {
                    return a.displayName.localeCompare(b.displayName);
                }),
                loading: false
            });
        }
    }, {
        key: 'loadChildren',
        value: function loadChildren() {
            var _this3 = this;

            if (this.state.children === undefined && !this.state.loading || this.props.idsThatShouldBeReloaded.indexOf(this.props.root.id) >= 0) {
                this.setState({ loading: true });

                var root = this.props.root;
                root.children.load({ fields: 'id,displayName,children::isNotEmpty,path,parent' }).then(function (children) {
                    _this3.setChildState(children);
                });
            }
        }
    }, {
        key: 'handleSelectClick',
        value: function handleSelectClick(e) {
            if (this.props.onSelectClick) {
                this.props.onSelectClick(e, this.props.root);
            }
            e.stopPropagation();
        }
    }, {
        key: 'shouldIncludeOrgUnit',
        value: function shouldIncludeOrgUnit(orgUnit) {
            if (!this.props.orgUnitsPathsToInclude || this.props.orgUnitsPathsToInclude.length === 0) {
                return true;
            }
            return !!this.props.orgUnitsPathsToInclude.some(function (ou) {
                return ou.includes('/' + orgUnit.id);
            });
        }
    }, {
        key: 'renderChild',
        value: function renderChild(orgUnit, expandedProp) {
            if (this.shouldIncludeOrgUnit(orgUnit)) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrgUnitTree, {
                    key: orgUnit.id,
                    root: orgUnit,
                    selected: this.props.selected,
                    initiallyExpanded: expandedProp,
                    onSelectClick: this.props.onSelectClick,
                    currentRoot: this.props.currentRoot,
                    onChangeCurrentRoot: this.props.onChangeCurrentRoot,
                    labelStyle: this.props.labelStyle,
                    selectedLabelStyle: this.props.selectedLabelStyle,
                    arrowSymbol: this.props.arrowSymbol,
                    idsThatShouldBeReloaded: this.props.idsThatShouldBeReloaded,
                    hideCheckboxes: this.props.hideCheckboxes,
                    onChildrenLoaded: this.props.onChildrenLoaded,
                    hideMemberCount: this.props.hideMemberCount,
                    orgUnitsPathsToInclude: this.props.orgUnitsPathsToInclude
                });
            }
            return null;
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this4 = this;

            // If initiallyExpanded is an array, remove the current root id and pass the rest on
            // If it's a string, pass it on unless it's the current root id
            var expandedProp = Array.isArray(this.props.initiallyExpanded) ? this.props.initiallyExpanded.filter(function (id) {
                return id !== _this4.props.root.id;
            }) : this.props.initiallyExpanded !== this.props.root.id && this.props.initiallyExpanded || [];

            if (Array.isArray(this.state.children) && this.state.children.length > 0) {
                return this.state.children.map(function (orgUnit) {
                    return _this4.renderChild(orgUnit, expandedProp);
                });
            }

            if (this.state.loading) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.progress },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default.a, { style: styles.progressBar })
                );
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var currentOu = this.props.root;

            // True if this OU has children = is not a leaf node
            var hasChildren = this.state.children === undefined || Array.isArray(this.state.children) && this.state.children.length > 0;
            // True if a click handler exists
            var isSelectable = !!this.props.onSelectClick;
            var pathRegEx = new RegExp('/' + currentOu.id + '$');
            var memberRegEx = new RegExp('/' + currentOu.id);
            var isSelected = this.props.selected && this.props.selected.some(function (ou) {
                return pathRegEx.test(ou);
            });
            // True if this OU is the current root
            var isCurrentRoot = this.props.currentRoot && this.props.currentRoot.id === currentOu.id;
            // True if this OU should be expanded by default
            var isInitiallyExpanded = this.props.initiallyExpanded.some(function (ou) {
                return ou.includes('/' + currentOu.id);
            });
            // True if this OU can BECOME the current root, which means that:
            // 1) there is a change root handler
            // 2) this OU is not already the current root
            // 3) this OU has children (is not a leaf node)
            var canBecomeCurrentRoot = this.props.onChangeCurrentRoot && !isCurrentRoot && hasChildren;

            var memberCount = this.props.selected !== undefined ? this.props.selected.filter(function (ou) {
                return memberRegEx.test(ou);
            }).length : currentOu.memberCount;

            // Hard coded styles for OU name labels - can be overridden with the selectedLabelStyle and labelStyle props
            var labelStyle = Object.assign({}, styles.label, {
                fontWeight: isSelected ? 500 : 300,
                color: isSelected ? 'orange' : 'inherit',
                cursor: canBecomeCurrentRoot ? 'pointer' : 'default'
            }, isSelected ? this.props.selectedLabelStyle : this.props.labelStyle);

            // Styles for this OU and OUs contained within it
            var ouContainerStyle = Object.assign({}, styles.ouContainer, isCurrentRoot ? styles.currentOuContainer : {});

            // Wrap the change root click handler in order to stop event propagation
            var setCurrentRoot = function setCurrentRoot(e) {
                e.stopPropagation();
                _this5.props.onChangeCurrentRoot(currentOu);
            };

            var label = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    style: labelStyle,
                    onClick: canBecomeCurrentRoot && setCurrentRoot || isSelectable && this.handleSelectClick,
                    role: 'button',
                    tabIndex: 0
                },
                isSelectable && !this.props.hideCheckboxes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    type: 'checkbox',
                    readOnly: true,
                    disabled: !isSelectable,
                    checked: isSelected,
                    onClick: this.handleSelectClick
                }),
                currentOu.displayName,
                hasChildren && !this.props.hideMemberCount && !!memberCount && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: styles.memberCount },
                    '(',
                    memberCount,
                    ')'
                )
            );

            if (hasChildren) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__tree_view_TreeView_component__["a" /* default */],
                    {
                        label: label,
                        onExpand: this.loadChildren,
                        persistent: true,
                        initiallyExpanded: isInitiallyExpanded,
                        arrowSymbol: this.props.arrowSymbol,
                        className: 'orgunit with-children',
                        style: ouContainerStyle
                    },
                    this.renderChildren()
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    onClick: isSelectable && this.handleSelectClick,
                    className: 'orgunit without-children',
                    style: ouContainerStyle,
                    role: 'button',
                    tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.spacer }),
                label
            );
        }
    }]);

    return OrgUnitTree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function orgUnitPathPropValidator(propValue, key, compName, location, propFullName) {
    if (!/(\/[a-zA-Z][a-zA-Z0-9]{10})+/.test(propValue[key])) {
        return new Error('Invalid org unit path `' + propValue[key] + '` supplied to `' + compName + '.' + propFullName + '`');
    }
    return undefined;
}

OrgUnitTree.propTypes = {
    /**
     * The root OrganisationUnit of the tree
     *
     * If the root OU is known to have no children, the `children` property of the root OU should be either
     * `false` or an empty array. If the children property is undefined, the children will be fetched from
     * the server when the tree is expanded.
     */
    root: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_d2_lib_model_Model___default.a).isRequired,

    /**
     * An array of paths of selected OUs
     *
     * The path of an OU is the UIDs of the OU and all its parent OUs separated by slashes (/)
     */
    selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(orgUnitPathPropValidator),

    /**
     * An array of OU paths that will be expanded automatically as soon as they are encountered
     *
     * The path of an OU is the UIDs of the OU and all its parent OUs separated by slashes (/)
     */
    initiallyExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(orgUnitPathPropValidator),

    /**
     * onSelectClick callback, which is triggered when a click triggers the selection of an organisation unit
     *
     * The onSelectClick callback will receive two arguments: The original click event, and the OU that was clicked
     */
    onSelectClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * onChangeCurrentRoot callback, which is triggered when the change current root label is clicked. Setting this also
     * enables the display of the change current root label
     *
     * the onChangeCurrentRoot callback will receive two arguments: The original click event, and the organisation unit
     * model object that was selected as the new root
     */
    onChangeCurrentRoot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * Organisation unit model representing the current root
     */
    currentRoot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * onChildrenLoaded callback, which is triggered when the children of this root org unit have been loaded
     *
     * The callback receives one argument: A D2 ModelCollection object that contains all the newly loaded org units
     */
    onChildrenLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * Custom styling for OU labels
     */
    labelStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * Custom styling for the labels of selected OUs
     */
    selectedLabelStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * An array of organisation unit IDs that should be reloaded from the API
     */
    idsThatShouldBeReloaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),

    /**
     * Custom arrow symbol
     */
    arrowSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * If true, don't display checkboxes next to org unit labels
     */
    hideCheckboxes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * if true, don't display the selected member count next to org unit labels
     */
    hideMemberCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * Array of paths of Organisation Units to include on tree. If not defined or empty, all children from root to leafs will be shown
     */
    orgUnitsPathsToInclude: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

OrgUnitTree.defaultProps = {
    selected: [],
    initiallyExpanded: [],
    onSelectClick: undefined,
    onChangeCurrentRoot: undefined,
    currentRoot: undefined,
    onChildrenLoaded: undefined,
    labelStyle: {},
    selectedLabelStyle: {},
    idsThatShouldBeReloaded: [],
    arrowSymbol: undefined,
    hideCheckboxes: false,
    hideMemberCount: false,
    orgUnitsPathsToInclude: null
};

/* harmony default export */ __webpack_exports__["default"] = (OrgUnitTree);

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LinearProgress = __webpack_require__(1174);

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LinearProgress2.default;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props, context) {
  var max = props.max,
      min = props.min,
      value = props.value;
  var _context$muiTheme = context.muiTheme,
      palette = _context$muiTheme.baseTheme.palette,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'relative',
      height: 4,
      display: 'block',
      width: '100%',
      backgroundColor: palette.primary3Color,
      borderRadius: borderRadius,
      margin: 0,
      overflow: 'hidden'
    },
    bar: {
      height: '100%'
    },
    barFragment1: {},
    barFragment2: {}
  };

  if (props.mode === 'indeterminate') {
    styles.barFragment1 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
    };

    styles.barFragment2 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
    };
  } else {
    styles.bar.backgroundColor = props.color || palette.primary1Color;
    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
    styles.bar.width = getRelativeValue(value, min, max) + '%';
  }

  return styles;
}

var LinearProgress = function (_Component) {
  (0, _inherits3.default)(LinearProgress, _Component);

  function LinearProgress() {
    (0, _classCallCheck3.default)(this, LinearProgress);
    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinearProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timers = {};

      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);

      this.timers.bar2 = setTimeout(function () {
        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
      }, 850);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timers.bar1);
      clearTimeout(this.timers.bar2);
    }
  }, {
    key: 'barUpdate',
    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      timeToNextStep = timeToNextStep || 420;
      step = step || 0;
      step %= 4;

      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
      var left = this.context.muiTheme.isRtl ? 'right' : 'left';

      if (step === 0) {
        barElement.style[left] = stepValues[0][0] + '%';
        barElement.style[right] = stepValues[0][1] + '%';
      } else if (step === 1) {
        barElement.style.transitionDuration = '840ms';
      } else if (step === 2) {
        barElement.style[left] = stepValues[1][0] + '%';
        barElement.style[right] = stepValues[1][1] + '%';
      } else if (step === 3) {
        barElement.style.transitionDuration = '0ms';
      }
      this.timers[id] = setTimeout(function () {
        return _this3.barUpdate(id, step + 1, barElement, stepValues);
      }, timeToNextStep);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.bar) },
          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
        )
      );
    }
  }]);
  return LinearProgress;
}(_react.Component);

LinearProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100
};
LinearProgress.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
LinearProgress.propTypes =  false ? {
  /**
   * The color of the progress bar, defaults to
   * primary color of theme.
   */
  color: _propTypes2.default.string,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes2.default.number,
  /**
   * The mode of show your progress, indeterminate for when
   * there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes2.default.number
} : {};
exports.default = LinearProgress;

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TreeView = function (_React$Component) {
    _inherits(TreeView, _React$Component);

    function TreeView(props) {
        _classCallCheck(this, TreeView);

        var _this = _possibleConstructorReturn(this, (TreeView.__proto__ || Object.getPrototypeOf(TreeView)).call(this, props));

        _this.state = {
            collapsed: !props.initiallyExpanded,
            hasBeenExpanded: props.initiallyExpanded
        };

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(TreeView, [{
        key: 'toggleCollapsed',
        value: function toggleCollapsed() {
            var _this2 = this;

            this.setState(function (state) {
                return {
                    collapsed: !state.collapsed,
                    hasBeenExpanded: true
                };
            }, function () {
                if (!_this2.state.collapsed && typeof _this2.props.onExpand === 'function') {
                    _this2.props.onExpand();
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            // When initiallyExpanded status changed and the tree is collapsed we fire a toggleEvent to open it up
            if (newProps.initiallyExpanded && this.state.collapsed) {
                this.toggleCollapsed();
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.onClick) {
                this.props.onClick(e);
            }
            if (e !== undefined) {
                e.stopPropagation();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var styles = {
                tree: {
                    marginLeft: 16,
                    whiteSpace: 'nowrap'
                },
                itemLabel: {
                    display: 'inline-block',
                    position: 'relative'
                },
                arrow: {
                    display: 'inline-block',
                    position: 'absolute',
                    left: -16,
                    top: -1,
                    width: 11,
                    height: 16,
                    paddingLeft: 4,
                    textAlign: 'center',
                    cursor: 'pointer'
                },
                arrowSymbol: {
                    transition: 'transform 150ms ease-out',
                    transform: this.state.collapsed ? '' : 'rotate(90deg)',
                    position: 'absolute'
                },
                clickTarget: {
                    cursor: this.props.onClick && 'pointer'
                },
                children: {
                    position: 'relative',
                    marginLeft: 16,
                    height: this.state.collapsed ? 0 : 'inherit'
                }
            };

            var label = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.itemLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'arrow', style: styles.arrow, onClick: this.toggleCollapsed.bind(this) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: styles.arrowSymbol },
                        this.props.arrowSymbol
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'label', onClick: this.handleClick, style: styles.clickTarget },
                    this.props.label
                )
            );

            styles.children.display = this.state.collapsed ? 'none' : 'block';

            // Render children if not collapsed, or (persistent and has been expanded)
            var children = (!this.state.collapsed || this.props.persistent && this.state.hasBeenExpanded) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'children', style: styles.children },
                this.props.children
            );

            var className = 'tree-view ' + this.props.className;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: className, style: Object.assign(styles.tree, this.props.style) },
                label,
                children
            );
        }
    }]);

    return TreeView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

// TODO: Documentation


TreeView.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    persistent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    initiallyExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    arrowSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

TreeView.defaultProps = {
    persistent: false,
    initiallyExpanded: false,
    arrowSymbol: '▸',
    style: {}
};

/* harmony default export */ __webpack_exports__["a"] = (TreeView);

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserOrgUnitsFirstLevel = function UserOrgUnitsFirstLevel(_ref) {
    var style = _ref.style;
    return _react2.default.createElement(
        "svg",
        {
            width: "45px",
            height: "41px",
            viewBox: "0 0 45 41",
            version: "1.1",
            style: style
        },
        _react2.default.createElement("rect", { className: "filled", x: "18.5", y: "0.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "30.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "6.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "12.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "24.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "36.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "0.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("path", { d: "M22.5,9.5 L22.5,12.5" }),
        _react2.default.createElement("path", { d: "M10.5,25.5 L10.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L10.5,15.5" }),
        _react2.default.createElement("path", { d: "M34.5,12.5 L34.5,15.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L4.5,31.5" }),
        _react2.default.createElement("path", { d: "M40.5,29.5 L40.5,32.5" }),
        _react2.default.createElement("path", { d: "M16.5,29.5 L16.5,32.5" }),
        _react2.default.createElement("path", { d: "M28.5,29.5 L28.5,32.5" }),
        _react2.default.createElement("path", { d: "M34.5,25.5 L34.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L34.5,12.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L16.5,28.5" }),
        _react2.default.createElement("path", { d: "M28.5,28.5 L40.5,28.5" })
    );
};

exports.default = UserOrgUnitsFirstLevel;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserOrgUnitsSecondLevel = function UserOrgUnitsSecondLevel(_ref) {
    var style = _ref.style;
    return _react2.default.createElement(
        "svg",
        {
            width: "45px",
            height: "41px",
            viewBox: "0 0 45 41",
            version: "1.1",
            style: style
        },
        _react2.default.createElement("rect", { x: "18.5", y: "0.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "30.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "6.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "12.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "24.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "36.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "0.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("path", { d: "M22.5,9.5 L22.5,12.5" }),
        _react2.default.createElement("path", { d: "M10.5,25.5 L10.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L10.5,15.5" }),
        _react2.default.createElement("path", { d: "M34.5,12.5 L34.5,15.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L4.5,31.5" }),
        _react2.default.createElement("path", { d: "M40.5,29.5 L40.5,32.5" }),
        _react2.default.createElement("path", { d: "M16.5,29.5 L16.5,32.5" }),
        _react2.default.createElement("path", { d: "M28.5,29.5 L28.5,32.5" }),
        _react2.default.createElement("path", { d: "M34.5,25.5 L34.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L34.5,12.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L16.5,28.5" }),
        _react2.default.createElement("path", { d: "M28.5,28.5 L40.5,28.5" })
    );
};

exports.default = UserOrgUnitsSecondLevel;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserOrgUnitsThirdLevel = function UserOrgUnitsThirdLevel(_ref) {
    var style = _ref.style;
    return _react2.default.createElement(
        "svg",
        {
            width: "45px",
            height: "41px",
            viewBox: "0 0 45 41",
            version: "1.1",
            style: style
        },
        _react2.default.createElement("rect", { x: "18.5", y: "0.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "30.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { x: "6.5", y: "16.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "12.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "24.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "36.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("rect", { className: "filled", x: "0.5", y: "32.5", width: "8", height: "8" }),
        _react2.default.createElement("path", { d: "M22.5,9.5 L22.5,12.5" }),
        _react2.default.createElement("path", { d: "M10.5,25.5 L10.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L10.5,15.5" }),
        _react2.default.createElement("path", { d: "M34.5,12.5 L34.5,15.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L4.5,31.5" }),
        _react2.default.createElement("path", { d: "M40.5,29.5 L40.5,32.5" }),
        _react2.default.createElement("path", { d: "M16.5,29.5 L16.5,32.5" }),
        _react2.default.createElement("path", { d: "M28.5,29.5 L28.5,32.5" }),
        _react2.default.createElement("path", { d: "M34.5,25.5 L34.5,28.5" }),
        _react2.default.createElement("path", { d: "M10.5,12.5 L34.5,12.5" }),
        _react2.default.createElement("path", { d: "M4.5,28.5 L16.5,28.5" }),
        _react2.default.createElement("path", { d: "M28.5,28.5 L40.5,28.5" })
    );
};

exports.default = UserOrgUnitsThirdLevel;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1180);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./UserOrgUnits.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./UserOrgUnits.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".UserOrgUnits {\n\n}\n\n\n.UserOrgUnits .selected {\n\n}\n\n.UserOrgUnits svg rect {\n    stroke: #555;\n    fill: none;\n}\n\n.UserOrgUnits svg rect.filled {\n    stroke: #555;\n    fill: #555;\n}\n\n.UserOrgUnits svg path {\n    stroke: #555;\n}", ""]);

// exports


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    container: {
        paddingTop: 24,
        lineHeight: '22px'
    },
    error: {
        color: 'red'
    }
};

var levels = {
    USER_ORGUNIT: 'user organisation unit',
    USER_ORGUNIT_CHILDREN: 'right below user organisation unit',
    USER_ORGUNIT_GRANDCHILDREN: 'two levels below user organisation unit'
};

var SelectedOrgUnits = function SelectedOrgUnits(_ref) {
    var units = _ref.units,
        rows = _ref.rows,
        error = _ref.error;

    var orgUnits = (0, _analytics.getOrgUnitNodesFromRows)(rows).map(function (ou) {
        return ou.displayName;
    }).sort();
    var userOrgUnits = (0, _analytics.getUserOrgUnitsFromRows)(rows).sort().map(function (id) {
        return _i18next2.default.t(levels[id]);
    });

    var selected = _i18next2.default.t('No organisation units are selected');

    if (orgUnits.length || userOrgUnits.length) {
        selected = units + ' ' + _i18next2.default.t('in') + ' ';

        if (userOrgUnits.length) {
            selected += userOrgUnits.join(', ');
        } else {
            selected += orgUnits.join(', ');
        }
    }

    return _react2.default.createElement(
        'div',
        { style: styles.container },
        error && !orgUnits.length && !userOrgUnits.length ? _react2.default.createElement(
            'div',
            { style: styles.error },
            error
        ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'strong',
                null,
                'Selected organisation units'
            ),
            _react2.default.createElement('br', null),
            selected
        )
    );
};

exports.default = SelectedOrgUnits;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Tabs = __webpack_require__(240);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _Checkbox = __webpack_require__(549);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FontStyle = __webpack_require__(550);

var _FontStyle2 = _interopRequireDefault(_FontStyle);

var _OrgUnitGroupSetSelect = __webpack_require__(1185);

var _OrgUnitGroupSetSelect2 = _interopRequireDefault(_OrgUnitGroupSetSelect);

var _OrgUnitTree = __webpack_require__(276);

var _OrgUnitTree2 = _interopRequireDefault(_OrgUnitTree);

var _OrgUnitGroupSelect = __webpack_require__(551);

var _OrgUnitGroupSelect2 = _interopRequireDefault(_OrgUnitGroupSelect);

var _OrgUnitLevelSelect = __webpack_require__(552);

var _OrgUnitLevelSelect2 = _interopRequireDefault(_OrgUnitLevelSelect);

var _UserOrgUnitsSelect = __webpack_require__(277);

var _UserOrgUnitsSelect2 = _interopRequireDefault(_UserOrgUnitsSelect);

var _LayerDialogStyles = __webpack_require__(242);

var _layerEdit = __webpack_require__(60);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _extends({}, _LayerDialogStyles.layerDialogStyles, {
    wrapper: {
        width: '100%',
        clear: 'both',
        height: 64
    },
    checkbox: {
        float: 'left',
        margin: '24px 0 0 12px',
        width: 180
    },
    font: {
        float: 'left',
        marginTop: -8
    },
    radius: {
        width: 206,
        marginTop: -8
    },
    help: {
        marginTop: 10
    },
    error: {
        marginTop: 10,
        color: 'red'
    }
});

var FacilityDialog = function (_Component) {
    _inherits(FacilityDialog, _Component);

    function FacilityDialog(props, context) {
        _classCallCheck(this, FacilityDialog);

        var _this = _possibleConstructorReturn(this, (FacilityDialog.__proto__ || Object.getPrototypeOf(FacilityDialog)).call(this, props, context));

        _this.state = {
            tab: 'group',
            showBuffer: _this.hasBuffer(props.areaRadius)
        };
        return _this;
    }

    _createClass(FacilityDialog, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var areaRadius = _ref.areaRadius;

            if (areaRadius !== this.props.areaRadius) {
                this.setState({
                    showBuffer: this.hasBuffer(areaRadius)
                });
            }
        }
    }, {
        key: 'onShowBufferClick',
        value: function onShowBufferClick(isChecked) {
            var _props = this.props,
                setAreaRadius = _props.setAreaRadius,
                areaRadius = _props.areaRadius;


            setAreaRadius(isChecked ? areaRadius || 5000 : null);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                _props2$rows = _props2.rows,
                rows = _props2$rows === undefined ? [] : _props2$rows,
                organisationUnitGroupSet = _props2.organisationUnitGroupSet,
                labels = _props2.labels,
                labelFontColor = _props2.labelFontColor,
                labelFontSize = _props2.labelFontSize,
                labelFontWeight = _props2.labelFontWeight,
                labelFontStyle = _props2.labelFontStyle,
                areaRadius = _props2.areaRadius,
                setOrganisationUnitGroupSet = _props2.setOrganisationUnitGroupSet,
                setOrgUnitLevels = _props2.setOrgUnitLevels,
                setOrgUnitGroups = _props2.setOrgUnitGroups,
                setUserOrgUnits = _props2.setUserOrgUnits,
                toggleOrganisationUnit = _props2.toggleOrganisationUnit,
                setLabels = _props2.setLabels,
                setLabelFontColor = _props2.setLabelFontColor,
                setLabelFontSize = _props2.setLabelFontSize,
                setLabelFontWeight = _props2.setLabelFontWeight,
                setLabelFontStyle = _props2.setLabelFontStyle,
                setAreaRadius = _props2.setAreaRadius;
            var _state = this.state,
                tab = _state.tab,
                orgUnitGroupSetError = _state.orgUnitGroupSetError,
                orgUnitsError = _state.orgUnitsError,
                showBuffer = _state.showBuffer;


            var orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
            var selectedUserOrgUnits = (0, _analytics.getUserOrgUnitsFromRows)(rows);

            return _react2.default.createElement(
                _Tabs.Tabs,
                {
                    style: styles.tabs,
                    tabItemContainerStyle: styles.tabBar,
                    value: tab,
                    onChange: function onChange(tab) {
                        return _this2.setState({ tab: tab });
                    }
                },
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'group', label: _i18next2.default.t('Group set') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_OrgUnitGroupSetSelect2.default, {
                            value: organisationUnitGroupSet,
                            onChange: setOrganisationUnitGroupSet,
                            style: styles.select,
                            errorText: orgUnitGroupSetError
                        })
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'orgunits', label: _i18next2.default.t('Organisation units') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitTree2.default, {
                                selected: (0, _analytics.getOrgUnitNodesFromRows)(rows),
                                onClick: toggleOrganisationUnit,
                                disabled: selectedUserOrgUnits.length ? true : false
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitLevelSelect2.default, {
                                orgUnitLevel: (0, _analytics.getOrgUnitLevelsFromRows)(rows),
                                onChange: setOrgUnitLevels
                            }),
                            _react2.default.createElement(_OrgUnitGroupSelect2.default, {
                                orgUnitGroup: (0, _analytics.getOrgUnitGroupsFromRows)(rows),
                                onChange: setOrgUnitGroups
                            }),
                            _react2.default.createElement(_UserOrgUnitsSelect2.default, {
                                selected: selectedUserOrgUnits,
                                onChange: setUserOrgUnits
                            }),
                            !orgUnits.length && orgUnitsError ? _react2.default.createElement(
                                'div',
                                { style: styles.error },
                                orgUnitsError
                            ) : _react2.default.createElement(
                                'div',
                                { style: styles.help },
                                _i18next2.default.t('Remember to select the organisation unit level containing the facilities.')
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'style', label: _i18next2.default.t('Style') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.wrapper },
                            _react2.default.createElement(_Checkbox2.default, {
                                label: _i18next2.default.t('Show labels'),
                                checked: labels,
                                onCheck: setLabels,
                                style: styles.checkbox
                            }),
                            labels && _react2.default.createElement(_FontStyle2.default, {
                                color: labelFontColor,
                                size: labelFontSize,
                                weight: labelFontWeight,
                                fontStyle: labelFontStyle,
                                onColorChange: setLabelFontColor,
                                onSizeChange: setLabelFontSize,
                                onWeightChange: setLabelFontWeight,
                                onStyleChange: setLabelFontStyle,
                                style: styles.font
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.labelWrapper },
                            _react2.default.createElement(_Checkbox2.default, {
                                label: _i18next2.default.t('Show buffer'),
                                checked: showBuffer,
                                onCheck: this.onShowBufferClick.bind(this),
                                style: styles.checkbox
                            }),
                            showBuffer && _react2.default.createElement(_TextField2.default, {
                                type: 'number',
                                label: _i18next2.default.t('Radius in meters'),
                                value: areaRadius || '',
                                onChange: setAreaRadius,
                                style: styles.radius
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: 'hasBuffer',
        value: function hasBuffer(areaRadius) {
            return areaRadius !== undefined && areaRadius !== null;
        }

        // TODO: Add to parent class?

    }, {
        key: 'setErrorState',
        value: function setErrorState(key, message, tab) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, key, message), _defineProperty(_setState, 'tab', tab), _setState));

            return false;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _props3 = this.props,
                organisationUnitGroupSet = _props3.organisationUnitGroupSet,
                rows = _props3.rows;


            if (!organisationUnitGroupSet) {
                return this.setErrorState('orgUnitGroupSetError', _i18next2.default.t('Group set is required'), 'group');
            }

            if (!(0, _analytics.getOrgUnitsFromRows)(rows).length) {
                return this.setErrorState('orgUnitsError', _i18next2.default.t('No organisation units are selected'), 'orgunits');
            }

            return true;
        }
    }]);

    return FacilityDialog;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, {
    setOrganisationUnitGroupSet: _layerEdit.setOrganisationUnitGroupSet,
    setOrgUnitLevels: _layerEdit.setOrgUnitLevels,
    setOrgUnitGroups: _layerEdit.setOrgUnitGroups,
    setUserOrgUnits: _layerEdit.setUserOrgUnits,
    toggleOrganisationUnit: _layerEdit.toggleOrganisationUnit,
    setLabels: _layerEdit.setLabels,
    setLabelFontColor: _layerEdit.setLabelFontColor,
    setLabelFontSize: _layerEdit.setLabelFontSize,
    setLabelFontWeight: _layerEdit.setLabelFontWeight,
    setLabelFontStyle: _layerEdit.setLabelFontStyle,
    setAreaRadius: _layerEdit.setAreaRadius
}, null, {
    withRef: true
})(FacilityDialog);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatBold = function EditorFormatBold(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
  );
};
EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
EditorFormatBold.displayName = 'EditorFormatBold';
EditorFormatBold.muiName = 'SvgIcon';

exports.default = EditorFormatBold;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatItalic = function EditorFormatItalic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
  );
};
EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
EditorFormatItalic.displayName = 'EditorFormatItalic';
EditorFormatItalic.muiName = 'SvgIcon';

exports.default = EditorFormatItalic;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrgUnitGroupSetSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _orgUnits = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrgUnitGroupSetSelect = exports.OrgUnitGroupSetSelect = function (_Component) {
    _inherits(OrgUnitGroupSetSelect, _Component);

    function OrgUnitGroupSetSelect() {
        _classCallCheck(this, OrgUnitGroupSetSelect);

        return _possibleConstructorReturn(this, (OrgUnitGroupSetSelect.__proto__ || Object.getPrototypeOf(OrgUnitGroupSetSelect)).apply(this, arguments));
    }

    _createClass(OrgUnitGroupSetSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                orgUnitGroupSets = _props.orgUnitGroupSets,
                loadOrgUnitGroupSets = _props.loadOrgUnitGroupSets;


            if (!orgUnitGroupSets) {
                loadOrgUnitGroupSets();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                orgUnitGroupSets = _props2.orgUnitGroupSets,
                value = _props2.value,
                onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Group set'),
                loading: orgUnitGroupSets ? false : true,
                items: orgUnitGroupSets,
                value: value ? value.id : null,
                onChange: onChange,
                style: style,
                errorText: !value && errorText ? errorText : null
            });
        }
    }]);

    return OrgUnitGroupSetSelect;
}(_react.Component);

OrgUnitGroupSetSelect.propTypes = {
    label: _propTypes2.default.string,
    value: _propTypes2.default.object,
    orgUnitGroupSets: _propTypes2.default.array,
    loadOrgUnitGroupSets: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        orgUnitGroupSets: state.orgUnitGroupSets
    };
}, { loadOrgUnitGroupSets: _orgUnits.loadOrgUnitGroupSets })(OrgUnitGroupSetSelect);

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThematicDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Reporting rate


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Tabs = __webpack_require__(240);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _ValueTypeSelect = __webpack_require__(1187);

var _ValueTypeSelect2 = _interopRequireDefault(_ValueTypeSelect);

var _AggregationTypeSelect = __webpack_require__(1188);

var _AggregationTypeSelect2 = _interopRequireDefault(_AggregationTypeSelect);

var _Checkbox = __webpack_require__(549);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Classification = __webpack_require__(669);

var _Classification2 = _interopRequireDefault(_Classification);

var _DataElementGroupSelect = __webpack_require__(1189);

var _DataElementGroupSelect2 = _interopRequireDefault(_DataElementGroupSelect);

var _DataElementSelect = __webpack_require__(1190);

var _DataElementSelect2 = _interopRequireDefault(_DataElementSelect);

var _DataElementOperandSelect = __webpack_require__(1191);

var _DataElementOperandSelect2 = _interopRequireDefault(_DataElementOperandSelect);

var _TotalsDetailsSelect = __webpack_require__(1192);

var _TotalsDetailsSelect2 = _interopRequireDefault(_TotalsDetailsSelect);

var _EventDataItemSelect = __webpack_require__(1196);

var _EventDataItemSelect2 = _interopRequireDefault(_EventDataItemSelect);

var _DataSetsSelect = __webpack_require__(1197);

var _DataSetsSelect2 = _interopRequireDefault(_DataSetsSelect);

var _FontStyle = __webpack_require__(550);

var _FontStyle2 = _interopRequireDefault(_FontStyle);

var _IndicatorGroupSelect = __webpack_require__(1198);

var _IndicatorGroupSelect2 = _interopRequireDefault(_IndicatorGroupSelect);

var _LegendSetSelect = __webpack_require__(1199);

var _LegendSetSelect2 = _interopRequireDefault(_LegendSetSelect);

var _LegendTypeSelect = __webpack_require__(1200);

var _LegendTypeSelect2 = _interopRequireDefault(_LegendTypeSelect);

var _IndicatorSelect = __webpack_require__(1201);

var _IndicatorSelect2 = _interopRequireDefault(_IndicatorSelect);

var _OrgUnitGroupSelect = __webpack_require__(551);

var _OrgUnitGroupSelect2 = _interopRequireDefault(_OrgUnitGroupSelect);

var _OrgUnitLevelSelect = __webpack_require__(552);

var _OrgUnitLevelSelect2 = _interopRequireDefault(_OrgUnitLevelSelect);

var _OrgUnitTree = __webpack_require__(276);

var _OrgUnitTree2 = _interopRequireDefault(_OrgUnitTree);

var _PeriodSelect = __webpack_require__(675);

var _PeriodSelect2 = _interopRequireDefault(_PeriodSelect);

var _PeriodTypeSelect = __webpack_require__(1216);

var _PeriodTypeSelect2 = _interopRequireDefault(_PeriodTypeSelect);

var _ProgramSelect = __webpack_require__(659);

var _ProgramSelect2 = _interopRequireDefault(_ProgramSelect);

var _ProgramIndicatorSelect = __webpack_require__(1217);

var _ProgramIndicatorSelect2 = _interopRequireDefault(_ProgramIndicatorSelect);

var _RelativePeriodSelect = __webpack_require__(661);

var _RelativePeriodSelect2 = _interopRequireDefault(_RelativePeriodSelect);

var _UserOrgUnitsSelect = __webpack_require__(277);

var _UserOrgUnitsSelect2 = _interopRequireDefault(_UserOrgUnitsSelect);

var _LayerDialogStyles = __webpack_require__(242);

var _dimension = __webpack_require__(90);

var _layers = __webpack_require__(68);

var _layerEdit = __webpack_require__(60);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _extends({}, _LayerDialogStyles.layerDialogStyles, {
    wrapper: {
        width: '100%',
        clear: 'both',
        height: 64
    },
    checkbox: {
        float: 'left',
        margin: '24px 0 0 12px',
        width: 180
    },
    font: {
        float: 'left',
        marginTop: -8
    },
    error: {
        marginTop: 10,
        color: 'red'
    }
});

var ThematicDialog = exports.ThematicDialog = function (_Component) {
    _inherits(ThematicDialog, _Component);

    function ThematicDialog(props, context) {
        _classCallCheck(this, ThematicDialog);

        var _this = _possibleConstructorReturn(this, (ThematicDialog.__proto__ || Object.getPrototypeOf(ThematicDialog)).call(this, props, context));

        _this.state = {
            tab: 'data'
        };
        return _this;
    }

    _createClass(ThematicDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                valueType = _props.valueType,
                columns = _props.columns,
                setValueType = _props.setValueType;

            var dataItem = (0, _analytics.getDataItemFromColumns)(columns);

            // Set value type if favorite is loaded
            if (!valueType && dataItem && dataItem.dimensionItemType) {
                var dimension = Object.keys(_dimension.dimConf).find(function (dim) {
                    return _dimension.dimConf[dim].itemType === dataItem.dimensionItemType;
                });

                if (dimension) {
                    setValueType(_dimension.dimConf[dimension].objectName, true);
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props2 = this.props,
                valueType = _props2.valueType,
                columns = _props2.columns,
                rows = _props2.rows,
                method = _props2.method,
                setValueType = _props2.setValueType,
                setClassification = _props2.setClassification,
                setLegendSet = _props2.setLegendSet,
                loadOrgUnitPath = _props2.loadOrgUnitPath;


            if (!valueType) {
                setValueType('in'); // TODO: Make constant
            }

            // Set connected legend set when indicator is selected
            if (columns) {
                var dataItem = (0, _analytics.getDataItemFromColumns)(columns);
                var prevDataItem = (0, _analytics.getDataItemFromColumns)(prevProps.columns);

                if (dataItem && dataItem !== prevDataItem) {
                    if (dataItem.legendSet) {
                        setClassification(_layers.CLASSIFICATION_PREDEFINED);
                        setLegendSet(dataItem.legendSet);
                    } else {
                        setClassification(_layers.CLASSIFICATION_EQUAL_INTERVALS);
                    }
                }
            }

            if (rows) {
                var orgUnits = (0, _analytics.getOrgUnitNodesFromRows)(rows);

                // Load organisation unit tree path (temporary solution, as favorites don't include paths)
                orgUnits.filter(function (ou) {
                    return !ou.path;
                }).forEach(function (ou) {
                    return loadOrgUnitPath(ou.id);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                classes = _props3.classes,
                colorScale = _props3.colorScale,
                columns = _props3.columns,
                dataElementGroup = _props3.dataElementGroup,
                filters = _props3.filters,
                id = _props3.id,
                indicatorGroup = _props3.indicatorGroup,
                labels = _props3.labels,
                labelFontColor = _props3.labelFontColor,
                labelFontSize = _props3.labelFontSize,
                labelFontStyle = _props3.labelFontStyle,
                labelFontWeight = _props3.labelFontWeight,
                legendSet = _props3.legendSet,
                method = _props3.method,
                operand = _props3.operand,
                periodType = _props3.periodType,
                program = _props3.program,
                radiusHigh = _props3.radiusHigh,
                radiusLow = _props3.radiusLow,
                rows = _props3.rows,
                valueType = _props3.valueType;
            var _props4 = this.props,
                setClassification = _props4.setClassification,
                setDataItem = _props4.setDataItem,
                setDataElementGroup = _props4.setDataElementGroup,
                setIndicatorGroup = _props4.setIndicatorGroup,
                setLabels = _props4.setLabels,
                setLabelFontColor = _props4.setLabelFontColor,
                setLabelFontSize = _props4.setLabelFontSize,
                setLabelFontWeight = _props4.setLabelFontWeight,
                setLabelFontStyle = _props4.setLabelFontStyle,
                setLegendSet = _props4.setLegendSet,
                setOperand = _props4.setOperand,
                setOrgUnitLevels = _props4.setOrgUnitLevels,
                setOrgUnitGroups = _props4.setOrgUnitGroups,
                setPeriod = _props4.setPeriod,
                setPeriodType = _props4.setPeriodType,
                setProgram = _props4.setProgram,
                setRadiusLow = _props4.setRadiusLow,
                setRadiusHigh = _props4.setRadiusHigh,
                setUserOrgUnits = _props4.setUserOrgUnits,
                setValueType = _props4.setValueType,
                toggleOrganisationUnit = _props4.toggleOrganisationUnit;
            var _state = this.state,
                tab = _state.tab,
                indicatorGroupError = _state.indicatorGroupError,
                indicatorError = _state.indicatorError,
                orgUnitsError = _state.orgUnitsError,
                periodTypeError = _state.periodTypeError,
                periodError = _state.periodError;


            var orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
            var selectedUserOrgUnits = (0, _analytics.getUserOrgUnitsFromRows)(rows);
            var period = (0, _analytics.getPeriodFromFilters)(filters);
            var dataItem = (0, _analytics.getDataItemFromColumns)(columns);

            return _react2.default.createElement(
                _Tabs.Tabs,
                {
                    style: styles.tabs,
                    tabItemContainerStyle: styles.tabBar,
                    value: tab,
                    onChange: function onChange(tab) {
                        return _this2.setState({ tab: tab });
                    }
                },
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'data', label: _i18next2.default.t('data') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_ValueTypeSelect2.default, {
                            value: valueType,
                            style: styles.select,
                            onChange: setValueType
                        }),
                        (!valueType || valueType === 'in') && [
                        // Indicator (default)
                        _react2.default.createElement(_IndicatorGroupSelect2.default, {
                            key: 'group',
                            indicatorGroup: indicatorGroup,
                            onChange: setIndicatorGroup,
                            style: styles.select,
                            errorText: indicatorGroupError
                        }), _react2.default.createElement(_IndicatorSelect2.default, {
                            key: 'indicator',
                            indicatorGroup: indicatorGroup,
                            indicator: dataItem,
                            onChange: setDataItem,
                            style: styles.select,
                            errorText: indicatorError
                        })],
                        valueType === 'de' && [
                        // Data element
                        _react2.default.createElement(_DataElementGroupSelect2.default, {
                            key: 'group',
                            dataElementGroup: dataElementGroup,
                            onChange: setDataElementGroup,
                            style: styles.select
                        }), dataElementGroup && _react2.default.createElement(_TotalsDetailsSelect2.default, {
                            key: 'totals',
                            operand: operand,
                            onChange: setOperand,
                            style: styles.select
                        }), operand === true ? _react2.default.createElement(_DataElementOperandSelect2.default, {
                            key: 'element',
                            dataElementGroup: dataElementGroup,
                            dataElement: dataItem,
                            onChange: setDataItem,
                            style: styles.select
                        }) : _react2.default.createElement(_DataElementSelect2.default, {
                            key: 'element',
                            dataElementGroup: dataElementGroup,
                            dataElement: dataItem,
                            onChange: setDataItem,
                            style: styles.select
                        })],
                        valueType === 'ds' && // Reporting rates
                        _react2.default.createElement(_DataSetsSelect2.default, {
                            key: 'item',
                            dataSet: dataItem,
                            onChange: setDataItem,
                            style: styles.select
                        }),
                        valueType === 'di' && [
                        // Event data items
                        _react2.default.createElement(_ProgramSelect2.default, {
                            key: 'program',
                            program: program,
                            onChange: setProgram,
                            style: styles.select
                        }), program && _react2.default.createElement(_EventDataItemSelect2.default, {
                            key: 'item',
                            program: program,
                            dataItem: dataItem,
                            onChange: setDataItem,
                            style: styles.select
                        })],
                        valueType === 'pi' && [
                        // Program indicator
                        _react2.default.createElement(_ProgramSelect2.default, {
                            key: 'program',
                            program: program,
                            onChange: setProgram,
                            style: styles.select
                        }), program && _react2.default.createElement(_ProgramIndicatorSelect2.default, {
                            key: 'indicator',
                            program: program,
                            programIndicator: dataItem,
                            onChange: setDataItem,
                            style: styles.select
                        })],
                        _react2.default.createElement(_AggregationTypeSelect2.default, { style: styles.select })
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'period', label: _i18next2.default.t('period') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_PeriodTypeSelect2.default, {
                            value: periodType,
                            onChange: function onChange(type) {
                                return setPeriodType(type.id);
                            },
                            style: styles.select,
                            errorText: periodTypeError
                        }),
                        periodType === 'relativePeriods' && _react2.default.createElement(_RelativePeriodSelect2.default, {
                            period: period,
                            onChange: setPeriod,
                            style: styles.select,
                            errorText: periodError
                        }),
                        (periodType && periodType !== 'relativePeriods' || !periodType && id) && _react2.default.createElement(_PeriodSelect2.default, {
                            periodType: periodType,
                            period: period,
                            onChange: setPeriod,
                            style: styles.select,
                            errorText: periodError
                        })
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'orgunits', label: _i18next2.default.t('Org units') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitTree2.default, {
                                selected: (0, _analytics.getOrgUnitNodesFromRows)(rows),
                                onClick: toggleOrganisationUnit,
                                disabled: selectedUserOrgUnits.length ? true : false
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitLevelSelect2.default, {
                                orgUnitLevel: (0, _analytics.getOrgUnitLevelsFromRows)(rows),
                                defaultLevel: 2,
                                onChange: setOrgUnitLevels
                            }),
                            _react2.default.createElement(_OrgUnitGroupSelect2.default, {
                                orgUnitGroup: (0, _analytics.getOrgUnitGroupsFromRows)(rows),
                                onChange: setOrgUnitGroups
                            }),
                            _react2.default.createElement(_UserOrgUnitsSelect2.default, {
                                selected: selectedUserOrgUnits,
                                onChange: setUserOrgUnits
                            }),
                            !orgUnits.length && orgUnitsError && _react2.default.createElement(
                                'div',
                                { style: styles.error },
                                orgUnitsError
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'style', label: _i18next2.default.t('Style') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flexColumnFlow },
                        _react2.default.createElement(_LegendTypeSelect2.default, {
                            method: method,
                            onChange: setClassification,
                            style: _extends({}, styles.select, { marginTop: 12 })
                        }),
                        method !== 1 && _react2.default.createElement(_Classification2.default, {
                            method: method,
                            classes: classes,
                            colorScale: colorScale,
                            style: _extends({}, styles.select, { marginTop: 12 })
                        }),
                        method === 1 && _react2.default.createElement(_LegendSetSelect2.default, {
                            legendSet: legendSet,
                            onChange: setLegendSet,
                            style: _extends({}, styles.select, { marginTop: 4 })
                        }),
                        _react2.default.createElement(
                            'div',
                            {
                                style: _extends({}, styles.flexFull, {
                                    marginTop: -12,
                                    marginLeft: -12
                                })
                            },
                            _react2.default.createElement(_TextField2.default, {
                                type: 'number',
                                label: _i18next2.default.t('Low size'),
                                value: radiusLow !== undefined ? radiusLow : 5,
                                onChange: setRadiusLow,
                                style: { width: 125, marginRight: 24 }
                            }),
                            _react2.default.createElement(_TextField2.default, {
                                type: 'number',
                                label: _i18next2.default.t('High size'),
                                value: radiusHigh !== undefined ? radiusHigh : 15,
                                onChange: setRadiusHigh,
                                style: { width: 125 }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: _extends({}, styles.wrapper, { marginLeft: -12 }) },
                            _react2.default.createElement(_Checkbox2.default, {
                                label: _i18next2.default.t('Show labels'),
                                checked: labels,
                                onCheck: setLabels,
                                style: styles.checkbox
                            }),
                            labels && _react2.default.createElement(_FontStyle2.default, {
                                color: labelFontColor,
                                size: labelFontSize,
                                weight: labelFontWeight,
                                fontStyle: labelFontStyle,
                                onColorChange: setLabelFontColor,
                                onSizeChange: setLabelFontSize,
                                onWeightChange: setLabelFontWeight,
                                onStyleChange: setLabelFontStyle,
                                style: styles.font
                            })
                        )
                    )
                )
            );
        }

        // TODO: Add to parent class?

    }, {
        key: 'setErrorState',
        value: function setErrorState(key, message, tab) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, key, message), _defineProperty(_setState, 'tab', tab), _setState));

            return false;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _props5 = this.props,
                valueType = _props5.valueType,
                indicatorGroup = _props5.indicatorGroup,
                periodType = _props5.periodType,
                columns = _props5.columns,
                rows = _props5.rows,
                filters = _props5.filters;

            var dataItem = (0, _analytics.getDataItemFromColumns)(columns);
            var period = (0, _analytics.getPeriodFromFilters)(filters);

            if (valueType === 'in') {
                // TODO: Use constant
                if (!indicatorGroup && !dataItem) {
                    return this.setErrorState('indicatorGroupError', _i18next2.default.t('Indicator group is required'), 'data');
                } else if (!dataItem) {
                    return this.setErrorState('indicatorError', _i18next2.default.t('Indicator is required'), 'data');
                }
            }

            if (!periodType && !period) {
                return this.setErrorState('periodTypeError', _i18next2.default.t('Period type is required'), 'period');
            } else if (!period) {
                return this.setErrorState('periodError', _i18next2.default.t('Period is required'), 'period');
            }

            if (!(0, _analytics.getOrgUnitsFromRows)(rows).length) {
                return this.setErrorState('orgUnitsError', _i18next2.default.t('No organisation units are selected'), 'orgunits');
            }

            return true;
        }
    }]);

    return ThematicDialog;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, {
    setClassification: _layerEdit.setClassification,
    setDataItem: _layerEdit.setDataItem,
    setDataElementGroup: _layerEdit.setDataElementGroup,
    setIndicatorGroup: _layerEdit.setIndicatorGroup,
    setLabels: _layerEdit.setLabels,
    setLabelFontColor: _layerEdit.setLabelFontColor,
    setLabelFontSize: _layerEdit.setLabelFontSize,
    setLabelFontWeight: _layerEdit.setLabelFontWeight,
    setLabelFontStyle: _layerEdit.setLabelFontStyle,
    setLegendSet: _layerEdit.setLegendSet,
    setOperand: _layerEdit.setOperand,
    setOrgUnitLevels: _layerEdit.setOrgUnitLevels,
    setOrgUnitGroups: _layerEdit.setOrgUnitGroups,
    setPeriod: _layerEdit.setPeriod,
    setPeriodType: _layerEdit.setPeriodType,
    setProgram: _layerEdit.setProgram,
    setRadiusLow: _layerEdit.setRadiusLow,
    setRadiusHigh: _layerEdit.setRadiusHigh,
    setUserOrgUnits: _layerEdit.setUserOrgUnits,
    setValueType: _layerEdit.setValueType,
    toggleOrganisationUnit: _layerEdit.toggleOrganisationUnit,
    loadOrgUnitPath: _layerEdit.loadOrgUnitPath
}, null, {
    withRef: true
})(ThematicDialog);

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _dimension = __webpack_require__(90);

var _layerEdit = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueTypeSelect = function ValueTypeSelect(props) {
    var value = props.value,
        _onChange = props.onChange;

    // console.log(dimConf.indicator.objectName);

    // TODO: Avoid creating on each render (needs to be created after i18next conatins transaltions

    var items = [{ id: _dimension.dimConf.indicator.objectName, name: _i18next2.default.t('Indicator') }, { id: _dimension.dimConf.dataElement.objectName, name: _i18next2.default.t('Data element') }, { id: _dimension.dimConf.dataSet.objectName, name: _i18next2.default.t('Reporting rates') }, {
        id: _dimension.dimConf.eventDataItem.objectName,
        name: _i18next2.default.t('Event data items')
    }, {
        id: _dimension.dimConf.programIndicator.objectName,
        name: _i18next2.default.t('Program indicators')
    }];

    return _react2.default.createElement(_SelectField2.default, _extends({}, props, {
        label: _i18next2.default.t('Item type'),
        items: items
        // value={value || dimConf.indicator.objectName}
        , value: value,
        onChange: function onChange(valueType) {
            return _onChange(valueType.id);
        }
    }));
};

exports.default = ValueTypeSelect;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AggregationTypeSelect = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _aggregationTypes = __webpack_require__(672);

var _layerEdit = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = void 0;

var AggregationTypeSelect = exports.AggregationTypeSelect = function AggregationTypeSelect(_ref) {
    var aggregationType = _ref.aggregationType,
        setAggregationType = _ref.setAggregationType,
        style = _ref.style;

    if (!types) {
        types = _aggregationTypes.aggregationTypes.map(function (type) {
            return {
                id: type.id,
                name: _i18next2.default.t(type.name)
            };
        });
    }

    return _react2.default.createElement(_SelectField2.default, {
        label: _i18next2.default.t('Aggregation type'),
        items: types,
        value: aggregationType || types[0].id,
        onChange: function onChange(type) {
            return setAggregationType(type.id);
        },
        style: style
    });
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        aggregationType: state.layerEdit.aggregationType
    };
}, { setAggregationType: _layerEdit.setAggregationType })(AggregationTypeSelect);

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementGroupSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _dataElements = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataElementGroupSelect = exports.DataElementGroupSelect = function (_Component) {
    _inherits(DataElementGroupSelect, _Component);

    function DataElementGroupSelect() {
        _classCallCheck(this, DataElementGroupSelect);

        return _possibleConstructorReturn(this, (DataElementGroupSelect.__proto__ || Object.getPrototypeOf(DataElementGroupSelect)).apply(this, arguments));
    }

    _createClass(DataElementGroupSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                dataElementGroups = _props.dataElementGroups,
                loadDataElementGroups = _props.loadDataElementGroups;


            if (!dataElementGroups) {
                loadDataElementGroups();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dataElementGroup = _props2.dataElementGroup,
                dataElementGroups = _props2.dataElementGroups,
                onChange = _props2.onChange,
                style = _props2.style;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Data element group'),
                loading: dataElementGroups ? false : true,
                items: dataElementGroups,
                value: dataElementGroup ? dataElementGroup.id : null,
                onChange: onChange,
                style: style
            });
        }
    }]);

    return DataElementGroupSelect;
}(_react.Component);

DataElementGroupSelect.propTypes = {
    dataElementGroup: _propTypes2.default.object,
    dataElementGroups: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dataElementGroups: state.dataElementGroups
    };
}, { loadDataElementGroups: _dataElements.loadDataElementGroups })(DataElementGroupSelect);

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _dataElements = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataElementSelect = exports.DataElementSelect = function (_PureComponent) {
    _inherits(DataElementSelect, _PureComponent);

    function DataElementSelect() {
        _classCallCheck(this, DataElementSelect);

        return _possibleConstructorReturn(this, (DataElementSelect.__proto__ || Object.getPrototypeOf(DataElementSelect)).apply(this, arguments));
    }

    _createClass(DataElementSelect, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                dataElements = _props.dataElements,
                dataElementGroup = _props.dataElementGroup,
                loadDataElements = _props.loadDataElements;


            if (dataElementGroup && !dataElements[dataElementGroup.id]) {
                loadDataElements(dataElementGroup.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dataElement = _props2.dataElement,
                dataElements = _props2.dataElements,
                dataElementGroup = _props2.dataElementGroup,
                _onChange = _props2.onChange,
                style = _props2.style;


            if (!dataElementGroup) {
                return null;
            }

            var items = dataElements[dataElementGroup.id];

            return _react2.default.createElement(_SelectField2.default, {
                key: 'indicators',
                label: _i18next2.default.t('Data element'),
                loading: items ? false : true,
                items: items,
                value: dataElement ? dataElement.id : null,
                onChange: function onChange(dataElement) {
                    return _onChange(dataElement, 'dataElement');
                },
                style: style
            });
        }
    }]);

    return DataElementSelect;
}(_react.PureComponent);

DataElementSelect.propTypes = {
    dataElement: _propTypes2.default.object,
    dataElements: _propTypes2.default.object,
    dataElementGroup: _propTypes2.default.object,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dataElements: state.dataElements
    };
}, { loadDataElements: _dataElements.loadDataElements })(DataElementSelect);

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementOperandSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _dataElements = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataElementOperandSelect = exports.DataElementOperandSelect = function (_Component) {
    _inherits(DataElementOperandSelect, _Component);

    function DataElementOperandSelect() {
        _classCallCheck(this, DataElementOperandSelect);

        return _possibleConstructorReturn(this, (DataElementOperandSelect.__proto__ || Object.getPrototypeOf(DataElementOperandSelect)).apply(this, arguments));
    }

    _createClass(DataElementOperandSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadDataElementOperands();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadDataElementOperands();
        }
    }, {
        key: 'loadDataElementOperands',
        value: function loadDataElementOperands() {
            var _props = this.props,
                dataElementOperands = _props.dataElementOperands,
                dataElementGroup = _props.dataElementGroup,
                loadDataElementOperands = _props.loadDataElementOperands;


            if (dataElementGroup && !dataElementOperands[dataElementGroup.id]) {
                loadDataElementOperands(dataElementGroup.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dataElement = _props2.dataElement,
                dataElementOperands = _props2.dataElementOperands,
                dataElementGroup = _props2.dataElementGroup,
                _onChange = _props2.onChange,
                style = _props2.style;


            if (!dataElementGroup) {
                return null;
            }

            var items = dataElementOperands[dataElementGroup.id];

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Data element operand'),
                loading: items ? false : true,
                items: items,
                value: dataElement ? dataElement.id : null,
                onChange: function onChange(dataElement) {
                    return _onChange(dataElement, 'operand');
                },
                style: style
            });
        }
    }]);

    return DataElementOperandSelect;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dataElementOperands: state.dataElementOperands
    };
}, { loadDataElementOperands: _dataElements.loadDataElementOperands })(DataElementOperandSelect);

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _RadioButton = __webpack_require__(673);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    radioGroup: {
        display: 'inline-block',
        marginTop: 8
    },
    radioButton: {
        display: 'inline-block',
        paddingRight: 16,
        width: 'auto'
    }
};

var TotalsDetailsSelect = function TotalsDetailsSelect(_ref) {
    var operand = _ref.operand,
        _onChange = _ref.onChange,
        style = _ref.style;
    return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(
            _RadioButton.RadioButtonGroup,
            {
                name: 'operand',
                valueSelected: operand === true,
                onChange: function onChange(event, value) {
                    return _onChange(value);
                },
                style: styles.radioGroup
            },
            _react2.default.createElement(_RadioButton.RadioButton, {
                value: false,
                label: _i18next2.default.t('Totals'),
                style: styles.radioButton
            }),
            _react2.default.createElement(_RadioButton.RadioButton, {
                value: true,
                label: _i18next2.default.t('Details'),
                style: styles.radioButton
            })
        )
    );
};

exports.default = TotalsDetailsSelect;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
ToggleRadioButtonUnchecked.muiName = 'SvgIcon';

exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(13);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(12);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
ToggleRadioButtonChecked.muiName = 'SvgIcon';

exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioButton = __webpack_require__(674);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _warning = __webpack_require__(54);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButtonGroup = function (_Component) {
  (0, _inherits3.default)(RadioButtonGroup, _Component);

  function RadioButtonGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioButtonGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      numberCheckedRadioButtons: 0,
      selected: ''
    }, _this.handleChange = function (event, newSelection) {
      _this.updateRadioButtons(newSelection);

      // Successful update
      if (_this.state.numberCheckedRadioButtons === 0) {
        if (_this.props.onChange) _this.props.onChange(event, newSelection);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RadioButtonGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var cnt = 0;
      var selected = '';
      var _props = this.props,
          valueSelected = _props.valueSelected,
          defaultSelected = _props.defaultSelected;

      if (valueSelected !== undefined) {
        selected = valueSelected;
      } else if (defaultSelected !== undefined) {
        selected = defaultSelected;
      }

      _react2.default.Children.forEach(this.props.children, function (option) {
        if (_this2.hasCheckAttribute(option)) cnt++;
      }, this);

      this.setState({
        numberCheckedRadioButtons: cnt,
        selected: selected
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasOwnProperty('valueSelected')) {
        this.setState({
          selected: nextProps.valueSelected
        });
      }
    }
  }, {
    key: 'hasCheckAttribute',
    value: function hasCheckAttribute(radioButton) {
      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
    }
  }, {
    key: 'updateRadioButtons',
    value: function updateRadioButtons(newSelection) {
      if (this.state.numberCheckedRadioButtons === 0) {
        this.setState({ selected: newSelection });
      } else {
         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
      }
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      return this.state.selected;
    }
  }, {
    key: 'setSelectedValue',
    value: function setSelectedValue(newSelectionValue) {
      this.updateRadioButtons(newSelectionValue);
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
      this.setSelectedValue('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var options = _react2.default.Children.map(this.props.children, function (option) {
        var _option$props = option.props,
            name = _option$props.name,
            value = _option$props.value,
            label = _option$props.label,
            onCheck = _option$props.onCheck,
            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);


        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
          ref: option.props.value,
          name: _this3.props.name,
          key: option.props.value,
          value: option.props.value,
          label: option.props.label,
          labelPosition: _this3.props.labelPosition,
          onCheck: _this3.handleChange,
          checked: option.props.value === _this3.state.selected
        }));
      }, this);

      return _react2.default.createElement(
        'div',
        {
          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
          className: this.props.className
        },
        options
      );
    }
  }]);
  return RadioButtonGroup;
}(_react.Component);

RadioButtonGroup.defaultProps = {
  style: {}
};
RadioButtonGroup.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RadioButtonGroup.propTypes =  false ? {
  /**
   * Should be used to pass `RadioButton` components.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The `value` property of the radio button that will be
   * selected by default. This takes precedence over the `checked` property
   * of the `RadioButton` elements.
   */
  defaultSelected: _propTypes2.default.any,
  /**
   * Where the label will be placed for all child radio buttons.
   * This takes precedence over the `labelPosition` property of the
   * `RadioButton` elements.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * The name that will be applied to all child radio buttons.
   */
  name: _propTypes2.default.string.isRequired,
  /**
   * Callback function that is fired when a radio button has
   * been checked.
   *
   * @param {object} event `change` event targeting the selected
   * radio button.
   * @param {*} value The `value` of the selected radio button.
   */
  onChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The `value` of the currently selected radio button.
   */
  valueSelected: _propTypes2.default.any
} : {};
exports.default = RadioButtonGroup;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventDataItemSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _analytics = __webpack_require__(32);

var _programs = __webpack_require__(142);

var _aggregationTypes = __webpack_require__(672);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventDataItemSelect = exports.EventDataItemSelect = function (_Component) {
    _inherits(EventDataItemSelect, _Component);

    function EventDataItemSelect() {
        _classCallCheck(this, EventDataItemSelect);

        return _possibleConstructorReturn(this, (EventDataItemSelect.__proto__ || Object.getPrototypeOf(EventDataItemSelect)).apply(this, arguments));
    }

    _createClass(EventDataItemSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadDataItems();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadDataItems();
        }

        // TODO: Make sure data load is only triggered once

    }, {
        key: 'loadDataItems',
        value: function loadDataItems() {
            var _props = this.props,
                program = _props.program,
                programAttributes = _props.programAttributes,
                dataElements = _props.dataElements,
                loadProgramTrackedEntityAttributes = _props.loadProgramTrackedEntityAttributes,
                loadProgramDataElements = _props.loadProgramDataElements;


            if (program && !programAttributes[program.id]) {
                loadProgramTrackedEntityAttributes(program.id);
            }

            if (program && !dataElements[program.id]) {
                loadProgramDataElements(program.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dataItem = _props2.dataItem,
                program = _props2.program,
                programAttributes = _props2.programAttributes,
                dataElements = _props2.dataElements,
                _onChange = _props2.onChange,
                style = _props2.style;


            var dataItems = (0, _analytics.combineDataItems)(programAttributes[program.id], dataElements[program.id], ['FILE_RESOURCE', 'ORGANISATION_UNIT', 'COORDINATE', 'DATE', 'TEXT', 'BOOLEAN'] // Exclude some value types
            );

            // console.log('dataItem', dataItem);

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Event data item'),
                items: dataItems,
                value: dataItem ? dataItem.id : null,
                onChange: function onChange(dataItem) {
                    return _onChange(dataItem, 'eventDataItem');
                },
                style: style
            });
        }
    }]);

    return EventDataItemSelect;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programAttributes: state.programTrackedEntityAttributes,
        dataElements: state.programDataElements
    };
}, { loadProgramTrackedEntityAttributes: _programs.loadProgramTrackedEntityAttributes, loadProgramDataElements: _programs.loadProgramDataElements })(EventDataItemSelect);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementGroupSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _dataSets = __webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataElementGroupSelect = exports.DataElementGroupSelect = function (_Component) {
    _inherits(DataElementGroupSelect, _Component);

    function DataElementGroupSelect() {
        _classCallCheck(this, DataElementGroupSelect);

        return _possibleConstructorReturn(this, (DataElementGroupSelect.__proto__ || Object.getPrototypeOf(DataElementGroupSelect)).apply(this, arguments));
    }

    _createClass(DataElementGroupSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                dataSets = _props.dataSets,
                loadDataSets = _props.loadDataSets;


            if (!dataSets) {
                loadDataSets();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dataSet = _props2.dataSet,
                dataSets = _props2.dataSets,
                _onChange = _props2.onChange,
                style = _props2.style;

            var dataSetId = dataSet ? dataSet.id.split('.')[0] : null; // Remove ".REPORTING_RATE"

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Data set'),
                loading: dataSets ? false : true,
                items: dataSets,
                value: dataSetId,
                onChange: function onChange(dataSet) {
                    return _onChange(dataSet, 'reportingRate');
                } // Reporting rates
                , style: style
            });
        }
    }]);

    return DataElementGroupSelect;
}(_react.Component);

DataElementGroupSelect.propTypes = {
    dataSet: _propTypes2.default.object,
    dataSets: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        dataSets: state.dataSets
    };
}, { loadDataSets: _dataSets.loadDataSets })(DataElementGroupSelect);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndicatorGroupSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _indicators = __webpack_require__(469);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndicatorGroupSelect = exports.IndicatorGroupSelect = function (_Component) {
    _inherits(IndicatorGroupSelect, _Component);

    function IndicatorGroupSelect() {
        _classCallCheck(this, IndicatorGroupSelect);

        return _possibleConstructorReturn(this, (IndicatorGroupSelect.__proto__ || Object.getPrototypeOf(IndicatorGroupSelect)).apply(this, arguments));
    }

    _createClass(IndicatorGroupSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                indicatorGroups = _props.indicatorGroups,
                loadIndicatorGroups = _props.loadIndicatorGroups;


            if (!indicatorGroups) {
                loadIndicatorGroups();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                indicatorGroups = _props2.indicatorGroups,
                indicatorGroup = _props2.indicatorGroup,
                onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Indicator group'),
                loading: indicatorGroups ? false : true,
                items: indicatorGroups,
                value: indicatorGroup ? indicatorGroup.id : null,
                onChange: onChange,
                style: style,
                errorText: !indicatorGroup && errorText ? errorText : null
            });
        }
    }]);

    return IndicatorGroupSelect;
}(_react.Component);

IndicatorGroupSelect.propTypes = {
    indicatorGroups: _propTypes2.default.array,
    indicatorGroup: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
    }),
    loadIndicatorGroups: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        indicatorGroups: state.indicatorGroups
    };
}, { loadIndicatorGroups: _indicators.loadIndicatorGroups })(IndicatorGroupSelect);

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegendSetSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _legendSets = __webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LegendSetSelect = exports.LegendSetSelect = function (_Component) {
    _inherits(LegendSetSelect, _Component);

    function LegendSetSelect() {
        _classCallCheck(this, LegendSetSelect);

        return _possibleConstructorReturn(this, (LegendSetSelect.__proto__ || Object.getPrototypeOf(LegendSetSelect)).apply(this, arguments));
    }

    _createClass(LegendSetSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                legendSets = _props.legendSets,
                loadLegendSets = _props.loadLegendSets;


            if (!legendSets) {
                loadLegendSets();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                legendSet = _props2.legendSet,
                legendSets = _props2.legendSets,
                onChange = _props2.onChange,
                style = _props2.style;


            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Legend set'),
                loading: legendSets ? false : true,
                items: legendSets,
                value: legendSet ? legendSet.id : null,
                onChange: onChange,
                style: style
            });
        }
    }]);

    return LegendSetSelect;
}(_react.Component);

LegendSetSelect.propTypes = {
    legendSet: _propTypes2.default.object,
    legendSets: _propTypes2.default.array,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        legendSets: state.legendSets
    };
}, { loadLegendSets: _legendSets.loadLegendSets })(LegendSetSelect);

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegendTypeSelect = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _RadioButton = __webpack_require__(673);

var _layers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    radioGroup: {
        display: 'inline-block',
        marginTop: 8
    },
    radioButton: {
        display: 'inline-block',
        paddingRight: 16,
        width: 'auto'
    }
};

var LegendTypeSelect = exports.LegendTypeSelect = function LegendTypeSelect(_ref) {
    var method = _ref.method,
        _onChange = _ref.onChange,
        style = _ref.style;
    return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(
            _RadioButton.RadioButtonGroup,
            {
                name: 'method',
                valueSelected: method === _layers.CLASSIFICATION_PREDEFINED ? _layers.CLASSIFICATION_PREDEFINED : _layers.CLASSIFICATION_EQUAL_INTERVALS,
                onChange: function onChange(event, type) {
                    return _onChange(type);
                },
                style: styles.radioGroup
            },
            _react2.default.createElement(_RadioButton.RadioButton, {
                value: _layers.CLASSIFICATION_EQUAL_INTERVALS,
                label: _i18next2.default.t('Automatic'),
                style: styles.radioButton
            }),
            _react2.default.createElement(_RadioButton.RadioButton, {
                value: _layers.CLASSIFICATION_PREDEFINED,
                label: _i18next2.default.t('Predefined'),
                style: styles.radioButton
            })
        )
    );
};

exports.default = LegendTypeSelect;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndicatorSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRedux = __webpack_require__(14);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _indicators = __webpack_require__(469);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndicatorSelect = exports.IndicatorSelect = function (_Component) {
    _inherits(IndicatorSelect, _Component);

    function IndicatorSelect() {
        _classCallCheck(this, IndicatorSelect);

        return _possibleConstructorReturn(this, (IndicatorSelect.__proto__ || Object.getPrototypeOf(IndicatorSelect)).apply(this, arguments));
    }

    _createClass(IndicatorSelect, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                indicatorGroup = _props.indicatorGroup,
                indicators = _props.indicators,
                loadIndicators = _props.loadIndicators;


            if (indicatorGroup && !indicators) {
                loadIndicators(indicatorGroup.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                indicatorGroup = _props2.indicatorGroup,
                indicator = _props2.indicator,
                indicators = _props2.indicators,
                _onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;


            var items = indicators;

            if (!indicatorGroup && !indicator) {
                return null;
            } else if (indicator) {
                items = [indicator]; // If favorite is loaded, we only know the used indicator
            }

            return _react2.default.createElement(_SelectField2.default, {
                key: 'indicators',
                loading: items ? false : true,
                label: _i18next2.default.t('Indicator'),
                items: items,
                value: indicator ? indicator.id : null,
                onChange: function onChange(dataItem) {
                    return _onChange(dataItem, 'indicator');
                },
                style: style,
                errorText: !indicator && errorText ? errorText : null
            });
        }
    }]);

    return IndicatorSelect;
}(_react.Component);

IndicatorSelect.propTypes = {
    indicatorGroup: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
    }),
    indicator: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
    }),
    indicators: _propTypes2.default.array,
    loadIndicators: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};
exports.default = (0, _reactRedux.connect)(function (state, props) {
    return {
        indicators: props.indicatorGroup ? state.indicators[props.indicatorGroup.id] : null
    };
}, { loadIndicators: _indicators.loadIndicators })(IndicatorSelect);

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createPeriods = undefined;

var _generators = __webpack_require__(1203);

var createPeriods = exports.createPeriods = function createPeriods(locale, periodType, year) {
    var localePeriodGenerator = (0, _generators.createPeriodGeneratorsForLocale)(locale);

    var periodGenerator = localePeriodGenerator['generate' + periodType + 'PeriodsForYear'] || localePeriodGenerator['generate' + periodType + 'PeriodsUpToYear'];

    if (!periodGenerator) {
        return null;
    }

    return periodGenerator(year).reverse();
};

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createPeriodGeneratorsForLocale = createPeriodGeneratorsForLocale;

var _daily = __webpack_require__(1204);

var _weekly = __webpack_require__(1206);

var _monthly = __webpack_require__(1207);

var _biMonthly = __webpack_require__(1208);

var _quarterly = __webpack_require__(1209);

var _sixMonthly = __webpack_require__(1210);

var _sixMonthlyApril = __webpack_require__(1211);

var _yearly = __webpack_require__(1212);

var _financialOctober = __webpack_require__(1213);

var _financialJuly = __webpack_require__(1214);

var _financialApril = __webpack_require__(1215);

/**
 *
 * @param locale
 * @returns {{generateDailyPeriodsForYear: (function(*=): *), generateWeeklyPeriodsForYear: (function(*=): *), generateMonthlyPeriodsForYear: (function(*=): *), generateBiMonthlyPeriodsForYear: (function(*=): *), generateQuarterlyPeriodsForYear: (function(*=): *), generateSixMonthlyPeriodsForYear: (function(*=): *), generateSixMonthlyAprilPeriodsForYear: (function(*=): *), generateYearlyPeriodsUpToYear: (function(*=, *=): *), generateFinancialOctoberPeriodsUpToYear: (function(*=, *=): *), generateFinancialJulyPeriodsUpToYear: (function(*=, *=): *), generateFinancialAprilPeriodsUpToYear: (function(*=, *=): *)}}
 */
function createPeriodGeneratorsForLocale() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    // eslint-disable-line import/prefer-default-export
    return {
        generateDailyPeriodsForYear: function generateDailyPeriodsForYear(year) {
            return (0, _daily.generateDailyPeriodsForYear)(year, locale);
        },
        generateWeeklyPeriodsForYear: function generateWeeklyPeriodsForYear(year) {
            return (0, _weekly.generateWeeklyPeriodsForYear)(year, locale);
        },
        generateMonthlyPeriodsForYear: function generateMonthlyPeriodsForYear(year) {
            return (0, _monthly.generateMonthlyPeriodsForYear)(year, locale);
        },
        generateBiMonthlyPeriodsForYear: function generateBiMonthlyPeriodsForYear(year) {
            return (0, _biMonthly.generateBiMonthlyPeriodsForYear)(year, locale);
        },
        generateQuarterlyPeriodsForYear: function generateQuarterlyPeriodsForYear(year) {
            return (0, _quarterly.generateQuarterlyPeriodsForYear)(year, locale);
        },
        generateSixMonthlyPeriodsForYear: function generateSixMonthlyPeriodsForYear(year) {
            return (0, _sixMonthly.generateSixMonthlyPeriodsForYear)(year, locale);
        },
        generateSixMonthlyAprilPeriodsForYear: function generateSixMonthlyAprilPeriodsForYear(year) {
            return (0, _sixMonthlyApril.generateSixMonthlyAprilPeriodsForYear)(year, locale);
        },
        generateYearlyPeriodsUpToYear: function generateYearlyPeriodsUpToYear(year, numberOfYears) {
            return (0, _yearly.generateYearlyPeriodsUpToYear)(year, numberOfYears, locale);
        },
        generateFinancialOctoberPeriodsUpToYear: function generateFinancialOctoberPeriodsUpToYear(year, numberOfYears) {
            return (0, _financialOctober.generateFinancialOctoberPeriodsUpToYear)(year, numberOfYears, locale);
        },
        generateFinancialJulyPeriodsUpToYear: function generateFinancialJulyPeriodsUpToYear(year, numberOfYears) {
            return (0, _financialJuly.generateFinancialJulyPeriodsUpToYear)(year, numberOfYears, locale);
        },
        generateFinancialAprilPeriodsUpToYear: function generateFinancialAprilPeriodsUpToYear(year, numberOfYears) {
            return (0, _financialApril.generateFinancialAprilPeriodsUpToYear)(year, numberOfYears, locale);
        }
    };
} /**
   * @module period/generators
   */
//# sourceMappingURL=index.js.map

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateDailyPeriodsForYear = generateDailyPeriodsForYear;

var _helpers = __webpack_require__(61);

var _formatters = __webpack_require__(1205);

/**
 * Generate daily periods for the given year.
 *
 * @private
 * @param {Integer} [year=getCurrentYear()] The year to generate the daily periods for.
 */
function generateDailyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var periods = [];
    var date = new Date(year, 0, 1);

    // As long as we are within the current year create daily periods
    while (date.getFullYear() === year) {
        var formattedDate = (0, _helpers.formatAsISODate)(date);

        var period = {
            startDate: formattedDate,
            endDate: formattedDate,
            name: (0, _formatters.toLocaleDayFormat)(date, locale),
            id: formattedDate.replace(/-/g, '')
        };

        periods.push(period);

        // Advance to the next day
        // date.setDate(date.getDate() + 1);
        date = (0, _helpers.addDays)(1, date);
    }

    return periods;
}
//# sourceMappingURL=daily.js.map

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toLocaleDayFormat = toLocaleDayFormat;
// For 'en': January 1, 2017
// For 'nl': 1 januari 2017
// For 'zh': 2017年1月1日
var localeDayFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};

var getFormatterMemoized = function () {
    var formatters = new Map();

    return function (locale, options) {
        if (formatters.has(locale) && formatters.get(locale).has(options)) {
            return formatters.get(locale).get(options);
        }
        var formatter = new Intl.DateTimeFormat(locale, options);

        formatters.set(locale, new Map([[options, formatter]]));

        return formatter;
    };
}();

function toLocaleDayFormat(date) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    return getFormatterMemoized(locale, localeDayFormatOptions).format(date);
}
//# sourceMappingURL=formatters.js.map

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateWeeklyPeriodsForYear = generateWeeklyPeriodsForYear;

var _helpers = __webpack_require__(61);

/**
 * Generate weekly periods types
 *
 * @private
 *
 * @param {Integer} [year] The year to generate the weeks for.
 */
function generateWeeklyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var periods = [];
    var weeksInYear = (0, _helpers.is53WeekISOYear)(year) ? 53 : 52;
    var startDate = (0, _helpers.getFirstDayInFirstISOWeekForYear)(year);

    for (var week = 1; week <= weeksInYear; week += 1) {
        var endDate = (0, _helpers.getLastDayOfTheWeekForFirstDayOfTheWeek)(startDate);

        var period = {
            startDate: (0, _helpers.formatAsISODate)(startDate),
            endDate: (0, _helpers.formatAsISODate)(endDate),
            name: 'W' + week + ' - ' + (0, _helpers.formatAsISODate)(startDate) + ' - ' + (0, _helpers.formatAsISODate)(endDate),
            id: year + 'W' + week
        };

        periods.push(period);

        // Go to the start of the next week +7 days
        startDate = (0, _helpers.addDays)(7, startDate);
    }

    return periods;
}
//# sourceMappingURL=weekly.js.map

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateMonthlyPeriodsForYear = generateMonthlyPeriodsForYear;

var _helpers = __webpack_require__(61);

function generateMonthlyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var periods = [];
    var date = new Date('31 Dec ' + year);

    while (date.getFullYear() === year) {
        var monthName = date.toLocaleDateString(locale, { month: 'long' });

        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setDate(1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = monthName + ' ' + date.getFullYear();
        period.id = (0, _helpers.getYYYYMM)(date);
        periods.push(period);
        date.setDate(0);
    }

    // Months are collected backwards. So we reverse to get the chronological order.
    return periods.reverse();
}
//# sourceMappingURL=monthly.js.map

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateBiMonthlyPeriodsForYear = generateBiMonthlyPeriodsForYear;

var _helpers = __webpack_require__(61);

function generateBiMonthlyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var periods = [];
    var date = new Date('31 Dec ' + year);

    while (date.getFullYear() === year) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setDate(0);
        date.setDate(1);

        var firstMonth = date.toLocaleDateString(locale, { month: 'long' });
        var lastMonth = (0, _helpers.addMonths)(1, date).toLocaleDateString(locale, { month: 'long' });

        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = firstMonth + ' - ' + lastMonth + ' ' + date.getFullYear();
        period.id = (0, _helpers.getBiMonthlyId)(date);
        periods.push(period);
        date.setDate(0);
    }

    // Bi-months are collected backwards. So we reverse to get the chronological order.
    return periods.reverse();
}
//# sourceMappingURL=bi-monthly.js.map

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateQuarterlyPeriodsForYear = generateQuarterlyPeriodsForYear;

var _helpers = __webpack_require__(61);

/**
 * Generate Quarterly periods for a year.
 *
 * This will generate four quarters for a given year. The generated quarterly periods looks as follows.
 *
 * {
 *   startDate: '2017-10-01',
 *   endDate: '2017-12-31',
 *   name: 'October - December 2017',
 *   id: '2017Q4',
 * }
 *
 * The id is an unofficial ISO 8601 style notation for quarters. The old period generator used to have
 * and `iso` field but as some of the notations are not official ISO 8601 notations this property has been removed.
 * In most cases the `id` property contained the same value so this can be used instead.
 *
 * @private
 *
 * @param {Integer} [year=new Date().getFullYear()] The year to generate the daily periods for.
 * @param {String} [locale='en-gb'] The locale to use when getting month names.
 */
function generateQuarterlyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-gb';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var periods = [];
    var date = new Date('31 Dec ' + year);
    var quarter = 4;
    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);

    while (date.getFullYear() === year) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setDate(0);
        date.setDate(0);
        date.setDate(1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = monthNames[date.getMonth()] + ' - ' + monthNames[date.getMonth() + 2] + ' ' + date.getFullYear();
        period.id = year + 'Q' + quarter;
        periods.push(period);
        date.setDate(0);
        quarter -= 1;
    }

    // Quarters are collected backwards. So we reverse to get the chronological order.
    return periods.reverse();
}
//# sourceMappingURL=quarterly.js.map

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSixMonthlyPeriodsForYear = generateSixMonthlyPeriodsForYear;

var _helpers = __webpack_require__(61);

function generateSixMonthlyPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);

    return [{
        startDate: year + '-01-01',
        endDate: year + '-06-30',
        name: monthNames[0] + ' - ' + monthNames[5] + ' ' + year,
        id: year + 'S1'
    }, {
        startDate: year + '-07-01',
        endDate: year + '-12-31',
        name: monthNames[6] + ' - ' + monthNames[11] + ' ' + year,
        id: year + 'S2'
    }];
}
//# sourceMappingURL=six-monthly.js.map

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSixMonthlyAprilPeriodsForYear = generateSixMonthlyAprilPeriodsForYear;

var _helpers = __webpack_require__(61);

function generateSixMonthlyAprilPeriodsForYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);

    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);
    var periods = [];

    var period = {};
    period.startDate = year + '-04-01';
    period.endDate = year + '-09-30';
    period.name = monthNames[3] + ' - ' + monthNames[8] + ' ' + year;
    period.iso = year + 'AprilS1';
    period.id = period.iso;
    periods.push(period);

    period = {};
    period.startDate = year + '-10-01';
    period.endDate = year + 1 + '-03-31';
    period.name = monthNames[9] + ' ' + year + ' - ' + monthNames[2] + ' ' + (year + 1);
    period.iso = year + 'AprilS2';
    period.id = period.iso;
    periods.push(period);

    return periods;
}
//# sourceMappingURL=six-monthly-april.js.map

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateYearlyPeriodsUpToYear = generateYearlyPeriodsUpToYear;

var _check = __webpack_require__(15);

var _helpers = __webpack_require__(61);

function generateYearlyPeriodsUpToYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var numberOfYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);
    if (!(0, _check.isInteger)(numberOfYears) || numberOfYears < 1) {
        throw new Error('Yearly generator parameter `numberOfYears` should be an integer larger than 0.');
    }

    var periods = [];
    var date = new Date('31 Dec ' + year);

    while (year - date.getFullYear() < numberOfYears) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setMonth(0, 1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = date.getFullYear().toString();
        period.id = date.getFullYear().toString();
        periods.push(period);
        date.setDate(0);
    }

    // Years are collected backwards. If isReverse is true, then do nothing. Else reverse to correct order and return.
    return periods.reverse();
}
//# sourceMappingURL=yearly.js.map

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateFinancialOctoberPeriodsUpToYear = generateFinancialOctoberPeriodsUpToYear;

var _check = __webpack_require__(15);

var _helpers = __webpack_require__(61);

function generateFinancialOctoberPeriodsUpToYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var numberOfYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);
    if (!(0, _check.isInteger)(numberOfYears) || numberOfYears < 1) {
        throw new Error('FinancialOctober generator parameter `numberOfYears` should be an integer larger than 0.');
    }

    var periods = [];
    var date = new Date('30 Sep ' + (year + 1));
    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);

    for (var i = 0; i < numberOfYears; i++) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setYear(date.getFullYear() - 1);
        date.setDate(date.getDate() + 1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = monthNames[9] + ' ' + date.getFullYear() + ' - ' + monthNames[8] + ' ' + (date.getFullYear() + 1);
        period.id = date.getFullYear() + 'Oct';
        periods.push(period);
        date.setDate(date.getDate() - 1);
    }

    // FinancialOctober periods are collected backwards. If isReverse is true, then do nothing. Else reverse to correct order and return.
    return periods.reverse();
}
//# sourceMappingURL=financial-october.js.map

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateFinancialJulyPeriodsUpToYear = generateFinancialJulyPeriodsUpToYear;

var _check = __webpack_require__(15);

var _helpers = __webpack_require__(61);

function generateFinancialJulyPeriodsUpToYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var numberOfYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);
    if (!(0, _check.isInteger)(numberOfYears) || numberOfYears < 1) {
        throw new Error('FinancialJuly generator parameter `numberOfYears` should be an integer larger than 0.');
    }

    var periods = [];
    var date = new Date('30 Jun ' + (year + 1));
    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);

    for (var i = 0; i < numberOfYears; i++) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setYear(date.getFullYear() - 1);
        date.setDate(date.getDate() + 1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = monthNames[6] + ' ' + date.getFullYear() + ' - ' + monthNames[5] + ' ' + (date.getFullYear() + 1);
        period.id = date.getFullYear() + 'July';
        periods.push(period);
        date.setDate(date.getDate() - 1);
    }

    // FinancialJuly periods are collected backwards.
    return periods.reverse();
}
//# sourceMappingURL=financial-july.js.map

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateFinancialAprilPeriodsUpToYear = generateFinancialAprilPeriodsUpToYear;

var _check = __webpack_require__(15);

var _helpers = __webpack_require__(61);

function generateFinancialAprilPeriodsUpToYear() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.getCurrentYear)();
    var numberOfYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
    // eslint-disable-line import/prefer-default-export
    (0, _helpers.validateIfValueIsInteger)(year);
    if (!(0, _check.isInteger)(numberOfYears) || numberOfYears < 1) {
        throw new Error('FinancialApril generator parameter `numberOfYears` should be an integer larger than 0.');
    }

    var periods = [];
    var date = new Date(year + 1, 2, 31);
    var monthNames = (0, _helpers.getMonthNamesForLocale)(locale);

    for (var i = 0; i < numberOfYears; i++) {
        var period = {};
        period.endDate = (0, _helpers.formatAsISODate)(date);
        date.setYear(date.getFullYear() - 1);
        date.setDate(date.getDate() + 1);
        period.startDate = (0, _helpers.formatAsISODate)(date);
        period.name = monthNames[3] + ' ' + date.getFullYear() + ' - ' + monthNames[2] + ' ' + (date.getFullYear() + 1);
        period.id = date.getFullYear() + 'April';
        periods.push(period);
        date.setDate(date.getDate() - 1);
    }

    // FinancialApril periods are collected backwards.
    return periods.reverse();
}
//# sourceMappingURL=financial-april.js.map

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _periods = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var periods = void 0;

var PeriodTypeSelect = function PeriodTypeSelect(_ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        style = _ref.style,
        errorText = _ref.errorText;

    if (!periods) {
        // Translate period names
        periods = _periods.periodTypes.map(function (_ref2) {
            var id = _ref2.id,
                name = _ref2.name;
            return {
                id: id,
                name: _i18next2.default.t(name)
            };
        });
    }

    return _react2.default.createElement(_SelectField2.default, {
        label: _i18next2.default.t('Period type'),
        items: periods,
        value: value,
        onChange: onChange,
        style: style,
        errorText: !value && errorText ? errorText : null
    });
};

PeriodTypeSelect.propTypes = {
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object,
    errorText: _propTypes2.default.string
};

exports.default = PeriodTypeSelect;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgramIndicatorSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _programs = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgramIndicatorSelect = exports.ProgramIndicatorSelect = function (_Component) {
    _inherits(ProgramIndicatorSelect, _Component);

    function ProgramIndicatorSelect() {
        _classCallCheck(this, ProgramIndicatorSelect);

        return _possibleConstructorReturn(this, (ProgramIndicatorSelect.__proto__ || Object.getPrototypeOf(ProgramIndicatorSelect)).apply(this, arguments));
    }

    _createClass(ProgramIndicatorSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadProgramIndicators();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadProgramIndicators();
        }
    }, {
        key: 'loadProgramIndicators',
        value: function loadProgramIndicators() {
            var _props = this.props,
                program = _props.program,
                programIndicator = _props.programIndicator,
                programIndicators = _props.programIndicators,
                onChange = _props.onChange,
                loadProgramIndicators = _props.loadProgramIndicators;


            if (program) {
                var indicators = programIndicators[program.id];

                // Load program stages when program is selected
                if (!indicators) {
                    loadProgramIndicators(program.id);
                }

                // Select first program indicator if only one
                if (program && !programIndicator && indicators && indicators.length === 1) {
                    onChange(indicators[0]);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                program = _props2.program,
                programIndicator = _props2.programIndicator,
                programIndicators = _props2.programIndicators,
                _onChange = _props2.onChange,
                style = _props2.style;


            if (!program) {
                return null;
            }

            var items = programIndicators[program.id];

            return _react2.default.createElement(_SelectField2.default, {
                label: _i18next2.default.t('Program indicator'),
                loading: items ? false : true,
                items: items,
                value: programIndicator ? programIndicator.id : null,
                onChange: function onChange(programIndicator) {
                    return _onChange(programIndicator, 'programIndicator');
                },
                style: style
            });
        }
    }]);

    return ProgramIndicatorSelect;
}(_react.Component);

ProgramIndicatorSelect.propTypes = {
    programIndicator: _propTypes2.default.object,
    programIndicators: _propTypes2.default.object,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        programIndicators: state.programIndicators
    };
}, { loadProgramIndicators: _programs.loadProgramIndicators })(ProgramIndicatorSelect);

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Tabs = __webpack_require__(240);

var _OrgUnitTree = __webpack_require__(276);

var _OrgUnitTree2 = _interopRequireDefault(_OrgUnitTree);

var _OrgUnitGroupSelect = __webpack_require__(551);

var _OrgUnitGroupSelect2 = _interopRequireDefault(_OrgUnitGroupSelect);

var _OrgUnitLevelSelect = __webpack_require__(552);

var _OrgUnitLevelSelect2 = _interopRequireDefault(_OrgUnitLevelSelect);

var _UserOrgUnitsSelect = __webpack_require__(277);

var _UserOrgUnitsSelect2 = _interopRequireDefault(_UserOrgUnitsSelect);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _Checkbox = __webpack_require__(549);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FontStyle = __webpack_require__(550);

var _FontStyle2 = _interopRequireDefault(_FontStyle);

var _LayerDialogStyles = __webpack_require__(242);

var _layerEdit = __webpack_require__(60);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _extends({}, _LayerDialogStyles.layerDialogStyles, {
    tabs: {
        height: 376
    },
    wrapper: {
        width: '100%',
        clear: 'both',
        height: 64
    },
    checkbox: {
        float: 'left',
        margin: '24px 0 0 12px',
        width: 180
    },
    font: {
        float: 'left',
        marginTop: -8
    },
    radius: {
        marginLeft: 12,
        width: 127
    },
    error: {
        marginTop: 10,
        color: 'red'
    }
});

var BoundaryDialog = function (_Component) {
    _inherits(BoundaryDialog, _Component);

    function BoundaryDialog(props, context) {
        _classCallCheck(this, BoundaryDialog);

        var _this = _possibleConstructorReturn(this, (BoundaryDialog.__proto__ || Object.getPrototypeOf(BoundaryDialog)).call(this, props, context));

        _this.state = {
            tab: 'orgunits'
        };
        return _this;
    }

    _createClass(BoundaryDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$rows = _props.rows,
                rows = _props$rows === undefined ? [] : _props$rows,
                labels = _props.labels,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                radiusLow = _props.radiusLow,
                setOrgUnitLevels = _props.setOrgUnitLevels,
                setOrgUnitGroups = _props.setOrgUnitGroups,
                setUserOrgUnits = _props.setUserOrgUnits,
                toggleOrganisationUnit = _props.toggleOrganisationUnit,
                setLabels = _props.setLabels,
                setLabelFontSize = _props.setLabelFontSize,
                setLabelFontStyle = _props.setLabelFontStyle,
                setRadiusLow = _props.setRadiusLow;
            var _state = this.state,
                tab = _state.tab,
                orgUnitsError = _state.orgUnitsError;


            var orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
            var selectedUserOrgUnits = (0, _analytics.getUserOrgUnitsFromRows)(rows);

            return _react2.default.createElement(
                _Tabs.Tabs,
                {
                    style: styles.tabs,
                    tabItemContainerStyle: styles.tabBar,
                    value: tab,
                    onChange: function onChange(tab) {
                        return _this2.setState({ tab: tab });
                    }
                },
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'orgunits', label: _i18next2.default.t('Organisation units') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitTree2.default, {
                                selected: (0, _analytics.getOrgUnitNodesFromRows)(rows),
                                onClick: toggleOrganisationUnit,
                                disabled: selectedUserOrgUnits.length ? true : false
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexHalf },
                            _react2.default.createElement(_OrgUnitLevelSelect2.default, {
                                orgUnitLevel: (0, _analytics.getOrgUnitLevelsFromRows)(rows),
                                onChange: setOrgUnitLevels
                            }),
                            _react2.default.createElement(_OrgUnitGroupSelect2.default, {
                                orgUnitGroup: (0, _analytics.getOrgUnitGroupsFromRows)(rows),
                                onChange: setOrgUnitGroups
                            }),
                            _react2.default.createElement(_UserOrgUnitsSelect2.default, {
                                selected: selectedUserOrgUnits,
                                onChange: setUserOrgUnits
                            }),
                            !orgUnits.length && orgUnitsError && _react2.default.createElement(
                                'div',
                                { style: styles.error },
                                orgUnitsError
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'style', label: _i18next2.default.t('Style') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.wrapper },
                            _react2.default.createElement(_Checkbox2.default, {
                                label: _i18next2.default.t('Show labels'),
                                checked: labels,
                                onCheck: setLabels,
                                style: styles.checkbox
                            }),
                            labels && _react2.default.createElement(_FontStyle2.default, {
                                size: labelFontSize,
                                fontStyle: labelFontStyle,
                                onSizeChange: setLabelFontSize,
                                onStyleChange: setLabelFontStyle,
                                style: styles.font
                            })
                        ),
                        _react2.default.createElement(_TextField2.default, {
                            type: 'number',
                            label: _i18next2.default.t('Point radius'),
                            value: radiusLow !== undefined ? radiusLow : 5,
                            onChange: setRadiusLow,
                            style: styles.radius
                        })
                    )
                )
            );
        }

        // TODO: Add to parent class?

    }, {
        key: 'setErrorState',
        value: function setErrorState(key, message, tab) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, key, message), _defineProperty(_setState, 'tab', tab), _setState));

            return false;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var rows = this.props.rows;


            if (!(0, _analytics.getOrgUnitsFromRows)(rows).length) {
                return this.setErrorState('orgUnitsError', _i18next2.default.t('No organisation units are selected'), 'orgunits');
            }

            return true;
        }
    }]);

    return BoundaryDialog;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, {
    setOrgUnitLevels: _layerEdit.setOrgUnitLevels,
    setOrgUnitGroups: _layerEdit.setOrgUnitGroups,
    setUserOrgUnits: _layerEdit.setUserOrgUnits,
    toggleOrganisationUnit: _layerEdit.toggleOrganisationUnit,
    setLabels: _layerEdit.setLabels,
    setLabelFontSize: _layerEdit.setLabelFontSize,
    setLabelFontStyle: _layerEdit.setLabelFontStyle,
    setRadiusLow: _layerEdit.setRadiusLow
}, null, {
    withRef: true
})(BoundaryDialog);

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import PropTypes from 'prop-types';


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _ColorScaleSelect = __webpack_require__(670);

var _ColorScaleSelect2 = _interopRequireDefault(_ColorScaleSelect);

var _Tabs = __webpack_require__(1220);

var _TextField = __webpack_require__(111);

var _TextField2 = _interopRequireDefault(_TextField);

var _Collection = __webpack_require__(1221);

var _Collection2 = _interopRequireDefault(_Collection);

var _LegendItem = __webpack_require__(633);

var _LegendItem2 = _interopRequireDefault(_LegendItem);

var _layerEdit = __webpack_require__(60);

var _colorscale = __webpack_require__(102);

var _earthEngineLoader = __webpack_require__(259);

var _LayerDialogStyles = __webpack_require__(242);

__webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var datasets = {
    'WorldPop/POP': {
        // Population density
        description: "Population density estimates with national totals adjusted to match UN population division estimates. Try a different year if you don't see data for your country.",
        collectionLabel: 'Select year',
        minValue: 0,
        maxValue: Number.MAX_VALUE,
        minLabel: 'Min people',
        maxLabel: 'Max people'
    },
    'USGS/SRTMGL1_003': {
        // Elevation
        description: 'Elevation above sea-level. You can adjust the min and max values so it better representes the terrain in your region.',
        minValue: 0,
        maxValue: 8848,
        minLabel: 'Min meters',
        maxLabel: 'Max meters'
    },
    'UCSB-CHG/CHIRPS/PENTAD': {
        // Precipitation
        description: 'Precipitation collected from satellite and weather stations on the ground. The values are in millimeters within 5 days periods. Updated monthly, during the 3rd week of the following month.',
        minValue: 0,
        maxValue: 100,
        minLabel: 'Min mm',
        maxLabel: 'Max mm'
    },
    'MODIS/MOD11A2': {
        // Temperature
        description: 'Land surface temperatures collected from satellite in 8 days periods. Blank spots will appear in areas with a persistent cloud cover.',
        minValue: -100,
        maxValue: 100,
        minLabel: 'Min °C',
        maxLabel: 'Max °C'
    },
    'MODIS/051/MCD12Q1': {
        // Landcover
        description: '17 distinct landcover types collected from satellites.',
        valueLabel: 'Select year'
    },
    'NOAA/DMSP-OLS/NIGHTTIME_LIGHTS': {
        // Nighttime lights
        description: 'Light intensity from cities, towns, and other sites with persistent lighting, including gas flares.',
        valueLabel: 'Select year',
        minValue: 0,
        maxValue: 63
    }
};

var styles = _extends({}, _LayerDialogStyles.layerDialogStyles, {
    legend: {
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff'
    },
    legendTitle: {
        padding: '16px 0 16px 32px',
        fontWeight: 'bold'
    },
    colorScale: {
        marginLeft: 12,
        maxWidth: 270,
        overflow: 'hidden'
    },
    error: {
        width: '100%',
        color: 'rgb(244, 67, 54)',
        fontSize: 12,
        lineHeight: '12px',
        marginLeft: 12
    }
});

var EarthEngineDialog = function (_Component) {
    _inherits(EarthEngineDialog, _Component);

    function EarthEngineDialog(props, context) {
        _classCallCheck(this, EarthEngineDialog);

        var _this = _possibleConstructorReturn(this, (EarthEngineDialog.__proto__ || Object.getPrototypeOf(EarthEngineDialog)).call(this, props, context));

        _this.state = {
            tab: 'data'
        };
        return _this;
    }

    // Steps are less as we also have colors for above and below (not below if min = 0)


    _createClass(EarthEngineDialog, [{
        key: 'getStepsFromParams',
        value: function getStepsFromParams() {
            var _props$params = this.props.params,
                palette = _props$params.palette,
                min = _props$params.min;

            return palette.split(',').length - (min === 0 ? 1 : 2);
        }

        // Always set state to update text field, but only store if valid

    }, {
        key: 'onStepsChange',
        value: function onStepsChange(newSteps) {
            var _props$params2 = this.props.params,
                min = _props$params2.min,
                max = _props$params2.max,
                palette = _props$params2.palette;

            var steps = newSteps === '' ? '' : parseInt(newSteps, 10);

            this.setState({ steps: steps });

            if (this.isValidSteps(steps)) {
                var scale = (0, _colorscale.getColorScale)(palette);
                var classes = (steps == 1 && min == 0 ? 2 : steps) + (min == 0 ? 1 : 2);
                var newPalette = (0, _colorscale.getColorPalette)(scale, classes);

                if (newPalette) {
                    this.props.setParams(min, max, newPalette);
                }
            }
        }

        // TODO: Create a d2-ui number field that returns numbers (not text) and controls min and max

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                datasetId = _props.datasetId,
                params = _props.params,
                filter = _props.filter,
                setParams = _props.setParams,
                setFilter = _props.setFilter;

            var dataset = datasets[datasetId];
            var _state = this.state,
                tab = _state.tab,
                steps = _state.steps,
                filterError = _state.filterError,
                rangeError = _state.rangeError,
                stepsError = _state.stepsError;


            return _react2.default.createElement(
                _Tabs.Tabs,
                {
                    style: styles.tabs,
                    value: tab,
                    onChange: function onChange(tab) {
                        return _this2.setState({ tab: tab });
                    }
                },
                _react2.default.createElement(
                    _Tabs.Tab,
                    { value: 'style', label: _i18next2.default.t('Style') },
                    _react2.default.createElement(
                        'div',
                        { style: styles.flex },
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexColumn },
                            _react2.default.createElement(
                                'div',
                                { style: _extends({}, styles.flexFull, { marginTop: 16 }) },
                                dataset.description
                            ),
                            datasetId !== 'USGS/SRTMGL1_003' && // If not elevation
                            _react2.default.createElement(_Collection2.default, {
                                label: _i18next2.default.t(dataset.collectionLabel),
                                id: datasetId,
                                filter: filter,
                                onChange: setFilter,
                                style: _extends({}, styles.flexFull, {
                                    marginBottom: 12
                                }),
                                errorText: filterError
                            }),
                            params && [_react2.default.createElement(_TextField2.default, {
                                key: 'min',
                                type: 'number',
                                label: _i18next2.default.t(dataset.minLabel || 'Min'),
                                value: params.min,
                                onChange: function onChange(min) {
                                    return setParams(parseInt(min), parseInt(params.max), params.palette);
                                },
                                style: styles.flexThird
                            }), _react2.default.createElement(_TextField2.default, {
                                key: 'max',
                                type: 'number',
                                label: _i18next2.default.t(dataset.maxLabel || 'Max'),
                                value: params.max,
                                onChange: function onChange(max) {
                                    return setParams(parseInt(params.min), parseInt(max), params.palette);
                                },
                                style: styles.flexThird
                            }), _react2.default.createElement(_TextField2.default, {
                                key: 'steps',
                                type: 'number',
                                label: _i18next2.default.t('Steps'),
                                value: steps !== undefined ? steps : this.getStepsFromParams(),
                                onChange: function onChange(steps) {
                                    return _this2.onStepsChange(steps);
                                },
                                style: styles.flexThird
                            }), _react2.default.createElement(
                                'div',
                                { key: 'range_error', style: styles.error },
                                !this.isValidRange() && rangeError
                            ), _react2.default.createElement(
                                'div',
                                { key: 'steps_error', style: styles.error },
                                !this.isValidSteps() && stepsError
                            ), _react2.default.createElement(_ColorScaleSelect2.default, {
                                key: 'scale',
                                palette: params.palette,
                                onChange: function onChange(palette) {
                                    return setParams(params.min, params.max, palette);
                                },
                                style: styles.colorScale
                            })]
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: styles.flexColumn },
                            params && _react2.default.createElement(
                                'div',
                                { style: styles.legend },
                                _react2.default.createElement(
                                    'div',
                                    { style: styles.legendTitle },
                                    _i18next2.default.t('Legend preview')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'Legend' },
                                    _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            (0, _earthEngineLoader.createLegend)(params).map(function (item, index) {
                                                return _react2.default.createElement(_LegendItem2.default, _extends({}, item, {
                                                    key: 'item-' + index
                                                }));
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }

        // TODO: Add to parent class?

    }, {
        key: 'setErrorState',
        value: function setErrorState(key, message, tab) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, key, message), _defineProperty(_setState, 'tab', tab), _setState));

            return false;
        }
    }, {
        key: 'isValidRange',
        value: function isValidRange() {
            var _props2 = this.props,
                datasetId = _props2.datasetId,
                params = _props2.params;

            var dataset = datasets[datasetId];
            var min = params.min,
                max = params.max;
            var minValue = dataset.minValue,
                maxValue = dataset.maxValue;


            return min < max && min >= minValue && min <= maxValue && max >= minValue && max <= maxValue;
        }
    }, {
        key: 'isValidSteps',
        value: function isValidSteps(newSteps) {
            var steps = newSteps !== undefined ? newSteps : this.getStepsFromParams();
            return steps > 0 && steps < 8; // Valid steps: 1-7
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _props3 = this.props,
                datasetId = _props3.datasetId,
                filter = _props3.filter,
                params = _props3.params;

            var dataset = datasets[datasetId];

            if (datasetId !== 'USGS/SRTMGL1_003' && !filter) {
                return this.setErrorState('filterError', _i18next2.default.t('This field is required'), 'style');
            }

            if (params) {
                var min = params.min,
                    max = params.max;
                var minValue = dataset.minValue,
                    maxValue = dataset.maxValue;

                // TODO: This should be implemented in the number fields directly

                if (!this.isValidRange()) {
                    return this.setErrorState('rangeError', _i18next2.default.t('Valid range is') + ' ' + minValue + ' - ' + maxValue, 'style');
                }
            }

            return true;
        }
    }]);

    return EarthEngineDialog;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, { setParams: _layerEdit.setParams, setFilter: _layerEdit.setFilter }, null, { withRef: true })(EarthEngineDialog);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return Tabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_helpers_utils__ = __webpack_require__(272);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tabs = function Tabs(_ref) {
    var style = _ref.style,
        selector = _ref.selector,
        children = _ref.children;

    var className = Object(__WEBPACK_IMPORTED_MODULE_3__component_helpers_utils__["a" /* createClassName */])('d2-ui-tabs', selector);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tabs"],
        {
            className: className,
            style: style
        },
        children
    );
};

Tabs.propTypes = {
    /**
     * Override the inline-styles of the root element
     */
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /**
     * If set, adds a class to the element in the format d2-ui-tabs-selector
     */
    selector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Tab = function (_Component) {
    _inherits(Tab, _Component);

    function Tab() {
        _classCallCheck(this, Tab);

        return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
    }

    _createClass(Tab, [{
        key: 'render',
        value: function render() {
            var className = Object(__WEBPACK_IMPORTED_MODULE_3__component_helpers_utils__["a" /* createClassName */])('d2-ui-tab', this.props.selector);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tab"], _extends({
                className: className
            }, this.props));
        }
    }]);

    return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tab.propTypes = {
    /**
     * If set, adds a class to the element in the format d2-ui-tab-selector
     */
    selector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Tab.muiName = 'Tab';
;

/* harmony default export */ __webpack_exports__["default"] = (Tabs);


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CollectionSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _SelectField = __webpack_require__(27);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _earthEngine = __webpack_require__(583);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var collectionFilters = {
    'WorldPop/POP': function WorldPopPOP(year) {
        return [{
            type: 'eq',
            arguments: ['year', year]
        }, {
            type: 'eq',
            arguments: ['UNadj', 'yes']
        }];
    }
};

var CollectionSelect = exports.CollectionSelect = function (_Component) {
    _inherits(CollectionSelect, _Component);

    function CollectionSelect() {
        _classCallCheck(this, CollectionSelect);

        return _possibleConstructorReturn(this, (CollectionSelect.__proto__ || Object.getPrototypeOf(CollectionSelect)).apply(this, arguments));
    }

    _createClass(CollectionSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                id = _props.id,
                collections = _props.collections,
                loadEarthEngineCollection = _props.loadEarthEngineCollection;


            if (id && !collections[id]) {
                loadEarthEngineCollection(id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                id = _props2.id,
                filter = _props2.filter,
                label = _props2.label,
                collections = _props2.collections,
                _onChange = _props2.onChange,
                style = _props2.style,
                errorText = _props2.errorText;

            var items = collections[id];
            var value = filter && filter[0].arguments[1];

            var collectionFilter = collectionFilters[id] || function (index) {
                return [{
                    type: 'eq',
                    arguments: ['system:index', index]
                }];
            };

            return _react2.default.createElement(_SelectField2.default, {
                label: label || _i18next2.default.t('Period'),
                loading: items ? false : true,
                items: items,
                value: value,
                onChange: function onChange(period) {
                    return _onChange(collectionFilter(period.id));
                },
                style: style,
                errorText: !value && errorText ? errorText : null
            });
        }
    }]);

    return CollectionSelect;
}(_react.Component);

CollectionSelect.propTypes = {
    collections: _propTypes2.default.object,
    onChange: _propTypes2.default.func.isRequired,
    style: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        collections: state.earthEngine
    };
}, { loadEarthEngineCollection: _earthEngine.loadEarthEngineCollection })(CollectionSelect);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Popover = __webpack_require__(268);

var _Popover2 = _interopRequireDefault(_Popover);

var _Menu = __webpack_require__(625);

var _Menu2 = _interopRequireDefault(_Menu);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _OrgUnitDialog = __webpack_require__(1223);

var _OrgUnitDialog2 = _interopRequireDefault(_OrgUnitDialog);

var _RelocateDialog = __webpack_require__(1227);

var _RelocateDialog2 = _interopRequireDefault(_RelocateDialog);

var _map = __webpack_require__(154);

var _layers = __webpack_require__(101);

var _orgUnits = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/callemall/material-ui/issues/2866
var anchorEl = document.getElementById('context-menu');

var styles = {
    list: {
        paddingTop: 4,
        paddingBottom: 4
    },
    menuItem: {
        fontSize: 12,
        lineHeight: '24px',
        minHeight: '24px'
    },

    menuItemInner: {
        padding: '0 8px 0 34px'
    },
    icon: {
        margin: 3,
        left: 6,
        width: 18,
        height: 18
    }
};

var ContextMenu = function ContextMenu(props, context) {
    var feature = props.feature,
        layerType = props.layerType,
        earthEngineLayers = props.earthEngineLayers,
        position = props.position;

    var isAdmin = context.d2.currentUser.authorities.has('F_GIS_ADMIN');
    var iconColor = '#777';
    var iconDisabledColor = '#eee';
    var coordinate = props.coordinate;
    var isPoint = void 0;
    var attr = {};

    if (position) {
        anchorEl.style.left = position[0] + 'px';
        anchorEl.style.top = position[1] + 'px';
    }

    if (feature) {
        isPoint = feature.geometry.type === 'Point';
        attr = feature.properties;
        coordinate = feature.geometry.coordinates;
    }

    return [_react2.default.createElement(
        _Popover2.default,
        {
            key: 'popover',
            open: props.position ? true : false,
            anchorEl: anchorEl,
            onRequestClose: props.onClose
        },
        _react2.default.createElement(
            _Menu2.default,
            {
                autoWidth: true,
                style: styles.menu,
                listStyle: styles.list,
                menuItemStyle: styles.menuItem
            },
            layerType !== 'facility' && feature && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    disabled: !attr.hasCoordinatesUp,
                    onClick: function onClick() {
                        return props.onDrill(props.layerId, attr.grandParentId, attr.grandParentParentGraph, parseInt(attr.level) - 1);
                    },
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, {
                        icon: 'ArrowUpward',
                        color: attr.hasCoordinatesUp ? iconColor : iconDisabledColor,
                        style: styles.icon
                    }),
                    innerDivStyle: styles.menuItemInner
                },
                _i18next2.default.t('Drill up one level')
            ),
            layerType !== 'facility' && feature && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    disabled: !attr.hasCoordinatesDown,
                    onClick: function onClick() {
                        return props.onDrill(props.layerId, attr.id, attr.parentGraph, parseInt(attr.level) + 1);
                    },
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, {
                        icon: 'ArrowDownward',
                        color: attr.hasCoordinatesDown ? iconColor : iconDisabledColor,
                        style: styles.icon
                    }),
                    innerDivStyle: styles.menuItemInner
                },
                _i18next2.default.t('Drill down one level')
            ),
            feature && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    onClick: function onClick() {
                        return props.onShowInformation(attr);
                    },
                    innerDivStyle: styles.menuItemInner,
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'InfoOutline', style: styles.icon })
                },
                _i18next2.default.t('Show information')
            ),
            coordinate && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    onClick: function onClick() {
                        return props.showCoordinate(coordinate);
                    },
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'Room', style: styles.icon }),
                    innerDivStyle: styles.menuItemInner
                },
                _i18next2.default.t('Show longitude/latitude')
            ),
            isAdmin && isPoint && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    onClick: function onClick() {
                        return props.onSwapCoordinate(props.layerId, feature.id, feature.geometry.coordinates.slice(0).reverse());
                    },
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'Room', style: styles.icon }),
                    innerDivStyle: styles.menuItemInner
                },
                _i18next2.default.t('Swap longitude/latitude')
            ),
            isAdmin && isPoint && _react2.default.createElement(
                _Menu.MenuItem,
                {
                    onClick: function onClick() {
                        return props.onRelocateStart(props.layerId, feature);
                    },
                    leftIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'Room', style: styles.icon }),
                    innerDivStyle: styles.menuItemInner
                },
                _i18next2.default.t('Relocate')
            ),
            earthEngineLayers.map(function (layer) {
                return _react2.default.createElement(
                    _Menu.MenuItem,
                    {
                        key: layer.id,
                        onClick: function onClick() {
                            return props.showEarthEngineValue(layer.id, coordinate);
                        },
                        innerDivStyle: styles.menuItemInner,
                        leftIcon: _react2.default.createElement(_SvgIcon2.default, { icon: 'Room', style: styles.icon })
                    },
                    _i18next2.default.t(layer.name)
                );
            })
        )
    ), _react2.default.createElement(_OrgUnitDialog2.default, { key: 'orgunit' }), _react2.default.createElement(_RelocateDialog2.default, { key: 'relocate' })];
};

ContextMenu.contextTypes = {
    d2: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state.contextMenu, {
        earthEngineLayers: state.map.mapViews.filter(function (view) {
            return view.layer === 'earthEngine';
        })
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClose: function onClose() {
            return dispatch((0, _map.closeContextMenu)());
        },
        onDrill: function onDrill(layerId, parentId, parentGraph, level) {
            return dispatch((0, _layers.drillLayer)(layerId, parentId, parentGraph, level));
        },
        onShowInformation: function onShowInformation(attr) {
            dispatch((0, _map.closeContextMenu)());
            dispatch((0, _orgUnits.loadOrgUnit)(attr));
        },
        showCoordinate: function showCoordinate(coord) {
            dispatch((0, _map.closeContextMenu)());
            dispatch((0, _map.openCoordinatePopup)(coord));
        },
        onRelocateStart: function onRelocateStart(layerId, feature) {
            dispatch((0, _map.closeContextMenu)());
            dispatch((0, _orgUnits.startRelocateOrgUnit)(layerId, feature));
        },
        onSwapCoordinate: function onSwapCoordinate(layerId, featureId, coordinate) {
            dispatch((0, _map.closeContextMenu)());
            dispatch((0, _orgUnits.changeOrgUnitCoordinate)(layerId, featureId, coordinate));
        },
        showEarthEngineValue: function showEarthEngineValue(layerId, coordinate) {
            dispatch((0, _map.closeContextMenu)());
            dispatch((0, _map.showEarthEngineValue)(layerId, coordinate));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContextMenu);

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrgUnitDialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _PeriodSelect = __webpack_require__(675);

var _PeriodSelect2 = _interopRequireDefault(_PeriodSelect);

var _orgUnits = __webpack_require__(93);

var _infrastructural = __webpack_require__(1224);

__webpack_require__(1225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrgUnitDialog = exports.OrgUnitDialog = function (_Component) {
    _inherits(OrgUnitDialog, _Component);

    function OrgUnitDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, OrgUnitDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrgUnitDialog.__proto__ || Object.getPrototypeOf(OrgUnitDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            peridType: null,
            period: null,
            periods: null
        }, _this.onPeriodChange = function (period) {
            _this.setState({
                period: period
            });
        }, _this.onClose = function () {
            _this.setState({
                period: null,
                data: null
            });
            _this.props.closeOrgUnit();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(OrgUnitDialog, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            var id = this.props.id;
            var _state = this.state,
                period = _state.period,
                periodType = _state.periodType,
                dataItems = _state.dataItems;


            if (!periodType || !dataItems) {
                (0, _infrastructural.loadConfigurations)().then(function (config) {
                    return _this2.setState(config);
                });
            } else if (id && dataItems && period && (id !== prevProps.id || period !== prevState.period)) {
                (0, _infrastructural.loadData)(id, period.id, dataItems).then(function (data) {
                    return _this2.setState({ data: data });
                });
            }
        }

        // Change of period state will trigger data load above


        // Clear data and period before closing dialog

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                name = _props.name,
                code = _props.code,
                parent = _props.parent,
                organisationUnitGroups = _props.organisationUnitGroups;
            var _state2 = this.state,
                periodType = _state2.periodType,
                period = _state2.period,
                data = _state2.data;


            if (!id) {
                return null;
            }

            var groups = organisationUnitGroups.toArray();

            var closeBtn = _react2.default.createElement(
                _Button2.default,
                { color: 'primary', onClick: this.onClose },
                _i18next2.default.t('Close')
            );

            return _react2.default.createElement(
                _Dialog2.default,
                {
                    title: name,
                    open: true,
                    contentStyle: { maxWidth: 600 },
                    onRequestClose: this.onClose,
                    actions: closeBtn,
                    className: 'OrgUnitDialog'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'OrgUnitDialog-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'OrgUnitDialog-metadata' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            _i18next2.default.t('Parent unit')
                        ),
                        parent.name,
                        _react2.default.createElement(
                            'h3',
                            null,
                            _i18next2.default.t('Code')
                        ),
                        code,
                        _react2.default.createElement(
                            'h3',
                            null,
                            _i18next2.default.t('Groups')
                        ),
                        groups.map(function (group) {
                            return _react2.default.createElement(
                                'div',
                                { key: group.id },
                                group.name
                            );
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'OrgUnitDialog-data' },
                        _react2.default.createElement(_PeriodSelect2.default, {
                            periodType: periodType,
                            period: period,
                            onChange: this.onPeriodChange,
                            style: { height: 70, margin: '-17px 0 0 3px' }
                        }),
                        data && data.length ? _react2.default.createElement(
                            'table',
                            { className: 'OrgUnitDialog-table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'left' },
                                        _i18next2.default.t('Data element')
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'right' },
                                        _i18next2.default.t('Value')
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                data.map(function (_ref2) {
                                    var id = _ref2.id,
                                        name = _ref2.name,
                                        value = _ref2.value;
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: id },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            name
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'right' },
                                            value
                                        )
                                    );
                                })
                            )
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'OrgUnitDialog-nodata' },
                            _i18next2.default.t('No data found for this period.')
                        )
                    )
                )
            );
        }
    }]);

    return OrgUnitDialog;
}(_react.Component);

OrgUnitDialog.propTypes = {
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    code: _propTypes2.default.string,
    parent: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    organisationUnitGroups: _propTypes2.default.object,
    closeOrgUnit: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return _extends({}, state.orgUnit);
}, { closeOrgUnit: _orgUnits.closeOrgUnit })(OrgUnitDialog);

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadData = exports.loadConfigurations = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _d2 = __webpack_require__(19);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Loads settings and data for the infrastuctural dialog for org units

var loadConfigurations = exports.loadConfigurations = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var d2, api, _ref2, _ref3, _ref3$, infrastructuralPeriodType, _ref3$2, infrastructuralIndicators, _ref3$3, infrastructuralDataElements, periodType, indicators, dataElements;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _d2.getInstance)();

                    case 2:
                        d2 = _context.sent;
                        api = d2.Api.getApi();
                        _context.next = 6;
                        return Promise.all([api.get('configuration/infrastructuralPeriodType'), api.get('configuration/infrastructuralIndicators'), api.get('configuration/infrastructuralDataElements')]);

                    case 6:
                        _ref2 = _context.sent;
                        _ref3 = _slicedToArray(_ref2, 3);
                        _ref3$ = _ref3[0];
                        infrastructuralPeriodType = _ref3$ === undefined ? {} : _ref3$;
                        _ref3$2 = _ref3[1];
                        infrastructuralIndicators = _ref3$2 === undefined ? {} : _ref3$2;
                        _ref3$3 = _ref3[2];
                        infrastructuralDataElements = _ref3$3 === undefined ? {} : _ref3$3;
                        periodType = infrastructuralPeriodType.id || 'Yearly';
                        indicators = infrastructuralIndicators.indicators || [];
                        dataElements = infrastructuralDataElements.dataElements || [];
                        return _context.abrupt('return', {
                            periodType: periodType,
                            dataItems: [].concat(indicators, dataElements)
                        });

                    case 18:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function loadConfigurations() {
        return _ref.apply(this, arguments);
    };
}();

var loadData = exports.loadData = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, period, dataItems) {
        var d2, analyticsRequest, data, dxIndex, valueIndex;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d2.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        analyticsRequest = new d2.analytics.request().addDataDimension(dataItems.map(function (item) {
                            return item.id;
                        })).addOrgUnitDimension(id).addPeriodFilter(period);
                        _context2.next = 6;
                        return d2.analytics.aggregate.get(analyticsRequest);

                    case 6:
                        data = _context2.sent;

                        if (!data.rows) {
                            _context2.next = 11;
                            break;
                        }

                        dxIndex = data.headers.findIndex(function (header) {
                            return header.name === 'dx';
                        });
                        valueIndex = data.headers.findIndex(function (header) {
                            return header.name === 'value';
                        });
                        return _context2.abrupt('return', data.rows.map(function (row) {
                            return {
                                id: row[dxIndex],
                                name: data.metaData.items[row[dxIndex]].name,
                                value: row[valueIndex]
                            };
                        }).sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        }));

                    case 11:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function loadData(_x, _x2, _x3) {
        return _ref4.apply(this, arguments);
    };
}();

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1226);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./OrgUnitDialog.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./OrgUnitDialog.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".OrgUnitDialog-content {\n    height: 300px;\n    max-height: 300px;\n}\n\n.OrgUnitDialog-metadata {\n    font-size: 14px;\n    margin-top: -10px;\n    width: 200px;\n    float: left;\n}\n\n.OrgUnitDialog-metadata h3 {\n    margin: 10px 0 2px 0;\n    font-size: 14px;\n}\n\n.OrgUnitDialog-data {\n    float: left;\n    width: 345px;\n}\n\n.OrgUnitDialog-nodata {\n    font-style: italic;\n    padding: 5px;\n    font-size: 14px;\n}\n\n.OrgUnitDialog-table {\n    display: block;\n    font-size: 14px;\n    width: 345px;\n    max-height: 240px;\n    overflow-y: auto;\n}\n\n.OrgUnitDialog-table .left {\n    text-align: left;\n    width: 280px;\n}\n\n.OrgUnitDialog-table .right {\n    text-align: right;\n    vertical-align: top;\n    width: 65px;\n}\n", ""]);

// exports


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Paper = __webpack_require__(73);

var _Paper2 = _interopRequireDefault(_Paper);

var _SvgIcon = __webpack_require__(56);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _orgUnits = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    paper: {
        position: 'absolute',
        top: 96,
        right: 48,
        width: 150,
        padding: 8,
        zIndex: 1100
    },
    close: {
        width: 16,
        height: 16,
        float: 'right',
        cursor: 'pointer'
    }
};

var RelocateDialog = function (_Component) {
    _inherits(RelocateDialog, _Component);

    function RelocateDialog() {
        _classCallCheck(this, RelocateDialog);

        return _possibleConstructorReturn(this, (RelocateDialog.__proto__ || Object.getPrototypeOf(RelocateDialog)).apply(this, arguments));
    }

    _createClass(RelocateDialog, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var feature = this.props.feature;
            var map = this.context.map;
            var mapContainer = map.getContainer();

            if (feature) {
                map.on('click', this.onMapClick, this);
                mapContainer.style.cursor = 'crosshair';
            } else {
                map.off('click', this.onMapClick, this);
                mapContainer.style.cursor = 'auto';
                mapContainer.style.cursor = '-webkit-grab';
                mapContainer.style.cursor = '-moz-grab';
            }
        }
    }, {
        key: 'onMapClick',
        value: function onMapClick(evt) {
            var _props = this.props,
                layerId = _props.layerId,
                feature = _props.feature,
                changeOrgUnitCoordinate = _props.changeOrgUnitCoordinate,
                stopRelocateOrgUnit = _props.stopRelocateOrgUnit;

            var latlng = evt.latlng;
            var coordinate = [parseFloat(latlng.lng.toFixed(6)), parseFloat(latlng.lat.toFixed(6))];

            changeOrgUnitCoordinate(layerId, feature.id, coordinate);
            stopRelocateOrgUnit();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                feature = _props2.feature,
                stopRelocateOrgUnit = _props2.stopRelocateOrgUnit;


            if (!feature) {
                return null;
            }

            return _react2.default.createElement(
                _Paper2.default,
                { style: styles.paper },
                _react2.default.createElement(
                    'span',
                    { onClick: stopRelocateOrgUnit },
                    _react2.default.createElement(_SvgIcon2.default, { icon: 'Cancel', style: styles.close })
                ),
                _i18next2.default.t('Click the map where you want to relocate facility'),
                ' ',
                _react2.default.createElement(
                    'strong',
                    null,
                    feature.properties.name
                )
            );
        }
    }]);

    return RelocateDialog;
}(_react.Component);

RelocateDialog.contextTypes = {
    map: _propTypes2.default.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
    return _extends({}, state.relocate);
}, { changeOrgUnitCoordinate: _orgUnits.changeOrgUnitCoordinate, stopRelocateOrgUnit: _orgUnits.stopRelocateOrgUnit })(RelocateDialog);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AboutDialog = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _about = __webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
    padding: 5
};

var AboutDialog = exports.AboutDialog = function AboutDialog(_ref, _ref2) {
    var aboutDialogOpen = _ref.aboutDialogOpen,
        closeAboutDialog = _ref.closeAboutDialog;
    var d2 = _ref2.d2;

    var system = d2.system.systemInfo;
    var user = d2.currentUser;

    var data = [{
        name: _i18next2.default.t('Time since last data update'),
        value: system.intervalSinceLastAnalyticsTableSuccess
    }, {
        name: _i18next2.default.t('Version'),
        value: system.version
    }, {
        name: _i18next2.default.t('Revision'),
        value: system.revision
    }, {
        name: _i18next2.default.t('Username'),
        value: user.username
    }];

    return _react2.default.createElement(
        _Dialog2.default,
        {
            title: _i18next2.default.t('About DHIS2 Maps'),
            actions: [_react2.default.createElement(
                _Button2.default,
                { color: 'primary', onClick: closeAboutDialog },
                _i18next2.default.t('Close')
            )],
            open: aboutDialogOpen,
            onRequestClose: closeAboutDialog
        },
        data.map(function (_ref3) {
            var name = _ref3.name,
                value = _ref3.value;
            return _react2.default.createElement(
                'div',
                { key: name, style: style },
                _react2.default.createElement(
                    'b',
                    null,
                    name
                ),
                ': ',
                value
            );
        })
    );
};

AboutDialog.propTypes = {
    aboutDialogOpen: _propTypes2.default.bool.isRequired,
    closeAboutDialog: _propTypes2.default.func.isRequired
};

AboutDialog.contextTypes = {
    d2: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        aboutDialogOpen: state.ui.aboutDialogOpen
    };
}, { closeAboutDialog: _about.closeAboutDialog })(AboutDialog);

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertsDialog = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Dialog = __webpack_require__(109);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(110);

var _Button2 = _interopRequireDefault(_Button);

var _alerts = __webpack_require__(584);

var _alerts2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var AlertsDialog = exports.AlertsDialog = function AlertsDialog(_ref) {
    var _ref$alerts = _ref.alerts,
        alerts = _ref$alerts === undefined ? [] : _ref$alerts,
        clearAlerts = _ref.clearAlerts;
    return alerts.length && _react2.default.createElement(
        _Dialog2.default,
        {
            title: _i18next2.default.t('Notifications'),
            open: true,
            onRequestClose: clearAlerts,
            actions: _react2.default.createElement(
                _Button2.default,
                { onClick: clearAlerts },
                _i18next2.default.t('Close')
            )
        },
        alerts.map(function (alert, index) {
            return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                    'strong',
                    null,
                    alert.title
                ),
                ': ',
                alert.description
            );
        })
    );
};

AlertsDialog.propTypes = {
    alerts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        title: _propTypes2.default.string.isRequired,
        description: _propTypes2.default.string.isRequired
    })),
    clearAlerts: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        alerts: [].concat(_toConsumableArray(state.alert ? [state.alert] : []), _toConsumableArray((0, _alerts2.getMapAlerts)(state.map)))
    };
}, { clearAlerts: _alerts.clearAlerts })(AlertsDialog);

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _Snackbar = __webpack_require__(1231);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _message = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = function Message(_ref) {
    var message = _ref.message,
        clearMessage = _ref.clearMessage;
    return message && _react2.default.createElement(_Snackbar2.default, {
        open: true,
        message: message,
        autoHideDuration: 5000,
        onRequestClose: clearMessage
    });
};

Message.propTypes = {
    message: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
    var message = _ref2.message;
    return { message: message };
}, { clearMessage: _message.clearMessage })(Message);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Snackbar = __webpack_require__(1232);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Snackbar2.default;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _ClickAwayListener = __webpack_require__(626);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _SnackbarBody = __webpack_require__(1233);

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
      zIndex = _context$muiTheme.zIndex;
  var open = state.open;


  var styles = {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: zIndex.snackbar,
      visibility: open ? 'visible' : 'hidden',
      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
    }
  };

  return styles;
}

var Snackbar = function (_Component) {
  (0, _inherits3.default)(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose('clickaway');
      } else {
        _this.setState({ open: false });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open,
        message: this.props.message,
        action: this.props.action
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.open) {
        this.setAutoHideTimer();
        this.setTransitionTimer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
        this.setState({
          open: false
        });

        clearTimeout(this.timerOneAtTheTimeId);
        this.timerOneAtTheTimeId = setTimeout(function () {
          _this2.setState({
            message: nextProps.message,
            action: nextProps.action,
            open: true
          });
        }, 400);
      } else {
        var open = nextProps.open;

        this.setState({
          open: open !== null ? open : this.state.open,
          message: nextProps.message,
          action: nextProps.action
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open !== this.state.open) {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        } else {
          clearTimeout(this.timerAutoHideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHideId);
      clearTimeout(this.timerTransitionId);
      clearTimeout(this.timerOneAtTheTimeId);
    }
  }, {
    key: 'setAutoHideTimer',


    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer() {
      var _this3 = this;

      var autoHideDuration = this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        clearTimeout(this.timerAutoHideId);
        this.timerAutoHideId = setTimeout(function () {
          if (_this3.props.open !== null && _this3.props.onRequestClose) {
            _this3.props.onRequestClose('timeout');
          } else {
            _this3.setState({ open: false });
          }
        }, autoHideDuration);
      }
    }

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function setTransitionTimer() {
      var _this4 = this;

      this.timerTransitionId = setTimeout(function () {
        _this4.timerTransitionId = undefined;
      }, 400);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          contentStyle = _props.contentStyle,
          bodyStyle = _props.bodyStyle,
          messageProp = _props.message,
          onRequestClose = _props.onRequestClose,
          onActionClick = _props.onActionClick,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionClick', 'style']);
      var _state = this.state,
          action = _state.action,
          message = _state.message,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: open ? this.componentClickAway : null },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
          _react2.default.createElement(_SnackbarBody2.default, {
            action: action,
            contentStyle: contentStyle,
            message: message,
            open: open,
            onActionClick: onActionClick,
            style: bodyStyle
          })
        )
      );
    }
  }]);
  return Snackbar;
}(_react.Component);

Snackbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Snackbar.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * Override the inline-styles of the body element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Snackbar;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarBody = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(10);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(18);

var _transitions2 = _interopRequireDefault(_transitions);

var _withWidth = __webpack_require__(1234);

var _withWidth2 = _interopRequireDefault(_withWidth);

var _FlatButton = __webpack_require__(162);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var open = props.open,
      width = props.width;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
      desktopGutter = _context$muiTheme$bas2.desktopGutter,
      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
      fontFamily = _context$muiTheme$bas.fontFamily,
      _context$muiTheme$sna = _context$muiTheme.snackbar,
      backgroundColor = _context$muiTheme$sna.backgroundColor,
      textColor = _context$muiTheme$sna.textColor,
      actionColor = _context$muiTheme$sna.actionColor,
      borderRadius = _context$muiTheme.borderRadius;


  var isSmall = width === _withWidth.SMALL;

  var styles = {
    root: {
      fontFamily: fontFamily,
      backgroundColor: backgroundColor,
      padding: '0 ' + desktopGutter + 'px',
      height: desktopSubheaderHeight,
      lineHeight: desktopSubheaderHeight + 'px',
      borderRadius: isSmall ? 0 : borderRadius,
      maxWidth: isSmall ? 'inherit' : 568,
      minWidth: isSmall ? 'inherit' : 288,
      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
      flexGrow: isSmall ? 1 : 0
    },
    content: {
      fontSize: 14,
      color: textColor,
      opacity: open ? 1 : 0,
      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
    },
    action: {
      color: actionColor,
      float: 'right',
      marginTop: 6,
      marginRight: -16,
      marginLeft: desktopGutter,
      backgroundColor: 'transparent'
    }
  };

  return styles;
}

var SnackbarBody = function SnackbarBody(props, context) {
  var action = props.action,
      contentStyle = props.contentStyle,
      message = props.message,
      open = props.open,
      onActionClick = props.onActionClick,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionClick', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
    style: styles.action,
    label: action,
    onClick: onActionClick
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    _react2.default.createElement(
      'div',
      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
      _react2.default.createElement(
        'span',
        null,
        message
      ),
      actionButton
    )
  );
};

exports.SnackbarBody = SnackbarBody;
SnackbarBody.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   * Width of the screen.
   */
  width: _propTypes2.default.number.isRequired
} : {};

SnackbarBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withWidth;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(108);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SMALL = exports.SMALL = 1;
var MEDIUM = exports.MEDIUM = 2;
var LARGE = exports.LARGE = 3;

function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$largeWidth = options.largeWidth,
      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
      _options$mediumWidth = options.mediumWidth,
      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
      _options$resizeInterv = options.resizeInterval,
      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;


  return function (MyComponent) {
    return function (_Component) {
      (0, _inherits3.default)(WithWidth, _Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: null
        }, _this.handleResize = function () {
          clearTimeout(_this.deferTimer);
          _this.deferTimer = setTimeout(function () {
            _this.updateWidth();
          }, resizeInterval);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.deferTimer);
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth() {
          var innerWidth = window.innerWidth;
          var width = void 0;

          if (innerWidth >= largeWidth) {
            width = LARGE;
          } else if (innerWidth >= mediumWidth) {
            width = MEDIUM;
          } else {
            // innerWidth < 768
            width = SMALL;
          }

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var width = this.state.width;

          /**
           * When rendering the component on the server,
           * we have no idea about the screen width.
           * In order to prevent blinks and help the reconciliation
           * we are not rendering the component.
           *
           * A better alternative would be to send client hints.
           * But the browser support of this API is low:
           * http://caniuse.com/#search=client%20hint
           */
          if (width === null) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            _react2.default.createElement(MyComponent, (0, _extends3.default)({
              width: width
            }, this.props))
          );
        }
      }]);
      return WithWidth;
    }(_react.Component);
  };
}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setUserSettings = undefined;

var _actionTypes = __webpack_require__(9);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Set user settings
var setUserSettings = exports.setUserSettings = function setUserSettings(settings) {
    return {
        type: types.USER_SETTINGS_SET,
        payload: settings
    };
};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1237);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
		var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, "body {\n  padding: 0;\n  margin: 0; }\n\n.dhis-gis-menu {\n  button: disabled;\n    button-opacity: 0.5; }\n\n#context-menu {\n  position: fixed;\n  top: 100px;\n  left: 100px; }\n\n#loading-mask {\n  position: relative;\n  height: 100%;\n  z-index: 2000; }\n  #loading-mask:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.25); }\n  #loading-mask:after {\n    content: \"\";\n    position: absolute;\n    border-width: 3px;\n    border-style: solid;\n    border-color: transparent white white;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    top: calc(50% - 12px);\n    left: calc(50% - 12px);\n    animation: 2s linear 0s normal none infinite running spin;\n    filter: drop-shadow(0 0 2 rgba(0, 0, 0, 0.33)); }\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(359deg); } }\n", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js